/******/ (function(modules) { // webpackBootstrap
/******/ 	// install a JSONP callback for chunk loading
/******/ 	var parentJsonpFunction = window["webpackJsonp"];
/******/ 	window["webpackJsonp"] = function webpackJsonpCallback(chunkIds, moreModules, executeModules) {
/******/ 		// add "moreModules" to the modules object,
/******/ 		// then flag all "chunkIds" as loaded and fire callback
/******/ 		var moduleId, chunkId, i = 0, resolves = [], result;
/******/ 		for(;i < chunkIds.length; i++) {
/******/ 			chunkId = chunkIds[i];
/******/ 			if(installedChunks[chunkId]) {
/******/ 				resolves.push(installedChunks[chunkId][0]);
/******/ 			}
/******/ 			installedChunks[chunkId] = 0;
/******/ 		}
/******/ 		for(moduleId in moreModules) {
/******/ 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
/******/ 				modules[moduleId] = moreModules[moduleId];
/******/ 			}
/******/ 		}
/******/ 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules, executeModules);
/******/ 		while(resolves.length) {
/******/ 			resolves.shift()();
/******/ 		}
/******/
/******/ 	};
/******/
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// objects to store loaded and loading chunks
/******/ 	var installedChunks = {
/******/ 		7: 0
/******/ 	};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/ 	// This file contains only the entry chunk.
/******/ 	// The chunk loading function for additional chunks
/******/ 	__webpack_require__.e = function requireEnsure(chunkId) {
/******/ 		var installedChunkData = installedChunks[chunkId];
/******/ 		if(installedChunkData === 0) {
/******/ 			return new Promise(function(resolve) { resolve(); });
/******/ 		}
/******/
/******/ 		// a Promise means "currently loading".
/******/ 		if(installedChunkData) {
/******/ 			return installedChunkData[2];
/******/ 		}
/******/
/******/ 		// setup Promise in chunk cache
/******/ 		var promise = new Promise(function(resolve, reject) {
/******/ 			installedChunkData = installedChunks[chunkId] = [resolve, reject];
/******/ 		});
/******/ 		installedChunkData[2] = promise;
/******/
/******/ 		// start chunk loading
/******/ 		var head = document.getElementsByTagName('head')[0];
/******/ 		var script = document.createElement('script');
/******/ 		script.type = 'text/javascript';
/******/ 		script.charset = 'utf-8';
/******/ 		script.async = true;
/******/ 		script.timeout = 120000;
/******/
/******/ 		if (__webpack_require__.nc) {
/******/ 			script.setAttribute("nonce", __webpack_require__.nc);
/******/ 		}
/******/ 		script.src = __webpack_require__.p + "static/js/" + ({}[chunkId]||chunkId) + "." + {"0":"31b7af5c","1":"aae1d20b","2":"d0f7e901","3":"e8aa9711","4":"9b3c60ab","5":"05304332","6":"0b262c6d"}[chunkId] + ".chunk.js";
/******/ 		var timeout = setTimeout(onScriptComplete, 120000);
/******/ 		script.onerror = script.onload = onScriptComplete;
/******/ 		function onScriptComplete() {
/******/ 			// avoid mem leaks in IE.
/******/ 			script.onerror = script.onload = null;
/******/ 			clearTimeout(timeout);
/******/ 			var chunk = installedChunks[chunkId];
/******/ 			if(chunk !== 0) {
/******/ 				if(chunk) {
/******/ 					chunk[1](new Error('Loading chunk ' + chunkId + ' failed.'));
/******/ 				}
/******/ 				installedChunks[chunkId] = undefined;
/******/ 			}
/******/ 		};
/******/ 		head.appendChild(script);
/******/
/******/ 		return promise;
/******/ 	};
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// on error function for async loading
/******/ 	__webpack_require__.oe = function(err) { console.error(err); throw err; };
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 337);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(545);
} else {
  module.exports = require('./cjs/react.development.js');
}


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(3);
var core = __webpack_require__(31);
var hide = __webpack_require__(22);
var redefine = __webpack_require__(23);
var ctx = __webpack_require__(32);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
  var key, own, out, exp;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    // export native or passed
    out = (own ? target : source)[key];
    // bind timers to global for call from export context
    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // extend global
    if (target) redefine(target, key, out, type & $export.U);
    // export
    if (exports[key] != out) hide(exports, key, exp);
    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
  }
};
global.core = core;
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(9);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 3 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var aux=function aux(props){return props.children;};/* harmony default export */ __webpack_exports__["a"] = (aux);

/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_68", function() { return TOGGLE_REGISTER_COMPANY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_49", function() { return SUCCESS_SEND_EMAIL_REGISTER_COMPANY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_70", function() { return TOGGLE_SEND_EMAIL_CONTANT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_43", function() { return START_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return FINISH_REQUEST; });
/* unused harmony export VERIFY_EMAIL */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_44", function() { return START_SIGNUP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_17", function() { return PRE_LOGIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_25", function() { return RESET_PRE_LOGIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_19", function() { return REQUEST_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return CLOSE_MODAL_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_39", function() { return SET_COMPANIES_TO_USER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_27", function() { return SELECT_COMPANY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_41", function() { return SIGNUP_SET_REFERAL_FRIEND_CODE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_40", function() { return SIGNUP_SET_LINK_CODE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_22", function() { return REQUEST_SIGNUP_SUCCESSFUL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return CLOSE_SIGNUP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return CLOSE_EMAIL_CONFIRMATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return CLOSE_RESET_PASSWORD_MODAL_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return CLOSE_SENT_EMAIL_RESET_PASSWORD_MODAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return CHANGE_PASSWORD_SUCCESSFUL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_21", function() { return REQUEST_SENT_EMAIL_RESET_PASSWORD_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_24", function() { return REQUEST_SUCCESS_LOGIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_5", function() { return LOGOUT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return FETCHING_BUSINESS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return FETCHING_MENU_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_28", function() { return SELECT_ITEM_SIDE_BAR_MENU; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_8", function() { return MENU_FETCHING_ADDRESS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_12", function() { return MENU_SELECT_ADDRESS_FOR_ORDER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_11", function() { return MENU_RESTAURANT_VERIFY_AVAILABLE_SUCCESSFUL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_6", function() { return MENU_CHANGE_TITLE_HEADER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_9", function() { return MENU_REMOVE_RESTAURANT_NOT_AVAILABLE; });
/* unused harmony export MENU_HANDLE_ORDER_TO_REPEAT */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_7", function() { return MENU_ERROR_HANDLING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_10", function() { return MENU_RESET_STATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return FETCHING_RECENTLY_ORDERED_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_14", function() { return ORDER_FEEDBACK_PENDING_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_13", function() { return ORDER_FEEDBACK_CLEAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_16", function() { return ORDER_FEEDBACK_SUBMITTED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_15", function() { return ORDER_FEEDBACK_SKIPPED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_42", function() { return START_RECENTLY_ORDER_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return FINISH_RECENTLY_ORDER_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return FETCHING_PRODUCT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return DELETE_RESTAURANT_SELECTED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_26", function() { return RESTAURANT_SELECTED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return CATEGORIES_SELECTED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_38", function() { return SETTING_ACTIVE_CATEGORY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_29", function() { return SELECT_PRODUCT; });
/* unused harmony export SELECT_PRODUCT_TO_CART */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return CLOSE_PRODUCT_DETAILS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_66", function() { return TOGGLE_CART; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_67", function() { return TOGGLE_MENU_MOBILE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_69", function() { return TOGGLE_RESTAURANTS_MOBILE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ADD_PRODUCT_TO_CART; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return DELETE_PRODUCT_FROM_CART; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return DELETE_ALL_PRODUCTS_FROM_CART; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return CART_SET_PAY_INFO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return CHANGE_RESTAURANT_OPTIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_72", function() { return USER_LOGGING_IN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_73", function() { return USER_LOGGING_OUT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_18", function() { return REALEX_CONFIG_DATA_LOADED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_45", function() { return STRIPE_CONFIG_DATA_LOADED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return CHECKOUT_REALEX_TOGGLE_SHOW_MODAL_RECEIPT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return CHECKOUT_REALEX_TOGGLE_SHOW_MODAL_PLACE_ORDER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return CHECKOUT_REALEX_TOGGLE_SHOW_MODAL_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_47", function() { return SUCCESS_FETCHING_CARDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_46", function() { return SUCCESS_FETCHING_CAMPAIGN_RATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_71", function() { return TRIGGER_MODAL_ERROR_PLACED_ORDER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_48", function() { return SUCCESS_PLACE_ORDER; });
/* unused harmony export CLOSE_MODAL_ERROR_LIMIT */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return CLOSE_MODAL_ERROR_PLACED_ORDER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return CART_CALCULATED_VALUES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return CART_UPDATED_RESTAURANT_STATUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return CART_TOGGLE_SHOW_MODAL_PLACE_ORDER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return CART_TOGGLE_SHOW_MODAL_RECEIPT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return CART_SET_PLACED_BUTTON_DISABLED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return CART_SET_INVOICE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return CART_RESET_STATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return CART_DELIVERY_TOMORROW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return CHECKOUT_RESET_STATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return CHECKOUT_RESIZE_REALEX_FORM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return CHECKOUT_SET_INTERVAL_REFERENCE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_35", function() { return SETTINGS_SHOW_CHANGE_COMPANY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_31", function() { return SETTINGS_CLOSE_CHANGE_COMPANY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_34", function() { return SETTINGS_SEND_EMAIL_SUPPORT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_33", function() { return SETTINGS_CLOSE_SENT_EMAIL_SUPORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_37", function() { return SETTINGS_UNSUBSCRIBE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_36", function() { return SETTINGS_SHOW_ERROR_UNSUBSCRIBE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_32", function() { return SETTINGS_CLOSE_ERROR_UNSUBSCRIBE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_30", function() { return SETTINGS_ACCOUNT_DELETED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_62", function() { return TEAM_VOUCHER_SUCCESS_FETCHING_CARDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_63", function() { return TEAM_VOUCHER_SUCCESS_PLACE_ORDER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_56", function() { return TEAM_VOUCHER_RESET_STATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_64", function() { return TEAM_VOUCHER_TOGGLE_SHOW_MODAL_PLACE_ORDER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_65", function() { return TEAM_VOUCHER_TOGGLE_SHOW_MODAL_RECEIPT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_61", function() { return TEAM_VOUCHER_SHOW_MODAL_CONFIRM_EMAILS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_53", function() { return TEAM_VOUCHER_CLOSE_MODAL_CONFIRM_EMAILS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_55", function() { return TEAM_VOUCHER_OPEN_MODAL_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_54", function() { return TEAM_VOUCHER_CLOSE_MODAL_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_59", function() { return TEAM_VOUCHER_SET_ORDER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_57", function() { return TEAM_VOUCHER_SET_AVAILABLE_TEAM_VOUCHER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_58", function() { return TEAM_VOUCHER_SET_CAMPAIGN_RATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_60", function() { return TEAM_VOUCHER_SET_PAY_INFO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_74", function() { return VOUCHER_BALANCE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return GET_ORDERS_DELIVERY_TRACKING_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return GDPR_SUCCESS_PRIVACY_POLICY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return GDPR_SUCCESS_TERMS_CONDITIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return GDPR_LOAD_STARTED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return GDPR_LOAD_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_50", function() { return TAGGED_INPUT_TEXT_ADD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_51", function() { return TAGGED_INPUT_TEXT_REMOVE; });
/* unused harmony export TAGGED_INPUT_TEXT_VALID_VALUE */
/* unused harmony export TAGGED_INPUT_TEXT_INVALID_VALUE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_52", function() { return TAGGED_INPUT_TEXT_RESET; });
/* unused harmony export TAGGED_INPUT_TEXT_SET_VALUE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1", function() { return INVOICE_FETCHING_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_2", function() { return INVOICE_PAY_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_3", function() { return INVOICE_RESET_STATE; });
/* unused harmony export LINK_VOUCHER_CREATE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_23", function() { return REQUEST_SUCCESS_CREATE_VOUCHER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_20", function() { return REQUEST_FAILED_CREATE_VOUCHER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return CLOSE_MODAL_ERROR_CREATE_LINK_VOUCHER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return CLOSE_MODAL_SUCCESS_CREATE_LINK_VOUCHER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_4", function() { return LINK_VOUCHER_LOAD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return CREATED_NEW_CUSTOMER_DELIVERY_ADDRESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return GUEST_POLICY_LOADED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return GUEST_RECIPIENT_ASK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return GUEST_RECIPIENT_CANCEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return GUEST_ADDED_TO_BASKET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return GUEST_RECIPIENT_CHOSEN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return GUEST_CHECKOUT_KEY_SPENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return CART_PARTY_VALUES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return CART_REMOVE_PARTIES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CART_BATCH_RESULT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CART_BATCH_RESULT_CLOSE; });
var TOGGLE_REGISTER_COMPANY='TOGGLE_REGISTER_COMPANY';var SUCCESS_SEND_EMAIL_REGISTER_COMPANY='SUCCESS_SEND_EMAIL_REGISTER_COMPANY';var TOGGLE_SEND_EMAIL_CONTANT='TOGGLE_SEND_EMAIL_CONTANT';var START_REQUEST='START_REQUEST';var FINISH_REQUEST='FINISH_REQUEST';var VERIFY_EMAIL='VERIFY_EMAIL';var START_SIGNUP='START_SIGNUP';var PRE_LOGIN='PRE_LOGIN';var RESET_PRE_LOGIN='RESET_PRE_LOGIN';var REQUEST_FAILED='REQUEST_FAILED';var CLOSE_MODAL_ERROR='CLOSE_MODAL_ERROR';var SET_COMPANIES_TO_USER='SET_COMPANIES_TO_USER';var SELECT_COMPANY='SELECT_COMPANY';var SIGNUP_SET_REFERAL_FRIEND_CODE='SIGNUP_SET_REFERAL_FRIEND_CODE';var SIGNUP_SET_LINK_CODE='SIGNUP_SET_LINK_CODE';var REQUEST_SIGNUP_SUCCESSFUL='REQUEST_SIGNUP_SUCCESSFUL';var CLOSE_SIGNUP='CLOSE_SIGNUP';var CLOSE_EMAIL_CONFIRMATION='CLOSE_EMAIL_CONFIRMATION';var CLOSE_RESET_PASSWORD_MODAL_ERROR='CLOSE_RESET_PASSWORD_MODAL_ERROR';var CLOSE_SENT_EMAIL_RESET_PASSWORD_MODAL='CLOSE_SENT_EMAIL_RESET_PASSWORD_MODAL';var CHANGE_PASSWORD_SUCCESSFUL='CHANGE_PASSWORD_SUCCESSFUL';var REQUEST_SENT_EMAIL_RESET_PASSWORD_SUCCESS='REQUEST_SENT_EMAIL_RESET_PASSWORD_SUCCESS';var REQUEST_SUCCESS_LOGIN='REQUEST_SUCCESS_LOGIN';var LOGOUT='LOGOUT';var FETCHING_BUSINESS_SUCCESS='FETCHING_BUSINESS_SUCCESS';var FETCHING_MENU_SUCCESS='FETCHING_MENU_SUCCESS';var SELECT_ITEM_SIDE_BAR_MENU='SELECT_ITEM_SIDE_BAR_MENU';var MENU_FETCHING_ADDRESS_SUCCESS='MENU_FETCHING_ADDRESS_SUCCESS';var MENU_SELECT_ADDRESS_FOR_ORDER='MENU_SELECT_ADDRESS_FOR_ORDER';var MENU_RESTAURANT_VERIFY_AVAILABLE_SUCCESSFUL='MENU_RESTAURANT_VERIFY_AVAILABLE_SUCCESSFUL';var MENU_CHANGE_TITLE_HEADER='MENU_CHANGE_TITLE_HEADER';var MENU_REMOVE_RESTAURANT_NOT_AVAILABLE='MENU_REMOVE_RESTAURANT_NOT_AVAILABLE';var MENU_HANDLE_ORDER_TO_REPEAT='MENU_HANDLE_ORDER_TO_REPEAT';var MENU_ERROR_HANDLING='MENU_ERROR_HANDLING';var MENU_RESET_STATE='MENU_RESET_STATE';var FETCHING_RECENTLY_ORDERED_SUCCESS='FETCHING_RECENTLY_ORDERED_SUCCESS';var ORDER_FEEDBACK_PENDING_SUCCESS='ORDER_FEEDBACK_PENDING_SUCCESS';var ORDER_FEEDBACK_CLEAR='ORDER_FEEDBACK_CLEAR';var ORDER_FEEDBACK_SUBMITTED='ORDER_FEEDBACK_SUBMITTED';var ORDER_FEEDBACK_SKIPPED='ORDER_FEEDBACK_SKIPPED';var START_RECENTLY_ORDER_REQUEST='START_RECENTLY_ORDER_REQUEST';var FINISH_RECENTLY_ORDER_REQUEST='FINISH_RECENTLY_ORDER_REQUEST';var FETCHING_PRODUCT_SUCCESS='FETCHING_PRODUCT_SUCCESS';var DELETE_RESTAURANT_SELECTED='DELETE_RESTAURANT_SELECTED';var RESTAURANT_SELECTED='RESTAURANT_SELECTED';var CATEGORIES_SELECTED='CATEGORIES_SELECTED';var SETTING_ACTIVE_CATEGORY='SETTING_ACTIVE_CATEGORY';var SELECT_PRODUCT='SELECT_PRODUCT';var SELECT_PRODUCT_TO_CART='SELECT_PRODUCT_TO_CART';var CLOSE_PRODUCT_DETAILS='CLOSE_PRODUCT_DETAILS';var TOGGLE_CART='TOGGLE_CART';var TOGGLE_MENU_MOBILE='TOGGLE_MENU_MOBILE';var TOGGLE_RESTAURANTS_MOBILE='TOGGLE_RESTAURANTS_MOBILE';var ADD_PRODUCT_TO_CART='ADD_PRODUCT_TO_CART';var DELETE_PRODUCT_FROM_CART='DELETE_PRODUCT_FROM_CART';var DELETE_ALL_PRODUCTS_FROM_CART='DELETE_ALL_PRODUCTS_FROM_CART';var CART_SET_PAY_INFO='CART_SET_PAY_INFO';var CHANGE_RESTAURANT_OPTIONS='CHANGE_RESTAURANT_OPTIONS';var USER_LOGGING_IN='USER_LOGGING_IN';var USER_LOGGING_OUT='USER_LOGGING_OUT';var REALEX_CONFIG_DATA_LOADED='REALEX_CONFIG_DATA_LOADED';var STRIPE_CONFIG_DATA_LOADED='STRIPE_CONFIG_DATA_LOADED';var CHECKOUT_REALEX_TOGGLE_SHOW_MODAL_RECEIPT='CHECKOUT_REALEX_TOGGLE_SHOW_MODAL_RECEIPT';var CHECKOUT_REALEX_TOGGLE_SHOW_MODAL_PLACE_ORDER='CHECKOUT_REALEX_TOGGLE_SHOW_MODAL_PLACE_ORDER';var CHECKOUT_REALEX_TOGGLE_SHOW_MODAL_ERROR='CHECKOUT_REALEX_TOGGLE_SHOW_MODAL_ERROR';var SUCCESS_FETCHING_CARDS='SUCCESS_FETCHING_CARDS';var SUCCESS_FETCHING_CAMPAIGN_RATE='SUCCESS_FETCHING_CAMPAIGN_RATE';var TRIGGER_MODAL_ERROR_PLACED_ORDER='TRIGGER_MODAL_ERROR_PLACED_ORDER';var SUCCESS_PLACE_ORDER='SUCCESS_PLACE_ORDER';var CLOSE_MODAL_ERROR_LIMIT='CLOSE_MODAL_ERROR_LIMIT';var CLOSE_MODAL_ERROR_PLACED_ORDER='CLOSE_MODAL_PLACED_ORDER';var CART_CALCULATED_VALUES='CART_CALCULATED_VALUES';var CART_UPDATED_RESTAURANT_STATUS='CART_UPDATED_RESTAURANT_STATUS';var CART_TOGGLE_SHOW_MODAL_PLACE_ORDER='CART_TOGGLE_SHOW_MODAL_PLACE_ORDER';var CART_TOGGLE_SHOW_MODAL_RECEIPT='CART_TOGGLE_SHOW_MODAL_RECEIPT';var CART_SET_PLACED_BUTTON_DISABLED='CART_SET_PLACED_BUTTON_DISABLED';var CART_SET_INVOICE='CART_SET_INVOICE';var CART_RESET_STATE='CART_RESET_STATE';var CART_DELIVERY_TOMORROW='CART_DELIVERY_TOMORROW';var CHECKOUT_RESET_STATE='CHECKOUT_RESET_STATE';var CHECKOUT_RESIZE_REALEX_FORM='CHECKOUT_RESIZE_REALEX_FORM';var CHECKOUT_SET_INTERVAL_REFERENCE='CHECKOUT_SET_INTERVAL_REFERENCE';var SETTINGS_SHOW_CHANGE_COMPANY='SETTINGS_SHOW_CHANGE_COMPANY';var SETTINGS_CLOSE_CHANGE_COMPANY='SETTINGS_CLOSE_CHANGE_COMPANY';var SETTINGS_SEND_EMAIL_SUPPORT_SUCCESS='SETTINGS_SEND_EMAIL_SUPPORT_SUCCESS';var SETTINGS_CLOSE_SENT_EMAIL_SUPORT='SETTINGS_CLOSE_SENT_EMAIL_SUPORT';var SETTINGS_UNSUBSCRIBE_SUCCESS='SETTINGS_UNSUBSCRIBE_SUCCESS';var SETTINGS_SHOW_ERROR_UNSUBSCRIBE='SETTINGS_SHOW_ERROR_UNSUBSCRIBE';var SETTINGS_CLOSE_ERROR_UNSUBSCRIBE='SETTINGS_CLOSE_ERROR_UNSUBSCRIBE';var SETTINGS_ACCOUNT_DELETED='SETTINGS_ACCOUNT_DELETED';var TEAM_VOUCHER_SUCCESS_FETCHING_CARDS='TEAM_VOUCHER_SUCCESS_FETCHING_CARDS';var TEAM_VOUCHER_SUCCESS_PLACE_ORDER='TEAM_VOUCHER_SUCCESS_PLACE_ORDER';var TEAM_VOUCHER_RESET_STATE='TEAM_VOUCHER_RESET_STATE';var TEAM_VOUCHER_TOGGLE_SHOW_MODAL_PLACE_ORDER='TEAM_VOUCHER_TOGGLE_SHOW_MODAL_PLACE_ORDER';var TEAM_VOUCHER_TOGGLE_SHOW_MODAL_RECEIPT='TEAM_VOUCHER_TOGGLE_SHOW_MODAL_RECEIPT';var TEAM_VOUCHER_SHOW_MODAL_CONFIRM_EMAILS='TEAM_VOUCHER_TOGGLE_SHOW_MODAL_CONFIRM_EMAILS';var TEAM_VOUCHER_CLOSE_MODAL_CONFIRM_EMAILS='TEAM_VOUCHER_TOGGLE_CLOSE_MODAL_CONFIRM_EMAILS';var TEAM_VOUCHER_OPEN_MODAL_ERROR='TEAM_VOUCHER_OPEN_MODAL_ERROR';var TEAM_VOUCHER_CLOSE_MODAL_ERROR='TEAM_VOUCHER_CLOSE_MODAL_ERROR';var TEAM_VOUCHER_SET_ORDER='TEAM_VOUCHER_SET_ORDER';var TEAM_VOUCHER_SET_AVAILABLE_TEAM_VOUCHER='TEAM_VOUCHER_SET_AVAILABLE_TEAM_VOUCHER';var TEAM_VOUCHER_SET_CAMPAIGN_RATE='TEAM_VOUCHER_SET_CAMPAIGN_RATE';var TEAM_VOUCHER_SET_PAY_INFO='TEAM_VOUCHER_SET_PAY_INFO';var VOUCHER_BALANCE_SUCCESS='VOUCHER_BALANCE_SUCCESS';var GET_ORDERS_DELIVERY_TRACKING_SUCCESS='GET_ORDERS_DELIVERY_TRACKING_SUCCESS';var GDPR_SUCCESS_PRIVACY_POLICY='GDPR_SUCCESS_PRIVACY_POLICY';var GDPR_SUCCESS_TERMS_CONDITIONS='GDPR_SUCCESS_TERMS_CONDITIONS';var GDPR_LOAD_STARTED='GDPR_LOAD_STARTED';var GDPR_LOAD_FAILED='GDPR_LOAD_FAILED';var TAGGED_INPUT_TEXT_ADD='TAGGED_INPUT_TEXT_ADD';var TAGGED_INPUT_TEXT_REMOVE='TAGGED_INPUT_TEXT_REMOVE';var TAGGED_INPUT_TEXT_VALID_VALUE='TAGGED_INPUT_TEXT_VALID_VALUE';var TAGGED_INPUT_TEXT_INVALID_VALUE='TAGGED_INPUT_TEXT_INVALID_VALUE';var TAGGED_INPUT_TEXT_RESET='TAGGED_INPUT_TEXT_RESET';var TAGGED_INPUT_TEXT_SET_VALUE='TAGGED_INPUT_TEXT_SET_VALUE';var INVOICE_FETCHING_SUCCESS='INVOICE_FETCHING_SUCCESS';var INVOICE_PAY_SUCCESS='INVOICE_PAY_SUCCESS';var INVOICE_RESET_STATE='INVOICE_RESET_STATE';var LINK_VOUCHER_CREATE='LINK_VOUCHER_CREATE';var REQUEST_SUCCESS_CREATE_VOUCHER='REQUEST_SUCCESS_CREATE_VOUCHER';var REQUEST_FAILED_CREATE_VOUCHER='REQUEST_FAILED_CREATE_VOUCHER';var CLOSE_MODAL_ERROR_CREATE_LINK_VOUCHER='CLOSE_MODAL_ERROR_CREATE_LINK_VOUCHER';var CLOSE_MODAL_SUCCESS_CREATE_LINK_VOUCHER='CLOSE_MODAL_SUCCESS_CREATE_LINK_VOUCHER';var LINK_VOUCHER_LOAD='LINK_VOUCHER_LOAD';var CREATED_NEW_CUSTOMER_DELIVERY_ADDRESS='CREATED_NEW_CUSTOMER_DELIVERY_ADDRESS';// Guest ordering: "Who's this for?"
var GUEST_POLICY_LOADED='GUEST_POLICY_LOADED';var GUEST_RECIPIENT_ASK='GUEST_RECIPIENT_ASK';var GUEST_RECIPIENT_CANCEL='GUEST_RECIPIENT_CANCEL';var GUEST_ADDED_TO_BASKET='GUEST_ADDED_TO_BASKET';var GUEST_RECIPIENT_CHOSEN='GUEST_RECIPIENT_CHOSEN';var GUEST_CHECKOUT_KEY_SPENT='GUEST_CHECKOUT_KEY_SPENT';var CART_PARTY_VALUES='CART_PARTY_VALUES';var CART_REMOVE_PARTIES='CART_REMOVE_PARTIES';var CART_BATCH_RESULT='CART_BATCH_RESULT';var CART_BATCH_RESULT_CLOSE='CART_BATCH_RESULT_CLOSE';

/***/ }),
/* 6 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var ReactIs = require('react-is');

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(550)();
}


/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Provider__ = __webpack_require__(581);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_connectAdvanced__ = __webpack_require__(261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Context__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__connect_connect__ = __webpack_require__(584);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__hooks_useDispatch__ = __webpack_require__(593);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__hooks_useSelector__ = __webpack_require__(594);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__hooks_useStore__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_batch__ = __webpack_require__(260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_reactBatchedUpdates__ = __webpack_require__(595);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_shallowEqual__ = __webpack_require__(263);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Provider", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Provider__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "connectAdvanced", function() { return __WEBPACK_IMPORTED_MODULE_1__components_connectAdvanced__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ReactReduxContext", function() { return __WEBPACK_IMPORTED_MODULE_2__components_Context__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "connect", function() { return __WEBPACK_IMPORTED_MODULE_3__connect_connect__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "batch", function() { return __WEBPACK_IMPORTED_MODULE_8__utils_reactBatchedUpdates__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "useDispatch", function() { return __WEBPACK_IMPORTED_MODULE_4__hooks_useDispatch__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "createDispatchHook", function() { return __WEBPACK_IMPORTED_MODULE_4__hooks_useDispatch__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "useSelector", function() { return __WEBPACK_IMPORTED_MODULE_5__hooks_useSelector__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "createSelectorHook", function() { return __WEBPACK_IMPORTED_MODULE_5__hooks_useSelector__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "useStore", function() { return __WEBPACK_IMPORTED_MODULE_6__hooks_useStore__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "createStoreHook", function() { return __WEBPACK_IMPORTED_MODULE_6__hooks_useStore__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "shallowEqual", function() { return __WEBPACK_IMPORTED_MODULE_9__utils_shallowEqual__["a"]; });










Object(__WEBPACK_IMPORTED_MODULE_7__utils_batch__["b" /* setBatch */])(__WEBPACK_IMPORTED_MODULE_8__utils_reactBatchedUpdates__["a" /* unstable_batchedUpdates */]);


/***/ }),
/* 9 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(83)('wks');
var uid = __webpack_require__(56);
var Symbol = __webpack_require__(3).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(34);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(6)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Landing__ = __webpack_require__(207);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_37", function() { return __WEBPACK_IMPORTED_MODULE_0__Landing__["m"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_27", function() { return __WEBPACK_IMPORTED_MODULE_0__Landing__["l"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_26", function() { return __WEBPACK_IMPORTED_MODULE_0__Landing__["k"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_18", function() { return __WEBPACK_IMPORTED_MODULE_0__Landing__["i"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return __WEBPACK_IMPORTED_MODULE_0__Landing__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_16", function() { return __WEBPACK_IMPORTED_MODULE_0__Landing__["h"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_15", function() { return __WEBPACK_IMPORTED_MODULE_0__Landing__["g"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return __WEBPACK_IMPORTED_MODULE_0__Landing__["f"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_20", function() { return __WEBPACK_IMPORTED_MODULE_0__Landing__["j"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_40", function() { return __WEBPACK_IMPORTED_MODULE_0__Landing__["n"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return __WEBPACK_IMPORTED_MODULE_0__Landing__["e"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_0__Landing__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Loading__ = __webpack_require__(657);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_30", function() { return __WEBPACK_IMPORTED_MODULE_1__Loading__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_1", function() { return __WEBPACK_IMPORTED_MODULE_1__Loading__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SignUp__ = __webpack_require__(179);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return __WEBPACK_IMPORTED_MODULE_2__SignUp__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return __WEBPACK_IMPORTED_MODULE_2__SignUp__["e"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_23", function() { return __WEBPACK_IMPORTED_MODULE_2__SignUp__["g"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_17", function() { return __WEBPACK_IMPORTED_MODULE_2__SignUp__["f"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return __WEBPACK_IMPORTED_MODULE_2__SignUp__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_2__SignUp__["a"]; });
/* unused harmony reexport setReferalFriendCode */
/* unused harmony reexport setLinkCode */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Password__ = __webpack_require__(659);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_7", function() { return __WEBPACK_IMPORTED_MODULE_3__Password__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_19", function() { return __WEBPACK_IMPORTED_MODULE_3__Password__["b"]; });
/* unused harmony reexport closeResetPasswordModalError */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_28", function() { return __WEBPACK_IMPORTED_MODULE_3__Password__["c"]; });
/* unused harmony reexport closeModalFailed */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Menu__ = __webpack_require__(180);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_4__Menu__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_4__Menu__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_22", function() { return __WEBPACK_IMPORTED_MODULE_4__Menu__["s"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return __WEBPACK_IMPORTED_MODULE_4__Menu__["k"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_41", function() { return __WEBPACK_IMPORTED_MODULE_4__Menu__["z"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_4__Menu__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_24", function() { return __WEBPACK_IMPORTED_MODULE_4__Menu__["t"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return __WEBPACK_IMPORTED_MODULE_4__Menu__["n"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return __WEBPACK_IMPORTED_MODULE_4__Menu__["l"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return __WEBPACK_IMPORTED_MODULE_4__Menu__["m"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return __WEBPACK_IMPORTED_MODULE_4__Menu__["j"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_31", function() { return __WEBPACK_IMPORTED_MODULE_4__Menu__["w"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_29", function() { return __WEBPACK_IMPORTED_MODULE_4__Menu__["v"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return __WEBPACK_IMPORTED_MODULE_4__Menu__["i"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_21", function() { return __WEBPACK_IMPORTED_MODULE_4__Menu__["r"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_4__Menu__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return __WEBPACK_IMPORTED_MODULE_4__Menu__["f"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_25", function() { return __WEBPACK_IMPORTED_MODULE_4__Menu__["u"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return __WEBPACK_IMPORTED_MODULE_4__Menu__["e"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_5", function() { return __WEBPACK_IMPORTED_MODULE_4__Menu__["p"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_6", function() { return __WEBPACK_IMPORTED_MODULE_4__Menu__["q"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_36", function() { return __WEBPACK_IMPORTED_MODULE_4__Menu__["x"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_38", function() { return __WEBPACK_IMPORTED_MODULE_4__Menu__["y"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_3", function() { return __WEBPACK_IMPORTED_MODULE_4__Menu__["o"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return __WEBPACK_IMPORTED_MODULE_4__Menu__["g"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return __WEBPACK_IMPORTED_MODULE_4__Menu__["h"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Business__ = __webpack_require__(660);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return __WEBPACK_IMPORTED_MODULE_5__Business__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Cart__ = __webpack_require__(69);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return __WEBPACK_IMPORTED_MODULE_6__Cart__["v"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_6__Cart__["e"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_6__Cart__["h"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_6__Cart__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return __WEBPACK_IMPORTED_MODULE_6__Cart__["u"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_39", function() { return __WEBPACK_IMPORTED_MODULE_6__Cart__["E"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return __WEBPACK_IMPORTED_MODULE_6__Cart__["n"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return __WEBPACK_IMPORTED_MODULE_6__Cart__["o"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_10", function() { return __WEBPACK_IMPORTED_MODULE_6__Cart__["x"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return __WEBPACK_IMPORTED_MODULE_6__Cart__["p"]; });
/* unused harmony reexport toggleShowModalPlacedOrderOnCart */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_6__Cart__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_6__Cart__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_6__Cart__["k"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_6__Cart__["f"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return __WEBPACK_IMPORTED_MODULE_6__Cart__["t"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_6__Cart__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_6__Cart__["l"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_14", function() { return __WEBPACK_IMPORTED_MODULE_6__Cart__["B"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_6__Cart__["m"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_34", function() { return __WEBPACK_IMPORTED_MODULE_6__Cart__["C"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return __WEBPACK_IMPORTED_MODULE_6__Cart__["s"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return __WEBPACK_IMPORTED_MODULE_6__Cart__["q"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_11", function() { return __WEBPACK_IMPORTED_MODULE_6__Cart__["y"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_13", function() { return __WEBPACK_IMPORTED_MODULE_6__Cart__["A"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_12", function() { return __WEBPACK_IMPORTED_MODULE_6__Cart__["z"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_6__Cart__["g"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_6__Cart__["cartToggleShowModalReceipt"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_35", function() { return __WEBPACK_IMPORTED_MODULE_6__Cart__["D"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_4", function() { return __WEBPACK_IMPORTED_MODULE_6__Cart__["w"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return __WEBPACK_IMPORTED_MODULE_6__Cart__["r"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_6__Cart__["j"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__DeliveryTracking__ = __webpack_require__(662);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_2", function() { return __WEBPACK_IMPORTED_MODULE_7__DeliveryTracking__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__LinkVoucher__ = __webpack_require__(664);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return __WEBPACK_IMPORTED_MODULE_8__LinkVoucher__["a"]; });
/* unused harmony reexport createLinkVoucher */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__VoucherBalance__ = __webpack_require__(665);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return __WEBPACK_IMPORTED_MODULE_9__VoucherBalance__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__TeamVoucher__ = __webpack_require__(181);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return __WEBPACK_IMPORTED_MODULE_10__TeamVoucher__["a"]; });
/* unused harmony reexport closeModalPlacedOrder */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return __WEBPACK_IMPORTED_MODULE_10__TeamVoucher__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return __WEBPACK_IMPORTED_MODULE_10__TeamVoucher__["e"]; });
/* unused harmony reexport customerExist */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return __WEBPACK_IMPORTED_MODULE_10__TeamVoucher__["f"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return __WEBPACK_IMPORTED_MODULE_10__TeamVoucher__["g"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_8", function() { return __WEBPACK_IMPORTED_MODULE_10__TeamVoucher__["h"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_9", function() { return __WEBPACK_IMPORTED_MODULE_10__TeamVoucher__["i"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_32", function() { return __WEBPACK_IMPORTED_MODULE_10__TeamVoucher__["l"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_33", function() { return __WEBPACK_IMPORTED_MODULE_10__TeamVoucher__["m"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_42", function() { return __WEBPACK_IMPORTED_MODULE_10__TeamVoucher__["n"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Customer__ = __webpack_require__(666);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return __WEBPACK_IMPORTED_MODULE_11__Customer__["a"]; });
/* unused harmony reexport getListCustomerDeliveryAddress */
/* unused harmony reexport deleteCustomerDeliveryAddress */


/***/ }),
/* 14 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function(useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if(item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}


/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ERROR_CODES; });
/* unused harmony export formatReferenceTime */
/* unused harmony export shortServerId */
/* harmony export (immutable) */ __webpack_exports__["d"] = formatReference;
/* unused harmony export formatFullReference */
/* harmony export (immutable) */ __webpack_exports__["f"] = serverIdOf;
/* unused harmony export statusOf */
/* harmony export (immutable) */ __webpack_exports__["c"] = failureKind;
/* harmony export (immutable) */ __webpack_exports__["h"] = userError;
/* harmony export (immutable) */ __webpack_exports__["e"] = knownError;
/* harmony export (immutable) */ __webpack_exports__["g"] = toDisplayError;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return errorCopy; });
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};// One shape for every error the customer sees (docs/ERROR_MESSAGES.md in lunchteam-ui-errors):
//   title     what failed, from the customer's side
//   message   why, in one sentence, only when we know (may be empty)
//   guidance  what to do next
//   code      stable AREA-REASON code support can search for
//   reference "CODE · 26 Oct 12:41 · 7f3a9c21": the line the customer reads out or copies
// plus serverId (full, for the copy action and the support composer), at (when it happened),
// status and retrySafe.
//
// Never shows raw server text: callers that know the reason pass their own copy.
var ERROR_CODES={NETWORK_OFFLINE:'NETWORK-OFFLINE',NETWORK_TIMEOUT:'NETWORK-TIMEOUT',SERVER_UNAVAILABLE:'SERVER-UNAVAILABLE',SERVER_UNEXPECTED:'SERVER-UNEXPECTED',AUTH_SIGNED_OUT:'AUTH-SIGNED-OUT',AUTH_LINK_EXPIRED:'AUTH-LINK-EXPIRED',AUTH_LINK_USED:'AUTH-LINK-USED',AUTH_WRONG_PASSWORD:'AUTH-WRONG-PASSWORD',AUTH_LOCKED:'AUTH-LOCKED',AUTH_LINK_NOT_ALLOWED:'AUTH-LINK-NOT-ALLOWED',AUTH_RESET_LINK_INVALID:'AUTH-RESET-LINK-INVALID',AUTH_PASSWORD_CHANGE_FAILED:'AUTH-PASSWORD-CHANGE-FAILED',ACCOUNT_NOT_FOUND:'ACCOUNT-NOT-FOUND',ACCOUNT_COMPANY_PENDING:'ACCOUNT-COMPANY-PENDING',ACCOUNT_UPDATE_FAILED:'ACCOUNT-UPDATE-FAILED',ACCOUNT_RETAIL_ONLY:'ACCOUNT-RETAIL-ONLY',ACCOUNT_COMPANY_NOT_SERVED:'ACCOUNT-COMPANY-NOT-SERVED',ACCOUNT_EMAIL_INVALID:'ACCOUNT-EMAIL-INVALID',ACCOUNT_SIGNUP_FAILED:'ACCOUNT-SIGNUP-FAILED',ACCOUNT_DETAILS_INVALID:'ACCOUNT-DETAILS-INVALID',ACCOUNT_UNSUBSCRIBE_FAILED:'ACCOUNT-UNSUBSCRIBE-FAILED',MENU_LOAD_FAILED:'MENU-LOAD-FAILED',MENU_RESTAURANT_CLOSED:'MENU-RESTAURANT-CLOSED',MENU_RESTAURANT_UNAVAILABLE:'MENU-RESTAURANT-UNAVAILABLE',MENU_ITEM_SOLD_OUT:'MENU-ITEM-SOLD-OUT',MENU_OPTIONS_MAX:'MENU-OPTIONS-MAX',MENU_OPTIONS_REQUIRED:'MENU-OPTIONS-REQUIRED',ORDER_CUTOFF_PASSED:'ORDER-CUTOFF-PASSED',ORDER_MIN_NOT_MET:'ORDER-MIN-NOT-MET',ORDER_MAX_EXCEEDED:'ORDER-MAX-EXCEEDED',ORDER_TIME_MISSING:'ORDER-TIME-MISSING',ORDER_GUEST_NOT_ALLOWED:'ORDER-GUEST-NOT-ALLOWED',ORDER_DUPLICATE:'ORDER-DUPLICATE',ORDER_PLACE_FAILED:'ORDER-PLACE-FAILED',ORDER_CANCEL_FAILED:'ORDER-CANCEL-FAILED',ORDER_UNKNOWN_STATE:'ORDER-UNKNOWN-STATE',ORDER_CHECKING:'ORDER-CHECKING',ORDER_PLACED_INCOMPLETE:'ORDER-PLACED-INCOMPLETE',PAYMENT_DECLINED:'PAYMENT-DECLINED',PAYMENT_3DS_FAILED:'PAYMENT-3DS-FAILED',PAYMENT_UNKNOWN_STATE:'PAYMENT-UNKNOWN-STATE',PAYMENT_CARD_EXPIRED:'PAYMENT-CARD-EXPIRED',PAYMENT_ON_ACCOUNT_UNAVAILABLE:'PAYMENT-ON-ACCOUNT-UNAVAILABLE',PAYMENT_ALREADY_PROCESSED:'PAYMENT-ALREADY-PROCESSED',PAYMENT_DETAILS_INVALID:'PAYMENT-DETAILS-INVALID',VOUCHER_INVALID:'VOUCHER-INVALID',VOUCHER_EXPIRED:'VOUCHER-EXPIRED',VOUCHER_USED:'VOUCHER-USED',VOUCHER_EMAIL_NOT_REGISTERED:'VOUCHER-EMAIL-NOT-REGISTERED',VOUCHER_EMAIL_NO_COMPANY:'VOUCHER-EMAIL-NO-COMPANY',DELIVERY_TRACKING_UNAVAILABLE:'DELIVERY-TRACKING-UNAVAILABLE',SUPPORT_SEND_REJECTED:'SUPPORT-SEND-REJECTED',SUPPORT_OFF:'SUPPORT-OFF',SUPPORT_TOO_LARGE:'SUPPORT-TOO-LARGE',SUPPORT_RATE_LIMITED:'SUPPORT-RATE-LIMITED',SUPPORT_BUSY:'SUPPORT-BUSY',SUPPORT_VOICE_UNCLEAR:'SUPPORT-VOICE-UNCLEAR',SUPPORT_VOICE_UNAVAILABLE:'SUPPORT-VOICE-UNAVAILABLE'// What each area's task is called when nothing more specific is known: "We couldn't <task>".
};var AREA_TASKS={AUTH:'sign you in',ACCOUNT:'save your details',MENU:'load the menu',ORDER:'place your order',PAYMENT:'take the payment',VOUCHER:'apply this voucher',DELIVERY:'load tracking for this order',SUPPORT:'send your message',SERVER:'finish that'};var MONTHS=['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];var pad=function pad(value){return value<10?'0'+value:''+value;};/** "26 Oct 12:41", local time. */function formatReferenceTime(at){var date=at instanceof Date?at:new Date(at);if(isNaN(date.getTime())){return'';}return date.getDate()+' '+MONTHS[date.getMonth()]+' '+pad(date.getHours())+':'+pad(date.getMinutes());}// Long ids (UUIDs, correlation ids) show their first 8 characters; a short reference made to be
// read out (e.g. "ORD-7K3P9Q") shows whole. The full value is always kept for copying.
var SHORT_ID_LIMIT=12;function shortServerId(id){var value=id===undefined||id===null?'':String(id).trim();if(!value){return'';}return value.length>SHORT_ID_LIMIT?value.slice(0,8):value;}/** "CODE · 26 Oct 12:41 · 7f3a9c21" (the screen form; without "Reference: "). */function formatReference(code,at,serverId){return[code,formatReferenceTime(at),shortServerId(serverId)].filter(Boolean).join(' · ');}/** The same line with the full server id: what the copy action and the support message carry. */function formatFullReference(code,at,serverId){var id=serverId===undefined||serverId===null?'':String(serverId).trim();return[code,formatReferenceTime(at),id].filter(Boolean).join(' · ');}var present=function present(value){return value!==undefined&&value!==null&&value!=='';};function readHeader(response,name){try{return response&&response.headers&&typeof response.headers.get==='function'?response.headers.get(name)||undefined:undefined;}catch(e){return undefined;}}function bodyOf(error){if(!error||(typeof error==='undefined'?'undefined':_typeof(error))!=='object'){return{};}var data=error.data!==undefined?error.data:error.body;if(data&&(typeof data==='undefined'?'undefined':_typeof(data))==='object'){return data;}return error;}/**
 * The server's id for this failure: a dedicated support reference first (body, then
 * X-Support-Reference), then the request's X-Correlation-ID. Only response evidence is read,
 * never a correlation id the page itself sent.
 */function serverIdOf(error){if(!error||(typeof error==='undefined'?'undefined':_typeof(error))!=='object'){return undefined;}var body=bodyOf(error);var candidates=[body.supportReference,body.support_reference,error.supportReference,error.supportReferenceHeader,readHeader(error.response,'X-Support-Reference'),error.responseCorrelationId,readHeader(error.response,'X-Correlation-ID')];for(var index=0;index<candidates.length;index+=1){if(present(candidates[index])&&_typeof(candidates[index])!=='object'){return String(candidates[index]);}}return undefined;}function statusOf(error){if(!error||(typeof error==='undefined'?'undefined':_typeof(error))!=='object'){return undefined;}var candidates=[error.status,error.responseStatus,error.response&&error.response.status,error.statusCode,error.data&&error.data.statusCode];for(var index=0;index<candidates.length;index+=1){var value=Number(candidates[index]);if(candidates[index]!==undefined&&candidates[index]!==null&&!isNaN(value)&&value>0){return value;}}return undefined;}var isOffline=function isOffline(){return typeof navigator!=='undefined'&&navigator.onLine===false;};/**
 * What kind of failure this is, before the area says what it means:
 * 'offline' | 'timeout' | 'unreachable' | 'server' | 'signed-out' | 'http' | 'unknown'.
 */function failureKind(error){if(!error){return'unknown';}var status=statusOf(error);var name=error.name||error.cause&&error.cause.name;if(error.isTimeout||error.code==='TIMEOUT'||name==='AbortError'||name==='TimeoutError'||status===408||status===504){return'timeout';}var networkFailure=error.isNetworkError||error.code==='NETWORK_ERROR'||name==='TypeError'&&!status;if(networkFailure){return error.offline||isOffline()?'offline':'unreachable';}if(error.code==='AUTHENTICATION_REQUIRED'||status===401){return'signed-out';}if(status>=500){return'server';}if(status){return'http';}return'unknown';}var TRANSPORT={offline:{code:ERROR_CODES.NETWORK_OFFLINE,title:"You're offline",message:'Your device has lost its internet connection.',guidance:'Check your connection and try again.'},timeout:{code:ERROR_CODES.NETWORK_TIMEOUT,title:'This is taking too long',message:'Lunch.Team took too long to answer.',guidance:'Check your connection and try again.'},unreachable:{code:ERROR_CODES.SERVER_UNAVAILABLE,title:"We couldn't reach Lunch.Team",message:'Your connection or our service may be down.',guidance:'Check your connection and try again in a minute.'},server:{code:ERROR_CODES.SERVER_UNAVAILABLE,title:"Lunch.Team isn't responding",message:'Our service is having a problem right now.',guidance:'Try again in a few minutes.'},'signed-out':{code:ERROR_CODES.AUTH_SIGNED_OUT,title:'Please sign in again',message:'Your session has expired.',guidance:'Sign in again to carry on.'}};var PAYMENT_UNKNOWN={code:ERROR_CODES.PAYMENT_UNKNOWN_STATE,title:"We couldn't confirm your payment",message:"We don't know yet whether the payment went through.",guidance:"Don't pay again yet. Check My Orders in a few minutes, or contact support with the reference below."// Next steps that must never be shown when retrying could charge or order twice.
};var RETRY_WORDS=/try again|retry/i;var NO_RETRY_GUIDANCE='Check My Orders before doing anything else, or contact support with the reference below.';/**
 * @param {*} error a request-layer error (status, code, data, response), a network failure, a timeout,
 *   or nothing (a failure the page detected itself)
 * @param {{area?: string, task?: string, title?: string, message?: string, guidance?: string,
 *   code?: string, retrySafe?: boolean, paymentUnknown?: boolean, at?: Date, keepTitle?: boolean}} options
 *   area   catalogue area (ORDER, ACCOUNT, ...) for codes and the default title
 *   task   "save your details": the title becomes "We couldn't save your details"
 *   title/message/guidance/code  what the caller knows about this failure (wins over the defaults
 *          for an ordinary HTTP failure; offline, slow, server down and signed out keep their own
 *          code and next step, under the caller's title)
 *   retrySafe false: never invite a retry (payments, orders that may exist)
 *   paymentUnknown true: the payment's outcome is unknown (PAYMENT-UNKNOWN-STATE wins)
 */function userError(error){var options=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};var area=String(options.area||'SERVER').toUpperCase();var task=options.task||AREA_TASKS[area]||AREA_TASKS.SERVER;var taskTitle=options.title||'We couldn\'t '+task;var status=statusOf(error);var serverId=options.serverId||serverIdOf(error);var at=options.at||error&&error.at||new Date();var kind=failureKind(error);var copy=void 0;if(options.paymentUnknown){copy=Object.assign({},PAYMENT_UNKNOWN);}else if(TRANSPORT[kind]){var transport=TRANSPORT[kind];copy={code:transport.code,// The task stays in the title when the caller named one ("We couldn't send your message").
title:options.title||options.task?taskTitle:transport.title,message:transport.message,guidance:transport.guidance};}else{var fallbackCode=kind==='http'?area+'-UNEXPECTED-'+status:area==='SERVER'?ERROR_CODES.SERVER_UNEXPECTED:area+'-UNEXPECTED';copy={code:options.code||fallbackCode,title:taskTitle,message:options.message||'',guidance:options.guidance||'Try again, or contact support with the reference below.'};}var retrySafe=options.paymentUnknown?false:options.retrySafe;if(retrySafe===false&&!options.paymentUnknown&&RETRY_WORDS.test(copy.guidance)){copy.guidance=options.guidance&&!RETRY_WORDS.test(options.guidance)?options.guidance:NO_RETRY_GUIDANCE;}return{title:copy.title,message:copy.message,guidance:copy.guidance,code:copy.code,reference:formatReference(copy.code,at,serverId),fullReference:formatFullReference(copy.code,at,serverId),serverId:serverId,at:at,status:status,retrySafe:retrySafe===undefined?kind!=='signed-out':retrySafe,kind:kind,isUserError:true};}/** A failure the page found itself (no request involved), in the same shape. */function knownError(code){var copy=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};return userError(null,Object.assign({},copy,{code:code,area:String(code).split('-')[0]}));}/**
 * Anything handed to an error display (a userError, a checkout error from mapCheckoutError,
 * or a legacy string) in the standard shape. Strings are never shown as the title.
 */function toDisplayError(value){var fallback=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};if(value&&(typeof value==='undefined'?'undefined':_typeof(value))==='object'&&value.isUserError){return value;}if(value&&(typeof value==='undefined'?'undefined':_typeof(value))==='object'&&(value.title||value.message)){var code=value.referenceCode||fallback.code||ERROR_CODES.SERVER_UNEXPECTED;var at=value.at||fallback.at||new Date();var serverId=value.serverId||value.supportReference;return Object.assign({},value,{title:value.title||fallback.title||'We couldn\'t '+(fallback.task||AREA_TASKS[String(fallback.area||'SERVER').toUpperCase()]||AREA_TASKS.SERVER),code:code,reference:formatReference(code,at,serverId),fullReference:formatFullReference(code,at,serverId),serverId:serverId,at:at,isUserError:true});}return userError(null,{area:fallback.area,task:fallback.task,title:fallback.title,code:fallback.code,message:typeof value==='string'?value:'',guidance:fallback.guidance,at:fallback.at});}/**
 * Fixed copy for a display that renders it later (a modal's errorMessage prop): the reference time
 * is taken when it is first shown.
 */var errorCopy=function errorCopy(code,copy){return Object.assign({},copy,{referenceCode:code});};

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(2);
var IE8_DOM_DEFINE = __webpack_require__(215);
var toPrimitive = __webpack_require__(40);
var dP = Object.defineProperty;

exports.f = __webpack_require__(12) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/

var stylesInDom = {};

var	memoize = function (fn) {
	var memo;

	return function () {
		if (typeof memo === "undefined") memo = fn.apply(this, arguments);
		return memo;
	};
};

var isOldIE = memoize(function () {
	// Test for IE <= 9 as proposed by Browserhacks
	// @see http://browserhacks.com/#hack-e71d8692f65334173fee715c222cb805
	// Tests for existence of standard globals is to allow style-loader
	// to operate correctly into non-standard environments
	// @see https://github.com/webpack-contrib/style-loader/issues/177
	return window && document && document.all && !window.atob;
});

var getElement = (function (fn) {
	var memo = {};

	return function(selector) {
		if (typeof memo[selector] === "undefined") {
			var styleTarget = fn.call(this, selector);
			// Special case to return head of iframe instead of iframe itself
			if (styleTarget instanceof window.HTMLIFrameElement) {
				try {
					// This will throw an exception if access to iframe is blocked
					// due to cross-origin restrictions
					styleTarget = styleTarget.contentDocument.head;
				} catch(e) {
					styleTarget = null;
				}
			}
			memo[selector] = styleTarget;
		}
		return memo[selector]
	};
})(function (target) {
	return document.querySelector(target)
});

var singleton = null;
var	singletonCounter = 0;
var	stylesInsertedAtTop = [];

var	fixUrls = __webpack_require__(624);

module.exports = function(list, options) {
	if (typeof DEBUG !== "undefined" && DEBUG) {
		if (typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
	}

	options = options || {};

	options.attrs = typeof options.attrs === "object" ? options.attrs : {};

	// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
	// tags it will allow on a page
	if (!options.singleton) options.singleton = isOldIE();

	// By default, add <style> tags to the <head> element
	if (!options.insertInto) options.insertInto = "head";

	// By default, add <style> tags to the bottom of the target
	if (!options.insertAt) options.insertAt = "bottom";

	var styles = listToStyles(list, options);

	addStylesToDom(styles, options);

	return function update (newList) {
		var mayRemove = [];

		for (var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];

			domStyle.refs--;
			mayRemove.push(domStyle);
		}

		if(newList) {
			var newStyles = listToStyles(newList, options);
			addStylesToDom(newStyles, options);
		}

		for (var i = 0; i < mayRemove.length; i++) {
			var domStyle = mayRemove[i];

			if(domStyle.refs === 0) {
				for (var j = 0; j < domStyle.parts.length; j++) domStyle.parts[j]();

				delete stylesInDom[domStyle.id];
			}
		}
	};
};

function addStylesToDom (styles, options) {
	for (var i = 0; i < styles.length; i++) {
		var item = styles[i];
		var domStyle = stylesInDom[item.id];

		if(domStyle) {
			domStyle.refs++;

			for(var j = 0; j < domStyle.parts.length; j++) {
				domStyle.parts[j](item.parts[j]);
			}

			for(; j < item.parts.length; j++) {
				domStyle.parts.push(addStyle(item.parts[j], options));
			}
		} else {
			var parts = [];

			for(var j = 0; j < item.parts.length; j++) {
				parts.push(addStyle(item.parts[j], options));
			}

			stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
		}
	}
}

function listToStyles (list, options) {
	var styles = [];
	var newStyles = {};

	for (var i = 0; i < list.length; i++) {
		var item = list[i];
		var id = options.base ? item[0] + options.base : item[0];
		var css = item[1];
		var media = item[2];
		var sourceMap = item[3];
		var part = {css: css, media: media, sourceMap: sourceMap};

		if(!newStyles[id]) styles.push(newStyles[id] = {id: id, parts: [part]});
		else newStyles[id].parts.push(part);
	}

	return styles;
}

function insertStyleElement (options, style) {
	var target = getElement(options.insertInto)

	if (!target) {
		throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
	}

	var lastStyleElementInsertedAtTop = stylesInsertedAtTop[stylesInsertedAtTop.length - 1];

	if (options.insertAt === "top") {
		if (!lastStyleElementInsertedAtTop) {
			target.insertBefore(style, target.firstChild);
		} else if (lastStyleElementInsertedAtTop.nextSibling) {
			target.insertBefore(style, lastStyleElementInsertedAtTop.nextSibling);
		} else {
			target.appendChild(style);
		}
		stylesInsertedAtTop.push(style);
	} else if (options.insertAt === "bottom") {
		target.appendChild(style);
	} else if (typeof options.insertAt === "object" && options.insertAt.before) {
		var nextSibling = getElement(options.insertInto + " " + options.insertAt.before);
		target.insertBefore(style, nextSibling);
	} else {
		throw new Error("[Style Loader]\n\n Invalid value for parameter 'insertAt' ('options.insertAt') found.\n Must be 'top', 'bottom', or Object.\n (https://github.com/webpack-contrib/style-loader#insertat)\n");
	}
}

function removeStyleElement (style) {
	if (style.parentNode === null) return false;
	style.parentNode.removeChild(style);

	var idx = stylesInsertedAtTop.indexOf(style);
	if(idx >= 0) {
		stylesInsertedAtTop.splice(idx, 1);
	}
}

function createStyleElement (options) {
	var style = document.createElement("style");

	options.attrs.type = "text/css";

	addAttrs(style, options.attrs);
	insertStyleElement(options, style);

	return style;
}

function createLinkElement (options) {
	var link = document.createElement("link");

	options.attrs.type = "text/css";
	options.attrs.rel = "stylesheet";

	addAttrs(link, options.attrs);
	insertStyleElement(options, link);

	return link;
}

function addAttrs (el, attrs) {
	Object.keys(attrs).forEach(function (key) {
		el.setAttribute(key, attrs[key]);
	});
}

function addStyle (obj, options) {
	var style, update, remove, result;

	// If a transform function was defined, run it on the css
	if (options.transform && obj.css) {
	    result = options.transform(obj.css);

	    if (result) {
	    	// If transform returns a value, use that instead of the original css.
	    	// This allows running runtime transformations on the css.
	    	obj.css = result;
	    } else {
	    	// If the transform function returns a falsy value, don't add this css.
	    	// This allows conditional loading of css
	    	return function() {
	    		// noop
	    	};
	    }
	}

	if (options.singleton) {
		var styleIndex = singletonCounter++;

		style = singleton || (singleton = createStyleElement(options));

		update = applyToSingletonTag.bind(null, style, styleIndex, false);
		remove = applyToSingletonTag.bind(null, style, styleIndex, true);

	} else if (
		obj.sourceMap &&
		typeof URL === "function" &&
		typeof URL.createObjectURL === "function" &&
		typeof URL.revokeObjectURL === "function" &&
		typeof Blob === "function" &&
		typeof btoa === "function"
	) {
		style = createLinkElement(options);
		update = updateLink.bind(null, style, options);
		remove = function () {
			removeStyleElement(style);

			if(style.href) URL.revokeObjectURL(style.href);
		};
	} else {
		style = createStyleElement(options);
		update = applyToTag.bind(null, style);
		remove = function () {
			removeStyleElement(style);
		};
	}

	update(obj);

	return function updateStyle (newObj) {
		if (newObj) {
			if (
				newObj.css === obj.css &&
				newObj.media === obj.media &&
				newObj.sourceMap === obj.sourceMap
			) {
				return;
			}

			update(obj = newObj);
		} else {
			remove();
		}
	};
}

var replaceText = (function () {
	var textStore = [];

	return function (index, replacement) {
		textStore[index] = replacement;

		return textStore.filter(Boolean).join('\n');
	};
})();

function applyToSingletonTag (style, index, remove, obj) {
	var css = remove ? "" : obj.css;

	if (style.styleSheet) {
		style.styleSheet.cssText = replaceText(index, css);
	} else {
		var cssNode = document.createTextNode(css);
		var childNodes = style.childNodes;

		if (childNodes[index]) style.removeChild(childNodes[index]);

		if (childNodes.length) {
			style.insertBefore(cssNode, childNodes[index]);
		} else {
			style.appendChild(cssNode);
		}
	}
}

function applyToTag (style, obj) {
	var css = obj.css;
	var media = obj.media;

	if(media) {
		style.setAttribute("media", media)
	}

	if(style.styleSheet) {
		style.styleSheet.cssText = css;
	} else {
		while(style.firstChild) {
			style.removeChild(style.firstChild);
		}

		style.appendChild(document.createTextNode(css));
	}
}

function updateLink (link, options, obj) {
	var css = obj.css;
	var sourceMap = obj.sourceMap;

	/*
		If convertToAbsoluteUrls isn't defined, but sourcemaps are enabled
		and there is no publicPath defined then lets turn convertToAbsoluteUrls
		on by default.  Otherwise default to the convertToAbsoluteUrls option
		directly
	*/
	var autoFixUrls = options.convertToAbsoluteUrls === undefined && sourceMap;

	if (options.convertToAbsoluteUrls || autoFixUrls) {
		css = fixUrls(css);
	}

	if (sourceMap) {
		// http://stackoverflow.com/a/26603875
		css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
	}

	var blob = new Blob([css], { type: "text/css" });

	var oldSrc = link.href;

	link.href = URL.createObjectURL(blob);

	if(oldSrc) URL.revokeObjectURL(oldSrc);
}


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(41);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_fetch__ = __webpack_require__(634);
/* harmony default export */ __webpack_exports__["a"] = ({get:function get(path,body,headers,autoHandle,autoControlSpinner){return Object(__WEBPACK_IMPORTED_MODULE_0__config_fetch__["a" /* default */])(path,{method:"get",body:body},headers,autoHandle,autoControlSpinner);},post:function post(path,body,headers,autoHandle,autoControlSpinner){return Object(__WEBPACK_IMPORTED_MODULE_0__config_fetch__["a" /* default */])(path,{method:"post",body:body},headers,autoHandle,autoControlSpinner);},put:function put(path,body){return Object(__WEBPACK_IMPORTED_MODULE_0__config_fetch__["a" /* default */])(path,{method:"put",body:body});},delete:function _delete(path,body){return Object(__WEBPACK_IMPORTED_MODULE_0__config_fetch__["a" /* default */])(path,{method:"delete",body:body});}});

/***/ }),
/* 20 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__hoc_ReactAux_ReactAux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_modal__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ErrorReference__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_userError__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modalError_scss__ = __webpack_require__(674);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modalError_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__modalError_scss__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var customStyles={content:{background:'none',border:'none'},overlay:{zIndex:'9999999',width:'100%',height:'100%',left:'0',top:'0',backgroundColor:'rgba(0, 0, 0, 0.7)'}// Every error popup: what failed, why (when known), what to do next, and a reference line
// support can use (docs/ERROR_MESSAGES.md). errorMessage is a userError / mapCheckoutError
// result; a plain string is shown as the body under a title built from area/task/title props.
};var ModalError=function(_Component){_inherits(ModalError,_Component);function ModalError(){_classCallCheck(this,ModalError);return _possibleConstructorReturn(this,(ModalError.__proto__||Object.getPrototypeOf(ModalError)).apply(this,arguments));}_createClass(ModalError,[{key:'displayFor',value:function displayFor(value){// The same error keeps the same reference time across re-renders.
if(!this.cached||this.cached.value!==value){this.cached={value:value,display:Object(__WEBPACK_IMPORTED_MODULE_4__utils_userError__["g" /* toDisplayError */])(value,{area:this.props.area,task:this.props.task,title:this.props.title,code:this.props.errorCode})};}return this.cached.display;}},{key:'render',value:function render(){if(!this.props.showModal){return null;}var error=this.displayFor(this.props.errorMessage);var title=error.title,message=error.message,guidance=error.guidance,orderNumber=error.orderNumber;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__hoc_ReactAux_ReactAux__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_modal___default.a,{isOpen:this.props.showModal,style:customStyles,onRequestClose:this.props.closeModal,shouldCloseOnOverlayClick:true,shouldCloseOnEsc:true,role:'alertdialog',aria:{describedby:'checkout-error-description',labelledby:'checkout-error-title'},contentLabel:title},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:this.props.style,id:'lb-error',className:'lb-geral lb-error_ mfp-bg-login error-popup-block  lb-centralizar singup zoom-anim-dialog'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'lb-padrao-singup6 mfp-content-login modal-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',onClick:this.props.closeModal,className:'bt-close mfp-close lb-fechar fa fa-times','aria-label':'Close error message'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'check-mark'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'fa fa-exclamation-circle lt-error-icon','aria-hidden':'true'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:this.props.styleContent,className:'lb-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'order lt-modal-error__body',id:'checkout-error-description'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',{id:'checkout-error-title',className:'lt-modal-error__title'},title),message?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'lt-modal-error__message'},message):null,guidance?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'lt-modal-error__guidance'},guidance):null,orderNumber?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'lt-modal-error__order'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Order number:'),' ',orderNumber):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__ErrorReference__["a" /* default */],{error:error,showContact:true,onContactSupport:this.props.closeModal})),!!this.props.actionButton?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',onClick:this.props.actionButton,className:'bt'},this.props.actionButtonTitle):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',onClick:this.props.closeModal,className:'bt'},'Close'))))));}}]);return ModalError;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (ModalError);

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(16);
var createDesc = __webpack_require__(55);
module.exports = __webpack_require__(12) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(3);
var hide = __webpack_require__(22);
var has = __webpack_require__(27);
var SRC = __webpack_require__(56)('src');
var $toString = __webpack_require__(345);
var TO_STRING = 'toString';
var TPL = ('' + $toString).split(TO_STRING);

__webpack_require__(31).inspectSource = function (it) {
  return $toString.call(it);
};

(module.exports = function (O, key, val, safe) {
  var isFunction = typeof val == 'function';
  if (isFunction) has(val, 'name') || hide(val, 'name', key);
  if (O[key] === val) return;
  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
  if (O === global) {
    O[key] = val;
  } else if (!safe) {
    delete O[key];
    hide(O, key, val);
  } else if (O[key]) {
    O[key] = val;
  } else {
    hide(O, key, val);
  }
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, TO_STRING, function toString() {
  return typeof this == 'function' && this[SRC] || $toString.call(this);
});


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(1);
var fails = __webpack_require__(6);
var defined = __webpack_require__(41);
var quot = /"/g;
// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
var createHTML = function (string, tag, attribute, value) {
  var S = String(defined(string));
  var p1 = '<' + tag;
  if (attribute !== '') p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
  return p1 + '>' + S + '</' + tag + '>';
};
module.exports = function (NAME, exec) {
  var O = {};
  O[NAME] = exec(createHTML);
  $export($export.P + $export.F * fails(function () {
    var test = ''[NAME]('"');
    return test !== test.toLowerCase() || test.split('"').length > 3;
  }), 'String', O);
};


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Modal = __webpack_require__(546);

var _Modal2 = _interopRequireDefault(_Modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Modal2.default;
module.exports = exports["default"];

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BrowserRouter__ = __webpack_require__(559);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__BrowserRouter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HashRouter__ = __webpack_require__(564);
/* unused harmony reexport HashRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Link__ = __webpack_require__(254);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__Link__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MemoryRouter__ = __webpack_require__(565);
/* unused harmony reexport MemoryRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NavLink__ = __webpack_require__(567);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_4__NavLink__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Prompt__ = __webpack_require__(569);
/* unused harmony reexport Prompt */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Redirect__ = __webpack_require__(571);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_6__Redirect__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Route__ = __webpack_require__(255);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_7__Route__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Router__ = __webpack_require__(172);
/* unused harmony reexport Router */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__StaticRouter__ = __webpack_require__(573);
/* unused harmony reexport StaticRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Switch__ = __webpack_require__(575);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_10__Switch__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__generatePath__ = __webpack_require__(577);
/* unused harmony reexport generatePath */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__matchPath__ = __webpack_require__(578);
/* unused harmony reexport matchPath */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__withRouter__ = __webpack_require__(579);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_13__withRouter__["a"]; });





























/***/ }),
/* 27 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(84);
var defined = __webpack_require__(41);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(85);
var createDesc = __webpack_require__(55);
var toIObject = __webpack_require__(28);
var toPrimitive = __webpack_require__(40);
var has = __webpack_require__(27);
var IE8_DOM_DEFINE = __webpack_require__(215);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(12) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(27);
var toObject = __webpack_require__(18);
var IE_PROTO = __webpack_require__(146)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 31 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.11' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(20);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 33 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 34 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(6);

module.exports = function (method, arg) {
  return !!method && fails(function () {
    // eslint-disable-next-line no-useless-call
    arg ? method.call(null, function () { /* empty */ }, 1) : method.call(null);
  });
};


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function checkDCE() {
  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
  if (
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
  ) {
    return;
  }
  if (false) {
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error('^_^');
  }
  try {
    // Verify that the code above has been dead code eliminated (DCE'd).
    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
  } catch (err) {
    // DevTools shouldn't crash React, no matter what.
    // We should still report in case we break this code.
    console.error(err);
  }
}

if (true) {
  // DCE check should happen before ReactDOM bundle executes so that
  // DevTools can report bad minification during injection.
  checkDCE();
  module.exports = __webpack_require__(547);
} else {
  module.exports = require('./cjs/react-dom.development.js');
}


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = "production" !== 'production';

var warning = function() {};

if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 1 ? len - 1 : 0);
    for (var key = 1; key < len; key++) {
      args[key - 1] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' +
      format.replace(/%s/g, function() {
        return args[argIndex++];
      });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  }

  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
          '`warning(condition, format, ...args)` requires a warning ' +
          'message argument'
      );
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

module.exports = warning;


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(640);


/***/ }),
/* 39 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(9);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 41 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(1);
var core = __webpack_require__(31);
var fails = __webpack_require__(6);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx = __webpack_require__(32);
var IObject = __webpack_require__(84);
var toObject = __webpack_require__(18);
var toLength = __webpack_require__(11);
var asc = __webpack_require__(162);
module.exports = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || asc;
  return function ($this, callbackfn, that) {
    var O = toObject($this);
    var self = IObject(O);
    var f = ctx(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      val = self[index];
      res = f(val, index, O);
      if (TYPE) {
        if (IS_MAP) result[index] = res;   // map
        else if (res) switch (TYPE) {
          case 3: return true;             // some
          case 5: return val;              // find
          case 6: return index;            // findIndex
          case 2: result.push(val);        // filter
        } else if (IS_EVERY) return false; // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};


/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export path */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return shallowEquals; });
function getValue(object,path){return path.replace(/\[/g,'.').replace(/\]/g,'').split('.').reduce(function(o,k){return(o||{})[k];},object);}function get(object,path,defaultValue){var result=object==null?undefined:getValue(object,path);return result===undefined?defaultValue:result;}var path=function path(pathString,object){return pathString.split('.').reduce(function(obj,key){return obj[key]===undefined?undefined:obj[key];},object);};var shallowEquals=function shallowEquals(a,b){for(var _len=arguments.length,keys=Array(_len>2?_len-2:0),_key=2;_key<_len;_key++){keys[_key-2]=arguments[_key];}return(keys.length?keys:Object.keys(a)).every(function(key){return a[key]===b[key];});};/* harmony default export */ __webpack_exports__["a"] = ({path:path,get:get,shallowEquals:shallowEquals});

/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var CURRENCY_SYMBOLS={'USD':'$ ',// US Dollar
'AUD':'AU$ ',// Autraliano Dollar
'EUR':'€ ',// Euro
'CRC':'₡ ',// Costa Rican Colón
'GBP':'£ ',// British Pound Sterling
'ILS':'₪ ',// Israeli New Sheqel
'INR':'₹ ',// Indian Rupee
'JPY':'¥ ',// Japanese Yen
'KRW':'₩ ',// South Korean Won
'NGN':'₦ ',// Nigerian Naira
'PHP':'₱ ',// Philippine Peso
'PLN':'zł ',// Polish Zloty
'PYG':'₲ ',// Paraguayan Guarani
'THB':'฿ ',// Thai Baht
'UAH':'₴ ',// Ukrainian Hryvnia
'VND':'₫ '// Vietnamese Dong
};var convertNameToSymbol=function convertNameToSymbol(currencyName){currencyName=!currencyName||isFinite(currencyName)?'':currencyName.toUpperCase();if(!!CURRENCY_SYMBOLS[currencyName]){return CURRENCY_SYMBOLS[currencyName];}return'€ ';};/* harmony default export */ __webpack_exports__["a"] = ({convertNameToSymbol:convertNameToSymbol});

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

if (__webpack_require__(12)) {
  var LIBRARY = __webpack_require__(50);
  var global = __webpack_require__(3);
  var fails = __webpack_require__(6);
  var $export = __webpack_require__(1);
  var $typed = __webpack_require__(110);
  var $buffer = __webpack_require__(170);
  var ctx = __webpack_require__(32);
  var anInstance = __webpack_require__(62);
  var propertyDesc = __webpack_require__(55);
  var hide = __webpack_require__(22);
  var redefineAll = __webpack_require__(64);
  var toInteger = __webpack_require__(34);
  var toLength = __webpack_require__(11);
  var toIndex = __webpack_require__(243);
  var toAbsoluteIndex = __webpack_require__(58);
  var toPrimitive = __webpack_require__(40);
  var has = __webpack_require__(27);
  var classof = __webpack_require__(74);
  var isObject = __webpack_require__(9);
  var toObject = __webpack_require__(18);
  var isArrayIter = __webpack_require__(159);
  var create = __webpack_require__(59);
  var getPrototypeOf = __webpack_require__(30);
  var gOPN = __webpack_require__(60).f;
  var getIterFn = __webpack_require__(161);
  var uid = __webpack_require__(56);
  var wks = __webpack_require__(10);
  var createArrayMethod = __webpack_require__(43);
  var createArrayIncludes = __webpack_require__(100);
  var speciesConstructor = __webpack_require__(87);
  var ArrayIterators = __webpack_require__(164);
  var Iterators = __webpack_require__(76);
  var $iterDetect = __webpack_require__(105);
  var setSpecies = __webpack_require__(61);
  var arrayFill = __webpack_require__(163);
  var arrayCopyWithin = __webpack_require__(232);
  var $DP = __webpack_require__(16);
  var $GOPD = __webpack_require__(29);
  var dP = $DP.f;
  var gOPD = $GOPD.f;
  var RangeError = global.RangeError;
  var TypeError = global.TypeError;
  var Uint8Array = global.Uint8Array;
  var ARRAY_BUFFER = 'ArrayBuffer';
  var SHARED_BUFFER = 'Shared' + ARRAY_BUFFER;
  var BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT';
  var PROTOTYPE = 'prototype';
  var ArrayProto = Array[PROTOTYPE];
  var $ArrayBuffer = $buffer.ArrayBuffer;
  var $DataView = $buffer.DataView;
  var arrayForEach = createArrayMethod(0);
  var arrayFilter = createArrayMethod(2);
  var arraySome = createArrayMethod(3);
  var arrayEvery = createArrayMethod(4);
  var arrayFind = createArrayMethod(5);
  var arrayFindIndex = createArrayMethod(6);
  var arrayIncludes = createArrayIncludes(true);
  var arrayIndexOf = createArrayIncludes(false);
  var arrayValues = ArrayIterators.values;
  var arrayKeys = ArrayIterators.keys;
  var arrayEntries = ArrayIterators.entries;
  var arrayLastIndexOf = ArrayProto.lastIndexOf;
  var arrayReduce = ArrayProto.reduce;
  var arrayReduceRight = ArrayProto.reduceRight;
  var arrayJoin = ArrayProto.join;
  var arraySort = ArrayProto.sort;
  var arraySlice = ArrayProto.slice;
  var arrayToString = ArrayProto.toString;
  var arrayToLocaleString = ArrayProto.toLocaleString;
  var ITERATOR = wks('iterator');
  var TAG = wks('toStringTag');
  var TYPED_CONSTRUCTOR = uid('typed_constructor');
  var DEF_CONSTRUCTOR = uid('def_constructor');
  var ALL_CONSTRUCTORS = $typed.CONSTR;
  var TYPED_ARRAY = $typed.TYPED;
  var VIEW = $typed.VIEW;
  var WRONG_LENGTH = 'Wrong length!';

  var $map = createArrayMethod(1, function (O, length) {
    return allocate(speciesConstructor(O, O[DEF_CONSTRUCTOR]), length);
  });

  var LITTLE_ENDIAN = fails(function () {
    // eslint-disable-next-line no-undef
    return new Uint8Array(new Uint16Array([1]).buffer)[0] === 1;
  });

  var FORCED_SET = !!Uint8Array && !!Uint8Array[PROTOTYPE].set && fails(function () {
    new Uint8Array(1).set({});
  });

  var toOffset = function (it, BYTES) {
    var offset = toInteger(it);
    if (offset < 0 || offset % BYTES) throw RangeError('Wrong offset!');
    return offset;
  };

  var validate = function (it) {
    if (isObject(it) && TYPED_ARRAY in it) return it;
    throw TypeError(it + ' is not a typed array!');
  };

  var allocate = function (C, length) {
    if (!(isObject(C) && TYPED_CONSTRUCTOR in C)) {
      throw TypeError('It is not a typed array constructor!');
    } return new C(length);
  };

  var speciesFromList = function (O, list) {
    return fromList(speciesConstructor(O, O[DEF_CONSTRUCTOR]), list);
  };

  var fromList = function (C, list) {
    var index = 0;
    var length = list.length;
    var result = allocate(C, length);
    while (length > index) result[index] = list[index++];
    return result;
  };

  var addGetter = function (it, key, internal) {
    dP(it, key, { get: function () { return this._d[internal]; } });
  };

  var $from = function from(source /* , mapfn, thisArg */) {
    var O = toObject(source);
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var iterFn = getIterFn(O);
    var i, length, values, result, step, iterator;
    if (iterFn != undefined && !isArrayIter(iterFn)) {
      for (iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++) {
        values.push(step.value);
      } O = values;
    }
    if (mapping && aLen > 2) mapfn = ctx(mapfn, arguments[2], 2);
    for (i = 0, length = toLength(O.length), result = allocate(this, length); length > i; i++) {
      result[i] = mapping ? mapfn(O[i], i) : O[i];
    }
    return result;
  };

  var $of = function of(/* ...items */) {
    var index = 0;
    var length = arguments.length;
    var result = allocate(this, length);
    while (length > index) result[index] = arguments[index++];
    return result;
  };

  // iOS Safari 6.x fails here
  var TO_LOCALE_BUG = !!Uint8Array && fails(function () { arrayToLocaleString.call(new Uint8Array(1)); });

  var $toLocaleString = function toLocaleString() {
    return arrayToLocaleString.apply(TO_LOCALE_BUG ? arraySlice.call(validate(this)) : validate(this), arguments);
  };

  var proto = {
    copyWithin: function copyWithin(target, start /* , end */) {
      return arrayCopyWithin.call(validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
    },
    every: function every(callbackfn /* , thisArg */) {
      return arrayEvery(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    fill: function fill(value /* , start, end */) { // eslint-disable-line no-unused-vars
      return arrayFill.apply(validate(this), arguments);
    },
    filter: function filter(callbackfn /* , thisArg */) {
      return speciesFromList(this, arrayFilter(validate(this), callbackfn,
        arguments.length > 1 ? arguments[1] : undefined));
    },
    find: function find(predicate /* , thisArg */) {
      return arrayFind(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    findIndex: function findIndex(predicate /* , thisArg */) {
      return arrayFindIndex(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    forEach: function forEach(callbackfn /* , thisArg */) {
      arrayForEach(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    indexOf: function indexOf(searchElement /* , fromIndex */) {
      return arrayIndexOf(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    includes: function includes(searchElement /* , fromIndex */) {
      return arrayIncludes(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    join: function join(separator) { // eslint-disable-line no-unused-vars
      return arrayJoin.apply(validate(this), arguments);
    },
    lastIndexOf: function lastIndexOf(searchElement /* , fromIndex */) { // eslint-disable-line no-unused-vars
      return arrayLastIndexOf.apply(validate(this), arguments);
    },
    map: function map(mapfn /* , thisArg */) {
      return $map(validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    reduce: function reduce(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
      return arrayReduce.apply(validate(this), arguments);
    },
    reduceRight: function reduceRight(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
      return arrayReduceRight.apply(validate(this), arguments);
    },
    reverse: function reverse() {
      var that = this;
      var length = validate(that).length;
      var middle = Math.floor(length / 2);
      var index = 0;
      var value;
      while (index < middle) {
        value = that[index];
        that[index++] = that[--length];
        that[length] = value;
      } return that;
    },
    some: function some(callbackfn /* , thisArg */) {
      return arraySome(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    sort: function sort(comparefn) {
      return arraySort.call(validate(this), comparefn);
    },
    subarray: function subarray(begin, end) {
      var O = validate(this);
      var length = O.length;
      var $begin = toAbsoluteIndex(begin, length);
      return new (speciesConstructor(O, O[DEF_CONSTRUCTOR]))(
        O.buffer,
        O.byteOffset + $begin * O.BYTES_PER_ELEMENT,
        toLength((end === undefined ? length : toAbsoluteIndex(end, length)) - $begin)
      );
    }
  };

  var $slice = function slice(start, end) {
    return speciesFromList(this, arraySlice.call(validate(this), start, end));
  };

  var $set = function set(arrayLike /* , offset */) {
    validate(this);
    var offset = toOffset(arguments[1], 1);
    var length = this.length;
    var src = toObject(arrayLike);
    var len = toLength(src.length);
    var index = 0;
    if (len + offset > length) throw RangeError(WRONG_LENGTH);
    while (index < len) this[offset + index] = src[index++];
  };

  var $iterators = {
    entries: function entries() {
      return arrayEntries.call(validate(this));
    },
    keys: function keys() {
      return arrayKeys.call(validate(this));
    },
    values: function values() {
      return arrayValues.call(validate(this));
    }
  };

  var isTAIndex = function (target, key) {
    return isObject(target)
      && target[TYPED_ARRAY]
      && typeof key != 'symbol'
      && key in target
      && String(+key) == String(key);
  };
  var $getDesc = function getOwnPropertyDescriptor(target, key) {
    return isTAIndex(target, key = toPrimitive(key, true))
      ? propertyDesc(2, target[key])
      : gOPD(target, key);
  };
  var $setDesc = function defineProperty(target, key, desc) {
    if (isTAIndex(target, key = toPrimitive(key, true))
      && isObject(desc)
      && has(desc, 'value')
      && !has(desc, 'get')
      && !has(desc, 'set')
      // TODO: add validation descriptor w/o calling accessors
      && !desc.configurable
      && (!has(desc, 'writable') || desc.writable)
      && (!has(desc, 'enumerable') || desc.enumerable)
    ) {
      target[key] = desc.value;
      return target;
    } return dP(target, key, desc);
  };

  if (!ALL_CONSTRUCTORS) {
    $GOPD.f = $getDesc;
    $DP.f = $setDesc;
  }

  $export($export.S + $export.F * !ALL_CONSTRUCTORS, 'Object', {
    getOwnPropertyDescriptor: $getDesc,
    defineProperty: $setDesc
  });

  if (fails(function () { arrayToString.call({}); })) {
    arrayToString = arrayToLocaleString = function toString() {
      return arrayJoin.call(this);
    };
  }

  var $TypedArrayPrototype$ = redefineAll({}, proto);
  redefineAll($TypedArrayPrototype$, $iterators);
  hide($TypedArrayPrototype$, ITERATOR, $iterators.values);
  redefineAll($TypedArrayPrototype$, {
    slice: $slice,
    set: $set,
    constructor: function () { /* noop */ },
    toString: arrayToString,
    toLocaleString: $toLocaleString
  });
  addGetter($TypedArrayPrototype$, 'buffer', 'b');
  addGetter($TypedArrayPrototype$, 'byteOffset', 'o');
  addGetter($TypedArrayPrototype$, 'byteLength', 'l');
  addGetter($TypedArrayPrototype$, 'length', 'e');
  dP($TypedArrayPrototype$, TAG, {
    get: function () { return this[TYPED_ARRAY]; }
  });

  // eslint-disable-next-line max-statements
  module.exports = function (KEY, BYTES, wrapper, CLAMPED) {
    CLAMPED = !!CLAMPED;
    var NAME = KEY + (CLAMPED ? 'Clamped' : '') + 'Array';
    var GETTER = 'get' + KEY;
    var SETTER = 'set' + KEY;
    var TypedArray = global[NAME];
    var Base = TypedArray || {};
    var TAC = TypedArray && getPrototypeOf(TypedArray);
    var FORCED = !TypedArray || !$typed.ABV;
    var O = {};
    var TypedArrayPrototype = TypedArray && TypedArray[PROTOTYPE];
    var getter = function (that, index) {
      var data = that._d;
      return data.v[GETTER](index * BYTES + data.o, LITTLE_ENDIAN);
    };
    var setter = function (that, index, value) {
      var data = that._d;
      if (CLAMPED) value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
      data.v[SETTER](index * BYTES + data.o, value, LITTLE_ENDIAN);
    };
    var addElement = function (that, index) {
      dP(that, index, {
        get: function () {
          return getter(this, index);
        },
        set: function (value) {
          return setter(this, index, value);
        },
        enumerable: true
      });
    };
    if (FORCED) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME, '_d');
        var index = 0;
        var offset = 0;
        var buffer, byteLength, length, klass;
        if (!isObject(data)) {
          length = toIndex(data);
          byteLength = length * BYTES;
          buffer = new $ArrayBuffer(byteLength);
        } else if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          buffer = data;
          offset = toOffset($offset, BYTES);
          var $len = data.byteLength;
          if ($length === undefined) {
            if ($len % BYTES) throw RangeError(WRONG_LENGTH);
            byteLength = $len - offset;
            if (byteLength < 0) throw RangeError(WRONG_LENGTH);
          } else {
            byteLength = toLength($length) * BYTES;
            if (byteLength + offset > $len) throw RangeError(WRONG_LENGTH);
          }
          length = byteLength / BYTES;
        } else if (TYPED_ARRAY in data) {
          return fromList(TypedArray, data);
        } else {
          return $from.call(TypedArray, data);
        }
        hide(that, '_d', {
          b: buffer,
          o: offset,
          l: byteLength,
          e: length,
          v: new $DataView(buffer)
        });
        while (index < length) addElement(that, index++);
      });
      TypedArrayPrototype = TypedArray[PROTOTYPE] = create($TypedArrayPrototype$);
      hide(TypedArrayPrototype, 'constructor', TypedArray);
    } else if (!fails(function () {
      TypedArray(1);
    }) || !fails(function () {
      new TypedArray(-1); // eslint-disable-line no-new
    }) || !$iterDetect(function (iter) {
      new TypedArray(); // eslint-disable-line no-new
      new TypedArray(null); // eslint-disable-line no-new
      new TypedArray(1.5); // eslint-disable-line no-new
      new TypedArray(iter); // eslint-disable-line no-new
    }, true)) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME);
        var klass;
        // `ws` module bug, temporarily remove validation length for Uint8Array
        // https://github.com/websockets/ws/pull/645
        if (!isObject(data)) return new Base(toIndex(data));
        if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          return $length !== undefined
            ? new Base(data, toOffset($offset, BYTES), $length)
            : $offset !== undefined
              ? new Base(data, toOffset($offset, BYTES))
              : new Base(data);
        }
        if (TYPED_ARRAY in data) return fromList(TypedArray, data);
        return $from.call(TypedArray, data);
      });
      arrayForEach(TAC !== Function.prototype ? gOPN(Base).concat(gOPN(TAC)) : gOPN(Base), function (key) {
        if (!(key in TypedArray)) hide(TypedArray, key, Base[key]);
      });
      TypedArray[PROTOTYPE] = TypedArrayPrototype;
      if (!LIBRARY) TypedArrayPrototype.constructor = TypedArray;
    }
    var $nativeIterator = TypedArrayPrototype[ITERATOR];
    var CORRECT_ITER_NAME = !!$nativeIterator
      && ($nativeIterator.name == 'values' || $nativeIterator.name == undefined);
    var $iterator = $iterators.values;
    hide(TypedArray, TYPED_CONSTRUCTOR, true);
    hide(TypedArrayPrototype, TYPED_ARRAY, NAME);
    hide(TypedArrayPrototype, VIEW, true);
    hide(TypedArrayPrototype, DEF_CONSTRUCTOR, TypedArray);

    if (CLAMPED ? new TypedArray(1)[TAG] != NAME : !(TAG in TypedArrayPrototype)) {
      dP(TypedArrayPrototype, TAG, {
        get: function () { return NAME; }
      });
    }

    O[NAME] = TypedArray;

    $export($export.G + $export.W + $export.F * (TypedArray != Base), O);

    $export($export.S, NAME, {
      BYTES_PER_ELEMENT: BYTES
    });

    $export($export.S + $export.F * fails(function () { Base.of.call(TypedArray, 1); }), NAME, {
      from: $from,
      of: $of
    });

    if (!(BYTES_PER_ELEMENT in TypedArrayPrototype)) hide(TypedArrayPrototype, BYTES_PER_ELEMENT, BYTES);

    $export($export.P, NAME, proto);

    setSpecies(NAME);

    $export($export.P + $export.F * FORCED_SET, NAME, { set: $set });

    $export($export.P + $export.F * !CORRECT_ITER_NAME, NAME, $iterators);

    if (!LIBRARY && TypedArrayPrototype.toString != arrayToString) TypedArrayPrototype.toString = arrayToString;

    $export($export.P + $export.F * fails(function () {
      new TypedArray(1).slice();
    }), NAME, { slice: $slice });

    $export($export.P + $export.F * (fails(function () {
      return [1, 2].toLocaleString() != new TypedArray([1, 2]).toLocaleString();
    }) || !fails(function () {
      TypedArrayPrototype.toLocaleString.call([1, 2]);
    })), NAME, { toLocaleString: $toLocaleString });

    Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
    if (!LIBRARY && !CORRECT_ITER_NAME) hide(TypedArrayPrototype, ITERATOR, $iterator);
  };
} else module.exports = function () { /* empty */ };


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

var Map = __webpack_require__(238);
var $export = __webpack_require__(1);
var shared = __webpack_require__(83)('metadata');
var store = shared.store || (shared.store = new (__webpack_require__(241))());

var getOrCreateMetadataMap = function (target, targetKey, create) {
  var targetMetadata = store.get(target);
  if (!targetMetadata) {
    if (!create) return undefined;
    store.set(target, targetMetadata = new Map());
  }
  var keyMetadata = targetMetadata.get(targetKey);
  if (!keyMetadata) {
    if (!create) return undefined;
    targetMetadata.set(targetKey, keyMetadata = new Map());
  } return keyMetadata;
};
var ordinaryHasOwnMetadata = function (MetadataKey, O, P) {
  var metadataMap = getOrCreateMetadataMap(O, P, false);
  return metadataMap === undefined ? false : metadataMap.has(MetadataKey);
};
var ordinaryGetOwnMetadata = function (MetadataKey, O, P) {
  var metadataMap = getOrCreateMetadataMap(O, P, false);
  return metadataMap === undefined ? undefined : metadataMap.get(MetadataKey);
};
var ordinaryDefineOwnMetadata = function (MetadataKey, MetadataValue, O, P) {
  getOrCreateMetadataMap(O, P, true).set(MetadataKey, MetadataValue);
};
var ordinaryOwnMetadataKeys = function (target, targetKey) {
  var metadataMap = getOrCreateMetadataMap(target, targetKey, false);
  var keys = [];
  if (metadataMap) metadataMap.forEach(function (_, key) { keys.push(key); });
  return keys;
};
var toMetaKey = function (it) {
  return it === undefined || typeof it == 'symbol' ? it : String(it);
};
var exp = function (O) {
  $export($export.S, 'Reflect', O);
};

module.exports = {
  store: store,
  map: getOrCreateMetadataMap,
  has: ordinaryHasOwnMetadata,
  get: ordinaryGetOwnMetadata,
  set: ordinaryDefineOwnMetadata,
  keys: ordinaryOwnMetadataKeys,
  key: toMetaKey,
  exp: exp
};


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg) && arg.length) {
				var inner = classNames.apply(null, arg);
				if (inner) {
					classes.push(inner);
				}
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return classNames;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 50 */
/***/ (function(module, exports) {

module.exports = false;


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(56)('meta');
var isObject = __webpack_require__(9);
var has = __webpack_require__(27);
var setDesc = __webpack_require__(16).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(6)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.31 Array.prototype[@@unscopables]
var UNSCOPABLES = __webpack_require__(10)('unscopables');
var ArrayProto = Array.prototype;
if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__(22)(ArrayProto, UNSCOPABLES, {});
module.exports = function (key) {
  ArrayProto[UNSCOPABLES][key] = true;
};


/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _extends;
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export cleanIds */
/* harmony export (immutable) */ __webpack_exports__["c"] = setSupportContext;
/* harmony export (immutable) */ __webpack_exports__["b"] = overlaySupportContext;
/* unused harmony export useSupportContext */
/* harmony export (immutable) */ __webpack_exports__["a"] = getSupportContext;
/* harmony export (immutable) */ __webpack_exports__["d"] = subscribeSupportContext;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};// Support context: which screen the customer is on and the records in view.
// Screens call setSupportContext (class components, in componentDidMount) or
// useSupportContext (function components). The composer reads it when a
// message is sent; the server adds the signed-in account, tracking and history.
var ID_FIELDS=['orderIds','restaurantId','menuId','productIds','companyId','routeId','printJobId','invoiceId'];var LIST_FIELDS=['orderIds','productIds'];var MAX_LIST=20;var current=null;var listeners=new Set();function currentPath(){return typeof window==='undefined'?'':window.location.pathname;}function present(value){return value!==undefined&&value!==null&&value!=='';}function cleanIds(ids){var cleaned={};if(!ids||(typeof ids==='undefined'?'undefined':_typeof(ids))!=='object'){return cleaned;}ID_FIELDS.forEach(function(field){var value=ids[field];if(LIST_FIELDS.indexOf(field)>=0){var list=Array.isArray(value)?value.filter(present).slice(0,MAX_LIST):[];if(list.length){cleaned[field]=list;}}else if(present(value)){cleaned[field]=value;}});return cleaned;}/**
 * @param {string} screenId e.g. 'checkout.cart'
 * @param {{orderIds?: Array<string|number>, restaurantId?: string|number,
 *   menuId?: string|number, productIds?: Array<string|number>,
 *   companyId?: string|number, routeId?: string|number, printJobId?: string,
 *   invoiceId?: string}} [ids]
 */function setSupportContext(screenId,ids){current={screenId:screenId||null,ids:cleanIds(ids),path:currentPath()};notify();}/**
 * For a drawer or modal over the page (the basket, the payment result): sets its context
 * and returns a function that puts the page's context back when it closes.
 */function overlaySupportContext(screenId,ids){var previous=current;var overlay={screenId:screenId||null,ids:cleanIds(ids),path:currentPath()};current=overlay;notify();return function(){if(current===overlay){current=previous;notify();}};}// Listeners run after the current render: screens may set context while rendering.
function notify(){setTimeout(function(){return listeners.forEach(function(listener){return listener();});},0);}// Hook form for function components: sets the context while the screen is shown.
function useSupportContext(screenId,ids){var key=JSON.stringify([screenId||null,cleanIds(ids)]);Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){setSupportContext(screenId,ids);},[key]);}// A context set on another page is stale: screens without a hook report only their path.
function getSupportContext(){var path=currentPath();if(current&&current.path===path){return{screenId:current.screenId,ids:current.ids,path:path};}return{screenId:null,ids:{},path:path};}function subscribeSupportContext(listener){listeners.add(listener);return function(){return listeners.delete(listener);};}

/***/ }),
/* 55 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 56 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(217);
var enumBugKeys = __webpack_require__(147);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(34);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(2);
var dPs = __webpack_require__(218);
var enumBugKeys = __webpack_require__(147);
var IE_PROTO = __webpack_require__(146)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(144)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(148).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(217);
var hiddenKeys = __webpack_require__(147).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(3);
var dP = __webpack_require__(16);
var DESCRIPTORS = __webpack_require__(12);
var SPECIES = __webpack_require__(10)('species');

module.exports = function (KEY) {
  var C = global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),
/* 62 */
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(32);
var call = __webpack_require__(230);
var isArrayIter = __webpack_require__(159);
var anObject = __webpack_require__(2);
var toLength = __webpack_require__(11);
var getIterFn = __webpack_require__(161);
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

var redefine = __webpack_require__(23);
module.exports = function (target, src, safe) {
  for (var key in src) redefine(target, key, src[key], safe);
  return target;
};


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(9);
module.exports = function (it, TYPE) {
  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
  return it;
};


/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ReactReduxContext; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

var ReactReduxContext =
/*#__PURE__*/
__WEBPACK_IMPORTED_MODULE_0_react___default.a.createContext(null);

if (false) {
  ReactReduxContext.displayName = 'ReactRedux';
}

/* unused harmony default export */ var _unused_webpack_default_export = (ReactReduxContext);

/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return KEY_PREFIX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FLUSH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return REHYDRATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return PAUSE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return PERSIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return PURGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return REGISTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DEFAULT_VERSION; });
var KEY_PREFIX = 'persist:';
var FLUSH = 'persist/FLUSH';
var REHYDRATE = 'persist/REHYDRATE';
var PAUSE = 'persist/PAUSE';
var PERSIST = 'persist/PERSIST';
var PURGE = 'persist/PURGE';
var REGISTER = 'persist/REGISTER';
var DEFAULT_VERSION = -1;

/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export normalizeGuestName */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return isValidGuestName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return createCheckoutRequestKey; });
/* unused harmony export guestFieldsForOrder */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return guestLabel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return GUEST_NAME_MAX; });
/* unused harmony export MAX_GUESTS_PER_CHECKOUT */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return isGuestPolicyEnabled; });
/* unused harmony export maxGuestsThisCheckout */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return canAddGuest; });
/* unused harmony export remainingText */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return recipientNote; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GUEST_NAME_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return recipientSubtitle; });
/* unused harmony export findGuest */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return defaultRecipient; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return createGuest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return guestDisplayName; });
/* unused harmony export basketParties */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return splitBasket; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return pruneGuests; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return partyHeaderName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return cartTotalText; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return guestFieldsForGuest; });
/* unused harmony export NEW_CARD_SEVERAL_PEOPLE */
/* unused harmony export ON_ACCOUNT_NOT_ALLOWED */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return checkoutRefusal; });
/* unused harmony export batchAllPlaced */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return batchResultTitle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return batchResultLines; });
/* unused harmony export GUEST_NAMES_NEEDED */
/* unused harmony export isValidGuest */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return guestNamesRefusal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return trackingHeading; });
// Guest ordering (spec 2026-10-22): the signed-in employee places one order per named guest.
// Mirrors the order service rules in GuestOrderingService.
var NAME_MAX=60;// Latin-1 letters only, matching the order service: receipts and kitchen tickets are stored latin1.
var NAME_PATTERN=/^[A-Za-zÀ-ÖØ-öø-ÿ][A-Za-zÀ-ÖØ-öø-ÿ .'-]*$/;var normalizeGuestName=function normalizeGuestName(value){return typeof value==='string'?(value.normalize?value.normalize('NFC'):value).replace(/[\u2018\u2019]/g,"'").trim().replace(/\s+/g,' '):'';};var isValidGuestName=function isValidGuestName(value){var name=normalizeGuestName(value);return name.length>0&&name.length<=NAME_MAX&&NAME_PATTERN.test(name);};var createCheckoutRequestKey=function createCheckoutRequestKey(){if(typeof window!=='undefined'&&window.crypto&&typeof window.crypto.randomUUID==='function'){return window.crypto.randomUUID();}return'guest-'+Date.now()+'-'+Math.random().toString(36).slice(2);};var guestFieldsForOrder=function guestFieldsForOrder(_ref){var guestOrder=_ref.guestOrder,guestFirstName=_ref.guestFirstName,guestLastName=_ref.guestLastName,checkoutRequestKey=_ref.checkoutRequestKey;if(!guestOrder)return{};return{guestOrder:true,guestFirstName:normalizeGuestName(guestFirstName),guestLastName:normalizeGuestName(guestLastName),checkoutRequestKey:checkoutRequestKey};};var guestLabel=function guestLabel(order){return order&&order.guestOrder?('For '+normalizeGuestName(order.guestFirstName)+' '+normalizeGuestName(order.guestLastName)).trim():null;};var GUEST_NAME_MAX=NAME_MAX;// ---------------------------------------------------------------------------
// "Who's this for?" (guest-ordering-who-is-this-for-ux-2026-10-23.md).
// Each basket item may carry a local guestId (never sent to the server). Guests live
// with the basket as {id, firstName, lastName, requestKey}. At checkout the basket
// is split into one order per person: the employee first, then each guest in the
// order they were added.
var MAX_GUESTS_PER_CHECKOUT=10;// The policy only counts when the server says guest ordering is on.
var isGuestPolicyEnabled=function isGuestPolicyEnabled(policy){return!!policy&&policy.enabled===true;};var hasCap=function hasCap(policy){return!!policy&&policy.remainingToday!==null&&policy.remainingToday!==undefined;};// Most guests one basket can take: what's left today, never more than 10.
var maxGuestsThisCheckout=function maxGuestsThisCheckout(policy){if(!hasCap(policy))return MAX_GUESTS_PER_CHECKOUT;return Math.max(0,Math.min(policy.remainingToday,MAX_GUESTS_PER_CHECKOUT));};var canAddGuest=function canAddGuest(policy,guestCount){return guestCount<maxGuestsThisCheckout(policy);};// "8 guest orders left today", "1 guest order left today", "No guest orders left today";
// null when there is no cap.
var remainingText=function remainingText(policy){if(!hasCap(policy))return null;var left=policy.remainingToday;if(left<=0)return'No guest orders left today';if(left===1)return'1 guest order left today';return left+' guest orders left today';};var NOTE='Each person gets their own order. Their name goes on the label; you get the confirmations.';// The note under the rows of the sheet.
var recipientNote=function recipientNote(policy,guestCount){if(!canAddGuest(policy,guestCount)){if(guestCount===0){return remainingText(policy)||"You can't order for more guests today.";}return"That's as many guests as you can order for today.";}var left=remainingText(policy);return left?left+'. '+NOTE:NOTE;};var GUEST_NAME_ERROR="Enter your guest's first and last name. Use letters (accents are fine), spaces, full stops, apostrophes and hyphens.";// The sheet's subtitle: the item name, or "Repeat order from <restaurant>".
var recipientSubtitle=function recipientSubtitle(payload){if(!payload)return'';if(Array.isArray(payload.product)){var name=payload.business&&payload.business.name;return name?'Repeat order from '+name:'Repeat order';}return payload.product&&payload.product.name||'';};var findGuest=function findGuest(guests,id){return id?(guests||[]).find(function(guest){return guest.id===id;})||null:null;};// Whoever was picked last while they're still in the basket; otherwise Me (null).
var defaultRecipient=function defaultRecipient(lastRecipientId,guests){return findGuest(guests,lastRecipientId)?lastRecipientId:null;};var guestSequence=0;var createGuest=function createGuest(firstName,lastName){guestSequence+=1;return{id:'guest-'+Date.now().toString(36)+'-'+guestSequence,firstName:normalizeGuestName(firstName),lastName:normalizeGuestName(lastName),requestKey:createCheckoutRequestKey()};};// "Mary Byrne", as sent and printed.
var guestDisplayName=function guestDisplayName(guest){return guest?(normalizeGuestName(guest.firstName)+' '+normalizeGuestName(guest.lastName)).trim():'';};var itemGuestId=function itemGuestId(product){return product&&product.guestId||null;};// Who the basket's orders are for, in display and sending order: the employee first
// (when they have items), then each guest with items, in the order they were added.
// null stands for the employee.
var basketParties=function basketParties(products,guests){var ids=(products||[]).map(itemGuestId);var parties=[];if(ids.some(function(id){return id===null;}))parties.push(null);(guests||[]).forEach(function(guest){if(ids.indexOf(guest.id)!==-1)parties.push(guest.id);});return parties;};// The basket split into one group per person, each with its items and subtotal.
var splitBasket=function splitBasket(products,guests){return basketParties(products,guests).map(function(guestId){var items=(products||[]).filter(function(product){return itemGuestId(product)===guestId;});return{guestId:guestId,guest:findGuest(guests,guestId),products:items,subtotal:items.reduce(function(sum,product){return sum+product.price;},0)};});};// Only guests who still have items stay in the basket.
var pruneGuests=function pruneGuests(products,guests){var ids=(products||[]).map(itemGuestId);return(guests||[]).filter(function(guest){return ids.indexOf(guest.id)!==-1;});};// Basket header: "You", or the guest's name (with a "Guest" tag beside it).
var partyHeaderName=function partyHeaderName(party){return party&&party.guest?guestDisplayName(party.guest):'You';};// The cart Total: "€9.50" for one order, "3 orders · €28.50" for one order per person.
var cartTotalText=function cartTotalText(total,orders,currencySymbol){var amount=''+currencySymbol+Number(total||0).toFixed(2);return orders>1?orders+' orders \xB7 '+amount:amount;};// The guest fields for one person's order: nothing for the employee.
var guestFieldsForGuest=function guestFieldsForGuest(guest){return guest?guestFieldsForOrder({guestOrder:true,guestFirstName:guest.firstName,guestLastName:guest.lastName,checkoutRequestKey:guest.requestKey}):{};};var NEW_CARD_SEVERAL_PEOPLE='Each person gets their own order, so a new card would mean paying several times. Choose On Account or a saved card, or order for one person at a time.';var ON_ACCOUNT_NOT_ALLOWED='Your company does not allow guest orders On Account. Please choose another payment method.';// Checks made before anything is sent. Returns the message to show, or null.
// A new card, iDEAL and Bancontact all pay on a separate page for one order, so
// none of them can pay for several people's orders.
var checkoutRefusal=function checkoutRefusal(_ref2){var partyCount=_ref2.partyCount,hasGuest=_ref2.hasGuest,payType=_ref2.payType,payWithAnotherCard=_ref2.payWithAnotherCard,policy=_ref2.policy;if(hasGuest&&payType==='A'&&policy&&policy.onAccountAllowed===false){return ON_ACCOUNT_NOT_ALLOWED;}var paysOnNewPage=payType==='C'&&!!payWithAnotherCard||payType==='I'||payType==='B';if(partyCount>1&&paysOnNewPage){return NEW_CARD_SEVERAL_PEOPLE;}return null;};// What happened when the basket was sent as one order per person.
// placed: [{orderNumber, name}], failedName, failureMessage, notSent: [name].
var batchAllPlaced=function batchAllPlaced(result){return!result.failedName&&result.notSent.length===0;};var batchResultTitle=function batchResultTitle(result){if(batchAllPlaced(result)){return result.placed.length===1?'1 order placed':result.placed.length+' orders placed';}return result.placed.length===0?'Orders not placed':"Some orders weren't placed";};var batchResultLines=function batchResultLines(result){var lines=[];if(result.placed.length>0){lines.push('Placed: '+result.placed.map(function(item){return'order '+item.orderNumber+' for '+item.name;}).join(', ')+'.');}if(result.failedName){var reason=String(result.failureMessage||"we couldn't place it").trim().replace(/\.+$/,'');lines.push('Not placed for '+result.failedName+': '+reason+'.');}if(result.notSent.length>0){lines.push('Not sent yet: '+result.notSent.join(', ')+'.');}if(!batchAllPlaced(result)){lines.push(result.failureCode==='PAYMENT-UNKNOWN-STATE'||result.failureCode==='PAYMENT-DECLINED'?"What wasn't ordered is still in your basket. Check My Orders or contact support before paying for that order again.":"What wasn't ordered is still in your basket. Tap Place Order to try again.");}return lines;};var GUEST_NAMES_NEEDED="Every guest needs a first and last name. Use letters (accents are fine), spaces, full stops, apostrophes and hyphens.";var isValidGuest=function isValidGuest(guest){return!!guest&&isValidGuestName(guest.firstName)&&isValidGuestName(guest.lastName);};// Place Order checks every guest before anything is sent: one bad name stops the lot.
var guestNamesRefusal=function guestNamesRefusal(guests){return(guests||[]).every(isValidGuest)?null:GUEST_NAMES_NEEDED;};// Delivery Tracking: "Order 9002 • For Mary Byrne • 23/10 11:02".
var trackingHeading=function trackingHeading(order){return['Order '+order.idOrder,guestLabel(order),order.dateRegOrderFormatted].filter(function(part){return part!==null&&part!==undefined&&part!=='';}).join(' • ');};

/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export hasServerResponse */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return cartResetState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return cartSetRestaurantOpen; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return calculateSubsidy; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return fetchingCards; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return fetchingCampaignRate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return placeOrder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return placeOrderAndPay; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return placeOrderAndGoToAddNewCard; });
/* unused harmony export paymentOrder */
/* unused harmony export consumeVoucher */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return toggleCart; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return addProductToCartNow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addProductToCart; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return chooseGuestRecipient; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return cancelGuestRecipient; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return fetchGuestPolicy; });
/* unused harmony export partyValueFromDiscount */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return calculatePartySubsidies; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return clearPartyValues; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return placePartyOrders; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return closeBatchResult; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return deleteProductFromCart; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return deleteAllProductsFromCart; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return appliedCartValues; });
/* unused harmony export successFetchingCarts */
/* unused harmony export successFetchingCampaignRate */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return triggerModalErrorPlacedOrder; });
/* unused harmony export successPlaceOrder */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return closeModalErrorPlacedOrder; });
/* unused harmony export openModalPlacedOrderOnCart */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return closeModalPlacedOrderOnCart; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return toggleIsButtonDisabled; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return openModalReceiptOnCart; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return closeModalReceiptOnCart; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return handlePayInvoice; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return deleteCard; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return changeDeliveryTomorrow; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actionTypes__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_services_orderService__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_services_voucherService__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_services_paymentService__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_services_campaignRateService__ = __webpack_require__(656);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_utils_time__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_utils_checkoutError__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_utils_userError__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_utils_orderConfirmation__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_utils_paymentFailure__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_utils_vouchers__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__config_guestOrdering__ = __webpack_require__(68);
var _this=this;function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}// A response came back from the server (not a lost request or a 5xx whose outcome is unknown).
var hasServerResponse=function hasServerResponse(error){return!!error&&!error.isNetworkError&&error.name!=="TypeError"&&!(error.response&&error.response.status>=500);};// Your own orders carry a checkoutRequestKey too, so a retry after a lost response
// returns the order already placed instead of placing it twice.
var ownCheckoutKey=null;var withCheckoutKey=function withCheckoutKey(order){if(!order||order.checkoutRequestKey||order.guestOrder)return order;if(!ownCheckoutKey)ownCheckoutKey=Object(__WEBPACK_IMPORTED_MODULE_12__config_guestOrdering__["h" /* createCheckoutRequestKey */])();return Object.assign({},order,{checkoutRequestKey:ownCheckoutKey});};// One order request at a time: a second tap on Place Order while the first is in
// flight is ignored.
var orderInFlight=false;var oneOrderAtATime=function oneOrderAtATime(send){if(orderInFlight)return Promise.resolve();orderInFlight=true;var release=function release(){orderInFlight=false;};var sending=void 0;try{sending=Promise.resolve(send());}catch(error){sending=Promise.reject(error);}return sending.then(function(result){release();return result;},function(error){release();throw error;});};// A checkoutRequestKey (yours or a guest's) is reused only when retrying a request whose
// response never arrived. Once the server answers, the next attempt gets a new key.
var markGuestKey=function markGuestKey(dispatch,order,error){if(!order||!order.checkoutRequestKey)return;if(error!==undefined&&!hasServerResponse(error))return;if(order.checkoutRequestKey===ownCheckoutKey){ownCheckoutKey=null;return;}dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["W" /* GUEST_CHECKOUT_KEY_SPENT */],requestKey:order.checkoutRequestKey});};var menuResetState=function menuResetState(){return{type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["_10" /* MENU_RESET_STATE */]};};var cartResetState=function cartResetState(){return function(dispatch){return dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["h" /* CART_RESET_STATE */]});};};var checkoutResetState=function checkoutResetState(){return{type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["u" /* CHECKOUT_RESET_STATE */]};};var cartSetPayInfo=function cartSetPayInfo(payInfo){return{type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["j" /* CART_SET_PAY_INFO */],payload:payInfo};};var cartSetRestaurantOpen=function cartSetRestaurantOpen(payInfo){return{type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["n" /* CART_UPDATED_RESTAURANT_STATUS */],payload:payInfo};};var discountOperationIsPercentage=function discountOperationIsPercentage(voucher){return voucher.discountOperation==="%";};var maxBasketCostIsPresent=function maxBasketCostIsPresent(voucher){return!!voucher.maxBasketCost;};var calculateSubsidy=function calculateSubsidy(idRestaurant,subtotal,taxDelivery,tipValue){return function(dispatch){__WEBPACK_IMPORTED_MODULE_3_services_voucherService__["a" /* default */].calculateSubsidy({idRestaurant:idRestaurant,value:subtotal}).then(function(data){dispatch(cartSetRestaurantOpen(data.isBusinessCorporate));var discounts=data.discounts;var voucherWithMaxBasketCost=data.discounts.find(function(voucher){return discountOperationIsPercentage(voucher)&&maxBasketCostIsPresent(voucher);})||{};if(subtotal!==data.newValue){var subsidy=subtotal.toFixed(2)-data.newValue;var total=data.newValue+taxDelivery;console.log("subtotal if: ",subtotal);dispatch(appliedCartValues(subtotal,subsidy.toFixed(2),total,voucherWithMaxBasketCost.maxBasketCost,discounts,tipValue));}else{var _total=subtotal+taxDelivery;console.log("subtotal else: ",subtotal);dispatch(appliedCartValues(subtotal,0,_total,voucherWithMaxBasketCost.maxBasketCost,discounts,tipValue));}}).catch(function(err){console.log(err);});};};var fetchingCards=function fetchingCards(){return function(dispatch){__WEBPACK_IMPORTED_MODULE_4_services_paymentService__["a" /* default */].getCards().then(function(data){dispatch(successFetchingCarts(data));}).catch(function(err){console.log(err);});};};var fetchingCampaignRate=function fetchingCampaignRate(idBusiness){return function(dispatch){__WEBPACK_IMPORTED_MODULE_5_services_campaignRateService__["a" /* default */].getCampaignRate(idBusiness).then(function(campaignRates){if(!campaignRates.find(function(campaignRate){return campaignRate.chargeType==="T"&&campaignRate.status==="E";})){campaignRates.push({chargeType:"T",statusReg:"A",status:"E",amount:10,discountType:"P"});}dispatch(successFetchingCampaignRate(campaignRates));}).catch(function(err){console.log(err);});};};var placeOrder=function placeOrder(order,payInfo){return function(dispatch){return oneOrderAtATime(function(){order=withCheckoutKey(order);return __WEBPACK_IMPORTED_MODULE_2_services_orderService__["a" /* default */].placeOrder(order).then(function(data){var payInfoUpdated=Object.assign({},payInfo,{idOrder:data.id,publicOrderNumber:data.publicOrderNumber});markGuestKey(dispatch,order);dispatch(cartSetPayInfo(payInfoUpdated));dispatch(successPlaceOrder(data));dispatch(openModalPlacedOrderOnCart());dispatch(consumeVoucher(payInfoUpdated));// Voice ordering reads the placed order from the promise.
return data;}).catch(function(err){markGuestKey(dispatch,order,err);dispatch(triggerModalErrorPlacedOrder(err));});});};};var placeOrderAndPay=function placeOrderAndPay(order,payInfo){var amout=payInfo.tipValue+payInfo.amount;payInfo.amount=amout;return function(dispatch){return oneOrderAtATime(function(){order=withCheckoutKey(order);return __WEBPACK_IMPORTED_MODULE_2_services_orderService__["a" /* default */].placeOrder(order).then(function(data){var payInfoUpdated=Object.assign({},payInfo,{idOrder:data.id,publicOrderNumber:data.publicOrderNumber});markGuestKey(dispatch,order);dispatch(successPlaceOrder(data));dispatch(cartSetPayInfo(payInfoUpdated));dispatch(paymentOrder(payInfoUpdated));}).catch(function(err){markGuestKey(dispatch,order,err);dispatch(triggerModalErrorPlacedOrder(err));});});};};var placeOrderAndGoToAddNewCard=function placeOrderAndGoToAddNewCard(order,payInfo,history){return function(dispatch){return oneOrderAtATime(function(){order=withCheckoutKey(order);return __WEBPACK_IMPORTED_MODULE_2_services_orderService__["a" /* default */].placeOrder(order).then(function(data){var payInfoUpdated=Object.assign({},payInfo,{idOrder:data.id,publicOrderNumber:data.publicOrderNumber});markGuestKey(dispatch,order);dispatch(successPlaceOrder(data));dispatch(cartSetPayInfo(payInfoUpdated));history.push("/Menu/checkout");}).catch(function(err){markGuestKey(dispatch,order,err);dispatch(triggerModalErrorPlacedOrder(err));});});};};var reconcilePaymentFailure=function reconcilePaymentFailure(payload,error){return function(dispatch){return Object(__WEBPACK_IMPORTED_MODULE_10_utils_paymentFailure__["a" /* resolvePaymentFailure */])(payload,error).then(function(checkoutError){dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["_71" /* TRIGGER_MODAL_ERROR_PLACED_ORDER */],checkoutError:checkoutError});});};};var paymentOrder=function paymentOrder(payload){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_4_services_paymentService__["a" /* default */].pay(payload)// Handle the payment rejection in the same step so an error raised while
// showing the result cannot trigger a second reconciliation.
.then(function(data){if(data.success){dispatch(openModalPlacedOrderOnCart());dispatch(consumeVoucher(payload));}else{return dispatch(reconcilePaymentFailure(payload,data));}},function(err){return dispatch(reconcilePaymentFailure(payload,err));});};};var consumeVoucher=function consumeVoucher(payload){return function(dispatch){var vouchers=Object(__WEBPACK_IMPORTED_MODULE_11_utils_vouchers__["a" /* normalizeVoucherDiscounts */])(payload&&payload.discounts);if(vouchers.length===0){return Promise.resolve();}var confirmVoucher=payload.payType==="A";var voucher={idOrder:payload.idOrder,totalOrder:payload.amount,confirmVoucher:confirmVoucher,vouchers:vouchers};return __WEBPACK_IMPORTED_MODULE_3_services_voucherService__["a" /* default */].consume(voucher).catch(function(err){dispatch(triggerModalErrorPlacedOrder(err,{outcome:__WEBPACK_IMPORTED_MODULE_7_utils_checkoutError__["a" /* CHECKOUT_OUTCOME */].CONFIRMED,orderNumber:payload.publicOrderNumber,postOrderFailure:true}));});};};var toggleCart=function toggleCart(){var status=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;return{type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["_66" /* TOGGLE_CART */],status:status};};// Straight into the basket. payload.guestId (optional) says who the item is for;
// without it an item keeps its own guestId (the basket's + button).
var addProductToCartNow=function addProductToCartNow(payload){return{type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["a" /* ADD_PRODUCT_TO_CART */],payload:payload};};var isDeliveringAtHome=function isDeliveringAtHome(state){var addresses=state.menuReducer&&state.menuReducer.addresses;return!!addresses&&!!addresses[0]&&addresses[0].idCustomerDeliveryAddress!=null;};// Every Add to basket: asks "Who's this for?" when the employee can order for guests,
// otherwise adds straight away exactly as before. Guest orders are for corporate
// delivery and collection only, so home delivery never asks.
var addProductToCart=function addProductToCart(payload){return function(dispatch,getState){var state=getState();var policy=state.cartReducer.cart.guestPolicy;if(!Object(__WEBPACK_IMPORTED_MODULE_12__config_guestOrdering__["o" /* isGuestPolicyEnabled */])(policy)||isDeliveringAtHome(state)){return dispatch(addProductToCartNow(payload));}return dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["Y" /* GUEST_RECIPIENT_ASK */],payload:payload,subtitle:Object(__WEBPACK_IMPORTED_MODULE_12__config_guestOrdering__["t" /* recipientSubtitle */])(payload)});};};// The sheet's Add to basket: guestId for someone already in the basket, newGuest
// ({firstName, lastName}, already checked) for a new one, neither for Me.
var chooseGuestRecipient=function chooseGuestRecipient(){var _ref=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{},guestId=_ref.guestId,newGuest=_ref.newGuest;return function(dispatch,getState){var prompt=getState().cartReducer.cart.guestPrompt;if(!prompt)return;var recipientId=guestId||null;if(newGuest){var guest=Object(__WEBPACK_IMPORTED_MODULE_12__config_guestOrdering__["i" /* createGuest */])(newGuest.firstName,newGuest.lastName);dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["V" /* GUEST_ADDED_TO_BASKET */],guest:guest});recipientId=guest.id;}dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["_0" /* GUEST_RECIPIENT_CHOSEN */],guestId:recipientId});dispatch(addProductToCartNow(Object.assign({},prompt.payload,{guestId:recipientId})));};};// Closing the sheet adds nothing.
var cancelGuestRecipient=function cancelGuestRecipient(){return{type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["Z" /* GUEST_RECIPIENT_CANCEL */]};};// GET /order/v1/order/guest-policy at sign-in and whenever the basket opens. Any failure
// (including an order service without the endpoint) means no guest ordering.
var fetchGuestPolicy=function fetchGuestPolicy(){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_2_services_orderService__["a" /* default */].getGuestPolicy().then(function(policy){return dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["X" /* GUEST_POLICY_LOADED */],policy:Object(__WEBPACK_IMPORTED_MODULE_12__config_guestOrdering__["o" /* isGuestPolicyEnabled */])(policy)?policy:null});}).catch(function(){return dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["X" /* GUEST_POLICY_LOADED */],policy:null});});};};// One person's order values from calculate-discount, worked out like calculateSubsidy.
var partyValueFromDiscount=function partyValueFromDiscount(party,data,taxDelivery){var subtotal=party.subtotal;var discounts=data&&data.discounts||[];var voucherWithMaxBasketCost=discounts.find(function(voucher){return discountOperationIsPercentage(voucher)&&maxBasketCostIsPresent(voucher);})||{};var subsidy=data&&subtotal!==data.newValue?Number(subtotal.toFixed(2))-data.newValue:0;return{guestId:party.guestId,subtotal:subtotal,subsidy:Number(subsidy.toFixed(2)),total:(subsidy?data.newValue:subtotal)+taxDelivery,discounts:discounts,maxBasketCost:voucherWithMaxBasketCost.maxBasketCost};};// Several people in the basket: the subsidy is worked out per order, by asking
// calculate-discount for each person's items. The totals block shows the sums.
var calculatePartySubsidies=function calculatePartySubsidies(idRestaurant,parties,taxDelivery,tipValue,withSubsidy){return function(dispatch){var valueFor=function valueFor(party){return withSubsidy?__WEBPACK_IMPORTED_MODULE_3_services_voucherService__["a" /* default */].calculateSubsidy({idRestaurant:idRestaurant,value:party.subtotal}).then(function(data){dispatch(cartSetRestaurantOpen(data.isBusinessCorporate));return partyValueFromDiscount(party,data,taxDelivery);}):Promise.resolve(partyValueFromDiscount(party,null,0));};return Promise.all(parties.map(valueFor)).then(function(values){dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["f" /* CART_PARTY_VALUES */],partyValues:values});var sum=function sum(field){return values.reduce(function(total,value){return total+value[field];},0);};var withMax=values.find(function(value){return!!value.maxBasketCost;})||{};dispatch(appliedCartValues(sum("subtotal"),sum("subsidy").toFixed(2),sum("total"),withMax.maxBasketCost,values.length>0?values[0].discounts:[],tipValue));return values;}).catch(function(err){console.log(err);return null;});};};var clearPartyValues=function clearPartyValues(){return{type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["f" /* CART_PARTY_VALUES */],partyValues:[]};};// The order API's 4xx messages are written for customers ("Daily guest limit reached"); anything
// else is described here, never in the server's words.
var failureReason=function failureReason(error){if(!hasServerResponse(error))return"no answer from Lunch.Team, so we couldn't confirm it";if(error&&error.code==="AUTHENTICATION_REQUIRED")return"your session expired";var data=error&&error.data;return data&&(data.message||data.errorMessage)||// A 400 body is thrown as it is; an Error's message is the request layer's, not the server's.
error&&!(error instanceof Error)&&(error.message||error.errorMessage||error.description)||"we couldn't place it";};var consumeQuietly=function consumeQuietly(payInfo){return __WEBPACK_IMPORTED_MODULE_3_services_voucherService__["a" /* default */].consume({idOrder:payInfo.idOrder,totalOrder:payInfo.amount,confirmVoucher:payInfo.payType==="A"&&(payInfo.discounts||[]).length>0,vouchers:payInfo.discounts}).catch(function(err){console.log(err);});};// Several people: one order each (yours without guest fields, each guest's with their
// name and own checkoutRequestKey), sent one after another and stopped at the first
// failure. A saved card pays each order in turn. sends: [{guestId, name, order, payInfo}].
// stillValid (optional): called right before each order is sent; a reason string stops this and the remaining
// sends (the orders already placed stay placed). The basket passes it on allergen-gated restaurants (Codex r3 P1).
var placePartyOrders=function placePartyOrders(sends){var _ref2=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{},stillValid=_ref2.stillValid;return function(dispatch){return oneOrderAtATime(function(){return sendPartyOrders(sends.map(function(send){return Object.assign({},send,{order:withCheckoutKey(send.order)});}),dispatch,stillValid);});};};var sendPartyOrders=function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(sends,dispatch,stillValid){var result,placedGuestIds,_loop,index,_ret,allPlaced;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:result={placed:[],failedName:null,failureMessage:null,notSent:[]};placedGuestIds=[];_loop=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(index){var send,fail,stale,data,orderNumber,payInfo,payment,paid,answered,payError,response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:send=sends[index];fail=function fail(message,code,error){result.failedName=send.name;result.failureMessage=message;result.failureCode=code;result.failureAt=new Date();result.failureServerId=Object(__WEBPACK_IMPORTED_MODULE_8_utils_userError__["f" /* serverIdOf */])(error);result.notSent=sends.slice(index+1).map(function(next){return next.name;});};stale=stillValid?stillValid():null;if(!stale){_context.next=11;break;}result.failedName=send.name;result.failureMessage=stale;result.failureCode=__WEBPACK_IMPORTED_MODULE_8_utils_userError__["a" /* ERROR_CODES */].ORDER_PLACE_FAILED;result.failureAt=new Date();result.failureServerId=null;result.notSent=sends.slice(index).map(function(next){return next.name;});return _context.abrupt("return","break");case 11:data=void 0;_context.prev=12;_context.next=15;return __WEBPACK_IMPORTED_MODULE_2_services_orderService__["a" /* default */].placeOrder(send.order);case 15:data=_context.sent;_context.next=23;break;case 18:_context.prev=18;_context.t0=_context["catch"](12);markGuestKey(dispatch,send.order,_context.t0);fail(failureReason(_context.t0),hasServerResponse(_context.t0)?__WEBPACK_IMPORTED_MODULE_8_utils_userError__["a" /* ERROR_CODES */].ORDER_PLACE_FAILED:__WEBPACK_IMPORTED_MODULE_8_utils_userError__["a" /* ERROR_CODES */].ORDER_UNKNOWN_STATE,_context.t0);return _context.abrupt("return","break");case 23:markGuestKey(dispatch,send.order);orderNumber=data.publicOrderNumber||data.id;payInfo=Object.assign({},send.payInfo,{idOrder:data.id,publicOrderNumber:data.publicOrderNumber});if(!(payInfo.payType==="C")){_context.next=48;break;}payment=Object.assign({},payInfo,{amount:payInfo.amount+(payInfo.tipValue||0)});paid=false;answered=true;payError=null;_context.prev=31;_context.next=34;return __WEBPACK_IMPORTED_MODULE_4_services_paymentService__["a" /* default */].pay(payment);case 34:response=_context.sent;paid=!!response&&!!response.success;_context.next=42;break;case 38:_context.prev=38;_context.t1=_context["catch"](31);payError=_context.t1;answered=hasServerResponse(_context.t1);case 42:if(paid){_context.next=45;break;}// A lost answer may still have charged the card: never invite paying again.
fail(answered?"order "+orderNumber+" was created but the card was declined, so it isn't paid":"order "+orderNumber+" was created but we couldn't confirm the card payment",answered?__WEBPACK_IMPORTED_MODULE_8_utils_userError__["a" /* ERROR_CODES */].PAYMENT_DECLINED:__WEBPACK_IMPORTED_MODULE_8_utils_userError__["a" /* ERROR_CODES */].PAYMENT_UNKNOWN_STATE,payError);return _context.abrupt("return","break");case 45:consumeQuietly(payment);_context.next=49;break;case 48:consumeQuietly(payInfo);case 49:result.placed.push({orderNumber:orderNumber,name:send.name});placedGuestIds.push(send.guestId||null);case 51:case"end":return _context.stop();}}},_callee,_this,[[12,18],[31,38]]);});index=0;case 4:if(!(index<sends.length)){_context2.next=12;break;}return _context2.delegateYield(_loop(index),"t0",6);case 6:_ret=_context2.t0;if(!(_ret==="break")){_context2.next=9;break;}return _context2.abrupt("break",12);case 9:index+=1;_context2.next=4;break;case 12:allPlaced=!result.failedName&&result.notSent.length===0;if(!allPlaced&&placedGuestIds.length>0){dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["g" /* CART_REMOVE_PARTIES */],guestIds:placedGuestIds});}dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["b" /* CART_BATCH_RESULT */],result:Object.assign({},result,{allPlaced:allPlaced})});dispatch(fetchGuestPolicy());return _context2.abrupt("return",result);case 17:case"end":return _context2.stop();}}},_callee2,_this);}));return function sendPartyOrders(_x4,_x5,_x6){return _ref3.apply(this,arguments);};}();var closeBatchResult=function closeBatchResult(){return{type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["c" /* CART_BATCH_RESULT_CLOSE */]};};var deleteProductFromCart=function deleteProductFromCart(payload){return{type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["I" /* DELETE_PRODUCT_FROM_CART */],payload:payload};};var deleteAllProductsFromCart=function deleteAllProductsFromCart(){return{type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["H" /* DELETE_ALL_PRODUCTS_FROM_CART */]};};var appliedCartValues=function appliedCartValues(subtotal,subsidy,total,maxBasketCost,discounts,tipValue){return{type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["d" /* CART_CALCULATED_VALUES */],subtotal:subtotal,subsidy:subsidy,tipValue:tipValue,total:total,maxBasketCost:maxBasketCost,discounts:discounts};};var successFetchingCarts=function successFetchingCarts(cards){return{type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["_47" /* SUCCESS_FETCHING_CARDS */],cards:cards};};var successFetchingCampaignRate=function successFetchingCampaignRate(data){return{type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["_46" /* SUCCESS_FETCHING_CAMPAIGN_RATE */],campaignRate:data};};var triggerModalErrorPlacedOrder=function triggerModalErrorPlacedOrder(error,context){return{type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["_71" /* TRIGGER_MODAL_ERROR_PLACED_ORDER */],checkoutError:Object(__WEBPACK_IMPORTED_MODULE_7_utils_checkoutError__["b" /* mapCheckoutError */])(error,context)};};var successPlaceOrder=function successPlaceOrder(data){return{type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["_48" /* SUCCESS_PLACE_ORDER */],payload:{idOrder:data.id,publicOrderNumber:data.publicOrderNumber,orderDeliveryDate:__WEBPACK_IMPORTED_MODULE_6_utils_time__["a" /* default */].dateArrayToDate(data.orderDeliveryDate),isInvoice:false,descriptionSuccess:Object(__WEBPACK_IMPORTED_MODULE_9_utils_orderConfirmation__["a" /* orderPlacedMessage */])(data.publicOrderNumber)}};};var closeModalErrorPlacedOrder=function closeModalErrorPlacedOrder(){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["A" /* CLOSE_MODAL_ERROR_PLACED_ORDER */]});dispatch(toggleIsButtonDisabled(false));};};var openModalPlacedOrderOnCart=function openModalPlacedOrderOnCart(){return{type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["l" /* CART_TOGGLE_SHOW_MODAL_PLACE_ORDER */],payload:true};};var closeModalPlacedOrderOnCart=function closeModalPlacedOrderOnCart(history){return function(dispatch){dispatch(menuResetState());dispatch(cartResetState());dispatch(checkoutResetState());dispatch(toggleIsButtonDisabled(false));history.push("/Menu");};};var toggleIsButtonDisabled=function toggleIsButtonDisabled(disabled){return{type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["k" /* CART_SET_PLACED_BUTTON_DISABLED */],payload:disabled};};var openModalReceiptOnCart=function openModalReceiptOnCart(){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["l" /* CART_TOGGLE_SHOW_MODAL_PLACE_ORDER */],payload:false});dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["m" /* CART_TOGGLE_SHOW_MODAL_RECEIPT */],payload:true});};};var closeModalReceiptOnCart=function closeModalReceiptOnCart(){return function(dispatch){dispatch(menuResetState());dispatch(cartResetState());dispatch(checkoutResetState());dispatch(toggleIsButtonDisabled(false));};};//////////////////////////////// Invoice //////////////////////////////////////
var handlePayInvoice=function handlePayInvoice(payload,history){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_4_services_paymentService__["a" /* default */].pay(payload).then(function(data){if(data.success){dispatch(payInvoiceSuccess(data.description));dispatch(toggleCart(false));dispatch(openModalPlacedOrderOnCart());history.push("/Menu");}else{dispatch(triggerModalErrorPlacedOrder(data,{paymentOutcomeUnknown:true}));}}).catch(function(error){dispatch(triggerModalErrorPlacedOrder(error,{paymentOutcomeUnknown:true}));});};};var payInvoiceSuccess=function payInvoiceSuccess(descriptionSucess){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["_2" /* INVOICE_PAY_SUCCESS */],descriptionSuccess:descriptionSucess});};};//////////////////////////////// Card //////////////////////////////////////
var deleteCard=function deleteCard(cardId){return function(dispatch){__WEBPACK_IMPORTED_MODULE_4_services_paymentService__["a" /* default */].deleteCard(cardId).then(function(result){dispatch(fetchingCards());});};};var changeDeliveryTomorrow=function changeDeliveryTomorrow(payload){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["e" /* CART_DELIVERY_TOMORROW */],payload:payload});};};

/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
var millisecondsToTime=function millisecondsToTime(milliseconds){var hours=~~(milliseconds/3600);var minutes=~~(milliseconds%3600/60);var time=hours+':'+(minutes>0?minutes:'0'+minutes);return time;};var getCurrentDate=function getCurrentDate(){var today=new Date();var dd=today.getDate();var mm=today.getMonth()+1;//January is 0!
var yyyy=today.getFullYear();dd=dd<10?'0'+dd:dd;mm=mm<10?'0'+mm:mm;today=dd+'/'+mm+'/'+yyyy;return today;};var dateArrayToDate=function dateArrayToDate(dateArray){return new Date(dateArray[0]||0,(dateArray[1]||0)-1,dateArray[2]||0,dateArray[3]||0,dateArray[4]||0,dateArray[5]||0);};var formatDateToDateTimeAmPm=function formatDateToDateTimeAmPm(date){return __WEBPACK_IMPORTED_MODULE_0_moment___default()(date).format('DD/MM/YYYY hh:mm a');};var formatDate=function formatDate(date){return __WEBPACK_IMPORTED_MODULE_0_moment___default()(date).format('DD/MM/YYYY');};var getCurrentHourMinutePlusMinutes=function getCurrentHourMinutePlusMinutes(minutes){return __WEBPACK_IMPORTED_MODULE_0_moment___default()(new Date()).add(minutes,'m').format('hh:mm a');};var formatDateToTimeAmPm=function formatDateToTimeAmPm(date){return __WEBPACK_IMPORTED_MODULE_0_moment___default()(date).format('hh:mm a');};/* harmony default export */ __webpack_exports__["a"] = ({millisecondsToTime:millisecondsToTime,getCurrentDate:getCurrentDate,dateArrayToDate:dateArrayToDate,formatDateToDateTimeAmPm:formatDateToDateTimeAmPm,formatDateToTimeAmPm:formatDateToTimeAmPm,getCurrentHourMinutePlusMinutes:getCurrentHourMinutePlusMinutes,formatDate:formatDate});

/***/ }),
/* 71 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.11' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/logo-lunch-team.2a34be80.svg";

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(16).f;
var has = __webpack_require__(27);
var TAG = __webpack_require__(10)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(33);
var TAG = __webpack_require__(10)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(1);
var defined = __webpack_require__(41);
var fails = __webpack_require__(6);
var spaces = __webpack_require__(150);
var space = '[' + spaces + ']';
var non = '\u200b\u0085';
var ltrim = RegExp('^' + space + space + '*');
var rtrim = RegExp(space + space + '*$');

var exporter = function (KEY, exec, ALIAS) {
  var exp = {};
  var FORCE = fails(function () {
    return !!spaces[KEY]() || non[KEY]() != non;
  });
  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
  if (ALIAS) exp[ALIAS] = fn;
  $export($export.P + $export.F * FORCE, 'String', exp);
};

// 1 -> String#trimLeft
// 2 -> String#trimRight
// 3 -> String#trim
var trim = exporter.trim = function (string, TYPE) {
  string = String(defined(string));
  if (TYPE & 1) string = string.replace(ltrim, '');
  if (TYPE & 2) string = string.replace(rtrim, '');
  return string;
};

module.exports = exporter;


/***/ }),
/* 76 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createBrowserHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createHashHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return createMemoryHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return createLocation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return locationsAreEqual; });
/* unused harmony export parsePath */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return createPath; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_resolve_pathname__ = __webpack_require__(560);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_value_equal__ = __webpack_require__(561);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_tiny_warning__ = __webpack_require__(562);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_tiny_invariant__ = __webpack_require__(563);






function addLeadingSlash(path) {
  return path.charAt(0) === '/' ? path : '/' + path;
}
function stripLeadingSlash(path) {
  return path.charAt(0) === '/' ? path.substr(1) : path;
}
function hasBasename(path, prefix) {
  return path.toLowerCase().indexOf(prefix.toLowerCase()) === 0 && '/?#'.indexOf(path.charAt(prefix.length)) !== -1;
}
function stripBasename(path, prefix) {
  return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
}
function stripTrailingSlash(path) {
  return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
}
function parsePath(path) {
  var pathname = path || '/';
  var search = '';
  var hash = '';
  var hashIndex = pathname.indexOf('#');

  if (hashIndex !== -1) {
    hash = pathname.substr(hashIndex);
    pathname = pathname.substr(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');

  if (searchIndex !== -1) {
    search = pathname.substr(searchIndex);
    pathname = pathname.substr(0, searchIndex);
  }

  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
}
function createPath(location) {
  var pathname = location.pathname,
      search = location.search,
      hash = location.hash;
  var path = pathname || '/';
  if (search && search !== '?') path += search.charAt(0) === '?' ? search : "?" + search;
  if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : "#" + hash;
  return path;
}

function createLocation(path, state, key, currentLocation) {
  var location;

  if (typeof path === 'string') {
    // Two-arg form: push(path, state)
    location = parsePath(path);
    location.state = state;
  } else {
    // One-arg form: push(location)
    location = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, path);
    if (location.pathname === undefined) location.pathname = '';

    if (location.search) {
      if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
    } else {
      location.search = '';
    }

    if (location.hash) {
      if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
    } else {
      location.hash = '';
    }

    if (state !== undefined && location.state === undefined) location.state = state;
  }

  try {
    location.pathname = decodeURI(location.pathname);
  } catch (e) {
    if (e instanceof URIError) {
      throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
    } else {
      throw e;
    }
  }

  if (key) location.key = key;

  if (currentLocation) {
    // Resolve incomplete/relative pathname relative to current location.
    if (!location.pathname) {
      location.pathname = currentLocation.pathname;
    } else if (location.pathname.charAt(0) !== '/') {
      location.pathname = Object(__WEBPACK_IMPORTED_MODULE_1_resolve_pathname__["a" /* default */])(location.pathname, currentLocation.pathname);
    }
  } else {
    // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) {
      location.pathname = '/';
    }
  }

  return location;
}
function locationsAreEqual(a, b) {
  return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && Object(__WEBPACK_IMPORTED_MODULE_2_value_equal__["a" /* default */])(a.state, b.state);
}

function createTransitionManager() {
  var prompt = null;

  function setPrompt(nextPrompt) {
     false ? warning(prompt == null, 'A history supports only one prompt at a time') : void 0;
    prompt = nextPrompt;
    return function () {
      if (prompt === nextPrompt) prompt = null;
    };
  }

  function confirmTransitionTo(location, action, getUserConfirmation, callback) {
    // TODO: If another transition starts while we're still confirming
    // the previous one, we may end up in a weird state. Figure out the
    // best way to handle this.
    if (prompt != null) {
      var result = typeof prompt === 'function' ? prompt(location, action) : prompt;

      if (typeof result === 'string') {
        if (typeof getUserConfirmation === 'function') {
          getUserConfirmation(result, callback);
        } else {
           false ? warning(false, 'A history needs a getUserConfirmation function in order to use a prompt message') : void 0;
          callback(true);
        }
      } else {
        // Return false from a transition hook to cancel the transition.
        callback(result !== false);
      }
    } else {
      callback(true);
    }
  }

  var listeners = [];

  function appendListener(fn) {
    var isActive = true;

    function listener() {
      if (isActive) fn.apply(void 0, arguments);
    }

    listeners.push(listener);
    return function () {
      isActive = false;
      listeners = listeners.filter(function (item) {
        return item !== listener;
      });
    };
  }

  function notifyListeners() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    listeners.forEach(function (listener) {
      return listener.apply(void 0, args);
    });
  }

  return {
    setPrompt: setPrompt,
    confirmTransitionTo: confirmTransitionTo,
    appendListener: appendListener,
    notifyListeners: notifyListeners
  };
}

var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function getConfirmation(message, callback) {
  callback(window.confirm(message)); // eslint-disable-line no-alert
}
/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */

function supportsHistory() {
  var ua = window.navigator.userAgent;
  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;
  return window.history && 'pushState' in window.history;
}
/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */

function supportsPopStateOnHashChange() {
  return window.navigator.userAgent.indexOf('Trident') === -1;
}
/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */

function supportsGoWithoutReloadUsingHash() {
  return window.navigator.userAgent.indexOf('Firefox') === -1;
}
/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */

function isExtraneousPopstateEvent(event) {
  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
}

var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';

function getHistoryState() {
  try {
    return window.history.state || {};
  } catch (e) {
    // IE 11 sometimes throws when accessing window.history.state
    // See https://github.com/ReactTraining/history/pull/289
    return {};
  }
}
/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */


function createBrowserHistory(props) {
  if (props === void 0) {
    props = {};
  }

  !canUseDOM ?  false ? invariant(false, 'Browser history needs a DOM') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
  var globalHistory = window.history;
  var canUseHistory = supportsHistory();
  var needsHashChangeListener = !supportsPopStateOnHashChange();
  var _props = props,
      _props$forceRefresh = _props.forceRefresh,
      forceRefresh = _props$forceRefresh === void 0 ? false : _props$forceRefresh,
      _props$getUserConfirm = _props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === void 0 ? getConfirmation : _props$getUserConfirm,
      _props$keyLength = _props.keyLength,
      keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
  var basename = props.basename ? stripTrailingSlash(addLeadingSlash(props.basename)) : '';

  function getDOMLocation(historyState) {
    var _ref = historyState || {},
        key = _ref.key,
        state = _ref.state;

    var _window$location = window.location,
        pathname = _window$location.pathname,
        search = _window$location.search,
        hash = _window$location.hash;
    var path = pathname + search + hash;
     false ? warning(!basename || hasBasename(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".') : void 0;
    if (basename) path = stripBasename(path, basename);
    return createLocation(path, state, key);
  }

  function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  }

  var transitionManager = createTransitionManager();

  function setState(nextState) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])(history, nextState);

    history.length = globalHistory.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  function handlePopState(event) {
    // Ignore extraneous popstate events in WebKit.
    if (isExtraneousPopstateEvent(event)) return;
    handlePop(getDOMLocation(event.state));
  }

  function handleHashChange() {
    handlePop(getDOMLocation(getHistoryState()));
  }

  var forceNextPop = false;

  function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';
      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({
            action: action,
            location: location
          });
        } else {
          revertPop(location);
        }
      });
    }
  }

  function revertPop(fromLocation) {
    var toLocation = history.location; // TODO: We could probably make this more reliable by
    // keeping a list of keys we've seen in sessionStorage.
    // Instead, we just default to 0 for keys we don't know.

    var toIndex = allKeys.indexOf(toLocation.key);
    if (toIndex === -1) toIndex = 0;
    var fromIndex = allKeys.indexOf(fromLocation.key);
    if (fromIndex === -1) fromIndex = 0;
    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  }

  var initialLocation = getDOMLocation(getHistoryState());
  var allKeys = [initialLocation.key]; // Public interface

  function createHref(location) {
    return basename + createPath(location);
  }

  function push(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var href = createHref(location);
      var key = location.key,
          state = location.state;

      if (canUseHistory) {
        globalHistory.pushState({
          key: key,
          state: state
        }, null, href);

        if (forceRefresh) {
          window.location.href = href;
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          var nextKeys = allKeys.slice(0, prevIndex + 1);
          nextKeys.push(location.key);
          allKeys = nextKeys;
          setState({
            action: action,
            location: location
          });
        }
      } else {
         false ? warning(state === undefined, 'Browser history cannot push state in browsers that do not support HTML5 history') : void 0;
        window.location.href = href;
      }
    });
  }

  function replace(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var href = createHref(location);
      var key = location.key,
          state = location.state;

      if (canUseHistory) {
        globalHistory.replaceState({
          key: key,
          state: state
        }, null, href);

        if (forceRefresh) {
          window.location.replace(href);
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          if (prevIndex !== -1) allKeys[prevIndex] = location.key;
          setState({
            action: action,
            location: location
          });
        }
      } else {
         false ? warning(state === undefined, 'Browser history cannot replace state in browsers that do not support HTML5 history') : void 0;
        window.location.replace(href);
      }
    });
  }

  function go(n) {
    globalHistory.go(n);
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  var listenerCount = 0;

  function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1 && delta === 1) {
      window.addEventListener(PopStateEvent, handlePopState);
      if (needsHashChangeListener) window.addEventListener(HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      window.removeEventListener(PopStateEvent, handlePopState);
      if (needsHashChangeListener) window.removeEventListener(HashChangeEvent, handleHashChange);
    }
  }

  var isBlocked = false;

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  }

  function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);
    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  }

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };
  return history;
}

var HashChangeEvent$1 = 'hashchange';
var HashPathCoders = {
  hashbang: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '!' ? path : '!/' + stripLeadingSlash(path);
    },
    decodePath: function decodePath(path) {
      return path.charAt(0) === '!' ? path.substr(1) : path;
    }
  },
  noslash: {
    encodePath: stripLeadingSlash,
    decodePath: addLeadingSlash
  },
  slash: {
    encodePath: addLeadingSlash,
    decodePath: addLeadingSlash
  }
};

function stripHash(url) {
  var hashIndex = url.indexOf('#');
  return hashIndex === -1 ? url : url.slice(0, hashIndex);
}

function getHashPath() {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var hashIndex = href.indexOf('#');
  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
}

function pushHashPath(path) {
  window.location.hash = path;
}

function replaceHashPath(path) {
  window.location.replace(stripHash(window.location.href) + '#' + path);
}

function createHashHistory(props) {
  if (props === void 0) {
    props = {};
  }

  !canUseDOM ?  false ? invariant(false, 'Hash history needs a DOM') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
  var globalHistory = window.history;
  var canGoWithoutReload = supportsGoWithoutReloadUsingHash();
  var _props = props,
      _props$getUserConfirm = _props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === void 0 ? getConfirmation : _props$getUserConfirm,
      _props$hashType = _props.hashType,
      hashType = _props$hashType === void 0 ? 'slash' : _props$hashType;
  var basename = props.basename ? stripTrailingSlash(addLeadingSlash(props.basename)) : '';
  var _HashPathCoders$hashT = HashPathCoders[hashType],
      encodePath = _HashPathCoders$hashT.encodePath,
      decodePath = _HashPathCoders$hashT.decodePath;

  function getDOMLocation() {
    var path = decodePath(getHashPath());
     false ? warning(!basename || hasBasename(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".') : void 0;
    if (basename) path = stripBasename(path, basename);
    return createLocation(path);
  }

  var transitionManager = createTransitionManager();

  function setState(nextState) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])(history, nextState);

    history.length = globalHistory.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  var forceNextPop = false;
  var ignorePath = null;

  function locationsAreEqual$$1(a, b) {
    return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash;
  }

  function handleHashChange() {
    var path = getHashPath();
    var encodedPath = encodePath(path);

    if (path !== encodedPath) {
      // Ensure we always have a properly-encoded hash.
      replaceHashPath(encodedPath);
    } else {
      var location = getDOMLocation();
      var prevLocation = history.location;
      if (!forceNextPop && locationsAreEqual$$1(prevLocation, location)) return; // A hashchange doesn't always == location change.

      if (ignorePath === createPath(location)) return; // Ignore this change; we already setState in push/replace.

      ignorePath = null;
      handlePop(location);
    }
  }

  function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';
      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({
            action: action,
            location: location
          });
        } else {
          revertPop(location);
        }
      });
    }
  }

  function revertPop(fromLocation) {
    var toLocation = history.location; // TODO: We could probably make this more reliable by
    // keeping a list of paths we've seen in sessionStorage.
    // Instead, we just default to 0 for paths we don't know.

    var toIndex = allPaths.lastIndexOf(createPath(toLocation));
    if (toIndex === -1) toIndex = 0;
    var fromIndex = allPaths.lastIndexOf(createPath(fromLocation));
    if (fromIndex === -1) fromIndex = 0;
    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  } // Ensure the hash is encoded properly before doing anything else.


  var path = getHashPath();
  var encodedPath = encodePath(path);
  if (path !== encodedPath) replaceHashPath(encodedPath);
  var initialLocation = getDOMLocation();
  var allPaths = [createPath(initialLocation)]; // Public interface

  function createHref(location) {
    var baseTag = document.querySelector('base');
    var href = '';

    if (baseTag && baseTag.getAttribute('href')) {
      href = stripHash(window.location.href);
    }

    return href + '#' + encodePath(basename + createPath(location));
  }

  function push(path, state) {
     false ? warning(state === undefined, 'Hash history cannot push state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, undefined, undefined, history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var path = createPath(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a PUSH, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        pushHashPath(encodedPath);
        var prevIndex = allPaths.lastIndexOf(createPath(history.location));
        var nextPaths = allPaths.slice(0, prevIndex + 1);
        nextPaths.push(path);
        allPaths = nextPaths;
        setState({
          action: action,
          location: location
        });
      } else {
         false ? warning(false, 'Hash history cannot PUSH the same path; a new entry will not be added to the history stack') : void 0;
        setState();
      }
    });
  }

  function replace(path, state) {
     false ? warning(state === undefined, 'Hash history cannot replace state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, undefined, undefined, history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var path = createPath(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a REPLACE, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        replaceHashPath(encodedPath);
      }

      var prevIndex = allPaths.indexOf(createPath(history.location));
      if (prevIndex !== -1) allPaths[prevIndex] = path;
      setState({
        action: action,
        location: location
      });
    });
  }

  function go(n) {
     false ? warning(canGoWithoutReload, 'Hash history go(n) causes a full page reload in this browser') : void 0;
    globalHistory.go(n);
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  var listenerCount = 0;

  function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1 && delta === 1) {
      window.addEventListener(HashChangeEvent$1, handleHashChange);
    } else if (listenerCount === 0) {
      window.removeEventListener(HashChangeEvent$1, handleHashChange);
    }
  }

  var isBlocked = false;

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  }

  function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);
    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  }

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };
  return history;
}

function clamp(n, lowerBound, upperBound) {
  return Math.min(Math.max(n, lowerBound), upperBound);
}
/**
 * Creates a history object that stores locations in memory.
 */


function createMemoryHistory(props) {
  if (props === void 0) {
    props = {};
  }

  var _props = props,
      getUserConfirmation = _props.getUserConfirmation,
      _props$initialEntries = _props.initialEntries,
      initialEntries = _props$initialEntries === void 0 ? ['/'] : _props$initialEntries,
      _props$initialIndex = _props.initialIndex,
      initialIndex = _props$initialIndex === void 0 ? 0 : _props$initialIndex,
      _props$keyLength = _props.keyLength,
      keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
  var transitionManager = createTransitionManager();

  function setState(nextState) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])(history, nextState);

    history.length = history.entries.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  }

  var index = clamp(initialIndex, 0, initialEntries.length - 1);
  var entries = initialEntries.map(function (entry) {
    return typeof entry === 'string' ? createLocation(entry, undefined, createKey()) : createLocation(entry, undefined, entry.key || createKey());
  }); // Public interface

  var createHref = createPath;

  function push(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var prevIndex = history.index;
      var nextIndex = prevIndex + 1;
      var nextEntries = history.entries.slice(0);

      if (nextEntries.length > nextIndex) {
        nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
      } else {
        nextEntries.push(location);
      }

      setState({
        action: action,
        location: location,
        index: nextIndex,
        entries: nextEntries
      });
    });
  }

  function replace(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      history.entries[history.index] = location;
      setState({
        action: action,
        location: location
      });
    });
  }

  function go(n) {
    var nextIndex = clamp(history.index + n, 0, history.entries.length - 1);
    var action = 'POP';
    var location = history.entries[nextIndex];
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (ok) {
        setState({
          action: action,
          location: location,
          index: nextIndex
        });
      } else {
        // Mimic the behavior of DOM histories by
        // causing a render after a cancelled POP.
        setState();
      }
    });
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  function canGo(n) {
    var nextIndex = history.index + n;
    return nextIndex >= 0 && nextIndex < history.entries.length;
  }

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    return transitionManager.setPrompt(prompt);
  }

  function listen(listener) {
    return transitionManager.appendListener(listener);
  }

  var history = {
    length: entries.length,
    action: 'POP',
    location: entries[index],
    index: index,
    entries: entries,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    canGo: canGo,
    block: block,
    listen: listen
  };
  return history;
}




/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_utils_http__ = __webpack_require__(19);
var calculateSubsidy=function calculateSubsidy(payload){return __WEBPACK_IMPORTED_MODULE_0_utils_http__["a" /* default */].post('/voucher/v1/voucher/calculate-discount',payload);};var consume=function consume(payload){return __WEBPACK_IMPORTED_MODULE_0_utils_http__["a" /* default */].post('/voucher/v1/voucher/consume',payload);};var availableTeamVoucher=function availableTeamVoucher(){return __WEBPACK_IMPORTED_MODULE_0_utils_http__["a" /* default */].get('/voucher/v1/voucher/available-team-voucher');};var getVoucherBalance=function getVoucherBalance(){return __WEBPACK_IMPORTED_MODULE_0_utils_http__["a" /* default */].get('/voucher/v1/balance');};var findVoucherByCode=function findVoucherByCode(code){return __WEBPACK_IMPORTED_MODULE_0_utils_http__["a" /* default */].get('/voucher/v1/voucher/link/findMasterVoucherByCode/'+code);};var createLinkVoucher=function createLinkVoucher(code){return __WEBPACK_IMPORTED_MODULE_0_utils_http__["a" /* default */].post('/voucher/v1/voucher/link/createVoucherByMasterCode/'+code);};/* harmony default export */ __webpack_exports__["a"] = ({calculateSubsidy:calculateSubsidy,consume:consume,availableTeamVoucher:availableTeamVoucher,findVoucherByCode:findVoucherByCode,createLinkVoucher:createLinkVoucher,getVoucherBalance:getVoucherBalance});

/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return orderPlacedMessage; });
var orderPlacedMessage=function orderPlacedMessage(publicOrderNumber){return publicOrderNumber?'Order '+publicOrderNumber+' has been placed.':'Your order has been placed.';};

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(123)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return OPEN_EVENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return PANEL_OPEN_EVENT; });
/* harmony export (immutable) */ __webpack_exports__["c"] = isComposerShown;
/* harmony export (immutable) */ __webpack_exports__["f"] = setComposerShown;
/* harmony export (immutable) */ __webpack_exports__["g"] = subscribeComposerShown;
/* harmony export (immutable) */ __webpack_exports__["d"] = notifySupportPanelOpen;
/* harmony export (immutable) */ __webpack_exports__["e"] = openSupportComposer;
// Whether the support composer is on screen, for parts of the page that offer it instead of a form of
// their own (the landing page footer's "Chat with us"), and the event that opens it. SupportDock says
// what it shows; the composer listens for the event. Kept apart from the composer, whose code loads
// only when it is shown.
var OPEN_EVENT='lt-support-open';// Sent on a small screen when the support conversation opens: sheets kept in page state (the menu's Categories
// sheet) close, so they can't cover it.
var PANEL_OPEN_EVENT='lt-support-panel-open';var composerShown=false;var listeners=new Set();function isComposerShown(){return composerShown;}function setComposerShown(shown){var next=!!shown;if(next===composerShown)return;composerShown=next;listeners.forEach(function(listener){return listener(next);});}/** Calls listener(shown) on every change; returns the function that stops it. */function subscribeComposerShown(listener){listeners.add(listener);return function(){return listeners.delete(listener);};}/**
 * Opens the composer: its conversation, or the first thing to fill in. detail.text, when given, goes
 * into an empty message box (an error's reference, from "Contact support").
 */function notifySupportPanelOpen(){var event=void 0;try{event=new window.CustomEvent(PANEL_OPEN_EVENT);}catch(e){event=document.createEvent('CustomEvent');event.initCustomEvent(PANEL_OPEN_EVENT,false,false,null);}window.dispatchEvent(event);}function openSupportComposer(){var detail=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;var event=void 0;try{event=new window.CustomEvent(OPEN_EVENT,{detail:detail});}catch(e){// Browsers without the CustomEvent constructor.
event=document.createEvent('CustomEvent');event.initCustomEvent(OPEN_EVENT,false,false,detail);}window.dispatchEvent(event);}

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(31);
var global = __webpack_require__(3);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(50) ? 'pure' : 'global',
  copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(33);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 85 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.2.5.3 get RegExp.prototype.flags
var anObject = __webpack_require__(2);
module.exports = function () {
  var that = anObject(this);
  var result = '';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = __webpack_require__(2);
var aFunction = __webpack_require__(20);
var SPECIES = __webpack_require__(10)('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(583);
} else {
  module.exports = require('./cjs/react-is.development.js');
}


/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_utils_http__ = __webpack_require__(19);
var placeOrder=function placeOrder(payload){return __WEBPACK_IMPORTED_MODULE_0_utils_http__["a" /* default */].post("/order/v1/order/",payload);};var getOrderStatus=function getOrderStatus(idOrder){return __WEBPACK_IMPORTED_MODULE_0_utils_http__["a" /* default */].get("/order/v1/order/"+idOrder+"/status",undefined,undefined,true,true);};// Quiet call: an older order service without guest ordering simply hides the option.
var getGuestPolicy=function getGuestPolicy(){return __WEBPACK_IMPORTED_MODULE_0_utils_http__["a" /* default */].get('/order/v1/order/guest-policy',undefined,undefined,true,false);};var getCampaignRate=function getCampaignRate(){return __WEBPACK_IMPORTED_MODULE_0_utils_http__["a" /* default */].get("/order/v1/order/campaingrate/");};var getOrder=function getOrder(idOrder){return __WEBPACK_IMPORTED_MODULE_0_utils_http__["a" /* default */].get("/order/v1/order/"+idOrder);};var getInvoiceInfo=function getInvoiceInfo(invoiceNumber){return __WEBPACK_IMPORTED_MODULE_0_utils_http__["a" /* default */].get("/order/v1/invoice/invoiceinfo/"+invoiceNumber);};var getInvoiceStatus=function getInvoiceStatus(invoiceNumber){return __WEBPACK_IMPORTED_MODULE_0_utils_http__["a" /* default */].get("/order/v1/invoice/invoicestatus/"+invoiceNumber);};var getPendingFeedback=function getPendingFeedback(idAddress){return idAddress?__WEBPACK_IMPORTED_MODULE_0_utils_http__["a" /* default */].get("/order/v1/order/feedback/pending/address/"+idAddress):__WEBPACK_IMPORTED_MODULE_0_utils_http__["a" /* default */].get('/order/v1/order/feedback/pending');};var submitFeedback=function submitFeedback(payload){return __WEBPACK_IMPORTED_MODULE_0_utils_http__["a" /* default */].post('/order/v1/order/feedback',payload);};var skipFeedback=function skipFeedback(payload){return __WEBPACK_IMPORTED_MODULE_0_utils_http__["a" /* default */].post('/order/v1/order/feedback/skip',payload);};/* harmony default export */ __webpack_exports__["a"] = ({placeOrder:placeOrder,getGuestPolicy:getGuestPolicy,getOrderStatus:getOrderStatus,getCampaignRate:getCampaignRate,getOrder:getOrder,getInvoiceInfo:getInvoiceInfo,getInvoiceStatus:getInvoiceStatus,getPendingFeedback:getPendingFeedback,submitFeedback:submitFeedback,skipFeedback:skipFeedback});

/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Backdrop_Backdrop__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__hoc_ReactAux_ReactAux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Modal_css__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Modal_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Modal_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__support_context__ = __webpack_require__(54);
var ModalSuccessPayment=function ModalSuccessPayment(props){// Support context is the payment result while the modal is open, then the page again.
Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){return props.showModal?Object(__WEBPACK_IMPORTED_MODULE_4__support_context__["b" /* overlaySupportContext */])('checkout.result'):undefined;},[props.showModal]);if(!props.showModal){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__hoc_ReactAux_ReactAux__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Backdrop_Backdrop__["a" /* default */],{show:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'lb-placed',className:'lb-geral lb-placed_ mfp-bg-login white-popup-block lb-centralizar singup zoom-anim-dialog Modal',tabIndex:0},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'lb-padrao-singup6 mfp-content-login modal-content',tabIndex:0},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:props.closeModal,type:'button',className:'bt-close mfp-close lb-fechar fa fa-times',ref:function ref(input){if(input!=null){input.focus();}},tabIndex:1}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'check-mark'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'fa fa-check-circle lt-success-tick','aria-hidden':'true'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'lb-content',tabIndex:0},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'order'},props.descriptionSuccess),!!props.openReceipt&&!props.isInvoice?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{onClick:props.openReceipt,className:'view'},'View your receipt'):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{onClick:props.closeModal,className:'bt',tabIndex:0},'Got it')))));};/* harmony default export */ __webpack_exports__["a"] = (ModalSuccessPayment);

/***/ }),
/* 91 */
/***/ (function(module, exports) {

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

module.exports = _interopRequireDefault;

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

var _Object$assign = __webpack_require__(685);

function _extends() {
  module.exports = _extends = _Object$assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

module.exports = _extends;

/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _defineProperty;
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _assertThisInitialized;
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__emotion_serialize__ = __webpack_require__(316);


function css() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return Object(__WEBPACK_IMPORTED_MODULE_0__emotion_serialize__["a" /* serializeStyles */])(args);
}

/* harmony default export */ __webpack_exports__["a"] = (css);


/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = getAllergyAnswer;
/* harmony export (immutable) */ __webpack_exports__["e"] = getAllergyRevision;
/* harmony export (immutable) */ __webpack_exports__["i"] = setAllergyAnswer;
/* unused harmony export allergyForRequest */
/* harmony export (immutable) */ __webpack_exports__["f"] = lineKey;
/* harmony export (immutable) */ __webpack_exports__["c"] = cartLines;
/* harmony export (immutable) */ __webpack_exports__["h"] = runBasketCheck;
/* harmony export (immutable) */ __webpack_exports__["g"] = readyToConfirm;
/* harmony export (immutable) */ __webpack_exports__["k"] = voiceConfirmAllowed;
/* harmony export (immutable) */ __webpack_exports__["b"] = blockedReason;
/* unused harmony export speakAdvice */
/* harmony export (immutable) */ __webpack_exports__["j"] = stopSpeaking;
/* harmony export (immutable) */ __webpack_exports__["a"] = allergenGateApplies;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__supportApi__ = __webpack_require__(209);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}// The allergen gate before a basket is confirmed, shared by the standard basket and chat/voice ordering on pilot
// restaurants. The server (POST /support/v1/order-intents/basket-check) reads the live menu and answers with the
// current prices and stock, problems and changes, the allergy question, allergen advice in words and a quote hash.
// A basket is placed only after a check that is confirmable for the exact quote the customer saw (and, in voice,
// heard to the end). Missing information is unknown, never allergen-free; nothing here decides what is safe.
// The customer's answer to "any allergies or dietary requirements?", per restaurant, for this page session only.
var answers={};// Bumped on every set or clear, so a check started under one answer is never used once the answer has moved.
var revisions={};function getAllergyAnswer(restaurantId){return answers[restaurantId]||null;}function getAllergyRevision(restaurantId){return revisions[restaurantId]||0;}// { none: true } or { text: 'allergic to milk' } (read by the server against the restaurant's own key), or
// the answer the server parsed from the customer's words ({ answered, none, codes, other }).
function setAllergyAnswer(restaurantId,answer){if(restaurantId===undefined||restaurantId===null)return;revisions[restaurantId]=(revisions[restaurantId]||0)+1;if(!answer)delete answers[restaurantId];else answers[restaurantId]=answer;}function allergyForRequest(answer){if(!answer)return undefined;if(answer.text)return{text:answer.text};if(answer.none)return{answered:true,none:true};return{answered:true,none:false,codes:answer.codes||[],other:answer.other||undefined};}function optionIdsOf(product){return(product.mealOptions||[]).map(function(option){return option.idMealOption;}).filter(function(id){return id!==undefined&&id!==null;}).sort(function(a,b){return a-b;});}function lineKey(productId,optionIds){return productId+':'+(optionIds||[]).slice().sort(function(a,b){return a-b;}).join(',');}// The basket as lines: one per dish and choice set, with how many and the unit price the customer sees.
function cartLines(products){var lines=[];(products||[]).forEach(function(product){if(!product||product.id===undefined)return;var optionIds=optionIdsOf(product);var key=lineKey(product.id,optionIds);var line=lines.find(function(candidate){return candidate.key===key;});if(line)line.qty+=1;else lines.push({key:key,productId:product.id,qty:1,optionIds:optionIds,unitPrice:product.price});});return lines.map(function(_ref){var key=_ref.key,line=_objectWithoutProperties(_ref,['key']);return line;});}function runBasketCheck(_ref2){var restaurantId=_ref2.restaurantId,products=_ref2.products,quoteHash=_ref2.quoteHash,seenAdviceText=_ref2.seenAdviceText;return Object(__WEBPACK_IMPORTED_MODULE_0__supportApi__["a" /* checkBasket */])({restaurantId:restaurantId,lines:cartLines(products),allergy:allergyForRequest(getAllergyAnswer(restaurantId)),quoteHash:quoteHash,seenAdviceText:seenAdviceText});}// Everything but the customer's own confirmation is in place: the check only waits for them to confirm this quote.
function readyToConfirm(check){return!!check&&check.applies===true&&Array.isArray(check.blockers)&&check.blockers.length>0&&check.blockers.every(function(blocker){return blocker==='NOT_ACKNOWLEDGED';});}// A chat or voice order can be confirmed: the check waits only for the customer, nothing is being checked, and the
// customer ticked that they read the written allergen advice for this exact quote (any change clears the tick).
function voiceConfirmAllowed(order){return!!order&&!order.checking&&!order.adviceStale&&readyToConfirm(order.check)&&order.ackQuote===order.check.quoteHash;}// Why a check can't be confirmed yet, in words, or '' when it only waits for the customer.
function blockedReason(check){if(!check||check.applies!==true)return'';var blockers=check.blockers||[];if(blockers.includes('ITEMS')){return(check.problems||[]).map(function(problem){return problem.message;}).join(' ')||'Your basket is empty.';}if(blockers.includes('ALLERGY_QUESTION'))return check.allergyQuestion||'';if(blockers.includes('RESTAURANT_CONFIRMATION')){return'Some dishes need the restaurant to confirm they suit your allergy or diet before you order them. Remove them, or contact the restaurant first.';}if(blockers.includes('CHANGED')){return(check.changes||[]).map(function(change){return change.message;}).join(' ');}return'';}// Not used while the pilot is written-only (owner, 3 Nov). Speaks the advice; resolves { completed: true } only
// when the whole text was spoken. Cancelled, interrupted,
// failed or unsupported speech resolves { completed: false }, so confirmation stays blocked.
function speakAdvice(text){var speech=arguments.length>1&&arguments[1]!==undefined?arguments[1]:typeof window!=='undefined'?window.speechSynthesis:null;var Utterance=typeof window!=='undefined'?window.SpeechSynthesisUtterance:null;if(!speech||!Utterance||!text)return Promise.resolve({completed:false,reason:'unsupported'});return new Promise(function(resolve){var settled=false;var finish=function finish(result){if(settled)return;settled=true;resolve(result);};var utterance=new Utterance(text);utterance.lang='en-IE';utterance.onend=function(){return finish({completed:true});};utterance.onerror=function(event){return finish({completed:false,reason:event&&event.error||'error'});};speech.cancel();speech.speak(utterance);});}function stopSpeaking(){var speech=arguments.length>0&&arguments[0]!==undefined?arguments[0]:typeof window!=='undefined'?window.speechSynthesis:null;if(speech)speech.cancel();}// Restaurants in the allergen-gated ordering pilot, from the build (REACT_APP_ALLERGEN_GATE_RESTAURANTS=8630).
// Only these call the check, and on these a failed check blocks the order: there is no stale fallback.
function allergenGateApplies(restaurantId){var ids=arguments.length>1&&arguments[1]!==undefined?arguments[1]:"8630"||'';if(restaurantId===undefined||restaurantId===null)return false;return ids.split(',').map(function(id){return id.trim();}).filter(Boolean).includes(String(restaurantId));}

/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Spinner_css__ = __webpack_require__(760);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Spinner_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Spinner_css__);
// Lunch.Team heart-and-fork mark (from the Basil logo set).
var MARK_PATH='M14.333,27.626c-0.463-0.48-0.919-0.97-1.391-1.441 c-2.188-2.193-4.384-4.378-6.571-6.571c-1.308-1.313-2.616-2.624-3.901-3.957c-0.953-0.99-1.69-2.131-2.059-3.463 c-0.422-1.521-0.547-3.069-0.244-4.637C0.751,4.54,2.485,2.39,5.18,1.012c1.653-0.846,3.43-1.151,5.293-0.947 c2.079,0.228,3.847,1.093,5.347,2.528c0.414,0.397,0.801,0.823,1.2,1.235c0.128,0.133,0.242,0.224,0.421,0.041 c0.554-0.565,1.108-1.13,1.687-1.669c0.837-0.778,1.804-1.362,2.888-1.718c1.24-0.407,2.521-0.557,3.828-0.447 c1.582,0.133,3.042,0.629,4.374,1.489c1.349,0.871,2.421,2.007,3.168,3.433c0.183,0.35,0.296,0.736,0.459,1.097 c0.599,1.325,0.699,2.729,0.588,4.145c-0.164,2.083-0.949,3.91-2.401,5.436c-0.442,0.465-0.864,0.95-1.318,1.403 c-2.343,2.338-4.694,4.668-7.04,7.002c-1.844,1.836-3.698,3.663-5.523,5.519c-0.654,0.665-1.784,0.396-2.017-0.447 c-0.166-0.598-0.293-1.227-0.304-1.843c-0.037-2.152-0.021-4.307-0.012-6.458c0.001-0.26-0.082-0.368-0.321-0.477 c-1.198-0.543-2.03-1.435-2.399-2.71c-0.109-0.377-0.175-0.778-0.178-1.171c-0.017-2.312-0.01-4.625-0.008-6.937 c0.001-0.714,0.546-1.086,1.206-0.827c0.381,0.15,0.484,0.468,0.484,0.841c0,1.336,0,2.671,0,4.007 c0.001,0.638-0.006,1.276,0.004,1.914c0.006,0.398,0.225,0.684,0.566,0.786c0.44,0.132,0.813,0.048,1.031-0.294 c0.104-0.163,0.148-0.389,0.149-0.586c0.011-1.934,0.003-3.868,0.009-5.801c0.002-0.735,0.579-1.131,1.255-0.861 c0.4,0.16,0.494,0.515,0.495,0.9c0.003,1.904,0,3.808,0.003,5.711c0.001,0.167,0.001,0.347,0.058,0.499 c0.119,0.321,0.564,0.545,0.906,0.493c0.458-0.068,0.743-0.346,0.782-0.768c0.011-0.118,0.008-0.239,0.008-0.358 c0.001-1.874-0.002-3.748,0.002-5.622c0.002-0.741,0.552-1.127,1.22-0.861c0.254,0.101,0.428,0.281,0.457,0.568 c0.015,0.149,0.03,0.298,0.03,0.447c0.002,2.153-0.003,4.306,0.003,6.459c0.003,0.948-0.205,1.826-0.747,2.62 c-0.482,0.707-1.104,1.237-1.893,1.563c-0.199,0.082-0.289,0.177-0.287,0.409c0.012,1.405,0.006,2.811,0.006,4.217 c0,0.078,0.007,0.157,0.013,0.301c0.098-0.076,0.166-0.119,0.222-0.175c2.984-2.982,5.972-5.961,8.95-8.95 c0.808-0.811,1.624-1.619,2.368-2.487c0.741-0.864,1.236-1.882,1.508-2.997c0.188-0.768,0.251-1.539,0.115-2.328 c-0.408-2.36-1.766-3.989-3.866-5.04c-1.181-0.591-2.436-0.833-3.758-0.659c-1.545,0.204-2.828,0.91-3.918,2.004 c-0.694,0.697-1.385,1.398-2.108,2.065c-0.91,0.84-1.424,0.479-2.013-0.07c-0.736-0.684-1.425-1.418-2.141-2.124 c-0.947-0.934-2.074-1.503-3.385-1.777c-2.807-0.586-6.04,0.932-7.345,3.607c-0.57,1.167-0.754,2.395-0.641,3.704 c0.155,1.79,1.035,3.168,2.252,4.389c3.103,3.113,6.213,6.219,9.314,9.334c0.101,0.101,0.198,0.263,0.2,0.397 c0.016,1.086,0.009,2.173,0.009,3.259c0,0.049-0.009,0.097-0.013,0.146C14.392,27.588,14.363,27.608,14.333,27.626';// "Orbit" loader: the heart stays still and a Basil ring turns round it.
// nameClass sets where it sits:
// lds-default   centred in its positioned parent
// lds-secondary centred in the flow (inside forms)
// lds-third     centred over the whole page, with a soft backdrop
var Spinner=function Spinner(props){var nameClass=props.nameClass?props.nameClass:'lds-default';var label=props.label||'Loading';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'lt-spinner-wrap '+nameClass,role:'status','aria-live':'polite'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'lt-orbit','aria-hidden':'true'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg',{className:'lt-orbit-ring',viewBox:'0 0 48 48'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('circle',{className:'lt-orbit-track',cx:'24',cy:'24',r:'22'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('circle',{className:'lt-orbit-arc',cx:'24',cy:'24',r:'22'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg',{className:'lt-orbit-mark',viewBox:'-1 -1 36.5 32'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:MARK_PATH}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:props.label?'lt-spinner-label':'lt-spinner-label lt-visually-hidden'},label));};/* harmony default export */ __webpack_exports__["a"] = (Spinner);

/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_hoc_ReactAux_ReactAux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Modal_css__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Modal_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Modal_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_modal__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_modal__);
var customStyles={content:{background:'none',border:'none'},overlay:{zIndex:'9999999',width:'100%',height:'100%',left:'0',top:'0',backgroundColor:'rgba(0, 0, 0, 0.7)'}};var ModalSuccess=function ModalSuccess(props){if(!props.showModal){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_hoc_ReactAux_ReactAux__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_modal___default.a,{isOpen:props.showModal,style:customStyles,onRequestClose:props.closeModal,shouldCloseOnOverlayClick:true,shouldCloseOnEsc:true,contentLabel:'Example Modal'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'lb-placed',style:props.style,className:'lb-geral lb-placed_ mfp-bg-login white-popup-block lb-centralizar singup zoom-anim-dialog Modal-Success'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'lb-padrao-singup6 mfp-content-login modal-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:props.closeModal,type:'button',className:'bt-close mfp-close lb-fechar fa fa-times'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'check-mark'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'fa fa-check-circle lt-success-tick','aria-hidden':'true'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'lb-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'modal-success-description'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,props.message)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{onClick:props.closeModal,className:'bt'},'Ok'))))));};/* harmony default export */ __webpack_exports__["a"] = (ModalSuccess);

/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MAGIC_LINK_CLIENT_APP; });
/* harmony export (immutable) */ __webpack_exports__["k"] = isValidMagicLinkToken;
/* harmony export (immutable) */ __webpack_exports__["g"] = extractMagicLinkToken;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return MAGIC_LINK_ERRORS; });
/* harmony export (immutable) */ __webpack_exports__["n"] = magicLinkUserError;
/* harmony export (immutable) */ __webpack_exports__["l"] = magicLinkErrorMessage;
/* harmony export (immutable) */ __webpack_exports__["f"] = classifyMagicLinkError;
/* unused harmony export MAGIC_LINK_SENT_MESSAGE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return MAGIC_LINK_LIFETIME_MINUTES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return MAGIC_LINK_RESEND_SECONDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return MAGIC_LINK_DEFAULT_RETRY_SECONDS; });
/* harmony export (immutable) */ __webpack_exports__["r"] = retryAfterSeconds;
/* unused harmony export formatWait */
/* harmony export (immutable) */ __webpack_exports__["j"] = isThrottled;
/* harmony export (immutable) */ __webpack_exports__["m"] = magicLinkRequestErrorMessage;
/* harmony export (immutable) */ __webpack_exports__["o"] = maskEmail;
/* harmony export (immutable) */ __webpack_exports__["s"] = safeRedirectPath;
/* harmony export (immutable) */ __webpack_exports__["q"] = rememberMagicLinkContext;
/* harmony export (immutable) */ __webpack_exports__["h"] = forgetSupportLinkInContext;
/* harmony export (immutable) */ __webpack_exports__["p"] = readMagicLinkContext;
/* harmony export (immutable) */ __webpack_exports__["i"] = isPhoneUserAgent;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__userError__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__support_deepLink__ = __webpack_require__(143);
var _MESSAGES,_CODES;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}// Helpers for email sign-in links (magic links).
//
// Links look like https://new.lunch.team/MagicLogin/<token>. Older links may carry
// ?token=<token> instead. The page never verifies a token on load: mail scanners open
// links before people do, and a single-use token would be spent before the click.
// UUIDs today (36 chars with hyphens); base64url 256-bit tokens later (43 chars).
var TOKEN_PATTERN=/^[A-Za-z0-9_-]{16,128}$/;var MAGIC_LINK_CLIENT_APP='LUNCH_WEB';function isValidMagicLinkToken(token){return typeof token==='string'&&TOKEN_PATTERN.test(token);}function safeDecode(value){try{return decodeURIComponent(value);}catch(error){return value;}}// Returns the token from /MagicLogin/<token> or ?token=<token>, or '' when there is none.
function extractMagicLinkToken(location){var pathname=location&&location.pathname||'';var search=location&&location.search||'';var match=pathname.match(/\/MagicLogin\/([^/?#]+)\/?$/i);if(match){return safeDecode(match[1]).trim();}var queryMatch=search.match(/[?&]token=([^&#]*)/);if(queryMatch){return safeDecode(queryMatch[1]).trim();}return'';}var MAGIC_LINK_ERRORS={EXPIRED:'expired',INVALID:'invalid',THROTTLED:'throttled',NOT_ALLOWED:'not_allowed',NETWORK:'network',UNKNOWN:'unknown'};var MESSAGES=(_MESSAGES={},_defineProperty(_MESSAGES,MAGIC_LINK_ERRORS.EXPIRED,'This sign-in link has expired. Links work for a short time only. Ask for a new link below, or sign in with your password.'),_defineProperty(_MESSAGES,MAGIC_LINK_ERRORS.INVALID,'This sign-in link has already been used or is not valid. Each link works once. Ask for a new link below, or sign in with your password.'),_defineProperty(_MESSAGES,MAGIC_LINK_ERRORS.THROTTLED,'Too many attempts. Please wait a few minutes, or sign in with your password.'),_defineProperty(_MESSAGES,MAGIC_LINK_ERRORS.NOT_ALLOWED,'Email sign-in links are not available for this account. Please sign in with your password.'),_defineProperty(_MESSAGES,MAGIC_LINK_ERRORS.NETWORK,'We could not reach Lunch.Team. Check your connection and try again.'),_defineProperty(_MESSAGES,MAGIC_LINK_ERRORS.UNKNOWN,"We couldn't finish signing you in. Try the link again, or sign in with your password."),_MESSAGES);var CODES=(_CODES={},_defineProperty(_CODES,MAGIC_LINK_ERRORS.EXPIRED,__WEBPACK_IMPORTED_MODULE_0__userError__["a" /* ERROR_CODES */].AUTH_LINK_EXPIRED),_defineProperty(_CODES,MAGIC_LINK_ERRORS.INVALID,__WEBPACK_IMPORTED_MODULE_0__userError__["a" /* ERROR_CODES */].AUTH_LINK_USED),_defineProperty(_CODES,MAGIC_LINK_ERRORS.THROTTLED,__WEBPACK_IMPORTED_MODULE_0__userError__["a" /* ERROR_CODES */].AUTH_LOCKED),_defineProperty(_CODES,MAGIC_LINK_ERRORS.NOT_ALLOWED,__WEBPACK_IMPORTED_MODULE_0__userError__["a" /* ERROR_CODES */].AUTH_LINK_NOT_ALLOWED),_CODES);/**
 * The support reference for a failed sign-in link (src/utils/userError.js): code, time and the
 * server's id. Network and server failures keep their own codes (offline, unreachable, down).
 */function magicLinkUserError(kind,error){var known=CODES[kind];return Object(__WEBPACK_IMPORTED_MODULE_0__userError__["h" /* userError */])(known?null:error,{area:'AUTH',code:known,serverId:known?Object(__WEBPACK_IMPORTED_MODULE_0__userError__["f" /* serverIdOf */])(error):undefined});}function magicLinkErrorMessage(kind){return MESSAGES[kind]||MESSAGES[MAGIC_LINK_ERRORS.UNKNOWN];}function errorStatus(error){if(!error){return undefined;}if(typeof error.status==='number'){return error.status;}if(error.response&&typeof error.response.status==='number'){return error.response.status;}return undefined;}function errorText(error){var data=error&&error.data||{};return[data.message,data.error,data.detail,data.code].filter(function(value){return typeof value==='string';}).join(' ').toLowerCase();}// Turns a failed verify call into one of MAGIC_LINK_ERRORS. Never exposes backend text.
function classifyMagicLinkError(error){if(error&&error.isNetworkError){return MAGIC_LINK_ERRORS.NETWORK;}var status=errorStatus(error);if(status===429){return MAGIC_LINK_ERRORS.THROTTLED;}if(status===403){return MAGIC_LINK_ERRORS.NOT_ALLOWED;}if(status===400||status===404||status===410||status===401){return errorText(error).indexOf('expired')!==-1?MAGIC_LINK_ERRORS.EXPIRED:MAGIC_LINK_ERRORS.INVALID;}return MAGIC_LINK_ERRORS.UNKNOWN;}// Message shown after "Email me a sign-in link". The same text whether or not the
// account exists, so the page does not reveal who has an account.
var MAGIC_LINK_SENT_MESSAGE='If there is a Lunch.Team account for that email, we have sent a sign-in link. It works once and expires soon. You can still sign in with your password.';// How long a link works (backend default) and how long "Resend" stays disabled.
var MAGIC_LINK_LIFETIME_MINUTES=15;var MAGIC_LINK_RESEND_SECONDS=30;// Used when a 429 does not say how long to wait.
var MAGIC_LINK_DEFAULT_RETRY_SECONDS=60;// Seconds to wait after a 429, from Retry-After (seconds or an HTTP date) or the body.
function retryAfterSeconds(error){var now=arguments.length>1&&arguments[1]!==undefined?arguments[1]:Date.now();if(!error){return undefined;}var data=error.data||{};var candidates=[error.retryAfter,data.retryAfterSeconds,data.retryAfter];for(var i=0;i<candidates.length;i+=1){var value=candidates[i];if(value===undefined||value===null||value===''){continue;}var asNumber=Number(value);if(!isNaN(asNumber)&&isFinite(asNumber)){return Math.max(1,Math.ceil(asNumber));}var asDate=Date.parse(value);if(!isNaN(asDate)){return Math.max(1,Math.ceil((asDate-now)/1000));}}return undefined;}function formatWait(seconds){if(seconds<60){return seconds+' second'+(seconds===1?'':'s');}var minutes=Math.ceil(seconds/60);return minutes+' minute'+(minutes===1?'':'s');}function isThrottled(error){return errorStatus(error)===429;}function magicLinkRequestErrorMessage(error){if(error&&error.isNetworkError){return MESSAGES[MAGIC_LINK_ERRORS.NETWORK];}if(isThrottled(error)){var wait=retryAfterSeconds(error);return wait?'Too many link requests. Please try again in '+formatWait(wait)+', or use your password.':'Too many link requests. Please wait a few minutes, or use your password.';}return'We could not send a sign-in link just now. Please try again, or use your password.';}// "fehin@lunch.team" -> "fe•••@lunch.team". Shown on screen only, never sent anywhere.
function maskEmail(email){var value=(email||'').trim();var at=value.lastIndexOf('@');if(at<1){return value;}var local=value.slice(0,at);var visible=local.length<=2?local.slice(0,1):local.slice(0,2);return visible+'\u2022\u2022\u2022'+value.slice(at);}// Only same-site paths, so ?redirect= can never send someone to another site.
function safeRedirectPath(value){if(typeof value!=='string'){return'';}var path=value.trim();if(!/^\/[A-Za-z0-9]/.test(path)||path.indexOf('//')===0||path.indexOf('\\')!==-1){return'';}if(/^\/MagicLogin\b/i.test(path)){return'';}return path;}// Remembers (on this device only) which email asked for a link and where they were
// going, so /MagicLogin can prefill "Email me a new link" and redirect after sign-in.
// The link opens in another tab, so a support reply email's link waiting in this one
// goes along in the redirect (deepLink.js).
var CONTEXT_KEY='lt:magicLinkContext';function rememberMagicLinkContext(_ref){var email=_ref.email,redirect=_ref.redirect;try{localStorage.setItem(CONTEXT_KEY,JSON.stringify({email:(email||'').trim(),redirect:Object(__WEBPACK_IMPORTED_MODULE_1__support_deepLink__["c" /* withPendingSupportLink */])(safeRedirectPath(redirect))}));}catch(error){// Storage can be unavailable (private mode); the flow still works without it.
}}// Once a sign-in link has been used, the support conversation in the remembered redirect is done with:
// the context stays in localStorage, and a later sign-in on this device (maybe another customer's) must
// not go there again.
function forgetSupportLinkInContext(){try{var parsed=JSON.parse(localStorage.getItem(CONTEXT_KEY)||'null');if(!parsed||typeof parsed.redirect!=='string')return;var redirect=Object(__WEBPACK_IMPORTED_MODULE_1__support_deepLink__["e" /* withoutSupportLinkInPath */])(parsed.redirect);if(redirect!==parsed.redirect){localStorage.setItem(CONTEXT_KEY,JSON.stringify(Object.assign({},parsed,{redirect:redirect})));}}catch(error){// Storage can be unavailable (private mode).
}}function readMagicLinkContext(){try{var parsed=JSON.parse(localStorage.getItem(CONTEXT_KEY)||'{}')||{};return{email:typeof parsed.email==='string'?parsed.email:'',redirect:safeRedirectPath(parsed.redirect)};}catch(error){return{email:'',redirect:''};}}function isPhoneUserAgent(userAgent){return /Android|iPhone|iPad|iPod/i.test(userAgent||'');}

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(28);
var toLength = __webpack_require__(11);
var toAbsoluteIndex = __webpack_require__(58);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 101 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(33);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(34);
var defined = __webpack_require__(41);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.8 IsRegExp(argument)
var isObject = __webpack_require__(9);
var cof = __webpack_require__(33);
var MATCH = __webpack_require__(10)('match');
module.exports = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
};


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(10)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var classof = __webpack_require__(74);
var builtinExec = RegExp.prototype.exec;

 // `RegExpExec` abstract operation
// https://tc39.github.io/ecma262/#sec-regexpexec
module.exports = function (R, S) {
  var exec = R.exec;
  if (typeof exec === 'function') {
    var result = exec.call(R, S);
    if (typeof result !== 'object') {
      throw new TypeError('RegExp exec method returned something other than an Object or null');
    }
    return result;
  }
  if (classof(R) !== 'RegExp') {
    throw new TypeError('RegExp#exec called on incompatible receiver');
  }
  return builtinExec.call(R, S);
};


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__(234);
var redefine = __webpack_require__(23);
var hide = __webpack_require__(22);
var fails = __webpack_require__(6);
var defined = __webpack_require__(41);
var wks = __webpack_require__(10);
var regexpExec = __webpack_require__(165);

var SPECIES = wks('species');

var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
  // #replace needs built-in support for named groups.
  // #match works fine because it just return the exec results, even if it has
  // a "grops" property.
  var re = /./;
  re.exec = function () {
    var result = [];
    result.groups = { a: '7' };
    return result;
  };
  return ''.replace(re, '$<a>') !== '7';
});

var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = (function () {
  // Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
  var re = /(?:)/;
  var originalExec = re.exec;
  re.exec = function () { return originalExec.apply(this, arguments); };
  var result = 'ab'.split(re);
  return result.length === 2 && result[0] === 'a' && result[1] === 'b';
})();

module.exports = function (KEY, length, exec) {
  var SYMBOL = wks(KEY);

  var DELEGATES_TO_SYMBOL = !fails(function () {
    // String methods call symbol-named RegEp methods
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  });

  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL ? !fails(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;
    re.exec = function () { execCalled = true; return null; };
    if (KEY === 'split') {
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};
      re.constructor[SPECIES] = function () { return re; };
    }
    re[SYMBOL]('');
    return !execCalled;
  }) : undefined;

  if (
    !DELEGATES_TO_SYMBOL ||
    !DELEGATES_TO_EXEC ||
    (KEY === 'replace' && !REPLACE_SUPPORTS_NAMED_GROUPS) ||
    (KEY === 'split' && !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC)
  ) {
    var nativeRegExpMethod = /./[SYMBOL];
    var fns = exec(
      defined,
      SYMBOL,
      ''[KEY],
      function maybeCallNative(nativeMethod, regexp, str, arg2, forceStringMethod) {
        if (regexp.exec === regexpExec) {
          if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
            // The native String method already delegates to @@method (this
            // polyfilled function), leasing to infinite recursion.
            // We avoid it by directly calling the native @@method method.
            return { done: true, value: nativeRegExpMethod.call(regexp, str, arg2) };
          }
          return { done: true, value: nativeMethod.call(str, regexp, arg2) };
        }
        return { done: false };
      }
    );
    var strfn = fns[0];
    var rxfn = fns[1];

    redefine(String.prototype, KEY, strfn);
    hide(RegExp.prototype, SYMBOL, length == 2
      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
      ? function (string, arg) { return rxfn.call(string, this, arg); }
      // 21.2.5.6 RegExp.prototype[@@match](string)
      // 21.2.5.9 RegExp.prototype[@@search](string)
      : function (string) { return rxfn.call(string, this); }
    );
  }
};


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(3);
var navigator = global.navigator;

module.exports = navigator && navigator.userAgent || '';


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(3);
var $export = __webpack_require__(1);
var redefine = __webpack_require__(23);
var redefineAll = __webpack_require__(64);
var meta = __webpack_require__(51);
var forOf = __webpack_require__(63);
var anInstance = __webpack_require__(62);
var isObject = __webpack_require__(9);
var fails = __webpack_require__(6);
var $iterDetect = __webpack_require__(105);
var setToStringTag = __webpack_require__(73);
var inheritIfRequired = __webpack_require__(151);

module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
  var Base = global[NAME];
  var C = Base;
  var ADDER = IS_MAP ? 'set' : 'add';
  var proto = C && C.prototype;
  var O = {};
  var fixMethod = function (KEY) {
    var fn = proto[KEY];
    redefine(proto, KEY,
      KEY == 'delete' ? function (a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'has' ? function has(a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'get' ? function get(a) {
        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'add' ? function add(a) { fn.call(this, a === 0 ? 0 : a); return this; }
        : function set(a, b) { fn.call(this, a === 0 ? 0 : a, b); return this; }
    );
  };
  if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
    new C().entries().next();
  }))) {
    // create collection constructor
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    redefineAll(C.prototype, methods);
    meta.NEED = true;
  } else {
    var instance = new C();
    // early implementations not supports chaining
    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
    // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
    // most early implementations doesn't supports iterables, most modern - not close it correctly
    var ACCEPT_ITERABLES = $iterDetect(function (iter) { new C(iter); }); // eslint-disable-line no-new
    // for early implementations -0 and +0 not the same
    var BUGGY_ZERO = !IS_WEAK && fails(function () {
      // V8 ~ Chromium 42- fails only with 5+ elements
      var $instance = new C();
      var index = 5;
      while (index--) $instance[ADDER](index, index);
      return !$instance.has(-0);
    });
    if (!ACCEPT_ITERABLES) {
      C = wrapper(function (target, iterable) {
        anInstance(target, C, NAME);
        var that = inheritIfRequired(new Base(), target, C);
        if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
        return that;
      });
      C.prototype = proto;
      proto.constructor = C;
    }
    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
      fixMethod('delete');
      fixMethod('has');
      IS_MAP && fixMethod('get');
    }
    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
    // weak collections should not contains .clear method
    if (IS_WEAK && proto.clear) delete proto.clear;
  }

  setToStringTag(C, NAME);

  O[NAME] = C;
  $export($export.G + $export.W + $export.F * (C != Base), O);

  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);

  return C;
};


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(3);
var hide = __webpack_require__(22);
var uid = __webpack_require__(56);
var TYPED = uid('typed_array');
var VIEW = uid('view');
var ABV = !!(global.ArrayBuffer && global.DataView);
var CONSTR = ABV;
var i = 0;
var l = 9;
var Typed;

var TypedArrayConstructors = (
  'Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array'
).split(',');

while (i < l) {
  if (Typed = global[TypedArrayConstructors[i++]]) {
    hide(Typed.prototype, TYPED, true);
    hide(Typed.prototype, VIEW, true);
  } else CONSTR = false;
}

module.exports = {
  ABV: ABV,
  CONSTR: CONSTR,
  TYPED: TYPED,
  VIEW: VIEW
};


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// Forced replacement prototype accessors methods
module.exports = __webpack_require__(50) || !__webpack_require__(6)(function () {
  var K = Math.random();
  // In FF throws only define methods
  // eslint-disable-next-line no-undef, no-useless-call
  __defineSetter__.call(null, K, function () { /* empty */ });
  delete __webpack_require__(3)[K];
});


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(1);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { of: function of() {
    var length = arguments.length;
    var A = new Array(length);
    while (length--) A[length] = arguments[length];
    return new this(A);
  } });
};


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(1);
var aFunction = __webpack_require__(20);
var ctx = __webpack_require__(32);
var forOf = __webpack_require__(63);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
    var mapFn = arguments[1];
    var mapping, A, n, cb;
    aFunction(this);
    mapping = mapFn !== undefined;
    if (mapping) aFunction(mapFn);
    if (source == undefined) return new this();
    A = [];
    if (mapping) {
      n = 0;
      cb = ctx(mapFn, arguments[2], 2);
      forOf(source, false, function (nextItem) {
        A.push(cb(nextItem, n++));
      });
    } else {
      forOf(source, false, A.push, A);
    }
    return new this(A);
  } });
};


/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _objectWithoutPropertiesLoose;
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export __DO_NOT_USE__ActionTypes */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return applyMiddleware; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return bindActionCreators; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return combineReducers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return compose; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return createStore; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_symbol_observable__ = __webpack_require__(586);


/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */
var randomString = function randomString() {
  return Math.random().toString(36).substring(7).split('').join('.');
};

var ActionTypes = {
  INIT: "@@redux/INIT" + randomString(),
  REPLACE: "@@redux/REPLACE" + randomString(),
  PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
    return "@@redux/PROBE_UNKNOWN_ACTION" + randomString();
  }
};

/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */
function isPlainObject(obj) {
  if (typeof obj !== 'object' || obj === null) return false;
  var proto = obj;

  while (Object.getPrototypeOf(proto) !== null) {
    proto = Object.getPrototypeOf(proto);
  }

  return Object.getPrototypeOf(obj) === proto;
}

/**
 * Creates a Redux store that holds the state tree.
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */

function createStore(reducer, preloadedState, enhancer) {
  var _ref2;

  if (typeof preloadedState === 'function' && typeof enhancer === 'function' || typeof enhancer === 'function' && typeof arguments[3] === 'function') {
    throw new Error('It looks like you are passing several store enhancers to ' + 'createStore(). This is not supported. Instead, compose them ' + 'together to a single function.');
  }

  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
    enhancer = preloadedState;
    preloadedState = undefined;
  }

  if (typeof enhancer !== 'undefined') {
    if (typeof enhancer !== 'function') {
      throw new Error('Expected the enhancer to be a function.');
    }

    return enhancer(createStore)(reducer, preloadedState);
  }

  if (typeof reducer !== 'function') {
    throw new Error('Expected the reducer to be a function.');
  }

  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;
  /**
   * This makes a shallow copy of currentListeners so we can use
   * nextListeners as a temporary list while dispatching.
   *
   * This prevents any bugs around consumers calling
   * subscribe/unsubscribe in the middle of a dispatch.
   */

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }
  /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */


  function getState() {
    if (isDispatching) {
      throw new Error('You may not call store.getState() while the reducer is executing. ' + 'The reducer has already received the state as an argument. ' + 'Pass it down from the top reducer instead of reading it from the store.');
    }

    return currentState;
  }
  /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */


  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error('Expected the listener to be a function.');
    }

    if (isDispatching) {
      throw new Error('You may not call store.subscribe() while the reducer is executing. ' + 'If you would like to be notified after the store has been updated, subscribe from a ' + 'component and invoke store.getState() in the callback to access the latest state. ' + 'See https://redux.js.org/api-reference/store#subscribelistener for more details.');
    }

    var isSubscribed = true;
    ensureCanMutateNextListeners();
    nextListeners.push(listener);
    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      if (isDispatching) {
        throw new Error('You may not unsubscribe from a store listener while the reducer is executing. ' + 'See https://redux.js.org/api-reference/store#subscribelistener for more details.');
      }

      isSubscribed = false;
      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
      currentListeners = null;
    };
  }
  /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */


  function dispatch(action) {
    if (!isPlainObject(action)) {
      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
    }

    if (typeof action.type === 'undefined') {
      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
    }

    if (isDispatching) {
      throw new Error('Reducers may not dispatch actions.');
    }

    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }

    var listeners = currentListeners = nextListeners;

    for (var i = 0; i < listeners.length; i++) {
      var listener = listeners[i];
      listener();
    }

    return action;
  }
  /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */


  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== 'function') {
      throw new Error('Expected the nextReducer to be a function.');
    }

    currentReducer = nextReducer; // This action has a similiar effect to ActionTypes.INIT.
    // Any reducers that existed in both the new and old rootReducer
    // will receive the previous state. This effectively populates
    // the new state tree with any relevant data from the old one.

    dispatch({
      type: ActionTypes.REPLACE
    });
  }
  /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */


  function observable() {
    var _ref;

    var outerSubscribe = subscribe;
    return _ref = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe(observer) {
        if (typeof observer !== 'object' || observer === null) {
          throw new TypeError('Expected the observer to be an object.');
        }

        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }

        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return {
          unsubscribe: unsubscribe
        };
      }
    }, _ref[__WEBPACK_IMPORTED_MODULE_0_symbol_observable__["a" /* default */]] = function () {
      return this;
    }, _ref;
  } // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.


  dispatch({
    type: ActionTypes.INIT
  });
  return _ref2 = {
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer
  }, _ref2[__WEBPACK_IMPORTED_MODULE_0_symbol_observable__["a" /* default */]] = observable, _ref2;
}

/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */


  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
  } catch (e) {} // eslint-disable-line no-empty

}

function getUndefinedStateErrorMessage(key, action) {
  var actionType = action && action.type;
  var actionDescription = actionType && "action \"" + String(actionType) + "\"" || 'an action';
  return "Given " + actionDescription + ", reducer \"" + key + "\" returned undefined. " + "To ignore an action, you must explicitly return the previous state. " + "If you want this reducer to hold no value, you can return null instead of undefined.";
}

function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
  var reducerKeys = Object.keys(reducers);
  var argumentName = action && action.type === ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';

  if (reducerKeys.length === 0) {
    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
  }

  if (!isPlainObject(inputState)) {
    return "The " + argumentName + " has unexpected type of \"" + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + "\". Expected argument to be an object with the following " + ("keys: \"" + reducerKeys.join('", "') + "\"");
  }

  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
  });
  unexpectedKeys.forEach(function (key) {
    unexpectedKeyCache[key] = true;
  });
  if (action && action.type === ActionTypes.REPLACE) return;

  if (unexpectedKeys.length > 0) {
    return "Unexpected " + (unexpectedKeys.length > 1 ? 'keys' : 'key') + " " + ("\"" + unexpectedKeys.join('", "') + "\" found in " + argumentName + ". ") + "Expected to find one of the known reducer keys instead: " + ("\"" + reducerKeys.join('", "') + "\". Unexpected keys will be ignored.");
  }
}

function assertReducerShape(reducers) {
  Object.keys(reducers).forEach(function (key) {
    var reducer = reducers[key];
    var initialState = reducer(undefined, {
      type: ActionTypes.INIT
    });

    if (typeof initialState === 'undefined') {
      throw new Error("Reducer \"" + key + "\" returned undefined during initialization. " + "If the state passed to the reducer is undefined, you must " + "explicitly return the initial state. The initial state may " + "not be undefined. If you don't want to set a value for this reducer, " + "you can use null instead of undefined.");
    }

    if (typeof reducer(undefined, {
      type: ActionTypes.PROBE_UNKNOWN_ACTION()
    }) === 'undefined') {
      throw new Error("Reducer \"" + key + "\" returned undefined when probed with a random type. " + ("Don't try to handle " + ActionTypes.INIT + " or other actions in \"redux/*\" ") + "namespace. They are considered private. Instead, you must return the " + "current state for any unknown actions, unless it is undefined, " + "in which case you must return the initial state, regardless of the " + "action type. The initial state may not be undefined, but can be null.");
    }
  });
}
/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */


function combineReducers(reducers) {
  var reducerKeys = Object.keys(reducers);
  var finalReducers = {};

  for (var i = 0; i < reducerKeys.length; i++) {
    var key = reducerKeys[i];

    if (false) {
      if (typeof reducers[key] === 'undefined') {
        warning("No reducer provided for key \"" + key + "\"");
      }
    }

    if (typeof reducers[key] === 'function') {
      finalReducers[key] = reducers[key];
    }
  }

  var finalReducerKeys = Object.keys(finalReducers); // This is used to make sure we don't warn about the same
  // keys multiple times.

  var unexpectedKeyCache;

  if (false) {
    unexpectedKeyCache = {};
  }

  var shapeAssertionError;

  try {
    assertReducerShape(finalReducers);
  } catch (e) {
    shapeAssertionError = e;
  }

  return function combination(state, action) {
    if (state === void 0) {
      state = {};
    }

    if (shapeAssertionError) {
      throw shapeAssertionError;
    }

    if (false) {
      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);

      if (warningMessage) {
        warning(warningMessage);
      }
    }

    var hasChanged = false;
    var nextState = {};

    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
      var _key = finalReducerKeys[_i];
      var reducer = finalReducers[_key];
      var previousStateForKey = state[_key];
      var nextStateForKey = reducer(previousStateForKey, action);

      if (typeof nextStateForKey === 'undefined') {
        var errorMessage = getUndefinedStateErrorMessage(_key, action);
        throw new Error(errorMessage);
      }

      nextState[_key] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }

    hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
    return hasChanged ? nextState : state;
  };
}

function bindActionCreator(actionCreator, dispatch) {
  return function () {
    return dispatch(actionCreator.apply(this, arguments));
  };
}
/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass an action creator as the first argument,
 * and get a dispatch wrapped function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */


function bindActionCreators(actionCreators, dispatch) {
  if (typeof actionCreators === 'function') {
    return bindActionCreator(actionCreators, dispatch);
  }

  if (typeof actionCreators !== 'object' || actionCreators === null) {
    throw new Error("bindActionCreators expected an object or a function, instead received " + (actionCreators === null ? 'null' : typeof actionCreators) + ". " + "Did you write \"import ActionCreators from\" instead of \"import * as ActionCreators from\"?");
  }

  var boundActionCreators = {};

  for (var key in actionCreators) {
    var actionCreator = actionCreators[key];

    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
  }

  return boundActionCreators;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    keys.push.apply(keys, Object.getOwnPropertySymbols(object));
  }

  if (enumerableOnly) keys = keys.filter(function (sym) {
    return Object.getOwnPropertyDescriptor(object, sym).enumerable;
  });
  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */
function compose() {
  for (var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(void 0, arguments));
    };
  });
}

/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */

function applyMiddleware() {
  for (var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  return function (createStore) {
    return function () {
      var store = createStore.apply(void 0, arguments);

      var _dispatch = function dispatch() {
        throw new Error('Dispatching while constructing your middleware is not allowed. ' + 'Other middleware would not be applied to this dispatch.');
      };

      var middlewareAPI = {
        getState: store.getState,
        dispatch: function dispatch() {
          return _dispatch.apply(void 0, arguments);
        }
      };
      var chain = middlewares.map(function (middleware) {
        return middleware(middlewareAPI);
      });
      _dispatch = compose.apply(void 0, chain)(store.dispatch);
      return _objectSpread2({}, store, {
        dispatch: _dispatch
      });
    };
  };
}

/*
 * This is a dummy function to check if the function name has been altered by minification.
 * If the function has been minified and NODE_ENV !== 'production', warn the user.
 */

function isCrushed() {}

if (false) {
  warning('You are currently using minified code outside of NODE_ENV === "production". ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or setting mode to production in webpack (https://webpack.js.org/concepts/mode/) ' + 'to ensure you have the correct code for your production build.');
}




/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_utils_http__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_utils_login_basicHeadersBuilders__ = __webpack_require__(642);
// options.showSpinner=false keeps the global spinner off. The global spinner makes the
// signed-out landing page redirect to /Menu and back while the request runs (see
// userIsNotAuthenticatedRedir in src/auth.js), which unmounts the sign-in form.
var login=function login(credentials){var options=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};var urlLogin=!!credentials&&!!credentials.staySigned?'/user/v1/login?remember-me=true':'/user/v1/login';return __WEBPACK_IMPORTED_MODULE_0_utils_http__["a" /* default */].post(urlLogin,undefined,Object(__WEBPACK_IMPORTED_MODULE_1_utils_login_basicHeadersBuilders__["a" /* default */])(credentials),false,options.showSpinner!==false);};var preLogin=function preLogin(credentials){var options=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};return __WEBPACK_IMPORTED_MODULE_0_utils_http__["a" /* default */].post('/user/v1/login/pre-login',credentials,undefined,true,options.showSpinner!==false);};var logout=function logout(){return __WEBPACK_IMPORTED_MODULE_0_utils_http__["a" /* default */].post('/user/v1/logout');};/* harmony default export */ __webpack_exports__["a"] = ({login:login,preLogin:preLogin,logout:logout});

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var require;//! moment.js

;(function (global, factory) {
     true ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    global.moment = factory()
}(this, (function () { 'use strict';

    var hookCallback;

    function hooks () {
        return hookCallback.apply(null, arguments);
    }

    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback (callback) {
        hookCallback = callback;
    }

    function isArray(input) {
        return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
    }

    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return input != null && Object.prototype.toString.call(input) === '[object Object]';
    }

    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) {
            return (Object.getOwnPropertyNames(obj).length === 0);
        } else {
            var k;
            for (k in obj) {
                if (obj.hasOwnProperty(k)) {
                    return false;
                }
            }
            return true;
        }
    }

    function isUndefined(input) {
        return input === void 0;
    }

    function isNumber(input) {
        return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
    }

    function isDate(input) {
        return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
    }

    function map(arr, fn) {
        var res = [], i;
        for (i = 0; i < arr.length; ++i) {
            res.push(fn(arr[i], i));
        }
        return res;
    }

    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }

    function extend(a, b) {
        for (var i in b) {
            if (hasOwnProp(b, i)) {
                a[i] = b[i];
            }
        }

        if (hasOwnProp(b, 'toString')) {
            a.toString = b.toString;
        }

        if (hasOwnProp(b, 'valueOf')) {
            a.valueOf = b.valueOf;
        }

        return a;
    }

    function createUTC (input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }

    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty           : false,
            unusedTokens    : [],
            unusedInput     : [],
            overflow        : -2,
            charsLeftOver   : 0,
            nullInput       : false,
            invalidMonth    : null,
            invalidFormat   : false,
            userInvalidated : false,
            iso             : false,
            parsedDateParts : [],
            meridiem        : null,
            rfc2822         : false,
            weekdayMismatch : false
        };
    }

    function getParsingFlags(m) {
        if (m._pf == null) {
            m._pf = defaultParsingFlags();
        }
        return m._pf;
    }

    var some;
    if (Array.prototype.some) {
        some = Array.prototype.some;
    } else {
        some = function (fun) {
            var t = Object(this);
            var len = t.length >>> 0;

            for (var i = 0; i < len; i++) {
                if (i in t && fun.call(this, t[i], i, t)) {
                    return true;
                }
            }

            return false;
        };
    }

    function isValid(m) {
        if (m._isValid == null) {
            var flags = getParsingFlags(m);
            var parsedParts = some.call(flags.parsedDateParts, function (i) {
                return i != null;
            });
            var isNowValid = !isNaN(m._d.getTime()) &&
                flags.overflow < 0 &&
                !flags.empty &&
                !flags.invalidMonth &&
                !flags.invalidWeekday &&
                !flags.weekdayMismatch &&
                !flags.nullInput &&
                !flags.invalidFormat &&
                !flags.userInvalidated &&
                (!flags.meridiem || (flags.meridiem && parsedParts));

            if (m._strict) {
                isNowValid = isNowValid &&
                    flags.charsLeftOver === 0 &&
                    flags.unusedTokens.length === 0 &&
                    flags.bigHour === undefined;
            }

            if (Object.isFrozen == null || !Object.isFrozen(m)) {
                m._isValid = isNowValid;
            }
            else {
                return isNowValid;
            }
        }
        return m._isValid;
    }

    function createInvalid (flags) {
        var m = createUTC(NaN);
        if (flags != null) {
            extend(getParsingFlags(m), flags);
        }
        else {
            getParsingFlags(m).userInvalidated = true;
        }

        return m;
    }

    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = hooks.momentProperties = [];

    function copyConfig(to, from) {
        var i, prop, val;

        if (!isUndefined(from._isAMomentObject)) {
            to._isAMomentObject = from._isAMomentObject;
        }
        if (!isUndefined(from._i)) {
            to._i = from._i;
        }
        if (!isUndefined(from._f)) {
            to._f = from._f;
        }
        if (!isUndefined(from._l)) {
            to._l = from._l;
        }
        if (!isUndefined(from._strict)) {
            to._strict = from._strict;
        }
        if (!isUndefined(from._tzm)) {
            to._tzm = from._tzm;
        }
        if (!isUndefined(from._isUTC)) {
            to._isUTC = from._isUTC;
        }
        if (!isUndefined(from._offset)) {
            to._offset = from._offset;
        }
        if (!isUndefined(from._pf)) {
            to._pf = getParsingFlags(from);
        }
        if (!isUndefined(from._locale)) {
            to._locale = from._locale;
        }

        if (momentProperties.length > 0) {
            for (i = 0; i < momentProperties.length; i++) {
                prop = momentProperties[i];
                val = from[prop];
                if (!isUndefined(val)) {
                    to[prop] = val;
                }
            }
        }

        return to;
    }

    var updateInProgress = false;

    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) {
            this._d = new Date(NaN);
        }
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }

    function isMoment (obj) {
        return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
    }

    function absFloor (number) {
        if (number < 0) {
            // -0 -> 0
            return Math.ceil(number) || 0;
        } else {
            return Math.floor(number);
        }
    }

    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion,
            value = 0;

        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
            value = absFloor(coercedNumber);
        }

        return value;
    }

    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length),
            lengthDiff = Math.abs(array1.length - array2.length),
            diffs = 0,
            i;
        for (i = 0; i < len; i++) {
            if ((dontConvert && array1[i] !== array2[i]) ||
                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
                diffs++;
            }
        }
        return diffs + lengthDiff;
    }

    function warn(msg) {
        if (hooks.suppressDeprecationWarnings === false &&
                (typeof console !==  'undefined') && console.warn) {
            console.warn('Deprecation warning: ' + msg);
        }
    }

    function deprecate(msg, fn) {
        var firstTime = true;

        return extend(function () {
            if (hooks.deprecationHandler != null) {
                hooks.deprecationHandler(null, msg);
            }
            if (firstTime) {
                var args = [];
                var arg;
                for (var i = 0; i < arguments.length; i++) {
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for (var key in arguments[0]) {
                            arg += key + ': ' + arguments[0][key] + ', ';
                        }
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else {
                        arg = arguments[i];
                    }
                    args.push(arg);
                }
                warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + (new Error()).stack);
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }

    var deprecations = {};

    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(name, msg);
        }
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }

    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;

    function isFunction(input) {
        return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
    }

    function set (config) {
        var prop, i;
        for (i in config) {
            prop = config[i];
            if (isFunction(prop)) {
                this[i] = prop;
            } else {
                this['_' + i] = prop;
            }
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp(
            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
                '|' + (/\d{1,2}/).source);
    }

    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig), prop;
        for (prop in childConfig) {
            if (hasOwnProp(childConfig, prop)) {
                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                    res[prop] = {};
                    extend(res[prop], parentConfig[prop]);
                    extend(res[prop], childConfig[prop]);
                } else if (childConfig[prop] != null) {
                    res[prop] = childConfig[prop];
                } else {
                    delete res[prop];
                }
            }
        }
        for (prop in parentConfig) {
            if (hasOwnProp(parentConfig, prop) &&
                    !hasOwnProp(childConfig, prop) &&
                    isObject(parentConfig[prop])) {
                // make sure changes to properties don't modify parent config
                res[prop] = extend({}, res[prop]);
            }
        }
        return res;
    }

    function Locale(config) {
        if (config != null) {
            this.set(config);
        }
    }

    var keys;

    if (Object.keys) {
        keys = Object.keys;
    } else {
        keys = function (obj) {
            var i, res = [];
            for (i in obj) {
                if (hasOwnProp(obj, i)) {
                    res.push(i);
                }
            }
            return res;
        };
    }

    var defaultCalendar = {
        sameDay : '[Today at] LT',
        nextDay : '[Tomorrow at] LT',
        nextWeek : 'dddd [at] LT',
        lastDay : '[Yesterday at] LT',
        lastWeek : '[Last] dddd [at] LT',
        sameElse : 'L'
    };

    function calendar (key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }

    var defaultLongDateFormat = {
        LTS  : 'h:mm:ss A',
        LT   : 'h:mm A',
        L    : 'MM/DD/YYYY',
        LL   : 'MMMM D, YYYY',
        LLL  : 'MMMM D, YYYY h:mm A',
        LLLL : 'dddd, MMMM D, YYYY h:mm A'
    };

    function longDateFormat (key) {
        var format = this._longDateFormat[key],
            formatUpper = this._longDateFormat[key.toUpperCase()];

        if (format || !formatUpper) {
            return format;
        }

        this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
            return val.slice(1);
        });

        return this._longDateFormat[key];
    }

    var defaultInvalidDate = 'Invalid date';

    function invalidDate () {
        return this._invalidDate;
    }

    var defaultOrdinal = '%d';
    var defaultDayOfMonthOrdinalParse = /\d{1,2}/;

    function ordinal (number) {
        return this._ordinal.replace('%d', number);
    }

    var defaultRelativeTime = {
        future : 'in %s',
        past   : '%s ago',
        s  : 'a few seconds',
        ss : '%d seconds',
        m  : 'a minute',
        mm : '%d minutes',
        h  : 'an hour',
        hh : '%d hours',
        d  : 'a day',
        dd : '%d days',
        M  : 'a month',
        MM : '%d months',
        y  : 'a year',
        yy : '%d years'
    };

    function relativeTime (number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return (isFunction(output)) ?
            output(number, withoutSuffix, string, isFuture) :
            output.replace(/%d/i, number);
    }

    function pastFuture (diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }

    var aliases = {};

    function addUnitAlias (unit, shorthand) {
        var lowerCase = unit.toLowerCase();
        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
    }

    function normalizeUnits(units) {
        return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
    }

    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {},
            normalizedProp,
            prop;

        for (prop in inputObject) {
            if (hasOwnProp(inputObject, prop)) {
                normalizedProp = normalizeUnits(prop);
                if (normalizedProp) {
                    normalizedInput[normalizedProp] = inputObject[prop];
                }
            }
        }

        return normalizedInput;
    }

    var priorities = {};

    function addUnitPriority(unit, priority) {
        priorities[unit] = priority;
    }

    function getPrioritizedUnits(unitsObj) {
        var units = [];
        for (var u in unitsObj) {
            units.push({unit: u, priority: priorities[u]});
        }
        units.sort(function (a, b) {
            return a.priority - b.priority;
        });
        return units;
    }

    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number),
            zerosToFill = targetLength - absNumber.length,
            sign = number >= 0;
        return (sign ? (forceSign ? '+' : '') : '-') +
            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }

    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;

    var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;

    var formatFunctions = {};

    var formatTokenFunctions = {};

    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken (token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') {
            func = function () {
                return this[callback]();
            };
        }
        if (token) {
            formatTokenFunctions[token] = func;
        }
        if (padded) {
            formatTokenFunctions[padded[0]] = function () {
                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
            };
        }
        if (ordinal) {
            formatTokenFunctions[ordinal] = function () {
                return this.localeData().ordinal(func.apply(this, arguments), token);
            };
        }
    }

    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) {
            return input.replace(/^\[|\]$/g, '');
        }
        return input.replace(/\\/g, '');
    }

    function makeFormatFunction(format) {
        var array = format.match(formattingTokens), i, length;

        for (i = 0, length = array.length; i < length; i++) {
            if (formatTokenFunctions[array[i]]) {
                array[i] = formatTokenFunctions[array[i]];
            } else {
                array[i] = removeFormattingTokens(array[i]);
            }
        }

        return function (mom) {
            var output = '', i;
            for (i = 0; i < length; i++) {
                output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
            }
            return output;
        };
    }

    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) {
            return m.localeData().invalidDate();
        }

        format = expandFormat(format, m.localeData());
        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);

        return formatFunctions[format](m);
    }

    function expandFormat(format, locale) {
        var i = 5;

        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }

        localFormattingTokens.lastIndex = 0;
        while (i >= 0 && localFormattingTokens.test(format)) {
            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }

        return format;
    }

    var match1         = /\d/;            //       0 - 9
    var match2         = /\d\d/;          //      00 - 99
    var match3         = /\d{3}/;         //     000 - 999
    var match4         = /\d{4}/;         //    0000 - 9999
    var match6         = /[+-]?\d{6}/;    // -999999 - 999999
    var match1to2      = /\d\d?/;         //       0 - 99
    var match3to4      = /\d\d\d\d?/;     //     999 - 9999
    var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
    var match1to3      = /\d{1,3}/;       //       0 - 999
    var match1to4      = /\d{1,4}/;       //       0 - 9999
    var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999

    var matchUnsigned  = /\d+/;           //       0 - inf
    var matchSigned    = /[+-]?\d+/;      //    -inf - inf

    var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
    var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z

    var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123

    // any word (or two) characters or numbers including two/three word month in arabic.
    // includes scottish gaelic two word and hyphenated months
    var matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i;

    var regexes = {};

    function addRegexToken (token, regex, strictRegex) {
        regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
            return (isStrict && strictRegex) ? strictRegex : regex;
        };
    }

    function getParseRegexForToken (token, config) {
        if (!hasOwnProp(regexes, token)) {
            return new RegExp(unescapeFormat(token));
        }

        return regexes[token](config._strict, config._locale);
    }

    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
            return p1 || p2 || p3 || p4;
        }));
    }

    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }

    var tokens = {};

    function addParseToken (token, callback) {
        var i, func = callback;
        if (typeof token === 'string') {
            token = [token];
        }
        if (isNumber(callback)) {
            func = function (input, array) {
                array[callback] = toInt(input);
            };
        }
        for (i = 0; i < token.length; i++) {
            tokens[token[i]] = func;
        }
    }

    function addWeekParseToken (token, callback) {
        addParseToken(token, function (input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }

    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) {
            tokens[token](input, config._a, config, token);
        }
    }

    var YEAR = 0;
    var MONTH = 1;
    var DATE = 2;
    var HOUR = 3;
    var MINUTE = 4;
    var SECOND = 5;
    var MILLISECOND = 6;
    var WEEK = 7;
    var WEEKDAY = 8;

    // FORMATTING

    addFormatToken('Y', 0, 0, function () {
        var y = this.year();
        return y <= 9999 ? '' + y : '+' + y;
    });

    addFormatToken(0, ['YY', 2], 0, function () {
        return this.year() % 100;
    });

    addFormatToken(0, ['YYYY',   4],       0, 'year');
    addFormatToken(0, ['YYYYY',  5],       0, 'year');
    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

    // ALIASES

    addUnitAlias('year', 'y');

    // PRIORITIES

    addUnitPriority('year', 1);

    // PARSING

    addRegexToken('Y',      matchSigned);
    addRegexToken('YY',     match1to2, match2);
    addRegexToken('YYYY',   match1to4, match4);
    addRegexToken('YYYYY',  match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);

    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
    addParseToken('YYYY', function (input, array) {
        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function (input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function (input, array) {
        array[YEAR] = parseInt(input, 10);
    });

    // HELPERS

    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }

    function isLeapYear(year) {
        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    }

    // HOOKS

    hooks.parseTwoDigitYear = function (input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };

    // MOMENTS

    var getSetYear = makeGetSet('FullYear', true);

    function getIsLeapYear () {
        return isLeapYear(this.year());
    }

    function makeGetSet (unit, keepTime) {
        return function (value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else {
                return get(this, unit);
            }
        };
    }

    function get (mom, unit) {
        return mom.isValid() ?
            mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
    }

    function set$1 (mom, unit, value) {
        if (mom.isValid() && !isNaN(value)) {
            if (unit === 'FullYear' && isLeapYear(mom.year()) && mom.month() === 1 && mom.date() === 29) {
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value, mom.month(), daysInMonth(value, mom.month()));
            }
            else {
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
            }
        }
    }

    // MOMENTS

    function stringGet (units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units]();
        }
        return this;
    }


    function stringSet (units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units);
            for (var i = 0; i < prioritized.length; i++) {
                this[prioritized[i].unit](units[prioritized[i].unit]);
            }
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) {
                return this[units](value);
            }
        }
        return this;
    }

    function mod(n, x) {
        return ((n % x) + x) % x;
    }

    var indexOf;

    if (Array.prototype.indexOf) {
        indexOf = Array.prototype.indexOf;
    } else {
        indexOf = function (o) {
            // I know
            var i;
            for (i = 0; i < this.length; ++i) {
                if (this[i] === o) {
                    return i;
                }
            }
            return -1;
        };
    }

    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) {
            return NaN;
        }
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1 ? (isLeapYear(year) ? 29 : 28) : (31 - modMonth % 7 % 2);
    }

    // FORMATTING

    addFormatToken('M', ['MM', 2], 'Mo', function () {
        return this.month() + 1;
    });

    addFormatToken('MMM', 0, 0, function (format) {
        return this.localeData().monthsShort(this, format);
    });

    addFormatToken('MMMM', 0, 0, function (format) {
        return this.localeData().months(this, format);
    });

    // ALIASES

    addUnitAlias('month', 'M');

    // PRIORITY

    addUnitPriority('month', 8);

    // PARSING

    addRegexToken('M',    match1to2);
    addRegexToken('MM',   match1to2, match2);
    addRegexToken('MMM',  function (isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function (isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });

    addParseToken(['M', 'MM'], function (input, array) {
        array[MONTH] = toInt(input) - 1;
    });

    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) {
            array[MONTH] = month;
        } else {
            getParsingFlags(config).invalidMonth = input;
        }
    });

    // LOCALES

    var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
    function localeMonths (m, format) {
        if (!m) {
            return isArray(this._months) ? this._months :
                this._months['standalone'];
        }
        return isArray(this._months) ? this._months[m.month()] :
            this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
    }

    var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
    function localeMonthsShort (m, format) {
        if (!m) {
            return isArray(this._monthsShort) ? this._monthsShort :
                this._monthsShort['standalone'];
        }
        return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
            this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
    }

    function handleStrictParse(monthName, format, strict) {
        var i, ii, mom, llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for (i = 0; i < 12; ++i) {
                mom = createUTC([2000, i]);
                this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeMonthsParse (monthName, format, strict) {
        var i, mom, regex;

        if (this._monthsParseExact) {
            return handleStrictParse.call(this, monthName, format, strict);
        }

        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }

        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
                this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
            }
            if (!strict && !this._monthsParse[i]) {
                regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
                return i;
            } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
                return i;
            } else if (!strict && this._monthsParse[i].test(monthName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function setMonth (mom, value) {
        var dayOfMonth;

        if (!mom.isValid()) {
            // No op
            return mom;
        }

        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) {
                value = toInt(value);
            } else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) {
                    return mom;
                }
            }
        }

        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
        return mom;
    }

    function getSetMonth (value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else {
            return get(this, 'Month');
        }
    }

    function getDaysInMonth () {
        return daysInMonth(this.year(), this.month());
    }

    var defaultMonthsShortRegex = matchWord;
    function monthsShortRegex (isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsShortStrictRegex;
            } else {
                return this._monthsShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) {
                this._monthsShortRegex = defaultMonthsShortRegex;
            }
            return this._monthsShortStrictRegex && isStrict ?
                this._monthsShortStrictRegex : this._monthsShortRegex;
        }
    }

    var defaultMonthsRegex = matchWord;
    function monthsRegex (isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsStrictRegex;
            } else {
                return this._monthsRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) {
                this._monthsRegex = defaultMonthsRegex;
            }
            return this._monthsStrictRegex && isStrict ?
                this._monthsStrictRegex : this._monthsRegex;
        }
    }

    function computeMonthsParse () {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var shortPieces = [], longPieces = [], mixedPieces = [],
            i, mom;
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            shortPieces.push(this.monthsShort(mom, ''));
            longPieces.push(this.months(mom, ''));
            mixedPieces.push(this.months(mom, ''));
            mixedPieces.push(this.monthsShort(mom, ''));
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 12; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
        }
        for (i = 0; i < 24; i++) {
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
    }

    function createDate (y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) {
                date.setFullYear(y);
            }
        } else {
            date = new Date(y, m, d, h, M, s, ms);
        }

        return date;
    }

    function createUTCDate (y) {
        var date;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            var args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) {
                date.setUTCFullYear(y);
            }
        } else {
            date = new Date(Date.UTC.apply(null, arguments));
        }

        return date;
    }

    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
            fwd = 7 + dow - doy,
            // first-week day local weekday -- which local weekday is fwd
            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

        return -fwdlw + fwd - 1;
    }

    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7,
            weekOffset = firstWeekOffset(year, dow, doy),
            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
            resYear, resDayOfYear;

        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }

        return {
            year: resYear,
            dayOfYear: resDayOfYear
        };
    }

    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
            resWeek, resYear;

        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }

        return {
            week: resWeek,
            year: resYear
        };
    }

    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy),
            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }

    // FORMATTING

    addFormatToken('w', ['ww', 2], 'wo', 'week');
    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

    // ALIASES

    addUnitAlias('week', 'w');
    addUnitAlias('isoWeek', 'W');

    // PRIORITIES

    addUnitPriority('week', 5);
    addUnitPriority('isoWeek', 5);

    // PARSING

    addRegexToken('w',  match1to2);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W',  match1to2);
    addRegexToken('WW', match1to2, match2);

    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
        week[token.substr(0, 1)] = toInt(input);
    });

    // HELPERS

    // LOCALES

    function localeWeek (mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }

    var defaultLocaleWeek = {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 6th is the first week of the year.
    };

    function localeFirstDayOfWeek () {
        return this._week.dow;
    }

    function localeFirstDayOfYear () {
        return this._week.doy;
    }

    // MOMENTS

    function getSetWeek (input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    function getSetISOWeek (input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    // FORMATTING

    addFormatToken('d', 0, 'do', 'day');

    addFormatToken('dd', 0, 0, function (format) {
        return this.localeData().weekdaysMin(this, format);
    });

    addFormatToken('ddd', 0, 0, function (format) {
        return this.localeData().weekdaysShort(this, format);
    });

    addFormatToken('dddd', 0, 0, function (format) {
        return this.localeData().weekdays(this, format);
    });

    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');

    // ALIASES

    addUnitAlias('day', 'd');
    addUnitAlias('weekday', 'e');
    addUnitAlias('isoWeekday', 'E');

    // PRIORITY
    addUnitPriority('day', 11);
    addUnitPriority('weekday', 11);
    addUnitPriority('isoWeekday', 11);

    // PARSING

    addRegexToken('d',    match1to2);
    addRegexToken('e',    match1to2);
    addRegexToken('E',    match1to2);
    addRegexToken('dd',   function (isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd',   function (isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd',   function (isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });

    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) {
            week.d = weekday;
        } else {
            getParsingFlags(config).invalidWeekday = input;
        }
    });

    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
        week[token] = toInt(input);
    });

    // HELPERS

    function parseWeekday(input, locale) {
        if (typeof input !== 'string') {
            return input;
        }

        if (!isNaN(input)) {
            return parseInt(input, 10);
        }

        input = locale.weekdaysParse(input);
        if (typeof input === 'number') {
            return input;
        }

        return null;
    }

    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') {
            return locale.weekdaysParse(input) % 7 || 7;
        }
        return isNaN(input) ? null : input;
    }

    // LOCALES
    function shiftWeekdays (ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }

    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
    function localeWeekdays (m, format) {
        var weekdays = isArray(this._weekdays) ? this._weekdays :
            this._weekdays[(m && m !== true && this._weekdays.isFormat.test(format)) ? 'format' : 'standalone'];
        return (m === true) ? shiftWeekdays(weekdays, this._week.dow)
            : (m) ? weekdays[m.day()] : weekdays;
    }

    var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
    function localeWeekdaysShort (m) {
        return (m === true) ? shiftWeekdays(this._weekdaysShort, this._week.dow)
            : (m) ? this._weekdaysShort[m.day()] : this._weekdaysShort;
    }

    var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
    function localeWeekdaysMin (m) {
        return (m === true) ? shiftWeekdays(this._weekdaysMin, this._week.dow)
            : (m) ? this._weekdaysMin[m.day()] : this._weekdaysMin;
    }

    function handleStrictParse$1(weekdayName, format, strict) {
        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];

            for (i = 0; i < 7; ++i) {
                mom = createUTC([2000, 1]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeWeekdaysParse (weekdayName, format, strict) {
        var i, mom, regex;

        if (this._weekdaysParseExact) {
            return handleStrictParse$1.call(this, weekdayName, format, strict);
        }

        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }

        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already

            mom = createUTC([2000, 1]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\\.?') + '$', 'i');
                this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$', 'i');
                this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$', 'i');
            }
            if (!this._weekdaysParse[i]) {
                regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function getSetDayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else {
            return day;
        }
    }

    function getSetLocaleDayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }

    function getSetISODayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }

        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.

        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else {
            return this.day() || 7;
        }
    }

    var defaultWeekdaysRegex = matchWord;
    function weekdaysRegex (isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysStrictRegex;
            } else {
                return this._weekdaysRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                this._weekdaysRegex = defaultWeekdaysRegex;
            }
            return this._weekdaysStrictRegex && isStrict ?
                this._weekdaysStrictRegex : this._weekdaysRegex;
        }
    }

    var defaultWeekdaysShortRegex = matchWord;
    function weekdaysShortRegex (isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysShortStrictRegex;
            } else {
                return this._weekdaysShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            }
            return this._weekdaysShortStrictRegex && isStrict ?
                this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
        }
    }

    var defaultWeekdaysMinRegex = matchWord;
    function weekdaysMinRegex (isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysMinStrictRegex;
            } else {
                return this._weekdaysMinRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            }
            return this._weekdaysMinStrictRegex && isStrict ?
                this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
        }
    }


    function computeWeekdaysParse () {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
            i, mom, minp, shortp, longp;
        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, 1]).day(i);
            minp = this.weekdaysMin(mom, '');
            shortp = this.weekdaysShort(mom, '');
            longp = this.weekdays(mom, '');
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 7; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;

        this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
        this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
    }

    // FORMATTING

    function hFormat() {
        return this.hours() % 12 || 12;
    }

    function kFormat() {
        return this.hours() || 24;
    }

    addFormatToken('H', ['HH', 2], 0, 'hour');
    addFormatToken('h', ['hh', 2], 0, hFormat);
    addFormatToken('k', ['kk', 2], 0, kFormat);

    addFormatToken('hmm', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });

    addFormatToken('hmmss', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2);
    });

    addFormatToken('Hmm', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });

    addFormatToken('Hmmss', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2);
    });

    function meridiem (token, lowercase) {
        addFormatToken(token, 0, 0, function () {
            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
        });
    }

    meridiem('a', true);
    meridiem('A', false);

    // ALIASES

    addUnitAlias('hour', 'h');

    // PRIORITY
    addUnitPriority('hour', 13);

    // PARSING

    function matchMeridiem (isStrict, locale) {
        return locale._meridiemParse;
    }

    addRegexToken('a',  matchMeridiem);
    addRegexToken('A',  matchMeridiem);
    addRegexToken('H',  match1to2);
    addRegexToken('h',  match1to2);
    addRegexToken('k',  match1to2);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);

    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);

    addParseToken(['H', 'HH'], HOUR);
    addParseToken(['k', 'kk'], function (input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken(['a', 'A'], function (input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken(['h', 'hh'], function (input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function (input, array, config) {
        var pos1 = input.length - 4;
        var pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function (input, array, config) {
        var pos1 = input.length - 4;
        var pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });

    // LOCALES

    function localeIsPM (input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return ((input + '').toLowerCase().charAt(0) === 'p');
    }

    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
    function localeMeridiem (hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'pm' : 'PM';
        } else {
            return isLower ? 'am' : 'AM';
        }
    }


    // MOMENTS

    // Setting the hour should keep the time, because the user explicitly
    // specified which hour they want. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.
    var getSetHour = makeGetSet('Hours', true);

    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,

        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,

        week: defaultLocaleWeek,

        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,

        meridiemParse: defaultLocaleMeridiemParse
    };

    // internal storage for locale config files
    var locales = {};
    var localeFamilies = {};
    var globalLocale;

    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }

    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0, j, next, locale, split;

        while (i < names.length) {
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while (j > 0) {
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) {
                    return locale;
                }
                if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
                    //the next array item is better than a shallower substring of this one
                    break;
                }
                j--;
            }
            i++;
        }
        return globalLocale;
    }

    function loadLocale(name) {
        var oldLocale = null;
        // TODO: Find a better way to register and load all the locales in Node
        if (!locales[name] && (typeof module !== 'undefined') &&
                module && module.exports) {
            try {
                oldLocale = globalLocale._abbr;
                var aliasedRequire = require;
                !(function webpackMissingModule() { var e = new Error("Cannot find module \"./locale\""); e.code = 'MODULE_NOT_FOUND'; throw e; }());
                getSetGlobalLocale(oldLocale);
            } catch (e) {}
        }
        return locales[name];
    }

    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale (key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) {
                data = getLocale(key);
            }
            else {
                data = defineLocale(key, values);
            }

            if (data) {
                // moment.duration._locale = moment._locale = data;
                globalLocale = data;
            }
            else {
                if ((typeof console !==  'undefined') && console.warn) {
                    //warn user if arguments are passed but the locale could not be set
                    console.warn('Locale ' + key +  ' not found. Did you forget to load it?');
                }
            }
        }

        return globalLocale._abbr;
    }

    function defineLocale (name, config) {
        if (config !== null) {
            var locale, parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple('defineLocaleOverride',
                        'use moment.updateLocale(localeName, config) to change ' +
                        'an existing locale. moment.defineLocale(localeName, ' +
                        'config) should only be used for creating a new locale ' +
                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) {
                    parentConfig = locales[config.parentLocale]._config;
                } else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) {
                        parentConfig = locale._config;
                    } else {
                        if (!localeFamilies[config.parentLocale]) {
                            localeFamilies[config.parentLocale] = [];
                        }
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));

            if (localeFamilies[name]) {
                localeFamilies[name].forEach(function (x) {
                    defineLocale(x.name, x.config);
                });
            }

            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);


            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }

    function updateLocale(name, config) {
        if (config != null) {
            var locale, tmpLocale, parentConfig = baseConfig;
            // MERGE
            tmpLocale = loadLocale(name);
            if (tmpLocale != null) {
                parentConfig = tmpLocale._config;
            }
            config = mergeConfigs(parentConfig, config);
            locale = new Locale(config);
            locale.parentLocale = locales[name];
            locales[name] = locale;

            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else {
            // pass null for config to unupdate, useful for tests
            if (locales[name] != null) {
                if (locales[name].parentLocale != null) {
                    locales[name] = locales[name].parentLocale;
                } else if (locales[name] != null) {
                    delete locales[name];
                }
            }
        }
        return locales[name];
    }

    // returns locale data
    function getLocale (key) {
        var locale;

        if (key && key._locale && key._locale._abbr) {
            key = key._locale._abbr;
        }

        if (!key) {
            return globalLocale;
        }

        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) {
                return locale;
            }
            key = [key];
        }

        return chooseLocale(key);
    }

    function listLocales() {
        return keys(locales);
    }

    function checkOverflow (m) {
        var overflow;
        var a = m._a;

        if (a && getParsingFlags(m).overflow === -2) {
            overflow =
                a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
                a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
                a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
                a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
                a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
                a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
                -1;

            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
                overflow = DATE;
            }
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
                overflow = WEEK;
            }
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
                overflow = WEEKDAY;
            }

            getParsingFlags(m).overflow = overflow;
        }

        return m;
    }

    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) {
            return a;
        }
        if (b != null) {
            return b;
        }
        return c;
    }

    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) {
            return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
        }
        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
    }

    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray (config) {
        var i, date, input = [], currentDate, expectedWeekday, yearToUse;

        if (config._d) {
            return;
        }

        currentDate = currentDateArray(config);

        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
            dayOfYearFromWeekInfo(config);
        }

        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
                getParsingFlags(config)._overflowDayOfYear = true;
            }

            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }

        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for (i = 0; i < 3 && config._a[i] == null; ++i) {
            config._a[i] = input[i] = currentDate[i];
        }

        // Zero out whatever was not defaulted, including time
        for (; i < 7; i++) {
            config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
        }

        // Check for 24:00:00.000
        if (config._a[HOUR] === 24 &&
                config._a[MINUTE] === 0 &&
                config._a[SECOND] === 0 &&
                config._a[MILLISECOND] === 0) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }

        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();

        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) {
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        }

        if (config._nextDay) {
            config._a[HOUR] = 24;
        }

        // check for mismatching day of week
        if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== expectedWeekday) {
            getParsingFlags(config).weekdayMismatch = true;
        }
    }

    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;

        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;

            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) {
                weekdayOverflow = true;
            }
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;

            var curWeek = weekOfYear(createLocal(), dow, doy);

            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

            // Default to current week.
            week = defaults(w.w, curWeek.week);

            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) {
                    weekdayOverflow = true;
                }
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) {
                    weekdayOverflow = true;
                }
            } else {
                // default to beginning of week
                weekday = dow;
            }
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
            getParsingFlags(config)._overflowWeeks = true;
        } else if (weekdayOverflow != null) {
            getParsingFlags(config)._overflowWeekday = true;
        } else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }

    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
    var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;

    var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;

    var isoDates = [
        ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
        ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
        ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
        ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
        ['YYYY-DDD', /\d{4}-\d{3}/],
        ['YYYY-MM', /\d{4}-\d\d/, false],
        ['YYYYYYMMDD', /[+-]\d{10}/],
        ['YYYYMMDD', /\d{8}/],
        // YYYYMM is NOT allowed by the standard
        ['GGGG[W]WWE', /\d{4}W\d{3}/],
        ['GGGG[W]WW', /\d{4}W\d{2}/, false],
        ['YYYYDDD', /\d{7}/]
    ];

    // iso time formats and regexes
    var isoTimes = [
        ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
        ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
        ['HH:mm:ss', /\d\d:\d\d:\d\d/],
        ['HH:mm', /\d\d:\d\d/],
        ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
        ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
        ['HHmmss', /\d\d\d\d\d\d/],
        ['HHmm', /\d\d\d\d/],
        ['HH', /\d\d/]
    ];

    var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;

    // date from iso format
    function configFromISO(config) {
        var i, l,
            string = config._i,
            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
            allowTime, dateFormat, timeFormat, tzFormat;

        if (match) {
            getParsingFlags(config).iso = true;

            for (i = 0, l = isoDates.length; i < l; i++) {
                if (isoDates[i][1].exec(match[1])) {
                    dateFormat = isoDates[i][0];
                    allowTime = isoDates[i][2] !== false;
                    break;
                }
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for (i = 0, l = isoTimes.length; i < l; i++) {
                    if (isoTimes[i][1].exec(match[3])) {
                        // match[2] should be 'T' or space
                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
                        break;
                    }
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) {
                    tzFormat = 'Z';
                } else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else {
            config._isValid = false;
        }
    }

    // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
    var rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/;

    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10)
        ];

        if (secondStr) {
            result.push(parseInt(secondStr, 10));
        }

        return result;
    }

    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) {
            return 2000 + year;
        } else if (year <= 999) {
            return 1900 + year;
        }
        return year;
    }

    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s.replace(/\([^)]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').replace(/^\s\s*/, '').replace(/\s\s*$/, '');
    }

    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an indepentent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
                weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }

    var obsOffsets = {
        UT: 0,
        GMT: 0,
        EDT: -4 * 60,
        EST: -5 * 60,
        CDT: -5 * 60,
        CST: -6 * 60,
        MDT: -6 * 60,
        MST: -7 * 60,
        PDT: -7 * 60,
        PST: -8 * 60
    };

    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) {
            return obsOffsets[obsOffset];
        } else if (militaryOffset) {
            // the only allowed military tz is Z
            return 0;
        } else {
            var hm = parseInt(numOffset, 10);
            var m = hm % 100, h = (hm - m) / 100;
            return h * 60 + m;
        }
    }

    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i));
        if (match) {
            var parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
            if (!checkWeekday(match[1], parsedArray, config)) {
                return;
            }

            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);

            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

            getParsingFlags(config).rfc2822 = true;
        } else {
            config._isValid = false;
        }
    }

    // date from iso format or fallback
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);

        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }

        configFromISO(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        configFromRFC2822(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        // Final attempt, use Input Fallback
        hooks.createFromInputFallback(config);
    }

    hooks.createFromInputFallback = deprecate(
        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
        'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
        'discouraged and will be removed in an upcoming major release. Please refer to ' +
        'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
        function (config) {
            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
        }
    );

    // constant that refers to the ISO standard
    hooks.ISO_8601 = function () {};

    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function () {};

    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;

        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i,
            i, parsedInput, tokens, token, skipped,
            stringLength = string.length,
            totalParsedInputLength = 0;

        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];

        for (i = 0; i < tokens.length; i++) {
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
            // console.log('token', token, 'parsedInput', parsedInput,
            //         'regex', getParseRegexForToken(token, config));
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) {
                    getParsingFlags(config).unusedInput.push(skipped);
                }
                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) {
                    getParsingFlags(config).empty = false;
                }
                else {
                    getParsingFlags(config).unusedTokens.push(token);
                }
                addTimeToArrayFromToken(token, parsedInput, config);
            }
            else if (config._strict && !parsedInput) {
                getParsingFlags(config).unusedTokens.push(token);
            }
        }

        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
        if (string.length > 0) {
            getParsingFlags(config).unusedInput.push(string);
        }

        // clear _12h flag if hour is <= 12
        if (config._a[HOUR] <= 12 &&
            getParsingFlags(config).bigHour === true &&
            config._a[HOUR] > 0) {
            getParsingFlags(config).bigHour = undefined;
        }

        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);

        configFromArray(config);
        checkOverflow(config);
    }


    function meridiemFixWrap (locale, hour, meridiem) {
        var isPm;

        if (meridiem == null) {
            // nothing to do
            return hour;
        }
        if (locale.meridiemHour != null) {
            return locale.meridiemHour(hour, meridiem);
        } else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) {
                hour += 12;
            }
            if (!isPm && hour === 12) {
                hour = 0;
            }
            return hour;
        } else {
            // this is not supposed to happen
            return hour;
        }
    }

    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig,
            bestMoment,

            scoreToBeat,
            i,
            currentScore;

        if (config._f.length === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }

        for (i = 0; i < config._f.length; i++) {
            currentScore = 0;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) {
                tempConfig._useUTC = config._useUTC;
            }
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);

            if (!isValid(tempConfig)) {
                continue;
            }

            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;

            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

            getParsingFlags(tempConfig).score = currentScore;

            if (scoreToBeat == null || currentScore < scoreToBeat) {
                scoreToBeat = currentScore;
                bestMoment = tempConfig;
            }
        }

        extend(config, bestMoment || tempConfig);
    }

    function configFromObject(config) {
        if (config._d) {
            return;
        }

        var i = normalizeObjectUnits(config._i);
        config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
            return obj && parseInt(obj, 10);
        });

        configFromArray(config);
    }

    function createFromConfig (config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }

        return res;
    }

    function prepareConfig (config) {
        var input = config._i,
            format = config._f;

        config._locale = config._locale || getLocale(config._l);

        if (input === null || (format === undefined && input === '')) {
            return createInvalid({nullInput: true});
        }

        if (typeof input === 'string') {
            config._i = input = config._locale.preparse(input);
        }

        if (isMoment(input)) {
            return new Moment(checkOverflow(input));
        } else if (isDate(input)) {
            config._d = input;
        } else if (isArray(format)) {
            configFromStringAndArray(config);
        } else if (format) {
            configFromStringAndFormat(config);
        }  else {
            configFromInput(config);
        }

        if (!isValid(config)) {
            config._d = null;
        }

        return config;
    }

    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) {
            config._d = new Date(hooks.now());
        } else if (isDate(input)) {
            config._d = new Date(input.valueOf());
        } else if (typeof input === 'string') {
            configFromString(config);
        } else if (isArray(input)) {
            config._a = map(input.slice(0), function (obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) {
            configFromObject(config);
        } else if (isNumber(input)) {
            // from milliseconds
            config._d = new Date(input);
        } else {
            hooks.createFromInputFallback(config);
        }
    }

    function createLocalOrUTC (input, format, locale, strict, isUTC) {
        var c = {};

        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }

        if ((isObject(input) && isObjectEmpty(input)) ||
                (isArray(input) && input.length === 0)) {
            input = undefined;
        }
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;

        return createFromConfig(c);
    }

    function createLocal (input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }

    var prototypeMin = deprecate(
        'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
        function () {
            var other = createLocal.apply(null, arguments);
            if (this.isValid() && other.isValid()) {
                return other < this ? this : other;
            } else {
                return createInvalid();
            }
        }
    );

    var prototypeMax = deprecate(
        'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
        function () {
            var other = createLocal.apply(null, arguments);
            if (this.isValid() && other.isValid()) {
                return other > this ? this : other;
            } else {
                return createInvalid();
            }
        }
    );

    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) {
            moments = moments[0];
        }
        if (!moments.length) {
            return createLocal();
        }
        res = moments[0];
        for (i = 1; i < moments.length; ++i) {
            if (!moments[i].isValid() || moments[i][fn](res)) {
                res = moments[i];
            }
        }
        return res;
    }

    // TODO: Use [].sort instead?
    function min () {
        var args = [].slice.call(arguments, 0);

        return pickBy('isBefore', args);
    }

    function max () {
        var args = [].slice.call(arguments, 0);

        return pickBy('isAfter', args);
    }

    var now = function () {
        return Date.now ? Date.now() : +(new Date());
    };

    var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];

    function isDurationValid(m) {
        for (var key in m) {
            if (!(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
                return false;
            }
        }

        var unitHasDecimal = false;
        for (var i = 0; i < ordering.length; ++i) {
            if (m[ordering[i]]) {
                if (unitHasDecimal) {
                    return false; // only allow non-integers for smallest unit
                }
                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                    unitHasDecimal = true;
                }
            }
        }

        return true;
    }

    function isValid$1() {
        return this._isValid;
    }

    function createInvalid$1() {
        return createDuration(NaN);
    }

    function Duration (duration) {
        var normalizedInput = normalizeObjectUnits(duration),
            years = normalizedInput.year || 0,
            quarters = normalizedInput.quarter || 0,
            months = normalizedInput.month || 0,
            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
            days = normalizedInput.day || 0,
            hours = normalizedInput.hour || 0,
            minutes = normalizedInput.minute || 0,
            seconds = normalizedInput.second || 0,
            milliseconds = normalizedInput.millisecond || 0;

        this._isValid = isDurationValid(normalizedInput);

        // representation for dateAddRemove
        this._milliseconds = +milliseconds +
            seconds * 1e3 + // 1000
            minutes * 6e4 + // 1000 * 60
            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days +
            weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months +
            quarters * 3 +
            years * 12;

        this._data = {};

        this._locale = getLocale();

        this._bubble();
    }

    function isDuration (obj) {
        return obj instanceof Duration;
    }

    function absRound (number) {
        if (number < 0) {
            return Math.round(-1 * number) * -1;
        } else {
            return Math.round(number);
        }
    }

    // FORMATTING

    function offset (token, separator) {
        addFormatToken(token, 0, 0, function () {
            var offset = this.utcOffset();
            var sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
        });
    }

    offset('Z', ':');
    offset('ZZ', '');

    // PARSING

    addRegexToken('Z',  matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken(['Z', 'ZZ'], function (input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });

    // HELPERS

    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;

    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher);

        if (matches === null) {
            return null;
        }

        var chunk   = matches[matches.length - 1] || [];
        var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
        var minutes = +(parts[1] * 60) + toInt(parts[2]);

        return minutes === 0 ?
          0 :
          parts[0] === '+' ? minutes : -minutes;
    }

    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else {
            return createLocal(input).local();
        }
    }

    function getDateOffset (m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
    }

    // HOOKS

    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function () {};

    // MOMENTS

    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset (input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0,
            localAdjust;
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) {
                    return this;
                }
            } else if (Math.abs(input) < 16 && !keepMinutes) {
                input = input * 60;
            }
            if (!this._isUTC && keepLocalTime) {
                localAdjust = getDateOffset(this);
            }
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) {
                this.add(localAdjust, 'm');
            }
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) {
                    addSubtract(this, createDuration(input - offset, 'm'), 1, false);
                } else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else {
            return this._isUTC ? offset : getDateOffset(this);
        }
    }

    function getSetZone (input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') {
                input = -input;
            }

            this.utcOffset(input, keepLocalTime);

            return this;
        } else {
            return -this.utcOffset();
        }
    }

    function setOffsetToUTC (keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }

    function setOffsetToLocal (keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;

            if (keepLocalTime) {
                this.subtract(getDateOffset(this), 'm');
            }
        }
        return this;
    }

    function setOffsetToParsedOffset () {
        if (this._tzm != null) {
            this.utcOffset(this._tzm, false, true);
        } else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) {
                this.utcOffset(tZone);
            }
            else {
                this.utcOffset(0, true);
            }
        }
        return this;
    }

    function hasAlignedHourOffset (input) {
        if (!this.isValid()) {
            return false;
        }
        input = input ? createLocal(input).utcOffset() : 0;

        return (this.utcOffset() - input) % 60 === 0;
    }

    function isDaylightSavingTime () {
        return (
            this.utcOffset() > this.clone().month(0).utcOffset() ||
            this.utcOffset() > this.clone().month(5).utcOffset()
        );
    }

    function isDaylightSavingTimeShifted () {
        if (!isUndefined(this._isDSTShifted)) {
            return this._isDSTShifted;
        }

        var c = {};

        copyConfig(c, this);
        c = prepareConfig(c);

        if (c._a) {
            var other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted = this.isValid() &&
                compareArrays(c._a, other.toArray()) > 0;
        } else {
            this._isDSTShifted = false;
        }

        return this._isDSTShifted;
    }

    function isLocal () {
        return this.isValid() ? !this._isUTC : false;
    }

    function isUtcOffset () {
        return this.isValid() ? this._isUTC : false;
    }

    function isUtc () {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }

    // ASP.NET json date format regex
    var aspNetRegex = /^(\-|\+)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/;

    // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
    // and further modified to allow for strings containing both week and day
    var isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

    function createDuration (input, key) {
        var duration = input,
            // matching against regexp is expensive, do it on demand
            match = null,
            sign,
            ret,
            diffRes;

        if (isDuration(input)) {
            duration = {
                ms : input._milliseconds,
                d  : input._days,
                M  : input._months
            };
        } else if (isNumber(input)) {
            duration = {};
            if (key) {
                duration[key] = input;
            } else {
                duration.milliseconds = input;
            }
        } else if (!!(match = aspNetRegex.exec(input))) {
            sign = (match[1] === '-') ? -1 : 1;
            duration = {
                y  : 0,
                d  : toInt(match[DATE])                         * sign,
                h  : toInt(match[HOUR])                         * sign,
                m  : toInt(match[MINUTE])                       * sign,
                s  : toInt(match[SECOND])                       * sign,
                ms : toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
            };
        } else if (!!(match = isoRegex.exec(input))) {
            sign = (match[1] === '-') ? -1 : 1;
            duration = {
                y : parseIso(match[2], sign),
                M : parseIso(match[3], sign),
                w : parseIso(match[4], sign),
                d : parseIso(match[5], sign),
                h : parseIso(match[6], sign),
                m : parseIso(match[7], sign),
                s : parseIso(match[8], sign)
            };
        } else if (duration == null) {// checks for null or undefined
            duration = {};
        } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));

            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }

        ret = new Duration(duration);

        if (isDuration(input) && hasOwnProp(input, '_locale')) {
            ret._locale = input._locale;
        }

        return ret;
    }

    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;

    function parseIso (inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }

    function positiveMomentsDifference(base, other) {
        var res = {};

        res.months = other.month() - base.month() +
            (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) {
            --res.months;
        }

        res.milliseconds = +other - +(base.clone().add(res.months, 'M'));

        return res;
    }

    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) {
            return {milliseconds: 0, months: 0};
        }

        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) {
            res = positiveMomentsDifference(base, other);
        } else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }

        return res;
    }

    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function (val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' +
                'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
                tmp = val; val = period; period = tmp;
            }

            val = typeof val === 'string' ? +val : val;
            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }

    function addSubtract (mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds,
            days = absRound(duration._days),
            months = absRound(duration._months);

        if (!mom.isValid()) {
            // No op
            return;
        }

        updateOffset = updateOffset == null ? true : updateOffset;

        if (months) {
            setMonth(mom, get(mom, 'Month') + months * isAdding);
        }
        if (days) {
            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        }
        if (milliseconds) {
            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        }
        if (updateOffset) {
            hooks.updateOffset(mom, days || months);
        }
    }

    var add      = createAdder(1, 'add');
    var subtract = createAdder(-1, 'subtract');

    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6 ? 'sameElse' :
                diff < -1 ? 'lastWeek' :
                diff < 0 ? 'lastDay' :
                diff < 1 ? 'sameDay' :
                diff < 2 ? 'nextDay' :
                diff < 7 ? 'nextWeek' : 'sameElse';
    }

    function calendar$1 (time, formats) {
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(),
            sod = cloneWithOffset(now, this).startOf('day'),
            format = hooks.calendarFormat(this, sod) || 'sameElse';

        var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);

        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
    }

    function clone () {
        return new Moment(this);
    }

    function isAfter (input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() > localInput.valueOf();
        } else {
            return localInput.valueOf() < this.clone().startOf(units).valueOf();
        }
    }

    function isBefore (input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() < localInput.valueOf();
        } else {
            return this.clone().endOf(units).valueOf() < localInput.valueOf();
        }
    }

    function isBetween (from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from),
            localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
            return false;
        }
        inclusivity = inclusivity || '()';
        return (inclusivity[0] === '(' ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) &&
            (inclusivity[1] === ')' ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
    }

    function isSame (input, units) {
        var localInput = isMoment(input) ? input : createLocal(input),
            inputMs;
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() === localInput.valueOf();
        } else {
            inputMs = localInput.valueOf();
            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
        }
    }

    function isSameOrAfter (input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }

    function isSameOrBefore (input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }

    function diff (input, units, asFloat) {
        var that,
            zoneDelta,
            output;

        if (!this.isValid()) {
            return NaN;
        }

        that = cloneWithOffset(input, this);

        if (!that.isValid()) {
            return NaN;
        }

        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

        units = normalizeUnits(units);

        switch (units) {
            case 'year': output = monthDiff(this, that) / 12; break;
            case 'month': output = monthDiff(this, that); break;
            case 'quarter': output = monthDiff(this, that) / 3; break;
            case 'second': output = (this - that) / 1e3; break; // 1000
            case 'minute': output = (this - that) / 6e4; break; // 1000 * 60
            case 'hour': output = (this - that) / 36e5; break; // 1000 * 60 * 60
            case 'day': output = (this - that - zoneDelta) / 864e5; break; // 1000 * 60 * 60 * 24, negate dst
            case 'week': output = (this - that - zoneDelta) / 6048e5; break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default: output = this - that;
        }

        return asFloat ? output : absFloor(output);
    }

    function monthDiff (a, b) {
        // difference in months
        var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
            // b is in (anchor - 1 month, anchor + 1 month)
            anchor = a.clone().add(wholeMonthDiff, 'months'),
            anchor2, adjust;

        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }

        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }

    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

    function toString () {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }

    function toISOString(keepOffset) {
        if (!this.isValid()) {
            return null;
        }
        var utc = keepOffset !== true;
        var m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) {
            return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
        }
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) {
                return this.toDate().toISOString();
            } else {
                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000).toISOString().replace('Z', formatMoment(m, 'Z'));
            }
        }
        return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
    }

    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */
    function inspect () {
        if (!this.isValid()) {
            return 'moment.invalid(/* ' + this._i + ' */)';
        }
        var func = 'moment';
        var zone = '';
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        var prefix = '[' + func + '("]';
        var year = (0 <= this.year() && this.year() <= 9999) ? 'YYYY' : 'YYYYYY';
        var datetime = '-MM-DD[T]HH:mm:ss.SSS';
        var suffix = zone + '[")]';

        return this.format(prefix + year + datetime + suffix);
    }

    function format (inputString) {
        if (!inputString) {
            inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
        }
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }

    function from (time, withoutSuffix) {
        if (this.isValid() &&
                ((isMoment(time) && time.isValid()) ||
                 createLocal(time).isValid())) {
            return createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function fromNow (withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }

    function to (time, withoutSuffix) {
        if (this.isValid() &&
                ((isMoment(time) && time.isValid()) ||
                 createLocal(time).isValid())) {
            return createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function toNow (withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }

    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale (key) {
        var newLocaleData;

        if (key === undefined) {
            return this._locale._abbr;
        } else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) {
                this._locale = newLocaleData;
            }
            return this;
        }
    }

    var lang = deprecate(
        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
        function (key) {
            if (key === undefined) {
                return this.localeData();
            } else {
                return this.locale(key);
            }
        }
    );

    function localeData () {
        return this._locale;
    }

    var MS_PER_SECOND = 1000;
    var MS_PER_MINUTE = 60 * MS_PER_SECOND;
    var MS_PER_HOUR = 60 * MS_PER_MINUTE;
    var MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;

    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return (dividend % divisor + divisor) % divisor;
    }

    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return new Date(y, m, d).valueOf();
        }
    }

    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return Date.UTC(y, m, d);
        }
    }

    function startOf (units) {
        var time;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        var startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year(), 0, 1);
                break;
            case 'quarter':
                time = startOfDate(this.year(), this.month() - this.month() % 3, 1);
                break;
            case 'month':
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case 'week':
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday());
                break;
            case 'isoWeek':
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case 'hour':
                time = this._d.valueOf();
                time -= mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR);
                break;
            case 'minute':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case 'second':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function endOf (units) {
        var time;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        var startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case 'quarter':
                time = startOfDate(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
                break;
            case 'month':
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case 'week':
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
                break;
            case 'isoWeek':
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case 'hour':
                time = this._d.valueOf();
                time += MS_PER_HOUR - mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR) - 1;
                break;
            case 'minute':
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case 'second':
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function valueOf () {
        return this._d.valueOf() - ((this._offset || 0) * 60000);
    }

    function unix () {
        return Math.floor(this.valueOf() / 1000);
    }

    function toDate () {
        return new Date(this.valueOf());
    }

    function toArray () {
        var m = this;
        return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
    }

    function toObject () {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds()
        };
    }

    function toJSON () {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }

    function isValid$2 () {
        return isValid(this);
    }

    function parsingFlags () {
        return extend({}, getParsingFlags(this));
    }

    function invalidAt () {
        return getParsingFlags(this).overflow;
    }

    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict
        };
    }

    // FORMATTING

    addFormatToken(0, ['gg', 2], 0, function () {
        return this.weekYear() % 100;
    });

    addFormatToken(0, ['GG', 2], 0, function () {
        return this.isoWeekYear() % 100;
    });

    function addWeekYearFormatToken (token, getter) {
        addFormatToken(0, [token, token.length], 0, getter);
    }

    addWeekYearFormatToken('gggg',     'weekYear');
    addWeekYearFormatToken('ggggg',    'weekYear');
    addWeekYearFormatToken('GGGG',  'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');

    // ALIASES

    addUnitAlias('weekYear', 'gg');
    addUnitAlias('isoWeekYear', 'GG');

    // PRIORITY

    addUnitPriority('weekYear', 1);
    addUnitPriority('isoWeekYear', 1);


    // PARSING

    addRegexToken('G',      matchSigned);
    addRegexToken('g',      matchSigned);
    addRegexToken('GG',     match1to2, match2);
    addRegexToken('gg',     match1to2, match2);
    addRegexToken('GGGG',   match1to4, match4);
    addRegexToken('gggg',   match1to4, match4);
    addRegexToken('GGGGG',  match1to6, match6);
    addRegexToken('ggggg',  match1to6, match6);

    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
        week[token.substr(0, 2)] = toInt(input);
    });

    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });

    // MOMENTS

    function getSetWeekYear (input) {
        return getSetWeekYearHelper.call(this,
                input,
                this.week(),
                this.weekday(),
                this.localeData()._week.dow,
                this.localeData()._week.doy);
    }

    function getSetISOWeekYear (input) {
        return getSetWeekYearHelper.call(this,
                input, this.isoWeek(), this.isoWeekday(), 1, 4);
    }

    function getISOWeeksInYear () {
        return weeksInYear(this.year(), 1, 4);
    }

    function getWeeksInYear () {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }

    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) {
            return weekOfYear(this, dow, doy).year;
        } else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) {
                week = weeksTarget;
            }
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }

    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }

    // FORMATTING

    addFormatToken('Q', 0, 'Qo', 'quarter');

    // ALIASES

    addUnitAlias('quarter', 'Q');

    // PRIORITY

    addUnitPriority('quarter', 7);

    // PARSING

    addRegexToken('Q', match1);
    addParseToken('Q', function (input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });

    // MOMENTS

    function getSetQuarter (input) {
        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    }

    // FORMATTING

    addFormatToken('D', ['DD', 2], 'Do', 'date');

    // ALIASES

    addUnitAlias('date', 'D');

    // PRIORITY
    addUnitPriority('date', 9);

    // PARSING

    addRegexToken('D',  match1to2);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function (isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict ?
          (locale._dayOfMonthOrdinalParse || locale._ordinalParse) :
          locale._dayOfMonthOrdinalParseLenient;
    });

    addParseToken(['D', 'DD'], DATE);
    addParseToken('Do', function (input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });

    // MOMENTS

    var getSetDayOfMonth = makeGetSet('Date', true);

    // FORMATTING

    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

    // ALIASES

    addUnitAlias('dayOfYear', 'DDD');

    // PRIORITY
    addUnitPriority('dayOfYear', 4);

    // PARSING

    addRegexToken('DDD',  match1to3);
    addRegexToken('DDDD', match3);
    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
        config._dayOfYear = toInt(input);
    });

    // HELPERS

    // MOMENTS

    function getSetDayOfYear (input) {
        var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
        return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
    }

    // FORMATTING

    addFormatToken('m', ['mm', 2], 0, 'minute');

    // ALIASES

    addUnitAlias('minute', 'm');

    // PRIORITY

    addUnitPriority('minute', 14);

    // PARSING

    addRegexToken('m',  match1to2);
    addRegexToken('mm', match1to2, match2);
    addParseToken(['m', 'mm'], MINUTE);

    // MOMENTS

    var getSetMinute = makeGetSet('Minutes', false);

    // FORMATTING

    addFormatToken('s', ['ss', 2], 0, 'second');

    // ALIASES

    addUnitAlias('second', 's');

    // PRIORITY

    addUnitPriority('second', 15);

    // PARSING

    addRegexToken('s',  match1to2);
    addRegexToken('ss', match1to2, match2);
    addParseToken(['s', 'ss'], SECOND);

    // MOMENTS

    var getSetSecond = makeGetSet('Seconds', false);

    // FORMATTING

    addFormatToken('S', 0, 0, function () {
        return ~~(this.millisecond() / 100);
    });

    addFormatToken(0, ['SS', 2], 0, function () {
        return ~~(this.millisecond() / 10);
    });

    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
    addFormatToken(0, ['SSSS', 4], 0, function () {
        return this.millisecond() * 10;
    });
    addFormatToken(0, ['SSSSS', 5], 0, function () {
        return this.millisecond() * 100;
    });
    addFormatToken(0, ['SSSSSS', 6], 0, function () {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
        return this.millisecond() * 1000000;
    });


    // ALIASES

    addUnitAlias('millisecond', 'ms');

    // PRIORITY

    addUnitPriority('millisecond', 16);

    // PARSING

    addRegexToken('S',    match1to3, match1);
    addRegexToken('SS',   match1to3, match2);
    addRegexToken('SSS',  match1to3, match3);

    var token;
    for (token = 'SSSS'; token.length <= 9; token += 'S') {
        addRegexToken(token, matchUnsigned);
    }

    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }

    for (token = 'S'; token.length <= 9; token += 'S') {
        addParseToken(token, parseMs);
    }
    // MOMENTS

    var getSetMillisecond = makeGetSet('Milliseconds', false);

    // FORMATTING

    addFormatToken('z',  0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');

    // MOMENTS

    function getZoneAbbr () {
        return this._isUTC ? 'UTC' : '';
    }

    function getZoneName () {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }

    var proto = Moment.prototype;

    proto.add               = add;
    proto.calendar          = calendar$1;
    proto.clone             = clone;
    proto.diff              = diff;
    proto.endOf             = endOf;
    proto.format            = format;
    proto.from              = from;
    proto.fromNow           = fromNow;
    proto.to                = to;
    proto.toNow             = toNow;
    proto.get               = stringGet;
    proto.invalidAt         = invalidAt;
    proto.isAfter           = isAfter;
    proto.isBefore          = isBefore;
    proto.isBetween         = isBetween;
    proto.isSame            = isSame;
    proto.isSameOrAfter     = isSameOrAfter;
    proto.isSameOrBefore    = isSameOrBefore;
    proto.isValid           = isValid$2;
    proto.lang              = lang;
    proto.locale            = locale;
    proto.localeData        = localeData;
    proto.max               = prototypeMax;
    proto.min               = prototypeMin;
    proto.parsingFlags      = parsingFlags;
    proto.set               = stringSet;
    proto.startOf           = startOf;
    proto.subtract          = subtract;
    proto.toArray           = toArray;
    proto.toObject          = toObject;
    proto.toDate            = toDate;
    proto.toISOString       = toISOString;
    proto.inspect           = inspect;
    proto.toJSON            = toJSON;
    proto.toString          = toString;
    proto.unix              = unix;
    proto.valueOf           = valueOf;
    proto.creationData      = creationData;
    proto.year       = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear    = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month       = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week           = proto.weeks        = getSetWeek;
    proto.isoWeek        = proto.isoWeeks     = getSetISOWeek;
    proto.weeksInYear    = getWeeksInYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.date       = getSetDayOfMonth;
    proto.day        = proto.days             = getSetDayOfWeek;
    proto.weekday    = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear  = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset            = getSetOffset;
    proto.utc                  = setOffsetToUTC;
    proto.local                = setOffsetToLocal;
    proto.parseZone            = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST                = isDaylightSavingTime;
    proto.isLocal              = isLocal;
    proto.isUtcOffset          = isUtcOffset;
    proto.isUtc                = isUtc;
    proto.isUTC                = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
    proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
    proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
    proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
    proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);

    function createUnix (input) {
        return createLocal(input * 1000);
    }

    function createInZone () {
        return createLocal.apply(null, arguments).parseZone();
    }

    function preParsePostFormat (string) {
        return string;
    }

    var proto$1 = Locale.prototype;

    proto$1.calendar        = calendar;
    proto$1.longDateFormat  = longDateFormat;
    proto$1.invalidDate     = invalidDate;
    proto$1.ordinal         = ordinal;
    proto$1.preparse        = preParsePostFormat;
    proto$1.postformat      = preParsePostFormat;
    proto$1.relativeTime    = relativeTime;
    proto$1.pastFuture      = pastFuture;
    proto$1.set             = set;

    proto$1.months            =        localeMonths;
    proto$1.monthsShort       =        localeMonthsShort;
    proto$1.monthsParse       =        localeMonthsParse;
    proto$1.monthsRegex       = monthsRegex;
    proto$1.monthsShortRegex  = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;

    proto$1.weekdays       =        localeWeekdays;
    proto$1.weekdaysMin    =        localeWeekdaysMin;
    proto$1.weekdaysShort  =        localeWeekdaysShort;
    proto$1.weekdaysParse  =        localeWeekdaysParse;

    proto$1.weekdaysRegex       =        weekdaysRegex;
    proto$1.weekdaysShortRegex  =        weekdaysShortRegex;
    proto$1.weekdaysMinRegex    =        weekdaysMinRegex;

    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;

    function get$1 (format, index, field, setter) {
        var locale = getLocale();
        var utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }

    function listMonthsImpl (format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';

        if (index != null) {
            return get$1(format, index, field, 'month');
        }

        var i;
        var out = [];
        for (i = 0; i < 12; i++) {
            out[i] = get$1(format, i, field, 'month');
        }
        return out;
    }

    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl (localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;

            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        }

        var locale = getLocale(),
            shift = localeSorted ? locale._week.dow : 0;

        if (index != null) {
            return get$1(format, (index + shift) % 7, field, 'day');
        }

        var i;
        var out = [];
        for (i = 0; i < 7; i++) {
            out[i] = get$1(format, (i + shift) % 7, field, 'day');
        }
        return out;
    }

    function listMonths (format, index) {
        return listMonthsImpl(format, index, 'months');
    }

    function listMonthsShort (format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }

    function listWeekdays (localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }

    function listWeekdaysShort (localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }

    function listWeekdaysMin (localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }

    getSetGlobalLocale('en', {
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (toInt(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        }
    });

    // Side effect imports

    hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
    hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);

    var mathAbs = Math.abs;

    function abs () {
        var data           = this._data;

        this._milliseconds = mathAbs(this._milliseconds);
        this._days         = mathAbs(this._days);
        this._months       = mathAbs(this._months);

        data.milliseconds  = mathAbs(data.milliseconds);
        data.seconds       = mathAbs(data.seconds);
        data.minutes       = mathAbs(data.minutes);
        data.hours         = mathAbs(data.hours);
        data.months        = mathAbs(data.months);
        data.years         = mathAbs(data.years);

        return this;
    }

    function addSubtract$1 (duration, input, value, direction) {
        var other = createDuration(input, value);

        duration._milliseconds += direction * other._milliseconds;
        duration._days         += direction * other._days;
        duration._months       += direction * other._months;

        return duration._bubble();
    }

    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1 (input, value) {
        return addSubtract$1(this, input, value, 1);
    }

    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1 (input, value) {
        return addSubtract$1(this, input, value, -1);
    }

    function absCeil (number) {
        if (number < 0) {
            return Math.floor(number);
        } else {
            return Math.ceil(number);
        }
    }

    function bubble () {
        var milliseconds = this._milliseconds;
        var days         = this._days;
        var months       = this._months;
        var data         = this._data;
        var seconds, minutes, hours, years, monthsFromDays;

        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
                (milliseconds <= 0 && days <= 0 && months <= 0))) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }

        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;

        seconds           = absFloor(milliseconds / 1000);
        data.seconds      = seconds % 60;

        minutes           = absFloor(seconds / 60);
        data.minutes      = minutes % 60;

        hours             = absFloor(minutes / 60);
        data.hours        = hours % 24;

        days += absFloor(hours / 24);

        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        data.days   = days;
        data.months = months;
        data.years  = years;

        return this;
    }

    function daysToMonths (days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return days * 4800 / 146097;
    }

    function monthsToDays (months) {
        // the reverse of daysToMonths
        return months * 146097 / 4800;
    }

    function as (units) {
        if (!this.isValid()) {
            return NaN;
        }
        var days;
        var months;
        var milliseconds = this._milliseconds;

        units = normalizeUnits(units);

        if (units === 'month' || units === 'quarter' || units === 'year') {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch (units) {
                case 'month':   return months;
                case 'quarter': return months / 3;
                case 'year':    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch (units) {
                case 'week'   : return days / 7     + milliseconds / 6048e5;
                case 'day'    : return days         + milliseconds / 864e5;
                case 'hour'   : return days * 24    + milliseconds / 36e5;
                case 'minute' : return days * 1440  + milliseconds / 6e4;
                case 'second' : return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
                default: throw new Error('Unknown unit ' + units);
            }
        }
    }

    // TODO: Use this.as('ms')?
    function valueOf$1 () {
        if (!this.isValid()) {
            return NaN;
        }
        return (
            this._milliseconds +
            this._days * 864e5 +
            (this._months % 12) * 2592e6 +
            toInt(this._months / 12) * 31536e6
        );
    }

    function makeAs (alias) {
        return function () {
            return this.as(alias);
        };
    }

    var asMilliseconds = makeAs('ms');
    var asSeconds      = makeAs('s');
    var asMinutes      = makeAs('m');
    var asHours        = makeAs('h');
    var asDays         = makeAs('d');
    var asWeeks        = makeAs('w');
    var asMonths       = makeAs('M');
    var asQuarters     = makeAs('Q');
    var asYears        = makeAs('y');

    function clone$1 () {
        return createDuration(this);
    }

    function get$2 (units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }

    function makeGetter(name) {
        return function () {
            return this.isValid() ? this._data[name] : NaN;
        };
    }

    var milliseconds = makeGetter('milliseconds');
    var seconds      = makeGetter('seconds');
    var minutes      = makeGetter('minutes');
    var hours        = makeGetter('hours');
    var days         = makeGetter('days');
    var months       = makeGetter('months');
    var years        = makeGetter('years');

    function weeks () {
        return absFloor(this.days() / 7);
    }

    var round = Math.round;
    var thresholds = {
        ss: 44,         // a few seconds to seconds
        s : 45,         // seconds to minute
        m : 45,         // minutes to hour
        h : 22,         // hours to day
        d : 26,         // days to month
        M : 11          // months to year
    };

    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }

    function relativeTime$1 (posNegDuration, withoutSuffix, locale) {
        var duration = createDuration(posNegDuration).abs();
        var seconds  = round(duration.as('s'));
        var minutes  = round(duration.as('m'));
        var hours    = round(duration.as('h'));
        var days     = round(duration.as('d'));
        var months   = round(duration.as('M'));
        var years    = round(duration.as('y'));

        var a = seconds <= thresholds.ss && ['s', seconds]  ||
                seconds < thresholds.s   && ['ss', seconds] ||
                minutes <= 1             && ['m']           ||
                minutes < thresholds.m   && ['mm', minutes] ||
                hours   <= 1             && ['h']           ||
                hours   < thresholds.h   && ['hh', hours]   ||
                days    <= 1             && ['d']           ||
                days    < thresholds.d   && ['dd', days]    ||
                months  <= 1             && ['M']           ||
                months  < thresholds.M   && ['MM', months]  ||
                years   <= 1             && ['y']           || ['yy', years];

        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }

    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding (roundingFunction) {
        if (roundingFunction === undefined) {
            return round;
        }
        if (typeof(roundingFunction) === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }

    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold (threshold, limit) {
        if (thresholds[threshold] === undefined) {
            return false;
        }
        if (limit === undefined) {
            return thresholds[threshold];
        }
        thresholds[threshold] = limit;
        if (threshold === 's') {
            thresholds.ss = limit - 1;
        }
        return true;
    }

    function humanize (withSuffix) {
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var locale = this.localeData();
        var output = relativeTime$1(this, !withSuffix, locale);

        if (withSuffix) {
            output = locale.pastFuture(+this, output);
        }

        return locale.postformat(output);
    }

    var abs$1 = Math.abs;

    function sign(x) {
        return ((x > 0) - (x < 0)) || +x;
    }

    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var seconds = abs$1(this._milliseconds) / 1000;
        var days         = abs$1(this._days);
        var months       = abs$1(this._months);
        var minutes, hours, years;

        // 3600 seconds -> 60 minutes -> 1 hour
        minutes           = absFloor(seconds / 60);
        hours             = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;

        // 12 months -> 1 year
        years  = absFloor(months / 12);
        months %= 12;


        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        var Y = years;
        var M = months;
        var D = days;
        var h = hours;
        var m = minutes;
        var s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
        var total = this.asSeconds();

        if (!total) {
            // this is the same as C#'s (Noda) and python (isodate)...
            // but not other JS (goog.date)
            return 'P0D';
        }

        var totalSign = total < 0 ? '-' : '';
        var ymSign = sign(this._months) !== sign(total) ? '-' : '';
        var daysSign = sign(this._days) !== sign(total) ? '-' : '';
        var hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';

        return totalSign + 'P' +
            (Y ? ymSign + Y + 'Y' : '') +
            (M ? ymSign + M + 'M' : '') +
            (D ? daysSign + D + 'D' : '') +
            ((h || m || s) ? 'T' : '') +
            (h ? hmsSign + h + 'H' : '') +
            (m ? hmsSign + m + 'M' : '') +
            (s ? hmsSign + s + 'S' : '');
    }

    var proto$2 = Duration.prototype;

    proto$2.isValid        = isValid$1;
    proto$2.abs            = abs;
    proto$2.add            = add$1;
    proto$2.subtract       = subtract$1;
    proto$2.as             = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds      = asSeconds;
    proto$2.asMinutes      = asMinutes;
    proto$2.asHours        = asHours;
    proto$2.asDays         = asDays;
    proto$2.asWeeks        = asWeeks;
    proto$2.asMonths       = asMonths;
    proto$2.asQuarters     = asQuarters;
    proto$2.asYears        = asYears;
    proto$2.valueOf        = valueOf$1;
    proto$2._bubble        = bubble;
    proto$2.clone          = clone$1;
    proto$2.get            = get$2;
    proto$2.milliseconds   = milliseconds;
    proto$2.seconds        = seconds;
    proto$2.minutes        = minutes;
    proto$2.hours          = hours;
    proto$2.days           = days;
    proto$2.weeks          = weeks;
    proto$2.months         = months;
    proto$2.years          = years;
    proto$2.humanize       = humanize;
    proto$2.toISOString    = toISOString$1;
    proto$2.toString       = toISOString$1;
    proto$2.toJSON         = toISOString$1;
    proto$2.locale         = locale;
    proto$2.localeData     = localeData;

    proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
    proto$2.lang = lang;

    // Side effect imports

    // FORMATTING

    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');

    // PARSING

    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function (input, array, config) {
        config._d = new Date(parseFloat(input, 10) * 1000);
    });
    addParseToken('x', function (input, array, config) {
        config._d = new Date(toInt(input));
    });

    // Side effect imports


    hooks.version = '2.24.0';

    setHookCallback(createLocal);

    hooks.fn                    = proto;
    hooks.min                   = min;
    hooks.max                   = max;
    hooks.now                   = now;
    hooks.utc                   = createUTC;
    hooks.unix                  = createUnix;
    hooks.months                = listMonths;
    hooks.isDate                = isDate;
    hooks.locale                = getSetGlobalLocale;
    hooks.invalid               = createInvalid;
    hooks.duration              = createDuration;
    hooks.isMoment              = isMoment;
    hooks.weekdays              = listWeekdays;
    hooks.parseZone             = createInZone;
    hooks.localeData            = getLocale;
    hooks.isDuration            = isDuration;
    hooks.monthsShort           = listMonthsShort;
    hooks.weekdaysMin           = listWeekdaysMin;
    hooks.defineLocale          = defineLocale;
    hooks.updateLocale          = updateLocale;
    hooks.locales               = listLocales;
    hooks.weekdaysShort         = listWeekdaysShort;
    hooks.normalizeUnits        = normalizeUnits;
    hooks.relativeTimeRounding  = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat        = getCalendarFormat;
    hooks.prototype             = proto;

    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',             // <input type="datetime-local" />
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',  // <input type="datetime-local" step="1" />
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',   // <input type="datetime-local" step="0.001" />
        DATE: 'YYYY-MM-DD',                             // <input type="date" />
        TIME: 'HH:mm',                                  // <input type="time" />
        TIME_SECONDS: 'HH:mm:ss',                       // <input type="time" step="1" />
        TIME_MS: 'HH:mm:ss.SSS',                        // <input type="time" step="0.001" />
        WEEK: 'GGGG-[W]WW',                             // <input type="week" />
        MONTH: 'YYYY-MM'                                // <input type="month" />
    };

    return hooks;

})));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(279)(module)))

/***/ }),
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CHECKOUT_OUTCOME; });
/* unused harmony export checkoutReferenceCode */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return mapCheckoutError; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__userError__ = __webpack_require__(15);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var CHECKOUT_OUTCOME={CONFIRMED:'CONFIRMED',CHECKING:'CHECKING',PAYMENT_FAILED:'PAYMENT_FAILED',SAFE_FAILURE:'SAFE_FAILURE',UNKNOWN:'UNKNOWN'};var LEGACY_UNCERTAIN_MESSAGES=['processing your first order','please contact the support. try again later'];var firstPresent=function firstPresent(source,fields){for(var index=0;index<fields.length;index+=1){if(source&&source[fields[index]]!==undefined&&source[fields[index]]!==null){return source[fields[index]];}}return undefined;};var normaliseOutcome=function normaliseOutcome(value){var outcome=String(value||'').toUpperCase().replace(/[- ]/g,'_');if(['CONFIRMED','ORDER_CONFIRMED','PLACED','SUCCESS'].indexOf(outcome)!==-1){return CHECKOUT_OUTCOME.CONFIRMED;}if(['CHECKING','PROCESSING','PENDING','ORDER_CHECKING'].indexOf(outcome)!==-1){return CHECKOUT_OUTCOME.CHECKING;}if(outcome===CHECKOUT_OUTCOME.PAYMENT_FAILED){return CHECKOUT_OUTCOME.PAYMENT_FAILED;}if(['SAFE_FAILURE','KNOWN_SAFE_FAILURE','NOT_PLACED','ORDER_NOT_PLACED','FAILED'].indexOf(outcome)!==-1){return CHECKOUT_OUTCOME.SAFE_FAILURE;}return CHECKOUT_OUTCOME.UNKNOWN;};var customerCopy=function customerCopy(outcome,orderNumber,postOrderFailure,retrySafe,supportReference){var orderLabel=orderNumber?'Order '+orderNumber:'Your order';switch(outcome){case CHECKOUT_OUTCOME.PAYMENT_FAILED:return{title:'Your payment was declined',message:'Your card payment failed, so this order is not confirmed.',guidance:'Check your card details or contact support before trying again.'};case CHECKOUT_OUTCOME.CONFIRMED:return{title:'Your order was placed',message:postOrderFailure?orderLabel+' was placed, but we could not complete a final checkout step.':orderLabel+' was placed, but we could not confirm every final checkout step.',guidance:supportReference?'Please do not place this order again. Support can use the reference below to help.':'Please do not place this order again. Contact support for help.'};case CHECKOUT_OUTCOME.CHECKING:return{title:'We are checking your order',message:'We are still checking whether your order was placed.',guidance:'Please do not place this order again while it is being checked.'};case CHECKOUT_OUTCOME.SAFE_FAILURE:return{title:'Your order was not placed',message:'We could not place your order.',guidance:retrySafe===true?'No order was created, so you can try again.':supportReference?'Please contact support with the reference below before trying again.':'Please contact support before trying again.'};default:return{title:'We could not confirm your order',message:'We could not confirm whether your order was placed.',guidance:'Please check My Orders or contact support before trying again. Do not place this order again until you have checked.'};}};var mapCheckoutCopy=function mapCheckoutCopy(error){var context=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};var response=error&&error.response;var backend=firstPresent(error,['data','body','error'])||response&&firstPresent(response,['data','body'])||error||{};var backendObject=(typeof backend==='undefined'?'undefined':_typeof(backend))==='object'?backend:error&&(typeof error==='undefined'?'undefined':_typeof(error))==='object'?error:{};var rawMessage=firstPresent(backendObject,['message','errorMessage','description'])||(typeof backend==='string'?backend:'')||error&&error.message||(typeof error==='string'?error:'');var status=firstPresent(backendObject,['status','httpStatus'])||response&&response.status||context.status;var responseHeaderReference=response&&response.headers&&response.headers.get?response.headers.get('X-Support-Reference'):undefined;var supportReference=firstPresent(backendObject,['supportReference','support_reference'])||responseHeaderReference||context.supportReference;var orderNumber=firstPresent(backendObject,['orderNumber','publicOrderNumber','order_number'])||context.orderNumber;var declaredOutcome=firstPresent(backendObject,['outcome','orderOutcome','failureCategory','category']);var retrySafe=firstPresent(backendObject,['retrySafe','retry_safe']);var errorCode=firstPresent(backendObject,['code'])||error&&error.code;var messageIsLegacyUncertain=LEGACY_UNCERTAIN_MESSAGES.some(function(message){return String(rawMessage||'').toLowerCase().indexOf(message)!==-1;});var isNetworkOrServerFailure=!error||error.name==='TypeError'||status>=500;if(errorCode==='AUTHENTICATION_REQUIRED'||status===401||status===403){// The order already exists when the session expires at the payment step.
if(context.paymentSessionExpired){return{title:'Please sign in again',message:'Your session expired, so we could not take the payment for '+(orderNumber?'order '+orderNumber:'your order')+'.',guidance:'Sign in again and check My Orders before trying again. Please do not place this order again.',outcome:CHECKOUT_OUTCOME.UNKNOWN,retrySafe:false,code:'AUTHENTICATION_REQUIRED',orderNumber:orderNumber,supportReference:supportReference,status:status,backendMessage:rawMessage};}return{title:'Please sign in again',message:'Your session has expired, so this order was not submitted.',guidance:'Sign in again, review your cart, and then place the order.',outcome:CHECKOUT_OUTCOME.SAFE_FAILURE,retrySafe:false,code:'AUTHENTICATION_REQUIRED',status:status,backendMessage:rawMessage};}if(context.preSubmitValidation){return{title:context.title||'Please check your order',message:rawMessage||'Some order details are missing.',guidance:context.guidance||'Update the details and try again.',outcome:CHECKOUT_OUTCOME.SAFE_FAILURE,retrySafe:true,status:status,backendMessage:rawMessage};}if(context.paymentOutcomeUnknown){return{title:'We could not confirm your payment',message:'We could not confirm whether the payment completed.',guidance:supportReference?'Please do not try the payment again yet. Contact support with the reference below.':'Please do not try the payment again yet. Contact support before trying again.',outcome:CHECKOUT_OUTCOME.UNKNOWN,retrySafe:false,supportReference:supportReference,status:status,backendMessage:rawMessage};}var numericStatus=Number(firstPresent(backendObject,['statusCode'])||response&&response.status||(typeof status==='number'?status:undefined));var isPlaceOrderRejection=Object.keys(context).length===0&&declaredOutcome===undefined&&numericStatus>=400&&numericStatus<500&&!!rawMessage;// A 4xx from the order endpoint means the server refused the order before
// creating it, so show its specific message rather than an unknown outcome.
if(isPlaceOrderRejection){return{title:'Your order was not placed',message:rawMessage,guidance:'No order was created. Review your order and try again.',outcome:CHECKOUT_OUTCOME.SAFE_FAILURE,retrySafe:true,orderNumber:orderNumber,supportReference:supportReference,status:status,code:errorCode,backendMessage:rawMessage};}var outcome=context.outcome?normaliseOutcome(context.outcome):normaliseOutcome(declaredOutcome);if(context.orderNumber&&context.postOrderFailure){outcome=CHECKOUT_OUTCOME.CONFIRMED;}else if(messageIsLegacyUncertain||isNetworkOrServerFailure){outcome=CHECKOUT_OUTCOME.UNKNOWN;}var copy=customerCopy(outcome,orderNumber,context.postOrderFailure,retrySafe,supportReference);return Object.assign({},copy,{outcome:outcome,orderNumber:orderNumber,supportReference:supportReference,status:status,failureCategory:firstPresent(backendObject,['failureCategory','category']),code:errorCode,retrySafe:retrySafe,backendMessage:rawMessage});};// The support reference code for a mapped checkout failure (docs/ERROR_MESSAGES.md).
var checkoutReferenceCode=function checkoutReferenceCode(result,error){var context=arguments.length>2&&arguments[2]!==undefined?arguments[2]:{};if(context.referenceCode){return context.referenceCode;}if(result.code==='AUTHENTICATION_REQUIRED'){return __WEBPACK_IMPORTED_MODULE_0__userError__["a" /* ERROR_CODES */].AUTH_SIGNED_OUT;}if(context.paymentOutcomeUnknown){return __WEBPACK_IMPORTED_MODULE_0__userError__["a" /* ERROR_CODES */].PAYMENT_UNKNOWN_STATE;}switch(result.outcome){case CHECKOUT_OUTCOME.PAYMENT_FAILED:return __WEBPACK_IMPORTED_MODULE_0__userError__["a" /* ERROR_CODES */].PAYMENT_DECLINED;case CHECKOUT_OUTCOME.CONFIRMED:return __WEBPACK_IMPORTED_MODULE_0__userError__["a" /* ERROR_CODES */].ORDER_PLACED_INCOMPLETE;case CHECKOUT_OUTCOME.CHECKING:return __WEBPACK_IMPORTED_MODULE_0__userError__["a" /* ERROR_CODES */].ORDER_CHECKING;case CHECKOUT_OUTCOME.SAFE_FAILURE:return __WEBPACK_IMPORTED_MODULE_0__userError__["a" /* ERROR_CODES */].ORDER_PLACE_FAILED;default:{// Unknown outcome: the order may exist. Say why we don't know when it was the connection.
var kind=Object(__WEBPACK_IMPORTED_MODULE_0__userError__["c" /* failureKind */])(error&&(typeof error==='undefined'?'undefined':_typeof(error))==='object'?error:null);if(kind==='offline')return __WEBPACK_IMPORTED_MODULE_0__userError__["a" /* ERROR_CODES */].NETWORK_OFFLINE;if(kind==='timeout')return __WEBPACK_IMPORTED_MODULE_0__userError__["a" /* ERROR_CODES */].NETWORK_TIMEOUT;if(kind==='unreachable'||kind==='server')return __WEBPACK_IMPORTED_MODULE_0__userError__["a" /* ERROR_CODES */].SERVER_UNAVAILABLE;return __WEBPACK_IMPORTED_MODULE_0__userError__["a" /* ERROR_CODES */].ORDER_UNKNOWN_STATE;}}};var mapCheckoutError=function mapCheckoutError(error){var context=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};var result=mapCheckoutCopy(error,context);return Object.assign({},result,{referenceCode:checkoutReferenceCode(result,error,context),// The dedicated support reference when the server gave one, else the request's correlation id.
serverId:result.supportReference||Object(__WEBPACK_IMPORTED_MODULE_0__userError__["f" /* serverIdOf */])(error&&(typeof error==='undefined'?'undefined':_typeof(error))==='object'?error:null),at:context.at||new Date()});};

/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__hoc_ReactAux_ReactAux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Modal_css__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Modal_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Modal_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_images_cart_mark_png__ = __webpack_require__(286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_images_cart_mark_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_images_cart_mark_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_modal__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_modal__);
var customStyles={content:{background:'none',border:'none'},overlay:{zIndex:'9999999',width:'100%',height:'100%',left:'0',top:'0',backgroundColor:'rgba(0, 0, 0, 0.7)'}};var ModalCartMessage=function ModalCartMessage(props){if(!props.showModal){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__hoc_ReactAux_ReactAux__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_modal___default.a,{isOpen:props.showModal,style:customStyles,onRequestClose:props.clickButtonDeny,shouldCloseOnOverlayClick:true,shouldCloseOnEsc:true,contentLabel:'Example Modal'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'lb-cart-message',className:'lb-geral lb-cart-message_ mfp-bg-login white-popup-block lb-centralizar singup zoom-anim-dialog Modal'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'lb-padrao-singup6 mfp-content-login modal-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:props.clickButtonDeny,type:'button',className:'bt-close mfp-close lb-fechar fa fa-times'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'check-mark'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{alt:'cart mark',src:__WEBPACK_IMPORTED_MODULE_3_images_cart_mark_png___default.a})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'lb-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'order'},props.message),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'no-yes wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{onClick:props.clickButtonDeny,className:'bt no'},'No'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{onClick:props.clickButtonConfirm,className:'bt yes'},'Yes')))))));};/* harmony default export */ __webpack_exports__["a"] = (ModalCartMessage);

/***/ }),
/* 120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_modal__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__hoc_ReactAux_ReactAux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_utils_time__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_utils_orderConfirmation__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modalReceiptTest_scss__ = __webpack_require__(287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modalReceiptTest_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__modalReceiptTest_scss__);
var customStyles={content:{background:'none',border:'none',height:'100%',left:'0',right:'0',top:'0',bottom:'0',overflowY:'scroll'},overlay:{position:'fixed',zIndex:'9999999',width:'100%',height:'100%',backgroundColor:'rgba(0, 0, 0, 0.8)'}};var Product=function Product(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bloco'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',{className:'left'},props.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',{className:'right'},props.price)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,props.description));};var ResumeLine=function ResumeLine(props){var classes=!!props.bold?'wrapper total':'wrapper';return props.showResume?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:classes},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'left'},props.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right'},props.value)):null;};var CustomerDetails=function CustomerDetails(_ref){var firstName=_ref.firstName,lastName=_ref.lastName,businessName=_ref.businessName,isCollection=_ref.isCollection,address=_ref.address;var customerName=firstName+' '+lastName;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'head'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,isCollection?'Collection by '+customerName:'Delivery to '+customerName+', '+businessName+' @ '+address.street));};var OrderDateDetails=function OrderDateDetails(_ref2){var cart=_ref2.cart,isCollection=_ref2.isCollection;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__hoc_ReactAux_ReactAux__["a" /* default */],null,!!cart&&!!cart.orderDeliveryDate&&isCollection?'Time for collection : '+__WEBPACK_IMPORTED_MODULE_3_utils_time__["a" /* default */].formatDateToDateTimeAmPm(cart.orderDeliveryDate):'Date: '+__WEBPACK_IMPORTED_MODULE_3_utils_time__["a" /* default */].formatDateToDateTimeAmPm(cart.orderDeliveryDate));};var modalReceipt=function modalReceipt(props){if(!props.showModal){return null;}var publicOrderNumber=props.data.cart.publicOrderNumber;var orderReference=publicOrderNumber?'Order '+publicOrderNumber:'Order details';var renderProduct=function renderProduct(item,currency,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Product,{key:index,name:item.name,price:currency+' '+Number(item.price).toFixed(2),description:(item.description||'')+' '+(item.calory||'')});};var total=function total(){return props.data.total===props.data.subtotal&&props.data.tipValue>0?props.data.total+props.data.tipValue:props.data.total;};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__hoc_ReactAux_ReactAux__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_modal___default.a,{isOpen:true,style:customStyles,onRequestClose:props.closeModal,shouldCloseOnOverlayClick:true,shouldCloseOnEsc:true,contentLabel:'Example Modal'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'lb-receipt',className:'lb-geral lb-receipt_'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-content modal-content-receipt',tabIndex:0},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'bt-close mfp-close lb-fechar fa fa-times',onClick:props.closeModal}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'check-mark'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'fa fa-check-circle lt-success-tick','aria-hidden':'true'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'lb-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'order'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,Object(__WEBPACK_IMPORTED_MODULE_4_utils_orderConfirmation__["a" /* orderPlacedMessage */])(publicOrderNumber))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'purchase'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'Receipt'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',{className:'thank-you'},'Thank you for your purchase,',' ',props.data.userDetails.firstName,' :)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'order-date'},orderReference,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(OrderDateDetails,{cart:props.data.cart,isCollection:props.data.forCollection==='Y'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'delivery'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CustomerDetails,{businessName:props.data.userDetails.businessName,firstName:props.data.userDetails.firstName,lastName:props.data.userDetails.lastName,isCollection:props.data.forCollection==='Y',address:props.data.address}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content'},props.data.cart.products.map(function(product,index){return renderProduct(product,props.data.currency,index);})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'foot'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ResumeLine,{showResume:true,name:'Subtotal',value:props.data.currency+' '+Number(props.data.subtotal).toFixed(2)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ResumeLine,{showResume:props.data.orderDeliveryDate!==undefined,name:'Tip',value:props.data.currency+' '+Number(props.data.tipValue).toFixed(2)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ResumeLine,{showResume:props.data.forCollection==='N'&&props.data.orderDeliveryDate!==undefined,name:'Subsidy',value:props.data.currency+' '+Number(props.data.cart.subsidy).toFixed(2)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ResumeLine,{showResume:props.data.forCollection==='N'&&props.data.orderDeliveryDate!==undefined,name:'Tax Delivery',value:props.data.currency+' '+Number(props.data.taxDelivery).toFixed(2)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ResumeLine,{showResume:props.data.forCollection==='Y',name:'Collection Discount',value:''+props.data.collectionDiscount}),!!props.data.surcharge&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ResumeLine,{showResume:true,name:'Surcharge',value:props.data.currency+' '+Number(props.data.surcharge).toFixed(2)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ResumeLine,{showResume:true,name:'Total',value:props.data.currency+' '+Number(total()).toFixed(2),bold:true})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{onClick:props.closeModal,className:'bt'},'Got it'))))));};/* harmony default export */ __webpack_exports__["a"] = (modalReceipt);

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(122);
var core = __webpack_require__(71);
var ctx = __webpack_require__(688);
var hide = __webpack_require__(690);
var has = __webpack_require__(292);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && has(exports, key)) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 122 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 123 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(695);
var enumBugKeys = __webpack_require__(297);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

var _Object$keys = __webpack_require__(704);

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};

  var sourceKeys = _Object$keys(source);

  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

module.exports = _objectWithoutPropertiesLoose;

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

var _Object$create = __webpack_require__(708);

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = _Object$create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

module.exports = _inheritsLoose;

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(91);

exports.__esModule = true;
exports.prefix = prefix;
exports.getClassSet = getClassSet;
exports.splitBsProps = splitBsProps;
exports.splitBsPropsAndOmit = splitBsPropsAndOmit;
exports.addStyle = addStyle;
exports._curry = exports.bsSizes = exports.bsStyles = exports.bsClass = void 0;

var _entries = _interopRequireDefault(__webpack_require__(718));

var _extends2 = _interopRequireDefault(__webpack_require__(92));

var _invariant = _interopRequireDefault(__webpack_require__(48));

var _propTypes = _interopRequireDefault(__webpack_require__(7));

var _StyleConfig = __webpack_require__(301);

// TODO: The publicly exposed parts of this should be in lib/BootstrapUtils.
function curry(fn) {
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var last = args[args.length - 1];

    if (typeof last === 'function') {
      return fn.apply(void 0, args);
    }

    return function (Component) {
      return fn.apply(void 0, args.concat([Component]));
    };
  };
}

function prefix(props, variant) {
  var bsClass = (props.bsClass || '').trim();
  !(bsClass != null) ?  false ? (0, _invariant.default)(false, 'A `bsClass` prop is required for this component') : invariant(false) : void 0;
  return bsClass + (variant ? "-" + variant : '');
}

var bsClass = curry(function (defaultClass, Component) {
  var propTypes = Component.propTypes || (Component.propTypes = {});
  var defaultProps = Component.defaultProps || (Component.defaultProps = {});
  propTypes.bsClass = _propTypes.default.string;
  defaultProps.bsClass = defaultClass;
  return Component;
});
exports.bsClass = bsClass;
var bsStyles = curry(function (styles, defaultStyle, Component) {
  if (typeof defaultStyle !== 'string') {
    Component = defaultStyle;
    defaultStyle = undefined;
  }

  var existing = Component.STYLES || [];
  var propTypes = Component.propTypes || {};
  styles.forEach(function (style) {
    if (existing.indexOf(style) === -1) {
      existing.push(style);
    }
  });

  var propType = _propTypes.default.oneOf(existing); // expose the values on the propType function for documentation


  Component.STYLES = existing;
  propType._values = existing;
  Component.propTypes = (0, _extends2.default)({}, propTypes, {
    bsStyle: propType
  });

  if (defaultStyle !== undefined) {
    var defaultProps = Component.defaultProps || (Component.defaultProps = {});
    defaultProps.bsStyle = defaultStyle;
  }

  return Component;
});
exports.bsStyles = bsStyles;
var bsSizes = curry(function (sizes, defaultSize, Component) {
  if (typeof defaultSize !== 'string') {
    Component = defaultSize;
    defaultSize = undefined;
  }

  var existing = Component.SIZES || [];
  var propTypes = Component.propTypes || {};
  sizes.forEach(function (size) {
    if (existing.indexOf(size) === -1) {
      existing.push(size);
    }
  });
  var values = [];
  existing.forEach(function (size) {
    var mappedSize = _StyleConfig.SIZE_MAP[size];

    if (mappedSize && mappedSize !== size) {
      values.push(mappedSize);
    }

    values.push(size);
  });

  var propType = _propTypes.default.oneOf(values);

  propType._values = values; // expose the values on the propType function for documentation

  Component.SIZES = existing;
  Component.propTypes = (0, _extends2.default)({}, propTypes, {
    bsSize: propType
  });

  if (defaultSize !== undefined) {
    if (!Component.defaultProps) {
      Component.defaultProps = {};
    }

    Component.defaultProps.bsSize = defaultSize;
  }

  return Component;
});
exports.bsSizes = bsSizes;

function getClassSet(props) {
  var _classes;

  var classes = (_classes = {}, _classes[prefix(props)] = true, _classes);

  if (props.bsSize) {
    var bsSize = _StyleConfig.SIZE_MAP[props.bsSize] || props.bsSize;
    classes[prefix(props, bsSize)] = true;
  }

  if (props.bsStyle) {
    classes[prefix(props, props.bsStyle)] = true;
  }

  return classes;
}

function getBsProps(props) {
  return {
    bsClass: props.bsClass,
    bsSize: props.bsSize,
    bsStyle: props.bsStyle,
    bsRole: props.bsRole
  };
}

function isBsProp(propName) {
  return propName === 'bsClass' || propName === 'bsSize' || propName === 'bsStyle' || propName === 'bsRole';
}

function splitBsProps(props) {
  var elementProps = {};
  (0, _entries.default)(props).forEach(function (_ref) {
    var propName = _ref[0],
        propValue = _ref[1];

    if (!isBsProp(propName)) {
      elementProps[propName] = propValue;
    }
  });
  return [getBsProps(props), elementProps];
}

function splitBsPropsAndOmit(props, omittedPropNames) {
  var isOmittedProp = {};
  omittedPropNames.forEach(function (propName) {
    isOmittedProp[propName] = true;
  });
  var elementProps = {};
  (0, _entries.default)(props).forEach(function (_ref2) {
    var propName = _ref2[0],
        propValue = _ref2[1];

    if (!isBsProp(propName) && !isOmittedProp[propName]) {
      elementProps[propName] = propValue;
    }
  });
  return [getBsProps(props), elementProps];
}
/**
 * Add a style variant to a Component. Mutates the propTypes of the component
 * in order to validate the new variant.
 */


function addStyle(Component) {
  for (var _len2 = arguments.length, styleVariant = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    styleVariant[_key2 - 1] = arguments[_key2];
  }

  bsStyles(styleVariant, Component);
}

var _curry = curry;
exports._curry = _curry;

/***/ }),
/* 128 */
/***/ (function(module, exports) {

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

module.exports = _inheritsLoose;

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

(function (global, factory) {
	 true ? factory(exports, __webpack_require__(0)) :
	typeof define === 'function' && define.amd ? define(['exports', 'react'], factory) :
	(global = global || self, factory(global.ReactStripe = {}, global.React));
}(this, (function (exports, React) { 'use strict';

	React = React && Object.prototype.hasOwnProperty.call(React, 'default') ? React['default'] : React;

	function createCommonjsModule(fn, module) {
		return module = { exports: {} }, fn(module, module.exports), module.exports;
	}

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */

	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	var ReactPropTypesSecret_1 = ReactPropTypesSecret;

	function emptyFunction() {}

	function emptyFunctionWithReset() {}

	emptyFunctionWithReset.resetWarningCache = emptyFunction;

	var factoryWithThrowingShims = function () {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret_1) {
	      // It is still safe when called from React.
	      return;
	    }

	    var err = new Error('Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use PropTypes.checkPropTypes() to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
	    err.name = 'Invariant Violation';
	    throw err;
	  }
	  shim.isRequired = shim;

	  function getShim() {
	    return shim;
	  }
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.

	  var ReactPropTypes = {
	    array: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    elementType: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim,
	    exact: getShim,
	    checkPropTypes: emptyFunctionWithReset,
	    resetWarningCache: emptyFunction
	  };
	  ReactPropTypes.PropTypes = ReactPropTypes;
	  return ReactPropTypes;
	};

	var propTypes = createCommonjsModule(function (module) {
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	{
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = factoryWithThrowingShims();
	}
	});

	function _typeof(obj) {
	  "@babel/helpers - typeof";

	  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
	    _typeof = function (obj) {
	      return typeof obj;
	    };
	  } else {
	    _typeof = function (obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
	    };
	  }

	  return _typeof(obj);
	}

	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }

	  return obj;
	}

	function ownKeys(object, enumerableOnly) {
	  var keys = Object.keys(object);

	  if (Object.getOwnPropertySymbols) {
	    var symbols = Object.getOwnPropertySymbols(object);
	    if (enumerableOnly) symbols = symbols.filter(function (sym) {
	      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
	    });
	    keys.push.apply(keys, symbols);
	  }

	  return keys;
	}

	function _objectSpread2(target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i] != null ? arguments[i] : {};

	    if (i % 2) {
	      ownKeys(Object(source), true).forEach(function (key) {
	        _defineProperty(target, key, source[key]);
	      });
	    } else if (Object.getOwnPropertyDescriptors) {
	      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
	    } else {
	      ownKeys(Object(source)).forEach(function (key) {
	        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
	      });
	    }
	  }

	  return target;
	}

	function _slicedToArray(arr, i) {
	  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
	}

	function _arrayWithHoles(arr) {
	  if (Array.isArray(arr)) return arr;
	}

	function _iterableToArrayLimit(arr, i) {
	  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
	  var _arr = [];
	  var _n = true;
	  var _d = false;
	  var _e = undefined;

	  try {
	    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
	      _arr.push(_s.value);

	      if (i && _arr.length === i) break;
	    }
	  } catch (err) {
	    _d = true;
	    _e = err;
	  } finally {
	    try {
	      if (!_n && _i["return"] != null) _i["return"]();
	    } finally {
	      if (_d) throw _e;
	    }
	  }

	  return _arr;
	}

	function _unsupportedIterableToArray(o, minLen) {
	  if (!o) return;
	  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
	  var n = Object.prototype.toString.call(o).slice(8, -1);
	  if (n === "Object" && o.constructor) n = o.constructor.name;
	  if (n === "Map" || n === "Set") return Array.from(o);
	  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
	}

	function _arrayLikeToArray(arr, len) {
	  if (len == null || len > arr.length) len = arr.length;

	  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

	  return arr2;
	}

	function _nonIterableRest() {
	  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
	}

	var usePrevious = function usePrevious(value) {
	  var ref = React.useRef(value);
	  React.useEffect(function () {
	    ref.current = value;
	  }, [value]);
	  return ref.current;
	};

	var isUnknownObject = function isUnknownObject(raw) {
	  return raw !== null && _typeof(raw) === 'object';
	};
	var isPromise = function isPromise(raw) {
	  return isUnknownObject(raw) && typeof raw.then === 'function';
	}; // We are using types to enforce the `stripe` prop in this lib,
	// but in an untyped integration `stripe` could be anything, so we need
	// to do some sanity validation to prevent type errors.

	var isStripe = function isStripe(raw) {
	  return isUnknownObject(raw) && typeof raw.elements === 'function' && typeof raw.createToken === 'function' && typeof raw.createPaymentMethod === 'function' && typeof raw.confirmCardPayment === 'function';
	};

	var PLAIN_OBJECT_STR = '[object Object]';
	var isEqual = function isEqual(left, right) {
	  if (!isUnknownObject(left) || !isUnknownObject(right)) {
	    return left === right;
	  }

	  var leftArray = Array.isArray(left);
	  var rightArray = Array.isArray(right);
	  if (leftArray !== rightArray) return false;
	  var leftPlainObject = Object.prototype.toString.call(left) === PLAIN_OBJECT_STR;
	  var rightPlainObject = Object.prototype.toString.call(right) === PLAIN_OBJECT_STR;
	  if (leftPlainObject !== rightPlainObject) return false;
	  if (!leftPlainObject && !leftArray) return false;
	  var leftKeys = Object.keys(left);
	  var rightKeys = Object.keys(right);
	  if (leftKeys.length !== rightKeys.length) return false;
	  var keySet = {};

	  for (var i = 0; i < leftKeys.length; i += 1) {
	    keySet[leftKeys[i]] = true;
	  }

	  for (var _i = 0; _i < rightKeys.length; _i += 1) {
	    keySet[rightKeys[_i]] = true;
	  }

	  var allKeys = Object.keys(keySet);

	  if (allKeys.length !== leftKeys.length) {
	    return false;
	  }

	  var l = left;
	  var r = right;

	  var pred = function pred(key) {
	    return isEqual(l[key], r[key]);
	  };

	  return allKeys.every(pred);
	};

	var extractAllowedOptionsUpdates = function extractAllowedOptionsUpdates(options, prevOptions, immutableKeys) {
	  if (!isUnknownObject(options)) {
	    return null;
	  }

	  return Object.keys(options).reduce(function (newOptions, key) {
	    var isUpdated = !isUnknownObject(prevOptions) || !isEqual(options[key], prevOptions[key]);

	    if (immutableKeys.includes(key)) {
	      if (isUpdated) {
	        console.warn("Unsupported prop change: options.".concat(key, " is not a mutable property."));
	      }

	      return newOptions;
	    }

	    if (!isUpdated) {
	      return newOptions;
	    }

	    return _objectSpread2(_objectSpread2({}, newOptions || {}), {}, _defineProperty({}, key, options[key]));
	  }, null);
	};

	var INVALID_STRIPE_ERROR = 'Invalid prop `stripe` supplied to `Elements`. We recommend using the `loadStripe` utility from `@stripe/stripe-js`. See https://stripe.com/docs/stripe-js/react#elements-props-stripe for details.'; // We are using types to enforce the `stripe` prop in this lib, but in a real
	// integration `stripe` could be anything, so we need to do some sanity
	// validation to prevent type errors.

	var validateStripe = function validateStripe(maybeStripe) {
	  if (maybeStripe === null || isStripe(maybeStripe)) {
	    return maybeStripe;
	  }

	  throw new Error(INVALID_STRIPE_ERROR);
	};

	var parseStripeProp = function parseStripeProp(raw) {
	  if (isPromise(raw)) {
	    return {
	      tag: 'async',
	      stripePromise: Promise.resolve(raw).then(validateStripe)
	    };
	  }

	  var stripe = validateStripe(raw);

	  if (stripe === null) {
	    return {
	      tag: 'empty'
	    };
	  }

	  return {
	    tag: 'sync',
	    stripe: stripe
	  };
	};

	var ElementsContext = /*#__PURE__*/React.createContext(null);
	ElementsContext.displayName = 'ElementsContext';
	var parseElementsContext = function parseElementsContext(ctx, useCase) {
	  if (!ctx) {
	    throw new Error("Could not find Elements context; You need to wrap the part of your app that ".concat(useCase, " in an <Elements> provider."));
	  }

	  return ctx;
	};
	/**
	 * The `Elements` provider allows you to use [Element components](https://stripe.com/docs/stripe-js/react#element-components) and access the [Stripe object](https://stripe.com/docs/js/initializing) in any nested component.
	 * Render an `Elements` provider at the root of your React app so that it is available everywhere you need it.
	 *
	 * To use the `Elements` provider, call `loadStripe` from `@stripe/stripe-js` with your publishable key.
	 * The `loadStripe` function will asynchronously load the Stripe.js script and initialize a `Stripe` object.
	 * Pass the returned `Promise` to `Elements`.
	 *
	 * @docs https://stripe.com/docs/stripe-js/react#elements-provider
	 */

	var Elements = function Elements(_ref) {
	  var rawStripeProp = _ref.stripe,
	      options = _ref.options,
	      children = _ref.children;

	  var _final = React.useRef(false);

	  var isMounted = React.useRef(true);
	  var parsed = React.useMemo(function () {
	    return parseStripeProp(rawStripeProp);
	  }, [rawStripeProp]);

	  var _React$useState = React.useState(function () {
	    return {
	      stripe: null,
	      elements: null
	    };
	  }),
	      _React$useState2 = _slicedToArray(_React$useState, 2),
	      ctx = _React$useState2[0],
	      setContext = _React$useState2[1];

	  var prevStripe = usePrevious(rawStripeProp);

	  if (prevStripe !== null) {
	    if (prevStripe !== rawStripeProp) {
	      console.warn('Unsupported prop change on Elements: You cannot change the `stripe` prop after setting it.');
	    }
	  }

	  if (!_final.current) {
	    if (parsed.tag === 'sync') {
	      _final.current = true;
	      setContext({
	        stripe: parsed.stripe,
	        elements: parsed.stripe.elements(options)
	      });
	    }

	    if (parsed.tag === 'async') {
	      _final.current = true;
	      parsed.stripePromise.then(function (stripe) {
	        if (stripe && isMounted.current) {
	          // Only update Elements context if the component is still mounted
	          // and stripe is not null. We allow stripe to be null to make
	          // handling SSR easier.
	          setContext({
	            stripe: stripe,
	            elements: stripe.elements(options)
	          });
	        }
	      });
	    }
	  }

	  var prevOptions = usePrevious(options);
	  React.useEffect(function () {
	    if (!ctx.elements) {
	      return;
	    }

	    var updates = extractAllowedOptionsUpdates(options, prevOptions, ['clientSecret', 'fonts']);

	    if (updates) {
	      ctx.elements.update(updates);
	    }
	  }, [options, prevOptions, ctx.elements]);
	  React.useEffect(function () {
	    return function () {
	      isMounted.current = false;
	    };
	  }, []);
	  React.useEffect(function () {
	    var anyStripe = ctx.stripe;

	    if (!anyStripe || !anyStripe._registerWrapper || !anyStripe.registerAppInfo) {
	      return;
	    }

	    anyStripe._registerWrapper({
	      name: 'react-stripe-js',
	      version: "1.5.0"
	    });

	    anyStripe.registerAppInfo({
	      name: 'react-stripe-js',
	      version: "1.5.0",
	      url: 'https://stripe.com/docs/stripe-js/react'
	    });
	  }, [ctx.stripe]);
	  return /*#__PURE__*/React.createElement(ElementsContext.Provider, {
	    value: ctx
	  }, children);
	};
	Elements.propTypes = {
	  stripe: propTypes.any,
	  options: propTypes.object
	};
	var useElementsContextWithUseCase = function useElementsContextWithUseCase(useCaseMessage) {
	  var ctx = React.useContext(ElementsContext);
	  return parseElementsContext(ctx, useCaseMessage);
	};
	/**
	 * @docs https://stripe.com/docs/stripe-js/react#useelements-hook
	 */

	var useElements = function useElements() {
	  var _useElementsContextWi = useElementsContextWithUseCase('calls useElements()'),
	      elements = _useElementsContextWi.elements;

	  return elements;
	};
	/**
	 * @docs https://stripe.com/docs/stripe-js/react#usestripe-hook
	 */

	var useStripe = function useStripe() {
	  var _useElementsContextWi2 = useElementsContextWithUseCase('calls useStripe()'),
	      stripe = _useElementsContextWi2.stripe;

	  return stripe;
	};
	/**
	 * @docs https://stripe.com/docs/stripe-js/react#elements-consumer
	 */

	var ElementsConsumer = function ElementsConsumer(_ref2) {
	  var children = _ref2.children;
	  var ctx = useElementsContextWithUseCase('mounts <ElementsConsumer>'); // Assert to satisfy the busted React.FC return type (it should be ReactNode)

	  return children(ctx);
	};
	ElementsConsumer.propTypes = {
	  children: propTypes.func.isRequired
	};

	var useCallbackReference = function useCallbackReference(cb) {
	  var ref = React.useRef(cb);
	  React.useEffect(function () {
	    ref.current = cb;
	  }, [cb]);
	  return function () {
	    if (ref.current) {
	      ref.current.apply(ref, arguments);
	    }
	  };
	};

	var noop = function noop() {};

	var capitalized = function capitalized(str) {
	  return str.charAt(0).toUpperCase() + str.slice(1);
	};

	var createElementComponent = function createElementComponent(type, isServer) {
	  var displayName = "".concat(capitalized(type), "Element");

	  var ClientElement = function ClientElement(_ref) {
	    var id = _ref.id,
	        className = _ref.className,
	        _ref$options = _ref.options,
	        options = _ref$options === void 0 ? {} : _ref$options,
	        _ref$onBlur = _ref.onBlur,
	        onBlur = _ref$onBlur === void 0 ? noop : _ref$onBlur,
	        _ref$onFocus = _ref.onFocus,
	        onFocus = _ref$onFocus === void 0 ? noop : _ref$onFocus,
	        _ref$onReady = _ref.onReady,
	        onReady = _ref$onReady === void 0 ? noop : _ref$onReady,
	        _ref$onChange = _ref.onChange,
	        onChange = _ref$onChange === void 0 ? noop : _ref$onChange,
	        _ref$onEscape = _ref.onEscape,
	        onEscape = _ref$onEscape === void 0 ? noop : _ref$onEscape,
	        _ref$onClick = _ref.onClick,
	        onClick = _ref$onClick === void 0 ? noop : _ref$onClick;

	    var _useElementsContextWi = useElementsContextWithUseCase("mounts <".concat(displayName, ">")),
	        elements = _useElementsContextWi.elements;

	    var elementRef = React.useRef(null);
	    var domNode = React.useRef(null);
	    var callOnReady = useCallbackReference(onReady);
	    var callOnBlur = useCallbackReference(onBlur);
	    var callOnFocus = useCallbackReference(onFocus);
	    var callOnClick = useCallbackReference(onClick);
	    var callOnChange = useCallbackReference(onChange);
	    var callOnEscape = useCallbackReference(onEscape);
	    React.useLayoutEffect(function () {
	      if (elementRef.current == null && elements && domNode.current != null) {
	        var element = elements.create(type, options);
	        elementRef.current = element;
	        element.mount(domNode.current);
	        element.on('ready', function () {
	          return callOnReady(element);
	        });
	        element.on('change', callOnChange);
	        element.on('blur', callOnBlur);
	        element.on('focus', callOnFocus);
	        element.on('escape', callOnEscape); // Users can pass an an onClick prop on any Element component
	        // just as they could listen for the `click` event on any Element,
	        // but only the PaymentRequestButton will actually trigger the event.

	        element.on('click', callOnClick);
	      }
	    });
	    var prevOptions = usePrevious(options);
	    React.useEffect(function () {
	      if (!elementRef.current) {
	        return;
	      }

	      var updates = extractAllowedOptionsUpdates(options, prevOptions, ['paymentRequest']);

	      if (updates) {
	        elementRef.current.update(updates);
	      }
	    }, [options, prevOptions]);
	    React.useLayoutEffect(function () {
	      return function () {
	        if (elementRef.current) {
	          elementRef.current.destroy();
	        }
	      };
	    }, []);
	    return /*#__PURE__*/React.createElement("div", {
	      id: id,
	      className: className,
	      ref: domNode
	    });
	  }; // Only render the Element wrapper in a server environment.


	  var ServerElement = function ServerElement(props) {
	    // Validate that we are in the right context by calling useElementsContextWithUseCase.
	    useElementsContextWithUseCase("mounts <".concat(displayName, ">"));
	    var id = props.id,
	        className = props.className;
	    return /*#__PURE__*/React.createElement("div", {
	      id: id,
	      className: className
	    });
	  };

	  var Element = isServer ? ServerElement : ClientElement;
	  Element.propTypes = {
	    id: propTypes.string,
	    className: propTypes.string,
	    onChange: propTypes.func,
	    onBlur: propTypes.func,
	    onFocus: propTypes.func,
	    onReady: propTypes.func,
	    onClick: propTypes.func,
	    options: propTypes.object
	  };
	  Element.displayName = displayName;
	  Element.__elementType = type;
	  return Element;
	};

	var isServer = typeof window === 'undefined';
	/**
	 * Requires beta access:
	 * Contact [Stripe support](https://support.stripe.com/) for more information.
	 *
	 * @docs https://stripe.com/docs/stripe-js/react#element-components
	 */

	var AuBankAccountElement = createElementComponent('auBankAccount', isServer);
	/**
	 * @docs https://stripe.com/docs/stripe-js/react#element-components
	 */

	var CardElement = createElementComponent('card', isServer);
	/**
	 * @docs https://stripe.com/docs/stripe-js/react#element-components
	 */

	var CardNumberElement = createElementComponent('cardNumber', isServer);
	/**
	 * @docs https://stripe.com/docs/stripe-js/react#element-components
	 */

	var CardExpiryElement = createElementComponent('cardExpiry', isServer);
	/**
	 * @docs https://stripe.com/docs/stripe-js/react#element-components
	 */

	var CardCvcElement = createElementComponent('cardCvc', isServer);
	/**
	 * @docs https://stripe.com/docs/stripe-js/react#element-components
	 */

	var FpxBankElement = createElementComponent('fpxBank', isServer);
	/**
	 * @docs https://stripe.com/docs/stripe-js/react#element-components
	 */

	var IbanElement = createElementComponent('iban', isServer);
	/**
	 * @docs https://stripe.com/docs/stripe-js/react#element-components
	 */

	var IdealBankElement = createElementComponent('idealBank', isServer);
	/**
	 * @docs https://stripe.com/docs/stripe-js/react#element-components
	 */

	var P24BankElement = createElementComponent('p24Bank', isServer);
	/**
	 * @docs https://stripe.com/docs/stripe-js/react#element-components
	 */

	var EpsBankElement = createElementComponent('epsBank', isServer);
	var PaymentElement = createElementComponent('payment', isServer);
	/**
	 * @docs https://stripe.com/docs/stripe-js/react#element-components
	 */

	var PaymentRequestButtonElement = createElementComponent('paymentRequestButton', isServer);
	/**
	 * @docs https://stripe.com/docs/stripe-js/react#element-components
	 */

	var AfterpayClearpayMessageElement = createElementComponent('afterpayClearpayMessage', isServer);

	exports.AfterpayClearpayMessageElement = AfterpayClearpayMessageElement;
	exports.AuBankAccountElement = AuBankAccountElement;
	exports.CardCvcElement = CardCvcElement;
	exports.CardElement = CardElement;
	exports.CardExpiryElement = CardExpiryElement;
	exports.CardNumberElement = CardNumberElement;
	exports.Elements = Elements;
	exports.ElementsConsumer = ElementsConsumer;
	exports.EpsBankElement = EpsBankElement;
	exports.FpxBankElement = FpxBankElement;
	exports.IbanElement = IbanElement;
	exports.IdealBankElement = IdealBankElement;
	exports.P24BankElement = P24BankElement;
	exports.PaymentElement = PaymentElement;
	exports.PaymentRequestButtonElement = PaymentRequestButtonElement;
	exports.useElements = useElements;
	exports.useStripe = useStripe;

	Object.defineProperty(exports, '__esModule', { value: true });

})));


/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _objectWithoutProperties;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__objectWithoutPropertiesLoose__ = __webpack_require__(114);

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = Object(__WEBPACK_IMPORTED_MODULE_0__objectWithoutPropertiesLoose__["a" /* default */])(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _classCallCheck;
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

/***/ }),
/* 132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _createClass;
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

/***/ }),
/* 133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _possibleConstructorReturn;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_esm_typeof__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assertThisInitialized__ = __webpack_require__(94);


function _possibleConstructorReturn(self, call) {
  if (call && (Object(__WEBPACK_IMPORTED_MODULE_0__helpers_esm_typeof__["a" /* default */])(call) === "object" || typeof call === "function")) {
    return call;
  }

  return Object(__WEBPACK_IMPORTED_MODULE_1__assertThisInitialized__["a" /* default */])(self);
}

/***/ }),
/* 134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _typeof;
function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

/***/ }),
/* 135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _getPrototypeOf;
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

/***/ }),
/* 136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _inherits;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__setPrototypeOf__ = __webpack_require__(811);

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object(__WEBPACK_IMPORTED_MODULE_0__setPrototypeOf__["a" /* default */])(subClass, superClass);
}

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.canUseDOM = exports.slidesOnLeft = exports.slidesOnRight = exports.siblingDirection = exports.getTotalSlides = exports.getPostClones = exports.getPreClones = exports.getTrackLeft = exports.getTrackAnimateCSS = exports.getTrackCSS = exports.checkSpecKeys = exports.getSlideCount = exports.checkNavigable = exports.getNavigableIndexes = exports.swipeEnd = exports.swipeMove = exports.swipeStart = exports.keyHandler = exports.changeSlide = exports.slideHandler = exports.initializedState = exports.extractObject = exports.canGoNext = exports.getSwipeDirection = exports.getHeight = exports.getWidth = exports.lazySlidesOnRight = exports.lazySlidesOnLeft = exports.lazyEndIndex = exports.lazyStartIndex = exports.getRequiredLazySlides = exports.getOnDemandLazySlides = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(36);

var _reactDom2 = _interopRequireDefault(_reactDom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getOnDemandLazySlides = exports.getOnDemandLazySlides = function getOnDemandLazySlides(spec) {
  var onDemandSlides = [];
  var startIndex = lazyStartIndex(spec);
  var endIndex = lazyEndIndex(spec);
  for (var slideIndex = startIndex; slideIndex < endIndex; slideIndex++) {
    if (spec.lazyLoadedList.indexOf(slideIndex) < 0) {
      onDemandSlides.push(slideIndex);
    }
  }
  return onDemandSlides;
};

// return list of slides that need to be present
var getRequiredLazySlides = exports.getRequiredLazySlides = function getRequiredLazySlides(spec) {
  var requiredSlides = [];
  var startIndex = lazyStartIndex(spec);
  var endIndex = lazyEndIndex(spec);
  for (var slideIndex = startIndex; slideIndex < endIndex; slideIndex++) {
    requiredSlides.push(slideIndex);
  }
  return requiredSlides;
};

// startIndex that needs to be present
var lazyStartIndex = exports.lazyStartIndex = function lazyStartIndex(spec) {
  return spec.currentSlide - lazySlidesOnLeft(spec);
};
var lazyEndIndex = exports.lazyEndIndex = function lazyEndIndex(spec) {
  return spec.currentSlide + lazySlidesOnRight(spec);
};
var lazySlidesOnLeft = exports.lazySlidesOnLeft = function lazySlidesOnLeft(spec) {
  return spec.centerMode ? Math.floor(spec.slidesToShow / 2) + (parseInt(spec.centerPadding) > 0 ? 1 : 0) : 0;
};
var lazySlidesOnRight = exports.lazySlidesOnRight = function lazySlidesOnRight(spec) {
  return spec.centerMode ? Math.floor((spec.slidesToShow - 1) / 2) + 1 + (parseInt(spec.centerPadding) > 0 ? 1 : 0) : spec.slidesToShow;
};

// get width of an element
var getWidth = exports.getWidth = function getWidth(elem) {
  return elem && elem.offsetWidth || 0;
};
var getHeight = exports.getHeight = function getHeight(elem) {
  return elem && elem.offsetHeight || 0;
};
var getSwipeDirection = exports.getSwipeDirection = function getSwipeDirection(touchObject) {
  var verticalSwiping = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var xDist, yDist, r, swipeAngle;
  xDist = touchObject.startX - touchObject.curX;
  yDist = touchObject.startY - touchObject.curY;
  r = Math.atan2(yDist, xDist);
  swipeAngle = Math.round(r * 180 / Math.PI);
  if (swipeAngle < 0) {
    swipeAngle = 360 - Math.abs(swipeAngle);
  }
  if (swipeAngle <= 45 && swipeAngle >= 0 || swipeAngle <= 360 && swipeAngle >= 315) {
    return "left";
  }
  if (swipeAngle >= 135 && swipeAngle <= 225) {
    return "right";
  }
  if (verticalSwiping === true) {
    if (swipeAngle >= 35 && swipeAngle <= 135) {
      return "up";
    } else {
      return "down";
    }
  }

  return "vertical";
};

// whether or not we can go next
var canGoNext = exports.canGoNext = function canGoNext(spec) {
  var canGo = true;
  if (!spec.infinite) {
    if (spec.centerMode && spec.currentSlide >= spec.slideCount - 1) {
      canGo = false;
    } else if (spec.slideCount <= spec.slidesToShow || spec.currentSlide >= spec.slideCount - spec.slidesToShow) {
      canGo = false;
    }
  }
  return canGo;
};

// given an object and a list of keys, return new object with given keys
var extractObject = exports.extractObject = function extractObject(spec, keys) {
  var newObject = {};
  keys.forEach(function (key) {
    return newObject[key] = spec[key];
  });
  return newObject;
};

// get initialized state
var initializedState = exports.initializedState = function initializedState(spec) {
  // spec also contains listRef, trackRef
  var slideCount = _react2.default.Children.count(spec.children);
  var listWidth = Math.ceil(getWidth(_reactDom2.default.findDOMNode(spec.listRef)));
  var trackWidth = Math.ceil(getWidth(_reactDom2.default.findDOMNode(spec.trackRef)));
  var slideWidth = void 0;
  if (!spec.vertical) {
    var centerPaddingAdj = spec.centerMode && parseInt(spec.centerPadding) * 2;
    if (typeof spec.centerPadding === "string" && spec.centerPadding.slice(-1) === "%") {
      centerPaddingAdj *= listWidth / 100;
    }
    slideWidth = Math.ceil((listWidth - centerPaddingAdj) / spec.slidesToShow);
  } else {
    slideWidth = listWidth;
  }
  var slideHeight = _reactDom2.default.findDOMNode(spec.listRef) && getHeight(_reactDom2.default.findDOMNode(spec.listRef).querySelector('[data-index="0"]'));
  var listHeight = slideHeight * spec.slidesToShow;
  var currentSlide = spec.currentSlide === undefined ? spec.initialSlide : spec.currentSlide;
  if (spec.rtl && spec.currentSlide === undefined) {
    currentSlide = slideCount - 1 - spec.initialSlide;
  }
  var lazyLoadedList = spec.lazyLoadedList || [];
  var slidesToLoad = getOnDemandLazySlides({ currentSlide: currentSlide, lazyLoadedList: lazyLoadedList }, spec);
  lazyLoadedList.concat(slidesToLoad);

  var state = {
    slideCount: slideCount,
    slideWidth: slideWidth,
    listWidth: listWidth,
    trackWidth: trackWidth,
    currentSlide: currentSlide,
    slideHeight: slideHeight,
    listHeight: listHeight,
    lazyLoadedList: lazyLoadedList
  };

  if (spec.autoplaying === null && spec.autoplay) {
    state["autoplaying"] = "playing";
  }

  return state;
};

var slideHandler = exports.slideHandler = function slideHandler(spec) {
  var waitForAnimate = spec.waitForAnimate,
      animating = spec.animating,
      fade = spec.fade,
      infinite = spec.infinite,
      index = spec.index,
      slideCount = spec.slideCount,
      lazyLoadedList = spec.lazyLoadedList,
      lazyLoad = spec.lazyLoad,
      currentSlide = spec.currentSlide,
      centerMode = spec.centerMode,
      slidesToScroll = spec.slidesToScroll,
      slidesToShow = spec.slidesToShow,
      useCSS = spec.useCSS;

  if (waitForAnimate && animating) return {};
  var animationSlide = index,
      finalSlide = void 0,
      animationLeft = void 0,
      finalLeft = void 0;
  var state = {},
      nextState = {};
  if (fade) {
    if (!infinite && (index < 0 || index >= slideCount)) return {};
    if (index < 0) {
      animationSlide = index + slideCount;
    } else if (index >= slideCount) {
      animationSlide = index - slideCount;
    }
    if (lazyLoad && lazyLoadedList.indexOf(animationSlide) < 0) {
      lazyLoadedList.push(animationSlide);
    }
    state = {
      animating: true,
      currentSlide: animationSlide,
      lazyLoadedList: lazyLoadedList
    };
    nextState = { animating: false };
  } else {
    finalSlide = animationSlide;
    if (animationSlide < 0) {
      finalSlide = animationSlide + slideCount;
      if (!infinite) finalSlide = 0;else if (slideCount % slidesToScroll !== 0) finalSlide = slideCount - slideCount % slidesToScroll;
    } else if (!canGoNext(spec) && animationSlide > currentSlide) {
      animationSlide = finalSlide = currentSlide;
    } else if (centerMode && animationSlide >= slideCount) {
      animationSlide = infinite ? slideCount : slideCount - 1;
      finalSlide = infinite ? 0 : slideCount - 1;
    } else if (animationSlide >= slideCount) {
      finalSlide = animationSlide - slideCount;
      if (!infinite) finalSlide = slideCount - slidesToShow;else if (slideCount % slidesToScroll !== 0) finalSlide = 0;
    }
    animationLeft = getTrackLeft(_extends({}, spec, { slideIndex: animationSlide }));
    finalLeft = getTrackLeft(_extends({}, spec, { slideIndex: finalSlide }));
    if (!infinite) {
      if (animationLeft === finalLeft) animationSlide = finalSlide;
      animationLeft = finalLeft;
    }
    lazyLoad && lazyLoadedList.concat(getOnDemandLazySlides(_extends({}, spec, { currentSlide: animationSlide })));
    if (!useCSS) {
      state = {
        currentSlide: finalSlide,
        trackStyle: getTrackCSS(_extends({}, spec, { left: finalLeft })),
        lazyLoadedList: lazyLoadedList
      };
    } else {
      state = {
        animating: true,
        currentSlide: finalSlide,
        trackStyle: getTrackAnimateCSS(_extends({}, spec, { left: animationLeft })),
        lazyLoadedList: lazyLoadedList
      };
      nextState = {
        animating: false,
        currentSlide: finalSlide,
        trackStyle: getTrackCSS(_extends({}, spec, { left: finalLeft })),
        swipeLeft: null
      };
    }
  }
  return { state: state, nextState: nextState };
};

var changeSlide = exports.changeSlide = function changeSlide(spec, options) {
  var indexOffset, previousInt, slideOffset, unevenOffset, targetSlide;
  var slidesToScroll = spec.slidesToScroll,
      slidesToShow = spec.slidesToShow,
      slideCount = spec.slideCount,
      currentSlide = spec.currentSlide,
      lazyLoad = spec.lazyLoad,
      infinite = spec.infinite;

  unevenOffset = slideCount % slidesToScroll !== 0;
  indexOffset = unevenOffset ? 0 : (slideCount - currentSlide) % slidesToScroll;

  if (options.message === "previous") {
    slideOffset = indexOffset === 0 ? slidesToScroll : slidesToShow - indexOffset;
    targetSlide = currentSlide - slideOffset;
    if (lazyLoad && !infinite) {
      previousInt = currentSlide - slideOffset;
      targetSlide = previousInt === -1 ? slideCount - 1 : previousInt;
    }
  } else if (options.message === "next") {
    slideOffset = indexOffset === 0 ? slidesToScroll : indexOffset;
    targetSlide = currentSlide + slideOffset;
    if (lazyLoad && !infinite) {
      targetSlide = (currentSlide + slidesToScroll) % slideCount + indexOffset;
    }
  } else if (options.message === "dots") {
    // Click on dots
    targetSlide = options.index * options.slidesToScroll;
    if (targetSlide === options.currentSlide) {
      return null;
    }
  } else if (options.message === "children") {
    // Click on the slides
    targetSlide = options.index;
    if (targetSlide === options.currentSlide) {
      return null;
    }
    if (infinite) {
      var direction = siblingDirection(_extends({}, spec, { targetSlide: targetSlide }));
      if (targetSlide > options.currentSlide && direction === "left") {
        targetSlide = targetSlide - slideCount;
      } else if (targetSlide < options.currentSlide && direction === "right") {
        targetSlide = targetSlide + slideCount;
      }
    }
  } else if (options.message === "index") {
    targetSlide = Number(options.index);
    if (targetSlide === options.currentSlide) {
      return null;
    }
  }
  return targetSlide;
};
var keyHandler = exports.keyHandler = function keyHandler(e, accessibility, rtl) {
  if (e.target.tagName.match("TEXTAREA|INPUT|SELECT") || !accessibility) return "";
  if (e.keyCode === 37) return rtl ? "next" : "previous";
  if (e.keyCode === 39) return rtl ? "previous" : "next";
  return "";
};

var swipeStart = exports.swipeStart = function swipeStart(e, swipe, draggable) {
  e.target.tagName === "IMG" && e.preventDefault();
  if (!swipe || !draggable && e.type.indexOf("mouse") !== -1) return "";
  return {
    dragging: true,
    touchObject: {
      startX: e.touches ? e.touches[0].pageX : e.clientX,
      startY: e.touches ? e.touches[0].pageY : e.clientY,
      curX: e.touches ? e.touches[0].pageX : e.clientX,
      curY: e.touches ? e.touches[0].pageY : e.clientY
    }
  };
};
var swipeMove = exports.swipeMove = function swipeMove(e, spec) {
  // spec also contains, trackRef and slideIndex
  var scrolling = spec.scrolling,
      animating = spec.animating,
      vertical = spec.vertical,
      swipeToSlide = spec.swipeToSlide,
      verticalSwiping = spec.verticalSwiping,
      rtl = spec.rtl,
      currentSlide = spec.currentSlide,
      edgeFriction = spec.edgeFriction,
      edgeDragged = spec.edgeDragged,
      onEdge = spec.onEdge,
      swiped = spec.swiped,
      swiping = spec.swiping,
      slideCount = spec.slideCount,
      slidesToScroll = spec.slidesToScroll,
      infinite = spec.infinite,
      touchObject = spec.touchObject,
      swipeEvent = spec.swipeEvent,
      listHeight = spec.listHeight,
      listWidth = spec.listWidth;

  if (scrolling) return;
  if (animating) return e.preventDefault();
  if (vertical && swipeToSlide && verticalSwiping) e.preventDefault();
  var swipeLeft = void 0,
      state = {};
  var curLeft = getTrackLeft(spec);
  touchObject.curX = e.touches ? e.touches[0].pageX : e.clientX;
  touchObject.curY = e.touches ? e.touches[0].pageY : e.clientY;
  touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curX - touchObject.startX, 2)));
  var verticalSwipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curY - touchObject.startY, 2)));
  if (!verticalSwiping && !swiping && verticalSwipeLength > 10) {
    return { scrolling: true };
  }
  if (verticalSwiping) touchObject.swipeLength = verticalSwipeLength;
  var positionOffset = (!rtl ? 1 : -1) * (touchObject.curX > touchObject.startX ? 1 : -1);
  if (verticalSwiping) positionOffset = touchObject.curY > touchObject.startY ? 1 : -1;

  var dotCount = Math.ceil(slideCount / slidesToScroll);
  var swipeDirection = getSwipeDirection(spec.touchObject, verticalSwiping);
  var touchSwipeLength = touchObject.swipeLength;
  if (!infinite) {
    if (currentSlide === 0 && swipeDirection === "right" || currentSlide + 1 >= dotCount && swipeDirection === "left" || !canGoNext(spec) && swipeDirection === "left") {
      touchSwipeLength = touchObject.swipeLength * edgeFriction;
      if (edgeDragged === false && onEdge) {
        onEdge(swipeDirection);
        state["edgeDragged"] = true;
      }
    }
  }
  if (!swiped && swipeEvent) {
    swipeEvent(swipeDirection);
    state["swiped"] = true;
  }
  if (!vertical) {
    if (!rtl) {
      swipeLeft = curLeft + touchSwipeLength * positionOffset;
    } else {
      swipeLeft = curLeft - touchSwipeLength * positionOffset;
    }
  } else {
    swipeLeft = curLeft + touchSwipeLength * (listHeight / listWidth) * positionOffset;
  }
  if (verticalSwiping) {
    swipeLeft = curLeft + touchSwipeLength * positionOffset;
  }
  state = _extends({}, state, {
    touchObject: touchObject,
    swipeLeft: swipeLeft,
    trackStyle: getTrackCSS(_extends({}, spec, { left: swipeLeft }))
  });
  if (Math.abs(touchObject.curX - touchObject.startX) < Math.abs(touchObject.curY - touchObject.startY) * 0.8) {
    return state;
  }
  if (touchObject.swipeLength > 10) {
    state["swiping"] = true;
    e.preventDefault();
  }
  return state;
};
var swipeEnd = exports.swipeEnd = function swipeEnd(e, spec) {
  var dragging = spec.dragging,
      swipe = spec.swipe,
      touchObject = spec.touchObject,
      listWidth = spec.listWidth,
      touchThreshold = spec.touchThreshold,
      verticalSwiping = spec.verticalSwiping,
      listHeight = spec.listHeight,
      currentSlide = spec.currentSlide,
      swipeToSlide = spec.swipeToSlide,
      scrolling = spec.scrolling,
      onSwipe = spec.onSwipe;

  if (!dragging) {
    if (swipe) e.preventDefault();
    return {};
  }
  var minSwipe = verticalSwiping ? listHeight / touchThreshold : listWidth / touchThreshold;
  var swipeDirection = getSwipeDirection(touchObject, verticalSwiping);
  // reset the state of touch related state variables.
  var state = {
    dragging: false,
    edgeDragged: false,
    scrolling: false,
    swiping: false,
    swiped: false,
    swipeLeft: null,
    touchObject: {}
  };
  if (scrolling) {
    return state;
  }
  if (!touchObject.swipeLength) {
    return state;
  }
  if (touchObject.swipeLength > minSwipe) {
    e.preventDefault();
    if (onSwipe) {
      onSwipe(swipeDirection);
    }
    var slideCount = void 0,
        newSlide = void 0;
    switch (swipeDirection) {
      case "left":
      case "up":
        newSlide = currentSlide + getSlideCount(spec);
        slideCount = swipeToSlide ? checkNavigable(spec, newSlide) : newSlide;
        state["currentDirection"] = 0;
        break;
      case "right":
      case "down":
        newSlide = currentSlide - getSlideCount(spec);
        slideCount = swipeToSlide ? checkNavigable(spec, newSlide) : newSlide;
        state["currentDirection"] = 1;
        break;
      default:
        slideCount = currentSlide;
    }
    state["triggerSlideHandler"] = slideCount;
  } else {
    // Adjust the track back to it's original position.
    var currentLeft = getTrackLeft(spec);
    state["trackStyle"] = getTrackAnimateCSS(_extends({}, spec, { left: currentLeft }));
  }
  return state;
};
var getNavigableIndexes = exports.getNavigableIndexes = function getNavigableIndexes(spec) {
  var max = spec.infinite ? spec.slideCount * 2 : spec.slideCount;
  var breakpoint = spec.infinite ? spec.slidesToShow * -1 : 0;
  var counter = spec.infinite ? spec.slidesToShow * -1 : 0;
  var indexes = [];
  while (breakpoint < max) {
    indexes.push(breakpoint);
    breakpoint = counter + spec.slidesToScroll;
    counter += Math.min(spec.slidesToScroll, spec.slidesToShow);
  }
  return indexes;
};
var checkNavigable = exports.checkNavigable = function checkNavigable(spec, index) {
  var navigables = getNavigableIndexes(spec);
  var prevNavigable = 0;
  if (index > navigables[navigables.length - 1]) {
    index = navigables[navigables.length - 1];
  } else {
    for (var n in navigables) {
      if (index < navigables[n]) {
        index = prevNavigable;
        break;
      }
      prevNavigable = navigables[n];
    }
  }
  return index;
};
var getSlideCount = exports.getSlideCount = function getSlideCount(spec) {
  var centerOffset = spec.centerMode ? spec.slideWidth * Math.floor(spec.slidesToShow / 2) : 0;
  if (spec.swipeToSlide) {
    var swipedSlide = void 0;
    var slickList = _reactDom2.default.findDOMNode(spec.listRef);
    var slides = slickList.querySelectorAll(".slick-slide");
    Array.from(slides).every(function (slide) {
      if (!spec.vertical) {
        if (slide.offsetLeft - centerOffset + getWidth(slide) / 2 > spec.swipeLeft * -1) {
          swipedSlide = slide;
          return false;
        }
      } else {
        if (slide.offsetTop + getHeight(slide) / 2 > spec.swipeLeft * -1) {
          swipedSlide = slide;
          return false;
        }
      }

      return true;
    });

    if (!swipedSlide) {
      return 0;
    }
    var currentIndex = spec.rtl === true ? spec.slideCount - spec.currentSlide : spec.currentSlide;
    var slidesTraversed = Math.abs(swipedSlide.dataset.index - currentIndex) || 1;
    return slidesTraversed;
  } else {
    return spec.slidesToScroll;
  }
};

var checkSpecKeys = exports.checkSpecKeys = function checkSpecKeys(spec, keysArray) {
  return keysArray.reduce(function (value, key) {
    return value && spec.hasOwnProperty(key);
  }, true) ? null : console.error("Keys Missing:", spec);
};

var getTrackCSS = exports.getTrackCSS = function getTrackCSS(spec) {
  checkSpecKeys(spec, ["left", "variableWidth", "slideCount", "slidesToShow", "slideWidth"]);
  var trackWidth = void 0,
      trackHeight = void 0;
  var trackChildren = spec.slideCount + 2 * spec.slidesToShow;
  if (!spec.vertical) {
    trackWidth = getTotalSlides(spec) * spec.slideWidth;
  } else {
    trackHeight = trackChildren * spec.slideHeight;
  }
  var style = {
    opacity: 1,
    transition: "",
    WebkitTransition: ""
  };
  if (spec.useTransform) {
    var WebkitTransform = !spec.vertical ? "translate3d(" + spec.left + "px, 0px, 0px)" : "translate3d(0px, " + spec.left + "px, 0px)";
    var transform = !spec.vertical ? "translate3d(" + spec.left + "px, 0px, 0px)" : "translate3d(0px, " + spec.left + "px, 0px)";
    var msTransform = !spec.vertical ? "translateX(" + spec.left + "px)" : "translateY(" + spec.left + "px)";
    style = _extends({}, style, {
      WebkitTransform: WebkitTransform,
      transform: transform,
      msTransform: msTransform
    });
  } else {
    if (spec.vertical) {
      style["top"] = spec.left;
    } else {
      style["left"] = spec.left;
    }
  }
  if (spec.fade) style = { opacity: 1 };
  if (trackWidth) style.width = trackWidth;
  if (trackHeight) style.height = trackHeight;

  // Fallback for IE8
  if (window && !window.addEventListener && window.attachEvent) {
    if (!spec.vertical) {
      style.marginLeft = spec.left + "px";
    } else {
      style.marginTop = spec.left + "px";
    }
  }

  return style;
};
var getTrackAnimateCSS = exports.getTrackAnimateCSS = function getTrackAnimateCSS(spec) {
  checkSpecKeys(spec, ["left", "variableWidth", "slideCount", "slidesToShow", "slideWidth", "speed", "cssEase"]);
  var style = getTrackCSS(spec);
  // useCSS is true by default so it can be undefined
  if (spec.useTransform) {
    style.WebkitTransition = "-webkit-transform " + spec.speed + "ms " + spec.cssEase;
    style.transition = "transform " + spec.speed + "ms " + spec.cssEase;
  } else {
    if (spec.vertical) {
      style.transition = "top " + spec.speed + "ms " + spec.cssEase;
    } else {
      style.transition = "left " + spec.speed + "ms " + spec.cssEase;
    }
  }
  return style;
};
var getTrackLeft = exports.getTrackLeft = function getTrackLeft(spec) {
  if (spec.unslick) {
    return 0;
  }

  checkSpecKeys(spec, ["slideIndex", "trackRef", "infinite", "centerMode", "slideCount", "slidesToShow", "slidesToScroll", "slideWidth", "listWidth", "variableWidth", "slideHeight"]);

  var slideIndex = spec.slideIndex,
      trackRef = spec.trackRef,
      infinite = spec.infinite,
      centerMode = spec.centerMode,
      slideCount = spec.slideCount,
      slidesToShow = spec.slidesToShow,
      slidesToScroll = spec.slidesToScroll,
      slideWidth = spec.slideWidth,
      listWidth = spec.listWidth,
      variableWidth = spec.variableWidth,
      slideHeight = spec.slideHeight,
      fade = spec.fade,
      vertical = spec.vertical;


  var slideOffset = 0;
  var targetLeft;
  var targetSlide;
  var verticalOffset = 0;

  if (fade || spec.slideCount === 1) {
    return 0;
  }

  var slidesToOffset = 0;
  if (infinite) {
    slidesToOffset = -getPreClones(spec); // bring active slide to the beginning of visual area
    // if next scroll doesn't have enough children, just reach till the end of original slides instead of shifting slidesToScroll children
    if (slideCount % slidesToScroll !== 0 && slideIndex + slidesToScroll > slideCount) {
      slidesToOffset = -(slideIndex > slideCount ? slidesToShow - (slideIndex - slideCount) : slideCount % slidesToScroll);
    }
    // shift current slide to center of the frame
    if (centerMode) {
      slidesToOffset += parseInt(slidesToShow / 2);
    }
  } else {
    if (slideCount % slidesToScroll !== 0 && slideIndex + slidesToScroll > slideCount) {
      slidesToOffset = slidesToShow - slideCount % slidesToScroll;
    }
    if (centerMode) {
      slidesToOffset = parseInt(slidesToShow / 2);
    }
  }
  slideOffset = slidesToOffset * slideWidth;
  verticalOffset = slidesToOffset * slideHeight;

  if (!vertical) {
    targetLeft = slideIndex * slideWidth * -1 + slideOffset;
  } else {
    targetLeft = slideIndex * slideHeight * -1 + verticalOffset;
  }

  if (variableWidth === true) {
    var targetSlideIndex;
    var trackElem = _reactDom2.default.findDOMNode(trackRef);
    targetSlideIndex = slideIndex + getPreClones(spec);
    targetSlide = trackElem && trackElem.childNodes[targetSlideIndex];
    targetLeft = targetSlide ? targetSlide.offsetLeft * -1 : 0;
    if (centerMode === true) {
      targetSlideIndex = infinite ? slideIndex + getPreClones(spec) : slideIndex;
      targetSlide = trackElem && trackElem.children[targetSlideIndex];
      targetLeft = 0;
      for (var slide = 0; slide < targetSlideIndex; slide++) {
        targetLeft -= trackElem && trackElem.children[slide] && trackElem.children[slide].offsetWidth;
      }
      targetLeft -= parseInt(spec.centerPadding);
      targetLeft += targetSlide && (listWidth - targetSlide.offsetWidth) / 2;
    }
  }

  return targetLeft;
};

var getPreClones = exports.getPreClones = function getPreClones(spec) {
  if (spec.unslick || !spec.infinite) {
    return 0;
  }
  if (spec.variableWidth) {
    return spec.slideCount;
  }
  return spec.slidesToShow + (spec.centerMode ? 1 : 0);
};

var getPostClones = exports.getPostClones = function getPostClones(spec) {
  if (spec.unslick || !spec.infinite) {
    return 0;
  }
  return spec.slideCount;
};

var getTotalSlides = exports.getTotalSlides = function getTotalSlides(spec) {
  return spec.slideCount === 1 ? 1 : getPreClones(spec) + spec.slideCount + getPostClones(spec);
};
var siblingDirection = exports.siblingDirection = function siblingDirection(spec) {
  if (spec.targetSlide > spec.currentSlide) {
    if (spec.targetSlide > spec.currentSlide + slidesOnRight(spec)) {
      return "left";
    }
    return "right";
  } else {
    if (spec.targetSlide < spec.currentSlide - slidesOnLeft(spec)) {
      return "right";
    }
    return "left";
  }
};

var slidesOnRight = exports.slidesOnRight = function slidesOnRight(_ref) {
  var slidesToShow = _ref.slidesToShow,
      centerMode = _ref.centerMode,
      rtl = _ref.rtl,
      centerPadding = _ref.centerPadding;

  // returns no of slides on the right of active slide
  if (centerMode) {
    var right = (slidesToShow - 1) / 2 + 1;
    if (parseInt(centerPadding) > 0) right += 1;
    if (rtl && slidesToShow % 2 === 0) right += 1;
    return right;
  }
  if (rtl) {
    return 0;
  }
  return slidesToShow - 1;
};

var slidesOnLeft = exports.slidesOnLeft = function slidesOnLeft(_ref2) {
  var slidesToShow = _ref2.slidesToShow,
      centerMode = _ref2.centerMode,
      rtl = _ref2.rtl,
      centerPadding = _ref2.centerPadding;

  // returns no of slides on the left of active slide
  if (centerMode) {
    var left = (slidesToShow - 1) / 2 + 1;
    if (parseInt(centerPadding) > 0) left += 1;
    if (!rtl && slidesToShow % 2 === 0) left += 1;
    return left;
  }
  if (rtl) {
    return slidesToShow - 1;
  }
  return 0;
};

var canUseDOM = exports.canUseDOM = function canUseDOM() {
  return !!(typeof window !== "undefined" && window.document && window.document.createElement);
};

/***/ }),
/* 138 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 139 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAMCAMAAABYzB2OAAAAOVBMVEUAAAD//v6QkJHGxsbf39/x8fE6Ojw9PT1GRkZRUVFpaWlwcHCIiIiioqKxsbEEBAQeHh4NDg4pKSk48VfqAAAAD3RSTlMAA4tHJRD18ubZu7GVdGCDdXy6AAAAOklEQVQI12NgYGBkQAOMYEwk4BViZ0bRycLBDwRcrHARRiZBfgE+EIFQyMbPzQpUysnPQ5QlCPPJAQCnWAFKCSfymwAAAABJRU5ErkJggg=="

/***/ }),
/* 140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var parse=function parse(queryString){var query={};var pairs=(queryString[0]==='?'?queryString.substr(1):queryString).split('&');for(var i=0;i<pairs.length;i++){var pair=pairs[i].split('=');query[decodeURIComponent(pair[0])]=decodeURIComponent(pair[1]||'');}return query;};/* harmony default export */ __webpack_exports__["a"] = ({parse:parse});

/***/ }),
/* 141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SIGN_IN_EVENTS; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_ga__ = __webpack_require__(645);
var TRACKING_ID= true?'UA-35583129-1':'UA-35583129-4';var sendWhoIsAccessing=function sendWhoIsAccessing(userEmail){__WEBPACK_IMPORTED_MODULE_0_react_ga__["a" /* default */].initialize(TRACKING_ID);var ga=__WEBPACK_IMPORTED_MODULE_0_react_ga__["a" /* default */].ga();ga('send','event','Login','Login Success',window.location.origin,{dimension1:userEmail,dimension2:window.location.origin});};var fireTracking=function fireTracking(){__WEBPACK_IMPORTED_MODULE_0_react_ga__["a" /* default */].initialize(TRACKING_ID);__WEBPACK_IMPORTED_MODULE_0_react_ga__["a" /* default */].pageview(window.location.pathname+window.location.search);};var sendEvent=function sendEvent(action,label){__WEBPACK_IMPORTED_MODULE_0_react_ga__["a" /* default */].initialize(TRACKING_ID);__WEBPACK_IMPORTED_MODULE_0_react_ga__["a" /* default */].event({category:'Lunch Feedback',action:action,label:label});};// Sign-in funnel events. Fixed names only: never pass an email, token or user id.
var SIGN_IN_EVENTS={MAGIC_LINK_REQUESTED:'magic_link_requested',MAGIC_LINK_SIGNED_IN:'magic_link_signed_in',PASSWORD_FALLBACK_CLICKED:'password_fallback_clicked'};var sendSignInEvent=function sendSignInEvent(action,label){try{__WEBPACK_IMPORTED_MODULE_0_react_ga__["a" /* default */].initialize(TRACKING_ID);__WEBPACK_IMPORTED_MODULE_0_react_ga__["a" /* default */].event(label?{category:'Sign In',action:action,label:label}:{category:'Sign In',action:action});}catch(error){// Analytics must never break sign-in.
}};/* harmony default export */ __webpack_exports__["b"] = ({fireTracking:fireTracking,sendWhoIsAccessing:sendWhoIsAccessing,sendEvent:sendEvent,sendSignInEvent:sendSignInEvent});

/***/ }),
/* 142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isNarrowMenuViewport;
// Keep the responsive menu markup in step with the menu stylesheet.
function isNarrowMenuViewport(){if(typeof window==='undefined')return false;return typeof window.matchMedia==='function'?window.matchMedia('(max-width: 1024px)').matches:window.innerWidth<=1024;}

/***/ }),
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = supportLinkFrom;
/* harmony export (immutable) */ __webpack_exports__["d"] = withoutSupportLink;
/* harmony export (immutable) */ __webpack_exports__["e"] = withoutSupportLinkInPath;
/* harmony export (immutable) */ __webpack_exports__["c"] = withPendingSupportLink;
/* harmony export (immutable) */ __webpack_exports__["a"] = captureSupportLink;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__conversationStore__ = __webpack_require__(210);
function _toArray(arr){return Array.isArray(arr)?arr:Array.from(arr);}// Links from support reply emails: {web}/Menu?support=SUP-XXXXXXXXXXXX opens that conversation in
// the composer's panel. The id is read as the page loads, before the router reads the address, so
// the sign-in redirect (/?redirect=...) never carries it; it waits in this tab (conversationStore)
// until the signed-in customer's composer shows, and comes out of the address bar at once. An email
// sign-in link opens in another tab, so the page it goes to after signing in carries the id instead.
var PARAM='support';var CONVERSATION_ID=/^SUP-[A-Z0-9]{6,24}$/;function decode(value){try{return decodeURIComponent(value.replace(/\+/g,' '));}catch(e){// Malformed escapes: not a parameter we use.
return null;}}function pairs(search){return(search||'').replace(/^\?/,'').split('&');}function isSupportPair(pair){return decode(pair.split('=')[0])===PARAM;}/** The conversation id in a query string (?support=SUP-...), or null for none or anything else. */function supportLinkFrom(search){var pair=pairs(search).filter(isSupportPair)[0];if(!pair||pair.indexOf('=')<0)return null;var value=decode(pair.slice(pair.indexOf('=')+1));return value&&CONVERSATION_ID.test(value)?value:null;}/** The query string without its support parameter; the rest stays exactly as it was. */function withoutSupportLink(search){var rest=pairs(search).filter(function(pair){return!isSupportPair(pair);}).join('&');return rest?'?'+rest:'';}/** A path (with query and hash) without its support parameter. */function withoutSupportLinkInPath(path){if(!path)return path;var _path$split=path.split('#'),_path$split2=_toArray(_path$split),beforeHash=_path$split2[0],hashParts=_path$split2.slice(1);var hash=hashParts.length?'#'+hashParts.join('#'):'';var queryAt=beforeHash.indexOf('?');if(queryAt<0)return path;return''+beforeHash.slice(0,queryAt)+withoutSupportLink(beforeHash.slice(queryAt))+hash;}/**
 * Where to go after signing in, with the link waiting in this tab added (?support=), for a sign-in
 * that ends in another tab (magicLink.js): that tab's storage doesn't have it. No path means /Menu,
 * as there; a path with its own link, or no link waiting, stays as it is.
 */function withPendingSupportLink(path){var conversationId=Object(__WEBPACK_IMPORTED_MODULE_0__conversationStore__["f" /* readPendingConversation */])();if(!conversationId||!CONVERSATION_ID.test(conversationId))return path;var _split=(path||'/Menu').split('#'),_split2=_toArray(_split),beforeHash=_split2[0],hashParts=_split2.slice(1);var hash=hashParts.length?'#'+hashParts.join('#'):'';var queryAt=beforeHash.indexOf('?');var pathname=queryAt<0?beforeHash:beforeHash.slice(0,queryAt);var search=queryAt<0?'':beforeHash.slice(queryAt);if(supportLinkFrom(search))return path;var rest=withoutSupportLink(search);var query=rest?rest+'&':'?';return''+pathname+query+PARAM+'='+conversationId+hash;}/**
 * Call as the page loads, before the router starts (index.js; SupportDock reads a later one through
 * the router). A valid ?support= id is kept for the composer and taken out of the address bar, so a
 * reload or a copied address doesn't open it again; anything else is left alone. Returns the id.
 */function captureSupportLink(){var location=arguments.length>0&&arguments[0]!==undefined?arguments[0]:window.location;var history=arguments.length>1&&arguments[1]!==undefined?arguments[1]:window.history;var conversationId=supportLinkFrom(location.search);if(!conversationId)return null;Object(__WEBPACK_IMPORTED_MODULE_0__conversationStore__["m" /* writePendingConversation */])(conversationId);try{history.replaceState(history.state,document.title,''+location.pathname+withoutSupportLink(location.search)+location.hash);}catch(e){// The id is kept all the same; only the address keeps the parameter.
}return conversationId;}

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(9);
var document = __webpack_require__(3).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(3);
var core = __webpack_require__(31);
var LIBRARY = __webpack_require__(50);
var wksExt = __webpack_require__(216);
var defineProperty = __webpack_require__(16).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(83)('keys');
var uid = __webpack_require__(56);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 147 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(3).document;
module.exports = document && document.documentElement;


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(9);
var anObject = __webpack_require__(2);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(32)(Function.call, __webpack_require__(29).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 150 */
/***/ (function(module, exports) {

module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(9);
var setPrototypeOf = __webpack_require__(149).set;
module.exports = function (that, target, C) {
  var S = target.constructor;
  var P;
  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
    setPrototypeOf(that, P);
  } return that;
};


/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toInteger = __webpack_require__(34);
var defined = __webpack_require__(41);

module.exports = function repeat(count) {
  var str = String(defined(this));
  var res = '';
  var n = toInteger(count);
  if (n < 0 || n == Infinity) throw RangeError("Count can't be negative");
  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) res += str;
  return res;
};


/***/ }),
/* 153 */
/***/ (function(module, exports) {

// 20.2.2.28 Math.sign(x)
module.exports = Math.sign || function sign(x) {
  // eslint-disable-next-line no-self-compare
  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
};


/***/ }),
/* 154 */
/***/ (function(module, exports) {

// 20.2.2.14 Math.expm1(x)
var $expm1 = Math.expm1;
module.exports = (!$expm1
  // Old FF bug
  || $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168
  // Tor Browser bug
  || $expm1(-2e-17) != -2e-17
) ? function expm1(x) {
  return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
} : $expm1;


/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(50);
var $export = __webpack_require__(1);
var redefine = __webpack_require__(23);
var hide = __webpack_require__(22);
var Iterators = __webpack_require__(76);
var $iterCreate = __webpack_require__(156);
var setToStringTag = __webpack_require__(73);
var getPrototypeOf = __webpack_require__(30);
var ITERATOR = __webpack_require__(10)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(59);
var descriptor = __webpack_require__(55);
var setToStringTag = __webpack_require__(73);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(22)(IteratorPrototype, __webpack_require__(10)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

// helper for String#{startsWith, endsWith, includes}
var isRegExp = __webpack_require__(104);
var defined = __webpack_require__(41);

module.exports = function (that, searchString, NAME) {
  if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
  return String(defined(that));
};


/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

var MATCH = __webpack_require__(10)('match');
module.exports = function (KEY) {
  var re = /./;
  try {
    '/./'[KEY](re);
  } catch (e) {
    try {
      re[MATCH] = false;
      return !'/./'[KEY](re);
    } catch (f) { /* empty */ }
  } return true;
};


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(76);
var ITERATOR = __webpack_require__(10)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(16);
var createDesc = __webpack_require__(55);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(74);
var ITERATOR = __webpack_require__(10)('iterator');
var Iterators = __webpack_require__(76);
module.exports = __webpack_require__(31).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = __webpack_require__(434);

module.exports = function (original, length) {
  return new (speciesConstructor(original))(length);
};


/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)

var toObject = __webpack_require__(18);
var toAbsoluteIndex = __webpack_require__(58);
var toLength = __webpack_require__(11);
module.exports = function fill(value /* , start = 0, end = @length */) {
  var O = toObject(this);
  var length = toLength(O.length);
  var aLen = arguments.length;
  var index = toAbsoluteIndex(aLen > 1 ? arguments[1] : undefined, length);
  var end = aLen > 2 ? arguments[2] : undefined;
  var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
  while (endPos > index) O[index++] = value;
  return O;
};


/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(52);
var step = __webpack_require__(233);
var Iterators = __webpack_require__(76);
var toIObject = __webpack_require__(28);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(155)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var regexpFlags = __webpack_require__(86);

var nativeExec = RegExp.prototype.exec;
// This always refers to the native implementation, because the
// String#replace polyfill uses ./fix-regexp-well-known-symbol-logic.js,
// which loads this file before patching the method.
var nativeReplace = String.prototype.replace;

var patchedExec = nativeExec;

var LAST_INDEX = 'lastIndex';

var UPDATES_LAST_INDEX_WRONG = (function () {
  var re1 = /a/,
      re2 = /b*/g;
  nativeExec.call(re1, 'a');
  nativeExec.call(re2, 'a');
  return re1[LAST_INDEX] !== 0 || re2[LAST_INDEX] !== 0;
})();

// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED;

if (PATCH) {
  patchedExec = function exec(str) {
    var re = this;
    var lastIndex, reCopy, match, i;

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + re.source + '$(?!\\s)', regexpFlags.call(re));
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re[LAST_INDEX];

    match = nativeExec.call(re, str);

    if (UPDATES_LAST_INDEX_WRONG && match) {
      re[LAST_INDEX] = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
      // eslint-disable-next-line no-loop-func
      nativeReplace.call(match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    return match;
  };
}

module.exports = patchedExec;


/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var at = __webpack_require__(103)(true);

 // `AdvanceStringIndex` abstract operation
// https://tc39.github.io/ecma262/#sec-advancestringindex
module.exports = function (S, index, unicode) {
  return index + (unicode ? at(S, index).length : 1);
};


/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(32);
var invoke = __webpack_require__(223);
var html = __webpack_require__(148);
var cel = __webpack_require__(144);
var global = __webpack_require__(3);
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (__webpack_require__(33)(process) == 'process') {
    defer = function (id) {
      process.nextTick(ctx(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function (id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function (id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};


/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(3);
var macrotask = __webpack_require__(167).set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = __webpack_require__(33)(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function () {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function () {
      process.nextTick(flush);
    };
  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    var promise = Promise.resolve(undefined);
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    } last = task;
  };
};


/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 25.4.1.5 NewPromiseCapability(C)
var aFunction = __webpack_require__(20);

function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}

module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(3);
var DESCRIPTORS = __webpack_require__(12);
var LIBRARY = __webpack_require__(50);
var $typed = __webpack_require__(110);
var hide = __webpack_require__(22);
var redefineAll = __webpack_require__(64);
var fails = __webpack_require__(6);
var anInstance = __webpack_require__(62);
var toInteger = __webpack_require__(34);
var toLength = __webpack_require__(11);
var toIndex = __webpack_require__(243);
var gOPN = __webpack_require__(60).f;
var dP = __webpack_require__(16).f;
var arrayFill = __webpack_require__(163);
var setToStringTag = __webpack_require__(73);
var ARRAY_BUFFER = 'ArrayBuffer';
var DATA_VIEW = 'DataView';
var PROTOTYPE = 'prototype';
var WRONG_LENGTH = 'Wrong length!';
var WRONG_INDEX = 'Wrong index!';
var $ArrayBuffer = global[ARRAY_BUFFER];
var $DataView = global[DATA_VIEW];
var Math = global.Math;
var RangeError = global.RangeError;
// eslint-disable-next-line no-shadow-restricted-names
var Infinity = global.Infinity;
var BaseBuffer = $ArrayBuffer;
var abs = Math.abs;
var pow = Math.pow;
var floor = Math.floor;
var log = Math.log;
var LN2 = Math.LN2;
var BUFFER = 'buffer';
var BYTE_LENGTH = 'byteLength';
var BYTE_OFFSET = 'byteOffset';
var $BUFFER = DESCRIPTORS ? '_b' : BUFFER;
var $LENGTH = DESCRIPTORS ? '_l' : BYTE_LENGTH;
var $OFFSET = DESCRIPTORS ? '_o' : BYTE_OFFSET;

// IEEE754 conversions based on https://github.com/feross/ieee754
function packIEEE754(value, mLen, nBytes) {
  var buffer = new Array(nBytes);
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var rt = mLen === 23 ? pow(2, -24) - pow(2, -77) : 0;
  var i = 0;
  var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
  var e, m, c;
  value = abs(value);
  // eslint-disable-next-line no-self-compare
  if (value != value || value === Infinity) {
    // eslint-disable-next-line no-self-compare
    m = value != value ? 1 : 0;
    e = eMax;
  } else {
    e = floor(log(value) / LN2);
    if (value * (c = pow(2, -e)) < 1) {
      e--;
      c *= 2;
    }
    if (e + eBias >= 1) {
      value += rt / c;
    } else {
      value += rt * pow(2, 1 - eBias);
    }
    if (value * c >= 2) {
      e++;
      c /= 2;
    }
    if (e + eBias >= eMax) {
      m = 0;
      e = eMax;
    } else if (e + eBias >= 1) {
      m = (value * c - 1) * pow(2, mLen);
      e = e + eBias;
    } else {
      m = value * pow(2, eBias - 1) * pow(2, mLen);
      e = 0;
    }
  }
  for (; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8);
  e = e << mLen | m;
  eLen += mLen;
  for (; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8);
  buffer[--i] |= s * 128;
  return buffer;
}
function unpackIEEE754(buffer, mLen, nBytes) {
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var nBits = eLen - 7;
  var i = nBytes - 1;
  var s = buffer[i--];
  var e = s & 127;
  var m;
  s >>= 7;
  for (; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8);
  m = e & (1 << -nBits) - 1;
  e >>= -nBits;
  nBits += mLen;
  for (; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8);
  if (e === 0) {
    e = 1 - eBias;
  } else if (e === eMax) {
    return m ? NaN : s ? -Infinity : Infinity;
  } else {
    m = m + pow(2, mLen);
    e = e - eBias;
  } return (s ? -1 : 1) * m * pow(2, e - mLen);
}

function unpackI32(bytes) {
  return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
}
function packI8(it) {
  return [it & 0xff];
}
function packI16(it) {
  return [it & 0xff, it >> 8 & 0xff];
}
function packI32(it) {
  return [it & 0xff, it >> 8 & 0xff, it >> 16 & 0xff, it >> 24 & 0xff];
}
function packF64(it) {
  return packIEEE754(it, 52, 8);
}
function packF32(it) {
  return packIEEE754(it, 23, 4);
}

function addGetter(C, key, internal) {
  dP(C[PROTOTYPE], key, { get: function () { return this[internal]; } });
}

function get(view, bytes, index, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = store.slice(start, start + bytes);
  return isLittleEndian ? pack : pack.reverse();
}
function set(view, bytes, index, conversion, value, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = conversion(+value);
  for (var i = 0; i < bytes; i++) store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
}

if (!$typed.ABV) {
  $ArrayBuffer = function ArrayBuffer(length) {
    anInstance(this, $ArrayBuffer, ARRAY_BUFFER);
    var byteLength = toIndex(length);
    this._b = arrayFill.call(new Array(byteLength), 0);
    this[$LENGTH] = byteLength;
  };

  $DataView = function DataView(buffer, byteOffset, byteLength) {
    anInstance(this, $DataView, DATA_VIEW);
    anInstance(buffer, $ArrayBuffer, DATA_VIEW);
    var bufferLength = buffer[$LENGTH];
    var offset = toInteger(byteOffset);
    if (offset < 0 || offset > bufferLength) throw RangeError('Wrong offset!');
    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
    if (offset + byteLength > bufferLength) throw RangeError(WRONG_LENGTH);
    this[$BUFFER] = buffer;
    this[$OFFSET] = offset;
    this[$LENGTH] = byteLength;
  };

  if (DESCRIPTORS) {
    addGetter($ArrayBuffer, BYTE_LENGTH, '_l');
    addGetter($DataView, BUFFER, '_b');
    addGetter($DataView, BYTE_LENGTH, '_l');
    addGetter($DataView, BYTE_OFFSET, '_o');
  }

  redefineAll($DataView[PROTOTYPE], {
    getInt8: function getInt8(byteOffset) {
      return get(this, 1, byteOffset)[0] << 24 >> 24;
    },
    getUint8: function getUint8(byteOffset) {
      return get(this, 1, byteOffset)[0];
    },
    getInt16: function getInt16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
    },
    getUint16: function getUint16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return bytes[1] << 8 | bytes[0];
    },
    getInt32: function getInt32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1]));
    },
    getUint32: function getUint32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1])) >>> 0;
    },
    getFloat32: function getFloat32(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 4, byteOffset, arguments[1]), 23, 4);
    },
    getFloat64: function getFloat64(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 8, byteOffset, arguments[1]), 52, 8);
    },
    setInt8: function setInt8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setUint8: function setUint8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setInt16: function setInt16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setUint16: function setUint16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setInt32: function setInt32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setUint32: function setUint32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setFloat32: function setFloat32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packF32, value, arguments[2]);
    },
    setFloat64: function setFloat64(byteOffset, value /* , littleEndian */) {
      set(this, 8, byteOffset, packF64, value, arguments[2]);
    }
  });
} else {
  if (!fails(function () {
    $ArrayBuffer(1);
  }) || !fails(function () {
    new $ArrayBuffer(-1); // eslint-disable-line no-new
  }) || fails(function () {
    new $ArrayBuffer(); // eslint-disable-line no-new
    new $ArrayBuffer(1.5); // eslint-disable-line no-new
    new $ArrayBuffer(NaN); // eslint-disable-line no-new
    return $ArrayBuffer.name != ARRAY_BUFFER;
  })) {
    $ArrayBuffer = function ArrayBuffer(length) {
      anInstance(this, $ArrayBuffer);
      return new BaseBuffer(toIndex(length));
    };
    var ArrayBufferProto = $ArrayBuffer[PROTOTYPE] = BaseBuffer[PROTOTYPE];
    for (var keys = gOPN(BaseBuffer), j = 0, key; keys.length > j;) {
      if (!((key = keys[j++]) in $ArrayBuffer)) hide($ArrayBuffer, key, BaseBuffer[key]);
    }
    if (!LIBRARY) ArrayBufferProto.constructor = $ArrayBuffer;
  }
  // iOS Safari 7.x bug
  var view = new $DataView(new $ArrayBuffer(2));
  var $setInt8 = $DataView[PROTOTYPE].setInt8;
  view.setInt8(0, 2147483648);
  view.setInt8(1, 2147483649);
  if (view.getInt8(0) || !view.getInt8(1)) redefineAll($DataView[PROTOTYPE], {
    setInt8: function setInt8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    },
    setUint8: function setUint8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    }
  }, true);
}
setToStringTag($ArrayBuffer, ARRAY_BUFFER);
setToStringTag($DataView, DATA_VIEW);
hide($DataView[PROTOTYPE], $typed.VIEW, true);
exports[ARRAY_BUFFER] = $ArrayBuffer;
exports[DATA_VIEW] = $DataView;


/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.canUseDOM = undefined;

var _exenv = __webpack_require__(555);

var _exenv2 = _interopRequireDefault(_exenv);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EE = _exenv2.default;

var SafeHTMLElement = EE.canUseDOM ? window.HTMLElement : {};

var canUseDOM = exports.canUseDOM = EE.canUseDOM;

exports.default = SafeHTMLElement;

/***/ }),
/* 172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Router__ = __webpack_require__(173);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Router__["a" /* default */]);

/***/ }),
/* 173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






/**
 * The public API for putting history on context.
 */

var Router = function (_React$Component) {
  _inherits(Router, _React$Component);

  function Router() {
    var _temp, _this, _ret;

    _classCallCheck(this, Router);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props.history.location.pathname)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Router.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        history: this.props.history,
        route: {
          location: this.props.history.location,
          match: this.state.match
        }
      })
    };
  };

  Router.prototype.computeMatch = function computeMatch(pathname) {
    return {
      path: "/",
      url: "/",
      params: {},
      isExact: pathname === "/"
    };
  };

  Router.prototype.componentWillMount = function componentWillMount() {
    var _this2 = this;

    var _props = this.props,
        children = _props.children,
        history = _props.history;


    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(children == null || __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 1, "A <Router> may have only one child element");

    // Do this here so we can setState when a <Redirect> changes the
    // location in componentWillMount. This happens e.g. when doing
    // server rendering using a <StaticRouter>.
    this.unlisten = history.listen(function () {
      _this2.setState({
        match: _this2.computeMatch(history.location.pathname)
      });
    });
  };

  Router.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(this.props.history === nextProps.history, "You cannot change <Router history>");
  };

  Router.prototype.componentWillUnmount = function componentWillUnmount() {
    this.unlisten();
  };

  Router.prototype.render = function render() {
    var children = this.props.children;

    return children ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children) : null;
  };

  return Router;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Router.propTypes = {
  history: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node
};
Router.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
Router.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Router);

/***/ }),
/* 174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_path_to_regexp__);


var patternCache = {};
var cacheLimit = 10000;
var cacheCount = 0;

var compilePath = function compilePath(pattern, options) {
  var cacheKey = "" + options.end + options.strict + options.sensitive;
  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});

  if (cache[pattern]) return cache[pattern];

  var keys = [];
  var re = __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default()(pattern, keys, options);
  var compiledPattern = { re: re, keys: keys };

  if (cacheCount < cacheLimit) {
    cache[pattern] = compiledPattern;
    cacheCount++;
  }

  return compiledPattern;
};

/**
 * Public API for matching a URL pathname to a path pattern.
 */
var matchPath = function matchPath(pathname) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var parent = arguments[2];

  if (typeof options === "string") options = { path: options };

  var _options = options,
      path = _options.path,
      _options$exact = _options.exact,
      exact = _options$exact === undefined ? false : _options$exact,
      _options$strict = _options.strict,
      strict = _options$strict === undefined ? false : _options$strict,
      _options$sensitive = _options.sensitive,
      sensitive = _options$sensitive === undefined ? false : _options$sensitive;


  if (path == null) return parent;

  var _compilePath = compilePath(path, { end: exact, strict: strict, sensitive: sensitive }),
      re = _compilePath.re,
      keys = _compilePath.keys;

  var match = re.exec(pathname);

  if (!match) return null;

  var url = match[0],
      values = match.slice(1);

  var isExact = pathname === url;

  if (exact && !isExact) return null;

  return {
    path: path, // the path pattern used to match
    url: path === "/" && url === "" ? "/" : url, // the matched portion of the URL
    isExact: isExact, // whether or not we matched exactly
    params: keys.reduce(function (memo, key, index) {
      memo[key.name] = values[index];
      return memo;
    }, {})
  };
};

/* harmony default export */ __webpack_exports__["a"] = (matchPath);

/***/ }),
/* 175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Subscription; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__batch__ = __webpack_require__(260);
 // encapsulates the subscription logic for connecting a component to the redux store, as
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants

var nullListeners = {
  notify: function notify() {}
};

function createListenerCollection() {
  var batch = Object(__WEBPACK_IMPORTED_MODULE_0__batch__["a" /* getBatch */])();
  var first = null;
  var last = null;
  return {
    clear: function clear() {
      first = null;
      last = null;
    },
    notify: function notify() {
      batch(function () {
        var listener = first;

        while (listener) {
          listener.callback();
          listener = listener.next;
        }
      });
    },
    get: function get() {
      var listeners = [];
      var listener = first;

      while (listener) {
        listeners.push(listener);
        listener = listener.next;
      }

      return listeners;
    },
    subscribe: function subscribe(callback) {
      var isSubscribed = true;
      var listener = last = {
        callback: callback,
        next: null,
        prev: last
      };

      if (listener.prev) {
        listener.prev.next = listener;
      } else {
        first = listener;
      }

      return function unsubscribe() {
        if (!isSubscribed || first === null) return;
        isSubscribed = false;

        if (listener.next) {
          listener.next.prev = listener.prev;
        } else {
          last = listener.prev;
        }

        if (listener.prev) {
          listener.prev.next = listener.next;
        } else {
          first = listener.next;
        }
      };
    }
  };
}

var Subscription =
/*#__PURE__*/
function () {
  function Subscription(store, parentSub) {
    this.store = store;
    this.parentSub = parentSub;
    this.unsubscribe = null;
    this.listeners = nullListeners;
    this.handleChangeWrapper = this.handleChangeWrapper.bind(this);
  }

  var _proto = Subscription.prototype;

  _proto.addNestedSub = function addNestedSub(listener) {
    this.trySubscribe();
    return this.listeners.subscribe(listener);
  };

  _proto.notifyNestedSubs = function notifyNestedSubs() {
    this.listeners.notify();
  };

  _proto.handleChangeWrapper = function handleChangeWrapper() {
    if (this.onStateChange) {
      this.onStateChange();
    }
  };

  _proto.isSubscribed = function isSubscribed() {
    return Boolean(this.unsubscribe);
  };

  _proto.trySubscribe = function trySubscribe() {
    if (!this.unsubscribe) {
      this.unsubscribe = this.parentSub ? this.parentSub.addNestedSub(this.handleChangeWrapper) : this.store.subscribe(this.handleChangeWrapper);
      this.listeners = createListenerCollection();
    }
  };

  _proto.tryUnsubscribe = function tryUnsubscribe() {
    if (this.unsubscribe) {
      this.unsubscribe();
      this.unsubscribe = null;
      this.listeners.clear();
      this.listeners = nullListeners;
    }
  };

  return Subscription;
}();



/***/ }),
/* 176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = persistReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stateReconciler_autoMergeLevel1__ = __webpack_require__(596);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__createPersistoid__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__getStoredState__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__purgeStoredState__ = __webpack_require__(273);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }








var DEFAULT_TIMEOUT = 5000;
/*
  @TODO add validation / handling for:
  - persisting a reducer which has nested _persist
  - handling actions that fire before reydrate is called
*/
function persistReducer(config, baseReducer) {
  if (false) {
    if (!config) throw new Error('config is required for persistReducer');
    if (!config.key) throw new Error('key is required in persistor config');
    if (!config.storage) throw new Error("redux-persist: config.storage is required. Try using one of the provided storage engines `import storage from 'redux-persist/lib/storage'`");
  }

  var version = config.version !== undefined ? config.version : __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* DEFAULT_VERSION */];
  var debug = config.debug || false;
  var stateReconciler = config.stateReconciler === undefined ? __WEBPACK_IMPORTED_MODULE_1__stateReconciler_autoMergeLevel1__["a" /* default */] : config.stateReconciler;
  var getStoredState = config.getStoredState || __WEBPACK_IMPORTED_MODULE_3__getStoredState__["a" /* default */];
  var timeout = config.timeout !== undefined ? config.timeout : DEFAULT_TIMEOUT;
  var _persistoid = null;
  var _purge = false;
  var _paused = true;
  var conditionalUpdate = function conditionalUpdate(state) {
    // update the persistoid only if we are rehydrated and not paused
    state._persist.rehydrated && _persistoid && !_paused && _persistoid.update(state);
    return state;
  };

  return function (state, action) {
    var _ref = state || {},
        _persist = _ref._persist,
        rest = _objectWithoutProperties(_ref, ['_persist']);

    var restState = rest;

    if (action.type === __WEBPACK_IMPORTED_MODULE_0__constants__["e" /* PERSIST */]) {
      var _sealed = false;
      var _rehydrate = function _rehydrate(payload, err) {
        // dev warning if we are already sealed
        if (false) console.error('redux-persist: rehydrate for "' + config.key + '" called after timeout.', payload, err);

        // only rehydrate if we are not already sealed
        if (!_sealed) {
          action.rehydrate(config.key, payload, err);
          _sealed = true;
        }
      };
      timeout && setTimeout(function () {
        !_sealed && _rehydrate(undefined, new Error('redux-persist: persist timed out for persist key "' + config.key + '"'));
      }, timeout);

      // @NOTE PERSIST resumes if paused.
      _paused = false;

      // @NOTE only ever create persistoid once, ensure we call it at least once, even if _persist has already been set
      if (!_persistoid) _persistoid = Object(__WEBPACK_IMPORTED_MODULE_2__createPersistoid__["a" /* default */])(config);

      // @NOTE PERSIST can be called multiple times, noop after the first
      if (_persist) return state;
      if (typeof action.rehydrate !== 'function' || typeof action.register !== 'function') throw new Error('redux-persist: either rehydrate or register is not a function on the PERSIST action. This can happen if the action is being replayed. This is an unexplored use case, please open an issue and we will figure out a resolution.');

      action.register(config.key);

      getStoredState(config).then(function (restoredState) {
        var migrate = config.migrate || function (s, v) {
          return Promise.resolve(s);
        };
        migrate(restoredState, version).then(function (migratedState) {
          _rehydrate(migratedState);
        }, function (migrateErr) {
          if (false) console.error('redux-persist: migration error', migrateErr);
          _rehydrate(undefined, migrateErr);
        });
      }, function (err) {
        _rehydrate(undefined, err);
      });

      return _extends({}, baseReducer(restState, action), {
        _persist: { version: version, rehydrated: false }
      });
    } else if (action.type === __WEBPACK_IMPORTED_MODULE_0__constants__["f" /* PURGE */]) {
      _purge = true;
      action.result(Object(__WEBPACK_IMPORTED_MODULE_4__purgeStoredState__["a" /* default */])(config));
      return _extends({}, baseReducer(restState, action), {
        _persist: _persist
      });
    } else if (action.type === __WEBPACK_IMPORTED_MODULE_0__constants__["b" /* FLUSH */]) {
      action.result(_persistoid && _persistoid.flush());
      return _extends({}, baseReducer(restState, action), {
        _persist: _persist
      });
    } else if (action.type === __WEBPACK_IMPORTED_MODULE_0__constants__["d" /* PAUSE */]) {
      _paused = true;
    } else if (action.type === __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* REHYDRATE */]) {
      // noop on restState if purging
      if (_purge) return _extends({}, restState, {
        _persist: _extends({}, _persist, { rehydrated: true })

        // @NOTE if key does not match, will continue to default else below
      });if (action.key === config.key) {
        var reducedState = baseReducer(restState, action);
        var inboundState = action.payload;
        // only reconcile state if stateReconciler and inboundState are both defined
        var reconciledRest = stateReconciler !== false && inboundState !== undefined ? stateReconciler(inboundState, state, reducedState, config) : reducedState;

        var _newState = _extends({}, reconciledRest, {
          _persist: _extends({}, _persist, { rehydrated: true })
        });
        return conditionalUpdate(_newState);
      }
    }

    // if we have not already handled PERSIST, straight passthrough
    if (!_persist) return baseReducer(state, action);

    // run base reducer:
    // is state modified ? return original : return updated
    var newState = baseReducer(restState, action);
    if (newState === restState) return state;else {
      newState._persist = _persist;
      return conditionalUpdate(newState);
    }
  };
}

/***/ }),
/* 177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = warn;
function warn(s) {
  console.warn('[react-ga]', s);
}

/***/ }),
/* 178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_utils_http__ = __webpack_require__(19);
var getStripeConfig=function getStripeConfig(payload){return __WEBPACK_IMPORTED_MODULE_0_utils_http__["a" /* default */].post('/payment/v1/stripe/config',payload);};var getCards=function getCards(){return __WEBPACK_IMPORTED_MODULE_0_utils_http__["a" /* default */].get('/payment/v1/stripe/card-list');};var deleteCard=function deleteCard(cardId){return __WEBPACK_IMPORTED_MODULE_0_utils_http__["a" /* default */].delete('/payment/v1/stripe/delete-card/'+cardId);};var pay=function pay(payload){return __WEBPACK_IMPORTED_MODULE_0_utils_http__["a" /* default */].post('/payment/v1/stripe/pay/card-saved',payload);};/* harmony default export */ __webpack_exports__["a"] = ({getStripeConfig:getStripeConfig,getCards:getCards,deleteCard:deleteCard,pay:pay});

/***/ }),
/* 179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return fetchingCompaniesToUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return requestSignup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return createNewUserByEmail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return closeModalErrorFailed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return closeSignup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return closeEmailConfirmation; });
/* unused harmony export requestSignupSuccessful */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return selectCompany; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return setReferalFriendCode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return setLinkCode; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actionTypes__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services_signUpService__ = __webpack_require__(658);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_utils_userError__ = __webpack_require__(15);
var fetchingCompaniesToUser=function fetchingCompaniesToUser(domain){return function(dispatch){__WEBPACK_IMPORTED_MODULE_1_services_signUpService__["a" /* default */].companiesToUser({companyDomain:domain}).then(function(companies){dispatch(setCompaniesToUser(companies));}).catch(function(err){dispatch(requestFailed(err,'find your company'));});};};var requestSignup=function requestSignup(user){return function(dispatch){__WEBPACK_IMPORTED_MODULE_1_services_signUpService__["a" /* default */].sendDetails(user).then(function(res){dispatch(requestSignupSuccessful(user));}).catch(function(err){dispatch(requestFailed(err,'create your account'));});};};var createNewUserByEmail=function createNewUserByEmail(email){return function(dispatch){__WEBPACK_IMPORTED_MODULE_1_services_signUpService__["a" /* default */].createNewUserByEmail(email).catch(function(err){return dispatch(requestFailed(err,'create your account'));});};};// A 400 with field errors means a detail was turned down; the server's wording is not shown.
var requestFailed=function requestFailed(error,task){var fieldErrors=!!error&&Array.isArray(error.errors)&&error.errors.length>0;return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["_19" /* REQUEST_FAILED */],errorMessage:Object(__WEBPACK_IMPORTED_MODULE_2_utils_userError__["h" /* userError */])(error,fieldErrors?{area:'ACCOUNT',code:__WEBPACK_IMPORTED_MODULE_2_utils_userError__["a" /* ERROR_CODES */].ACCOUNT_DETAILS_INVALID,title:'Check your details',message:'One of the details you entered was not accepted.',guidance:'Check your name, work email and company, then try again.'}:{area:'ACCOUNT',code:__WEBPACK_IMPORTED_MODULE_2_utils_userError__["a" /* ERROR_CODES */].ACCOUNT_SIGNUP_FAILED,task:task})};};var closeModalErrorFailed=function closeModalErrorFailed(){return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["y" /* CLOSE_MODAL_ERROR */]};};var setCompaniesToUser=function setCompaniesToUser(companies){return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["_39" /* SET_COMPANIES_TO_USER */],companies:companies};};var setCompany=function setCompany(idBusiness){return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["_27" /* SELECT_COMPANY */],idBusiness:idBusiness};};var closeSignup=function closeSignup(){return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["F" /* CLOSE_SIGNUP */]};};var closeEmailConfirmation=function closeEmailConfirmation(){return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["x" /* CLOSE_EMAIL_CONFIRMATION */]};};var requestSignupSuccessful=function requestSignupSuccessful(user){return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["_22" /* REQUEST_SIGNUP_SUCCESSFUL */],signUpFinished:true,user:user};};var selectCompany=function selectCompany(idBusiness){return function(dispatch){dispatch(setCompany(idBusiness));};};var setReferalFriendCode=function setReferalFriendCode(combinedToken){return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["_41" /* SIGNUP_SET_REFERAL_FRIEND_CODE */],referalFriendCode:combinedToken};};var setLinkCode=function setLinkCode(code){return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["_40" /* SIGNUP_SET_LINK_CODE */],code:code};};

/***/ }),
/* 180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return logoutRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return fetchingListAddressForOrder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return fetchingRecentlyOrdered; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return fetchingPendingOrderFeedback; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return submitOrderFeedback; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return skipOrderFeedback; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return fetchingMenu; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return selectItemSideBarMenu; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return changeMenuTitleHeader; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return verifyRestaurantAvailable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return closeModalAvailableRestaurant; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return fetchingProducts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return fetchingMealOptionsFromPopularDish; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return changeRestaurantOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return restaurantSelected; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return categoriesSelected; });
/* unused harmony export settingActiveCategory */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return deleteRestaurantSelected; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return selectProduct; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return closeProductDetails; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return selectAddressForOrder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return logoutSuccess; });
/* unused harmony export orderFeedbackPendingSuccess */
/* unused harmony export orderFeedbackClear */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return toggleMenuMobile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return toggleRestaurants; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return handleOrderToRepeat; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return errorHandling; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return fetchingInvoiceInfo; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actionTypes__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services_menuService__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_services_orderService__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_utils_googleAnalytics__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_utils_userError__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Cart__ = __webpack_require__(69);
// Every Add to basket goes through "Who's this for?" when guest ordering is on.
var logoutRequest=function logoutRequest(){return function(dispatch){__WEBPACK_IMPORTED_MODULE_1_services_menuService__["a" /* default */].logout().then(function(data){dispatch(logoutSuccess());localStorage.removeItem("country");}).catch(function(error){if(error.response.status===401){dispatch(logoutSuccess());}});};};var fetchingListAddressForOrder=function fetchingListAddressForOrder(email){return function(dispatch){__WEBPACK_IMPORTED_MODULE_1_services_menuService__["a" /* default */].getListAddressToDelivery(email).then(function(addresses){if(addresses.length===1){dispatch(selectAddressForOrder(addresses));}dispatch(requestSuccessListAddressToDelivery(addresses));}).catch(function(error){console.log(error);});};};var fetchingRecentlyOrdered=function fetchingRecentlyOrdered(idAddress){return function(dispatch){dispatch(startRecentlyOrderRequest());__WEBPACK_IMPORTED_MODULE_1_services_menuService__["a" /* default */].getRecentlyOrdered(idAddress).then(function(data){dispatch(finishRecentlyOrderRequest());dispatch(fetchingRecentlyOrderedSuccess(data));}).catch(function(error){console.log(error);});};};var fetchingPendingOrderFeedback=function fetchingPendingOrderFeedback(idAddress){return function(dispatch){__WEBPACK_IMPORTED_MODULE_2_services_orderService__["a" /* default */].getPendingFeedback(idAddress).then(function(data){if(data&&data.previousOrderId){__WEBPACK_IMPORTED_MODULE_3_utils_googleAnalytics__["b" /* default */].sendEvent('feedback_card_viewed',String(data.previousOrderId));dispatch(orderFeedbackPendingSuccess(data));}else{dispatch(orderFeedbackClear());}}).catch(function(error){console.log(error);});};};var submitOrderFeedback=function submitOrderFeedback(payload){return function(dispatch){__WEBPACK_IMPORTED_MODULE_2_services_orderService__["a" /* default */].submitFeedback(payload).then(function(){__WEBPACK_IMPORTED_MODULE_3_utils_googleAnalytics__["b" /* default */].sendEvent('feedback_submitted',String(payload.previousOrderId));dispatch(orderFeedbackSubmitted());}).catch(function(error){console.log(error);});};};var skipOrderFeedback=function skipOrderFeedback(payload){return function(dispatch){__WEBPACK_IMPORTED_MODULE_2_services_orderService__["a" /* default */].skipFeedback(payload).then(function(){__WEBPACK_IMPORTED_MODULE_3_utils_googleAnalytics__["b" /* default */].sendEvent('feedback_skipped',String(payload.previousOrderId));dispatch(orderFeedbackSkipped());}).catch(function(error){console.log(error);});};};var fetchingMenu=function fetchingMenu(idBusiness,idAddress){return function(dispatch){__WEBPACK_IMPORTED_MODULE_1_services_menuService__["a" /* default */].fetchingMenu(idBusiness,idAddress).then(function(data){dispatch(fetchingMenuSuccess(data));}).catch(function(error){console.log(error);});};};var selectItemSideBarMenu=function selectItemSideBarMenu(itemsSideBar){return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["_28" /* SELECT_ITEM_SIDE_BAR_MENU */],itemsSideBar:itemsSideBar};};var changeMenuTitleHeader=function changeMenuTitleHeader(titleHeader){return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["_6" /* MENU_CHANGE_TITLE_HEADER */],titleHeader:titleHeader};};var verifyRestaurantAvailable=function verifyRestaurantAvailable(idRestaurant,idBusiness){return function(dispatch){__WEBPACK_IMPORTED_MODULE_1_services_menuService__["a" /* default */].verifyRestaurantAvailable(idRestaurant,idBusiness).then(function(data){dispatch(verifyRestaurantAvailableSuccessful(data));});};};var verifyRestaurantAvailableSuccessful=function verifyRestaurantAvailableSuccessful(payload){return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["_11" /* MENU_RESTAURANT_VERIFY_AVAILABLE_SUCCESSFUL */],payload:payload};};var closeModalAvailableRestaurant=function closeModalAvailableRestaurant(){return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["_9" /* MENU_REMOVE_RESTAURANT_NOT_AVAILABLE */]};};var fetchingProducts=function fetchingProducts(idRestaurant,idCategory,idProduct){return function(dispatch){dispatch(settingActiveCategory(idCategory));__WEBPACK_IMPORTED_MODULE_1_services_menuService__["a" /* default */].getProducts(idRestaurant,idCategory,idProduct).then(function(data){dispatch(fetchingProductsSuccess(data));}).catch(function(error){console.log(error);});};};var fetchingMealOptionsFromPopularDish=function fetchingMealOptionsFromPopularDish(payload){return function(dispatch){__WEBPACK_IMPORTED_MODULE_1_services_menuService__["a" /* default */].getCategoryFromProduct(payload.product,payload.business.id).then(function(data){if(data.length>0&&data[0].mealOptions.length>0){var productSelected=Object.assign({},data[0],{businessName:payload.product.businessName,businessId:payload.business.businessId,currency:payload.business.currency});dispatch(selectProduct(productSelected));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__Cart__["a" /* addProductToCart */])(payload));}}).catch(function(error){console.log(error);});};};var changeRestaurantOptions=function changeRestaurantOptions(idRestaurantsOptions){return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["q" /* CHANGE_RESTAURANT_OPTIONS */],idRestaurantsOptions:idRestaurantsOptions};};var restaurantSelected=function restaurantSelected(restaurant){return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["_26" /* RESTAURANT_SELECTED */],restaurant:restaurant};};var categoriesSelected=function categoriesSelected(categoriesRestaurant){return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["o" /* CATEGORIES_SELECTED */],categoriesRestaurant:categoriesRestaurant};};var settingActiveCategory=function settingActiveCategory(idCategory){return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["_38" /* SETTING_ACTIVE_CATEGORY */],idActiveCategory:idCategory};};var deleteRestaurantSelected=function deleteRestaurantSelected(){return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["J" /* DELETE_RESTAURANT_SELECTED */]};};var selectProduct=function selectProduct(product){return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["_29" /* SELECT_PRODUCT */],productSelected:product};};var closeProductDetails=function closeProductDetails(){return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["C" /* CLOSE_PRODUCT_DETAILS */]};};var selectAddressForOrder=function selectAddressForOrder(address){return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["_12" /* MENU_SELECT_ADDRESS_FOR_ORDER */],address:address};};var startRecentlyOrderRequest=function startRecentlyOrderRequest(){return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["_42" /* START_RECENTLY_ORDER_REQUEST */]};};var finishRecentlyOrderRequest=function finishRecentlyOrderRequest(){return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["O" /* FINISH_RECENTLY_ORDER_REQUEST */]};};var logoutSuccess=function logoutSuccess(){return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["_5" /* LOGOUT */]};};var requestSuccessListAddressToDelivery=function requestSuccessListAddressToDelivery(listAddressToDelivery){return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["_8" /* MENU_FETCHING_ADDRESS_SUCCESS */],listAddressToDelivery:listAddressToDelivery};};var fetchingMenuSuccess=function fetchingMenuSuccess(data){return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["L" /* FETCHING_MENU_SUCCESS */],businessCollection:data.businessCollection,businessDelivery:data.businessDelivery,businessPlatter:data.businessPlatter,popularDishDelivery:data.popularDishDelivery};};var fetchingProductsSuccess=function fetchingProductsSuccess(data){return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["M" /* FETCHING_PRODUCT_SUCCESS */],products:data};};var fetchingRecentlyOrderedSuccess=function fetchingRecentlyOrderedSuccess(data){return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["N" /* FETCHING_RECENTLY_ORDERED_SUCCESS */],recentlyOrdered:data};};var orderFeedbackPendingSuccess=function orderFeedbackPendingSuccess(pendingFeedback){return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["_14" /* ORDER_FEEDBACK_PENDING_SUCCESS */],pendingFeedback:pendingFeedback};};var orderFeedbackClear=function orderFeedbackClear(){return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["_13" /* ORDER_FEEDBACK_CLEAR */]};};var orderFeedbackSubmitted=function orderFeedbackSubmitted(){return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["_16" /* ORDER_FEEDBACK_SUBMITTED */]};};var orderFeedbackSkipped=function orderFeedbackSkipped(){return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["_15" /* ORDER_FEEDBACK_SKIPPED */]};};var toggleMenuMobile=function toggleMenuMobile(){var status=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["_67" /* TOGGLE_MENU_MOBILE */],status:status};};var toggleRestaurants=function toggleRestaurants(){var status=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["_69" /* TOGGLE_RESTAURANTS_MOBILE */],status:status};};var handleOrderToRepeat=function handleOrderToRepeat(idOrder){return function(dispatch){__WEBPACK_IMPORTED_MODULE_2_services_orderService__["a" /* default */].getOrder(idOrder).then(function(response){if(!response.restaurant.isOpen){dispatch(errorHandling({showError:true,errorMessage:Object(__WEBPACK_IMPORTED_MODULE_4_utils_userError__["e" /* knownError */])(__WEBPACK_IMPORTED_MODULE_4_utils_userError__["a" /* ERROR_CODES */].MENU_RESTAURANT_CLOSED,{title:"This restaurant is closed now",message:"It has stopped taking orders for today, so this order can't be repeated.",guidance:"Choose another restaurant, or order again tomorrow."})}));}else if(!response.canOrder){dispatch(errorHandling({showError:true,errorMessage:Object(__WEBPACK_IMPORTED_MODULE_4_utils_userError__["e" /* knownError */])(__WEBPACK_IMPORTED_MODULE_4_utils_userError__["a" /* ERROR_CODES */].MENU_RESTAURANT_UNAVAILABLE,{title:"This restaurant isn't available today",message:"This order can't be repeated today.",guidance:"Choose another restaurant from today's menu."})}));}else{var productsLastOrder=response.orderItems.map(function(orderItem){var productMap=Object.assign({},orderItem.product,{mealOptions:orderItem.mealOptions?orderItem.mealOptions:[]});var price=0;if(orderItem.mealOptions){price=orderItem.mealOptions.reduce(function(inicial,item){return inicial+item.product.price;},0);}price=price+orderItem.product.price;productMap.price=price;return productMap;});dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__Cart__["a" /* addProductToCart */])({product:productsLastOrder,business:response.restaurant}));}}).catch(function(err){dispatch(errorHandling({showError:true,errorMessage:Object(__WEBPACK_IMPORTED_MODULE_4_utils_userError__["h" /* userError */])(err,{area:'ORDER',task:'load that order to repeat it'})}));});};};var errorHandling=function errorHandling(_errorHandling){return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["_7" /* MENU_ERROR_HANDLING */],errorHandling:_errorHandling};};var fetchingInvoiceInfo=function fetchingInvoiceInfo(invoiceNumber){return function(dispatch){__WEBPACK_IMPORTED_MODULE_2_services_orderService__["a" /* default */].getInvoiceInfo(invoiceNumber).then(function(data){if(!!data.paymentDescription){dispatch(invoiceAlreadyPaid(data));}else{dispatch(fetchingInvoiceSuccess(data));}}).catch(function(err){dispatch(errorHandling({showError:true,errorMessage:Object(__WEBPACK_IMPORTED_MODULE_4_utils_userError__["h" /* userError */])(err,{area:'PAYMENT',task:'load this invoice'})}));});};};var invoiceAlreadyPaid=function invoiceAlreadyPaid(payload){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["_1" /* INVOICE_FETCHING_SUCCESS */],invoiceNumber:payload.invoiceNumber,currency:payload.currency,total:payload.total,descriptionSuccess:'Invoice '+payload.invoiceNumber+' has already been paid.'});dispatch({type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["i" /* CART_SET_INVOICE */],payload:true});dispatch({type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["l" /* CART_TOGGLE_SHOW_MODAL_PLACE_ORDER */],payload:true});};};var fetchingInvoiceSuccess=function fetchingInvoiceSuccess(payload){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["_1" /* INVOICE_FETCHING_SUCCESS */],invoiceNumber:payload.invoiceNumber,currency:payload.currency,total:payload.total});dispatch({type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["i" /* CART_SET_INVOICE */],payload:true});dispatch({type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["_66" /* TOGGLE_CART */],status:true});};};

/***/ }),
/* 181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return closeModalPlacedOrder; });
/* unused harmony export successPlaceOrder */
/* unused harmony export paymentOrder */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return closeModalError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return teamVoucherSetOrder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return teamVoucherFetchingCards; });
/* unused harmony export customerExist */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return verifyUnregisteredEmails; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return placeOrderAndGoToAddNewCard; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return closeModalPlacedOrderAndRedirect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return placeOrderAndPay; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return fetchValidTeamVouchers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return fetchTeamVoucherCampaignRate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return openModalReceipt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return closeModalReceiptAndRedirect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return openModalConfirmEmails; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return closeModalConfirmEmails; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actionTypes__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services_paymentService__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_services_orderService__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_services_voucherService__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_utils_time__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_services_loginService__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_utils_paymentFailure__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_utils_checkoutError__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_utils_userError__ = __webpack_require__(15);
var successFetchingCarts=function successFetchingCarts(cards){return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["_62" /* TEAM_VOUCHER_SUCCESS_FETCHING_CARDS */],payload:cards};};var closeModalPlacedOrder=function closeModalPlacedOrder(){return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["_64" /* TEAM_VOUCHER_TOGGLE_SHOW_MODAL_PLACE_ORDER */],payload:false};};var openModalPlacedOrder=function openModalPlacedOrder(){return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["_64" /* TEAM_VOUCHER_TOGGLE_SHOW_MODAL_PLACE_ORDER */],payload:true};};var successPlaceOrder=function successPlaceOrder(data){return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["_63" /* TEAM_VOUCHER_SUCCESS_PLACE_ORDER */],payload:{idOrder:data.id,publicOrderNumber:data.publicOrderNumber,idBusinessRestaurant:data.restaurant.id}};};var teamVoucherResetState=function teamVoucherResetState(){return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["_56" /* TEAM_VOUCHER_RESET_STATE */]};};var reconcilePaymentFailure=function reconcilePaymentFailure(payload,error){return function(dispatch){return Object(__WEBPACK_IMPORTED_MODULE_6_utils_paymentFailure__["a" /* resolvePaymentFailure */])(payload,error).then(function(checkoutError){dispatch(openModalError({errorMessage:checkoutError,errorType:"pay-order"}));});};};var paymentOrder=function paymentOrder(payload){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_1_services_paymentService__["a" /* default */].pay(payload).then(function(data){if(data.success){dispatch(openModalPlacedOrder());}else{return dispatch(reconcilePaymentFailure(payload,data));}},function(error){return dispatch(reconcilePaymentFailure(payload,error));});};};var successValidTeamVouchersRequest=function successValidTeamVouchersRequest(vouchers){return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["_57" /* TEAM_VOUCHER_SET_AVAILABLE_TEAM_VOUCHER */],payload:!!vouchers?vouchers.map(function(v){v.expiryDate=__WEBPACK_IMPORTED_MODULE_4_utils_time__["a" /* default */].dateArrayToDate(v.expiryDate);return v;}):undefined};};var teamVoucherSetCampaignRate=function teamVoucherSetCampaignRate(campaignRateCC){return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["_58" /* TEAM_VOUCHER_SET_CAMPAIGN_RATE */],payload:campaignRateCC};};var teamVoucherSetPayInfo=function teamVoucherSetPayInfo(payInfo){return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["_60" /* TEAM_VOUCHER_SET_PAY_INFO */],payload:payInfo};};var notRegisteredError=function notRegisteredError(email){return Object(__WEBPACK_IMPORTED_MODULE_8_utils_userError__["e" /* knownError */])(__WEBPACK_IMPORTED_MODULE_8_utils_userError__["a" /* ERROR_CODES */].VOUCHER_EMAIL_NOT_REGISTERED,{title:"This person doesn't have an account yet",message:email+" isn't signed up to Lunch.Team.",guidance:'Create an account for them so they can use the voucher, or close to remove the email.'});};var noCompanyError=function noCompanyError(email){return Object(__WEBPACK_IMPORTED_MODULE_8_utils_userError__["e" /* knownError */])(__WEBPACK_IMPORTED_MODULE_8_utils_userError__["a" /* ERROR_CODES */].VOUCHER_EMAIL_NO_COMPANY,{title:"We can't send a voucher to this email",message:email+" isn't linked to a company we deliver to, so it will be removed from the list.",guidance:'If the email is right, contact support with the reference below.'});};// The check itself failed (connection, server): the email still comes off the list.
var emailCheckFailedError=function emailCheckFailedError(error,email){return Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_8_utils_userError__["h" /* userError */])(error,{area:'VOUCHER',title:"We couldn't check this email"}),{message:email+" will be removed from the list for now."});};var openModalError=function openModalError(errorObject){return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["_55" /* TEAM_VOUCHER_OPEN_MODAL_ERROR */],payload:errorObject};};var closeModalError=function closeModalError(){return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["_54" /* TEAM_VOUCHER_CLOSE_MODAL_ERROR */],payload:false};};var teamVoucherSetOrder=function teamVoucherSetOrder(order){return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["_59" /* TEAM_VOUCHER_SET_ORDER */],payload:order};};var teamVoucherFetchingCards=function teamVoucherFetchingCards(){return function(dispatch){__WEBPACK_IMPORTED_MODULE_1_services_paymentService__["a" /* default */].getCards().then(function(data){return dispatch(successFetchingCarts(data));}).catch(function(error){return console.error(error);});};};var customerExist=function customerExist(emailList,newOption){return function(dispatch){__WEBPACK_IMPORTED_MODULE_5_services_loginService__["a" /* default */].preLogin({email:newOption.value}).then(function(data){if(!!data.userAlreadyRegistered){return;}if(data.hasRelatedBusiness){dispatch(openModalError({errorMessage:notRegisteredError(newOption.value),errorType:"invalid-team-voucher",errorObject:newOption}));}else{dispatch(openModalError({errorMessage:noCompanyError(newOption.value),errorType:"not-accepted-invalid-team-voucher",errorObject:newOption}));}}).catch(function(error){dispatch(openModalError({errorMessage:emailCheckFailedError(error,newOption.value),errorType:"not-accepted-invalid-team-voucher",errorObject:newOption}));});};};var verifyUnregisteredEmails=function verifyUnregisteredEmails(emailList,newOption){return function(dispatch){__WEBPACK_IMPORTED_MODULE_5_services_loginService__["a" /* default */].preLogin({email:newOption.value}).then(function(data){if(data.userAlreadyRegistered&&data.hasRelatedBusiness){return"REGISTERED";}if(data.hasRelatedBusiness&&!data.userAlreadyRegistered){return"NOT REGISTERED";/* dispatch(
            openModalError({
              errorMessage: notRegisteredError(newOption.value),
              errorType: "invalid-team-voucher",
              errorObject: newOption
            })
          ); */}else{/* dispatch(
            openModalError({
              errorMessage: noCompanyError(newOption.value),
              errorType: "not-accepted-invalid-team-voucher",
              errorObject: newOption
            })
          );
          return null; */}}).catch(function(error){dispatch(openModalError({errorMessage:emailCheckFailedError(error,newOption.value),errorType:"not-accepted-invalid-team-voucher",errorObject:newOption}));});};};var placeOrderAndGoToAddNewCard=function placeOrderAndGoToAddNewCard(order,payInfo,history){return function(dispatch){__WEBPACK_IMPORTED_MODULE_2_services_orderService__["a" /* default */].placeOrder(order).then(function(data){var payInfoUpdated=Object.assign({},payInfo,{idOrder:data.id,publicOrderNumber:data.publicOrderNumber});dispatch(successPlaceOrder(data));dispatch(teamVoucherSetPayInfo(payInfoUpdated));history.push("/Menu/checkout");}).catch(function(error){return dispatch(openModalError({errorMessage:Object(__WEBPACK_IMPORTED_MODULE_7_utils_checkoutError__["b" /* mapCheckoutError */])(error),errorType:"place-order"}));});};};var closeModalPlacedOrderAndRedirect=function closeModalPlacedOrderAndRedirect(history){return function(dispatch){dispatch(teamVoucherResetState());history.replace("/TeamVoucher");};};var placeOrderAndPay=function placeOrderAndPay(order,payInfo){return function(dispatch){__WEBPACK_IMPORTED_MODULE_2_services_orderService__["a" /* default */].placeOrder(order).then(function(data){var payInfoUpdated=Object.assign({},payInfo,{idOrder:data.id,publicOrderNumber:data.publicOrderNumber});dispatch(successPlaceOrder(data));dispatch(paymentOrder(payInfoUpdated));}).catch(function(error){return dispatch(openModalError({errorMessage:Object(__WEBPACK_IMPORTED_MODULE_7_utils_checkoutError__["b" /* mapCheckoutError */])(error),errorType:"place-order"}));});};};var fetchValidTeamVouchers=function fetchValidTeamVouchers(){return function(dispatch){__WEBPACK_IMPORTED_MODULE_3_services_voucherService__["a" /* default */].availableTeamVoucher().then(function(vouchers){dispatch(successValidTeamVouchersRequest(vouchers));}).catch(function(error){return console.error("When try to fetch available team vouchers: ",error);});};};var byChargeTypeCC=function byChargeTypeCC(campaignRate){return campaignRate.chargeType==="C";};var fetchTeamVoucherCampaignRate=function fetchTeamVoucherCampaignRate(){return function(dispatch){__WEBPACK_IMPORTED_MODULE_2_services_orderService__["a" /* default */].getCampaignRate().then(function(data){return dispatch(teamVoucherSetCampaignRate(data.filter(byChargeTypeCC)[0]));}).catch(function(error){return console.error(error);});};};var openModalReceipt=function openModalReceipt(){return function(dispatch){dispatch(closeModalPlacedOrder());dispatch({type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["_65" /* TEAM_VOUCHER_TOGGLE_SHOW_MODAL_RECEIPT */],payload:true});};};var closeModalReceiptAndRedirect=function closeModalReceiptAndRedirect(history){return function(dispatch){dispatch(teamVoucherResetState());history.replace("/Menu");};};var openModalConfirmEmails=function openModalConfirmEmails(){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["_61" /* TEAM_VOUCHER_SHOW_MODAL_CONFIRM_EMAILS */],payload:false});};};var closeModalConfirmEmails=function closeModalConfirmEmails(history){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["_53" /* TEAM_VOUCHER_CLOSE_MODAL_CONFIRM_EMAILS */],payload:false});};};

/***/ }),
/* 182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony default export */ __webpack_exports__["a"] = (function(props){return props.product.calory||props.product.allergies?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{tabIndex:0},props.product.calory?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,props.product.calory.substring(0,9),' kCal'):null,props.product.allergies?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'Allergens: ',props.product.allergies):null):null;});

/***/ }),
/* 183 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Backdrop_css__ = __webpack_require__(678);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Backdrop_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Backdrop_css__);
var backdrop=function backdrop(props){return props.show?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'Backdrop'}):null;};/* harmony default export */ __webpack_exports__["a"] = (backdrop);

/***/ }),
/* 185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CartProduct__ = __webpack_require__(681);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CartInvoice__ = __webpack_require__(763);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_actions_index__ = __webpack_require__(13);
var Cart=function Cart(props){Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){props.onFetchingCards();},[]);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:props.cart.checkout?'block':'none'},className:'cart-sidebar'},props.cart.isInvoice?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__CartInvoice__["a" /* default */],null):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__CartProduct__["a" /* default */],null));};var mapStateToProps=function mapStateToProps(state){return{cart:state.cartReducer.cart};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onFetchingCards:function onFetchingCards(){return dispatch(__WEBPACK_IMPORTED_MODULE_5_actions_index__["Q" /* fetchingCards */]());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["g" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(Cart)));

/***/ }),
/* 186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__hoc_ReactAux_ReactAux__ = __webpack_require__(4);
var getStyle=function getStyle(disabled){var expired=arguments.length>1&&arguments[1]!==undefined?arguments[1]:false;if(disabled&&!expired){return{color:'var(--lt-color-muted-foreground)',cursor:'not-allowed'};}else if(expired){return{color:'var(--lt-color-danger)'};}return{cursor:'pointer'};};var paymentOptions=function paymentOptions(props){var country=localStorage.getItem('country');var options=null;if(props.total===0&&props.subsidy>0&&!props.onlyCreditCard){options=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'order-voucher payment-options'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'fl',tabIndex:0},'Payment Options'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'radio-payment'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{disabled:props.disabled,onChange:function onChange(event){return props.selectPaymentMethod(event,'onVoucher');},type:'radio',name:'paymentOption',id:'onVoucher',checked:props.payTypeSelected==='A'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{style:getStyle(props.disabled),htmlFor:'onVoucher'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Pay with Voucher'))));}else if(!!props.business&&props.business.acceptOnAccount==='Y'&&!props.onlyCreditCard){options=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'order-voucher payment-options'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'fl'},'Payment Options'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'radio-payment'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__hoc_ReactAux_ReactAux__["a" /* default */],{key:0},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{disabled:props.disabled,onChange:function onChange(event){return props.selectPaymentMethod(event,'onAccount');},type:'radio',name:'paymentOption',id:'onAccount',checked:props.payTypeSelected==='A'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{style:getStyle(props.disabled),htmlFor:'onAccount'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'On Account')))));}else{options=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'order-voucher payment-options'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'fl'},'Payment Options'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'radio-payment'},props.cards.map(function(card,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__hoc_ReactAux_ReactAux__["a" /* default */],{key:index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{disabled:props.disabled,onChange:function onChange(event){return props.selectPaymentMethod(card.cardId,'onCreditCard');},type:'radio',name:'paymentOption',id:card.cardId,checked:props.payTypeSelected==='C'&&props.cardSelected&&props.cardSelected.cardId===card.cardId}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{style:getStyle(props.disabled,card.expired),htmlFor:card.cardId},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,card.brandName),' - ending ',card.lastFour,card.expired?'(card expired)':null));}),country==='Belgium'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__hoc_ReactAux_ReactAux__["a" /* default */],{key:13},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{disabled:props.disabled,onChange:function onChange(event){return props.selectPaymentMethod(event,'bancontact');},type:'radio',name:'paymentOption',id:'bancontact',checked:props.payTypeSelected==='B'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{style:getStyle(props.disabled),htmlFor:'bancontact'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Bancontact'))),country==='Netherlands'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__hoc_ReactAux_ReactAux__["a" /* default */],{key:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{disabled:props.disabled,onChange:function onChange(event){return props.selectPaymentMethod(event,'ideal');},type:'radio',name:'paymentOption',id:'ideal',checked:props.payTypeSelected==='I'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{style:getStyle(props.disabled),htmlFor:'ideal'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Ideal'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__hoc_ReactAux_ReactAux__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{disabled:props.disabled,onChange:function onChange(event){return props.selectPaymentMethod('payWithAnotherCard','onCreditCard');},type:'radio',name:'paymentOption',id:'payWithAnotherCard',checked:props.payTypeSelected==='C'&&!props.cardSelected}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{style:getStyle(props.disabled),htmlFor:'payWithAnotherCard'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Pay with another card ')))));}return options;};/* harmony default export */ __webpack_exports__["a"] = (paymentOptions);

/***/ }),
/* 187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_utils_object__ = __webpack_require__(44);
var getSurchargeLabel=function getSurchargeLabel(props){var payTypeSelected=__WEBPACK_IMPORTED_MODULE_1_utils_object__["a" /* default */].get(props,"payTypeSelected",undefined);if(payTypeSelected==="C"&&!!props.campaignRateCC&&props.total>0){var isFlatRate=props.campaignRateCC.discountType==="F";return!!isFlatRate?" (+ "+props.campaignRateCC.amount+" SURCHARGE)":" (% "+props.campaignRateCC.amount+" SURCHARGE)";}return"";};var getButtonText=function getButtonText(props){var buttonText=!!props.buttonText?props.buttonText:"Place Order";return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,""+buttonText+getSurchargeLabel(props));};var getStyle=function getStyle(disabled){if(disabled){return{background:"var(--lt-color-muted)",color:"var(--lt-color-muted-foreground)",border:"1px solid var(--lt-color-border)",cursor:"not-allowed"};}return{cursor:"pointer",minWidth:"100px"};};var PaymentButton=function PaymentButton(props){var containerClassName="payment-buttons "+(props.containerClassName||"");var disabled=!props.payTypeSelected||!!props.disabled||props.payTypeSelected==="C"&&props.total===0;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:containerClassName},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{disabled:disabled,style:getStyle(disabled),className:"btn orange-bold",onClick:function onClick(){return props.handlePlaceOrder();}},getButtonText(props))));};/* harmony default export */ __webpack_exports__["a"] = (PaymentButton);

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(189);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 189 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(293);
var defined = __webpack_require__(294);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 191 */
/***/ (function(module, exports) {

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

module.exports = _assertThisInitialized;

/***/ }),
/* 192 */
/***/ (function(module, exports) {

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

module.exports = _defineProperty;

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var implementation = __webpack_require__(735);

module.exports = Function.prototype.bind || implementation;


/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var keys = __webpack_require__(303);
var hasSymbols = typeof Symbol === 'function' && typeof Symbol('foo') === 'symbol';

var toStr = Object.prototype.toString;
var concat = Array.prototype.concat;
var origDefineProperty = Object.defineProperty;

var isFunction = function (fn) {
	return typeof fn === 'function' && toStr.call(fn) === '[object Function]';
};

var arePropertyDescriptorsSupported = function () {
	var obj = {};
	try {
		origDefineProperty(obj, 'x', { enumerable: false, value: obj });
		// eslint-disable-next-line no-unused-vars, no-restricted-syntax
		for (var _ in obj) { // jscs:ignore disallowUnusedVariables
			return false;
		}
		return obj.x === obj;
	} catch (e) { /* this is IE 8. */
		return false;
	}
};
var supportsDescriptors = origDefineProperty && arePropertyDescriptorsSupported();

var defineProperty = function (object, name, value, predicate) {
	if (name in object && (!isFunction(predicate) || !predicate())) {
		return;
	}
	if (supportsDescriptors) {
		origDefineProperty(object, name, {
			configurable: true,
			enumerable: false,
			value: value,
			writable: true
		});
	} else {
		object[name] = value;
	}
};

var defineProperties = function (object, map) {
	var predicates = arguments.length > 2 ? arguments[2] : {};
	var props = keys(map);
	if (hasSymbols) {
		props = concat.call(props, Object.getOwnPropertySymbols(map));
	}
	for (var i = 0; i < props.length; i += 1) {
		defineProperty(object, props[i], map[props[i]], predicates[props[i]]);
	}
};

defineProperties.supportsDescriptors = !!supportsDescriptors;

module.exports = defineProperties;


/***/ }),
/* 195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ManagerReferenceNodeContext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ManagerReferenceNodeSetterContext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Manager; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_inheritsLoose__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_inheritsLoose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_inheritsLoose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineProperty__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_create_react_context__ = __webpack_require__(744);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_create_react_context___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_create_react_context__);





var ManagerReferenceNodeContext = __WEBPACK_IMPORTED_MODULE_4_create_react_context___default()();
var ManagerReferenceNodeSetterContext = __WEBPACK_IMPORTED_MODULE_4_create_react_context___default()();

var Manager =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_inheritsLoose___default()(Manager, _React$Component);

  function Manager() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_assertThisInitialized___default()(_this), "referenceNode", void 0);

    __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_assertThisInitialized___default()(_this), "setReferenceNode", function (newReferenceNode) {
      if (newReferenceNode && _this.referenceNode !== newReferenceNode) {
        _this.referenceNode = newReferenceNode;

        _this.forceUpdate();
      }
    });

    return _this;
  }

  var _proto = Manager.prototype;

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.referenceNode = null;
  };

  _proto.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](ManagerReferenceNodeContext.Provider, {
      value: this.referenceNode
    }, __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](ManagerReferenceNodeSetterContext.Provider, {
      value: this.setReferenceNode
    }, this.props.children));
  };

  return Manager;
}(__WEBPACK_IMPORTED_MODULE_3_react__["Component"]);



/***/ }),
/* 196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_modal__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_google_autocomplete__ = __webpack_require__(751);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_google_autocomplete___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_google_autocomplete__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__hoc_ReactAux_ReactAux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_images_logo_lunch_team_svg__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_images_logo_lunch_team_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_images_logo_lunch_team_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__index_css__ = __webpack_require__(753);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__index_css__);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var customStyles={content:{background:'none',border:'none'},overlay:{zIndex:'9999999',width:'100%',height:'100%',left:'0',top:'0',backgroundColor:'rgba(0, 0, 0, 0.7)'}};var disable={background:'var(--lt-color-muted)',color:'var(--lt-color-muted-foreground)',border:'1px solid var(--lt-color-border)',cursor:'not-allowed'};var OptionsForDelivery=function OptionsForDelivery(_ref){var listAddress=_ref.listAddress,selectOptionForOrder=_ref.selectOptionForOrder,showCollectionOption=_ref.showCollectionOption,showDeliverAtHomeOption=_ref.showDeliverAtHomeOption,handleSearchNewDeliveryAddress=_ref.handleSearchNewDeliveryAddress,onFetchingMenu=_ref.onFetchingMenu,idBusiness=_ref.idBusiness,onToggleCart=_ref.onToggleCart,onDeleteAllproductsFromCard=_ref.onDeleteAllproductsFromCard,onCartResetState=_ref.onCartResetState,onDeleteRestaurantSelected=_ref.onDeleteRestaurantSelected,onFetchingRecentlyOrdered=_ref.onFetchingRecentlyOrdered;var onClickOptionsForDelivery=function onClickOptionsForDelivery(address){localStorage.setItem('idBusinessAddress',address.idBusinessAddress);selectOptionForOrder(address);onToggleCart();onDeleteAllproductsFromCard();onFetchingMenu(idBusiness,address.idBusinessAddress);onCartResetState();onDeleteRestaurantSelected();onFetchingRecentlyOrdered(address.idBusinessAddress);};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__hoc_ReactAux_ReactAux__["a" /* default */],null,listAddress.map(function(address){return!address.forCollection||address.forCollection&&showCollectionOption?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__hoc_ReactAux_ReactAux__["a" /* default */],{key:address.idBusinessAddress==null?address.idCustomerDeliveryAddress:address.idBusinessAddress},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:function onClick(){return onClickOptionsForDelivery(address);},className:'btn orange-bold'},address.street)):null;}),showDeliverAtHomeOption?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:function onClick(){return handleSearchNewDeliveryAddress();},className:'btn orange-bold'},'Deliver @ HOME'):null);};var LocationSearchInput=function LocationSearchInput(_ref2){var place=_ref2.place,handleSetAddress=_ref2.handleSetAddress,handleSaveAddress=_ref2.handleSaveAddress,handleBackToAddressList=_ref2.handleBackToAddressList;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__hoc_ReactAux_ReactAux__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_google_autocomplete___default.a,{onPlaceSelected:function onPlaceSelected(place){handleSetAddress(place);},componentRestrictions:{country:'ie'},types:['address']}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:function onClick(e){return handleSaveAddress();},style:place===''||place==null?disable:null,className:'btn orange-bold'},place===''||place==null?'Find your address':'Save '+place),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:function onClick(e){return handleBackToAddressList();},className:'btn orange-bold'},'Back to address list'));};var OptionsForDeliveryOrCollectionOrder=function OptionsForDeliveryOrCollectionOrder(_ref3){var showModal=_ref3.showModal,listAddress=_ref3.listAddress,showCollectionOption=_ref3.showCollectionOption,showDeliverAtHomeOption=_ref3.showDeliverAtHomeOption,selectOptionForOrder=_ref3.selectOptionForOrder,createCustomerDeliveryAddress=_ref3.createCustomerDeliveryAddress,onFetchingMenu=_ref3.onFetchingMenu,idBusiness=_ref3.idBusiness,onToggleCart=_ref3.onToggleCart,onDeleteAllproductsFromCard=_ref3.onDeleteAllproductsFromCard,onCartResetState=_ref3.onCartResetState,onDeleteRestaurantSelected=_ref3.onDeleteRestaurantSelected,onFetchingRecentlyOrdered=_ref3.onFetchingRecentlyOrdered;var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState2=_slicedToArray(_useState,2),search=_useState2[0],setSearch=_useState2[1];var _useState3=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(''),_useState4=_slicedToArray(_useState3,2),place=_useState4[0],setPlace=_useState4[1];var _useState5=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]),_useState6=_slicedToArray(_useState5,2),fullPlace=_useState6[0],setFullPlace=_useState6[1];if(!showModal){return null;}var onHandleSearchNewDeliveryAddress=function onHandleSearchNewDeliveryAddress(){setSearch(true);showModal=false;};var onHandleBackToAddressList=function onHandleBackToAddressList(){setSearch(false);};var onHandleSetAddress=function onHandleSetAddress(place){setPlace(place.formatted_address);setFullPlace(place);};var onHandleSaveAddress=function onHandleSaveAddress(){createCustomerDeliveryAddress(getAddressInfoObject());};var getAddressInfoObject=function getAddressInfoObject(){return{formattedAddress:fullPlace.formatted_address,placeId:fullPlace.place_id,lat:fullPlace.geometry.location.lat(),lng:fullPlace.geometry.location.lng()};};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__hoc_ReactAux_ReactAux__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_modal___default.a,{isOpen:showModal,style:customStyles,className:'content-react-modal',contentLabel:'Order for Modal'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'login3',className:'mfp-bg-login white-popup-block lb-centralizar singup zoom-anim-dialog'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{style:{display:'block',margin:'0 auto',paddingBottom:'80px'},src:__WEBPACK_IMPORTED_MODULE_4_images_logo_lunch_team_svg___default.a,alt:'Lunch Team'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'b'},'Order for'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{maxHeight:document.documentElement.clientHeight>900?'600px':'300px',overflowY:'scroll',paddingRight:'8px',marginRight:'-10px'}},!search?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(OptionsForDelivery,{idBusiness:idBusiness,onToggleCart:onToggleCart,onDeleteAllproductsFromCard:onDeleteAllproductsFromCard,onFetchingMenu:onFetchingMenu,listAddress:listAddress,selectOptionForOrder:selectOptionForOrder,showCollectionOption:showCollectionOption,showDeliverAtHomeOption:showDeliverAtHomeOption,handleSearchNewDeliveryAddress:onHandleSearchNewDeliveryAddress,onCartResetState:onCartResetState,onDeleteRestaurantSelected:onDeleteRestaurantSelected,onFetchingRecentlyOrdered:onFetchingRecentlyOrdered}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(LocationSearchInput,{handleSetAddress:onHandleSetAddress,handleSaveAddress:onHandleSaveAddress,handleBackToAddressList:onHandleBackToAddressList,place:place}))))));};/* harmony default export */ __webpack_exports__["a"] = (OptionsForDeliveryOrCollectionOrder);

/***/ }),
/* 197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process, module) {/* unused harmony export css */
/* unused harmony export keyframes */
/* unused harmony export injectGlobal */
/* unused harmony export isStyledComponent */
/* unused harmony export consolidateStreamedStyles */
/* unused harmony export ThemeProvider */
/* unused harmony export withTheme */
/* unused harmony export ServerStyleSheet */
/* unused harmony export StyleSheetManager */
/* unused harmony export __DO_NOT_USE_OR_YOU_WILL_BE_HAUNTED_BY_SPOOKY_GHOSTS */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fbjs_lib_hyphenateStyleName__ = __webpack_require__(755);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fbjs_lib_hyphenateStyleName___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_fbjs_lib_hyphenateStyleName__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_stylis__ = __webpack_require__(757);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_stylis___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_stylis__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_stylis_rule_sheet__ = __webpack_require__(758);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_stylis_rule_sheet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_stylis_rule_sheet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_hoist_non_react_statics__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_is__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_is__);








var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};

var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

// 
var isPlainObject = (function (x) {
  return (typeof x === 'undefined' ? 'undefined' : _typeof(x)) === 'object' && x.constructor === Object;
});

// 


/**
 * Parse errors.md and turn it into a simple hash of code: message
 */
var ERRORS =  false ? {
  "1": "Cannot create styled-component for component: %s.\n\n",
  "2": "Can't collect styles once you've consumed a `ServerStyleSheet`'s styles! `ServerStyleSheet` is a one off instance for each server-side render cycle.\n\n* Are you trying to reuse it across renders?\n* Are you accidentally calling collectStyles twice?\n\n",
  "3": "Streaming SSR is only supported in a Node.js environment; Please do not try to call this method in the browser.\n\n",
  "4": "The `StyleSheetManager` expects a valid target or sheet prop!\n\n* Does this error occur on the client and is your target falsy?\n* Does this error occur on the server and is the sheet falsy?\n\n",
  "5": "The clone method cannot be used on the client!\n\n* Are you running in a client-like environment on the server?\n* Are you trying to run SSR on the client?\n\n",
  "6": "Trying to insert a new style tag, but the given Node is unmounted!\n\n* Are you using a custom target that isn't mounted?\n* Does your document not have a valid head element?\n* Have you accidentally removed a style tag manually?\n\n",
  "7": "ThemeProvider: Please return an object from your \"theme\" prop function, e.g.\n\n```js\ntheme={() => ({})}\n```\n\n",
  "8": "ThemeProvider: Please make your \"theme\" prop an object.\n\n",
  "9": "Missing document `<head>`\n\n",
  "10": "Cannot find a StyleSheet instance. Usually this happens if there are multiple copies of styled-components loaded at once. Check out this issue for how to troubleshoot and fix the common cases where this situation can happen: https://github.com/styled-components/styled-components/issues/1941#issuecomment-417862021\n\n",
  "11": "A plain React class (%s) has been interpolated into styles, probably as a component selector (https://www.styled-components.com/docs/advanced#referring-to-other-components). Only styled-component classes can be targeted in this fashion."
} : {};

/**
 * super basic version of sprintf
 */
function format() {
  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  var a = args[0];
  var b = [];
  var c = void 0;

  for (c = 1; c < args.length; c += 1) {
    b.push(args[c]);
  }

  b.forEach(function (d) {
    a = a.replace(/%[a-z]/, d);
  });

  return a;
}

/**
 * Create an error file out of errors.md for development and a simple web link to the full errors
 * in production mode.
 */

var StyledComponentsError = function (_Error) {
  inherits(StyledComponentsError, _Error);

  function StyledComponentsError(code) {
    classCallCheck(this, StyledComponentsError);

    for (var _len2 = arguments.length, interpolations = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      interpolations[_key2 - 1] = arguments[_key2];
    }

    if (true) {
      var _this = possibleConstructorReturn(this, _Error.call(this, 'An error occurred. See https://github.com/styled-components/styled-components/blob/master/src/utils/errors.md#' + code + ' for more information. ' + (interpolations ? 'Additional arguments: ' + interpolations.join(', ') : '')));
    } else {
      var _this = possibleConstructorReturn(this, _Error.call(this, format.apply(undefined, [ERRORS[code]].concat(interpolations))));
    }
    return possibleConstructorReturn(_this);
  }

  return StyledComponentsError;
}(Error);

// 

var objToCss = function objToCss(obj, prevKey) {
  var css = Object.keys(obj).filter(function (key) {
    var chunk = obj[key];
    return chunk !== undefined && chunk !== null && chunk !== false && chunk !== '';
  }).map(function (key) {
    if (isPlainObject(obj[key])) return objToCss(obj[key], key);
    return __WEBPACK_IMPORTED_MODULE_0_fbjs_lib_hyphenateStyleName___default()(key) + ': ' + obj[key] + ';';
  }).join(' ');
  return prevKey ? prevKey + ' {\n  ' + css + '\n}' : css;
};

var flatten = function flatten(chunks, executionContext) {
  return chunks.reduce(function (ruleSet, chunk) {
    /* Remove falsey values */
    if (chunk === undefined || chunk === null || chunk === false || chunk === '') {
      return ruleSet;
    }

    /* Flatten ruleSet */
    if (Array.isArray(chunk)) {
      ruleSet.push.apply(ruleSet, flatten(chunk, executionContext));
      return ruleSet;
    }

    /* Handle other components */
    if (chunk.hasOwnProperty('styledComponentId')) {
      // $FlowFixMe not sure how to make this pass
      ruleSet.push('.' + chunk.styledComponentId);
      return ruleSet;
    }

    /* Either execute or defer the function */
    if (typeof chunk === 'function') {
      if (executionContext) {
        var nextChunk = chunk(executionContext);
        /* Throw if a React Element was given styles */
        if (__WEBPACK_IMPORTED_MODULE_1_react___default.a.isValidElement(nextChunk)) {
          var elementName = chunk.displayName || chunk.name;
          throw new StyledComponentsError(11, elementName);
        }
        ruleSet.push.apply(ruleSet, flatten([nextChunk], executionContext));
      } else ruleSet.push(chunk);

      return ruleSet;
    }

    /* Handle objects */
    ruleSet.push(
    // $FlowFixMe have to add %checks somehow to isPlainObject
    isPlainObject(chunk) ? objToCss(chunk) : chunk.toString());

    return ruleSet;
  }, []);
};

// 

var COMMENT_REGEX = /^\s*\/\/.*$/gm;

// NOTE: This stylis instance is only used to split rules from SSR'd style tags
var stylisSplitter = new __WEBPACK_IMPORTED_MODULE_2_stylis___default.a({
  global: false,
  cascade: true,
  keyframe: false,
  prefix: false,
  compress: false,
  semicolon: true
});

var stylis = new __WEBPACK_IMPORTED_MODULE_2_stylis___default.a({
  global: false,
  cascade: true,
  keyframe: false,
  prefix: true,
  compress: false,
  semicolon: false // NOTE: This means "autocomplete missing semicolons"
});

// Wrap `insertRulePlugin to build a list of rules,
// and then make our own plugin to return the rules. This
// makes it easier to hook into the existing SSR architecture

var parsingRules = [];
// eslint-disable-next-line consistent-return
var returnRulesPlugin = function returnRulesPlugin(context) {
  if (context === -2) {
    var parsedRules = parsingRules;
    parsingRules = [];
    return parsedRules;
  }
};

var parseRulesPlugin = __WEBPACK_IMPORTED_MODULE_3_stylis_rule_sheet___default()(function (rule) {
  parsingRules.push(rule);
});

stylis.use([parseRulesPlugin, returnRulesPlugin]);
stylisSplitter.use([parseRulesPlugin, returnRulesPlugin]);

var stringifyRules = function stringifyRules(rules, selector, prefix) {
  var flatCSS = rules.join('').replace(COMMENT_REGEX, ''); // replace JS comments

  var cssStr = selector && prefix ? prefix + ' ' + selector + ' { ' + flatCSS + ' }' : flatCSS;

  return stylis(prefix || !selector ? '' : selector, cssStr);
};

var splitByRules = function splitByRules(css) {
  return stylisSplitter('', css);
};

// 

function isStyledComponent(target) /* : %checks */{
  return (
    // $FlowFixMe TODO: flow for styledComponentId
    typeof target === 'function' && typeof target.styledComponentId === 'string'
  );
}

// 

/* This function is DEPRECATED and will be removed on the next major version release.
 * It was needed to rehydrate all style blocks prepended to chunks before React
 * tries to rehydrate its HTML stream. Since the master StyleSheet will now detect
 * the use of streamed style tags and will perform the rehydration earlier when needed
 * this function will not be needed anymore */
function consolidateStreamedStyles() {
  if (false) {
    // eslint-disable-next-line no-console
    console.warn('styled-components automatically does streaming SSR rehydration now.\n' + 'Calling consolidateStreamedStyles manually is no longer necessary and a noop now.\n' + '- Please remove the consolidateStreamedStyles call from your client.');
  }
}

// 
/* eslint-disable no-bitwise */

/* This is the "capacity" of our alphabet i.e. 2x26 for all letters plus their capitalised
 * counterparts */
var charsLength = 52;

/* start at 75 for 'a' until 'z' (25) and then start at 65 for capitalised letters */
var getAlphabeticChar = function getAlphabeticChar(code) {
  return String.fromCharCode(code + (code > 25 ? 39 : 97));
};

/* input a number, usually a hash and convert it to base-52 */
var generateAlphabeticName = function generateAlphabeticName(code) {
  var name = '';
  var x = void 0;

  /* get a char and divide by alphabet-length */
  for (x = code; x > charsLength; x = Math.floor(x / charsLength)) {
    name = getAlphabeticChar(x % charsLength) + name;
  }

  return getAlphabeticChar(x % charsLength) + name;
};

// 

var interleave = (function (strings, interpolations) {
  var result = [strings[0]];

  for (var i = 0, len = interpolations.length; i < len; i += 1) {
    result.push(interpolations[i], strings[i + 1]);
  }

  return result;
});

// 
var EMPTY_ARRAY = Object.freeze([]);
var EMPTY_OBJECT = Object.freeze({});

// 

var css = (function (styles) {
  for (var _len = arguments.length, interpolations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    interpolations[_key - 1] = arguments[_key];
  }

  if (typeof styles === 'function' || isPlainObject(styles)) {
    // $FlowFixMe
    return flatten(interleave(EMPTY_ARRAY, [styles].concat(interpolations)));
  }

  // $FlowFixMe
  return flatten(interleave(styles, interpolations));
});

// 


var SC_ATTR = typeof process !== 'undefined' && Object({"NODE_ENV":"production","PUBLIC_URL":"","REACT_APP_SUPPORT_COMPOSER":"true","REACT_APP_SUPPORT_HOURS":"Mon-Fri 07:00-15:00","REACT_APP_ALLERGEN_GATE_RESTAURANTS":"8630"}).SC_ATTR || 'data-styled-components';
var SC_STREAM_ATTR = 'data-styled-streamed';
var CONTEXT_KEY = '__styled-components-stylesheet__';

var IS_BROWSER = typeof window !== 'undefined' && 'HTMLElement' in window;

var DISABLE_SPEEDY = "production" !== 'production';

// 
var SC_COMPONENT_ID = /^[^\S\n]*?\/\* sc-component-id:\s*(\S+)\s+\*\//gm;

var extractComps = (function (maybeCSS) {
  var css = '' + (maybeCSS || ''); // Definitely a string, and a clone
  var existingComponents = [];
  css.replace(SC_COMPONENT_ID, function (match, componentId, matchIndex) {
    existingComponents.push({ componentId: componentId, matchIndex: matchIndex });
    return match;
  });
  return existingComponents.map(function (_ref, i) {
    var componentId = _ref.componentId,
        matchIndex = _ref.matchIndex;

    var nextComp = existingComponents[i + 1];
    var cssFromDOM = nextComp ? css.slice(matchIndex, nextComp.matchIndex) : css.slice(matchIndex);
    return { componentId: componentId, cssFromDOM: cssFromDOM };
  });
});

// 
/* eslint-disable camelcase, no-undef */

var getNonce = (function () {
  return  true ? __webpack_require__.nc : null;
});

// 
// Helper to call a given function, only once
var once = (function (cb) {
  var called = false;

  return function () {
    if (!called) {
      called = true;
      cb();
    }
  };
});

// 
/* These are helpers for the StyleTags to keep track of the injected
 * rule names for each (component) ID that they're keeping track of.
 * They're crucial for detecting whether a name has already been
 * injected.
 * (This excludes rehydrated names) */

/* adds a new ID:name pairing to a names dictionary */
var addNameForId = function addNameForId(names, id, name) {
  if (name) {
    // eslint-disable-next-line no-param-reassign
    var namesForId = names[id] || (names[id] = Object.create(null));
    namesForId[name] = true;
  }
};

/* resets an ID entirely by overwriting it in the dictionary */
var resetIdNames = function resetIdNames(names, id) {
  // eslint-disable-next-line no-param-reassign
  names[id] = Object.create(null);
};

/* factory for a names dictionary checking the existance of an ID:name pairing */
var hasNameForId = function hasNameForId(names) {
  return function (id, name) {
    return names[id] !== undefined && names[id][name];
  };
};

/* stringifies names for the html/element output */
var stringifyNames = function stringifyNames(names) {
  var str = '';
  // eslint-disable-next-line guard-for-in
  for (var id in names) {
    str += Object.keys(names[id]).join(' ') + ' ';
  }
  return str.trim();
};

/* clones the nested names dictionary */
var cloneNames = function cloneNames(names) {
  var clone = Object.create(null);
  // eslint-disable-next-line guard-for-in
  for (var id in names) {
    clone[id] = _extends({}, names[id]);
  }
  return clone;
};

// 

/* These are helpers that deal with the insertRule (aka speedy) API
 * They are used in the StyleTags and specifically the speedy tag
 */

/* retrieve a sheet for a given style tag */
var sheetForTag = function sheetForTag(tag) {
  // $FlowFixMe
  if (tag.sheet) return tag.sheet;

  /* Firefox quirk requires us to step through all stylesheets to find one owned by the given tag */
  var size = document.styleSheets.length;
  for (var i = 0; i < size; i += 1) {
    var sheet = document.styleSheets[i];
    // $FlowFixMe
    if (sheet.ownerNode === tag) return sheet;
  }

  /* we should always be able to find a tag */
  throw new StyledComponentsError(10);
};

/* insert a rule safely and return whether it was actually injected */
var safeInsertRule = function safeInsertRule(sheet, cssRule, index) {
  /* abort early if cssRule string is falsy */
  if (!cssRule) return false;

  var maxIndex = sheet.cssRules.length;

  try {
    /* use insertRule and cap passed index with maxIndex (no of cssRules) */
    sheet.insertRule(cssRule, index <= maxIndex ? index : maxIndex);
  } catch (err) {
    /* any error indicates an invalid rule */
    return false;
  }

  return true;
};

/* deletes `size` rules starting from `removalIndex` */
var deleteRules = function deleteRules(sheet, removalIndex, size) {
  var lowerBound = removalIndex - size;
  for (var i = removalIndex; i > lowerBound; i -= 1) {
    sheet.deleteRule(i);
  }
};

// 

/* this marker separates component styles and is important for rehydration */
var makeTextMarker = function makeTextMarker(id) {
  return '\n/* sc-component-id: ' + id + ' */\n';
};

/* add up all numbers in array up until and including the index */
var addUpUntilIndex = function addUpUntilIndex(sizes, index) {
  var totalUpToIndex = 0;
  for (var i = 0; i <= index; i += 1) {
    totalUpToIndex += sizes[i];
  }

  return totalUpToIndex;
};

/* create a new style tag after lastEl */
var makeStyleTag = function makeStyleTag(target, tagEl, insertBefore) {
  var el = document.createElement('style');
  el.setAttribute(SC_ATTR, '');

  var nonce = getNonce();
  if (nonce) {
    el.setAttribute('nonce', nonce);
  }

  /* Work around insertRule quirk in EdgeHTML */
  el.appendChild(document.createTextNode(''));

  if (target && !tagEl) {
    /* Append to target when no previous element was passed */
    target.appendChild(el);
  } else {
    if (!tagEl || !target || !tagEl.parentNode) {
      throw new StyledComponentsError(6);
    }

    /* Insert new style tag after the previous one */
    tagEl.parentNode.insertBefore(el, insertBefore ? tagEl : tagEl.nextSibling);
  }

  return el;
};

/* takes a css factory function and outputs an html styled tag factory */
var wrapAsHtmlTag = function wrapAsHtmlTag(css, names) {
  return function (additionalAttrs) {
    var nonce = getNonce();
    var attrs = [nonce && 'nonce="' + nonce + '"', SC_ATTR + '="' + stringifyNames(names) + '"', additionalAttrs];

    var htmlAttr = attrs.filter(Boolean).join(' ');
    return '<style ' + htmlAttr + '>' + css() + '</style>';
  };
};

/* takes a css factory function and outputs an element factory */
var wrapAsElement = function wrapAsElement(css, names) {
  return function () {
    var _props;

    var props = (_props = {}, _props[SC_ATTR] = stringifyNames(names), _props);

    var nonce = getNonce();
    if (nonce) {
      // $FlowFixMe
      props.nonce = nonce;
    }

    // eslint-disable-next-line react/no-danger
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('style', _extends({}, props, { dangerouslySetInnerHTML: { __html: css() } }));
  };
};

var getIdsFromMarkersFactory = function getIdsFromMarkersFactory(markers) {
  return function () {
    return Object.keys(markers);
  };
};

/* speedy tags utilise insertRule */
var makeSpeedyTag = function makeSpeedyTag(el, getImportRuleTag) {
  var names = Object.create(null);
  var markers = Object.create(null);
  var sizes = [];

  var extractImport = getImportRuleTag !== undefined;
  /* indicates whther getImportRuleTag was called */
  var usedImportRuleTag = false;

  var insertMarker = function insertMarker(id) {
    var prev = markers[id];
    if (prev !== undefined) {
      return prev;
    }

    markers[id] = sizes.length;
    sizes.push(0);
    resetIdNames(names, id);

    return markers[id];
  };

  var insertRules = function insertRules(id, cssRules, name) {
    var marker = insertMarker(id);
    var sheet = sheetForTag(el);
    var insertIndex = addUpUntilIndex(sizes, marker);

    var injectedRules = 0;
    var importRules = [];
    var cssRulesSize = cssRules.length;

    for (var i = 0; i < cssRulesSize; i += 1) {
      var cssRule = cssRules[i];
      var mayHaveImport = extractImport; /* @import rules are reordered to appear first */
      if (mayHaveImport && cssRule.indexOf('@import') !== -1) {
        importRules.push(cssRule);
      } else if (safeInsertRule(sheet, cssRule, insertIndex + injectedRules)) {
        mayHaveImport = false;
        injectedRules += 1;
      }
    }

    if (extractImport && importRules.length > 0) {
      usedImportRuleTag = true;
      // $FlowFixMe
      getImportRuleTag().insertRules(id + '-import', importRules);
    }

    sizes[marker] += injectedRules; /* add up no of injected rules */
    addNameForId(names, id, name);
  };

  var removeRules = function removeRules(id) {
    var marker = markers[id];
    if (marker === undefined) return;

    var size = sizes[marker];
    var sheet = sheetForTag(el);
    var removalIndex = addUpUntilIndex(sizes, marker);
    deleteRules(sheet, removalIndex, size);
    sizes[marker] = 0;
    resetIdNames(names, id);

    if (extractImport && usedImportRuleTag) {
      // $FlowFixMe
      getImportRuleTag().removeRules(id + '-import');
    }
  };

  var css = function css() {
    var _sheetForTag = sheetForTag(el),
        cssRules = _sheetForTag.cssRules;

    var str = '';

    // eslint-disable-next-line guard-for-in
    for (var id in markers) {
      str += makeTextMarker(id);
      var marker = markers[id];
      var end = addUpUntilIndex(sizes, marker);
      var size = sizes[marker];
      for (var i = end - size; i < end; i += 1) {
        var rule = cssRules[i];
        if (rule !== undefined) {
          str += rule.cssText;
        }
      }
    }

    return str;
  };

  return {
    clone: function clone() {
      throw new StyledComponentsError(5);
    },

    css: css,
    getIds: getIdsFromMarkersFactory(markers),
    hasNameForId: hasNameForId(names),
    insertMarker: insertMarker,
    insertRules: insertRules,
    removeRules: removeRules,
    sealed: false,
    styleTag: el,
    toElement: wrapAsElement(css, names),
    toHTML: wrapAsHtmlTag(css, names)
  };
};

var makeTextNode = function makeTextNode(id) {
  return document.createTextNode(makeTextMarker(id));
};

var makeBrowserTag = function makeBrowserTag(el, getImportRuleTag) {
  var names = Object.create(null);
  var markers = Object.create(null);

  var extractImport = getImportRuleTag !== undefined;

  /* indicates whther getImportRuleTag was called */
  var usedImportRuleTag = false;

  var insertMarker = function insertMarker(id) {
    var prev = markers[id];
    if (prev !== undefined) {
      return prev;
    }

    markers[id] = makeTextNode(id);
    el.appendChild(markers[id]);
    names[id] = Object.create(null);

    return markers[id];
  };

  var insertRules = function insertRules(id, cssRules, name) {
    var marker = insertMarker(id);
    var importRules = [];
    var cssRulesSize = cssRules.length;

    for (var i = 0; i < cssRulesSize; i += 1) {
      var rule = cssRules[i];
      var mayHaveImport = extractImport;
      if (mayHaveImport && rule.indexOf('@import') !== -1) {
        importRules.push(rule);
      } else {
        mayHaveImport = false;
        var separator = i === cssRulesSize - 1 ? '' : ' ';
        marker.appendData('' + rule + separator);
      }
    }

    addNameForId(names, id, name);

    if (extractImport && importRules.length > 0) {
      usedImportRuleTag = true;
      // $FlowFixMe
      getImportRuleTag().insertRules(id + '-import', importRules);
    }
  };

  var removeRules = function removeRules(id) {
    var marker = markers[id];
    if (marker === undefined) return;

    /* create new empty text node and replace the current one */
    var newMarker = makeTextNode(id);
    el.replaceChild(newMarker, marker);
    markers[id] = newMarker;
    resetIdNames(names, id);

    if (extractImport && usedImportRuleTag) {
      // $FlowFixMe
      getImportRuleTag().removeRules(id + '-import');
    }
  };

  var css = function css() {
    var str = '';
    // eslint-disable-next-line guard-for-in
    for (var id in markers) {
      str += markers[id].data;
    }
    return str;
  };

  return {
    clone: function clone() {
      throw new StyledComponentsError(5);
    },

    css: css,
    getIds: getIdsFromMarkersFactory(markers),
    hasNameForId: hasNameForId(names),
    insertMarker: insertMarker,
    insertRules: insertRules,
    removeRules: removeRules,
    sealed: false,
    styleTag: el,
    toElement: wrapAsElement(css, names),
    toHTML: wrapAsHtmlTag(css, names)
  };
};

var makeServerTagInternal = function makeServerTagInternal(namesArg, markersArg) {
  var names = namesArg === undefined ? Object.create(null) : namesArg;
  var markers = markersArg === undefined ? Object.create(null) : markersArg;

  var insertMarker = function insertMarker(id) {
    var prev = markers[id];
    if (prev !== undefined) {
      return prev;
    }

    return markers[id] = [''];
  };

  var insertRules = function insertRules(id, cssRules, name) {
    var marker = insertMarker(id);
    marker[0] += cssRules.join(' ');
    addNameForId(names, id, name);
  };

  var removeRules = function removeRules(id) {
    var marker = markers[id];
    if (marker === undefined) return;
    marker[0] = '';
    resetIdNames(names, id);
  };

  var css = function css() {
    var str = '';
    // eslint-disable-next-line guard-for-in
    for (var id in markers) {
      var cssForId = markers[id][0];
      if (cssForId) {
        str += makeTextMarker(id) + cssForId;
      }
    }
    return str;
  };

  var clone = function clone() {
    var namesClone = cloneNames(names);
    var markersClone = Object.create(null);

    // eslint-disable-next-line guard-for-in
    for (var id in markers) {
      markersClone[id] = [markers[id][0]];
    }

    return makeServerTagInternal(namesClone, markersClone);
  };

  var tag = {
    clone: clone,
    css: css,
    getIds: getIdsFromMarkersFactory(markers),
    hasNameForId: hasNameForId(names),
    insertMarker: insertMarker,
    insertRules: insertRules,
    removeRules: removeRules,
    sealed: false,
    styleTag: null,
    toElement: wrapAsElement(css, names),
    toHTML: wrapAsHtmlTag(css, names)
  };

  return tag;
};

var makeServerTag = function makeServerTag() {
  return makeServerTagInternal();
};

var makeTag = function makeTag(target, tagEl, forceServer, insertBefore, getImportRuleTag) {
  if (IS_BROWSER && !forceServer) {
    var el = makeStyleTag(target, tagEl, insertBefore);

    if (DISABLE_SPEEDY) {
      return makeBrowserTag(el, getImportRuleTag);
    } else {
      return makeSpeedyTag(el, getImportRuleTag);
    }
  }

  return makeServerTag();
};

/* wraps a given tag so that rehydration is performed once when necessary */
var makeRehydrationTag = function makeRehydrationTag(tag, els, extracted, immediateRehydration) {
  /* rehydration function that adds all rules to the new tag */
  var rehydrate = once(function () {
    /* add all extracted components to the new tag */
    for (var i = 0, len = extracted.length; i < len; i += 1) {
      var _extracted$i = extracted[i],
          componentId = _extracted$i.componentId,
          cssFromDOM = _extracted$i.cssFromDOM;

      var cssRules = splitByRules(cssFromDOM);
      tag.insertRules(componentId, cssRules);
    }

    /* remove old HTMLStyleElements, since they have been rehydrated */
    for (var _i = 0, _len = els.length; _i < _len; _i += 1) {
      var el = els[_i];
      if (el.parentNode) {
        el.parentNode.removeChild(el);
      }
    }
  });

  if (immediateRehydration) rehydrate();

  return _extends({}, tag, {
    /* add rehydration hook to insertion methods */
    insertMarker: function insertMarker(id) {
      rehydrate();
      return tag.insertMarker(id);
    },
    insertRules: function insertRules(id, cssRules, name) {
      rehydrate();
      return tag.insertRules(id, cssRules, name);
    }
  });
};

// 

var SPLIT_REGEX = /\s+/;

/* determine the maximum number of components before tags are sharded */
var MAX_SIZE = void 0;
if (IS_BROWSER) {
  /* in speedy mode we can keep a lot more rules in a sheet before a slowdown can be expected */
  MAX_SIZE = DISABLE_SPEEDY ? 40 : 1000;
} else {
  /* for servers we do not need to shard at all */
  MAX_SIZE = -1;
}

var sheetRunningId = 0;
var master = void 0;

var StyleSheet = function () {
  /* a map from ids to tags */
  /* deferred rules for a given id */
  /* this is used for not reinjecting rules via hasNameForId() */
  /* when rules for an id are removed using remove() we have to ignore rehydratedNames for it */
  /* a list of tags belonging to this StyleSheet */
  /* a tag for import rules */
  /* current capacity until a new tag must be created */
  /* children (aka clones) of this StyleSheet inheriting all and future injections */

  function StyleSheet() {
    var _this = this;

    var target = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : IS_BROWSER ? document.head : null;
    var forceServer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    classCallCheck(this, StyleSheet);

    this.getImportRuleTag = function () {
      var importRuleTag = _this.importRuleTag;

      if (importRuleTag !== undefined) {
        return importRuleTag;
      }

      var firstTag = _this.tags[0];
      var insertBefore = true;

      return _this.importRuleTag = makeTag(_this.target, firstTag ? firstTag.styleTag : null, _this.forceServer, insertBefore);
    };

    sheetRunningId += 1;
    this.id = sheetRunningId;
    this.forceServer = forceServer;
    this.target = forceServer ? null : target;
    this.tagMap = {};
    this.deferred = {};
    this.rehydratedNames = {};
    this.ignoreRehydratedNames = {};
    this.tags = [];
    this.capacity = 1;
    this.clones = [];
  }

  /* rehydrate all SSR'd style tags */


  StyleSheet.prototype.rehydrate = function rehydrate() {
    if (!IS_BROWSER || this.forceServer) {
      return this;
    }

    var els = [];
    var extracted = [];
    var isStreamed = false;

    /* retrieve all of our SSR style elements from the DOM */
    var nodes = document.querySelectorAll('style[' + SC_ATTR + ']');
    var nodesSize = nodes.length;

    /* abort rehydration if no previous style tags were found */
    if (nodesSize === 0) {
      return this;
    }

    for (var i = 0; i < nodesSize; i += 1) {
      // $FlowFixMe: We can trust that all elements in this query are style elements
      var el = nodes[i];

      /* check if style tag is a streamed tag */
      if (!isStreamed) isStreamed = !!el.getAttribute(SC_STREAM_ATTR);

      /* retrieve all component names */
      var elNames = (el.getAttribute(SC_ATTR) || '').trim().split(SPLIT_REGEX);
      var elNamesSize = elNames.length;
      for (var j = 0; j < elNamesSize; j += 1) {
        var name = elNames[j];
        /* add rehydrated name to sheet to avoid readding styles */
        this.rehydratedNames[name] = true;
      }

      /* extract all components and their CSS */
      extracted.push.apply(extracted, extractComps(el.textContent));

      /* store original HTMLStyleElement */
      els.push(el);
    }

    /* abort rehydration if nothing was extracted */
    var extractedSize = extracted.length;
    if (extractedSize === 0) {
      return this;
    }

    /* create a tag to be used for rehydration */
    var tag = this.makeTag(null);
    var rehydrationTag = makeRehydrationTag(tag, els, extracted, isStreamed);

    /* reset capacity and adjust MAX_SIZE by the initial size of the rehydration */
    this.capacity = Math.max(1, MAX_SIZE - extractedSize);
    this.tags.push(rehydrationTag);

    /* retrieve all component ids */
    for (var _j = 0; _j < extractedSize; _j += 1) {
      this.tagMap[extracted[_j].componentId] = rehydrationTag;
    }

    return this;
  };

  /* retrieve a "master" instance of StyleSheet which is typically used when no other is available
   * The master StyleSheet is targeted by injectGlobal, keyframes, and components outside of any
    * StyleSheetManager's context */


  /* reset the internal "master" instance */
  StyleSheet.reset = function reset() {
    var forceServer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    master = new StyleSheet(undefined, forceServer).rehydrate();
  };

  /* adds "children" to the StyleSheet that inherit all of the parents' rules
   * while their own rules do not affect the parent */


  StyleSheet.prototype.clone = function clone() {
    var sheet = new StyleSheet(this.target, this.forceServer);

    /* add to clone array */
    this.clones.push(sheet);

    /* clone all tags */
    sheet.tags = this.tags.map(function (tag) {
      var ids = tag.getIds();
      var newTag = tag.clone();

      /* reconstruct tagMap */
      for (var i = 0; i < ids.length; i += 1) {
        sheet.tagMap[ids[i]] = newTag;
      }

      return newTag;
    });

    /* clone other maps */
    sheet.rehydratedNames = _extends({}, this.rehydratedNames);
    sheet.deferred = _extends({}, this.deferred);

    return sheet;
  };

  /* force StyleSheet to create a new tag on the next injection */


  StyleSheet.prototype.sealAllTags = function sealAllTags() {
    this.capacity = 1;

    this.tags.forEach(function (tag) {
      // eslint-disable-next-line no-param-reassign
      tag.sealed = true;
    });
  };

  StyleSheet.prototype.makeTag = function makeTag$$1(tag) {
    var lastEl = tag ? tag.styleTag : null;
    var insertBefore = false;

    return makeTag(this.target, lastEl, this.forceServer, insertBefore, this.getImportRuleTag);
  };

  /* get a tag for a given componentId, assign the componentId to one, or shard */
  StyleSheet.prototype.getTagForId = function getTagForId(id) {
    /* simply return a tag, when the componentId was already assigned one */
    var prev = this.tagMap[id];
    if (prev !== undefined && !prev.sealed) {
      return prev;
    }

    var tag = this.tags[this.tags.length - 1];

    /* shard (create a new tag) if the tag is exhausted (See MAX_SIZE) */
    this.capacity -= 1;

    if (this.capacity === 0) {
      this.capacity = MAX_SIZE;
      tag = this.makeTag(tag);
      this.tags.push(tag);
    }

    return this.tagMap[id] = tag;
  };

  /* mainly for injectGlobal to check for its id */


  StyleSheet.prototype.hasId = function hasId(id) {
    return this.tagMap[id] !== undefined;
  };

  /* caching layer checking id+name to already have a corresponding tag and injected rules */


  StyleSheet.prototype.hasNameForId = function hasNameForId(id, name) {
    /* exception for rehydrated names which are checked separately */
    if (this.ignoreRehydratedNames[id] === undefined && this.rehydratedNames[name]) {
      return true;
    }

    var tag = this.tagMap[id];
    return tag !== undefined && tag.hasNameForId(id, name);
  };

  /* registers a componentId and registers it on its tag */


  StyleSheet.prototype.deferredInject = function deferredInject(id, cssRules) {
    /* don't inject when the id is already registered */
    if (this.tagMap[id] !== undefined) return;

    var clones = this.clones;

    for (var i = 0; i < clones.length; i += 1) {
      clones[i].deferredInject(id, cssRules);
    }

    this.getTagForId(id).insertMarker(id);
    this.deferred[id] = cssRules;
  };

  /* injects rules for a given id with a name that will need to be cached */


  StyleSheet.prototype.inject = function inject(id, cssRules, name) {
    var clones = this.clones;


    for (var i = 0; i < clones.length; i += 1) {
      clones[i].inject(id, cssRules, name);
    }

    var tag = this.getTagForId(id);

    /* add deferred rules for component */
    if (this.deferred[id] !== undefined) {
      // Combine passed cssRules with previously deferred CSS rules
      // NOTE: We cannot mutate the deferred array itself as all clones
      // do the same (see clones[i].inject)
      var rules = this.deferred[id].concat(cssRules);
      tag.insertRules(id, rules, name);

      this.deferred[id] = undefined;
    } else {
      tag.insertRules(id, cssRules, name);
    }
  };

  /* removes all rules for a given id, which doesn't remove its marker but resets it */


  StyleSheet.prototype.remove = function remove(id) {
    var tag = this.tagMap[id];
    if (tag === undefined) return;

    var clones = this.clones;

    for (var i = 0; i < clones.length; i += 1) {
      clones[i].remove(id);
    }

    /* remove all rules from the tag */
    tag.removeRules(id);
    /* ignore possible rehydrated names */
    this.ignoreRehydratedNames[id] = true;
    /* delete possible deferred rules */
    this.deferred[id] = undefined;
  };

  StyleSheet.prototype.toHTML = function toHTML() {
    return this.tags.map(function (tag) {
      return tag.toHTML();
    }).join('');
  };

  StyleSheet.prototype.toReactElements = function toReactElements() {
    var id = this.id;


    return this.tags.map(function (tag, i) {
      var key = 'sc-' + id + '-' + i;
      return Object(__WEBPACK_IMPORTED_MODULE_1_react__["cloneElement"])(tag.toElement(), { key: key });
    });
  };

  createClass(StyleSheet, null, [{
    key: 'master',
    get: function get$$1() {
      return master || (master = new StyleSheet().rehydrate());
    }

    /* NOTE: This is just for backwards-compatibility with jest-styled-components */

  }, {
    key: 'instance',
    get: function get$$1() {
      return StyleSheet.master;
    }
  }]);
  return StyleSheet;
}();

var _StyleSheetManager$ch;

var StyleSheetManager = function (_Component) {
  inherits(StyleSheetManager, _Component);

  function StyleSheetManager() {
    classCallCheck(this, StyleSheetManager);
    return possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  StyleSheetManager.prototype.getChildContext = function getChildContext() {
    var _ref;

    return _ref = {}, _ref[CONTEXT_KEY] = this.sheetInstance, _ref;
  };

  StyleSheetManager.prototype.componentWillMount = function componentWillMount() {
    if (this.props.sheet) {
      this.sheetInstance = this.props.sheet;
    } else if (this.props.target) {
      this.sheetInstance = new StyleSheet(this.props.target);
    } else {
      throw new StyledComponentsError(4);
    }
  };

  StyleSheetManager.prototype.render = function render() {
    /* eslint-disable react/prop-types */
    // Flow v0.43.1 will report an error accessing the `children` property,
    // but v0.47.0 will not. It is necessary to use a type cast instead of
    // a "fixme" comment to satisfy both Flow versions.
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.Children.only(this.props.children);
  };

  return StyleSheetManager;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

StyleSheetManager.childContextTypes = (_StyleSheetManager$ch = {}, _StyleSheetManager$ch[CONTEXT_KEY] = __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.instanceOf(StyleSheet), __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.instanceOf(ServerStyleSheet)]).isRequired, _StyleSheetManager$ch);
 false ? StyleSheetManager.propTypes = {
  sheet: PropTypes.oneOfType([PropTypes.instanceOf(StyleSheet), PropTypes.instanceOf(ServerStyleSheet)]),
  target: PropTypes.shape({
    appendChild: PropTypes.func.isRequired
  })
} : void 0;

// 

var ServerStyleSheet = function () {
  function ServerStyleSheet() {
    classCallCheck(this, ServerStyleSheet);

    /* The master sheet might be reset, so keep a reference here */
    this.masterSheet = StyleSheet.master;
    this.instance = this.masterSheet.clone();
    this.closed = false;
  }

  ServerStyleSheet.prototype.complete = function complete() {
    if (!this.closed) {
      /* Remove closed StyleSheets from the master sheet */
      var index = this.masterSheet.clones.indexOf(this.instance);
      this.masterSheet.clones.splice(index, 1);
      this.closed = true;
    }
  };

  ServerStyleSheet.prototype.collectStyles = function collectStyles(children) {
    if (this.closed) {
      throw new StyledComponentsError(2);
    }

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      StyleSheetManager,
      { sheet: this.instance },
      children
    );
  };

  ServerStyleSheet.prototype.getStyleTags = function getStyleTags() {
    this.complete();
    return this.instance.toHTML();
  };

  ServerStyleSheet.prototype.getStyleElement = function getStyleElement() {
    this.complete();
    return this.instance.toReactElements();
  };

  ServerStyleSheet.prototype.interleaveWithNodeStream = function interleaveWithNodeStream(readableStream) {
    var _this = this;

    {
      throw new StyledComponentsError(3);
    }

    /* the tag index keeps track of which tags have already been emitted */
    var instance = this.instance;

    var instanceTagIndex = 0;

    var streamAttr = SC_STREAM_ATTR + '="true"';

    var transformer = new stream.Transform({
      transform: function appendStyleChunks(chunk, /* encoding */_, callback) {
        var tags = instance.tags;

        var html = '';

        /* retrieve html for each new style tag */
        for (; instanceTagIndex < tags.length; instanceTagIndex += 1) {
          var tag = tags[instanceTagIndex];
          html += tag.toHTML(streamAttr);
        }

        /* force our StyleSheets to emit entirely new tags */
        instance.sealAllTags();

        /* prepend style html to chunk */
        this.push(html + chunk);
        callback();
      }
    });

    readableStream.on('end', function () {
      return _this.complete();
    });
    readableStream.on('error', function (err) {
      _this.complete();

      // forward the error to the transform stream
      transformer.emit('error', err);
    });

    return readableStream.pipe(transformer);
  };

  return ServerStyleSheet;
}();

// 

var LIMIT = 200;

var createWarnTooManyClasses = (function (displayName) {
  var generatedClasses = {};
  var warningSeen = false;

  return function (className) {
    if (!warningSeen) {
      generatedClasses[className] = true;
      if (Object.keys(generatedClasses).length >= LIMIT) {
        // Unable to find latestRule in test environment.
        /* eslint-disable no-console, prefer-template */
        console.warn('Over ' + LIMIT + ' classes were generated for component ' + displayName + '. \n' + 'Consider using the attrs method, together with a style object for frequently changed styles.\n' + 'Example:\n' + '  const Component = styled.div.attrs({\n' + '    style: ({ background }) => ({\n' + '      background,\n' + '    }),\n' + '  })`width: 100%;`\n\n' + '  <Component />');
        warningSeen = true;
        generatedClasses = {};
      }
    }
  };
});

// 

var determineTheme = (function (props, fallbackTheme, defaultProps) {
  // Props should take precedence over ThemeProvider, which should take precedence over
  // defaultProps, but React automatically puts defaultProps on props.

  /* eslint-disable react/prop-types */
  var isDefaultTheme = defaultProps && props.theme === defaultProps.theme;
  var theme = props.theme && !isDefaultTheme ? props.theme : fallbackTheme;
  /* eslint-enable */

  return theme;
});

// 
var escapeRegex = /[[\].#*$><+~=|^:(),"'`-]+/g;
var dashesAtEnds = /(^-|-$)/g;

/**
 * TODO: Explore using CSS.escape when it becomes more available
 * in evergreen browsers.
 */
function escape(str) {
  return str
  // Replace all possible CSS selectors
  .replace(escapeRegex, '-')

  // Remove extraneous hyphens at the start and end
  .replace(dashesAtEnds, '');
}

// 

function getComponentName(target) {
  return target.displayName || target.name || 'Component';
}

// 

function isTag(target) /* : %checks */{
  return typeof target === 'string';
}

// 

function generateDisplayName(target) {
  return isTag(target) ? 'styled.' + target : 'Styled(' + getComponentName(target) + ')';
}

// 
/* eslint-disable max-len */
/**
 * Trying to avoid the unknown-prop errors on styled components by filtering by
 * React's attribute whitelist.
 *
 * To regenerate this regex:
 *
 * 1. `npm i -g regexgen` (https://github.com/devongovett/regexgen)
 * 2. Run `regexgen` with the list of space-separated words below as input
 * 3. Surround the emitted regex with this: `/^(GENERATED_REGEX)$/` -- this will ensure a full string match
 *    and no false positives from partials
 * */
/*
children dangerouslySetInnerHTML key ref autoFocus defaultValue valueLink defaultChecked checkedLink innerHTML suppressContentEditableWarning onFocusIn onFocusOut className onCopy onCut onPaste onCompositionEnd onCompositionStart onCompositionUpdate onKeyDown onKeyPress onKeyUp onFocus onBlur onChange onInput onInvalid onSubmit onReset onClick onContextMenu onDoubleClick onDrag onDragEnd onDragEnter onDragExit onDragLeave onDragOver onDragStart onDrop onMouseDown onMouseEnter onMouseLeave onMouseMove onMouseOut onMouseOver onMouseUp onSelect onTouchCancel onTouchEnd onTouchMove onTouchStart onScroll onWheel onAbort onCanPlay onCanPlayThrough onDurationChange onEmptied onEncrypted onEnded onError onLoadedData onLoadedMetadata onLoadStart onPause onPlay onPlaying onProgress onRateChange onSeeked onSeeking onStalled onSuspend onTimeUpdate onVolumeChange onWaiting onLoad onAnimationStart onAnimationEnd onAnimationIteration onTransitionEnd onCopyCapture onCutCapture onPasteCapture onCompositionEndCapture onCompositionStartCapture onCompositionUpdateCapture onKeyDownCapture onKeyPressCapture onKeyUpCapture onFocusCapture onBlurCapture onChangeCapture onInputCapture onSubmitCapture onResetCapture onClickCapture onContextMenuCapture onDoubleClickCapture onDragCapture onDragEndCapture onDragEnterCapture onDragExitCapture onDragLeaveCapture onDragOverCapture onDragStartCapture onDropCapture onMouseDownCapture onMouseEnterCapture onMouseLeaveCapture onMouseMoveCapture onMouseOutCapture onMouseOverCapture onMouseUpCapture onSelectCapture onTouchCancelCapture onTouchEndCapture onTouchMoveCapture onTouchStartCapture onScrollCapture onWheelCapture onAbortCapture onCanPlayCapture onCanPlayThroughCapture onDurationChangeCapture onEmptiedCapture onEncryptedCapture onEndedCapture onErrorCapture onLoadedDataCapture onLoadedMetadataCapture onLoadStartCapture onPauseCapture onPlayCapture onPlayingCapture onProgressCapture onRateChangeCapture onSeekedCapture onSeekingCapture onStalledCapture onSuspendCapture onTimeUpdateCapture onVolumeChangeCapture onWaitingCapture onLoadCapture onAnimationStartCapture onAnimationEndCapture onAnimationIterationCapture onTransitionEndCapture accept acceptCharset accessKey action allowFullScreen allowTransparency alt as async autoComplete autoPlay capture cellPadding cellSpacing charSet challenge checked cite classID className cols colSpan content contentEditable contextMenu controlsList controls coords crossOrigin data dateTime default defer dir disabled download draggable encType form formAction formEncType formMethod formNoValidate formTarget frameBorder headers height hidden high href hrefLang htmlFor httpEquiv icon id inputMode integrity is keyParams keyType kind label lang list loop low manifest marginHeight marginWidth max maxLength media mediaGroup method min minLength multiple muted name nonce noValidate open optimum pattern placeholder playsInline poster preload profile radioGroup readOnly referrerPolicy rel required reversed role rows rowSpan sandbox scope scoped scrolling seamless selected shape size sizes span spellCheck src srcDoc srcLang srcSet start step style summary tabIndex target title type useMap value width wmode wrap about datatype inlist prefix property resource typeof vocab autoCapitalize autoCorrect autoSave color itemProp itemScope itemType itemID itemRef results security unselectable accentHeight accumulate additive alignmentBaseline allowReorder alphabetic amplitude arabicForm ascent attributeName attributeType autoReverse azimuth baseFrequency baseProfile baselineShift bbox begin bias by calcMode capHeight clip clipPath clipRule clipPathUnits colorInterpolation colorInterpolationFilters colorProfile colorRendering contentScriptType contentStyleType cursor cx cy d decelerate descent diffuseConstant direction display divisor dominantBaseline dur dx dy edgeMode elevation enableBackground end exponent externalResourcesRequired fill fillOpacity fillRule filter filterRes filterUnits floodColor floodOpacity focusable fontFamily fontSize fontSizeAdjust fontStretch fontStyle fontVariant fontWeight format from fx fy g1 g2 glyphName glyphOrientationHorizontal glyphOrientationVertical glyphRef gradientTransform gradientUnits hanging horizAdvX horizOriginX ideographic imageRendering in in2 intercept k k1 k2 k3 k4 kernelMatrix kernelUnitLength kerning keyPoints keySplines keyTimes lengthAdjust letterSpacing lightingColor limitingConeAngle local markerEnd markerMid markerStart markerHeight markerUnits markerWidth mask maskContentUnits maskUnits mathematical mode numOctaves offset opacity operator order orient orientation origin overflow overlinePosition overlineThickness paintOrder panose1 pathLength patternContentUnits patternTransform patternUnits pointerEvents points pointsAtX pointsAtY pointsAtZ preserveAlpha preserveAspectRatio primitiveUnits r radius refX refY renderingIntent repeatCount repeatDur requiredExtensions requiredFeatures restart result rotate rx ry scale seed shapeRendering slope spacing specularConstant specularExponent speed spreadMethod startOffset stdDeviation stemh stemv stitchTiles stopColor stopOpacity strikethroughPosition strikethroughThickness string stroke strokeDasharray strokeDashoffset strokeLinecap strokeLinejoin strokeMiterlimit strokeOpacity strokeWidth surfaceScale systemLanguage tableValues targetX targetY textAnchor textDecoration textRendering textLength to transform u1 u2 underlinePosition underlineThickness unicode unicodeBidi unicodeRange unitsPerEm vAlphabetic vHanging vIdeographic vMathematical values vectorEffect version vertAdvY vertOriginX vertOriginY viewBox viewTarget visibility widths wordSpacing writingMode x xHeight x1 x2 xChannelSelector xlinkActuate xlinkArcrole xlinkHref xlinkRole xlinkShow xlinkTitle xlinkType xmlBase xmlns xmlnsXlink xmlLang xmlSpace y y1 y2 yChannelSelector z zoomAndPan onPointerDown onPointerMove onPointerUp onPointerCancel onGotPointerCapture onLostPointerCapture onPointerEnter onPointerLeave onPointerOver onPointerOut class for autofocus allow allowUserMedia allowPaymentRequest
*/
/* eslint-enable max-len */

var ATTRIBUTE_REGEX = /^((?:s(?:uppressContentEditableWarn|croll|pac)|(?:shape|image|text)Render|(?:letter|word)Spac|vHang|hang)ing|(?:on(?:AnimationIteration|C(?:o(?:mposition(?:Update|Start|End)|ntextMenu|py)|anPlayThrough|anPlay|hange|lick|ut)|(?:Animation|Touch|Load|Drag)Start|(?:(?:Duration|Volume|Rate)Chang|(?:MouseLea|(?:Touch|Mouse)Mo|DragLea)v|Paus)e|Loaded(?:Metad|D)ata|(?:(?:T(?:ransition|ouch)|Animation)E|Suspe)nd|DoubleClick|(?:TouchCanc|Whe)el|Lo(?:stPointer|ad)|TimeUpdate|(?:Mouse(?:Ent|Ov)e|Drag(?:Ent|Ov)e|Erro)r|GotPointer|MouseDown|(?:E(?:n(?:crypt|d)|mpti)|S(?:tall|eek))ed|KeyPress|(?:MouseOu|DragExi|S(?:elec|ubmi)|Rese|Inpu)t|P(?:rogress|laying)|DragEnd|Key(?:Down|Up)|(?:MouseU|Dro)p|(?:Wait|Seek)ing|Scroll|Focus|Paste|Abort|Drag|Play|Blur)Captur|alignmentBaselin|(?:limitingConeAng|xlink(?:(?:Arcr|R)o|Tit)|s(?:urfaceSca|ty|ca)|unselectab|baseProfi|fontSty|(?:focus|dragg)ab|multip|profi|tit)l|d(?:ominantBaselin|efaultValu)|onPointerLeav|a(?:uto(?:Capitaliz|Revers|Sav)|dditiv)|(?:(?:formNoValid|xlinkActu|noValid|accumul|rot)a|autoComple|decelera)t|(?:(?:attribute|item)T|datat)yp|onPointerMov|(?:attribute|glyph)Nam|playsInlin|(?:writing|input|edge)Mod|(?:formE|e)ncTyp|(?:amplitu|mo)d|(?:xlinkTy|itemSco|keyTy|slo)p|(?:xmlSpa|non)c|fillRul|(?:dateTi|na)m|r(?:esourc|ol)|xmlBas|wmod)e|(?:glyphOrientationHorizont|loc)al|(?:externalResourcesRequir|select|revers|mut)ed|c(?:o(?:lorInterpolationFilter|ord)s|o(?:lor(?:Interpolation)?|nt(?:rols|ent))|(?:ontentS(?:cript|tyle)Typ|o(?:ntentEditab|lorProfi)l|l(?:assNam|ipRul)|a(?:lcMod|ptur)|it)e|olorRendering|l(?:ipPathUnits|assID)|(?:ontrolsLis|apHeigh)t|h(?:eckedLink|a(?:llenge|rSet)|ildren|ecked)|ell(?:Spac|Padd)ing|o(?:ntextMenu|ls)|(?:rossOrigi|olSpa)n|l(?:ip(?:Path)?|ass)|ursor|[xy])|glyphOrientationVertical|d(?:angerouslySetInnerHTML|efaultChecked|ownload|isabled|isplay|[xy])|(?:s(?:trikethroughThickn|eaml)es|(?:und|ov)erlineThicknes|r(?:equiredExtension|adiu)|(?:requiredFeatur|tableValu|stitchTil|numOctav|filterR)e|key(?:(?:Splin|Tim)e|Param)|auto[Ff]ocu|header|bia)s|(?:(?:st(?:rikethroughPosi|dDevia)|(?:und|ov)erlinePosi|(?:textDecor|elev)a|orienta)tio|(?:strokeLinejo|orig)i|on(?:PointerDow|FocusI)|formActio|zoomAndPa|directio|(?:vers|act)io|rowSpa|begi|ico)n|o(?:n(?:AnimationIteration|C(?:o(?:mposition(?:Update|Start|End)|ntextMenu|py)|anPlayThrough|anPlay|hange|lick|ut)|(?:(?:Duration|Volume|Rate)Chang|(?:MouseLea|(?:Touch|Mouse)Mo|DragLea)v|Paus)e|Loaded(?:Metad|D)ata|(?:Animation|Touch|Load|Drag)Start|(?:(?:T(?:ransition|ouch)|Animation)E|Suspe)nd|DoubleClick|(?:TouchCanc|Whe)el|(?:Mouse(?:Ent|Ov)e|Drag(?:Ent|Ov)e|Erro)r|TimeUpdate|(?:E(?:n(?:crypt|d)|mpti)|S(?:tall|eek))ed|MouseDown|P(?:rogress|laying)|(?:MouseOu|DragExi|S(?:elec|ubmi)|Rese|Inpu)t|KeyPress|DragEnd|Key(?:Down|Up)|(?:Wait|Seek)ing|(?:MouseU|Dro)p|Scroll|Paste|Focus|Abort|Drag|Play|Load|Blur)|rient)|p(?:reserveAspectRatio|ointsAt[X-Z]|anose1)|(?:(?:allowPaymentReque|(?:fontSize|length)Adju|manife)s|strokeMiterlimi|(?:(?:specularE|e)xpon|renderingInt|asc)en|(?:specularConsta|repeatCou|fontVaria)n|d(?:iffuseConsta|esce)n|baselineShif|vectorEffec|onPointerOu|(?:(?:mar(?:ker|gin)|x)H|accentH|fontW)eigh|markerStar|a(?:utoCorrec|bou)|onFocusOu|intercep|restar|forma|inlis|heigh|lis)t|(?:patternContent|ma(?:sk(?:Content)?|rker)|primitive|gradient|pattern|filter)Units|(?:(?:allowTranspar|baseFrequ)enc|re(?:ferrerPolic|adOnl)|(?:(?:st(?:roke|op)O|floodO|fillO|o)pac|integr|secur)it|visibilit|fontFamil|accessKe|propert|summar)y|(?:gradientT|patternT|t)ransform|(?:(?:st(?:rokeDasho|artO)|o)ffs|acceptChars|formTarg|viewTarg|srcS)et|(?:[xy]ChannelSelect|lightingCol|textAnch|floodCol|stopCol|operat|htmlF)or|(?:(?:enableBackgrou|markerE)n|s(?:p(?:readMetho|ee)|ee)|formMetho|(?:markerM|onInval)i|preloa|metho|kin)d|k(?:ernel(?:UnitLength|Matrix)|[1-4])|strokeDasharray|(?:onPointerCanc|lab)el|(?:allowFullScre|hidd)en|a(?:l(?:lowUserMedia|phabetic|t)|rabicForm|sync)|systemLanguage|(?:(?:o(?:nPointer(?:Ent|Ov)|rd)|allowReord|placehold|frameBord|paintOrd|post)e|repeatDu|d(?:efe|u))r|(?:pointerEve|keyPoi)nts|preserveAlpha|(?:strokeLineca|onPointerU|itemPro|useMa|wra|loo)p|v(?:Mathematical|ert(?:Origin[XY]|AdvY)|alues|ocab)|unicodeRange|h(?:oriz(?:Origin|Adv)X|ttpEquiv)|(?:vI|i)deographic|mathematical|u(?:nicodeBidi|[12])|(?:fontStretc|hig)h|vAlphabetic|(?:(?:mar(?:ker|gin)W|strokeW)id|azimu)th|(?:xmlnsXl|valueL)ink|mediaGroup|spellCheck|(?:text|m(?:in|ax))Length|(?:unitsPerE|optimu|fro)m|r(?:adioGroup|e(?:sults|f[XY]|l)|ows|[xy])|pathLength|(?:xlinkHr|glyphR)ef|innerHTML|xlinkShow|f(?:o(?:ntSize|rm?)|il(?:ter|l))|(?:tabInde|(?:sand|b)bo|viewBo)x|autoPlay|r(?:e(?:quired|sult|f))?|(?:(?:href|xml|src)La|kerni)ng|o(?:verflow|pen)|i(?:temRef|n2|s)|p(?:attern|oints)|unicode|d(?:efault|ata|ir)?|divisor|t(?:arget[XY]|o)|(?:stri|la)ng|(?:width|size)s|prefix|typeof|srcDoc|s(?:coped|te(?:m[hv]|p)|pan)|s(?:t(?:roke|art)|hape|cope|rc)|a(?:ccept|llow|s)|itemID|t(?:arget|ype)|m(?:edia|a(?:sk|x)|in)|value|width|x(?:mlns)?|size|href|k(?:ey)?|end|low|by|x[12]|y[12]|g[12]|i[dn]|f[xy]|[yz])$/;
/* From DOMProperty */
var ATTRIBUTE_NAME_START_CHAR = ':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
var ATTRIBUTE_NAME_CHAR = ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040';
var isCustomAttribute = RegExp.prototype.test.bind(new RegExp('^(x|data|aria)-[' + ATTRIBUTE_NAME_CHAR + ']*$'));

var validAttr = (function (name) {
  return ATTRIBUTE_REGEX.test(name) || isCustomAttribute(name.toLowerCase());
});

// 

function hasInInheritanceChain(child, parent) {
  var target = child;

  while (target) {
    target = Object.getPrototypeOf(target);

    if (target && target === parent) {
      return true;
    }
  }

  return false;
}

// 
/**
 * Creates a broadcast that can be listened to, i.e. simple event emitter
 *
 * @see https://github.com/ReactTraining/react-broadcast
 */

var createBroadcast = function createBroadcast(initialState) {
  var listeners = {};
  var id = 0;
  var state = initialState;

  function publish(nextState) {
    state = nextState;

    // eslint-disable-next-line guard-for-in, no-restricted-syntax
    for (var key in listeners) {
      var listener = listeners[key];
      if (listener === undefined) {
        // eslint-disable-next-line no-continue
        continue;
      }

      listener(state);
    }
  }

  function subscribe(listener) {
    var currentId = id;
    listeners[currentId] = listener;
    id += 1;
    listener(state);
    return currentId;
  }

  function unsubscribe(unsubID) {
    listeners[unsubID] = undefined;
  }

  return { publish: publish, subscribe: subscribe, unsubscribe: unsubscribe };
};

var _contextShape, _ThemeProvider$contex;

// NOTE: DO NOT CHANGE, changing this is a semver major change!
var CHANNEL = '__styled-components__';
var CHANNEL_NEXT = CHANNEL + 'next__';

var CONTEXT_CHANNEL_SHAPE = __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.shape({
  getTheme: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  subscribe: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  unsubscribe: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func
});

var contextShape = (_contextShape = {}, _contextShape[CHANNEL] = __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func, _contextShape[CHANNEL_NEXT] = CONTEXT_CHANNEL_SHAPE, _contextShape);

var warnChannelDeprecated = void 0;
if (false) {
  warnChannelDeprecated = once(function () {
    // eslint-disable-next-line no-console
    console.warn('Warning: Usage of `context.' + CHANNEL + '` as a function is deprecated. It will be replaced with the object on `.context.' + CHANNEL_NEXT + '` in a future version.');
  });
}

var isFunction = function isFunction(test) {
  return typeof test === 'function';
};

/**
 * Provide a theme to an entire react component tree via context and event listeners (have to do
 * both context and event emitter as pure components block context updates)
 */

var ThemeProvider = function (_Component) {
  inherits(ThemeProvider, _Component);

  function ThemeProvider() {
    classCallCheck(this, ThemeProvider);

    var _this = possibleConstructorReturn(this, _Component.call(this));

    _this.unsubscribeToOuterId = -1;

    _this.getTheme = _this.getTheme.bind(_this);
    return _this;
  }

  ThemeProvider.prototype.componentWillMount = function componentWillMount() {
    var _this2 = this;

    // If there is a ThemeProvider wrapper anywhere around this theme provider, merge this theme
    // with the outer theme
    var outerContext = this.context[CHANNEL_NEXT];
    if (outerContext !== undefined) {
      this.unsubscribeToOuterId = outerContext.subscribe(function (theme) {
        _this2.outerTheme = theme;

        if (_this2.broadcast !== undefined) {
          _this2.publish(_this2.props.theme);
        }
      });
    }

    this.broadcast = createBroadcast(this.getTheme());
  };

  ThemeProvider.prototype.getChildContext = function getChildContext() {
    var _this3 = this,
        _babelHelpers$extends;

    return _extends({}, this.context, (_babelHelpers$extends = {}, _babelHelpers$extends[CHANNEL_NEXT] = {
      getTheme: this.getTheme,
      subscribe: this.broadcast.subscribe,
      unsubscribe: this.broadcast.unsubscribe
    }, _babelHelpers$extends[CHANNEL] = function (subscriber) {
      if (false) {
        warnChannelDeprecated();
      }

      // Patch the old `subscribe` provide via `CHANNEL` for older clients.
      var unsubscribeId = _this3.broadcast.subscribe(subscriber);
      return function () {
        return _this3.broadcast.unsubscribe(unsubscribeId);
      };
    }, _babelHelpers$extends));
  };

  ThemeProvider.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (this.props.theme !== nextProps.theme) {
      this.publish(nextProps.theme);
    }
  };

  ThemeProvider.prototype.componentWillUnmount = function componentWillUnmount() {
    if (this.unsubscribeToOuterId !== -1) {
      this.context[CHANNEL_NEXT].unsubscribe(this.unsubscribeToOuterId);
    }
  };

  // Get the theme from the props, supporting both (outerTheme) => {} as well as object notation


  ThemeProvider.prototype.getTheme = function getTheme(passedTheme) {
    var theme = passedTheme || this.props.theme;

    if (isFunction(theme)) {
      var mergedTheme = theme(this.outerTheme);

      if (false) {
        throw new StyledComponentsError(7);
      }

      return mergedTheme;
    }

    if (theme === null || Array.isArray(theme) || (typeof theme === 'undefined' ? 'undefined' : _typeof(theme)) !== 'object') {
      throw new StyledComponentsError(8);
    }

    return _extends({}, this.outerTheme, theme);
  };

  ThemeProvider.prototype.publish = function publish(theme) {
    this.broadcast.publish(this.getTheme(theme));
  };

  ThemeProvider.prototype.render = function render() {
    if (!this.props.children) {
      return null;
    }

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.Children.only(this.props.children);
  };

  return ThemeProvider;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

ThemeProvider.childContextTypes = contextShape;
ThemeProvider.contextTypes = (_ThemeProvider$contex = {}, _ThemeProvider$contex[CHANNEL_NEXT] = CONTEXT_CHANNEL_SHAPE, _ThemeProvider$contex);

var _babelHelpers$extends;

// HACK for generating all static styles without needing to allocate
// an empty execution context every single time...
var STATIC_EXECUTION_CONTEXT = {};

var modifiedContextShape = _extends({}, contextShape, (_babelHelpers$extends = {}, _babelHelpers$extends[CONTEXT_KEY] = __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.instanceOf(StyleSheet), __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.instanceOf(ServerStyleSheet)]), _babelHelpers$extends));

var identifiers = {};

/* We depend on components having unique IDs */
var generateId = function generateId(ComponentStyle, _displayName, parentComponentId) {
  var displayName = typeof _displayName !== 'string' ? 'sc' : escape(_displayName);

  /**
   * This ensures uniqueness if two components happen to share
   * the same displayName.
   */
  var nr = (identifiers[displayName] || 0) + 1;
  identifiers[displayName] = nr;

  var componentId = displayName + '-' + ComponentStyle.generateName(displayName + nr);

  return parentComponentId !== undefined ? parentComponentId + '-' + componentId : componentId;
};

var warnExtendDeprecated = function warnExtendDeprecated() {};
if (false) {
  warnExtendDeprecated = once(function () {
    // eslint-disable-next-line no-console
    console.warn('Warning: The "extend" API will be removed in the upcoming v4.0 release. Use styled(StyledComponent) instead. You can find more information here: https://github.com/styled-components/styled-components/issues/1546');
  });
}

// $FlowFixMe

var BaseStyledComponent = function (_Component) {
  inherits(BaseStyledComponent, _Component);

  function BaseStyledComponent() {
    var _temp, _this, _ret;

    classCallCheck(this, BaseStyledComponent);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.attrs = {}, _this.state = {
      theme: null,
      generatedClassName: ''
    }, _this.unsubscribeId = -1, _temp), possibleConstructorReturn(_this, _ret);
  }

  BaseStyledComponent.prototype.unsubscribeFromContext = function unsubscribeFromContext() {
    if (this.unsubscribeId !== -1) {
      this.context[CHANNEL_NEXT].unsubscribe(this.unsubscribeId);
    }
  };

  BaseStyledComponent.prototype.buildExecutionContext = function buildExecutionContext(theme, props) {
    var attrs = this.constructor.attrs;

    var context = _extends({}, props, { theme: theme });
    if (attrs === undefined) {
      return context;
    }

    this.attrs = Object.keys(attrs).reduce(function (acc, key) {
      var attr = attrs[key];

      // eslint-disable-next-line no-param-reassign
      acc[key] = typeof attr === 'function' && !hasInInheritanceChain(attr, __WEBPACK_IMPORTED_MODULE_1_react__["Component"]) ? attr(context) : attr;
      return acc;
    }, {});

    return _extends({}, context, this.attrs);
  };

  BaseStyledComponent.prototype.generateAndInjectStyles = function generateAndInjectStyles(theme, props) {
    var _constructor = this.constructor,
        attrs = _constructor.attrs,
        componentStyle = _constructor.componentStyle,
        warnTooManyClasses = _constructor.warnTooManyClasses;

    var styleSheet = this.context[CONTEXT_KEY] || StyleSheet.master;

    // statically styled-components don't need to build an execution context object,
    // and shouldn't be increasing the number of class names
    if (componentStyle.isStatic && attrs === undefined) {
      return componentStyle.generateAndInjectStyles(STATIC_EXECUTION_CONTEXT, styleSheet);
    } else {
      var executionContext = this.buildExecutionContext(theme, props);
      var className = componentStyle.generateAndInjectStyles(executionContext, styleSheet);

      if (false) {
        warnTooManyClasses(className);
      }

      return className;
    }
  };

  BaseStyledComponent.prototype.componentWillMount = function componentWillMount() {
    var _this2 = this;

    var componentStyle = this.constructor.componentStyle;

    var styledContext = this.context[CHANNEL_NEXT];

    // If this is a statically-styled component, we don't need to the theme
    // to generate or build styles.
    if (componentStyle.isStatic) {
      var generatedClassName = this.generateAndInjectStyles(STATIC_EXECUTION_CONTEXT, this.props);
      this.setState({ generatedClassName: generatedClassName });
      // If there is a theme in the context, subscribe to the event emitter. This
      // is necessary due to pure components blocking context updates, this circumvents
      // that by updating when an event is emitted
    } else if (styledContext !== undefined) {
      var subscribe = styledContext.subscribe;

      this.unsubscribeId = subscribe(function (nextTheme) {
        // This will be called once immediately
        var theme = determineTheme(_this2.props, nextTheme, _this2.constructor.defaultProps);

        var generatedClassName = _this2.generateAndInjectStyles(theme, _this2.props);

        _this2.setState({ theme: theme, generatedClassName: generatedClassName });
      });
    } else {
      // eslint-disable-next-line react/prop-types
      var theme = this.props.theme || EMPTY_OBJECT;
      var _generatedClassName = this.generateAndInjectStyles(theme, this.props);
      this.setState({ theme: theme, generatedClassName: _generatedClassName });
    }
  };

  BaseStyledComponent.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var _this3 = this;

    // If this is a statically-styled component, we don't need to listen to
    // props changes to update styles
    var componentStyle = this.constructor.componentStyle;

    if (componentStyle.isStatic) {
      return;
    }

    this.setState(function (prevState) {
      var theme = determineTheme(nextProps, prevState.theme, _this3.constructor.defaultProps);
      var generatedClassName = _this3.generateAndInjectStyles(theme, nextProps);

      return { theme: theme, generatedClassName: generatedClassName };
    });
  };

  BaseStyledComponent.prototype.componentWillUnmount = function componentWillUnmount() {
    this.unsubscribeFromContext();
  };

  BaseStyledComponent.prototype.render = function render() {
    // eslint-disable-next-line react/prop-types
    var innerRef = this.props.innerRef;
    var generatedClassName = this.state.generatedClassName;
    var _constructor2 = this.constructor,
        styledComponentId = _constructor2.styledComponentId,
        target = _constructor2.target;


    var isTargetTag = isTag(target);

    var className = [
    // eslint-disable-next-line react/prop-types
    this.props.className, styledComponentId, this.attrs.className, generatedClassName].filter(Boolean).join(' ');

    var baseProps = _extends({}, this.attrs, {
      className: className
    });

    if (isStyledComponent(target)) {
      baseProps.innerRef = innerRef;
    } else {
      baseProps.ref = innerRef;
    }

    var propsForElement = baseProps;
    var key = void 0;

    for (key in this.props) {
      // Don't pass through non HTML tags through to HTML elements
      // always omit innerRef
      if (key !== 'innerRef' && key !== 'className' && (!isTargetTag || validAttr(key))) {
        propsForElement[key] = key === 'style' && key in this.attrs ? _extends({}, this.attrs[key], this.props[key]) : this.props[key];
      }
    }

    return Object(__WEBPACK_IMPORTED_MODULE_1_react__["createElement"])(target, propsForElement);
  };

  return BaseStyledComponent;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

var _StyledComponent = (function (ComponentStyle, constructWithOptions) {
  var createStyledComponent = function createStyledComponent(target, options, rules) {
    var _options$isClass = options.isClass,
        isClass = _options$isClass === undefined ? !isTag(target) : _options$isClass,
        _options$displayName = options.displayName,
        displayName = _options$displayName === undefined ? generateDisplayName(target) : _options$displayName,
        _options$componentId = options.componentId,
        componentId = _options$componentId === undefined ? generateId(ComponentStyle, options.displayName, options.parentComponentId) : _options$componentId,
        _options$ParentCompon = options.ParentComponent,
        ParentComponent = _options$ParentCompon === undefined ? BaseStyledComponent : _options$ParentCompon,
        extendingRules = options.rules,
        attrs = options.attrs;


    var styledComponentId = options.displayName && options.componentId ? escape(options.displayName) + '-' + options.componentId : options.componentId || componentId;

    var componentStyle = new ComponentStyle(extendingRules === undefined ? rules : extendingRules.concat(rules), attrs, styledComponentId);

    var StyledComponent = function (_ParentComponent) {
      inherits(StyledComponent, _ParentComponent);

      function StyledComponent() {
        classCallCheck(this, StyledComponent);
        return possibleConstructorReturn(this, _ParentComponent.apply(this, arguments));
      }

      StyledComponent.withComponent = function withComponent(tag) {
        var previousComponentId = options.componentId,
            optionsToCopy = objectWithoutProperties(options, ['componentId']);


        var newComponentId = previousComponentId && previousComponentId + '-' + (isTag(tag) ? tag : escape(getComponentName(tag)));

        var newOptions = _extends({}, optionsToCopy, {
          componentId: newComponentId,
          ParentComponent: StyledComponent
        });

        return createStyledComponent(tag, newOptions, rules);
      };

      createClass(StyledComponent, null, [{
        key: 'extend',
        get: function get$$1() {
          var rulesFromOptions = options.rules,
              parentComponentId = options.componentId,
              optionsToCopy = objectWithoutProperties(options, ['rules', 'componentId']);


          var newRules = rulesFromOptions === undefined ? rules : rulesFromOptions.concat(rules);

          var newOptions = _extends({}, optionsToCopy, {
            rules: newRules,
            parentComponentId: parentComponentId,
            ParentComponent: StyledComponent
          });

          warnExtendDeprecated();

          return constructWithOptions(createStyledComponent, target, newOptions);
        }
      }]);
      return StyledComponent;
    }(ParentComponent);

    StyledComponent.attrs = attrs;
    StyledComponent.componentStyle = componentStyle;
    StyledComponent.contextTypes = modifiedContextShape;
    StyledComponent.displayName = displayName;
    StyledComponent.styledComponentId = styledComponentId;
    StyledComponent.target = target;


    if (false) {
      StyledComponent.warnTooManyClasses = createWarnTooManyClasses(displayName);
    }

    if (isClass) {
      __WEBPACK_IMPORTED_MODULE_5_hoist_non_react_statics___default()(StyledComponent, target, {
        // all SC-specific things should not be hoisted
        attrs: true,
        componentStyle: true,
        displayName: true,
        extend: true,
        styledComponentId: true,
        target: true,
        warnTooManyClasses: true,
        withComponent: true
      });
    }

    return StyledComponent;
  };

  return createStyledComponent;
});

// Source: https://github.com/garycourt/murmurhash-js/blob/master/murmurhash2_gc.js
function murmurhash(str) {
  var l = str.length | 0,
      h = l | 0,
      i = 0,
      k;

  while (l >= 4) {
    k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;

    k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    k ^= k >>> 24;
    k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);

    h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16) ^ k;

    l -= 4;
    ++i;
  }

  switch (l) {
    case 3:
      h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
    case 2:
      h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
    case 1:
      h ^= str.charCodeAt(i) & 0xff;
      h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
  }

  h ^= h >>> 13;
  h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
  h ^= h >>> 15;

  return h >>> 0;
}

// 

var areStylesCacheable = IS_BROWSER;

var isStaticRules = function isStaticRules(rules, attrs) {
  for (var i = 0, len = rules.length; i < len; i += 1) {
    var rule = rules[i];

    // recursive case
    if (Array.isArray(rule) && !isStaticRules(rule)) {
      return false;
    } else if (typeof rule === 'function' && !isStyledComponent(rule)) {
      // functions are allowed to be static if they're just being
      // used to get the classname of a nested styled component
      return false;
    }
  }

  if (attrs !== undefined) {
    // eslint-disable-next-line guard-for-in, no-restricted-syntax
    for (var key in attrs) {
      if (typeof attrs[key] === 'function') {
        return false;
      }
    }
  }

  return true;
};

var isHMREnabled = typeof module !== 'undefined' && module.hot && "production" !== 'production';

/*
 ComponentStyle is all the CSS-specific stuff, not
 the React-specific stuff.
 */
var _ComponentStyle = (function (nameGenerator, flatten, stringifyRules) {
  /* combines hashStr (murmurhash) and nameGenerator for convenience */
  var generateRuleHash = function generateRuleHash(str) {
    return nameGenerator(murmurhash(str));
  };

  var ComponentStyle = function () {
    function ComponentStyle(rules, attrs, componentId) {
      classCallCheck(this, ComponentStyle);

      this.rules = rules;
      this.isStatic = !isHMREnabled && isStaticRules(rules, attrs);
      this.componentId = componentId;

      if (!StyleSheet.master.hasId(componentId)) {
        var placeholder =  false ? ['.' + componentId + ' {}'] : [];

        StyleSheet.master.deferredInject(componentId, placeholder);
      }
    }

    /*
     * Flattens a rule set into valid CSS
     * Hashes it, wraps the whole chunk in a .hash1234 {}
     * Returns the hash to be injected on render()
     * */


    ComponentStyle.prototype.generateAndInjectStyles = function generateAndInjectStyles(executionContext, styleSheet) {
      var isStatic = this.isStatic,
          componentId = this.componentId,
          lastClassName = this.lastClassName;

      if (areStylesCacheable && isStatic && lastClassName !== undefined && styleSheet.hasNameForId(componentId, lastClassName)) {
        return lastClassName;
      }

      var flatCSS = flatten(this.rules, executionContext);
      var name = generateRuleHash(this.componentId + flatCSS.join(''));

      if (!styleSheet.hasNameForId(componentId, name)) {
        styleSheet.inject(this.componentId, stringifyRules(flatCSS, '.' + name), name);
      }

      this.lastClassName = name;
      return name;
    };

    ComponentStyle.generateName = function generateName(str) {
      return generateRuleHash(str);
    };

    return ComponentStyle;
  }();

  return ComponentStyle;
});

// 
// Thanks to ReactDOMFactories for this handy list!

var domElements = ['a', 'abbr', 'address', 'area', 'article', 'aside', 'audio', 'b', 'base', 'bdi', 'bdo', 'big', 'blockquote', 'body', 'br', 'button', 'canvas', 'caption', 'cite', 'code', 'col', 'colgroup', 'data', 'datalist', 'dd', 'del', 'details', 'dfn', 'dialog', 'div', 'dl', 'dt', 'em', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'i', 'iframe', 'img', 'input', 'ins', 'kbd', 'keygen', 'label', 'legend', 'li', 'link', 'main', 'map', 'mark', 'marquee', 'menu', 'menuitem', 'meta', 'meter', 'nav', 'noscript', 'object', 'ol', 'optgroup', 'option', 'output', 'p', 'param', 'picture', 'pre', 'progress', 'q', 'rp', 'rt', 'ruby', 's', 'samp', 'script', 'section', 'select', 'small', 'source', 'span', 'strong', 'style', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'textarea', 'tfoot', 'th', 'thead', 'time', 'title', 'tr', 'track', 'u', 'ul', 'var', 'video', 'wbr',

// SVG
'circle', 'clipPath', 'defs', 'ellipse', 'foreignObject', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'svg', 'text', 'tspan'];

// 

var _styled = (function (styledComponent, constructWithOptions) {
  var styled = function styled(tag) {
    return constructWithOptions(styledComponent, tag);
  };

  // Shorthands for all valid HTML Elements
  domElements.forEach(function (domElement) {
    styled[domElement] = styled(domElement);
  });

  return styled;
});

// 

var replaceWhitespace = function replaceWhitespace(str) {
  return str.replace(/\s|\\n/g, '');
};

var _keyframes = (function (nameGenerator, stringifyRules, css) {
  return function () {
    var styleSheet = StyleSheet.master;
    var rules = css.apply(undefined, arguments);
    var name = nameGenerator(murmurhash(replaceWhitespace(JSON.stringify(rules))));
    var id = 'sc-keyframes-' + name;

    if (!styleSheet.hasNameForId(id, name)) {
      styleSheet.inject(id, stringifyRules(rules, name, '@keyframes'), name);
    }

    return name;
  };
});

// 

var _injectGlobal = (function (stringifyRules, css) {
  var injectGlobal = function injectGlobal() {
    var styleSheet = StyleSheet.master;
    var rules = css.apply(undefined, arguments);
    var hash = murmurhash(JSON.stringify(rules));
    var id = 'sc-global-' + hash;

    if (!styleSheet.hasId(id)) {
      styleSheet.inject(id, stringifyRules(rules));
    }
  };

  return injectGlobal;
});

// 

var _constructWithOptions = (function (css) {
  var constructWithOptions = function constructWithOptions(componentConstructor, tag) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : EMPTY_OBJECT;

    if (!Object(__WEBPACK_IMPORTED_MODULE_6_react_is__["isValidElementType"])(tag)) {
      throw new StyledComponentsError(1, String(tag));
    }

    /* This is callable directly as a template function */
    // $FlowFixMe: Not typed to avoid destructuring arguments
    var templateFunction = function templateFunction() {
      return componentConstructor(tag, options, css.apply(undefined, arguments));
    };

    /* If config methods are called, wrap up a new template function and merge options */
    templateFunction.withConfig = function (config) {
      return constructWithOptions(componentConstructor, tag, _extends({}, options, config));
    };
    templateFunction.attrs = function (attrs) {
      return constructWithOptions(componentConstructor, tag, _extends({}, options, {
        attrs: _extends({}, options.attrs || EMPTY_OBJECT, attrs)
      }));
    };

    return templateFunction;
  };

  return constructWithOptions;
});

// 

var withTheme = (function (Component$$1) {
  var isStatelessFunctionalComponent = typeof Component$$1 === 'function' &&
  // $FlowFixMe TODO: flow for prototype
  !(Component$$1.prototype && 'isReactComponent' in Component$$1.prototype);

  // NOTE: We can't pass a ref to a stateless functional component
  var shouldSetInnerRef = isStyledComponent(Component$$1) || isStatelessFunctionalComponent;

  var WithTheme = function (_React$Component) {
    inherits(WithTheme, _React$Component);

    function WithTheme() {
      var _temp, _this, _ret;

      classCallCheck(this, WithTheme);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = EMPTY_OBJECT, _this.unsubscribeId = -1, _temp), possibleConstructorReturn(_this, _ret);
    }

    // NOTE: This is so that isStyledComponent passes for the innerRef unwrapping


    WithTheme.prototype.componentWillMount = function componentWillMount() {
      var _this2 = this;

      var defaultProps = this.constructor.defaultProps;

      var styledContext = this.context[CHANNEL_NEXT];
      var themeProp = determineTheme(this.props, undefined, defaultProps);
      if (styledContext === undefined && themeProp === undefined && "production" !== 'production') {
        // eslint-disable-next-line no-console
        console.warn('[withTheme] You are not using a ThemeProvider nor passing a theme prop or a theme in defaultProps');
      } else if (styledContext === undefined && themeProp !== undefined) {
        this.setState({ theme: themeProp });
      } else {
        var subscribe = styledContext.subscribe;

        this.unsubscribeId = subscribe(function (nextTheme) {
          var theme = determineTheme(_this2.props, nextTheme, defaultProps);
          _this2.setState({ theme: theme });
        });
      }
    };

    WithTheme.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      var defaultProps = this.constructor.defaultProps;

      this.setState(function (oldState) {
        var theme = determineTheme(nextProps, oldState.theme, defaultProps);

        return { theme: theme };
      });
    };

    WithTheme.prototype.componentWillUnmount = function componentWillUnmount() {
      if (this.unsubscribeId !== -1) {
        this.context[CHANNEL_NEXT].unsubscribe(this.unsubscribeId);
      }
    };

    WithTheme.prototype.render = function render() {
      var props = _extends({
        theme: this.state.theme
      }, this.props);

      if (!shouldSetInnerRef) {
        props.ref = props.innerRef;
        delete props.innerRef;
      }

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Component$$1, props);
    };

    return WithTheme;
  }(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

  WithTheme.contextTypes = contextShape;
  WithTheme.displayName = 'WithTheme(' + getComponentName(Component$$1) + ')';
  WithTheme.styledComponentId = 'withTheme';


  return __WEBPACK_IMPORTED_MODULE_5_hoist_non_react_statics___default()(WithTheme, Component$$1);
});

// 

/* eslint-disable */
var __DO_NOT_USE_OR_YOU_WILL_BE_HAUNTED_BY_SPOOKY_GHOSTS = {
  StyleSheet: StyleSheet
};

// 

/* Warning if you've imported this file on React Native */
if (false) {
  // eslint-disable-next-line no-console
  console.warn("It looks like you've imported 'styled-components' on React Native.\n" + "Perhaps you're looking to import 'styled-components/native'?\n" + 'Read more about this at https://www.styled-components.com/docs/basics#react-native');
}

/* Warning if there are several instances of styled-components */
if (false) {
  window['__styled-components-init__'] = window['__styled-components-init__'] || 0;

  if (window['__styled-components-init__'] === 1) {
    // eslint-disable-next-line no-console
    console.warn("It looks like there are several instances of 'styled-components' initialized in this application. " + 'This may cause dynamic styles not rendering properly, errors happening during rehydration process ' + 'and makes your application bigger without a good reason.\n\n' + 'See https://s-c.sh/2BAXzed for more info.');
  }

  window['__styled-components-init__'] += 1;
}

/* Instantiate singletons */
var ComponentStyle = _ComponentStyle(generateAlphabeticName, flatten, stringifyRules);
var constructWithOptions = _constructWithOptions(css);
var StyledComponent = _StyledComponent(ComponentStyle, constructWithOptions);

/* Instantiate exported singletons */
var keyframes = _keyframes(generateAlphabeticName, stringifyRules, css);
var injectGlobal = _injectGlobal(stringifyRules, css);
var styled = _styled(StyledComponent, constructWithOptions);

/* harmony default export */ __webpack_exports__["a"] = (styled);

//# sourceMappingURL=styled-components.browser.esm.js.map

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(754), __webpack_require__(264)(module)))

/***/ }),
/* 198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = stripePaymentError;
/* harmony export (immutable) */ __webpack_exports__["a"] = paymentDetailsError;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__userError__ = __webpack_require__(15);
// A Stripe confirm*Payment error in the standard error shape (src/utils/userError.js).
// Money first: anything that is not a clear decline or a detail to fix may have charged the
// customer, so it is PAYMENT-UNKNOWN-STATE and never invites a retry.
var DECLINE_GUIDANCE='Try another card or payment method.';function stripePaymentError(stripeError){var error=stripeError||{};var serverId=error.payment_intent&&error.payment_intent.id||undefined;// Stripe writes card_error and validation_error messages for customers ("Your card has
// insufficient funds."): they are the reason, so they are the body.
var reason=typeof error.message==='string'?error.message.trim():'';if(error.code==='expired_card'){return Object(__WEBPACK_IMPORTED_MODULE_0__userError__["e" /* knownError */])(__WEBPACK_IMPORTED_MODULE_0__userError__["a" /* ERROR_CODES */].PAYMENT_CARD_EXPIRED,{title:'Your card has expired',message:'This card can no longer be used.',guidance:DECLINE_GUIDANCE,serverId:serverId});}if(error.code==='payment_intent_authentication_failure'){return Object(__WEBPACK_IMPORTED_MODULE_0__userError__["e" /* knownError */])(__WEBPACK_IMPORTED_MODULE_0__userError__["a" /* ERROR_CODES */].PAYMENT_3DS_FAILED,{title:"Your bank didn't confirm the payment",message:"The bank's security check was not completed, so you were not charged.",guidance:"Try again and complete your bank's check, or use another card.",serverId:serverId});}if(error.type==='card_error'){return Object(__WEBPACK_IMPORTED_MODULE_0__userError__["e" /* knownError */])(__WEBPACK_IMPORTED_MODULE_0__userError__["a" /* ERROR_CODES */].PAYMENT_DECLINED,{title:'Your card was declined',message:reason,guidance:DECLINE_GUIDANCE,serverId:serverId});}if(error.type==='validation_error'){return Object(__WEBPACK_IMPORTED_MODULE_0__userError__["e" /* knownError */])(__WEBPACK_IMPORTED_MODULE_0__userError__["a" /* ERROR_CODES */].PAYMENT_DETAILS_INVALID,{title:'Check your payment details',message:reason,guidance:'Correct the details, then pay again.',serverId:serverId});}return Object(__WEBPACK_IMPORTED_MODULE_0__userError__["h" /* userError */])(null,{area:'PAYMENT',paymentUnknown:true,serverId:serverId});}/** A payment detail the form checked itself (a missing or too long name). */function paymentDetailsError(title,guidance){return Object(__WEBPACK_IMPORTED_MODULE_0__userError__["e" /* knownError */])(__WEBPACK_IMPORTED_MODULE_0__userError__["a" /* ERROR_CODES */].PAYMENT_DETAILS_INVALID,{title:title,guidance:guidance});}

/***/ }),
/* 199 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _objectSpread;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__defineProperty__ = __webpack_require__(93);

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? Object(arguments[i]) : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      Object(__WEBPACK_IMPORTED_MODULE_0__defineProperty__["a" /* default */])(target, key, source[key]);
    });
  }

  return target;
}

/***/ }),
/* 201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CacheProvider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ClassNames; });
/* unused harmony export Global */
/* unused harmony export ThemeContext */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return jsx; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return keyframes; });
/* unused harmony export withEmotionCache */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_inheritsLoose__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_inheritsLoose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_inheritsLoose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__emotion_cache__ = __webpack_require__(314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__emotion_utils__ = __webpack_require__(814);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__emotion_serialize__ = __webpack_require__(316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__emotion_sheet__ = __webpack_require__(315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__emotion_css__ = __webpack_require__(95);
/* unused harmony reexport css */









var EmotionCacheContext = Object(__WEBPACK_IMPORTED_MODULE_1_react__["createContext"])( // we're doing this to avoid preconstruct's dead code elimination in this one case
// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== 'undefined' ? Object(__WEBPACK_IMPORTED_MODULE_2__emotion_cache__["a" /* default */])() : null);
var ThemeContext = Object(__WEBPACK_IMPORTED_MODULE_1_react__["createContext"])({});
var CacheProvider = EmotionCacheContext.Provider;

var withEmotionCache = function withEmotionCache(func) {
  var render = function render(props, ref) {
    return Object(__WEBPACK_IMPORTED_MODULE_1_react__["createElement"])(EmotionCacheContext.Consumer, null, function (cache) {
      return func(props, cache, ref);
    });
  }; // $FlowFixMe


  return Object(__WEBPACK_IMPORTED_MODULE_1_react__["forwardRef"])(render);
};

// thus we only need to replace what is a valid character for JS, but not for CSS

var sanitizeIdentifier = function sanitizeIdentifier(identifier) {
  return identifier.replace(/\$/g, '-');
};

var typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
var labelPropName = '__EMOTION_LABEL_PLEASE_DO_NOT_USE__';
var hasOwnProperty = Object.prototype.hasOwnProperty;

var render = function render(cache, props, theme, ref) {
  var cssProp = theme === null ? props.css : props.css(theme); // so that using `css` from `emotion` and passing the result to the css prop works
  // not passing the registered cache to serializeStyles because it would
  // make certain babel optimisations not possible

  if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) {
    cssProp = cache.registered[cssProp];
  }

  var type = props[typePropName];
  var registeredStyles = [cssProp];
  var className = '';

  if (typeof props.className === 'string') {
    className = Object(__WEBPACK_IMPORTED_MODULE_3__emotion_utils__["a" /* getRegisteredStyles */])(cache.registered, registeredStyles, props.className);
  } else if (props.className != null) {
    className = props.className + " ";
  }

  var serialized = Object(__WEBPACK_IMPORTED_MODULE_4__emotion_serialize__["a" /* serializeStyles */])(registeredStyles);

  if (false) {
    var labelFromStack = props[labelPropName];

    if (labelFromStack) {
      serialized = serializeStyles([serialized, 'label:' + labelFromStack + ';']);
    }
  }

  var rules = Object(__WEBPACK_IMPORTED_MODULE_3__emotion_utils__["b" /* insertStyles */])(cache, serialized, typeof type === 'string');
  className += cache.key + "-" + serialized.name;
  var newProps = {};

  for (var key in props) {
    if (hasOwnProperty.call(props, key) && key !== 'css' && key !== typePropName && ("production" === 'production' || key !== labelPropName)) {
      newProps[key] = props[key];
    }
  }

  newProps.ref = ref;
  newProps.className = className;
  var ele = Object(__WEBPACK_IMPORTED_MODULE_1_react__["createElement"])(type, newProps);

  return ele;
};

var Emotion =
/* #__PURE__ */
withEmotionCache(function (props, cache, ref) {
  // use Context.read for the theme when it's stable
  if (typeof props.css === 'function') {
    return Object(__WEBPACK_IMPORTED_MODULE_1_react__["createElement"])(ThemeContext.Consumer, null, function (theme) {
      return render(cache, props, theme, ref);
    });
  }

  return render(cache, props, null, ref);
});

if (false) {
  Emotion.displayName = 'EmotionCssPropInternal';
} // $FlowFixMe


var jsx = function jsx(type, props) {
  var args = arguments;

  if (props == null || !hasOwnProperty.call(props, 'css')) {
    // $FlowFixMe
    return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"].apply(undefined, args);
  }

  if (false) {
    throw new Error("Strings are not allowed as css prop values, please wrap it in a css template literal from '@emotion/css' like this: css`" + props.css + "`");
  }

  var argsLength = args.length;
  var createElementArgArray = new Array(argsLength);
  createElementArgArray[0] = Emotion;
  var newProps = {};

  for (var key in props) {
    if (hasOwnProperty.call(props, key)) {
      newProps[key] = props[key];
    }
  }

  newProps[typePropName] = type;

  if (false) {
    var error = new Error();

    if (error.stack) {
      // chrome
      var match = error.stack.match(/at (?:Object\.|)jsx.*\n\s+at ([A-Z][A-Za-z$]+) /);

      if (!match) {
        // safari and firefox
        match = error.stack.match(/.*\n([A-Z][A-Za-z$]+)@/);
      }

      if (match) {
        newProps[labelPropName] = sanitizeIdentifier(match[1]);
      }
    }
  }

  createElementArgArray[1] = newProps;

  for (var i = 2; i < argsLength; i++) {
    createElementArgArray[i] = args[i];
  } // $FlowFixMe


  return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"].apply(null, createElementArgArray);
};

var warnedAboutCssPropForGlobal = false;
var Global =
/* #__PURE__ */
withEmotionCache(function (props, cache) {
  if (false) {
    console.error("It looks like you're using the css prop on Global, did you mean to use the styles prop instead?");
    warnedAboutCssPropForGlobal = true;
  }

  var styles = props.styles;

  if (typeof styles === 'function') {
    return Object(__WEBPACK_IMPORTED_MODULE_1_react__["createElement"])(ThemeContext.Consumer, null, function (theme) {
      var serialized = Object(__WEBPACK_IMPORTED_MODULE_4__emotion_serialize__["a" /* serializeStyles */])([styles(theme)]);
      return Object(__WEBPACK_IMPORTED_MODULE_1_react__["createElement"])(InnerGlobal, {
        serialized: serialized,
        cache: cache
      });
    });
  }

  var serialized = Object(__WEBPACK_IMPORTED_MODULE_4__emotion_serialize__["a" /* serializeStyles */])([styles]);
  return Object(__WEBPACK_IMPORTED_MODULE_1_react__["createElement"])(InnerGlobal, {
    serialized: serialized,
    cache: cache
  });
});

// maintain place over rerenders.
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var InnerGlobal =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_inheritsLoose___default()(InnerGlobal, _React$Component);

  function InnerGlobal(props, context, updater) {
    return _React$Component.call(this, props, context, updater) || this;
  }

  var _proto = InnerGlobal.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.sheet = new __WEBPACK_IMPORTED_MODULE_5__emotion_sheet__["a" /* StyleSheet */]({
      key: this.props.cache.key + "-global",
      nonce: this.props.cache.sheet.nonce,
      container: this.props.cache.sheet.container
    }); // $FlowFixMe

    var node = document.querySelector("style[data-emotion-" + this.props.cache.key + "=\"" + this.props.serialized.name + "\"]");

    if (node !== null) {
      this.sheet.tags.push(node);
    }

    if (this.props.cache.sheet.tags.length) {
      this.sheet.before = this.props.cache.sheet.tags[0];
    }

    this.insertStyles();
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (prevProps.serialized.name !== this.props.serialized.name) {
      this.insertStyles();
    }
  };

  _proto.insertStyles = function insertStyles$1() {
    if (this.props.serialized.next !== undefined) {
      // insert keyframes
      Object(__WEBPACK_IMPORTED_MODULE_3__emotion_utils__["b" /* insertStyles */])(this.props.cache, this.props.serialized.next, true);
    }

    if (this.sheet.tags.length) {
      // if this doesn't exist then it will be null so the style element will be appended
      var element = this.sheet.tags[this.sheet.tags.length - 1].nextElementSibling;
      this.sheet.before = element;
      this.sheet.flush();
    }

    this.props.cache.insert("", this.props.serialized, this.sheet, false);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.sheet.flush();
  };

  _proto.render = function render() {

    return null;
  };

  return InnerGlobal;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

var keyframes = function keyframes() {
  var insertable = __WEBPACK_IMPORTED_MODULE_6__emotion_css__["a" /* default */].apply(void 0, arguments);
  var name = "animation-" + insertable.name; // $FlowFixMe

  return {
    name: name,
    styles: "@keyframes " + name + "{" + insertable.styles + "}",
    anim: 1,
    toString: function toString() {
      return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
    }
  };
};

var classnames = function classnames(args) {
  var len = args.length;
  var i = 0;
  var cls = '';

  for (; i < len; i++) {
    var arg = args[i];
    if (arg == null) continue;
    var toAdd = void 0;

    switch (typeof arg) {
      case 'boolean':
        break;

      case 'object':
        {
          if (Array.isArray(arg)) {
            toAdd = classnames(arg);
          } else {
            toAdd = '';

            for (var k in arg) {
              if (arg[k] && k) {
                toAdd && (toAdd += ' ');
                toAdd += k;
              }
            }
          }

          break;
        }

      default:
        {
          toAdd = arg;
        }
    }

    if (toAdd) {
      cls && (cls += ' ');
      cls += toAdd;
    }
  }

  return cls;
};

function merge(registered, css, className) {
  var registeredStyles = [];
  var rawClassName = Object(__WEBPACK_IMPORTED_MODULE_3__emotion_utils__["a" /* getRegisteredStyles */])(registered, registeredStyles, className);

  if (registeredStyles.length < 2) {
    return className;
  }

  return rawClassName + css(registeredStyles);
}

var ClassNames = withEmotionCache(function (props, context) {
  return Object(__WEBPACK_IMPORTED_MODULE_1_react__["createElement"])(ThemeContext.Consumer, null, function (theme) {
    var hasRendered = false;

    var css = function css() {
      if (hasRendered && "production" !== 'production') {
        throw new Error('css can only be used during render');
      }

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      var serialized = Object(__WEBPACK_IMPORTED_MODULE_4__emotion_serialize__["a" /* serializeStyles */])(args, context.registered);

      {
        Object(__WEBPACK_IMPORTED_MODULE_3__emotion_utils__["b" /* insertStyles */])(context, serialized, false);
      }

      return context.key + "-" + serialized.name;
    };

    var cx = function cx() {
      if (hasRendered && "production" !== 'production') {
        throw new Error('cx can only be used during render');
      }

      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return merge(context.registered, css, classnames(args));
    };

    var content = {
      css: css,
      cx: cx,
      theme: theme
    };
    var ele = props.children(content);
    hasRendered = true;

    return ele;
  });
});




/***/ }),
/* 202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getScrollParent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getScrollTop; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return animatedScrollTo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return isMobileDevice; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return isDocumentElement; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return cleanValue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getBoundingClientObj; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return scrollIntoView; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return isTouchCapable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return classNames; });
/* unused harmony export k */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return noop; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return scrollTo; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_typeof__ = __webpack_require__(134);


// ==============================
// NO OP
// ==============================
var noop = function noop() {};
// Class Name Prefixer
// ==============================

/**
 String representation of component state for styling with class names.

 Expects an array of strings OR a string/object pair:
 - className(['comp', 'comp-arg', 'comp-arg-2'])
   @returns 'react-select__comp react-select__comp-arg react-select__comp-arg-2'
 - className('comp', { some: true, state: false })
   @returns 'react-select__comp react-select__comp--some'
*/

function applyPrefixToName(prefix, name) {
  if (!name) {
    return prefix;
  } else if (name[0] === '-') {
    return prefix + name;
  } else {
    return prefix + '__' + name;
  }
}

function classNames(prefix, state, className) {
  var arr = [className];

  if (state && prefix) {
    for (var key in state) {
      if (state.hasOwnProperty(key) && state[key]) {
        arr.push("".concat(applyPrefixToName(prefix, key)));
      }
    }
  }

  return arr.filter(function (i) {
    return i;
  }).map(function (i) {
    return String(i).trim();
  }).join(' ');
} // ==============================
// Clean Value
// ==============================

var cleanValue = function cleanValue(value) {
  if (Array.isArray(value)) return value.filter(Boolean);
  if (Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_typeof__["a" /* default */])(value) === 'object' && value !== null) return [value];
  return [];
}; // ==============================
// Handle Input Change
// ==============================

function handleInputChange(inputValue, actionMeta, onInputChange) {
  if (onInputChange) {
    var newValue = onInputChange(inputValue, actionMeta);
    if (typeof newValue === 'string') return newValue;
  }

  return inputValue;
} // ==============================
// Scroll Helpers
// ==============================

function isDocumentElement(el) {
  return [document.documentElement, document.body, window].indexOf(el) > -1;
} // Normalized Scroll Top
// ------------------------------

function getScrollTop(el) {
  if (isDocumentElement(el)) {
    return window.pageYOffset;
  }

  return el.scrollTop;
}
function scrollTo(el, top) {
  // with a scroll distance, we perform scroll on the element
  if (isDocumentElement(el)) {
    window.scrollTo(0, top);
    return;
  }

  el.scrollTop = top;
} // Get Scroll Parent
// ------------------------------

function getScrollParent(element) {
  var style = getComputedStyle(element);
  var excludeStaticParent = style.position === 'absolute';
  var overflowRx = /(auto|scroll)/;
  var docEl = document.documentElement; // suck it, flow...

  if (style.position === 'fixed') return docEl;

  for (var parent = element; parent = parent.parentElement;) {
    style = getComputedStyle(parent);

    if (excludeStaticParent && style.position === 'static') {
      continue;
    }

    if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) {
      return parent;
    }
  }

  return docEl;
} // Animated Scroll To
// ------------------------------

/**
  @param t: time (elapsed)
  @param b: initial value
  @param c: amount of change
  @param d: duration
*/

function easeOutCubic(t, b, c, d) {
  return c * ((t = t / d - 1) * t * t + 1) + b;
}

function animatedScrollTo(element, to) {
  var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 200;
  var callback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : noop;
  var start = getScrollTop(element);
  var change = to - start;
  var increment = 10;
  var currentTime = 0;

  function animateScroll() {
    currentTime += increment;
    var val = easeOutCubic(currentTime, start, change, duration);
    scrollTo(element, val);

    if (currentTime < duration) {
      window.requestAnimationFrame(animateScroll);
    } else {
      callback(element);
    }
  }

  animateScroll();
} // Scroll Into View
// ------------------------------

function scrollIntoView(menuEl, focusedEl) {
  var menuRect = menuEl.getBoundingClientRect();
  var focusedRect = focusedEl.getBoundingClientRect();
  var overScroll = focusedEl.offsetHeight / 3;

  if (focusedRect.bottom + overScroll > menuRect.bottom) {
    scrollTo(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
  } else if (focusedRect.top - overScroll < menuRect.top) {
    scrollTo(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
  }
} // ==============================
// Get bounding client object
// ==============================
// cannot get keys using array notation with DOMRect

function getBoundingClientObj(element) {
  var rect = element.getBoundingClientRect();
  return {
    bottom: rect.bottom,
    height: rect.height,
    left: rect.left,
    right: rect.right,
    top: rect.top,
    width: rect.width
  };
}
// Touch Capability Detector
// ==============================

function isTouchCapable() {
  try {
    document.createEvent('TouchEvent');
    return true;
  } catch (e) {
    return false;
  }
} // ==============================
// Mobile Device Detector
// ==============================

function isMobileDevice() {
  try {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  } catch (e) {
    return false;
  }
}




/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(948);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(17)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../lunch-team-client-checkout-msg/node_modules/css-loader/index.js!../../../../../../../lunch-team-client-checkout-msg/node_modules/sass-loader/dist/cjs.js!./privacyTerms.scss", function() {
			var newContent = require("!!../../../../../../../lunch-team-client-checkout-msg/node_modules/css-loader/index.js!../../../../../../../lunch-team-client-checkout-msg/node_modules/sass-loader/dist/cjs.js!./privacyTerms.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__support_contactSupport__ = __webpack_require__(671);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__errorReference_scss__ = __webpack_require__(672);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__errorReference_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__errorReference_scss__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// The support line under an error: "Reference: CODE · 26 Oct 12:41 · 7f3a9c21", selectable, with a
// copy button (copies the full server id), and optionally "Contact support".
var ErrorReference=function(_Component){_inherits(ErrorReference,_Component);function ErrorReference(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ErrorReference);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ErrorReference.__proto__||Object.getPrototypeOf(ErrorReference)).call.apply(_ref,[this].concat(args))),_this),_this.state={copied:false},_this.copy=function(){var error=_this.props.error;var text='Reference: '+(error.fullReference||error.reference);var done=function done(){_this.setState({copied:true});window.clearTimeout(_this.copiedTimer);_this.copiedTimer=window.setTimeout(function(){return _this.setState({copied:false});},2000);};try{if(navigator.clipboard&&navigator.clipboard.writeText){navigator.clipboard.writeText(text).then(done,function(){});}}catch(e){// The line stays selectable.
}},_this.contact=function(){var _this$props=_this.props,error=_this$props.error,onContactSupport=_this$props.onContactSupport;Object(__WEBPACK_IMPORTED_MODULE_1__support_contactSupport__["a" /* contactSupport */])(error);if(onContactSupport)onContactSupport();},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ErrorReference,[{key:'componentWillUnmount',value:function componentWillUnmount(){window.clearTimeout(this.copiedTimer);}},{key:'render',value:function render(){var _props=this.props,error=_props.error,showContact=_props.showContact,className=_props.className;if(!error||!error.reference){return null;}var canCopy=typeof navigator!=='undefined'&&!!navigator.clipboard;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'lt-error-reference'+(className?' '+className:'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'lt-error-reference__line'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'lt-error-reference__text'},'Reference: ',error.reference),canCopy&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'lt-error-reference__copy',onClick:this.copy,'aria-label':'Copy the support reference'},this.state.copied?'Copied':'Copy')),showContact&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'lt-error-reference__contact',onClick:this.contact},'Contact support'));}}]);return ErrorReference;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (ErrorReference);

/***/ }),
/* 205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export MENU_SCREEN */
/* unused harmony export CART_SCREEN */
/* harmony export (immutable) */ __webpack_exports__["g"] = registerVoiceOrderHandler;
/* harmony export (immutable) */ __webpack_exports__["b"] = getVoiceOrderHandler;
/* harmony export (immutable) */ __webpack_exports__["i"] = voiceOrderingFor;
/* harmony export (immutable) */ __webpack_exports__["h"] = subscribeVoiceOrder;
/* harmony export (immutable) */ __webpack_exports__["d"] = notifyVoiceOrder;
/* harmony export (immutable) */ __webpack_exports__["a"] = formatMoney;
/* harmony export (immutable) */ __webpack_exports__["f"] = readBack;
/* harmony export (immutable) */ __webpack_exports__["c"] = itemsToAdd;
/* harmony export (immutable) */ __webpack_exports__["e"] = offersCheckout;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__basketCheck__ = __webpack_require__(96);
// Voice ordering from the composer on a restaurant menu page. The server reads the words against the menu
// (POST /support/v1/order-intents) and only proposes; the screens that own the basket run the actions:
// - the menu page registers addToBasket (LOW risk: runs at once);
// - the basket registers checkout (MEDIUM risk: runs only after the customer taps confirm, On Account only).
// Without both handlers (another page, the basket not mounted) the composer sends a support message as before.
var handlers={};var listeners=new Set();var MENU_SCREEN='menu.restaurant';// The open basket: on a pilot restaurant, words there still update the order and the allergy answer.
var CART_SCREEN='checkout.cart';/**
 * @param {'addToBasket'|'checkout'|'summary'} name
 * @param {Function} handler
 * @returns {Function} unregister: only removes this handler, not a newer one
 */function registerVoiceOrderHandler(name,handler){handlers[name]=handler;notify();return function(){if(handlers[name]===handler){delete handlers[name];notify();}};}function getVoiceOrderHandler(name){return handlers[name]||null;}// Voice ordering applies to this context: a menu page with a restaurant (or, on an allergen-pilot restaurant, its
// open basket), and the basket can take the items.
function voiceOrderingFor(context){return!!context&&(context.screenId===MENU_SCREEN||context.screenId===CART_SCREEN&&!!context.ids&&Object(__WEBPACK_IMPORTED_MODULE_0__basketCheck__["a" /* allergenGateApplies */])(context.ids.restaurantId))&&!!context.ids&&context.ids.restaurantId!==undefined&&context.ids.restaurantId!==null&&!!handlers.addToBasket&&!!handlers.checkout;}// The basket total and whether it can be placed On Account, for the confirm card.
function subscribeVoiceOrder(listener){listeners.add(listener);return function(){return listeners.delete(listener);};}function notifyVoiceOrder(){notify();}function notify(){setTimeout(function(){return listeners.forEach(function(listener){return listener();});},0);}function formatMoney(amount,currencySymbol){var value=Number(amount);return''+(currencySymbol||'€')+(Number.isFinite(value)?value:0).toFixed(2);}// "1 × Caesar Club, €11.50" or "2 × Caesar Club, €23.00 and 1 × Soup, €4.00".
function readBack(items,currencySymbol){var lines=(items||[]).map(function(item){return item.qty+' \xD7 '+item.name+', '+formatMoney((item.unitPrice||0)*(item.qty||1),currencySymbol);});if(lines.length<=1)return lines.join('');return lines.slice(0,-1).join('; ')+' and '+lines[lines.length-1];}// Items the server proposed, from its ADD_TO_BASKET actions (LOW risk) matched to its items.
function itemsToAdd(intent){if(!intent||intent.decision!=='ORDER')return[];var items=intent.items||[];return(intent.actions||[]).filter(function(action){return action.type==='ADD_TO_BASKET'&&action.risk==='LOW';}).map(function(action){var item=items.find(function(candidate){return candidate.productId===action.productId;});return item?Object.assign({},item,{qty:action.qty||item.qty||1}):null;}).filter(Boolean);}// The server proposed checkout On Account, behind an explicit confirm.
function offersCheckout(intent){return!!intent&&(intent.actions||[]).some(function(action){return action.type==='CHECKOUT'&&action.risk==='MEDIUM'&&action.paymentMethod==='ON_ACCOUNT'&&action.requiresConfirm===true;});}

/***/ }),
/* 206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fetchingPrivacyPolicy; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fetchingTermsConditions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_services_gdprService__ = __webpack_require__(633);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions_actionTypes__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_userError__ = __webpack_require__(15);
// Fetches the document the service points at. A failed request or a non-2xx file is a
// load failure the screen shows (with a reference), never an empty box.
var fetchDocument=function fetchDocument(getPath){return getPath().then(function(data){return fetch(data.path).then(function(res){if(!res.ok){var error=new Error('Document request failed ('+res.status+')');error.status=res.status;error.response=res;throw error;}return res.text();});});};var documentLoadFailed=function documentLoadFailed(error){return{type:__WEBPACK_IMPORTED_MODULE_1__actions_actionTypes__["Q" /* GDPR_LOAD_FAILED */],loadError:Object(__WEBPACK_IMPORTED_MODULE_2__utils_userError__["h" /* userError */])(error,{area:'ACCOUNT',code:'ACCOUNT-TERMS-LOAD-FAILED',title:"We couldn't load the terms",guidance:'Try again. You can read and accept them once they load.'})};};var fetchingPrivacyPolicy=function fetchingPrivacyPolicy(){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actions_actionTypes__["R" /* GDPR_LOAD_STARTED */]});return fetchDocument(function(){return __WEBPACK_IMPORTED_MODULE_0_services_gdprService__["a" /* default */].getPrivacyPolicy();}).then(function(privacyContent){return dispatch(successFetchingPrivacyPolicy(privacyContent));}).catch(function(err){return dispatch(documentLoadFailed(err));});};};var successFetchingPrivacyPolicy=function successFetchingPrivacyPolicy(privacyPolicy){return{type:__WEBPACK_IMPORTED_MODULE_1__actions_actionTypes__["S" /* GDPR_SUCCESS_PRIVACY_POLICY */],privacyPolicy:privacyPolicy};};var fetchingTermsConditions=function fetchingTermsConditions(){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actions_actionTypes__["R" /* GDPR_LOAD_STARTED */]});return fetchDocument(function(){return __WEBPACK_IMPORTED_MODULE_0_services_gdprService__["a" /* default */].getTermsConditions();}).then(function(termsConditionsContent){return dispatch(successFetchingTermsConditions(termsConditionsContent));}).catch(function(err){return dispatch(documentLoadFailed(err));});};};var successFetchingTermsConditions=function successFetchingTermsConditions(termsConditions){return{type:__WEBPACK_IMPORTED_MODULE_1__actions_actionTypes__["T" /* GDPR_SUCCESS_TERMS_CONDITIONS */],termsConditions:termsConditions};};

/***/ }),
/* 207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return toggleRegisterCompany; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return sendEmailToRegisterCompany; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return sendEmailContact; });
/* unused harmony export PRE_LOGIN_ROUTES */
/* unused harmony export preLoginRoute */
/* unused harmony export RETAIL_ONLY_MESSAGE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return OFFICE_NOT_SET_UP_TITLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return OFFICE_NOT_SET_UP_GUIDANCE; });
/* unused harmony export OFFICE_NOT_SET_UP_MESSAGE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return requestVerifyEmail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return resetPreLogin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return requestLogin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return completeMagicLinkLogin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return requestEmailResetPassword; });
/* harmony export (immutable) */ __webpack_exports__["n"] = tryAutomaticallyLogin;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return closeModalError; });
/* unused harmony export openModalError */
/* unused harmony export createLinkVoucher */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return closeSuccessModalCreateLinkVoucher; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return closeErrorModalCreateLinkVoucher; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actionTypes__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_services_loginService__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_services_userService__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_services_landingService__ = __webpack_require__(644);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_services_voucherService__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_utils_object__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_utils_googleAnalytics__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_utils_inspectlet__ = __webpack_require__(655);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_utils_queryString__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_utils_userError__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Cart__ = __webpack_require__(69);
var _this2=this;function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}var toggleRegisterCompany=function toggleRegisterCompany(toggle){return{type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["_68" /* TOGGLE_REGISTER_COMPANY */],toggle:toggle};};var loggingIn=function loggingIn(){return{type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["_72" /* USER_LOGGING_IN */]};};function loggingOut(){return{type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["_73" /* USER_LOGGING_OUT */]};}var sendEmailToRegisterCompany=function sendEmailToRegisterCompany(payload){return function(dispatch){__WEBPACK_IMPORTED_MODULE_4_services_landingService__["a" /* default */].sendEmailToRegisterCompany(payload).then(function(data){dispatch(successSendEmailToRegisterCompany());}).catch(function(err){console.log(err);});};};var successSendEmailToRegisterCompany=function successSendEmailToRegisterCompany(){return{type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["_49" /* SUCCESS_SEND_EMAIL_REGISTER_COMPANY */]};};var sendEmailContact=function sendEmailContact(payload){return function(dispatch){dispatch(toggleSendEmailContact(false));__WEBPACK_IMPORTED_MODULE_4_services_landingService__["a" /* default */].sendEmailContact(payload).then(function(data){dispatch(toggleSendEmailContact(true));}).catch(function(err){console.log(err);});};};var toggleSendEmailContact=function toggleSendEmailContact(toggle){return{type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["_70" /* TOGGLE_SEND_EMAIL_CONTANT */],toggle:toggle};};var PRE_LOGIN_ROUTES={PASSWORD:'password',SIGNUP:'signup',NO_OFFICE:'no_office',RETAIL_ONLY:'retail_only'};// Where the email step goes, from the POST /user/v1/login/pre-login answer.
// A registered account always goes to the password/sign-in step. Signup needs an
// explicit userAlreadyRegistered === false, so a partial or odd answer can never send
// an existing account to the Terms & Conditions page.
var preLoginRoute=function preLoginRoute(data){var answer=data||{};if(answer.userAlreadyRegistered===true){return answer.retailOnly?PRE_LOGIN_ROUTES.RETAIL_ONLY:PRE_LOGIN_ROUTES.PASSWORD;}if(!answer.hasRelatedBusiness){return PRE_LOGIN_ROUTES.NO_OFFICE;}if(answer.retailOnly){return PRE_LOGIN_ROUTES.RETAIL_ONLY;}if(answer.userAlreadyRegistered===false){return PRE_LOGIN_ROUTES.SIGNUP;}return PRE_LOGIN_ROUTES.NO_OFFICE;};// The email belongs to a retail account (personal ordering), not an office account.
var RETAIL_ONLY_MESSAGE='This email is set up for personal ordering, not an office account. Sign in with the work email your company '+'registered with us, or contact support@lunch.team and we will sort it out.';// No company we deliver to matches this email's domain yet.
var OFFICE_NOT_SET_UP_TITLE="We don't deliver to your office yet";var OFFICE_NOT_SET_UP_GUIDANCE="Register your company and we'll be in touch, or chat with us using the chat button at the bottom of the page.";var OFFICE_NOT_SET_UP_MESSAGE=OFFICE_NOT_SET_UP_TITLE+'. '+OFFICE_NOT_SET_UP_GUIDANCE;// Only the latest email check may change the page (two quick "Next" clicks, or a slow
// answer for an older email, must not win).
var latestPreLoginRequest=0;var requestVerifyEmail=function requestVerifyEmail(credentials){return function(dispatch){var requestId=++latestPreLoginRequest;// Clear any signup started earlier in this tab so it cannot fire again.
dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["F" /* CLOSE_SIGNUP */]});return __WEBPACK_IMPORTED_MODULE_2_services_loginService__["a" /* default */].preLogin(credentials,{showSpinner:false}).then(function(data){if(requestId!==latestPreLoginRequest){return undefined;}var route=preLoginRoute(data);if(route===PRE_LOGIN_ROUTES.PASSWORD){dispatch(preLogin(credentials.email));}else if(route===PRE_LOGIN_ROUTES.SIGNUP){dispatch(startSignup(credentials.email));}else if(route===PRE_LOGIN_ROUTES.RETAIL_ONLY){dispatch(requestFailed(Object(__WEBPACK_IMPORTED_MODULE_10_utils_userError__["e" /* knownError */])(__WEBPACK_IMPORTED_MODULE_10_utils_userError__["a" /* ERROR_CODES */].ACCOUNT_RETAIL_ONLY,{title:'This email is for personal ordering',message:RETAIL_ONLY_MESSAGE})));}else{dispatch(requestFailed(Object(__WEBPACK_IMPORTED_MODULE_10_utils_userError__["e" /* knownError */])(__WEBPACK_IMPORTED_MODULE_10_utils_userError__["a" /* ERROR_CODES */].ACCOUNT_COMPANY_NOT_SERVED,{title:OFFICE_NOT_SET_UP_TITLE,guidance:OFFICE_NOT_SET_UP_GUIDANCE})));}return route;}).catch(function(error){if(requestId!==latestPreLoginRequest){return undefined;}if(error&&!!error.errors){dispatch(requestFailed(Object(__WEBPACK_IMPORTED_MODULE_10_utils_userError__["h" /* userError */])(error,{area:'ACCOUNT',code:__WEBPACK_IMPORTED_MODULE_10_utils_userError__["a" /* ERROR_CODES */].ACCOUNT_EMAIL_INVALID,title:'Check your email address',guidance:'Enter a work email like name@company.ie.'})));}else{dispatch(requestFailed(Object(__WEBPACK_IMPORTED_MODULE_10_utils_userError__["h" /* userError */])(error,{area:'AUTH',task:'check your email'})));}return undefined;});};};// "Use a different email" on the sign-in step.
var resetPreLogin=function resetPreLogin(){return{type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["_25" /* RESET_PRE_LOGIN */]};};// options.showSpinner=false: the sign-in panel shows its own progress, and the global
// spinner would bounce the landing page to /Menu and back while the request runs.
// Returns the request promise (it never rejects; failures show the error modal).
var requestLogin=function requestLogin(credentials,options){return function(dispatch){var params=__WEBPACK_IMPORTED_MODULE_9_utils_queryString__["a" /* default */].parse(window.location.search);return __WEBPACK_IMPORTED_MODULE_2_services_loginService__["a" /* default */].login(credentials,options).then(function(userDetails){if(false){localStorage.setItem('@LT/DEV_KEYS',window.btoa(credentials.email+':'+credentials.password));}__WEBPACK_IMPORTED_MODULE_7_utils_googleAnalytics__["b" /* default */].sendWhoIsAccessing(userDetails.username);dispatch(requestSuccessLogin(userDetails));dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__Cart__["t" /* fetchGuestPolicy */])());__WEBPACK_IMPORTED_MODULE_8_utils_inspectlet__["a" /* default */].tagSession(userDetails);dispatch(createLinkVoucher(params));localStorage.setItem('country',userDetails.country);}).catch(function(err){if(err&&err.response&&err.response.status===401){// Neutral: never says whether the account exists.
dispatch(requestFailed(Object(__WEBPACK_IMPORTED_MODULE_10_utils_userError__["h" /* userError */])(null,{area:'AUTH',code:__WEBPACK_IMPORTED_MODULE_10_utils_userError__["a" /* ERROR_CODES */].AUTH_WRONG_PASSWORD,title:"We couldn't sign you in",message:"The email or password isn't right.",guidance:'Check them and try again, or reset your password.',serverId:Object(__WEBPACK_IMPORTED_MODULE_10_utils_userError__["f" /* serverIdOf */])(err)})));}else{dispatch(requestFailed(Object(__WEBPACK_IMPORTED_MODULE_10_utils_userError__["h" /* userError */])(err,{area:'AUTH',task:'sign you in'})));}});};};// After a successful email sign-in link (verify-magic-link). The response has the same
// shape as POST /user/v1/login, and the session cookies are already set by the browser.
var completeMagicLinkLogin=function completeMagicLinkLogin(userDetails){return function(dispatch){var params=__WEBPACK_IMPORTED_MODULE_9_utils_queryString__["a" /* default */].parse(window.location.search);__WEBPACK_IMPORTED_MODULE_7_utils_googleAnalytics__["b" /* default */].sendWhoIsAccessing(userDetails.username);dispatch(requestSuccessLogin(userDetails));__WEBPACK_IMPORTED_MODULE_8_utils_inspectlet__["a" /* default */].tagSession(userDetails);dispatch(createLinkVoucher(params));if(userDetails.country){localStorage.setItem('country',userDetails.country);}};};var requestEmailResetPassword=function requestEmailResetPassword(email){return function(dispatch){__WEBPACK_IMPORTED_MODULE_3_services_userService__["a" /* default */].requestEmailResetPassword({email:email}).then(function(data){dispatch(requestSentEmailResetPasswordSuccess());}).catch(function(err){console.log(err);});};};var requestSentEmailResetPasswordSuccess=function requestSentEmailResetPasswordSuccess(email){return{type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["_21" /* REQUEST_SENT_EMAIL_RESET_PASSWORD_SUCCESS */]};};function tryAutomaticallyLogin(){var _this=this;return function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(dispatch){var params,response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:params=__WEBPACK_IMPORTED_MODULE_9_utils_queryString__["a" /* default */].parse(window.location.search);dispatch(loggingIn());_context.prev=2;_context.next=5;return __WEBPACK_IMPORTED_MODULE_2_services_loginService__["a" /* default */].login();case 5:response=_context.sent;if(!!__WEBPACK_IMPORTED_MODULE_6_utils_object__["a" /* default */].get(response,'idUser',undefined)){dispatch(requestSuccessLogin(response));dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__Cart__["t" /* fetchGuestPolicy */])());__WEBPACK_IMPORTED_MODULE_8_utils_inspectlet__["a" /* default */].tagSession(response);dispatch(createLinkVoucher(params));}else{dispatch(loggingOut());}_context.next=12;break;case 9:_context.prev=9;_context.t0=_context['catch'](2);dispatch(loggingOut());case 12:case'end':return _context.stop();}}},_callee,_this,[[2,9]]);}));return function(_x){return _ref.apply(this,arguments);};}();}var startSignup=function startSignup(email){return{type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["_44" /* START_SIGNUP */],email:email};};// errorMessage: a userError (src/utils/userError.js), shown by ModalError.
var requestFailed=function requestFailed(error){return{type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["_19" /* REQUEST_FAILED */],errorMessage:error};};var preLogin=function preLogin(email){return{type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["_17" /* PRE_LOGIN */],email:email};};var requestSuccessLogin=function requestSuccessLogin(userDetails){return{type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["_24" /* REQUEST_SUCCESS_LOGIN */],userDetails:userDetails};};var closeModalError=function closeModalError(){return{type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["y" /* CLOSE_MODAL_ERROR */]};};var openModalError=function openModalError(messageError){return{type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["r" /* CHECKOUT_REALEX_TOGGLE_SHOW_MODAL_ERROR */],payload:{show:true,messageError:messageError}};};var createLinkVoucher=function createLinkVoucher(params){return function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(dispatch){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:if(params.isCodeLink){try{__WEBPACK_IMPORTED_MODULE_5_services_voucherService__["a" /* default */].createLinkVoucher(params.code).then(function(data){dispatch(requestSuccessCreateVoucher({message:'You\'ve got a voucher!'}));}).catch(function(err){dispatch(requestFailedCreateVoucher({message:voucherLinkError(err)}));});}catch(error){dispatch(requestFailedCreateVoucher({message:voucherLinkError(error)}));}}case 1:case'end':return _context2.stop();}}},_callee2,_this2);}));return function(_x2){return _ref2.apply(this,arguments);};}();};var voucherLinkError=function voucherLinkError(error){return Object(__WEBPACK_IMPORTED_MODULE_10_utils_userError__["h" /* userError */])(error,{area:'VOUCHER',code:__WEBPACK_IMPORTED_MODULE_10_utils_userError__["a" /* ERROR_CODES */].VOUCHER_INVALID,title:"We couldn't add this voucher",message:'This voucher link has expired or has already been used.',guidance:'Ask the person who sent it for a new link.'});};var requestSuccessCreateVoucher=function requestSuccessCreateVoucher(successMessage){return{type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["_23" /* REQUEST_SUCCESS_CREATE_VOUCHER */],message:successMessage.message};};var requestFailedCreateVoucher=function requestFailedCreateVoucher(errorMessage){return{type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["_20" /* REQUEST_FAILED_CREATE_VOUCHER */],message:errorMessage.message};};var closeSuccessModalCreateLinkVoucher=function closeSuccessModalCreateLinkVoucher(successMessage){return{type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["B" /* CLOSE_MODAL_SUCCESS_CREATE_LINK_VOUCHER */]};};var closeErrorModalCreateLinkVoucher=function closeErrorModalCreateLinkVoucher(){return{type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["z" /* CLOSE_MODAL_ERROR_CREATE_LINK_VOUCHER */]};};

/***/ }),
/* 208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export stripQuery */
/* harmony export (immutable) */ __webpack_exports__["e"] = sanitizePath;
/* harmony export (immutable) */ __webpack_exports__["a"] = addBreadcrumb;
/* harmony export (immutable) */ __webpack_exports__["c"] = getBreadcrumbs;
/* harmony export (immutable) */ __webpack_exports__["b"] = clearBreadcrumbs;
/* harmony export (immutable) */ __webpack_exports__["d"] = installBreadcrumbListeners;
// Last 20 client events, sent with a support message so support can see what
// happened just before: screens visited, API errors, script errors and
// network changes. Paths only (no query strings), no form values.
var MAX=20;var ring=[];var installed=false;function truncate(value,max){var text=value===undefined||value===null?'':String(value);return text.length>max?text.slice(0,max):text;}function stripQuery(path){return truncate(String(path||'').split(/[?#]/)[0],200);}// Routes whose path carries a secret (sign-in links, password reset, unsubscribe, voucher codes).
var SECRET_ROUTES=/^\/(MagicLogin|ResetPassword|ChangePassword|Unsubscribe|GetVoucher)(\/|$)/i;// A segment after one of these is a secret; covers the voucher API's findMasterVoucherByCode/<code>
// and createVoucherByMasterCode/<code>.
var SECRET_AFTER=/^(validation-token|unsubscribe|token|magic-link|reset-password)$|By(Master)?Code$/i;function looksLikeToken(segment){if(/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(segment))return true;return segment.length>=20&&/^[A-Za-z0-9_\-.=%]+$/.test(segment)&&/\d/.test(segment)&&/[A-Za-z]/.test(segment);}/** Path without query, hash or anything that looks like a token, safe to show support staff. */function sanitizePath(path){var clean=stripQuery(path);var routeMatch=SECRET_ROUTES.exec(clean);if(routeMatch){return'/'+routeMatch[1]+(clean.length>routeMatch[0].length||routeMatch[2]?'/:token':'');}var segments=clean.split('/');return segments.map(function(segment,index){return index>0&&SECRET_AFTER.test(segments[index-1])||looksLikeToken(segment)?':token':segment;}).join('/');}function addBreadcrumb(type,name,detail){var crumb={type:type,name:truncate(name,200),at:new Date().toISOString()};if(detail!==undefined&&detail!==null&&detail!==''){crumb.detail=truncate(detail,300);}ring=ring.concat(crumb).slice(-MAX);}function getBreadcrumbs(){return ring.slice();}function clearBreadcrumbs(){ring=[];}// Window-level listeners; safe to call more than once.
function installBreadcrumbListeners(){if(installed||typeof window==='undefined'){return;}installed=true;window.addEventListener('error',function(event){addBreadcrumb('js_error',event&&event.message?event.message:'Script error');});window.addEventListener('unhandledrejection',function(event){var reason=event&&event.reason;addBreadcrumb('js_error',reason&&reason.message||'Unhandled promise rejection');});window.addEventListener('online',function(){return addBreadcrumb('network','online');});window.addEventListener('offline',function(){return addBreadcrumb('network','offline');});}

/***/ }),
/* 209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SOURCE_APP */
/* unused harmony export serverMessage */
/* unused harmony export retryAfterSeconds */
/* unused harmony export waitInWords */
/* harmony export (immutable) */ __webpack_exports__["c"] = getAvailability;
/* unused harmony export buildReportForm */
/* harmony export (immutable) */ __webpack_exports__["j"] = sendReport;
/* harmony export (immutable) */ __webpack_exports__["b"] = dictate;
/* unused harmony export customerView */
/* harmony export (immutable) */ __webpack_exports__["g"] = listMyConversations;
/* harmony export (immutable) */ __webpack_exports__["d"] = getConversation;
/* unused harmony export VISITOR_TOKEN_HEADER */
/* harmony export (immutable) */ __webpack_exports__["h"] = postVisitorMessage;
/* harmony export (immutable) */ __webpack_exports__["e"] = getVisitorConversation;
/* harmony export (immutable) */ __webpack_exports__["f"] = interpretOrder;
/* harmony export (immutable) */ __webpack_exports__["a"] = checkBasket;
/* harmony export (immutable) */ __webpack_exports__["i"] = reportOrderOutcome;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_fetch_serverURL__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_userError__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__composerModel__ = __webpack_require__(331);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}// Calls to the support API (logistic service, /support/v1 through the gateway).
// The session cookie goes with every call; X-Requested-By is required for
// cookie sign-in (the server's CSRF guard).
var SOURCE_APP='web';var BASE_HEADERS={Accept:'application/json','X-Requested-By':'Browser'};var FRIENDLY={400:"We couldn't send that. Check the message and attachments and try again.",401:'Your session has expired. Please sign in again to contact support.',403:'Support messages are switched off for your account.',413:'That is too large to send. Try fewer or smaller files.',429:'You have sent a lot of messages. Please wait a few minutes and try again.',503:'Lunch.Team support is busy right now. Please try again in a minute.'};// Support reference codes (src/utils/userError.js) for each status.
var CODES={400:__WEBPACK_IMPORTED_MODULE_1__utils_userError__["a" /* ERROR_CODES */].SUPPORT_SEND_REJECTED,401:__WEBPACK_IMPORTED_MODULE_1__utils_userError__["a" /* ERROR_CODES */].AUTH_SIGNED_OUT,403:__WEBPACK_IMPORTED_MODULE_1__utils_userError__["a" /* ERROR_CODES */].SUPPORT_OFF,413:__WEBPACK_IMPORTED_MODULE_1__utils_userError__["a" /* ERROR_CODES */].SUPPORT_TOO_LARGE,429:__WEBPACK_IMPORTED_MODULE_1__utils_userError__["a" /* ERROR_CODES */].SUPPORT_RATE_LIMITED,503:__WEBPACK_IMPORTED_MODULE_1__utils_userError__["a" /* ERROR_CODES */].SUPPORT_BUSY};var DICTATION_CODES={422:__WEBPACK_IMPORTED_MODULE_1__utils_userError__["a" /* ERROR_CODES */].SUPPORT_VOICE_UNCLEAR,503:__WEBPACK_IMPORTED_MODULE_1__utils_userError__["a" /* ERROR_CODES */].SUPPORT_VOICE_UNAVAILABLE};var SERVER_DOWN="Lunch.Team support isn't responding. Please try again in a few minutes.";var UNEXPECTED="Support couldn't take that just now. Please try again in a minute.";// Dictation is the only voice call; its errors say so.
var DICTATION_FRIENDLY={422:"We couldn't understand that recording. Try again, or type your message.",503:'Voice is not available right now. Please type your message.'};// What the server said, when it said more than the status: its errors carry message (= detail) and
// error (the reason phrase, e.g. "Bad Request").
function serverMessage(body){if(!body||(typeof body==='undefined'?'undefined':_typeof(body))!=='object')return'';var said=[body.message,body.detail].filter(function(value){return typeof value==='string'&&value.trim();})[0];if(!said)return'';var phrase=[body.error,body.title].filter(function(value){return typeof value==='string';});return phrase.indexOf(said)>=0?'':said.trim();}// How long a 429 asks to wait: retryAfterSeconds in the body, else the Retry-After header (seconds);
// null when neither says.
function retryAfterSeconds(body,response){var fromBody=body&&Number(body.retryAfterSeconds);if(fromBody>0)return Math.ceil(fromBody);var header=response&&response.headers&&typeof response.headers.get==='function'?Number(response.headers.get('Retry-After')):NaN;return header>0?Math.ceil(header):null;}// "a minute", "3 minutes": the wait in a sentence.
function waitInWords(seconds){var minutes=Math.max(1,Math.ceil(seconds/60));return minutes===1?'a minute':minutes+' minutes';}var WAIT_A_FEW_MINUTES=/Please wait a few minutes( and try again)?\./;function failure(status,body,overrides,response){var message=overrides&&overrides[status]||FRIENDLY[status]||(status>=500?SERVER_DOWN:UNEXPECTED);var wait=status===429?retryAfterSeconds(body,response):null;if(wait){message=message.replace(WAIT_A_FEW_MINUTES,'Please try again in '+waitInWords(wait)+'.');}var error=new Error(message);error.status=status;error.retryAfterSeconds=wait;error.body=body;error.serverMessage=serverMessage(body);error.code=overrides===DICTATION_FRIENDLY&&DICTATION_CODES[status]||CODES[status]||(status>=500?__WEBPACK_IMPORTED_MODULE_1__utils_userError__["a" /* ERROR_CODES */].SERVER_UNAVAILABLE:'SUPPORT-UNEXPECTED-'+status);error.at=new Date();error.serverId=Object(__WEBPACK_IMPORTED_MODULE_1__utils_userError__["f" /* serverIdOf */])({body:body,response:response});error.reference=Object(__WEBPACK_IMPORTED_MODULE_1__utils_userError__["d" /* formatReference */])(error.code,error.at,error.serverId);return error;}function request(path){var options=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};var overrides=arguments[2];return fetch(__WEBPACK_IMPORTED_MODULE_0__config_fetch_serverURL__["a" /* default */].api(path),Object.assign({mode:'cors',credentials:'include'},options,{headers:Object.assign({},BASE_HEADERS,options.headers||{})})).then(function(response){return response.text().then(function(text){var body=null;try{body=text?JSON.parse(text):null;}catch(e){body={message:text};}if(!response.ok){throw failure(response.status,body,overrides,response);}return body;});},function(cause){var offline=typeof navigator!=='undefined'&&navigator.onLine===false;var error=new Error(offline?"You're offline. Check your connection and try again.":'We could not reach Lunch.Team. Check your connection and try again.');error.isNetworkError=true;error.cause=cause;error.code=offline?__WEBPACK_IMPORTED_MODULE_1__utils_userError__["a" /* ERROR_CODES */].NETWORK_OFFLINE:__WEBPACK_IMPORTED_MODULE_1__utils_userError__["a" /* ERROR_CODES */].SERVER_UNAVAILABLE;error.at=new Date();error.reference=Object(__WEBPACK_IMPORTED_MODULE_1__utils_userError__["d" /* formatReference */])(error.code,error.at);throw error;});}function getAvailability(){return request('/support/v1/availability?sourceApp='+SOURCE_APP);}/** Builds the multipart body for POST /support/v1/reports. */function buildReportForm(_ref){var clientReportId=_ref.clientReportId,conversationId=_ref.conversationId,text=_ref.text,files=_ref.files,audio=_ref.audio,context=_ref.context,breadcrumbs=_ref.breadcrumbs;var form=new FormData();form.append('sourceApp',SOURCE_APP);form.append('clientReportId',clientReportId);if(conversationId){form.append('conversationId',conversationId);}if(text){form.append('text',text);}if(context){form.append('context',JSON.stringify(context));}if(breadcrumbs&&breadcrumbs.length){form.append('breadcrumbs',JSON.stringify(breadcrumbs));}(files||[]).forEach(function(file){return form.append('files',file,file.name);});if(audio){form.append('audio',audio.blob,audio.fileName);}return form;}function sendReport(report){return request('/support/v1/reports',{method:'POST',body:buildReportForm(report)});}function dictate(_ref2){var blob=_ref2.blob,fileName=_ref2.fileName,screenId=_ref2.screenId,restaurantId=_ref2.restaurantId;var form=new FormData();form.append('sourceApp',SOURCE_APP);if(screenId){form.append('screenId',screenId);}// On a menu page the server gives the speech model the dish names.
if(restaurantId!==undefined&&restaurantId!==null){form.append('restaurantId',String(restaurantId));}form.append('audio',blob,fileName);return request('/support/v1/dictation',{method:'POST',body:form},DICTATION_FRIENDLY);}// The customer's view of a conversation: staff-only notes (audience INTERNAL, such as the assistant's
// handoff reason) never show here, even for an account that also has the support inbox, which the
// server answers with the staff view. Messages without an audience are from before it existed.
function customerView(conversation){if(!conversation||!Array.isArray(conversation.messages))return conversation;return Object.assign({},conversation,{messages:conversation.messages.filter(function(message){return!message.audience||message.audience==='PUBLIC';})});}// The signed-in customer's own conversations, newest activity first (resumeFromServer).
function listMyConversations(){var limit=arguments.length>0&&arguments[0]!==undefined?arguments[0]:5;return request('/support/v1/conversations?limit='+limit).then(function(list){return Array.isArray(list)?list:[];});}function getConversation(conversationId){return request('/support/v1/conversations/'+encodeURIComponent(conversationId)).then(customerView);}// ---- signed-out visitors (landing page) --------------------------------------
// No session: a visitor's conversation is reached with its token, which the server returns once, when
// the conversation is created, and this browser keeps (conversationStore). Text only.
var VISITOR_TOKEN_HEADER='X-Support-Visitor-Token';var VISITOR_FRIENDLY={400:"We couldn't send that. Check your email address and message and try again.",403:"Support chat isn't available right now.",429:"You're sending messages too quickly. Please wait a few minutes."};function sentence(text){var trimmed=text.trim();var capital=trimmed.charAt(0).toUpperCase()+trimmed.slice(1);return /[.!?]$/.test(capital)?capital:capital+'.';}/**
 * The visitor's view of a failed call. reason says what the composer can do about it:
 * 'conversation-full' (the server's cap on one conversation; a new one can take the message), 'email'
 * or 'name' (a detail the server turned down). A 400 shows the server's own words when they say what
 * is wrong; a rejected or empty message (the honeypot) keeps the friendly text.
 */function visitorFailure(error){var said=error&&error.serverMessage;if(error&&error.status===429&&/conversation is full/i.test(said)){error.message=__WEBPACK_IMPORTED_MODULE_2__composerModel__["b" /* VISITOR_CONVERSATION_FULL */];error.reason='conversation-full';}else if(error&&error.status===400&&said){if(/valid email/i.test(said)){error.message=__WEBPACK_IMPORTED_MODULE_2__composerModel__["c" /* VISITOR_EMAIL_INVALID */];error.reason='email';}else if(/name is required/i.test(said)){error.message=__WEBPACK_IMPORTED_MODULE_2__composerModel__["h" /* VISITOR_NAME_MISSING */];error.reason='name';}else if(/^text must be/i.test(said)){error.message='Your message must be 1 to 2,000 characters.';}else if(!/^message (rejected|required)$/i.test(said)){error.message=sentence(said);}}throw error;}function visitorHeaders(token){return token?_defineProperty({},VISITOR_TOKEN_HEADER,token):{};}/**
 * POST /support/v1/visitor/messages. A new conversation (no conversationId) needs the name and email
 * (company is optional); the next message in one needs its token. website is the honeypot, sent as it
 * is (empty from a person).
 * Resolves with {conversationId, visitorToken (on creation only), assistantReplying}.
 */function postVisitorMessage(_ref4){var conversationId=_ref4.conversationId,token=_ref4.token,email=_ref4.email,name=_ref4.name,company=_ref4.company,text=_ref4.text,clientMessageId=_ref4.clientMessageId,screen=_ref4.screen,website=_ref4.website;var body={text:text,clientMessageId:clientMessageId,website:website||''};if(conversationId)body.conversationId=conversationId;if(email)body.email=email;if(name)body.name=name;if(company)body.company=company;if(screen)body.screen=screen;return request('/support/v1/visitor/messages',{method:'POST',headers:Object.assign({'Content-Type':'application/json'},visitorHeaders(token)),body:JSON.stringify(body)},VISITOR_FRIENDLY).catch(visitorFailure);}/** The visitor's conversation (public messages only); 404 when it is gone or the token doesn't match. */function getVisitorConversation(conversationId,token){return request('/support/v1/visitor/conversations/'+encodeURIComponent(conversationId),{headers:visitorHeaders(token)},VISITOR_FRIENDLY).then(customerView,visitorFailure);}// Voice ordering: the server reads the words against the menu in view and answers ORDER, CLARIFY or
// SUPPORT. It only proposes; nothing is ordered here.
function interpretOrder(_ref5){var text=_ref5.text,restaurantId=_ref5.restaurantId,screenId=_ref5.screenId,basket=_ref5.basket;return request('/support/v1/order-intents',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({sourceApp:SOURCE_APP,screenId:screenId,restaurantId:restaurantId,text:text,basket:basket})});}// The check before a basket is confirmed on a pilot restaurant: live prices, stock and choices, what changed,
// the allergy question and allergen advice. applies=false means the restaurant isn't in the pilot.
function checkBasket(_ref6){var restaurantId=_ref6.restaurantId,lines=_ref6.lines,allergy=_ref6.allergy,quoteHash=_ref6.quoteHash,seenAdviceText=_ref6.seenAdviceText;return request('/support/v1/order-intents/basket-check',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({sourceApp:SOURCE_APP,restaurantId:restaurantId,lines:lines,allergy:allergy,quoteHash:quoteHash,seenAdviceText:seenAdviceText})});}// What the customer did with an order intent: ADDED, PLACED (orderId), DISMISSED or FAILED. Best effort.
function reportOrderOutcome(intentId,_ref7){var outcome=_ref7.outcome,orderId=_ref7.orderId,detail=_ref7.detail;if(!intentId)return Promise.resolve();return request('/support/v1/order-intents/'+encodeURIComponent(intentId)+'/outcome',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({outcome:outcome,orderId:orderId,detail:detail})}).catch(function(){return undefined;});}

/***/ }),
/* 210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VISITOR_CONVERSATION_DAYS */
/* harmony export (immutable) */ __webpack_exports__["h"] = readStorage;
/* harmony export (immutable) */ __webpack_exports__["o"] = writeStorage;
/* harmony export (immutable) */ __webpack_exports__["d"] = readConversation;
/* harmony export (immutable) */ __webpack_exports__["k"] = writeConversation;
/* harmony export (immutable) */ __webpack_exports__["e"] = readLeftConversation;
/* harmony export (immutable) */ __webpack_exports__["l"] = writeLeftConversation;
/* harmony export (immutable) */ __webpack_exports__["g"] = readResumeChecked;
/* harmony export (immutable) */ __webpack_exports__["n"] = writeResumeChecked;
/* harmony export (immutable) */ __webpack_exports__["f"] = readPendingConversation;
/* harmony export (immutable) */ __webpack_exports__["m"] = writePendingConversation;
/* harmony export (immutable) */ __webpack_exports__["i"] = readVisitorConversation;
/* harmony export (immutable) */ __webpack_exports__["p"] = writeVisitorConversation;
/* harmony export (immutable) */ __webpack_exports__["a"] = clearVisitorConversation;
/* harmony export (immutable) */ __webpack_exports__["j"] = readVisitorDetails;
/* harmony export (immutable) */ __webpack_exports__["q"] = writeVisitorDetails;
/* harmony export (immutable) */ __webpack_exports__["b"] = forgetVisitor;
/* unused harmony export clearStoredConversations */
/* harmony export (immutable) */ __webpack_exports__["c"] = noteSignedInUser;
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};// What the composer keeps per signed-in user in this browser (localStorage): the open support
// conversation, so a new tab or a later visit finds it again and staff replies aren't missed (CH-3).
// Also, for whoever signs in, the conversation a support reply email's link asked for. Kept apart from
// the composer so the dock can clear it without loading the composer.
var CONVERSATION_KEY='@LT/SUPPORT_CONVERSATION';var LAST_USER_KEY='@LT/SUPPORT_LAST_USER';// Set once this tab has asked the server for the customer's conversations (resumeFromServer).
var RESUME_CHECKED_KEY='@LT/SUPPORT_RESUME_CHECKED';// The conversation the customer left ("New conversation", or gone): never picked up from the server again.
var LEFT_KEY='@LT/SUPPORT_LEFT';// Not per user: the link is often opened signed out, and must outlast a sign-in that clears those.
var PENDING_KEY='@LT/SUPPORT_LINK';// A signed-out visitor's conversation (localStorage, for 7 days) and what they typed to start it
// (sessionStorage, gone when the browser session ends). Both go when a customer signs in here.
var VISITOR_KEY='@LT/SUPPORT_VISITOR';var VISITOR_DETAILS_KEY='@LT/SUPPORT_VISITOR_DETAILS';var VISITOR_CONVERSATION_DAYS=7;var VISITOR_CONVERSATION_MS=VISITOR_CONVERSATION_DAYS*24*60*60*1000;function readStorage(storage,key){try{return window[storage].getItem(key);}catch(e){return null;}}function writeStorage(storage,key,value){try{if(value===null){window[storage].removeItem(key);}else{window[storage].setItem(key,value);}}catch(e){// Private mode: the composer still works, it just forgets between reloads.
}}function userKey(prefix,userId){return prefix+':'+(userId||'user');}function readConversation(userId){var key=userKey(CONVERSATION_KEY,userId);var stored=readStorage('localStorage',key);if(stored)return stored;// Until 4 Nov 2026 the id was kept per tab (sessionStorage): move it to this browser once.
var tab=readStorage('sessionStorage',key);if(tab){writeStorage('localStorage',key,tab);writeStorage('sessionStorage',key,null);}return tab;}function writeConversation(userId,conversationId){var key=userKey(CONVERSATION_KEY,userId);writeStorage('localStorage',key,conversationId||null);writeStorage('sessionStorage',key,null);}/** The conversation this customer left in this browser, so resumeFromServer doesn't bring it back. */function readLeftConversation(userId){return readStorage('localStorage',userKey(LEFT_KEY,userId));}function writeLeftConversation(userId,conversationId){writeStorage('localStorage',userKey(LEFT_KEY,userId),conversationId||null);}/** Whether this tab already asked the server for this customer's conversations. */function readResumeChecked(userId){return readStorage('sessionStorage',userKey(RESUME_CHECKED_KEY,userId))==='1';}function writeResumeChecked(userId){writeStorage('sessionStorage',userKey(RESUME_CHECKED_KEY,userId),'1');}/** The conversation id from a support reply email's link (deepLink.js), until a composer opens it. */function readPendingConversation(){return readStorage('sessionStorage',PENDING_KEY);}function writePendingConversation(conversationId){writeStorage('sessionStorage',PENDING_KEY,conversationId||null);}function readJson(storage,key){var raw=readStorage(storage,key);if(!raw)return null;try{var value=JSON.parse(raw);return value&&(typeof value==='undefined'?'undefined':_typeof(value))==='object'&&!Array.isArray(value)?value:null;}catch(e){// Not ours, or damaged: as if there were none.
return null;}}function isText(value){return typeof value==='string'&&!!value;}/**
 * The conversation a signed-out visitor started in this browser: {conversationId, token}, or null for
 * none. The token is the only way back into it; the server returned it once, when the conversation was
 * created. Kept for 7 days from the last message sent with it: an older one (or anything unreadable)
 * is removed here, so a shared browser doesn't hand it to the next person for long.
 */function readVisitorConversation(){var now=arguments.length>0&&arguments[0]!==undefined?arguments[0]:Date.now();var value=readJson('localStorage',VISITOR_KEY);var age=value?now-value.savedAt:NaN;if(value&&isText(value.conversationId)&&isText(value.token)&&typeof value.savedAt==='number'&&age>=0&&age<VISITOR_CONVERSATION_MS){return{conversationId:value.conversationId,token:value.token};}if(readStorage('localStorage',VISITOR_KEY)!==null){writeStorage('localStorage',VISITOR_KEY,null);}return null;}/** Keeps the conversation and its token, from now; without both, forgets it. */function writeVisitorConversation(record){var now=arguments.length>1&&arguments[1]!==undefined?arguments[1]:Date.now();writeStorage('localStorage',VISITOR_KEY,record&&isText(record.conversationId)&&isText(record.token)?JSON.stringify({conversationId:record.conversationId,token:record.token,savedAt:now}):null);}/** Forgets the conversation and its token; the details stay for the next one in this session. */function clearVisitorConversation(){writeStorage('localStorage',VISITOR_KEY,null);}/** The visitor's name, email and company in this browser session ('' for any not given). */function readVisitorDetails(){var value=readJson('sessionStorage',VISITOR_DETAILS_KEY);var text=function text(field){return value&&typeof value[field]==='string'?value[field]:'';};return{name:text('name'),email:text('email'),company:text('company')};}function writeVisitorDetails(details){var value={name:details&&details.name||'',email:details&&details.email||'',company:details&&details.company||''};writeStorage('sessionStorage',VISITOR_DETAILS_KEY,value.name||value.email||value.company?JSON.stringify(value):null);}/** Everything a visitor left in this browser: on "Forget this chat", and when a customer signs in. */function forgetVisitor(){writeStorage('localStorage',VISITOR_KEY,null);writeStorage('sessionStorage',VISITOR_DETAILS_KEY,null);}// Every key in a Storage (key()/length); stand-ins without them keep keys as own properties.
function storedKeys(store){if(typeof store.key==='function'&&typeof store.length==='number'){var keys=[];for(var i=0;i<store.length;i++){keys.push(store.key(i));}return keys;}return Object.keys(store);}// Conversation ids of every user in this browser (and the per-tab ones kept before 4 Nov 2026).
function clearStoredConversations(){['localStorage','sessionStorage'].forEach(function(storage){try{var store=window[storage];storedKeys(store).filter(function(key){return key&&(key.indexOf(CONVERSATION_KEY)===0||key.indexOf(LEFT_KEY)===0);}).forEach(function(key){return store.removeItem(key);});}catch(e){// Storage unavailable: nothing was stored.
}});}/**
 * Call when a customer is signed in. Signing out keeps what is stored (it is per user, so the same
 * customer finds their conversation again); a different customer signing in to this browser clears
 * it, so a shared computer never keeps the last one's conversation (their own comes back from the
 * server when they sign in again).
 */function noteSignedInUser(userId){if(!userId)return;var current=String(userId);var last=readStorage('localStorage',LAST_USER_KEY)||readStorage('sessionStorage',LAST_USER_KEY);if(last&&last!==current)clearStoredConversations();writeStorage('localStorage',LAST_USER_KEY,current);writeStorage('sessionStorage',LAST_USER_KEY,null);}

/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(850);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(17)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../lunch-team-client-checkout-msg/node_modules/css-loader/index.js!../../../../../../lunch-team-client-checkout-msg/node_modules/sass-loader/dist/cjs.js!./SignIn.scss", function() {
			var newContent = require("!!../../../../../../lunch-team-client-checkout-msg/node_modules/css-loader/index.js!../../../../../../lunch-team-client-checkout-msg/node_modules/sass-loader/dist/cjs.js!./SignIn.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return checkValidity; });
var checkValidity=function checkValidity(value,rules){var isValid=true;if(!rules){return true;}if(rules.required){isValid=value.trim()!==''&&isValid;}if(rules.minLength){isValid=value.length>=rules.minLength&&isValid;}if(rules.email){var re=/^(([^<>()[\]\\.,;:\s@]+(\.[^<>()[\]\\.,;:\s@]+)*)|(.+))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;isValid=re.test(value);}return isValid;};

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var asap = __webpack_require__(340);

function noop() {}

// States:
//
// 0 - pending
// 1 - fulfilled with _value
// 2 - rejected with _value
// 3 - adopted the state of another promise, _value
//
// once the state is no longer pending (0) it is immutable

// All `_` prefixed properties will be reduced to `_{random number}`
// at build time to obfuscate them and discourage their use.
// We don't use symbols or Object.defineProperty to fully hide them
// because the performance isn't good enough.


// to avoid using try/catch inside critical functions, we
// extract them to here.
var LAST_ERROR = null;
var IS_ERROR = {};
function getThen(obj) {
  try {
    return obj.then;
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

function tryCallOne(fn, a) {
  try {
    return fn(a);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}
function tryCallTwo(fn, a, b) {
  try {
    fn(a, b);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

module.exports = Promise;

function Promise(fn) {
  if (typeof this !== 'object') {
    throw new TypeError('Promises must be constructed via new');
  }
  if (typeof fn !== 'function') {
    throw new TypeError('Promise constructor\'s argument is not a function');
  }
  this._75 = 0;
  this._83 = 0;
  this._18 = null;
  this._38 = null;
  if (fn === noop) return;
  doResolve(fn, this);
}
Promise._47 = null;
Promise._71 = null;
Promise._44 = noop;

Promise.prototype.then = function(onFulfilled, onRejected) {
  if (this.constructor !== Promise) {
    return safeThen(this, onFulfilled, onRejected);
  }
  var res = new Promise(noop);
  handle(this, new Handler(onFulfilled, onRejected, res));
  return res;
};

function safeThen(self, onFulfilled, onRejected) {
  return new self.constructor(function (resolve, reject) {
    var res = new Promise(noop);
    res.then(resolve, reject);
    handle(self, new Handler(onFulfilled, onRejected, res));
  });
}
function handle(self, deferred) {
  while (self._83 === 3) {
    self = self._18;
  }
  if (Promise._47) {
    Promise._47(self);
  }
  if (self._83 === 0) {
    if (self._75 === 0) {
      self._75 = 1;
      self._38 = deferred;
      return;
    }
    if (self._75 === 1) {
      self._75 = 2;
      self._38 = [self._38, deferred];
      return;
    }
    self._38.push(deferred);
    return;
  }
  handleResolved(self, deferred);
}

function handleResolved(self, deferred) {
  asap(function() {
    var cb = self._83 === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      if (self._83 === 1) {
        resolve(deferred.promise, self._18);
      } else {
        reject(deferred.promise, self._18);
      }
      return;
    }
    var ret = tryCallOne(cb, self._18);
    if (ret === IS_ERROR) {
      reject(deferred.promise, LAST_ERROR);
    } else {
      resolve(deferred.promise, ret);
    }
  });
}
function resolve(self, newValue) {
  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
  if (newValue === self) {
    return reject(
      self,
      new TypeError('A promise cannot be resolved with itself.')
    );
  }
  if (
    newValue &&
    (typeof newValue === 'object' || typeof newValue === 'function')
  ) {
    var then = getThen(newValue);
    if (then === IS_ERROR) {
      return reject(self, LAST_ERROR);
    }
    if (
      then === self.then &&
      newValue instanceof Promise
    ) {
      self._83 = 3;
      self._18 = newValue;
      finale(self);
      return;
    } else if (typeof then === 'function') {
      doResolve(then.bind(newValue), self);
      return;
    }
  }
  self._83 = 1;
  self._18 = newValue;
  finale(self);
}

function reject(self, newValue) {
  self._83 = 2;
  self._18 = newValue;
  if (Promise._71) {
    Promise._71(self, newValue);
  }
  finale(self);
}
function finale(self) {
  if (self._75 === 1) {
    handle(self, self._38);
    self._38 = null;
  }
  if (self._75 === 2) {
    for (var i = 0; i < self._38.length; i++) {
      handle(self, self._38[i]);
    }
    self._38 = null;
  }
}

function Handler(onFulfilled, onRejected, promise){
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, promise) {
  var done = false;
  var res = tryCallTwo(fn, function (value) {
    if (done) return;
    done = true;
    resolve(promise, value);
  }, function (reason) {
    if (done) return;
    done = true;
    reject(promise, reason);
  });
  if (!done && res === IS_ERROR) {
    done = true;
    reject(promise, LAST_ERROR);
  }
}


/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

__webpack_require__(343);

__webpack_require__(540);

__webpack_require__(541);

if (global._babelPolyfill) {
  throw new Error("only one instance of babel-polyfill is allowed");
}
global._babelPolyfill = true;

var DEFINE_PROPERTY = "defineProperty";
function define(O, key, value) {
  O[key] || Object[DEFINE_PROPERTY](O, key, {
    writable: true,
    configurable: true,
    value: value
  });
}

define(String.prototype, "padLeft", "".padStart);
define(String.prototype, "padRight", "".padEnd);

"pop,reverse,shift,keys,values,entries,indexOf,every,some,forEach,map,filter,find,findIndex,includes,join,slice,concat,push,splice,unshift,sort,lastIndexOf,reduce,reduceRight,copyWithin,fill".split(",").forEach(function (key) {
  [][key] && define(Array, key, Function.call.bind([][key]));
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(39)))

/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(12) && !__webpack_require__(6)(function () {
  return Object.defineProperty(__webpack_require__(144)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(10);


/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(27);
var toIObject = __webpack_require__(28);
var arrayIndexOf = __webpack_require__(100)(false);
var IE_PROTO = __webpack_require__(146)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(16);
var anObject = __webpack_require__(2);
var getKeys = __webpack_require__(57);

module.exports = __webpack_require__(12) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(28);
var gOPN = __webpack_require__(60).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var DESCRIPTORS = __webpack_require__(12);
var getKeys = __webpack_require__(57);
var gOPS = __webpack_require__(101);
var pIE = __webpack_require__(85);
var toObject = __webpack_require__(18);
var IObject = __webpack_require__(84);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(6)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;


/***/ }),
/* 221 */
/***/ (function(module, exports) {

// 7.2.9 SameValue(x, y)
module.exports = Object.is || function is(x, y) {
  // eslint-disable-next-line no-self-compare
  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
};


/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var aFunction = __webpack_require__(20);
var isObject = __webpack_require__(9);
var invoke = __webpack_require__(223);
var arraySlice = [].slice;
var factories = {};

var construct = function (F, len, args) {
  if (!(len in factories)) {
    for (var n = [], i = 0; i < len; i++) n[i] = 'a[' + i + ']';
    // eslint-disable-next-line no-new-func
    factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
  } return factories[len](F, args);
};

module.exports = Function.bind || function bind(that /* , ...args */) {
  var fn = aFunction(this);
  var partArgs = arraySlice.call(arguments, 1);
  var bound = function (/* args... */) {
    var args = partArgs.concat(arraySlice.call(arguments));
    return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
  };
  if (isObject(fn.prototype)) bound.prototype = fn.prototype;
  return bound;
};


/***/ }),
/* 223 */
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};


/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

var $parseInt = __webpack_require__(3).parseInt;
var $trim = __webpack_require__(75).trim;
var ws = __webpack_require__(150);
var hex = /^[-+]?0[xX]/;

module.exports = $parseInt(ws + '08') !== 8 || $parseInt(ws + '0x16') !== 22 ? function parseInt(str, radix) {
  var string = $trim(String(str), 3);
  return $parseInt(string, (radix >>> 0) || (hex.test(string) ? 16 : 10));
} : $parseInt;


/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

var $parseFloat = __webpack_require__(3).parseFloat;
var $trim = __webpack_require__(75).trim;

module.exports = 1 / $parseFloat(__webpack_require__(150) + '-0') !== -Infinity ? function parseFloat(str) {
  var string = $trim(String(str), 3);
  var result = $parseFloat(string);
  return result === 0 && string.charAt(0) == '-' ? -0 : result;
} : $parseFloat;


/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

var cof = __webpack_require__(33);
module.exports = function (it, msg) {
  if (typeof it != 'number' && cof(it) != 'Number') throw TypeError(msg);
  return +it;
};


/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var isObject = __webpack_require__(9);
var floor = Math.floor;
module.exports = function isInteger(it) {
  return !isObject(it) && isFinite(it) && floor(it) === it;
};


/***/ }),
/* 228 */
/***/ (function(module, exports) {

// 20.2.2.20 Math.log1p(x)
module.exports = Math.log1p || function log1p(x) {
  return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
};


/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.16 Math.fround(x)
var sign = __webpack_require__(153);
var pow = Math.pow;
var EPSILON = pow(2, -52);
var EPSILON32 = pow(2, -23);
var MAX32 = pow(2, 127) * (2 - EPSILON32);
var MIN32 = pow(2, -126);

var roundTiesToEven = function (n) {
  return n + 1 / EPSILON - 1 / EPSILON;
};

module.exports = Math.fround || function fround(x) {
  var $abs = Math.abs(x);
  var $sign = sign(x);
  var a, result;
  if ($abs < MIN32) return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
  a = (1 + EPSILON32 / EPSILON) * $abs;
  result = a - (a - $abs);
  // eslint-disable-next-line no-self-compare
  if (result > MAX32 || result != result) return $sign * Infinity;
  return $sign * result;
};


/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(2);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

var aFunction = __webpack_require__(20);
var toObject = __webpack_require__(18);
var IObject = __webpack_require__(84);
var toLength = __webpack_require__(11);

module.exports = function (that, callbackfn, aLen, memo, isRight) {
  aFunction(callbackfn);
  var O = toObject(that);
  var self = IObject(O);
  var length = toLength(O.length);
  var index = isRight ? length - 1 : 0;
  var i = isRight ? -1 : 1;
  if (aLen < 2) for (;;) {
    if (index in self) {
      memo = self[index];
      index += i;
      break;
    }
    index += i;
    if (isRight ? index < 0 : length <= index) {
      throw TypeError('Reduce of empty array with no initial value');
    }
  }
  for (;isRight ? index >= 0 : length > index; index += i) if (index in self) {
    memo = callbackfn(memo, self[index], index, O);
  }
  return memo;
};


/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)

var toObject = __webpack_require__(18);
var toAbsoluteIndex = __webpack_require__(58);
var toLength = __webpack_require__(11);

module.exports = [].copyWithin || function copyWithin(target /* = 0 */, start /* = 0, end = @length */) {
  var O = toObject(this);
  var len = toLength(O.length);
  var to = toAbsoluteIndex(target, len);
  var from = toAbsoluteIndex(start, len);
  var end = arguments.length > 2 ? arguments[2] : undefined;
  var count = Math.min((end === undefined ? len : toAbsoluteIndex(end, len)) - from, len - to);
  var inc = 1;
  if (from < to && to < from + count) {
    inc = -1;
    from += count - 1;
    to += count - 1;
  }
  while (count-- > 0) {
    if (from in O) O[to] = O[from];
    else delete O[to];
    to += inc;
    from += inc;
  } return O;
};


/***/ }),
/* 233 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var regexpExec = __webpack_require__(165);
__webpack_require__(1)({
  target: 'RegExp',
  proto: true,
  forced: regexpExec !== /./.exec
}, {
  exec: regexpExec
});


/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

// 21.2.5.3 get RegExp.prototype.flags()
if (__webpack_require__(12) && /./g.flags != 'g') __webpack_require__(16).f(RegExp.prototype, 'flags', {
  configurable: true,
  get: __webpack_require__(86)
});


/***/ }),
/* 236 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};


/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(2);
var isObject = __webpack_require__(9);
var newPromiseCapability = __webpack_require__(169);

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(239);
var validate = __webpack_require__(65);
var MAP = 'Map';

// 23.1 Map Objects
module.exports = __webpack_require__(109)(MAP, function (get) {
  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.1.3.6 Map.prototype.get(key)
  get: function get(key) {
    var entry = strong.getEntry(validate(this, MAP), key);
    return entry && entry.v;
  },
  // 23.1.3.9 Map.prototype.set(key, value)
  set: function set(key, value) {
    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
  }
}, strong, true);


/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var dP = __webpack_require__(16).f;
var create = __webpack_require__(59);
var redefineAll = __webpack_require__(64);
var ctx = __webpack_require__(32);
var anInstance = __webpack_require__(62);
var forOf = __webpack_require__(63);
var $iterDefine = __webpack_require__(155);
var step = __webpack_require__(233);
var setSpecies = __webpack_require__(61);
var DESCRIPTORS = __webpack_require__(12);
var fastKey = __webpack_require__(51).fastKey;
var validate = __webpack_require__(65);
var SIZE = DESCRIPTORS ? '_s' : 'size';

var getEntry = function (that, key) {
  // fast case
  var index = fastKey(key);
  var entry;
  if (index !== 'F') return that._i[index];
  // frozen object case
  for (entry = that._f; entry; entry = entry.n) {
    if (entry.k == key) return entry;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;         // collection type
      that._i = create(null); // index
      that._f = undefined;    // first entry
      that._l = undefined;    // last entry
      that[SIZE] = 0;         // size
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear() {
        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
          entry.r = true;
          if (entry.p) entry.p = entry.p.n = undefined;
          delete data[entry.i];
        }
        that._f = that._l = undefined;
        that[SIZE] = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function (key) {
        var that = validate(this, NAME);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.n;
          var prev = entry.p;
          delete that._i[entry.i];
          entry.r = true;
          if (prev) prev.n = next;
          if (next) next.p = prev;
          if (that._f == entry) that._f = next;
          if (that._l == entry) that._l = prev;
          that[SIZE]--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /* , that = undefined */) {
        validate(this, NAME);
        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var entry;
        while (entry = entry ? entry.n : this._f) {
          f(entry.v, entry.k, this);
          // revert to the last existing entry
          while (entry && entry.r) entry = entry.p;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key) {
        return !!getEntry(validate(this, NAME), key);
      }
    });
    if (DESCRIPTORS) dP(C.prototype, 'size', {
      get: function () {
        return validate(this, NAME)[SIZE];
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var entry = getEntry(that, key);
    var prev, index;
    // change existing entry
    if (entry) {
      entry.v = value;
    // create new entry
    } else {
      that._l = entry = {
        i: index = fastKey(key, true), // <- index
        k: key,                        // <- key
        v: value,                      // <- value
        p: prev = that._l,             // <- previous entry
        n: undefined,                  // <- next entry
        r: false                       // <- removed
      };
      if (!that._f) that._f = entry;
      if (prev) prev.n = entry;
      that[SIZE]++;
      // add to index
      if (index !== 'F') that._i[index] = entry;
    } return that;
  },
  getEntry: getEntry,
  setStrong: function (C, NAME, IS_MAP) {
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    $iterDefine(C, NAME, function (iterated, kind) {
      this._t = validate(iterated, NAME); // target
      this._k = kind;                     // kind
      this._l = undefined;                // previous
    }, function () {
      var that = this;
      var kind = that._k;
      var entry = that._l;
      // revert to the last existing entry
      while (entry && entry.r) entry = entry.p;
      // get next entry
      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
        // or finish the iteration
        that._t = undefined;
        return step(1);
      }
      // return step by kind
      if (kind == 'keys') return step(0, entry.k);
      if (kind == 'values') return step(0, entry.v);
      return step(0, [entry.k, entry.v]);
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(NAME);
  }
};


/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(239);
var validate = __webpack_require__(65);
var SET = 'Set';

// 23.2 Set Objects
module.exports = __webpack_require__(109)(SET, function (get) {
  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.2.3.1 Set.prototype.add(value)
  add: function add(value) {
    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
  }
}, strong);


/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(3);
var each = __webpack_require__(43)(0);
var redefine = __webpack_require__(23);
var meta = __webpack_require__(51);
var assign = __webpack_require__(220);
var weak = __webpack_require__(242);
var isObject = __webpack_require__(9);
var validate = __webpack_require__(65);
var NATIVE_WEAK_MAP = __webpack_require__(65);
var IS_IE11 = !global.ActiveXObject && 'ActiveXObject' in global;
var WEAK_MAP = 'WeakMap';
var getWeak = meta.getWeak;
var isExtensible = Object.isExtensible;
var uncaughtFrozenStore = weak.ufstore;
var InternalMap;

var wrapper = function (get) {
  return function WeakMap() {
    return get(this, arguments.length > 0 ? arguments[0] : undefined);
  };
};

var methods = {
  // 23.3.3.3 WeakMap.prototype.get(key)
  get: function get(key) {
    if (isObject(key)) {
      var data = getWeak(key);
      if (data === true) return uncaughtFrozenStore(validate(this, WEAK_MAP)).get(key);
      return data ? data[this._i] : undefined;
    }
  },
  // 23.3.3.5 WeakMap.prototype.set(key, value)
  set: function set(key, value) {
    return weak.def(validate(this, WEAK_MAP), key, value);
  }
};

// 23.3 WeakMap Objects
var $WeakMap = module.exports = __webpack_require__(109)(WEAK_MAP, wrapper, methods, weak, true, true);

// IE11 WeakMap frozen keys fix
if (NATIVE_WEAK_MAP && IS_IE11) {
  InternalMap = weak.getConstructor(wrapper, WEAK_MAP);
  assign(InternalMap.prototype, methods);
  meta.NEED = true;
  each(['delete', 'has', 'get', 'set'], function (key) {
    var proto = $WeakMap.prototype;
    var method = proto[key];
    redefine(proto, key, function (a, b) {
      // store frozen objects on internal weakmap shim
      if (isObject(a) && !isExtensible(a)) {
        if (!this._f) this._f = new InternalMap();
        var result = this._f[key](a, b);
        return key == 'set' ? this : result;
      // store all the rest on native weakmap
      } return method.call(this, a, b);
    });
  });
}


/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var redefineAll = __webpack_require__(64);
var getWeak = __webpack_require__(51).getWeak;
var anObject = __webpack_require__(2);
var isObject = __webpack_require__(9);
var anInstance = __webpack_require__(62);
var forOf = __webpack_require__(63);
var createArrayMethod = __webpack_require__(43);
var $has = __webpack_require__(27);
var validate = __webpack_require__(65);
var arrayFind = createArrayMethod(5);
var arrayFindIndex = createArrayMethod(6);
var id = 0;

// fallback for uncaught frozen keys
var uncaughtFrozenStore = function (that) {
  return that._l || (that._l = new UncaughtFrozenStore());
};
var UncaughtFrozenStore = function () {
  this.a = [];
};
var findUncaughtFrozen = function (store, key) {
  return arrayFind(store.a, function (it) {
    return it[0] === key;
  });
};
UncaughtFrozenStore.prototype = {
  get: function (key) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) return entry[1];
  },
  has: function (key) {
    return !!findUncaughtFrozen(this, key);
  },
  set: function (key, value) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) entry[1] = value;
    else this.a.push([key, value]);
  },
  'delete': function (key) {
    var index = arrayFindIndex(this.a, function (it) {
      return it[0] === key;
    });
    if (~index) this.a.splice(index, 1);
    return !!~index;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;      // collection type
      that._i = id++;      // collection id
      that._l = undefined; // leak store for uncaught frozen objects
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.3.3.2 WeakMap.prototype.delete(key)
      // 23.4.3.3 WeakSet.prototype.delete(value)
      'delete': function (key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME))['delete'](key);
        return data && $has(data, this._i) && delete data[this._i];
      },
      // 23.3.3.4 WeakMap.prototype.has(key)
      // 23.4.3.4 WeakSet.prototype.has(value)
      has: function has(key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME)).has(key);
        return data && $has(data, this._i);
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var data = getWeak(anObject(key), true);
    if (data === true) uncaughtFrozenStore(that).set(key, value);
    else data[that._i] = value;
    return that;
  },
  ufstore: uncaughtFrozenStore
};


/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/ecma262/#sec-toindex
var toInteger = __webpack_require__(34);
var toLength = __webpack_require__(11);
module.exports = function (it) {
  if (it === undefined) return 0;
  var number = toInteger(it);
  var length = toLength(number);
  if (number !== length) throw RangeError('Wrong length!');
  return length;
};


/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

// all object keys, includes non-enumerable and symbols
var gOPN = __webpack_require__(60);
var gOPS = __webpack_require__(101);
var anObject = __webpack_require__(2);
var Reflect = __webpack_require__(3).Reflect;
module.exports = Reflect && Reflect.ownKeys || function ownKeys(it) {
  var keys = gOPN.f(anObject(it));
  var getSymbols = gOPS.f;
  return getSymbols ? keys.concat(getSymbols(it)) : keys;
};


/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray
var isArray = __webpack_require__(102);
var isObject = __webpack_require__(9);
var toLength = __webpack_require__(11);
var ctx = __webpack_require__(32);
var IS_CONCAT_SPREADABLE = __webpack_require__(10)('isConcatSpreadable');

function flattenIntoArray(target, original, source, sourceLen, start, depth, mapper, thisArg) {
  var targetIndex = start;
  var sourceIndex = 0;
  var mapFn = mapper ? ctx(mapper, thisArg, 3) : false;
  var element, spreadable;

  while (sourceIndex < sourceLen) {
    if (sourceIndex in source) {
      element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];

      spreadable = false;
      if (isObject(element)) {
        spreadable = element[IS_CONCAT_SPREADABLE];
        spreadable = spreadable !== undefined ? !!spreadable : isArray(element);
      }

      if (spreadable && depth > 0) {
        targetIndex = flattenIntoArray(target, original, element, toLength(element.length), targetIndex, depth - 1) - 1;
      } else {
        if (targetIndex >= 0x1fffffffffffff) throw TypeError();
        target[targetIndex] = element;
      }

      targetIndex++;
    }
    sourceIndex++;
  }
  return targetIndex;
}

module.exports = flattenIntoArray;


/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-string-pad-start-end
var toLength = __webpack_require__(11);
var repeat = __webpack_require__(152);
var defined = __webpack_require__(41);

module.exports = function (that, maxLength, fillString, left) {
  var S = String(defined(that));
  var stringLength = S.length;
  var fillStr = fillString === undefined ? ' ' : String(fillString);
  var intMaxLength = toLength(maxLength);
  if (intMaxLength <= stringLength || fillStr == '') return S;
  var fillLen = intMaxLength - stringLength;
  var stringFiller = repeat.call(fillStr, Math.ceil(fillLen / fillStr.length));
  if (stringFiller.length > fillLen) stringFiller = stringFiller.slice(0, fillLen);
  return left ? stringFiller + S : S + stringFiller;
};


/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(12);
var getKeys = __webpack_require__(57);
var toIObject = __webpack_require__(28);
var isEnum = __webpack_require__(85).f;
module.exports = function (isEntries) {
  return function (it) {
    var O = toIObject(it);
    var keys = getKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) {
      key = keys[i++];
      if (!DESCRIPTORS || isEnum.call(O, key)) {
        result.push(isEntries ? [key, O[key]] : O[key]);
      }
    }
    return result;
  };
};


/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var classof = __webpack_require__(74);
var from = __webpack_require__(249);
module.exports = function (NAME) {
  return function toJSON() {
    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
    return from(this);
  };
};


/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

var forOf = __webpack_require__(63);

module.exports = function (iter, ITERATOR) {
  var result = [];
  forOf(iter, false, result.push, result, ITERATOR);
  return result;
};


/***/ }),
/* 250 */
/***/ (function(module, exports) {

// https://rwaldron.github.io/proposal-math-extensions/
module.exports = Math.scale || function scale(x, inLow, inHigh, outLow, outHigh) {
  if (
    arguments.length === 0
      // eslint-disable-next-line no-self-compare
      || x != x
      // eslint-disable-next-line no-self-compare
      || inLow != inLow
      // eslint-disable-next-line no-self-compare
      || inHigh != inHigh
      // eslint-disable-next-line no-self-compare
      || outLow != outLow
      // eslint-disable-next-line no-self-compare
      || outHigh != outHigh
  ) return NaN;
  if (x === Infinity || x === -Infinity) return x;
  return (x - inLow) * (outHigh - outLow) / (inHigh - inLow) + outLow;
};


/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = findTabbableDescendants;
/*!
 * Adapted from jQuery UI core
 *
 * http://jqueryui.com
 *
 * Copyright 2014 jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/category/ui-core/
 */

var tabbableNode = /input|select|textarea|button|object/;

function hidesContents(element) {
  var zeroSize = element.offsetWidth <= 0 && element.offsetHeight <= 0;

  // If the node is empty, this is good enough
  if (zeroSize && !element.innerHTML) return true;

  // Otherwise we need to check some styles
  var style = window.getComputedStyle(element);
  return zeroSize ? style.getPropertyValue("overflow") !== "visible" ||
  // if 'overflow: visible' set, check if there is actually any overflow
  element.scrollWidth <= 0 && element.scrollHeight <= 0 : style.getPropertyValue("display") == "none";
}

function visible(element) {
  var parentElement = element;
  while (parentElement) {
    if (parentElement === document.body) break;
    if (hidesContents(parentElement)) return false;
    parentElement = parentElement.parentNode;
  }
  return true;
}

function focusable(element, isTabIndexNotNaN) {
  var nodeName = element.nodeName.toLowerCase();
  var res = tabbableNode.test(nodeName) && !element.disabled || (nodeName === "a" ? element.href || isTabIndexNotNaN : isTabIndexNotNaN);
  return res && visible(element);
}

function tabbable(element) {
  var tabIndex = element.getAttribute("tabindex");
  if (tabIndex === null) tabIndex = undefined;
  var isTabIndexNaN = isNaN(tabIndex);
  return (isTabIndexNaN || tabIndex >= 0) && focusable(element, !isTabIndexNaN);
}

function findTabbableDescendants(element) {
  return [].slice.call(element.querySelectorAll("*"), 0).filter(tabbable);
}
module.exports = exports["default"];

/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.assertNodeList = assertNodeList;
exports.setElement = setElement;
exports.validateElement = validateElement;
exports.hide = hide;
exports.show = show;
exports.documentNotReadyOrSSRTesting = documentNotReadyOrSSRTesting;
exports.resetForTesting = resetForTesting;

var _warning = __webpack_require__(37);

var _warning2 = _interopRequireDefault(_warning);

var _safeHTMLElement = __webpack_require__(171);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var globalElement = null;

function assertNodeList(nodeList, selector) {
  if (!nodeList || !nodeList.length) {
    throw new Error("react-modal: No elements were found for selector " + selector + ".");
  }
}

function setElement(element) {
  var useElement = element;
  if (typeof useElement === "string" && _safeHTMLElement.canUseDOM) {
    var el = document.querySelectorAll(useElement);
    assertNodeList(el, useElement);
    useElement = "length" in el ? el[0] : el;
  }
  globalElement = useElement || globalElement;
  return globalElement;
}

function validateElement(appElement) {
  if (!appElement && !globalElement) {
    (0, _warning2.default)(false, ["react-modal: App element is not defined.", "Please use `Modal.setAppElement(el)` or set `appElement={el}`.", "This is needed so screen readers don't see main content", "when modal is opened. It is not recommended, but you can opt-out", "by setting `ariaHideApp={false}`."].join(" "));

    return false;
  }

  return true;
}

function hide(appElement) {
  if (validateElement(appElement)) {
    (appElement || globalElement).setAttribute("aria-hidden", "true");
  }
}

function show(appElement) {
  if (validateElement(appElement)) {
    (appElement || globalElement).removeAttribute("aria-hidden");
  }
}

function documentNotReadyOrSSRTesting() {
  globalElement = null;
}

function resetForTesting() {
  globalElement = null;
}

/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// Tracks portals that are open and emits events to subscribers

var PortalOpenInstances = function PortalOpenInstances() {
  var _this = this;

  _classCallCheck(this, PortalOpenInstances);

  this.register = function (openInstance) {
    if (_this.openInstances.indexOf(openInstance) !== -1) {
      if (false) {
        // eslint-disable-next-line no-console
        console.warn("React-Modal: Cannot register modal instance that's already open");
      }
      return;
    }
    _this.openInstances.push(openInstance);
    _this.emit("register");
  };

  this.deregister = function (openInstance) {
    var index = _this.openInstances.indexOf(openInstance);
    if (index === -1) {
      if (false) {
        // eslint-disable-next-line no-console
        console.warn("React-Modal: Unable to deregister " + openInstance + " as " + "it was never registered");
      }
      return;
    }
    _this.openInstances.splice(index, 1);
    _this.emit("deregister");
  };

  this.subscribe = function (callback) {
    _this.subscribers.push(callback);
  };

  this.emit = function (eventType) {
    _this.subscribers.forEach(function (subscriber) {
      return subscriber(eventType,
      // shallow copy to avoid accidental mutation
      _this.openInstances.slice());
    });
  };

  this.openInstances = [];
  this.subscribers = [];
};

var portalOpenInstances = new PortalOpenInstances();

exports.default = portalOpenInstances;
module.exports = exports["default"];

/***/ }),
/* 254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(77);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var isModifiedEvent = function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
};

/**
 * The public API for rendering a history-aware <a>.
 */

var Link = function (_React$Component) {
  _inherits(Link, _React$Component);

  function Link() {
    var _temp, _this, _ret;

    _classCallCheck(this, Link);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function (event) {
      if (_this.props.onClick) _this.props.onClick(event);

      if (!event.defaultPrevented && // onClick prevented default
      event.button === 0 && // ignore everything but left clicks
      !_this.props.target && // let browser handle "target=_blank" etc.
      !isModifiedEvent(event) // ignore clicks with modifier keys
      ) {
          event.preventDefault();

          var history = _this.context.router.history;
          var _this$props = _this.props,
              replace = _this$props.replace,
              to = _this$props.to;


          if (replace) {
            history.replace(to);
          } else {
            history.push(to);
          }
        }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Link.prototype.render = function render() {
    var _props = this.props,
        replace = _props.replace,
        to = _props.to,
        innerRef = _props.innerRef,
        props = _objectWithoutProperties(_props, ["replace", "to", "innerRef"]); // eslint-disable-line no-unused-vars

    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(this.context.router, "You should not use <Link> outside a <Router>");

    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(to !== undefined, 'You must specify the "to" property');

    var history = this.context.router.history;

    var location = typeof to === "string" ? Object(__WEBPACK_IMPORTED_MODULE_3_history__["c" /* createLocation */])(to, null, null, history.location) : to;

    var href = history.createHref(location);
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", _extends({}, props, { onClick: this.handleClick, href: href, ref: innerRef }));
  };

  return Link;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Link.propTypes = {
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  target: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired,
  innerRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func])
};
Link.defaultProps = {
  replace: false
};
Link.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      createHref: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Link);

/***/ }),
/* 255 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Route__ = __webpack_require__(256);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Route__["a" /* default */]);

/***/ }),
/* 256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__matchPath__ = __webpack_require__(174);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var isEmptyChildren = function isEmptyChildren(children) {
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 0;
};

/**
 * The public API for matching a single path and rendering.
 */

var Route = function (_React$Component) {
  _inherits(Route, _React$Component);

  function Route() {
    var _temp, _this, _ret;

    _classCallCheck(this, Route);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props, _this.context.router)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Route.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        route: {
          location: this.props.location || this.context.router.route.location,
          match: this.state.match
        }
      })
    };
  };

  Route.prototype.computeMatch = function computeMatch(_ref, router) {
    var computedMatch = _ref.computedMatch,
        location = _ref.location,
        path = _ref.path,
        strict = _ref.strict,
        exact = _ref.exact,
        sensitive = _ref.sensitive;

    if (computedMatch) return computedMatch; // <Switch> already computed the match for us

    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(router, "You should not use <Route> or withRouter() outside a <Router>");

    var route = router.route;

    var pathname = (location || route.location).pathname;

    return Object(__WEBPACK_IMPORTED_MODULE_4__matchPath__["a" /* default */])(pathname, { path: path, strict: strict, exact: exact, sensitive: sensitive }, route.match);
  };

  Route.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.component && this.props.render), "You should not use <Route component> and <Route render> in the same route; <Route render> will be ignored");

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.component && this.props.children && !isEmptyChildren(this.props.children)), "You should not use <Route component> and <Route children> in the same route; <Route children> will be ignored");

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.render && this.props.children && !isEmptyChildren(this.props.children)), "You should not use <Route render> and <Route children> in the same route; <Route children> will be ignored");
  };

  Route.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps, nextContext) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(nextProps.location && !this.props.location), '<Route> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(!nextProps.location && this.props.location), '<Route> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');

    this.setState({
      match: this.computeMatch(nextProps, nextContext.router)
    });
  };

  Route.prototype.render = function render() {
    var match = this.state.match;
    var _props = this.props,
        children = _props.children,
        component = _props.component,
        render = _props.render;
    var _context$router = this.context.router,
        history = _context$router.history,
        route = _context$router.route,
        staticContext = _context$router.staticContext;

    var location = this.props.location || route.location;
    var props = { match: match, location: location, history: history, staticContext: staticContext };

    if (component) return match ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(component, props) : null;

    if (render) return match ? render(props) : null;

    if (typeof children === "function") return children(props);

    if (children && !isEmptyChildren(children)) return __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children);

    return null;
  };

  return Route;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Route.propTypes = {
  computedMatch: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object, // private, from <Switch>
  path: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  exact: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  strict: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  sensitive: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  component: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  render: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node]),
  location: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
Route.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
    route: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
    staticContext: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
  })
};
Route.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Route);

/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

var isarray = __webpack_require__(568)

/**
 * Expose `pathToRegexp`.
 */
module.exports = pathToRegexp
module.exports.parse = parse
module.exports.compile = compile
module.exports.tokensToFunction = tokensToFunction
module.exports.tokensToRegExp = tokensToRegExp

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g')

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = []
  var key = 0
  var index = 0
  var path = ''
  var defaultDelimiter = options && options.delimiter || '/'
  var res

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0]
    var escaped = res[1]
    var offset = res.index
    path += str.slice(index, offset)
    index = offset + m.length

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1]
      continue
    }

    var next = str[index]
    var prefix = res[2]
    var name = res[3]
    var capture = res[4]
    var group = res[5]
    var modifier = res[6]
    var asterisk = res[7]

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path)
      path = ''
    }

    var partial = prefix != null && next != null && next !== prefix
    var repeat = modifier === '+' || modifier === '*'
    var optional = modifier === '?' || modifier === '*'
    var delimiter = res[2] || defaultDelimiter
    var pattern = capture || group

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    })
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index)
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path)
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options), options)
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens, options) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length)

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$', flags(options))
    }
  }

  return function (obj, opts) {
    var path = ''
    var data = obj || {}
    var options = opts || {}
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i]

      if (typeof token === 'string') {
        path += token

        continue
      }

      var value = data[token.name]
      var segment

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j])

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value)

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options && options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g)

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      })
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = []

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source)
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options))

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  var strict = options.strict
  var end = options.end !== false
  var route = ''

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i]

    if (typeof token === 'string') {
      route += escapeString(token)
    } else {
      var prefix = escapeString(token.prefix)
      var capture = '(?:' + token.pattern + ')'

      keys.push(token)

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*'
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?'
        } else {
          capture = prefix + '(' + capture + ')?'
        }
      } else {
        capture = prefix + '(' + capture + ')'
      }

      route += capture
    }
  }

  var delimiter = escapeString(options.delimiter || '/')
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?'
  }

  if (end) {
    route += '$'
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)'
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}


/***/ }),
/* 258 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_path_to_regexp__);


var patternCache = {};
var cacheLimit = 10000;
var cacheCount = 0;

var compileGenerator = function compileGenerator(pattern) {
  var cacheKey = pattern;
  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});

  if (cache[pattern]) return cache[pattern];

  var compiledGenerator = __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default.a.compile(pattern);

  if (cacheCount < cacheLimit) {
    cache[pattern] = compiledGenerator;
    cacheCount++;
  }

  return compiledGenerator;
};

/**
 * Public API for generating a URL pathname from a pattern and parameters.
 */
var generatePath = function generatePath() {
  var pattern = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "/";
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (pattern === "/") {
    return pattern;
  }
  var generator = compileGenerator(pattern);
  return generator(params, { pretty: true });
};

/* harmony default export */ __webpack_exports__["a"] = (generatePath);

/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = getPrototypeOf && getPrototypeOf(Object);

function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try { // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return setBatch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getBatch; });
// Default to a dummy "batch" implementation that just runs the callback
function defaultNoopBatch(callback) {
  callback();
}

var batch = defaultNoopBatch; // Allow injecting another batching function later

var setBatch = function setBatch(newBatch) {
  return batch = newBatch;
}; // Supply a getter just to skip dealing with ESM bindings

var getBatch = function getBatch() {
  return batch;
};

/***/ }),
/* 261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = connectAdvanced;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__ = __webpack_require__(582);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_is__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_is__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_Subscription__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_useIsomorphicLayoutEffect__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Context__ = __webpack_require__(66);







 // Define some constant arrays just to avoid re-creating these

var EMPTY_ARRAY = [];
var NO_SUBSCRIPTION_ARRAY = [null, null];

var stringifyComponent = function stringifyComponent(Comp) {
  try {
    return JSON.stringify(Comp);
  } catch (err) {
    return String(Comp);
  }
};

function storeStateUpdatesReducer(state, action) {
  var updateCount = state[1];
  return [action.payload, updateCount + 1];
}

function useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
  Object(__WEBPACK_IMPORTED_MODULE_6__utils_useIsomorphicLayoutEffect__["a" /* useIsomorphicLayoutEffect */])(function () {
    return effectFunc.apply(void 0, effectArgs);
  }, dependencies);
}

function captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, actualChildProps, childPropsFromStoreUpdate, notifyNestedSubs) {
  // We want to capture the wrapper props and child props we used for later comparisons
  lastWrapperProps.current = wrapperProps;
  lastChildProps.current = actualChildProps;
  renderIsScheduled.current = false; // If the render was from a store update, clear out that reference and cascade the subscriber update

  if (childPropsFromStoreUpdate.current) {
    childPropsFromStoreUpdate.current = null;
    notifyNestedSubs();
  }
}

function subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, childPropsFromStoreUpdate, notifyNestedSubs, forceComponentUpdateDispatch) {
  // If we're not subscribed to the store, nothing to do here
  if (!shouldHandleStateChanges) return; // Capture values for checking if and when this component unmounts

  var didUnsubscribe = false;
  var lastThrownError = null; // We'll run this callback every time a store subscription update propagates to this component

  var checkForUpdates = function checkForUpdates() {
    if (didUnsubscribe) {
      // Don't run stale listeners.
      // Redux doesn't guarantee unsubscriptions happen until next dispatch.
      return;
    }

    var latestStoreState = store.getState();
    var newChildProps, error;

    try {
      // Actually run the selector with the most recent store state and wrapper props
      // to determine what the child props should be
      newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
    } catch (e) {
      error = e;
      lastThrownError = e;
    }

    if (!error) {
      lastThrownError = null;
    } // If the child props haven't changed, nothing to do here - cascade the subscription update


    if (newChildProps === lastChildProps.current) {
      if (!renderIsScheduled.current) {
        notifyNestedSubs();
      }
    } else {
      // Save references to the new child props.  Note that we track the "child props from store update"
      // as a ref instead of a useState/useReducer because we need a way to determine if that value has
      // been processed.  If this went into useState/useReducer, we couldn't clear out the value without
      // forcing another re-render, which we don't want.
      lastChildProps.current = newChildProps;
      childPropsFromStoreUpdate.current = newChildProps;
      renderIsScheduled.current = true; // If the child props _did_ change (or we caught an error), this wrapper component needs to re-render

      forceComponentUpdateDispatch({
        type: 'STORE_UPDATED',
        payload: {
          error: error
        }
      });
    }
  }; // Actually subscribe to the nearest connected ancestor (or store)


  subscription.onStateChange = checkForUpdates;
  subscription.trySubscribe(); // Pull data from the store after first render in case the store has
  // changed since we began.

  checkForUpdates();

  var unsubscribeWrapper = function unsubscribeWrapper() {
    didUnsubscribe = true;
    subscription.tryUnsubscribe();
    subscription.onStateChange = null;

    if (lastThrownError) {
      // It's possible that we caught an error due to a bad mapState function, but the
      // parent re-rendered without this component and we're about to unmount.
      // This shouldn't happen as long as we do top-down subscriptions correctly, but
      // if we ever do those wrong, this throw will surface the error in our tests.
      // In that case, throw the error from here so it doesn't get lost.
      throw lastThrownError;
    }
  };

  return unsubscribeWrapper;
}

var initStateUpdates = function initStateUpdates() {
  return [null, 0];
};

function connectAdvanced(
/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
      export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
    Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
    Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/
selectorFactory, // options object:
_ref) {
  if (_ref === void 0) {
    _ref = {};
  }

  var _ref2 = _ref,
      _ref2$getDisplayName = _ref2.getDisplayName,
      getDisplayName = _ref2$getDisplayName === void 0 ? function (name) {
    return "ConnectAdvanced(" + name + ")";
  } : _ref2$getDisplayName,
      _ref2$methodName = _ref2.methodName,
      methodName = _ref2$methodName === void 0 ? 'connectAdvanced' : _ref2$methodName,
      _ref2$renderCountProp = _ref2.renderCountProp,
      renderCountProp = _ref2$renderCountProp === void 0 ? undefined : _ref2$renderCountProp,
      _ref2$shouldHandleSta = _ref2.shouldHandleStateChanges,
      shouldHandleStateChanges = _ref2$shouldHandleSta === void 0 ? true : _ref2$shouldHandleSta,
      _ref2$storeKey = _ref2.storeKey,
      storeKey = _ref2$storeKey === void 0 ? 'store' : _ref2$storeKey,
      _ref2$withRef = _ref2.withRef,
      withRef = _ref2$withRef === void 0 ? false : _ref2$withRef,
      _ref2$forwardRef = _ref2.forwardRef,
      forwardRef = _ref2$forwardRef === void 0 ? false : _ref2$forwardRef,
      _ref2$context = _ref2.context,
      context = _ref2$context === void 0 ? __WEBPACK_IMPORTED_MODULE_7__Context__["a" /* ReactReduxContext */] : _ref2$context,
      connectOptions = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref2, ["getDisplayName", "methodName", "renderCountProp", "shouldHandleStateChanges", "storeKey", "withRef", "forwardRef", "context"]);

  if (false) {
    if (renderCountProp !== undefined) {
      throw new Error("renderCountProp is removed. render counting is built into the latest React Dev Tools profiling extension");
    }

    if (withRef) {
      throw new Error('withRef is removed. To access the wrapped instance, use a ref on the connected component');
    }

    var customStoreWarningMessage = 'To use a custom Redux store for specific components, create a custom React context with ' + "React.createContext(), and pass the context object to React Redux's Provider and specific components" + ' like: <Provider context={MyContext}><ConnectedComponent context={MyContext} /></Provider>. ' + 'You may also pass a {context : MyContext} option to connect';

    if (storeKey !== 'store') {
      throw new Error('storeKey has been removed and does not do anything. ' + customStoreWarningMessage);
    }
  }

  var Context = context;
  return function wrapWithConnect(WrappedComponent) {
    if (false) {
      throw new Error("You must pass a component to the function returned by " + (methodName + ". Instead received " + stringifyComponent(WrappedComponent)));
    }

    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
    var displayName = getDisplayName(wrappedComponentName);

    var selectorFactoryOptions = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, connectOptions, {
      getDisplayName: getDisplayName,
      methodName: methodName,
      renderCountProp: renderCountProp,
      shouldHandleStateChanges: shouldHandleStateChanges,
      storeKey: storeKey,
      displayName: displayName,
      wrappedComponentName: wrappedComponentName,
      WrappedComponent: WrappedComponent
    });

    var pure = connectOptions.pure;

    function createChildSelector(store) {
      return selectorFactory(store.dispatch, selectorFactoryOptions);
    } // If we aren't running in "pure" mode, we don't want to memoize values.
    // To avoid conditionally calling hooks, we fall back to a tiny wrapper
    // that just executes the given callback immediately.


    var usePureOnlyMemo = pure ? __WEBPACK_IMPORTED_MODULE_3_react__["useMemo"] : function (callback) {
      return callback();
    };

    function ConnectFunction(props) {
      var _useMemo = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useMemo"])(function () {
        // Distinguish between actual "data" props that were passed to the wrapper component,
        // and values needed to control behavior (forwarded refs, alternate context instances).
        // To maintain the wrapperProps object reference, memoize this destructuring.
        var forwardedRef = props.forwardedRef,
            wrapperProps = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(props, ["forwardedRef"]);

        return [props.context, forwardedRef, wrapperProps];
      }, [props]),
          propsContext = _useMemo[0],
          forwardedRef = _useMemo[1],
          wrapperProps = _useMemo[2];

      var ContextToUse = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useMemo"])(function () {
        // Users may optionally pass in a custom context instance to use instead of our ReactReduxContext.
        // Memoize the check that determines which context instance we should use.
        return propsContext && propsContext.Consumer && Object(__WEBPACK_IMPORTED_MODULE_4_react_is__["isContextConsumer"])(__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(propsContext.Consumer, null)) ? propsContext : Context;
      }, [propsContext, Context]); // Retrieve the store and ancestor subscription via context, if available

      var contextValue = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useContext"])(ContextToUse); // The store _must_ exist as either a prop or in context.
      // We'll check to see if it _looks_ like a Redux store first.
      // This allows us to pass through a `store` prop that is just a plain value.

      var didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
      var didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);

      if (false) {
        throw new Error("Could not find \"store\" in the context of " + ("\"" + displayName + "\". Either wrap the root component in a <Provider>, ") + "or pass a custom React context provider to <Provider> and the corresponding " + ("React context consumer to " + displayName + " in connect options."));
      } // Based on the previous check, one of these must be true


      var store = didStoreComeFromProps ? props.store : contextValue.store;
      var childPropsSelector = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useMemo"])(function () {
        // The child props selector needs the store reference as an input.
        // Re-create this selector whenever the store changes.
        return createChildSelector(store);
      }, [store]);

      var _useMemo2 = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useMemo"])(function () {
        if (!shouldHandleStateChanges) return NO_SUBSCRIPTION_ARRAY; // This Subscription's source should match where store came from: props vs. context. A component
        // connected to the store via props shouldn't use subscription from context, or vice versa.

        var subscription = new __WEBPACK_IMPORTED_MODULE_5__utils_Subscription__["a" /* default */](store, didStoreComeFromProps ? null : contextValue.subscription); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
        // the middle of the notification loop, where `subscription` will then be null. This can
        // probably be avoided if Subscription's listeners logic is changed to not call listeners
        // that have been unsubscribed in the  middle of the notification loop.

        var notifyNestedSubs = subscription.notifyNestedSubs.bind(subscription);
        return [subscription, notifyNestedSubs];
      }, [store, didStoreComeFromProps, contextValue]),
          subscription = _useMemo2[0],
          notifyNestedSubs = _useMemo2[1]; // Determine what {store, subscription} value should be put into nested context, if necessary,
      // and memoize that value to avoid unnecessary context updates.


      var overriddenContextValue = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useMemo"])(function () {
        if (didStoreComeFromProps) {
          // This component is directly subscribed to a store from props.
          // We don't want descendants reading from this store - pass down whatever
          // the existing context value is from the nearest connected ancestor.
          return contextValue;
        } // Otherwise, put this component's subscription instance into context, so that
        // connected descendants won't update until after this component is done


        return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, contextValue, {
          subscription: subscription
        });
      }, [didStoreComeFromProps, contextValue, subscription]); // We need to force this wrapper component to re-render whenever a Redux store update
      // causes a change to the calculated child component props (or we caught an error in mapState)

      var _useReducer = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useReducer"])(storeStateUpdatesReducer, EMPTY_ARRAY, initStateUpdates),
          _useReducer$ = _useReducer[0],
          previousStateUpdateResult = _useReducer$[0],
          forceComponentUpdateDispatch = _useReducer[1]; // Propagate any mapState/mapDispatch errors upwards


      if (previousStateUpdateResult && previousStateUpdateResult.error) {
        throw previousStateUpdateResult.error;
      } // Set up refs to coordinate values between the subscription effect and the render logic


      var lastChildProps = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useRef"])();
      var lastWrapperProps = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useRef"])(wrapperProps);
      var childPropsFromStoreUpdate = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useRef"])();
      var renderIsScheduled = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useRef"])(false);
      var actualChildProps = usePureOnlyMemo(function () {
        // Tricky logic here:
        // - This render may have been triggered by a Redux store update that produced new child props
        // - However, we may have gotten new wrapper props after that
        // If we have new child props, and the same wrapper props, we know we should use the new child props as-is.
        // But, if we have new wrapper props, those might change the child props, so we have to recalculate things.
        // So, we'll use the child props from store update only if the wrapper props are the same as last time.
        if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) {
          return childPropsFromStoreUpdate.current;
        } // TODO We're reading the store directly in render() here. Bad idea?
        // This will likely cause Bad Things (TM) to happen in Concurrent Mode.
        // Note that we do this because on renders _not_ caused by store updates, we need the latest store state
        // to determine what the child props should be.


        return childPropsSelector(store.getState(), wrapperProps);
      }, [store, previousStateUpdateResult, wrapperProps]); // We need this to execute synchronously every time we re-render. However, React warns
      // about useLayoutEffect in SSR, so we try to detect environment and fall back to
      // just useEffect instead to avoid the warning, since neither will run anyway.

      useIsomorphicLayoutEffectWithArgs(captureWrapperProps, [lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, actualChildProps, childPropsFromStoreUpdate, notifyNestedSubs]); // Our re-subscribe logic only runs when the store/subscription setup changes

      useIsomorphicLayoutEffectWithArgs(subscribeUpdates, [shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, childPropsFromStoreUpdate, notifyNestedSubs, forceComponentUpdateDispatch], [store, subscription, childPropsSelector]); // Now that all that's done, we can finally try to actually render the child component.
      // We memoize the elements for the rendered child component as an optimization.

      var renderedWrappedComponent = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useMemo"])(function () {
        return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(WrappedComponent, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, actualChildProps, {
          ref: forwardedRef
        }));
      }, [forwardedRef, WrappedComponent, actualChildProps]); // If React sees the exact same element reference as last time, it bails out of re-rendering
      // that child, same as if it was wrapped in React.memo() or returned false from shouldComponentUpdate.

      var renderedChild = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useMemo"])(function () {
        if (shouldHandleStateChanges) {
          // If this component is subscribed to store updates, we need to pass its own
          // subscription instance down to our descendants. That means rendering the same
          // Context instance, and putting a different value into the context.
          return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ContextToUse.Provider, {
            value: overriddenContextValue
          }, renderedWrappedComponent);
        }

        return renderedWrappedComponent;
      }, [ContextToUse, renderedWrappedComponent, overriddenContextValue]);
      return renderedChild;
    } // If we're in "pure" mode, ensure our wrapper component only re-renders when incoming props have changed.


    var Connect = pure ? __WEBPACK_IMPORTED_MODULE_3_react___default.a.memo(ConnectFunction) : ConnectFunction;
    Connect.WrappedComponent = WrappedComponent;
    Connect.displayName = displayName;

    if (forwardRef) {
      var forwarded = __WEBPACK_IMPORTED_MODULE_3_react___default.a.forwardRef(function forwardConnectRef(props, ref) {
        return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Connect, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props, {
          forwardedRef: ref
        }));
      });
      forwarded.displayName = displayName;
      forwarded.WrappedComponent = WrappedComponent;
      return __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default()(forwarded, WrappedComponent);
    }

    return __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default()(Connect, WrappedComponent);
  };
}

/***/ }),
/* 262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return useIsomorphicLayoutEffect; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
 // React currently throws a warning when using useLayoutEffect on the server.
// To get around it, we can conditionally useEffect on the server (no-op) and
// useLayoutEffect in the browser. We need useLayoutEffect to ensure the store
// subscription callback always has the selector from the latest render commit
// available, otherwise a store update may happen between render and the effect,
// which may cause missed updates; we also must ensure the store subscription
// is created synchronously, otherwise a store update may occur before the
// subscription is created and an inconsistent state may be observed

var useIsomorphicLayoutEffect = typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined' ? __WEBPACK_IMPORTED_MODULE_0_react__["useLayoutEffect"] : __WEBPACK_IMPORTED_MODULE_0_react__["useEffect"];

/***/ }),
/* 263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = shallowEqual;
function is(x, y) {
  if (x === y) {
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function shallowEqual(objA, objB) {
  if (is(objA, objB)) return true;

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);
  if (keysA.length !== keysB.length) return false;

  for (var i = 0; i < keysA.length; i++) {
    if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

/***/ }),
/* 264 */
/***/ (function(module, exports) {

module.exports = function(originalModule) {
	if(!originalModule.webpackPolyfill) {
		var module = Object.create(originalModule);
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		Object.defineProperty(module, "exports", {
			enumerable: true,
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = wrapMapToPropsConstant;
/* unused harmony export getDependsOnOwnProps */
/* harmony export (immutable) */ __webpack_exports__["b"] = wrapMapToPropsFunc;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_verifyPlainObject__ = __webpack_require__(266);

function wrapMapToPropsConstant(getConstant) {
  return function initConstantSelector(dispatch, options) {
    var constant = getConstant(dispatch, options);

    function constantSelector() {
      return constant;
    }

    constantSelector.dependsOnOwnProps = false;
    return constantSelector;
  };
} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
// whether mapToProps needs to be invoked when props have changed.
//
// A length of one signals that mapToProps does not depend on props from the parent component.
// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
// therefore not reporting its length accurately..

function getDependsOnOwnProps(mapToProps) {
  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
// this function wraps mapToProps in a proxy function which does several things:
//
//  * Detects whether the mapToProps function being called depends on props, which
//    is used by selectorFactory to decide if it should reinvoke on props changes.
//
//  * On first call, handles mapToProps if returns another function, and treats that
//    new function as the true mapToProps for subsequent calls.
//
//  * On first call, verifies the first result is a plain object, in order to warn
//    the developer that their mapToProps function is not returning a valid result.
//

function wrapMapToPropsFunc(mapToProps, methodName) {
  return function initProxySelector(dispatch, _ref) {
    var displayName = _ref.displayName;

    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
    }; // allow detectFactoryAndVerify to get ownProps


    proxy.dependsOnOwnProps = true;

    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
      proxy.mapToProps = mapToProps;
      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
      var props = proxy(stateOrDispatch, ownProps);

      if (typeof props === 'function') {
        proxy.mapToProps = props;
        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
        props = proxy(stateOrDispatch, ownProps);
      }

      if (false) verifyPlainObject(props, displayName, methodName);
      return props;
    };

    return proxy;
  };
}

/***/ }),
/* 266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isPlainObject__ = __webpack_require__(588);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__warning__ = __webpack_require__(267);


function verifyPlainObject(value, displayName, methodName) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_0__isPlainObject__["a" /* default */])(value)) {
    Object(__WEBPACK_IMPORTED_MODULE_1__warning__["a" /* default */])(methodName + "() in " + displayName + " must return a plain object. Instead received " + value + ".");
  }
}

/***/ }),
/* 267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = warning;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */


  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */

}

/***/ }),
/* 268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createStoreHook;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return useStore; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Context__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__useReduxContext__ = __webpack_require__(269);



/**
 * Hook factory, which creates a `useStore` hook bound to a given context.
 *
 * @param {React.Context} [context=ReactReduxContext] Context passed to your `<Provider>`.
 * @returns {Function} A `useStore` hook bound to the specified context.
 */

function createStoreHook(context) {
  if (context === void 0) {
    context = __WEBPACK_IMPORTED_MODULE_1__components_Context__["a" /* ReactReduxContext */];
  }

  var useReduxContext = context === __WEBPACK_IMPORTED_MODULE_1__components_Context__["a" /* ReactReduxContext */] ? __WEBPACK_IMPORTED_MODULE_2__useReduxContext__["a" /* useReduxContext */] : function () {
    return Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(context);
  };
  return function useStore() {
    var _useReduxContext = useReduxContext(),
        store = _useReduxContext.store;

    return store;
  };
}
/**
 * A hook to access the redux store.
 *
 * @returns {any} the redux store
 *
 * @example
 *
 * import React from 'react'
 * import { useStore } from 'react-redux'
 *
 * export const ExampleComponent = () => {
 *   const store = useStore()
 *   return <div>{store.getState()}</div>
 * }
 */

var useStore =
/*#__PURE__*/
createStoreHook();

/***/ }),
/* 269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useReduxContext;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Context__ = __webpack_require__(66);


/**
 * A hook to access the value of the `ReactReduxContext`. This is a low-level
 * hook that you should usually not need to call directly.
 *
 * @returns {any} the value of the `ReactReduxContext`
 *
 * @example
 *
 * import React from 'react'
 * import { useReduxContext } from 'react-redux'
 *
 * export const CounterComponent = ({ value }) => {
 *   const { store } = useReduxContext()
 *   return <div>{store.getState()}</div>
 * }
 */

function useReduxContext() {
  var contextValue = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_1__components_Context__["a" /* ReactReduxContext */]);

  if (false) {
    throw new Error('could not find react-redux context value; please ensure the component is wrapped in a <Provider>');
  }

  return contextValue;
}

/***/ }),
/* 270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__persistReducer__ = __webpack_require__(176);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__persistReducer__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__persistCombineReducers__ = __webpack_require__(597);
/* unused harmony reexport persistCombineReducers */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__persistStore__ = __webpack_require__(599);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__persistStore__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__createMigrate__ = __webpack_require__(600);
/* unused harmony reexport createMigrate */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__createTransform__ = __webpack_require__(601);
/* unused harmony reexport createTransform */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__getStoredState__ = __webpack_require__(272);
/* unused harmony reexport getStoredState */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__createPersistoid__ = __webpack_require__(271);
/* unused harmony reexport createPersistoid */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__purgeStoredState__ = __webpack_require__(273);
/* unused harmony reexport purgeStoredState */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constants__ = __webpack_require__(67);
/* unused harmony namespace reexport */











/***/ }),
/* 271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createPersistoid;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(67);


// @TODO remove once flow < 0.63 support is no longer required.

function createPersistoid(config) {
  // defaults
  var blacklist = config.blacklist || null;
  var whitelist = config.whitelist || null;
  var transforms = config.transforms || [];
  var throttle = config.throttle || 0;
  var storageKey = '' + (config.keyPrefix !== undefined ? config.keyPrefix : __WEBPACK_IMPORTED_MODULE_0__constants__["c" /* KEY_PREFIX */]) + config.key;
  var storage = config.storage;
  var serialize = config.serialize === false ? function (x) {
    return x;
  } : defaultSerialize;

  // initialize stateful values
  var lastState = {};
  var stagedState = {};
  var keysToProcess = [];
  var timeIterator = null;
  var writePromise = null;

  var update = function update(state) {
    // add any changed keys to the queue
    Object.keys(state).forEach(function (key) {
      if (!passWhitelistBlacklist(key)) return; // is keyspace ignored? noop
      if (lastState[key] === state[key]) return; // value unchanged? noop
      if (keysToProcess.indexOf(key) !== -1) return; // is key already queued? noop
      keysToProcess.push(key); // add key to queue
    });

    //if any key is missing in the new state which was present in the lastState,
    //add it for processing too
    Object.keys(lastState).forEach(function (key) {
      if (state[key] === undefined) {
        keysToProcess.push(key);
      }
    });

    // start the time iterator if not running (read: throttle)
    if (timeIterator === null) {
      timeIterator = setInterval(processNextKey, throttle);
    }

    lastState = state;
  };

  function processNextKey() {
    if (keysToProcess.length === 0) {
      if (timeIterator) clearInterval(timeIterator);
      timeIterator = null;
      return;
    }

    var key = keysToProcess.shift();
    var endState = transforms.reduce(function (subState, transformer) {
      return transformer.in(subState, key, lastState);
    }, lastState[key]);

    if (endState !== undefined) {
      try {
        stagedState[key] = serialize(endState);
      } catch (err) {
        console.error('redux-persist/createPersistoid: error serializing state', err);
      }
    } else {
      //if the endState is undefined, no need to persist the existing serialized content
      delete stagedState[key];
    }

    if (keysToProcess.length === 0) {
      writeStagedState();
    }
  }

  function writeStagedState() {
    // cleanup any removed keys just before write.
    Object.keys(stagedState).forEach(function (key) {
      if (lastState[key] === undefined) {
        delete stagedState[key];
      }
    });

    writePromise = storage.setItem(storageKey, serialize(stagedState)).catch(onWriteFail);
  }

  function passWhitelistBlacklist(key) {
    if (whitelist && whitelist.indexOf(key) === -1 && key !== '_persist') return false;
    if (blacklist && blacklist.indexOf(key) !== -1) return false;
    return true;
  }

  function onWriteFail(err) {
    // @TODO add fail handlers (typically storage full)
    if (err && "production" !== 'production') {
      console.error('Error storing data', err);
    }
  }

  var flush = function flush() {
    while (keysToProcess.length !== 0) {
      processNextKey();
    }
    return writePromise || Promise.resolve();
  };

  // return `persistoid`
  return {
    update: update,
    flush: flush
  };
}

// @NOTE in the future this may be exposed via config
function defaultSerialize(data) {
  return JSON.stringify(data);
}

/***/ }),
/* 272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getStoredState;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(67);




function getStoredState(config) {
  var transforms = config.transforms || [];
  var storageKey = '' + (config.keyPrefix !== undefined ? config.keyPrefix : __WEBPACK_IMPORTED_MODULE_0__constants__["c" /* KEY_PREFIX */]) + config.key;
  var storage = config.storage;
  var debug = config.debug;
  var deserialize = config.serialize === false ? function (x) {
    return x;
  } : defaultDeserialize;
  return storage.getItem(storageKey).then(function (serialized) {
    if (!serialized) return undefined;else {
      try {
        var state = {};
        var rawState = deserialize(serialized);
        Object.keys(rawState).forEach(function (key) {
          state[key] = transforms.reduceRight(function (subState, transformer) {
            return transformer.out(subState, key, rawState);
          }, deserialize(rawState[key]));
        });
        return state;
      } catch (err) {
        if (false) console.log('redux-persist/getStoredState: Error restoring data ' + serialized, err);
        throw err;
      }
    }
  });
}

function defaultDeserialize(serial) {
  return JSON.parse(serial);
}

/***/ }),
/* 273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = purgeStoredState;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(67);




function purgeStoredState(config) {
  var storage = config.storage;
  var storageKey = '' + (config.keyPrefix !== undefined ? config.keyPrefix : __WEBPACK_IMPORTED_MODULE_0__constants__["c" /* KEY_PREFIX */]) + config.key;
  return storage.removeItem(storageKey, warnIfRemoveError);
}

function warnIfRemoveError(err) {
  if (err && "production" !== 'production') {
    console.error('redux-persist/purgeStoredState: Error purging data stored state', err);
  }
}

/***/ }),
/* 274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_thunk__ = __webpack_require__(603);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_persist_lib_storage__ = __webpack_require__(604);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_persist_lib_storage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_redux_persist_lib_storage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_persist__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_reducers_landingReducer__ = __webpack_require__(607);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_reducers_signUpReducer__ = __webpack_require__(608);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_reducers_passwordReducer__ = __webpack_require__(609);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_reducers_authenticationReducer__ = __webpack_require__(610);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_reducers_menuReducer__ = __webpack_require__(611);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_reducers_cartReducer__ = __webpack_require__(612);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_reducers_loadingReducer__ = __webpack_require__(613);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_reducers_checkoutReducer__ = __webpack_require__(614);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_reducers_businessReducer__ = __webpack_require__(615);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_reducers_settingsReducer__ = __webpack_require__(616);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_reducers_gdprReducer__ = __webpack_require__(617);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_reducers_teamVoucherReducer__ = __webpack_require__(618);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_reducers_linkVoucherReducer__ = __webpack_require__(619);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_reducers_deliveryTrackingReducer__ = __webpack_require__(620);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_reducers_taggedInputTextReducer__ = __webpack_require__(621);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_reducers_invoiceReducer__ = __webpack_require__(622);
var composeEnhancers=window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__||__WEBPACK_IMPORTED_MODULE_0_redux__["d" /* compose */];var signupPersistConfig={key:'signupPersist',storage:__WEBPACK_IMPORTED_MODULE_2_redux_persist_lib_storage___default.a,whitelist:['user']};var menuPersistConfig={key:'menuPersist',storage:__WEBPACK_IMPORTED_MODULE_2_redux_persist_lib_storage___default.a,whitelist:['listAddress','addresses','showCollectionOption','itemsSideBarMenu','restaurantsOptions']};var rootReducer=Object(__WEBPACK_IMPORTED_MODULE_0_redux__["c" /* combineReducers */])({landingReducer:__WEBPACK_IMPORTED_MODULE_4_reducers_landingReducer__["a" /* default */],signupReducer:Object(__WEBPACK_IMPORTED_MODULE_3_redux_persist__["a" /* persistReducer */])(signupPersistConfig,__WEBPACK_IMPORTED_MODULE_5_reducers_signUpReducer__["a" /* default */]),passwordReducer:__WEBPACK_IMPORTED_MODULE_6_reducers_passwordReducer__["a" /* default */],authenticationReducer:__WEBPACK_IMPORTED_MODULE_7_reducers_authenticationReducer__["a" /* default */],menuReducer:Object(__WEBPACK_IMPORTED_MODULE_3_redux_persist__["a" /* persistReducer */])(menuPersistConfig,__WEBPACK_IMPORTED_MODULE_8_reducers_menuReducer__["a" /* default */]),cartReducer:__WEBPACK_IMPORTED_MODULE_9_reducers_cartReducer__["a" /* default */],loadingReducer:__WEBPACK_IMPORTED_MODULE_10_reducers_loadingReducer__["a" /* default */],checkoutReducer:__WEBPACK_IMPORTED_MODULE_11_reducers_checkoutReducer__["a" /* default */],businessReducer:__WEBPACK_IMPORTED_MODULE_12_reducers_businessReducer__["a" /* default */],settingsReducer:__WEBPACK_IMPORTED_MODULE_13_reducers_settingsReducer__["a" /* default */],gdprReducer:__WEBPACK_IMPORTED_MODULE_14_reducers_gdprReducer__["a" /* default */],teamVoucherReducer:__WEBPACK_IMPORTED_MODULE_15_reducers_teamVoucherReducer__["a" /* default */],linkVoucherReducer:__WEBPACK_IMPORTED_MODULE_16_reducers_linkVoucherReducer__["a" /* default */],deliveryTrackingReducer:__WEBPACK_IMPORTED_MODULE_17_reducers_deliveryTrackingReducer__["a" /* default */],taggedInputTextReducer:__WEBPACK_IMPORTED_MODULE_18_reducers_taggedInputTextReducer__["a" /* default */],invoiceReducer:__WEBPACK_IMPORTED_MODULE_19_reducers_invoiceReducer__["a" /* default */]});/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux__["e" /* createStore */])(rootReducer,composeEnhancers(Object(__WEBPACK_IMPORTED_MODULE_0_redux__["a" /* applyMiddleware */])(__WEBPACK_IMPORTED_MODULE_1_redux_thunk__["a" /* default */]))));

/***/ }),
/* 275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_hoc_ReactAux_ReactAux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__img_logo_lunch_team_svg__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__img_logo_lunch_team_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__img_logo_lunch_team_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__GDPRModal_scss__ = __webpack_require__(631);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__GDPRModal_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__GDPRModal_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_modal__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_modal__);
var customStyles={content:{background:'none',border:'none'},overlay:{zIndex:'9999999',width:'100%',height:'100%',left:'0',top:'0',backgroundColor:'rgba(0, 0, 0, 0.7)'}};var GdprModal=function GdprModal(props){if(!props.show)return null;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_hoc_ReactAux_ReactAux__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_modal___default.a,{isOpen:props.show,style:customStyles,onRequestClose:props.clickButtonDeny,shouldCloseOnOverlayClick:true,contentLabel:'Example Modal'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:props.style,className:'gdpr-modal'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:props.closeModal,title:'Close (Esc)',type:'button',className:'mfp-close lb-fechar fa fa-times'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_2__img_logo_lunch_team_svg___default.a,alt:'Lunch Team'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,props.isTermsConditions?'Terms & Conditions':'Privacy Policy')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content gdpr-content-modal'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:props.isTermsConditions?'show':'none'},dangerouslySetInnerHTML:{__html:props.termsConditions}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:!props.isTermsConditions?'show':'none'},dangerouslySetInnerHTML:{__html:props.privacyPolicy}})))));};/* harmony default export */ __webpack_exports__["a"] = (GdprModal);

/***/ }),
/* 276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var host=window.location.host;var protocol='https';var serviceType={api:''};// Production builds keep the default. The staging build sets REACT_APP_API_HOST
// at compile time so that it never calls the production API.
var hostApi=Object({"NODE_ENV":"production","PUBLIC_URL":"","REACT_APP_SUPPORT_COMPOSER":"true","REACT_APP_SUPPORT_HOURS":"Mon-Fri 07:00-15:00","REACT_APP_ALLERGEN_GATE_RESTAURANTS":"8630"}).REACT_APP_API_HOST||'api.lunch.team';var currentHost=function currentHost(){return protocol+'://'+host;};var currentServerHost=function currentServerHost(){return protocol+'://'+hostApi;};function server(service){var path=arguments.length>1&&arguments[1]!==undefined?arguments[1]:'';return''+currentServerHost()+service+path;}/* harmony default export */ __webpack_exports__["a"] = ({api:function api(path){return server(serviceType.api,path);},currentHost:currentHost});

/***/ }),
/* 277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_utils_http__ = __webpack_require__(19);
var validationToken=function validationToken(token){return __WEBPACK_IMPORTED_MODULE_0_utils_http__["a" /* default */].post('/user/v1/sign-up/validation-token/'+token);};var changePassword=function changePassword(payload){return __WEBPACK_IMPORTED_MODULE_0_utils_http__["a" /* default */].post('/user/v1/sign-up/change-password',payload);};var requestEmailResetPassword=function requestEmailResetPassword(payload){return __WEBPACK_IMPORTED_MODULE_0_utils_http__["a" /* default */].post('/user/v1/login/request-reset-password',payload);};var resetPassword=function resetPassword(payload){return __WEBPACK_IMPORTED_MODULE_0_utils_http__["a" /* default */].post('/user/v1/login/reset-password',payload);};/* harmony default export */ __webpack_exports__["a"] = ({validationToken:validationToken,changePassword:changePassword,requestEmailResetPassword:requestEmailResetPassword,resetPassword:resetPassword});

/***/ }),
/* 278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = trim;
// GA strings need to have leading/trailing whitespace trimmed, and not all
// browsers have String.prototoype.trim().
function trim(s) {
  return s.replace(/^\s+|\s+$/g, '');
}

/***/ }),
/* 279 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return resolvePaymentFailure; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_services_orderService__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_utils_checkoutError__ = __webpack_require__(118);
var outcomeForStatus=function outcomeForStatus(status){if(status&&status.orderStatus==='F'){return __WEBPACK_IMPORTED_MODULE_1_utils_checkoutError__["a" /* CHECKOUT_OUTCOME */].PAYMENT_FAILED;}if(status&&status.orderStatus==='T'){return __WEBPACK_IMPORTED_MODULE_1_utils_checkoutError__["a" /* CHECKOUT_OUTCOME */].CONFIRMED;}return __WEBPACK_IMPORTED_MODULE_1_utils_checkoutError__["a" /* CHECKOUT_OUTCOME */].CHECKING;};// A failed payment response does not establish the final order outcome. Read
// the existing order once; never create another order or retry the payment here.
// Resolves to the customer-facing checkout error and never rejects.
var resolvePaymentFailure=function resolvePaymentFailure(payload,error){var orderNumber=payload.publicOrderNumber;var original=Object(__WEBPACK_IMPORTED_MODULE_1_utils_checkoutError__["b" /* mapCheckoutError */])(error,{orderNumber:orderNumber});// The status read would fail the same way, so report the expired session.
if(original.code==='AUTHENTICATION_REQUIRED'){return Promise.resolve(Object(__WEBPACK_IMPORTED_MODULE_1_utils_checkoutError__["b" /* mapCheckoutError */])(error,{orderNumber:orderNumber,paymentSessionExpired:true}));}return __WEBPACK_IMPORTED_MODULE_0_services_orderService__["a" /* default */].getOrderStatus(payload.idOrder).catch(function(){return undefined;}).then(function(status){return Object(__WEBPACK_IMPORTED_MODULE_1_utils_checkoutError__["b" /* mapCheckoutError */])({supportReference:original.supportReference},{outcome:outcomeForStatus(status),orderNumber:orderNumber});});};

/***/ }),
/* 281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return normalizeVoucherDiscounts; });
var normalizeVoucherDiscounts=function normalizeVoucherDiscounts(discounts){return Array.isArray(discounts)?discounts:[];};

/***/ }),
/* 282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_utils_http__ = __webpack_require__(19);
var fetchingMenu=function fetchingMenu(idBusiness,idAddress){return __WEBPACK_IMPORTED_MODULE_0_utils_http__["a" /* default */].get('/menu/v1/menu/business/'+idBusiness+'/address/'+idAddress);};var getListAddressToDelivery=function getListAddressToDelivery(payload){return __WEBPACK_IMPORTED_MODULE_0_utils_http__["a" /* default */].post('/user/v1/business/addresses-to-delivery',payload);};// const getRecentlyOrdered = () => http.get('/order/v1/order/lastorders/')
var getRecentlyOrdered=function getRecentlyOrdered(idAddress){return __WEBPACK_IMPORTED_MODULE_0_utils_http__["a" /* default */].get('/order/v1/order/lastorders/address/'+idAddress);};var getProducts=function getProducts(idRestaurant,idCategory){var idProduct=arguments.length>2&&arguments[2]!==undefined?arguments[2]:0;return __WEBPACK_IMPORTED_MODULE_0_utils_http__["a" /* default */].get('/menu/v1/product/'+idProduct+'/categoryType/'+idCategory+'/restaurant/'+idRestaurant);};var getCategoryFromProduct=function getCategoryFromProduct(product,idRestaurant){return __WEBPACK_IMPORTED_MODULE_0_utils_http__["a" /* default */].get('/menu/v1/product/'+product.id+'/categoryType/'+product.idCategoryType+'/restaurant/'+idRestaurant);};var verifyRestaurantAvailable=function verifyRestaurantAvailable(idRestaurant,idBusiness){return __WEBPACK_IMPORTED_MODULE_0_utils_http__["a" /* default */].get('/menu/v1/restaurant/available/business/'+idBusiness+'/restaurant/'+idRestaurant);};var logout=function logout(){return __WEBPACK_IMPORTED_MODULE_0_utils_http__["a" /* default */].get('/user/v1/logout');};/* harmony default export */ __webpack_exports__["a"] = ({fetchingMenu:fetchingMenu,getListAddressToDelivery:getListAddressToDelivery,getRecentlyOrdered:getRecentlyOrdered,getProducts:getProducts,getCategoryFromProduct:getCategoryFromProduct,logout:logout,verifyRestaurantAvailable:verifyRestaurantAvailable});

/***/ }),
/* 283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_utils_viewport__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__hoc_ReactAux_ReactAux__ = __webpack_require__(4);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();function Categories(props){var itemsSidebar=Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["useSelector"])(function(state){return state.menuReducer.itemsSideBarMenu;});var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(__WEBPACK_IMPORTED_MODULE_2_utils_viewport__["a" /* isNarrowMenuViewport */]),_useState2=_slicedToArray(_useState,2),isMobile=_useState2[0],setIsMobile=_useState2[1];Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){var syncViewport=function syncViewport(){return setIsMobile(Object(__WEBPACK_IMPORTED_MODULE_2_utils_viewport__["a" /* isNarrowMenuViewport */])());};window.addEventListener('resize',syncViewport);syncViewport();return function(){return window.removeEventListener('resize',syncViewport);};},[]);var isOption=itemsSidebar[2].active===true;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:props.showCategoriesMobile?'vr menu-open':'vr','aria-label':'Categories'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('aside',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'menu-nav',tabIndex:2,id:'categories-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__hoc_ReactAux_ReactAux__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:props.showRestaurantsMobile?'desktop_hide menu-open':'desktop_hide',onClick:function onClick(){return props.toggleRestaurants();},'aria-expanded':props.showRestaurantsMobile?'true':'false',role:'button','aria-label':isOption?'Show options':'Show restaurants'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,isOption?'Options':'Restaurants',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'d-arrow'}))),isMobile?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:props.showCategoriesMobile?'menu-open':null,onClick:function onClick(){return props.toggleCategoriesNavClass();},'aria-expanded':props.showCategoriesMobile?'true':'false'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Categories',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'d-arrow'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,props.categoriesType.map(function(item){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:item.id,onClick:function onClick(){props.selectCategory(item.id);window.document.getElementById('orders-items').focus();},className:item.active?'active':null,role:'button'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,item.name));}))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:props.showCategoriesMobile?'menu-open':null,onClick:function onClick(){return props.toggleCategoriesNavClass();},'aria-expanded':props.showCategoriesMobile?'true':'false'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Categories',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'d-arrow'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,props.categoriesType.map(function(item){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:item.id,onClick:function onClick(){props.selectCategory(item.id);window.document.getElementById('orders-items').focus();},className:item.active?'active':null,role:'button'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,item.name));}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:props.checkout?'desktop_hide menu-open':'desktop_hide',onClick:function onClick(){return props.toggleCart();},'aria-expanded':props.checkout?'true':'false',role:'button'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Cart',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'d-arrow'})))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cart-menu-category-overlay'}));}/* harmony default export */ __webpack_exports__["a"] = (Categories);

/***/ }),
/* 284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export product */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_utils_currency__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__hoc_ReactAux_ReactAux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ProductDetails_NutritionFacts__ = __webpack_require__(182);
var product=function product(props){var currency='€';if(!!props.business){currency=__WEBPACK_IMPORTED_MODULE_1_utils_currency__["a" /* default */].convertNameToSymbol(props.business.currency);}return props.business!=null&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__hoc_ReactAux_ReactAux__["a" /* default */],{key:props.product.id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{onClick:function onClick(){return props.selectProduct(props.product.id);},className:props.business.isOpen?'modal-a popup-with-zoom-anim':'modal-a popup-with-zoom-anim menu-inactive',disabled:!!!props.business.isOpen,id:'orders-items',role:'button','aria-label':'Selecionar '+props.product.name+' por '+(currency+props.product.price.toFixed(2))},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('article',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{style:{width:'85%',fontSize:'14px'}},props.product.name,props.isPopularDish?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'restaurant-name-home block fr'},' ','BY ',props.business.name,' '):null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,currency+props.product.price.toFixed(2))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__ProductDetails_NutritionFacts__["a" /* default */],{product:props.product}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'product-description'},props.product.description))));};/* harmony default export */ __webpack_exports__["a"] = (product);

/***/ }),
/* 285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoc_ReactAux_ReactAux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_modal__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_UI_Modal_ModalError__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_utils_currency__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store_actions__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__PickOutOptions__ = __webpack_require__(676);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ProductDetails_NutritionFacts__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ProductDetails_css__ = __webpack_require__(677);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ProductDetails_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__ProductDetails_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_utils_userError__ = __webpack_require__(15);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var initialState={total:0,errorMessage:'',showModal:false,mealOptions:[]};var customStyles={overlay:{zIndex:'9999999',width:'100%',maxHeight:document.documentElement.clientHeight<900?'100%':'540px',left:'0',top:'0',backgroundColor:'rgba(0, 0, 0, 0.7)'}};var ProductDetails=function(_Component){_inherits(ProductDetails,_Component);function ProductDetails(props){_classCallCheck(this,ProductDetails);var _this=_possibleConstructorReturn(this,(ProductDetails.__proto__||Object.getPrototypeOf(ProductDetails)).call(this,props));_this.handleSelectMealOptions=function(evt,idCategoryType,idMealOption){var category=_this.props.productSelected.mealOptions.find(function(x){return x.idCategoryType===idCategoryType;});var mealOption=category.mealOptionItens.find(function(x){return x.id===idMealOption;});if(evt.target.checked){var mealOptionsUpdated=[].concat(_toConsumableArray(_this.state.mealOptions));var list=mealOptionsUpdated.filter(function(item){return item.idCategoryType===idCategoryType;});if(!!!category.itemMaxQuantity||list.length<category.itemMaxQuantity){mealOptionsUpdated.push({idCategoryType:idCategoryType,idMealOption:idMealOption,price:mealOption.price});_this.setState({mealOptions:mealOptionsUpdated});var totalProduct=_this.state.total+mealOption.price;_this.setState({total:totalProduct});}else{var max=category.itemMaxQuantity;_this.setState({showModal:true,errorMessage:Object(__WEBPACK_IMPORTED_MODULE_10_utils_userError__["e" /* knownError */])(__WEBPACK_IMPORTED_MODULE_10_utils_userError__["a" /* ERROR_CODES */].MENU_OPTIONS_MAX,{title:'You can choose up to '+max+' here',message:'This section allows '+max+' '+(max===1?'choice':'choices')+'.',guidance:'Untick one to choose a different option.'})});}}else{var _totalProduct=_this.state.total-mealOption.price;_this.setState({total:_totalProduct});var index=_this.state.mealOptions.findIndex(function(x){return x.idCategoryType===idCategoryType&&x.idMealOption===idMealOption;});var _mealOptionsUpdated=[].concat(_toConsumableArray(_this.state.mealOptions.slice(0,index)),_toConsumableArray(_this.state.mealOptions.slice(index+1)));_this.setState({mealOptions:_mealOptionsUpdated});}};_this.handleClickAddProduct=function(){var AllMandatoryChecked=_this.props.productSelected.mealOptions.every(function(mealOption){var exist=true;if(mealOption.flagRequired==='Y'){exist=_this.state.mealOptions.some(function(mealOptionSelected){return mealOptionSelected.idCategoryType===mealOption.idCategoryType;});}return exist;});if(AllMandatoryChecked){var productSelected={id:_this.props.productSelected.id,name:_this.props.productSelected.name,description:_this.props.productSelected.description,price:_this.state.total,mealOptions:_this.state.mealOptions};_this.props.onAddProductToCart({product:productSelected,business:_this.props.restaurantSelected});_this.setState(initialState);_this.props.onCloseProductDetails();}else{_this.setState({showModal:true,errorMessage:Object(__WEBPACK_IMPORTED_MODULE_10_utils_userError__["e" /* knownError */])(__WEBPACK_IMPORTED_MODULE_10_utils_userError__["a" /* ERROR_CODES */].MENU_OPTIONS_REQUIRED,{title:'Choose the required options',message:'Some sections of this dish need a choice before it can go in your basket.',guidance:'Make a choice in each required section, then add the dish.'})});}};_this.handleCloseModal=function(){_this.setState({showModal:false});};_this.handleCloseProductDetails=function(){_this.setState(initialState);_this.props.onCloseProductDetails();};_this.state=initialState;return _this;}_createClass(ProductDetails,[{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){if(this.props.productSelected!==prevProps.productSelected&&this.props.productSelected){this.setState({total:this.props.productSelected.price});}}},{key:'render',value:function render(){return this.props.productSelected!==null?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_hoc_ReactAux_ReactAux__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_modal___default.a,{isOpen:true,className:'content-react-modal',style:customStyles,onRequestClose:this.handleCloseProductDetails,shouldCloseOnOverlayClick:true,shouldCloseOnEsc:true,contentLabel:'Example Modal'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_UI_Modal_ModalError__["a" /* default */],{showModal:this.state.showModal,errorMessage:this.state.errorMessage,closeModal:this.handleCloseModal,style:{zIndex:'99999999',position:'absolute',margin:'1% 25%'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{height:'inherit'},className:'lb-padrao-singup6 mfp-content-login modal-content product-details-content',tabIndex:0},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:this.handleCloseProductDetails,title:'Close (Esc)',type:'button',className:'mfp-close lb-fechar fa fa-times'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('article',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',{tabIndex:0},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,this.props.productSelected.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'By',' ',this.props.restaurantSelected?this.props.restaurantSelected.name:this.props.productSelected.businessName)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__ProductDetails_NutritionFacts__["a" /* default */],{product:this.props.productSelected}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,this.props.productSelected.description)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__PickOutOptions__["a" /* default */],{productSelected:this.props.productSelected,selectMealOptions:this.handleSelectMealOptions,mealOptionsSelected:this.state.mealOptions}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:this.handleClickAddProduct,className:'orange-bold btn-product-details'},'+ Add for',' ',__WEBPACK_IMPORTED_MODULE_5_utils_currency__["a" /* default */].convertNameToSymbol(this.props.restaurantSelected.currency)+this.state.total.toFixed(2))))):null;}}]);return ProductDetails;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{productSelected:state.menuReducer.productSelected,restaurantSelected:state.menuReducer.restaurantSelected};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onCloseProductDetails:function onCloseProductDetails(){return dispatch(__WEBPACK_IMPORTED_MODULE_6__store_actions__["B" /* closeProductDetails */]());},onAddProductToCart:function onAddProductToCart(product){return dispatch(__WEBPACK_IMPORTED_MODULE_6__store_actions__["a" /* addProductToCart */](product));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(ProductDetails));

/***/ }),
/* 286 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEMAAABDCAMAAADwFEhBAAAApVBMVEUAAAD///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////+4/eNVAAAANnRSTlMA+wRfzDLyb1sJ5L1zwPZU2MMeeJVEBui5tpnen0sgEQ7Jjms/7dtQNyois8d+0oiHZRgHkKrbkk6YAAAC3ElEQVRYw61Ya3uqMAwOMOUiTNCpcOb9ftvZ3Bz//6edp6mejLYReNj7rTZ9TdM3aQOw8NfhONpurNzabKNxOPChJnr9znNehJX0e9UJvpzIyk2wIuerEoMfjnIeo7DCnroB2adX19sNdp57TYk36JYwHNO729nqUJg5rLL7BtPjIwqnLa1ew0/Q8em+yum2wzLYL9IkdmzOwomlyQtjMU/ln4Q4z7GE0tV0bpqdLXAy6ZVJJ0G7xczgxRmn3m0og/0uSTRPhh08DQ+qwMMT6gyVnzGczwOohsEzBlZRFnpBFKUk6ElBbVMMtgfV4eERToGAwfiAOvjAkCikiV2Lw04KrvuBiOcU6mEq4hrcszgUjH2oi75YFt6kIdyI/x92XpVxGAtH5DpHLHKAOMhHFurCSCS7TRyIS5WwilIQYQ4Jubg002q1Tnm+eTIjmQDBFcLs3UJjFZOwlfNoA2FmYeikvjIoIuM5/v60O0md+eKYVwrHmufY/bRbCWH50vwAChKOIikWavHTGgU2AhUTjmNftBuhzMa4JQ1PZopvQ+DGEFExUQqKDj2plqiQGNWhY2viWNI8KSSGAPWq42Kg2MxMcg+grdY0oExU4Rq33Mb0QP3qbqrYDs3np/vBC75rDr3FxgO+VYoxk/4b7lxQv6c/hOuO2/CW0wcs8jxmqrSqD06nE0ovBqRTyhftD9r7lgrMTS1fmLyFN7Z46Hmr1g+6PTkOvX5QHVOwP1sMh1rHqJ7WBdVTqusaWt6eGWt1ne4X/VHT8fkx3S90XRmL4Rs3VhcOBZ2qySVVYGVMbsj7lk4o75v0cWLGdO+vCu+PnkEfE21M6Mn3R6EAJ7aqj9h7MLYTJYxpg/dY03fh8Tffp83fyc3f64T5okHf0KB/4fso92Ef5VIf1bifK+8r3Tp9Jd/fXo7FmQvT35b02dny1mcvs0Dpsxv2+82/OzT7/nHmvn9U/w4zZy3/AS5lAv6QxZ50AAAAAElFTkSuQmCC"

/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(679);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(17)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../lunch-team-client-checkout-msg/node_modules/css-loader/index.js!../../../../../../../lunch-team-client-checkout-msg/node_modules/sass-loader/dist/cjs.js!./modalReceiptTest.scss", function() {
			var newContent = require("!!../../../../../../../lunch-team-client-checkout-msg/node_modules/css-loader/index.js!../../../../../../../lunch-team-client-checkout-msg/node_modules/sass-loader/dist/cjs.js!./modalReceiptTest.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export recentlyOrdered */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__RecentlyOrdered_css__ = __webpack_require__(680);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__RecentlyOrdered_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__RecentlyOrdered_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__hoc_ReactAux_ReactAux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_utils_currency__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Products_ProductDetails_NutritionFacts__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config_guestOrdering__ = __webpack_require__(68);
var recentlyOrdered=function recentlyOrdered(props){var classes='';if(props.fastReOrderMenu&&props.checkout){classes='list-items recently-ordered cart-open fastreorder';}else if(props.fastReOrderMenu&&!props.checkout){classes='list-items recently-ordered recently-ordered';//classes = 'list-items-recently-ordered recently-ordered'
}else if(!props.fastReOrderMenu&&props.checkout){classes='list-items recently-ordered cart-open';}else{classes='list-items recently-ordered';}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:classes},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:'header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'th-date'},'DATE'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'th-restaurant'},'RESTAURANT'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'th-order'},'ORDER'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'th-total'},'TOTAL'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,props.recentlyOrdered.map(function(item,x){return props.restaurantsOptions[0].active===true&&item.restaurant.forCollection==='N'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__hoc_ReactAux_ReactAux__["a" /* default */],{key:x},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:'item'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'date'},new Date(item.dateReg).toLocaleDateString('en-GB').toString()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'restaurant-name'},item.restaurant.name,Object(__WEBPACK_IMPORTED_MODULE_5__config_guestOrdering__["m" /* guestLabel */])(item)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__hoc_ReactAux_ReactAux__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),Object(__WEBPACK_IMPORTED_MODULE_5__config_guestOrdering__["m" /* guestLabel */])(item))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'items-order'},item.orderItems.map(function(item,y){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__hoc_ReactAux_ReactAux__["a" /* default */],{key:y},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('article',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,item.product.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Products_ProductDetails_NutritionFacts__["a" /* default */],{product:item.product})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,item.product.description?item.product.description:''))));})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'price'},__WEBPACK_IMPORTED_MODULE_3_utils_currency__["a" /* default */].convertNameToSymbol(item.restaurant.currency)+item.totalAmount.toFixed(2)),item.canOrder&&item.forCollection==='N'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'repeat'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{onClick:function onClick(){return props.addRepeatOrderProduct(item);}},'Repeat')))):props.restaurantsOptions[1].active===true&&item.restaurant.forCollection==='Y'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__hoc_ReactAux_ReactAux__["a" /* default */],{key:item.id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:'item'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'date'},new Date(item.dateReg).toLocaleDateString('en-GB').toString()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'restaurant-name'},item.restaurant.name,Object(__WEBPACK_IMPORTED_MODULE_5__config_guestOrdering__["m" /* guestLabel */])(item)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__hoc_ReactAux_ReactAux__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),Object(__WEBPACK_IMPORTED_MODULE_5__config_guestOrdering__["m" /* guestLabel */])(item))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'items-order'},item.orderItems.map(function(item){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__hoc_ReactAux_ReactAux__["a" /* default */],{key:item.product.id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('article',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,item.product.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Products_ProductDetails_NutritionFacts__["a" /* default */],{product:item.product})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,item.product.description?item.product.description:''))));})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'price'},__WEBPACK_IMPORTED_MODULE_3_utils_currency__["a" /* default */].convertNameToSymbol(item.restaurant.currency)+item.totalAmount.toFixed(2)),item.canOrder?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'repeat'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{onClick:function onClick(){return props.addRepeatOrderProduct(item);}},'Repeat')):null)):null;}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'notice-reorder'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Plase Note:'),' Repeat order shows prices applied in the past. New prices may apply'));};/* harmony default export */ __webpack_exports__["a"] = (recentlyOrdered);

/***/ }),
/* 289 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ReactAux_ReactAux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_UI_Modal_ModalError__ = __webpack_require__(21);
var withErrorHandling=function withErrorHandling(WrappedComponent){return function(_ref){var children=_ref.children,handlingError=_ref.handlingError,closedErrorModal=_ref.closedErrorModal;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__ReactAux_ReactAux__["a" /* default */],null,handlingError.showError&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_UI_Modal_ModalError__["a" /* default */],{showModal:handlingError.showError,closeModal:closedErrorModal,errorMessage:handlingError.errorMessage}),children);};};var ErrorHandling=withErrorHandling(function(_ref2){var children=_ref2.children;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,children);});/* harmony default export */ __webpack_exports__["a"] = (ErrorHandling);

/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(188);
var IE8_DOM_DEFINE = __webpack_require__(691);
var toPrimitive = __webpack_require__(692);
var dP = Object.defineProperty;

exports.f = __webpack_require__(80) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(189);
var document = __webpack_require__(122).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 292 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(696);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 294 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 295 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(700)('keys');
var uid = __webpack_require__(702);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 297 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 298 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(294);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIs = __webpack_require__(88);

var _createChainableTypeChecker = __webpack_require__(714);

var _createChainableTypeChecker2 = _interopRequireDefault(_createChainableTypeChecker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function elementType(props, propName, componentName, location, propFullName) {
  var propValue = props[propName];

  if (_react2.default.isValidElement(propValue)) {
    return new Error('Invalid ' + location + ' `' + propFullName + '` of type ReactElement ' + ('supplied to `' + componentName + '`,expected an element type (a string ') + ', component class, or function component).');
  }

  if (!(0, _reactIs.isValidElementType)(propValue)) {
    return new Error('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected an element type (a string ') + ', component class, or function component).');
  }

  return null;
}

exports.default = (0, _createChainableTypeChecker2.default)(elementType);
module.exports = exports['default'];

/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.Style = exports.State = exports.DEVICE_SIZES = exports.SIZE_MAP = exports.Size = void 0;
var Size = {
  LARGE: 'large',
  SMALL: 'small',
  XSMALL: 'xsmall'
};
exports.Size = Size;
var SIZE_MAP = {
  large: 'lg',
  medium: 'md',
  small: 'sm',
  xsmall: 'xs',
  lg: 'lg',
  md: 'md',
  sm: 'sm',
  xs: 'xs'
};
exports.SIZE_MAP = SIZE_MAP;
var DEVICE_SIZES = ['lg', 'md', 'sm', 'xs'];
exports.DEVICE_SIZES = DEVICE_SIZES;
var State = {
  SUCCESS: 'success',
  WARNING: 'warning',
  DANGER: 'danger',
  INFO: 'info'
};
exports.State = State;
var Style = {
  DEFAULT: 'default',
  PRIMARY: 'primary',
  LINK: 'link',
  INVERSE: 'inverse'
};
exports.Style = Style;

/***/ }),
/* 302 */
/***/ (function(module, exports) {

function _extends() {
  module.exports = _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

module.exports = _extends;

/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var slice = Array.prototype.slice;
var isArgs = __webpack_require__(304);

var origKeys = Object.keys;
var keysShim = origKeys ? function keys(o) { return origKeys(o); } : __webpack_require__(730);

var originalKeys = Object.keys;

keysShim.shim = function shimObjectKeys() {
	if (Object.keys) {
		var keysWorksWithArguments = (function () {
			// Safari 5.0 bug
			var args = Object.keys(arguments);
			return args && args.length === arguments.length;
		}(1, 2));
		if (!keysWorksWithArguments) {
			Object.keys = function keys(object) { // eslint-disable-line func-name-matching
				if (isArgs(object)) {
					return originalKeys(slice.call(object));
				}
				return originalKeys(object);
			};
		}
	} else {
		Object.keys = keysShim;
	}
	return Object.keys || keysShim;
};

module.exports = keysShim;


/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var toStr = Object.prototype.toString;

module.exports = function isArguments(value) {
	var str = toStr.call(value);
	var isArgs = str === '[object Arguments]';
	if (!isArgs) {
		isArgs = str !== '[object Array]' &&
			value !== null &&
			typeof value === 'object' &&
			typeof value.length === 'number' &&
			value.length >= 0 &&
			toStr.call(value.callee) === '[object Function]';
	}
	return isArgs;
};


/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $Object = Object;
var $TypeError = TypeError;

module.exports = function flags() {
	if (this != null && this !== $Object(this)) {
		throw new $TypeError('RegExp.prototype.flags getter called on non-object');
	}
	var result = '';
	if (this.global) {
		result += 'g';
	}
	if (this.ignoreCase) {
		result += 'i';
	}
	if (this.multiline) {
		result += 'm';
	}
	if (this.dotAll) {
		result += 's';
	}
	if (this.unicode) {
		result += 'u';
	}
	if (this.sticky) {
		result += 'y';
	}
	return result;
};


/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var implementation = __webpack_require__(305);

var supportsDescriptors = __webpack_require__(194).supportsDescriptors;
var $gOPD = Object.getOwnPropertyDescriptor;
var $TypeError = TypeError;

module.exports = function getPolyfill() {
	if (!supportsDescriptors) {
		throw new $TypeError('RegExp.prototype.flags requires a true ES5 environment that supports property descriptors');
	}
	if ((/a/mig).flags === 'gim') {
		var descriptor = $gOPD(RegExp.prototype, 'flags');
		if (descriptor && typeof descriptor.get === 'function' && typeof (/a/).dotAll === 'boolean') {
			return descriptor.get;
		}
	}
	return implementation;
};


/***/ }),
/* 307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return unwrapArray; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return safeInvoke; });
/* unused harmony export shallowEqual */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return setRef; });
/**
 * Takes an argument and if it's an array, returns the first item in the array,
 * otherwise returns the argument. Used for Preact compatibility.
 */
var unwrapArray = function unwrapArray(arg) {
  return Array.isArray(arg) ? arg[0] : arg;
};
/**
 * Takes a maybe-undefined function and arbitrary args and invokes the function
 * only if it is defined.
 */

var safeInvoke = function safeInvoke(fn) {
  if (typeof fn === "function") {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return fn.apply(void 0, args);
  }
};
/**
 * Does a shallow equality check of two objects by comparing the reference
 * equality of each value.
 */

var shallowEqual = function shallowEqual(objA, objB) {
  var aKeys = Object.keys(objA);
  var bKeys = Object.keys(objB);

  if (bKeys.length !== aKeys.length) {
    return false;
  }

  for (var i = 0; i < bKeys.length; i++) {
    var key = aKeys[i];

    if (objA[key] !== objB[key]) {
      return false;
    }
  }

  return true;
};
/**
 * Sets a ref using either a ref callback or a ref object
 */

var setRef = function setRef(ref, node) {
  // if its a function call it
  if (typeof ref === "function") {
    return safeInvoke(ref, node);
  } // otherwise we should treat it as a ref object
  else if (ref != null) {
      ref.current = node;
    }
};

/***/ }),
/* 308 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 309 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_assets_images_logo_lunch_team_svg__ = __webpack_require__(330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_assets_images_logo_lunch_team_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_assets_images_logo_lunch_team_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__index_css__ = __webpack_require__(759);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__index_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  height: 100%;\n  width: 100%;\n  z-index: 1000;\n  background-color: rgba(0, 0, 0, .65);\n'],['\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  height: 100%;\n  width: 100%;\n  z-index: 1000;\n  background-color: rgba(0, 0, 0, .65);\n']),_templateObject2=_taggedTemplateLiteral(['\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 10000;\n  overflow: auto;\n  text-align: center;\n  overflow-scrolling: touch;\n  padding: 4px;\n  cursor: pointer;\n\n  &:after {\n    vertical-align: middle;\n    display: inline-block;\n    height: 100%;\n    margin-left: -.05em;\n    content: \'\';\n  }\n'],['\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 10000;\n  overflow: auto;\n  text-align: center;\n  overflow-scrolling: touch;\n  padding: 4px;\n  cursor: pointer;\n\n  &:after {\n    vertical-align: middle;\n    display: inline-block;\n    height: 100%;\n    margin-left: -.05em;\n    content: \'\';\n  }\n']),_templateObject3=_taggedTemplateLiteral(['\n  position: relative;\n  outline: 0;\n  width: 100%;\n  background: white;\n  display: inline-block;\n  vertical-align: middle;\n  box-sizing: border-box;\n  max-width: 480px;\n  cursor: default;\n  -moz-border-radius: var(--lt-radius-overlay);\n  -webkit-border-radius: var(--lt-radius-overlay);\n  border-radius: var(--lt-radius-overlay);\n'],['\n  position: relative;\n  outline: 0;\n  width: 100%;\n  background: white;\n  display: inline-block;\n  vertical-align: middle;\n  box-sizing: border-box;\n  max-width: 480px;\n  cursor: default;\n  -moz-border-radius: var(--lt-radius-overlay);\n  -webkit-border-radius: var(--lt-radius-overlay);\n  border-radius: var(--lt-radius-overlay);\n']),_templateObject4=_taggedTemplateLiteral(['\n  padding: 16px 8px 8px 8px\n'],['\n  padding: 16px 8px 8px 8px\n']),_templateObject5=_taggedTemplateLiteral(['\n  padding-bottom: 16px\n'],['\n  padding-bottom: 16px\n']);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Overlay=__WEBPACK_IMPORTED_MODULE_1_styled_components__["a" /* default */].div(_templateObject);var Content=__WEBPACK_IMPORTED_MODULE_1_styled_components__["a" /* default */].div(_templateObject2);var Dialog=__WEBPACK_IMPORTED_MODULE_1_styled_components__["a" /* default */].div(_templateObject3);var Header=__WEBPACK_IMPORTED_MODULE_1_styled_components__["a" /* default */].div(_templateObject4);var Body=__WEBPACK_IMPORTED_MODULE_1_styled_components__["a" /* default */].div(_templateObject5);var ModalConfirm=function(_Component){_inherits(ModalConfirm,_Component);function ModalConfirm(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ModalConfirm);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ModalConfirm.__proto__||Object.getPrototypeOf(ModalConfirm)).call.apply(_ref,[this].concat(args))),_this),_this.onOverlayClick=function(){if(_this.props.onClose){_this.props.onClose();}},_this.onDialogClick=function(event){event.stopPropagation();},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ModalConfirm,[{key:'listenKeyboard',value:function listenKeyboard(event){if(event.key==='Escape'||event.keyCode===27){this.props.onClose();}}},{key:'componentDidMount',value:function componentDidMount(){if(this.props.onClose){window.addEventListener('keydown',this.listenKeyboard.bind(this),true);}}},{key:'componentWillUnmount',value:function componentWillUnmount(){if(this.props.onClose){window.removeEventListener('keydown',this.listenKeyboard.bind(this),true);}}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Overlay,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Content,{onClick:this.onOverlayClick},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Dialog,{onClick:this.onDialogClick},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Header,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{style:{cursor:'auto'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_2_assets_images_logo_lunch_team_svg___default.a,alt:'Lunch Team'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Body,null,this.props.children),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'confirm-no-yes'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{onClick:this.props.onClose,className:'btn-cancel'},'No'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{onClick:this.props.onConfirm,className:'btn-confirm'},'Yes')))));}}]);return ModalConfirm;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (ModalConfirm);

/***/ }),
/* 310 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__img_logo_lunch_team_svg__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__img_logo_lunch_team_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__img_logo_lunch_team_svg__);
var logo=function logo(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'menu-logo'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{onClick:function onClick(){return props.goToMenu(1);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_1__img_logo_lunch_team_svg___default.a,alt:'Lunch Team Logo'})));};/* harmony default export */ __webpack_exports__["a"] = (logo);

/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/header.868a1fac.jpg";

/***/ }),
/* 312 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _toConsumableArray;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayWithoutHoles__ = __webpack_require__(808);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__iterableToArray__ = __webpack_require__(809);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__nonIterableSpread__ = __webpack_require__(810);



function _toConsumableArray(arr) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__arrayWithoutHoles__["a" /* default */])(arr) || Object(__WEBPACK_IMPORTED_MODULE_1__iterableToArray__["a" /* default */])(arr) || Object(__WEBPACK_IMPORTED_MODULE_2__nonIterableSpread__["a" /* default */])();
}

/***/ }),
/* 313 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) {
        return false;
    }
    for (var i = 0; i < newInputs.length; i++) {
        if (newInputs[i] !== lastInputs[i]) {
            return false;
        }
    }
    return true;
}

function memoizeOne(resultFn, isEqual) {
    if (isEqual === void 0) { isEqual = areInputsEqual; }
    var lastThis;
    var lastArgs = [];
    var lastResult;
    var calledOnce = false;
    function memoized() {
        var newArgs = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            newArgs[_i] = arguments[_i];
        }
        if (calledOnce && lastThis === this && isEqual(newArgs, lastArgs)) {
            return lastResult;
        }
        lastResult = resultFn.apply(this, newArgs);
        calledOnce = true;
        lastThis = this;
        lastArgs = newArgs;
        return lastResult;
    }
    return memoized;
}

/* harmony default export */ __webpack_exports__["a"] = (memoizeOne);


/***/ }),
/* 314 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__emotion_sheet__ = __webpack_require__(315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__emotion_stylis__ = __webpack_require__(812);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__emotion_weak_memoize__ = __webpack_require__(813);




// https://github.com/thysultan/stylis.js/tree/master/plugins/rule-sheet
// inlined to avoid umd wrapper and peerDep warnings/installing stylis
// since we use stylis after closure compiler
var delimiter = '/*|*/';
var needle = delimiter + '}';

function toSheet(block) {
  if (block) {
    Sheet.current.insert(block + '}');
  }
}

var Sheet = {
  current: null
};
var ruleSheet = function ruleSheet(context, content, selectors, parents, line, column, length, ns, depth, at) {
  switch (context) {
    // property
    case 1:
      {
        switch (content.charCodeAt(0)) {
          case 64:
            {
              // @import
              Sheet.current.insert(content + ';');
              return '';
            }
          // charcode for l

          case 108:
            {
              // charcode for b
              // this ignores label
              if (content.charCodeAt(2) === 98) {
                return '';
              }
            }
        }

        break;
      }
    // selector

    case 2:
      {
        if (ns === 0) return content + delimiter;
        break;
      }
    // at-rule

    case 3:
      {
        switch (ns) {
          // @font-face, @page
          case 102:
          case 112:
            {
              Sheet.current.insert(selectors[0] + content);
              return '';
            }

          default:
            {
              return content + (at === 0 ? delimiter : '');
            }
        }
      }

    case -2:
      {
        content.split(needle).forEach(toSheet);
      }
  }
};

var createCache = function createCache(options) {
  if (options === undefined) options = {};
  var key = options.key || 'css';
  var stylisOptions;

  if (options.prefix !== undefined) {
    stylisOptions = {
      prefix: options.prefix
    };
  }

  var stylis = new __WEBPACK_IMPORTED_MODULE_1__emotion_stylis__["a" /* default */](stylisOptions);

  if (false) {
    // $FlowFixMe
    if (/[^a-z-]/.test(key)) {
      throw new Error("Emotion key must only contain lower case alphabetical characters and - but \"" + key + "\" was passed");
    }
  }

  var inserted = {}; // $FlowFixMe

  var container;

  {
    container = options.container || document.head;
    var nodes = document.querySelectorAll("style[data-emotion-" + key + "]");
    Array.prototype.forEach.call(nodes, function (node) {
      var attrib = node.getAttribute("data-emotion-" + key); // $FlowFixMe

      attrib.split(' ').forEach(function (id) {
        inserted[id] = true;
      });

      if (node.parentNode !== container) {
        container.appendChild(node);
      }
    });
  }

  var _insert;

  {
    stylis.use(options.stylisPlugins)(ruleSheet);

    _insert = function insert(selector, serialized, sheet, shouldCache) {
      var name = serialized.name;
      Sheet.current = sheet;

      if (false) {
        var map = serialized.map;
        Sheet.current = {
          insert: function insert(rule) {
            sheet.insert(rule + map);
          }
        };
      }

      stylis(selector, serialized.styles);

      if (shouldCache) {
        cache.inserted[name] = true;
      }
    };
  }

  if (false) {
    // https://esbench.com/bench/5bf7371a4cd7e6009ef61d0a
    var commentStart = /\/\*/g;
    var commentEnd = /\*\//g;
    stylis.use(function (context, content) {
      switch (context) {
        case -1:
          {
            while (commentStart.test(content)) {
              commentEnd.lastIndex = commentStart.lastIndex;

              if (commentEnd.test(content)) {
                commentStart.lastIndex = commentEnd.lastIndex;
                continue;
              }

              throw new Error('Your styles have an unterminated comment ("/*" without corresponding "*/").');
            }

            commentStart.lastIndex = 0;
            break;
          }
      }
    });
    stylis.use(function (context, content, selectors) {
      switch (context) {
        case -1:
          {
            var flag = 'emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason';
            var unsafePseudoClasses = content.match(/(:first|:nth|:nth-last)-child/g);

            if (unsafePseudoClasses && cache.compat !== true) {
              unsafePseudoClasses.forEach(function (unsafePseudoClass) {
                var ignoreRegExp = new RegExp(unsafePseudoClass + ".*\\/\\* " + flag + " \\*\\/");
                var ignore = ignoreRegExp.test(content);

                if (unsafePseudoClass && !ignore) {
                  console.error("The pseudo class \"" + unsafePseudoClass + "\" is potentially unsafe when doing server-side rendering. Try changing it to \"" + unsafePseudoClass.split('-child')[0] + "-of-type\".");
                }
              });
            }

            break;
          }
      }
    });
  }

  var cache = {
    key: key,
    sheet: new __WEBPACK_IMPORTED_MODULE_0__emotion_sheet__["a" /* StyleSheet */]({
      key: key,
      container: container,
      nonce: options.nonce,
      speedy: options.speedy
    }),
    nonce: options.nonce,
    inserted: inserted,
    registered: {},
    insert: _insert
  };
  return cache;
};

/* harmony default export */ __webpack_exports__["a"] = (createCache);


/***/ }),
/* 315 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StyleSheet; });
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/
// $FlowFixMe
function sheetForTag(tag) {
  if (tag.sheet) {
    // $FlowFixMe
    return tag.sheet;
  } // this weirdness brought to you by firefox

  /* istanbul ignore next */


  for (var i = 0; i < document.styleSheets.length; i++) {
    if (document.styleSheets[i].ownerNode === tag) {
      // $FlowFixMe
      return document.styleSheets[i];
    }
  }
}

function createStyleElement(options) {
  var tag = document.createElement('style');
  tag.setAttribute('data-emotion', options.key);

  if (options.nonce !== undefined) {
    tag.setAttribute('nonce', options.nonce);
  }

  tag.appendChild(document.createTextNode(''));
  return tag;
}

var StyleSheet =
/*#__PURE__*/
function () {
  function StyleSheet(options) {
    this.isSpeedy = options.speedy === undefined ? "production" === 'production' : options.speedy;
    this.tags = [];
    this.ctr = 0;
    this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets

    this.key = options.key;
    this.container = options.container;
    this.before = null;
  }

  var _proto = StyleSheet.prototype;

  _proto.insert = function insert(rule) {
    // the max length is how many rules we have per style tag, it's 65000 in speedy mode
    // it's 1 in dev because we insert source maps that map a single rule to a location
    // and you can only have one source map per style tag
    if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) {
      var _tag = createStyleElement(this);

      var before;

      if (this.tags.length === 0) {
        before = this.before;
      } else {
        before = this.tags[this.tags.length - 1].nextSibling;
      }

      this.container.insertBefore(_tag, before);
      this.tags.push(_tag);
    }

    var tag = this.tags[this.tags.length - 1];

    if (this.isSpeedy) {
      var sheet = sheetForTag(tag);

      try {
        // this is a really hot path
        // we check the second character first because having "i"
        // as the second character will happen less often than
        // having "@" as the first character
        var isImportRule = rule.charCodeAt(1) === 105 && rule.charCodeAt(0) === 64; // this is the ultrafast version, works across browsers
        // the big drawback is that the css won't be editable in devtools

        sheet.insertRule(rule, // we need to insert @import rules before anything else
        // otherwise there will be an error
        // technically this means that the @import rules will
        // _usually_(not always since there could be multiple style tags)
        // be the first ones in prod and generally later in dev
        // this shouldn't really matter in the real world though
        // @import is generally only used for font faces from google fonts and etc.
        // so while this could be technically correct then it would be slower and larger
        // for a tiny bit of correctness that won't matter in the real world
        isImportRule ? 0 : sheet.cssRules.length);
      } catch (e) {
        if (false) {
          console.warn("There was a problem inserting the following rule: \"" + rule + "\"", e);
        }
      }
    } else {
      tag.appendChild(document.createTextNode(rule));
    }

    this.ctr++;
  };

  _proto.flush = function flush() {
    // $FlowFixMe
    this.tags.forEach(function (tag) {
      return tag.parentNode.removeChild(tag);
    });
    this.tags = [];
    this.ctr = 0;
  };

  return StyleSheet;
}();




/***/ }),
/* 316 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return serializeStyles; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__emotion_hash__ = __webpack_require__(815);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__emotion_unitless__ = __webpack_require__(816);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__emotion_memoize__ = __webpack_require__(817);




var ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
var hyphenateRegex = /[A-Z]|^ms/g;
var animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;

var isCustomProperty = function isCustomProperty(property) {
  return property.charCodeAt(1) === 45;
};

var isProcessableValue = function isProcessableValue(value) {
  return value != null && typeof value !== 'boolean';
};

var processStyleName = Object(__WEBPACK_IMPORTED_MODULE_2__emotion_memoize__["a" /* default */])(function (styleName) {
  return isCustomProperty(styleName) ? styleName : styleName.replace(hyphenateRegex, '-$&').toLowerCase();
});

var processStyleValue = function processStyleValue(key, value) {
  switch (key) {
    case 'animation':
    case 'animationName':
      {
        if (typeof value === 'string') {
          return value.replace(animationRegex, function (match, p1, p2) {
            cursor = {
              name: p1,
              styles: p2,
              next: cursor
            };
            return p1;
          });
        }
      }
  }

  if (__WEBPACK_IMPORTED_MODULE_1__emotion_unitless__["a" /* default */][key] !== 1 && !isCustomProperty(key) && typeof value === 'number' && value !== 0) {
    return value + 'px';
  }

  return value;
};

if (false) {
  var contentValuePattern = /(attr|calc|counters?|url)\(/;
  var contentValues = ['normal', 'none', 'counter', 'open-quote', 'close-quote', 'no-open-quote', 'no-close-quote', 'initial', 'inherit', 'unset'];
  var oldProcessStyleValue = processStyleValue;
  var msPattern = /^-ms-/;
  var hyphenPattern = /-(.)/g;
  var hyphenatedCache = {};

  processStyleValue = function processStyleValue(key, value) {
    if (key === 'content') {
      if (typeof value !== 'string' || contentValues.indexOf(value) === -1 && !contentValuePattern.test(value) && (value.charAt(0) !== value.charAt(value.length - 1) || value.charAt(0) !== '"' && value.charAt(0) !== "'")) {
        console.error("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"" + value + "\"'`");
      }
    }

    var processed = oldProcessStyleValue(key, value);

    if (processed !== '' && !isCustomProperty(key) && key.indexOf('-') !== -1 && hyphenatedCache[key] === undefined) {
      hyphenatedCache[key] = true;
      console.error("Using kebab-case for css properties in objects is not supported. Did you mean " + key.replace(msPattern, 'ms-').replace(hyphenPattern, function (str, _char) {
        return _char.toUpperCase();
      }) + "?");
    }

    return processed;
  };
}

var shouldWarnAboutInterpolatingClassNameFromCss = true;

function handleInterpolation(mergedProps, registered, interpolation, couldBeSelectorInterpolation) {
  if (interpolation == null) {
    return '';
  }

  if (interpolation.__emotion_styles !== undefined) {
    if (false) {
      throw new Error('Component selectors can only be used in conjunction with babel-plugin-emotion.');
    }

    return interpolation;
  }

  switch (typeof interpolation) {
    case 'boolean':
      {
        return '';
      }

    case 'object':
      {
        if (interpolation.anim === 1) {
          cursor = {
            name: interpolation.name,
            styles: interpolation.styles,
            next: cursor
          };
          return interpolation.name;
        }

        if (interpolation.styles !== undefined) {
          var next = interpolation.next;

          if (next !== undefined) {
            // not the most efficient thing ever but this is a pretty rare case
            // and there will be very few iterations of this generally
            while (next !== undefined) {
              cursor = {
                name: next.name,
                styles: next.styles,
                next: cursor
              };
              next = next.next;
            }
          }

          var styles = interpolation.styles + ";";

          if (false) {
            styles += interpolation.map;
          }

          return styles;
        }

        return createStringFromObject(mergedProps, registered, interpolation);
      }

    case 'function':
      {
        if (mergedProps !== undefined) {
          var previousCursor = cursor;
          var result = interpolation(mergedProps);
          cursor = previousCursor;
          return handleInterpolation(mergedProps, registered, result, couldBeSelectorInterpolation);
        } else if (false) {
          console.error('Functions that are interpolated in css calls will be stringified.\n' + 'If you want to have a css call based on props, create a function that returns a css call like this\n' + 'let dynamicStyle = (props) => css`color: ${props.color}`\n' + 'It can be called directly with props or interpolated in a styled call like this\n' + "let SomeComponent = styled('div')`${dynamicStyle}`");
        }

        break;
      }

    case 'string':
      if (false) {
        var matched = [];
        var replaced = interpolation.replace(animationRegex, function (match, p1, p2) {
          var fakeVarName = "animation" + matched.length;
          matched.push("const " + fakeVarName + " = keyframes`" + p2.replace(/^@keyframes animation-\w+/, '') + "`");
          return "${" + fakeVarName + "}";
        });

        if (matched.length) {
          console.error('`keyframes` output got interpolated into plain string, please wrap it with `css`.\n\n' + 'Instead of doing this:\n\n' + [].concat(matched, ["`" + replaced + "`"]).join('\n') + '\n\nYou should wrap it with `css` like this:\n\n' + ("css`" + replaced + "`"));
        }
      }

      break;
  } // finalize string values (regular strings and functions interpolated into css calls)


  if (registered == null) {
    return interpolation;
  }

  var cached = registered[interpolation];

  if (false) {
    console.error('Interpolating a className from css`` is not recommended and will cause problems with composition.\n' + 'Interpolating a className from css`` will be completely unsupported in a future major version of Emotion');
    shouldWarnAboutInterpolatingClassNameFromCss = false;
  }

  return cached !== undefined && !couldBeSelectorInterpolation ? cached : interpolation;
}

function createStringFromObject(mergedProps, registered, obj) {
  var string = '';

  if (Array.isArray(obj)) {
    for (var i = 0; i < obj.length; i++) {
      string += handleInterpolation(mergedProps, registered, obj[i], false);
    }
  } else {
    for (var _key in obj) {
      var value = obj[_key];

      if (typeof value !== 'object') {
        if (registered != null && registered[value] !== undefined) {
          string += _key + "{" + registered[value] + "}";
        } else if (isProcessableValue(value)) {
          string += processStyleName(_key) + ":" + processStyleValue(_key, value) + ";";
        }
      } else {
        if (_key === 'NO_COMPONENT_SELECTOR' && "production" !== 'production') {
          throw new Error('Component selectors can only be used in conjunction with babel-plugin-emotion.');
        }

        if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
          for (var _i = 0; _i < value.length; _i++) {
            if (isProcessableValue(value[_i])) {
              string += processStyleName(_key) + ":" + processStyleValue(_key, value[_i]) + ";";
            }
          }
        } else {
          var interpolated = handleInterpolation(mergedProps, registered, value, false);

          switch (_key) {
            case 'animation':
            case 'animationName':
              {
                string += processStyleName(_key) + ":" + interpolated + ";";
                break;
              }

            default:
              {
                if (false) {
                  console.error(UNDEFINED_AS_OBJECT_KEY_ERROR);
                }

                string += _key + "{" + interpolated + "}";
              }
          }
        }
      }
    }
  }

  return string;
}

var labelPattern = /label:\s*([^\s;\n{]+)\s*;/g;
var sourceMapPattern;

if (false) {
  sourceMapPattern = /\/\*#\ssourceMappingURL=data:application\/json;\S+\s+\*\//;
} // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list


var cursor;
var serializeStyles = function serializeStyles(args, registered, mergedProps) {
  if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) {
    return args[0];
  }

  var stringMode = true;
  var styles = '';
  cursor = undefined;
  var strings = args[0];

  if (strings == null || strings.raw === undefined) {
    stringMode = false;
    styles += handleInterpolation(mergedProps, registered, strings, false);
  } else {
    if (false) {
      console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR);
    }

    styles += strings[0];
  } // we start at 1 since we've already handled the first arg


  for (var i = 1; i < args.length; i++) {
    styles += handleInterpolation(mergedProps, registered, args[i], styles.charCodeAt(styles.length - 1) === 46);

    if (stringMode) {
      if (false) {
        console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR);
      }

      styles += strings[i];
    }
  }

  var sourceMap;

  if (false) {
    styles = styles.replace(sourceMapPattern, function (match) {
      sourceMap = match;
      return '';
    });
  } // using a global regex with .exec is stateful so lastIndex has to be reset each time


  labelPattern.lastIndex = 0;
  var identifierName = '';
  var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5

  while ((match = labelPattern.exec(styles)) !== null) {
    identifierName += '-' + // $FlowFixMe we know it's not null
    match[1];
  }

  var name = Object(__WEBPACK_IMPORTED_MODULE_0__emotion_hash__["a" /* default */])(styles) + identifierName;

  if (false) {
    // $FlowFixMe SerializedStyles type doesn't have toString property (and we don't want to add it)
    return {
      name: name,
      styles: styles,
      map: sourceMap,
      next: cursor,
      toString: function toString() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
      }
    };
  }

  return {
    name: name,
    styles: styles,
    next: cursor
  };
};




/***/ }),
/* 317 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MenuPlacer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return containerCSS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return css; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return clearIndicatorCSS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return dropdownIndicatorCSS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return groupHeadingCSS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return indicatorSeparatorCSS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return groupCSS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return inputCSS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return indicatorsContainerCSS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return loadingMessageCSS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return menuListCSS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return loadingIndicatorCSS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return menuCSS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return menuPortalCSS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return multiValueCSS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return multiValueLabelCSS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return multiValueRemoveCSS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return noOptionsMessageCSS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return optionCSS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return placeholderCSS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return css$1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return valueContainerCSS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return defaultComponents; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return exportedEqual; });
/* unused harmony export y */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectSpread__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_createClass__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_possibleConstructorReturn__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_getPrototypeOf__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_inherits__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__emotion_core__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_dom__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__babel_runtime_helpers_esm_typeof__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__chunk_39d3fda8_browser_esm_js__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__emotion_css__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__babel_runtime_helpers_esm_taggedTemplateLiteral__ = __webpack_require__(318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react_input_autosize__ = __webpack_require__(319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react_input_autosize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_react_input_autosize__);




















function getMenuPlacement(_ref) {
  var maxHeight = _ref.maxHeight,
      menuEl = _ref.menuEl,
      minHeight = _ref.minHeight,
      placement = _ref.placement,
      shouldScroll = _ref.shouldScroll,
      isFixedPosition = _ref.isFixedPosition,
      theme = _ref.theme;
  var spacing = theme.spacing;
  var scrollParent = Object(__WEBPACK_IMPORTED_MODULE_15__chunk_39d3fda8_browser_esm_js__["a"])(menuEl);
  var defaultState = {
    placement: 'bottom',
    maxHeight: maxHeight
  }; // something went wrong, return default state

  if (!menuEl || !menuEl.offsetParent) return defaultState; // we can't trust `scrollParent.scrollHeight` --> it may increase when
  // the menu is rendered

  var _scrollParent$getBoun = scrollParent.getBoundingClientRect(),
      scrollHeight = _scrollParent$getBoun.height;

  var _menuEl$getBoundingCl = menuEl.getBoundingClientRect(),
      menuBottom = _menuEl$getBoundingCl.bottom,
      menuHeight = _menuEl$getBoundingCl.height,
      menuTop = _menuEl$getBoundingCl.top;

  var _menuEl$offsetParent$ = menuEl.offsetParent.getBoundingClientRect(),
      containerTop = _menuEl$offsetParent$.top;

  var viewHeight = window.innerHeight;
  var scrollTop = Object(__WEBPACK_IMPORTED_MODULE_15__chunk_39d3fda8_browser_esm_js__["b"])(scrollParent);
  var marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
  var marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
  var viewSpaceAbove = containerTop - marginTop;
  var viewSpaceBelow = viewHeight - menuTop;
  var scrollSpaceAbove = viewSpaceAbove + scrollTop;
  var scrollSpaceBelow = scrollHeight - scrollTop - menuTop;
  var scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
  var scrollUp = scrollTop + menuTop - marginTop;
  var scrollDuration = 160;

  switch (placement) {
    case 'auto':
    case 'bottom':
      // 1: the menu will fit, do nothing
      if (viewSpaceBelow >= menuHeight) {
        return {
          placement: 'bottom',
          maxHeight: maxHeight
        };
      } // 2: the menu will fit, if scrolled


      if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
        if (shouldScroll) {
          Object(__WEBPACK_IMPORTED_MODULE_15__chunk_39d3fda8_browser_esm_js__["c"])(scrollParent, scrollDown, scrollDuration);
        }

        return {
          placement: 'bottom',
          maxHeight: maxHeight
        };
      } // 3: the menu will fit, if constrained


      if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
        if (shouldScroll) {
          Object(__WEBPACK_IMPORTED_MODULE_15__chunk_39d3fda8_browser_esm_js__["c"])(scrollParent, scrollDown, scrollDuration);
        } // we want to provide as much of the menu as possible to the user,
        // so give them whatever is available below rather than the minHeight.


        var constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;
        return {
          placement: 'bottom',
          maxHeight: constrainedHeight
        };
      } // 4. Forked beviour when there isn't enough space below
      // AUTO: flip the menu, render above


      if (placement === 'auto' || isFixedPosition) {
        // may need to be constrained after flipping
        var _constrainedHeight = maxHeight;
        var spaceAbove = isFixedPosition ? viewSpaceAbove : scrollSpaceAbove;

        if (spaceAbove >= minHeight) {
          _constrainedHeight = Math.min(spaceAbove - marginBottom - spacing.controlHeight, maxHeight);
        }

        return {
          placement: 'top',
          maxHeight: _constrainedHeight
        };
      } // BOTTOM: allow browser to increase scrollable area and immediately set scroll


      if (placement === 'bottom') {
        Object(__WEBPACK_IMPORTED_MODULE_15__chunk_39d3fda8_browser_esm_js__["l" /* s */])(scrollParent, scrollDown);
        return {
          placement: 'bottom',
          maxHeight: maxHeight
        };
      }

      break;

    case 'top':
      // 1: the menu will fit, do nothing
      if (viewSpaceAbove >= menuHeight) {
        return {
          placement: 'top',
          maxHeight: maxHeight
        };
      } // 2: the menu will fit, if scrolled


      if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
        if (shouldScroll) {
          Object(__WEBPACK_IMPORTED_MODULE_15__chunk_39d3fda8_browser_esm_js__["c"])(scrollParent, scrollUp, scrollDuration);
        }

        return {
          placement: 'top',
          maxHeight: maxHeight
        };
      } // 3: the menu will fit, if constrained


      if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
        var _constrainedHeight2 = maxHeight; // we want to provide as much of the menu as possible to the user,
        // so give them whatever is available below rather than the minHeight.

        if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
          _constrainedHeight2 = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
        }

        if (shouldScroll) {
          Object(__WEBPACK_IMPORTED_MODULE_15__chunk_39d3fda8_browser_esm_js__["c"])(scrollParent, scrollUp, scrollDuration);
        }

        return {
          placement: 'top',
          maxHeight: _constrainedHeight2
        };
      } // 4. not enough space, the browser WILL NOT increase scrollable area when
      // absolutely positioned element rendered above the viewport (only below).
      // Flip the menu, render below


      return {
        placement: 'bottom',
        maxHeight: maxHeight
      };

    default:
      throw new Error("Invalid placement provided \"".concat(placement, "\"."));
  } // fulfil contract with flow: implicit return value of undefined


  return defaultState;
} // Menu Component
// ------------------------------

function alignToControl(placement) {
  var placementToCSSProp = {
    bottom: 'top',
    top: 'bottom'
  };
  return placement ? placementToCSSProp[placement] : 'bottom';
}

var coercePlacement = function coercePlacement(p) {
  return p === 'auto' ? 'bottom' : p;
};

var menuCSS = function menuCSS(_ref2) {
  var _ref3;

  var placement = _ref2.placement,
      _ref2$theme = _ref2.theme,
      borderRadius = _ref2$theme.borderRadius,
      spacing = _ref2$theme.spacing,
      colors = _ref2$theme.colors;
  return _ref3 = {
    label: 'menu'
  }, Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_ref3, alignToControl(placement), '100%'), Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_ref3, "backgroundColor", colors.neutral0), Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_ref3, "borderRadius", borderRadius), Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_ref3, "boxShadow", '0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)'), Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_ref3, "marginBottom", spacing.menuGutter), Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_ref3, "marginTop", spacing.menuGutter), Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_ref3, "position", 'absolute'), Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_ref3, "width", '100%'), Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_ref3, "zIndex", 1), _ref3;
}; // NOTE: internal only

var MenuPlacer =
/*#__PURE__*/
function (_Component) {
  Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_inherits__["a" /* default */])(MenuPlacer, _Component);

  function MenuPlacer() {
    var _getPrototypeOf2;

    var _this;

    Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, MenuPlacer);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_possibleConstructorReturn__["a" /* default */])(this, (_getPrototypeOf2 = Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_getPrototypeOf__["a" /* default */])(MenuPlacer)).call.apply(_getPrototypeOf2, [this].concat(args)));

    Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "state", {
      maxHeight: _this.props.maxMenuHeight,
      placement: null
    });

    Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "getPlacement", function (ref) {
      var _this$props = _this.props,
          minMenuHeight = _this$props.minMenuHeight,
          maxMenuHeight = _this$props.maxMenuHeight,
          menuPlacement = _this$props.menuPlacement,
          menuPosition = _this$props.menuPosition,
          menuShouldScrollIntoView = _this$props.menuShouldScrollIntoView,
          theme = _this$props.theme;
      var getPortalPlacement = _this.context.getPortalPlacement;
      if (!ref) return; // DO NOT scroll if position is fixed

      var isFixedPosition = menuPosition === 'fixed';
      var shouldScroll = menuShouldScrollIntoView && !isFixedPosition;
      var state = getMenuPlacement({
        maxHeight: maxMenuHeight,
        menuEl: ref,
        minHeight: minMenuHeight,
        placement: menuPlacement,
        shouldScroll: shouldScroll,
        isFixedPosition: isFixedPosition,
        theme: theme
      });
      if (getPortalPlacement) getPortalPlacement(state);

      _this.setState(state);
    });

    Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "getUpdatedProps", function () {
      var menuPlacement = _this.props.menuPlacement;
      var placement = _this.state.placement || coercePlacement(menuPlacement);
      return Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectSpread__["a" /* default */])({}, _this.props, {
        placement: placement,
        maxHeight: _this.state.maxHeight
      });
    });

    return _this;
  }

  Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_createClass__["a" /* default */])(MenuPlacer, [{
    key: "render",
    value: function render() {
      var children = this.props.children;
      return children({
        ref: this.getPlacement,
        placerProps: this.getUpdatedProps()
      });
    }
  }]);

  return MenuPlacer;
}(__WEBPACK_IMPORTED_MODULE_10_react__["Component"]);

Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(MenuPlacer, "contextTypes", {
  getPortalPlacement: __WEBPACK_IMPORTED_MODULE_13_prop_types___default.a.func
});

var Menu = function Menu(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerRef = props.innerRef,
      innerProps = props.innerProps;
  return Object(__WEBPACK_IMPORTED_MODULE_11__emotion_core__["c" /* jsx */])("div", Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
    css: getStyles('menu', props),
    className: cx({
      menu: true
    }, className)
  }, innerProps, {
    ref: innerRef
  }), children);
};
// Menu List
// ==============================

var menuListCSS = function menuListCSS(_ref4) {
  var maxHeight = _ref4.maxHeight,
      baseUnit = _ref4.theme.spacing.baseUnit;
  return {
    maxHeight: maxHeight,
    overflowY: 'auto',
    paddingBottom: baseUnit,
    paddingTop: baseUnit,
    position: 'relative',
    // required for offset[Height, Top] > keyboard scroll
    WebkitOverflowScrolling: 'touch'
  };
};
var MenuList = function MenuList(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      isMulti = props.isMulti,
      innerRef = props.innerRef;
  return Object(__WEBPACK_IMPORTED_MODULE_11__emotion_core__["c" /* jsx */])("div", {
    css: getStyles('menuList', props),
    className: cx({
      'menu-list': true,
      'menu-list--is-multi': isMulti
    }, className),
    ref: innerRef
  }, children);
}; // ==============================
// Menu Notices
// ==============================

var noticeCSS = function noticeCSS(_ref5) {
  var _ref5$theme = _ref5.theme,
      baseUnit = _ref5$theme.spacing.baseUnit,
      colors = _ref5$theme.colors;
  return {
    color: colors.neutral40,
    padding: "".concat(baseUnit * 2, "px ").concat(baseUnit * 3, "px"),
    textAlign: 'center'
  };
};

var noOptionsMessageCSS = noticeCSS;
var loadingMessageCSS = noticeCSS;
var NoOptionsMessage = function NoOptionsMessage(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps;
  return Object(__WEBPACK_IMPORTED_MODULE_11__emotion_core__["c" /* jsx */])("div", Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
    css: getStyles('noOptionsMessage', props),
    className: cx({
      'menu-notice': true,
      'menu-notice--no-options': true
    }, className)
  }, innerProps), children);
};
NoOptionsMessage.defaultProps = {
  children: 'No options'
};
var LoadingMessage = function LoadingMessage(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps;
  return Object(__WEBPACK_IMPORTED_MODULE_11__emotion_core__["c" /* jsx */])("div", Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
    css: getStyles('loadingMessage', props),
    className: cx({
      'menu-notice': true,
      'menu-notice--loading': true
    }, className)
  }, innerProps), children);
};
LoadingMessage.defaultProps = {
  children: 'Loading...'
}; // ==============================
// Menu Portal
// ==============================

var menuPortalCSS = function menuPortalCSS(_ref6) {
  var rect = _ref6.rect,
      offset = _ref6.offset,
      position = _ref6.position;
  return {
    left: rect.left,
    position: position,
    top: offset,
    width: rect.width,
    zIndex: 1
  };
};
var MenuPortal =
/*#__PURE__*/
function (_Component2) {
  Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_inherits__["a" /* default */])(MenuPortal, _Component2);

  function MenuPortal() {
    var _getPrototypeOf3;

    var _this2;

    Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, MenuPortal);

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    _this2 = Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_possibleConstructorReturn__["a" /* default */])(this, (_getPrototypeOf3 = Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_getPrototypeOf__["a" /* default */])(MenuPortal)).call.apply(_getPrototypeOf3, [this].concat(args)));

    Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this2)), "state", {
      placement: null
    });

    Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this2)), "getPortalPlacement", function (_ref7) {
      var placement = _ref7.placement;
      var initialPlacement = coercePlacement(_this2.props.menuPlacement); // avoid re-renders if the placement has not changed

      if (placement !== initialPlacement) {
        _this2.setState({
          placement: placement
        });
      }
    });

    return _this2;
  }

  Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_createClass__["a" /* default */])(MenuPortal, [{
    key: "getChildContext",
    value: function getChildContext() {
      return {
        getPortalPlacement: this.getPortalPlacement
      };
    } // callback for occassions where the menu must "flip"

  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          appendTo = _this$props2.appendTo,
          children = _this$props2.children,
          controlElement = _this$props2.controlElement,
          menuPlacement = _this$props2.menuPlacement,
          position = _this$props2.menuPosition,
          getStyles = _this$props2.getStyles;
      var isFixed = position === 'fixed'; // bail early if required elements aren't present

      if (!appendTo && !isFixed || !controlElement) {
        return null;
      }

      var placement = this.state.placement || coercePlacement(menuPlacement);
      var rect = Object(__WEBPACK_IMPORTED_MODULE_15__chunk_39d3fda8_browser_esm_js__["g"])(controlElement);
      var scrollDistance = isFixed ? 0 : window.pageYOffset;
      var offset = rect[placement] + scrollDistance;
      var state = {
        offset: offset,
        position: position,
        rect: rect
      }; // same wrapper element whether fixed or portalled

      var menuWrapper = Object(__WEBPACK_IMPORTED_MODULE_11__emotion_core__["c" /* jsx */])("div", {
        css: getStyles('menuPortal', state)
      }, children);
      return appendTo ? Object(__WEBPACK_IMPORTED_MODULE_12_react_dom__["createPortal"])(menuWrapper, appendTo) : menuWrapper;
    }
  }]);

  return MenuPortal;
}(__WEBPACK_IMPORTED_MODULE_10_react__["Component"]);

Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(MenuPortal, "childContextTypes", {
  getPortalPlacement: __WEBPACK_IMPORTED_MODULE_13_prop_types___default.a.func
});

var isArray = Array.isArray;
var keyList = Object.keys;
var hasProp = Object.prototype.hasOwnProperty;

function equal(a, b) {
  // fast-deep-equal index.js 2.0.1
  if (a === b) return true;

  if (a && b && Object(__WEBPACK_IMPORTED_MODULE_14__babel_runtime_helpers_esm_typeof__["a" /* default */])(a) == 'object' && Object(__WEBPACK_IMPORTED_MODULE_14__babel_runtime_helpers_esm_typeof__["a" /* default */])(b) == 'object') {
    var arrA = isArray(a),
        arrB = isArray(b),
        i,
        length,
        key;

    if (arrA && arrB) {
      length = a.length;
      if (length != b.length) return false;

      for (i = length; i-- !== 0;) {
        if (!equal(a[i], b[i])) return false;
      }

      return true;
    }

    if (arrA != arrB) return false;
    var dateA = a instanceof Date,
        dateB = b instanceof Date;
    if (dateA != dateB) return false;
    if (dateA && dateB) return a.getTime() == b.getTime();
    var regexpA = a instanceof RegExp,
        regexpB = b instanceof RegExp;
    if (regexpA != regexpB) return false;
    if (regexpA && regexpB) return a.toString() == b.toString();
    var keys = keyList(a);
    length = keys.length;

    if (length !== keyList(b).length) {
      return false;
    }

    for (i = length; i-- !== 0;) {
      if (!hasProp.call(b, keys[i])) return false;
    } // end fast-deep-equal
    // Custom handling for React


    for (i = length; i-- !== 0;) {
      key = keys[i];

      if (key === '_owner' && a.$$typeof) {
        // React-specific: avoid traversing React elements' _owner.
        //  _owner contains circular references
        // and is not needed when comparing the actual elements (and not their owners)
        // .$$typeof and ._store on just reasonable markers of a react element
        continue;
      } else {
        // all other properties should be traversed as usual
        if (!equal(a[key], b[key])) return false;
      }
    } // fast-deep-equal index.js 2.0.1


    return true;
  }

  return a !== a && b !== b;
} // end fast-deep-equal


function exportedEqual(a, b) {
  try {
    return equal(a, b);
  } catch (error) {
    if (error.message && error.message.match(/stack|recursion/i)) {
      // warn on circular references, don't crash
      // browsers give this different errors name and messages:
      // chrome/safari: "RangeError", "Maximum call stack size exceeded"
      // firefox: "InternalError", too much recursion"
      // edge: "Error", "Out of stack space"
      console.warn('Warning: react-fast-compare does not handle circular references.', error.name, error.message);
      return false;
    } // some other error. we should definitely know about these


    throw error;
  }
}

var containerCSS = function containerCSS(_ref) {
  var isDisabled = _ref.isDisabled,
      isRtl = _ref.isRtl;
  return {
    label: 'container',
    direction: isRtl ? 'rtl' : null,
    pointerEvents: isDisabled ? 'none' : null,
    // cancel mouse events when disabled
    position: 'relative'
  };
};
var SelectContainer = function SelectContainer(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps,
      isDisabled = props.isDisabled,
      isRtl = props.isRtl;
  return Object(__WEBPACK_IMPORTED_MODULE_11__emotion_core__["c" /* jsx */])("div", Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
    css: getStyles('container', props),
    className: cx({
      '--is-disabled': isDisabled,
      '--is-rtl': isRtl
    }, className)
  }, innerProps), children);
}; // ==============================
// Value Container
// ==============================

var valueContainerCSS = function valueContainerCSS(_ref2) {
  var spacing = _ref2.theme.spacing;
  return {
    alignItems: 'center',
    display: 'flex',
    flex: 1,
    flexWrap: 'wrap',
    padding: "".concat(spacing.baseUnit / 2, "px ").concat(spacing.baseUnit * 2, "px"),
    WebkitOverflowScrolling: 'touch',
    position: 'relative',
    overflow: 'hidden'
  };
};
var ValueContainer =
/*#__PURE__*/
function (_Component) {
  Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_inherits__["a" /* default */])(ValueContainer, _Component);

  function ValueContainer() {
    Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, ValueContainer);

    return Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_possibleConstructorReturn__["a" /* default */])(this, Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_getPrototypeOf__["a" /* default */])(ValueContainer).apply(this, arguments));
  }

  Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_createClass__["a" /* default */])(ValueContainer, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          className = _this$props.className,
          cx = _this$props.cx,
          isMulti = _this$props.isMulti,
          getStyles = _this$props.getStyles,
          hasValue = _this$props.hasValue;
      return Object(__WEBPACK_IMPORTED_MODULE_11__emotion_core__["c" /* jsx */])("div", {
        css: getStyles('valueContainer', this.props),
        className: cx({
          'value-container': true,
          'value-container--is-multi': isMulti,
          'value-container--has-value': hasValue
        }, className)
      }, children);
    }
  }]);

  return ValueContainer;
}(__WEBPACK_IMPORTED_MODULE_10_react__["Component"]); // ==============================
// Indicator Container
// ==============================

var indicatorsContainerCSS = function indicatorsContainerCSS() {
  return {
    alignItems: 'center',
    alignSelf: 'stretch',
    display: 'flex',
    flexShrink: 0
  };
};
var IndicatorsContainer = function IndicatorsContainer(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles;
  return Object(__WEBPACK_IMPORTED_MODULE_11__emotion_core__["c" /* jsx */])("div", {
    css: getStyles('indicatorsContainer', props),
    className: cx({
      indicators: true
    }, className)
  }, children);
};

function _templateObject() {
  var data = Object(__WEBPACK_IMPORTED_MODULE_17__babel_runtime_helpers_esm_taggedTemplateLiteral__["a" /* default */])(["\n  0%, 80%, 100% { opacity: 0; }\n  40% { opacity: 1; }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var _ref2 =  true ? {
  name: "19bqh2r",
  styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0;"
} : {
  name: "19bqh2r",
  styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"
};

// ==============================
// Dropdown & Clear Icons
// ==============================
var Svg = function Svg(_ref) {
  var size = _ref.size,
      props = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(_ref, ["size"]);

  return Object(__WEBPACK_IMPORTED_MODULE_11__emotion_core__["c" /* jsx */])("svg", Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
    height: size,
    width: size,
    viewBox: "0 0 20 20",
    "aria-hidden": "true",
    focusable: "false",
    css: _ref2
  }, props));
};

var CrossIcon = function CrossIcon(props) {
  return Object(__WEBPACK_IMPORTED_MODULE_11__emotion_core__["c" /* jsx */])(Svg, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
    size: 20
  }, props), Object(__WEBPACK_IMPORTED_MODULE_11__emotion_core__["c" /* jsx */])("path", {
    d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
  }));
};
var DownChevron = function DownChevron(props) {
  return Object(__WEBPACK_IMPORTED_MODULE_11__emotion_core__["c" /* jsx */])(Svg, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
    size: 20
  }, props), Object(__WEBPACK_IMPORTED_MODULE_11__emotion_core__["c" /* jsx */])("path", {
    d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
  }));
}; // ==============================
// Dropdown & Clear Buttons
// ==============================

var baseCSS = function baseCSS(_ref3) {
  var isFocused = _ref3.isFocused,
      _ref3$theme = _ref3.theme,
      baseUnit = _ref3$theme.spacing.baseUnit,
      colors = _ref3$theme.colors;
  return {
    label: 'indicatorContainer',
    color: isFocused ? colors.neutral60 : colors.neutral20,
    display: 'flex',
    padding: baseUnit * 2,
    transition: 'color 150ms',
    ':hover': {
      color: isFocused ? colors.neutral80 : colors.neutral40
    }
  };
};

var dropdownIndicatorCSS = baseCSS;
var DropdownIndicator = function DropdownIndicator(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps;
  return Object(__WEBPACK_IMPORTED_MODULE_11__emotion_core__["c" /* jsx */])("div", Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, innerProps, {
    css: getStyles('dropdownIndicator', props),
    className: cx({
      indicator: true,
      'dropdown-indicator': true
    }, className)
  }), children || Object(__WEBPACK_IMPORTED_MODULE_11__emotion_core__["c" /* jsx */])(DownChevron, null));
};
var clearIndicatorCSS = baseCSS;
var ClearIndicator = function ClearIndicator(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps;
  return Object(__WEBPACK_IMPORTED_MODULE_11__emotion_core__["c" /* jsx */])("div", Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, innerProps, {
    css: getStyles('clearIndicator', props),
    className: cx({
      indicator: true,
      'clear-indicator': true
    }, className)
  }), children || Object(__WEBPACK_IMPORTED_MODULE_11__emotion_core__["c" /* jsx */])(CrossIcon, null));
}; // ==============================
// Separator
// ==============================

var indicatorSeparatorCSS = function indicatorSeparatorCSS(_ref4) {
  var isDisabled = _ref4.isDisabled,
      _ref4$theme = _ref4.theme,
      baseUnit = _ref4$theme.spacing.baseUnit,
      colors = _ref4$theme.colors;
  return {
    label: 'indicatorSeparator',
    alignSelf: 'stretch',
    backgroundColor: isDisabled ? colors.neutral10 : colors.neutral20,
    marginBottom: baseUnit * 2,
    marginTop: baseUnit * 2,
    width: 1
  };
};
var IndicatorSeparator = function IndicatorSeparator(props) {
  var className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps;
  return Object(__WEBPACK_IMPORTED_MODULE_11__emotion_core__["c" /* jsx */])("span", Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, innerProps, {
    css: getStyles('indicatorSeparator', props),
    className: cx({
      'indicator-separator': true
    }, className)
  }));
}; // ==============================
// Loading
// ==============================

var loadingDotAnimations = Object(__WEBPACK_IMPORTED_MODULE_11__emotion_core__["d" /* keyframes */])(_templateObject());
var loadingIndicatorCSS = function loadingIndicatorCSS(_ref5) {
  var isFocused = _ref5.isFocused,
      size = _ref5.size,
      _ref5$theme = _ref5.theme,
      colors = _ref5$theme.colors,
      baseUnit = _ref5$theme.spacing.baseUnit;
  return {
    label: 'loadingIndicator',
    color: isFocused ? colors.neutral60 : colors.neutral20,
    display: 'flex',
    padding: baseUnit * 2,
    transition: 'color 150ms',
    alignSelf: 'center',
    fontSize: size,
    lineHeight: 1,
    marginRight: size,
    textAlign: 'center',
    verticalAlign: 'middle'
  };
};

var LoadingDot = function LoadingDot(_ref6) {
  var delay = _ref6.delay,
      offset = _ref6.offset;
  return Object(__WEBPACK_IMPORTED_MODULE_11__emotion_core__["c" /* jsx */])("span", {
    css:
    /*#__PURE__*/
    Object(__WEBPACK_IMPORTED_MODULE_16__emotion_css__["a" /* default */])({
      animation: "".concat(loadingDotAnimations, " 1s ease-in-out ").concat(delay, "ms infinite;"),
      backgroundColor: 'currentColor',
      borderRadius: '1em',
      display: 'inline-block',
      marginLeft: offset ? '1em' : null,
      height: '1em',
      verticalAlign: 'top',
      width: '1em'
    },  true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")
  });
};

var LoadingIndicator = function LoadingIndicator(props) {
  var className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps,
      isRtl = props.isRtl;
  return Object(__WEBPACK_IMPORTED_MODULE_11__emotion_core__["c" /* jsx */])("div", Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, innerProps, {
    css: getStyles('loadingIndicator', props),
    className: cx({
      indicator: true,
      'loading-indicator': true
    }, className)
  }), Object(__WEBPACK_IMPORTED_MODULE_11__emotion_core__["c" /* jsx */])(LoadingDot, {
    delay: 0,
    offset: isRtl
  }), Object(__WEBPACK_IMPORTED_MODULE_11__emotion_core__["c" /* jsx */])(LoadingDot, {
    delay: 160,
    offset: true
  }), Object(__WEBPACK_IMPORTED_MODULE_11__emotion_core__["c" /* jsx */])(LoadingDot, {
    delay: 320,
    offset: !isRtl
  }));
};
LoadingIndicator.defaultProps = {
  size: 4
};

var css = function css(_ref) {
  var isDisabled = _ref.isDisabled,
      isFocused = _ref.isFocused,
      _ref$theme = _ref.theme,
      colors = _ref$theme.colors,
      borderRadius = _ref$theme.borderRadius,
      spacing = _ref$theme.spacing;
  return {
    label: 'control',
    alignItems: 'center',
    backgroundColor: isDisabled ? colors.neutral5 : colors.neutral0,
    borderColor: isDisabled ? colors.neutral10 : isFocused ? colors.primary : colors.neutral20,
    borderRadius: borderRadius,
    borderStyle: 'solid',
    borderWidth: 1,
    boxShadow: isFocused ? "0 0 0 1px ".concat(colors.primary) : null,
    cursor: 'default',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    minHeight: spacing.controlHeight,
    outline: '0 !important',
    position: 'relative',
    transition: 'all 100ms',
    '&:hover': {
      borderColor: isFocused ? colors.primary : colors.neutral30
    }
  };
};

var Control = function Control(props) {
  var children = props.children,
      cx = props.cx,
      getStyles = props.getStyles,
      className = props.className,
      isDisabled = props.isDisabled,
      isFocused = props.isFocused,
      innerRef = props.innerRef,
      innerProps = props.innerProps,
      menuIsOpen = props.menuIsOpen;
  return Object(__WEBPACK_IMPORTED_MODULE_11__emotion_core__["c" /* jsx */])("div", Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
    ref: innerRef,
    css: getStyles('control', props),
    className: cx({
      control: true,
      'control--is-disabled': isDisabled,
      'control--is-focused': isFocused,
      'control--menu-is-open': menuIsOpen
    }, className)
  }, innerProps), children);
};

var groupCSS = function groupCSS(_ref) {
  var spacing = _ref.theme.spacing;
  return {
    paddingBottom: spacing.baseUnit * 2,
    paddingTop: spacing.baseUnit * 2
  };
};

var Group = function Group(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      Heading = props.Heading,
      headingProps = props.headingProps,
      label = props.label,
      theme = props.theme,
      selectProps = props.selectProps;
  return Object(__WEBPACK_IMPORTED_MODULE_11__emotion_core__["c" /* jsx */])("div", {
    css: getStyles('group', props),
    className: cx({
      group: true
    }, className)
  }, Object(__WEBPACK_IMPORTED_MODULE_11__emotion_core__["c" /* jsx */])(Heading, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, headingProps, {
    selectProps: selectProps,
    theme: theme,
    getStyles: getStyles,
    cx: cx
  }), label), Object(__WEBPACK_IMPORTED_MODULE_11__emotion_core__["c" /* jsx */])("div", null, children));
};

var groupHeadingCSS = function groupHeadingCSS(_ref2) {
  var spacing = _ref2.theme.spacing;
  return {
    label: 'group',
    color: '#999',
    cursor: 'default',
    display: 'block',
    fontSize: '75%',
    fontWeight: '500',
    marginBottom: '0.25em',
    paddingLeft: spacing.baseUnit * 3,
    paddingRight: spacing.baseUnit * 3,
    textTransform: 'uppercase'
  };
};
var GroupHeading = function GroupHeading(props) {
  var className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      theme = props.theme,
      selectProps = props.selectProps,
      cleanProps = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["className", "cx", "getStyles", "theme", "selectProps"]);

  return Object(__WEBPACK_IMPORTED_MODULE_11__emotion_core__["c" /* jsx */])("div", Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
    css: getStyles('groupHeading', Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectSpread__["a" /* default */])({
      theme: theme
    }, cleanProps)),
    className: cx({
      'group-heading': true
    }, className)
  }, cleanProps));
};

var inputCSS = function inputCSS(_ref) {
  var isDisabled = _ref.isDisabled,
      _ref$theme = _ref.theme,
      spacing = _ref$theme.spacing,
      colors = _ref$theme.colors;
  return {
    margin: spacing.baseUnit / 2,
    paddingBottom: spacing.baseUnit / 2,
    paddingTop: spacing.baseUnit / 2,
    visibility: isDisabled ? 'hidden' : 'visible',
    color: colors.neutral80
  };
};

var inputStyle = function inputStyle(isHidden) {
  return {
    label: 'input',
    background: 0,
    border: 0,
    fontSize: 'inherit',
    opacity: isHidden ? 0 : 1,
    outline: 0,
    padding: 0,
    color: 'inherit'
  };
};

var Input = function Input(_ref2) {
  var className = _ref2.className,
      cx = _ref2.cx,
      getStyles = _ref2.getStyles,
      innerRef = _ref2.innerRef,
      isHidden = _ref2.isHidden,
      isDisabled = _ref2.isDisabled,
      theme = _ref2.theme,
      selectProps = _ref2.selectProps,
      props = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(_ref2, ["className", "cx", "getStyles", "innerRef", "isHidden", "isDisabled", "theme", "selectProps"]);

  return Object(__WEBPACK_IMPORTED_MODULE_11__emotion_core__["c" /* jsx */])("div", {
    css: getStyles('input', Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectSpread__["a" /* default */])({
      theme: theme
    }, props))
  }, Object(__WEBPACK_IMPORTED_MODULE_11__emotion_core__["c" /* jsx */])(__WEBPACK_IMPORTED_MODULE_18_react_input_autosize___default.a, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: cx({
      input: true
    }, className),
    inputRef: innerRef,
    inputStyle: inputStyle(isHidden),
    disabled: isDisabled
  }, props)));
};

var multiValueCSS = function multiValueCSS(_ref) {
  var _ref$theme = _ref.theme,
      spacing = _ref$theme.spacing,
      borderRadius = _ref$theme.borderRadius,
      colors = _ref$theme.colors;
  return {
    label: 'multiValue',
    backgroundColor: colors.neutral10,
    borderRadius: borderRadius / 2,
    display: 'flex',
    margin: spacing.baseUnit / 2,
    minWidth: 0 // resolves flex/text-overflow bug

  };
};
var multiValueLabelCSS = function multiValueLabelCSS(_ref2) {
  var _ref2$theme = _ref2.theme,
      borderRadius = _ref2$theme.borderRadius,
      colors = _ref2$theme.colors,
      cropWithEllipsis = _ref2.cropWithEllipsis;
  return {
    borderRadius: borderRadius / 2,
    color: colors.neutral80,
    fontSize: '85%',
    overflow: 'hidden',
    padding: 3,
    paddingLeft: 6,
    textOverflow: cropWithEllipsis ? 'ellipsis' : null,
    whiteSpace: 'nowrap'
  };
};
var multiValueRemoveCSS = function multiValueRemoveCSS(_ref3) {
  var _ref3$theme = _ref3.theme,
      spacing = _ref3$theme.spacing,
      borderRadius = _ref3$theme.borderRadius,
      colors = _ref3$theme.colors,
      isFocused = _ref3.isFocused;
  return {
    alignItems: 'center',
    borderRadius: borderRadius / 2,
    backgroundColor: isFocused && colors.dangerLight,
    display: 'flex',
    paddingLeft: spacing.baseUnit,
    paddingRight: spacing.baseUnit,
    ':hover': {
      backgroundColor: colors.dangerLight,
      color: colors.danger
    }
  };
};
var MultiValueGeneric = function MultiValueGeneric(_ref4) {
  var children = _ref4.children,
      innerProps = _ref4.innerProps;
  return Object(__WEBPACK_IMPORTED_MODULE_11__emotion_core__["c" /* jsx */])("div", innerProps, children);
};
var MultiValueContainer = MultiValueGeneric;
var MultiValueLabel = MultiValueGeneric;
var MultiValueRemove =
/*#__PURE__*/
function (_Component) {
  Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_inherits__["a" /* default */])(MultiValueRemove, _Component);

  function MultiValueRemove() {
    Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, MultiValueRemove);

    return Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_possibleConstructorReturn__["a" /* default */])(this, Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_getPrototypeOf__["a" /* default */])(MultiValueRemove).apply(this, arguments));
  }

  Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_createClass__["a" /* default */])(MultiValueRemove, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          innerProps = _this$props.innerProps;
      return Object(__WEBPACK_IMPORTED_MODULE_11__emotion_core__["c" /* jsx */])("div", innerProps, children || Object(__WEBPACK_IMPORTED_MODULE_11__emotion_core__["c" /* jsx */])(CrossIcon, {
        size: 14
      }));
    }
  }]);

  return MultiValueRemove;
}(__WEBPACK_IMPORTED_MODULE_10_react__["Component"]);

var MultiValue =
/*#__PURE__*/
function (_Component2) {
  Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_inherits__["a" /* default */])(MultiValue, _Component2);

  function MultiValue() {
    Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, MultiValue);

    return Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_possibleConstructorReturn__["a" /* default */])(this, Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_getPrototypeOf__["a" /* default */])(MultiValue).apply(this, arguments));
  }

  Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_createClass__["a" /* default */])(MultiValue, [{
    key: "render",
    value: function render() {
      var _this = this;

      var _this$props2 = this.props,
          children = _this$props2.children,
          className = _this$props2.className,
          components = _this$props2.components,
          cx = _this$props2.cx,
          data = _this$props2.data,
          getStyles = _this$props2.getStyles,
          innerProps = _this$props2.innerProps,
          isDisabled = _this$props2.isDisabled,
          removeProps = _this$props2.removeProps,
          selectProps = _this$props2.selectProps;
      var Container = components.Container,
          Label = components.Label,
          Remove = components.Remove;
      return Object(__WEBPACK_IMPORTED_MODULE_11__emotion_core__["c" /* jsx */])(__WEBPACK_IMPORTED_MODULE_11__emotion_core__["b" /* ClassNames */], null, function (_ref5) {
        var css = _ref5.css,
            emotionCx = _ref5.cx;
        return Object(__WEBPACK_IMPORTED_MODULE_11__emotion_core__["c" /* jsx */])(Container, {
          data: data,
          innerProps: Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectSpread__["a" /* default */])({}, innerProps, {
            className: emotionCx(css(getStyles('multiValue', _this.props)), cx({
              'multi-value': true,
              'multi-value--is-disabled': isDisabled
            }, className))
          }),
          selectProps: selectProps
        }, Object(__WEBPACK_IMPORTED_MODULE_11__emotion_core__["c" /* jsx */])(Label, {
          data: data,
          innerProps: {
            className: emotionCx(css(getStyles('multiValueLabel', _this.props)), cx({
              'multi-value__label': true
            }, className))
          },
          selectProps: selectProps
        }, children), Object(__WEBPACK_IMPORTED_MODULE_11__emotion_core__["c" /* jsx */])(Remove, {
          data: data,
          innerProps: Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectSpread__["a" /* default */])({
            className: emotionCx(css(getStyles('multiValueRemove', _this.props)), cx({
              'multi-value__remove': true
            }, className))
          }, removeProps),
          selectProps: selectProps
        }));
      });
    }
  }]);

  return MultiValue;
}(__WEBPACK_IMPORTED_MODULE_10_react__["Component"]);

Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(MultiValue, "defaultProps", {
  cropWithEllipsis: true
});

var optionCSS = function optionCSS(_ref) {
  var isDisabled = _ref.isDisabled,
      isFocused = _ref.isFocused,
      isSelected = _ref.isSelected,
      _ref$theme = _ref.theme,
      spacing = _ref$theme.spacing,
      colors = _ref$theme.colors;
  return {
    label: 'option',
    backgroundColor: isSelected ? colors.primary : isFocused ? colors.primary25 : 'transparent',
    color: isDisabled ? colors.neutral20 : isSelected ? colors.neutral0 : 'inherit',
    cursor: 'default',
    display: 'block',
    fontSize: 'inherit',
    padding: "".concat(spacing.baseUnit * 2, "px ").concat(spacing.baseUnit * 3, "px"),
    width: '100%',
    userSelect: 'none',
    WebkitTapHighlightColor: 'rgba(0, 0, 0, 0)',
    // provide some affordance on touch devices
    ':active': {
      backgroundColor: !isDisabled && (isSelected ? colors.primary : colors.primary50)
    }
  };
};

var Option = function Option(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      isDisabled = props.isDisabled,
      isFocused = props.isFocused,
      isSelected = props.isSelected,
      innerRef = props.innerRef,
      innerProps = props.innerProps;
  return Object(__WEBPACK_IMPORTED_MODULE_11__emotion_core__["c" /* jsx */])("div", Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
    css: getStyles('option', props),
    className: cx({
      option: true,
      'option--is-disabled': isDisabled,
      'option--is-focused': isFocused,
      'option--is-selected': isSelected
    }, className),
    ref: innerRef
  }, innerProps), children);
};

var placeholderCSS = function placeholderCSS(_ref) {
  var _ref$theme = _ref.theme,
      spacing = _ref$theme.spacing,
      colors = _ref$theme.colors;
  return {
    label: 'placeholder',
    color: colors.neutral50,
    marginLeft: spacing.baseUnit / 2,
    marginRight: spacing.baseUnit / 2,
    position: 'absolute',
    top: '50%',
    transform: 'translateY(-50%)'
  };
};

var Placeholder = function Placeholder(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps;
  return Object(__WEBPACK_IMPORTED_MODULE_11__emotion_core__["c" /* jsx */])("div", Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
    css: getStyles('placeholder', props),
    className: cx({
      placeholder: true
    }, className)
  }, innerProps), children);
};

var css$1 = function css(_ref) {
  var isDisabled = _ref.isDisabled,
      _ref$theme = _ref.theme,
      spacing = _ref$theme.spacing,
      colors = _ref$theme.colors;
  return {
    label: 'singleValue',
    color: isDisabled ? colors.neutral40 : colors.neutral80,
    marginLeft: spacing.baseUnit / 2,
    marginRight: spacing.baseUnit / 2,
    maxWidth: "calc(100% - ".concat(spacing.baseUnit * 2, "px)"),
    overflow: 'hidden',
    position: 'absolute',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    top: '50%',
    transform: 'translateY(-50%)'
  };
};

var SingleValue = function SingleValue(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      isDisabled = props.isDisabled,
      innerProps = props.innerProps;
  return Object(__WEBPACK_IMPORTED_MODULE_11__emotion_core__["c" /* jsx */])("div", Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
    css: getStyles('singleValue', props),
    className: cx({
      'single-value': true,
      'single-value--is-disabled': isDisabled
    }, className)
  }, innerProps), children);
};

var components = {
  ClearIndicator: ClearIndicator,
  Control: Control,
  DropdownIndicator: DropdownIndicator,
  DownChevron: DownChevron,
  CrossIcon: CrossIcon,
  Group: Group,
  GroupHeading: GroupHeading,
  IndicatorsContainer: IndicatorsContainer,
  IndicatorSeparator: IndicatorSeparator,
  Input: Input,
  LoadingIndicator: LoadingIndicator,
  Menu: Menu,
  MenuList: MenuList,
  MenuPortal: MenuPortal,
  LoadingMessage: LoadingMessage,
  NoOptionsMessage: NoOptionsMessage,
  MultiValue: MultiValue,
  MultiValueContainer: MultiValueContainer,
  MultiValueLabel: MultiValueLabel,
  MultiValueRemove: MultiValueRemove,
  Option: Option,
  Placeholder: Placeholder,
  SelectContainer: SelectContainer,
  SingleValue: SingleValue,
  ValueContainer: ValueContainer
};
var defaultComponents = function defaultComponents(props) {
  return Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectSpread__["a" /* default */])({}, components, props.components);
};




/***/ }),
/* 318 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _taggedTemplateLiteral;
function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(7);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var sizerStyle = {
	position: 'absolute',
	top: 0,
	left: 0,
	visibility: 'hidden',
	height: 0,
	overflow: 'scroll',
	whiteSpace: 'pre'
};

var INPUT_PROPS_BLACKLIST = ['extraWidth', 'injectStyles', 'inputClassName', 'inputRef', 'inputStyle', 'minWidth', 'onAutosize', 'placeholderIsMinWidth'];

var cleanInputProps = function cleanInputProps(inputProps) {
	INPUT_PROPS_BLACKLIST.forEach(function (field) {
		return delete inputProps[field];
	});
	return inputProps;
};

var copyStyles = function copyStyles(styles, node) {
	node.style.fontSize = styles.fontSize;
	node.style.fontFamily = styles.fontFamily;
	node.style.fontWeight = styles.fontWeight;
	node.style.fontStyle = styles.fontStyle;
	node.style.letterSpacing = styles.letterSpacing;
	node.style.textTransform = styles.textTransform;
};

var isIE = typeof window !== 'undefined' && window.navigator ? /MSIE |Trident\/|Edge\//.test(window.navigator.userAgent) : false;

var generateId = function generateId() {
	// we only need an auto-generated ID for stylesheet injection, which is only
	// used for IE. so if the browser is not IE, this should return undefined.
	return isIE ? '_' + Math.random().toString(36).substr(2, 12) : undefined;
};

var AutosizeInput = function (_Component) {
	_inherits(AutosizeInput, _Component);

	function AutosizeInput(props) {
		_classCallCheck(this, AutosizeInput);

		var _this = _possibleConstructorReturn(this, (AutosizeInput.__proto__ || Object.getPrototypeOf(AutosizeInput)).call(this, props));

		_this.inputRef = function (el) {
			_this.input = el;
			if (typeof _this.props.inputRef === 'function') {
				_this.props.inputRef(el);
			}
		};

		_this.placeHolderSizerRef = function (el) {
			_this.placeHolderSizer = el;
		};

		_this.sizerRef = function (el) {
			_this.sizer = el;
		};

		_this.state = {
			inputWidth: props.minWidth,
			inputId: props.id || generateId()
		};
		return _this;
	}

	_createClass(AutosizeInput, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			this.mounted = true;
			this.copyInputStyles();
			this.updateInputWidth();
		}
	}, {
		key: 'UNSAFE_componentWillReceiveProps',
		value: function UNSAFE_componentWillReceiveProps(nextProps) {
			var id = nextProps.id;

			if (id !== this.props.id) {
				this.setState({ inputId: id || generateId() });
			}
		}
	}, {
		key: 'componentDidUpdate',
		value: function componentDidUpdate(prevProps, prevState) {
			if (prevState.inputWidth !== this.state.inputWidth) {
				if (typeof this.props.onAutosize === 'function') {
					this.props.onAutosize(this.state.inputWidth);
				}
			}
			this.updateInputWidth();
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			this.mounted = false;
		}
	}, {
		key: 'copyInputStyles',
		value: function copyInputStyles() {
			if (!this.mounted || !window.getComputedStyle) {
				return;
			}
			var inputStyles = this.input && window.getComputedStyle(this.input);
			if (!inputStyles) {
				return;
			}
			copyStyles(inputStyles, this.sizer);
			if (this.placeHolderSizer) {
				copyStyles(inputStyles, this.placeHolderSizer);
			}
		}
	}, {
		key: 'updateInputWidth',
		value: function updateInputWidth() {
			if (!this.mounted || !this.sizer || typeof this.sizer.scrollWidth === 'undefined') {
				return;
			}
			var newInputWidth = void 0;
			if (this.props.placeholder && (!this.props.value || this.props.value && this.props.placeholderIsMinWidth)) {
				newInputWidth = Math.max(this.sizer.scrollWidth, this.placeHolderSizer.scrollWidth) + 2;
			} else {
				newInputWidth = this.sizer.scrollWidth + 2;
			}
			// add extraWidth to the detected width. for number types, this defaults to 16 to allow for the stepper UI
			var extraWidth = this.props.type === 'number' && this.props.extraWidth === undefined ? 16 : parseInt(this.props.extraWidth) || 0;
			newInputWidth += extraWidth;
			if (newInputWidth < this.props.minWidth) {
				newInputWidth = this.props.minWidth;
			}
			if (newInputWidth !== this.state.inputWidth) {
				this.setState({
					inputWidth: newInputWidth
				});
			}
		}
	}, {
		key: 'getInput',
		value: function getInput() {
			return this.input;
		}
	}, {
		key: 'focus',
		value: function focus() {
			this.input.focus();
		}
	}, {
		key: 'blur',
		value: function blur() {
			this.input.blur();
		}
	}, {
		key: 'select',
		value: function select() {
			this.input.select();
		}
	}, {
		key: 'renderStyles',
		value: function renderStyles() {
			// this method injects styles to hide IE's clear indicator, which messes
			// with input size detection. the stylesheet is only injected when the
			// browser is IE, and can also be disabled by the `injectStyles` prop.
			var injectStyles = this.props.injectStyles;

			return isIE && injectStyles ? _react2.default.createElement('style', { dangerouslySetInnerHTML: {
					__html: 'input#' + this.state.inputId + '::-ms-clear {display: none;}'
				} }) : null;
		}
	}, {
		key: 'render',
		value: function render() {
			var sizerValue = [this.props.defaultValue, this.props.value, ''].reduce(function (previousValue, currentValue) {
				if (previousValue !== null && previousValue !== undefined) {
					return previousValue;
				}
				return currentValue;
			});

			var wrapperStyle = _extends({}, this.props.style);
			if (!wrapperStyle.display) wrapperStyle.display = 'inline-block';

			var inputStyle = _extends({
				boxSizing: 'content-box',
				width: this.state.inputWidth + 'px'
			}, this.props.inputStyle);

			var inputProps = _objectWithoutProperties(this.props, []);

			cleanInputProps(inputProps);
			inputProps.className = this.props.inputClassName;
			inputProps.id = this.state.inputId;
			inputProps.style = inputStyle;

			return _react2.default.createElement(
				'div',
				{ className: this.props.className, style: wrapperStyle },
				this.renderStyles(),
				_react2.default.createElement('input', _extends({}, inputProps, { ref: this.inputRef })),
				_react2.default.createElement(
					'div',
					{ ref: this.sizerRef, style: sizerStyle },
					sizerValue
				),
				this.props.placeholder ? _react2.default.createElement(
					'div',
					{ ref: this.placeHolderSizerRef, style: sizerStyle },
					this.props.placeholder
				) : null
			);
		}
	}]);

	return AutosizeInput;
}(_react.Component);

AutosizeInput.propTypes = {
	className: _propTypes2.default.string, // className for the outer element
	defaultValue: _propTypes2.default.any, // default field value
	extraWidth: _propTypes2.default.oneOfType([// additional width for input element
	_propTypes2.default.number, _propTypes2.default.string]),
	id: _propTypes2.default.string, // id to use for the input, can be set for consistent snapshots
	injectStyles: _propTypes2.default.bool, // inject the custom stylesheet to hide clear UI, defaults to true
	inputClassName: _propTypes2.default.string, // className for the input element
	inputRef: _propTypes2.default.func, // ref callback for the input element
	inputStyle: _propTypes2.default.object, // css styles for the input element
	minWidth: _propTypes2.default.oneOfType([// minimum width for input element
	_propTypes2.default.number, _propTypes2.default.string]),
	onAutosize: _propTypes2.default.func, // onAutosize handler: function(newWidth) {}
	onChange: _propTypes2.default.func, // onChange handler: function(event) {}
	placeholder: _propTypes2.default.string, // placeholder text
	placeholderIsMinWidth: _propTypes2.default.bool, // don't collapse size to less than the placeholder
	style: _propTypes2.default.object, // css styles for the outer element
	value: _propTypes2.default.any // field value
};
AutosizeInput.defaultProps = {
	minWidth: 1,
	injectStyles: true
};

exports.default = AutosizeInput;

/***/ }),
/* 320 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Select; });
/* unused harmony export a */
/* unused harmony export c */
/* unused harmony export d */
/* unused harmony export m */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_toConsumableArray__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_objectSpread__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_createClass__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_possibleConstructorReturn__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_getPrototypeOf__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_inherits__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_memoize_one__ = __webpack_require__(313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__emotion_core__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_dom__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__chunk_39d3fda8_browser_esm_js__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__chunk_80640036_browser_esm_js__ = __webpack_require__(317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__emotion_css__ = __webpack_require__(95);



















var diacritics = [{
  base: 'A',
  letters: /[\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F]/g
}, {
  base: 'AA',
  letters: /[\uA732]/g
}, {
  base: 'AE',
  letters: /[\u00C6\u01FC\u01E2]/g
}, {
  base: 'AO',
  letters: /[\uA734]/g
}, {
  base: 'AU',
  letters: /[\uA736]/g
}, {
  base: 'AV',
  letters: /[\uA738\uA73A]/g
}, {
  base: 'AY',
  letters: /[\uA73C]/g
}, {
  base: 'B',
  letters: /[\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181]/g
}, {
  base: 'C',
  letters: /[\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E]/g
}, {
  base: 'D',
  letters: /[\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779]/g
}, {
  base: 'DZ',
  letters: /[\u01F1\u01C4]/g
}, {
  base: 'Dz',
  letters: /[\u01F2\u01C5]/g
}, {
  base: 'E',
  letters: /[\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E]/g
}, {
  base: 'F',
  letters: /[\u0046\u24BB\uFF26\u1E1E\u0191\uA77B]/g
}, {
  base: 'G',
  letters: /[\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E]/g
}, {
  base: 'H',
  letters: /[\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D]/g
}, {
  base: 'I',
  letters: /[\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197]/g
}, {
  base: 'J',
  letters: /[\u004A\u24BF\uFF2A\u0134\u0248]/g
}, {
  base: 'K',
  letters: /[\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2]/g
}, {
  base: 'L',
  letters: /[\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780]/g
}, {
  base: 'LJ',
  letters: /[\u01C7]/g
}, {
  base: 'Lj',
  letters: /[\u01C8]/g
}, {
  base: 'M',
  letters: /[\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C]/g
}, {
  base: 'N',
  letters: /[\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4]/g
}, {
  base: 'NJ',
  letters: /[\u01CA]/g
}, {
  base: 'Nj',
  letters: /[\u01CB]/g
}, {
  base: 'O',
  letters: /[\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C]/g
}, {
  base: 'OI',
  letters: /[\u01A2]/g
}, {
  base: 'OO',
  letters: /[\uA74E]/g
}, {
  base: 'OU',
  letters: /[\u0222]/g
}, {
  base: 'P',
  letters: /[\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754]/g
}, {
  base: 'Q',
  letters: /[\u0051\u24C6\uFF31\uA756\uA758\u024A]/g
}, {
  base: 'R',
  letters: /[\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782]/g
}, {
  base: 'S',
  letters: /[\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784]/g
}, {
  base: 'T',
  letters: /[\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786]/g
}, {
  base: 'TZ',
  letters: /[\uA728]/g
}, {
  base: 'U',
  letters: /[\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244]/g
}, {
  base: 'V',
  letters: /[\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245]/g
}, {
  base: 'VY',
  letters: /[\uA760]/g
}, {
  base: 'W',
  letters: /[\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72]/g
}, {
  base: 'X',
  letters: /[\u0058\u24CD\uFF38\u1E8A\u1E8C]/g
}, {
  base: 'Y',
  letters: /[\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE]/g
}, {
  base: 'Z',
  letters: /[\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762]/g
}, {
  base: 'a',
  letters: /[\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250]/g
}, {
  base: 'aa',
  letters: /[\uA733]/g
}, {
  base: 'ae',
  letters: /[\u00E6\u01FD\u01E3]/g
}, {
  base: 'ao',
  letters: /[\uA735]/g
}, {
  base: 'au',
  letters: /[\uA737]/g
}, {
  base: 'av',
  letters: /[\uA739\uA73B]/g
}, {
  base: 'ay',
  letters: /[\uA73D]/g
}, {
  base: 'b',
  letters: /[\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253]/g
}, {
  base: 'c',
  letters: /[\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184]/g
}, {
  base: 'd',
  letters: /[\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A]/g
}, {
  base: 'dz',
  letters: /[\u01F3\u01C6]/g
}, {
  base: 'e',
  letters: /[\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD]/g
}, {
  base: 'f',
  letters: /[\u0066\u24D5\uFF46\u1E1F\u0192\uA77C]/g
}, {
  base: 'g',
  letters: /[\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F]/g
}, {
  base: 'h',
  letters: /[\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265]/g
}, {
  base: 'hv',
  letters: /[\u0195]/g
}, {
  base: 'i',
  letters: /[\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131]/g
}, {
  base: 'j',
  letters: /[\u006A\u24D9\uFF4A\u0135\u01F0\u0249]/g
}, {
  base: 'k',
  letters: /[\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3]/g
}, {
  base: 'l',
  letters: /[\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747]/g
}, {
  base: 'lj',
  letters: /[\u01C9]/g
}, {
  base: 'm',
  letters: /[\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F]/g
}, {
  base: 'n',
  letters: /[\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5]/g
}, {
  base: 'nj',
  letters: /[\u01CC]/g
}, {
  base: 'o',
  letters: /[\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275]/g
}, {
  base: 'oi',
  letters: /[\u01A3]/g
}, {
  base: 'ou',
  letters: /[\u0223]/g
}, {
  base: 'oo',
  letters: /[\uA74F]/g
}, {
  base: 'p',
  letters: /[\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755]/g
}, {
  base: 'q',
  letters: /[\u0071\u24E0\uFF51\u024B\uA757\uA759]/g
}, {
  base: 'r',
  letters: /[\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783]/g
}, {
  base: 's',
  letters: /[\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B]/g
}, {
  base: 't',
  letters: /[\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787]/g
}, {
  base: 'tz',
  letters: /[\uA729]/g
}, {
  base: 'u',
  letters: /[\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289]/g
}, {
  base: 'v',
  letters: /[\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C]/g
}, {
  base: 'vy',
  letters: /[\uA761]/g
}, {
  base: 'w',
  letters: /[\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73]/g
}, {
  base: 'x',
  letters: /[\u0078\u24E7\uFF58\u1E8B\u1E8D]/g
}, {
  base: 'y',
  letters: /[\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF]/g
}, {
  base: 'z',
  letters: /[\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763]/g
}];
var stripDiacritics = function stripDiacritics(str) {
  for (var i = 0; i < diacritics.length; i++) {
    str = str.replace(diacritics[i].letters, diacritics[i].base);
  }

  return str;
};

var trimString = function trimString(str) {
  return str.replace(/^\s+|\s+$/g, '');
};

var defaultStringify = function defaultStringify(option) {
  return "".concat(option.label, " ").concat(option.value);
};

var createFilter = function createFilter(config) {
  return function (option, rawInput) {
    var _ignoreCase$ignoreAcc = Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_objectSpread__["a" /* default */])({
      ignoreCase: true,
      ignoreAccents: true,
      stringify: defaultStringify,
      trim: true,
      matchFrom: 'any'
    }, config),
        ignoreCase = _ignoreCase$ignoreAcc.ignoreCase,
        ignoreAccents = _ignoreCase$ignoreAcc.ignoreAccents,
        stringify = _ignoreCase$ignoreAcc.stringify,
        trim = _ignoreCase$ignoreAcc.trim,
        matchFrom = _ignoreCase$ignoreAcc.matchFrom;

    var input = trim ? trimString(rawInput) : rawInput;
    var candidate = trim ? trimString(stringify(option)) : stringify(option);

    if (ignoreCase) {
      input = input.toLowerCase();
      candidate = candidate.toLowerCase();
    }

    if (ignoreAccents) {
      input = stripDiacritics(input);
      candidate = stripDiacritics(candidate);
    }

    return matchFrom === 'start' ? candidate.substr(0, input.length) === input : candidate.indexOf(input) > -1;
  };
};

var _ref =  true ? {
  name: "1laao21-a11yText",
  styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap;"
} : {
  name: "1laao21-a11yText",
  styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkExMXlUZXh0LmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQVFNIiwiZmlsZSI6IkExMXlUZXh0LmpzIiwic291cmNlc0NvbnRlbnQiOlsiLy8gQGZsb3dcbi8qKiBAanN4IGpzeCAqL1xuaW1wb3J0IHsgdHlwZSBFbGVtZW50Q29uZmlnIH0gZnJvbSAncmVhY3QnO1xuaW1wb3J0IHsganN4IH0gZnJvbSAnQGVtb3Rpb24vY29yZSc7XG5cbi8vIEFzc2lzdGl2ZSB0ZXh0IHRvIGRlc2NyaWJlIHZpc3VhbCBlbGVtZW50cy4gSGlkZGVuIGZvciBzaWdodGVkIHVzZXJzLlxuY29uc3QgQTExeVRleHQgPSAocHJvcHM6IEVsZW1lbnRDb25maWc8J3NwYW4nPikgPT4gKFxuICAgIDxzcGFuXG4gICAgICBjc3M9e3tcbiAgICAgICAgbGFiZWw6ICdhMTF5VGV4dCcsXG4gICAgICAgIHpJbmRleDogOTk5OSxcbiAgICAgICAgYm9yZGVyOiAwLFxuICAgICAgICBjbGlwOiAncmVjdCgxcHgsIDFweCwgMXB4LCAxcHgpJyxcbiAgICAgICAgaGVpZ2h0OiAxLFxuICAgICAgICB3aWR0aDogMSxcbiAgICAgICAgcG9zaXRpb246ICdhYnNvbHV0ZScsXG4gICAgICAgIG92ZXJmbG93OiAnaGlkZGVuJyxcbiAgICAgICAgcGFkZGluZzogMCxcbiAgICAgICAgd2hpdGVTcGFjZTogJ25vd3JhcCcsXG4gICAgICB9fVxuICAgICAgey4uLnByb3BzfVxuICAgIC8+XG4pO1xuXG5leHBvcnQgZGVmYXVsdCBBMTF5VGV4dDtcbiJdfQ== */"
};

var A11yText = function A11yText(props) {
  return Object(__WEBPACK_IMPORTED_MODULE_13__emotion_core__["c" /* jsx */])("span", Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
    css: _ref
  }, props));
};

var DummyInput =
/*#__PURE__*/
function (_Component) {
  Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_inherits__["a" /* default */])(DummyInput, _Component);

  function DummyInput() {
    Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, DummyInput);

    return Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_possibleConstructorReturn__["a" /* default */])(this, Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_getPrototypeOf__["a" /* default */])(DummyInput).apply(this, arguments));
  }

  Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_createClass__["a" /* default */])(DummyInput, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          inProp = _this$props.in,
          out = _this$props.out,
          onExited = _this$props.onExited,
          appear = _this$props.appear,
          enter = _this$props.enter,
          exit = _this$props.exit,
          innerRef = _this$props.innerRef,
          emotion = _this$props.emotion,
          props = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(_this$props, ["in", "out", "onExited", "appear", "enter", "exit", "innerRef", "emotion"]);

      return Object(__WEBPACK_IMPORTED_MODULE_13__emotion_core__["c" /* jsx */])("input", Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
        ref: innerRef
      }, props, {
        css:
        /*#__PURE__*/
        Object(__WEBPACK_IMPORTED_MODULE_17__emotion_css__["a" /* default */])({
          label: 'dummyInput',
          // get rid of any default styles
          background: 0,
          border: 0,
          fontSize: 'inherit',
          outline: 0,
          padding: 0,
          // important! without `width` browsers won't allow focus
          width: 1,
          // remove cursor on desktop
          color: 'transparent',
          // remove cursor on mobile whilst maintaining "scroll into view" behaviour
          left: -100,
          opacity: 0,
          position: 'relative',
          transform: 'scale(0)'
        },  true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkR1bW15SW5wdXQuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBWVEiLCJmaWxlIjoiRHVtbXlJbnB1dC5qcyIsInNvdXJjZXNDb250ZW50IjpbIi8vIEBmbG93XG4vKiogQGpzeCBqc3ggKi9cbmltcG9ydCB7IENvbXBvbmVudCB9IGZyb20gJ3JlYWN0JztcbmltcG9ydCB7IGpzeCB9IGZyb20gJ0BlbW90aW9uL2NvcmUnO1xuXG5leHBvcnQgZGVmYXVsdCBjbGFzcyBEdW1teUlucHV0IGV4dGVuZHMgQ29tcG9uZW50PGFueT4ge1xuICByZW5kZXIgKCkge1xuICAgIGNvbnN0IHsgaW46IGluUHJvcCwgb3V0LCBvbkV4aXRlZCwgYXBwZWFyLCBlbnRlciwgZXhpdCwgaW5uZXJSZWYsIGVtb3Rpb24sIC4uLnByb3BzIH0gPSB0aGlzLnByb3BzO1xuICAgIHJldHVybihcbiAgICAgIDxpbnB1dFxuICAgICAgICByZWY9e2lubmVyUmVmfVxuICAgICAgICB7Li4ucHJvcHN9XG4gICAgICAgIGNzcz17e1xuICAgICAgICAgIGxhYmVsOiAnZHVtbXlJbnB1dCcsXG4gICAgICAgICAgLy8gZ2V0IHJpZCBvZiBhbnkgZGVmYXVsdCBzdHlsZXNcbiAgICAgICAgICBiYWNrZ3JvdW5kOiAwLFxuICAgICAgICAgIGJvcmRlcjogMCxcbiAgICAgICAgICBmb250U2l6ZTogJ2luaGVyaXQnLFxuICAgICAgICAgIG91dGxpbmU6IDAsXG4gICAgICAgICAgcGFkZGluZzogMCxcbiAgICAgICAgICAvLyBpbXBvcnRhbnQhIHdpdGhvdXQgYHdpZHRoYCBicm93c2VycyB3b24ndCBhbGxvdyBmb2N1c1xuICAgICAgICAgIHdpZHRoOiAxLFxuXG4gICAgICAgICAgLy8gcmVtb3ZlIGN1cnNvciBvbiBkZXNrdG9wXG4gICAgICAgICAgY29sb3I6ICd0cmFuc3BhcmVudCcsXG5cbiAgICAgICAgICAvLyByZW1vdmUgY3Vyc29yIG9uIG1vYmlsZSB3aGlsc3QgbWFpbnRhaW5pbmcgXCJzY3JvbGwgaW50byB2aWV3XCIgYmVoYXZpb3VyXG4gICAgICAgICAgbGVmdDogLTEwMCxcbiAgICAgICAgICBvcGFjaXR5OiAwLFxuICAgICAgICAgIHBvc2l0aW9uOiAncmVsYXRpdmUnLFxuICAgICAgICAgIHRyYW5zZm9ybTogJ3NjYWxlKDApJyxcbiAgICAgICAgfX1cbiAgICAgIC8+XG4gICAgKTtcbiAgfVxufVxuIl19 */")
      }));
    }
  }]);

  return DummyInput;
}(__WEBPACK_IMPORTED_MODULE_11_react__["Component"]);

var NodeResolver =
/*#__PURE__*/
function (_Component) {
  Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_inherits__["a" /* default */])(NodeResolver, _Component);

  function NodeResolver() {
    Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, NodeResolver);

    return Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_possibleConstructorReturn__["a" /* default */])(this, Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_getPrototypeOf__["a" /* default */])(NodeResolver).apply(this, arguments));
  }

  Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_createClass__["a" /* default */])(NodeResolver, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.innerRef(Object(__WEBPACK_IMPORTED_MODULE_14_react_dom__["findDOMNode"])(this));
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.props.innerRef(null);
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.children;
    }
  }]);

  return NodeResolver;
}(__WEBPACK_IMPORTED_MODULE_11_react__["Component"]);

var STYLE_KEYS = ['boxSizing', 'height', 'overflow', 'paddingRight', 'position'];
var LOCK_STYLES = {
  boxSizing: 'border-box',
  // account for possible declaration `width: 100%;` on body
  overflow: 'hidden',
  position: 'relative',
  height: '100%'
};

function preventTouchMove(e) {
  e.preventDefault();
}
function allowTouchMove(e) {
  e.stopPropagation();
}
function preventInertiaScroll() {
  var top = this.scrollTop;
  var totalScroll = this.scrollHeight;
  var currentScroll = top + this.offsetHeight;

  if (top === 0) {
    this.scrollTop = 1;
  } else if (currentScroll === totalScroll) {
    this.scrollTop = top - 1;
  }
} // `ontouchstart` check works on most browsers
// `maxTouchPoints` works on IE10/11 and Surface

function isTouchDevice() {
  return 'ontouchstart' in window || navigator.maxTouchPoints;
}

var canUseDOM = !!(window.document && window.document.createElement);
var activeScrollLocks = 0;

var ScrollLock =
/*#__PURE__*/
function (_Component) {
  Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_inherits__["a" /* default */])(ScrollLock, _Component);

  function ScrollLock() {
    var _getPrototypeOf2;

    var _this;

    Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, ScrollLock);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_possibleConstructorReturn__["a" /* default */])(this, (_getPrototypeOf2 = Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_getPrototypeOf__["a" /* default */])(ScrollLock)).call.apply(_getPrototypeOf2, [this].concat(args)));

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "originalStyles", {});

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "listenerOptions", {
      capture: false,
      passive: false
    });

    return _this;
  }

  Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_createClass__["a" /* default */])(ScrollLock, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      if (!canUseDOM) return;
      var _this$props = this.props,
          accountForScrollbars = _this$props.accountForScrollbars,
          touchScrollTarget = _this$props.touchScrollTarget;
      var target = document.body;
      var targetStyle = target && target.style;

      if (accountForScrollbars) {
        // store any styles already applied to the body
        STYLE_KEYS.forEach(function (key) {
          var val = targetStyle && targetStyle[key];
          _this2.originalStyles[key] = val;
        });
      } // apply the lock styles and padding if this is the first scroll lock


      if (accountForScrollbars && activeScrollLocks < 1) {
        var currentPadding = parseInt(this.originalStyles.paddingRight, 10) || 0;
        var clientWidth = document.body ? document.body.clientWidth : 0;
        var adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;
        Object.keys(LOCK_STYLES).forEach(function (key) {
          var val = LOCK_STYLES[key];

          if (targetStyle) {
            targetStyle[key] = val;
          }
        });

        if (targetStyle) {
          targetStyle.paddingRight = "".concat(adjustedPadding, "px");
        }
      } // account for touch devices


      if (target && isTouchDevice()) {
        // Mobile Safari ignores { overflow: hidden } declaration on the body.
        target.addEventListener('touchmove', preventTouchMove, this.listenerOptions); // Allow scroll on provided target

        if (touchScrollTarget) {
          touchScrollTarget.addEventListener('touchstart', preventInertiaScroll, this.listenerOptions);
          touchScrollTarget.addEventListener('touchmove', allowTouchMove, this.listenerOptions);
        }
      } // increment active scroll locks


      activeScrollLocks += 1;
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _this3 = this;

      if (!canUseDOM) return;
      var _this$props2 = this.props,
          accountForScrollbars = _this$props2.accountForScrollbars,
          touchScrollTarget = _this$props2.touchScrollTarget;
      var target = document.body;
      var targetStyle = target && target.style; // safely decrement active scroll locks

      activeScrollLocks = Math.max(activeScrollLocks - 1, 0); // reapply original body styles, if any

      if (accountForScrollbars && activeScrollLocks < 1) {
        STYLE_KEYS.forEach(function (key) {
          var val = _this3.originalStyles[key];

          if (targetStyle) {
            targetStyle[key] = val;
          }
        });
      } // remove touch listeners


      if (target && isTouchDevice()) {
        target.removeEventListener('touchmove', preventTouchMove, this.listenerOptions);

        if (touchScrollTarget) {
          touchScrollTarget.removeEventListener('touchstart', preventInertiaScroll, this.listenerOptions);
          touchScrollTarget.removeEventListener('touchmove', allowTouchMove, this.listenerOptions);
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      return null;
    }
  }]);

  return ScrollLock;
}(__WEBPACK_IMPORTED_MODULE_11_react__["Component"]);

Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(ScrollLock, "defaultProps", {
  accountForScrollbars: true
});

var _ref$1 =  true ? {
  name: "1dsbpcp",
  styles: "position:fixed;left:0;bottom:0;right:0;top:0;"
} : {
  name: "1dsbpcp",
  styles: "position:fixed;left:0;bottom:0;right:0;top:0;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlNjcm9sbEJsb2NrLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQTZEVSIsImZpbGUiOiJTY3JvbGxCbG9jay5qcyIsInNvdXJjZXNDb250ZW50IjpbIi8vIEBmbG93XG4vKiogQGpzeCBqc3ggKi9cbmltcG9ydCB7IFB1cmVDb21wb25lbnQsIHR5cGUgRWxlbWVudCB9IGZyb20gJ3JlYWN0JztcbmltcG9ydCB7IGpzeCB9IGZyb20gJ0BlbW90aW9uL2NvcmUnO1xuaW1wb3J0IE5vZGVSZXNvbHZlciBmcm9tICcuL05vZGVSZXNvbHZlcic7XG5pbXBvcnQgU2Nyb2xsTG9jayBmcm9tICcuL1Njcm9sbExvY2svaW5kZXgnO1xuXG50eXBlIFByb3BzID0ge1xuICBjaGlsZHJlbjogRWxlbWVudDwqPixcbiAgaXNFbmFibGVkOiBib29sZWFuLFxufTtcbnR5cGUgU3RhdGUgPSB7XG4gIHRvdWNoU2Nyb2xsVGFyZ2V0OiBIVE1MRWxlbWVudCB8IG51bGwsXG59O1xuXG4vLyBOT1RFOlxuLy8gV2Ugc2hvdWxkbid0IG5lZWQgdGhpcyBhZnRlciB1cGRhdGluZyB0byBSZWFjdCB2MTYuMy4wLCB3aGljaCBpbnRyb2R1Y2VzOlxuLy8gLSBjcmVhdGVSZWYoKSBodHRwczovL3JlYWN0anMub3JnL2RvY3MvcmVhY3QtYXBpLmh0bWwjcmVhY3RjcmVhdGVyZWZcbi8vIC0gZm9yd2FyZFJlZigpIGh0dHBzOi8vcmVhY3Rqcy5vcmcvZG9jcy9yZWFjdC1hcGkuaHRtbCNyZWFjdGZvcndhcmRyZWZcblxuZXhwb3J0IGRlZmF1bHQgY2xhc3MgU2Nyb2xsQmxvY2sgZXh0ZW5kcyBQdXJlQ29tcG9uZW50PFByb3BzLCBTdGF0ZT4ge1xuICBzdGF0ZSA9IHsgdG91Y2hTY3JvbGxUYXJnZXQ6IG51bGwgfTtcblxuICAvLyBtdXN0IGJlIGluIHN0YXRlIHRvIHRyaWdnZXIgYSByZS1yZW5kZXIsIG9ubHkgcnVucyBvbmNlIHBlciBpbnN0YW5jZVxuICBnZXRTY3JvbGxUYXJnZXQgPSAocmVmOiBIVE1MRWxlbWVudCkgPT4ge1xuICAgIGlmIChyZWYgPT09IHRoaXMuc3RhdGUudG91Y2hTY3JvbGxUYXJnZXQpIHJldHVybjtcbiAgICB0aGlzLnNldFN0YXRlKHsgdG91Y2hTY3JvbGxUYXJnZXQ6IHJlZiB9KTtcbiAgfTtcblxuICAvLyB0aGlzIHdpbGwgY2xvc2UgdGhlIG1lbnUgd2hlbiBhIHVzZXIgY2xpY2tzIG91dHNpZGVcbiAgYmx1clNlbGVjdElucHV0ID0gKCkgPT4ge1xuICAgIGlmIChkb2N1bWVudC5hY3RpdmVFbGVtZW50KSB7XG4gICAgICBkb2N1bWVudC5hY3RpdmVFbGVtZW50LmJsdXIoKTtcbiAgICB9XG4gIH07XG5cbiAgcmVuZGVyKCkge1xuICAgIGNvbnN0IHsgY2hpbGRyZW4sIGlzRW5hYmxlZCB9ID0gdGhpcy5wcm9wcztcbiAgICBjb25zdCB7IHRvdWNoU2Nyb2xsVGFyZ2V0IH0gPSB0aGlzLnN0YXRlO1xuXG4gICAgLy8gYmFpbCBlYXJseSBpZiBub3QgZW5hYmxlZFxuICAgIGlmICghaXNFbmFibGVkKSByZXR1cm4gY2hpbGRyZW47XG5cbiAgICAvKlxuICAgICAqIERpdlxuICAgICAqIC0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLVxuICAgICAqIGJsb2NrcyBzY3JvbGxpbmcgb24gbm9uLWJvZHkgZWxlbWVudHMgYmVoaW5kIHRoZSBtZW51XG5cbiAgICAgKiBOb2RlUmVzb2x2ZXJcbiAgICAgKiAtLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS1cbiAgICAgKiB3ZSBuZWVkIGEgcmVmZXJlbmNlIHRvIHRoZSBzY3JvbGxhYmxlIGVsZW1lbnQgdG8gXCJ1bmxvY2tcIiBzY3JvbGwgb25cbiAgICAgKiBtb2JpbGUgZGV2aWNlc1xuXG4gICAgICogU2Nyb2xsTG9ja1xuICAgICAqIC0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLVxuICAgICAqIGFjdHVhbGx5IGRvZXMgdGhlIHNjcm9sbCBsb2NraW5nXG4gICAgICovXG4gICAgcmV0dXJuIChcbiAgICAgIDxkaXY+XG4gICAgICAgIDxkaXZcbiAgICAgICAgICBvbkNsaWNrPXt0aGlzLmJsdXJTZWxlY3RJbnB1dH1cbiAgICAgICAgICBjc3M9e3sgcG9zaXRpb246ICdmaXhlZCcsIGxlZnQ6IDAsIGJvdHRvbTogMCwgcmlnaHQ6IDAsIHRvcDogMCB9fVxuICAgICAgICAvPlxuICAgICAgICA8Tm9kZVJlc29sdmVyIGlubmVyUmVmPXt0aGlzLmdldFNjcm9sbFRhcmdldH0+e2NoaWxkcmVufTwvTm9kZVJlc29sdmVyPlxuICAgICAgICB7dG91Y2hTY3JvbGxUYXJnZXQgPyAoXG4gICAgICAgICAgPFNjcm9sbExvY2sgdG91Y2hTY3JvbGxUYXJnZXQ9e3RvdWNoU2Nyb2xsVGFyZ2V0fSAvPlxuICAgICAgICApIDogbnVsbH1cbiAgICAgIDwvZGl2PlxuICAgICk7XG4gIH1cbn1cbiJdfQ== */"
};

// NOTE:
// We shouldn't need this after updating to React v16.3.0, which introduces:
// - createRef() https://reactjs.org/docs/react-api.html#reactcreateref
// - forwardRef() https://reactjs.org/docs/react-api.html#reactforwardref
var ScrollBlock =
/*#__PURE__*/
function (_PureComponent) {
  Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_inherits__["a" /* default */])(ScrollBlock, _PureComponent);

  function ScrollBlock() {
    var _getPrototypeOf2;

    var _this;

    Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, ScrollBlock);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_possibleConstructorReturn__["a" /* default */])(this, (_getPrototypeOf2 = Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_getPrototypeOf__["a" /* default */])(ScrollBlock)).call.apply(_getPrototypeOf2, [this].concat(args)));

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "state", {
      touchScrollTarget: null
    });

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "getScrollTarget", function (ref) {
      if (ref === _this.state.touchScrollTarget) return;

      _this.setState({
        touchScrollTarget: ref
      });
    });

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "blurSelectInput", function () {
      if (document.activeElement) {
        document.activeElement.blur();
      }
    });

    return _this;
  }

  Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_createClass__["a" /* default */])(ScrollBlock, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          isEnabled = _this$props.isEnabled;
      var touchScrollTarget = this.state.touchScrollTarget; // bail early if not enabled

      if (!isEnabled) return children;
      /*
       * Div
       * ------------------------------
       * blocks scrolling on non-body elements behind the menu
        * NodeResolver
       * ------------------------------
       * we need a reference to the scrollable element to "unlock" scroll on
       * mobile devices
        * ScrollLock
       * ------------------------------
       * actually does the scroll locking
       */

      return Object(__WEBPACK_IMPORTED_MODULE_13__emotion_core__["c" /* jsx */])("div", null, Object(__WEBPACK_IMPORTED_MODULE_13__emotion_core__["c" /* jsx */])("div", {
        onClick: this.blurSelectInput,
        css: _ref$1
      }), Object(__WEBPACK_IMPORTED_MODULE_13__emotion_core__["c" /* jsx */])(NodeResolver, {
        innerRef: this.getScrollTarget
      }, children), touchScrollTarget ? Object(__WEBPACK_IMPORTED_MODULE_13__emotion_core__["c" /* jsx */])(ScrollLock, {
        touchScrollTarget: touchScrollTarget
      }) : null);
    }
  }]);

  return ScrollBlock;
}(__WEBPACK_IMPORTED_MODULE_11_react__["PureComponent"]);

var ScrollCaptor =
/*#__PURE__*/
function (_Component) {
  Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_inherits__["a" /* default */])(ScrollCaptor, _Component);

  function ScrollCaptor() {
    var _getPrototypeOf2;

    var _this;

    Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, ScrollCaptor);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_possibleConstructorReturn__["a" /* default */])(this, (_getPrototypeOf2 = Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_getPrototypeOf__["a" /* default */])(ScrollCaptor)).call.apply(_getPrototypeOf2, [this].concat(args)));

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "isBottom", false);

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "isTop", false);

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "scrollTarget", void 0);

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "touchStart", void 0);

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "cancelScroll", function (event) {
      event.preventDefault();
      event.stopPropagation();
    });

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "handleEventDelta", function (event, delta) {
      var _this$props = _this.props,
          onBottomArrive = _this$props.onBottomArrive,
          onBottomLeave = _this$props.onBottomLeave,
          onTopArrive = _this$props.onTopArrive,
          onTopLeave = _this$props.onTopLeave;
      var _this$scrollTarget = _this.scrollTarget,
          scrollTop = _this$scrollTarget.scrollTop,
          scrollHeight = _this$scrollTarget.scrollHeight,
          clientHeight = _this$scrollTarget.clientHeight;
      var target = _this.scrollTarget;
      var isDeltaPositive = delta > 0;
      var availableScroll = scrollHeight - clientHeight - scrollTop;
      var shouldCancelScroll = false; // reset bottom/top flags

      if (availableScroll > delta && _this.isBottom) {
        if (onBottomLeave) onBottomLeave(event);
        _this.isBottom = false;
      }

      if (isDeltaPositive && _this.isTop) {
        if (onTopLeave) onTopLeave(event);
        _this.isTop = false;
      } // bottom limit


      if (isDeltaPositive && delta > availableScroll) {
        if (onBottomArrive && !_this.isBottom) {
          onBottomArrive(event);
        }

        target.scrollTop = scrollHeight;
        shouldCancelScroll = true;
        _this.isBottom = true; // top limit
      } else if (!isDeltaPositive && -delta > scrollTop) {
        if (onTopArrive && !_this.isTop) {
          onTopArrive(event);
        }

        target.scrollTop = 0;
        shouldCancelScroll = true;
        _this.isTop = true;
      } // cancel scroll


      if (shouldCancelScroll) {
        _this.cancelScroll(event);
      }
    });

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "onWheel", function (event) {
      _this.handleEventDelta(event, event.deltaY);
    });

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "onTouchStart", function (event) {
      // set touch start so we can calculate touchmove delta
      _this.touchStart = event.changedTouches[0].clientY;
    });

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "onTouchMove", function (event) {
      var deltaY = _this.touchStart - event.changedTouches[0].clientY;

      _this.handleEventDelta(event, deltaY);
    });

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "getScrollTarget", function (ref) {
      _this.scrollTarget = ref;
    });

    return _this;
  }

  Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_createClass__["a" /* default */])(ScrollCaptor, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.startListening(this.scrollTarget);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.stopListening(this.scrollTarget);
    }
  }, {
    key: "startListening",
    value: function startListening(el) {
      // bail early if no element is available to attach to
      if (!el) return; // all the if statements are to appease Flow 😢

      if (typeof el.addEventListener === 'function') {
        el.addEventListener('wheel', this.onWheel, false);
      }

      if (typeof el.addEventListener === 'function') {
        el.addEventListener('touchstart', this.onTouchStart, false);
      }

      if (typeof el.addEventListener === 'function') {
        el.addEventListener('touchmove', this.onTouchMove, false);
      }
    }
  }, {
    key: "stopListening",
    value: function stopListening(el) {
      // all the if statements are to appease Flow 😢
      if (typeof el.removeEventListener === 'function') {
        el.removeEventListener('wheel', this.onWheel, false);
      }

      if (typeof el.removeEventListener === 'function') {
        el.removeEventListener('touchstart', this.onTouchStart, false);
      }

      if (typeof el.removeEventListener === 'function') {
        el.removeEventListener('touchmove', this.onTouchMove, false);
      }
    }
  }, {
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(NodeResolver, {
        innerRef: this.getScrollTarget
      }, this.props.children);
    }
  }]);

  return ScrollCaptor;
}(__WEBPACK_IMPORTED_MODULE_11_react__["Component"]);

var ScrollCaptorSwitch =
/*#__PURE__*/
function (_Component2) {
  Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_inherits__["a" /* default */])(ScrollCaptorSwitch, _Component2);

  function ScrollCaptorSwitch() {
    Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, ScrollCaptorSwitch);

    return Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_possibleConstructorReturn__["a" /* default */])(this, Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_getPrototypeOf__["a" /* default */])(ScrollCaptorSwitch).apply(this, arguments));
  }

  Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_createClass__["a" /* default */])(ScrollCaptorSwitch, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          isEnabled = _this$props2.isEnabled,
          props = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(_this$props2, ["isEnabled"]);

      return isEnabled ? __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(ScrollCaptor, props) : this.props.children;
    }
  }]);

  return ScrollCaptorSwitch;
}(__WEBPACK_IMPORTED_MODULE_11_react__["Component"]);

Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(ScrollCaptorSwitch, "defaultProps", {
  isEnabled: true
});

var instructionsAriaMessage = function instructionsAriaMessage(event) {
  var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var isSearchable = context.isSearchable,
      isMulti = context.isMulti,
      label = context.label,
      isDisabled = context.isDisabled;

  switch (event) {
    case 'menu':
      return "Use Up and Down to choose options".concat(isDisabled ? '' : ', press Enter to select the currently focused option', ", press Escape to exit the menu, press Tab to select the option and exit the menu.");

    case 'input':
      return "".concat(label ? label : 'Select', " is focused ").concat(isSearchable ? ',type to refine list' : '', ", press Down to open the menu, ").concat(isMulti ? ' press left to focus selected values' : '');

    case 'value':
      return 'Use left and right to toggle between focused values, press Backspace to remove the currently focused value';
  }
};
var valueEventAriaMessage = function valueEventAriaMessage(event, context) {
  var value = context.value,
      isDisabled = context.isDisabled;
  if (!value) return;

  switch (event) {
    case 'deselect-option':
    case 'pop-value':
    case 'remove-value':
      return "option ".concat(value, ", deselected.");

    case 'select-option':
      return isDisabled ? "option ".concat(value, " is disabled. Select another option.") : "option ".concat(value, ", selected.");
  }
};
var valueFocusAriaMessage = function valueFocusAriaMessage(_ref) {
  var focusedValue = _ref.focusedValue,
      getOptionLabel = _ref.getOptionLabel,
      selectValue = _ref.selectValue;
  return "value ".concat(getOptionLabel(focusedValue), " focused, ").concat(selectValue.indexOf(focusedValue) + 1, " of ").concat(selectValue.length, ".");
};
var optionFocusAriaMessage = function optionFocusAriaMessage(_ref2) {
  var focusedOption = _ref2.focusedOption,
      getOptionLabel = _ref2.getOptionLabel,
      options = _ref2.options;
  return "option ".concat(getOptionLabel(focusedOption), " focused").concat(focusedOption.isDisabled ? ' disabled' : '', ", ").concat(options.indexOf(focusedOption) + 1, " of ").concat(options.length, ".");
};
var resultsAriaMessage = function resultsAriaMessage(_ref3) {
  var inputValue = _ref3.inputValue,
      screenReaderMessage = _ref3.screenReaderMessage;
  return "".concat(screenReaderMessage).concat(inputValue ? ' for search term ' + inputValue : '', ".");
};

var formatGroupLabel = function formatGroupLabel(group) {
  return group.label;
};
var getOptionLabel = function getOptionLabel(option) {
  return option.label;
};
var getOptionValue = function getOptionValue(option) {
  return option.value;
};
var isOptionDisabled = function isOptionDisabled(option) {
  return !!option.isDisabled;
};

var defaultStyles = {
  clearIndicator: __WEBPACK_IMPORTED_MODULE_16__chunk_80640036_browser_esm_js__["d" /* c */],
  container: __WEBPACK_IMPORTED_MODULE_16__chunk_80640036_browser_esm_js__["b" /* a */],
  control: __WEBPACK_IMPORTED_MODULE_16__chunk_80640036_browser_esm_js__["c" /* b */],
  dropdownIndicator: __WEBPACK_IMPORTED_MODULE_16__chunk_80640036_browser_esm_js__["e" /* d */],
  group: __WEBPACK_IMPORTED_MODULE_16__chunk_80640036_browser_esm_js__["h" /* g */],
  groupHeading: __WEBPACK_IMPORTED_MODULE_16__chunk_80640036_browser_esm_js__["f" /* e */],
  indicatorsContainer: __WEBPACK_IMPORTED_MODULE_16__chunk_80640036_browser_esm_js__["j" /* i */],
  indicatorSeparator: __WEBPACK_IMPORTED_MODULE_16__chunk_80640036_browser_esm_js__["g" /* f */],
  input: __WEBPACK_IMPORTED_MODULE_16__chunk_80640036_browser_esm_js__["i" /* h */],
  loadingIndicator: __WEBPACK_IMPORTED_MODULE_16__chunk_80640036_browser_esm_js__["m" /* l */],
  loadingMessage: __WEBPACK_IMPORTED_MODULE_16__chunk_80640036_browser_esm_js__["k" /* j */],
  menu: __WEBPACK_IMPORTED_MODULE_16__chunk_80640036_browser_esm_js__["n" /* m */],
  menuList: __WEBPACK_IMPORTED_MODULE_16__chunk_80640036_browser_esm_js__["l" /* k */],
  menuPortal: __WEBPACK_IMPORTED_MODULE_16__chunk_80640036_browser_esm_js__["o" /* n */],
  multiValue: __WEBPACK_IMPORTED_MODULE_16__chunk_80640036_browser_esm_js__["p" /* o */],
  multiValueLabel: __WEBPACK_IMPORTED_MODULE_16__chunk_80640036_browser_esm_js__["q" /* p */],
  multiValueRemove: __WEBPACK_IMPORTED_MODULE_16__chunk_80640036_browser_esm_js__["r" /* q */],
  noOptionsMessage: __WEBPACK_IMPORTED_MODULE_16__chunk_80640036_browser_esm_js__["s" /* r */],
  option: __WEBPACK_IMPORTED_MODULE_16__chunk_80640036_browser_esm_js__["t" /* s */],
  placeholder: __WEBPACK_IMPORTED_MODULE_16__chunk_80640036_browser_esm_js__["u" /* t */],
  singleValue: __WEBPACK_IMPORTED_MODULE_16__chunk_80640036_browser_esm_js__["v" /* u */],
  valueContainer: __WEBPACK_IMPORTED_MODULE_16__chunk_80640036_browser_esm_js__["w" /* v */]
}; // Merge Utility
// Allows consumers to extend a base Select with additional styles

function mergeStyles(source) {
  var target = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  // initialize with source styles
  var styles = Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_objectSpread__["a" /* default */])({}, source); // massage in target styles


  Object.keys(target).forEach(function (key) {
    if (source[key]) {
      styles[key] = function (rsCss, props) {
        return target[key](source[key](rsCss, props), props);
      };
    } else {
      styles[key] = target[key];
    }
  });
  return styles;
}

var colors = {
  primary: '#2684FF',
  primary75: '#4C9AFF',
  primary50: '#B2D4FF',
  primary25: '#DEEBFF',
  danger: '#DE350B',
  dangerLight: '#FFBDAD',
  neutral0: 'hsl(0, 0%, 100%)',
  neutral5: 'hsl(0, 0%, 95%)',
  neutral10: 'hsl(0, 0%, 90%)',
  neutral20: 'hsl(0, 0%, 80%)',
  neutral30: 'hsl(0, 0%, 70%)',
  neutral40: 'hsl(0, 0%, 60%)',
  neutral50: 'hsl(0, 0%, 50%)',
  neutral60: 'hsl(0, 0%, 40%)',
  neutral70: 'hsl(0, 0%, 30%)',
  neutral80: 'hsl(0, 0%, 20%)',
  neutral90: 'hsl(0, 0%, 10%)'
};
var borderRadius = 4; // Used to calculate consistent margin/padding on elements

var baseUnit = 4; // The minimum height of the control

var controlHeight = 38; // The amount of space between the control and menu */

var menuGutter = baseUnit * 2;
var spacing = {
  baseUnit: baseUnit,
  controlHeight: controlHeight,
  menuGutter: menuGutter
};
var defaultTheme = {
  borderRadius: borderRadius,
  colors: colors,
  spacing: spacing
};

var defaultProps = {
  backspaceRemovesValue: true,
  blurInputOnSelect: Object(__WEBPACK_IMPORTED_MODULE_15__chunk_39d3fda8_browser_esm_js__["i"])(),
  captureMenuScroll: !Object(__WEBPACK_IMPORTED_MODULE_15__chunk_39d3fda8_browser_esm_js__["i"])(),
  closeMenuOnSelect: true,
  closeMenuOnScroll: false,
  components: {},
  controlShouldRenderValue: true,
  escapeClearsValue: false,
  filterOption: createFilter(),
  formatGroupLabel: formatGroupLabel,
  getOptionLabel: getOptionLabel,
  getOptionValue: getOptionValue,
  isDisabled: false,
  isLoading: false,
  isMulti: false,
  isRtl: false,
  isSearchable: true,
  isOptionDisabled: isOptionDisabled,
  loadingMessage: function loadingMessage() {
    return 'Loading...';
  },
  maxMenuHeight: 300,
  minMenuHeight: 140,
  menuIsOpen: false,
  menuPlacement: 'bottom',
  menuPosition: 'absolute',
  menuShouldBlockScroll: false,
  menuShouldScrollIntoView: !Object(__WEBPACK_IMPORTED_MODULE_15__chunk_39d3fda8_browser_esm_js__["d"])(),
  noOptionsMessage: function noOptionsMessage() {
    return 'No options';
  },
  openMenuOnFocus: false,
  openMenuOnClick: true,
  options: [],
  pageSize: 5,
  placeholder: 'Select...',
  screenReaderStatus: function screenReaderStatus(_ref) {
    var count = _ref.count;
    return "".concat(count, " result").concat(count !== 1 ? 's' : '', " available");
  },
  styles: {},
  tabIndex: '0',
  tabSelectsValue: true
};
var instanceId = 1;

var Select =
/*#__PURE__*/
function (_Component) {
  Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_inherits__["a" /* default */])(Select, _Component);

  // Misc. Instance Properties
  // ------------------------------
  // TODO
  // Refs
  // ------------------------------
  // Lifecycle
  // ------------------------------
  function Select(_props) {
    var _this;

    Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, Select);

    _this = Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_possibleConstructorReturn__["a" /* default */])(this, Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_getPrototypeOf__["a" /* default */])(Select).call(this, _props));

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "state", {
      ariaLiveSelection: '',
      ariaLiveContext: '',
      focusedOption: null,
      focusedValue: null,
      inputIsHidden: false,
      isFocused: false,
      menuOptions: {
        render: [],
        focusable: []
      },
      selectValue: []
    });

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "blockOptionHover", false);

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "isComposing", false);

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "clearFocusValueOnUpdate", false);

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "commonProps", void 0);

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "components", void 0);

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "hasGroups", false);

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "initialTouchX", 0);

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "initialTouchY", 0);

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "inputIsHiddenAfterUpdate", void 0);

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "instancePrefix", '');

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "openAfterFocus", false);

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "scrollToFocusedOptionOnUpdate", false);

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "userIsDragging", void 0);

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "controlRef", null);

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "getControlRef", function (ref) {
      _this.controlRef = ref;
    });

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "focusedOptionRef", null);

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "getFocusedOptionRef", function (ref) {
      _this.focusedOptionRef = ref;
    });

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "menuListRef", null);

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "getMenuListRef", function (ref) {
      _this.menuListRef = ref;
    });

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "inputRef", null);

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "getInputRef", function (ref) {
      _this.inputRef = ref;
    });

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "cacheComponents", function (components) {
      _this.components = Object(__WEBPACK_IMPORTED_MODULE_16__chunk_80640036_browser_esm_js__["x" /* w */])({
        components: components
      });
    });

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "focus", _this.focusInput);

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "blur", _this.blurInput);

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "onChange", function (newValue, actionMeta) {
      var _this$props = _this.props,
          onChange = _this$props.onChange,
          name = _this$props.name;
      onChange(newValue, Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_objectSpread__["a" /* default */])({}, actionMeta, {
        name: name
      }));
    });

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "setValue", function (newValue) {
      var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'set-value';
      var option = arguments.length > 2 ? arguments[2] : undefined;
      var _this$props2 = _this.props,
          closeMenuOnSelect = _this$props2.closeMenuOnSelect,
          isMulti = _this$props2.isMulti;

      _this.onInputChange('', {
        action: 'set-value'
      });

      if (closeMenuOnSelect) {
        _this.inputIsHiddenAfterUpdate = !isMulti;

        _this.onMenuClose();
      } // when the select value should change, we should reset focusedValue


      _this.clearFocusValueOnUpdate = true;

      _this.onChange(newValue, {
        action: action,
        option: option
      });
    });

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "selectOption", function (newValue) {
      var _this$props3 = _this.props,
          blurInputOnSelect = _this$props3.blurInputOnSelect,
          isMulti = _this$props3.isMulti;
      var selectValue = _this.state.selectValue;

      if (isMulti) {
        if (_this.isOptionSelected(newValue, selectValue)) {
          var candidate = _this.getOptionValue(newValue);

          _this.setValue(selectValue.filter(function (i) {
            return _this.getOptionValue(i) !== candidate;
          }), 'deselect-option', newValue);

          _this.announceAriaLiveSelection({
            event: 'deselect-option',
            context: {
              value: _this.getOptionLabel(newValue)
            }
          });
        } else {
          if (!_this.isOptionDisabled(newValue, selectValue)) {
            _this.setValue([].concat(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_toConsumableArray__["a" /* default */])(selectValue), [newValue]), 'select-option', newValue);

            _this.announceAriaLiveSelection({
              event: 'select-option',
              context: {
                value: _this.getOptionLabel(newValue)
              }
            });
          } else {
            // announce that option is disabled
            _this.announceAriaLiveSelection({
              event: 'select-option',
              context: {
                value: _this.getOptionLabel(newValue),
                isDisabled: true
              }
            });
          }
        }
      } else {
        if (!_this.isOptionDisabled(newValue, selectValue)) {
          _this.setValue(newValue, 'select-option');

          _this.announceAriaLiveSelection({
            event: 'select-option',
            context: {
              value: _this.getOptionLabel(newValue)
            }
          });
        } else {
          // announce that option is disabled
          _this.announceAriaLiveSelection({
            event: 'select-option',
            context: {
              value: _this.getOptionLabel(newValue),
              isDisabled: true
            }
          });
        }
      }

      if (blurInputOnSelect) {
        _this.blurInput();
      }
    });

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "removeValue", function (removedValue) {
      var selectValue = _this.state.selectValue;

      var candidate = _this.getOptionValue(removedValue);

      var newValue = selectValue.filter(function (i) {
        return _this.getOptionValue(i) !== candidate;
      });

      _this.onChange(newValue.length ? newValue : null, {
        action: 'remove-value',
        removedValue: removedValue
      });

      _this.announceAriaLiveSelection({
        event: 'remove-value',
        context: {
          value: removedValue ? _this.getOptionLabel(removedValue) : ''
        }
      });

      _this.focusInput();
    });

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "clearValue", function () {
      var isMulti = _this.props.isMulti;

      _this.onChange(isMulti ? [] : null, {
        action: 'clear'
      });
    });

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "popValue", function () {
      var selectValue = _this.state.selectValue;
      var lastSelectedValue = selectValue[selectValue.length - 1];
      var newValue = selectValue.slice(0, selectValue.length - 1);

      _this.announceAriaLiveSelection({
        event: 'pop-value',
        context: {
          value: lastSelectedValue ? _this.getOptionLabel(lastSelectedValue) : ''
        }
      });

      _this.onChange(newValue.length ? newValue : null, {
        action: 'pop-value',
        removedValue: lastSelectedValue
      });
    });

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "getOptionLabel", function (data) {
      return _this.props.getOptionLabel(data);
    });

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "getOptionValue", function (data) {
      return _this.props.getOptionValue(data);
    });

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "getStyles", function (key, props) {
      var base = defaultStyles[key](props);
      base.boxSizing = 'border-box';
      var custom = _this.props.styles[key];
      return custom ? custom(base, props) : base;
    });

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "getElementId", function (element) {
      return "".concat(_this.instancePrefix, "-").concat(element);
    });

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "getActiveDescendentId", function () {
      var menuIsOpen = _this.props.menuIsOpen;
      var _this$state = _this.state,
          menuOptions = _this$state.menuOptions,
          focusedOption = _this$state.focusedOption;
      if (!focusedOption || !menuIsOpen) return undefined;
      var index = menuOptions.focusable.indexOf(focusedOption);
      var option = menuOptions.render[index];
      return option && option.key;
    });

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "announceAriaLiveSelection", function (_ref2) {
      var event = _ref2.event,
          context = _ref2.context;

      _this.setState({
        ariaLiveSelection: valueEventAriaMessage(event, context)
      });
    });

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "announceAriaLiveContext", function (_ref3) {
      var event = _ref3.event,
          context = _ref3.context;

      _this.setState({
        ariaLiveContext: instructionsAriaMessage(event, Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_objectSpread__["a" /* default */])({}, context, {
          label: _this.props['aria-label']
        }))
      });
    });

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "onMenuMouseDown", function (event) {
      if (event.button !== 0) {
        return;
      }

      event.stopPropagation();
      event.preventDefault();

      _this.focusInput();
    });

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "onMenuMouseMove", function (event) {
      _this.blockOptionHover = false;
    });

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "onControlMouseDown", function (event) {
      var openMenuOnClick = _this.props.openMenuOnClick;

      if (!_this.state.isFocused) {
        if (openMenuOnClick) {
          _this.openAfterFocus = true;
        }

        _this.focusInput();
      } else if (!_this.props.menuIsOpen) {
        if (openMenuOnClick) {
          _this.openMenu('first');
        }
      } else {
        //$FlowFixMe
        if (event.target.tagName !== 'INPUT') {
          _this.onMenuClose();
        }
      } //$FlowFixMe


      if (event.target.tagName !== 'INPUT') {
        event.preventDefault();
      }
    });

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "onDropdownIndicatorMouseDown", function (event) {
      // ignore mouse events that weren't triggered by the primary button
      if (event && event.type === 'mousedown' && event.button !== 0) {
        return;
      }

      if (_this.props.isDisabled) return;
      var _this$props4 = _this.props,
          isMulti = _this$props4.isMulti,
          menuIsOpen = _this$props4.menuIsOpen;

      _this.focusInput();

      if (menuIsOpen) {
        _this.inputIsHiddenAfterUpdate = !isMulti;

        _this.onMenuClose();
      } else {
        _this.openMenu('first');
      }

      event.preventDefault();
      event.stopPropagation();
    });

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "onClearIndicatorMouseDown", function (event) {
      // ignore mouse events that weren't triggered by the primary button
      if (event && event.type === 'mousedown' && event.button !== 0) {
        return;
      }

      _this.clearValue();

      event.stopPropagation();
      _this.openAfterFocus = false;

      if (event.type === 'touchend') {
        _this.focusInput();
      } else {
        setTimeout(function () {
          return _this.focusInput();
        });
      }
    });

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "onScroll", function (event) {
      if (typeof _this.props.closeMenuOnScroll === 'boolean') {
        if (event.target instanceof HTMLElement && Object(__WEBPACK_IMPORTED_MODULE_15__chunk_39d3fda8_browser_esm_js__["e"])(event.target)) {
          _this.props.onMenuClose();
        }
      } else if (typeof _this.props.closeMenuOnScroll === 'function') {
        if (_this.props.closeMenuOnScroll(event)) {
          _this.props.onMenuClose();
        }
      }
    });

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "onCompositionStart", function () {
      _this.isComposing = true;
    });

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "onCompositionEnd", function () {
      _this.isComposing = false;
    });

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "onTouchStart", function (_ref4) {
      var touches = _ref4.touches;
      var touch = touches.item(0);

      if (!touch) {
        return;
      }

      _this.initialTouchX = touch.clientX;
      _this.initialTouchY = touch.clientY;
      _this.userIsDragging = false;
    });

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "onTouchMove", function (_ref5) {
      var touches = _ref5.touches;
      var touch = touches.item(0);

      if (!touch) {
        return;
      }

      var deltaX = Math.abs(touch.clientX - _this.initialTouchX);
      var deltaY = Math.abs(touch.clientY - _this.initialTouchY);
      var moveThreshold = 5;
      _this.userIsDragging = deltaX > moveThreshold || deltaY > moveThreshold;
    });

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "onTouchEnd", function (event) {
      if (_this.userIsDragging) return; // close the menu if the user taps outside
      // we're checking on event.target here instead of event.currentTarget, because we want to assert information
      // on events on child elements, not the document (which we've attached this handler to).

      if (_this.controlRef && !_this.controlRef.contains(event.target) && _this.menuListRef && !_this.menuListRef.contains(event.target)) {
        _this.blurInput();
      } // reset move vars


      _this.initialTouchX = 0;
      _this.initialTouchY = 0;
    });

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "onControlTouchEnd", function (event) {
      if (_this.userIsDragging) return;

      _this.onControlMouseDown(event);
    });

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "onClearIndicatorTouchEnd", function (event) {
      if (_this.userIsDragging) return;

      _this.onClearIndicatorMouseDown(event);
    });

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "onDropdownIndicatorTouchEnd", function (event) {
      if (_this.userIsDragging) return;

      _this.onDropdownIndicatorMouseDown(event);
    });

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "handleInputChange", function (event) {
      var inputValue = event.currentTarget.value;
      _this.inputIsHiddenAfterUpdate = false;

      _this.onInputChange(inputValue, {
        action: 'input-change'
      });

      _this.onMenuOpen();
    });

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "onInputFocus", function (event) {
      var _this$props5 = _this.props,
          isSearchable = _this$props5.isSearchable,
          isMulti = _this$props5.isMulti;

      if (_this.props.onFocus) {
        _this.props.onFocus(event);
      }

      _this.inputIsHiddenAfterUpdate = false;

      _this.announceAriaLiveContext({
        event: 'input',
        context: {
          isSearchable: isSearchable,
          isMulti: isMulti
        }
      });

      _this.setState({
        isFocused: true
      });

      if (_this.openAfterFocus || _this.props.openMenuOnFocus) {
        _this.openMenu('first');
      }

      _this.openAfterFocus = false;
    });

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "onInputBlur", function (event) {
      if (_this.menuListRef && _this.menuListRef.contains(document.activeElement)) {
        _this.inputRef.focus();

        return;
      }

      if (_this.props.onBlur) {
        _this.props.onBlur(event);
      }

      _this.onInputChange('', {
        action: 'input-blur'
      });

      _this.onMenuClose();

      _this.setState({
        focusedValue: null,
        isFocused: false
      });
    });

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "onOptionHover", function (focusedOption) {
      if (_this.blockOptionHover || _this.state.focusedOption === focusedOption) {
        return;
      }

      _this.setState({
        focusedOption: focusedOption
      });
    });

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "shouldHideSelectedOptions", function () {
      var _this$props6 = _this.props,
          hideSelectedOptions = _this$props6.hideSelectedOptions,
          isMulti = _this$props6.isMulti;
      if (hideSelectedOptions === undefined) return isMulti;
      return hideSelectedOptions;
    });

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "onKeyDown", function (event) {
      var _this$props7 = _this.props,
          isMulti = _this$props7.isMulti,
          backspaceRemovesValue = _this$props7.backspaceRemovesValue,
          escapeClearsValue = _this$props7.escapeClearsValue,
          inputValue = _this$props7.inputValue,
          isClearable = _this$props7.isClearable,
          isDisabled = _this$props7.isDisabled,
          menuIsOpen = _this$props7.menuIsOpen,
          onKeyDown = _this$props7.onKeyDown,
          tabSelectsValue = _this$props7.tabSelectsValue,
          openMenuOnFocus = _this$props7.openMenuOnFocus;
      var _this$state2 = _this.state,
          focusedOption = _this$state2.focusedOption,
          focusedValue = _this$state2.focusedValue,
          selectValue = _this$state2.selectValue;
      if (isDisabled) return;

      if (typeof onKeyDown === 'function') {
        onKeyDown(event);

        if (event.defaultPrevented) {
          return;
        }
      } // Block option hover events when the user has just pressed a key


      _this.blockOptionHover = true;

      switch (event.key) {
        case 'ArrowLeft':
          if (!isMulti || inputValue) return;

          _this.focusValue('previous');

          break;

        case 'ArrowRight':
          if (!isMulti || inputValue) return;

          _this.focusValue('next');

          break;

        case 'Delete':
        case 'Backspace':
          if (inputValue) return;

          if (focusedValue) {
            _this.removeValue(focusedValue);
          } else {
            if (!backspaceRemovesValue) return;

            if (isMulti) {
              _this.popValue();
            } else if (isClearable) {
              _this.clearValue();
            }
          }

          break;

        case 'Tab':
          if (_this.isComposing) return;

          if (event.shiftKey || !menuIsOpen || !tabSelectsValue || !focusedOption || // don't capture the event if the menu opens on focus and the focused
          // option is already selected; it breaks the flow of navigation
          openMenuOnFocus && _this.isOptionSelected(focusedOption, selectValue)) {
            return;
          }

          _this.selectOption(focusedOption);

          break;

        case 'Enter':
          if (event.keyCode === 229) {
            // ignore the keydown event from an Input Method Editor(IME)
            // ref. https://www.w3.org/TR/uievents/#determine-keydown-keyup-keyCode
            break;
          }

          if (menuIsOpen) {
            if (!focusedOption) return;
            if (_this.isComposing) return;

            _this.selectOption(focusedOption);

            break;
          }

          return;

        case 'Escape':
          if (menuIsOpen) {
            _this.inputIsHiddenAfterUpdate = false;

            _this.onInputChange('', {
              action: 'menu-close'
            });

            _this.onMenuClose();
          } else if (isClearable && escapeClearsValue) {
            _this.clearValue();
          }

          break;

        case ' ':
          // space
          if (inputValue) {
            return;
          }

          if (!menuIsOpen) {
            _this.openMenu('first');

            break;
          }

          if (!focusedOption) return;

          _this.selectOption(focusedOption);

          break;

        case 'ArrowUp':
          if (menuIsOpen) {
            _this.focusOption('up');
          } else {
            _this.openMenu('last');
          }

          break;

        case 'ArrowDown':
          if (menuIsOpen) {
            _this.focusOption('down');
          } else {
            _this.openMenu('first');
          }

          break;

        case 'PageUp':
          if (!menuIsOpen) return;

          _this.focusOption('pageup');

          break;

        case 'PageDown':
          if (!menuIsOpen) return;

          _this.focusOption('pagedown');

          break;

        case 'Home':
          if (!menuIsOpen) return;

          _this.focusOption('first');

          break;

        case 'End':
          if (!menuIsOpen) return;

          _this.focusOption('last');

          break;

        default:
          return;
      }

      event.preventDefault();
    });

    var value = _props.value;
    _this.cacheComponents = Object(__WEBPACK_IMPORTED_MODULE_12_memoize_one__["a" /* default */])(_this.cacheComponents, __WEBPACK_IMPORTED_MODULE_16__chunk_80640036_browser_esm_js__["y" /* x */]).bind(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));

    _this.cacheComponents(_props.components);

    _this.instancePrefix = 'react-select-' + (_this.props.instanceId || ++instanceId);

    var _selectValue = Object(__WEBPACK_IMPORTED_MODULE_15__chunk_39d3fda8_browser_esm_js__["f"])(value);

    var _menuOptions = _props.menuIsOpen ? _this.buildMenuOptions(_props, _selectValue) : {
      render: [],
      focusable: []
    };

    _this.state.menuOptions = _menuOptions;
    _this.state.selectValue = _selectValue;
    return _this;
  }

  Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_createClass__["a" /* default */])(Select, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.startListeningComposition();
      this.startListeningToTouch();

      if (this.props.closeMenuOnScroll && document && document.addEventListener) {
        // Listen to all scroll events, and filter them out inside of 'onScroll'
        document.addEventListener('scroll', this.onScroll, true);
      }

      if (this.props.autoFocus) {
        this.focusInput();
      }
    }
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      var _this$props8 = this.props,
          options = _this$props8.options,
          value = _this$props8.value,
          menuIsOpen = _this$props8.menuIsOpen,
          inputValue = _this$props8.inputValue; // re-cache custom components

      this.cacheComponents(nextProps.components); // rebuild the menu options

      if (nextProps.value !== value || nextProps.options !== options || nextProps.menuIsOpen !== menuIsOpen || nextProps.inputValue !== inputValue) {
        var selectValue = Object(__WEBPACK_IMPORTED_MODULE_15__chunk_39d3fda8_browser_esm_js__["f"])(nextProps.value);
        var menuOptions = nextProps.menuIsOpen ? this.buildMenuOptions(nextProps, selectValue) : {
          render: [],
          focusable: []
        };
        var focusedValue = this.getNextFocusedValue(selectValue);
        var focusedOption = this.getNextFocusedOption(menuOptions.focusable);
        this.setState({
          menuOptions: menuOptions,
          selectValue: selectValue,
          focusedOption: focusedOption,
          focusedValue: focusedValue
        });
      } // some updates should toggle the state of the input visibility


      if (this.inputIsHiddenAfterUpdate != null) {
        this.setState({
          inputIsHidden: this.inputIsHiddenAfterUpdate
        });
        delete this.inputIsHiddenAfterUpdate;
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props9 = this.props,
          isDisabled = _this$props9.isDisabled,
          menuIsOpen = _this$props9.menuIsOpen;
      var isFocused = this.state.isFocused;

      if ( // ensure focus is restored correctly when the control becomes enabled
      isFocused && !isDisabled && prevProps.isDisabled || // ensure focus is on the Input when the menu opens
      isFocused && menuIsOpen && !prevProps.menuIsOpen) {
        this.focusInput();
      } // scroll the focused option into view if necessary


      if (this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate) {
        Object(__WEBPACK_IMPORTED_MODULE_15__chunk_39d3fda8_browser_esm_js__["h"])(this.menuListRef, this.focusedOptionRef);
      }

      this.scrollToFocusedOptionOnUpdate = false;
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.stopListeningComposition();
      this.stopListeningToTouch();
      document.removeEventListener('scroll', this.onScroll, true);
    }
  }, {
    key: "onMenuOpen",
    // ==============================
    // Consumer Handlers
    // ==============================
    value: function onMenuOpen() {
      this.props.onMenuOpen();
    }
  }, {
    key: "onMenuClose",
    value: function onMenuClose() {
      var _this$props10 = this.props,
          isSearchable = _this$props10.isSearchable,
          isMulti = _this$props10.isMulti;
      this.announceAriaLiveContext({
        event: 'input',
        context: {
          isSearchable: isSearchable,
          isMulti: isMulti
        }
      });
      this.onInputChange('', {
        action: 'menu-close'
      });
      this.props.onMenuClose();
    }
  }, {
    key: "onInputChange",
    value: function onInputChange(newValue, actionMeta) {
      this.props.onInputChange(newValue, actionMeta);
    } // ==============================
    // Methods
    // ==============================

  }, {
    key: "focusInput",
    value: function focusInput() {
      if (!this.inputRef) return;
      this.inputRef.focus();
    }
  }, {
    key: "blurInput",
    value: function blurInput() {
      if (!this.inputRef) return;
      this.inputRef.blur();
    } // aliased for consumers

  }, {
    key: "openMenu",
    value: function openMenu(focusOption) {
      var _this$state3 = this.state,
          menuOptions = _this$state3.menuOptions,
          selectValue = _this$state3.selectValue,
          isFocused = _this$state3.isFocused;
      var isMulti = this.props.isMulti;
      var openAtIndex = focusOption === 'first' ? 0 : menuOptions.focusable.length - 1;

      if (!isMulti) {
        var selectedIndex = menuOptions.focusable.indexOf(selectValue[0]);

        if (selectedIndex > -1) {
          openAtIndex = selectedIndex;
        }
      } // only scroll if the menu isn't already open


      this.scrollToFocusedOptionOnUpdate = !(isFocused && this.menuListRef);
      this.inputIsHiddenAfterUpdate = false;
      this.onMenuOpen();
      this.setState({
        focusedValue: null,
        focusedOption: menuOptions.focusable[openAtIndex]
      });
      this.announceAriaLiveContext({
        event: 'menu'
      });
    }
  }, {
    key: "focusValue",
    value: function focusValue(direction) {
      var _this$props11 = this.props,
          isMulti = _this$props11.isMulti,
          isSearchable = _this$props11.isSearchable;
      var _this$state4 = this.state,
          selectValue = _this$state4.selectValue,
          focusedValue = _this$state4.focusedValue; // Only multiselects support value focusing

      if (!isMulti) return;
      this.setState({
        focusedOption: null
      });
      var focusedIndex = selectValue.indexOf(focusedValue);

      if (!focusedValue) {
        focusedIndex = -1;
        this.announceAriaLiveContext({
          event: 'value'
        });
      }

      var lastIndex = selectValue.length - 1;
      var nextFocus = -1;
      if (!selectValue.length) return;

      switch (direction) {
        case 'previous':
          if (focusedIndex === 0) {
            // don't cycle from the start to the end
            nextFocus = 0;
          } else if (focusedIndex === -1) {
            // if nothing is focused, focus the last value first
            nextFocus = lastIndex;
          } else {
            nextFocus = focusedIndex - 1;
          }

          break;

        case 'next':
          if (focusedIndex > -1 && focusedIndex < lastIndex) {
            nextFocus = focusedIndex + 1;
          }

          break;
      }

      if (nextFocus === -1) {
        this.announceAriaLiveContext({
          event: 'input',
          context: {
            isSearchable: isSearchable,
            isMulti: isMulti
          }
        });
      }

      this.setState({
        inputIsHidden: nextFocus !== -1,
        focusedValue: selectValue[nextFocus]
      });
    }
  }, {
    key: "focusOption",
    value: function focusOption() {
      var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'first';
      var pageSize = this.props.pageSize;
      var _this$state5 = this.state,
          focusedOption = _this$state5.focusedOption,
          menuOptions = _this$state5.menuOptions;
      var options = menuOptions.focusable;
      if (!options.length) return;
      var nextFocus = 0; // handles 'first'

      var focusedIndex = options.indexOf(focusedOption);

      if (!focusedOption) {
        focusedIndex = -1;
        this.announceAriaLiveContext({
          event: 'menu'
        });
      }

      if (direction === 'up') {
        nextFocus = focusedIndex > 0 ? focusedIndex - 1 : options.length - 1;
      } else if (direction === 'down') {
        nextFocus = (focusedIndex + 1) % options.length;
      } else if (direction === 'pageup') {
        nextFocus = focusedIndex - pageSize;
        if (nextFocus < 0) nextFocus = 0;
      } else if (direction === 'pagedown') {
        nextFocus = focusedIndex + pageSize;
        if (nextFocus > options.length - 1) nextFocus = options.length - 1;
      } else if (direction === 'last') {
        nextFocus = options.length - 1;
      }

      this.scrollToFocusedOptionOnUpdate = true;
      this.setState({
        focusedOption: options[nextFocus],
        focusedValue: null
      });
      this.announceAriaLiveContext({
        event: 'menu',
        context: {
          isDisabled: isOptionDisabled(options[nextFocus])
        }
      });
    }
  }, {
    key: "getTheme",
    // ==============================
    // Getters
    // ==============================
    value: function getTheme() {
      // Use the default theme if there are no customizations.
      if (!this.props.theme) {
        return defaultTheme;
      } // If the theme prop is a function, assume the function
      // knows how to merge the passed-in default theme with
      // its own modifications.


      if (typeof this.props.theme === 'function') {
        return this.props.theme(defaultTheme);
      } // Otherwise, if a plain theme object was passed in,
      // overlay it with the default theme.


      return Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_objectSpread__["a" /* default */])({}, defaultTheme, this.props.theme);
    }
  }, {
    key: "getCommonProps",
    value: function getCommonProps() {
      var clearValue = this.clearValue,
          getStyles = this.getStyles,
          setValue = this.setValue,
          selectOption = this.selectOption,
          props = this.props;
      var classNamePrefix = props.classNamePrefix,
          isMulti = props.isMulti,
          isRtl = props.isRtl,
          options = props.options;
      var selectValue = this.state.selectValue;
      var hasValue = this.hasValue();

      var getValue = function getValue() {
        return selectValue;
      };

      var cx = __WEBPACK_IMPORTED_MODULE_15__chunk_39d3fda8_browser_esm_js__["j"].bind(null, classNamePrefix);
      return {
        cx: cx,
        clearValue: clearValue,
        getStyles: getStyles,
        getValue: getValue,
        hasValue: hasValue,
        isMulti: isMulti,
        isRtl: isRtl,
        options: options,
        selectOption: selectOption,
        setValue: setValue,
        selectProps: props,
        theme: this.getTheme()
      };
    }
  }, {
    key: "getNextFocusedValue",
    value: function getNextFocusedValue(nextSelectValue) {
      if (this.clearFocusValueOnUpdate) {
        this.clearFocusValueOnUpdate = false;
        return null;
      }

      var _this$state6 = this.state,
          focusedValue = _this$state6.focusedValue,
          lastSelectValue = _this$state6.selectValue;
      var lastFocusedIndex = lastSelectValue.indexOf(focusedValue);

      if (lastFocusedIndex > -1) {
        var nextFocusedIndex = nextSelectValue.indexOf(focusedValue);

        if (nextFocusedIndex > -1) {
          // the focused value is still in the selectValue, return it
          return focusedValue;
        } else if (lastFocusedIndex < nextSelectValue.length) {
          // the focusedValue is not present in the next selectValue array by
          // reference, so return the new value at the same index
          return nextSelectValue[lastFocusedIndex];
        }
      }

      return null;
    }
  }, {
    key: "getNextFocusedOption",
    value: function getNextFocusedOption(options) {
      var lastFocusedOption = this.state.focusedOption;
      return lastFocusedOption && options.indexOf(lastFocusedOption) > -1 ? lastFocusedOption : options[0];
    }
  }, {
    key: "hasValue",
    value: function hasValue() {
      var selectValue = this.state.selectValue;
      return selectValue.length > 0;
    }
  }, {
    key: "hasOptions",
    value: function hasOptions() {
      return !!this.state.menuOptions.render.length;
    }
  }, {
    key: "countOptions",
    value: function countOptions() {
      return this.state.menuOptions.focusable.length;
    }
  }, {
    key: "isClearable",
    value: function isClearable() {
      var _this$props12 = this.props,
          isClearable = _this$props12.isClearable,
          isMulti = _this$props12.isMulti; // single select, by default, IS NOT clearable
      // multi select, by default, IS clearable

      if (isClearable === undefined) return isMulti;
      return isClearable;
    }
  }, {
    key: "isOptionDisabled",
    value: function isOptionDisabled(option, selectValue) {
      return typeof this.props.isOptionDisabled === 'function' ? this.props.isOptionDisabled(option, selectValue) : false;
    }
  }, {
    key: "isOptionSelected",
    value: function isOptionSelected(option, selectValue) {
      var _this2 = this;

      if (selectValue.indexOf(option) > -1) return true;

      if (typeof this.props.isOptionSelected === 'function') {
        return this.props.isOptionSelected(option, selectValue);
      }

      var candidate = this.getOptionValue(option);
      return selectValue.some(function (i) {
        return _this2.getOptionValue(i) === candidate;
      });
    }
  }, {
    key: "filterOption",
    value: function filterOption(option, inputValue) {
      return this.props.filterOption ? this.props.filterOption(option, inputValue) : true;
    }
  }, {
    key: "formatOptionLabel",
    value: function formatOptionLabel(data, context) {
      if (typeof this.props.formatOptionLabel === 'function') {
        var inputValue = this.props.inputValue;
        var selectValue = this.state.selectValue;
        return this.props.formatOptionLabel(data, {
          context: context,
          inputValue: inputValue,
          selectValue: selectValue
        });
      } else {
        return this.getOptionLabel(data);
      }
    }
  }, {
    key: "formatGroupLabel",
    value: function formatGroupLabel(data) {
      return this.props.formatGroupLabel(data);
    } // ==============================
    // Mouse Handlers
    // ==============================

  }, {
    key: "startListeningComposition",
    // ==============================
    // Composition Handlers
    // ==============================
    value: function startListeningComposition() {
      if (document && document.addEventListener) {
        document.addEventListener('compositionstart', this.onCompositionStart, false);
        document.addEventListener('compositionend', this.onCompositionEnd, false);
      }
    }
  }, {
    key: "stopListeningComposition",
    value: function stopListeningComposition() {
      if (document && document.removeEventListener) {
        document.removeEventListener('compositionstart', this.onCompositionStart);
        document.removeEventListener('compositionend', this.onCompositionEnd);
      }
    }
  }, {
    key: "startListeningToTouch",
    // ==============================
    // Touch Handlers
    // ==============================
    value: function startListeningToTouch() {
      if (document && document.addEventListener) {
        document.addEventListener('touchstart', this.onTouchStart, false);
        document.addEventListener('touchmove', this.onTouchMove, false);
        document.addEventListener('touchend', this.onTouchEnd, false);
      }
    }
  }, {
    key: "stopListeningToTouch",
    value: function stopListeningToTouch() {
      if (document && document.removeEventListener) {
        document.removeEventListener('touchstart', this.onTouchStart);
        document.removeEventListener('touchmove', this.onTouchMove);
        document.removeEventListener('touchend', this.onTouchEnd);
      }
    }
  }, {
    key: "buildMenuOptions",
    // ==============================
    // Menu Options
    // ==============================
    value: function buildMenuOptions(props, selectValue) {
      var _this3 = this;

      var _props$inputValue = props.inputValue,
          inputValue = _props$inputValue === void 0 ? '' : _props$inputValue,
          options = props.options;

      var toOption = function toOption(option, id) {
        var isDisabled = _this3.isOptionDisabled(option, selectValue);

        var isSelected = _this3.isOptionSelected(option, selectValue);

        var label = _this3.getOptionLabel(option);

        var value = _this3.getOptionValue(option);

        if (_this3.shouldHideSelectedOptions() && isSelected || !_this3.filterOption({
          label: label,
          value: value,
          data: option
        }, inputValue)) {
          return;
        }

        var onHover = isDisabled ? undefined : function () {
          return _this3.onOptionHover(option);
        };
        var onSelect = isDisabled ? undefined : function () {
          return _this3.selectOption(option);
        };
        var optionId = "".concat(_this3.getElementId('option'), "-").concat(id);
        return {
          innerProps: {
            id: optionId,
            onClick: onSelect,
            onMouseMove: onHover,
            onMouseOver: onHover,
            tabIndex: -1
          },
          data: option,
          isDisabled: isDisabled,
          isSelected: isSelected,
          key: optionId,
          label: label,
          type: 'option',
          value: value
        };
      };

      return options.reduce(function (acc, item, itemIndex) {
        if (item.options) {
          // TODO needs a tidier implementation
          if (!_this3.hasGroups) _this3.hasGroups = true;
          var items = item.options;
          var children = items.map(function (child, i) {
            var option = toOption(child, "".concat(itemIndex, "-").concat(i));
            if (option) acc.focusable.push(child);
            return option;
          }).filter(Boolean);

          if (children.length) {
            var groupId = "".concat(_this3.getElementId('group'), "-").concat(itemIndex);
            acc.render.push({
              type: 'group',
              key: groupId,
              data: item,
              options: children
            });
          }
        } else {
          var option = toOption(item, "".concat(itemIndex));

          if (option) {
            acc.render.push(option);
            acc.focusable.push(item);
          }
        }

        return acc;
      }, {
        render: [],
        focusable: []
      });
    } // ==============================
    // Renderers
    // ==============================

  }, {
    key: "constructAriaLiveMessage",
    value: function constructAriaLiveMessage() {
      var _this$state7 = this.state,
          ariaLiveContext = _this$state7.ariaLiveContext,
          selectValue = _this$state7.selectValue,
          focusedValue = _this$state7.focusedValue,
          focusedOption = _this$state7.focusedOption;
      var _this$props13 = this.props,
          options = _this$props13.options,
          menuIsOpen = _this$props13.menuIsOpen,
          inputValue = _this$props13.inputValue,
          screenReaderStatus = _this$props13.screenReaderStatus; // An aria live message representing the currently focused value in the select.

      var focusedValueMsg = focusedValue ? valueFocusAriaMessage({
        focusedValue: focusedValue,
        getOptionLabel: this.getOptionLabel,
        selectValue: selectValue
      }) : ''; // An aria live message representing the currently focused option in the select.

      var focusedOptionMsg = focusedOption && menuIsOpen ? optionFocusAriaMessage({
        focusedOption: focusedOption,
        getOptionLabel: this.getOptionLabel,
        options: options
      }) : ''; // An aria live message representing the set of focusable results and current searchterm/inputvalue.

      var resultsMsg = resultsAriaMessage({
        inputValue: inputValue,
        screenReaderMessage: screenReaderStatus({
          count: this.countOptions()
        })
      });
      return "".concat(focusedValueMsg, " ").concat(focusedOptionMsg, " ").concat(resultsMsg, " ").concat(ariaLiveContext);
    }
  }, {
    key: "renderInput",
    value: function renderInput() {
      var _this$props14 = this.props,
          isDisabled = _this$props14.isDisabled,
          isSearchable = _this$props14.isSearchable,
          inputId = _this$props14.inputId,
          inputValue = _this$props14.inputValue,
          tabIndex = _this$props14.tabIndex;
      var Input = this.components.Input;
      var inputIsHidden = this.state.inputIsHidden;
      var id = inputId || this.getElementId('input');

      if (!isSearchable) {
        // use a dummy input to maintain focus/blur functionality
        return __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(DummyInput, {
          id: id,
          innerRef: this.getInputRef,
          onBlur: this.onInputBlur,
          onChange: __WEBPACK_IMPORTED_MODULE_15__chunk_39d3fda8_browser_esm_js__["k" /* n */],
          onFocus: this.onInputFocus,
          readOnly: true,
          disabled: isDisabled,
          tabIndex: tabIndex,
          value: ""
        });
      } // aria attributes makes the JSX "noisy", separated for clarity


      var ariaAttributes = {
        'aria-autocomplete': 'list',
        'aria-label': this.props['aria-label'],
        'aria-labelledby': this.props['aria-labelledby']
      };
      var _this$commonProps = this.commonProps,
          cx = _this$commonProps.cx,
          theme = _this$commonProps.theme,
          selectProps = _this$commonProps.selectProps;
      return __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(Input, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
        autoCapitalize: "none",
        autoComplete: "off",
        autoCorrect: "off",
        cx: cx,
        getStyles: this.getStyles,
        id: id,
        innerRef: this.getInputRef,
        isDisabled: isDisabled,
        isHidden: inputIsHidden,
        onBlur: this.onInputBlur,
        onChange: this.handleInputChange,
        onFocus: this.onInputFocus,
        selectProps: selectProps,
        spellCheck: "false",
        tabIndex: tabIndex,
        theme: theme,
        type: "text",
        value: inputValue
      }, ariaAttributes));
    }
  }, {
    key: "renderPlaceholderOrValue",
    value: function renderPlaceholderOrValue() {
      var _this4 = this;

      var _this$components = this.components,
          MultiValue = _this$components.MultiValue,
          MultiValueContainer = _this$components.MultiValueContainer,
          MultiValueLabel = _this$components.MultiValueLabel,
          MultiValueRemove = _this$components.MultiValueRemove,
          SingleValue = _this$components.SingleValue,
          Placeholder = _this$components.Placeholder;
      var commonProps = this.commonProps;
      var _this$props15 = this.props,
          controlShouldRenderValue = _this$props15.controlShouldRenderValue,
          isDisabled = _this$props15.isDisabled,
          isMulti = _this$props15.isMulti,
          inputValue = _this$props15.inputValue,
          placeholder = _this$props15.placeholder;
      var _this$state8 = this.state,
          selectValue = _this$state8.selectValue,
          focusedValue = _this$state8.focusedValue,
          isFocused = _this$state8.isFocused;

      if (!this.hasValue() || !controlShouldRenderValue) {
        return inputValue ? null : __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(Placeholder, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, commonProps, {
          key: "placeholder",
          isDisabled: isDisabled,
          isFocused: isFocused
        }), placeholder);
      }

      if (isMulti) {
        var selectValues = selectValue.map(function (opt, index) {
          var isOptionFocused = opt === focusedValue;
          return __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(MultiValue, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, commonProps, {
            components: {
              Container: MultiValueContainer,
              Label: MultiValueLabel,
              Remove: MultiValueRemove
            },
            isFocused: isOptionFocused,
            isDisabled: isDisabled,
            key: _this4.getOptionValue(opt),
            index: index,
            removeProps: {
              onClick: function onClick() {
                return _this4.removeValue(opt);
              },
              onTouchEnd: function onTouchEnd() {
                return _this4.removeValue(opt);
              },
              onMouseDown: function onMouseDown(e) {
                e.preventDefault();
                e.stopPropagation();
              }
            },
            data: opt
          }), _this4.formatOptionLabel(opt, 'value'));
        });
        return selectValues;
      }

      if (inputValue) {
        return null;
      }

      var singleValue = selectValue[0];
      return __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(SingleValue, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, commonProps, {
        data: singleValue,
        isDisabled: isDisabled
      }), this.formatOptionLabel(singleValue, 'value'));
    }
  }, {
    key: "renderClearIndicator",
    value: function renderClearIndicator() {
      var ClearIndicator = this.components.ClearIndicator;
      var commonProps = this.commonProps;
      var _this$props16 = this.props,
          isDisabled = _this$props16.isDisabled,
          isLoading = _this$props16.isLoading;
      var isFocused = this.state.isFocused;

      if (!this.isClearable() || !ClearIndicator || isDisabled || !this.hasValue() || isLoading) {
        return null;
      }

      var innerProps = {
        onMouseDown: this.onClearIndicatorMouseDown,
        onTouchEnd: this.onClearIndicatorTouchEnd,
        'aria-hidden': 'true'
      };
      return __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(ClearIndicator, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, commonProps, {
        innerProps: innerProps,
        isFocused: isFocused
      }));
    }
  }, {
    key: "renderLoadingIndicator",
    value: function renderLoadingIndicator() {
      var LoadingIndicator = this.components.LoadingIndicator;
      var commonProps = this.commonProps;
      var _this$props17 = this.props,
          isDisabled = _this$props17.isDisabled,
          isLoading = _this$props17.isLoading;
      var isFocused = this.state.isFocused;
      if (!LoadingIndicator || !isLoading) return null;
      var innerProps = {
        'aria-hidden': 'true'
      };
      return __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(LoadingIndicator, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, commonProps, {
        innerProps: innerProps,
        isDisabled: isDisabled,
        isFocused: isFocused
      }));
    }
  }, {
    key: "renderIndicatorSeparator",
    value: function renderIndicatorSeparator() {
      var _this$components2 = this.components,
          DropdownIndicator = _this$components2.DropdownIndicator,
          IndicatorSeparator = _this$components2.IndicatorSeparator; // separator doesn't make sense without the dropdown indicator

      if (!DropdownIndicator || !IndicatorSeparator) return null;
      var commonProps = this.commonProps;
      var isDisabled = this.props.isDisabled;
      var isFocused = this.state.isFocused;
      return __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(IndicatorSeparator, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, commonProps, {
        isDisabled: isDisabled,
        isFocused: isFocused
      }));
    }
  }, {
    key: "renderDropdownIndicator",
    value: function renderDropdownIndicator() {
      var DropdownIndicator = this.components.DropdownIndicator;
      if (!DropdownIndicator) return null;
      var commonProps = this.commonProps;
      var isDisabled = this.props.isDisabled;
      var isFocused = this.state.isFocused;
      var innerProps = {
        onMouseDown: this.onDropdownIndicatorMouseDown,
        onTouchEnd: this.onDropdownIndicatorTouchEnd,
        'aria-hidden': 'true'
      };
      return __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(DropdownIndicator, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, commonProps, {
        innerProps: innerProps,
        isDisabled: isDisabled,
        isFocused: isFocused
      }));
    }
  }, {
    key: "renderMenu",
    value: function renderMenu() {
      var _this5 = this;

      var _this$components3 = this.components,
          Group = _this$components3.Group,
          GroupHeading = _this$components3.GroupHeading,
          Menu = _this$components3.Menu,
          MenuList = _this$components3.MenuList,
          MenuPortal = _this$components3.MenuPortal,
          LoadingMessage = _this$components3.LoadingMessage,
          NoOptionsMessage = _this$components3.NoOptionsMessage,
          Option = _this$components3.Option;
      var commonProps = this.commonProps;
      var _this$state9 = this.state,
          focusedOption = _this$state9.focusedOption,
          menuOptions = _this$state9.menuOptions;
      var _this$props18 = this.props,
          captureMenuScroll = _this$props18.captureMenuScroll,
          inputValue = _this$props18.inputValue,
          isLoading = _this$props18.isLoading,
          loadingMessage = _this$props18.loadingMessage,
          minMenuHeight = _this$props18.minMenuHeight,
          maxMenuHeight = _this$props18.maxMenuHeight,
          menuIsOpen = _this$props18.menuIsOpen,
          menuPlacement = _this$props18.menuPlacement,
          menuPosition = _this$props18.menuPosition,
          menuPortalTarget = _this$props18.menuPortalTarget,
          menuShouldBlockScroll = _this$props18.menuShouldBlockScroll,
          menuShouldScrollIntoView = _this$props18.menuShouldScrollIntoView,
          noOptionsMessage = _this$props18.noOptionsMessage,
          onMenuScrollToTop = _this$props18.onMenuScrollToTop,
          onMenuScrollToBottom = _this$props18.onMenuScrollToBottom;
      if (!menuIsOpen) return null; // TODO: Internal Option Type here

      var render = function render(props) {
        // for performance, the menu options in state aren't changed when the
        // focused option changes so we calculate additional props based on that
        var isFocused = focusedOption === props.data;
        props.innerRef = isFocused ? _this5.getFocusedOptionRef : undefined;
        return __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(Option, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, commonProps, props, {
          isFocused: isFocused
        }), _this5.formatOptionLabel(props.data, 'menu'));
      };

      var menuUI;

      if (this.hasOptions()) {
        menuUI = menuOptions.render.map(function (item) {
          if (item.type === 'group') {
            var type = item.type,
                group = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(item, ["type"]);

            var headingId = "".concat(item.key, "-heading");
            return __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(Group, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, commonProps, group, {
              Heading: GroupHeading,
              headingProps: {
                id: headingId
              },
              label: _this5.formatGroupLabel(item.data)
            }), item.options.map(function (option) {
              return render(option);
            }));
          } else if (item.type === 'option') {
            return render(item);
          }
        });
      } else if (isLoading) {
        var message = loadingMessage({
          inputValue: inputValue
        });
        if (message === null) return null;
        menuUI = __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(LoadingMessage, commonProps, message);
      } else {
        var _message = noOptionsMessage({
          inputValue: inputValue
        });

        if (_message === null) return null;
        menuUI = __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(NoOptionsMessage, commonProps, _message);
      }

      var menuPlacementProps = {
        minMenuHeight: minMenuHeight,
        maxMenuHeight: maxMenuHeight,
        menuPlacement: menuPlacement,
        menuPosition: menuPosition,
        menuShouldScrollIntoView: menuShouldScrollIntoView
      };
      var menuElement = __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__chunk_80640036_browser_esm_js__["a" /* M */], Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, commonProps, menuPlacementProps), function (_ref6) {
        var ref = _ref6.ref,
            _ref6$placerProps = _ref6.placerProps,
            placement = _ref6$placerProps.placement,
            maxHeight = _ref6$placerProps.maxHeight;
        return __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(Menu, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, commonProps, menuPlacementProps, {
          innerRef: ref,
          innerProps: {
            onMouseDown: _this5.onMenuMouseDown,
            onMouseMove: _this5.onMenuMouseMove
          },
          isLoading: isLoading,
          placement: placement
        }), __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(ScrollCaptorSwitch, {
          isEnabled: captureMenuScroll,
          onTopArrive: onMenuScrollToTop,
          onBottomArrive: onMenuScrollToBottom
        }, __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(ScrollBlock, {
          isEnabled: menuShouldBlockScroll
        }, __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(MenuList, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, commonProps, {
          innerRef: _this5.getMenuListRef,
          isLoading: isLoading,
          maxHeight: maxHeight
        }), menuUI))));
      }); // positioning behaviour is almost identical for portalled and fixed,
      // so we use the same component. the actual portalling logic is forked
      // within the component based on `menuPosition`

      return menuPortalTarget || menuPosition === 'fixed' ? __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(MenuPortal, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, commonProps, {
        appendTo: menuPortalTarget,
        controlElement: this.controlRef,
        menuPlacement: menuPlacement,
        menuPosition: menuPosition
      }), menuElement) : menuElement;
    }
  }, {
    key: "renderFormField",
    value: function renderFormField() {
      var _this6 = this;

      var _this$props19 = this.props,
          delimiter = _this$props19.delimiter,
          isDisabled = _this$props19.isDisabled,
          isMulti = _this$props19.isMulti,
          name = _this$props19.name;
      var selectValue = this.state.selectValue;
      if (!name || isDisabled) return;

      if (isMulti) {
        if (delimiter) {
          var value = selectValue.map(function (opt) {
            return _this6.getOptionValue(opt);
          }).join(delimiter);
          return __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement("input", {
            name: name,
            type: "hidden",
            value: value
          });
        } else {
          var input = selectValue.length > 0 ? selectValue.map(function (opt, i) {
            return __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement("input", {
              key: "i-".concat(i),
              name: name,
              type: "hidden",
              value: _this6.getOptionValue(opt)
            });
          }) : __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement("input", {
            name: name,
            type: "hidden"
          });
          return __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement("div", null, input);
        }
      } else {
        var _value = selectValue[0] ? this.getOptionValue(selectValue[0]) : '';

        return __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement("input", {
          name: name,
          type: "hidden",
          value: _value
        });
      }
    }
  }, {
    key: "renderLiveRegion",
    value: function renderLiveRegion() {
      if (!this.state.isFocused) return null;
      return __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(A11yText, {
        "aria-live": "polite"
      }, __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement("p", {
        id: "aria-selection-event"
      }, "\xA0", this.state.ariaLiveSelection), __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement("p", {
        id: "aria-context"
      }, "\xA0", this.constructAriaLiveMessage()));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$components4 = this.components,
          Control = _this$components4.Control,
          IndicatorsContainer = _this$components4.IndicatorsContainer,
          SelectContainer = _this$components4.SelectContainer,
          ValueContainer = _this$components4.ValueContainer;
      var _this$props20 = this.props,
          className = _this$props20.className,
          id = _this$props20.id,
          isDisabled = _this$props20.isDisabled,
          menuIsOpen = _this$props20.menuIsOpen;
      var isFocused = this.state.isFocused;
      var commonProps = this.commonProps = this.getCommonProps();
      return __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(SelectContainer, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, commonProps, {
        className: className,
        innerProps: {
          id: id,
          onKeyDown: this.onKeyDown
        },
        isDisabled: isDisabled,
        isFocused: isFocused
      }), this.renderLiveRegion(), __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(Control, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, commonProps, {
        innerRef: this.getControlRef,
        innerProps: {
          onMouseDown: this.onControlMouseDown,
          onTouchEnd: this.onControlTouchEnd
        },
        isDisabled: isDisabled,
        isFocused: isFocused,
        menuIsOpen: menuIsOpen
      }), __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(ValueContainer, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, commonProps, {
        isDisabled: isDisabled
      }), this.renderPlaceholderOrValue(), this.renderInput()), __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(IndicatorsContainer, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, commonProps, {
        isDisabled: isDisabled
      }), this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderIndicatorSeparator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField());
    }
  }]);

  return Select;
}(__WEBPACK_IMPORTED_MODULE_11_react__["Component"]);

Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Select, "defaultProps", defaultProps);




/***/ }),
/* 321 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return add; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return remove; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return reset; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actionTypes__ = __webpack_require__(5);
var add=function add(valueToAdd){return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["_50" /* TAGGED_INPUT_TEXT_ADD */],payload:valueToAdd};};var remove=function remove(valueToRemove){return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["_51" /* TAGGED_INPUT_TEXT_REMOVE */],payload:valueToRemove};};var reset=function reset(){return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["_52" /* TAGGED_INPUT_TEXT_RESET */]};};

/***/ }),
/* 322 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _slider = __webpack_require__(854);

var _slider2 = _interopRequireDefault(_slider);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _slider2.default;

/***/ }),
/* 324 */
/***/ (function(module, exports) {

/**
 * Helper function for iterating over a collection
 *
 * @param collection
 * @param fn
 */
function each(collection, fn) {
    var i      = 0,
        length = collection.length,
        cont;

    for(i; i < length; i++) {
        cont = fn(collection[i], i);
        if(cont === false) {
            break; //allow early exit
        }
    }
}

/**
 * Helper function for determining whether target object is an array
 *
 * @param target the object under test
 * @return {Boolean} true if array, false otherwise
 */
function isArray(target) {
    return Object.prototype.toString.apply(target) === '[object Array]';
}

/**
 * Helper function for determining whether target object is a function
 *
 * @param target the object under test
 * @return {Boolean} true if function, false otherwise
 */
function isFunction(target) {
    return typeof target === 'function';
}

module.exports = {
    isFunction : isFunction,
    isArray : isArray,
    each : each
};


/***/ }),
/* 325 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAIBAMAAAA2IaO4AAAAMFBMVEUAAAD///////////////////////////////////////////////////////////87TQQwAAAAD3RSTlMABQ4Jxr3NoNGysalsZBV/act5AAAAK0lEQVQI12MAAgMg5uthYGRQ+85wTdl/I0O9608BBqn/gQwMzCEgSSUGBgCZwQfCi6uRcwAAAABJRU5ErkJggg=="

/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _url = __webpack_require__(952);

var _url2 = _interopRequireDefault(_url);

var _queryString = __webpack_require__(336);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var defaults = {
  redirectQueryParamName: 'redirect',
  locationSelector: function locationSelector(_ref) {
    var location = _ref.location;
    return location;
  }
};

exports.default = function (args) {
  var _defaults$args = _extends({}, defaults, args),
      redirectQueryParamName = _defaults$args.redirectQueryParamName,
      locationSelector = _defaults$args.locationSelector;

  var getRedirectQueryParam = function getRedirectQueryParam(props) {
    var location = locationSelector(props);
    var query = (0, _queryString.parse)(location.search);
    return query[redirectQueryParamName];
  };

  var createRedirectLoc = function createRedirectLoc(allowRedirectBack) {
    return function (props, redirectPath) {
      var location = locationSelector(props);
      var redirectLoc = _url2.default.parse(redirectPath, true);

      var query = void 0;

      if (allowRedirectBack) {
        query = _defineProperty({}, redirectQueryParamName, '' + location.pathname + location.search + location.hash);
      } else {
        query = {};
      }

      query = _extends({}, query, redirectLoc.query);

      return {
        pathname: redirectLoc.pathname,
        hash: redirectLoc.hash,
        search: (0, _queryString.stringify)(query)
      };
    };
  };

  return {
    getRedirectQueryParam: getRedirectQueryParam,
    createRedirectLoc: createRedirectLoc
  };
};

/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(7);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _hoistNonReactStatics = __webpack_require__(962);

var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var defaults = {
  AuthenticatingComponent: function AuthenticatingComponent() {
    return null;
  }, // dont render anything while authenticating
  FailureComponent: function FailureComponent() {
    return null;
  }, // dont render anything on failure of the predicate
  wrapperDisplayName: 'AuthWrapper'
};

exports.default = function (args) {
  var _defaults$args = _extends({}, defaults, args),
      AuthenticatingComponent = _defaults$args.AuthenticatingComponent,
      FailureComponent = _defaults$args.FailureComponent,
      wrapperDisplayName = _defaults$args.wrapperDisplayName;

  // Wraps the component that needs the auth enforcement


  function wrapComponent(DecoratedComponent) {
    var _class, _temp;

    var displayName = DecoratedComponent.displayName || DecoratedComponent.name || 'Component';

    var UserAuthWrapper = (_temp = _class = function (_Component) {
      _inherits(UserAuthWrapper, _Component);

      function UserAuthWrapper() {
        _classCallCheck(this, UserAuthWrapper);

        return _possibleConstructorReturn(this, (UserAuthWrapper.__proto__ || Object.getPrototypeOf(UserAuthWrapper)).apply(this, arguments));
      }

      _createClass(UserAuthWrapper, [{
        key: 'render',
        value: function render() {
          var _props = this.props,
              isAuthenticated = _props.isAuthenticated,
              isAuthenticating = _props.isAuthenticating;

          if (isAuthenticated) {
            return _react2.default.createElement(DecoratedComponent, this.props);
          } else if (isAuthenticating) {
            return _react2.default.createElement(AuthenticatingComponent, this.props);
          } else {
            return _react2.default.createElement(FailureComponent, this.props);
          }
        }
      }]);

      return UserAuthWrapper;
    }(_react.Component), _class.displayName = wrapperDisplayName + '(' + displayName + ')', _class.propTypes = {
      isAuthenticated: _propTypes2.default.bool,
      isAuthenticating: _propTypes2.default.bool
    }, _class.defaultProps = {
      isAuthenticating: false
    }, _temp);


    return (0, _hoistNonReactStatics2.default)(UserAuthWrapper, DecoratedComponent);
  }

  return wrapComponent;
};

/***/ }),
/* 328 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAUCAYAAACAl21KAAACuklEQVR4AZSTXUhUQRSAz5y97nWzWNd1dysIewp6C3op6EeqF41KF0tQKEgiCkpIQslcb1taPkpUUBAkRdLfipA+aGD0EkSvBT1EPt67ba5R6V3vndMZ3etP7FZe5rtn5pwzZ+acmUFYxRfsOBiKJuKno0b9cThXoy+fuqpAOvr8AmE3SOiMluutKrAXDKOXDsdiibr9apXKriNNsUS8sRCRRF0NaXiSJO3iyVtAiD7dr/eEL9dvVbtD0LRuAjHOqzxAgY8IaLAQAsQI0wsAVUy+0RnNB8+ioUAtp0bxvNYTv7jzN9i81IggTELuQSEgs6SG9yTobiF4N/0CRYp9J5n5xnM/CKDm9De7AzmiM68FmGbHh0pZCHNq5orjUA/7fmWAA1+nOXefmRx6BTdHbU5NqRcgCZNKWYzM9OxngXgbgM6S4/Rb/u8ZMKo1xYpAktzAQsgi//CMKwGfWJi9Z0s3t5FCOyrd4LGYLN+raqR509CHi31Pt0IaE07aePoDWOql/kMOwZuFkxbDqkab885BkFSW7/9TCClsdjIZ4KJ/Qb4zDQKxhat/wM7NDQLnHDGOrlVSORWDAHKeTR0YpjE7ZkJmwMTsa2WIQqhJSLc5ApFSNS4GgZxdbkOVryI4W7ZOLyk5pW64EHReOs4mdfWLgejb8Eegaq2iq36n7vePcbJ9yshbLdMQLkZC+oVYKNDtsT4c6FSoMRC1sG+M4WmgYUxWJDUBj1mxnfFaFdegkS9dOwG1ekhJbYr5MdE2z5kXDiMBvOOq//SUy+Qa7gcZJYvBZgCBYhytqZkRx4UGHt6Bpc9EFFcBRBwQThRCqJNmeHe1lHPaUD2HzLXURztnd3Le7QDwSQK9lTnnlpV8kbKM1EAhTOP5fUU6OTRq9Q6bi09k+sbLKStr8wvHPh/ihHoCHPS/228AAAD///+PtM4AAAAGSURBVAMA55RxfR9AR/UAAAAASUVORK5CYII="

/***/ }),
/* 329 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,/9j/4AAQSkZJRgABAQEASABIAAD/2wBDAAEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQH/2wBDAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQH/wAARCAABAA4DAREAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAACAr/xAAfEAAAAwkAAAAAAAAAAAAAAAAAAQIDBQcyNHFyscL/xAAUAQEAAAAAAAAAAAAAAAAAAAAA/8QAFBEBAAAAAAAAAAAAAAAAAAAAAP/aAAwDAQACEQMRAD8AsrhrIxunkAr3RTJxLRAP/9k="

/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/logo-lunch-team.2a34be80.svg";

/***/ }),
/* 331 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export MAX_FILES */
/* unused harmony export MAX_FILE_BYTES */
/* unused harmony export MAX_TOTAL_FILE_BYTES */
/* unused harmony export MAX_REQUEST_BYTES */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MAX_TEXT; });
/* unused harmony export MAX_IMAGE_EDGE */
/* unused harmony export MAX_SOURCE_PHOTO_BYTES */
/* unused harmony export HOLD_THRESHOLD_MS */
/* unused harmony export SILENCE_LEVEL */
/* unused harmony export MIN_SPEECH_MS */
/* unused harmony export CANCEL_DISTANCE_PX */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return VISITOR_MAX_TEXT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return VISITOR_MAX_EMAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return VISITOR_MAX_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return VISITOR_MAX_COMPANY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return VISITOR_PLACEHOLDER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return VISITOR_NAME_MISSING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return VISITOR_EMAIL_INVALID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return VISITOR_CONVERSATION_FULL; });
/* harmony export (immutable) */ __webpack_exports__["r"] = isValidVisitorEmail;
/* unused harmony export fileType */
/* unused harmony export isReencoded */
/* harmony export (immutable) */ __webpack_exports__["j"] = acceptFiles;
/* harmony export (immutable) */ __webpack_exports__["l"] = classifyPress;
/* harmony export (immutable) */ __webpack_exports__["q"] = heardSpeech;
/* harmony export (immutable) */ __webpack_exports__["t"] = movedToCancel;
/* harmony export (immutable) */ __webpack_exports__["v"] = placeholderFor;
/* harmony export (immutable) */ __webpack_exports__["n"] = encodedTextLength;
/* harmony export (immutable) */ __webpack_exports__["y"] = uploadSizeProblem;
/* harmony export (immutable) */ __webpack_exports__["w"] = preparationProblem;
/* harmony export (immutable) */ __webpack_exports__["o"] = formatDuration;
/* harmony export (immutable) */ __webpack_exports__["u"] = newClientReportId;
/* harmony export (immutable) */ __webpack_exports__["k"] = appendDictation;
/* harmony export (immutable) */ __webpack_exports__["p"] = hasPendingTranscripts;
/* harmony export (immutable) */ __webpack_exports__["s"] = makeThumbnail;
/* harmony export (immutable) */ __webpack_exports__["x"] = sanitizeImage;
/* harmony export (immutable) */ __webpack_exports__["m"] = conversationChanges;
// Rules for the support composer that don't need the DOM, kept here so they can be tested.
var MAX_FILES=5;var MAX_FILE_BYTES=10*1024*1024;// Logistic and its nginx reject a request over 30 MB, and nginx's 413 reaches the browser as a network
// error. Attachments may add up to 24 MB, leaving room for a voice note and the form fields.
var MAX_TOTAL_FILE_BYTES=24*1024*1024;var MAX_REQUEST_BYTES=28*1024*1024;var MAX_TEXT=4000;// Photos are re-encoded before upload (drops EXIF such as GPS) and scaled to fit this.
var MAX_IMAGE_EDGE=2560;// The server's limits apply to the re-encoded copy, usually far smaller; this only guards decoding memory.
var MAX_SOURCE_PHOTO_BYTES=30*1024*1024;// A press shorter than this on the mic is a tap (dictate); longer is a hold (send on release).
var HOLD_THRESHOLD_MS=350;// Below this the recording is treated as silence and not sent (speech models invent text for silence).
var SILENCE_LEVEL=0.04;var MIN_SPEECH_MS=700;// Moving this far from the mic during a hold cancels it.
var CANCEL_DISTANCE_PX=60;// Signed-out visitors (landing page) send text only, within the server's visitor limits.
var VISITOR_MAX_TEXT=2000;var VISITOR_MAX_EMAIL=200;var VISITOR_MAX_NAME=120;var VISITOR_MAX_COMPANY=160;var VISITOR_PLACEHOLDER='Questions about Lunch.Team or signing in?';// What a visitor is told, by the composer or from the server's answer (supportApi).
var VISITOR_NAME_MISSING='Enter your name.';var VISITOR_EMAIL_INVALID="That email address doesn't look right. Please check it and try again.";var VISITOR_CONVERSATION_FULL='This chat is full. Start a new conversation, or sign in.';// One plain address, as the server takes it (SupportVisitorService.PLAIN_EMAIL): a dot-atom local part,
// '@', and host-name labels joined by dots, with at least one dot. No quoted parts, comments or IP literals.
var EMAIL_ATOM="[A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+";var EMAIL_LABEL='[A-Za-z0-9](?:[A-Za-z0-9-]{0,61}[A-Za-z0-9])?';var VISITOR_EMAIL=new RegExp('^'+EMAIL_ATOM+'(?:\\.'+EMAIL_ATOM+')*@'+EMAIL_LABEL+'(?:\\.'+EMAIL_LABEL+')+$');function isValidVisitorEmail(value){var email=(value||'').trim();return!!email&&email.length<=VISITOR_MAX_EMAIL&&VISITOR_EMAIL.test(email);}var FILE_TYPES=['image/jpeg','image/png','image/webp','image/heic','image/gif','application/pdf'];var TYPE_BY_EXTENSION={jpg:'image/jpeg',jpeg:'image/jpeg',png:'image/png',webp:'image/webp',heic:'image/heic',heif:'image/heic',gif:'image/gif',pdf:'application/pdf'};function fileType(file){if(file.type&&FILE_TYPES.indexOf(file.type)>=0){return file.type;}if(file.type==='image/heif'){return'image/heic';}var match=/\.([a-z0-9]+)$/i.exec(file.name||'');return(!file.type||file.type==='application/octet-stream')&&match?TYPE_BY_EXTENSION[match[1].toLowerCase()]||null:null;}// Photos the composer re-encodes before upload; PDFs go as picked. GIF too (its first frame, as PNG):
// otherwise a JPEG renamed .gif would keep its EXIF and GPS.
var REENCODE_TYPES=['image/jpeg','image/png','image/webp','image/heic','image/gif'];function isReencoded(type){return REENCODE_TYPES.indexOf(type)>=0;}/**
 * Splits picked files into ones we can send and messages for the rest.
 * Files with a missing browser type (e.g. HEIC on some browsers) are re-typed from their extension.
 * Files sent as picked are held to the server's limits here. Photos are re-encoded first, so their
 * limits are checked on the copy when sending (uploadSizeProblem).
 * existingBytes is the upload size already known for what is attached, for the total cap.
 */function acceptFiles(existingCount,picked){var existingBytes=arguments.length>2&&arguments[2]!==undefined?arguments[2]:0;var accepted=[];var errors=[];var totalBytes=existingBytes;(picked||[]).forEach(function(file){var type=fileType(file);var photo=isReencoded(type);if(!type){errors.push(file.name+': only photos and PDFs can be attached.');}else if(photo&&file.size>MAX_SOURCE_PHOTO_BYTES){errors.push(file.name+': photos must be 30 MB or smaller.');}else if(!photo&&file.size>MAX_FILE_BYTES){errors.push(file.name+': files must be 10 MB or smaller.');}else if(existingCount+accepted.length>=MAX_FILES){errors.push('You can attach up to '+MAX_FILES+' files.');}else if(!photo&&totalBytes+file.size>MAX_TOTAL_FILE_BYTES){errors.push('Attachments can add up to 24 MB in total.');}else{if(!photo)totalBytes+=file.size;accepted.push(type===file.type?file:retype(file,type));}});return{accepted:accepted,errors:errors.filter(function(message,index){return errors.indexOf(message)===index;})};}function retype(file,type){try{return new File([file],file.name,{type:type,lastModified:file.lastModified});}catch(e){return file;}}function classifyPress(durationMs){return durationMs<HOLD_THRESHOLD_MS?'tap':'hold';}function heardSpeech(recording){return!!recording&&recording.durationMs>=MIN_SPEECH_MS&&recording.peakLevel>=SILENCE_LEVEL;}function movedToCancel(start,point){if(!start||!point)return false;var dx=point.x-start.x;var dy=point.y-start.y;return Math.sqrt(dx*dx+dy*dy)>CANCEL_DISTANCE_PX;}// Short enough for one line at 320px wide with 44px touch buttons (about 175px of text).
function placeholderFor(screenId){switch(screenId){case'order.tracking':case'order.detail':case'orders.list':return'Problem with an order?';case'checkout.cart':case'checkout.result':return'Basket or payment?';case'menu.restaurant':return'Menu question?';case'account.profile':return'Account question?';default:return'How can we help?';}}// Multipart encoding sends each line break as CR LF, and the server counts both characters.
function encodedTextLength(text){var value=text||'';return value.length+(value.match(/\n/g)||[]).length;}/**
 * Checked on what is actually uploaded (re-encoded photos, the voice note) before sending:
 * a message for a file or a message over the server's limits, or null when it can go.
 */function uploadSizeProblem(files){var voiceBytes=arguments.length>1&&arguments[1]!==undefined?arguments[1]:0;var uploads=files||[];var big=uploads.filter(function(file){return file.size>MAX_FILE_BYTES;});if(big.length){return big.map(function(file){return file.name;}).join(', ')+': files must be 10 MB or smaller. Remove '+(big.length>1?'them':'it')+' and try again.';}var total=uploads.reduce(function(sum,file){return sum+file.size;},voiceBytes);if(total>MAX_REQUEST_BYTES){return"That's too much for one message. Remove a photo or two and try again.";}return null;}/** Why a photo was taken off the message when it couldn't be re-encoded (see sanitizeImage). */function preparationProblem(fileName,error){return error&&error.code==='heic'?fileName+': this browser can\'t open HEIC photos. Attach a JPEG or a screenshot instead.':fileName+': we couldn\'t prepare this photo, so it wasn\'t attached. Try again, or attach a screenshot.';}function formatDuration(ms){var seconds=Math.max(0,Math.floor(ms/1000));var minutes=Math.floor(seconds/60);var rest=seconds%60;return minutes+':'+(rest<10?'0':'')+rest;}function newClientReportId(){var random=typeof window!=='undefined'&&window.crypto&&window.crypto.getRandomValues?Array.from(window.crypto.getRandomValues(new Uint32Array(2)),function(n){return n.toString(36);}).join(''):Math.random().toString(36).slice(2)+Math.random().toString(36).slice(2);return'web-'+Date.now().toString(36)+'-'+random;}/** Appends dictated words to what the customer has already typed. */function appendDictation(text,words){var spoken=(words||'').trim();if(!spoken)return text;if(!text||!text.trim())return spoken;return /\s$/.test(text)?text+spoken:text+' '+spoken;}// Transcripts still being made: keep checking the conversation until they finish.
function hasPendingTranscripts(conversation){return(conversation&&conversation.messages||[]).some(function(message){return(message.attachments||[]).some(function(attachment){return attachment.kind==='AUDIO'&&['PENDING','PROCESSING','RETRY','CONFIGURATION_REQUIRED'].indexOf(attachment.transcriptStatus)>=0;});});}// Frees the canvas's memory now: iOS Safari counts every canvas against one cap until garbage collection.
function releaseCanvas(canvas){canvas.width=0;canvas.height=0;}// Small square preview as a data: URL. The site's Content-Security-Policy allows data: images but not blob: URLs.
// Resolves null when the browser can't decode the image; the chip then shows a file icon.
function makeThumbnail(file){var size=arguments.length>1&&arguments[1]!==undefined?arguments[1]:56;var draw=function draw(source,width,height){var canvas=document.createElement('canvas');canvas.width=size;canvas.height=size;var scale=Math.max(size/width,size/height);var drawWidth=width*scale;var drawHeight=height*scale;var context=canvas.getContext&&canvas.getContext('2d');if(!context)return null;// White behind transparent pixels, as in the uploaded JPEG.
context.fillStyle='#ffffff';context.fillRect(0,0,size,size);context.drawImage(source,(size-drawWidth)/2,(size-drawHeight)/2,drawWidth,drawHeight);var thumbnail=canvas.toDataURL('image/jpeg',0.8);releaseCanvas(canvas);return thumbnail;};var viaElement=function viaElement(){return new Promise(function(resolve){var reader=new FileReader();reader.onload=function(){var image=new Image();image.onload=function(){return resolve(draw(image,image.naturalWidth,image.naturalHeight));};image.onerror=function(){return resolve(null);};image.src=reader.result;};reader.onerror=function(){return resolve(null);};reader.readAsDataURL(file);});};if(typeof window==='undefined'||file.type.indexOf('image/')!==0){return Promise.resolve(null);}if(typeof window.createImageBitmap==='function'){return window.createImageBitmap(file).then(function(bitmap){var thumbnail=draw(bitmap,bitmap.width,bitmap.height);if(typeof bitmap.close==='function')bitmap.close();return thumbnail;}).catch(function(){return viaElement();}).catch(function(){return null;});}return viaElement().catch(function(){return null;});}function preparationError(code){var error=new Error('The photo could not be re-encoded ('+code+').');error.code=code;return error;}// The photo decoded and upright (EXIF orientation applied), ready to draw.
function decodePhoto(file){var viaElement=function viaElement(){return new Promise(function(resolve,reject){var reader=new FileReader();reader.onload=function(){var image=new Image();image.onload=function(){return resolve({source:image,width:image.naturalWidth,height:image.naturalHeight,close:function close(){}});};image.onerror=reject;image.src=reader.result;};reader.onerror=reject;reader.readAsDataURL(file);});};if(typeof window.createImageBitmap!=='function')return viaElement();return new Promise(function(resolve){return resolve(window.createImageBitmap(file,{imageOrientation:'from-image'}));}).then(function(bitmap){return{source:bitmap,width:bitmap.width,height:bitmap.height,close:function close(){if(typeof bitmap.close==='function')bitmap.close();}};},function(){return viaElement();});}// Draws the photo at most MAX_IMAGE_EDGE on its longer side and encodes it as type.
function encodePhoto(photo,type){return new Promise(function(resolve,reject){if(!photo.width||!photo.height){reject(new Error('Nothing to draw.'));return;}var scale=Math.min(1,MAX_IMAGE_EDGE/Math.max(photo.width,photo.height));var canvas=document.createElement('canvas');canvas.width=Math.max(1,Math.round(photo.width*scale));canvas.height=Math.max(1,Math.round(photo.height*scale));var context=canvas.getContext&&canvas.getContext('2d');if(!context||typeof canvas.toBlob!=='function'){releaseCanvas(canvas);reject(new Error('No canvas.'));return;}if(type==='image/jpeg'){// JPEG has no transparency: without a fill, transparent pixels turn black.
context.fillStyle='#ffffff';context.fillRect(0,0,canvas.width,canvas.height);}context.drawImage(photo.source,0,0,canvas.width,canvas.height);canvas.toBlob(function(blob){releaseCanvas(canvas);if(blob&&blob.size)resolve(blob);else reject(new Error('Nothing encoded.'));},type,0.85);});}function asUpload(blob,file){var type=blob.type||'image/jpeg';var name=(file.name||'photo').replace(/\.[a-z0-9]+$/i,'')+(type==='image/png'?'.png':'.jpg');try{return new File([blob],name,{type:type,lastModified:file.lastModified});}catch(e){// No File constructor (old Edge): the blob goes under this name.
blob.name=name;return blob;}}/**
 * A copy of a photo without its metadata (EXIF GPS location, device, time), scaled to MAX_IMAGE_EDGE.
 * PNG stays PNG (transparency) unless that copy is bigger than the original or over 10 MB; then it
 * becomes JPEG on white, like the other photos. GIF and PDF are returned unchanged.
 * Rejects when a photo can't be re-encoded, so it is never uploaded with its metadata: error.code is
 * 'heic' for a HEIC photo this browser can't open (Safari can), 'failed' for anything else.
 */function sanitizeImage(file){// The type from the extension when the browser gave none: where there is no File constructor to re-type
// the pick (old Edge), an untyped .jpg must still be re-encoded, not sent with its EXIF.
var type=fileType(file)||file.type;if(!isReencoded(type))return Promise.resolve(file);var decodeFailure=type==='image/heic'?'heic':'failed';if(typeof window==='undefined'){return Promise.reject(preparationError(decodeFailure));}return decodePhoto(file).then(function(photo){var jpeg=function jpeg(){return encodePhoto(photo,'image/jpeg');};var encoded=type==='image/png'||type==='image/gif'?encodePhoto(photo,'image/png').then(function(png){return png.size>MAX_FILE_BYTES||png.size>file.size?jpeg():png;}):jpeg();return encoded.then(function(blob){photo.close();return asUpload(blob,file);},function(){photo.close();throw preparationError('failed');});},function(){throw preparationError(decodeFailure);});}/**
 * What changed between two reads of the conversation, for screen-reader announcements and the unread dot:
 * replies is the number of new messages from support (assistantReplies of them from the Lunch.Team
 * assistant); transcribed the number of voice notes that finished.
 */function conversationChanges(previous,next){var before=previous&&previous.messages||[];var after=next&&next.messages||[];var known={};var finishedBefore={};before.forEach(function(message){known[message.messageId]=true;(message.attachments||[]).forEach(function(attachment){if(attachment.transcriptStatus==='COMPLETED'||attachment.transcriptStatus==='FAILED'){finishedBefore[attachment.attachmentId]=true;}});});var replies=0;var assistantReplies=0;var transcribed=0;after.forEach(function(message){if(!known[message.messageId]&&message.authorType!=='REQUESTER'){replies++;if(message.authorType==='ASSISTANT')assistantReplies++;}(message.attachments||[]).forEach(function(attachment){if(attachment.kind==='AUDIO'&&attachment.transcriptStatus==='COMPLETED'&&!finishedBefore[attachment.attachmentId]&&known[message.messageId]){transcribed++;}});});return{replies:replies,assistantReplies:assistantReplies,transcribed:transcribed};}

/***/ }),
/* 332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return closeChangeCompany; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return showChangeCompany; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return sendEmailSuport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return deleteAccount; });
/* unused harmony export deleteAccountSuccess */
/* unused harmony export sendEmailSupportSuccess */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return closeSentEmailSupport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return showErrorUnsubscribe; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return closeErrorUnsubscribe; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return unsubscribe; });
/* unused harmony export isUnsubscribeSuccess */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actionTypes__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services_settingsService__ = __webpack_require__(783);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_utils_userError__ = __webpack_require__(15);
var closeChangeCompany=function closeChangeCompany(){return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["_31" /* SETTINGS_CLOSE_CHANGE_COMPANY */]};};var showChangeCompany=function showChangeCompany(){return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["_35" /* SETTINGS_SHOW_CHANGE_COMPANY */]};};var sendEmailSuport=function sendEmailSuport(payload){return function(dispatch){__WEBPACK_IMPORTED_MODULE_1_services_settingsService__["a" /* default */].sendEmailSuport(payload).then(function(data){dispatch(sendEmailSupportSuccess());}).catch(function(err){console.log(err);});};};var deleteAccount=function deleteAccount(){return function(dispatch){__WEBPACK_IMPORTED_MODULE_1_services_settingsService__["a" /* default */].deleteAccount().then(dispatch(deleteAccountSuccess()));};};var deleteAccountSuccess=function deleteAccountSuccess(){return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["_30" /* SETTINGS_ACCOUNT_DELETED */]};};var sendEmailSupportSuccess=function sendEmailSupportSuccess(){return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["_34" /* SETTINGS_SEND_EMAIL_SUPPORT_SUCCESS */]};};var closeSentEmailSupport=function closeSentEmailSupport(){return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["_33" /* SETTINGS_CLOSE_SENT_EMAIL_SUPORT */]};};var showErrorUnsubscribe=function showErrorUnsubscribe(errorMessageUnsubscribe){return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["_36" /* SETTINGS_SHOW_ERROR_UNSUBSCRIBE */],errorMessageUnsubscribe:errorMessageUnsubscribe};};var closeErrorUnsubscribe=function closeErrorUnsubscribe(){return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["_32" /* SETTINGS_CLOSE_ERROR_UNSUBSCRIBE */]};};var unsubscribe=function unsubscribe(token){return function(dispatch){__WEBPACK_IMPORTED_MODULE_1_services_settingsService__["a" /* default */].unsubscribe(token).then(function(response){if(response.isUnsubscribed){dispatch(isUnsubscribeSuccess());}else{dispatch(showErrorUnsubscribe(Object(__WEBPACK_IMPORTED_MODULE_2_utils_userError__["e" /* knownError */])(__WEBPACK_IMPORTED_MODULE_2_utils_userError__["a" /* ERROR_CODES */].ACCOUNT_UNSUBSCRIBE_FAILED,{title:"We couldn't unsubscribe you",guidance:'Try the link in your most recent Lunch.Team email, or contact support and we will do it for you.',serverId:Object(__WEBPACK_IMPORTED_MODULE_2_utils_userError__["f" /* serverIdOf */])(response)})));}}).catch(function(err){dispatch(showErrorUnsubscribe(Object(__WEBPACK_IMPORTED_MODULE_2_utils_userError__["h" /* userError */])(err,{area:'ACCOUNT',code:__WEBPACK_IMPORTED_MODULE_2_utils_userError__["a" /* ERROR_CODES */].ACCOUNT_UNSUBSCRIBE_FAILED,task:'unsubscribe you'})));});};};var isUnsubscribeSuccess=function isUnsubscribeSuccess(){return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["_37" /* SETTINGS_UNSUBSCRIBE_SUCCESS */]};};

/***/ }),
/* 333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_utils_http__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_utils_magicLink__ = __webpack_require__(99);
// The shared fetch wrapper resolves non-2xx responses (other than 401/403) with the raw
// Response when autoHandle is false. Turn those into errors that carry the status, so
// callers can tell "expired" from "too many attempts".
function isRawResponse(result){return!!result&&typeof result.status==='number'&&typeof result.ok==='boolean'&&typeof result.text==='function';}function parseBody(response){return response.text().then(function(text){if(!text){return{};}try{return JSON.parse(text);}catch(error){return{message:text};}},function(){return{};});}// Readable only if the API exposes it to the browser (CORS); the body is the fallback.
function readRetryAfter(response){try{return response.headers&&typeof response.headers.get==='function'&&response.headers.get('Retry-After')||undefined;}catch(error){return undefined;}}function call(path,body){// autoHandle=false, autoControlSpinner=false: the caller shows its own progress.
return __WEBPACK_IMPORTED_MODULE_0_utils_http__["a" /* default */].post(path,body,undefined,false,false).then(function(result){if(isRawResponse(result)){if(result.ok){return parseBody(result);}return parseBody(result).then(function(data){var error=new Error('Magic link request failed');error.status=result.status;error.data=data;error.retryAfter=readRetryAfter(result);throw error;});}return result;},function(error){if(error&&error.response&&typeof error.status!=='number'){error.status=error.response.status;}throw error;});}var clientFields={clientApp:__WEBPACK_IMPORTED_MODULE_1_utils_magicLink__["a" /* MAGIC_LINK_CLIENT_APP */],targetApp:__WEBPACK_IMPORTED_MODULE_1_utils_magicLink__["a" /* MAGIC_LINK_CLIENT_APP */]// { enabled, enforced, requested, message }. "enforced" is ignored by this site:
// password sign-in is always offered.
};var status=function status(email){return call('/user/v1/login/magic-link-status',Object.assign({email:email},clientFields));};// Always answers generically; the backend never says whether the account exists.
var request=function request(email){return call('/user/v1/login/request-magic-link',Object.assign({email:email},clientFields));};// Same response as POST /user/v1/login: the user details body plus the session cookies.
var verify=function verify(token){return call('/user/v1/login/verify-magic-link',Object.assign({token:token},clientFields));};/* harmony default export */ __webpack_exports__["a"] = ({status:status,request:request,verify:verify});

/***/ }),
/* 334 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export MAIL_APPS */
/* unused harmony export CheckEmail */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_utils_magicLink__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SignIn_scss__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SignIn_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__SignIn_scss__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MAIL_APPS=[{name:'Gmail',href:'https://mail.google.com/'},{name:'Outlook',href:'https://outlook.live.com/'}];// "Check your email" after a sign-in link was sent. Used by the sign-in panel and by
// /MagicLogin after "Email me a new link".
//
// Resend stays disabled for `cooldownSeconds` (30 by default, or the Retry-After of a
// 429). Changing `cooldownKey` restarts the countdown.
var CheckEmail=function(_Component){_inherits(CheckEmail,_Component);function CheckEmail(){var _ref;var _temp,_this,_ret;_classCallCheck(this,CheckEmail);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=CheckEmail.__proto__||Object.getPrototypeOf(CheckEmail)).call.apply(_ref,[this].concat(args))),_this),_this.state={remaining:0},_this.tick=function(){var remaining=Math.max(0,_this.state.remaining-1);_this.setState({remaining:remaining});if(remaining===0){_this.stopCountdown();}},_this.handleResend=function(event){if(event&&event.preventDefault){event.preventDefault();}if(_this.state.remaining>0||_this.props.resending){return undefined;}return _this.props.onResend&&_this.props.onResend();},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(CheckEmail,[{key:'componentDidMount',value:function componentDidMount(){this.startCountdown(this.props.cooldownSeconds);if(this.props.autoFocus&&this.heading){this.heading.focus();}}},{key:'componentDidUpdate',value:function componentDidUpdate(previousProps){if(previousProps.cooldownKey!==this.props.cooldownKey){this.startCountdown(this.props.cooldownSeconds);}}},{key:'componentWillUnmount',value:function componentWillUnmount(){this.stopCountdown();}},{key:'startCountdown',value:function startCountdown(seconds){this.stopCountdown();var remaining=Math.max(0,Math.ceil(Number(seconds)||0));this.setState({remaining:remaining});if(remaining>0){this.timer=setInterval(this.tick,1000);}}},{key:'stopCountdown',value:function stopCountdown(){if(this.timer){clearInterval(this.timer);this.timer=null;}}},{key:'resendLabel',value:function resendLabel(){if(this.props.resending){return'Sending…';}if(this.state.remaining>0){return'Resend link in '+this.state.remaining+'s';}return'Resend link';}},{key:'render',value:function render(){var _this2=this;var _props=this.props,email=_props.email,message=_props.message,messageIsError=_props.messageIsError,onUsePassword=_props.onUsePassword,resending=_props.resending;var waiting=this.state.remaining>0;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'sign-in-check'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'sign-in-check__icon','aria-hidden':'true'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg',{viewBox:'0 0 24 24',width:'40',height:'40'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'currentColor',d:'M20 4H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zm0 4-8 5-8-5V6l8 5 8-5z'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{id:this.props.titleId||'sign-in-title',className:'sign-in__title',tabIndex:-1,ref:function ref(node){_this2.heading=node;}},'Check your email'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'sign-in-check__sent'},'We sent a sign-in link to ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,Object(__WEBPACK_IMPORTED_MODULE_1_utils_magicLink__["o" /* maskEmail */])(email))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'sign-in-check__help'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'Tap the link in the email to sign in. It works once.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'It expires in ',__WEBPACK_IMPORTED_MODULE_1_utils_magicLink__["d" /* MAGIC_LINK_LIFETIME_MINUTES */],' minutes.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'Can\u2019t see it? Check your spam or junk folder.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'sign-in-check__apps'},MAIL_APPS.map(function(app){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{key:app.name,className:'sign-in-btn sign-in-btn--outline sign-in-check__app',href:app.href,target:'_blank',rel:'noopener noreferrer'},'Open ',app.name,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'sign-in-visually-hidden'},' (opens in a new tab)'));})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'sign-in-btn sign-in-btn--secondary sign-in-check__resend',onClick:this.handleResend,disabled:waiting||!!resending,'aria-disabled':waiting||!!resending},this.resendLabel()),message&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:messageIsError?'sign-in__message sign-in__message--error':'sign-in__message',role:messageIsError?'alert':'status'},message),onUsePassword&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'sign-in-link sign-in-check__password',onClick:onUsePassword},'Use my password instead'));}}]);return CheckEmail;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);CheckEmail.defaultProps={cooldownSeconds:__WEBPACK_IMPORTED_MODULE_1_utils_magicLink__["e" /* MAGIC_LINK_RESEND_SECONDS */],cooldownKey:0};/* harmony default export */ __webpack_exports__["a"] = (CheckEmail);

/***/ }),
/* 335 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__FieldError_css__ = __webpack_require__(931);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__FieldError_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__FieldError_css__);
// Says what is wrong with a field. The red border alone is a colour-only cue,
// so an invalid field also gets these words and an icon.
var FieldError=function FieldError(_ref){var id=_ref.id,show=_ref.show,children=_ref.children;return show?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{id:id,className:'field-error'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'fa fa-exclamation-circle','aria-hidden':'true'}),children):null;};/* harmony default export */ __webpack_exports__["a"] = (FieldError);

/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strictUriEncode = __webpack_require__(958);
var objectAssign = __webpack_require__(82);
var decodeComponent = __webpack_require__(959);

function encoderForArrayFormat(opts) {
	switch (opts.arrayFormat) {
		case 'index':
			return function (key, value, index) {
				return value === null ? [
					encode(key, opts),
					'[',
					index,
					']'
				].join('') : [
					encode(key, opts),
					'[',
					encode(index, opts),
					']=',
					encode(value, opts)
				].join('');
			};

		case 'bracket':
			return function (key, value) {
				return value === null ? encode(key, opts) : [
					encode(key, opts),
					'[]=',
					encode(value, opts)
				].join('');
			};

		default:
			return function (key, value) {
				return value === null ? encode(key, opts) : [
					encode(key, opts),
					'=',
					encode(value, opts)
				].join('');
			};
	}
}

function parserForArrayFormat(opts) {
	var result;

	switch (opts.arrayFormat) {
		case 'index':
			return function (key, value, accumulator) {
				result = /\[(\d*)\]$/.exec(key);

				key = key.replace(/\[\d*\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				}

				if (accumulator[key] === undefined) {
					accumulator[key] = {};
				}

				accumulator[key][result[1]] = value;
			};

		case 'bracket':
			return function (key, value, accumulator) {
				result = /(\[\])$/.exec(key);
				key = key.replace(/\[\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				} else if (accumulator[key] === undefined) {
					accumulator[key] = [value];
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};

		default:
			return function (key, value, accumulator) {
				if (accumulator[key] === undefined) {
					accumulator[key] = value;
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};
	}
}

function encode(value, opts) {
	if (opts.encode) {
		return opts.strict ? strictUriEncode(value) : encodeURIComponent(value);
	}

	return value;
}

function keysSorter(input) {
	if (Array.isArray(input)) {
		return input.sort();
	} else if (typeof input === 'object') {
		return keysSorter(Object.keys(input)).sort(function (a, b) {
			return Number(a) - Number(b);
		}).map(function (key) {
			return input[key];
		});
	}

	return input;
}

function extract(str) {
	var queryStart = str.indexOf('?');
	if (queryStart === -1) {
		return '';
	}
	return str.slice(queryStart + 1);
}

function parse(str, opts) {
	opts = objectAssign({arrayFormat: 'none'}, opts);

	var formatter = parserForArrayFormat(opts);

	// Create an object with no prototype
	// https://github.com/sindresorhus/query-string/issues/47
	var ret = Object.create(null);

	if (typeof str !== 'string') {
		return ret;
	}

	str = str.trim().replace(/^[?#&]/, '');

	if (!str) {
		return ret;
	}

	str.split('&').forEach(function (param) {
		var parts = param.replace(/\+/g, ' ').split('=');
		// Firefox (pre 40) decodes `%3D` to `=`
		// https://github.com/sindresorhus/query-string/pull/37
		var key = parts.shift();
		var val = parts.length > 0 ? parts.join('=') : undefined;

		// missing `=` should be `null`:
		// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
		val = val === undefined ? null : decodeComponent(val);

		formatter(decodeComponent(key), val, ret);
	});

	return Object.keys(ret).sort().reduce(function (result, key) {
		var val = ret[key];
		if (Boolean(val) && typeof val === 'object' && !Array.isArray(val)) {
			// Sort object keys, not values
			result[key] = keysSorter(val);
		} else {
			result[key] = val;
		}

		return result;
	}, Object.create(null));
}

exports.extract = extract;
exports.parse = parse;

exports.stringify = function (obj, opts) {
	var defaults = {
		encode: true,
		strict: true,
		arrayFormat: 'none'
	};

	opts = objectAssign(defaults, opts);

	if (opts.sort === false) {
		opts.sort = function () {};
	}

	var formatter = encoderForArrayFormat(opts);

	return obj ? Object.keys(obj).sort(opts.sort).map(function (key) {
		var val = obj[key];

		if (val === undefined) {
			return '';
		}

		if (val === null) {
			return encode(key, opts);
		}

		if (Array.isArray(val)) {
			var result = [];

			val.slice().forEach(function (val2) {
				if (val2 === undefined) {
					return;
				}

				result.push(formatter(key, val2, result.length));
			});

			return result.join('&');
		}

		return encode(key, opts) + '=' + encode(val, opts);
	}).filter(function (x) {
		return x.length > 0;
	}).join('&') : '';
};

exports.parseUrl = function (str, opts) {
	return {
		url: str.split('?')[0] || '',
		query: parse(extract(str), opts)
	};
};


/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(338);
module.exports = __webpack_require__(544);


/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (typeof Promise === 'undefined') {
  // Rejection tracking prevents a common issue where React gets into an
  // inconsistent state due to an error, but it gets swallowed by a Promise,
  // and the user has no idea what causes React's erratic future behavior.
  __webpack_require__(339).enable();
  window.Promise = __webpack_require__(341);
}

// fetch() polyfill for making API calls.
__webpack_require__(342);

// Object.assign() is commonly used with React.
// It will use the native implementation if it's present and isn't buggy.
Object.assign = __webpack_require__(82);

// In tests, polyfill requestAnimationFrame since jsdom doesn't provide it yet.
// We don't polyfill it in the browser--this is user's responsibility.
if (false) {
  require('raf').polyfill(global);
}

__webpack_require__(214)


/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Promise = __webpack_require__(213);

var DEFAULT_WHITELIST = [
  ReferenceError,
  TypeError,
  RangeError
];

var enabled = false;
exports.disable = disable;
function disable() {
  enabled = false;
  Promise._47 = null;
  Promise._71 = null;
}

exports.enable = enable;
function enable(options) {
  options = options || {};
  if (enabled) disable();
  enabled = true;
  var id = 0;
  var displayId = 0;
  var rejections = {};
  Promise._47 = function (promise) {
    if (
      promise._83 === 2 && // IS REJECTED
      rejections[promise._56]
    ) {
      if (rejections[promise._56].logged) {
        onHandled(promise._56);
      } else {
        clearTimeout(rejections[promise._56].timeout);
      }
      delete rejections[promise._56];
    }
  };
  Promise._71 = function (promise, err) {
    if (promise._75 === 0) { // not yet handled
      promise._56 = id++;
      rejections[promise._56] = {
        displayId: null,
        error: err,
        timeout: setTimeout(
          onUnhandled.bind(null, promise._56),
          // For reference errors and type errors, this almost always
          // means the programmer made a mistake, so log them after just
          // 100ms
          // otherwise, wait 2 seconds to see if they get handled
          matchWhitelist(err, DEFAULT_WHITELIST)
            ? 100
            : 2000
        ),
        logged: false
      };
    }
  };
  function onUnhandled(id) {
    if (
      options.allRejections ||
      matchWhitelist(
        rejections[id].error,
        options.whitelist || DEFAULT_WHITELIST
      )
    ) {
      rejections[id].displayId = displayId++;
      if (options.onUnhandled) {
        rejections[id].logged = true;
        options.onUnhandled(
          rejections[id].displayId,
          rejections[id].error
        );
      } else {
        rejections[id].logged = true;
        logError(
          rejections[id].displayId,
          rejections[id].error
        );
      }
    }
  }
  function onHandled(id) {
    if (rejections[id].logged) {
      if (options.onHandled) {
        options.onHandled(rejections[id].displayId, rejections[id].error);
      } else if (!rejections[id].onUnhandled) {
        console.warn(
          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
        );
        console.warn(
          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
          rejections[id].displayId + '.'
        );
      }
    }
  }
}

function logError(id, error) {
  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
  var errStr = (error && (error.stack || error)) + '';
  errStr.split('\n').forEach(function (line) {
    console.warn('  ' + line);
  });
}

function matchWhitelist(error, list) {
  return list.some(function (cls) {
    return error instanceof cls;
  });
}

/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

// Use the fastest means possible to execute a task in its own turn, with
// priority over other events including IO, animation, reflow, and redraw
// events in browsers.
//
// An exception thrown by a task will permanently interrupt the processing of
// subsequent tasks. The higher level `asap` function ensures that if an
// exception is thrown by a task, that the task queue will continue flushing as
// soon as possible, but if you use `rawAsap` directly, you are responsible to
// either ensure that no exceptions are thrown from your task, or to manually
// call `rawAsap.requestFlush` if an exception is thrown.
module.exports = rawAsap;
function rawAsap(task) {
    if (!queue.length) {
        requestFlush();
        flushing = true;
    }
    // Equivalent to push, but avoids a function call.
    queue[queue.length] = task;
}

var queue = [];
// Once a flush has been requested, no further calls to `requestFlush` are
// necessary until the next `flush` completes.
var flushing = false;
// `requestFlush` is an implementation-specific method that attempts to kick
// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
// the event queue before yielding to the browser's own event loop.
var requestFlush;
// The position of the next task to execute in the task queue. This is
// preserved between calls to `flush` so that it can be resumed if
// a task throws an exception.
var index = 0;
// If a task schedules additional tasks recursively, the task queue can grow
// unbounded. To prevent memory exhaustion, the task queue will periodically
// truncate already-completed tasks.
var capacity = 1024;

// The flush function processes all tasks that have been scheduled with
// `rawAsap` unless and until one of those tasks throws an exception.
// If a task throws an exception, `flush` ensures that its state will remain
// consistent and will resume where it left off when called again.
// However, `flush` does not make any arrangements to be called again if an
// exception is thrown.
function flush() {
    while (index < queue.length) {
        var currentIndex = index;
        // Advance the index before calling the task. This ensures that we will
        // begin flushing on the next task the task throws an error.
        index = index + 1;
        queue[currentIndex].call();
        // Prevent leaking memory for long chains of recursive calls to `asap`.
        // If we call `asap` within tasks scheduled by `asap`, the queue will
        // grow, but to avoid an O(n) walk for every task we execute, we don't
        // shift tasks off the queue after they have been executed.
        // Instead, we periodically shift 1024 tasks off the queue.
        if (index > capacity) {
            // Manually shift all values starting at the index back to the
            // beginning of the queue.
            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
                queue[scan] = queue[scan + index];
            }
            queue.length -= index;
            index = 0;
        }
    }
    queue.length = 0;
    index = 0;
    flushing = false;
}

// `requestFlush` is implemented using a strategy based on data collected from
// every available SauceLabs Selenium web driver worker at time of writing.
// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593

// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.

/* globals self */
var scope = typeof global !== "undefined" ? global : self;
var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;

// MutationObservers are desirable because they have high priority and work
// reliably everywhere they are implemented.
// They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
if (typeof BrowserMutationObserver === "function") {
    requestFlush = makeRequestCallFromMutationObserver(flush);

// MessageChannels are desirable because they give direct access to the HTML
// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
// 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.

// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396

// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
} else {
    requestFlush = makeRequestCallFromTimer(flush);
}

// `requestFlush` requests that the high priority event queue be flushed as
// soon as possible.
// This is useful to prevent an error thrown in a task from stalling the event
// queue if the exception handled by Node.js’s
// `process.on("uncaughtException")` or by a domain.
rawAsap.requestFlush = requestFlush;

// To request a high priority event, we induce a mutation observer by toggling
// the text of a text node between "1" and "-1".
function makeRequestCallFromMutationObserver(callback) {
    var toggle = 1;
    var observer = new BrowserMutationObserver(callback);
    var node = document.createTextNode("");
    observer.observe(node, {characterData: true});
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}

// The message channel technique was discovered by Malte Ubl and was the
// original foundation for this library.
// http://www.nonblocking.io/2011/06/windownexttick.html

// Safari 6.0.5 (at least) intermittently fails to create message ports on a
// page's first load. Thankfully, this version of Safari supports
// MutationObservers, so we don't need to fall back in that case.

// function makeRequestCallFromMessageChannel(callback) {
//     var channel = new MessageChannel();
//     channel.port1.onmessage = callback;
//     return function requestCall() {
//         channel.port2.postMessage(0);
//     };
// }

// For reasons explained above, we are also unable to use `setImmediate`
// under any circumstances.
// Even if we were, there is another bug in Internet Explorer 10.
// It is not sufficient to assign `setImmediate` to `requestFlush` because
// `setImmediate` must be called *by name* and therefore must be wrapped in a
// closure.
// Never forget.

// function makeRequestCallFromSetImmediate(callback) {
//     return function requestCall() {
//         setImmediate(callback);
//     };
// }

// Safari 6.0 has a problem where timers will get lost while the user is
// scrolling. This problem does not impact ASAP because Safari 6.0 supports
// mutation observers, so that implementation is used instead.
// However, if we ever elect to use timers in Safari, the prevalent work-around
// is to add a scroll event listener that calls for a flush.

// `setTimeout` does not call the passed callback if the delay is less than
// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
// even then.

function makeRequestCallFromTimer(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        var timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        var intervalHandle = setInterval(handleTimer, 50);

        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}

// This is for `asap.js` only.
// Its name will be periodically randomized to break any code that depends on
// its existence.
rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;

// ASAP was originally a nextTick shim included in Q. This was factored out
// into this ASAP package. It was later adapted to RSVP which made further
// amendments. These decisions, particularly to marginalize MessageChannel and
// to capture the MutationObserver implementation in a closure, were integrated
// back into ASAP proper.
// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(39)))

/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//This file contains the ES6 extensions to the core Promises/A+ API

var Promise = __webpack_require__(213);

module.exports = Promise;

/* Static Functions */

var TRUE = valuePromise(true);
var FALSE = valuePromise(false);
var NULL = valuePromise(null);
var UNDEFINED = valuePromise(undefined);
var ZERO = valuePromise(0);
var EMPTYSTRING = valuePromise('');

function valuePromise(value) {
  var p = new Promise(Promise._44);
  p._83 = 1;
  p._18 = value;
  return p;
}
Promise.resolve = function (value) {
  if (value instanceof Promise) return value;

  if (value === null) return NULL;
  if (value === undefined) return UNDEFINED;
  if (value === true) return TRUE;
  if (value === false) return FALSE;
  if (value === 0) return ZERO;
  if (value === '') return EMPTYSTRING;

  if (typeof value === 'object' || typeof value === 'function') {
    try {
      var then = value.then;
      if (typeof then === 'function') {
        return new Promise(then.bind(value));
      }
    } catch (ex) {
      return new Promise(function (resolve, reject) {
        reject(ex);
      });
    }
  }
  return valuePromise(value);
};

Promise.all = function (arr) {
  var args = Array.prototype.slice.call(arr);

  return new Promise(function (resolve, reject) {
    if (args.length === 0) return resolve([]);
    var remaining = args.length;
    function res(i, val) {
      if (val && (typeof val === 'object' || typeof val === 'function')) {
        if (val instanceof Promise && val.then === Promise.prototype.then) {
          while (val._83 === 3) {
            val = val._18;
          }
          if (val._83 === 1) return res(i, val._18);
          if (val._83 === 2) reject(val._18);
          val.then(function (val) {
            res(i, val);
          }, reject);
          return;
        } else {
          var then = val.then;
          if (typeof then === 'function') {
            var p = new Promise(then.bind(val));
            p.then(function (val) {
              res(i, val);
            }, reject);
            return;
          }
        }
      }
      args[i] = val;
      if (--remaining === 0) {
        resolve(args);
      }
    }
    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise.reject = function (value) {
  return new Promise(function (resolve, reject) {
    reject(value);
  });
};

Promise.race = function (values) {
  return new Promise(function (resolve, reject) {
    values.forEach(function(value){
      Promise.resolve(value).then(resolve, reject);
    });
  });
};

/* Prototype Methods */

Promise.prototype['catch'] = function (onRejected) {
  return this.then(null, onRejected);
};


/***/ }),
/* 342 */
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    rawHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = 'status' in options ? options.status : 200
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(344);
__webpack_require__(347);
__webpack_require__(348);
__webpack_require__(349);
__webpack_require__(350);
__webpack_require__(351);
__webpack_require__(352);
__webpack_require__(353);
__webpack_require__(354);
__webpack_require__(355);
__webpack_require__(356);
__webpack_require__(357);
__webpack_require__(358);
__webpack_require__(359);
__webpack_require__(360);
__webpack_require__(361);
__webpack_require__(362);
__webpack_require__(363);
__webpack_require__(364);
__webpack_require__(365);
__webpack_require__(366);
__webpack_require__(367);
__webpack_require__(368);
__webpack_require__(369);
__webpack_require__(370);
__webpack_require__(371);
__webpack_require__(372);
__webpack_require__(373);
__webpack_require__(374);
__webpack_require__(375);
__webpack_require__(376);
__webpack_require__(377);
__webpack_require__(378);
__webpack_require__(379);
__webpack_require__(380);
__webpack_require__(381);
__webpack_require__(382);
__webpack_require__(383);
__webpack_require__(384);
__webpack_require__(385);
__webpack_require__(386);
__webpack_require__(387);
__webpack_require__(388);
__webpack_require__(389);
__webpack_require__(390);
__webpack_require__(391);
__webpack_require__(392);
__webpack_require__(393);
__webpack_require__(394);
__webpack_require__(395);
__webpack_require__(396);
__webpack_require__(397);
__webpack_require__(398);
__webpack_require__(399);
__webpack_require__(400);
__webpack_require__(401);
__webpack_require__(402);
__webpack_require__(403);
__webpack_require__(404);
__webpack_require__(405);
__webpack_require__(406);
__webpack_require__(407);
__webpack_require__(408);
__webpack_require__(409);
__webpack_require__(410);
__webpack_require__(411);
__webpack_require__(412);
__webpack_require__(413);
__webpack_require__(414);
__webpack_require__(415);
__webpack_require__(416);
__webpack_require__(417);
__webpack_require__(418);
__webpack_require__(419);
__webpack_require__(420);
__webpack_require__(421);
__webpack_require__(422);
__webpack_require__(424);
__webpack_require__(425);
__webpack_require__(427);
__webpack_require__(428);
__webpack_require__(429);
__webpack_require__(430);
__webpack_require__(431);
__webpack_require__(432);
__webpack_require__(433);
__webpack_require__(435);
__webpack_require__(436);
__webpack_require__(437);
__webpack_require__(438);
__webpack_require__(439);
__webpack_require__(440);
__webpack_require__(441);
__webpack_require__(442);
__webpack_require__(443);
__webpack_require__(444);
__webpack_require__(445);
__webpack_require__(446);
__webpack_require__(447);
__webpack_require__(164);
__webpack_require__(448);
__webpack_require__(234);
__webpack_require__(449);
__webpack_require__(235);
__webpack_require__(450);
__webpack_require__(451);
__webpack_require__(452);
__webpack_require__(453);
__webpack_require__(454);
__webpack_require__(238);
__webpack_require__(240);
__webpack_require__(241);
__webpack_require__(455);
__webpack_require__(456);
__webpack_require__(457);
__webpack_require__(458);
__webpack_require__(459);
__webpack_require__(460);
__webpack_require__(461);
__webpack_require__(462);
__webpack_require__(463);
__webpack_require__(464);
__webpack_require__(465);
__webpack_require__(466);
__webpack_require__(467);
__webpack_require__(468);
__webpack_require__(469);
__webpack_require__(470);
__webpack_require__(471);
__webpack_require__(472);
__webpack_require__(473);
__webpack_require__(474);
__webpack_require__(475);
__webpack_require__(476);
__webpack_require__(477);
__webpack_require__(478);
__webpack_require__(479);
__webpack_require__(480);
__webpack_require__(481);
__webpack_require__(482);
__webpack_require__(483);
__webpack_require__(484);
__webpack_require__(485);
__webpack_require__(486);
__webpack_require__(487);
__webpack_require__(488);
__webpack_require__(489);
__webpack_require__(490);
__webpack_require__(491);
__webpack_require__(492);
__webpack_require__(493);
__webpack_require__(494);
__webpack_require__(495);
__webpack_require__(496);
__webpack_require__(497);
__webpack_require__(498);
__webpack_require__(499);
__webpack_require__(500);
__webpack_require__(501);
__webpack_require__(502);
__webpack_require__(503);
__webpack_require__(504);
__webpack_require__(505);
__webpack_require__(506);
__webpack_require__(507);
__webpack_require__(508);
__webpack_require__(509);
__webpack_require__(510);
__webpack_require__(511);
__webpack_require__(512);
__webpack_require__(513);
__webpack_require__(514);
__webpack_require__(515);
__webpack_require__(516);
__webpack_require__(517);
__webpack_require__(518);
__webpack_require__(519);
__webpack_require__(520);
__webpack_require__(521);
__webpack_require__(522);
__webpack_require__(523);
__webpack_require__(524);
__webpack_require__(525);
__webpack_require__(526);
__webpack_require__(527);
__webpack_require__(528);
__webpack_require__(529);
__webpack_require__(530);
__webpack_require__(531);
__webpack_require__(532);
__webpack_require__(533);
__webpack_require__(534);
__webpack_require__(535);
__webpack_require__(536);
__webpack_require__(537);
__webpack_require__(538);
__webpack_require__(539);
module.exports = __webpack_require__(31);


/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(3);
var has = __webpack_require__(27);
var DESCRIPTORS = __webpack_require__(12);
var $export = __webpack_require__(1);
var redefine = __webpack_require__(23);
var META = __webpack_require__(51).KEY;
var $fails = __webpack_require__(6);
var shared = __webpack_require__(83);
var setToStringTag = __webpack_require__(73);
var uid = __webpack_require__(56);
var wks = __webpack_require__(10);
var wksExt = __webpack_require__(216);
var wksDefine = __webpack_require__(145);
var enumKeys = __webpack_require__(346);
var isArray = __webpack_require__(102);
var anObject = __webpack_require__(2);
var isObject = __webpack_require__(9);
var toObject = __webpack_require__(18);
var toIObject = __webpack_require__(28);
var toPrimitive = __webpack_require__(40);
var createDesc = __webpack_require__(55);
var _create = __webpack_require__(59);
var gOPNExt = __webpack_require__(219);
var $GOPD = __webpack_require__(29);
var $GOPS = __webpack_require__(101);
var $DP = __webpack_require__(16);
var $keys = __webpack_require__(57);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(60).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(85).f = $propertyIsEnumerable;
  $GOPS.f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(50)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });

$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return $GOPS.f(toObject(it));
  }
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(22)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(83)('native-function-to-string', Function.toString);


/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(57);
var gOPS = __webpack_require__(101);
var pIE = __webpack_require__(85);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(1);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(59) });


/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(1);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(12), 'Object', { defineProperty: __webpack_require__(16).f });


/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(1);
// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
$export($export.S + $export.F * !__webpack_require__(12), 'Object', { defineProperties: __webpack_require__(218) });


/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
var toIObject = __webpack_require__(28);
var $getOwnPropertyDescriptor = __webpack_require__(29).f;

__webpack_require__(42)('getOwnPropertyDescriptor', function () {
  return function getOwnPropertyDescriptor(it, key) {
    return $getOwnPropertyDescriptor(toIObject(it), key);
  };
});


/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = __webpack_require__(18);
var $getPrototypeOf = __webpack_require__(30);

__webpack_require__(42)('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});


/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(18);
var $keys = __webpack_require__(57);

__webpack_require__(42)('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 Object.getOwnPropertyNames(O)
__webpack_require__(42)('getOwnPropertyNames', function () {
  return __webpack_require__(219).f;
});


/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.5 Object.freeze(O)
var isObject = __webpack_require__(9);
var meta = __webpack_require__(51).onFreeze;

__webpack_require__(42)('freeze', function ($freeze) {
  return function freeze(it) {
    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
  };
});


/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.17 Object.seal(O)
var isObject = __webpack_require__(9);
var meta = __webpack_require__(51).onFreeze;

__webpack_require__(42)('seal', function ($seal) {
  return function seal(it) {
    return $seal && isObject(it) ? $seal(meta(it)) : it;
  };
});


/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.15 Object.preventExtensions(O)
var isObject = __webpack_require__(9);
var meta = __webpack_require__(51).onFreeze;

__webpack_require__(42)('preventExtensions', function ($preventExtensions) {
  return function preventExtensions(it) {
    return $preventExtensions && isObject(it) ? $preventExtensions(meta(it)) : it;
  };
});


/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.12 Object.isFrozen(O)
var isObject = __webpack_require__(9);

__webpack_require__(42)('isFrozen', function ($isFrozen) {
  return function isFrozen(it) {
    return isObject(it) ? $isFrozen ? $isFrozen(it) : false : true;
  };
});


/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.13 Object.isSealed(O)
var isObject = __webpack_require__(9);

__webpack_require__(42)('isSealed', function ($isSealed) {
  return function isSealed(it) {
    return isObject(it) ? $isSealed ? $isSealed(it) : false : true;
  };
});


/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.11 Object.isExtensible(O)
var isObject = __webpack_require__(9);

__webpack_require__(42)('isExtensible', function ($isExtensible) {
  return function isExtensible(it) {
    return isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
  };
});


/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(1);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(220) });


/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.10 Object.is(value1, value2)
var $export = __webpack_require__(1);
$export($export.S, 'Object', { is: __webpack_require__(221) });


/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(1);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(149).set });


/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.3.6 Object.prototype.toString()
var classof = __webpack_require__(74);
var test = {};
test[__webpack_require__(10)('toStringTag')] = 'z';
if (test + '' != '[object z]') {
  __webpack_require__(23)(Object.prototype, 'toString', function toString() {
    return '[object ' + classof(this) + ']';
  }, true);
}


/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

// 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)
var $export = __webpack_require__(1);

$export($export.P, 'Function', { bind: __webpack_require__(222) });


/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(16).f;
var FProto = Function.prototype;
var nameRE = /^\s*function ([^ (]*)/;
var NAME = 'name';

// 19.2.4.2 name
NAME in FProto || __webpack_require__(12) && dP(FProto, NAME, {
  configurable: true,
  get: function () {
    try {
      return ('' + this).match(nameRE)[1];
    } catch (e) {
      return '';
    }
  }
});


/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isObject = __webpack_require__(9);
var getPrototypeOf = __webpack_require__(30);
var HAS_INSTANCE = __webpack_require__(10)('hasInstance');
var FunctionProto = Function.prototype;
// 19.2.3.6 Function.prototype[@@hasInstance](V)
if (!(HAS_INSTANCE in FunctionProto)) __webpack_require__(16).f(FunctionProto, HAS_INSTANCE, { value: function (O) {
  if (typeof this != 'function' || !isObject(O)) return false;
  if (!isObject(this.prototype)) return O instanceof this;
  // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
  while (O = getPrototypeOf(O)) if (this.prototype === O) return true;
  return false;
} });


/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(1);
var $parseInt = __webpack_require__(224);
// 18.2.5 parseInt(string, radix)
$export($export.G + $export.F * (parseInt != $parseInt), { parseInt: $parseInt });


/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(1);
var $parseFloat = __webpack_require__(225);
// 18.2.4 parseFloat(string)
$export($export.G + $export.F * (parseFloat != $parseFloat), { parseFloat: $parseFloat });


/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(3);
var has = __webpack_require__(27);
var cof = __webpack_require__(33);
var inheritIfRequired = __webpack_require__(151);
var toPrimitive = __webpack_require__(40);
var fails = __webpack_require__(6);
var gOPN = __webpack_require__(60).f;
var gOPD = __webpack_require__(29).f;
var dP = __webpack_require__(16).f;
var $trim = __webpack_require__(75).trim;
var NUMBER = 'Number';
var $Number = global[NUMBER];
var Base = $Number;
var proto = $Number.prototype;
// Opera ~12 has broken Object#toString
var BROKEN_COF = cof(__webpack_require__(59)(proto)) == NUMBER;
var TRIM = 'trim' in String.prototype;

// 7.1.3 ToNumber(argument)
var toNumber = function (argument) {
  var it = toPrimitive(argument, false);
  if (typeof it == 'string' && it.length > 2) {
    it = TRIM ? it.trim() : $trim(it, 3);
    var first = it.charCodeAt(0);
    var third, radix, maxCode;
    if (first === 43 || first === 45) {
      third = it.charCodeAt(2);
      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
    } else if (first === 48) {
      switch (it.charCodeAt(1)) {
        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal /^0b[01]+$/i
        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal /^0o[0-7]+$/i
        default: return +it;
      }
      for (var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++) {
        code = digits.charCodeAt(i);
        // parseInt parses a string to a first unavailable symbol
        // but ToNumber should return NaN if a string contains unavailable symbols
        if (code < 48 || code > maxCode) return NaN;
      } return parseInt(digits, radix);
    }
  } return +it;
};

if (!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')) {
  $Number = function Number(value) {
    var it = arguments.length < 1 ? 0 : value;
    var that = this;
    return that instanceof $Number
      // check on 1..constructor(foo) case
      && (BROKEN_COF ? fails(function () { proto.valueOf.call(that); }) : cof(that) != NUMBER)
        ? inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
  };
  for (var keys = __webpack_require__(12) ? gOPN(Base) : (
    // ES3:
    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
    // ES6 (in case, if modules with ES6 Number statics required before):
    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
  ).split(','), j = 0, key; keys.length > j; j++) {
    if (has(Base, key = keys[j]) && !has($Number, key)) {
      dP($Number, key, gOPD(Base, key));
    }
  }
  $Number.prototype = proto;
  proto.constructor = $Number;
  __webpack_require__(23)(global, NUMBER, $Number);
}


/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var toInteger = __webpack_require__(34);
var aNumberValue = __webpack_require__(226);
var repeat = __webpack_require__(152);
var $toFixed = 1.0.toFixed;
var floor = Math.floor;
var data = [0, 0, 0, 0, 0, 0];
var ERROR = 'Number.toFixed: incorrect invocation!';
var ZERO = '0';

var multiply = function (n, c) {
  var i = -1;
  var c2 = c;
  while (++i < 6) {
    c2 += n * data[i];
    data[i] = c2 % 1e7;
    c2 = floor(c2 / 1e7);
  }
};
var divide = function (n) {
  var i = 6;
  var c = 0;
  while (--i >= 0) {
    c += data[i];
    data[i] = floor(c / n);
    c = (c % n) * 1e7;
  }
};
var numToString = function () {
  var i = 6;
  var s = '';
  while (--i >= 0) {
    if (s !== '' || i === 0 || data[i] !== 0) {
      var t = String(data[i]);
      s = s === '' ? t : s + repeat.call(ZERO, 7 - t.length) + t;
    }
  } return s;
};
var pow = function (x, n, acc) {
  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
};
var log = function (x) {
  var n = 0;
  var x2 = x;
  while (x2 >= 4096) {
    n += 12;
    x2 /= 4096;
  }
  while (x2 >= 2) {
    n += 1;
    x2 /= 2;
  } return n;
};

$export($export.P + $export.F * (!!$toFixed && (
  0.00008.toFixed(3) !== '0.000' ||
  0.9.toFixed(0) !== '1' ||
  1.255.toFixed(2) !== '1.25' ||
  1000000000000000128.0.toFixed(0) !== '1000000000000000128'
) || !__webpack_require__(6)(function () {
  // V8 ~ Android 4.3-
  $toFixed.call({});
})), 'Number', {
  toFixed: function toFixed(fractionDigits) {
    var x = aNumberValue(this, ERROR);
    var f = toInteger(fractionDigits);
    var s = '';
    var m = ZERO;
    var e, z, j, k;
    if (f < 0 || f > 20) throw RangeError(ERROR);
    // eslint-disable-next-line no-self-compare
    if (x != x) return 'NaN';
    if (x <= -1e21 || x >= 1e21) return String(x);
    if (x < 0) {
      s = '-';
      x = -x;
    }
    if (x > 1e-21) {
      e = log(x * pow(2, 69, 1)) - 69;
      z = e < 0 ? x * pow(2, -e, 1) : x / pow(2, e, 1);
      z *= 0x10000000000000;
      e = 52 - e;
      if (e > 0) {
        multiply(0, z);
        j = f;
        while (j >= 7) {
          multiply(1e7, 0);
          j -= 7;
        }
        multiply(pow(10, j, 1), 0);
        j = e - 1;
        while (j >= 23) {
          divide(1 << 23);
          j -= 23;
        }
        divide(1 << j);
        multiply(1, 1);
        divide(2);
        m = numToString();
      } else {
        multiply(0, z);
        multiply(1 << -e, 0);
        m = numToString() + repeat.call(ZERO, f);
      }
    }
    if (f > 0) {
      k = m.length;
      m = s + (k <= f ? '0.' + repeat.call(ZERO, f - k) + m : m.slice(0, k - f) + '.' + m.slice(k - f));
    } else {
      m = s + m;
    } return m;
  }
});


/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var $fails = __webpack_require__(6);
var aNumberValue = __webpack_require__(226);
var $toPrecision = 1.0.toPrecision;

$export($export.P + $export.F * ($fails(function () {
  // IE7-
  return $toPrecision.call(1, undefined) !== '1';
}) || !$fails(function () {
  // V8 ~ Android 4.3-
  $toPrecision.call({});
})), 'Number', {
  toPrecision: function toPrecision(precision) {
    var that = aNumberValue(this, 'Number#toPrecision: incorrect invocation!');
    return precision === undefined ? $toPrecision.call(that) : $toPrecision.call(that, precision);
  }
});


/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.1 Number.EPSILON
var $export = __webpack_require__(1);

$export($export.S, 'Number', { EPSILON: Math.pow(2, -52) });


/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.2 Number.isFinite(number)
var $export = __webpack_require__(1);
var _isFinite = __webpack_require__(3).isFinite;

$export($export.S, 'Number', {
  isFinite: function isFinite(it) {
    return typeof it == 'number' && _isFinite(it);
  }
});


/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var $export = __webpack_require__(1);

$export($export.S, 'Number', { isInteger: __webpack_require__(227) });


/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.4 Number.isNaN(number)
var $export = __webpack_require__(1);

$export($export.S, 'Number', {
  isNaN: function isNaN(number) {
    // eslint-disable-next-line no-self-compare
    return number != number;
  }
});


/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.5 Number.isSafeInteger(number)
var $export = __webpack_require__(1);
var isInteger = __webpack_require__(227);
var abs = Math.abs;

$export($export.S, 'Number', {
  isSafeInteger: function isSafeInteger(number) {
    return isInteger(number) && abs(number) <= 0x1fffffffffffff;
  }
});


/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.6 Number.MAX_SAFE_INTEGER
var $export = __webpack_require__(1);

$export($export.S, 'Number', { MAX_SAFE_INTEGER: 0x1fffffffffffff });


/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.10 Number.MIN_SAFE_INTEGER
var $export = __webpack_require__(1);

$export($export.S, 'Number', { MIN_SAFE_INTEGER: -0x1fffffffffffff });


/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(1);
var $parseFloat = __webpack_require__(225);
// 20.1.2.12 Number.parseFloat(string)
$export($export.S + $export.F * (Number.parseFloat != $parseFloat), 'Number', { parseFloat: $parseFloat });


/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(1);
var $parseInt = __webpack_require__(224);
// 20.1.2.13 Number.parseInt(string, radix)
$export($export.S + $export.F * (Number.parseInt != $parseInt), 'Number', { parseInt: $parseInt });


/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.3 Math.acosh(x)
var $export = __webpack_require__(1);
var log1p = __webpack_require__(228);
var sqrt = Math.sqrt;
var $acosh = Math.acosh;

$export($export.S + $export.F * !($acosh
  // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
  && Math.floor($acosh(Number.MAX_VALUE)) == 710
  // Tor Browser bug: Math.acosh(Infinity) -> NaN
  && $acosh(Infinity) == Infinity
), 'Math', {
  acosh: function acosh(x) {
    return (x = +x) < 1 ? NaN : x > 94906265.62425156
      ? Math.log(x) + Math.LN2
      : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
  }
});


/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.5 Math.asinh(x)
var $export = __webpack_require__(1);
var $asinh = Math.asinh;

function asinh(x) {
  return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
}

// Tor Browser bug: Math.asinh(0) -> -0
$export($export.S + $export.F * !($asinh && 1 / $asinh(0) > 0), 'Math', { asinh: asinh });


/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.7 Math.atanh(x)
var $export = __webpack_require__(1);
var $atanh = Math.atanh;

// Tor Browser bug: Math.atanh(-0) -> 0
$export($export.S + $export.F * !($atanh && 1 / $atanh(-0) < 0), 'Math', {
  atanh: function atanh(x) {
    return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
  }
});


/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.9 Math.cbrt(x)
var $export = __webpack_require__(1);
var sign = __webpack_require__(153);

$export($export.S, 'Math', {
  cbrt: function cbrt(x) {
    return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
  }
});


/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.11 Math.clz32(x)
var $export = __webpack_require__(1);

$export($export.S, 'Math', {
  clz32: function clz32(x) {
    return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
  }
});


/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.12 Math.cosh(x)
var $export = __webpack_require__(1);
var exp = Math.exp;

$export($export.S, 'Math', {
  cosh: function cosh(x) {
    return (exp(x = +x) + exp(-x)) / 2;
  }
});


/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.14 Math.expm1(x)
var $export = __webpack_require__(1);
var $expm1 = __webpack_require__(154);

$export($export.S + $export.F * ($expm1 != Math.expm1), 'Math', { expm1: $expm1 });


/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.16 Math.fround(x)
var $export = __webpack_require__(1);

$export($export.S, 'Math', { fround: __webpack_require__(229) });


/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
var $export = __webpack_require__(1);
var abs = Math.abs;

$export($export.S, 'Math', {
  hypot: function hypot(value1, value2) { // eslint-disable-line no-unused-vars
    var sum = 0;
    var i = 0;
    var aLen = arguments.length;
    var larg = 0;
    var arg, div;
    while (i < aLen) {
      arg = abs(arguments[i++]);
      if (larg < arg) {
        div = larg / arg;
        sum = sum * div * div + 1;
        larg = arg;
      } else if (arg > 0) {
        div = arg / larg;
        sum += div * div;
      } else sum += arg;
    }
    return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
  }
});


/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.18 Math.imul(x, y)
var $export = __webpack_require__(1);
var $imul = Math.imul;

// some WebKit versions fails with big numbers, some has wrong arity
$export($export.S + $export.F * __webpack_require__(6)(function () {
  return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
}), 'Math', {
  imul: function imul(x, y) {
    var UINT16 = 0xffff;
    var xn = +x;
    var yn = +y;
    var xl = UINT16 & xn;
    var yl = UINT16 & yn;
    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
  }
});


/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.21 Math.log10(x)
var $export = __webpack_require__(1);

$export($export.S, 'Math', {
  log10: function log10(x) {
    return Math.log(x) * Math.LOG10E;
  }
});


/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.20 Math.log1p(x)
var $export = __webpack_require__(1);

$export($export.S, 'Math', { log1p: __webpack_require__(228) });


/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.22 Math.log2(x)
var $export = __webpack_require__(1);

$export($export.S, 'Math', {
  log2: function log2(x) {
    return Math.log(x) / Math.LN2;
  }
});


/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.28 Math.sign(x)
var $export = __webpack_require__(1);

$export($export.S, 'Math', { sign: __webpack_require__(153) });


/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.30 Math.sinh(x)
var $export = __webpack_require__(1);
var expm1 = __webpack_require__(154);
var exp = Math.exp;

// V8 near Chromium 38 has a problem with very small numbers
$export($export.S + $export.F * __webpack_require__(6)(function () {
  return !Math.sinh(-2e-17) != -2e-17;
}), 'Math', {
  sinh: function sinh(x) {
    return Math.abs(x = +x) < 1
      ? (expm1(x) - expm1(-x)) / 2
      : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
  }
});


/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.33 Math.tanh(x)
var $export = __webpack_require__(1);
var expm1 = __webpack_require__(154);
var exp = Math.exp;

$export($export.S, 'Math', {
  tanh: function tanh(x) {
    var a = expm1(x = +x);
    var b = expm1(-x);
    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
  }
});


/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.34 Math.trunc(x)
var $export = __webpack_require__(1);

$export($export.S, 'Math', {
  trunc: function trunc(it) {
    return (it > 0 ? Math.floor : Math.ceil)(it);
  }
});


/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(1);
var toAbsoluteIndex = __webpack_require__(58);
var fromCharCode = String.fromCharCode;
var $fromCodePoint = String.fromCodePoint;

// length should be 1, old FF problem
$export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
  // 21.1.2.2 String.fromCodePoint(...codePoints)
  fromCodePoint: function fromCodePoint(x) { // eslint-disable-line no-unused-vars
    var res = [];
    var aLen = arguments.length;
    var i = 0;
    var code;
    while (aLen > i) {
      code = +arguments[i++];
      if (toAbsoluteIndex(code, 0x10ffff) !== code) throw RangeError(code + ' is not a valid code point');
      res.push(code < 0x10000
        ? fromCharCode(code)
        : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00)
      );
    } return res.join('');
  }
});


/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(1);
var toIObject = __webpack_require__(28);
var toLength = __webpack_require__(11);

$export($export.S, 'String', {
  // 21.1.2.4 String.raw(callSite, ...substitutions)
  raw: function raw(callSite) {
    var tpl = toIObject(callSite.raw);
    var len = toLength(tpl.length);
    var aLen = arguments.length;
    var res = [];
    var i = 0;
    while (len > i) {
      res.push(String(tpl[i++]));
      if (i < aLen) res.push(String(arguments[i]));
    } return res.join('');
  }
});


/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.1.3.25 String.prototype.trim()
__webpack_require__(75)('trim', function ($trim) {
  return function trim() {
    return $trim(this, 3);
  };
});


/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(103)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(155)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var $at = __webpack_require__(103)(false);
$export($export.P, 'String', {
  // 21.1.3.3 String.prototype.codePointAt(pos)
  codePointAt: function codePointAt(pos) {
    return $at(this, pos);
  }
});


/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])

var $export = __webpack_require__(1);
var toLength = __webpack_require__(11);
var context = __webpack_require__(157);
var ENDS_WITH = 'endsWith';
var $endsWith = ''[ENDS_WITH];

$export($export.P + $export.F * __webpack_require__(158)(ENDS_WITH), 'String', {
  endsWith: function endsWith(searchString /* , endPosition = @length */) {
    var that = context(this, searchString, ENDS_WITH);
    var endPosition = arguments.length > 1 ? arguments[1] : undefined;
    var len = toLength(that.length);
    var end = endPosition === undefined ? len : Math.min(toLength(endPosition), len);
    var search = String(searchString);
    return $endsWith
      ? $endsWith.call(that, search, end)
      : that.slice(end - search.length, end) === search;
  }
});


/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.7 String.prototype.includes(searchString, position = 0)

var $export = __webpack_require__(1);
var context = __webpack_require__(157);
var INCLUDES = 'includes';

$export($export.P + $export.F * __webpack_require__(158)(INCLUDES), 'String', {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~context(this, searchString, INCLUDES)
      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(1);

$export($export.P, 'String', {
  // 21.1.3.13 String.prototype.repeat(count)
  repeat: __webpack_require__(152)
});


/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.18 String.prototype.startsWith(searchString [, position ])

var $export = __webpack_require__(1);
var toLength = __webpack_require__(11);
var context = __webpack_require__(157);
var STARTS_WITH = 'startsWith';
var $startsWith = ''[STARTS_WITH];

$export($export.P + $export.F * __webpack_require__(158)(STARTS_WITH), 'String', {
  startsWith: function startsWith(searchString /* , position = 0 */) {
    var that = context(this, searchString, STARTS_WITH);
    var index = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
    var search = String(searchString);
    return $startsWith
      ? $startsWith.call(that, search, index)
      : that.slice(index, index + search.length) === search;
  }
});


/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.2 String.prototype.anchor(name)
__webpack_require__(24)('anchor', function (createHTML) {
  return function anchor(name) {
    return createHTML(this, 'a', 'name', name);
  };
});


/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.3 String.prototype.big()
__webpack_require__(24)('big', function (createHTML) {
  return function big() {
    return createHTML(this, 'big', '', '');
  };
});


/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.4 String.prototype.blink()
__webpack_require__(24)('blink', function (createHTML) {
  return function blink() {
    return createHTML(this, 'blink', '', '');
  };
});


/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.5 String.prototype.bold()
__webpack_require__(24)('bold', function (createHTML) {
  return function bold() {
    return createHTML(this, 'b', '', '');
  };
});


/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.6 String.prototype.fixed()
__webpack_require__(24)('fixed', function (createHTML) {
  return function fixed() {
    return createHTML(this, 'tt', '', '');
  };
});


/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.7 String.prototype.fontcolor(color)
__webpack_require__(24)('fontcolor', function (createHTML) {
  return function fontcolor(color) {
    return createHTML(this, 'font', 'color', color);
  };
});


/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.8 String.prototype.fontsize(size)
__webpack_require__(24)('fontsize', function (createHTML) {
  return function fontsize(size) {
    return createHTML(this, 'font', 'size', size);
  };
});


/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.9 String.prototype.italics()
__webpack_require__(24)('italics', function (createHTML) {
  return function italics() {
    return createHTML(this, 'i', '', '');
  };
});


/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.10 String.prototype.link(url)
__webpack_require__(24)('link', function (createHTML) {
  return function link(url) {
    return createHTML(this, 'a', 'href', url);
  };
});


/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.11 String.prototype.small()
__webpack_require__(24)('small', function (createHTML) {
  return function small() {
    return createHTML(this, 'small', '', '');
  };
});


/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.12 String.prototype.strike()
__webpack_require__(24)('strike', function (createHTML) {
  return function strike() {
    return createHTML(this, 'strike', '', '');
  };
});


/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.13 String.prototype.sub()
__webpack_require__(24)('sub', function (createHTML) {
  return function sub() {
    return createHTML(this, 'sub', '', '');
  };
});


/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.14 String.prototype.sup()
__webpack_require__(24)('sup', function (createHTML) {
  return function sup() {
    return createHTML(this, 'sup', '', '');
  };
});


/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

// 20.3.3.1 / 15.9.4.4 Date.now()
var $export = __webpack_require__(1);

$export($export.S, 'Date', { now: function () { return new Date().getTime(); } });


/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var toObject = __webpack_require__(18);
var toPrimitive = __webpack_require__(40);

$export($export.P + $export.F * __webpack_require__(6)(function () {
  return new Date(NaN).toJSON() !== null
    || Date.prototype.toJSON.call({ toISOString: function () { return 1; } }) !== 1;
}), 'Date', {
  // eslint-disable-next-line no-unused-vars
  toJSON: function toJSON(key) {
    var O = toObject(this);
    var pv = toPrimitive(O);
    return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
  }
});


/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
var $export = __webpack_require__(1);
var toISOString = __webpack_require__(423);

// PhantomJS / old WebKit has a broken implementations
$export($export.P + $export.F * (Date.prototype.toISOString !== toISOString), 'Date', {
  toISOString: toISOString
});


/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
var fails = __webpack_require__(6);
var getTime = Date.prototype.getTime;
var $toISOString = Date.prototype.toISOString;

var lz = function (num) {
  return num > 9 ? num : '0' + num;
};

// PhantomJS / old WebKit has a broken implementations
module.exports = (fails(function () {
  return $toISOString.call(new Date(-5e13 - 1)) != '0385-07-25T07:06:39.999Z';
}) || !fails(function () {
  $toISOString.call(new Date(NaN));
})) ? function toISOString() {
  if (!isFinite(getTime.call(this))) throw RangeError('Invalid time value');
  var d = this;
  var y = d.getUTCFullYear();
  var m = d.getUTCMilliseconds();
  var s = y < 0 ? '-' : y > 9999 ? '+' : '';
  return s + ('00000' + Math.abs(y)).slice(s ? -6 : -4) +
    '-' + lz(d.getUTCMonth() + 1) + '-' + lz(d.getUTCDate()) +
    'T' + lz(d.getUTCHours()) + ':' + lz(d.getUTCMinutes()) +
    ':' + lz(d.getUTCSeconds()) + '.' + (m > 99 ? m : '0' + lz(m)) + 'Z';
} : $toISOString;


/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

var DateProto = Date.prototype;
var INVALID_DATE = 'Invalid Date';
var TO_STRING = 'toString';
var $toString = DateProto[TO_STRING];
var getTime = DateProto.getTime;
if (new Date(NaN) + '' != INVALID_DATE) {
  __webpack_require__(23)(DateProto, TO_STRING, function toString() {
    var value = getTime.call(this);
    // eslint-disable-next-line no-self-compare
    return value === value ? $toString.call(this) : INVALID_DATE;
  });
}


/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

var TO_PRIMITIVE = __webpack_require__(10)('toPrimitive');
var proto = Date.prototype;

if (!(TO_PRIMITIVE in proto)) __webpack_require__(22)(proto, TO_PRIMITIVE, __webpack_require__(426));


/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var anObject = __webpack_require__(2);
var toPrimitive = __webpack_require__(40);
var NUMBER = 'number';

module.exports = function (hint) {
  if (hint !== 'string' && hint !== NUMBER && hint !== 'default') throw TypeError('Incorrect hint');
  return toPrimitive(anObject(this), hint != NUMBER);
};


/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
var $export = __webpack_require__(1);

$export($export.S, 'Array', { isArray: __webpack_require__(102) });


/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(32);
var $export = __webpack_require__(1);
var toObject = __webpack_require__(18);
var call = __webpack_require__(230);
var isArrayIter = __webpack_require__(159);
var toLength = __webpack_require__(11);
var createProperty = __webpack_require__(160);
var getIterFn = __webpack_require__(161);

$export($export.S + $export.F * !__webpack_require__(105)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var createProperty = __webpack_require__(160);

// WebKit Array.of isn't generic
$export($export.S + $export.F * __webpack_require__(6)(function () {
  function F() { /* empty */ }
  return !(Array.of.call(F) instanceof F);
}), 'Array', {
  // 22.1.2.3 Array.of( ...items)
  of: function of(/* ...args */) {
    var index = 0;
    var aLen = arguments.length;
    var result = new (typeof this == 'function' ? this : Array)(aLen);
    while (aLen > index) createProperty(result, index, arguments[index++]);
    result.length = aLen;
    return result;
  }
});


/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.13 Array.prototype.join(separator)
var $export = __webpack_require__(1);
var toIObject = __webpack_require__(28);
var arrayJoin = [].join;

// fallback for not array-like strings
$export($export.P + $export.F * (__webpack_require__(84) != Object || !__webpack_require__(35)(arrayJoin)), 'Array', {
  join: function join(separator) {
    return arrayJoin.call(toIObject(this), separator === undefined ? ',' : separator);
  }
});


/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var html = __webpack_require__(148);
var cof = __webpack_require__(33);
var toAbsoluteIndex = __webpack_require__(58);
var toLength = __webpack_require__(11);
var arraySlice = [].slice;

// fallback for not array-like ES3 strings and DOM objects
$export($export.P + $export.F * __webpack_require__(6)(function () {
  if (html) arraySlice.call(html);
}), 'Array', {
  slice: function slice(begin, end) {
    var len = toLength(this.length);
    var klass = cof(this);
    end = end === undefined ? len : end;
    if (klass == 'Array') return arraySlice.call(this, begin, end);
    var start = toAbsoluteIndex(begin, len);
    var upTo = toAbsoluteIndex(end, len);
    var size = toLength(upTo - start);
    var cloned = new Array(size);
    var i = 0;
    for (; i < size; i++) cloned[i] = klass == 'String'
      ? this.charAt(start + i)
      : this[start + i];
    return cloned;
  }
});


/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var aFunction = __webpack_require__(20);
var toObject = __webpack_require__(18);
var fails = __webpack_require__(6);
var $sort = [].sort;
var test = [1, 2, 3];

$export($export.P + $export.F * (fails(function () {
  // IE8-
  test.sort(undefined);
}) || !fails(function () {
  // V8 bug
  test.sort(null);
  // Old WebKit
}) || !__webpack_require__(35)($sort)), 'Array', {
  // 22.1.3.25 Array.prototype.sort(comparefn)
  sort: function sort(comparefn) {
    return comparefn === undefined
      ? $sort.call(toObject(this))
      : $sort.call(toObject(this), aFunction(comparefn));
  }
});


/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var $forEach = __webpack_require__(43)(0);
var STRICT = __webpack_require__(35)([].forEach, true);

$export($export.P + $export.F * !STRICT, 'Array', {
  // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
  forEach: function forEach(callbackfn /* , thisArg */) {
    return $forEach(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(9);
var isArray = __webpack_require__(102);
var SPECIES = __webpack_require__(10)('species');

module.exports = function (original) {
  var C;
  if (isArray(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};


/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var $map = __webpack_require__(43)(1);

$export($export.P + $export.F * !__webpack_require__(35)([].map, true), 'Array', {
  // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
  map: function map(callbackfn /* , thisArg */) {
    return $map(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var $filter = __webpack_require__(43)(2);

$export($export.P + $export.F * !__webpack_require__(35)([].filter, true), 'Array', {
  // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
  filter: function filter(callbackfn /* , thisArg */) {
    return $filter(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var $some = __webpack_require__(43)(3);

$export($export.P + $export.F * !__webpack_require__(35)([].some, true), 'Array', {
  // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
  some: function some(callbackfn /* , thisArg */) {
    return $some(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var $every = __webpack_require__(43)(4);

$export($export.P + $export.F * !__webpack_require__(35)([].every, true), 'Array', {
  // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])
  every: function every(callbackfn /* , thisArg */) {
    return $every(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var $reduce = __webpack_require__(231);

$export($export.P + $export.F * !__webpack_require__(35)([].reduce, true), 'Array', {
  // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
  reduce: function reduce(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments[1], false);
  }
});


/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var $reduce = __webpack_require__(231);

$export($export.P + $export.F * !__webpack_require__(35)([].reduceRight, true), 'Array', {
  // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
  reduceRight: function reduceRight(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments[1], true);
  }
});


/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var $indexOf = __webpack_require__(100)(false);
var $native = [].indexOf;
var NEGATIVE_ZERO = !!$native && 1 / [1].indexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(35)($native)), 'Array', {
  // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
    return NEGATIVE_ZERO
      // convert -0 to +0
      ? $native.apply(this, arguments) || 0
      : $indexOf(this, searchElement, arguments[1]);
  }
});


/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var toIObject = __webpack_require__(28);
var toInteger = __webpack_require__(34);
var toLength = __webpack_require__(11);
var $native = [].lastIndexOf;
var NEGATIVE_ZERO = !!$native && 1 / [1].lastIndexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(35)($native)), 'Array', {
  // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
  lastIndexOf: function lastIndexOf(searchElement /* , fromIndex = @[*-1] */) {
    // convert -0 to +0
    if (NEGATIVE_ZERO) return $native.apply(this, arguments) || 0;
    var O = toIObject(this);
    var length = toLength(O.length);
    var index = length - 1;
    if (arguments.length > 1) index = Math.min(index, toInteger(arguments[1]));
    if (index < 0) index = length + index;
    for (;index >= 0; index--) if (index in O) if (O[index] === searchElement) return index || 0;
    return -1;
  }
});


/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
var $export = __webpack_require__(1);

$export($export.P, 'Array', { copyWithin: __webpack_require__(232) });

__webpack_require__(52)('copyWithin');


/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
var $export = __webpack_require__(1);

$export($export.P, 'Array', { fill: __webpack_require__(163) });

__webpack_require__(52)('fill');


/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
var $export = __webpack_require__(1);
var $find = __webpack_require__(43)(5);
var KEY = 'find';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  find: function find(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(52)(KEY);


/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
var $export = __webpack_require__(1);
var $find = __webpack_require__(43)(6);
var KEY = 'findIndex';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  findIndex: function findIndex(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(52)(KEY);


/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(61)('Array');


/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(3);
var inheritIfRequired = __webpack_require__(151);
var dP = __webpack_require__(16).f;
var gOPN = __webpack_require__(60).f;
var isRegExp = __webpack_require__(104);
var $flags = __webpack_require__(86);
var $RegExp = global.RegExp;
var Base = $RegExp;
var proto = $RegExp.prototype;
var re1 = /a/g;
var re2 = /a/g;
// "new" creates a new object, old webkit buggy here
var CORRECT_NEW = new $RegExp(re1) !== re1;

if (__webpack_require__(12) && (!CORRECT_NEW || __webpack_require__(6)(function () {
  re2[__webpack_require__(10)('match')] = false;
  // RegExp constructor can alter flags and IsRegExp works correct with @@match
  return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, 'i') != '/a/i';
}))) {
  $RegExp = function RegExp(p, f) {
    var tiRE = this instanceof $RegExp;
    var piRE = isRegExp(p);
    var fiU = f === undefined;
    return !tiRE && piRE && p.constructor === $RegExp && fiU ? p
      : inheritIfRequired(CORRECT_NEW
        ? new Base(piRE && !fiU ? p.source : p, f)
        : Base((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? $flags.call(p) : f)
      , tiRE ? this : proto, $RegExp);
  };
  var proxy = function (key) {
    key in $RegExp || dP($RegExp, key, {
      configurable: true,
      get: function () { return Base[key]; },
      set: function (it) { Base[key] = it; }
    });
  };
  for (var keys = gOPN(Base), i = 0; keys.length > i;) proxy(keys[i++]);
  proto.constructor = $RegExp;
  $RegExp.prototype = proto;
  __webpack_require__(23)(global, 'RegExp', $RegExp);
}

__webpack_require__(61)('RegExp');


/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__(235);
var anObject = __webpack_require__(2);
var $flags = __webpack_require__(86);
var DESCRIPTORS = __webpack_require__(12);
var TO_STRING = 'toString';
var $toString = /./[TO_STRING];

var define = function (fn) {
  __webpack_require__(23)(RegExp.prototype, TO_STRING, fn, true);
};

// 21.2.5.14 RegExp.prototype.toString()
if (__webpack_require__(6)(function () { return $toString.call({ source: 'a', flags: 'b' }) != '/a/b'; })) {
  define(function toString() {
    var R = anObject(this);
    return '/'.concat(R.source, '/',
      'flags' in R ? R.flags : !DESCRIPTORS && R instanceof RegExp ? $flags.call(R) : undefined);
  });
// FF44- RegExp#toString has a wrong name
} else if ($toString.name != TO_STRING) {
  define(function toString() {
    return $toString.call(this);
  });
}


/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__(2);
var toLength = __webpack_require__(11);
var advanceStringIndex = __webpack_require__(166);
var regExpExec = __webpack_require__(106);

// @@match logic
__webpack_require__(107)('match', 1, function (defined, MATCH, $match, maybeCallNative) {
  return [
    // `String.prototype.match` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.match
    function match(regexp) {
      var O = defined(this);
      var fn = regexp == undefined ? undefined : regexp[MATCH];
      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
    },
    // `RegExp.prototype[@@match]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@match
    function (regexp) {
      var res = maybeCallNative($match, regexp, this);
      if (res.done) return res.value;
      var rx = anObject(regexp);
      var S = String(this);
      if (!rx.global) return regExpExec(rx, S);
      var fullUnicode = rx.unicode;
      rx.lastIndex = 0;
      var A = [];
      var n = 0;
      var result;
      while ((result = regExpExec(rx, S)) !== null) {
        var matchStr = String(result[0]);
        A[n] = matchStr;
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
        n++;
      }
      return n === 0 ? null : A;
    }
  ];
});


/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__(2);
var toObject = __webpack_require__(18);
var toLength = __webpack_require__(11);
var toInteger = __webpack_require__(34);
var advanceStringIndex = __webpack_require__(166);
var regExpExec = __webpack_require__(106);
var max = Math.max;
var min = Math.min;
var floor = Math.floor;
var SUBSTITUTION_SYMBOLS = /\$([$&`']|\d\d?|<[^>]*>)/g;
var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&`']|\d\d?)/g;

var maybeToString = function (it) {
  return it === undefined ? it : String(it);
};

// @@replace logic
__webpack_require__(107)('replace', 2, function (defined, REPLACE, $replace, maybeCallNative) {
  return [
    // `String.prototype.replace` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.replace
    function replace(searchValue, replaceValue) {
      var O = defined(this);
      var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
      return fn !== undefined
        ? fn.call(searchValue, O, replaceValue)
        : $replace.call(String(O), searchValue, replaceValue);
    },
    // `RegExp.prototype[@@replace]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@replace
    function (regexp, replaceValue) {
      var res = maybeCallNative($replace, regexp, this, replaceValue);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);
      var functionalReplace = typeof replaceValue === 'function';
      if (!functionalReplace) replaceValue = String(replaceValue);
      var global = rx.global;
      if (global) {
        var fullUnicode = rx.unicode;
        rx.lastIndex = 0;
      }
      var results = [];
      while (true) {
        var result = regExpExec(rx, S);
        if (result === null) break;
        results.push(result);
        if (!global) break;
        var matchStr = String(result[0]);
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
      }
      var accumulatedResult = '';
      var nextSourcePosition = 0;
      for (var i = 0; i < results.length; i++) {
        result = results[i];
        var matched = String(result[0]);
        var position = max(min(toInteger(result.index), S.length), 0);
        var captures = [];
        // NOTE: This is equivalent to
        //   captures = result.slice(1).map(maybeToString)
        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
        for (var j = 1; j < result.length; j++) captures.push(maybeToString(result[j]));
        var namedCaptures = result.groups;
        if (functionalReplace) {
          var replacerArgs = [matched].concat(captures, position, S);
          if (namedCaptures !== undefined) replacerArgs.push(namedCaptures);
          var replacement = String(replaceValue.apply(undefined, replacerArgs));
        } else {
          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
        }
        if (position >= nextSourcePosition) {
          accumulatedResult += S.slice(nextSourcePosition, position) + replacement;
          nextSourcePosition = position + matched.length;
        }
      }
      return accumulatedResult + S.slice(nextSourcePosition);
    }
  ];

    // https://tc39.github.io/ecma262/#sec-getsubstitution
  function getSubstitution(matched, str, position, captures, namedCaptures, replacement) {
    var tailPos = position + matched.length;
    var m = captures.length;
    var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
    if (namedCaptures !== undefined) {
      namedCaptures = toObject(namedCaptures);
      symbols = SUBSTITUTION_SYMBOLS;
    }
    return $replace.call(replacement, symbols, function (match, ch) {
      var capture;
      switch (ch.charAt(0)) {
        case '$': return '$';
        case '&': return matched;
        case '`': return str.slice(0, position);
        case "'": return str.slice(tailPos);
        case '<':
          capture = namedCaptures[ch.slice(1, -1)];
          break;
        default: // \d\d?
          var n = +ch;
          if (n === 0) return match;
          if (n > m) {
            var f = floor(n / 10);
            if (f === 0) return match;
            if (f <= m) return captures[f - 1] === undefined ? ch.charAt(1) : captures[f - 1] + ch.charAt(1);
            return match;
          }
          capture = captures[n - 1];
      }
      return capture === undefined ? '' : capture;
    });
  }
});


/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__(2);
var sameValue = __webpack_require__(221);
var regExpExec = __webpack_require__(106);

// @@search logic
__webpack_require__(107)('search', 1, function (defined, SEARCH, $search, maybeCallNative) {
  return [
    // `String.prototype.search` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.search
    function search(regexp) {
      var O = defined(this);
      var fn = regexp == undefined ? undefined : regexp[SEARCH];
      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
    },
    // `RegExp.prototype[@@search]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@search
    function (regexp) {
      var res = maybeCallNative($search, regexp, this);
      if (res.done) return res.value;
      var rx = anObject(regexp);
      var S = String(this);
      var previousLastIndex = rx.lastIndex;
      if (!sameValue(previousLastIndex, 0)) rx.lastIndex = 0;
      var result = regExpExec(rx, S);
      if (!sameValue(rx.lastIndex, previousLastIndex)) rx.lastIndex = previousLastIndex;
      return result === null ? -1 : result.index;
    }
  ];
});


/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isRegExp = __webpack_require__(104);
var anObject = __webpack_require__(2);
var speciesConstructor = __webpack_require__(87);
var advanceStringIndex = __webpack_require__(166);
var toLength = __webpack_require__(11);
var callRegExpExec = __webpack_require__(106);
var regexpExec = __webpack_require__(165);
var fails = __webpack_require__(6);
var $min = Math.min;
var $push = [].push;
var $SPLIT = 'split';
var LENGTH = 'length';
var LAST_INDEX = 'lastIndex';
var MAX_UINT32 = 0xffffffff;

// babel-minify transpiles RegExp('x', 'y') -> /x/y and it causes SyntaxError
var SUPPORTS_Y = !fails(function () { RegExp(MAX_UINT32, 'y'); });

// @@split logic
__webpack_require__(107)('split', 2, function (defined, SPLIT, $split, maybeCallNative) {
  var internalSplit;
  if (
    'abbc'[$SPLIT](/(b)*/)[1] == 'c' ||
    'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 ||
    'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 ||
    '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 ||
    '.'[$SPLIT](/()()/)[LENGTH] > 1 ||
    ''[$SPLIT](/.?/)[LENGTH]
  ) {
    // based on es5-shim implementation, need to rework it
    internalSplit = function (separator, limit) {
      var string = String(this);
      if (separator === undefined && limit === 0) return [];
      // If `separator` is not a regex, use native split
      if (!isRegExp(separator)) return $split.call(string, separator, limit);
      var output = [];
      var flags = (separator.ignoreCase ? 'i' : '') +
                  (separator.multiline ? 'm' : '') +
                  (separator.unicode ? 'u' : '') +
                  (separator.sticky ? 'y' : '');
      var lastLastIndex = 0;
      var splitLimit = limit === undefined ? MAX_UINT32 : limit >>> 0;
      // Make `global` and avoid `lastIndex` issues by working with a copy
      var separatorCopy = new RegExp(separator.source, flags + 'g');
      var match, lastIndex, lastLength;
      while (match = regexpExec.call(separatorCopy, string)) {
        lastIndex = separatorCopy[LAST_INDEX];
        if (lastIndex > lastLastIndex) {
          output.push(string.slice(lastLastIndex, match.index));
          if (match[LENGTH] > 1 && match.index < string[LENGTH]) $push.apply(output, match.slice(1));
          lastLength = match[0][LENGTH];
          lastLastIndex = lastIndex;
          if (output[LENGTH] >= splitLimit) break;
        }
        if (separatorCopy[LAST_INDEX] === match.index) separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
      }
      if (lastLastIndex === string[LENGTH]) {
        if (lastLength || !separatorCopy.test('')) output.push('');
      } else output.push(string.slice(lastLastIndex));
      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
    };
  // Chakra, V8
  } else if ('0'[$SPLIT](undefined, 0)[LENGTH]) {
    internalSplit = function (separator, limit) {
      return separator === undefined && limit === 0 ? [] : $split.call(this, separator, limit);
    };
  } else {
    internalSplit = $split;
  }

  return [
    // `String.prototype.split` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.split
    function split(separator, limit) {
      var O = defined(this);
      var splitter = separator == undefined ? undefined : separator[SPLIT];
      return splitter !== undefined
        ? splitter.call(separator, O, limit)
        : internalSplit.call(String(O), separator, limit);
    },
    // `RegExp.prototype[@@split]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@split
    //
    // NOTE: This cannot be properly polyfilled in engines that don't support
    // the 'y' flag.
    function (regexp, limit) {
      var res = maybeCallNative(internalSplit, regexp, this, limit, internalSplit !== $split);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);
      var C = speciesConstructor(rx, RegExp);

      var unicodeMatching = rx.unicode;
      var flags = (rx.ignoreCase ? 'i' : '') +
                  (rx.multiline ? 'm' : '') +
                  (rx.unicode ? 'u' : '') +
                  (SUPPORTS_Y ? 'y' : 'g');

      // ^(? + rx + ) is needed, in combination with some S slicing, to
      // simulate the 'y' flag.
      var splitter = new C(SUPPORTS_Y ? rx : '^(?:' + rx.source + ')', flags);
      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
      if (lim === 0) return [];
      if (S.length === 0) return callRegExpExec(splitter, S) === null ? [S] : [];
      var p = 0;
      var q = 0;
      var A = [];
      while (q < S.length) {
        splitter.lastIndex = SUPPORTS_Y ? q : 0;
        var z = callRegExpExec(splitter, SUPPORTS_Y ? S : S.slice(q));
        var e;
        if (
          z === null ||
          (e = $min(toLength(splitter.lastIndex + (SUPPORTS_Y ? 0 : q)), S.length)) === p
        ) {
          q = advanceStringIndex(S, q, unicodeMatching);
        } else {
          A.push(S.slice(p, q));
          if (A.length === lim) return A;
          for (var i = 1; i <= z.length - 1; i++) {
            A.push(z[i]);
            if (A.length === lim) return A;
          }
          q = p = e;
        }
      }
      A.push(S.slice(p));
      return A;
    }
  ];
});


/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(50);
var global = __webpack_require__(3);
var ctx = __webpack_require__(32);
var classof = __webpack_require__(74);
var $export = __webpack_require__(1);
var isObject = __webpack_require__(9);
var aFunction = __webpack_require__(20);
var anInstance = __webpack_require__(62);
var forOf = __webpack_require__(63);
var speciesConstructor = __webpack_require__(87);
var task = __webpack_require__(167).set;
var microtask = __webpack_require__(168)();
var newPromiseCapabilityModule = __webpack_require__(169);
var perform = __webpack_require__(236);
var userAgent = __webpack_require__(108);
var promiseResolve = __webpack_require__(237);
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var versions = process && process.versions;
var v8 = versions && versions.v8 || '';
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function () { /* empty */ };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[__webpack_require__(10)('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function')
      && promise.then(empty) instanceof FakePromise
      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
      // we can't detect it synchronously, so just check versions
      && v8.indexOf('6.6') !== 0
      && userAgent.indexOf('Chrome/66') === -1;
  } catch (e) { /* empty */ }
}();

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value); // may throw
            if (domain) {
              domain.exit();
              exited = true;
            }
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        if (domain && !exited) domain.exit();
        reject(e);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function (promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function (promise) {
  return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var onHandleUnhandled = function (promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function (value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function (value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = __webpack_require__(64)($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === $Promise || C === Wrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
__webpack_require__(73)($Promise, PROMISE);
__webpack_require__(61)(PROMISE);
Wrapper = __webpack_require__(31)[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(105)(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});


/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var weak = __webpack_require__(242);
var validate = __webpack_require__(65);
var WEAK_SET = 'WeakSet';

// 23.4 WeakSet Objects
__webpack_require__(109)(WEAK_SET, function (get) {
  return function WeakSet() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.4.3.1 WeakSet.prototype.add(value)
  add: function add(value) {
    return weak.def(validate(this, WEAK_SET), value, true);
  }
}, weak, false, true);


/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var $typed = __webpack_require__(110);
var buffer = __webpack_require__(170);
var anObject = __webpack_require__(2);
var toAbsoluteIndex = __webpack_require__(58);
var toLength = __webpack_require__(11);
var isObject = __webpack_require__(9);
var ArrayBuffer = __webpack_require__(3).ArrayBuffer;
var speciesConstructor = __webpack_require__(87);
var $ArrayBuffer = buffer.ArrayBuffer;
var $DataView = buffer.DataView;
var $isView = $typed.ABV && ArrayBuffer.isView;
var $slice = $ArrayBuffer.prototype.slice;
var VIEW = $typed.VIEW;
var ARRAY_BUFFER = 'ArrayBuffer';

$export($export.G + $export.W + $export.F * (ArrayBuffer !== $ArrayBuffer), { ArrayBuffer: $ArrayBuffer });

$export($export.S + $export.F * !$typed.CONSTR, ARRAY_BUFFER, {
  // 24.1.3.1 ArrayBuffer.isView(arg)
  isView: function isView(it) {
    return $isView && $isView(it) || isObject(it) && VIEW in it;
  }
});

$export($export.P + $export.U + $export.F * __webpack_require__(6)(function () {
  return !new $ArrayBuffer(2).slice(1, undefined).byteLength;
}), ARRAY_BUFFER, {
  // 24.1.4.3 ArrayBuffer.prototype.slice(start, end)
  slice: function slice(start, end) {
    if ($slice !== undefined && end === undefined) return $slice.call(anObject(this), start); // FF fix
    var len = anObject(this).byteLength;
    var first = toAbsoluteIndex(start, len);
    var fin = toAbsoluteIndex(end === undefined ? len : end, len);
    var result = new (speciesConstructor(this, $ArrayBuffer))(toLength(fin - first));
    var viewS = new $DataView(this);
    var viewT = new $DataView(result);
    var index = 0;
    while (first < fin) {
      viewT.setUint8(index++, viewS.getUint8(first++));
    } return result;
  }
});

__webpack_require__(61)(ARRAY_BUFFER);


/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(1);
$export($export.G + $export.W + $export.F * !__webpack_require__(110).ABV, {
  DataView: __webpack_require__(170).DataView
});


/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(46)('Int8', 1, function (init) {
  return function Int8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(46)('Uint8', 1, function (init) {
  return function Uint8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(46)('Uint8', 1, function (init) {
  return function Uint8ClampedArray(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
}, true);


/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(46)('Int16', 2, function (init) {
  return function Int16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(46)('Uint16', 2, function (init) {
  return function Uint16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(46)('Int32', 4, function (init) {
  return function Int32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(46)('Uint32', 4, function (init) {
  return function Uint32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(46)('Float32', 4, function (init) {
  return function Float32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(46)('Float64', 8, function (init) {
  return function Float64Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.1 Reflect.apply(target, thisArgument, argumentsList)
var $export = __webpack_require__(1);
var aFunction = __webpack_require__(20);
var anObject = __webpack_require__(2);
var rApply = (__webpack_require__(3).Reflect || {}).apply;
var fApply = Function.apply;
// MS Edge argumentsList argument is optional
$export($export.S + $export.F * !__webpack_require__(6)(function () {
  rApply(function () { /* empty */ });
}), 'Reflect', {
  apply: function apply(target, thisArgument, argumentsList) {
    var T = aFunction(target);
    var L = anObject(argumentsList);
    return rApply ? rApply(T, thisArgument, L) : fApply.call(T, thisArgument, L);
  }
});


/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.2 Reflect.construct(target, argumentsList [, newTarget])
var $export = __webpack_require__(1);
var create = __webpack_require__(59);
var aFunction = __webpack_require__(20);
var anObject = __webpack_require__(2);
var isObject = __webpack_require__(9);
var fails = __webpack_require__(6);
var bind = __webpack_require__(222);
var rConstruct = (__webpack_require__(3).Reflect || {}).construct;

// MS Edge supports only 2 arguments and argumentsList argument is optional
// FF Nightly sets third argument as `new.target`, but does not create `this` from it
var NEW_TARGET_BUG = fails(function () {
  function F() { /* empty */ }
  return !(rConstruct(function () { /* empty */ }, [], F) instanceof F);
});
var ARGS_BUG = !fails(function () {
  rConstruct(function () { /* empty */ });
});

$export($export.S + $export.F * (NEW_TARGET_BUG || ARGS_BUG), 'Reflect', {
  construct: function construct(Target, args /* , newTarget */) {
    aFunction(Target);
    anObject(args);
    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
    if (ARGS_BUG && !NEW_TARGET_BUG) return rConstruct(Target, args, newTarget);
    if (Target == newTarget) {
      // w/o altered newTarget, optimization for 0-4 arguments
      switch (args.length) {
        case 0: return new Target();
        case 1: return new Target(args[0]);
        case 2: return new Target(args[0], args[1]);
        case 3: return new Target(args[0], args[1], args[2]);
        case 4: return new Target(args[0], args[1], args[2], args[3]);
      }
      // w/o altered newTarget, lot of arguments case
      var $args = [null];
      $args.push.apply($args, args);
      return new (bind.apply(Target, $args))();
    }
    // with altered newTarget, not support built-in constructors
    var proto = newTarget.prototype;
    var instance = create(isObject(proto) ? proto : Object.prototype);
    var result = Function.apply.call(Target, instance, args);
    return isObject(result) ? result : instance;
  }
});


/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)
var dP = __webpack_require__(16);
var $export = __webpack_require__(1);
var anObject = __webpack_require__(2);
var toPrimitive = __webpack_require__(40);

// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
$export($export.S + $export.F * __webpack_require__(6)(function () {
  // eslint-disable-next-line no-undef
  Reflect.defineProperty(dP.f({}, 1, { value: 1 }), 1, { value: 2 });
}), 'Reflect', {
  defineProperty: function defineProperty(target, propertyKey, attributes) {
    anObject(target);
    propertyKey = toPrimitive(propertyKey, true);
    anObject(attributes);
    try {
      dP.f(target, propertyKey, attributes);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.4 Reflect.deleteProperty(target, propertyKey)
var $export = __webpack_require__(1);
var gOPD = __webpack_require__(29).f;
var anObject = __webpack_require__(2);

$export($export.S, 'Reflect', {
  deleteProperty: function deleteProperty(target, propertyKey) {
    var desc = gOPD(anObject(target), propertyKey);
    return desc && !desc.configurable ? false : delete target[propertyKey];
  }
});


/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 26.1.5 Reflect.enumerate(target)
var $export = __webpack_require__(1);
var anObject = __webpack_require__(2);
var Enumerate = function (iterated) {
  this._t = anObject(iterated); // target
  this._i = 0;                  // next index
  var keys = this._k = [];      // keys
  var key;
  for (key in iterated) keys.push(key);
};
__webpack_require__(156)(Enumerate, 'Object', function () {
  var that = this;
  var keys = that._k;
  var key;
  do {
    if (that._i >= keys.length) return { value: undefined, done: true };
  } while (!((key = keys[that._i++]) in that._t));
  return { value: key, done: false };
});

$export($export.S, 'Reflect', {
  enumerate: function enumerate(target) {
    return new Enumerate(target);
  }
});


/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.6 Reflect.get(target, propertyKey [, receiver])
var gOPD = __webpack_require__(29);
var getPrototypeOf = __webpack_require__(30);
var has = __webpack_require__(27);
var $export = __webpack_require__(1);
var isObject = __webpack_require__(9);
var anObject = __webpack_require__(2);

function get(target, propertyKey /* , receiver */) {
  var receiver = arguments.length < 3 ? target : arguments[2];
  var desc, proto;
  if (anObject(target) === receiver) return target[propertyKey];
  if (desc = gOPD.f(target, propertyKey)) return has(desc, 'value')
    ? desc.value
    : desc.get !== undefined
      ? desc.get.call(receiver)
      : undefined;
  if (isObject(proto = getPrototypeOf(target))) return get(proto, propertyKey, receiver);
}

$export($export.S, 'Reflect', { get: get });


/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)
var gOPD = __webpack_require__(29);
var $export = __webpack_require__(1);
var anObject = __webpack_require__(2);

$export($export.S, 'Reflect', {
  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey) {
    return gOPD.f(anObject(target), propertyKey);
  }
});


/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.8 Reflect.getPrototypeOf(target)
var $export = __webpack_require__(1);
var getProto = __webpack_require__(30);
var anObject = __webpack_require__(2);

$export($export.S, 'Reflect', {
  getPrototypeOf: function getPrototypeOf(target) {
    return getProto(anObject(target));
  }
});


/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.9 Reflect.has(target, propertyKey)
var $export = __webpack_require__(1);

$export($export.S, 'Reflect', {
  has: function has(target, propertyKey) {
    return propertyKey in target;
  }
});


/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.10 Reflect.isExtensible(target)
var $export = __webpack_require__(1);
var anObject = __webpack_require__(2);
var $isExtensible = Object.isExtensible;

$export($export.S, 'Reflect', {
  isExtensible: function isExtensible(target) {
    anObject(target);
    return $isExtensible ? $isExtensible(target) : true;
  }
});


/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.11 Reflect.ownKeys(target)
var $export = __webpack_require__(1);

$export($export.S, 'Reflect', { ownKeys: __webpack_require__(244) });


/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.12 Reflect.preventExtensions(target)
var $export = __webpack_require__(1);
var anObject = __webpack_require__(2);
var $preventExtensions = Object.preventExtensions;

$export($export.S, 'Reflect', {
  preventExtensions: function preventExtensions(target) {
    anObject(target);
    try {
      if ($preventExtensions) $preventExtensions(target);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.13 Reflect.set(target, propertyKey, V [, receiver])
var dP = __webpack_require__(16);
var gOPD = __webpack_require__(29);
var getPrototypeOf = __webpack_require__(30);
var has = __webpack_require__(27);
var $export = __webpack_require__(1);
var createDesc = __webpack_require__(55);
var anObject = __webpack_require__(2);
var isObject = __webpack_require__(9);

function set(target, propertyKey, V /* , receiver */) {
  var receiver = arguments.length < 4 ? target : arguments[3];
  var ownDesc = gOPD.f(anObject(target), propertyKey);
  var existingDescriptor, proto;
  if (!ownDesc) {
    if (isObject(proto = getPrototypeOf(target))) {
      return set(proto, propertyKey, V, receiver);
    }
    ownDesc = createDesc(0);
  }
  if (has(ownDesc, 'value')) {
    if (ownDesc.writable === false || !isObject(receiver)) return false;
    if (existingDescriptor = gOPD.f(receiver, propertyKey)) {
      if (existingDescriptor.get || existingDescriptor.set || existingDescriptor.writable === false) return false;
      existingDescriptor.value = V;
      dP.f(receiver, propertyKey, existingDescriptor);
    } else dP.f(receiver, propertyKey, createDesc(0, V));
    return true;
  }
  return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
}

$export($export.S, 'Reflect', { set: set });


/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.14 Reflect.setPrototypeOf(target, proto)
var $export = __webpack_require__(1);
var setProto = __webpack_require__(149);

if (setProto) $export($export.S, 'Reflect', {
  setPrototypeOf: function setPrototypeOf(target, proto) {
    setProto.check(target, proto);
    try {
      setProto.set(target, proto);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/Array.prototype.includes
var $export = __webpack_require__(1);
var $includes = __webpack_require__(100)(true);

$export($export.P, 'Array', {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

__webpack_require__(52)('includes');


/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatMap
var $export = __webpack_require__(1);
var flattenIntoArray = __webpack_require__(245);
var toObject = __webpack_require__(18);
var toLength = __webpack_require__(11);
var aFunction = __webpack_require__(20);
var arraySpeciesCreate = __webpack_require__(162);

$export($export.P, 'Array', {
  flatMap: function flatMap(callbackfn /* , thisArg */) {
    var O = toObject(this);
    var sourceLen, A;
    aFunction(callbackfn);
    sourceLen = toLength(O.length);
    A = arraySpeciesCreate(O, 0);
    flattenIntoArray(A, O, O, sourceLen, 0, 1, callbackfn, arguments[1]);
    return A;
  }
});

__webpack_require__(52)('flatMap');


/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatten
var $export = __webpack_require__(1);
var flattenIntoArray = __webpack_require__(245);
var toObject = __webpack_require__(18);
var toLength = __webpack_require__(11);
var toInteger = __webpack_require__(34);
var arraySpeciesCreate = __webpack_require__(162);

$export($export.P, 'Array', {
  flatten: function flatten(/* depthArg = 1 */) {
    var depthArg = arguments[0];
    var O = toObject(this);
    var sourceLen = toLength(O.length);
    var A = arraySpeciesCreate(O, 0);
    flattenIntoArray(A, O, O, sourceLen, 0, depthArg === undefined ? 1 : toInteger(depthArg));
    return A;
  }
});

__webpack_require__(52)('flatten');


/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/mathiasbynens/String.prototype.at
var $export = __webpack_require__(1);
var $at = __webpack_require__(103)(true);

$export($export.P, 'String', {
  at: function at(pos) {
    return $at(this, pos);
  }
});


/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-string-pad-start-end
var $export = __webpack_require__(1);
var $pad = __webpack_require__(246);
var userAgent = __webpack_require__(108);

// https://github.com/zloirock/core-js/issues/280
var WEBKIT_BUG = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(userAgent);

$export($export.P + $export.F * WEBKIT_BUG, 'String', {
  padStart: function padStart(maxLength /* , fillString = ' ' */) {
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
  }
});


/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-string-pad-start-end
var $export = __webpack_require__(1);
var $pad = __webpack_require__(246);
var userAgent = __webpack_require__(108);

// https://github.com/zloirock/core-js/issues/280
var WEBKIT_BUG = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(userAgent);

$export($export.P + $export.F * WEBKIT_BUG, 'String', {
  padEnd: function padEnd(maxLength /* , fillString = ' ' */) {
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
  }
});


/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
__webpack_require__(75)('trimLeft', function ($trim) {
  return function trimLeft() {
    return $trim(this, 1);
  };
}, 'trimStart');


/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
__webpack_require__(75)('trimRight', function ($trim) {
  return function trimRight() {
    return $trim(this, 2);
  };
}, 'trimEnd');


/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/String.prototype.matchAll/
var $export = __webpack_require__(1);
var defined = __webpack_require__(41);
var toLength = __webpack_require__(11);
var isRegExp = __webpack_require__(104);
var getFlags = __webpack_require__(86);
var RegExpProto = RegExp.prototype;

var $RegExpStringIterator = function (regexp, string) {
  this._r = regexp;
  this._s = string;
};

__webpack_require__(156)($RegExpStringIterator, 'RegExp String', function next() {
  var match = this._r.exec(this._s);
  return { value: match, done: match === null };
});

$export($export.P, 'String', {
  matchAll: function matchAll(regexp) {
    defined(this);
    if (!isRegExp(regexp)) throw TypeError(regexp + ' is not a regexp!');
    var S = String(this);
    var flags = 'flags' in RegExpProto ? String(regexp.flags) : getFlags.call(regexp);
    var rx = new RegExp(regexp.source, ~flags.indexOf('g') ? flags : 'g' + flags);
    rx.lastIndex = toLength(regexp.lastIndex);
    return new $RegExpStringIterator(rx, S);
  }
});


/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(145)('asyncIterator');


/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(145)('observable');


/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-getownpropertydescriptors
var $export = __webpack_require__(1);
var ownKeys = __webpack_require__(244);
var toIObject = __webpack_require__(28);
var gOPD = __webpack_require__(29);
var createProperty = __webpack_require__(160);

$export($export.S, 'Object', {
  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
    var O = toIObject(object);
    var getDesc = gOPD.f;
    var keys = ownKeys(O);
    var result = {};
    var i = 0;
    var key, desc;
    while (keys.length > i) {
      desc = getDesc(O, key = keys[i++]);
      if (desc !== undefined) createProperty(result, key, desc);
    }
    return result;
  }
});


/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(1);
var $values = __webpack_require__(247)(false);

$export($export.S, 'Object', {
  values: function values(it) {
    return $values(it);
  }
});


/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(1);
var $entries = __webpack_require__(247)(true);

$export($export.S, 'Object', {
  entries: function entries(it) {
    return $entries(it);
  }
});


/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var toObject = __webpack_require__(18);
var aFunction = __webpack_require__(20);
var $defineProperty = __webpack_require__(16);

// B.2.2.2 Object.prototype.__defineGetter__(P, getter)
__webpack_require__(12) && $export($export.P + __webpack_require__(111), 'Object', {
  __defineGetter__: function __defineGetter__(P, getter) {
    $defineProperty.f(toObject(this), P, { get: aFunction(getter), enumerable: true, configurable: true });
  }
});


/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var toObject = __webpack_require__(18);
var aFunction = __webpack_require__(20);
var $defineProperty = __webpack_require__(16);

// B.2.2.3 Object.prototype.__defineSetter__(P, setter)
__webpack_require__(12) && $export($export.P + __webpack_require__(111), 'Object', {
  __defineSetter__: function __defineSetter__(P, setter) {
    $defineProperty.f(toObject(this), P, { set: aFunction(setter), enumerable: true, configurable: true });
  }
});


/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var toObject = __webpack_require__(18);
var toPrimitive = __webpack_require__(40);
var getPrototypeOf = __webpack_require__(30);
var getOwnPropertyDescriptor = __webpack_require__(29).f;

// B.2.2.4 Object.prototype.__lookupGetter__(P)
__webpack_require__(12) && $export($export.P + __webpack_require__(111), 'Object', {
  __lookupGetter__: function __lookupGetter__(P) {
    var O = toObject(this);
    var K = toPrimitive(P, true);
    var D;
    do {
      if (D = getOwnPropertyDescriptor(O, K)) return D.get;
    } while (O = getPrototypeOf(O));
  }
});


/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var toObject = __webpack_require__(18);
var toPrimitive = __webpack_require__(40);
var getPrototypeOf = __webpack_require__(30);
var getOwnPropertyDescriptor = __webpack_require__(29).f;

// B.2.2.5 Object.prototype.__lookupSetter__(P)
__webpack_require__(12) && $export($export.P + __webpack_require__(111), 'Object', {
  __lookupSetter__: function __lookupSetter__(P) {
    var O = toObject(this);
    var K = toPrimitive(P, true);
    var D;
    do {
      if (D = getOwnPropertyDescriptor(O, K)) return D.set;
    } while (O = getPrototypeOf(O));
  }
});


/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(1);

$export($export.P + $export.R, 'Map', { toJSON: __webpack_require__(248)('Map') });


/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(1);

$export($export.P + $export.R, 'Set', { toJSON: __webpack_require__(248)('Set') });


/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
__webpack_require__(112)('Map');


/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
__webpack_require__(112)('Set');


/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.of
__webpack_require__(112)('WeakMap');


/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.of
__webpack_require__(112)('WeakSet');


/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
__webpack_require__(113)('Map');


/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.from
__webpack_require__(113)('Set');


/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.from
__webpack_require__(113)('WeakMap');


/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.from
__webpack_require__(113)('WeakSet');


/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-global
var $export = __webpack_require__(1);

$export($export.G, { global: __webpack_require__(3) });


/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-global
var $export = __webpack_require__(1);

$export($export.S, 'System', { global: __webpack_require__(3) });


/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/ljharb/proposal-is-error
var $export = __webpack_require__(1);
var cof = __webpack_require__(33);

$export($export.S, 'Error', {
  isError: function isError(it) {
    return cof(it) === 'Error';
  }
});


/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(1);

$export($export.S, 'Math', {
  clamp: function clamp(x, lower, upper) {
    return Math.min(upper, Math.max(lower, x));
  }
});


/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(1);

$export($export.S, 'Math', { DEG_PER_RAD: Math.PI / 180 });


/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(1);
var RAD_PER_DEG = 180 / Math.PI;

$export($export.S, 'Math', {
  degrees: function degrees(radians) {
    return radians * RAD_PER_DEG;
  }
});


/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(1);
var scale = __webpack_require__(250);
var fround = __webpack_require__(229);

$export($export.S, 'Math', {
  fscale: function fscale(x, inLow, inHigh, outLow, outHigh) {
    return fround(scale(x, inLow, inHigh, outLow, outHigh));
  }
});


/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(1);

$export($export.S, 'Math', {
  iaddh: function iaddh(x0, x1, y0, y1) {
    var $x0 = x0 >>> 0;
    var $x1 = x1 >>> 0;
    var $y0 = y0 >>> 0;
    return $x1 + (y1 >>> 0) + (($x0 & $y0 | ($x0 | $y0) & ~($x0 + $y0 >>> 0)) >>> 31) | 0;
  }
});


/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(1);

$export($export.S, 'Math', {
  isubh: function isubh(x0, x1, y0, y1) {
    var $x0 = x0 >>> 0;
    var $x1 = x1 >>> 0;
    var $y0 = y0 >>> 0;
    return $x1 - (y1 >>> 0) - ((~$x0 & $y0 | ~($x0 ^ $y0) & $x0 - $y0 >>> 0) >>> 31) | 0;
  }
});


/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(1);

$export($export.S, 'Math', {
  imulh: function imulh(u, v) {
    var UINT16 = 0xffff;
    var $u = +u;
    var $v = +v;
    var u0 = $u & UINT16;
    var v0 = $v & UINT16;
    var u1 = $u >> 16;
    var v1 = $v >> 16;
    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
    return u1 * v1 + (t >> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >> 16);
  }
});


/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(1);

$export($export.S, 'Math', { RAD_PER_DEG: 180 / Math.PI });


/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(1);
var DEG_PER_RAD = Math.PI / 180;

$export($export.S, 'Math', {
  radians: function radians(degrees) {
    return degrees * DEG_PER_RAD;
  }
});


/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(1);

$export($export.S, 'Math', { scale: __webpack_require__(250) });


/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(1);

$export($export.S, 'Math', {
  umulh: function umulh(u, v) {
    var UINT16 = 0xffff;
    var $u = +u;
    var $v = +v;
    var u0 = $u & UINT16;
    var v0 = $v & UINT16;
    var u1 = $u >>> 16;
    var v1 = $v >>> 16;
    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
    return u1 * v1 + (t >>> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >>> 16);
  }
});


/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

// http://jfbastien.github.io/papers/Math.signbit.html
var $export = __webpack_require__(1);

$export($export.S, 'Math', { signbit: function signbit(x) {
  // eslint-disable-next-line no-self-compare
  return (x = +x) != x ? x : x == 0 ? 1 / x == Infinity : x > 0;
} });


/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// https://github.com/tc39/proposal-promise-finally

var $export = __webpack_require__(1);
var core = __webpack_require__(31);
var global = __webpack_require__(3);
var speciesConstructor = __webpack_require__(87);
var promiseResolve = __webpack_require__(237);

$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
  var C = speciesConstructor(this, core.Promise || global.Promise);
  var isFunction = typeof onFinally == 'function';
  return this.then(
    isFunction ? function (x) {
      return promiseResolve(C, onFinally()).then(function () { return x; });
    } : onFinally,
    isFunction ? function (e) {
      return promiseResolve(C, onFinally()).then(function () { throw e; });
    } : onFinally
  );
} });


/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-promise-try
var $export = __webpack_require__(1);
var newPromiseCapability = __webpack_require__(169);
var perform = __webpack_require__(236);

$export($export.S, 'Promise', { 'try': function (callbackfn) {
  var promiseCapability = newPromiseCapability.f(this);
  var result = perform(callbackfn);
  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
  return promiseCapability.promise;
} });


/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(47);
var anObject = __webpack_require__(2);
var toMetaKey = metadata.key;
var ordinaryDefineOwnMetadata = metadata.set;

metadata.exp({ defineMetadata: function defineMetadata(metadataKey, metadataValue, target, targetKey) {
  ordinaryDefineOwnMetadata(metadataKey, metadataValue, anObject(target), toMetaKey(targetKey));
} });


/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(47);
var anObject = __webpack_require__(2);
var toMetaKey = metadata.key;
var getOrCreateMetadataMap = metadata.map;
var store = metadata.store;

metadata.exp({ deleteMetadata: function deleteMetadata(metadataKey, target /* , targetKey */) {
  var targetKey = arguments.length < 3 ? undefined : toMetaKey(arguments[2]);
  var metadataMap = getOrCreateMetadataMap(anObject(target), targetKey, false);
  if (metadataMap === undefined || !metadataMap['delete'](metadataKey)) return false;
  if (metadataMap.size) return true;
  var targetMetadata = store.get(target);
  targetMetadata['delete'](targetKey);
  return !!targetMetadata.size || store['delete'](target);
} });


/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(47);
var anObject = __webpack_require__(2);
var getPrototypeOf = __webpack_require__(30);
var ordinaryHasOwnMetadata = metadata.has;
var ordinaryGetOwnMetadata = metadata.get;
var toMetaKey = metadata.key;

var ordinaryGetMetadata = function (MetadataKey, O, P) {
  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
  if (hasOwn) return ordinaryGetOwnMetadata(MetadataKey, O, P);
  var parent = getPrototypeOf(O);
  return parent !== null ? ordinaryGetMetadata(MetadataKey, parent, P) : undefined;
};

metadata.exp({ getMetadata: function getMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryGetMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

var Set = __webpack_require__(240);
var from = __webpack_require__(249);
var metadata = __webpack_require__(47);
var anObject = __webpack_require__(2);
var getPrototypeOf = __webpack_require__(30);
var ordinaryOwnMetadataKeys = metadata.keys;
var toMetaKey = metadata.key;

var ordinaryMetadataKeys = function (O, P) {
  var oKeys = ordinaryOwnMetadataKeys(O, P);
  var parent = getPrototypeOf(O);
  if (parent === null) return oKeys;
  var pKeys = ordinaryMetadataKeys(parent, P);
  return pKeys.length ? oKeys.length ? from(new Set(oKeys.concat(pKeys))) : pKeys : oKeys;
};

metadata.exp({ getMetadataKeys: function getMetadataKeys(target /* , targetKey */) {
  return ordinaryMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
} });


/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(47);
var anObject = __webpack_require__(2);
var ordinaryGetOwnMetadata = metadata.get;
var toMetaKey = metadata.key;

metadata.exp({ getOwnMetadata: function getOwnMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryGetOwnMetadata(metadataKey, anObject(target)
    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(47);
var anObject = __webpack_require__(2);
var ordinaryOwnMetadataKeys = metadata.keys;
var toMetaKey = metadata.key;

metadata.exp({ getOwnMetadataKeys: function getOwnMetadataKeys(target /* , targetKey */) {
  return ordinaryOwnMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
} });


/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(47);
var anObject = __webpack_require__(2);
var getPrototypeOf = __webpack_require__(30);
var ordinaryHasOwnMetadata = metadata.has;
var toMetaKey = metadata.key;

var ordinaryHasMetadata = function (MetadataKey, O, P) {
  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
  if (hasOwn) return true;
  var parent = getPrototypeOf(O);
  return parent !== null ? ordinaryHasMetadata(MetadataKey, parent, P) : false;
};

metadata.exp({ hasMetadata: function hasMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryHasMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(47);
var anObject = __webpack_require__(2);
var ordinaryHasOwnMetadata = metadata.has;
var toMetaKey = metadata.key;

metadata.exp({ hasOwnMetadata: function hasOwnMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryHasOwnMetadata(metadataKey, anObject(target)
    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

var $metadata = __webpack_require__(47);
var anObject = __webpack_require__(2);
var aFunction = __webpack_require__(20);
var toMetaKey = $metadata.key;
var ordinaryDefineOwnMetadata = $metadata.set;

$metadata.exp({ metadata: function metadata(metadataKey, metadataValue) {
  return function decorator(target, targetKey) {
    ordinaryDefineOwnMetadata(
      metadataKey, metadataValue,
      (targetKey !== undefined ? anObject : aFunction)(target),
      toMetaKey(targetKey)
    );
  };
} });


/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/rwaldron/tc39-notes/blob/master/es6/2014-09/sept-25.md#510-globalasap-for-enqueuing-a-microtask
var $export = __webpack_require__(1);
var microtask = __webpack_require__(168)();
var process = __webpack_require__(3).process;
var isNode = __webpack_require__(33)(process) == 'process';

$export($export.G, {
  asap: function asap(fn) {
    var domain = isNode && process.domain;
    microtask(domain ? domain.bind(fn) : fn);
  }
});


/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/zenparsing/es-observable
var $export = __webpack_require__(1);
var global = __webpack_require__(3);
var core = __webpack_require__(31);
var microtask = __webpack_require__(168)();
var OBSERVABLE = __webpack_require__(10)('observable');
var aFunction = __webpack_require__(20);
var anObject = __webpack_require__(2);
var anInstance = __webpack_require__(62);
var redefineAll = __webpack_require__(64);
var hide = __webpack_require__(22);
var forOf = __webpack_require__(63);
var RETURN = forOf.RETURN;

var getMethod = function (fn) {
  return fn == null ? undefined : aFunction(fn);
};

var cleanupSubscription = function (subscription) {
  var cleanup = subscription._c;
  if (cleanup) {
    subscription._c = undefined;
    cleanup();
  }
};

var subscriptionClosed = function (subscription) {
  return subscription._o === undefined;
};

var closeSubscription = function (subscription) {
  if (!subscriptionClosed(subscription)) {
    subscription._o = undefined;
    cleanupSubscription(subscription);
  }
};

var Subscription = function (observer, subscriber) {
  anObject(observer);
  this._c = undefined;
  this._o = observer;
  observer = new SubscriptionObserver(this);
  try {
    var cleanup = subscriber(observer);
    var subscription = cleanup;
    if (cleanup != null) {
      if (typeof cleanup.unsubscribe === 'function') cleanup = function () { subscription.unsubscribe(); };
      else aFunction(cleanup);
      this._c = cleanup;
    }
  } catch (e) {
    observer.error(e);
    return;
  } if (subscriptionClosed(this)) cleanupSubscription(this);
};

Subscription.prototype = redefineAll({}, {
  unsubscribe: function unsubscribe() { closeSubscription(this); }
});

var SubscriptionObserver = function (subscription) {
  this._s = subscription;
};

SubscriptionObserver.prototype = redefineAll({}, {
  next: function next(value) {
    var subscription = this._s;
    if (!subscriptionClosed(subscription)) {
      var observer = subscription._o;
      try {
        var m = getMethod(observer.next);
        if (m) return m.call(observer, value);
      } catch (e) {
        try {
          closeSubscription(subscription);
        } finally {
          throw e;
        }
      }
    }
  },
  error: function error(value) {
    var subscription = this._s;
    if (subscriptionClosed(subscription)) throw value;
    var observer = subscription._o;
    subscription._o = undefined;
    try {
      var m = getMethod(observer.error);
      if (!m) throw value;
      value = m.call(observer, value);
    } catch (e) {
      try {
        cleanupSubscription(subscription);
      } finally {
        throw e;
      }
    } cleanupSubscription(subscription);
    return value;
  },
  complete: function complete(value) {
    var subscription = this._s;
    if (!subscriptionClosed(subscription)) {
      var observer = subscription._o;
      subscription._o = undefined;
      try {
        var m = getMethod(observer.complete);
        value = m ? m.call(observer, value) : undefined;
      } catch (e) {
        try {
          cleanupSubscription(subscription);
        } finally {
          throw e;
        }
      } cleanupSubscription(subscription);
      return value;
    }
  }
});

var $Observable = function Observable(subscriber) {
  anInstance(this, $Observable, 'Observable', '_f')._f = aFunction(subscriber);
};

redefineAll($Observable.prototype, {
  subscribe: function subscribe(observer) {
    return new Subscription(observer, this._f);
  },
  forEach: function forEach(fn) {
    var that = this;
    return new (core.Promise || global.Promise)(function (resolve, reject) {
      aFunction(fn);
      var subscription = that.subscribe({
        next: function (value) {
          try {
            return fn(value);
          } catch (e) {
            reject(e);
            subscription.unsubscribe();
          }
        },
        error: reject,
        complete: resolve
      });
    });
  }
});

redefineAll($Observable, {
  from: function from(x) {
    var C = typeof this === 'function' ? this : $Observable;
    var method = getMethod(anObject(x)[OBSERVABLE]);
    if (method) {
      var observable = anObject(method.call(x));
      return observable.constructor === C ? observable : new C(function (observer) {
        return observable.subscribe(observer);
      });
    }
    return new C(function (observer) {
      var done = false;
      microtask(function () {
        if (!done) {
          try {
            if (forOf(x, false, function (it) {
              observer.next(it);
              if (done) return RETURN;
            }) === RETURN) return;
          } catch (e) {
            if (done) throw e;
            observer.error(e);
            return;
          } observer.complete();
        }
      });
      return function () { done = true; };
    });
  },
  of: function of() {
    for (var i = 0, l = arguments.length, items = new Array(l); i < l;) items[i] = arguments[i++];
    return new (typeof this === 'function' ? this : $Observable)(function (observer) {
      var done = false;
      microtask(function () {
        if (!done) {
          for (var j = 0; j < items.length; ++j) {
            observer.next(items[j]);
            if (done) return;
          } observer.complete();
        }
      });
      return function () { done = true; };
    });
  }
});

hide($Observable.prototype, OBSERVABLE, function () { return this; });

$export($export.G, { Observable: $Observable });

__webpack_require__(61)('Observable');


/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

// ie9- setTimeout & setInterval additional parameters fix
var global = __webpack_require__(3);
var $export = __webpack_require__(1);
var userAgent = __webpack_require__(108);
var slice = [].slice;
var MSIE = /MSIE .\./.test(userAgent); // <- dirty ie9- check
var wrap = function (set) {
  return function (fn, time /* , ...args */) {
    var boundArgs = arguments.length > 2;
    var args = boundArgs ? slice.call(arguments, 2) : false;
    return set(boundArgs ? function () {
      // eslint-disable-next-line no-new-func
      (typeof fn == 'function' ? fn : Function(fn)).apply(this, args);
    } : fn, time);
  };
};
$export($export.G + $export.B + $export.F * MSIE, {
  setTimeout: wrap(global.setTimeout),
  setInterval: wrap(global.setInterval)
});


/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(1);
var $task = __webpack_require__(167);
$export($export.G + $export.B, {
  setImmediate: $task.set,
  clearImmediate: $task.clear
});


/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

var $iterators = __webpack_require__(164);
var getKeys = __webpack_require__(57);
var redefine = __webpack_require__(23);
var global = __webpack_require__(3);
var hide = __webpack_require__(22);
var Iterators = __webpack_require__(76);
var wks = __webpack_require__(10);
var ITERATOR = wks('iterator');
var TO_STRING_TAG = wks('toStringTag');
var ArrayValues = Iterators.Array;

var DOMIterables = {
  CSSRuleList: true, // TODO: Not spec compliant, should be false.
  CSSStyleDeclaration: false,
  CSSValueList: false,
  ClientRectList: false,
  DOMRectList: false,
  DOMStringList: false,
  DOMTokenList: true,
  DataTransferItemList: false,
  FileList: false,
  HTMLAllCollection: false,
  HTMLCollection: false,
  HTMLFormElement: false,
  HTMLSelectElement: false,
  MediaList: true, // TODO: Not spec compliant, should be false.
  MimeTypeArray: false,
  NamedNodeMap: false,
  NodeList: true,
  PaintRequestList: false,
  Plugin: false,
  PluginArray: false,
  SVGLengthList: false,
  SVGNumberList: false,
  SVGPathSegList: false,
  SVGPointList: false,
  SVGStringList: false,
  SVGTransformList: false,
  SourceBufferList: false,
  StyleSheetList: true, // TODO: Not spec compliant, should be false.
  TextTrackCueList: false,
  TextTrackList: false,
  TouchList: false
};

for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
  var NAME = collections[i];
  var explicit = DOMIterables[NAME];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  var key;
  if (proto) {
    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
    Iterators[NAME] = ArrayValues;
    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
  }
}


/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * Copyright (c) 2014, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
 * additional grant of patent rights can be found in the PATENTS file in
 * the same directory.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    if (typeof global.process === "object" && global.process.domain) {
      invoke = global.process.domain.bind(invoke);
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // Among the various tricks for obtaining a reference to the global
  // object, this seems to be the most reliable technique that does not
  // use indirect eval (which violates Content Security Policy).
  typeof global === "object" ? global :
  typeof window === "object" ? window :
  typeof self === "object" ? self : this
);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(39)))

/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(542);
module.exports = __webpack_require__(31).RegExp.escape;


/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/benjamingr/RexExp.escape
var $export = __webpack_require__(1);
var $re = __webpack_require__(543)(/[\\^$*+?.()|[\]{}]/g, '\\$&');

$export($export.S, 'RegExp', { escape: function escape(it) { return $re(it); } });


/***/ }),
/* 543 */
/***/ (function(module, exports) {

module.exports = function (regExp, replace) {
  var replacer = replace === Object(replace) ? function (part) {
    return replace[part];
  } : replace;
  return function (it) {
    return String(it).replace(regExp, replacer);
  };
};


/***/ }),
/* 544 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_modal__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_dom__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_dom__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_redux_persist__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_redux_persist_lib_integration_react__ = __webpack_require__(602);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_redux_persist_lib_integration_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_redux_persist_lib_integration_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__config_createStore__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__index_css__ = __webpack_require__(623);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__App__ = __webpack_require__(625);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__registerServiceWorker__ = __webpack_require__(1000);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__support_deepLink__ = __webpack_require__(143);
// Before the router reads the address: a support reply email's link (?support=) waits for the
// composer and leaves the address bar, so the sign-in redirect doesn't carry it.
Object(__WEBPACK_IMPORTED_MODULE_12__support_deepLink__["a" /* captureSupportLink */])();var persistor=Object(__WEBPACK_IMPORTED_MODULE_6_redux_persist__["b" /* persistStore */])(__WEBPACK_IMPORTED_MODULE_8__config_createStore__["a" /* default */]);var app=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_redux__["Provider"],{store:__WEBPACK_IMPORTED_MODULE_8__config_createStore__["a" /* default */]},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_redux_persist_lib_integration_react__["PersistGate"],{loading:null,persistor:persistor},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["a" /* BrowserRouter */],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__App__["a" /* default */],null))));__WEBPACK_IMPORTED_MODULE_2_react_modal___default.a.setAppElement(document.getElementById("root"));__WEBPACK_IMPORTED_MODULE_3_react_dom___default.a.render(app,document.getElementById("root"));// The site no longer uses a service worker. Remove any old one this browser still has.
Object(__WEBPACK_IMPORTED_MODULE_11__registerServiceWorker__["a" /* unregisterAll */])();

/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.14.0
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var l=__webpack_require__(82),n="function"===typeof Symbol&&Symbol.for,p=n?Symbol.for("react.element"):60103,q=n?Symbol.for("react.portal"):60106,r=n?Symbol.for("react.fragment"):60107,t=n?Symbol.for("react.strict_mode"):60108,u=n?Symbol.for("react.profiler"):60114,v=n?Symbol.for("react.provider"):60109,w=n?Symbol.for("react.context"):60110,x=n?Symbol.for("react.forward_ref"):60112,y=n?Symbol.for("react.suspense"):60113,z=n?Symbol.for("react.memo"):60115,A=n?Symbol.for("react.lazy"):
60116,B="function"===typeof Symbol&&Symbol.iterator;function C(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}
var D={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}},E={};function F(a,b,c){this.props=a;this.context=b;this.refs=E;this.updater=c||D}F.prototype.isReactComponent={};F.prototype.setState=function(a,b){if("object"!==typeof a&&"function"!==typeof a&&null!=a)throw Error(C(85));this.updater.enqueueSetState(this,a,b,"setState")};F.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};
function G(){}G.prototype=F.prototype;function H(a,b,c){this.props=a;this.context=b;this.refs=E;this.updater=c||D}var I=H.prototype=new G;I.constructor=H;l(I,F.prototype);I.isPureReactComponent=!0;var J={current:null},K=Object.prototype.hasOwnProperty,L={key:!0,ref:!0,__self:!0,__source:!0};
function M(a,b,c){var e,d={},g=null,k=null;if(null!=b)for(e in void 0!==b.ref&&(k=b.ref),void 0!==b.key&&(g=""+b.key),b)K.call(b,e)&&!L.hasOwnProperty(e)&&(d[e]=b[e]);var f=arguments.length-2;if(1===f)d.children=c;else if(1<f){for(var h=Array(f),m=0;m<f;m++)h[m]=arguments[m+2];d.children=h}if(a&&a.defaultProps)for(e in f=a.defaultProps,f)void 0===d[e]&&(d[e]=f[e]);return{$$typeof:p,type:a,key:g,ref:k,props:d,_owner:J.current}}
function N(a,b){return{$$typeof:p,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}}function O(a){return"object"===typeof a&&null!==a&&a.$$typeof===p}function escape(a){var b={"=":"=0",":":"=2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var P=/\/+/g,Q=[];function R(a,b,c,e){if(Q.length){var d=Q.pop();d.result=a;d.keyPrefix=b;d.func=c;d.context=e;d.count=0;return d}return{result:a,keyPrefix:b,func:c,context:e,count:0}}
function S(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>Q.length&&Q.push(a)}
function T(a,b,c,e){var d=typeof a;if("undefined"===d||"boolean"===d)a=null;var g=!1;if(null===a)g=!0;else switch(d){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case p:case q:g=!0}}if(g)return c(e,a,""===b?"."+U(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var k=0;k<a.length;k++){d=a[k];var f=b+U(d,k);g+=T(d,f,c,e)}else if(null===a||"object"!==typeof a?f=null:(f=B&&a[B]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=f.call(a),k=
0;!(d=a.next()).done;)d=d.value,f=b+U(d,k++),g+=T(d,f,c,e);else if("object"===d)throw c=""+a,Error(C(31,"[object Object]"===c?"object with keys {"+Object.keys(a).join(", ")+"}":c,""));return g}function V(a,b,c){return null==a?0:T(a,"",b,c)}function U(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function W(a,b){a.func.call(a.context,b,a.count++)}
function aa(a,b,c){var e=a.result,d=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?X(a,e,c,function(a){return a}):null!=a&&(O(a)&&(a=N(a,d+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(P,"$&/")+"/")+c)),e.push(a))}function X(a,b,c,e,d){var g="";null!=c&&(g=(""+c).replace(P,"$&/")+"/");b=R(b,g,e,d);V(a,aa,b);S(b)}var Y={current:null};function Z(){var a=Y.current;if(null===a)throw Error(C(321));return a}
var ba={ReactCurrentDispatcher:Y,ReactCurrentBatchConfig:{suspense:null},ReactCurrentOwner:J,IsSomeRendererActing:{current:!1},assign:l};exports.Children={map:function(a,b,c){if(null==a)return a;var e=[];X(a,e,null,b,c);return e},forEach:function(a,b,c){if(null==a)return a;b=R(null,null,b,c);V(a,W,b);S(b)},count:function(a){return V(a,function(){return null},null)},toArray:function(a){var b=[];X(a,b,null,function(a){return a});return b},only:function(a){if(!O(a))throw Error(C(143));return a}};
exports.Component=F;exports.Fragment=r;exports.Profiler=u;exports.PureComponent=H;exports.StrictMode=t;exports.Suspense=y;exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=ba;
exports.cloneElement=function(a,b,c){if(null===a||void 0===a)throw Error(C(267,a));var e=l({},a.props),d=a.key,g=a.ref,k=a._owner;if(null!=b){void 0!==b.ref&&(g=b.ref,k=J.current);void 0!==b.key&&(d=""+b.key);if(a.type&&a.type.defaultProps)var f=a.type.defaultProps;for(h in b)K.call(b,h)&&!L.hasOwnProperty(h)&&(e[h]=void 0===b[h]&&void 0!==f?f[h]:b[h])}var h=arguments.length-2;if(1===h)e.children=c;else if(1<h){f=Array(h);for(var m=0;m<h;m++)f[m]=arguments[m+2];e.children=f}return{$$typeof:p,type:a.type,
key:d,ref:g,props:e,_owner:k}};exports.createContext=function(a,b){void 0===b&&(b=null);a={$$typeof:w,_calculateChangedBits:b,_currentValue:a,_currentValue2:a,_threadCount:0,Provider:null,Consumer:null};a.Provider={$$typeof:v,_context:a};return a.Consumer=a};exports.createElement=M;exports.createFactory=function(a){var b=M.bind(null,a);b.type=a;return b};exports.createRef=function(){return{current:null}};exports.forwardRef=function(a){return{$$typeof:x,render:a}};exports.isValidElement=O;
exports.lazy=function(a){return{$$typeof:A,_ctor:a,_status:-1,_result:null}};exports.memo=function(a,b){return{$$typeof:z,type:a,compare:void 0===b?null:b}};exports.useCallback=function(a,b){return Z().useCallback(a,b)};exports.useContext=function(a,b){return Z().useContext(a,b)};exports.useDebugValue=function(){};exports.useEffect=function(a,b){return Z().useEffect(a,b)};exports.useImperativeHandle=function(a,b,c){return Z().useImperativeHandle(a,b,c)};
exports.useLayoutEffect=function(a,b){return Z().useLayoutEffect(a,b)};exports.useMemo=function(a,b){return Z().useMemo(a,b)};exports.useReducer=function(a,b,c){return Z().useReducer(a,b,c)};exports.useRef=function(a){return Z().useRef(a)};exports.useState=function(a){return Z().useState(a)};exports.version="16.14.0";


/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bodyOpenClassName = exports.portalClassName = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(36);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _propTypes = __webpack_require__(7);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ModalPortal = __webpack_require__(552);

var _ModalPortal2 = _interopRequireDefault(_ModalPortal);

var _ariaAppHider = __webpack_require__(252);

var ariaAppHider = _interopRequireWildcard(_ariaAppHider);

var _safeHTMLElement = __webpack_require__(171);

var _safeHTMLElement2 = _interopRequireDefault(_safeHTMLElement);

var _reactLifecyclesCompat = __webpack_require__(558);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var portalClassName = exports.portalClassName = "ReactModalPortal";
var bodyOpenClassName = exports.bodyOpenClassName = "ReactModal__Body--open";

var isReact16 = _reactDom2.default.createPortal !== undefined;

var getCreatePortal = function getCreatePortal() {
  return isReact16 ? _reactDom2.default.createPortal : _reactDom2.default.unstable_renderSubtreeIntoContainer;
};

function getParentElement(parentSelector) {
  return parentSelector();
}

var Modal = function (_Component) {
  _inherits(Modal, _Component);

  function Modal() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Modal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Modal.__proto__ || Object.getPrototypeOf(Modal)).call.apply(_ref, [this].concat(args))), _this), _this.removePortal = function () {
      !isReact16 && _reactDom2.default.unmountComponentAtNode(_this.node);
      var parent = getParentElement(_this.props.parentSelector);
      if (parent) {
        parent.removeChild(_this.node);
      } else {
        // eslint-disable-next-line no-console
        console.warn('React-Modal: "parentSelector" prop did not returned any DOM ' + "element. Make sure that the parent element is unmounted to " + "avoid any memory leaks.");
      }
    }, _this.portalRef = function (ref) {
      _this.portal = ref;
    }, _this.renderPortal = function (props) {
      var createPortal = getCreatePortal();
      var portal = createPortal(_this, _react2.default.createElement(_ModalPortal2.default, _extends({ defaultStyles: Modal.defaultStyles }, props)), _this.node);
      _this.portalRef(portal);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Modal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!_safeHTMLElement.canUseDOM) return;

      if (!isReact16) {
        this.node = document.createElement("div");
      }
      this.node.className = this.props.portalClassName;

      var parent = getParentElement(this.props.parentSelector);
      parent.appendChild(this.node);

      !isReact16 && this.renderPortal(this.props);
    }
  }, {
    key: "getSnapshotBeforeUpdate",
    value: function getSnapshotBeforeUpdate(prevProps) {
      var prevParent = getParentElement(prevProps.parentSelector);
      var nextParent = getParentElement(this.props.parentSelector);
      return { prevParent: prevParent, nextParent: nextParent };
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, _, snapshot) {
      if (!_safeHTMLElement.canUseDOM) return;
      var _props = this.props,
          isOpen = _props.isOpen,
          portalClassName = _props.portalClassName;


      if (prevProps.portalClassName !== portalClassName) {
        this.node.className = portalClassName;
      }

      var prevParent = snapshot.prevParent,
          nextParent = snapshot.nextParent;

      if (nextParent !== prevParent) {
        prevParent.removeChild(this.node);
        nextParent.appendChild(this.node);
      }

      // Stop unnecessary renders if modal is remaining closed
      if (!prevProps.isOpen && !isOpen) return;

      !isReact16 && this.renderPortal(this.props);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (!_safeHTMLElement.canUseDOM || !this.node || !this.portal) return;

      var state = this.portal.state;
      var now = Date.now();
      var closesAt = state.isOpen && this.props.closeTimeoutMS && (state.closesAt || now + this.props.closeTimeoutMS);

      if (closesAt) {
        if (!state.beforeClose) {
          this.portal.closeWithTimeout();
        }

        setTimeout(this.removePortal, closesAt - now);
      } else {
        this.removePortal();
      }
    }
  }, {
    key: "render",
    value: function render() {
      if (!_safeHTMLElement.canUseDOM || !isReact16) {
        return null;
      }

      if (!this.node && isReact16) {
        this.node = document.createElement("div");
      }

      var createPortal = getCreatePortal();
      return createPortal(_react2.default.createElement(_ModalPortal2.default, _extends({
        ref: this.portalRef,
        defaultStyles: Modal.defaultStyles
      }, this.props)), this.node);
    }
  }], [{
    key: "setAppElement",
    value: function setAppElement(element) {
      ariaAppHider.setElement(element);
    }

    /* eslint-disable react/no-unused-prop-types */

    /* eslint-enable react/no-unused-prop-types */

  }]);

  return Modal;
}(_react.Component);

Modal.propTypes = {
  isOpen: _propTypes2.default.bool.isRequired,
  style: _propTypes2.default.shape({
    content: _propTypes2.default.object,
    overlay: _propTypes2.default.object
  }),
  portalClassName: _propTypes2.default.string,
  bodyOpenClassName: _propTypes2.default.string,
  htmlOpenClassName: _propTypes2.default.string,
  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
    base: _propTypes2.default.string.isRequired,
    afterOpen: _propTypes2.default.string.isRequired,
    beforeClose: _propTypes2.default.string.isRequired
  })]),
  overlayClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
    base: _propTypes2.default.string.isRequired,
    afterOpen: _propTypes2.default.string.isRequired,
    beforeClose: _propTypes2.default.string.isRequired
  })]),
  appElement: _propTypes2.default.instanceOf(_safeHTMLElement2.default),
  onAfterOpen: _propTypes2.default.func,
  onRequestClose: _propTypes2.default.func,
  closeTimeoutMS: _propTypes2.default.number,
  ariaHideApp: _propTypes2.default.bool,
  shouldFocusAfterRender: _propTypes2.default.bool,
  shouldCloseOnOverlayClick: _propTypes2.default.bool,
  shouldReturnFocusAfterClose: _propTypes2.default.bool,
  parentSelector: _propTypes2.default.func,
  aria: _propTypes2.default.object,
  data: _propTypes2.default.object,
  role: _propTypes2.default.string,
  contentLabel: _propTypes2.default.string,
  shouldCloseOnEsc: _propTypes2.default.bool,
  overlayRef: _propTypes2.default.func,
  contentRef: _propTypes2.default.func
};
Modal.defaultProps = {
  isOpen: false,
  portalClassName: portalClassName,
  bodyOpenClassName: bodyOpenClassName,
  role: "dialog",
  ariaHideApp: true,
  closeTimeoutMS: 0,
  shouldFocusAfterRender: true,
  shouldCloseOnEsc: true,
  shouldCloseOnOverlayClick: true,
  shouldReturnFocusAfterClose: true,
  parentSelector: function parentSelector() {
    return document.body;
  }
};
Modal.defaultStyles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(255, 255, 255, 0.75)"
  },
  content: {
    position: "absolute",
    top: "40px",
    left: "40px",
    right: "40px",
    bottom: "40px",
    border: "1px solid #ccc",
    background: "#fff",
    overflow: "auto",
    WebkitOverflowScrolling: "touch",
    borderRadius: "4px",
    outline: "none",
    padding: "20px"
  }
};


(0, _reactLifecyclesCompat.polyfill)(Modal);

exports.default = Modal;

/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.14.0
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/
var aa=__webpack_require__(0),n=__webpack_require__(82),r=__webpack_require__(548);function u(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}if(!aa)throw Error(u(227));
function ba(a,b,c,d,e,f,g,h,k){var l=Array.prototype.slice.call(arguments,3);try{b.apply(c,l)}catch(m){this.onError(m)}}var da=!1,ea=null,fa=!1,ha=null,ia={onError:function(a){da=!0;ea=a}};function ja(a,b,c,d,e,f,g,h,k){da=!1;ea=null;ba.apply(ia,arguments)}function ka(a,b,c,d,e,f,g,h,k){ja.apply(this,arguments);if(da){if(da){var l=ea;da=!1;ea=null}else throw Error(u(198));fa||(fa=!0,ha=l)}}var la=null,ma=null,na=null;
function oa(a,b,c){var d=a.type||"unknown-event";a.currentTarget=na(c);ka(d,b,void 0,a);a.currentTarget=null}var pa=null,qa={};
function ra(){if(pa)for(var a in qa){var b=qa[a],c=pa.indexOf(a);if(!(-1<c))throw Error(u(96,a));if(!sa[c]){if(!b.extractEvents)throw Error(u(97,a));sa[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],g=b,h=d;if(ta.hasOwnProperty(h))throw Error(u(99,h));ta[h]=f;var k=f.phasedRegistrationNames;if(k){for(e in k)k.hasOwnProperty(e)&&ua(k[e],g,h);e=!0}else f.registrationName?(ua(f.registrationName,g,h),e=!0):e=!1;if(!e)throw Error(u(98,d,a));}}}}
function ua(a,b,c){if(va[a])throw Error(u(100,a));va[a]=b;wa[a]=b.eventTypes[c].dependencies}var sa=[],ta={},va={},wa={};function xa(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];if(!qa.hasOwnProperty(c)||qa[c]!==d){if(qa[c])throw Error(u(102,c));qa[c]=d;b=!0}}b&&ra()}var ya=!("undefined"===typeof window||"undefined"===typeof window.document||"undefined"===typeof window.document.createElement),za=null,Aa=null,Ba=null;
function Ca(a){if(a=ma(a)){if("function"!==typeof za)throw Error(u(280));var b=a.stateNode;b&&(b=la(b),za(a.stateNode,a.type,b))}}function Da(a){Aa?Ba?Ba.push(a):Ba=[a]:Aa=a}function Ea(){if(Aa){var a=Aa,b=Ba;Ba=Aa=null;Ca(a);if(b)for(a=0;a<b.length;a++)Ca(b[a])}}function Fa(a,b){return a(b)}function Ga(a,b,c,d,e){return a(b,c,d,e)}function Ha(){}var Ia=Fa,Ja=!1,Ka=!1;function La(){if(null!==Aa||null!==Ba)Ha(),Ea()}
function Ma(a,b,c){if(Ka)return a(b,c);Ka=!0;try{return Ia(a,b,c)}finally{Ka=!1,La()}}var Na=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,Oa=Object.prototype.hasOwnProperty,Pa={},Qa={};
function Ra(a){if(Oa.call(Qa,a))return!0;if(Oa.call(Pa,a))return!1;if(Na.test(a))return Qa[a]=!0;Pa[a]=!0;return!1}function Sa(a,b,c,d){if(null!==c&&0===c.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(d)return!1;if(null!==c)return!c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}
function Ta(a,b,c,d){if(null===b||"undefined"===typeof b||Sa(a,b,c,d))return!0;if(d)return!1;if(null!==c)switch(c.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}function v(a,b,c,d,e,f){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=e;this.mustUseProperty=c;this.propertyName=a;this.type=b;this.sanitizeURL=f}var C={};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){C[a]=new v(a,0,!1,a,null,!1)});[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];C[b]=new v(b,1,!1,a[1],null,!1)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){C[a]=new v(a,2,!1,a.toLowerCase(),null,!1)});
["autoReverse","externalResourcesRequired","focusable","preserveAlpha"].forEach(function(a){C[a]=new v(a,2,!1,a,null,!1)});"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){C[a]=new v(a,3,!1,a.toLowerCase(),null,!1)});
["checked","multiple","muted","selected"].forEach(function(a){C[a]=new v(a,3,!0,a,null,!1)});["capture","download"].forEach(function(a){C[a]=new v(a,4,!1,a,null,!1)});["cols","rows","size","span"].forEach(function(a){C[a]=new v(a,6,!1,a,null,!1)});["rowSpan","start"].forEach(function(a){C[a]=new v(a,5,!1,a.toLowerCase(),null,!1)});var Ua=/[\-:]([a-z])/g;function Va(a){return a[1].toUpperCase()}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(Ua,
Va);C[b]=new v(b,1,!1,a,null,!1)});"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(Ua,Va);C[b]=new v(b,1,!1,a,"http://www.w3.org/1999/xlink",!1)});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(Ua,Va);C[b]=new v(b,1,!1,a,"http://www.w3.org/XML/1998/namespace",!1)});["tabIndex","crossOrigin"].forEach(function(a){C[a]=new v(a,1,!1,a.toLowerCase(),null,!1)});
C.xlinkHref=new v("xlinkHref",1,!1,"xlink:href","http://www.w3.org/1999/xlink",!0);["src","href","action","formAction"].forEach(function(a){C[a]=new v(a,1,!1,a.toLowerCase(),null,!0)});var Wa=aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;Wa.hasOwnProperty("ReactCurrentDispatcher")||(Wa.ReactCurrentDispatcher={current:null});Wa.hasOwnProperty("ReactCurrentBatchConfig")||(Wa.ReactCurrentBatchConfig={suspense:null});
function Xa(a,b,c,d){var e=C.hasOwnProperty(b)?C[b]:null;var f=null!==e?0===e.type:d?!1:!(2<b.length)||"o"!==b[0]&&"O"!==b[0]||"n"!==b[1]&&"N"!==b[1]?!1:!0;f||(Ta(b,c,e,d)&&(c=null),d||null===e?Ra(b)&&(null===c?a.removeAttribute(b):a.setAttribute(b,""+c)):e.mustUseProperty?a[e.propertyName]=null===c?3===e.type?!1:"":c:(b=e.attributeName,d=e.attributeNamespace,null===c?a.removeAttribute(b):(e=e.type,c=3===e||4===e&&!0===c?"":""+c,d?a.setAttributeNS(d,b,c):a.setAttribute(b,c))))}
var Ya=/^(.*)[\\\/]/,E="function"===typeof Symbol&&Symbol.for,Za=E?Symbol.for("react.element"):60103,$a=E?Symbol.for("react.portal"):60106,ab=E?Symbol.for("react.fragment"):60107,bb=E?Symbol.for("react.strict_mode"):60108,cb=E?Symbol.for("react.profiler"):60114,db=E?Symbol.for("react.provider"):60109,eb=E?Symbol.for("react.context"):60110,fb=E?Symbol.for("react.concurrent_mode"):60111,gb=E?Symbol.for("react.forward_ref"):60112,hb=E?Symbol.for("react.suspense"):60113,ib=E?Symbol.for("react.suspense_list"):
60120,jb=E?Symbol.for("react.memo"):60115,kb=E?Symbol.for("react.lazy"):60116,lb=E?Symbol.for("react.block"):60121,mb="function"===typeof Symbol&&Symbol.iterator;function nb(a){if(null===a||"object"!==typeof a)return null;a=mb&&a[mb]||a["@@iterator"];return"function"===typeof a?a:null}function ob(a){if(-1===a._status){a._status=0;var b=a._ctor;b=b();a._result=b;b.then(function(b){0===a._status&&(b=b.default,a._status=1,a._result=b)},function(b){0===a._status&&(a._status=2,a._result=b)})}}
function pb(a){if(null==a)return null;if("function"===typeof a)return a.displayName||a.name||null;if("string"===typeof a)return a;switch(a){case ab:return"Fragment";case $a:return"Portal";case cb:return"Profiler";case bb:return"StrictMode";case hb:return"Suspense";case ib:return"SuspenseList"}if("object"===typeof a)switch(a.$$typeof){case eb:return"Context.Consumer";case db:return"Context.Provider";case gb:var b=a.render;b=b.displayName||b.name||"";return a.displayName||(""!==b?"ForwardRef("+b+")":
"ForwardRef");case jb:return pb(a.type);case lb:return pb(a.render);case kb:if(a=1===a._status?a._result:null)return pb(a)}return null}function qb(a){var b="";do{a:switch(a.tag){case 3:case 4:case 6:case 7:case 10:case 9:var c="";break a;default:var d=a._debugOwner,e=a._debugSource,f=pb(a.type);c=null;d&&(c=pb(d.type));d=f;f="";e?f=" (at "+e.fileName.replace(Ya,"")+":"+e.lineNumber+")":c&&(f=" (created by "+c+")");c="\n    in "+(d||"Unknown")+f}b+=c;a=a.return}while(a);return b}
function rb(a){switch(typeof a){case "boolean":case "number":case "object":case "string":case "undefined":return a;default:return""}}function sb(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
function tb(a){var b=sb(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"undefined"!==typeof c&&"function"===typeof c.get&&"function"===typeof c.set){var e=c.get,f=c.set;Object.defineProperty(a,b,{configurable:!0,get:function(){return e.call(this)},set:function(a){d=""+a;f.call(this,a)}});Object.defineProperty(a,b,{enumerable:c.enumerable});return{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=
null;delete a[b]}}}}function xb(a){a._valueTracker||(a._valueTracker=tb(a))}function yb(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=sb(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}function zb(a,b){var c=b.checked;return n({},b,{defaultChecked:void 0,defaultValue:void 0,value:void 0,checked:null!=c?c:a._wrapperState.initialChecked})}
function Ab(a,b){var c=null==b.defaultValue?"":b.defaultValue,d=null!=b.checked?b.checked:b.defaultChecked;c=rb(null!=b.value?b.value:c);a._wrapperState={initialChecked:d,initialValue:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}function Bb(a,b){b=b.checked;null!=b&&Xa(a,"checked",b,!1)}
function Cb(a,b){Bb(a,b);var c=rb(b.value),d=b.type;if(null!=c)if("number"===d){if(0===c&&""===a.value||a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);else if("submit"===d||"reset"===d){a.removeAttribute("value");return}b.hasOwnProperty("value")?Db(a,b.type,c):b.hasOwnProperty("defaultValue")&&Db(a,b.type,rb(b.defaultValue));null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
function Eb(a,b,c){if(b.hasOwnProperty("value")||b.hasOwnProperty("defaultValue")){var d=b.type;if(!("submit"!==d&&"reset"!==d||void 0!==b.value&&null!==b.value))return;b=""+a._wrapperState.initialValue;c||b===a.value||(a.value=b);a.defaultValue=b}c=a.name;""!==c&&(a.name="");a.defaultChecked=!!a._wrapperState.initialChecked;""!==c&&(a.name=c)}
function Db(a,b,c){if("number"!==b||a.ownerDocument.activeElement!==a)null==c?a.defaultValue=""+a._wrapperState.initialValue:a.defaultValue!==""+c&&(a.defaultValue=""+c)}function Fb(a){var b="";aa.Children.forEach(a,function(a){null!=a&&(b+=a)});return b}function Gb(a,b){a=n({children:void 0},b);if(b=Fb(b.children))a.children=b;return a}
function Hb(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+rb(c);b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
function Ib(a,b){if(null!=b.dangerouslySetInnerHTML)throw Error(u(91));return n({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function Jb(a,b){var c=b.value;if(null==c){c=b.children;b=b.defaultValue;if(null!=c){if(null!=b)throw Error(u(92));if(Array.isArray(c)){if(!(1>=c.length))throw Error(u(93));c=c[0]}b=c}null==b&&(b="");c=b}a._wrapperState={initialValue:rb(c)}}
function Kb(a,b){var c=rb(b.value),d=rb(b.defaultValue);null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&a.defaultValue!==c&&(a.defaultValue=c));null!=d&&(a.defaultValue=""+d)}function Lb(a){var b=a.textContent;b===a._wrapperState.initialValue&&""!==b&&null!==b&&(a.value=b)}var Mb={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
function Nb(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function Ob(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?Nb(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
var Pb,Qb=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==Mb.svg||"innerHTML"in a)a.innerHTML=b;else{Pb=Pb||document.createElement("div");Pb.innerHTML="<svg>"+b.valueOf().toString()+"</svg>";for(b=Pb.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
function Rb(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}function Sb(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;return c}var Tb={animationend:Sb("Animation","AnimationEnd"),animationiteration:Sb("Animation","AnimationIteration"),animationstart:Sb("Animation","AnimationStart"),transitionend:Sb("Transition","TransitionEnd")},Ub={},Vb={};
ya&&(Vb=document.createElement("div").style,"AnimationEvent"in window||(delete Tb.animationend.animation,delete Tb.animationiteration.animation,delete Tb.animationstart.animation),"TransitionEvent"in window||delete Tb.transitionend.transition);function Wb(a){if(Ub[a])return Ub[a];if(!Tb[a])return a;var b=Tb[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in Vb)return Ub[a]=b[c];return a}
var Xb=Wb("animationend"),Yb=Wb("animationiteration"),Zb=Wb("animationstart"),$b=Wb("transitionend"),ac="abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "),bc=new ("function"===typeof WeakMap?WeakMap:Map);function cc(a){var b=bc.get(a);void 0===b&&(b=new Map,bc.set(a,b));return b}
function dc(a){var b=a,c=a;if(a.alternate)for(;b.return;)b=b.return;else{a=b;do b=a,0!==(b.effectTag&1026)&&(c=b.return),a=b.return;while(a)}return 3===b.tag?c:null}function ec(a){if(13===a.tag){var b=a.memoizedState;null===b&&(a=a.alternate,null!==a&&(b=a.memoizedState));if(null!==b)return b.dehydrated}return null}function fc(a){if(dc(a)!==a)throw Error(u(188));}
function gc(a){var b=a.alternate;if(!b){b=dc(a);if(null===b)throw Error(u(188));return b!==a?null:a}for(var c=a,d=b;;){var e=c.return;if(null===e)break;var f=e.alternate;if(null===f){d=e.return;if(null!==d){c=d;continue}break}if(e.child===f.child){for(f=e.child;f;){if(f===c)return fc(e),a;if(f===d)return fc(e),b;f=f.sibling}throw Error(u(188));}if(c.return!==d.return)c=e,d=f;else{for(var g=!1,h=e.child;h;){if(h===c){g=!0;c=e;d=f;break}if(h===d){g=!0;d=e;c=f;break}h=h.sibling}if(!g){for(h=f.child;h;){if(h===
c){g=!0;c=f;d=e;break}if(h===d){g=!0;d=f;c=e;break}h=h.sibling}if(!g)throw Error(u(189));}}if(c.alternate!==d)throw Error(u(190));}if(3!==c.tag)throw Error(u(188));return c.stateNode.current===c?a:b}function hc(a){a=gc(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child.return=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}}return null}
function ic(a,b){if(null==b)throw Error(u(30));if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}function jc(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var kc=null;
function lc(a){if(a){var b=a._dispatchListeners,c=a._dispatchInstances;if(Array.isArray(b))for(var d=0;d<b.length&&!a.isPropagationStopped();d++)oa(a,b[d],c[d]);else b&&oa(a,b,c);a._dispatchListeners=null;a._dispatchInstances=null;a.isPersistent()||a.constructor.release(a)}}function mc(a){null!==a&&(kc=ic(kc,a));a=kc;kc=null;if(a){jc(a,lc);if(kc)throw Error(u(95));if(fa)throw a=ha,fa=!1,ha=null,a;}}
function nc(a){a=a.target||a.srcElement||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}function oc(a){if(!ya)return!1;a="on"+a;var b=a in document;b||(b=document.createElement("div"),b.setAttribute(a,"return;"),b="function"===typeof b[a]);return b}var pc=[];function qc(a){a.topLevelType=null;a.nativeEvent=null;a.targetInst=null;a.ancestors.length=0;10>pc.length&&pc.push(a)}
function rc(a,b,c,d){if(pc.length){var e=pc.pop();e.topLevelType=a;e.eventSystemFlags=d;e.nativeEvent=b;e.targetInst=c;return e}return{topLevelType:a,eventSystemFlags:d,nativeEvent:b,targetInst:c,ancestors:[]}}
function sc(a){var b=a.targetInst,c=b;do{if(!c){a.ancestors.push(c);break}var d=c;if(3===d.tag)d=d.stateNode.containerInfo;else{for(;d.return;)d=d.return;d=3!==d.tag?null:d.stateNode.containerInfo}if(!d)break;b=c.tag;5!==b&&6!==b||a.ancestors.push(c);c=tc(d)}while(c);for(c=0;c<a.ancestors.length;c++){b=a.ancestors[c];var e=nc(a.nativeEvent);d=a.topLevelType;var f=a.nativeEvent,g=a.eventSystemFlags;0===c&&(g|=64);for(var h=null,k=0;k<sa.length;k++){var l=sa[k];l&&(l=l.extractEvents(d,b,f,e,g))&&(h=
ic(h,l))}mc(h)}}function uc(a,b,c){if(!c.has(a)){switch(a){case "scroll":vc(b,"scroll",!0);break;case "focus":case "blur":vc(b,"focus",!0);vc(b,"blur",!0);c.set("blur",null);c.set("focus",null);break;case "cancel":case "close":oc(a)&&vc(b,a,!0);break;case "invalid":case "submit":case "reset":break;default:-1===ac.indexOf(a)&&F(a,b)}c.set(a,null)}}
var wc,xc,yc,zc=!1,Ac=[],Bc=null,Cc=null,Dc=null,Ec=new Map,Fc=new Map,Gc=[],Hc="mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput close cancel copy cut paste click change contextmenu reset submit".split(" "),Ic="focus blur dragenter dragleave mouseover mouseout pointerover pointerout gotpointercapture lostpointercapture".split(" ");
function Jc(a,b){var c=cc(b);Hc.forEach(function(a){uc(a,b,c)});Ic.forEach(function(a){uc(a,b,c)})}function Kc(a,b,c,d,e){return{blockedOn:a,topLevelType:b,eventSystemFlags:c|32,nativeEvent:e,container:d}}
function Lc(a,b){switch(a){case "focus":case "blur":Bc=null;break;case "dragenter":case "dragleave":Cc=null;break;case "mouseover":case "mouseout":Dc=null;break;case "pointerover":case "pointerout":Ec.delete(b.pointerId);break;case "gotpointercapture":case "lostpointercapture":Fc.delete(b.pointerId)}}function Mc(a,b,c,d,e,f){if(null===a||a.nativeEvent!==f)return a=Kc(b,c,d,e,f),null!==b&&(b=Nc(b),null!==b&&xc(b)),a;a.eventSystemFlags|=d;return a}
function Oc(a,b,c,d,e){switch(b){case "focus":return Bc=Mc(Bc,a,b,c,d,e),!0;case "dragenter":return Cc=Mc(Cc,a,b,c,d,e),!0;case "mouseover":return Dc=Mc(Dc,a,b,c,d,e),!0;case "pointerover":var f=e.pointerId;Ec.set(f,Mc(Ec.get(f)||null,a,b,c,d,e));return!0;case "gotpointercapture":return f=e.pointerId,Fc.set(f,Mc(Fc.get(f)||null,a,b,c,d,e)),!0}return!1}
function Pc(a){var b=tc(a.target);if(null!==b){var c=dc(b);if(null!==c)if(b=c.tag,13===b){if(b=ec(c),null!==b){a.blockedOn=b;r.unstable_runWithPriority(a.priority,function(){yc(c)});return}}else if(3===b&&c.stateNode.hydrate){a.blockedOn=3===c.tag?c.stateNode.containerInfo:null;return}}a.blockedOn=null}function Qc(a){if(null!==a.blockedOn)return!1;var b=Rc(a.topLevelType,a.eventSystemFlags,a.container,a.nativeEvent);if(null!==b){var c=Nc(b);null!==c&&xc(c);a.blockedOn=b;return!1}return!0}
function Sc(a,b,c){Qc(a)&&c.delete(b)}function Tc(){for(zc=!1;0<Ac.length;){var a=Ac[0];if(null!==a.blockedOn){a=Nc(a.blockedOn);null!==a&&wc(a);break}var b=Rc(a.topLevelType,a.eventSystemFlags,a.container,a.nativeEvent);null!==b?a.blockedOn=b:Ac.shift()}null!==Bc&&Qc(Bc)&&(Bc=null);null!==Cc&&Qc(Cc)&&(Cc=null);null!==Dc&&Qc(Dc)&&(Dc=null);Ec.forEach(Sc);Fc.forEach(Sc)}function Uc(a,b){a.blockedOn===b&&(a.blockedOn=null,zc||(zc=!0,r.unstable_scheduleCallback(r.unstable_NormalPriority,Tc)))}
function Vc(a){function b(b){return Uc(b,a)}if(0<Ac.length){Uc(Ac[0],a);for(var c=1;c<Ac.length;c++){var d=Ac[c];d.blockedOn===a&&(d.blockedOn=null)}}null!==Bc&&Uc(Bc,a);null!==Cc&&Uc(Cc,a);null!==Dc&&Uc(Dc,a);Ec.forEach(b);Fc.forEach(b);for(c=0;c<Gc.length;c++)d=Gc[c],d.blockedOn===a&&(d.blockedOn=null);for(;0<Gc.length&&(c=Gc[0],null===c.blockedOn);)Pc(c),null===c.blockedOn&&Gc.shift()}
var Wc={},Yc=new Map,Zc=new Map,$c=["abort","abort",Xb,"animationEnd",Yb,"animationIteration",Zb,"animationStart","canplay","canPlay","canplaythrough","canPlayThrough","durationchange","durationChange","emptied","emptied","encrypted","encrypted","ended","ended","error","error","gotpointercapture","gotPointerCapture","load","load","loadeddata","loadedData","loadedmetadata","loadedMetadata","loadstart","loadStart","lostpointercapture","lostPointerCapture","playing","playing","progress","progress","seeking",
"seeking","stalled","stalled","suspend","suspend","timeupdate","timeUpdate",$b,"transitionEnd","waiting","waiting"];function ad(a,b){for(var c=0;c<a.length;c+=2){var d=a[c],e=a[c+1],f="on"+(e[0].toUpperCase()+e.slice(1));f={phasedRegistrationNames:{bubbled:f,captured:f+"Capture"},dependencies:[d],eventPriority:b};Zc.set(d,b);Yc.set(d,f);Wc[e]=f}}
ad("blur blur cancel cancel click click close close contextmenu contextMenu copy copy cut cut auxclick auxClick dblclick doubleClick dragend dragEnd dragstart dragStart drop drop focus focus input input invalid invalid keydown keyDown keypress keyPress keyup keyUp mousedown mouseDown mouseup mouseUp paste paste pause pause play play pointercancel pointerCancel pointerdown pointerDown pointerup pointerUp ratechange rateChange reset reset seeked seeked submit submit touchcancel touchCancel touchend touchEnd touchstart touchStart volumechange volumeChange".split(" "),0);
ad("drag drag dragenter dragEnter dragexit dragExit dragleave dragLeave dragover dragOver mousemove mouseMove mouseout mouseOut mouseover mouseOver pointermove pointerMove pointerout pointerOut pointerover pointerOver scroll scroll toggle toggle touchmove touchMove wheel wheel".split(" "),1);ad($c,2);for(var bd="change selectionchange textInput compositionstart compositionend compositionupdate".split(" "),cd=0;cd<bd.length;cd++)Zc.set(bd[cd],0);
var dd=r.unstable_UserBlockingPriority,ed=r.unstable_runWithPriority,fd=!0;function F(a,b){vc(b,a,!1)}function vc(a,b,c){var d=Zc.get(b);switch(void 0===d?2:d){case 0:d=gd.bind(null,b,1,a);break;case 1:d=hd.bind(null,b,1,a);break;default:d=id.bind(null,b,1,a)}c?a.addEventListener(b,d,!0):a.addEventListener(b,d,!1)}function gd(a,b,c,d){Ja||Ha();var e=id,f=Ja;Ja=!0;try{Ga(e,a,b,c,d)}finally{(Ja=f)||La()}}function hd(a,b,c,d){ed(dd,id.bind(null,a,b,c,d))}
function id(a,b,c,d){if(fd)if(0<Ac.length&&-1<Hc.indexOf(a))a=Kc(null,a,b,c,d),Ac.push(a);else{var e=Rc(a,b,c,d);if(null===e)Lc(a,d);else if(-1<Hc.indexOf(a))a=Kc(e,a,b,c,d),Ac.push(a);else if(!Oc(e,a,b,c,d)){Lc(a,d);a=rc(a,d,null,b);try{Ma(sc,a)}finally{qc(a)}}}}
function Rc(a,b,c,d){c=nc(d);c=tc(c);if(null!==c){var e=dc(c);if(null===e)c=null;else{var f=e.tag;if(13===f){c=ec(e);if(null!==c)return c;c=null}else if(3===f){if(e.stateNode.hydrate)return 3===e.tag?e.stateNode.containerInfo:null;c=null}else e!==c&&(c=null)}}a=rc(a,d,c,b);try{Ma(sc,a)}finally{qc(a)}return null}
var jd={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridArea:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,
floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},kd=["Webkit","ms","Moz","O"];Object.keys(jd).forEach(function(a){kd.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);jd[b]=jd[a]})});function ld(a,b,c){return null==b||"boolean"===typeof b||""===b?"":c||"number"!==typeof b||0===b||jd.hasOwnProperty(a)&&jd[a]?(""+b).trim():b+"px"}
function md(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--"),e=ld(c,b[c],d);"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var nd=n({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
function od(a,b){if(b){if(nd[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML))throw Error(u(137,a,""));if(null!=b.dangerouslySetInnerHTML){if(null!=b.children)throw Error(u(60));if(!("object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML))throw Error(u(61));}if(null!=b.style&&"object"!==typeof b.style)throw Error(u(62,""));}}
function pd(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}var qd=Mb.html;function rd(a,b){a=9===a.nodeType||11===a.nodeType?a:a.ownerDocument;var c=cc(a);b=wa[b];for(var d=0;d<b.length;d++)uc(b[d],a,c)}function sd(){}
function td(a){a=a||("undefined"!==typeof document?document:void 0);if("undefined"===typeof a)return null;try{return a.activeElement||a.body}catch(b){return a.body}}function ud(a){for(;a&&a.firstChild;)a=a.firstChild;return a}function vd(a,b){var c=ud(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=ud(c)}}
function wd(a,b){return a&&b?a===b?!0:a&&3===a.nodeType?!1:b&&3===b.nodeType?wd(a,b.parentNode):"contains"in a?a.contains(b):a.compareDocumentPosition?!!(a.compareDocumentPosition(b)&16):!1:!1}function xd(){for(var a=window,b=td();b instanceof a.HTMLIFrameElement;){try{var c="string"===typeof b.contentWindow.location.href}catch(d){c=!1}if(c)a=b.contentWindow;else break;b=td(a.document)}return b}
function yd(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&("text"===a.type||"search"===a.type||"tel"===a.type||"url"===a.type||"password"===a.type)||"textarea"===b||"true"===a.contentEditable)}var zd="$",Ad="/$",Bd="$?",Cd="$!",Dd=null,Ed=null;function Fd(a,b){switch(a){case "button":case "input":case "select":case "textarea":return!!b.autoFocus}return!1}
function Gd(a,b){return"textarea"===a||"option"===a||"noscript"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&null!=b.dangerouslySetInnerHTML.__html}var Hd="function"===typeof setTimeout?setTimeout:void 0,Id="function"===typeof clearTimeout?clearTimeout:void 0;function Jd(a){for(;null!=a;a=a.nextSibling){var b=a.nodeType;if(1===b||3===b)break}return a}
function Kd(a){a=a.previousSibling;for(var b=0;a;){if(8===a.nodeType){var c=a.data;if(c===zd||c===Cd||c===Bd){if(0===b)return a;b--}else c===Ad&&b++}a=a.previousSibling}return null}var Ld=Math.random().toString(36).slice(2),Md="__reactInternalInstance$"+Ld,Nd="__reactEventHandlers$"+Ld,Od="__reactContainere$"+Ld;
function tc(a){var b=a[Md];if(b)return b;for(var c=a.parentNode;c;){if(b=c[Od]||c[Md]){c=b.alternate;if(null!==b.child||null!==c&&null!==c.child)for(a=Kd(a);null!==a;){if(c=a[Md])return c;a=Kd(a)}return b}a=c;c=a.parentNode}return null}function Nc(a){a=a[Md]||a[Od];return!a||5!==a.tag&&6!==a.tag&&13!==a.tag&&3!==a.tag?null:a}function Pd(a){if(5===a.tag||6===a.tag)return a.stateNode;throw Error(u(33));}function Qd(a){return a[Nd]||null}
function Rd(a){do a=a.return;while(a&&5!==a.tag);return a?a:null}
function Sd(a,b){var c=a.stateNode;if(!c)return null;var d=la(c);if(!d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":case "onMouseEnter":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;if(c&&"function"!==typeof c)throw Error(u(231,
b,typeof c));return c}function Td(a,b,c){if(b=Sd(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=ic(c._dispatchListeners,b),c._dispatchInstances=ic(c._dispatchInstances,a)}function Ud(a){if(a&&a.dispatchConfig.phasedRegistrationNames){for(var b=a._targetInst,c=[];b;)c.push(b),b=Rd(b);for(b=c.length;0<b--;)Td(c[b],"captured",a);for(b=0;b<c.length;b++)Td(c[b],"bubbled",a)}}
function Vd(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=Sd(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=ic(c._dispatchListeners,b),c._dispatchInstances=ic(c._dispatchInstances,a))}function Wd(a){a&&a.dispatchConfig.registrationName&&Vd(a._targetInst,null,a)}function Xd(a){jc(a,Ud)}var Yd=null,Zd=null,$d=null;
function ae(){if($d)return $d;var a,b=Zd,c=b.length,d,e="value"in Yd?Yd.value:Yd.textContent,f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var g=c-a;for(d=1;d<=g&&b[c-d]===e[f-d];d++);return $d=e.slice(a,1<d?1-d:void 0)}function be(){return!0}function ce(){return!1}
function G(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?be:ce;this.isPropagationStopped=ce;return this}
n(G.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=be)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=be)},persist:function(){this.isPersistent=be},isPersistent:ce,destructor:function(){var a=this.constructor.Interface,
b;for(b in a)this[b]=null;this.nativeEvent=this._targetInst=this.dispatchConfig=null;this.isPropagationStopped=this.isDefaultPrevented=ce;this._dispatchInstances=this._dispatchListeners=null}});G.Interface={type:null,target:null,currentTarget:function(){return null},eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
G.extend=function(a){function b(){}function c(){return d.apply(this,arguments)}var d=this;b.prototype=d.prototype;var e=new b;n(e,c.prototype);c.prototype=e;c.prototype.constructor=c;c.Interface=n({},d.Interface,a);c.extend=d.extend;de(c);return c};de(G);function ee(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}
function fe(a){if(!(a instanceof this))throw Error(u(279));a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}function de(a){a.eventPool=[];a.getPooled=ee;a.release=fe}var ge=G.extend({data:null}),he=G.extend({data:null}),ie=[9,13,27,32],je=ya&&"CompositionEvent"in window,ke=null;ya&&"documentMode"in document&&(ke=document.documentMode);
var le=ya&&"TextEvent"in window&&!ke,me=ya&&(!je||ke&&8<ke&&11>=ke),ne=String.fromCharCode(32),oe={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["compositionend","keypress","textInput","paste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"blur compositionend keydown keypress keyup mousedown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
captured:"onCompositionStartCapture"},dependencies:"blur compositionstart keydown keypress keyup mousedown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"blur compositionupdate keydown keypress keyup mousedown".split(" ")}},pe=!1;
function qe(a,b){switch(a){case "keyup":return-1!==ie.indexOf(b.keyCode);case "keydown":return 229!==b.keyCode;case "keypress":case "mousedown":case "blur":return!0;default:return!1}}function re(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var se=!1;function te(a,b){switch(a){case "compositionend":return re(b);case "keypress":if(32!==b.which)return null;pe=!0;return ne;case "textInput":return a=b.data,a===ne&&pe?null:a;default:return null}}
function ue(a,b){if(se)return"compositionend"===a||!je&&qe(a,b)?(a=ae(),$d=Zd=Yd=null,se=!1,a):null;switch(a){case "paste":return null;case "keypress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "compositionend":return me&&"ko"!==b.locale?null:b.data;default:return null}}
var ve={eventTypes:oe,extractEvents:function(a,b,c,d){var e;if(je)b:{switch(a){case "compositionstart":var f=oe.compositionStart;break b;case "compositionend":f=oe.compositionEnd;break b;case "compositionupdate":f=oe.compositionUpdate;break b}f=void 0}else se?qe(a,c)&&(f=oe.compositionEnd):"keydown"===a&&229===c.keyCode&&(f=oe.compositionStart);f?(me&&"ko"!==c.locale&&(se||f!==oe.compositionStart?f===oe.compositionEnd&&se&&(e=ae()):(Yd=d,Zd="value"in Yd?Yd.value:Yd.textContent,se=!0)),f=ge.getPooled(f,
b,c,d),e?f.data=e:(e=re(c),null!==e&&(f.data=e)),Xd(f),e=f):e=null;(a=le?te(a,c):ue(a,c))?(b=he.getPooled(oe.beforeInput,b,c,d),b.data=a,Xd(b)):b=null;return null===e?b:null===b?e:[e,b]}},we={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function xe(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!we[a.type]:"textarea"===b?!0:!1}
var ye={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"blur change click focus input keydown keyup selectionchange".split(" ")}};function ze(a,b,c){a=G.getPooled(ye.change,a,b,c);a.type="change";Da(c);Xd(a);return a}var Ae=null,Be=null;function Ce(a){mc(a)}function De(a){var b=Pd(a);if(yb(b))return a}function Ee(a,b){if("change"===a)return b}var Fe=!1;ya&&(Fe=oc("input")&&(!document.documentMode||9<document.documentMode));
function Ge(){Ae&&(Ae.detachEvent("onpropertychange",He),Be=Ae=null)}function He(a){if("value"===a.propertyName&&De(Be))if(a=ze(Be,a,nc(a)),Ja)mc(a);else{Ja=!0;try{Fa(Ce,a)}finally{Ja=!1,La()}}}function Ie(a,b,c){"focus"===a?(Ge(),Ae=b,Be=c,Ae.attachEvent("onpropertychange",He)):"blur"===a&&Ge()}function Je(a){if("selectionchange"===a||"keyup"===a||"keydown"===a)return De(Be)}function Ke(a,b){if("click"===a)return De(b)}function Le(a,b){if("input"===a||"change"===a)return De(b)}
var Me={eventTypes:ye,_isInputEventSupported:Fe,extractEvents:function(a,b,c,d){var e=b?Pd(b):window,f=e.nodeName&&e.nodeName.toLowerCase();if("select"===f||"input"===f&&"file"===e.type)var g=Ee;else if(xe(e))if(Fe)g=Le;else{g=Je;var h=Ie}else(f=e.nodeName)&&"input"===f.toLowerCase()&&("checkbox"===e.type||"radio"===e.type)&&(g=Ke);if(g&&(g=g(a,b)))return ze(g,c,d);h&&h(a,e,b);"blur"===a&&(a=e._wrapperState)&&a.controlled&&"number"===e.type&&Db(e,"number",e.value)}},Ne=G.extend({view:null,detail:null}),
Oe={Alt:"altKey",Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function Pe(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=Oe[a])?!!b[a]:!1}function Qe(){return Pe}
var Re=0,Se=0,Te=!1,Ue=!1,Ve=Ne.extend({screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:Qe,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)},movementX:function(a){if("movementX"in a)return a.movementX;var b=Re;Re=a.screenX;return Te?"mousemove"===a.type?a.screenX-b:0:(Te=!0,0)},movementY:function(a){if("movementY"in a)return a.movementY;
var b=Se;Se=a.screenY;return Ue?"mousemove"===a.type?a.screenY-b:0:(Ue=!0,0)}}),We=Ve.extend({pointerId:null,width:null,height:null,pressure:null,tangentialPressure:null,tiltX:null,tiltY:null,twist:null,pointerType:null,isPrimary:null}),Xe={mouseEnter:{registrationName:"onMouseEnter",dependencies:["mouseout","mouseover"]},mouseLeave:{registrationName:"onMouseLeave",dependencies:["mouseout","mouseover"]},pointerEnter:{registrationName:"onPointerEnter",dependencies:["pointerout","pointerover"]},pointerLeave:{registrationName:"onPointerLeave",
dependencies:["pointerout","pointerover"]}},Ye={eventTypes:Xe,extractEvents:function(a,b,c,d,e){var f="mouseover"===a||"pointerover"===a,g="mouseout"===a||"pointerout"===a;if(f&&0===(e&32)&&(c.relatedTarget||c.fromElement)||!g&&!f)return null;f=d.window===d?d:(f=d.ownerDocument)?f.defaultView||f.parentWindow:window;if(g){if(g=b,b=(b=c.relatedTarget||c.toElement)?tc(b):null,null!==b){var h=dc(b);if(b!==h||5!==b.tag&&6!==b.tag)b=null}}else g=null;if(g===b)return null;if("mouseout"===a||"mouseover"===
a){var k=Ve;var l=Xe.mouseLeave;var m=Xe.mouseEnter;var p="mouse"}else if("pointerout"===a||"pointerover"===a)k=We,l=Xe.pointerLeave,m=Xe.pointerEnter,p="pointer";a=null==g?f:Pd(g);f=null==b?f:Pd(b);l=k.getPooled(l,g,c,d);l.type=p+"leave";l.target=a;l.relatedTarget=f;c=k.getPooled(m,b,c,d);c.type=p+"enter";c.target=f;c.relatedTarget=a;d=g;p=b;if(d&&p)a:{k=d;m=p;g=0;for(a=k;a;a=Rd(a))g++;a=0;for(b=m;b;b=Rd(b))a++;for(;0<g-a;)k=Rd(k),g--;for(;0<a-g;)m=Rd(m),a--;for(;g--;){if(k===m||k===m.alternate)break a;
k=Rd(k);m=Rd(m)}k=null}else k=null;m=k;for(k=[];d&&d!==m;){g=d.alternate;if(null!==g&&g===m)break;k.push(d);d=Rd(d)}for(d=[];p&&p!==m;){g=p.alternate;if(null!==g&&g===m)break;d.push(p);p=Rd(p)}for(p=0;p<k.length;p++)Vd(k[p],"bubbled",l);for(p=d.length;0<p--;)Vd(d[p],"captured",c);return 0===(e&64)?[l]:[l,c]}};function Ze(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}var $e="function"===typeof Object.is?Object.is:Ze,af=Object.prototype.hasOwnProperty;
function bf(a,b){if($e(a,b))return!0;if("object"!==typeof a||null===a||"object"!==typeof b||null===b)return!1;var c=Object.keys(a),d=Object.keys(b);if(c.length!==d.length)return!1;for(d=0;d<c.length;d++)if(!af.call(b,c[d])||!$e(a[c[d]],b[c[d]]))return!1;return!0}
var cf=ya&&"documentMode"in document&&11>=document.documentMode,df={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:"blur contextmenu dragend focus keydown keyup mousedown mouseup selectionchange".split(" ")}},ef=null,ff=null,gf=null,hf=!1;
function jf(a,b){var c=b.window===b?b.document:9===b.nodeType?b:b.ownerDocument;if(hf||null==ef||ef!==td(c))return null;c=ef;"selectionStart"in c&&yd(c)?c={start:c.selectionStart,end:c.selectionEnd}:(c=(c.ownerDocument&&c.ownerDocument.defaultView||window).getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset});return gf&&bf(gf,c)?null:(gf=c,a=G.getPooled(df.select,ff,a,b),a.type="select",a.target=ef,Xd(a),a)}
var kf={eventTypes:df,extractEvents:function(a,b,c,d,e,f){e=f||(d.window===d?d.document:9===d.nodeType?d:d.ownerDocument);if(!(f=!e)){a:{e=cc(e);f=wa.onSelect;for(var g=0;g<f.length;g++)if(!e.has(f[g])){e=!1;break a}e=!0}f=!e}if(f)return null;e=b?Pd(b):window;switch(a){case "focus":if(xe(e)||"true"===e.contentEditable)ef=e,ff=b,gf=null;break;case "blur":gf=ff=ef=null;break;case "mousedown":hf=!0;break;case "contextmenu":case "mouseup":case "dragend":return hf=!1,jf(c,d);case "selectionchange":if(cf)break;
case "keydown":case "keyup":return jf(c,d)}return null}},lf=G.extend({animationName:null,elapsedTime:null,pseudoElement:null}),mf=G.extend({clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}}),nf=Ne.extend({relatedTarget:null});function of(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;10===a&&(a=13);return 32<=a||13===a?a:0}
var pf={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},qf={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"},rf=Ne.extend({key:function(a){if(a.key){var b=pf[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=of(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?qf[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:Qe,charCode:function(a){return"keypress"===
a.type?of(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===a.type?of(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}}),sf=Ve.extend({dataTransfer:null}),tf=Ne.extend({touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:Qe}),uf=G.extend({propertyName:null,elapsedTime:null,pseudoElement:null}),vf=Ve.extend({deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in
a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null}),wf={eventTypes:Wc,extractEvents:function(a,b,c,d){var e=Yc.get(a);if(!e)return null;switch(a){case "keypress":if(0===of(c))return null;case "keydown":case "keyup":a=rf;break;case "blur":case "focus":a=nf;break;case "click":if(2===c.button)return null;case "auxclick":case "dblclick":case "mousedown":case "mousemove":case "mouseup":case "mouseout":case "mouseover":case "contextmenu":a=
Ve;break;case "drag":case "dragend":case "dragenter":case "dragexit":case "dragleave":case "dragover":case "dragstart":case "drop":a=sf;break;case "touchcancel":case "touchend":case "touchmove":case "touchstart":a=tf;break;case Xb:case Yb:case Zb:a=lf;break;case $b:a=uf;break;case "scroll":a=Ne;break;case "wheel":a=vf;break;case "copy":case "cut":case "paste":a=mf;break;case "gotpointercapture":case "lostpointercapture":case "pointercancel":case "pointerdown":case "pointermove":case "pointerout":case "pointerover":case "pointerup":a=
We;break;default:a=G}b=a.getPooled(e,b,c,d);Xd(b);return b}};if(pa)throw Error(u(101));pa=Array.prototype.slice.call("ResponderEventPlugin SimpleEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));ra();var xf=Nc;la=Qd;ma=xf;na=Pd;xa({SimpleEventPlugin:wf,EnterLeaveEventPlugin:Ye,ChangeEventPlugin:Me,SelectEventPlugin:kf,BeforeInputEventPlugin:ve});var yf=[],zf=-1;function H(a){0>zf||(a.current=yf[zf],yf[zf]=null,zf--)}
function I(a,b){zf++;yf[zf]=a.current;a.current=b}var Af={},J={current:Af},K={current:!1},Bf=Af;function Cf(a,b){var c=a.type.contextTypes;if(!c)return Af;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e);return e}function L(a){a=a.childContextTypes;return null!==a&&void 0!==a}
function Df(){H(K);H(J)}function Ef(a,b,c){if(J.current!==Af)throw Error(u(168));I(J,b);I(K,c)}function Ff(a,b,c){var d=a.stateNode;a=b.childContextTypes;if("function"!==typeof d.getChildContext)return c;d=d.getChildContext();for(var e in d)if(!(e in a))throw Error(u(108,pb(b)||"Unknown",e));return n({},c,{},d)}function Gf(a){a=(a=a.stateNode)&&a.__reactInternalMemoizedMergedChildContext||Af;Bf=J.current;I(J,a);I(K,K.current);return!0}
function Hf(a,b,c){var d=a.stateNode;if(!d)throw Error(u(169));c?(a=Ff(a,b,Bf),d.__reactInternalMemoizedMergedChildContext=a,H(K),H(J),I(J,a)):H(K);I(K,c)}
var If=r.unstable_runWithPriority,Jf=r.unstable_scheduleCallback,Kf=r.unstable_cancelCallback,Lf=r.unstable_requestPaint,Mf=r.unstable_now,Nf=r.unstable_getCurrentPriorityLevel,Of=r.unstable_ImmediatePriority,Pf=r.unstable_UserBlockingPriority,Qf=r.unstable_NormalPriority,Rf=r.unstable_LowPriority,Sf=r.unstable_IdlePriority,Tf={},Uf=r.unstable_shouldYield,Vf=void 0!==Lf?Lf:function(){},Wf=null,Xf=null,Yf=!1,Zf=Mf(),$f=1E4>Zf?Mf:function(){return Mf()-Zf};
function ag(){switch(Nf()){case Of:return 99;case Pf:return 98;case Qf:return 97;case Rf:return 96;case Sf:return 95;default:throw Error(u(332));}}function bg(a){switch(a){case 99:return Of;case 98:return Pf;case 97:return Qf;case 96:return Rf;case 95:return Sf;default:throw Error(u(332));}}function cg(a,b){a=bg(a);return If(a,b)}function dg(a,b,c){a=bg(a);return Jf(a,b,c)}function eg(a){null===Wf?(Wf=[a],Xf=Jf(Of,fg)):Wf.push(a);return Tf}function gg(){if(null!==Xf){var a=Xf;Xf=null;Kf(a)}fg()}
function fg(){if(!Yf&&null!==Wf){Yf=!0;var a=0;try{var b=Wf;cg(99,function(){for(;a<b.length;a++){var c=b[a];do c=c(!0);while(null!==c)}});Wf=null}catch(c){throw null!==Wf&&(Wf=Wf.slice(a+1)),Jf(Of,gg),c;}finally{Yf=!1}}}function hg(a,b,c){c/=10;return 1073741821-(((1073741821-a+b/10)/c|0)+1)*c}function ig(a,b){if(a&&a.defaultProps){b=n({},b);a=a.defaultProps;for(var c in a)void 0===b[c]&&(b[c]=a[c])}return b}var jg={current:null},kg=null,lg=null,mg=null;function ng(){mg=lg=kg=null}
function og(a){var b=jg.current;H(jg);a.type._context._currentValue=b}function pg(a,b){for(;null!==a;){var c=a.alternate;if(a.childExpirationTime<b)a.childExpirationTime=b,null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);else if(null!==c&&c.childExpirationTime<b)c.childExpirationTime=b;else break;a=a.return}}function qg(a,b){kg=a;mg=lg=null;a=a.dependencies;null!==a&&null!==a.firstContext&&(a.expirationTime>=b&&(rg=!0),a.firstContext=null)}
function sg(a,b){if(mg!==a&&!1!==b&&0!==b){if("number"!==typeof b||1073741823===b)mg=a,b=1073741823;b={context:a,observedBits:b,next:null};if(null===lg){if(null===kg)throw Error(u(308));lg=b;kg.dependencies={expirationTime:0,firstContext:b,responders:null}}else lg=lg.next=b}return a._currentValue}var tg=!1;function ug(a){a.updateQueue={baseState:a.memoizedState,baseQueue:null,shared:{pending:null},effects:null}}
function vg(a,b){a=a.updateQueue;b.updateQueue===a&&(b.updateQueue={baseState:a.baseState,baseQueue:a.baseQueue,shared:a.shared,effects:a.effects})}function wg(a,b){a={expirationTime:a,suspenseConfig:b,tag:0,payload:null,callback:null,next:null};return a.next=a}function xg(a,b){a=a.updateQueue;if(null!==a){a=a.shared;var c=a.pending;null===c?b.next=b:(b.next=c.next,c.next=b);a.pending=b}}
function yg(a,b){var c=a.alternate;null!==c&&vg(c,a);a=a.updateQueue;c=a.baseQueue;null===c?(a.baseQueue=b.next=b,b.next=b):(b.next=c.next,c.next=b)}
function zg(a,b,c,d){var e=a.updateQueue;tg=!1;var f=e.baseQueue,g=e.shared.pending;if(null!==g){if(null!==f){var h=f.next;f.next=g.next;g.next=h}f=g;e.shared.pending=null;h=a.alternate;null!==h&&(h=h.updateQueue,null!==h&&(h.baseQueue=g))}if(null!==f){h=f.next;var k=e.baseState,l=0,m=null,p=null,x=null;if(null!==h){var z=h;do{g=z.expirationTime;if(g<d){var ca={expirationTime:z.expirationTime,suspenseConfig:z.suspenseConfig,tag:z.tag,payload:z.payload,callback:z.callback,next:null};null===x?(p=x=
ca,m=k):x=x.next=ca;g>l&&(l=g)}else{null!==x&&(x=x.next={expirationTime:1073741823,suspenseConfig:z.suspenseConfig,tag:z.tag,payload:z.payload,callback:z.callback,next:null});Ag(g,z.suspenseConfig);a:{var D=a,t=z;g=b;ca=c;switch(t.tag){case 1:D=t.payload;if("function"===typeof D){k=D.call(ca,k,g);break a}k=D;break a;case 3:D.effectTag=D.effectTag&-4097|64;case 0:D=t.payload;g="function"===typeof D?D.call(ca,k,g):D;if(null===g||void 0===g)break a;k=n({},k,g);break a;case 2:tg=!0}}null!==z.callback&&
(a.effectTag|=32,g=e.effects,null===g?e.effects=[z]:g.push(z))}z=z.next;if(null===z||z===h)if(g=e.shared.pending,null===g)break;else z=f.next=g.next,g.next=h,e.baseQueue=f=g,e.shared.pending=null}while(1)}null===x?m=k:x.next=p;e.baseState=m;e.baseQueue=x;Bg(l);a.expirationTime=l;a.memoizedState=k}}
function Cg(a,b,c){a=b.effects;b.effects=null;if(null!==a)for(b=0;b<a.length;b++){var d=a[b],e=d.callback;if(null!==e){d.callback=null;d=e;e=c;if("function"!==typeof d)throw Error(u(191,d));d.call(e)}}}var Dg=Wa.ReactCurrentBatchConfig,Eg=(new aa.Component).refs;function Fg(a,b,c,d){b=a.memoizedState;c=c(d,b);c=null===c||void 0===c?b:n({},b,c);a.memoizedState=c;0===a.expirationTime&&(a.updateQueue.baseState=c)}
var Jg={isMounted:function(a){return(a=a._reactInternalFiber)?dc(a)===a:!1},enqueueSetState:function(a,b,c){a=a._reactInternalFiber;var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e=wg(d,e);e.payload=b;void 0!==c&&null!==c&&(e.callback=c);xg(a,e);Ig(a,d)},enqueueReplaceState:function(a,b,c){a=a._reactInternalFiber;var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e=wg(d,e);e.tag=1;e.payload=b;void 0!==c&&null!==c&&(e.callback=c);xg(a,e);Ig(a,d)},enqueueForceUpdate:function(a,b){a=a._reactInternalFiber;var c=Gg(),d=Dg.suspense;
c=Hg(c,a,d);d=wg(c,d);d.tag=2;void 0!==b&&null!==b&&(d.callback=b);xg(a,d);Ig(a,c)}};function Kg(a,b,c,d,e,f,g){a=a.stateNode;return"function"===typeof a.shouldComponentUpdate?a.shouldComponentUpdate(d,f,g):b.prototype&&b.prototype.isPureReactComponent?!bf(c,d)||!bf(e,f):!0}
function Lg(a,b,c){var d=!1,e=Af;var f=b.contextType;"object"===typeof f&&null!==f?f=sg(f):(e=L(b)?Bf:J.current,d=b.contextTypes,f=(d=null!==d&&void 0!==d)?Cf(a,e):Af);b=new b(c,f);a.memoizedState=null!==b.state&&void 0!==b.state?b.state:null;b.updater=Jg;a.stateNode=b;b._reactInternalFiber=a;d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=e,a.__reactInternalMemoizedMaskedChildContext=f);return b}
function Mg(a,b,c,d){a=b.state;"function"===typeof b.componentWillReceiveProps&&b.componentWillReceiveProps(c,d);"function"===typeof b.UNSAFE_componentWillReceiveProps&&b.UNSAFE_componentWillReceiveProps(c,d);b.state!==a&&Jg.enqueueReplaceState(b,b.state,null)}
function Ng(a,b,c,d){var e=a.stateNode;e.props=c;e.state=a.memoizedState;e.refs=Eg;ug(a);var f=b.contextType;"object"===typeof f&&null!==f?e.context=sg(f):(f=L(b)?Bf:J.current,e.context=Cf(a,f));zg(a,c,e,d);e.state=a.memoizedState;f=b.getDerivedStateFromProps;"function"===typeof f&&(Fg(a,b,f,c),e.state=a.memoizedState);"function"===typeof b.getDerivedStateFromProps||"function"===typeof e.getSnapshotBeforeUpdate||"function"!==typeof e.UNSAFE_componentWillMount&&"function"!==typeof e.componentWillMount||
(b=e.state,"function"===typeof e.componentWillMount&&e.componentWillMount(),"function"===typeof e.UNSAFE_componentWillMount&&e.UNSAFE_componentWillMount(),b!==e.state&&Jg.enqueueReplaceState(e,e.state,null),zg(a,c,e,d),e.state=a.memoizedState);"function"===typeof e.componentDidMount&&(a.effectTag|=4)}var Og=Array.isArray;
function Pg(a,b,c){a=c.ref;if(null!==a&&"function"!==typeof a&&"object"!==typeof a){if(c._owner){c=c._owner;if(c){if(1!==c.tag)throw Error(u(309));var d=c.stateNode}if(!d)throw Error(u(147,a));var e=""+a;if(null!==b&&null!==b.ref&&"function"===typeof b.ref&&b.ref._stringRef===e)return b.ref;b=function(a){var b=d.refs;b===Eg&&(b=d.refs={});null===a?delete b[e]:b[e]=a};b._stringRef=e;return b}if("string"!==typeof a)throw Error(u(284));if(!c._owner)throw Error(u(290,a));}return a}
function Qg(a,b){if("textarea"!==a.type)throw Error(u(31,"[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,""));}
function Rg(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.effectTag=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b){a=Sg(a,b);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.effectTag=
2,c):d;b.effectTag=2;return c}function g(b){a&&null===b.alternate&&(b.effectTag=2);return b}function h(a,b,c,d){if(null===b||6!==b.tag)return b=Tg(c,a.mode,d),b.return=a,b;b=e(b,c);b.return=a;return b}function k(a,b,c,d){if(null!==b&&b.elementType===c.type)return d=e(b,c.props),d.ref=Pg(a,b,c),d.return=a,d;d=Ug(c.type,c.key,c.props,null,a.mode,d);d.ref=Pg(a,b,c);d.return=a;return d}function l(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==
c.implementation)return b=Vg(c,a.mode,d),b.return=a,b;b=e(b,c.children||[]);b.return=a;return b}function m(a,b,c,d,f){if(null===b||7!==b.tag)return b=Wg(c,a.mode,d,f),b.return=a,b;b=e(b,c);b.return=a;return b}function p(a,b,c){if("string"===typeof b||"number"===typeof b)return b=Tg(""+b,a.mode,c),b.return=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case Za:return c=Ug(b.type,b.key,b.props,null,a.mode,c),c.ref=Pg(a,null,b),c.return=a,c;case $a:return b=Vg(b,a.mode,c),b.return=a,b}if(Og(b)||
nb(b))return b=Wg(b,a.mode,c,null),b.return=a,b;Qg(a,b)}return null}function x(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:h(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case Za:return c.key===e?c.type===ab?m(a,b,c.props.children,d,e):k(a,b,c,d):null;case $a:return c.key===e?l(a,b,c,d):null}if(Og(c)||nb(c))return null!==e?null:m(a,b,c,d,null);Qg(a,c)}return null}function z(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=
a.get(c)||null,h(b,a,""+d,e);if("object"===typeof d&&null!==d){switch(d.$$typeof){case Za:return a=a.get(null===d.key?c:d.key)||null,d.type===ab?m(b,a,d.props.children,e,d.key):k(b,a,d,e);case $a:return a=a.get(null===d.key?c:d.key)||null,l(b,a,d,e)}if(Og(d)||nb(d))return a=a.get(c)||null,m(b,a,d,e,null);Qg(b,d)}return null}function ca(e,g,h,k){for(var l=null,t=null,m=g,y=g=0,A=null;null!==m&&y<h.length;y++){m.index>y?(A=m,m=null):A=m.sibling;var q=x(e,m,h[y],k);if(null===q){null===m&&(m=A);break}a&&
m&&null===q.alternate&&b(e,m);g=f(q,g,y);null===t?l=q:t.sibling=q;t=q;m=A}if(y===h.length)return c(e,m),l;if(null===m){for(;y<h.length;y++)m=p(e,h[y],k),null!==m&&(g=f(m,g,y),null===t?l=m:t.sibling=m,t=m);return l}for(m=d(e,m);y<h.length;y++)A=z(m,e,y,h[y],k),null!==A&&(a&&null!==A.alternate&&m.delete(null===A.key?y:A.key),g=f(A,g,y),null===t?l=A:t.sibling=A,t=A);a&&m.forEach(function(a){return b(e,a)});return l}function D(e,g,h,l){var k=nb(h);if("function"!==typeof k)throw Error(u(150));h=k.call(h);
if(null==h)throw Error(u(151));for(var m=k=null,t=g,y=g=0,A=null,q=h.next();null!==t&&!q.done;y++,q=h.next()){t.index>y?(A=t,t=null):A=t.sibling;var D=x(e,t,q.value,l);if(null===D){null===t&&(t=A);break}a&&t&&null===D.alternate&&b(e,t);g=f(D,g,y);null===m?k=D:m.sibling=D;m=D;t=A}if(q.done)return c(e,t),k;if(null===t){for(;!q.done;y++,q=h.next())q=p(e,q.value,l),null!==q&&(g=f(q,g,y),null===m?k=q:m.sibling=q,m=q);return k}for(t=d(e,t);!q.done;y++,q=h.next())q=z(t,e,y,q.value,l),null!==q&&(a&&null!==
q.alternate&&t.delete(null===q.key?y:q.key),g=f(q,g,y),null===m?k=q:m.sibling=q,m=q);a&&t.forEach(function(a){return b(e,a)});return k}return function(a,d,f,h){var k="object"===typeof f&&null!==f&&f.type===ab&&null===f.key;k&&(f=f.props.children);var l="object"===typeof f&&null!==f;if(l)switch(f.$$typeof){case Za:a:{l=f.key;for(k=d;null!==k;){if(k.key===l){switch(k.tag){case 7:if(f.type===ab){c(a,k.sibling);d=e(k,f.props.children);d.return=a;a=d;break a}break;default:if(k.elementType===f.type){c(a,
k.sibling);d=e(k,f.props);d.ref=Pg(a,k,f);d.return=a;a=d;break a}}c(a,k);break}else b(a,k);k=k.sibling}f.type===ab?(d=Wg(f.props.children,a.mode,h,f.key),d.return=a,a=d):(h=Ug(f.type,f.key,f.props,null,a.mode,h),h.ref=Pg(a,d,f),h.return=a,a=h)}return g(a);case $a:a:{for(k=f.key;null!==d;){if(d.key===k)if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===f.implementation){c(a,d.sibling);d=e(d,f.children||[]);d.return=a;a=d;break a}else{c(a,d);break}else b(a,d);d=
d.sibling}d=Vg(f,a.mode,h);d.return=a;a=d}return g(a)}if("string"===typeof f||"number"===typeof f)return f=""+f,null!==d&&6===d.tag?(c(a,d.sibling),d=e(d,f),d.return=a,a=d):(c(a,d),d=Tg(f,a.mode,h),d.return=a,a=d),g(a);if(Og(f))return ca(a,d,f,h);if(nb(f))return D(a,d,f,h);l&&Qg(a,f);if("undefined"===typeof f&&!k)switch(a.tag){case 1:case 0:throw a=a.type,Error(u(152,a.displayName||a.name||"Component"));}return c(a,d)}}var Xg=Rg(!0),Yg=Rg(!1),Zg={},$g={current:Zg},ah={current:Zg},bh={current:Zg};
function ch(a){if(a===Zg)throw Error(u(174));return a}function dh(a,b){I(bh,b);I(ah,a);I($g,Zg);a=b.nodeType;switch(a){case 9:case 11:b=(b=b.documentElement)?b.namespaceURI:Ob(null,"");break;default:a=8===a?b.parentNode:b,b=a.namespaceURI||null,a=a.tagName,b=Ob(b,a)}H($g);I($g,b)}function eh(){H($g);H(ah);H(bh)}function fh(a){ch(bh.current);var b=ch($g.current);var c=Ob(b,a.type);b!==c&&(I(ah,a),I($g,c))}function gh(a){ah.current===a&&(H($g),H(ah))}var M={current:0};
function hh(a){for(var b=a;null!==b;){if(13===b.tag){var c=b.memoizedState;if(null!==c&&(c=c.dehydrated,null===c||c.data===Bd||c.data===Cd))return b}else if(19===b.tag&&void 0!==b.memoizedProps.revealOrder){if(0!==(b.effectTag&64))return b}else if(null!==b.child){b.child.return=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}return null}function ih(a,b){return{responder:a,props:b}}
var jh=Wa.ReactCurrentDispatcher,kh=Wa.ReactCurrentBatchConfig,lh=0,N=null,O=null,P=null,mh=!1;function Q(){throw Error(u(321));}function nh(a,b){if(null===b)return!1;for(var c=0;c<b.length&&c<a.length;c++)if(!$e(a[c],b[c]))return!1;return!0}
function oh(a,b,c,d,e,f){lh=f;N=b;b.memoizedState=null;b.updateQueue=null;b.expirationTime=0;jh.current=null===a||null===a.memoizedState?ph:qh;a=c(d,e);if(b.expirationTime===lh){f=0;do{b.expirationTime=0;if(!(25>f))throw Error(u(301));f+=1;P=O=null;b.updateQueue=null;jh.current=rh;a=c(d,e)}while(b.expirationTime===lh)}jh.current=sh;b=null!==O&&null!==O.next;lh=0;P=O=N=null;mh=!1;if(b)throw Error(u(300));return a}
function th(){var a={memoizedState:null,baseState:null,baseQueue:null,queue:null,next:null};null===P?N.memoizedState=P=a:P=P.next=a;return P}function uh(){if(null===O){var a=N.alternate;a=null!==a?a.memoizedState:null}else a=O.next;var b=null===P?N.memoizedState:P.next;if(null!==b)P=b,O=a;else{if(null===a)throw Error(u(310));O=a;a={memoizedState:O.memoizedState,baseState:O.baseState,baseQueue:O.baseQueue,queue:O.queue,next:null};null===P?N.memoizedState=P=a:P=P.next=a}return P}
function vh(a,b){return"function"===typeof b?b(a):b}
function wh(a){var b=uh(),c=b.queue;if(null===c)throw Error(u(311));c.lastRenderedReducer=a;var d=O,e=d.baseQueue,f=c.pending;if(null!==f){if(null!==e){var g=e.next;e.next=f.next;f.next=g}d.baseQueue=e=f;c.pending=null}if(null!==e){e=e.next;d=d.baseState;var h=g=f=null,k=e;do{var l=k.expirationTime;if(l<lh){var m={expirationTime:k.expirationTime,suspenseConfig:k.suspenseConfig,action:k.action,eagerReducer:k.eagerReducer,eagerState:k.eagerState,next:null};null===h?(g=h=m,f=d):h=h.next=m;l>N.expirationTime&&
(N.expirationTime=l,Bg(l))}else null!==h&&(h=h.next={expirationTime:1073741823,suspenseConfig:k.suspenseConfig,action:k.action,eagerReducer:k.eagerReducer,eagerState:k.eagerState,next:null}),Ag(l,k.suspenseConfig),d=k.eagerReducer===a?k.eagerState:a(d,k.action);k=k.next}while(null!==k&&k!==e);null===h?f=d:h.next=g;$e(d,b.memoizedState)||(rg=!0);b.memoizedState=d;b.baseState=f;b.baseQueue=h;c.lastRenderedState=d}return[b.memoizedState,c.dispatch]}
function xh(a){var b=uh(),c=b.queue;if(null===c)throw Error(u(311));c.lastRenderedReducer=a;var d=c.dispatch,e=c.pending,f=b.memoizedState;if(null!==e){c.pending=null;var g=e=e.next;do f=a(f,g.action),g=g.next;while(g!==e);$e(f,b.memoizedState)||(rg=!0);b.memoizedState=f;null===b.baseQueue&&(b.baseState=f);c.lastRenderedState=f}return[f,d]}
function yh(a){var b=th();"function"===typeof a&&(a=a());b.memoizedState=b.baseState=a;a=b.queue={pending:null,dispatch:null,lastRenderedReducer:vh,lastRenderedState:a};a=a.dispatch=zh.bind(null,N,a);return[b.memoizedState,a]}function Ah(a,b,c,d){a={tag:a,create:b,destroy:c,deps:d,next:null};b=N.updateQueue;null===b?(b={lastEffect:null},N.updateQueue=b,b.lastEffect=a.next=a):(c=b.lastEffect,null===c?b.lastEffect=a.next=a:(d=c.next,c.next=a,a.next=d,b.lastEffect=a));return a}
function Bh(){return uh().memoizedState}function Ch(a,b,c,d){var e=th();N.effectTag|=a;e.memoizedState=Ah(1|b,c,void 0,void 0===d?null:d)}function Dh(a,b,c,d){var e=uh();d=void 0===d?null:d;var f=void 0;if(null!==O){var g=O.memoizedState;f=g.destroy;if(null!==d&&nh(d,g.deps)){Ah(b,c,f,d);return}}N.effectTag|=a;e.memoizedState=Ah(1|b,c,f,d)}function Eh(a,b){return Ch(516,4,a,b)}function Fh(a,b){return Dh(516,4,a,b)}function Gh(a,b){return Dh(4,2,a,b)}
function Hh(a,b){if("function"===typeof b)return a=a(),b(a),function(){b(null)};if(null!==b&&void 0!==b)return a=a(),b.current=a,function(){b.current=null}}function Ih(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Dh(4,2,Hh.bind(null,b,a),c)}function Jh(){}function Kh(a,b){th().memoizedState=[a,void 0===b?null:b];return a}function Lh(a,b){var c=uh();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&nh(b,d[1]))return d[0];c.memoizedState=[a,b];return a}
function Mh(a,b){var c=uh();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&nh(b,d[1]))return d[0];a=a();c.memoizedState=[a,b];return a}function Nh(a,b,c){var d=ag();cg(98>d?98:d,function(){a(!0)});cg(97<d?97:d,function(){var d=kh.suspense;kh.suspense=void 0===b?null:b;try{a(!1),c()}finally{kh.suspense=d}})}
function zh(a,b,c){var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e={expirationTime:d,suspenseConfig:e,action:c,eagerReducer:null,eagerState:null,next:null};var f=b.pending;null===f?e.next=e:(e.next=f.next,f.next=e);b.pending=e;f=a.alternate;if(a===N||null!==f&&f===N)mh=!0,e.expirationTime=lh,N.expirationTime=lh;else{if(0===a.expirationTime&&(null===f||0===f.expirationTime)&&(f=b.lastRenderedReducer,null!==f))try{var g=b.lastRenderedState,h=f(g,c);e.eagerReducer=f;e.eagerState=h;if($e(h,g))return}catch(k){}finally{}Ig(a,
d)}}
var sh={readContext:sg,useCallback:Q,useContext:Q,useEffect:Q,useImperativeHandle:Q,useLayoutEffect:Q,useMemo:Q,useReducer:Q,useRef:Q,useState:Q,useDebugValue:Q,useResponder:Q,useDeferredValue:Q,useTransition:Q},ph={readContext:sg,useCallback:Kh,useContext:sg,useEffect:Eh,useImperativeHandle:function(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Ch(4,2,Hh.bind(null,b,a),c)},useLayoutEffect:function(a,b){return Ch(4,2,a,b)},useMemo:function(a,b){var c=th();b=void 0===b?null:b;a=a();c.memoizedState=[a,
b];return a},useReducer:function(a,b,c){var d=th();b=void 0!==c?c(b):b;d.memoizedState=d.baseState=b;a=d.queue={pending:null,dispatch:null,lastRenderedReducer:a,lastRenderedState:b};a=a.dispatch=zh.bind(null,N,a);return[d.memoizedState,a]},useRef:function(a){var b=th();a={current:a};return b.memoizedState=a},useState:yh,useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=yh(a),d=c[0],e=c[1];Eh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=
c}},[a,b]);return d},useTransition:function(a){var b=yh(!1),c=b[0];b=b[1];return[Kh(Nh.bind(null,b,a),[b,a]),c]}},qh={readContext:sg,useCallback:Lh,useContext:sg,useEffect:Fh,useImperativeHandle:Ih,useLayoutEffect:Gh,useMemo:Mh,useReducer:wh,useRef:Bh,useState:function(){return wh(vh)},useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=wh(vh),d=c[0],e=c[1];Fh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=c}},[a,b]);return d},useTransition:function(a){var b=
wh(vh),c=b[0];b=b[1];return[Lh(Nh.bind(null,b,a),[b,a]),c]}},rh={readContext:sg,useCallback:Lh,useContext:sg,useEffect:Fh,useImperativeHandle:Ih,useLayoutEffect:Gh,useMemo:Mh,useReducer:xh,useRef:Bh,useState:function(){return xh(vh)},useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=xh(vh),d=c[0],e=c[1];Fh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=c}},[a,b]);return d},useTransition:function(a){var b=xh(vh),c=b[0];b=b[1];return[Lh(Nh.bind(null,
b,a),[b,a]),c]}},Oh=null,Ph=null,Qh=!1;function Rh(a,b){var c=Sh(5,null,null,0);c.elementType="DELETED";c.type="DELETED";c.stateNode=b;c.return=a;c.effectTag=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}
function Th(a,b){switch(a.tag){case 5:var c=a.type;b=1!==b.nodeType||c.toLowerCase()!==b.nodeName.toLowerCase()?null:b;return null!==b?(a.stateNode=b,!0):!1;case 6:return b=""===a.pendingProps||3!==b.nodeType?null:b,null!==b?(a.stateNode=b,!0):!1;case 13:return!1;default:return!1}}
function Uh(a){if(Qh){var b=Ph;if(b){var c=b;if(!Th(a,b)){b=Jd(c.nextSibling);if(!b||!Th(a,b)){a.effectTag=a.effectTag&-1025|2;Qh=!1;Oh=a;return}Rh(Oh,c)}Oh=a;Ph=Jd(b.firstChild)}else a.effectTag=a.effectTag&-1025|2,Qh=!1,Oh=a}}function Vh(a){for(a=a.return;null!==a&&5!==a.tag&&3!==a.tag&&13!==a.tag;)a=a.return;Oh=a}
function Wh(a){if(a!==Oh)return!1;if(!Qh)return Vh(a),Qh=!0,!1;var b=a.type;if(5!==a.tag||"head"!==b&&"body"!==b&&!Gd(b,a.memoizedProps))for(b=Ph;b;)Rh(a,b),b=Jd(b.nextSibling);Vh(a);if(13===a.tag){a=a.memoizedState;a=null!==a?a.dehydrated:null;if(!a)throw Error(u(317));a:{a=a.nextSibling;for(b=0;a;){if(8===a.nodeType){var c=a.data;if(c===Ad){if(0===b){Ph=Jd(a.nextSibling);break a}b--}else c!==zd&&c!==Cd&&c!==Bd||b++}a=a.nextSibling}Ph=null}}else Ph=Oh?Jd(a.stateNode.nextSibling):null;return!0}
function Xh(){Ph=Oh=null;Qh=!1}var Yh=Wa.ReactCurrentOwner,rg=!1;function R(a,b,c,d){b.child=null===a?Yg(b,null,c,d):Xg(b,a.child,c,d)}function Zh(a,b,c,d,e){c=c.render;var f=b.ref;qg(b,e);d=oh(a,b,c,d,f,e);if(null!==a&&!rg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),$h(a,b,e);b.effectTag|=1;R(a,b,d,e);return b.child}
function ai(a,b,c,d,e,f){if(null===a){var g=c.type;if("function"===typeof g&&!bi(g)&&void 0===g.defaultProps&&null===c.compare&&void 0===c.defaultProps)return b.tag=15,b.type=g,ci(a,b,g,d,e,f);a=Ug(c.type,null,d,null,b.mode,f);a.ref=b.ref;a.return=b;return b.child=a}g=a.child;if(e<f&&(e=g.memoizedProps,c=c.compare,c=null!==c?c:bf,c(e,d)&&a.ref===b.ref))return $h(a,b,f);b.effectTag|=1;a=Sg(g,d);a.ref=b.ref;a.return=b;return b.child=a}
function ci(a,b,c,d,e,f){return null!==a&&bf(a.memoizedProps,d)&&a.ref===b.ref&&(rg=!1,e<f)?(b.expirationTime=a.expirationTime,$h(a,b,f)):di(a,b,c,d,f)}function ei(a,b){var c=b.ref;if(null===a&&null!==c||null!==a&&a.ref!==c)b.effectTag|=128}function di(a,b,c,d,e){var f=L(c)?Bf:J.current;f=Cf(b,f);qg(b,e);c=oh(a,b,c,d,f,e);if(null!==a&&!rg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),$h(a,b,e);b.effectTag|=1;R(a,b,c,e);return b.child}
function fi(a,b,c,d,e){if(L(c)){var f=!0;Gf(b)}else f=!1;qg(b,e);if(null===b.stateNode)null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),Lg(b,c,d),Ng(b,c,d,e),d=!0;else if(null===a){var g=b.stateNode,h=b.memoizedProps;g.props=h;var k=g.context,l=c.contextType;"object"===typeof l&&null!==l?l=sg(l):(l=L(c)?Bf:J.current,l=Cf(b,l));var m=c.getDerivedStateFromProps,p="function"===typeof m||"function"===typeof g.getSnapshotBeforeUpdate;p||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&
"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Mg(b,g,d,l);tg=!1;var x=b.memoizedState;g.state=x;zg(b,d,g,e);k=b.memoizedState;h!==d||x!==k||K.current||tg?("function"===typeof m&&(Fg(b,c,m,d),k=b.memoizedState),(h=tg||Kg(b,c,h,d,x,k,l))?(p||"function"!==typeof g.UNSAFE_componentWillMount&&"function"!==typeof g.componentWillMount||("function"===typeof g.componentWillMount&&g.componentWillMount(),"function"===typeof g.UNSAFE_componentWillMount&&g.UNSAFE_componentWillMount()),"function"===
typeof g.componentDidMount&&(b.effectTag|=4)):("function"===typeof g.componentDidMount&&(b.effectTag|=4),b.memoizedProps=d,b.memoizedState=k),g.props=d,g.state=k,g.context=l,d=h):("function"===typeof g.componentDidMount&&(b.effectTag|=4),d=!1)}else g=b.stateNode,vg(a,b),h=b.memoizedProps,g.props=b.type===b.elementType?h:ig(b.type,h),k=g.context,l=c.contextType,"object"===typeof l&&null!==l?l=sg(l):(l=L(c)?Bf:J.current,l=Cf(b,l)),m=c.getDerivedStateFromProps,(p="function"===typeof m||"function"===
typeof g.getSnapshotBeforeUpdate)||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Mg(b,g,d,l),tg=!1,k=b.memoizedState,g.state=k,zg(b,d,g,e),x=b.memoizedState,h!==d||k!==x||K.current||tg?("function"===typeof m&&(Fg(b,c,m,d),x=b.memoizedState),(m=tg||Kg(b,c,h,d,k,x,l))?(p||"function"!==typeof g.UNSAFE_componentWillUpdate&&"function"!==typeof g.componentWillUpdate||("function"===typeof g.componentWillUpdate&&g.componentWillUpdate(d,
x,l),"function"===typeof g.UNSAFE_componentWillUpdate&&g.UNSAFE_componentWillUpdate(d,x,l)),"function"===typeof g.componentDidUpdate&&(b.effectTag|=4),"function"===typeof g.getSnapshotBeforeUpdate&&(b.effectTag|=256)):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),b.memoizedProps=d,b.memoizedState=x),g.props=d,g.state=x,g.context=l,d=m):
("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),d=!1);return gi(a,b,c,d,f,e)}
function gi(a,b,c,d,e,f){ei(a,b);var g=0!==(b.effectTag&64);if(!d&&!g)return e&&Hf(b,c,!1),$h(a,b,f);d=b.stateNode;Yh.current=b;var h=g&&"function"!==typeof c.getDerivedStateFromError?null:d.render();b.effectTag|=1;null!==a&&g?(b.child=Xg(b,a.child,null,f),b.child=Xg(b,null,h,f)):R(a,b,h,f);b.memoizedState=d.state;e&&Hf(b,c,!0);return b.child}function hi(a){var b=a.stateNode;b.pendingContext?Ef(a,b.pendingContext,b.pendingContext!==b.context):b.context&&Ef(a,b.context,!1);dh(a,b.containerInfo)}
var ii={dehydrated:null,retryTime:0};
function ji(a,b,c){var d=b.mode,e=b.pendingProps,f=M.current,g=!1,h;(h=0!==(b.effectTag&64))||(h=0!==(f&2)&&(null===a||null!==a.memoizedState));h?(g=!0,b.effectTag&=-65):null!==a&&null===a.memoizedState||void 0===e.fallback||!0===e.unstable_avoidThisFallback||(f|=1);I(M,f&1);if(null===a){void 0!==e.fallback&&Uh(b);if(g){g=e.fallback;e=Wg(null,d,0,null);e.return=b;if(0===(b.mode&2))for(a=null!==b.memoizedState?b.child.child:b.child,e.child=a;null!==a;)a.return=e,a=a.sibling;c=Wg(g,d,c,null);c.return=
b;e.sibling=c;b.memoizedState=ii;b.child=e;return c}d=e.children;b.memoizedState=null;return b.child=Yg(b,null,d,c)}if(null!==a.memoizedState){a=a.child;d=a.sibling;if(g){e=e.fallback;c=Sg(a,a.pendingProps);c.return=b;if(0===(b.mode&2)&&(g=null!==b.memoizedState?b.child.child:b.child,g!==a.child))for(c.child=g;null!==g;)g.return=c,g=g.sibling;d=Sg(d,e);d.return=b;c.sibling=d;c.childExpirationTime=0;b.memoizedState=ii;b.child=c;return d}c=Xg(b,a.child,e.children,c);b.memoizedState=null;return b.child=
c}a=a.child;if(g){g=e.fallback;e=Wg(null,d,0,null);e.return=b;e.child=a;null!==a&&(a.return=e);if(0===(b.mode&2))for(a=null!==b.memoizedState?b.child.child:b.child,e.child=a;null!==a;)a.return=e,a=a.sibling;c=Wg(g,d,c,null);c.return=b;e.sibling=c;c.effectTag|=2;e.childExpirationTime=0;b.memoizedState=ii;b.child=e;return c}b.memoizedState=null;return b.child=Xg(b,a,e.children,c)}
function ki(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);pg(a.return,b)}function li(a,b,c,d,e,f){var g=a.memoizedState;null===g?a.memoizedState={isBackwards:b,rendering:null,renderingStartTime:0,last:d,tail:c,tailExpiration:0,tailMode:e,lastEffect:f}:(g.isBackwards=b,g.rendering=null,g.renderingStartTime=0,g.last=d,g.tail=c,g.tailExpiration=0,g.tailMode=e,g.lastEffect=f)}
function mi(a,b,c){var d=b.pendingProps,e=d.revealOrder,f=d.tail;R(a,b,d.children,c);d=M.current;if(0!==(d&2))d=d&1|2,b.effectTag|=64;else{if(null!==a&&0!==(a.effectTag&64))a:for(a=b.child;null!==a;){if(13===a.tag)null!==a.memoizedState&&ki(a,c);else if(19===a.tag)ki(a,c);else if(null!==a.child){a.child.return=a;a=a.child;continue}if(a===b)break a;for(;null===a.sibling;){if(null===a.return||a.return===b)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}d&=1}I(M,d);if(0===(b.mode&2))b.memoizedState=
null;else switch(e){case "forwards":c=b.child;for(e=null;null!==c;)a=c.alternate,null!==a&&null===hh(a)&&(e=c),c=c.sibling;c=e;null===c?(e=b.child,b.child=null):(e=c.sibling,c.sibling=null);li(b,!1,e,c,f,b.lastEffect);break;case "backwards":c=null;e=b.child;for(b.child=null;null!==e;){a=e.alternate;if(null!==a&&null===hh(a)){b.child=e;break}a=e.sibling;e.sibling=c;c=e;e=a}li(b,!0,c,null,f,b.lastEffect);break;case "together":li(b,!1,null,null,void 0,b.lastEffect);break;default:b.memoizedState=null}return b.child}
function $h(a,b,c){null!==a&&(b.dependencies=a.dependencies);var d=b.expirationTime;0!==d&&Bg(d);if(b.childExpirationTime<c)return null;if(null!==a&&b.child!==a.child)throw Error(u(153));if(null!==b.child){a=b.child;c=Sg(a,a.pendingProps);b.child=c;for(c.return=b;null!==a.sibling;)a=a.sibling,c=c.sibling=Sg(a,a.pendingProps),c.return=b;c.sibling=null}return b.child}var ni,oi,pi,qi;
ni=function(a,b){for(var c=b.child;null!==c;){if(5===c.tag||6===c.tag)a.appendChild(c.stateNode);else if(4!==c.tag&&null!==c.child){c.child.return=c;c=c.child;continue}if(c===b)break;for(;null===c.sibling;){if(null===c.return||c.return===b)return;c=c.return}c.sibling.return=c.return;c=c.sibling}};oi=function(){};
pi=function(a,b,c,d,e){var f=a.memoizedProps;if(f!==d){var g=b.stateNode;ch($g.current);a=null;switch(c){case "input":f=zb(g,f);d=zb(g,d);a=[];break;case "option":f=Gb(g,f);d=Gb(g,d);a=[];break;case "select":f=n({},f,{value:void 0});d=n({},d,{value:void 0});a=[];break;case "textarea":f=Ib(g,f);d=Ib(g,d);a=[];break;default:"function"!==typeof f.onClick&&"function"===typeof d.onClick&&(g.onclick=sd)}od(c,d);var h,k;c=null;for(h in f)if(!d.hasOwnProperty(h)&&f.hasOwnProperty(h)&&null!=f[h])if("style"===
h)for(k in g=f[h],g)g.hasOwnProperty(k)&&(c||(c={}),c[k]="");else"dangerouslySetInnerHTML"!==h&&"children"!==h&&"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&"autoFocus"!==h&&(va.hasOwnProperty(h)?a||(a=[]):(a=a||[]).push(h,null));for(h in d){var l=d[h];g=null!=f?f[h]:void 0;if(d.hasOwnProperty(h)&&l!==g&&(null!=l||null!=g))if("style"===h)if(g){for(k in g)!g.hasOwnProperty(k)||l&&l.hasOwnProperty(k)||(c||(c={}),c[k]="");for(k in l)l.hasOwnProperty(k)&&g[k]!==l[k]&&(c||(c={}),
c[k]=l[k])}else c||(a||(a=[]),a.push(h,c)),c=l;else"dangerouslySetInnerHTML"===h?(l=l?l.__html:void 0,g=g?g.__html:void 0,null!=l&&g!==l&&(a=a||[]).push(h,l)):"children"===h?g===l||"string"!==typeof l&&"number"!==typeof l||(a=a||[]).push(h,""+l):"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&(va.hasOwnProperty(h)?(null!=l&&rd(e,h),a||g===l||(a=[])):(a=a||[]).push(h,l))}c&&(a=a||[]).push("style",c);e=a;if(b.updateQueue=e)b.effectTag|=4}};
qi=function(a,b,c,d){c!==d&&(b.effectTag|=4)};function ri(a,b){switch(a.tailMode){case "hidden":b=a.tail;for(var c=null;null!==b;)null!==b.alternate&&(c=b),b=b.sibling;null===c?a.tail=null:c.sibling=null;break;case "collapsed":c=a.tail;for(var d=null;null!==c;)null!==c.alternate&&(d=c),c=c.sibling;null===d?b||null===a.tail?a.tail=null:a.tail.sibling=null:d.sibling=null}}
function si(a,b,c){var d=b.pendingProps;switch(b.tag){case 2:case 16:case 15:case 0:case 11:case 7:case 8:case 12:case 9:case 14:return null;case 1:return L(b.type)&&Df(),null;case 3:return eh(),H(K),H(J),c=b.stateNode,c.pendingContext&&(c.context=c.pendingContext,c.pendingContext=null),null!==a&&null!==a.child||!Wh(b)||(b.effectTag|=4),oi(b),null;case 5:gh(b);c=ch(bh.current);var e=b.type;if(null!==a&&null!=b.stateNode)pi(a,b,e,d,c),a.ref!==b.ref&&(b.effectTag|=128);else{if(!d){if(null===b.stateNode)throw Error(u(166));
return null}a=ch($g.current);if(Wh(b)){d=b.stateNode;e=b.type;var f=b.memoizedProps;d[Md]=b;d[Nd]=f;switch(e){case "iframe":case "object":case "embed":F("load",d);break;case "video":case "audio":for(a=0;a<ac.length;a++)F(ac[a],d);break;case "source":F("error",d);break;case "img":case "image":case "link":F("error",d);F("load",d);break;case "form":F("reset",d);F("submit",d);break;case "details":F("toggle",d);break;case "input":Ab(d,f);F("invalid",d);rd(c,"onChange");break;case "select":d._wrapperState=
{wasMultiple:!!f.multiple};F("invalid",d);rd(c,"onChange");break;case "textarea":Jb(d,f),F("invalid",d),rd(c,"onChange")}od(e,f);a=null;for(var g in f)if(f.hasOwnProperty(g)){var h=f[g];"children"===g?"string"===typeof h?d.textContent!==h&&(a=["children",h]):"number"===typeof h&&d.textContent!==""+h&&(a=["children",""+h]):va.hasOwnProperty(g)&&null!=h&&rd(c,g)}switch(e){case "input":xb(d);Eb(d,f,!0);break;case "textarea":xb(d);Lb(d);break;case "select":case "option":break;default:"function"===typeof f.onClick&&
(d.onclick=sd)}c=a;b.updateQueue=c;null!==c&&(b.effectTag|=4)}else{g=9===c.nodeType?c:c.ownerDocument;a===qd&&(a=Nb(e));a===qd?"script"===e?(a=g.createElement("div"),a.innerHTML="<script>\x3c/script>",a=a.removeChild(a.firstChild)):"string"===typeof d.is?a=g.createElement(e,{is:d.is}):(a=g.createElement(e),"select"===e&&(g=a,d.multiple?g.multiple=!0:d.size&&(g.size=d.size))):a=g.createElementNS(a,e);a[Md]=b;a[Nd]=d;ni(a,b,!1,!1);b.stateNode=a;g=pd(e,d);switch(e){case "iframe":case "object":case "embed":F("load",
a);h=d;break;case "video":case "audio":for(h=0;h<ac.length;h++)F(ac[h],a);h=d;break;case "source":F("error",a);h=d;break;case "img":case "image":case "link":F("error",a);F("load",a);h=d;break;case "form":F("reset",a);F("submit",a);h=d;break;case "details":F("toggle",a);h=d;break;case "input":Ab(a,d);h=zb(a,d);F("invalid",a);rd(c,"onChange");break;case "option":h=Gb(a,d);break;case "select":a._wrapperState={wasMultiple:!!d.multiple};h=n({},d,{value:void 0});F("invalid",a);rd(c,"onChange");break;case "textarea":Jb(a,
d);h=Ib(a,d);F("invalid",a);rd(c,"onChange");break;default:h=d}od(e,h);var k=h;for(f in k)if(k.hasOwnProperty(f)){var l=k[f];"style"===f?md(a,l):"dangerouslySetInnerHTML"===f?(l=l?l.__html:void 0,null!=l&&Qb(a,l)):"children"===f?"string"===typeof l?("textarea"!==e||""!==l)&&Rb(a,l):"number"===typeof l&&Rb(a,""+l):"suppressContentEditableWarning"!==f&&"suppressHydrationWarning"!==f&&"autoFocus"!==f&&(va.hasOwnProperty(f)?null!=l&&rd(c,f):null!=l&&Xa(a,f,l,g))}switch(e){case "input":xb(a);Eb(a,d,!1);
break;case "textarea":xb(a);Lb(a);break;case "option":null!=d.value&&a.setAttribute("value",""+rb(d.value));break;case "select":a.multiple=!!d.multiple;c=d.value;null!=c?Hb(a,!!d.multiple,c,!1):null!=d.defaultValue&&Hb(a,!!d.multiple,d.defaultValue,!0);break;default:"function"===typeof h.onClick&&(a.onclick=sd)}Fd(e,d)&&(b.effectTag|=4)}null!==b.ref&&(b.effectTag|=128)}return null;case 6:if(a&&null!=b.stateNode)qi(a,b,a.memoizedProps,d);else{if("string"!==typeof d&&null===b.stateNode)throw Error(u(166));
c=ch(bh.current);ch($g.current);Wh(b)?(c=b.stateNode,d=b.memoizedProps,c[Md]=b,c.nodeValue!==d&&(b.effectTag|=4)):(c=(9===c.nodeType?c:c.ownerDocument).createTextNode(d),c[Md]=b,b.stateNode=c)}return null;case 13:H(M);d=b.memoizedState;if(0!==(b.effectTag&64))return b.expirationTime=c,b;c=null!==d;d=!1;null===a?void 0!==b.memoizedProps.fallback&&Wh(b):(e=a.memoizedState,d=null!==e,c||null===e||(e=a.child.sibling,null!==e&&(f=b.firstEffect,null!==f?(b.firstEffect=e,e.nextEffect=f):(b.firstEffect=b.lastEffect=
e,e.nextEffect=null),e.effectTag=8)));if(c&&!d&&0!==(b.mode&2))if(null===a&&!0!==b.memoizedProps.unstable_avoidThisFallback||0!==(M.current&1))S===ti&&(S=ui);else{if(S===ti||S===ui)S=vi;0!==wi&&null!==T&&(xi(T,U),yi(T,wi))}if(c||d)b.effectTag|=4;return null;case 4:return eh(),oi(b),null;case 10:return og(b),null;case 17:return L(b.type)&&Df(),null;case 19:H(M);d=b.memoizedState;if(null===d)return null;e=0!==(b.effectTag&64);f=d.rendering;if(null===f)if(e)ri(d,!1);else{if(S!==ti||null!==a&&0!==(a.effectTag&
64))for(f=b.child;null!==f;){a=hh(f);if(null!==a){b.effectTag|=64;ri(d,!1);e=a.updateQueue;null!==e&&(b.updateQueue=e,b.effectTag|=4);null===d.lastEffect&&(b.firstEffect=null);b.lastEffect=d.lastEffect;for(d=b.child;null!==d;)e=d,f=c,e.effectTag&=2,e.nextEffect=null,e.firstEffect=null,e.lastEffect=null,a=e.alternate,null===a?(e.childExpirationTime=0,e.expirationTime=f,e.child=null,e.memoizedProps=null,e.memoizedState=null,e.updateQueue=null,e.dependencies=null):(e.childExpirationTime=a.childExpirationTime,
e.expirationTime=a.expirationTime,e.child=a.child,e.memoizedProps=a.memoizedProps,e.memoizedState=a.memoizedState,e.updateQueue=a.updateQueue,f=a.dependencies,e.dependencies=null===f?null:{expirationTime:f.expirationTime,firstContext:f.firstContext,responders:f.responders}),d=d.sibling;I(M,M.current&1|2);return b.child}f=f.sibling}}else{if(!e)if(a=hh(f),null!==a){if(b.effectTag|=64,e=!0,c=a.updateQueue,null!==c&&(b.updateQueue=c,b.effectTag|=4),ri(d,!0),null===d.tail&&"hidden"===d.tailMode&&!f.alternate)return b=
b.lastEffect=d.lastEffect,null!==b&&(b.nextEffect=null),null}else 2*$f()-d.renderingStartTime>d.tailExpiration&&1<c&&(b.effectTag|=64,e=!0,ri(d,!1),b.expirationTime=b.childExpirationTime=c-1);d.isBackwards?(f.sibling=b.child,b.child=f):(c=d.last,null!==c?c.sibling=f:b.child=f,d.last=f)}return null!==d.tail?(0===d.tailExpiration&&(d.tailExpiration=$f()+500),c=d.tail,d.rendering=c,d.tail=c.sibling,d.lastEffect=b.lastEffect,d.renderingStartTime=$f(),c.sibling=null,b=M.current,I(M,e?b&1|2:b&1),c):null}throw Error(u(156,
b.tag));}function zi(a){switch(a.tag){case 1:L(a.type)&&Df();var b=a.effectTag;return b&4096?(a.effectTag=b&-4097|64,a):null;case 3:eh();H(K);H(J);b=a.effectTag;if(0!==(b&64))throw Error(u(285));a.effectTag=b&-4097|64;return a;case 5:return gh(a),null;case 13:return H(M),b=a.effectTag,b&4096?(a.effectTag=b&-4097|64,a):null;case 19:return H(M),null;case 4:return eh(),null;case 10:return og(a),null;default:return null}}function Ai(a,b){return{value:a,source:b,stack:qb(b)}}
var Bi="function"===typeof WeakSet?WeakSet:Set;function Ci(a,b){var c=b.source,d=b.stack;null===d&&null!==c&&(d=qb(c));null!==c&&pb(c.type);b=b.value;null!==a&&1===a.tag&&pb(a.type);try{console.error(b)}catch(e){setTimeout(function(){throw e;})}}function Di(a,b){try{b.props=a.memoizedProps,b.state=a.memoizedState,b.componentWillUnmount()}catch(c){Ei(a,c)}}function Fi(a){var b=a.ref;if(null!==b)if("function"===typeof b)try{b(null)}catch(c){Ei(a,c)}else b.current=null}
function Gi(a,b){switch(b.tag){case 0:case 11:case 15:case 22:return;case 1:if(b.effectTag&256&&null!==a){var c=a.memoizedProps,d=a.memoizedState;a=b.stateNode;b=a.getSnapshotBeforeUpdate(b.elementType===b.type?c:ig(b.type,c),d);a.__reactInternalSnapshotBeforeUpdate=b}return;case 3:case 5:case 6:case 4:case 17:return}throw Error(u(163));}
function Hi(a,b){b=b.updateQueue;b=null!==b?b.lastEffect:null;if(null!==b){var c=b=b.next;do{if((c.tag&a)===a){var d=c.destroy;c.destroy=void 0;void 0!==d&&d()}c=c.next}while(c!==b)}}function Ii(a,b){b=b.updateQueue;b=null!==b?b.lastEffect:null;if(null!==b){var c=b=b.next;do{if((c.tag&a)===a){var d=c.create;c.destroy=d()}c=c.next}while(c!==b)}}
function Ji(a,b,c){switch(c.tag){case 0:case 11:case 15:case 22:Ii(3,c);return;case 1:a=c.stateNode;if(c.effectTag&4)if(null===b)a.componentDidMount();else{var d=c.elementType===c.type?b.memoizedProps:ig(c.type,b.memoizedProps);a.componentDidUpdate(d,b.memoizedState,a.__reactInternalSnapshotBeforeUpdate)}b=c.updateQueue;null!==b&&Cg(c,b,a);return;case 3:b=c.updateQueue;if(null!==b){a=null;if(null!==c.child)switch(c.child.tag){case 5:a=c.child.stateNode;break;case 1:a=c.child.stateNode}Cg(c,b,a)}return;
case 5:a=c.stateNode;null===b&&c.effectTag&4&&Fd(c.type,c.memoizedProps)&&a.focus();return;case 6:return;case 4:return;case 12:return;case 13:null===c.memoizedState&&(c=c.alternate,null!==c&&(c=c.memoizedState,null!==c&&(c=c.dehydrated,null!==c&&Vc(c))));return;case 19:case 17:case 20:case 21:return}throw Error(u(163));}
function Ki(a,b,c){"function"===typeof Li&&Li(b);switch(b.tag){case 0:case 11:case 14:case 15:case 22:a=b.updateQueue;if(null!==a&&(a=a.lastEffect,null!==a)){var d=a.next;cg(97<c?97:c,function(){var a=d;do{var c=a.destroy;if(void 0!==c){var g=b;try{c()}catch(h){Ei(g,h)}}a=a.next}while(a!==d)})}break;case 1:Fi(b);c=b.stateNode;"function"===typeof c.componentWillUnmount&&Di(b,c);break;case 5:Fi(b);break;case 4:Mi(a,b,c)}}
function Ni(a){var b=a.alternate;a.return=null;a.child=null;a.memoizedState=null;a.updateQueue=null;a.dependencies=null;a.alternate=null;a.firstEffect=null;a.lastEffect=null;a.pendingProps=null;a.memoizedProps=null;a.stateNode=null;null!==b&&Ni(b)}function Oi(a){return 5===a.tag||3===a.tag||4===a.tag}
function Pi(a){a:{for(var b=a.return;null!==b;){if(Oi(b)){var c=b;break a}b=b.return}throw Error(u(160));}b=c.stateNode;switch(c.tag){case 5:var d=!1;break;case 3:b=b.containerInfo;d=!0;break;case 4:b=b.containerInfo;d=!0;break;default:throw Error(u(161));}c.effectTag&16&&(Rb(b,""),c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c.return||Oi(c.return)){c=null;break a}c=c.return}c.sibling.return=c.return;for(c=c.sibling;5!==c.tag&&6!==c.tag&&18!==c.tag;){if(c.effectTag&2)continue b;
if(null===c.child||4===c.tag)continue b;else c.child.return=c,c=c.child}if(!(c.effectTag&2)){c=c.stateNode;break a}}d?Qi(a,c,b):Ri(a,c,b)}
function Qi(a,b,c){var d=a.tag,e=5===d||6===d;if(e)a=e?a.stateNode:a.stateNode.instance,b?8===c.nodeType?c.parentNode.insertBefore(a,b):c.insertBefore(a,b):(8===c.nodeType?(b=c.parentNode,b.insertBefore(a,c)):(b=c,b.appendChild(a)),c=c._reactRootContainer,null!==c&&void 0!==c||null!==b.onclick||(b.onclick=sd));else if(4!==d&&(a=a.child,null!==a))for(Qi(a,b,c),a=a.sibling;null!==a;)Qi(a,b,c),a=a.sibling}
function Ri(a,b,c){var d=a.tag,e=5===d||6===d;if(e)a=e?a.stateNode:a.stateNode.instance,b?c.insertBefore(a,b):c.appendChild(a);else if(4!==d&&(a=a.child,null!==a))for(Ri(a,b,c),a=a.sibling;null!==a;)Ri(a,b,c),a=a.sibling}
function Mi(a,b,c){for(var d=b,e=!1,f,g;;){if(!e){e=d.return;a:for(;;){if(null===e)throw Error(u(160));f=e.stateNode;switch(e.tag){case 5:g=!1;break a;case 3:f=f.containerInfo;g=!0;break a;case 4:f=f.containerInfo;g=!0;break a}e=e.return}e=!0}if(5===d.tag||6===d.tag){a:for(var h=a,k=d,l=c,m=k;;)if(Ki(h,m,l),null!==m.child&&4!==m.tag)m.child.return=m,m=m.child;else{if(m===k)break a;for(;null===m.sibling;){if(null===m.return||m.return===k)break a;m=m.return}m.sibling.return=m.return;m=m.sibling}g?(h=
f,k=d.stateNode,8===h.nodeType?h.parentNode.removeChild(k):h.removeChild(k)):f.removeChild(d.stateNode)}else if(4===d.tag){if(null!==d.child){f=d.stateNode.containerInfo;g=!0;d.child.return=d;d=d.child;continue}}else if(Ki(a,d,c),null!==d.child){d.child.return=d;d=d.child;continue}if(d===b)break;for(;null===d.sibling;){if(null===d.return||d.return===b)return;d=d.return;4===d.tag&&(e=!1)}d.sibling.return=d.return;d=d.sibling}}
function Si(a,b){switch(b.tag){case 0:case 11:case 14:case 15:case 22:Hi(3,b);return;case 1:return;case 5:var c=b.stateNode;if(null!=c){var d=b.memoizedProps,e=null!==a?a.memoizedProps:d;a=b.type;var f=b.updateQueue;b.updateQueue=null;if(null!==f){c[Nd]=d;"input"===a&&"radio"===d.type&&null!=d.name&&Bb(c,d);pd(a,e);b=pd(a,d);for(e=0;e<f.length;e+=2){var g=f[e],h=f[e+1];"style"===g?md(c,h):"dangerouslySetInnerHTML"===g?Qb(c,h):"children"===g?Rb(c,h):Xa(c,g,h,b)}switch(a){case "input":Cb(c,d);break;
case "textarea":Kb(c,d);break;case "select":b=c._wrapperState.wasMultiple,c._wrapperState.wasMultiple=!!d.multiple,a=d.value,null!=a?Hb(c,!!d.multiple,a,!1):b!==!!d.multiple&&(null!=d.defaultValue?Hb(c,!!d.multiple,d.defaultValue,!0):Hb(c,!!d.multiple,d.multiple?[]:"",!1))}}}return;case 6:if(null===b.stateNode)throw Error(u(162));b.stateNode.nodeValue=b.memoizedProps;return;case 3:b=b.stateNode;b.hydrate&&(b.hydrate=!1,Vc(b.containerInfo));return;case 12:return;case 13:c=b;null===b.memoizedState?
d=!1:(d=!0,c=b.child,Ti=$f());if(null!==c)a:for(a=c;;){if(5===a.tag)f=a.stateNode,d?(f=f.style,"function"===typeof f.setProperty?f.setProperty("display","none","important"):f.display="none"):(f=a.stateNode,e=a.memoizedProps.style,e=void 0!==e&&null!==e&&e.hasOwnProperty("display")?e.display:null,f.style.display=ld("display",e));else if(6===a.tag)a.stateNode.nodeValue=d?"":a.memoizedProps;else if(13===a.tag&&null!==a.memoizedState&&null===a.memoizedState.dehydrated){f=a.child.sibling;f.return=a;a=
f;continue}else if(null!==a.child){a.child.return=a;a=a.child;continue}if(a===c)break;for(;null===a.sibling;){if(null===a.return||a.return===c)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}Ui(b);return;case 19:Ui(b);return;case 17:return}throw Error(u(163));}function Ui(a){var b=a.updateQueue;if(null!==b){a.updateQueue=null;var c=a.stateNode;null===c&&(c=a.stateNode=new Bi);b.forEach(function(b){var d=Vi.bind(null,a,b);c.has(b)||(c.add(b),b.then(d,d))})}}
var Wi="function"===typeof WeakMap?WeakMap:Map;function Xi(a,b,c){c=wg(c,null);c.tag=3;c.payload={element:null};var d=b.value;c.callback=function(){Yi||(Yi=!0,Zi=d);Ci(a,b)};return c}
function $i(a,b,c){c=wg(c,null);c.tag=3;var d=a.type.getDerivedStateFromError;if("function"===typeof d){var e=b.value;c.payload=function(){Ci(a,b);return d(e)}}var f=a.stateNode;null!==f&&"function"===typeof f.componentDidCatch&&(c.callback=function(){"function"!==typeof d&&(null===aj?aj=new Set([this]):aj.add(this),Ci(a,b));var c=b.stack;this.componentDidCatch(b.value,{componentStack:null!==c?c:""})});return c}
var bj=Math.ceil,cj=Wa.ReactCurrentDispatcher,dj=Wa.ReactCurrentOwner,V=0,ej=8,fj=16,gj=32,ti=0,hj=1,ij=2,ui=3,vi=4,jj=5,W=V,T=null,X=null,U=0,S=ti,kj=null,lj=1073741823,mj=1073741823,nj=null,wi=0,oj=!1,Ti=0,pj=500,Y=null,Yi=!1,Zi=null,aj=null,qj=!1,rj=null,sj=90,tj=null,uj=0,vj=null,wj=0;function Gg(){return(W&(fj|gj))!==V?1073741821-($f()/10|0):0!==wj?wj:wj=1073741821-($f()/10|0)}
function Hg(a,b,c){b=b.mode;if(0===(b&2))return 1073741823;var d=ag();if(0===(b&4))return 99===d?1073741823:1073741822;if((W&fj)!==V)return U;if(null!==c)a=hg(a,c.timeoutMs|0||5E3,250);else switch(d){case 99:a=1073741823;break;case 98:a=hg(a,150,100);break;case 97:case 96:a=hg(a,5E3,250);break;case 95:a=2;break;default:throw Error(u(326));}null!==T&&a===U&&--a;return a}
function Ig(a,b){if(50<uj)throw uj=0,vj=null,Error(u(185));a=xj(a,b);if(null!==a){var c=ag();1073741823===b?(W&ej)!==V&&(W&(fj|gj))===V?yj(a):(Z(a),W===V&&gg()):Z(a);(W&4)===V||98!==c&&99!==c||(null===tj?tj=new Map([[a,b]]):(c=tj.get(a),(void 0===c||c>b)&&tj.set(a,b)))}}
function xj(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);var d=a.return,e=null;if(null===d&&3===a.tag)e=a.stateNode;else for(;null!==d;){c=d.alternate;d.childExpirationTime<b&&(d.childExpirationTime=b);null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);if(null===d.return&&3===d.tag){e=d.stateNode;break}d=d.return}null!==e&&(T===e&&(Bg(b),S===vi&&xi(e,U)),yi(e,b));return e}
function zj(a){var b=a.lastExpiredTime;if(0!==b)return b;b=a.firstPendingTime;if(!Aj(a,b))return b;var c=a.lastPingedTime;a=a.nextKnownPendingLevel;a=c>a?c:a;return 2>=a&&b!==a?0:a}
function Z(a){if(0!==a.lastExpiredTime)a.callbackExpirationTime=1073741823,a.callbackPriority=99,a.callbackNode=eg(yj.bind(null,a));else{var b=zj(a),c=a.callbackNode;if(0===b)null!==c&&(a.callbackNode=null,a.callbackExpirationTime=0,a.callbackPriority=90);else{var d=Gg();1073741823===b?d=99:1===b||2===b?d=95:(d=10*(1073741821-b)-10*(1073741821-d),d=0>=d?99:250>=d?98:5250>=d?97:95);if(null!==c){var e=a.callbackPriority;if(a.callbackExpirationTime===b&&e>=d)return;c!==Tf&&Kf(c)}a.callbackExpirationTime=
b;a.callbackPriority=d;b=1073741823===b?eg(yj.bind(null,a)):dg(d,Bj.bind(null,a),{timeout:10*(1073741821-b)-$f()});a.callbackNode=b}}}
function Bj(a,b){wj=0;if(b)return b=Gg(),Cj(a,b),Z(a),null;var c=zj(a);if(0!==c){b=a.callbackNode;if((W&(fj|gj))!==V)throw Error(u(327));Dj();a===T&&c===U||Ej(a,c);if(null!==X){var d=W;W|=fj;var e=Fj();do try{Gj();break}catch(h){Hj(a,h)}while(1);ng();W=d;cj.current=e;if(S===hj)throw b=kj,Ej(a,c),xi(a,c),Z(a),b;if(null===X)switch(e=a.finishedWork=a.current.alternate,a.finishedExpirationTime=c,d=S,T=null,d){case ti:case hj:throw Error(u(345));case ij:Cj(a,2<c?2:c);break;case ui:xi(a,c);d=a.lastSuspendedTime;
c===d&&(a.nextKnownPendingLevel=Ij(e));if(1073741823===lj&&(e=Ti+pj-$f(),10<e)){if(oj){var f=a.lastPingedTime;if(0===f||f>=c){a.lastPingedTime=c;Ej(a,c);break}}f=zj(a);if(0!==f&&f!==c)break;if(0!==d&&d!==c){a.lastPingedTime=d;break}a.timeoutHandle=Hd(Jj.bind(null,a),e);break}Jj(a);break;case vi:xi(a,c);d=a.lastSuspendedTime;c===d&&(a.nextKnownPendingLevel=Ij(e));if(oj&&(e=a.lastPingedTime,0===e||e>=c)){a.lastPingedTime=c;Ej(a,c);break}e=zj(a);if(0!==e&&e!==c)break;if(0!==d&&d!==c){a.lastPingedTime=
d;break}1073741823!==mj?d=10*(1073741821-mj)-$f():1073741823===lj?d=0:(d=10*(1073741821-lj)-5E3,e=$f(),c=10*(1073741821-c)-e,d=e-d,0>d&&(d=0),d=(120>d?120:480>d?480:1080>d?1080:1920>d?1920:3E3>d?3E3:4320>d?4320:1960*bj(d/1960))-d,c<d&&(d=c));if(10<d){a.timeoutHandle=Hd(Jj.bind(null,a),d);break}Jj(a);break;case jj:if(1073741823!==lj&&null!==nj){f=lj;var g=nj;d=g.busyMinDurationMs|0;0>=d?d=0:(e=g.busyDelayMs|0,f=$f()-(10*(1073741821-f)-(g.timeoutMs|0||5E3)),d=f<=e?0:e+d-f);if(10<d){xi(a,c);a.timeoutHandle=
Hd(Jj.bind(null,a),d);break}}Jj(a);break;default:throw Error(u(329));}Z(a);if(a.callbackNode===b)return Bj.bind(null,a)}}return null}
function yj(a){var b=a.lastExpiredTime;b=0!==b?b:1073741823;if((W&(fj|gj))!==V)throw Error(u(327));Dj();a===T&&b===U||Ej(a,b);if(null!==X){var c=W;W|=fj;var d=Fj();do try{Kj();break}catch(e){Hj(a,e)}while(1);ng();W=c;cj.current=d;if(S===hj)throw c=kj,Ej(a,b),xi(a,b),Z(a),c;if(null!==X)throw Error(u(261));a.finishedWork=a.current.alternate;a.finishedExpirationTime=b;T=null;Jj(a);Z(a)}return null}function Lj(){if(null!==tj){var a=tj;tj=null;a.forEach(function(a,c){Cj(c,a);Z(c)});gg()}}
function Mj(a,b){var c=W;W|=1;try{return a(b)}finally{W=c,W===V&&gg()}}function Nj(a,b){var c=W;W&=-2;W|=ej;try{return a(b)}finally{W=c,W===V&&gg()}}
function Ej(a,b){a.finishedWork=null;a.finishedExpirationTime=0;var c=a.timeoutHandle;-1!==c&&(a.timeoutHandle=-1,Id(c));if(null!==X)for(c=X.return;null!==c;){var d=c;switch(d.tag){case 1:d=d.type.childContextTypes;null!==d&&void 0!==d&&Df();break;case 3:eh();H(K);H(J);break;case 5:gh(d);break;case 4:eh();break;case 13:H(M);break;case 19:H(M);break;case 10:og(d)}c=c.return}T=a;X=Sg(a.current,null);U=b;S=ti;kj=null;mj=lj=1073741823;nj=null;wi=0;oj=!1}
function Hj(a,b){do{try{ng();jh.current=sh;if(mh)for(var c=N.memoizedState;null!==c;){var d=c.queue;null!==d&&(d.pending=null);c=c.next}lh=0;P=O=N=null;mh=!1;if(null===X||null===X.return)return S=hj,kj=b,X=null;a:{var e=a,f=X.return,g=X,h=b;b=U;g.effectTag|=2048;g.firstEffect=g.lastEffect=null;if(null!==h&&"object"===typeof h&&"function"===typeof h.then){var k=h;if(0===(g.mode&2)){var l=g.alternate;l?(g.updateQueue=l.updateQueue,g.memoizedState=l.memoizedState,g.expirationTime=l.expirationTime):(g.updateQueue=
null,g.memoizedState=null)}var m=0!==(M.current&1),p=f;do{var x;if(x=13===p.tag){var z=p.memoizedState;if(null!==z)x=null!==z.dehydrated?!0:!1;else{var ca=p.memoizedProps;x=void 0===ca.fallback?!1:!0!==ca.unstable_avoidThisFallback?!0:m?!1:!0}}if(x){var D=p.updateQueue;if(null===D){var t=new Set;t.add(k);p.updateQueue=t}else D.add(k);if(0===(p.mode&2)){p.effectTag|=64;g.effectTag&=-2981;if(1===g.tag)if(null===g.alternate)g.tag=17;else{var y=wg(1073741823,null);y.tag=2;xg(g,y)}g.expirationTime=1073741823;
break a}h=void 0;g=b;var A=e.pingCache;null===A?(A=e.pingCache=new Wi,h=new Set,A.set(k,h)):(h=A.get(k),void 0===h&&(h=new Set,A.set(k,h)));if(!h.has(g)){h.add(g);var q=Oj.bind(null,e,k,g);k.then(q,q)}p.effectTag|=4096;p.expirationTime=b;break a}p=p.return}while(null!==p);h=Error((pb(g.type)||"A React component")+" suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display."+qb(g))}S!==
jj&&(S=ij);h=Ai(h,g);p=f;do{switch(p.tag){case 3:k=h;p.effectTag|=4096;p.expirationTime=b;var B=Xi(p,k,b);yg(p,B);break a;case 1:k=h;var w=p.type,ub=p.stateNode;if(0===(p.effectTag&64)&&("function"===typeof w.getDerivedStateFromError||null!==ub&&"function"===typeof ub.componentDidCatch&&(null===aj||!aj.has(ub)))){p.effectTag|=4096;p.expirationTime=b;var vb=$i(p,k,b);yg(p,vb);break a}}p=p.return}while(null!==p)}X=Pj(X)}catch(Xc){b=Xc;continue}break}while(1)}
function Fj(){var a=cj.current;cj.current=sh;return null===a?sh:a}function Ag(a,b){a<lj&&2<a&&(lj=a);null!==b&&a<mj&&2<a&&(mj=a,nj=b)}function Bg(a){a>wi&&(wi=a)}function Kj(){for(;null!==X;)X=Qj(X)}function Gj(){for(;null!==X&&!Uf();)X=Qj(X)}function Qj(a){var b=Rj(a.alternate,a,U);a.memoizedProps=a.pendingProps;null===b&&(b=Pj(a));dj.current=null;return b}
function Pj(a){X=a;do{var b=X.alternate;a=X.return;if(0===(X.effectTag&2048)){b=si(b,X,U);if(1===U||1!==X.childExpirationTime){for(var c=0,d=X.child;null!==d;){var e=d.expirationTime,f=d.childExpirationTime;e>c&&(c=e);f>c&&(c=f);d=d.sibling}X.childExpirationTime=c}if(null!==b)return b;null!==a&&0===(a.effectTag&2048)&&(null===a.firstEffect&&(a.firstEffect=X.firstEffect),null!==X.lastEffect&&(null!==a.lastEffect&&(a.lastEffect.nextEffect=X.firstEffect),a.lastEffect=X.lastEffect),1<X.effectTag&&(null!==
a.lastEffect?a.lastEffect.nextEffect=X:a.firstEffect=X,a.lastEffect=X))}else{b=zi(X);if(null!==b)return b.effectTag&=2047,b;null!==a&&(a.firstEffect=a.lastEffect=null,a.effectTag|=2048)}b=X.sibling;if(null!==b)return b;X=a}while(null!==X);S===ti&&(S=jj);return null}function Ij(a){var b=a.expirationTime;a=a.childExpirationTime;return b>a?b:a}function Jj(a){var b=ag();cg(99,Sj.bind(null,a,b));return null}
function Sj(a,b){do Dj();while(null!==rj);if((W&(fj|gj))!==V)throw Error(u(327));var c=a.finishedWork,d=a.finishedExpirationTime;if(null===c)return null;a.finishedWork=null;a.finishedExpirationTime=0;if(c===a.current)throw Error(u(177));a.callbackNode=null;a.callbackExpirationTime=0;a.callbackPriority=90;a.nextKnownPendingLevel=0;var e=Ij(c);a.firstPendingTime=e;d<=a.lastSuspendedTime?a.firstSuspendedTime=a.lastSuspendedTime=a.nextKnownPendingLevel=0:d<=a.firstSuspendedTime&&(a.firstSuspendedTime=
d-1);d<=a.lastPingedTime&&(a.lastPingedTime=0);d<=a.lastExpiredTime&&(a.lastExpiredTime=0);a===T&&(X=T=null,U=0);1<c.effectTag?null!==c.lastEffect?(c.lastEffect.nextEffect=c,e=c.firstEffect):e=c:e=c.firstEffect;if(null!==e){var f=W;W|=gj;dj.current=null;Dd=fd;var g=xd();if(yd(g)){if("selectionStart"in g)var h={start:g.selectionStart,end:g.selectionEnd};else a:{h=(h=g.ownerDocument)&&h.defaultView||window;var k=h.getSelection&&h.getSelection();if(k&&0!==k.rangeCount){h=k.anchorNode;var l=k.anchorOffset,
m=k.focusNode;k=k.focusOffset;try{h.nodeType,m.nodeType}catch(wb){h=null;break a}var p=0,x=-1,z=-1,ca=0,D=0,t=g,y=null;b:for(;;){for(var A;;){t!==h||0!==l&&3!==t.nodeType||(x=p+l);t!==m||0!==k&&3!==t.nodeType||(z=p+k);3===t.nodeType&&(p+=t.nodeValue.length);if(null===(A=t.firstChild))break;y=t;t=A}for(;;){if(t===g)break b;y===h&&++ca===l&&(x=p);y===m&&++D===k&&(z=p);if(null!==(A=t.nextSibling))break;t=y;y=t.parentNode}t=A}h=-1===x||-1===z?null:{start:x,end:z}}else h=null}h=h||{start:0,end:0}}else h=
null;Ed={activeElementDetached:null,focusedElem:g,selectionRange:h};fd=!1;Y=e;do try{Tj()}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);Y=e;do try{for(g=a,h=b;null!==Y;){var q=Y.effectTag;q&16&&Rb(Y.stateNode,"");if(q&128){var B=Y.alternate;if(null!==B){var w=B.ref;null!==w&&("function"===typeof w?w(null):w.current=null)}}switch(q&1038){case 2:Pi(Y);Y.effectTag&=-3;break;case 6:Pi(Y);Y.effectTag&=-3;Si(Y.alternate,Y);break;case 1024:Y.effectTag&=-1025;break;case 1028:Y.effectTag&=
-1025;Si(Y.alternate,Y);break;case 4:Si(Y.alternate,Y);break;case 8:l=Y,Mi(g,l,h),Ni(l)}Y=Y.nextEffect}}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);w=Ed;B=xd();q=w.focusedElem;h=w.selectionRange;if(B!==q&&q&&q.ownerDocument&&wd(q.ownerDocument.documentElement,q)){null!==h&&yd(q)&&(B=h.start,w=h.end,void 0===w&&(w=B),"selectionStart"in q?(q.selectionStart=B,q.selectionEnd=Math.min(w,q.value.length)):(w=(B=q.ownerDocument||document)&&B.defaultView||window,w.getSelection&&
(w=w.getSelection(),l=q.textContent.length,g=Math.min(h.start,l),h=void 0===h.end?g:Math.min(h.end,l),!w.extend&&g>h&&(l=h,h=g,g=l),l=vd(q,g),m=vd(q,h),l&&m&&(1!==w.rangeCount||w.anchorNode!==l.node||w.anchorOffset!==l.offset||w.focusNode!==m.node||w.focusOffset!==m.offset)&&(B=B.createRange(),B.setStart(l.node,l.offset),w.removeAllRanges(),g>h?(w.addRange(B),w.extend(m.node,m.offset)):(B.setEnd(m.node,m.offset),w.addRange(B))))));B=[];for(w=q;w=w.parentNode;)1===w.nodeType&&B.push({element:w,left:w.scrollLeft,
top:w.scrollTop});"function"===typeof q.focus&&q.focus();for(q=0;q<B.length;q++)w=B[q],w.element.scrollLeft=w.left,w.element.scrollTop=w.top}fd=!!Dd;Ed=Dd=null;a.current=c;Y=e;do try{for(q=a;null!==Y;){var ub=Y.effectTag;ub&36&&Ji(q,Y.alternate,Y);if(ub&128){B=void 0;var vb=Y.ref;if(null!==vb){var Xc=Y.stateNode;switch(Y.tag){case 5:B=Xc;break;default:B=Xc}"function"===typeof vb?vb(B):vb.current=B}}Y=Y.nextEffect}}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);Y=
null;Vf();W=f}else a.current=c;if(qj)qj=!1,rj=a,sj=b;else for(Y=e;null!==Y;)b=Y.nextEffect,Y.nextEffect=null,Y=b;b=a.firstPendingTime;0===b&&(aj=null);1073741823===b?a===vj?uj++:(uj=0,vj=a):uj=0;"function"===typeof Uj&&Uj(c.stateNode,d);Z(a);if(Yi)throw Yi=!1,a=Zi,Zi=null,a;if((W&ej)!==V)return null;gg();return null}function Tj(){for(;null!==Y;){var a=Y.effectTag;0!==(a&256)&&Gi(Y.alternate,Y);0===(a&512)||qj||(qj=!0,dg(97,function(){Dj();return null}));Y=Y.nextEffect}}
function Dj(){if(90!==sj){var a=97<sj?97:sj;sj=90;return cg(a,Vj)}}function Vj(){if(null===rj)return!1;var a=rj;rj=null;if((W&(fj|gj))!==V)throw Error(u(331));var b=W;W|=gj;for(a=a.current.firstEffect;null!==a;){try{var c=a;if(0!==(c.effectTag&512))switch(c.tag){case 0:case 11:case 15:case 22:Hi(5,c),Ii(5,c)}}catch(d){if(null===a)throw Error(u(330));Ei(a,d)}c=a.nextEffect;a.nextEffect=null;a=c}W=b;gg();return!0}
function Wj(a,b,c){b=Ai(c,b);b=Xi(a,b,1073741823);xg(a,b);a=xj(a,1073741823);null!==a&&Z(a)}function Ei(a,b){if(3===a.tag)Wj(a,a,b);else for(var c=a.return;null!==c;){if(3===c.tag){Wj(c,a,b);break}else if(1===c.tag){var d=c.stateNode;if("function"===typeof c.type.getDerivedStateFromError||"function"===typeof d.componentDidCatch&&(null===aj||!aj.has(d))){a=Ai(b,a);a=$i(c,a,1073741823);xg(c,a);c=xj(c,1073741823);null!==c&&Z(c);break}}c=c.return}}
function Oj(a,b,c){var d=a.pingCache;null!==d&&d.delete(b);T===a&&U===c?S===vi||S===ui&&1073741823===lj&&$f()-Ti<pj?Ej(a,U):oj=!0:Aj(a,c)&&(b=a.lastPingedTime,0!==b&&b<c||(a.lastPingedTime=c,Z(a)))}function Vi(a,b){var c=a.stateNode;null!==c&&c.delete(b);b=0;0===b&&(b=Gg(),b=Hg(b,a,null));a=xj(a,b);null!==a&&Z(a)}var Rj;
Rj=function(a,b,c){var d=b.expirationTime;if(null!==a){var e=b.pendingProps;if(a.memoizedProps!==e||K.current)rg=!0;else{if(d<c){rg=!1;switch(b.tag){case 3:hi(b);Xh();break;case 5:fh(b);if(b.mode&4&&1!==c&&e.hidden)return b.expirationTime=b.childExpirationTime=1,null;break;case 1:L(b.type)&&Gf(b);break;case 4:dh(b,b.stateNode.containerInfo);break;case 10:d=b.memoizedProps.value;e=b.type._context;I(jg,e._currentValue);e._currentValue=d;break;case 13:if(null!==b.memoizedState){d=b.child.childExpirationTime;
if(0!==d&&d>=c)return ji(a,b,c);I(M,M.current&1);b=$h(a,b,c);return null!==b?b.sibling:null}I(M,M.current&1);break;case 19:d=b.childExpirationTime>=c;if(0!==(a.effectTag&64)){if(d)return mi(a,b,c);b.effectTag|=64}e=b.memoizedState;null!==e&&(e.rendering=null,e.tail=null);I(M,M.current);if(!d)return null}return $h(a,b,c)}rg=!1}}else rg=!1;b.expirationTime=0;switch(b.tag){case 2:d=b.type;null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;e=Cf(b,J.current);qg(b,c);e=oh(null,
b,d,a,e,c);b.effectTag|=1;if("object"===typeof e&&null!==e&&"function"===typeof e.render&&void 0===e.$$typeof){b.tag=1;b.memoizedState=null;b.updateQueue=null;if(L(d)){var f=!0;Gf(b)}else f=!1;b.memoizedState=null!==e.state&&void 0!==e.state?e.state:null;ug(b);var g=d.getDerivedStateFromProps;"function"===typeof g&&Fg(b,d,g,a);e.updater=Jg;b.stateNode=e;e._reactInternalFiber=b;Ng(b,d,a,c);b=gi(null,b,d,!0,f,c)}else b.tag=0,R(null,b,e,c),b=b.child;return b;case 16:a:{e=b.elementType;null!==a&&(a.alternate=
null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;ob(e);if(1!==e._status)throw e._result;e=e._result;b.type=e;f=b.tag=Xj(e);a=ig(e,a);switch(f){case 0:b=di(null,b,e,a,c);break a;case 1:b=fi(null,b,e,a,c);break a;case 11:b=Zh(null,b,e,a,c);break a;case 14:b=ai(null,b,e,ig(e.type,a),d,c);break a}throw Error(u(306,e,""));}return b;case 0:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),di(a,b,d,e,c);case 1:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),fi(a,b,d,e,c);
case 3:hi(b);d=b.updateQueue;if(null===a||null===d)throw Error(u(282));d=b.pendingProps;e=b.memoizedState;e=null!==e?e.element:null;vg(a,b);zg(b,d,null,c);d=b.memoizedState.element;if(d===e)Xh(),b=$h(a,b,c);else{if(e=b.stateNode.hydrate)Ph=Jd(b.stateNode.containerInfo.firstChild),Oh=b,e=Qh=!0;if(e)for(c=Yg(b,null,d,c),b.child=c;c;)c.effectTag=c.effectTag&-3|1024,c=c.sibling;else R(a,b,d,c),Xh();b=b.child}return b;case 5:return fh(b),null===a&&Uh(b),d=b.type,e=b.pendingProps,f=null!==a?a.memoizedProps:
null,g=e.children,Gd(d,e)?g=null:null!==f&&Gd(d,f)&&(b.effectTag|=16),ei(a,b),b.mode&4&&1!==c&&e.hidden?(b.expirationTime=b.childExpirationTime=1,b=null):(R(a,b,g,c),b=b.child),b;case 6:return null===a&&Uh(b),null;case 13:return ji(a,b,c);case 4:return dh(b,b.stateNode.containerInfo),d=b.pendingProps,null===a?b.child=Xg(b,null,d,c):R(a,b,d,c),b.child;case 11:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),Zh(a,b,d,e,c);case 7:return R(a,b,b.pendingProps,c),b.child;case 8:return R(a,
b,b.pendingProps.children,c),b.child;case 12:return R(a,b,b.pendingProps.children,c),b.child;case 10:a:{d=b.type._context;e=b.pendingProps;g=b.memoizedProps;f=e.value;var h=b.type._context;I(jg,h._currentValue);h._currentValue=f;if(null!==g)if(h=g.value,f=$e(h,f)?0:("function"===typeof d._calculateChangedBits?d._calculateChangedBits(h,f):1073741823)|0,0===f){if(g.children===e.children&&!K.current){b=$h(a,b,c);break a}}else for(h=b.child,null!==h&&(h.return=b);null!==h;){var k=h.dependencies;if(null!==
k){g=h.child;for(var l=k.firstContext;null!==l;){if(l.context===d&&0!==(l.observedBits&f)){1===h.tag&&(l=wg(c,null),l.tag=2,xg(h,l));h.expirationTime<c&&(h.expirationTime=c);l=h.alternate;null!==l&&l.expirationTime<c&&(l.expirationTime=c);pg(h.return,c);k.expirationTime<c&&(k.expirationTime=c);break}l=l.next}}else g=10===h.tag?h.type===b.type?null:h.child:h.child;if(null!==g)g.return=h;else for(g=h;null!==g;){if(g===b){g=null;break}h=g.sibling;if(null!==h){h.return=g.return;g=h;break}g=g.return}h=
g}R(a,b,e.children,c);b=b.child}return b;case 9:return e=b.type,f=b.pendingProps,d=f.children,qg(b,c),e=sg(e,f.unstable_observedBits),d=d(e),b.effectTag|=1,R(a,b,d,c),b.child;case 14:return e=b.type,f=ig(e,b.pendingProps),f=ig(e.type,f),ai(a,b,e,f,d,c);case 15:return ci(a,b,b.type,b.pendingProps,d,c);case 17:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),b.tag=1,L(d)?(a=!0,Gf(b)):a=!1,qg(b,c),Lg(b,d,e),Ng(b,d,e,c),gi(null,
b,d,!0,a,c);case 19:return mi(a,b,c)}throw Error(u(156,b.tag));};var Uj=null,Li=null;function Yj(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(b.isDisabled||!b.supportsFiber)return!0;try{var c=b.inject(a);Uj=function(a){try{b.onCommitFiberRoot(c,a,void 0,64===(a.current.effectTag&64))}catch(e){}};Li=function(a){try{b.onCommitFiberUnmount(c,a)}catch(e){}}}catch(d){}return!0}
function Zj(a,b,c,d){this.tag=a;this.key=c;this.sibling=this.child=this.return=this.stateNode=this.type=this.elementType=null;this.index=0;this.ref=null;this.pendingProps=b;this.dependencies=this.memoizedState=this.updateQueue=this.memoizedProps=null;this.mode=d;this.effectTag=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.childExpirationTime=this.expirationTime=0;this.alternate=null}function Sh(a,b,c,d){return new Zj(a,b,c,d)}
function bi(a){a=a.prototype;return!(!a||!a.isReactComponent)}function Xj(a){if("function"===typeof a)return bi(a)?1:0;if(void 0!==a&&null!==a){a=a.$$typeof;if(a===gb)return 11;if(a===jb)return 14}return 2}
function Sg(a,b){var c=a.alternate;null===c?(c=Sh(a.tag,b,a.key,a.mode),c.elementType=a.elementType,c.type=a.type,c.stateNode=a.stateNode,c.alternate=a,a.alternate=c):(c.pendingProps=b,c.effectTag=0,c.nextEffect=null,c.firstEffect=null,c.lastEffect=null);c.childExpirationTime=a.childExpirationTime;c.expirationTime=a.expirationTime;c.child=a.child;c.memoizedProps=a.memoizedProps;c.memoizedState=a.memoizedState;c.updateQueue=a.updateQueue;b=a.dependencies;c.dependencies=null===b?null:{expirationTime:b.expirationTime,
firstContext:b.firstContext,responders:b.responders};c.sibling=a.sibling;c.index=a.index;c.ref=a.ref;return c}
function Ug(a,b,c,d,e,f){var g=2;d=a;if("function"===typeof a)bi(a)&&(g=1);else if("string"===typeof a)g=5;else a:switch(a){case ab:return Wg(c.children,e,f,b);case fb:g=8;e|=7;break;case bb:g=8;e|=1;break;case cb:return a=Sh(12,c,b,e|8),a.elementType=cb,a.type=cb,a.expirationTime=f,a;case hb:return a=Sh(13,c,b,e),a.type=hb,a.elementType=hb,a.expirationTime=f,a;case ib:return a=Sh(19,c,b,e),a.elementType=ib,a.expirationTime=f,a;default:if("object"===typeof a&&null!==a)switch(a.$$typeof){case db:g=
10;break a;case eb:g=9;break a;case gb:g=11;break a;case jb:g=14;break a;case kb:g=16;d=null;break a;case lb:g=22;break a}throw Error(u(130,null==a?a:typeof a,""));}b=Sh(g,c,b,e);b.elementType=a;b.type=d;b.expirationTime=f;return b}function Wg(a,b,c,d){a=Sh(7,a,d,b);a.expirationTime=c;return a}function Tg(a,b,c){a=Sh(6,a,null,b);a.expirationTime=c;return a}
function Vg(a,b,c){b=Sh(4,null!==a.children?a.children:[],a.key,b);b.expirationTime=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}
function ak(a,b,c){this.tag=b;this.current=null;this.containerInfo=a;this.pingCache=this.pendingChildren=null;this.finishedExpirationTime=0;this.finishedWork=null;this.timeoutHandle=-1;this.pendingContext=this.context=null;this.hydrate=c;this.callbackNode=null;this.callbackPriority=90;this.lastExpiredTime=this.lastPingedTime=this.nextKnownPendingLevel=this.lastSuspendedTime=this.firstSuspendedTime=this.firstPendingTime=0}
function Aj(a,b){var c=a.firstSuspendedTime;a=a.lastSuspendedTime;return 0!==c&&c>=b&&a<=b}function xi(a,b){var c=a.firstSuspendedTime,d=a.lastSuspendedTime;c<b&&(a.firstSuspendedTime=b);if(d>b||0===c)a.lastSuspendedTime=b;b<=a.lastPingedTime&&(a.lastPingedTime=0);b<=a.lastExpiredTime&&(a.lastExpiredTime=0)}
function yi(a,b){b>a.firstPendingTime&&(a.firstPendingTime=b);var c=a.firstSuspendedTime;0!==c&&(b>=c?a.firstSuspendedTime=a.lastSuspendedTime=a.nextKnownPendingLevel=0:b>=a.lastSuspendedTime&&(a.lastSuspendedTime=b+1),b>a.nextKnownPendingLevel&&(a.nextKnownPendingLevel=b))}function Cj(a,b){var c=a.lastExpiredTime;if(0===c||c>b)a.lastExpiredTime=b}
function bk(a,b,c,d){var e=b.current,f=Gg(),g=Dg.suspense;f=Hg(f,e,g);a:if(c){c=c._reactInternalFiber;b:{if(dc(c)!==c||1!==c.tag)throw Error(u(170));var h=c;do{switch(h.tag){case 3:h=h.stateNode.context;break b;case 1:if(L(h.type)){h=h.stateNode.__reactInternalMemoizedMergedChildContext;break b}}h=h.return}while(null!==h);throw Error(u(171));}if(1===c.tag){var k=c.type;if(L(k)){c=Ff(c,k,h);break a}}c=h}else c=Af;null===b.context?b.context=c:b.pendingContext=c;b=wg(f,g);b.payload={element:a};d=void 0===
d?null:d;null!==d&&(b.callback=d);xg(e,b);Ig(e,f);return f}function ck(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return a.child.stateNode;default:return a.child.stateNode}}function dk(a,b){a=a.memoizedState;null!==a&&null!==a.dehydrated&&a.retryTime<b&&(a.retryTime=b)}function ek(a,b){dk(a,b);(a=a.alternate)&&dk(a,b)}
function fk(a,b,c){c=null!=c&&!0===c.hydrate;var d=new ak(a,b,c),e=Sh(3,null,null,2===b?7:1===b?3:0);d.current=e;e.stateNode=d;ug(e);a[Od]=d.current;c&&0!==b&&Jc(a,9===a.nodeType?a:a.ownerDocument);this._internalRoot=d}fk.prototype.render=function(a){bk(a,this._internalRoot,null,null)};fk.prototype.unmount=function(){var a=this._internalRoot,b=a.containerInfo;bk(null,a,null,function(){b[Od]=null})};
function gk(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}function hk(a,b){b||(b=a?9===a.nodeType?a.documentElement:a.firstChild:null,b=!(!b||1!==b.nodeType||!b.hasAttribute("data-reactroot")));if(!b)for(var c;c=a.lastChild;)a.removeChild(c);return new fk(a,0,b?{hydrate:!0}:void 0)}
function ik(a,b,c,d,e){var f=c._reactRootContainer;if(f){var g=f._internalRoot;if("function"===typeof e){var h=e;e=function(){var a=ck(g);h.call(a)}}bk(b,g,a,e)}else{f=c._reactRootContainer=hk(c,d);g=f._internalRoot;if("function"===typeof e){var k=e;e=function(){var a=ck(g);k.call(a)}}Nj(function(){bk(b,g,a,e)})}return ck(g)}function jk(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:$a,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}
wc=function(a){if(13===a.tag){var b=hg(Gg(),150,100);Ig(a,b);ek(a,b)}};xc=function(a){13===a.tag&&(Ig(a,3),ek(a,3))};yc=function(a){if(13===a.tag){var b=Gg();b=Hg(b,a,null);Ig(a,b);ek(a,b)}};
za=function(a,b,c){switch(b){case "input":Cb(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=c.parentNode;c=c.querySelectorAll("input[name="+JSON.stringify(""+b)+'][type="radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=Qd(d);if(!e)throw Error(u(90));yb(d);Cb(d,e)}}}break;case "textarea":Kb(a,c);break;case "select":b=c.value,null!=b&&Hb(a,!!c.multiple,b,!1)}};Fa=Mj;
Ga=function(a,b,c,d,e){var f=W;W|=4;try{return cg(98,a.bind(null,b,c,d,e))}finally{W=f,W===V&&gg()}};Ha=function(){(W&(1|fj|gj))===V&&(Lj(),Dj())};Ia=function(a,b){var c=W;W|=2;try{return a(b)}finally{W=c,W===V&&gg()}};function kk(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;if(!gk(b))throw Error(u(200));return jk(a,b,null,c)}var lk={Events:[Nc,Pd,Qd,xa,ta,Xd,function(a){jc(a,Wd)},Da,Ea,id,mc,Dj,{current:!1}]};
(function(a){var b=a.findFiberByHostInstance;return Yj(n({},a,{overrideHookState:null,overrideProps:null,setSuspenseHandler:null,scheduleUpdate:null,currentDispatcherRef:Wa.ReactCurrentDispatcher,findHostInstanceByFiber:function(a){a=hc(a);return null===a?null:a.stateNode},findFiberByHostInstance:function(a){return b?b(a):null},findHostInstancesForRefresh:null,scheduleRefresh:null,scheduleRoot:null,setRefreshHandler:null,getCurrentFiber:null}))})({findFiberByHostInstance:tc,bundleType:0,version:"16.14.0",
rendererPackageName:"react-dom"});exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=lk;exports.createPortal=kk;exports.findDOMNode=function(a){if(null==a)return null;if(1===a.nodeType)return a;var b=a._reactInternalFiber;if(void 0===b){if("function"===typeof a.render)throw Error(u(188));throw Error(u(268,Object.keys(a)));}a=hc(b);a=null===a?null:a.stateNode;return a};
exports.flushSync=function(a,b){if((W&(fj|gj))!==V)throw Error(u(187));var c=W;W|=1;try{return cg(99,a.bind(null,b))}finally{W=c,gg()}};exports.hydrate=function(a,b,c){if(!gk(b))throw Error(u(200));return ik(null,a,b,!0,c)};exports.render=function(a,b,c){if(!gk(b))throw Error(u(200));return ik(null,a,b,!1,c)};
exports.unmountComponentAtNode=function(a){if(!gk(a))throw Error(u(40));return a._reactRootContainer?(Nj(function(){ik(null,null,a,!1,function(){a._reactRootContainer=null;a[Od]=null})}),!0):!1};exports.unstable_batchedUpdates=Mj;exports.unstable_createPortal=function(a,b){return kk(a,b,2<arguments.length&&void 0!==arguments[2]?arguments[2]:null)};
exports.unstable_renderSubtreeIntoContainer=function(a,b,c,d){if(!gk(c))throw Error(u(200));if(null==a||void 0===a._reactInternalFiber)throw Error(u(38));return ik(a,b,c,!1,d)};exports.version="16.14.0";


/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(549);
} else {
  module.exports = require('./cjs/scheduler.development.js');
}


/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v0.19.1
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var f,g,h,k,l;
if("undefined"===typeof window||"function"!==typeof MessageChannel){var p=null,q=null,t=function(){if(null!==p)try{var a=exports.unstable_now();p(!0,a);p=null}catch(b){throw setTimeout(t,0),b;}},u=Date.now();exports.unstable_now=function(){return Date.now()-u};f=function(a){null!==p?setTimeout(f,0,a):(p=a,setTimeout(t,0))};g=function(a,b){q=setTimeout(a,b)};h=function(){clearTimeout(q)};k=function(){return!1};l=exports.unstable_forceFrameRate=function(){}}else{var w=window.performance,x=window.Date,
y=window.setTimeout,z=window.clearTimeout;if("undefined"!==typeof console){var A=window.cancelAnimationFrame;"function"!==typeof window.requestAnimationFrame&&console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills");"function"!==typeof A&&console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills")}if("object"===
typeof w&&"function"===typeof w.now)exports.unstable_now=function(){return w.now()};else{var B=x.now();exports.unstable_now=function(){return x.now()-B}}var C=!1,D=null,E=-1,F=5,G=0;k=function(){return exports.unstable_now()>=G};l=function(){};exports.unstable_forceFrameRate=function(a){0>a||125<a?console.error("forceFrameRate takes a positive int between 0 and 125, forcing framerates higher than 125 fps is not unsupported"):F=0<a?Math.floor(1E3/a):5};var H=new MessageChannel,I=H.port2;H.port1.onmessage=
function(){if(null!==D){var a=exports.unstable_now();G=a+F;try{D(!0,a)?I.postMessage(null):(C=!1,D=null)}catch(b){throw I.postMessage(null),b;}}else C=!1};f=function(a){D=a;C||(C=!0,I.postMessage(null))};g=function(a,b){E=y(function(){a(exports.unstable_now())},b)};h=function(){z(E);E=-1}}function J(a,b){var c=a.length;a.push(b);a:for(;;){var d=c-1>>>1,e=a[d];if(void 0!==e&&0<K(e,b))a[d]=b,a[c]=e,c=d;else break a}}function L(a){a=a[0];return void 0===a?null:a}
function M(a){var b=a[0];if(void 0!==b){var c=a.pop();if(c!==b){a[0]=c;a:for(var d=0,e=a.length;d<e;){var m=2*(d+1)-1,n=a[m],v=m+1,r=a[v];if(void 0!==n&&0>K(n,c))void 0!==r&&0>K(r,n)?(a[d]=r,a[v]=c,d=v):(a[d]=n,a[m]=c,d=m);else if(void 0!==r&&0>K(r,c))a[d]=r,a[v]=c,d=v;else break a}}return b}return null}function K(a,b){var c=a.sortIndex-b.sortIndex;return 0!==c?c:a.id-b.id}var N=[],O=[],P=1,Q=null,R=3,S=!1,T=!1,U=!1;
function V(a){for(var b=L(O);null!==b;){if(null===b.callback)M(O);else if(b.startTime<=a)M(O),b.sortIndex=b.expirationTime,J(N,b);else break;b=L(O)}}function W(a){U=!1;V(a);if(!T)if(null!==L(N))T=!0,f(X);else{var b=L(O);null!==b&&g(W,b.startTime-a)}}
function X(a,b){T=!1;U&&(U=!1,h());S=!0;var c=R;try{V(b);for(Q=L(N);null!==Q&&(!(Q.expirationTime>b)||a&&!k());){var d=Q.callback;if(null!==d){Q.callback=null;R=Q.priorityLevel;var e=d(Q.expirationTime<=b);b=exports.unstable_now();"function"===typeof e?Q.callback=e:Q===L(N)&&M(N);V(b)}else M(N);Q=L(N)}if(null!==Q)var m=!0;else{var n=L(O);null!==n&&g(W,n.startTime-b);m=!1}return m}finally{Q=null,R=c,S=!1}}
function Y(a){switch(a){case 1:return-1;case 2:return 250;case 5:return 1073741823;case 4:return 1E4;default:return 5E3}}var Z=l;exports.unstable_IdlePriority=5;exports.unstable_ImmediatePriority=1;exports.unstable_LowPriority=4;exports.unstable_NormalPriority=3;exports.unstable_Profiling=null;exports.unstable_UserBlockingPriority=2;exports.unstable_cancelCallback=function(a){a.callback=null};exports.unstable_continueExecution=function(){T||S||(T=!0,f(X))};
exports.unstable_getCurrentPriorityLevel=function(){return R};exports.unstable_getFirstCallbackNode=function(){return L(N)};exports.unstable_next=function(a){switch(R){case 1:case 2:case 3:var b=3;break;default:b=R}var c=R;R=b;try{return a()}finally{R=c}};exports.unstable_pauseExecution=function(){};exports.unstable_requestPaint=Z;exports.unstable_runWithPriority=function(a,b){switch(a){case 1:case 2:case 3:case 4:case 5:break;default:a=3}var c=R;R=a;try{return b()}finally{R=c}};
exports.unstable_scheduleCallback=function(a,b,c){var d=exports.unstable_now();if("object"===typeof c&&null!==c){var e=c.delay;e="number"===typeof e&&0<e?d+e:d;c="number"===typeof c.timeout?c.timeout:Y(a)}else c=Y(a),e=d;c=e+c;a={id:P++,callback:b,priorityLevel:a,startTime:e,expirationTime:c,sortIndex:-1};e>d?(a.sortIndex=e,J(O,a),null===L(N)&&a===L(O)&&(U?h():U=!0,g(W,e-d))):(a.sortIndex=c,J(N,a),T||S||(T=!0,f(X)));return a};
exports.unstable_shouldYield=function(){var a=exports.unstable_now();V(a);var b=L(N);return b!==Q&&null!==Q&&null!==b&&null!==b.callback&&b.startTime<=a&&b.expirationTime<Q.expirationTime||k()};exports.unstable_wrapCallback=function(a){var b=R;return function(){var c=R;R=b;try{return a.apply(this,arguments)}finally{R=c}}};


/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(551);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(7);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _focusManager = __webpack_require__(553);

var focusManager = _interopRequireWildcard(_focusManager);

var _scopeTab = __webpack_require__(554);

var _scopeTab2 = _interopRequireDefault(_scopeTab);

var _ariaAppHider = __webpack_require__(252);

var ariaAppHider = _interopRequireWildcard(_ariaAppHider);

var _classList = __webpack_require__(556);

var classList = _interopRequireWildcard(_classList);

var _safeHTMLElement = __webpack_require__(171);

var _safeHTMLElement2 = _interopRequireDefault(_safeHTMLElement);

var _portalOpenInstances = __webpack_require__(253);

var _portalOpenInstances2 = _interopRequireDefault(_portalOpenInstances);

__webpack_require__(557);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// so that our CSS is statically analyzable
var CLASS_NAMES = {
  overlay: "ReactModal__Overlay",
  content: "ReactModal__Content"
};

var TAB_KEY = 9;
var ESC_KEY = 27;

var ariaHiddenInstances = 0;

var ModalPortal = function (_Component) {
  _inherits(ModalPortal, _Component);

  function ModalPortal(props) {
    _classCallCheck(this, ModalPortal);

    var _this = _possibleConstructorReturn(this, (ModalPortal.__proto__ || Object.getPrototypeOf(ModalPortal)).call(this, props));

    _this.setOverlayRef = function (overlay) {
      _this.overlay = overlay;
      _this.props.overlayRef && _this.props.overlayRef(overlay);
    };

    _this.setContentRef = function (content) {
      _this.content = content;
      _this.props.contentRef && _this.props.contentRef(content);
    };

    _this.afterClose = function () {
      var _this$props = _this.props,
          appElement = _this$props.appElement,
          ariaHideApp = _this$props.ariaHideApp,
          htmlOpenClassName = _this$props.htmlOpenClassName,
          bodyOpenClassName = _this$props.bodyOpenClassName;

      // Remove classes.

      bodyOpenClassName && classList.remove(document.body, bodyOpenClassName);

      htmlOpenClassName && classList.remove(document.getElementsByTagName("html")[0], htmlOpenClassName);

      // Reset aria-hidden attribute if all modals have been removed
      if (ariaHideApp && ariaHiddenInstances > 0) {
        ariaHiddenInstances -= 1;

        if (ariaHiddenInstances === 0) {
          ariaAppHider.show(appElement);
        }
      }

      if (_this.props.shouldFocusAfterRender) {
        if (_this.props.shouldReturnFocusAfterClose) {
          focusManager.returnFocus();
          focusManager.teardownScopedFocus();
        } else {
          focusManager.popWithoutFocus();
        }
      }

      if (_this.props.onAfterClose) {
        _this.props.onAfterClose();
      }

      _portalOpenInstances2.default.deregister(_this);
    };

    _this.open = function () {
      _this.beforeOpen();
      if (_this.state.afterOpen && _this.state.beforeClose) {
        clearTimeout(_this.closeTimer);
        _this.setState({ beforeClose: false });
      } else {
        if (_this.props.shouldFocusAfterRender) {
          focusManager.setupScopedFocus(_this.node);
          focusManager.markForFocusLater();
        }

        _this.setState({ isOpen: true }, function () {
          _this.setState({ afterOpen: true });

          if (_this.props.isOpen && _this.props.onAfterOpen) {
            _this.props.onAfterOpen({
              overlayEl: _this.overlay,
              contentEl: _this.content
            });
          }
        });
      }
    };

    _this.close = function () {
      if (_this.props.closeTimeoutMS > 0) {
        _this.closeWithTimeout();
      } else {
        _this.closeWithoutTimeout();
      }
    };

    _this.focusContent = function () {
      return _this.content && !_this.contentHasFocus() && _this.content.focus();
    };

    _this.closeWithTimeout = function () {
      var closesAt = Date.now() + _this.props.closeTimeoutMS;
      _this.setState({ beforeClose: true, closesAt: closesAt }, function () {
        _this.closeTimer = setTimeout(_this.closeWithoutTimeout, _this.state.closesAt - Date.now());
      });
    };

    _this.closeWithoutTimeout = function () {
      _this.setState({
        beforeClose: false,
        isOpen: false,
        afterOpen: false,
        closesAt: null
      }, _this.afterClose);
    };

    _this.handleKeyDown = function (event) {
      if (event.keyCode === TAB_KEY) {
        (0, _scopeTab2.default)(_this.content, event);
      }

      if (_this.props.shouldCloseOnEsc && event.keyCode === ESC_KEY) {
        event.stopPropagation();
        _this.requestClose(event);
      }
    };

    _this.handleOverlayOnClick = function (event) {
      if (_this.shouldClose === null) {
        _this.shouldClose = true;
      }

      if (_this.shouldClose && _this.props.shouldCloseOnOverlayClick) {
        if (_this.ownerHandlesClose()) {
          _this.requestClose(event);
        } else {
          _this.focusContent();
        }
      }
      _this.shouldClose = null;
    };

    _this.handleContentOnMouseUp = function () {
      _this.shouldClose = false;
    };

    _this.handleOverlayOnMouseDown = function (event) {
      if (!_this.props.shouldCloseOnOverlayClick && event.target == _this.overlay) {
        event.preventDefault();
      }
    };

    _this.handleContentOnClick = function () {
      _this.shouldClose = false;
    };

    _this.handleContentOnMouseDown = function () {
      _this.shouldClose = false;
    };

    _this.requestClose = function (event) {
      return _this.ownerHandlesClose() && _this.props.onRequestClose(event);
    };

    _this.ownerHandlesClose = function () {
      return _this.props.onRequestClose;
    };

    _this.shouldBeClosed = function () {
      return !_this.state.isOpen && !_this.state.beforeClose;
    };

    _this.contentHasFocus = function () {
      return document.activeElement === _this.content || _this.content.contains(document.activeElement);
    };

    _this.buildClassName = function (which, additional) {
      var classNames = (typeof additional === "undefined" ? "undefined" : _typeof(additional)) === "object" ? additional : {
        base: CLASS_NAMES[which],
        afterOpen: CLASS_NAMES[which] + "--after-open",
        beforeClose: CLASS_NAMES[which] + "--before-close"
      };
      var className = classNames.base;
      if (_this.state.afterOpen) {
        className = className + " " + classNames.afterOpen;
      }
      if (_this.state.beforeClose) {
        className = className + " " + classNames.beforeClose;
      }
      return typeof additional === "string" && additional ? className + " " + additional : className;
    };

    _this.attributesFromObject = function (prefix, items) {
      return Object.keys(items).reduce(function (acc, name) {
        acc[prefix + "-" + name] = items[name];
        return acc;
      }, {});
    };

    _this.state = {
      afterOpen: false,
      beforeClose: false
    };

    _this.shouldClose = null;
    _this.moveFromContentToOverlay = null;
    return _this;
  }

  _createClass(ModalPortal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.isOpen) {
        this.open();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (false) {
        if (prevProps.bodyOpenClassName !== this.props.bodyOpenClassName) {
          // eslint-disable-next-line no-console
          console.warn('React-Modal: "bodyOpenClassName" prop has been modified. ' + "This may cause unexpected behavior when multiple modals are open.");
        }
        if (prevProps.htmlOpenClassName !== this.props.htmlOpenClassName) {
          // eslint-disable-next-line no-console
          console.warn('React-Modal: "htmlOpenClassName" prop has been modified. ' + "This may cause unexpected behavior when multiple modals are open.");
        }
      }

      if (this.props.isOpen && !prevProps.isOpen) {
        this.open();
      } else if (!this.props.isOpen && prevProps.isOpen) {
        this.close();
      }

      // Focus only needs to be set once when the modal is being opened
      if (this.props.shouldFocusAfterRender && this.state.isOpen && !prevState.isOpen) {
        this.focusContent();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.state.isOpen) {
        this.afterClose();
      }
      clearTimeout(this.closeTimer);
    }
  }, {
    key: "beforeOpen",
    value: function beforeOpen() {
      var _props = this.props,
          appElement = _props.appElement,
          ariaHideApp = _props.ariaHideApp,
          htmlOpenClassName = _props.htmlOpenClassName,
          bodyOpenClassName = _props.bodyOpenClassName;

      // Add classes.

      bodyOpenClassName && classList.add(document.body, bodyOpenClassName);

      htmlOpenClassName && classList.add(document.getElementsByTagName("html")[0], htmlOpenClassName);

      if (ariaHideApp) {
        ariaHiddenInstances += 1;
        ariaAppHider.hide(appElement);
      }

      _portalOpenInstances2.default.register(this);
    }

    // Don't steal focus from inner elements

  }, {
    key: "render",
    value: function render() {
      var _props2 = this.props,
          id = _props2.id,
          className = _props2.className,
          overlayClassName = _props2.overlayClassName,
          defaultStyles = _props2.defaultStyles;

      var contentStyles = className ? {} : defaultStyles.content;
      var overlayStyles = overlayClassName ? {} : defaultStyles.overlay;

      return this.shouldBeClosed() ? null : _react2.default.createElement(
        "div",
        {
          ref: this.setOverlayRef,
          className: this.buildClassName("overlay", overlayClassName),
          style: _extends({}, overlayStyles, this.props.style.overlay),
          onClick: this.handleOverlayOnClick,
          onMouseDown: this.handleOverlayOnMouseDown
        },
        _react2.default.createElement(
          "div",
          _extends({
            id: id,
            ref: this.setContentRef,
            style: _extends({}, contentStyles, this.props.style.content),
            className: this.buildClassName("content", className),
            tabIndex: "-1",
            onKeyDown: this.handleKeyDown,
            onMouseDown: this.handleContentOnMouseDown,
            onMouseUp: this.handleContentOnMouseUp,
            onClick: this.handleContentOnClick,
            role: this.props.role,
            "aria-label": this.props.contentLabel
          }, this.attributesFromObject("aria", this.props.aria || {}), this.attributesFromObject("data", this.props.data || {}), {
            "data-testid": this.props.testId
          }),
          this.props.children
        )
      );
    }
  }]);

  return ModalPortal;
}(_react.Component);

ModalPortal.defaultProps = {
  style: {
    overlay: {},
    content: {}
  },
  defaultStyles: {}
};
ModalPortal.propTypes = {
  isOpen: _propTypes2.default.bool.isRequired,
  defaultStyles: _propTypes2.default.shape({
    content: _propTypes2.default.object,
    overlay: _propTypes2.default.object
  }),
  style: _propTypes2.default.shape({
    content: _propTypes2.default.object,
    overlay: _propTypes2.default.object
  }),
  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  overlayClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  bodyOpenClassName: _propTypes2.default.string,
  htmlOpenClassName: _propTypes2.default.string,
  ariaHideApp: _propTypes2.default.bool,
  appElement: _propTypes2.default.instanceOf(_safeHTMLElement2.default),
  onAfterOpen: _propTypes2.default.func,
  onAfterClose: _propTypes2.default.func,
  onRequestClose: _propTypes2.default.func,
  closeTimeoutMS: _propTypes2.default.number,
  shouldFocusAfterRender: _propTypes2.default.bool,
  shouldCloseOnOverlayClick: _propTypes2.default.bool,
  shouldReturnFocusAfterClose: _propTypes2.default.bool,
  role: _propTypes2.default.string,
  contentLabel: _propTypes2.default.string,
  aria: _propTypes2.default.object,
  data: _propTypes2.default.object,
  children: _propTypes2.default.node,
  shouldCloseOnEsc: _propTypes2.default.bool,
  overlayRef: _propTypes2.default.func,
  contentRef: _propTypes2.default.func,
  id: _propTypes2.default.string,
  testId: _propTypes2.default.string
};
exports.default = ModalPortal;
module.exports = exports["default"];

/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleBlur = handleBlur;
exports.handleFocus = handleFocus;
exports.markForFocusLater = markForFocusLater;
exports.returnFocus = returnFocus;
exports.popWithoutFocus = popWithoutFocus;
exports.setupScopedFocus = setupScopedFocus;
exports.teardownScopedFocus = teardownScopedFocus;

var _tabbable = __webpack_require__(251);

var _tabbable2 = _interopRequireDefault(_tabbable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var focusLaterElements = [];
var modalElement = null;
var needToFocus = false;

function handleBlur() {
  needToFocus = true;
}

function handleFocus() {
  if (needToFocus) {
    needToFocus = false;
    if (!modalElement) {
      return;
    }
    // need to see how jQuery shims document.on('focusin') so we don't need the
    // setTimeout, firefox doesn't support focusin, if it did, we could focus
    // the element outside of a setTimeout. Side-effect of this implementation
    // is that the document.body gets focus, and then we focus our element right
    // after, seems fine.
    setTimeout(function () {
      if (modalElement.contains(document.activeElement)) {
        return;
      }
      var el = (0, _tabbable2.default)(modalElement)[0] || modalElement;
      el.focus();
    }, 0);
  }
}

function markForFocusLater() {
  focusLaterElements.push(document.activeElement);
}

/* eslint-disable no-console */
function returnFocus() {
  var toFocus = null;
  try {
    if (focusLaterElements.length !== 0) {
      toFocus = focusLaterElements.pop();
      toFocus.focus();
    }
    return;
  } catch (e) {
    console.warn(["You tried to return focus to", toFocus, "but it is not in the DOM anymore"].join(" "));
  }
}
/* eslint-enable no-console */

function popWithoutFocus() {
  focusLaterElements.length > 0 && focusLaterElements.pop();
}

function setupScopedFocus(element) {
  modalElement = element;

  if (window.addEventListener) {
    window.addEventListener("blur", handleBlur, false);
    document.addEventListener("focus", handleFocus, true);
  } else {
    window.attachEvent("onBlur", handleBlur);
    document.attachEvent("onFocus", handleFocus);
  }
}

function teardownScopedFocus() {
  modalElement = null;

  if (window.addEventListener) {
    window.removeEventListener("blur", handleBlur);
    document.removeEventListener("focus", handleFocus);
  } else {
    window.detachEvent("onBlur", handleBlur);
    document.detachEvent("onFocus", handleFocus);
  }
}

/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = scopeTab;

var _tabbable = __webpack_require__(251);

var _tabbable2 = _interopRequireDefault(_tabbable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function scopeTab(node, event) {
  var tabbable = (0, _tabbable2.default)(node);

  if (!tabbable.length) {
    // Do nothing, since there are no elements that can receive focus.
    event.preventDefault();
    return;
  }

  var target = void 0;

  var shiftKey = event.shiftKey;
  var head = tabbable[0];
  var tail = tabbable[tabbable.length - 1];

  // proceed with default browser behavior on tab.
  // Focus on last element on shift + tab.
  if (node === document.activeElement) {
    if (!shiftKey) return;
    target = tail;
  }

  if (tail === document.activeElement && !shiftKey) {
    target = head;
  }

  if (head === document.activeElement && shiftKey) {
    target = tail;
  }

  if (target) {
    event.preventDefault();
    target.focus();
    return;
  }

  // Safari radio issue.
  //
  // Safari does not move the focus to the radio button,
  // so we need to force it to really walk through all elements.
  //
  // This is very error prone, since we are trying to guess
  // if it is a safari browser from the first occurence between
  // chrome or safari.
  //
  // The chrome user agent contains the first ocurrence
  // as the 'chrome/version' and later the 'safari/version'.
  var checkSafari = /(\bChrome\b|\bSafari\b)\//.exec(navigator.userAgent);
  var isSafariDesktop = checkSafari != null && checkSafari[1] != "Chrome" && /\biPod\b|\biPad\b/g.exec(navigator.userAgent) == null;

  // If we are not in safari desktop, let the browser control
  // the focus
  if (!isSafariDesktop) return;

  var x = tabbable.indexOf(document.activeElement);

  if (x > -1) {
    x += shiftKey ? -1 : 1;
  }

  target = tabbable[x];

  // If the tabbable element does not exist,
  // focus head/tail based on shiftKey
  if (typeof target === "undefined") {
    event.preventDefault();
    target = shiftKey ? tail : head;
    target.focus();
    return;
  }

  event.preventDefault();

  target.focus();
}
module.exports = exports["default"];

/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2015 Jed Watson.
  Based on code that is Copyright 2013-2015, Facebook, Inc.
  All rights reserved.
*/
/* global define */

(function () {
	'use strict';

	var canUseDOM = !!(
		typeof window !== 'undefined' &&
		window.document &&
		window.document.createElement
	);

	var ExecutionEnvironment = {

		canUseDOM: canUseDOM,

		canUseWorkers: typeof Worker !== 'undefined',

		canUseEventListeners:
			canUseDOM && !!(window.addEventListener || window.attachEvent),

		canUseViewport: canUseDOM && !!window.screen

	};

	if (true) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return ExecutionEnvironment;
		}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (typeof module !== 'undefined' && module.exports) {
		module.exports = ExecutionEnvironment;
	} else {
		window.ExecutionEnvironment = ExecutionEnvironment;
	}

}());


/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dumpClassLists = dumpClassLists;
var htmlClassList = {};
var docBodyClassList = {};

function dumpClassLists() {
  if (false) {
    var classes = document.getElementsByTagName("html")[0].className;
    var buffer = "Show tracked classes:\n\n";

    buffer += "<html /> (" + classes + "):\n";
    for (var x in htmlClassList) {
      buffer += "  " + x + " " + htmlClassList[x] + "\n";
    }

    classes = document.body.className;

    // eslint-disable-next-line max-len
    buffer += "\n\ndoc.body (" + classes + "):\n";
    for (var _x in docBodyClassList) {
      buffer += "  " + _x + " " + docBodyClassList[_x] + "\n";
    }

    buffer += "\n";

    // eslint-disable-next-line no-console
    console.log(buffer);
  }
}

/**
 * Track the number of reference of a class.
 * @param {object} poll The poll to receive the reference.
 * @param {string} className The class name.
 * @return {string}
 */
var incrementReference = function incrementReference(poll, className) {
  if (!poll[className]) {
    poll[className] = 0;
  }
  poll[className] += 1;
  return className;
};

/**
 * Drop the reference of a class.
 * @param {object} poll The poll to receive the reference.
 * @param {string} className The class name.
 * @return {string}
 */
var decrementReference = function decrementReference(poll, className) {
  if (poll[className]) {
    poll[className] -= 1;
  }
  return className;
};

/**
 * Track a class and add to the given class list.
 * @param {Object} classListRef A class list of an element.
 * @param {Object} poll         The poll to be used.
 * @param {Array}  classes      The list of classes to be tracked.
 */
var trackClass = function trackClass(classListRef, poll, classes) {
  classes.forEach(function (className) {
    incrementReference(poll, className);
    classListRef.add(className);
  });
};

/**
 * Untrack a class and remove from the given class list if the reference
 * reaches 0.
 * @param {Object} classListRef A class list of an element.
 * @param {Object} poll         The poll to be used.
 * @param {Array}  classes      The list of classes to be untracked.
 */
var untrackClass = function untrackClass(classListRef, poll, classes) {
  classes.forEach(function (className) {
    decrementReference(poll, className);
    poll[className] === 0 && classListRef.remove(className);
  });
};

/**
 * Public inferface to add classes to the document.body.
 * @param {string} bodyClass The class string to be added.
 *                           It may contain more then one class
 *                           with ' ' as separator.
 */
var add = exports.add = function add(element, classString) {
  return trackClass(element.classList, element.nodeName.toLowerCase() == "html" ? htmlClassList : docBodyClassList, classString.split(" "));
};

/**
 * Public inferface to remove classes from the document.body.
 * @param {string} bodyClass The class string to be added.
 *                           It may contain more then one class
 *                           with ' ' as separator.
 */
var remove = exports.remove = function remove(element, classString) {
  return untrackClass(element.classList, element.nodeName.toLowerCase() == "html" ? htmlClassList : docBodyClassList, classString.split(" "));
};

/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _portalOpenInstances = __webpack_require__(253);

var _portalOpenInstances2 = _interopRequireDefault(_portalOpenInstances);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Body focus trap see Issue #742

var before = void 0,
    after = void 0,
    instances = [];

function focusContent() {
  if (instances.length === 0) {
    if (false) {
      // eslint-disable-next-line no-console
      console.warn("React-Modal: Open instances > 0 expected");
    }
    return;
  }
  instances[instances.length - 1].focusContent();
}

function bodyTrap(eventType, openInstances) {
  if (!before || !after) {
    before = document.createElement("div");
    before.setAttribute("data-react-modal-body-trap", "");
    before.style.position = "absolute";
    before.style.opacity = "0";
    before.setAttribute("tabindex", "0");
    before.addEventListener("focus", focusContent);
    after = before.cloneNode();
    after.addEventListener("focus", focusContent);
  }

  instances = openInstances;

  if (instances.length > 0) {
    // Add focus trap
    if (document.body.firstChild !== before) {
      document.body.insertBefore(before, document.body.firstChild);
    }
    if (document.body.lastChild !== after) {
      document.body.appendChild(after);
    }
  } else {
    // Remove focus trap
    if (before.parentElement) {
      before.parentElement.removeChild(before);
    }
    if (after.parentElement) {
      after.parentElement.removeChild(after);
    }
  }
}

_portalOpenInstances2.default.subscribe(bodyTrap);

/***/ }),
/* 558 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "polyfill", function() { return polyfill; });
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

function componentWillMount() {
  // Call this.constructor.gDSFP to support sub-classes.
  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
  if (state !== null && state !== undefined) {
    this.setState(state);
  }
}

function componentWillReceiveProps(nextProps) {
  // Call this.constructor.gDSFP to support sub-classes.
  // Use the setState() updater to ensure state isn't stale in certain edge cases.
  function updater(prevState) {
    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
    return state !== null && state !== undefined ? state : null;
  }
  // Binding "this" is important for shallow renderer support.
  this.setState(updater.bind(this));
}

function componentWillUpdate(nextProps, nextState) {
  try {
    var prevProps = this.props;
    var prevState = this.state;
    this.props = nextProps;
    this.state = nextState;
    this.__reactInternalSnapshotFlag = true;
    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
      prevProps,
      prevState
    );
  } finally {
    this.props = prevProps;
    this.state = prevState;
  }
}

// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
componentWillMount.__suppressDeprecationWarning = true;
componentWillReceiveProps.__suppressDeprecationWarning = true;
componentWillUpdate.__suppressDeprecationWarning = true;

function polyfill(Component) {
  var prototype = Component.prototype;

  if (!prototype || !prototype.isReactComponent) {
    throw new Error('Can only polyfill class components');
  }

  if (
    typeof Component.getDerivedStateFromProps !== 'function' &&
    typeof prototype.getSnapshotBeforeUpdate !== 'function'
  ) {
    return Component;
  }

  // If new component APIs are defined, "unsafe" lifecycles won't be called.
  // Error if any of these lifecycles are present,
  // Because they would work differently between older and newer (16.3+) versions of React.
  var foundWillMountName = null;
  var foundWillReceivePropsName = null;
  var foundWillUpdateName = null;
  if (typeof prototype.componentWillMount === 'function') {
    foundWillMountName = 'componentWillMount';
  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
    foundWillMountName = 'UNSAFE_componentWillMount';
  }
  if (typeof prototype.componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'componentWillReceiveProps';
  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
  }
  if (typeof prototype.componentWillUpdate === 'function') {
    foundWillUpdateName = 'componentWillUpdate';
  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
  }
  if (
    foundWillMountName !== null ||
    foundWillReceivePropsName !== null ||
    foundWillUpdateName !== null
  ) {
    var componentName = Component.displayName || Component.name;
    var newApiName =
      typeof Component.getDerivedStateFromProps === 'function'
        ? 'getDerivedStateFromProps()'
        : 'getSnapshotBeforeUpdate()';

    throw Error(
      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
        componentName +
        ' uses ' +
        newApiName +
        ' but also contains the following legacy lifecycles:' +
        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
        (foundWillReceivePropsName !== null
          ? '\n  ' + foundWillReceivePropsName
          : '') +
        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
        'https://fb.me/react-async-component-lifecycle-hooks'
    );
  }

  // React <= 16.2 does not support static getDerivedStateFromProps.
  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
  // Newer versions of React will ignore these lifecycles if gDSFP exists.
  if (typeof Component.getDerivedStateFromProps === 'function') {
    prototype.componentWillMount = componentWillMount;
    prototype.componentWillReceiveProps = componentWillReceiveProps;
  }

  // React <= 16.2 does not support getSnapshotBeforeUpdate.
  // As a workaround, use cWU to invoke the new lifecycle.
  // Newer versions of React will ignore that lifecycle if gSBU exists.
  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
    if (typeof prototype.componentDidUpdate !== 'function') {
      throw new Error(
        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
      );
    }

    prototype.componentWillUpdate = componentWillUpdate;

    var componentDidUpdate = prototype.componentDidUpdate;

    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
      prevProps,
      prevState,
      maybeSnapshot
    ) {
      // 16.3+ will not execute our will-update method;
      // It will pass a snapshot value to did-update though.
      // Older versions will require our polyfilled will-update value.
      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
      // Because for <= 15.x versions this might be a "prevContext" object.
      // We also can't just check "__reactInternalSnapshot",
      // Because get-snapshot might return a falsy value.
      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
      var snapshot = this.__reactInternalSnapshotFlag
        ? this.__reactInternalSnapshot
        : maybeSnapshot;

      componentDidUpdate.call(this, prevProps, prevState, snapshot);
    };
  }

  return Component;
}




/***/ }),
/* 559 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(172);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that uses HTML5 history.
 */

var BrowserRouter = function (_React$Component) {
  _inherits(BrowserRouter, _React$Component);

  function BrowserRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, BrowserRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["a" /* createBrowserHistory */])(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  BrowserRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<BrowserRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { BrowserRouter as Router }`.");
  };

  BrowserRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return BrowserRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

BrowserRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  forceRefresh: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  keyLength: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* harmony default export */ __webpack_exports__["a"] = (BrowserRouter);

/***/ }),
/* 560 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function isAbsolute(pathname) {
  return pathname.charAt(0) === '/';
}

// About 1.5x faster than the two-arg version of Array#splice()
function spliceOne(list, index) {
  for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1) {
    list[i] = list[k];
  }

  list.pop();
}

// This implementation is based heavily on node's url.parse
function resolvePathname(to, from) {
  if (from === undefined) from = '';

  var toParts = (to && to.split('/')) || [];
  var fromParts = (from && from.split('/')) || [];

  var isToAbs = to && isAbsolute(to);
  var isFromAbs = from && isAbsolute(from);
  var mustEndAbs = isToAbs || isFromAbs;

  if (to && isAbsolute(to)) {
    // to is absolute
    fromParts = toParts;
  } else if (toParts.length) {
    // to is relative, drop the filename
    fromParts.pop();
    fromParts = fromParts.concat(toParts);
  }

  if (!fromParts.length) return '/';

  var hasTrailingSlash;
  if (fromParts.length) {
    var last = fromParts[fromParts.length - 1];
    hasTrailingSlash = last === '.' || last === '..' || last === '';
  } else {
    hasTrailingSlash = false;
  }

  var up = 0;
  for (var i = fromParts.length; i >= 0; i--) {
    var part = fromParts[i];

    if (part === '.') {
      spliceOne(fromParts, i);
    } else if (part === '..') {
      spliceOne(fromParts, i);
      up++;
    } else if (up) {
      spliceOne(fromParts, i);
      up--;
    }
  }

  if (!mustEndAbs) for (; up--; up) fromParts.unshift('..');

  if (
    mustEndAbs &&
    fromParts[0] !== '' &&
    (!fromParts[0] || !isAbsolute(fromParts[0]))
  )
    fromParts.unshift('');

  var result = fromParts.join('/');

  if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';

  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (resolvePathname);


/***/ }),
/* 561 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function valueOf(obj) {
  return obj.valueOf ? obj.valueOf() : Object.prototype.valueOf.call(obj);
}

function valueEqual(a, b) {
  // Test for strict equality first.
  if (a === b) return true;

  // Otherwise, if either of them == null they are not equal.
  if (a == null || b == null) return false;

  if (Array.isArray(a)) {
    return (
      Array.isArray(b) &&
      a.length === b.length &&
      a.every(function(item, index) {
        return valueEqual(item, b[index]);
      })
    );
  }

  if (typeof a === 'object' || typeof b === 'object') {
    var aValue = valueOf(a);
    var bValue = valueOf(b);

    if (aValue !== a || bValue !== b) return valueEqual(aValue, bValue);

    return Object.keys(Object.assign({}, a, b)).every(function(key) {
      return valueEqual(a[key], b[key]);
    });
  }

  return false;
}

/* harmony default export */ __webpack_exports__["a"] = (valueEqual);


/***/ }),
/* 562 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var isProduction = "production" === 'production';
function warning(condition, message) {
  if (!isProduction) {
    if (condition) {
      return;
    }

    var text = "Warning: " + message;

    if (typeof console !== 'undefined') {
      console.warn(text);
    }

    try {
      throw Error(text);
    } catch (x) {}
  }
}

/* unused harmony default export */ var _unused_webpack_default_export = (warning);


/***/ }),
/* 563 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var isProduction = "production" === 'production';
var prefix = 'Invariant failed';
function invariant(condition, message) {
    if (condition) {
        return;
    }
    if (isProduction) {
        throw new Error(prefix);
    }
    throw new Error(prefix + ": " + (message || ''));
}

/* harmony default export */ __webpack_exports__["a"] = (invariant);


/***/ }),
/* 564 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(172);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that uses window.location.hash.
 */

var HashRouter = function (_React$Component) {
  _inherits(HashRouter, _React$Component);

  function HashRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, HashRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["b" /* createHashHistory */])(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  HashRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<HashRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { HashRouter as Router }`.");
  };

  HashRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return HashRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

HashRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  hashType: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(["hashbang", "noslash", "slash"]),
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* unused harmony default export */ var _unused_webpack_default_export = (HashRouter);

/***/ }),
/* 565 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_MemoryRouter__ = __webpack_require__(566);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_MemoryRouter__["a" /* default */]);

/***/ }),
/* 566 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(173);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that stores location in memory.
 */

var MemoryRouter = function (_React$Component) {
  _inherits(MemoryRouter, _React$Component);

  function MemoryRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, MemoryRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["d" /* createMemoryHistory */])(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  MemoryRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<MemoryRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { MemoryRouter as Router }`.");
  };

  MemoryRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return MemoryRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

MemoryRouter.propTypes = {
  initialEntries: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,
  initialIndex: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  keyLength: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* harmony default export */ __webpack_exports__["a"] = (MemoryRouter);

/***/ }),
/* 567 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Route__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Link__ = __webpack_require__(254);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * A <Link> wrapper that knows if it's "active" or not.
 */
var NavLink = function NavLink(_ref) {
  var to = _ref.to,
      exact = _ref.exact,
      strict = _ref.strict,
      location = _ref.location,
      activeClassName = _ref.activeClassName,
      className = _ref.className,
      activeStyle = _ref.activeStyle,
      style = _ref.style,
      getIsActive = _ref.isActive,
      ariaCurrent = _ref["aria-current"],
      rest = _objectWithoutProperties(_ref, ["to", "exact", "strict", "location", "activeClassName", "className", "activeStyle", "style", "isActive", "aria-current"]);

  var path = (typeof to === "undefined" ? "undefined" : _typeof(to)) === "object" ? to.pathname : to;

  // Regex taken from: https://github.com/pillarjs/path-to-regexp/blob/master/index.js#L202
  var escapedPath = path && path.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Route__["a" /* default */], {
    path: escapedPath,
    exact: exact,
    strict: strict,
    location: location,
    children: function children(_ref2) {
      var location = _ref2.location,
          match = _ref2.match;

      var isActive = !!(getIsActive ? getIsActive(match, location) : match);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Link__["a" /* default */], _extends({
        to: to,
        className: isActive ? [className, activeClassName].filter(function (i) {
          return i;
        }).join(" ") : className,
        style: isActive ? _extends({}, style, activeStyle) : style,
        "aria-current": isActive && ariaCurrent || null
      }, rest));
    }
  });
};

NavLink.propTypes = {
  to: __WEBPACK_IMPORTED_MODULE_3__Link__["a" /* default */].propTypes.to,
  exact: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  strict: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  activeClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  activeStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  isActive: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  "aria-current": __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["page", "step", "location", "date", "time", "true"])
};

NavLink.defaultProps = {
  activeClassName: "active",
  "aria-current": "page"
};

/* harmony default export */ __webpack_exports__["a"] = (NavLink);

/***/ }),
/* 568 */
/***/ (function(module, exports) {

module.exports = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};


/***/ }),
/* 569 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Prompt__ = __webpack_require__(570);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Prompt__["a" /* default */]);

/***/ }),
/* 570 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





/**
 * The public API for prompting the user before navigating away
 * from a screen with a component.
 */

var Prompt = function (_React$Component) {
  _inherits(Prompt, _React$Component);

  function Prompt() {
    _classCallCheck(this, Prompt);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Prompt.prototype.enable = function enable(message) {
    if (this.unblock) this.unblock();

    this.unblock = this.context.router.history.block(message);
  };

  Prompt.prototype.disable = function disable() {
    if (this.unblock) {
      this.unblock();
      this.unblock = null;
    }
  };

  Prompt.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(this.context.router, "You should not use <Prompt> outside a <Router>");

    if (this.props.when) this.enable(this.props.message);
  };

  Prompt.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.when) {
      if (!this.props.when || this.props.message !== nextProps.message) this.enable(nextProps.message);
    } else {
      this.disable();
    }
  };

  Prompt.prototype.componentWillUnmount = function componentWillUnmount() {
    this.disable();
  };

  Prompt.prototype.render = function render() {
    return null;
  };

  return Prompt;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Prompt.propTypes = {
  when: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  message: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]).isRequired
};
Prompt.defaultProps = {
  when: true
};
Prompt.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      block: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Prompt);

/***/ }),
/* 571 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Redirect__ = __webpack_require__(572);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Redirect__["a" /* default */]);

/***/ }),
/* 572 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__generatePath__ = __webpack_require__(258);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








/**
 * The public API for updating the location programmatically
 * with a component.
 */

var Redirect = function (_React$Component) {
  _inherits(Redirect, _React$Component);

  function Redirect() {
    _classCallCheck(this, Redirect);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Redirect.prototype.isStatic = function isStatic() {
    return this.context.router && this.context.router.staticContext;
  };

  Redirect.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.context.router, "You should not use <Redirect> outside a <Router>");

    if (this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidMount = function componentDidMount() {
    if (!this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    var prevTo = Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(prevProps.to);
    var nextTo = Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(this.props.to);

    if (Object(__WEBPACK_IMPORTED_MODULE_4_history__["f" /* locationsAreEqual */])(prevTo, nextTo)) {
      __WEBPACK_IMPORTED_MODULE_2_warning___default()(false, "You tried to redirect to the same route you're currently on: " + ("\"" + nextTo.pathname + nextTo.search + "\""));
      return;
    }

    this.perform();
  };

  Redirect.prototype.computeTo = function computeTo(_ref) {
    var computedMatch = _ref.computedMatch,
        to = _ref.to;

    if (computedMatch) {
      if (typeof to === "string") {
        return Object(__WEBPACK_IMPORTED_MODULE_5__generatePath__["a" /* default */])(to, computedMatch.params);
      } else {
        return _extends({}, to, {
          pathname: Object(__WEBPACK_IMPORTED_MODULE_5__generatePath__["a" /* default */])(to.pathname, computedMatch.params)
        });
      }
    }

    return to;
  };

  Redirect.prototype.perform = function perform() {
    var history = this.context.router.history;
    var push = this.props.push;

    var to = this.computeTo(this.props);

    if (push) {
      history.push(to);
    } else {
      history.replace(to);
    }
  };

  Redirect.prototype.render = function render() {
    return null;
  };

  return Redirect;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Redirect.propTypes = {
  computedMatch: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, // private, from <Switch>
  push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  from: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired
};
Redirect.defaultProps = {
  push: false
};
Redirect.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired,
    staticContext: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Redirect);

/***/ }),
/* 573 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_StaticRouter__ = __webpack_require__(574);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_StaticRouter__["a" /* default */]);

/***/ }),
/* 574 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Router__ = __webpack_require__(173);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var addLeadingSlash = function addLeadingSlash(path) {
  return path.charAt(0) === "/" ? path : "/" + path;
};

var addBasename = function addBasename(basename, location) {
  if (!basename) return location;

  return _extends({}, location, {
    pathname: addLeadingSlash(basename) + location.pathname
  });
};

var stripBasename = function stripBasename(basename, location) {
  if (!basename) return location;

  var base = addLeadingSlash(basename);

  if (location.pathname.indexOf(base) !== 0) return location;

  return _extends({}, location, {
    pathname: location.pathname.substr(base.length)
  });
};

var createURL = function createURL(location) {
  return typeof location === "string" ? location : Object(__WEBPACK_IMPORTED_MODULE_4_history__["e" /* createPath */])(location);
};

var staticHandler = function staticHandler(methodName) {
  return function () {
    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(false, "You cannot %s with <StaticRouter>", methodName);
  };
};

var noop = function noop() {};

/**
 * The public top-level API for a "static" <Router>, so-called because it
 * can't actually change the current location. Instead, it just records
 * location changes in a context object. Useful mainly in testing and
 * server-rendering scenarios.
 */

var StaticRouter = function (_React$Component) {
  _inherits(StaticRouter, _React$Component);

  function StaticRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, StaticRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.createHref = function (path) {
      return addLeadingSlash(_this.props.basename + createURL(path));
    }, _this.handlePush = function (location) {
      var _this$props = _this.props,
          basename = _this$props.basename,
          context = _this$props.context;

      context.action = "PUSH";
      context.location = addBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(location));
      context.url = createURL(context.location);
    }, _this.handleReplace = function (location) {
      var _this$props2 = _this.props,
          basename = _this$props2.basename,
          context = _this$props2.context;

      context.action = "REPLACE";
      context.location = addBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(location));
      context.url = createURL(context.location);
    }, _this.handleListen = function () {
      return noop;
    }, _this.handleBlock = function () {
      return noop;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  StaticRouter.prototype.getChildContext = function getChildContext() {
    return {
      router: {
        staticContext: this.props.context
      }
    };
  };

  StaticRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<StaticRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { StaticRouter as Router }`.");
  };

  StaticRouter.prototype.render = function render() {
    var _props = this.props,
        basename = _props.basename,
        context = _props.context,
        location = _props.location,
        props = _objectWithoutProperties(_props, ["basename", "context", "location"]);

    var history = {
      createHref: this.createHref,
      action: "POP",
      location: stripBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(location)),
      push: this.handlePush,
      replace: this.handleReplace,
      go: staticHandler("go"),
      goBack: staticHandler("goBack"),
      goForward: staticHandler("goForward"),
      listen: this.handleListen,
      block: this.handleBlock
    };

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Router__["a" /* default */], _extends({}, props, { history: history }));
  };

  return StaticRouter;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

StaticRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  context: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  location: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object])
};
StaticRouter.defaultProps = {
  basename: "",
  location: "/"
};
StaticRouter.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (StaticRouter);

/***/ }),
/* 575 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Switch__ = __webpack_require__(576);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Switch__["a" /* default */]);

/***/ }),
/* 576 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__matchPath__ = __webpack_require__(174);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for rendering the first <Route> that matches.
 */

var Switch = function (_React$Component) {
  _inherits(Switch, _React$Component);

  function Switch() {
    _classCallCheck(this, Switch);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Switch.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.context.router, "You should not use <Switch> outside a <Router>");
  };

  Switch.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    __WEBPACK_IMPORTED_MODULE_2_warning___default()(!(nextProps.location && !this.props.location), '<Switch> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    __WEBPACK_IMPORTED_MODULE_2_warning___default()(!(!nextProps.location && this.props.location), '<Switch> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
  };

  Switch.prototype.render = function render() {
    var route = this.context.router.route;
    var children = this.props.children;

    var location = this.props.location || route.location;

    var match = void 0,
        child = void 0;
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (element) {
      if (match == null && __WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(element)) {
        var _element$props = element.props,
            pathProp = _element$props.path,
            exact = _element$props.exact,
            strict = _element$props.strict,
            sensitive = _element$props.sensitive,
            from = _element$props.from;

        var path = pathProp || from;

        child = element;
        match = Object(__WEBPACK_IMPORTED_MODULE_4__matchPath__["a" /* default */])(location.pathname, { path: path, exact: exact, strict: strict, sensitive: sensitive }, route.match);
      }
    });

    return match ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(child, { location: location, computedMatch: match }) : null;
  };

  return Switch;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Switch.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    route: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
  }).isRequired
};
Switch.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};


/* harmony default export */ __webpack_exports__["a"] = (Switch);

/***/ }),
/* 577 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_generatePath__ = __webpack_require__(258);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_generatePath__["a" /* default */]);

/***/ }),
/* 578 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_matchPath__ = __webpack_require__(174);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_matchPath__["a" /* default */]);

/***/ }),
/* 579 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_withRouter__ = __webpack_require__(580);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_withRouter__["a" /* default */]);

/***/ }),
/* 580 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Route__ = __webpack_require__(256);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * A public higher-order component to access the imperative API
 */
var withRouter = function withRouter(Component) {
  var C = function C(props) {
    var wrappedComponentRef = props.wrappedComponentRef,
        remainingProps = _objectWithoutProperties(props, ["wrappedComponentRef"]);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Route__["a" /* default */], {
      children: function children(routeComponentProps) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component, _extends({}, remainingProps, routeComponentProps, {
          ref: wrappedComponentRef
        }));
      }
    });
  };

  C.displayName = "withRouter(" + (Component.displayName || Component.name) + ")";
  C.WrappedComponent = Component;
  C.propTypes = {
    wrappedComponentRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
  };

  return __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default()(C, Component);
};

/* harmony default export */ __webpack_exports__["a"] = (withRouter);

/***/ }),
/* 581 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Context__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_Subscription__ = __webpack_require__(175);





function Provider(_ref) {
  var store = _ref.store,
      context = _ref.context,
      children = _ref.children;
  var contextValue = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function () {
    var subscription = new __WEBPACK_IMPORTED_MODULE_3__utils_Subscription__["a" /* default */](store);
    subscription.onStateChange = subscription.notifyNestedSubs;
    return {
      store: store,
      subscription: subscription
    };
  }, [store]);
  var previousState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function () {
    return store.getState();
  }, [store]);
  Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    var subscription = contextValue.subscription;
    subscription.trySubscribe();

    if (previousState !== store.getState()) {
      subscription.notifyNestedSubs();
    }

    return function () {
      subscription.tryUnsubscribe();
      subscription.onStateChange = null;
    };
  }, [contextValue, previousState]);
  var Context = context || __WEBPACK_IMPORTED_MODULE_2__Context__["a" /* ReactReduxContext */];
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Context.Provider, {
    value: contextValue
  }, children);
}

if (false) {
  Provider.propTypes = {
    store: PropTypes.shape({
      subscribe: PropTypes.func.isRequired,
      dispatch: PropTypes.func.isRequired,
      getState: PropTypes.func.isRequired
    }),
    context: PropTypes.object,
    children: PropTypes.any
  };
}

/* harmony default export */ __webpack_exports__["a"] = (Provider);

/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var reactIs = __webpack_require__(88);

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;

function getStatics(component) {
  // React v16.11 and below
  if (reactIs.isMemo(component)) {
    return MEMO_STATICS;
  } // React v16.12 and above


  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames(sourceComponent);

    if (getOwnPropertySymbols) {
      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
    }

    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
  }

  return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.13.0
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;


/***/ }),
/* 584 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createConnect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_connectAdvanced__ = __webpack_require__(261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mapDispatchToProps__ = __webpack_require__(585);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mapStateToProps__ = __webpack_require__(589);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mergeProps__ = __webpack_require__(590);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__selectorFactory__ = __webpack_require__(591);








/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */

function match(arg, factories, name) {
  for (var i = factories.length - 1; i >= 0; i--) {
    var result = factories[i](arg);
    if (result) return result;
  }

  return function (dispatch, options) {
    throw new Error("Invalid value of type " + typeof arg + " for " + name + " argument when connecting component " + options.wrappedComponentName + ".");
  };
}

function strictEqual(a, b) {
  return a === b;
} // createConnect with default args builds the 'official' connect behavior. Calling it with
// different options opens up some testing and extensibility scenarios


function createConnect(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      _ref$connectHOC = _ref.connectHOC,
      connectHOC = _ref$connectHOC === void 0 ? __WEBPACK_IMPORTED_MODULE_2__components_connectAdvanced__["a" /* default */] : _ref$connectHOC,
      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
      mapStateToPropsFactories = _ref$mapStateToPropsF === void 0 ? __WEBPACK_IMPORTED_MODULE_5__mapStateToProps__["a" /* default */] : _ref$mapStateToPropsF,
      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
      mapDispatchToPropsFactories = _ref$mapDispatchToPro === void 0 ? __WEBPACK_IMPORTED_MODULE_4__mapDispatchToProps__["a" /* default */] : _ref$mapDispatchToPro,
      _ref$mergePropsFactor = _ref.mergePropsFactories,
      mergePropsFactories = _ref$mergePropsFactor === void 0 ? __WEBPACK_IMPORTED_MODULE_6__mergeProps__["a" /* default */] : _ref$mergePropsFactor,
      _ref$selectorFactory = _ref.selectorFactory,
      selectorFactory = _ref$selectorFactory === void 0 ? __WEBPACK_IMPORTED_MODULE_7__selectorFactory__["a" /* default */] : _ref$selectorFactory;

  return function connect(mapStateToProps, mapDispatchToProps, mergeProps, _ref2) {
    if (_ref2 === void 0) {
      _ref2 = {};
    }

    var _ref3 = _ref2,
        _ref3$pure = _ref3.pure,
        pure = _ref3$pure === void 0 ? true : _ref3$pure,
        _ref3$areStatesEqual = _ref3.areStatesEqual,
        areStatesEqual = _ref3$areStatesEqual === void 0 ? strictEqual : _ref3$areStatesEqual,
        _ref3$areOwnPropsEqua = _ref3.areOwnPropsEqual,
        areOwnPropsEqual = _ref3$areOwnPropsEqua === void 0 ? __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__["a" /* default */] : _ref3$areOwnPropsEqua,
        _ref3$areStatePropsEq = _ref3.areStatePropsEqual,
        areStatePropsEqual = _ref3$areStatePropsEq === void 0 ? __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__["a" /* default */] : _ref3$areStatePropsEq,
        _ref3$areMergedPropsE = _ref3.areMergedPropsEqual,
        areMergedPropsEqual = _ref3$areMergedPropsE === void 0 ? __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__["a" /* default */] : _ref3$areMergedPropsE,
        extraOptions = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref3, ["pure", "areStatesEqual", "areOwnPropsEqual", "areStatePropsEqual", "areMergedPropsEqual"]);

    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');
    return connectHOC(selectorFactory, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      // used in error messages
      methodName: 'connect',
      // used to compute Connect's displayName from the wrapped component's displayName.
      getDisplayName: function getDisplayName(name) {
        return "Connect(" + name + ")";
      },
      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
      shouldHandleStateChanges: Boolean(mapStateToProps),
      // passed through to selectorFactory
      initMapStateToProps: initMapStateToProps,
      initMapDispatchToProps: initMapDispatchToProps,
      initMergeProps: initMergeProps,
      pure: pure,
      areStatesEqual: areStatesEqual,
      areOwnPropsEqual: areOwnPropsEqual,
      areStatePropsEqual: areStatePropsEqual,
      areMergedPropsEqual: areMergedPropsEqual
    }, extraOptions));
  };
}
/* harmony default export */ __webpack_exports__["a"] = (createConnect());

/***/ }),
/* 585 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapDispatchToPropsIsFunction */
/* unused harmony export whenMapDispatchToPropsIsMissing */
/* unused harmony export whenMapDispatchToPropsIsObject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__ = __webpack_require__(265);


function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
  return typeof mapDispatchToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["b" /* wrapMapToPropsFunc */])(mapDispatchToProps, 'mapDispatchToProps') : undefined;
}
function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
  return !mapDispatchToProps ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function (dispatch) {
    return {
      dispatch: dispatch
    };
  }) : undefined;
}
function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_redux__["b" /* bindActionCreators */])(mapDispatchToProps, dispatch);
  }) : undefined;
}
/* harmony default export */ __webpack_exports__["a"] = ([whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject]);

/***/ }),
/* 586 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ponyfill_js__ = __webpack_require__(587);
/* global window */


var root;

if (typeof self !== 'undefined') {
  root = self;
} else if (typeof window !== 'undefined') {
  root = window;
} else if (typeof global !== 'undefined') {
  root = global;
} else if (true) {
  root = module;
} else {
  root = Function('return this')();
}

var result = Object(__WEBPACK_IMPORTED_MODULE_0__ponyfill_js__["a" /* default */])(root);
/* harmony default export */ __webpack_exports__["a"] = (result);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(39), __webpack_require__(264)(module)))

/***/ }),
/* 587 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = symbolObservablePonyfill;
function symbolObservablePonyfill(root) {
	var result;
	var Symbol = root.Symbol;

	if (typeof Symbol === 'function') {
		if (Symbol.observable) {
			result = Symbol.observable;
		} else {
			result = Symbol('observable');
			Symbol.observable = result;
		}
	} else {
		result = '@@observable';
	}

	return result;
};


/***/ }),
/* 588 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isPlainObject;
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */
function isPlainObject(obj) {
  if (typeof obj !== 'object' || obj === null) return false;
  var proto = Object.getPrototypeOf(obj);
  if (proto === null) return true;
  var baseProto = proto;

  while (Object.getPrototypeOf(baseProto) !== null) {
    baseProto = Object.getPrototypeOf(baseProto);
  }

  return proto === baseProto;
}

/***/ }),
/* 589 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapStateToPropsIsFunction */
/* unused harmony export whenMapStateToPropsIsMissing */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__ = __webpack_require__(265);

function whenMapStateToPropsIsFunction(mapStateToProps) {
  return typeof mapStateToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["b" /* wrapMapToPropsFunc */])(mapStateToProps, 'mapStateToProps') : undefined;
}
function whenMapStateToPropsIsMissing(mapStateToProps) {
  return !mapStateToProps ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function () {
    return {};
  }) : undefined;
}
/* harmony default export */ __webpack_exports__["a"] = ([whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing]);

/***/ }),
/* 590 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export defaultMergeProps */
/* unused harmony export wrapMergePropsFunc */
/* unused harmony export whenMergePropsIsFunction */
/* unused harmony export whenMergePropsIsOmitted */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_verifyPlainObject__ = __webpack_require__(266);


function defaultMergeProps(stateProps, dispatchProps, ownProps) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, ownProps, {}, stateProps, {}, dispatchProps);
}
function wrapMergePropsFunc(mergeProps) {
  return function initMergePropsProxy(dispatch, _ref) {
    var displayName = _ref.displayName,
        pure = _ref.pure,
        areMergedPropsEqual = _ref.areMergedPropsEqual;
    var hasRunOnce = false;
    var mergedProps;
    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);

      if (hasRunOnce) {
        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
      } else {
        hasRunOnce = true;
        mergedProps = nextMergedProps;
        if (false) verifyPlainObject(mergedProps, displayName, 'mergeProps');
      }

      return mergedProps;
    };
  };
}
function whenMergePropsIsFunction(mergeProps) {
  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
}
function whenMergePropsIsOmitted(mergeProps) {
  return !mergeProps ? function () {
    return defaultMergeProps;
  } : undefined;
}
/* harmony default export */ __webpack_exports__["a"] = ([whenMergePropsIsFunction, whenMergePropsIsOmitted]);

/***/ }),
/* 591 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export impureFinalPropsSelectorFactory */
/* unused harmony export pureFinalPropsSelectorFactory */
/* harmony export (immutable) */ __webpack_exports__["a"] = finalPropsSelectorFactory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__verifySubselectors__ = __webpack_require__(592);


function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
  return function impureFinalPropsSelector(state, ownProps) {
    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
  };
}
function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
  var areStatesEqual = _ref.areStatesEqual,
      areOwnPropsEqual = _ref.areOwnPropsEqual,
      areStatePropsEqual = _ref.areStatePropsEqual;
  var hasRunAtLeastOnce = false;
  var state;
  var ownProps;
  var stateProps;
  var dispatchProps;
  var mergedProps;

  function handleFirstCall(firstState, firstOwnProps) {
    state = firstState;
    ownProps = firstOwnProps;
    stateProps = mapStateToProps(state, ownProps);
    dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    hasRunAtLeastOnce = true;
    return mergedProps;
  }

  function handleNewPropsAndNewState() {
    stateProps = mapStateToProps(state, ownProps);
    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewProps() {
    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewState() {
    var nextStateProps = mapStateToProps(state, ownProps);
    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
    stateProps = nextStateProps;
    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleSubsequentCalls(nextState, nextOwnProps) {
    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
    var stateChanged = !areStatesEqual(nextState, state);
    state = nextState;
    ownProps = nextOwnProps;
    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
    if (propsChanged) return handleNewProps();
    if (stateChanged) return handleNewState();
    return mergedProps;
  }

  return function pureFinalPropsSelector(nextState, nextOwnProps) {
    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
  };
} // TODO: Add more comments
// If pure is true, the selector returned by selectorFactory will memoize its results,
// allowing connectAdvanced's shouldComponentUpdate to return false if final
// props have not changed. If false, the selector will always return a new
// object and shouldComponentUpdate will always return true.

function finalPropsSelectorFactory(dispatch, _ref2) {
  var initMapStateToProps = _ref2.initMapStateToProps,
      initMapDispatchToProps = _ref2.initMapDispatchToProps,
      initMergeProps = _ref2.initMergeProps,
      options = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref2, ["initMapStateToProps", "initMapDispatchToProps", "initMergeProps"]);

  var mapStateToProps = initMapStateToProps(dispatch, options);
  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
  var mergeProps = initMergeProps(dispatch, options);

  if (false) {
    verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, options.displayName);
  }

  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;
  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}

/***/ }),
/* 592 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_warning__ = __webpack_require__(267);


function verify(selector, methodName, displayName) {
  if (!selector) {
    throw new Error("Unexpected value for " + methodName + " in " + displayName + ".");
  } else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
    if (!Object.prototype.hasOwnProperty.call(selector, 'dependsOnOwnProps')) {
      Object(__WEBPACK_IMPORTED_MODULE_0__utils_warning__["a" /* default */])("The selector for " + methodName + " of " + displayName + " did not specify a value for dependsOnOwnProps.");
    }
  }
}

function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
  verify(mapStateToProps, 'mapStateToProps', displayName);
  verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
  verify(mergeProps, 'mergeProps', displayName);
}

/***/ }),
/* 593 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createDispatchHook;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return useDispatch; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Context__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__useStore__ = __webpack_require__(268);


/**
 * Hook factory, which creates a `useDispatch` hook bound to a given context.
 *
 * @param {React.Context} [context=ReactReduxContext] Context passed to your `<Provider>`.
 * @returns {Function} A `useDispatch` hook bound to the specified context.
 */

function createDispatchHook(context) {
  if (context === void 0) {
    context = __WEBPACK_IMPORTED_MODULE_0__components_Context__["a" /* ReactReduxContext */];
  }

  var useStore = context === __WEBPACK_IMPORTED_MODULE_0__components_Context__["a" /* ReactReduxContext */] ? __WEBPACK_IMPORTED_MODULE_1__useStore__["b" /* useStore */] : Object(__WEBPACK_IMPORTED_MODULE_1__useStore__["a" /* createStoreHook */])(context);
  return function useDispatch() {
    var store = useStore();
    return store.dispatch;
  };
}
/**
 * A hook to access the redux `dispatch` function.
 *
 * @returns {any|function} redux store's `dispatch` function
 *
 * @example
 *
 * import React, { useCallback } from 'react'
 * import { useDispatch } from 'react-redux'
 *
 * export const CounterComponent = ({ value }) => {
 *   const dispatch = useDispatch()
 *   const increaseCounter = useCallback(() => dispatch({ type: 'increase-counter' }), [])
 *   return (
 *     <div>
 *       <span>{value}</span>
 *       <button onClick={increaseCounter}>Increase counter</button>
 *     </div>
 *   )
 * }
 */

var useDispatch =
/*#__PURE__*/
createDispatchHook();

/***/ }),
/* 594 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createSelectorHook;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return useSelector; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__useReduxContext__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_Subscription__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_useIsomorphicLayoutEffect__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Context__ = __webpack_require__(66);






var refEquality = function refEquality(a, b) {
  return a === b;
};

function useSelectorWithStoreAndSubscription(selector, equalityFn, store, contextSub) {
  var _useReducer = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useReducer"])(function (s) {
    return s + 1;
  }, 0),
      forceRender = _useReducer[1];

  var subscription = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function () {
    return new __WEBPACK_IMPORTED_MODULE_2__utils_Subscription__["a" /* default */](store, contextSub);
  }, [store, contextSub]);
  var latestSubscriptionCallbackError = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])();
  var latestSelector = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])();
  var latestSelectedState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])();
  var selectedState;

  try {
    if (selector !== latestSelector.current || latestSubscriptionCallbackError.current) {
      selectedState = selector(store.getState());
    } else {
      selectedState = latestSelectedState.current;
    }
  } catch (err) {
    if (latestSubscriptionCallbackError.current) {
      err.message += "\nThe error may be correlated with this previous error:\n" + latestSubscriptionCallbackError.current.stack + "\n\n";
    }

    throw err;
  }

  Object(__WEBPACK_IMPORTED_MODULE_3__utils_useIsomorphicLayoutEffect__["a" /* useIsomorphicLayoutEffect */])(function () {
    latestSelector.current = selector;
    latestSelectedState.current = selectedState;
    latestSubscriptionCallbackError.current = undefined;
  });
  Object(__WEBPACK_IMPORTED_MODULE_3__utils_useIsomorphicLayoutEffect__["a" /* useIsomorphicLayoutEffect */])(function () {
    function checkForUpdates() {
      try {
        var newSelectedState = latestSelector.current(store.getState());

        if (equalityFn(newSelectedState, latestSelectedState.current)) {
          return;
        }

        latestSelectedState.current = newSelectedState;
      } catch (err) {
        // we ignore all errors here, since when the component
        // is re-rendered, the selectors are called again, and
        // will throw again, if neither props nor store state
        // changed
        latestSubscriptionCallbackError.current = err;
      }

      forceRender({});
    }

    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe();
    checkForUpdates();
    return function () {
      return subscription.tryUnsubscribe();
    };
  }, [store, subscription]);
  return selectedState;
}
/**
 * Hook factory, which creates a `useSelector` hook bound to a given context.
 *
 * @param {React.Context} [context=ReactReduxContext] Context passed to your `<Provider>`.
 * @returns {Function} A `useSelector` hook bound to the specified context.
 */


function createSelectorHook(context) {
  if (context === void 0) {
    context = __WEBPACK_IMPORTED_MODULE_4__components_Context__["a" /* ReactReduxContext */];
  }

  var useReduxContext = context === __WEBPACK_IMPORTED_MODULE_4__components_Context__["a" /* ReactReduxContext */] ? __WEBPACK_IMPORTED_MODULE_1__useReduxContext__["a" /* useReduxContext */] : function () {
    return Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(context);
  };
  return function useSelector(selector, equalityFn) {
    if (equalityFn === void 0) {
      equalityFn = refEquality;
    }

    if (false) {
      throw new Error("You must pass a selector to useSelectors");
    }

    var _useReduxContext = useReduxContext(),
        store = _useReduxContext.store,
        contextSub = _useReduxContext.subscription;

    return useSelectorWithStoreAndSubscription(selector, equalityFn, store, contextSub);
  };
}
/**
 * A hook to access the redux store's state. This hook takes a selector function
 * as an argument. The selector is called with the store state.
 *
 * This hook takes an optional equality comparison function as the second parameter
 * that allows you to customize the way the selected state is compared to determine
 * whether the component needs to be re-rendered.
 *
 * @param {Function} selector the selector function
 * @param {Function=} equalityFn the function that will be used to determine equality
 *
 * @returns {any} the selected state
 *
 * @example
 *
 * import React from 'react'
 * import { useSelector } from 'react-redux'
 *
 * export const CounterComponent = () => {
 *   const counter = useSelector(state => state.counter)
 *   return <div>{counter}</div>
 * }
 */

var useSelector =
/*#__PURE__*/
createSelectorHook();

/***/ }),
/* 595 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_dom__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_dom__);
/* harmony reexport (binding) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_0_react_dom__, "unstable_batchedUpdates")) __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0_react_dom__["unstable_batchedUpdates"]; });
/* eslint-disable import/no-unresolved */


/***/ }),
/* 596 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = autoMergeLevel1;
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function autoMergeLevel1(inboundState, originalState, reducedState, _ref) {
  var debug = _ref.debug;

  var newState = _extends({}, reducedState);
  // only rehydrate if inboundState exists and is an object
  if (inboundState && (typeof inboundState === 'undefined' ? 'undefined' : _typeof(inboundState)) === 'object') {
    Object.keys(inboundState).forEach(function (key) {
      // ignore _persist data
      if (key === '_persist') return;
      // if reducer modifies substate, skip auto rehydration
      if (originalState[key] !== reducedState[key]) {
        if (false) console.log('redux-persist/stateReconciler: sub state for key `%s` modified, skipping.', key);
        return;
      }
      // otherwise hard set the new value
      newState[key] = inboundState[key];
    });
  }

  if (false) console.log('redux-persist/stateReconciler: rehydrated keys \'' + Object.keys(inboundState).join(', ') + '\'');

  return newState;
}

/*
  autoMergeLevel1: 
    - merges 1 level of substate
    - skips substate if already modified
*/

/***/ }),
/* 597 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__persistReducer__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__stateReconciler_autoMergeLevel2__ = __webpack_require__(598);




// combineReducers + persistReducer with stateReconciler defaulted to autoMergeLevel2
function persistCombineReducers(config, reducers) {
  config.stateReconciler = config.stateReconciler === undefined ? __WEBPACK_IMPORTED_MODULE_2__stateReconciler_autoMergeLevel2__["a" /* default */] : config.stateReconciler;
  return Object(__WEBPACK_IMPORTED_MODULE_1__persistReducer__["a" /* default */])(config, Object(__WEBPACK_IMPORTED_MODULE_0_redux__["c" /* combineReducers */])(reducers));
}

/***/ }),
/* 598 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = autoMergeLevel2;
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function autoMergeLevel2(inboundState, originalState, reducedState, _ref) {
  var debug = _ref.debug;

  var newState = _extends({}, reducedState);
  // only rehydrate if inboundState exists and is an object
  if (inboundState && (typeof inboundState === 'undefined' ? 'undefined' : _typeof(inboundState)) === 'object') {
    Object.keys(inboundState).forEach(function (key) {
      // ignore _persist data
      if (key === '_persist') return;
      // if reducer modifies substate, skip auto rehydration
      if (originalState[key] !== reducedState[key]) {
        if (false) console.log('redux-persist/stateReconciler: sub state for key `%s` modified, skipping.', key);
        return;
      }
      if (isPlainEnoughObject(reducedState[key])) {
        // if object is plain enough shallow merge the new values (hence "Level2")
        newState[key] = _extends({}, newState[key], inboundState[key]);
        return;
      }
      // otherwise hard set
      newState[key] = inboundState[key];
    });
  }

  if (false) console.log('redux-persist/stateReconciler: rehydrated keys \'' + Object.keys(inboundState).join(', ') + '\'');

  return newState;
}

/*
  autoMergeLevel2: 
    - merges 2 level of substate
    - skips substate if already modified
    - this is essentially redux-perist v4 behavior
*/

function isPlainEnoughObject(o) {
  return o !== null && !Array.isArray(o) && (typeof o === 'undefined' ? 'undefined' : _typeof(o)) === 'object';
}

/***/ }),
/* 599 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = persistStore;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__persistReducer__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(67);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }






var initialState = {
  registry: [],
  bootstrapped: false
};

var persistorReducer = function persistorReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_2__constants__["g" /* REGISTER */]:
      return _extends({}, state, { registry: [].concat(_toConsumableArray(state.registry), [action.key]) });
    case __WEBPACK_IMPORTED_MODULE_2__constants__["h" /* REHYDRATE */]:
      var firstIndex = state.registry.indexOf(action.key);
      var registry = [].concat(_toConsumableArray(state.registry));
      registry.splice(firstIndex, 1);
      return _extends({}, state, { registry: registry, bootstrapped: registry.length === 0 });
    default:
      return state;
  }
};

function persistStore(store, options, cb) {
  // help catch incorrect usage of passing PersistConfig in as PersistorOptions
  if (false) {
    var optionsToTest = options || {};
    var bannedKeys = ['blacklist', 'whitelist', 'transforms', 'storage', 'keyPrefix', 'migrate'];
    bannedKeys.forEach(function (k) {
      if (!!optionsToTest[k]) console.error('redux-persist: invalid option passed to persistStore: "' + k + '". You may be incorrectly passing persistConfig into persistStore, whereas it should be passed into persistReducer.');
    });
  }
  var boostrappedCb = cb || false;

  var _pStore = Object(__WEBPACK_IMPORTED_MODULE_0_redux__["e" /* createStore */])(persistorReducer, initialState, options ? options.enhancer : undefined);
  var register = function register(key) {
    _pStore.dispatch({
      type: __WEBPACK_IMPORTED_MODULE_2__constants__["g" /* REGISTER */],
      key: key
    });
  };

  var rehydrate = function rehydrate(key, payload, err) {
    var rehydrateAction = {
      type: __WEBPACK_IMPORTED_MODULE_2__constants__["h" /* REHYDRATE */],
      payload: payload,
      err: err,
      key: key
      // dispatch to `store` to rehydrate and `persistor` to track result
    };store.dispatch(rehydrateAction);
    _pStore.dispatch(rehydrateAction);
    if (boostrappedCb && persistor.getState().bootstrapped) {
      boostrappedCb();
      boostrappedCb = false;
    }
  };

  var persistor = _extends({}, _pStore, {
    purge: function purge() {
      var results = [];
      store.dispatch({
        type: __WEBPACK_IMPORTED_MODULE_2__constants__["f" /* PURGE */],
        result: function result(purgeResult) {
          results.push(purgeResult);
        }
      });
      return Promise.all(results);
    },
    flush: function flush() {
      var results = [];
      store.dispatch({
        type: __WEBPACK_IMPORTED_MODULE_2__constants__["b" /* FLUSH */],
        result: function result(flushResult) {
          results.push(flushResult);
        }
      });
      return Promise.all(results);
    },
    pause: function pause() {
      store.dispatch({
        type: __WEBPACK_IMPORTED_MODULE_2__constants__["d" /* PAUSE */]
      });
    },
    persist: function persist() {
      store.dispatch({ type: __WEBPACK_IMPORTED_MODULE_2__constants__["e" /* PERSIST */], register: register, rehydrate: rehydrate });
    }
  });

  persistor.persist();

  return persistor;
}

/***/ }),
/* 600 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(67);


function createMigrate(migrations, config) {
  var _ref = config || {},
      debug = _ref.debug;

  return function (state, currentVersion) {
    if (!state) {
      if (false) console.log('redux-persist: no inbound state, skipping migration');
      return Promise.resolve(undefined);
    }

    var inboundVersion = state._persist && state._persist.version !== undefined ? state._persist.version : __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* DEFAULT_VERSION */];
    if (inboundVersion === currentVersion) {
      if (false) console.log('redux-persist: versions match, noop migration');
      return Promise.resolve(state);
    }
    if (inboundVersion > currentVersion) {
      if (false) console.error('redux-persist: downgrading version is not supported');
      return Promise.resolve(state);
    }

    var migrationKeys = Object.keys(migrations).map(function (ver) {
      return parseInt(ver);
    }).filter(function (key) {
      return currentVersion >= key && key > inboundVersion;
    }).sort(function (a, b) {
      return a - b;
    });

    if (false) console.log('redux-persist: migrationKeys', migrationKeys);
    try {
      var migratedState = migrationKeys.reduce(function (state, versionKey) {
        if (false) console.log('redux-persist: running migration for versionKey', versionKey);
        return migrations[versionKey](state);
      }, state);
      return Promise.resolve(migratedState);
    } catch (err) {
      return Promise.reject(err);
    }
  };
}

/***/ }),
/* 601 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */


function createTransform(
// @NOTE inbound: transform state coming from redux on its way to being serialized and stored
inbound,
// @NOTE outbound: transform state coming from storage, on its way to be rehydrated into redux
outbound) {
  var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var whitelist = config.whitelist || null;
  var blacklist = config.blacklist || null;

  function whitelistBlacklistCheck(key) {
    if (whitelist && whitelist.indexOf(key) === -1) return true;
    if (blacklist && blacklist.indexOf(key) !== -1) return true;
    return false;
  }

  return {
    in: function _in(state, key, fullState) {
      return !whitelistBlacklistCheck(key) && inbound ? inbound(state, key, fullState) : state;
    },
    out: function out(state, key, fullState) {
      return !whitelistBlacklistCheck(key) && outbound ? outbound(state, key, fullState) : state;
    }
  };
}

/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.PersistGate = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// eslint-disable-line import/no-unresolved
// eslint-disable-line import/no-unresolved
var PersistGate = exports.PersistGate = function (_PureComponent) {
  _inherits(PersistGate, _PureComponent);

  function PersistGate() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, PersistGate);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PersistGate.__proto__ || Object.getPrototypeOf(PersistGate)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      bootstrapped: false
    }, _this.handlePersistorState = function () {
      var persistor = _this.props.persistor;

      var _persistor$getState = persistor.getState(),
          bootstrapped = _persistor$getState.bootstrapped;

      if (bootstrapped) {
        if (_this.props.onBeforeLift) {
          Promise.resolve(_this.props.onBeforeLift()).then(function () {
            return _this.setState({ bootstrapped: true });
          }).catch(function () {
            return _this.setState({ bootstrapped: true });
          });
        } else {
          _this.setState({ bootstrapped: true });
        }
        _this._unsubscribe && _this._unsubscribe();
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(PersistGate, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this._unsubscribe = this.props.persistor.subscribe(this.handlePersistorState);
      this.handlePersistorState();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this._unsubscribe && this._unsubscribe();
    }
  }, {
    key: 'render',
    value: function render() {
      if (false) {
        if (typeof this.props.children === 'function' && this.props.loading) console.error('redux-persist: PersistGate expects either a function child or loading prop, but not both. The loading prop will be ignored.');
      }
      if (typeof this.props.children === 'function') {
        return this.props.children(this.state.bootstrapped);
      }

      return this.state.bootstrapped ? this.props.children : this.props.loading;
    }
  }]);

  return PersistGate;
}(_react.PureComponent);

PersistGate.defaultProps = {
  loading: null
};

/***/ }),
/* 603 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function createThunkMiddleware(extraArgument) {
  return function (_ref) {
    var dispatch = _ref.dispatch,
        getState = _ref.getState;
    return function (next) {
      return function (action) {
        if (typeof action === 'function') {
          return action(dispatch, getState, extraArgument);
        }

        return next(action);
      };
    };
  };
}

var thunk = createThunkMiddleware();
thunk.withExtraArgument = createThunkMiddleware;

/* harmony default export */ __webpack_exports__["a"] = (thunk);

/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _createWebStorage = __webpack_require__(605);

var _createWebStorage2 = _interopRequireDefault(_createWebStorage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _createWebStorage2.default)('local');

/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = createWebStorage;

var _getStorage = __webpack_require__(606);

var _getStorage2 = _interopRequireDefault(_getStorage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function createWebStorage(type) {
  var storage = (0, _getStorage2.default)(type);
  return {
    getItem: function getItem(key) {
      return new Promise(function (resolve, reject) {
        resolve(storage.getItem(key));
      });
    },
    setItem: function setItem(key, item) {
      return new Promise(function (resolve, reject) {
        resolve(storage.setItem(key, item));
      });
    },
    removeItem: function removeItem(key) {
      return new Promise(function (resolve, reject) {
        resolve(storage.removeItem(key));
      });
    }
  };
}

/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.default = getStorage;


function noop() {}

var noopStorage = {
  getItem: noop,
  setItem: noop,
  removeItem: noop
};

function hasStorage(storageType) {
  if ((typeof self === 'undefined' ? 'undefined' : _typeof(self)) !== 'object' || !(storageType in self)) {
    return false;
  }

  try {
    var storage = self[storageType];
    var testKey = 'redux-persist ' + storageType + ' test';
    storage.setItem(testKey, 'test');
    storage.getItem(testKey);
    storage.removeItem(testKey);
  } catch (e) {
    if (false) console.warn('redux-persist ' + storageType + ' test failed, persistence will be disabled.');
    return false;
  }
  return true;
}

function getStorage(type) {
  var storageType = type + 'Storage';
  if (hasStorage(storageType)) return self[storageType];else {
    if (false) {
      console.error('redux-persist failed to create sync storage. falling back to memory storage.');
    }
    return noopStorage;
  }
}

/***/ }),
/* 607 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__ = __webpack_require__(5);
var initialState={showRegisterCompany:false,showSuccessModal:false,isSentEmailContact:false,showSuccessModalCreateLinkVoucher:false,showErrorModalCreateLinkVoucher:false,showMessage:''};var landingReducer=function landingReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var actions=arguments[1];switch(actions.type){case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_68" /* TOGGLE_REGISTER_COMPANY */]:return Object.assign({},state,{showSuccessModal:false,showRegisterCompany:actions.toggle});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_49" /* SUCCESS_SEND_EMAIL_REGISTER_COMPANY */]:return Object.assign({},state,{showRegisterCompany:false,showSuccessModal:true});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_70" /* TOGGLE_SEND_EMAIL_CONTANT */]:return Object.assign({},state,{isSentEmailContact:actions.toggle});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_23" /* REQUEST_SUCCESS_CREATE_VOUCHER */]:return Object.assign({},state,{showSuccessModalCreateLinkVoucher:true,showMessage:actions.message});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_20" /* REQUEST_FAILED_CREATE_VOUCHER */]:return Object.assign({},state,{showErrorModalCreateLinkVoucher:true,showMessage:actions.message});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["B" /* CLOSE_MODAL_SUCCESS_CREATE_LINK_VOUCHER */]:return Object.assign({},state,{showSuccessModalCreateLinkVoucher:false});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["z" /* CLOSE_MODAL_ERROR_CREATE_LINK_VOUCHER */]:return Object.assign({},state,{showErrorModalCreateLinkVoucher:false});default:return state;}};/* harmony default export */ __webpack_exports__["a"] = (landingReducer);

/***/ }),
/* 608 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_actions_actionTypes__ = __webpack_require__(5);
var initialState={user:{idBusiness:0,userEmail:'',firstName:'',lastName:'',mobile:'',phone:'',subscribeEmailCampaign:false},companies:[],goToSignup:false,signUpFinished:false,error:false,errorMessage:'',preLogin:false,needToTryAutomaticLogin:true,isLoading:false,referalFriendCode:null,linkCode:null,email:''};var signUpReducer=function signUpReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];var userUpdate=null;switch(action.type){case __WEBPACK_IMPORTED_MODULE_0_actions_actionTypes__["_44" /* START_SIGNUP */]:var userEmail=action.email;userUpdate=Object.assign({},state.user,{userEmail:userEmail});return Object.assign({},state,{user:userUpdate,goToSignup:true,preLogin:false,email:''});case __WEBPACK_IMPORTED_MODULE_0_actions_actionTypes__["_72" /* USER_LOGGING_IN */]:return Object.assign({},state,{isLoading:true});case __WEBPACK_IMPORTED_MODULE_0_actions_actionTypes__["_73" /* USER_LOGGING_OUT */]:return Object.assign({},state,{isLoading:false,needToTryAutomaticLogin:false});case __WEBPACK_IMPORTED_MODULE_0_actions_actionTypes__["_19" /* REQUEST_FAILED */]:return Object.assign({},state,{error:true,errorMessage:action.errorMessage});case __WEBPACK_IMPORTED_MODULE_0_actions_actionTypes__["_17" /* PRE_LOGIN */]:// A registered account: never keep a signup in progress (goToSignup sends the
// landing page to /Signup) or a persisted signup email around.
return Object.assign({},state,{preLogin:true,goToSignup:false,user:Object.assign({},state.user,{userEmail:''}),email:action.email});case __WEBPACK_IMPORTED_MODULE_0_actions_actionTypes__["_25" /* RESET_PRE_LOGIN */]:return Object.assign({},state,{preLogin:false,email:''});case __WEBPACK_IMPORTED_MODULE_0_actions_actionTypes__["y" /* CLOSE_MODAL_ERROR */]:return Object.assign({},state,{error:false});case __WEBPACK_IMPORTED_MODULE_0_actions_actionTypes__["_39" /* SET_COMPANIES_TO_USER */]:return Object.assign({},state,{companies:action.companies});case __WEBPACK_IMPORTED_MODULE_0_actions_actionTypes__["_27" /* SELECT_COMPANY */]:var idBusiness=action.idBusiness;userUpdate=Object.assign({},state.user,{idBusiness:idBusiness});return Object.assign({},state,{user:userUpdate});case __WEBPACK_IMPORTED_MODULE_0_actions_actionTypes__["_22" /* REQUEST_SIGNUP_SUCCESSFUL */]:userUpdate=Object.assign({},action.user);return Object.assign({},state,{signUpFinished:action.signUpFinished,user:userUpdate});case __WEBPACK_IMPORTED_MODULE_0_actions_actionTypes__["F" /* CLOSE_SIGNUP */]:return Object.assign({},state,{goToSignup:false,isDuplicated:false});case __WEBPACK_IMPORTED_MODULE_0_actions_actionTypes__["x" /* CLOSE_EMAIL_CONFIRMATION */]:return Object.assign({},state,{user:{},companies:[],goToSignup:false,signUpFinished:false,isDuplicated:false,referalFriendCode:null,linkCode:null});case __WEBPACK_IMPORTED_MODULE_0_actions_actionTypes__["_24" /* REQUEST_SUCCESS_LOGIN */]:return Object.assign({},state,{preLogin:false});case __WEBPACK_IMPORTED_MODULE_0_actions_actionTypes__["_41" /* SIGNUP_SET_REFERAL_FRIEND_CODE */]:return Object.assign({},state,{referalFriendCode:action.referalFriendCode});case __WEBPACK_IMPORTED_MODULE_0_actions_actionTypes__["_40" /* SIGNUP_SET_LINK_CODE */]:return Object.assign({},state,{linkCode:action.code});default:return state;}};/* harmony default export */ __webpack_exports__["a"] = (signUpReducer);

/***/ }),
/* 609 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__ = __webpack_require__(5);
var initialState={error:false,errorMessage:'',isRequestSentEmailResetPasswordSuccess:false,isFinishedChangePasswordSuccess:false};var passwordReducer=function passwordReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_19" /* REQUEST_FAILED */]:return Object.assign({},state,{error:true,errorMessage:action.errorMessage});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["y" /* CLOSE_MODAL_ERROR */]:return Object.assign({},state,{error:false});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_21" /* REQUEST_SENT_EMAIL_RESET_PASSWORD_SUCCESS */]:return Object.assign({},state,{isRequestSentEmailResetPasswordSuccess:true});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["E" /* CLOSE_SENT_EMAIL_RESET_PASSWORD_MODAL */]:return Object.assign({},state,{isRequestSentEmailResetPasswordSuccess:false});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_24" /* REQUEST_SUCCESS_LOGIN */]:return Object.assign({},state,{isFinishedChangePasswordSuccess:true});default:return state;}};/* harmony default export */ __webpack_exports__["a"] = (passwordReducer);

/***/ }),
/* 610 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__ = __webpack_require__(5);
var initialState={userDetails:null};var authenticationReducer=function authenticationReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_24" /* REQUEST_SUCCESS_LOGIN */]:return Object.assign({},state,{userDetails:action.userDetails});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_5" /* LOGOUT */]:localStorage.removeItem("country");return Object.assign({},state,{userDetails:null});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["p" /* CHANGE_PASSWORD_SUCCESSFUL */]:return Object.assign({},state,{userDetails:action.userDetails});default:return state;}};/* harmony default export */ __webpack_exports__["a"] = (authenticationReducer);

/***/ }),
/* 611 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_actions_actionTypes__ = __webpack_require__(5);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var initialSideBarMenu=[{index:1,title:'Restaurants',class:'sprite restaurant',active:true,restaurants:{businessDelivery:[],businessCollection:[]}},{index:2,title:'Fast Re-order',class:'sprite reload',active:false},{index:3,title:'Vouchers',class:'sprite voucher',active:false},{index:4,title:'Platters',class:'sprite platters',active:false,restaurants:{businessPlatter:[]}},{index:5,title:'Cart',class:'sprite cart',active:false},{index:6,title:'Delivery Tracking',class:'sprite tracking',active:false},{index:7,title:'Settings',class:'sprite settings',active:false},{index:8,title:'GDPR Info',class:'sprite gdpr',active:false},{index:9,title:'Logout',class:'sprite logout',active:false}];var initialState={titleHeader:'Popular Dishes',showCollectionOption:false,loadingRecentlyOrder:false,addresses:[],listAddress:[],popularDishDelivery:[],recentlyOrdered:[],restaurantSelected:null,categoriesRestaurant:[],products:[],productSelected:null,itemsSideBarMenu:[].concat(initialSideBarMenu),restaurantsOptions:[{id:1,active:true,type:'Delivery'},{id:2,active:false,type:'Collection'}],showMenuMobile:false,showRestaurantsMobile:false,errorHandling:{showError:false,errorMessage:''},acceptDeliverAtHome:false,pendingFeedback:null,feedbackSuccess:false};var menuReducer=function menuReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var actions=arguments[1];switch(actions.type){case __WEBPACK_IMPORTED_MODULE_0_actions_actionTypes__["q" /* CHANGE_RESTAURANT_OPTIONS */]:var restaurantsOptions=state.restaurantsOptions.map(function(option){if(option.id===actions.idRestaurantsOptions){return{id:option.id,active:true,type:option.type};}else{return{id:option.id,active:false,type:option.type};}});return Object.assign({},state,{restaurantsOptions:restaurantsOptions,categoriesRestaurant:[],products:[]});case __WEBPACK_IMPORTED_MODULE_0_actions_actionTypes__["_8" /* MENU_FETCHING_ADDRESS_SUCCESS */]:return Object.assign({},state,{listAddress:actions.listAddressToDelivery.filter(function(item){return item.idBusinessAddress!=null||item.idCustomerDeliveryAddress!=null;}),acceptDeliverAtHome:actions.listAddressToDelivery.filter(function(item){return item.idBusinessAddress===null&&item.acceptDeliverAtHome===true;}).length>0});case __WEBPACK_IMPORTED_MODULE_0_actions_actionTypes__["_12" /* MENU_SELECT_ADDRESS_FOR_ORDER */]:return Object.assign({},state,{addresses:actions.address});case __WEBPACK_IMPORTED_MODULE_0_actions_actionTypes__["_5" /* LOGOUT */]:return Object.assign({},state,{listAddress:[],addresses:[],showCollectionOption:false,titleHeader:'Popular Dishes',restaurantSelected:null,restaurantsOptions:[{id:1,active:true,type:'Delivery'},{id:2,active:false,type:'Collection'}],itemsSideBarMenu:[{index:1,title:'Restaurants',class:'sprite restaurant',active:true,restaurants:{businessDelivery:[],businessCollection:[]}},{index:2,title:'Fast Re-order',class:'sprite reload',active:false},{index:3,title:'Team Vouchers',class:'sprite voucher',active:false},{index:4,title:'Platters',class:'sprite platters',active:false,restaurants:{businessPlatter:[]}},{index:5,title:'Cart',class:'sprite cart',active:false},{index:6,title:'Delivery Tracking',class:'sprite tracking',active:false},{index:7,title:'Settings',class:'sprite settings',active:false},{index:8,title:'GDPR Info',class:'sprite gdpr',active:false},{index:9,title:'Logout',class:'sprite logout',active:false}]});case __WEBPACK_IMPORTED_MODULE_0_actions_actionTypes__["L" /* FETCHING_MENU_SUCCESS */]:var popularDishDelivery=!actions.popularDishDelivery?[]:actions.popularDishDelivery.map(function(item){return{product:item.product,business:Object.assign({},item.business)};});var itemsSideBarMenu=[].concat(_toConsumableArray(state.itemsSideBarMenu));itemsSideBarMenu[0].restaurants.businessDelivery=actions.businessDelivery;itemsSideBarMenu[0].restaurants.businessCollection=actions.businessCollection;itemsSideBarMenu[3].restaurants.businessPlatter=actions.businessPlatter;var showCollectionOption=actions.businessCollection.length>0&&state.listAddress.some(function(item){return item.forCollection;})?true:false;return Object.assign({},state,{itemsSideBarMenu:itemsSideBarMenu,popularDishDelivery:popularDishDelivery,showCollectionOption:showCollectionOption,titleHeader:'Popular Dishes',restaurantSelected:null,restaurantsOptions:[{id:1,active:true,type:'Delivery'},{id:2,active:false,type:'Collection'}],categoriesRestaurant:[{id:0,name:"Popular Dishes",active:true},{id:1,name:"Recently Ordered",active:false}]});case __WEBPACK_IMPORTED_MODULE_0_actions_actionTypes__["_28" /* SELECT_ITEM_SIDE_BAR_MENU */]:var itemsSideBarMenuUpdate=[].concat(_toConsumableArray(actions.itemsSideBar));return Object.assign({},state,{itemsSideBarMenu:itemsSideBarMenuUpdate});case __WEBPACK_IMPORTED_MODULE_0_actions_actionTypes__["_11" /* MENU_RESTAURANT_VERIFY_AVAILABLE_SUCCESSFUL */]:var restaurantSelected=Object.assign({},state.restaurantSelected,{isAvailable:actions.payload.isAvailable});return Object.assign({},state,{restaurantSelected:restaurantSelected});case __WEBPACK_IMPORTED_MODULE_0_actions_actionTypes__["_9" /* MENU_REMOVE_RESTAURANT_NOT_AVAILABLE */]:return Object.assign({},state,{restaurantSelected:null});case __WEBPACK_IMPORTED_MODULE_0_actions_actionTypes__["_6" /* MENU_CHANGE_TITLE_HEADER */]:return Object.assign({},state,{titleHeader:actions.titleHeader});case __WEBPACK_IMPORTED_MODULE_0_actions_actionTypes__["o" /* CATEGORIES_SELECTED */]:var categoriesRestaurantUpdate=actions.categoriesRestaurant.map(function(categorie){categorie.active=false;return categorie;});return Object.assign({},state,{categoriesRestaurant:categoriesRestaurantUpdate,products:[]});case __WEBPACK_IMPORTED_MODULE_0_actions_actionTypes__["_26" /* RESTAURANT_SELECTED */]:return Object.assign({},state,{restaurantSelected:actions.restaurant});case __WEBPACK_IMPORTED_MODULE_0_actions_actionTypes__["_38" /* SETTING_ACTIVE_CATEGORY */]:var categoriesRestaurantActiveUpdate=state.categoriesRestaurant.map(function(categorie){if(categorie.id===actions.idActiveCategory){categorie.active=true;}else{categorie.active=false;}return categorie;});return Object.assign({},state,{categoriesRestaurant:categoriesRestaurantActiveUpdate});case __WEBPACK_IMPORTED_MODULE_0_actions_actionTypes__["J" /* DELETE_RESTAURANT_SELECTED */]:return Object.assign({},state,{restaurantSelected:null});case __WEBPACK_IMPORTED_MODULE_0_actions_actionTypes__["M" /* FETCHING_PRODUCT_SUCCESS */]:var productsUpdatedCurrency=actions.products.length>0?actions.products.map(function(product){product.currency=state.restaurantSelected.currency;return product;}):state.products;return Object.assign({},state,{products:productsUpdatedCurrency});case __WEBPACK_IMPORTED_MODULE_0_actions_actionTypes__["_29" /* SELECT_PRODUCT */]:return Object.assign({},state,{productSelected:actions.productSelected});case __WEBPACK_IMPORTED_MODULE_0_actions_actionTypes__["C" /* CLOSE_PRODUCT_DETAILS */]:return Object.assign({},state,{productSelected:null});case __WEBPACK_IMPORTED_MODULE_0_actions_actionTypes__["N" /* FETCHING_RECENTLY_ORDERED_SUCCESS */]:return Object.assign({},state,{recentlyOrdered:actions.recentlyOrdered});case __WEBPACK_IMPORTED_MODULE_0_actions_actionTypes__["_14" /* ORDER_FEEDBACK_PENDING_SUCCESS */]:return Object.assign({},state,{pendingFeedback:actions.pendingFeedback,feedbackSuccess:false});case __WEBPACK_IMPORTED_MODULE_0_actions_actionTypes__["_13" /* ORDER_FEEDBACK_CLEAR */]:return Object.assign({},state,{pendingFeedback:null,feedbackSuccess:false});case __WEBPACK_IMPORTED_MODULE_0_actions_actionTypes__["_16" /* ORDER_FEEDBACK_SUBMITTED */]:return Object.assign({},state,{pendingFeedback:null,feedbackSuccess:true});case __WEBPACK_IMPORTED_MODULE_0_actions_actionTypes__["_15" /* ORDER_FEEDBACK_SKIPPED */]:return Object.assign({},state,{pendingFeedback:null,feedbackSuccess:false});case __WEBPACK_IMPORTED_MODULE_0_actions_actionTypes__["_42" /* START_RECENTLY_ORDER_REQUEST */]:return Object.assign({},state,{loadingRecentlyOrder:true});case __WEBPACK_IMPORTED_MODULE_0_actions_actionTypes__["O" /* FINISH_RECENTLY_ORDER_REQUEST */]:return Object.assign({},state,{loadingRecentlyOrder:false});case __WEBPACK_IMPORTED_MODULE_0_actions_actionTypes__["_10" /* MENU_RESET_STATE */]:return Object.assign({},state,{restaurantSelected:null});case __WEBPACK_IMPORTED_MODULE_0_actions_actionTypes__["_67" /* TOGGLE_MENU_MOBILE */]:return Object.assign({},state,{showMenuMobile:state.showRestaurantsMobile?false:actions.status!==null?actions.status:!state.showMenuMobile,showRestaurantsMobile:false});case __WEBPACK_IMPORTED_MODULE_0_actions_actionTypes__["_69" /* TOGGLE_RESTAURANTS_MOBILE */]:return Object.assign({},state,{showMenuMobile:false,showRestaurantsMobile:actions.status!==null?actions.status:!state.showRestaurantsMobile});case __WEBPACK_IMPORTED_MODULE_0_actions_actionTypes__["_7" /* MENU_ERROR_HANDLING */]:return Object.assign({},state,{errorHandling:actions.errorHandling});case __WEBPACK_IMPORTED_MODULE_0_actions_actionTypes__["G" /* CREATED_NEW_CUSTOMER_DELIVERY_ADDRESS */]:return Object.assign({},state,{addresses:[actions.payload],listAddress:state.listAddress.concat(actions.payload)});default:return state;}};/* harmony default export */ __webpack_exports__["a"] = (menuReducer);

/***/ }),
/* 612 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_guestOrdering__ = __webpack_require__(68);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}// Items carry an optional local guestId; a copy keeps the menu's product objects clean.
var withGuestId=function withGuestId(product,guestId){return Object.assign({},product,{guestId:guestId!==undefined?guestId:product.guestId||null});};// A guest whose items are all gone leaves the basket; an empty basket has no guests.
var guestsAfterChange=function guestsAfterChange(cart,products){var guests=products.length>0?Object(__WEBPACK_IMPORTED_MODULE_1__config_guestOrdering__["r" /* pruneGuests */])(products,cart.guests):[];var lastStillThere=guests.some(function(guest){return guest.id===cart.lastRecipientId;});return{guests:guests,lastRecipientId:lastStillThere?cart.lastRecipientId:null};};var emptyGuestState={guests:[],lastRecipientId:null,guestPrompt:null,partyValues:[],batchResult:null};var initialState={cart:Object.assign({campaignRateCC:null,campaignRateCollection:null,isInvoice:false,idOrder:undefined,publicOrderNumber:undefined,descriptionSuccess:"",orderDeliveryDate:undefined,checkout:false,showPlacedModal:false,showReceiptModal:false,products:[],restaurantSelected:null,subsidy:0,subtotal:0,total:0,tipValue:0,maxBasketCost:0,cards:[],modalErrorPlacedOrder:false,errorLimit:"",checkoutError:null,payInfo:{},isButtonDisabled:false,discounts:[],deliveryTomorrow:false,restaurantCurrentIsOpen:true,guestPolicy:null},emptyGuestState)};var cartReducer=function cartReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var actions=arguments[1];var cartUpdate=void 0;switch(actions.type){case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_66" /* TOGGLE_CART */]:cartUpdate=state.cart;cartUpdate.checkout=actions.status!==null?actions.status:!cartUpdate.checkout;return Object.assign({},state,{cart:cartUpdate});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["a" /* ADD_PRODUCT_TO_CART */]:cartUpdate=state.cart;var productsUpdated=void 0;var addedGuestId=actions.payload.guestId;if(Array.isArray(actions.payload.product)){productsUpdated=[].concat(_toConsumableArray(cartUpdate.products),_toConsumableArray(actions.payload.product.map(function(product){return withGuestId(product,addedGuestId);})));}else{productsUpdated=[].concat(_toConsumableArray(cartUpdate.products),[withGuestId(actions.payload.product,addedGuestId)]);}cartUpdate.products=productsUpdated;if(JSON.stringify(cartUpdate.restaurantSelected)!==JSON.stringify(actions.payload.business)){cartUpdate.restaurantSelected=actions.payload.business;cartUpdate.campaignRateCC=null;cartUpdate.campaignRateCollection=null;}cartUpdate.checkout=true;return Object.assign({},state,{cart:Object.assign({},state.cart,cartUpdate)});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["I" /* DELETE_PRODUCT_FROM_CART */]:cartUpdate=state.cart;var productsUpdate=[].concat(_toConsumableArray(cartUpdate.products));var removed=actions.payload.product;var index=productsUpdate.indexOf(removed);if(index===-1){index=productsUpdate.findIndex(function(product){return product.id===removed.id&&(product.guestId||null)===(removed.guestId||null);});}if(index!==-1)productsUpdate.splice(index,1);cartUpdate.products=productsUpdate;Object.assign(cartUpdate,guestsAfterChange(cartUpdate,productsUpdate));cartUpdate.checkout=productsUpdate.length>0?true:false;return Object.assign({},state,{cart:cartUpdate});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["H" /* DELETE_ALL_PRODUCTS_FROM_CART */]:cartUpdate=state.cart;cartUpdate.checkout=false;cartUpdate.products=[];cartUpdate.subsidy=0;cartUpdate.tipValue=0;Object.assign(cartUpdate,emptyGuestState);return Object.assign({},state,{cart:cartUpdate});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_5" /* LOGOUT */]:cartUpdate=state.cart;cartUpdate.subtotal=0;cartUpdate.tipValue=0;cartUpdate.total=0;cartUpdate.maxBasketCost=0;cartUpdate.cards=[];cartUpdate.restaurantSelected=null;cartUpdate.checkout=false;cartUpdate.campaignRate=[];cartUpdate.products=[];cartUpdate.subsidy=0;cartUpdate.guestPolicy=null;Object.assign(cartUpdate,emptyGuestState);return Object.assign({},state,{cart:cartUpdate});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["d" /* CART_CALCULATED_VALUES */]:cartUpdate=state.cart;cartUpdate.subsidy=actions.subsidy;cartUpdate.total=actions.total;cartUpdate.tipValue=actions.tipValue;cartUpdate.maxBasketCost=actions.maxBasketCost;cartUpdate.discounts=actions.discounts;if(cartUpdate.campaignRateCollection&&cartUpdate.restaurantSelected.forCollection==="Y"){var discount=cartUpdate.campaignRateCollection.discountType==="P"?cartUpdate.total*(cartUpdate.campaignRateCollection.amount/100):cartUpdate.campaignRateCollection.amount;cartUpdate.total=cartUpdate.total-discount;}cartUpdate.subtotal=actions.subtotal;return Object.assign({},state,{cart:cartUpdate});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_47" /* SUCCESS_FETCHING_CARDS */]:cartUpdate=state.cart;cartUpdate.cards=actions.cards;return Object.assign({},state,{cart:cartUpdate});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_46" /* SUCCESS_FETCHING_CAMPAIGN_RATE */]:cartUpdate=state.cart;cartUpdate.campaignRateCC=actions.campaignRate.find(function(item){return item.chargeType==="C"&&item.statusReg==="A"&&item.status==="E";});cartUpdate.campaignRateCollection=actions.campaignRate.find(function(item){return item.chargeType==="T"&&item.statusReg==="A"&&item.status==="E";});return Object.assign({},state,{cart:cartUpdate});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_71" /* TRIGGER_MODAL_ERROR_PLACED_ORDER */]:cartUpdate=state.cart;cartUpdate.modalErrorPlacedOrder=true;cartUpdate.checkoutError=actions.checkoutError;cartUpdate.errorLimit=actions.checkoutError.message;return Object.assign({},state,{cart:cartUpdate});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["A" /* CLOSE_MODAL_ERROR_PLACED_ORDER */]:cartUpdate=state.cart;cartUpdate.modalErrorPlacedOrder=false;return Object.assign({},state,{cart:cartUpdate});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_48" /* SUCCESS_PLACE_ORDER */]:cartUpdate=state.cart;cartUpdate.idOrder=actions.payload.idOrder;cartUpdate.publicOrderNumber=actions.payload.publicOrderNumber;cartUpdate.orderDeliveryDate=actions.payload.orderDeliveryDate;cartUpdate.descriptionSuccess=actions.payload.descriptionSuccess;return Object.assign({},state,{cart:cartUpdate});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["h" /* CART_RESET_STATE */]:return{cart:Object.assign({idOrder:undefined,publicOrderNumber:undefined,orderDeliveryDate:undefined,descriptionSuccess:"",checkout:false,isInvoice:false,showPlacedModal:false,showReceiptModal:false,products:[],restaurantSelected:null,campaignRate:[],subsidy:0,subtotal:0,tipValue:0,total:0,maxBasketCost:0,cards:[],modalErrorPlacedOrder:false,isButtonDisabled:false,errorLimit:"",checkoutError:null,discounts:[],deliveryTomorrow:false,restaurantCurrentIsOpen:true,// The policy belongs to the signed-in employee, not to the basket.
guestPolicy:state.cart.guestPolicy},emptyGuestState)};case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["l" /* CART_TOGGLE_SHOW_MODAL_PLACE_ORDER */]:return Object.assign({},state,{cart:Object.assign({},state.cart,{showPlacedModal:actions.payload})});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["m" /* CART_TOGGLE_SHOW_MODAL_RECEIPT */]:return Object.assign({},state,{cart:Object.assign({},state.cart,{showReceiptModal:actions.payload})});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["k" /* CART_SET_PLACED_BUTTON_DISABLED */]:return Object.assign({},state,{cart:Object.assign({},state.cart,{isButtonDisabled:actions.payload})});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["j" /* CART_SET_PAY_INFO */]:return Object.assign({},state,{cart:Object.assign({},state.cart,{payInfo:actions.payload})});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["i" /* CART_SET_INVOICE */]:return Object.assign({},state,{cart:Object.assign({},state.cart,{isInvoice:actions.payload})});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["e" /* CART_DELIVERY_TOMORROW */]:return Object.assign({},state,{cart:Object.assign({},state.cart,{deliveryTomorrow:actions.payload})});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["n" /* CART_UPDATED_RESTAURANT_STATUS */]:return Object.assign({},state,{cart:Object.assign({},state.cart,{restaurantCurrentIsOpen:actions.payload})});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["X" /* GUEST_POLICY_LOADED */]:return Object.assign({},state,{cart:Object.assign({},state.cart,{guestPolicy:actions.policy})});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["Y" /* GUEST_RECIPIENT_ASK */]:return Object.assign({},state,{cart:Object.assign({},state.cart,{guestPrompt:{payload:actions.payload,subtitle:actions.subtitle}})});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["Z" /* GUEST_RECIPIENT_CANCEL */]:return Object.assign({},state,{cart:Object.assign({},state.cart,{guestPrompt:null})});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["V" /* GUEST_ADDED_TO_BASKET */]:return Object.assign({},state,{cart:Object.assign({},state.cart,{guests:[].concat(_toConsumableArray(state.cart.guests),[actions.guest])})});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_0" /* GUEST_RECIPIENT_CHOSEN */]:return Object.assign({},state,{cart:Object.assign({},state.cart,{guestPrompt:null,lastRecipientId:actions.guestId})});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["W" /* GUEST_CHECKOUT_KEY_SPENT */]:// The server returned an order (or refused the request) for this key:
// the next attempt for that guest is a new order with a new key.
return Object.assign({},state,{cart:Object.assign({},state.cart,{guests:state.cart.guests.map(function(guest){return guest.requestKey===actions.requestKey?Object.assign({},guest,{requestKey:Object(__WEBPACK_IMPORTED_MODULE_1__config_guestOrdering__["h" /* createCheckoutRequestKey */])()}):guest;})})});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["f" /* CART_PARTY_VALUES */]:return Object.assign({},state,{cart:Object.assign({},state.cart,{partyValues:actions.partyValues})});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["g" /* CART_REMOVE_PARTIES */]:{// Placed people's items leave the basket; the rest stay for another try.
var placed=actions.guestIds;var products=state.cart.products.filter(function(product){return placed.indexOf(product.guestId||null)===-1;});return Object.assign({},state,{cart:Object.assign({},state.cart,{products:products,checkout:products.length>0?state.cart.checkout:false,partyValues:[]},guestsAfterChange(state.cart,products))});}case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["b" /* CART_BATCH_RESULT */]:return Object.assign({},state,{cart:Object.assign({},state.cart,{batchResult:actions.result})});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["c" /* CART_BATCH_RESULT_CLOSE */]:return Object.assign({},state,{cart:Object.assign({},state.cart,{batchResult:null})});default:return state;}};/* harmony default export */ __webpack_exports__["a"] = (cartReducer);

/***/ }),
/* 613 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_actions_actionTypes__ = __webpack_require__(5);
var initialState={loading:false};var loadingReducer=function loadingReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var actions=arguments[1];switch(actions.type){case __WEBPACK_IMPORTED_MODULE_0_actions_actionTypes__["_43" /* START_REQUEST */]:return Object.assign({},state,{loading:true});case __WEBPACK_IMPORTED_MODULE_0_actions_actionTypes__["P" /* FINISH_REQUEST */]:return Object.assign({},state,{loading:false});default:return state;}};/* harmony default export */ __webpack_exports__["a"] = (loadingReducer);

/***/ }),
/* 614 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__ = __webpack_require__(5);
var initialState={realex:{},stripe:{},showModalReceipt:false,showModalPlaceOrder:false,showModalError:false,messageError:'',messageSuccess:'',intervalReference:undefined,realexFormSize:{width:'100%',height:'950'}};var checkoutReducer=function checkoutReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var _ref=arguments[1];var type=_ref.type,payload=_ref.payload;switch(type){case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_18" /* REALEX_CONFIG_DATA_LOADED */]:return Object.assign({},state,{realex:Object.assign({},payload)});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_45" /* STRIPE_CONFIG_DATA_LOADED */]:return Object.assign({},state,{stripe:Object.assign({},payload)});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["t" /* CHECKOUT_REALEX_TOGGLE_SHOW_MODAL_RECEIPT */]:return Object.assign({},state,{showModalReceipt:payload});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["r" /* CHECKOUT_REALEX_TOGGLE_SHOW_MODAL_ERROR */]:return Object.assign({},state,{showModalError:payload.show,messageError:payload.messageError});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["s" /* CHECKOUT_REALEX_TOGGLE_SHOW_MODAL_PLACE_ORDER */]:return Object.assign({},state,{showModalPlaceOrder:payload.show,messageSuccess:payload.messageSuccess});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["w" /* CHECKOUT_SET_INTERVAL_REFERENCE */]:return Object.assign({},state,{intervalReference:payload});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["v" /* CHECKOUT_RESIZE_REALEX_FORM */]:return Object.assign({},state,{realexFormSize:payload});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["u" /* CHECKOUT_RESET_STATE */]:clearInterval(state.intervalReference);return initialState;default:return state;}};/* harmony default export */ __webpack_exports__["a"] = (checkoutReducer);

/***/ }),
/* 615 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__ = __webpack_require__(5);
var initialState={business:null};var businessReducer=function businessReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var actions=arguments[1];switch(actions.type){case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["K" /* FETCHING_BUSINESS_SUCCESS */]:return Object.assign({},state,{business:actions.business});default:return state;}};/* harmony default export */ __webpack_exports__["a"] = (businessReducer);

/***/ }),
/* 616 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_actions_actionTypes__ = __webpack_require__(5);
var initalState={showCompanyChange:false,isSentEmailSupport:false,isUnsubscribeSuccess:false,showErrorMessageUnsubscribe:false,isAccountDeleted:false};var settingsReducer=function settingsReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initalState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0_actions_actionTypes__["_35" /* SETTINGS_SHOW_CHANGE_COMPANY */]:return Object.assign({},state,{showCompanyChange:true});case __WEBPACK_IMPORTED_MODULE_0_actions_actionTypes__["_31" /* SETTINGS_CLOSE_CHANGE_COMPANY */]:return Object.assign({},state,{showCompanyChange:false});case __WEBPACK_IMPORTED_MODULE_0_actions_actionTypes__["_34" /* SETTINGS_SEND_EMAIL_SUPPORT_SUCCESS */]:return Object.assign({},state,{showCompanyChange:false,isSentEmailSupport:true});case __WEBPACK_IMPORTED_MODULE_0_actions_actionTypes__["_33" /* SETTINGS_CLOSE_SENT_EMAIL_SUPORT */]:return Object.assign({},state,{isSentEmailSupport:false});case __WEBPACK_IMPORTED_MODULE_0_actions_actionTypes__["_37" /* SETTINGS_UNSUBSCRIBE_SUCCESS */]:return Object.assign({},state,{isUnsubscribeSuccess:true});case __WEBPACK_IMPORTED_MODULE_0_actions_actionTypes__["_36" /* SETTINGS_SHOW_ERROR_UNSUBSCRIBE */]:return Object.assign({},state,{showErrorMessageUnsubscribe:true,errorMessageUnsubscribe:action.errorMessageUnsubscribe});case __WEBPACK_IMPORTED_MODULE_0_actions_actionTypes__["_32" /* SETTINGS_CLOSE_ERROR_UNSUBSCRIBE */]:return Object.assign({},state,{showErrorMessageUnsubscribe:false});case __WEBPACK_IMPORTED_MODULE_0_actions_actionTypes__["_30" /* SETTINGS_ACCOUNT_DELETED */]:return Object.assign({},state,{isAccountDeleted:true});default:return state;}};/* harmony default export */ __webpack_exports__["a"] = (settingsReducer);

/***/ }),
/* 617 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__ = __webpack_require__(5);
var initialState={termsConditions:'',privacyPolicy:'',loadError:null};var gdprReducer=function gdprReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var actions=arguments[1];switch(actions.type){case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["S" /* GDPR_SUCCESS_PRIVACY_POLICY */]:return Object.assign({},state,{privacyPolicy:actions.privacyPolicy});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["T" /* GDPR_SUCCESS_TERMS_CONDITIONS */]:return Object.assign({},state,{termsConditions:actions.termsConditions});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["R" /* GDPR_LOAD_STARTED */]:return Object.assign({},state,{loadError:null});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["Q" /* GDPR_LOAD_FAILED */]:return Object.assign({},state,{loadError:actions.loadError});default:return state;}};/* harmony default export */ __webpack_exports__["a"] = (gdprReducer);

/***/ }),
/* 618 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__ = __webpack_require__(5);
var initialState={order:{},cards:[],availableTeamVouchers:[],availableTeamVouchersTotal:0,availableTeamVouchersLastExpiryDate:undefined,idOrder:undefined,showModalReceipt:false,showModalConfirmEmails:false,showModalPlaceOrder:false,showModalError:false,campaignRateCC:{},payInfo:{},errorMessage:undefined,errorType:undefined,voucherBalance:[]};var teamVoucherReducer=function teamVoucherReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_62" /* TEAM_VOUCHER_SUCCESS_FETCHING_CARDS */]:return Object.assign({},state,{cards:action.payload});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_59" /* TEAM_VOUCHER_SET_ORDER */]:return Object.assign({},state,{order:action.payload});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_58" /* TEAM_VOUCHER_SET_CAMPAIGN_RATE */]:return Object.assign({},state,{campaignRateCC:action.payload});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_60" /* TEAM_VOUCHER_SET_PAY_INFO */]:return Object.assign({},state,{payInfo:action.payload});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_57" /* TEAM_VOUCHER_SET_AVAILABLE_TEAM_VOUCHER */]:return Object.assign({},state,{availableTeamVouchers:action.payload,availableTeamVouchersTotal:action.payload.map(function(tv){return tv.value;}).reduce(function(sum,current){return sum+current;},0),availableTeamVouchersLastExpiryDate:0});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_63" /* TEAM_VOUCHER_SUCCESS_PLACE_ORDER */]:return Object.assign({},state,{order:Object.assign({},state.order,{idOrder:action.payload.idOrder,publicOrderNumber:action.payload.publicOrderNumber,idBusinessRestaurant:action.payload.idBusinessRestaurant})});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_64" /* TEAM_VOUCHER_TOGGLE_SHOW_MODAL_PLACE_ORDER */]:return Object.assign({},state,{showModalPlaceOrder:action.payload});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_65" /* TEAM_VOUCHER_TOGGLE_SHOW_MODAL_RECEIPT */]:return Object.assign({},state,{showModalReceipt:action.payload});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_61" /* TEAM_VOUCHER_SHOW_MODAL_CONFIRM_EMAILS */]:return Object.assign({},state,{showModalConfirmEmails:true});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_53" /* TEAM_VOUCHER_CLOSE_MODAL_CONFIRM_EMAILS */]:return Object.assign({},state,{showModalConfirmEmails:false});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_55" /* TEAM_VOUCHER_OPEN_MODAL_ERROR */]:return Object.assign({},state,{showModalError:true,errorMessage:action.payload.errorMessage,errorType:action.payload.errorType,errorObject:action.payload.errorObject});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_54" /* TEAM_VOUCHER_CLOSE_MODAL_ERROR */]:return Object.assign({},state,{showModalError:false,errorMessage:undefined,errorType:undefined,errorObject:undefined});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_74" /* VOUCHER_BALANCE_SUCCESS */]:return Object.assign({},state,{voucherBalance:action.payload});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_56" /* TEAM_VOUCHER_RESET_STATE */]:return initialState;default:return state;}};/* harmony default export */ __webpack_exports__["a"] = (teamVoucherReducer);

/***/ }),
/* 619 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__ = __webpack_require__(5);
var initialState={valid:false,amount:0,expiryDate:'',discountOperation:'',code:null};var linkVoucherReducer=function linkVoucherReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_4" /* LINK_VOUCHER_LOAD */]:return Object.assign({},state,{valid:action.payload.active,amount:action.payload.value,expiryDate:action.payload.expiryDate,discountOperation:action.payload.discountOperation});default:return state;}};/* harmony default export */ __webpack_exports__["a"] = (linkVoucherReducer);

/***/ }),
/* 620 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__ = __webpack_require__(5);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var initialState={orders:[]};var deliveryTrackingReducer=function deliveryTrackingReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var actions=arguments[1];switch(actions.type){case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["U" /* GET_ORDERS_DELIVERY_TRACKING_SUCCESS */]:return Object.assign({},state,{orders:[].concat(_toConsumableArray(actions.orders))});default:return state;}};/* harmony default export */ __webpack_exports__["a"] = (deliveryTrackingReducer);

/***/ }),
/* 621 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__ = __webpack_require__(5);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var initialState={values:[],errorMessage:undefined};var taggedInputTextReducer=function taggedInputTextReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_50" /* TAGGED_INPUT_TEXT_ADD */]:return Object.assign({},state,{values:[].concat(_toConsumableArray(state.values),[action.payload])});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_51" /* TAGGED_INPUT_TEXT_REMOVE */]:var newValues=state.values.filter(function(a){return a.value!==action.payload.value;});return Object.assign({},state,{values:newValues});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_52" /* TAGGED_INPUT_TEXT_RESET */]:return initialState;default:return state;}};/* harmony default export */ __webpack_exports__["a"] = (taggedInputTextReducer);

/***/ }),
/* 622 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__ = __webpack_require__(5);
var initialState={invoice:{invoiceNumber:null,currency:null,total:null,descriptionSuccess:""}};var invoiceReducer=function invoiceReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var actions=arguments[1];var invoiceUpdate=void 0;switch(actions.type){case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_1" /* INVOICE_FETCHING_SUCCESS */]:invoiceUpdate={invoiceNumber:actions.invoiceNumber,currency:actions.currency,total:actions.total,descriptionSuccess:actions.descriptionSuccess};return Object.assign({},state,{invoice:Object.assign({},invoiceUpdate)});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_2" /* INVOICE_PAY_SUCCESS */]:invoiceUpdate=state.invoice;invoiceUpdate.descriptionSuccess=actions.descriptionSuccess;return Object.assign({},state,{invoice:Object.assign({},invoiceUpdate)});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_3" /* INVOICE_RESET_STATE */]:invoiceUpdate={invoiceNumber:null,currency:null,total:null};return Object.assign({},state,{invoice:Object.assign({},invoiceUpdate)});default:return state;}};/* harmony default export */ __webpack_exports__["a"] = (invoiceReducer);

/***/ }),
/* 623 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 624 */
/***/ (function(module, exports) {


/**
 * When source maps are enabled, `style-loader` uses a link element with a data-uri to
 * embed the css on the page. This breaks all relative urls because now they are relative to a
 * bundle instead of the current page.
 *
 * One solution is to only use full urls, but that may be impossible.
 *
 * Instead, this function "fixes" the relative urls to be absolute according to the current page location.
 *
 * A rudimentary test suite is located at `test/fixUrls.js` and can be run via the `npm test` command.
 *
 */

module.exports = function (css) {
  // get current location
  var location = typeof window !== "undefined" && window.location;

  if (!location) {
    throw new Error("fixUrls requires window.location");
  }

	// blank or null?
	if (!css || typeof css !== "string") {
	  return css;
  }

  var baseUrl = location.protocol + "//" + location.host;
  var currentDir = baseUrl + location.pathname.replace(/\/[^\/]*$/, "/");

	// convert each url(...)
	/*
	This regular expression is just a way to recursively match brackets within
	a string.

	 /url\s*\(  = Match on the word "url" with any whitespace after it and then a parens
	   (  = Start a capturing group
	     (?:  = Start a non-capturing group
	         [^)(]  = Match anything that isn't a parentheses
	         |  = OR
	         \(  = Match a start parentheses
	             (?:  = Start another non-capturing groups
	                 [^)(]+  = Match anything that isn't a parentheses
	                 |  = OR
	                 \(  = Match a start parentheses
	                     [^)(]*  = Match anything that isn't a parentheses
	                 \)  = Match a end parentheses
	             )  = End Group
              *\) = Match anything and then a close parens
          )  = Close non-capturing group
          *  = Match anything
       )  = Close capturing group
	 \)  = Match a close parens

	 /gi  = Get all matches, not the first.  Be case insensitive.
	 */
	var fixedCss = css.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function(fullMatch, origUrl) {
		// strip quotes (if they exist)
		var unquotedOrigUrl = origUrl
			.trim()
			.replace(/^"(.*)"$/, function(o, $1){ return $1; })
			.replace(/^'(.*)'$/, function(o, $1){ return $1; });

		// already a full url? no change
		if (/^(#|data:|http:\/\/|https:\/\/|file:\/\/\/)/i.test(unquotedOrigUrl)) {
		  return fullMatch;
		}

		// convert the url to a full url
		var newUrl;

		if (unquotedOrigUrl.indexOf("//") === 0) {
		  	//TODO: should we add protocol?
			newUrl = unquotedOrigUrl;
		} else if (unquotedOrigUrl.indexOf("/") === 0) {
			// path should be relative to the base url
			newUrl = baseUrl + unquotedOrigUrl; // already starts with '/'
		} else {
			// path should be relative to current directory
			newUrl = currentDir + unquotedOrigUrl.replace(/^\.\//, ""); // Strip leading './'
		}

		// send back the fixed url(...)
		return "url(" + JSON.stringify(newUrl) + ")";
	});

	// send back the fixed css
	return fixedCss;
};


/***/ }),
/* 625 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_Menu_Menu__ = __webpack_require__(626);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__containers_Landing__ = __webpack_require__(843);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__containers_Landing_PrivacyTerms__ = __webpack_require__(947);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__containers_Landing_TermsAndConditions__ = __webpack_require__(949);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__containers_Landing_DeleteAccount__ = __webpack_require__(950);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__auth__ = __webpack_require__(951);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__hoc_asyncComponent_asyncComponent__ = __webpack_require__(965);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__shared_liveChat__ = __webpack_require__(966);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__support_SupportDock__ = __webpack_require__(967);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__App_scss__ = __webpack_require__(968);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__App_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__App_scss__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MenuComponent=Object(__WEBPACK_IMPORTED_MODULE_7__auth__["a" /* userIsAuthenticatedRedir */])(__WEBPACK_IMPORTED_MODULE_2__containers_Menu_Menu__["a" /* default */]);var LandingComponent=Object(__WEBPACK_IMPORTED_MODULE_7__auth__["b" /* userIsNotAuthenticatedRedir */])(__WEBPACK_IMPORTED_MODULE_3__containers_Landing__["a" /* default */]);var asyncSignUp=Object(__WEBPACK_IMPORTED_MODULE_8__hoc_asyncComponent_asyncComponent__["a" /* default */])(function(){return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 1002));});var asyncChangePassword=Object(__WEBPACK_IMPORTED_MODULE_8__hoc_asyncComponent_asyncComponent__["a" /* default */])(function(){return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, 1003));});var asyncResetPassword=Object(__WEBPACK_IMPORTED_MODULE_8__hoc_asyncComponent_asyncComponent__["a" /* default */])(function(){return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, 1004));});var asyncUnsubscribe=Object(__WEBPACK_IMPORTED_MODULE_8__hoc_asyncComponent_asyncComponent__["a" /* default */])(function(){return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 1005));});var asyncLinkVoucher=Object(__WEBPACK_IMPORTED_MODULE_8__hoc_asyncComponent_asyncComponent__["a" /* default */])(function(){return __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, 1006));});// Email sign-in links: https://new.lunch.team/MagicLogin/<token> (also ?token=).
// The page verifies only when the person clicks "Sign me in".
var asyncMagicLogin=Object(__WEBPACK_IMPORTED_MODULE_8__hoc_asyncComponent_asyncComponent__["a" /* default */])(function(){return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, 1007));});// Set when the support composer took over and hid the widget; a later mount (sign-out, or the
// composer failing to load) brings it back.
var liveChatHiddenForComposer=false;var LiveChatLoader=function(_Component){_inherits(LiveChatLoader,_Component);function LiveChatLoader(){var _ref;var _temp,_this,_ret;_classCallCheck(this,LiveChatLoader);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=LiveChatLoader.__proto__||Object.getPrototypeOf(LiveChatLoader)).call.apply(_ref,[this].concat(args))),_this),_this.updateFallbackLauncherVisibility=function(){var button=document.getElementById('lunchteam-livechat-fallback');if(!button){return;}button.style.display=_this.isNativeLiveChatVisible()?'none':'block';},_this.openLiveChat=function(){if(window.LC_API&&typeof window.LC_API.open_chat_window==='function'){window.LC_API.open_chat_window();window.setTimeout(_this.updateFallbackLauncherVisibility,500);window.setTimeout(_this.updateFallbackLauncherVisibility,2000);return;}window.open('https://secure.livechatinc.com/licence/6817451/v2/open_chat.cgi?groups=1','_blank','noopener,noreferrer');},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(LiveChatLoader,[{key:'componentDidMount',value:function componentDidMount(){document.documentElement.classList.remove('lunchteam-livechat-off');this.installPositionStyle();if(liveChatHiddenForComposer){liveChatHiddenForComposer=false;this.showWidgetAgain();}if(this.isMobileSurface()){document.documentElement.classList.add('lunchteam-mobile-surface');return;}if(window.LC_API||document.getElementById('lunchteam-livechat-script')){this.installFallbackLauncher();this.startFallbackVisibilityChecks();return;}window.__lc=window.__lc||{};window.__lc.license=__WEBPACK_IMPORTED_MODULE_9__shared_liveChat__["a" /* LICENSE_ID */];var script=document.createElement('script');script.id='lunchteam-livechat-script';script.type='text/javascript';script.async=true;script.src='https://cdn.livechatinc.com/tracking.js';var firstScript=document.getElementsByTagName('script')[0];if(firstScript&&firstScript.parentNode){firstScript.parentNode.insertBefore(script,firstScript);}else{document.head.appendChild(script);}this.installFallbackLauncher();this.startFallbackVisibilityChecks();}// Unmounted when the support composer takes over (customer signed in): hide LiveChat and its fallback button.
},{key:'componentWillUnmount',value:function componentWillUnmount(){if(this.liveChatFallbackInterval){window.clearInterval(this.liveChatFallbackInterval);}(this.liveChatFallbackTimeouts||[]).forEach(function(timeout){return window.clearTimeout(timeout);});var button=document.getElementById('lunchteam-livechat-fallback');if(button&&button.parentNode){button.parentNode.removeChild(button);}document.documentElement.classList.add('lunchteam-livechat-off');liveChatHiddenForComposer=true;try{if(window.LiveChatWidget&&typeof window.LiveChatWidget.call==='function'){window.LiveChatWidget.call('hide');}else if(window.LC_API&&typeof window.LC_API.hide_chat_window==='function'){window.LC_API.hide_chat_window();}}catch(e){// The CSS rule below still hides the widget.
}}// Undoes the 'hide' above: the widget comes back minimised, as its launcher.
},{key:'showWidgetAgain',value:function showWidgetAgain(){try{if(window.LiveChatWidget&&typeof window.LiveChatWidget.call==='function'){window.LiveChatWidget.call('minimize');}else if(window.LC_API&&typeof window.LC_API.minimize_chat_window==='function'){window.LC_API.minimize_chat_window();}}catch(e){// The fallback launcher still opens the chat.
}}},{key:'installPositionStyle',value:function installPositionStyle(){if(document.getElementById('lunchteam-livechat-position')){return;}var style=document.createElement('style');style.id='lunchteam-livechat-position';style.textContent=['#chat-widget-container{left:0!important;right:auto!important;}','.lunchteam-livechat-off #chat-widget-container,.lunchteam-livechat-off #lunchteam-livechat-fallback{display:none!important;}','.lunchteam-mobile-surface #chat-widget-container,','.lunchteam-mobile-surface #lunchteam-livechat-fallback{display:none!important;visibility:hidden!important;pointer-events:none!important;}','@media (max-width:767px){#chat-widget-container,#lunchteam-livechat-fallback{display:none!important;visibility:hidden!important;pointer-events:none!important;}}'].join('');document.head.appendChild(style);}},{key:'isMobileSurface',value:function isMobileSurface(){var userAgent=navigator.userAgent||'';return /Android|iPhone|iPad|iPod/i.test(userAgent)||window.matchMedia('(max-width: 767px)').matches;}},{key:'installFallbackLauncher',value:function installFallbackLauncher(){if(document.getElementById('lunchteam-livechat-fallback')){return;}var button=document.createElement('button');button.id='lunchteam-livechat-fallback';button.type='button';button.setAttribute('aria-label','Open Lunch.Team support chat');button.textContent='Chat with us';button.style.cssText=['display:none','position:fixed','left:16px','bottom:16px','z-index:2147483647','border:0','border-radius:4px','background:#0e7a4b','color:#fff','font:600 14px/1.2 Arial,sans-serif','padding:14px 18px','box-shadow:0 4px 16px rgba(0,0,0,0.28)','cursor:pointer'].join(';');button.addEventListener('click',this.openLiveChat);document.body.appendChild(button);}},{key:'startFallbackVisibilityChecks',value:function startFallbackVisibilityChecks(){this.updateFallbackLauncherVisibility();this.liveChatFallbackTimeouts=[window.setTimeout(this.updateFallbackLauncherVisibility,2500),window.setTimeout(this.updateFallbackLauncherVisibility,6000)];this.liveChatFallbackInterval=window.setInterval(this.updateFallbackLauncherVisibility,5000);}},{key:'isNativeLiveChatVisible',value:function isNativeLiveChatVisible(){var container=document.getElementById('chat-widget-container');if(!container){return false;}var style=window.getComputedStyle(container);var rect=container.getBoundingClientRect();return style.display!=='none'&&style.visibility!=='hidden'&&style.opacity!=='0'&&style.zIndex!=='-1'&&rect.width>0&&rect.height>0;}},{key:'render',value:function render(){return null;}}]);return LiveChatLoader;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var App=function(_Component2){_inherits(App,_Component2);function App(){_classCallCheck(this,App);return _possibleConstructorReturn(this,(App.__proto__||Object.getPrototypeOf(App)).apply(this,arguments));}_createClass(App,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["f" /* Switch */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{path:'/Signup',component:asyncSignUp}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{path:'/Unsubscribe',component:asyncUnsubscribe}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{path:'/ChangePassword',component:asyncChangePassword}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{path:'/ResetPassword',component:asyncResetPassword}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{path:'/MagicLogin',component:asyncMagicLogin}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{path:'/Menu',component:MenuComponent}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{path:'/GetVoucher',component:asyncLinkVoucher}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{path:'/',exact:true,component:LandingComponent}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{path:'/Privacy',component:__WEBPACK_IMPORTED_MODULE_4__containers_Landing_PrivacyTerms__["a" /* PrivacyTerms */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{path:'/Terms',component:__WEBPACK_IMPORTED_MODULE_5__containers_Landing_TermsAndConditions__["a" /* TermsAndConditions */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{path:'/delete-account',component:__WEBPACK_IMPORTED_MODULE_6__containers_Landing_DeleteAccount__["a" /* DeleteAccount */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{path:'/DeleteAccount',component:__WEBPACK_IMPORTED_MODULE_6__containers_Landing_DeleteAccount__["a" /* DeleteAccount */]})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__support_SupportDock__["a" /* default */],{fallback:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(LiveChatLoader,null)}));}}]);return App;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (App);

/***/ }),
/* 626 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MenuComponents_CookieApproval__ = __webpack_require__(627);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__DefaultMenu_DefaultMenu__ = __webpack_require__(669);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DynamicMenu_DynamicMenu__ = __webpack_require__(764);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__FastReOrder__ = __webpack_require__(767);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_containers_DeliveryTracking__ = __webpack_require__(768);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_containers_Settings__ = __webpack_require__(772);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_containers_GDPR__ = __webpack_require__(784);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Header__ = __webpack_require__(787);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__SideBar_SideBar__ = __webpack_require__(790);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_containers_Checkout__ = __webpack_require__(793);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_containers_TeamVoucher__ = __webpack_require__(803);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__hoc_ReactAux_ReactAux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__DefaultMenu_OptionsForOrder__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Cart_GuestRecipient__ = __webpack_require__(837);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_components_UI_Modal_ModalError__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_components_UI_Modal_ModalSuccess__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__OrderFeedbackCard_OrderFeedbackCard__ = __webpack_require__(841);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_utils_queryString__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_actions_index__ = __webpack_require__(13);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MenuBuilder=function(_Component){_inherits(MenuBuilder,_Component);function MenuBuilder(){var _ref;var _temp,_this,_ret;_classCallCheck(this,MenuBuilder);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=MenuBuilder.__proto__||Object.getPrototypeOf(MenuBuilder)).call.apply(_ref,[this].concat(args))),_this),_this.state={feedbackAddressKey:null,feedbackTestCompleted:false},_this.onHandleVerifyRepeatOrder=function(){var idOrderToRepeat=parseFloat(_this.props.location.pathname.substring(_this.props.location.pathname.lastIndexOf('/')+1,_this.props.location.pathname.length));if(!isNaN(idOrderToRepeat)){_this.props.onChangeTitleHeader('Popular Dishes');_this.handleItemArraySideBarToActive(1);_this.props.onHandleOrderToRepeat(idOrderToRepeat);}},_this.onHandleInvoicePayment=function(){var values=__WEBPACK_IMPORTED_MODULE_20_utils_queryString__["a" /* default */].parse(_this.props.location.search);if(values.invoice){_this.props.onhandleInvoiceInfo(values.invoice);}},_this.onHandleSelectItemSideBar=function(index){_this.handleItemArraySideBarToActive(index);var pickedOnlyRestaurant=false;switch(index){case 1:pickedOnlyRestaurant=_this.onHandleSelectDefaultMenu();break;case 2:_this.onHandleFastReOrder();break;case 3:_this.onHandleTeamVoucher();break;case 4:_this.onHandlePlatter();break;case 5:_this.props.toggleIsCartButtonDisabled(false);_this.props.onToggleCart();break;case 6:_this.onHandleDeliveryTracking();break;case 7:_this.onHandleSettings();break;case 8:_this.onHandleGDPR();break;case 9:_this.onHandleLogout();break;default:break;}// With one restaurant the menu is chosen for the customer and the drawer closes; otherwise it toggles as before.
if(pickedOnlyRestaurant)_this.props.onToggleMenuMobile(false);else _this.props.onToggleMenuMobile();},_this.handleItemArraySideBarToActive=function(index){var updateItemsSideBar=[].concat(_toConsumableArray(_this.props.itemsSideBarMenu));var updateItemInactive=updateItemsSideBar.find(function(item){return item.active===true;});if(updateItemInactive.index!==index){var updateItemActive=updateItemsSideBar.find(function(item){return item.index===index;});updateItemInactive.active=false;updateItemsSideBar[updateItemActive.index-1]=updateItemActive;updateItemActive.active=true;updateItemsSideBar[updateItemInactive.index-1]=updateItemInactive;_this.props.onSelectItemSideBarMenu(updateItemsSideBar);}},_this.onHandleSelectDefaultMenu=function(){_this.props.onDeleteRestaurantSelected();_this.props.history.replace('/Menu');return _this.initPrint();},_this.onHandleFastReOrder=function(){_this.props.onDeleteRestaurantSelected();_this.props.history.replace('/Menu/FastReOrder');},_this.onHandlePlatter=function(){_this.props.onSelectDeliveryOption();_this.props.onDeleteRestaurantSelected();_this.props.history.replace('/Menu');},_this.onHandleOptionsMenu=function(){_this.props.history.replace('/Menu');},_this.onHandleCheckout=function(){_this.props.onDeleteRestaurantSelected();_this.props.history.replace('/Menu/checkout');},_this.onHandleTeamVoucher=function(){_this.props.onSelectDeliveryOption();_this.props.onDeleteRestaurantSelected();_this.props.history.replace('/Menu/TeamVoucher');},_this.onHandleDeliveryTracking=function(){_this.props.onDeleteRestaurantSelected();_this.props.history.replace('/Menu/DeliveryTracking');},_this.onHandleSettings=function(){_this.props.onDeleteRestaurantSelected();_this.props.history.replace('/Menu/Settings');},_this.onHandleGDPR=function(){_this.props.onDeleteRestaurantSelected();_this.props.history.replace('/Menu/GDPR');},_this.onHandleLogout=function(){_this.props.onLogoutRequest();},_this.onHandleToggleRestaurantOptions=function(idRestaurantsOptions){_this.props.onChangeRestaurantOptions(idRestaurantsOptions);_this.props.onDeleteRestaurantSelected();},_this.onHandleSelectRestaurantDelivery=function(idRestaurant){if(_this.props.restaurantsOptions[0].active){var restaurant=_this.props.itemsSideBarMenu[0].restaurants.businessDelivery.find(function(business){return business.id===idRestaurant;});_this.props.onRestaurantSelected(restaurant);_this.props.onChangeTitleHeader(restaurant.name);_this.props.onCategoriesSelected(restaurant.categoryType);}else{var _restaurant=_this.props.itemsSideBarMenu[0].restaurants.businessCollection.find(function(business){return business.id===idRestaurant;});_this.props.onRestaurantSelected(_restaurant);_this.props.onChangeTitleHeader(_restaurant.name);_this.props.onCategoriesSelected(_restaurant.categoryType);}_this.props.onToggleCart(false);_this.props.history.replace('/Menu/Dynamic');_this.props.onVerifyRestaurantAvailable(idRestaurant,_this.props.userDetails.idBusiness);},_this.onHandleSelectRestaurantPlatter=function(idRestaurant){var restaurant=_this.props.itemsSideBarMenu[3].restaurants.businessPlatter.find(function(business){return business.id===idRestaurant;});_this.props.onRestaurantSelected(restaurant);_this.props.onCategoriesSelected(restaurant.categoryType);_this.props.onToggleCart(false);_this.props.history.replace('/Menu/Dynamic');},_this.handleMenu=function(idBusiness,idAddress){_this.props.onFetchingMenu(idBusiness,idAddress);},_this.handleSelectOptionForOrder=function(address){/*Adding address for order to array of addresses */address.forCollection&&_this.props.onSelectForColectionOption();var addresses=[].concat(_toConsumableArray(!_this.props.addresses.some(function(item){return item.forCollection===address.forCollection;})||!!!address.forCollection?[].concat(_toConsumableArray(_this.props.addresses),[address]):_this.props.addresses));/*If address wasn't forCollection then check if there's a forCollection Address in
    fetched list if yes add it to array of addresses */if(!!!address.forCollection){addresses=[].concat(_toConsumableArray(!!!_this.props.addresses.some(function(item){return item.forCollection;})&&_this.props.listAddress.some(function(item){return item.forCollection;})?[].concat(_toConsumableArray(addresses),[_this.props.listAddress.find(function(item){return item.forCollection;})]):addresses));}_this.props.onSelectAddressForOrder(addresses);_this.props.onFetchingMenu(_this.props.userDetails.idBusiness,address.idBusinessAddress);_this.fetchFeedbackForAddress(address);_this.initPrint();},_this.fetchFeedbackForSelectedAddress=function(){if(!_this.props.addresses||_this.props.addresses.length===0){return;}_this.fetchFeedbackForAddress(_this.props.addresses[0]);},_this.fetchFeedbackForAddress=function(address){var idAddress=address&&address.idBusinessAddress;var feedbackAddressKey=idAddress||'default';if(_this.state.feedbackAddressKey===feedbackAddressKey){return;}_this.setState({feedbackAddressKey:feedbackAddressKey});_this.props.onFetchingPendingOrderFeedback(idAddress);},_this.isFeedbackTestMode=function(){var values=__WEBPACK_IMPORTED_MODULE_20_utils_queryString__["a" /* default */].parse(_this.props.location.search);return values.feedbackTest==='1';},_this.getFeedback=function(){if(_this.props.pendingFeedback){return _this.props.pendingFeedback;}if(!_this.isFeedbackTestMode()||_this.state.feedbackTestCompleted){return null;}return{previousOrderId:-1,restaurantId:-1,restaurantName:_this.props.titleHeader||'Demo Restaurant Dublin',orderedItemsSnapshot:'Caesar Club',isFeedbackTest:true};},_this.handleSubmitOrderFeedback=function(payload){if(payload.previousOrderId===-1){_this.setState({feedbackTestCompleted:true});return;}_this.props.onSubmitOrderFeedback(payload);},_this.handleSkipOrderFeedback=function(payload){if(payload.previousOrderId===-1){_this.setState({feedbackTestCompleted:true});return;}_this.props.onSkipOrderFeedback(payload);},_this.handleCreateCustomerDeliveryAddress=function(place){_this.props.onCreateCustomerDeliveryAddress(place);},_this.showOptionsForOrder=function(){return _this.props.restaurantsOptions[0].active?_this.props.listAddress.length>0&&!_this.props.addresses.some(function(item){return item.forCollection===false;}):false;},_this.showCollectionOption=function(){return!_this.props.addresses.find(function(address){return address.forCollection;})&&_this.props.showCollectionOption;},_this.initPrint=function(){var businessCollection=_this.props.itemsSideBarMenu[0].restaurants.businessCollection;var businessDelivery=_this.props.itemsSideBarMenu[0].restaurants.businessDelivery;// With one restaurant it is chosen for the customer and the menu drawer stays closed. A bare toggle here opened
// the drawer on every phone load, over the page and the support composer.
if(businessCollection.length===1&&businessDelivery.length===0){_this.onHandleSelectRestaurantPlatter(businessCollection[0].id);_this.props.onToggleMenuMobile(false);return true;}if(businessDelivery.length===1&&businessCollection.length===0){_this.onHandleSelectRestaurantDelivery(businessDelivery[0].id);_this.props.onToggleMenuMobile(false);return true;}return false;},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(MenuBuilder,[{key:'componentDidMount',value:function componentDidMount(){this.props.onFetchingBusinessFromUser();this.onHandleVerifyRepeatOrder();this.onHandleInvoicePayment();this.fetchFeedbackForSelectedAddress();this.initPrint();}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){if(prevProps.addresses!==this.props.addresses){this.fetchFeedbackForSelectedAddress();}}},{key:'componentWillUnmount',value:function componentWillUnmount(){this.props.history.replace('/');}},{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__hoc_ReactAux_ReactAux__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__MenuComponents_CookieApproval__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'wrap',tabIndex:0},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__SideBar_SideBar__["a" /* default */],{goToDefaultMenu:this.onHandleSelectItemSideBar,activeRestaurant:this.props.restaurantSelected,selectItemSideBar:this.onHandleSelectItemSideBar,restaurantsOptions:this.props.restaurantsOptions,showMenuMobile:this.props.showMenuMobile,toggleMenuMobile:this.props.onToggleMenuMobile,showRestaurantsMobile:this.props.showRestaurantsMobile,selectRestaurantDelivery:this.onHandleSelectRestaurantDelivery,selectRestaurantPlatter:this.onHandleSelectRestaurantPlatter,itemsSideBarMenu:this.props.itemsSideBarMenu}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'principal-right',tabIndex:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Header__["a" /* default */],{showCollectionOption:this.props.showCollectionOption,titleHeader:this.props.titleHeader,itemsSideBarMenu:this.props.itemsSideBarMenu,toggleCart:this.props.onToggleCart,toggleMenuMobile:this.props.onToggleMenuMobile,showMenuMobile:this.props.showMenuMobile,goToDefaultMenu:this.onHandleSelectItemSideBar,restaurantSelected:this.props.restaurantSelected,restaurantsOptions:this.props.restaurantsOptions,quantityProductsSelected:this.props.products.length,toggleRestaurantOptions:this.onHandleToggleRestaurantOptions,businessId:this.props.userDetails.idBusiness}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__DefaultMenu_OptionsForOrder__["a" /* default */],{onFetchingMenu:this.handleMenu,idBusiness:this.props.userDetails.idBusiness,listAddress:this.props.listAddress,showModal:this.showOptionsForOrder(),showCollectionOption:this.showCollectionOption(),onToggleCart:this.props.onToggleCart,onDeleteAllproductsFromCard:this.props.onDeleteAllproductsFromCard,showDeliverAtHomeOption:this.props.showDeliverAtHomeOption,selectOptionForOrder:this.handleSelectOptionForOrder,createCustomerDeliveryAddress:this.handleCreateCustomerDeliveryAddress,onCartResetState:this.props.onCartResetState,onDeleteRestaurantSelected:this.props.onDeleteRestaurantSelected,onFetchingRecentlyOrdered:this.props.onFetchingRecentlyOrdered}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_components_UI_Modal_ModalError__["a" /* default */],{style:{zIndex:'99999',position:'absolute',margin:'5% 26%'},showModal:this.props.showErrorModalCreateLinkVoucher,closeModal:function closeModal(){return _this2.props.onCloseErrorModalCreateLinkVoucher();},errorMessage:this.props.showMessageLinkVoucher,actionButtonTitle:''}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_components_UI_Modal_ModalSuccess__["a" /* default */],{showModal:this.props.showSuccessModalCreateLinkVoucher,message:this.props.showMessageLinkVoucher,closeModal:function closeModal(){return _this2.props.onCloseSuccessModalCreateLinkVoucher();}}),this.props.feedbackSuccess||this.state.feedbackTestCompleted?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'order-feedback-success',role:'status'},'Thanks \u2014 this helps us improve lunch.'):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__OrderFeedbackCard_OrderFeedbackCard__["a" /* default */],{feedback:this.getFeedback(),onSubmit:this.handleSubmitOrderFeedback,onSkip:this.handleSkipOrderFeedback}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__Cart_GuestRecipient__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["f" /* Switch */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["e" /* Route */],{exact:true,path:'/Menu',component:__WEBPACK_IMPORTED_MODULE_4__DefaultMenu_DefaultMenu__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["e" /* Route */],{path:'/Menu/Dynamic',component:__WEBPACK_IMPORTED_MODULE_5__DynamicMenu_DynamicMenu__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["e" /* Route */],{path:'/Menu/FastReOrder',component:__WEBPACK_IMPORTED_MODULE_6__FastReOrder__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["e" /* Route */],{path:'/Menu/checkout',component:__WEBPACK_IMPORTED_MODULE_12_containers_Checkout__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["e" /* Route */],{path:'/Menu/DeliveryTracking',component:__WEBPACK_IMPORTED_MODULE_7_containers_DeliveryTracking__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["e" /* Route */],{path:'/Menu/Settings',component:__WEBPACK_IMPORTED_MODULE_8_containers_Settings__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["e" /* Route */],{path:'/Menu/GDPR',component:__WEBPACK_IMPORTED_MODULE_9_containers_GDPR__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["e" /* Route */],{path:'/Menu/TeamVoucher',component:__WEBPACK_IMPORTED_MODULE_13_containers_TeamVoucher__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["e" /* Route */],{path:'/Menu/ReOrder/:idOrder',component:__WEBPACK_IMPORTED_MODULE_4__DefaultMenu_DefaultMenu__["a" /* default */]})))));}}]);return MenuBuilder;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{titleHeader:state.menuReducer.titleHeader,restaurantsOptions:state.menuReducer.restaurantsOptions,userDetails:state.authenticationReducer.userDetails,restaurantSelected:state.menuReducer.restaurantSelected,itemsSideBarMenu:state.menuReducer.itemsSideBarMenu,products:state.cartReducer.cart.products,showMenuMobile:state.menuReducer.showMenuMobile,showRestaurantsMobile:state.menuReducer.showRestaurantsMobile,showCollectionOption:state.menuReducer.showCollectionOption,showDeliverAtHomeOption:state.menuReducer.acceptDeliverAtHome,listAddress:state.menuReducer.listAddress,addresses:state.menuReducer.addresses,showSuccessModalCreateLinkVoucher:state.landingReducer.showSuccessModalCreateLinkVoucher,showErrorModalCreateLinkVoucher:state.landingReducer.showErrorModalCreateLinkVoucher,showMessageLinkVoucher:state.landingReducer.showMessage,pendingFeedback:state.menuReducer.pendingFeedback,feedbackSuccess:state.menuReducer.feedbackSuccess};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onChangeTitleHeader:function onChangeTitleHeader(titleHeader){return dispatch(__WEBPACK_IMPORTED_MODULE_21_actions_index__["l" /* changeMenuTitleHeader */](titleHeader));},onChangeRestaurantOptions:function onChangeRestaurantOptions(idRestaurantsOptions){return dispatch(__WEBPACK_IMPORTED_MODULE_21_actions_index__["m" /* changeRestaurantOptions */](idRestaurantsOptions));},onFetchingMenu:function onFetchingMenu(idBusiness,idAddress){return dispatch(__WEBPACK_IMPORTED_MODULE_21_actions_index__["V" /* fetchingMenu */](idBusiness,idAddress));},onFetchingBusinessFromUser:function onFetchingBusinessFromUser(){return dispatch(__WEBPACK_IMPORTED_MODULE_21_actions_index__["O" /* fetchingBusinessFromUser */]());},onSelectItemSideBarMenu:function onSelectItemSideBarMenu(itemsSideBar){return dispatch(__WEBPACK_IMPORTED_MODULE_21_actions_index__["_24" /* selectItemSideBarMenu */](itemsSideBar));},onLogoutRequest:function onLogoutRequest(){return dispatch(__WEBPACK_IMPORTED_MODULE_21_actions_index__["_5" /* logoutRequest */]());},onRestaurantSelected:function onRestaurantSelected(restaurant){return dispatch(__WEBPACK_IMPORTED_MODULE_21_actions_index__["_21" /* restaurantSelected */](restaurant));},onCategoriesSelected:function onCategoriesSelected(categoriesSelected){return dispatch(__WEBPACK_IMPORTED_MODULE_21_actions_index__["j" /* categoriesSelected */](categoriesSelected));},onDeleteRestaurantSelected:function onDeleteRestaurantSelected(){return dispatch(__WEBPACK_IMPORTED_MODULE_21_actions_index__["J" /* deleteRestaurantSelected */]());},onToggleCart:function onToggleCart(status){return dispatch(__WEBPACK_IMPORTED_MODULE_21_actions_index__["_34" /* toggleCart */](status));},onToggleMenuMobile:function onToggleMenuMobile(status){return dispatch(__WEBPACK_IMPORTED_MODULE_21_actions_index__["_36" /* toggleMenuMobile */](status));},toggleIsCartButtonDisabled:function toggleIsCartButtonDisabled(disabled){return dispatch(__WEBPACK_IMPORTED_MODULE_21_actions_index__["_35" /* toggleIsButtonDisabled */](disabled));},onHandleOrderToRepeat:function onHandleOrderToRepeat(idOrder){return dispatch(__WEBPACK_IMPORTED_MODULE_21_actions_index__["_3" /* handleOrderToRepeat */](idOrder));},onhandleInvoiceInfo:function onhandleInvoiceInfo(invoiceNumber){return dispatch(__WEBPACK_IMPORTED_MODULE_21_actions_index__["S" /* fetchingInvoiceInfo */](invoiceNumber));},onVerifyRestaurantAvailable:function onVerifyRestaurantAvailable(idRestaurant,idBusiness){return dispatch(__WEBPACK_IMPORTED_MODULE_21_actions_index__["_41" /* verifyRestaurantAvailable */](idRestaurant,idBusiness));},onSelectDeliveryOption:function onSelectDeliveryOption(){return dispatch(__WEBPACK_IMPORTED_MODULE_21_actions_index__["m" /* changeRestaurantOptions */](1));},onSelectForColectionOption:function onSelectForColectionOption(){return dispatch(__WEBPACK_IMPORTED_MODULE_21_actions_index__["m" /* changeRestaurantOptions */](2));},onSelectAddressForOrder:function onSelectAddressForOrder(address){return dispatch(__WEBPACK_IMPORTED_MODULE_21_actions_index__["_22" /* selectAddressForOrder */](address));},onCloseSuccessModalCreateLinkVoucher:function onCloseSuccessModalCreateLinkVoucher(){return dispatch(__WEBPACK_IMPORTED_MODULE_21_actions_index__["D" /* closeSuccessModalCreateLinkVoucher */]());},onCloseErrorModalCreateLinkVoucher:function onCloseErrorModalCreateLinkVoucher(){return dispatch(__WEBPACK_IMPORTED_MODULE_21_actions_index__["r" /* closeErrorModalCreateLinkVoucher */]());},onCreateCustomerDeliveryAddress:function onCreateCustomerDeliveryAddress(place){return dispatch(__WEBPACK_IMPORTED_MODULE_21_actions_index__["F" /* createCustomerDeliveryAddress */](place));},onDeleteAllproductsFromCard:function onDeleteAllproductsFromCard(){return dispatch(__WEBPACK_IMPORTED_MODULE_21_actions_index__["G" /* deleteAllProductsFromCart */]());},onCartResetState:function onCartResetState(){return dispatch(__WEBPACK_IMPORTED_MODULE_21_actions_index__["g" /* cartResetState */]());},onFetchingRecentlyOrdered:function onFetchingRecentlyOrdered(idAddress){return dispatch(__WEBPACK_IMPORTED_MODULE_21_actions_index__["Y" /* fetchingRecentlyOrdered */](idAddress));},onFetchingPendingOrderFeedback:function onFetchingPendingOrderFeedback(idAddress){return dispatch(__WEBPACK_IMPORTED_MODULE_21_actions_index__["W" /* fetchingPendingOrderFeedback */](idAddress));},onSubmitOrderFeedback:function onSubmitOrderFeedback(payload){return dispatch(__WEBPACK_IMPORTED_MODULE_21_actions_index__["_31" /* submitOrderFeedback */](payload));},onSkipOrderFeedback:function onSkipOrderFeedback(payload){return dispatch(__WEBPACK_IMPORTED_MODULE_21_actions_index__["_29" /* skipOrderFeedback */](payload));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(MenuBuilder));

/***/ }),
/* 627 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_cookie_consent__ = __webpack_require__(628);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_cookie_consent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_cookie_consent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_containers_GDPR_GDPRModal__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_hoc_ReactAux_ReactAux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_actions_Gdpr__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__CookieApproval_css__ = __webpack_require__(668);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__CookieApproval_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__CookieApproval_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CookieApproval=function(_Component){_inherits(CookieApproval,_Component);function CookieApproval(props){_classCallCheck(this,CookieApproval);var _this=_possibleConstructorReturn(this,(CookieApproval.__proto__||Object.getPrototypeOf(CookieApproval)).call(this,props));_this.state={showModal:false};_this.escFunction=function(event){if(event.keyCode===27){_this.setState({showModal:false});}};_this.handlePrivacyPolicy=function(){_this.props.onFetchingPrivacyPolicy();_this.setState({showModal:true});};_this.handleCloseModal=function(){_this.setState({showModal:false});};_this.escFunction=_this.escFunction.bind(_this);return _this;}_createClass(CookieApproval,[{key:"componentDidMount",value:function componentDidMount(){document.addEventListener("keydown",this.escFunction,false);}},{key:"componentWillUnmount",value:function componentWillUnmount(){document.removeEventListener("keydown",this.escFunction,false);}},{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_hoc_ReactAux_ReactAux__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_cookie_consent___default.a,{location:"top",expire:365,disableStyles:true,buttonText:"OK",containerClasses:"cookie-approval",contentClasses:"cookie-approval-text",buttonClasses:"cookie-approval-button"},"We use cookies to make Lunch.Team work and to improve it."," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{type:"button",className:"cookie-approval-link",onClick:this.handlePrivacyPolicy},"Privacy policy")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_containers_GDPR_GDPRModal__["a" /* default */],{style:{top:"15%",right:"1%",height:"60%",width:"98%",overflow:"hidden"},show:this.state.showModal,privacyPolicy:this.props.privacyPolicy,closeModal:this.handleCloseModal,isTermsConditions:false}));}}]);return CookieApproval;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{privacyPolicy:state.gdprReducer.privacyPolicy};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onFetchingPrivacyPolicy:function onFetchingPrivacyPolicy(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_actions_Gdpr__["a" /* fetchingPrivacyPolicy */])());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(CookieApproval));

/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 8);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (process.env.NODE_ENV !== 'production') {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyFunction = __webpack_require__(1);

/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = emptyFunction;

if (process.env.NODE_ENV !== 'production') {
  var printWarning = function printWarning(format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  warning = function warning(condition, format) {
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }

    if (format.indexOf('Failed Composite propType: ') === 0) {
      return; // Ignore CompositeComponent proptype check.
    }

    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

module.exports = warning;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * JavaScript Cookie v2.2.0
 * https://github.com/js-cookie/js-cookie
 *
 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
 * Released under the MIT license
 */
;(function (factory) {
	var registeredInModuleLoader = false;
	if (true) {
		!(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		registeredInModuleLoader = true;
	}
	if (true) {
		module.exports = factory();
		registeredInModuleLoader = true;
	}
	if (!registeredInModuleLoader) {
		var OldCookies = window.Cookies;
		var api = window.Cookies = factory();
		api.noConflict = function () {
			window.Cookies = OldCookies;
			return api;
		};
	}
}(function () {
	function extend () {
		var i = 0;
		var result = {};
		for (; i < arguments.length; i++) {
			var attributes = arguments[ i ];
			for (var key in attributes) {
				result[key] = attributes[key];
			}
		}
		return result;
	}

	function init (converter) {
		function api (key, value, attributes) {
			var result;
			if (typeof document === 'undefined') {
				return;
			}

			// Write

			if (arguments.length > 1) {
				attributes = extend({
					path: '/'
				}, api.defaults, attributes);

				if (typeof attributes.expires === 'number') {
					var expires = new Date();
					expires.setMilliseconds(expires.getMilliseconds() + attributes.expires * 864e+5);
					attributes.expires = expires;
				}

				// We're using "expires" because "max-age" is not supported by IE
				attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';

				try {
					result = JSON.stringify(value);
					if (/^[\{\[]/.test(result)) {
						value = result;
					}
				} catch (e) {}

				if (!converter.write) {
					value = encodeURIComponent(String(value))
						.replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);
				} else {
					value = converter.write(value, key);
				}

				key = encodeURIComponent(String(key));
				key = key.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent);
				key = key.replace(/[\(\)]/g, escape);

				var stringifiedAttributes = '';

				for (var attributeName in attributes) {
					if (!attributes[attributeName]) {
						continue;
					}
					stringifiedAttributes += '; ' + attributeName;
					if (attributes[attributeName] === true) {
						continue;
					}
					stringifiedAttributes += '=' + attributes[attributeName];
				}
				return (document.cookie = key + '=' + value + stringifiedAttributes);
			}

			// Read

			if (!key) {
				result = {};
			}

			// To prevent the for loop in the first place assign an empty array
			// in case there are no cookies at all. Also prevents odd result when
			// calling "get()"
			var cookies = document.cookie ? document.cookie.split('; ') : [];
			var rdecode = /(%[0-9A-Z]{2})+/g;
			var i = 0;

			for (; i < cookies.length; i++) {
				var parts = cookies[i].split('=');
				var cookie = parts.slice(1).join('=');

				if (!this.json && cookie.charAt(0) === '"') {
					cookie = cookie.slice(1, -1);
				}

				try {
					var name = parts[0].replace(rdecode, decodeURIComponent);
					cookie = converter.read ?
						converter.read(cookie, name) : converter(cookie, name) ||
						cookie.replace(rdecode, decodeURIComponent);

					if (this.json) {
						try {
							cookie = JSON.parse(cookie);
						} catch (e) {}
					}

					if (key === name) {
						result = cookie;
						break;
					}

					if (!key) {
						result[name] = cookie;
					}
				} catch (e) {}
			}

			return result;
		}

		api.set = api;
		api.get = function (key) {
			return api.call(api, key);
		};
		api.getJSON = function () {
			return api.apply({
				json: true
			}, [].slice.call(arguments));
		};
		api.defaults = {};

		api.remove = function (key, attributes) {
			api(key, '', extend(attributes, {
				expires: -1
			}));
		};

		api.withConverter = init;

		return api;
	}

	return init(function () {});
}));


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (process.env.NODE_ENV !== 'production') {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = __webpack_require__(12)(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(11)();
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 7 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(629);

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Cookies = exports.OPTIONS = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(7);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(6);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _jsCookie = __webpack_require__(5);

var _jsCookie2 = _interopRequireDefault(_jsCookie);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var OPTIONS = exports.OPTIONS = {
  TOP: "top",
  BOTTOM: "bottom",
  NONE: "none"
};

var CookieConsent = function (_Component) {
  _inherits(CookieConsent, _Component);

  function CookieConsent(props) {
    _classCallCheck(this, CookieConsent);

    var _this = _possibleConstructorReturn(this, (CookieConsent.__proto__ || Object.getPrototypeOf(CookieConsent)).call(this, props));

    _this.accept.bind(_this);

    _this.state = {
      visible: false,
      style: {
        alignItems: "baseline",
        background: "#353535",
        color: "white",
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "space-between",
        left: "0",
        position: "fixed",
        width: "100%",
        zIndex: "999"
      },
      buttonStyle: {
        background: "#ffd42d",
        border: "0",
        borderRadius: "0px",
        boxShadow: "none",
        color: "black",
        flex: "0 0 auto",
        padding: "5px 10px",
        margin: "15px"
      },
      contentStyle: {
        flex: "1 0 300px",
        margin: "15px"
      }
    };

    _this.handleScroll = _this.handleScroll.bind(_this);
    return _this;
  }

  _createClass(CookieConsent, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _props = this.props,
          cookieName = _props.cookieName,
          debug = _props.debug;

      // if cookie undefined or debug

      if (_jsCookie2.default.get(cookieName) === undefined || debug) {
        this.setState({ visible: true });
      }

      // if acceptOnScroll is set to true, add a listener
      if (this.props.acceptOnScroll) {
        window.addEventListener("scroll", this.handleScroll, { passive: true });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // remove listener if still set
      window.removeEventListener("scroll", this.handleScroll);
    }

    /**
     * checks whether scroll has exceeded set amount and fire accept if so.
     */

  }, {
    key: "handleScroll",
    value: function handleScroll() {
      // (top / height) - height * 100
      var rootNode = document.documentElement,
          body = document.body,
          top = "scrollTop",
          height = "scrollHeight";

      var percentage = (rootNode[top] || body[top]) / ((rootNode[height] || body[height]) - rootNode.clientHeight) * 100;

      if (percentage > this.props.acceptOnScrollPercentage) {
        this.accept();
      }
    }

    /**
     * Set a persistent cookie
     */

  }, {
    key: "accept",
    value: function accept() {
      var _props2 = this.props,
          cookieName = _props2.cookieName,
          cookieValue = _props2.cookieValue,
          expires = _props2.expires,
          hideOnAccept = _props2.hideOnAccept,
          onAccept = _props2.onAccept,
          extraCookieOptions = _props2.extraCookieOptions;

      // fire onAccept

      onAccept();
      // remove listener if set
      window.removeEventListener("scroll", this.handleScroll);

      _jsCookie2.default.set(cookieName, cookieValue, _extends({ expires: expires }, extraCookieOptions));

      if (hideOnAccept) {
        this.setState({ visible: false });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      // If the bar shouldn't be visible don't render anything.
      if (!this.state.visible) {
        return null;
      }

      var _props3 = this.props,
          location = _props3.location,
          style = _props3.style,
          buttonStyle = _props3.buttonStyle,
          contentStyle = _props3.contentStyle,
          disableStyles = _props3.disableStyles,
          buttonText = _props3.buttonText,
          containerClasses = _props3.containerClasses,
          contentClasses = _props3.contentClasses,
          buttonClasses = _props3.buttonClasses,
          buttonId = _props3.buttonId;


      var myStyle = {};
      var myButtonStyle = {};
      var myContentStyle = {};

      if (disableStyles) {
        // if styles are disabled use the provided styles (or non)
        myStyle = Object.assign({}, style);
        myButtonStyle = Object.assign({}, buttonStyle);
        myContentStyle = Object.assign({}, contentStyle);
      } else {
        // if styles aren't disabled merge them with the styles that are provided (or use default styles)
        myStyle = Object.assign({}, _extends({}, this.state.style, style));
        myButtonStyle = Object.assign({}, _extends({}, this.state.buttonStyle, buttonStyle));
        myContentStyle = Object.assign({}, _extends({}, this.state.contentStyle, contentStyle));
      }

      // syntactic sugar to enable user to easily select top / bottom
      switch (location) {
        case OPTIONS.TOP:
          myStyle.top = "0";
          myStyle.position = "fixed";
          break;

        case OPTIONS.BOTTOM:
          myStyle.bottom = "0";
          myStyle.position = "fixed";
          break;
      }

      return _react2.default.createElement(
        "div",
        { className: "cookieConsent " + containerClasses, style: myStyle },
        _react2.default.createElement(
          "div",
          { style: myContentStyle, className: contentClasses },
          this.props.children
        ),
        _react2.default.createElement(
          "button",
          {
            style: myButtonStyle,
            className: buttonClasses,
            id: buttonId,
            onClick: function onClick() {
              _this2.accept();
            }
          },
          buttonText
        )
      );
    }
  }]);

  return CookieConsent;
}(_react.Component);

CookieConsent.propTypes = {
  location: _propTypes2.default.oneOf(Object.keys(OPTIONS).map(function (key) {
    return OPTIONS[key];
  })),
  style: _propTypes2.default.object,
  buttonStyle: _propTypes2.default.object,
  contentStyle: _propTypes2.default.object,
  children: _propTypes2.default.any, // eslint-disable-line react/forbid-prop-types
  disableStyles: _propTypes2.default.bool,
  hideOnAccept: _propTypes2.default.bool,
  onAccept: _propTypes2.default.func,
  buttonText: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func, _propTypes2.default.element]),
  cookieName: _propTypes2.default.string,
  cookieValue: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.bool, _propTypes2.default.number]),
  debug: _propTypes2.default.bool,
  expires: _propTypes2.default.number,
  containerClasses: _propTypes2.default.string,
  contentClasses: _propTypes2.default.string,
  buttonClasses: _propTypes2.default.string,
  buttonId: _propTypes2.default.string,
  acceptOnScroll: _propTypes2.default.bool,
  acceptOnScrollPercentage: _propTypes2.default.number,
  extraCookieOptions: _propTypes2.default.object
};

CookieConsent.defaultProps = {
  disableStyles: false,
  hideOnAccept: true,
  acceptOnScroll: false,
  acceptOnScrollPercentage: 25,
  location: OPTIONS.BOTTOM,
  onAccept: function onAccept() {},
  cookieName: "CookieConsent",
  cookieValue: true,
  buttonText: "I understand",
  debug: false,
  expires: 365,
  containerClasses: "",
  contentClasses: "",
  buttonClasses: "",
  buttonId: "",
  extraCookieOptions: {}
};

exports.default = CookieConsent;
exports.Cookies = _jsCookie2.default;

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



if (process.env.NODE_ENV !== 'production') {
  var invariant = __webpack_require__(2);
  var warning = __webpack_require__(4);
  var ReactPropTypesSecret = __webpack_require__(3);
  var loggedTypeFailures = {};
}

/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */
function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
  if (process.env.NODE_ENV !== 'production') {
    for (var typeSpecName in typeSpecs) {
      if (typeSpecs.hasOwnProperty(typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          invariant(typeof typeSpecs[typeSpecName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'the `prop-types` package, but received `%s`.', componentName || 'React class', location, typeSpecName, typeof typeSpecs[typeSpecName]);
          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
        } catch (ex) {
          error = ex;
        }
        warning(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error);
        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;

          var stack = getStack ? getStack() : '';

          warning(false, 'Failed %s type: %s%s', location, error.message, stack != null ? stack : '');
        }
      }
    }
  }
}

module.exports = checkPropTypes;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var emptyFunction = __webpack_require__(1);
var invariant = __webpack_require__(2);
var ReactPropTypesSecret = __webpack_require__(3);

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(
      false,
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var emptyFunction = __webpack_require__(1);
var invariant = __webpack_require__(2);
var warning = __webpack_require__(4);
var assign = __webpack_require__(9);

var ReactPropTypesSecret = __webpack_require__(3);
var checkPropTypes = __webpack_require__(10);

module.exports = function(isValidElement, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */
  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */

  var ANONYMOUS = '<<anonymous>>';

  // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),

    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker,
    exact: createStrictShapeTypeChecker,
  };

  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */
  /*eslint-disable no-self-compare*/
  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */
  function PropTypeError(message) {
    this.message = message;
    this.stack = '';
  }
  // Make `instanceof Error` still work for returned errors.
  PropTypeError.prototype = Error.prototype;

  function createChainableTypeChecker(validate) {
    if (process.env.NODE_ENV !== 'production') {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }
    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;

      if (secret !== ReactPropTypesSecret) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          invariant(
            false,
            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
            'Use `PropTypes.checkPropTypes()` to call them. ' +
            'Read more at http://fb.me/use-check-prop-types'
          );
        } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;
          if (
            !manualPropTypeCallCache[cacheKey] &&
            // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3
          ) {
            warning(
              false,
              'You are manually calling a React.PropTypes validation ' +
              'function for the `%s` prop on `%s`. This is deprecated ' +
              'and will throw in the standalone `prop-types` package. ' +
              'You may be seeing this warning due to a third-party PropTypes ' +
              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.',
              propFullName,
              componentName
            );
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }
      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }
          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }
        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);

    return chainedCheckType;
  }

  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);

        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunction.thatReturnsNull);
  }

  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }
      var propValue = props[propName];
      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }
      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
        if (error instanceof Error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
      process.env.NODE_ENV !== 'production' ? warning(false, 'Invalid argument supplied to oneOf, expected an instance of array.') : void 0;
      return emptyFunction.thatReturnsNull;
    }

    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }

      var valuesString = JSON.stringify(expectedValues);
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }
      for (var key in propValue) {
        if (propValue.hasOwnProperty(key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
          if (error instanceof Error) {
            return error;
          }
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
      process.env.NODE_ENV !== 'production' ? warning(false, 'Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunction.thatReturnsNull;
    }

    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (typeof checker !== 'function') {
        warning(
          false,
          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
          'received %s at index %s.',
          getPostfixForTypeWarning(checker),
          i
        );
        return emptyFunction.thatReturnsNull;
      }
    }

    function validate(props, propName, componentName, location, propFullName) {
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
          return null;
        }
      }

      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      for (var key in shapeTypes) {
        var checker = shapeTypes[key];
        if (!checker) {
          continue;
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createStrictShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      // We need to check all keys in case some are required but missing from
      // props.
      var allKeys = assign({}, props[propName], shapeTypes);
      for (var key in allKeys) {
        var checker = shapeTypes[key];
        if (!checker) {
          return new PropTypeError(
            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
            '\nValid keys: ' +  JSON.stringify(Object.keys(shapeTypes), null, '  ')
          );
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
        if (error) {
          return error;
        }
      }
      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;
      case 'boolean':
        return !propValue;
      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }
        if (propValue === null || isValidElement(propValue)) {
          return true;
        }

        var iteratorFn = getIteratorFn(propValue);
        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;
          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;
              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }

        return true;
      default:
        return false;
    }
  }

  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    }

    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    }

    // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }

    return false;
  }

  // Equivalent of `typeof` but with special handling for array and regexp.
  function getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) {
      return 'array';
    }
    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }
    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }
    return propType;
  }

  // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.
  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }
    var propType = getPropType(propValue);
    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }
    return propType;
  }

  // Returns a string that is postfixed to a warning about an invalid type.
  // For example, "undefined" or "of type array"
  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);
    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;
      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;
      default:
        return type;
    }
  }

  // Returns class name of the object, if any.
  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }
    return propValue.constructor.name;
  }

  ReactPropTypes.checkPropTypes = checkPropTypes;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ })
/******/ ]);

/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(630);
} else {
  module.exports = require('./cjs/react.development.js');
}


/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.13.0
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var l=__webpack_require__(82),n="function"===typeof Symbol&&Symbol.for,p=n?Symbol.for("react.element"):60103,q=n?Symbol.for("react.portal"):60106,r=n?Symbol.for("react.fragment"):60107,t=n?Symbol.for("react.strict_mode"):60108,u=n?Symbol.for("react.profiler"):60114,v=n?Symbol.for("react.provider"):60109,w=n?Symbol.for("react.context"):60110,x=n?Symbol.for("react.forward_ref"):60112,y=n?Symbol.for("react.suspense"):60113,z=n?Symbol.for("react.memo"):60115,A=n?Symbol.for("react.lazy"):
60116,B="function"===typeof Symbol&&Symbol.iterator;function C(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}
var D={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}},E={};function F(a,b,c){this.props=a;this.context=b;this.refs=E;this.updater=c||D}F.prototype.isReactComponent={};F.prototype.setState=function(a,b){if("object"!==typeof a&&"function"!==typeof a&&null!=a)throw Error(C(85));this.updater.enqueueSetState(this,a,b,"setState")};F.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};
function G(){}G.prototype=F.prototype;function H(a,b,c){this.props=a;this.context=b;this.refs=E;this.updater=c||D}var I=H.prototype=new G;I.constructor=H;l(I,F.prototype);I.isPureReactComponent=!0;var J={current:null},K=Object.prototype.hasOwnProperty,L={key:!0,ref:!0,__self:!0,__source:!0};
function M(a,b,c){var e,d={},g=null,k=null;if(null!=b)for(e in void 0!==b.ref&&(k=b.ref),void 0!==b.key&&(g=""+b.key),b)K.call(b,e)&&!L.hasOwnProperty(e)&&(d[e]=b[e]);var f=arguments.length-2;if(1===f)d.children=c;else if(1<f){for(var h=Array(f),m=0;m<f;m++)h[m]=arguments[m+2];d.children=h}if(a&&a.defaultProps)for(e in f=a.defaultProps,f)void 0===d[e]&&(d[e]=f[e]);return{$$typeof:p,type:a,key:g,ref:k,props:d,_owner:J.current}}
function N(a,b){return{$$typeof:p,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}}function O(a){return"object"===typeof a&&null!==a&&a.$$typeof===p}function escape(a){var b={"=":"=0",":":"=2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var P=/\/+/g,Q=[];function R(a,b,c,e){if(Q.length){var d=Q.pop();d.result=a;d.keyPrefix=b;d.func=c;d.context=e;d.count=0;return d}return{result:a,keyPrefix:b,func:c,context:e,count:0}}
function S(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>Q.length&&Q.push(a)}
function T(a,b,c,e){var d=typeof a;if("undefined"===d||"boolean"===d)a=null;var g=!1;if(null===a)g=!0;else switch(d){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case p:case q:g=!0}}if(g)return c(e,a,""===b?"."+U(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var k=0;k<a.length;k++){d=a[k];var f=b+U(d,k);g+=T(d,f,c,e)}else if(null===a||"object"!==typeof a?f=null:(f=B&&a[B]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=f.call(a),k=
0;!(d=a.next()).done;)d=d.value,f=b+U(d,k++),g+=T(d,f,c,e);else if("object"===d)throw c=""+a,Error(C(31,"[object Object]"===c?"object with keys {"+Object.keys(a).join(", ")+"}":c,""));return g}function V(a,b,c){return null==a?0:T(a,"",b,c)}function U(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function W(a,b){a.func.call(a.context,b,a.count++)}
function aa(a,b,c){var e=a.result,d=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?X(a,e,c,function(a){return a}):null!=a&&(O(a)&&(a=N(a,d+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(P,"$&/")+"/")+c)),e.push(a))}function X(a,b,c,e,d){var g="";null!=c&&(g=(""+c).replace(P,"$&/")+"/");b=R(b,g,e,d);V(a,aa,b);S(b)}var Y={current:null};function Z(){var a=Y.current;if(null===a)throw Error(C(321));return a}
var ba={ReactCurrentDispatcher:Y,ReactCurrentBatchConfig:{suspense:null},ReactCurrentOwner:J,IsSomeRendererActing:{current:!1},assign:l};exports.Children={map:function(a,b,c){if(null==a)return a;var e=[];X(a,e,null,b,c);return e},forEach:function(a,b,c){if(null==a)return a;b=R(null,null,b,c);V(a,W,b);S(b)},count:function(a){return V(a,function(){return null},null)},toArray:function(a){var b=[];X(a,b,null,function(a){return a});return b},only:function(a){if(!O(a))throw Error(C(143));return a}};
exports.Component=F;exports.Fragment=r;exports.Profiler=u;exports.PureComponent=H;exports.StrictMode=t;exports.Suspense=y;exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=ba;
exports.cloneElement=function(a,b,c){if(null===a||void 0===a)throw Error(C(267,a));var e=l({},a.props),d=a.key,g=a.ref,k=a._owner;if(null!=b){void 0!==b.ref&&(g=b.ref,k=J.current);void 0!==b.key&&(d=""+b.key);if(a.type&&a.type.defaultProps)var f=a.type.defaultProps;for(h in b)K.call(b,h)&&!L.hasOwnProperty(h)&&(e[h]=void 0===b[h]&&void 0!==f?f[h]:b[h])}var h=arguments.length-2;if(1===h)e.children=c;else if(1<h){f=Array(h);for(var m=0;m<h;m++)f[m]=arguments[m+2];e.children=f}return{$$typeof:p,type:a.type,
key:d,ref:g,props:e,_owner:k}};exports.createContext=function(a,b){void 0===b&&(b=null);a={$$typeof:w,_calculateChangedBits:b,_currentValue:a,_currentValue2:a,_threadCount:0,Provider:null,Consumer:null};a.Provider={$$typeof:v,_context:a};return a.Consumer=a};exports.createElement=M;exports.createFactory=function(a){var b=M.bind(null,a);b.type=a;return b};exports.createRef=function(){return{current:null}};exports.forwardRef=function(a){return{$$typeof:x,render:a}};exports.isValidElement=O;
exports.lazy=function(a){return{$$typeof:A,_ctor:a,_status:-1,_result:null}};exports.memo=function(a,b){return{$$typeof:z,type:a,compare:void 0===b?null:b}};exports.useCallback=function(a,b){return Z().useCallback(a,b)};exports.useContext=function(a,b){return Z().useContext(a,b)};exports.useDebugValue=function(){};exports.useEffect=function(a,b){return Z().useEffect(a,b)};exports.useImperativeHandle=function(a,b,c){return Z().useImperativeHandle(a,b,c)};
exports.useLayoutEffect=function(a,b){return Z().useLayoutEffect(a,b)};exports.useMemo=function(a,b){return Z().useMemo(a,b)};exports.useReducer=function(a,b,c){return Z().useReducer(a,b,c)};exports.useRef=function(a){return Z().useRef(a)};exports.useState=function(a){return Z().useState(a)};exports.version="16.13.0";


/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(632);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(17)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../lunch-team-client-checkout-msg/node_modules/css-loader/index.js!../../../../../../../lunch-team-client-checkout-msg/node_modules/sass-loader/dist/cjs.js!./GDPRModal.scss", function() {
			var newContent = require("!!../../../../../../../lunch-team-client-checkout-msg/node_modules/css-loader/index.js!../../../../../../../lunch-team-client-checkout-msg/node_modules/sass-loader/dist/cjs.js!./GDPRModal.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(14)(undefined);
// imports


// module
exports.push([module.i, ".gdpr-modal{background:#fff;width:80%;margin:0 auto;padding:2em 4em 2em;border-radius:16px;z-index:9999999;position:absolute}.gdpr-content-modal{margin-top:10px;height:80%;overflow-y:scroll}.gdpr-content-modal div{max-height:100%}.gdpr-modal h3{margin-top:15px;margin-bottom:15px}.gdpr-modal img{display:block;margin:auto}", ""]);

// exports


/***/ }),
/* 633 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_utils_http__ = __webpack_require__(19);
var getTermsConditions=function getTermsConditions(){return __WEBPACK_IMPORTED_MODULE_0_utils_http__["a" /* default */].get('/user/v1/terms-conditions');};var getPrivacyPolicy=function getPrivacyPolicy(){return __WEBPACK_IMPORTED_MODULE_0_utils_http__["a" /* default */].get('/user/v1/privacy-policy');};/* harmony default export */ __webpack_exports__["a"] = ({getTermsConditions:getTermsConditions,getPrivacyPolicy:getPrivacyPolicy});

/***/ }),
/* 634 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fetch__ = __webpack_require__(635);
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__fetch__["a" /* default */]);

/***/ }),
/* 635 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export attachResponseEvidence */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__serverURL__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fetchConfig__ = __webpack_require__(636);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__statusCode__ = __webpack_require__(639);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__createStore__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_actions_index__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__support_breadcrumbs__ = __webpack_require__(208);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};/**
 * A implementação dos serializadores foi baseada em:
 * http://mcculloughwebservices.com/2016/09/23/handling-a-null-response-from-an-api/
 *
 * Não é possível simplesmente realizar a chamada de response.json()
 * pois decidimos que a nossa API poderia retornar valores com o Body
 * vazio e/ou nulo, sendo assim, ocorreria um erro ao deserializar
 * que é resolvido com a implementação adotada
 */// What support needs to find a failed request: the status and the server's ids for it.
// Read once here so every error the app shows can carry them (src/utils/userError.js).
function readHeader(response,name){try{return response&&response.headers&&typeof response.headers.get==='function'&&response.headers.get(name)||undefined;}catch(e){return undefined;}}function attachResponseEvidence(target,response){if(!target||(typeof target==='undefined'?'undefined':_typeof(target))!=='object'||!response){return target;}// responseStatus, not status: a validation body may carry its own status field.
if(target.responseStatus===undefined){target.responseStatus=response.status;}var correlationId=readHeader(response,'X-Correlation-ID');var supportReference=readHeader(response,'X-Support-Reference');if(correlationId&&!target.responseCorrelationId){target.responseCorrelationId=correlationId;}if(supportReference&&!target.supportReferenceHeader){target.supportReferenceHeader=supportReference;}return target;}function throwValidationErrors(response){return response.json().then(function(errors){throw attachResponseEvidence(errors,response);});}function parseErrorBody(response){return response.text().then(function(text){if(!text){return{};}try{return JSON.parse(text);}catch(error){return{message:text};}});}function throwUnexpectedError(response,errorMessage,errorCode){return parseErrorBody(response).then(function(data){var error=new Error(errorMessage);error.response=response;error.data=data;error.code=data&&(typeof data==='undefined'?'undefined':_typeof(data))==='object'&&data.code||errorCode;attachResponseEvidence(error,response);throw error;});}function throwNetworkError(cause){var error=new Error('We could not reach the service.');error.code='NETWORK_ERROR';error.isNetworkError=true;// Offline and "server not reachable" need different next steps.
error.offline=typeof navigator!=='undefined'&&navigator.onLine===false;error.isTimeout=!!(cause&&(cause.name==='AbortError'||cause.name==='TimeoutError'));error.cause=cause;throw error;}function _parseJSON(response){return response.text().then(function(text){return!!text?JSON.parse(text):{};});}// function _parseImagem(response) {
//   let data;
//   const urlCreator = window.URL || window.webkitURL;
//   return response.blob().then(blobResponse => {
//     data = blobResponse;
//     return urlCreator.createObjectURL(data);
//   })
// }
/* harmony default export */ __webpack_exports__["a"] = (function(path,config,headers){var autoHandle=arguments.length>3&&arguments[3]!==undefined?arguments[3]:true;var autoControlSpinner=arguments.length>4&&arguments[4]!==undefined?arguments[4]:true;if(!!autoControlSpinner){__WEBPACK_IMPORTED_MODULE_3__createStore__["a" /* default */].dispatch(__WEBPACK_IMPORTED_MODULE_4_actions_index__["_30" /* startRequest */]());}return fetch(__WEBPACK_IMPORTED_MODULE_0__serverURL__["a" /* default */].api(path),Object(__WEBPACK_IMPORTED_MODULE_1__fetchConfig__["a" /* default */])(config,headers)).then(function(response){if(!!autoControlSpinner){__WEBPACK_IMPORTED_MODULE_3__createStore__["a" /* default */].dispatch(__WEBPACK_IMPORTED_MODULE_4_actions_index__["_1" /* finishRequest */]());}if(!response.ok){Object(__WEBPACK_IMPORTED_MODULE_5__support_breadcrumbs__["a" /* addBreadcrumb */])('api_error',(config&&config.method||'GET')+' '+Object(__WEBPACK_IMPORTED_MODULE_5__support_breadcrumbs__["e" /* sanitizePath */])(path),String(response.status));}if(response.ok){// var res = response.url.startsWith("http://api-staging.lunch.team/menu/v1/image/restaurant/cover") ||
//   response.url.startsWith("https://api.lunch.team/menu/v1/image/restaurant/cover") ?
//   _parseImagem(response) : _parseJSON(response);
var res=_parseJSON(response);return res;}else if(__WEBPACK_IMPORTED_MODULE_2__statusCode__["a" /* default */].isAuthenticationError(response)){__WEBPACK_IMPORTED_MODULE_3__createStore__["a" /* default */].dispatch(__WEBPACK_IMPORTED_MODULE_4_actions_index__["_6" /* logoutSuccess */]());// - enviar para a rota de login com mensagem
// avisando que session expirou
// - excluir informações localStorage
return throwUnexpectedError(response,'Your session has expired. Please sign in again.','AUTHENTICATION_REQUIRED');}else if(!autoHandle){return response;}else if(__WEBPACK_IMPORTED_MODULE_2__statusCode__["a" /* default */].isValidationError(response)){// tratar genericamente
// lançar erro
return throwValidationErrors(response);}else{// exibir erro
// lançar erro
return throwUnexpectedError(response,"Lunch.Team couldn't finish that request.",'HTTP_ERROR');}},function(error){__WEBPACK_IMPORTED_MODULE_3__createStore__["a" /* default */].dispatch(__WEBPACK_IMPORTED_MODULE_4_actions_index__["_1" /* finishRequest */]());Object(__WEBPACK_IMPORTED_MODULE_5__support_breadcrumbs__["a" /* addBreadcrumb */])('api_error',(config&&config.method||'GET')+' '+Object(__WEBPACK_IMPORTED_MODULE_5__support_breadcrumbs__["e" /* sanitizePath */])(path),'network');throwNetworkError(error);});});

/***/ }),
/* 636 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__httpHeaders__ = __webpack_require__(637);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cookieExpression__ = __webpack_require__(638);
var defaultConfig={mode:'cors',credentials:'include'};/* harmony default export */ __webpack_exports__["a"] = (function(config,headers){defaultConfig.headers=Object.assign(Object(__WEBPACK_IMPORTED_MODULE_0__httpHeaders__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__cookieExpression__["a" /* default */])()),headers);var devKey=localStorage.getItem('@LT/DEV_KEYS');var fetchObject=Object.assign(defaultConfig,config,{body:JSON.stringify(config.body)});if(false){fetchObject.headers.Authorization='Basic '+String(devKey);}return fetchObject;});

/***/ }),
/* 637 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(cookieValue){return{Accept:['application/json','text/plain','*/*'],'Content-Type':'application/json','X-Requested-By':'Browser','X-XSRF-TOKEN':cookieValue};});

/***/ }),
/* 638 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(){return document.cookie.replace(/(?:(?:^|.*;\s*)XSRF-TOKEN\s*\\=\s*([^;]*).*$)|^.*$/,'$1');});

/***/ }),
/* 639 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var status={API_VALIDATION_ERROR:[400],AUTHENTICATION_ERROR:[401,403],OK:[200,201,202,203,204,205,206,207,208],SERVICE_DOWN:[404,500,502,503]};/* harmony default export */ __webpack_exports__["a"] = ({isSuccess:function isSuccess(response){return status.OK.indexOf(response.status)!==-1;},isValidationError:function isValidationError(response){return status.API_VALIDATION_ERROR.indexOf(response.status)!==-1;},isAuthenticationError:function isAuthenticationError(response){return status.AUTHENTICATION_ERROR.indexOf(response.status)!==-1;}});

/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

// This method of obtaining a reference to the global object needs to be
// kept identical to the way it is obtained in runtime.js
var g = (function() { return this })() || Function("return this")();

// Use `getOwnPropertyNames` because not all browsers support calling
// `hasOwnProperty` on the global `self` object in a worker. See #183.
var hadRuntime = g.regeneratorRuntime &&
  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;

// Save the old regeneratorRuntime in case it needs to be restored later.
var oldRuntime = hadRuntime && g.regeneratorRuntime;

// Force reevalutation of runtime.js.
g.regeneratorRuntime = undefined;

module.exports = __webpack_require__(641);

if (hadRuntime) {
  // Restore the original runtime.
  g.regeneratorRuntime = oldRuntime;
} else {
  // Remove the global property added by runtime.js.
  try {
    delete g.regeneratorRuntime;
  } catch(e) {
    g.regeneratorRuntime = undefined;
  }
}


/***/ }),
/* 641 */
/***/ (function(module, exports) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // In sloppy mode, unbound `this` refers to the global object, fallback to
  // Function constructor if we're in global strict mode. That is sadly a form
  // of indirect eval which violates Content Security Policy.
  (function() { return this })() || Function("return this")()
);


/***/ }),
/* 642 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_config_base64__ = __webpack_require__(643);
/* harmony default export */ __webpack_exports__["a"] = (function(credentials){var headers={};if(credentials){var authorization=void 0;if(typeof btoa!=='undefined'){authorization='Basic '+btoa(credentials.email+':'+credentials.password);}else{authorization='Basic '+__WEBPACK_IMPORTED_MODULE_0_config_base64__["a" /* default */].encode(credentials.email+':'+credentials.password);}headers.authorization=authorization;}return headers;});

/***/ }),
/* 643 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({encode:function encode(s){return btoa(s);},decode:function decode(s){return atob(s);}});

/***/ }),
/* 644 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_utils_http__ = __webpack_require__(19);
var sendEmailToRegisterCompany=function sendEmailToRegisterCompany(payload){return __WEBPACK_IMPORTED_MODULE_0_utils_http__["a" /* default */].post('/settings/v1/settings/sendmailcompany',payload);};var sendEmailContact=function sendEmailContact(payload){return __WEBPACK_IMPORTED_MODULE_0_utils_http__["a" /* default */].post('/settings/v1/settings/sendmailcontact',payload);};/* harmony default export */ __webpack_exports__["a"] = ({sendEmailToRegisterCompany:sendEmailToRegisterCompany,sendEmailContact:sendEmailContact});

/***/ }),
/* 645 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export initialize */
/* unused harmony export ga */
/* unused harmony export set */
/* unused harmony export send */
/* unused harmony export pageview */
/* unused harmony export modalview */
/* unused harmony export timing */
/* unused harmony export event */
/* unused harmony export exception */
/* unused harmony export plugin */
/* unused harmony export outboundLink */
/* unused harmony export testModeAPI */
/* unused harmony export OutboundLink */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_OutboundLink__ = __webpack_require__(646);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core__ = __webpack_require__(647);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



var initialize = __WEBPACK_IMPORTED_MODULE_1__core__["initialize"];
var ga = __WEBPACK_IMPORTED_MODULE_1__core__["ga"];
var set = __WEBPACK_IMPORTED_MODULE_1__core__["set"];
var send = __WEBPACK_IMPORTED_MODULE_1__core__["send"];
var pageview = __WEBPACK_IMPORTED_MODULE_1__core__["pageview"];
var modalview = __WEBPACK_IMPORTED_MODULE_1__core__["modalview"];
var timing = __WEBPACK_IMPORTED_MODULE_1__core__["timing"];
var event = __WEBPACK_IMPORTED_MODULE_1__core__["event"];
var exception = __WEBPACK_IMPORTED_MODULE_1__core__["exception"];
var plugin = __WEBPACK_IMPORTED_MODULE_1__core__["plugin"];
var outboundLink = __WEBPACK_IMPORTED_MODULE_1__core__["outboundLink"];
var testModeAPI = __WEBPACK_IMPORTED_MODULE_1__core__["testModeAPI"];
__WEBPACK_IMPORTED_MODULE_0__components_OutboundLink__["a" /* default */].origTrackLink = __WEBPACK_IMPORTED_MODULE_0__components_OutboundLink__["a" /* default */].trackLink;
__WEBPACK_IMPORTED_MODULE_0__components_OutboundLink__["a" /* default */].trackLink = __WEBPACK_IMPORTED_MODULE_1__core__["outboundLink"];
var OutboundLink = __WEBPACK_IMPORTED_MODULE_0__components_OutboundLink__["a" /* default */];
/* harmony default export */ __webpack_exports__["a"] = (_objectSpread({}, __WEBPACK_IMPORTED_MODULE_1__core__, {
  OutboundLink: OutboundLink
}));

/***/ }),
/* 646 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return OutboundLink; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_console_warn__ = __webpack_require__(177);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




var NEWTAB = '_blank';
var MIDDLECLICK = 1;

var OutboundLink =
/*#__PURE__*/
function (_Component) {
  _inherits(OutboundLink, _Component);

  function OutboundLink() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, OutboundLink);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(OutboundLink)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "handleClick", function (event) {
      var _this$props = _this.props,
          target = _this$props.target,
          eventLabel = _this$props.eventLabel,
          to = _this$props.to,
          onClick = _this$props.onClick,
          trackerNames = _this$props.trackerNames;
      var eventMeta = {
        label: eventLabel
      };
      var sameTarget = target !== NEWTAB;
      var normalClick = !(event.ctrlKey || event.shiftKey || event.metaKey || event.button === MIDDLECLICK);

      if (sameTarget && normalClick) {
        event.preventDefault();
        OutboundLink.trackLink(eventMeta, function () {
          window.location.href = to;
        }, trackerNames);
      } else {
        OutboundLink.trackLink(eventMeta, function () {}, trackerNames);
      }

      if (onClick) {
        onClick(event);
      }
    });

    return _this;
  }

  _createClass(OutboundLink, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          href = _this$props2.to,
          oldProps = _objectWithoutProperties(_this$props2, ["to"]);

      var props = _objectSpread({}, oldProps, {
        href: href,
        onClick: this.handleClick
      });

      if (this.props.target === NEWTAB) {
        props.rel = 'noopener noreferrer';
      }

      delete props.eventLabel;
      delete props.trackerNames;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', props);
    }
  }]);

  return OutboundLink;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

_defineProperty(OutboundLink, "trackLink", function () {
  Object(__WEBPACK_IMPORTED_MODULE_2__utils_console_warn__["a" /* default */])('ga tracking not enabled');
});

_defineProperty(OutboundLink, "propTypes", {
  eventLabel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  target: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  trackerNames: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string)
});

_defineProperty(OutboundLink, "defaultProps", {
  target: null,
  to: null,
  onClick: null,
  trackerNames: null
});



/***/ }),
/* 647 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["initialize"] = initialize;
/* harmony export (immutable) */ __webpack_exports__["ga"] = ga;
/* harmony export (immutable) */ __webpack_exports__["set"] = set;
/* harmony export (immutable) */ __webpack_exports__["send"] = send;
/* harmony export (immutable) */ __webpack_exports__["pageview"] = pageview;
/* harmony export (immutable) */ __webpack_exports__["modalview"] = modalview;
/* harmony export (immutable) */ __webpack_exports__["timing"] = timing;
/* harmony export (immutable) */ __webpack_exports__["event"] = event;
/* harmony export (immutable) */ __webpack_exports__["exception"] = exception;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "plugin", function() { return plugin; });
/* harmony export (immutable) */ __webpack_exports__["outboundLink"] = outboundLink;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "testModeAPI", function() { return testModeAPI; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_format__ = __webpack_require__(648);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_removeLeadingSlash__ = __webpack_require__(651);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_trim__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_loadGA__ = __webpack_require__(652);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_console_warn__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_console_log__ = __webpack_require__(653);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_testModeAPI__ = __webpack_require__(654);
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

/**
 * React Google Analytics Module
 *
 * @package react-ga
 * @author  Adam Lofting <adam@mozillafoundation.org>
 *          Atul Varma <atul@mozillafoundation.org>
 */

/**
 * Utilities
 */








var _isNotBrowser = typeof window === 'undefined' || typeof document === 'undefined';

var _debug = false;
var _titleCase = true;
var _testMode = false;
var _alwaysSendToDefaultTracker = true;

var internalGa = function internalGa() {
  var _window;

  if (_testMode) return __WEBPACK_IMPORTED_MODULE_6__utils_testModeAPI__["a" /* default */].ga.apply(__WEBPACK_IMPORTED_MODULE_6__utils_testModeAPI__["a" /* default */], arguments);
  if (_isNotBrowser) return false;
  if (!window.ga) return Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('ReactGA.initialize must be called first or GoogleAnalytics should be loaded manually');
  return (_window = window).ga.apply(_window, arguments);
};

function _format(s) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_format__["a" /* default */])(s, _titleCase);
}

function _gaCommand(trackerNames) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  var command = args[0];

  if (typeof internalGa === 'function') {
    if (typeof command !== 'string') {
      Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('ga command must be a string');
      return;
    }

    if (_alwaysSendToDefaultTracker || !Array.isArray(trackerNames)) internalGa.apply(void 0, args);

    if (Array.isArray(trackerNames)) {
      trackerNames.forEach(function (name) {
        internalGa.apply(void 0, _toConsumableArray(["".concat(name, ".").concat(command)].concat(args.slice(1))));
      });
    }
  }
}

function _initialize(gaTrackingID, options) {
  if (!gaTrackingID) {
    Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('gaTrackingID is required in initialize()');
    return;
  }

  if (options) {
    if (options.debug && options.debug === true) {
      _debug = true;
    }

    if (options.titleCase === false) {
      _titleCase = false;
    }

    if (options.useExistingGa) {
      return;
    }
  }

  if (options && options.gaOptions) {
    internalGa('create', gaTrackingID, options.gaOptions);
  } else {
    internalGa('create', gaTrackingID, 'auto');
  }
}

function initialize(configsOrTrackingId, options) {
  if (options && options.testMode === true) {
    _testMode = true;
  } else {
    if (_isNotBrowser) {
      return false;
    }

    if (!options || options.standardImplementation !== true) Object(__WEBPACK_IMPORTED_MODULE_3__utils_loadGA__["a" /* default */])(options);
  }

  _alwaysSendToDefaultTracker = options && typeof options.alwaysSendToDefaultTracker === 'boolean' ? options.alwaysSendToDefaultTracker : true;

  if (Array.isArray(configsOrTrackingId)) {
    configsOrTrackingId.forEach(function (config) {
      if (_typeof(config) !== 'object') {
        Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('All configs must be an object');
        return;
      }

      _initialize(config.trackingId, config);
    });
  } else {
    _initialize(configsOrTrackingId, options);
  }

  return true;
}
/**
 * ga:
 * Returns the original GA object.
 */

function ga() {
  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }

  if (args.length > 0) {
    internalGa.apply(void 0, args);

    if (_debug) {
      Object(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])('called ga(\'arguments\');');
      Object(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])("with arguments: ".concat(JSON.stringify(args)));
    }
  }

  return window.ga;
}
/**
 * set:
 * GA tracker set method
 * @param {Object} fieldsObject - a field/value pair or a group of field/value pairs on the tracker
 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
 */

function set(fieldsObject, trackerNames) {
  if (!fieldsObject) {
    Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('`fieldsObject` is required in .set()');
    return;
  }

  if (_typeof(fieldsObject) !== 'object') {
    Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('Expected `fieldsObject` arg to be an Object');
    return;
  }

  if (Object.keys(fieldsObject).length === 0) {
    Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('empty `fieldsObject` given to .set()');
  }

  _gaCommand(trackerNames, 'set', fieldsObject);

  if (_debug) {
    Object(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])('called ga(\'set\', fieldsObject);');
    Object(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])("with fieldsObject: ".concat(JSON.stringify(fieldsObject)));
  }
}
/**
 * send:
 * Clone of the low level `ga.send` method
 * WARNING: No validations will be applied to this
 * @param  {Object} fieldObject - field object for tracking different analytics
 * @param  {Array} trackerNames - trackers to send the command to
 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
 */

function send(fieldObject, trackerNames) {
  _gaCommand(trackerNames, 'send', fieldObject);

  if (_debug) {
    Object(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])('called ga(\'send\', fieldObject);');
    Object(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])("with fieldObject: ".concat(JSON.stringify(fieldObject)));
    Object(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])("with trackers: ".concat(JSON.stringify(trackerNames)));
  }
}
/**
 * pageview:
 * Basic GA pageview tracking
 * @param  {String} path - the current page page e.g. '/about'
 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
 * @param {String} title - (optional) the page title e. g. 'My Website'
 */

function pageview(rawPath, trackerNames, title) {
  if (!rawPath) {
    Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('path is required in .pageview()');
    return;
  }

  var path = Object(__WEBPACK_IMPORTED_MODULE_2__utils_trim__["a" /* default */])(rawPath);

  if (path === '') {
    Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('path cannot be an empty string in .pageview()');
    return;
  }

  var extraFields = {};

  if (title) {
    extraFields.title = title;
  }

  if (typeof ga === 'function') {
    _gaCommand(trackerNames, 'send', _objectSpread({
      hitType: 'pageview',
      page: path
    }, extraFields));

    if (_debug) {
      Object(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])('called ga(\'send\', \'pageview\', path);');
      var extraLog = '';

      if (title) {
        extraLog = " and title: ".concat(title);
      }

      Object(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])("with path: ".concat(path).concat(extraLog));
    }
  }
}
/**
 * modalview:
 * a proxy to basic GA pageview tracking to consistently track
 * modal views that are an equivalent UX to a traditional pageview
 * @param  {String} modalName e.g. 'add-or-edit-club'
 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
 */

function modalview(rawModalName, trackerNames) {
  if (!rawModalName) {
    Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('modalName is required in .modalview(modalName)');
    return;
  }

  var modalName = Object(__WEBPACK_IMPORTED_MODULE_1__utils_removeLeadingSlash__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__utils_trim__["a" /* default */])(rawModalName));

  if (modalName === '') {
    Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('modalName cannot be an empty string or a single / in .modalview()');
    return;
  }

  if (typeof ga === 'function') {
    var path = "/modal/".concat(modalName);

    _gaCommand(trackerNames, 'send', 'pageview', path);

    if (_debug) {
      Object(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])('called ga(\'send\', \'pageview\', path);');
      Object(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])("with path: ".concat(path));
    }
  }
}
/**
 * timing:
 * GA timing
 * @param args.category {String} required
 * @param args.variable {String} required
 * @param args.value  {Int}  required
 * @param args.label  {String} required
 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
 */

function timing() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      category = _ref.category,
      variable = _ref.variable,
      value = _ref.value,
      label = _ref.label;

  var trackerNames = arguments.length > 1 ? arguments[1] : undefined;

  if (typeof ga === 'function') {
    if (!category || !variable || !value || typeof value !== 'number') {
      Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('args.category, args.variable ' + 'AND args.value are required in timing() ' + 'AND args.value has to be a number');
      return;
    } // Required Fields


    var fieldObject = {
      hitType: 'timing',
      timingCategory: _format(category),
      timingVar: _format(variable),
      timingValue: value
    };

    if (label) {
      fieldObject.timingLabel = _format(label);
    }

    send(fieldObject, trackerNames);
  }
}
/**
 * event:
 * GA event tracking
 * @param args.category {String} required
 * @param args.action {String} required
 * @param args.label {String} optional
 * @param args.value {Int} optional
 * @param args.nonInteraction {boolean} optional
 * @param args.transport {string} optional
 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
 */

function event() {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      category = _ref2.category,
      action = _ref2.action,
      label = _ref2.label,
      value = _ref2.value,
      nonInteraction = _ref2.nonInteraction,
      transport = _ref2.transport,
      args = _objectWithoutProperties(_ref2, ["category", "action", "label", "value", "nonInteraction", "transport"]);

  var trackerNames = arguments.length > 1 ? arguments[1] : undefined;

  if (typeof ga === 'function') {
    // Simple Validation
    if (!category || !action) {
      Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('args.category AND args.action are required in event()');
      return;
    } // Required Fields


    var fieldObject = {
      hitType: 'event',
      eventCategory: _format(category),
      eventAction: _format(action)
    }; // Optional Fields

    if (label) {
      fieldObject.eventLabel = _format(label);
    }

    if (typeof value !== 'undefined') {
      if (typeof value !== 'number') {
        Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('Expected `args.value` arg to be a Number.');
      } else {
        fieldObject.eventValue = value;
      }
    }

    if (typeof nonInteraction !== 'undefined') {
      if (typeof nonInteraction !== 'boolean') {
        Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('`args.nonInteraction` must be a boolean.');
      } else {
        fieldObject.nonInteraction = nonInteraction;
      }
    }

    if (typeof transport !== 'undefined') {
      if (typeof transport !== 'string') {
        Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('`args.transport` must be a string.');
      } else {
        if (['beacon', 'xhr', 'image'].indexOf(transport) === -1) {
          Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('`args.transport` must be either one of these values: `beacon`, `xhr` or `image`');
        }

        fieldObject.transport = transport;
      }
    }

    Object.keys(args).filter(function (key) {
      return key.substr(0, 'dimension'.length) === 'dimension';
    }).forEach(function (key) {
      fieldObject[key] = args[key];
    });
    Object.keys(args).filter(function (key) {
      return key.substr(0, 'metric'.length) === 'metric';
    }).forEach(function (key) {
      fieldObject[key] = args[key];
    }); // Send to GA

    send(fieldObject, trackerNames);
  }
}
/**
 * exception:
 * GA exception tracking
 * @param args.description {String} optional
 * @param args.fatal {boolean} optional
 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
 */

function exception(_ref3, trackerNames) {
  var description = _ref3.description,
      fatal = _ref3.fatal;

  if (typeof ga === 'function') {
    // Required Fields
    var fieldObject = {
      hitType: 'exception'
    }; // Optional Fields

    if (description) {
      fieldObject.exDescription = _format(description);
    }

    if (typeof fatal !== 'undefined') {
      if (typeof fatal !== 'boolean') {
        Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('`args.fatal` must be a boolean.');
      } else {
        fieldObject.exFatal = fatal;
      }
    } // Send to GA


    send(fieldObject, trackerNames);
  }
}
var plugin = {
  /**
   * require:
   * GA requires a plugin
   * @param name {String} e.g. 'ecommerce' or 'myplugin'
   * @param options {Object} optional e.g {path: '/log', debug: true}
   * @param trackerName {String} optional e.g 'trackerName'
   */
  require: function require(rawName, options, trackerName) {
    if (typeof ga === 'function') {
      // Required Fields
      if (!rawName) {
        Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('`name` is required in .require()');
        return;
      }

      var name = Object(__WEBPACK_IMPORTED_MODULE_2__utils_trim__["a" /* default */])(rawName);

      if (name === '') {
        Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('`name` cannot be an empty string in .require()');
        return;
      }

      var requireString = trackerName ? "".concat(trackerName, ".require") : 'require'; // Optional Fields

      if (options) {
        if (_typeof(options) !== 'object') {
          Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('Expected `options` arg to be an Object');
          return;
        }

        if (Object.keys(options).length === 0) {
          Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('Empty `options` given to .require()');
        }

        ga(requireString, name, options);

        if (_debug) {
          Object(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])("called ga('require', '".concat(name, "', ").concat(JSON.stringify(options)));
        }
      } else {
        ga(requireString, name);

        if (_debug) {
          Object(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])("called ga('require', '".concat(name, "');"));
        }
      }
    }
  },

  /**
   * execute:
   * GA execute action for plugin
   * Takes variable number of arguments
   * @param pluginName {String} e.g. 'ecommerce' or 'myplugin'
   * @param action {String} e.g. 'addItem' or 'myCustomAction'
   * @param actionType {String} optional e.g. 'detail'
   * @param payload {Object} optional e.g { id: '1x5e', name : 'My product to track' }
   */
  execute: function execute(pluginName, action) {
    var payload;
    var actionType;

    if ((arguments.length <= 2 ? 0 : arguments.length - 2) === 1) {
      payload = arguments.length <= 2 ? undefined : arguments[2];
    } else {
      actionType = arguments.length <= 2 ? undefined : arguments[2];
      payload = arguments.length <= 3 ? undefined : arguments[3];
    }

    if (typeof ga === 'function') {
      if (typeof pluginName !== 'string') {
        Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('Expected `pluginName` arg to be a String.');
      } else if (typeof action !== 'string') {
        Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('Expected `action` arg to be a String.');
      } else {
        var command = "".concat(pluginName, ":").concat(action);
        payload = payload || null;

        if (actionType && payload) {
          ga(command, actionType, payload);

          if (_debug) {
            Object(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])("called ga('".concat(command, "');"));
            Object(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])("actionType: \"".concat(actionType, "\" with payload: ").concat(JSON.stringify(payload)));
          }
        } else if (payload) {
          ga(command, payload);

          if (_debug) {
            Object(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])("called ga('".concat(command, "');"));
            Object(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])("with payload: ".concat(JSON.stringify(payload)));
          }
        } else {
          ga(command);

          if (_debug) {
            Object(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])("called ga('".concat(command, "');"));
          }
        }
      }
    }
  }
};
/**
 * outboundLink:
 * GA outboundLink tracking
 * @param args.label {String} e.g. url, or 'Create an Account'
 * @param {function} hitCallback - Called after processing a hit.
 */

function outboundLink(args, hitCallback, trackerNames) {
  if (typeof hitCallback !== 'function') {
    Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('hitCallback function is required');
    return;
  }

  if (typeof ga === 'function') {
    // Simple Validation
    if (!args || !args.label) {
      Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('args.label is required in outboundLink()');
      return;
    } // Required Fields


    var fieldObject = {
      hitType: 'event',
      eventCategory: 'Outbound',
      eventAction: 'Click',
      eventLabel: _format(args.label)
    };
    var safetyCallbackCalled = false;

    var safetyCallback = function safetyCallback() {
      // This prevents a delayed response from GA
      // causing hitCallback from being fired twice
      safetyCallbackCalled = true;
      hitCallback();
    }; // Using a timeout to ensure the execution of critical application code
    // in the case when the GA server might be down
    // or an ad blocker prevents sending the data
    // register safety net timeout:


    var t = setTimeout(safetyCallback, 250);

    var clearableCallbackForGA = function clearableCallbackForGA() {
      clearTimeout(t);

      if (!safetyCallbackCalled) {
        hitCallback();
      }
    };

    fieldObject.hitCallback = clearableCallbackForGA; // Send to GA

    send(fieldObject, trackerNames);
  } else {
    // if ga is not defined, return the callback so the application
    // continues to work as expected
    setTimeout(hitCallback, 0);
  }
}
var testModeAPI = __WEBPACK_IMPORTED_MODULE_6__utils_testModeAPI__["a" /* default */];
/* harmony default export */ __webpack_exports__["default"] = ({
  initialize: initialize,
  ga: ga,
  set: set,
  send: send,
  pageview: pageview,
  modalview: modalview,
  timing: timing,
  event: event,
  exception: exception,
  plugin: plugin,
  outboundLink: outboundLink,
  testModeAPI: __WEBPACK_IMPORTED_MODULE_6__utils_testModeAPI__["a" /* default */]
});

/***/ }),
/* 648 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = format;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mightBeEmail__ = __webpack_require__(649);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toTitleCase__ = __webpack_require__(650);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__console_warn__ = __webpack_require__(177);



var redacted = 'REDACTED (Potential Email Address)';
function format(s, titleCase) {
  if (Object(__WEBPACK_IMPORTED_MODULE_0__mightBeEmail__["a" /* default */])(s)) {
    Object(__WEBPACK_IMPORTED_MODULE_2__console_warn__["a" /* default */])('This arg looks like an email address, redacting.');
    return redacted;
  }

  if (titleCase) {
    return Object(__WEBPACK_IMPORTED_MODULE_1__toTitleCase__["a" /* default */])(s);
  }

  return s;
}

/***/ }),
/* 649 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = mightBeEmail;
// See if s could be an email address. We don't want to send personal data like email.
// https://support.google.com/analytics/answer/2795983?hl=en
function mightBeEmail(s) {
  // There's no point trying to validate rfc822 fully, just look for ...@...
  return typeof s === 'string' && s.indexOf('@') !== -1;
}

/***/ }),
/* 650 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = toTitleCase;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__trim__ = __webpack_require__(278);
/**
 * To Title Case 2.1 - http://individed.com/code/to-title-case/
 * Copyright 2008-2013 David Gouch. Licensed under the MIT License.
 * https://github.com/gouch/to-title-case
 */

var smallWords = /^(a|an|and|as|at|but|by|en|for|if|in|nor|of|on|or|per|the|to|vs?\.?|via)$/i;
function toTitleCase(string) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__trim__["a" /* default */])(string).replace(/[A-Za-z0-9\u00C0-\u00FF]+[^\s-]*/g, function (match, index, title) {
    if (index > 0 && index + match.length !== title.length && match.search(smallWords) > -1 && title.charAt(index - 2) !== ':' && (title.charAt(index + match.length) !== '-' || title.charAt(index - 1) === '-') && title.charAt(index - 1).search(/[^\s-]/) < 0) {
      return match.toLowerCase();
    }

    if (match.substr(1).search(/[A-Z]|\../) > -1) {
      return match;
    }

    return match.charAt(0).toUpperCase() + match.substr(1);
  });
}

/***/ }),
/* 651 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = removeLeadingSlash;
function removeLeadingSlash(string) {
  if (string.substring(0, 1) === '/') {
    return string.substring(1);
  }

  return string;
}

/***/ }),
/* 652 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (options) {
  var gaAddress = 'https://www.google-analytics.com/analytics.js';

  if (options && options.gaAddress) {
    gaAddress = options.gaAddress;
  } else if (options && options.debug) {
    gaAddress = 'https://www.google-analytics.com/analytics_debug.js';
  } // https://developers.google.com/analytics/devguides/collection/analyticsjs/

  /* eslint-disable */


  (function (i, s, o, g, r, a, m) {
    i['GoogleAnalyticsObject'] = r;
    i[r] = i[r] || function () {
      (i[r].q = i[r].q || []).push(arguments);
    }, i[r].l = 1 * new Date();
    a = s.createElement(o), m = s.getElementsByTagName(o)[0];
    a.async = 1;
    a.src = g;
    m.parentNode.insertBefore(a, m);
  })(window, document, 'script', gaAddress, 'ga');
  /* eslint-enable */

});

/***/ }),
/* 653 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = log;
function log(s) {
  console.info('[react-ga]', s);
}

/***/ }),
/* 654 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export gaCalls */
var gaCalls = [];
/* harmony default export */ __webpack_exports__["a"] = ({
  calls: gaCalls,
  ga: function ga() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    gaCalls.push([].concat(args));
  },
  resetCalls: function resetCalls() {
    gaCalls.length = 0;
  }
});

/***/ }),
/* 655 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var tagSession=function tagSession(user){try{var data={email:user.username,businessName:user.businessName,firstName:user.firstName,idBusiness:user.idBusiness,idUser:user.idUser,idCustomer:user.idCustomer};window.__insp.push(['tagSession',data]);}catch(inspectorError){console.log(inspectorError);}};/* harmony default export */ __webpack_exports__["a"] = ({tagSession:tagSession});

/***/ }),
/* 656 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_utils_http__ = __webpack_require__(19);
var getCampaignRate=function getCampaignRate(idBusiness){return __WEBPACK_IMPORTED_MODULE_0_utils_http__["a" /* default */].get('/order/v1/order/campaingrate/'+idBusiness);};/* harmony default export */ __webpack_exports__["a"] = ({getCampaignRate:getCampaignRate});

/***/ }),
/* 657 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return startRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return finishRequest; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actionTypes__ = __webpack_require__(5);
var startRequest=function startRequest(){return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["_43" /* START_REQUEST */]};};var finishRequest=function finishRequest(){return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["P" /* FINISH_REQUEST */]};};

/***/ }),
/* 658 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_utils_http__ = __webpack_require__(19);
var companiesToUser=function companiesToUser(payload){return __WEBPACK_IMPORTED_MODULE_0_utils_http__["a" /* default */].post('/user/v1/business/search',payload);};var validateMobile=function validateMobile(payload){return __WEBPACK_IMPORTED_MODULE_0_utils_http__["a" /* default */].post('/user/v1/sign-up/validate-mobile',payload);};var sendDetails=function sendDetails(payload){return __WEBPACK_IMPORTED_MODULE_0_utils_http__["a" /* default */].post('/user/v1/sign-up/send-details',payload);};var createNewUserByEmail=function createNewUserByEmail(userEmail){return __WEBPACK_IMPORTED_MODULE_0_utils_http__["a" /* default */].post('/user/v1/sign-up',[{userEmail:userEmail}]);};var sendDetailsWithCodeMobile=function sendDetailsWithCodeMobile(payload){return __WEBPACK_IMPORTED_MODULE_0_utils_http__["a" /* default */].post('/user/v1/sign-up/with-code-mobile',payload);};/* harmony default export */ __webpack_exports__["a"] = ({companiesToUser:companiesToUser,validateMobile:validateMobile,sendDetails:sendDetails,sendDetailsWithCodeMobile:sendDetailsWithCodeMobile,createNewUserByEmail:createNewUserByEmail});

/***/ }),
/* 659 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return sendRequestChangePassword; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return resetPassword; });
/* unused harmony export tryAutomaticallyLogin */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return onCloseRequestEmailResetPasswordModal; });
/* unused harmony export closeResetPasswordModalError */
/* unused harmony export closeModalFailed */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actionTypes__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_services_userService__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_services_loginService__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_utils_object__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_utils_userError__ = __webpack_require__(15);
function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}var resetLinkInvalid=function resetLinkInvalid(){return Object(__WEBPACK_IMPORTED_MODULE_5_utils_userError__["e" /* knownError */])(__WEBPACK_IMPORTED_MODULE_5_utils_userError__["a" /* ERROR_CODES */].AUTH_RESET_LINK_INVALID,{title:"This password link can't be used",message:'It has expired or has already been used.',guidance:'Ask for a new link with Forgot password on the sign-in page.'});};var sendRequestChangePassword=function sendRequestChangePassword(passwordData){return function(dispatch){__WEBPACK_IMPORTED_MODULE_2_services_userService__["a" /* default */].changePassword(passwordData).then(function(userDetails){if(userDetails.idUser){dispatch(tryAutomaticallyLogin());}else{dispatch(requestFailed(resetLinkInvalid()));}}).catch(function(err){dispatch(requestFailed(Object(__WEBPACK_IMPORTED_MODULE_5_utils_userError__["h" /* userError */])(err,{area:'AUTH',code:__WEBPACK_IMPORTED_MODULE_5_utils_userError__["a" /* ERROR_CODES */].AUTH_PASSWORD_CHANGE_FAILED,task:'change your password'})));});};};var resetPassword=function resetPassword(payload){return function(dispatch){__WEBPACK_IMPORTED_MODULE_2_services_userService__["a" /* default */].resetPassword(payload).then(function(data){if(data.valid){dispatch(tryAutomaticallyLogin());}else{dispatch(requestFailed(resetLinkInvalid()));}}).catch(function(err){dispatch(requestFailed(Object(__WEBPACK_IMPORTED_MODULE_5_utils_userError__["h" /* userError */])(err,{area:'AUTH',task:'reset your password'})));});};};function tryAutomaticallyLogin(){var _this=this;return function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(dispatch){var response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:dispatch(loggingIn());_context.prev=1;_context.next=4;return __WEBPACK_IMPORTED_MODULE_3_services_loginService__["a" /* default */].login();case 4:response=_context.sent;if(!!__WEBPACK_IMPORTED_MODULE_4_utils_object__["a" /* default */].get(response,'idUser',undefined)){dispatch(requestSuccessLogin(response));}else{dispatch(loggingOut());}_context.next=11;break;case 8:_context.prev=8;_context.t0=_context['catch'](1);dispatch(loggingOut());case 11:case'end':return _context.stop();}}},_callee,_this,[[1,8]]);}));return function(_x){return _ref.apply(this,arguments);};}();}var requestSuccessLogin=function requestSuccessLogin(userDetails){return{type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["_24" /* REQUEST_SUCCESS_LOGIN */],userDetails:userDetails};};var loggingIn=function loggingIn(){return{type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["_72" /* USER_LOGGING_IN */]};};function loggingOut(){return{type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["_73" /* USER_LOGGING_OUT */]};}var onCloseRequestEmailResetPasswordModal=function onCloseRequestEmailResetPasswordModal(){return{type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["E" /* CLOSE_SENT_EMAIL_RESET_PASSWORD_MODAL */]};};var closeResetPasswordModalError=function closeResetPasswordModalError(){return{type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["D" /* CLOSE_RESET_PASSWORD_MODAL_ERROR */]};};// error: a userError, shown by ModalError.
var requestFailed=function requestFailed(error){return{type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["_19" /* REQUEST_FAILED */],errorMessage:error};};var closeModalFailed=function closeModalFailed(){return{type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["y" /* CLOSE_MODAL_ERROR */]};};

/***/ }),
/* 660 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fetchingBusinessFromUser; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actionTypes__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services_businessService__ = __webpack_require__(661);
var fetchingBusinessFromUser=function fetchingBusinessFromUser(){return function(dispatch){__WEBPACK_IMPORTED_MODULE_1_services_businessService__["a" /* default */].getBusinessFromUser().then(function(business){dispatch(fetchingBusinessSuccess(business));}).catch(function(err){console.log(err);});};};var fetchingBusinessSuccess=function fetchingBusinessSuccess(business){return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["K" /* FETCHING_BUSINESS_SUCCESS */],business:business};};

/***/ }),
/* 661 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_utils_http__ = __webpack_require__(19);
var getBusinessFromUser=function getBusinessFromUser(idCompany){return __WEBPACK_IMPORTED_MODULE_0_utils_http__["a" /* default */].get('/user/v1/business/');};/* harmony default export */ __webpack_exports__["a"] = ({getBusinessFromUser:getBusinessFromUser});

/***/ }),
/* 662 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getOrders; });
/* unused harmony export getOrdersSuccess */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actionTypes__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services_deliveryTrackingService__ = __webpack_require__(663);
var getOrders=function getOrders(){return function(dispatch){__WEBPACK_IMPORTED_MODULE_1_services_deliveryTrackingService__["a" /* default */].getOrders().then(function(data){dispatch(getOrdersSuccess(data));}).catch(function(err){console.log(err);});};};var getOrdersSuccess=function getOrdersSuccess(orders){return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["U" /* GET_ORDERS_DELIVERY_TRACKING_SUCCESS */],orders:orders};};

/***/ }),
/* 663 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_utils_http__ = __webpack_require__(19);
var getOrders=function getOrders(){return __WEBPACK_IMPORTED_MODULE_0_utils_http__["a" /* default */].get('/order/v1/order/deliverytracking');};/* harmony default export */ __webpack_exports__["a"] = ({getOrders:getOrders});

/***/ }),
/* 664 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return findVoucherByCode; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actionTypes__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services_voucherService__ = __webpack_require__(78);
var findVoucherByCode=function findVoucherByCode(code){return function(dispatch){__WEBPACK_IMPORTED_MODULE_1_services_voucherService__["a" /* default */].findVoucherByCode(code).then(function(data){dispatch(successLinkVoucherRequest(data));}).catch(function(err){console.log(err);});};};var successLinkVoucherRequest=function successLinkVoucherRequest(voucher){return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["_4" /* LINK_VOUCHER_LOAD */],payload:voucher};};

/***/ }),
/* 665 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fetchingVoucherBalance; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_services_voucherService__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actionTypes__ = __webpack_require__(5);
var fetchingVoucherBalance=function fetchingVoucherBalance(){return function(dispatch){__WEBPACK_IMPORTED_MODULE_0_services_voucherService__["a" /* default */].getVoucherBalance().then(function(data){dispatch(successFetchingVoucherBalance(data));}).catch(function(err){return console.log(err);});};};var successFetchingVoucherBalance=function successFetchingVoucherBalance(data){return{type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["_74" /* VOUCHER_BALANCE_SUCCESS */],payload:data};};

/***/ }),
/* 666 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createCustomerDeliveryAddress; });
/* unused harmony export createdNewCustomerDeliveryAddress */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actionTypes__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services_customerService__ = __webpack_require__(667);
var createCustomerDeliveryAddress=function createCustomerDeliveryAddress(payload){return function(dispatch){__WEBPACK_IMPORTED_MODULE_1_services_customerService__["a" /* default */].createCustomerDeliveryAddress(payload).then(function(address){dispatch(createdNewCustomerDeliveryAddress(address));}).catch(function(error){console.log(error);});};};var createdNewCustomerDeliveryAddress=function createdNewCustomerDeliveryAddress(payload){return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["G" /* CREATED_NEW_CUSTOMER_DELIVERY_ADDRESS */],payload:payload};};

/***/ }),
/* 667 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_utils_http__ = __webpack_require__(19);
var additionalInfo=function additionalInfo(emailList){return __WEBPACK_IMPORTED_MODULE_0_utils_http__["a" /* default */].post('/user/v1/customer/additional-info',emailList);};var createCustomerDeliveryAddress=function createCustomerDeliveryAddress(payload){return __WEBPACK_IMPORTED_MODULE_0_utils_http__["a" /* default */].post('/user/v1/customerDeliveryAddress',payload);};var getListCustomerDeliveryAddress=function getListCustomerDeliveryAddress(){return __WEBPACK_IMPORTED_MODULE_0_utils_http__["a" /* default */].get('/user/v1/customerDeliveryAddress');};var deleteCustomerDeliveryAddress=function deleteCustomerDeliveryAddress(id){return __WEBPACK_IMPORTED_MODULE_0_utils_http__["a" /* default */].post('/user/v1/customerDeliveryAddress',id);};/* harmony default export */ __webpack_exports__["a"] = ({additionalInfo:additionalInfo,createCustomerDeliveryAddress:createCustomerDeliveryAddress,getListCustomerDeliveryAddress:getListCustomerDeliveryAddress,deleteCustomerDeliveryAddress:deleteCustomerDeliveryAddress});

/***/ }),
/* 668 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 669 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__support_supportEntry__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_hoc_ReactAux_ReactAux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__MenuComponents_Categories_Categories__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__MenuComponents_PopularDish__ = __webpack_require__(670);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__MenuComponents_Products_ProductDetails_ProductDetails__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_UI_Modal_ModalCartMessage__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_UI_Modal_ModalError__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_UI_Modal_ModalSuccessPayment__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_UI_Modal_ModalReceipt__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__MenuComponents_RecentlyOrdered_RecentlyOrdered__ = __webpack_require__(288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_hoc_ErroHandling__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_actions_index__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Cart_Cart__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_utils_object__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_utils_currency__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__support_context__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_utils_userError__ = __webpack_require__(15);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var DefaultMenu=function(_Component){_inherits(DefaultMenu,_Component);function DefaultMenu(){var _ref;var _temp,_this,_ret;_classCallCheck(this,DefaultMenu);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=DefaultMenu.__proto__||Object.getPrototypeOf(DefaultMenu)).call.apply(_ref,[this].concat(args))),_this),_this.state={categoriesType:[{id:0,name:'Popular Dishes',active:true},{id:1,name:'Recently Ordered',active:false}],differentRestaurant:false,productStandBy:null,businessStandBy:null,showCategoriesMobile:false,showRestaurantsMobile:false},_this.closeCategoriesSheet=function(){if(_this.state.showCategoriesMobile)_this.setState({showCategoriesMobile:false});},_this.toggleCategoriesNavClass=function(){_this.props.onToggleCart(false);_this.props.onToggleRestaurants(false);_this.setState({showCategoriesMobile:!_this.state.showCategoriesMobile});},_this.toggleCart=function(){_this.props.onToggleCart();_this.props.onToggleRestaurants(false);_this.setState({showCategoriesMobile:false});},_this.toggleRestaurants=function(){_this.props.onToggleCart(false);_this.props.onToggleRestaurants();_this.setState({showCategoriesMobile:false});},_this.getSurcharge=function(){var isPayTypeCreditCard=function isPayTypeCreditCard(payType){return payType==='C';};var payType=__WEBPACK_IMPORTED_MODULE_15_utils_object__["a" /* default */].get(_this.props,'cart.payInfo.payType',undefined);if(isPayTypeCreditCard(payType)){return __WEBPACK_IMPORTED_MODULE_15_utils_object__["a" /* default */].get(_this.props,'cart.campaignRateCC.amount',0);}return 0;},_this.getTaxDelivery=function(){return!!_this.props.restaurantOnCart&&_this.props.restaurantOnCart.taxDelivery&&_this.isDeliverAtHome()?_this.props.restaurantOnCart.taxDelivery.toFixed(2):Number(0).toFixed(2);},_this.getCollectionDiscount=function(){var campaignRateCollection=__WEBPACK_IMPORTED_MODULE_15_utils_object__["a" /* default */].get(_this.props,'cart.campaignRateCollection',null);if(campaignRateCollection){var collectionDiscount=campaignRateCollection.discountType==='P'?'% '+campaignRateCollection.amount:'- '+campaignRateCollection.amount;return collectionDiscount;}else{return'';}},_this.isForCollection=function(){return __WEBPACK_IMPORTED_MODULE_15_utils_object__["a" /* default */].get(_this.props,'cart.restaurantSelected.forCollection','N');},_this.getReceiptData=function(){return{cart:_this.props.cart,total:_this.getAmount(),currency:_this.getCurrency(),surcharge:_this.getSurcharge(),subtotal:_this.getSubTotal(),taxDelivery:_this.getTaxDelivery(),userDetails:_this.props.userDetails,orderDeliveryDate:__WEBPACK_IMPORTED_MODULE_15_utils_object__["a" /* default */].get(_this.props,'cart.orderDeliveryDate',undefined),collectionDiscount:_this.getCollectionDiscount(),forCollection:_this.isForCollection(),address:_this.getAddress(),tipValue:__WEBPACK_IMPORTED_MODULE_15_utils_object__["a" /* default */].get(_this.props,'cart.tipValue',0)};},_this.handleSelectCategory=function(id){var categoriesTypeUpdate=_this.state.categoriesType.map(function(category){if(category.active){category.active=false;}else if(category.id===id){category.active=true;}return category;});_this.props.onChangeTitleHeader(categoriesTypeUpdate[id].name);_this.setState({categoriesType:categoriesTypeUpdate});},_this.handleSelectProductFromPopularDish=function(idProduct){var popularDishItem=_this.props.popularDishDelivery.find(function(item){return item.product.id===idProduct;});if(popularDishItem.business.isOpen){if(_this.verifyIfRestaurantInCart(popularDishItem.business.id)){_this.setState({productStandBy:popularDishItem.product});_this.setState({businessStandBy:popularDishItem.business});}else{_this.props.onRestaurantSelected(popularDishItem.business);_this.props.onFetchingMealOptionsFromPopularDish(popularDishItem);}}else{_this.props.onErrorHandling({showError:true,errorMessage:Object(__WEBPACK_IMPORTED_MODULE_18_utils_userError__["e" /* knownError */])(__WEBPACK_IMPORTED_MODULE_18_utils_userError__["a" /* ERROR_CODES */].MENU_RESTAURANT_CLOSED,{title:"This restaurant is closed now",message:'It has stopped taking orders for today.',guidance:'Choose another restaurant, or order for tomorrow.'})});}},_this.handleAddRecentlyOrderProduct=function(item){var productsLastOrder=item.orderItems.map(function(orderItem){var productMap=Object.assign({},orderItem.product,{mealOptions:orderItem.mealOptions?orderItem.mealOptions:[]});var price=0;if(orderItem.mealOptions){price=orderItem.mealOptions.reduce(function(inicial,item){return inicial+item.product.price;},0);}price=price+orderItem.product.price;productMap.price=price;return productMap;});if(_this.verifyIfRestaurantInCart(item.restaurant.id)){_this.setState({productStandBy:productsLastOrder});_this.setState({businessStandBy:item.restaurant});}else{_this.props.onAddProductToCart({product:productsLastOrder,business:item.restaurant});_this.props.onRestaurantSelected(item.restaurant);}},_this.verifyIfRestaurantInCart=function(idRestaurant){var isDifferent=!_this.props.restaurantOnCart?false:_this.props.restaurantOnCart.id!==idRestaurant;_this.setState({differentRestaurant:isDifferent});return isDifferent;},_this.handleConfirmOkCartModal=function(){_this.props.onDeleteAllProductsFromCart();if(_this.state.categoriesType[1].active){_this.props.onAddProductToCart({product:_this.state.productStandBy,business:_this.state.businessStandBy});_this.props.onRestaurantSelected(_this.state.businessStandBy);}else{_this.props.onFetchingMealOptionsFromPopularDish({product:_this.state.productStandBy,business:_this.state.businessStandBy});_this.props.onRestaurantSelected(_this.state.businessStandBy);}_this.setState({differentRestaurant:false});},_this.handleDenyCartModal=function(){_this.setState({differentRestaurant:false});},_this.handleCloseHandlingError=function(){_this.props.onErrorHandling({showError:false,errorMessage:''});},_this.handleCloseModalPlacedOrderOnCart=function(){_this.props.closeModalPlacedOrderOnCart(_this.props.history);},_this.getAddress=function(){return _this.props.addresses[0];},_this.isDeliverAtHome=function(){return _this.getAddress()!=null?_this.getAddress().idCustomerDeliveryAddress!=null:false;},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(DefaultMenu,[{key:'componentWillUnmount',value:function componentWillUnmount(){window.removeEventListener(__WEBPACK_IMPORTED_MODULE_1__support_supportEntry__["b" /* PANEL_OPEN_EVENT */],this.closeCategoriesSheet);}},{key:'componentDidMount',value:function componentDidMount(prevProps){window.addEventListener(__WEBPACK_IMPORTED_MODULE_1__support_supportEntry__["b" /* PANEL_OPEN_EVENT */],this.closeCategoriesSheet);var reorderId=this.props.match&&this.props.match.params&&this.props.match.params.idOrder;if(reorderId)Object(__WEBPACK_IMPORTED_MODULE_17__support_context__["c" /* setSupportContext */])('order.detail',{orderIds:[reorderId]});this.props.onFetchingMenu(this.props.userDetails.idBusiness,localStorage.getItem('idBusinessAddress'));if(this.props.listAddress.length===0){this.props.onFetchingListAddressForOrder({email:this.props.userDetails.username});}this.props.onChangeTitleHeader('Popular Dishes');localStorage.removeItem('PayInfo');}},{key:'getAmount',value:function getAmount(){return __WEBPACK_IMPORTED_MODULE_15_utils_object__["a" /* default */].get(this.props,'cart.payInfo.amount',0);}},{key:'getCurrency',value:function getCurrency(){return __WEBPACK_IMPORTED_MODULE_16_utils_currency__["a" /* default */].convertNameToSymbol(__WEBPACK_IMPORTED_MODULE_15_utils_object__["a" /* default */].get(this.props,'cart.restaurantSelected.currency','EUR'));}// The support conversation opened on a small screen: the Categories sheet mustn't cover it.
},{key:'getSubTotal',value:function getSubTotal(){return __WEBPACK_IMPORTED_MODULE_15_utils_object__["a" /* default */].get(this.props,'cart.subtotal',0);}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_hoc_ReactAux_ReactAux__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_hoc_ErroHandling__["a" /* default */],{handlingError:this.props.errorHandling,closedErrorModal:this.handleCloseHandlingError},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__MenuComponents_Products_ProductDetails_ProductDetails__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_UI_Modal_ModalCartMessage__["a" /* default */],{clickButtonConfirm:this.handleConfirmOkCartModal,clickButtonDeny:this.handleDenyCartModal,message:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Note! You can only order from ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),' one restaurant at a time.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Clear current basket to add?'),showModal:this.state.differentRestaurant}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_UI_Modal_ModalError__["a" /* default */],{showModal:this.props.modalErrorPlacedOrder,closeModal:this.props.closeModalErrorPlacedOrder,errorMessage:this.props.checkoutError||this.props.errorMessage}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_UI_Modal_ModalSuccessPayment__["a" /* default */],{descriptionSuccess:this.props.cart.isInvoice?this.props.invoice.descriptionSuccess:this.props.cart.descriptionSuccess,isInvoice:this.props.cart.isInvoice,closeModal:this.handleCloseModalPlacedOrderOnCart,showModal:this.props.showSuccessPaymentModal,openReceipt:this.props.openModalReceiptOnCart}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_UI_Modal_ModalReceipt__["a" /* default */],{showModal:this.props.showReceiptModal,closeModal:this.props.closeModalReceiptOnCart,data:this.getReceiptData()}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'main-content','aria-label':'Order categories'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__MenuComponents_Categories_Categories__["a" /* default */],{categoriesType:this.state.categoriesType,selectCategory:this.handleSelectCategory,showCategoriesMobile:this.state.showCategoriesMobile,toggleCategoriesNavClass:this.toggleCategoriesNavClass,showRestaurantsMobile:this.props.showRestaurantsMobile,toggleRestaurants:this.toggleRestaurants,checkout:this.props.checkout,toggleCart:this.toggleCart}),this.state.categoriesType[0].active?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__MenuComponents_PopularDish__["a" /* default */],{checkout:this.props.checkout,restaurantsOptions:this.props.restaurantsOptions,selectProduct:this.handleSelectProductFromPopularDish,popularDishItems:this.props.popularDishDelivery}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__MenuComponents_RecentlyOrdered_RecentlyOrdered__["a" /* default */],{checkout:this.props.checkout,restaurantsOptions:this.props.restaurantsOptions,addRepeatOrderProduct:this.handleAddRecentlyOrderProduct,showLoading:this.props.loadingRecentlyOrder,recentlyOrdered:this.props.recentlyOrdered}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__Cart_Cart__["a" /* default */],null))));}}]);return DefaultMenu;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{restaurantsOptions:state.menuReducer.restaurantsOptions,restaurantSelected:state.menuReducer.restaurantSelected,userDetails:state.authenticationReducer.userDetails,listAddress:state.menuReducer.listAddress,popularDishDelivery:state.menuReducer.popularDishDelivery,recentlyOrdered:state.menuReducer.recentlyOrdered,loadingRecentlyOrder:state.menuReducer.loadingRecentlyOrder,showRestaurantsMobile:state.menuReducer.showRestaurantsMobile,cart:state.cartReducer.cart,invoice:state.invoiceReducer.invoice,checkout:state.cartReducer.cart.checkout,showSuccessPaymentModal:state.cartReducer.cart.showPlacedModal,showReceiptModal:state.cartReducer.cart.showReceiptModal,restaurantOnCart:state.cartReducer.cart.restaurantSelected,modalErrorPlacedOrder:state.cartReducer.cart.modalErrorPlacedOrder,errorMessage:state.cartReducer.cart.errorLimit,checkoutError:state.cartReducer.cart.checkoutError,errorHandling:state.menuReducer.errorHandling,showCollectionOption:state.menuReducer.showCollectionOption,addresses:state.menuReducer.addresses};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onFetchingMenu:function onFetchingMenu(idBusiness,idAddress){return dispatch(__WEBPACK_IMPORTED_MODULE_13_actions_index__["V" /* fetchingMenu */](idBusiness,idAddress));},onChangeTitleHeader:function onChangeTitleHeader(titleHeader){return dispatch(__WEBPACK_IMPORTED_MODULE_13_actions_index__["l" /* changeMenuTitleHeader */](titleHeader));},onFetchingListAddressForOrder:function onFetchingListAddressForOrder(email){return dispatch(__WEBPACK_IMPORTED_MODULE_13_actions_index__["T" /* fetchingListAddressForOrder */](email));},onRestaurantSelected:function onRestaurantSelected(restaurant){return dispatch(__WEBPACK_IMPORTED_MODULE_13_actions_index__["_21" /* restaurantSelected */](restaurant));},onSelectProduct:function onSelectProduct(product){return dispatch(__WEBPACK_IMPORTED_MODULE_13_actions_index__["_25" /* selectProduct */](product));},onAddProductToCart:function onAddProductToCart(products){return dispatch(__WEBPACK_IMPORTED_MODULE_13_actions_index__["a" /* addProductToCart */](products));},onFetchingMealOptionsFromPopularDish:function onFetchingMealOptionsFromPopularDish(payload){return dispatch(__WEBPACK_IMPORTED_MODULE_13_actions_index__["U" /* fetchingMealOptionsFromPopularDish */](payload));},onDeleteAllProductsFromCart:function onDeleteAllProductsFromCart(){return dispatch(__WEBPACK_IMPORTED_MODULE_13_actions_index__["G" /* deleteAllProductsFromCart */]());},onToggleCart:function onToggleCart(status){return dispatch(__WEBPACK_IMPORTED_MODULE_13_actions_index__["_34" /* toggleCart */](status));},onToggleRestaurants:function onToggleRestaurants(status){return dispatch(__WEBPACK_IMPORTED_MODULE_13_actions_index__["_38" /* toggleRestaurants */](status));},cartToggleShowModalReceipt:function cartToggleShowModalReceipt(isClosing){return dispatch(__WEBPACK_IMPORTED_MODULE_13_actions_index__["i" /* cartToggleShowModalReceipt */](isClosing));},closeModalErrorPlacedOrder:function closeModalErrorPlacedOrder(){return dispatch(__WEBPACK_IMPORTED_MODULE_13_actions_index__["w" /* closeModalErrorPlacedOrder */]());},closeModalPlacedOrderOnCart:function closeModalPlacedOrderOnCart(history){return dispatch(__WEBPACK_IMPORTED_MODULE_13_actions_index__["y" /* closeModalPlacedOrderOnCart */](history));},closeModalReceiptOnCart:function closeModalReceiptOnCart(){return dispatch(__WEBPACK_IMPORTED_MODULE_13_actions_index__["A" /* closeModalReceiptOnCart */]());},openModalReceiptOnCart:function openModalReceiptOnCart(){return dispatch(__WEBPACK_IMPORTED_MODULE_13_actions_index__["_10" /* openModalReceiptOnCart */]());},onErrorHandling:function onErrorHandling(errorMessage){return dispatch(__WEBPACK_IMPORTED_MODULE_13_actions_index__["K" /* errorHandling */](errorMessage));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(DefaultMenu));

/***/ }),
/* 670 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export popularDish */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Products_Product__ = __webpack_require__(284);
var popularDish=function popularDish(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:props.checkout?'list-items cart-open':'list-items'},props.popularDishItems.map(function(item){return props.restaurantsOptions[0].active===true?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Products_Product__["a" /* default */],{isPopularDish:true,key:item.product.id+item.business.name+item.business.id,product:item.product,business:item.business,selectProduct:props.selectProduct}):item.product.forCollection?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Products_Product__["a" /* default */],{key:item.product.id,product:item.product,selectProduct:props.selectProduct}):null;}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cart-menu-category-overlay'}));};/* harmony default export */ __webpack_exports__["a"] = (popularDish);

/***/ }),
/* 671 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SUPPORT_EMAIL */
/* unused harmony export supportMessageFor */
/* unused harmony export supportMailto */
/* harmony export (immutable) */ __webpack_exports__["a"] = contactSupport;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__supportEntry__ = __webpack_require__(81);
// "Contact support" from an error: the support composer when it is on screen (pre-filled with the
// reference), else LiveChat (the reference set as a chat variable staff see), else an email to
// support@lunch.team with the reference in the subject.
var SUPPORT_EMAIL='support@lunch.team';/** The message the customer starts from: what failed and the reference. No personal data. */function supportMessageFor(error){var lines=[];if(error&&error.title)lines.push(error.title+'.');if(error&&(error.fullReference||error.reference)){lines.push('Reference: '+(error.fullReference||error.reference));}return lines.join('\n');}function supportMailto(error){var reference=error&&(error.fullReference||error.reference);var subject=reference?'Help with '+reference:'Help with Lunch.Team';var body=supportMessageFor(error);return'mailto:'+SUPPORT_EMAIL+'?subject='+encodeURIComponent(subject)+(body?'&body='+encodeURIComponent(body+'\n\n'):'');}function liveChatOpen(error){if(typeof document!=='undefined'){var root=document.documentElement;// Hidden on phones and while the composer has taken over.
if(root.classList.contains('lunchteam-livechat-off')||root.classList.contains('lunchteam-mobile-surface')){return false;}}var reference=error&&(error.fullReference||error.reference)||'';try{if(window.LiveChatWidget&&typeof window.LiveChatWidget.call==='function'){if(reference){window.LiveChatWidget.call('set_session_variables',{support_reference:reference});}window.LiveChatWidget.call('maximize');return true;}if(window.LC_API&&typeof window.LC_API.open_chat_window==='function'){if(reference&&typeof window.LC_API.set_custom_variables==='function'){window.LC_API.set_custom_variables([{name:'support_reference',value:reference}]);}window.LC_API.open_chat_window();return true;}}catch(e){return false;}return false;}/** Opens the best support route for this error. Returns 'composer' | 'livechat' | 'email'. */function contactSupport(error){if(Object(__WEBPACK_IMPORTED_MODULE_0__supportEntry__["c" /* isComposerShown */])()){Object(__WEBPACK_IMPORTED_MODULE_0__supportEntry__["e" /* openSupportComposer */])({text:supportMessageFor(error)});return'composer';}if(liveChatOpen(error)){return'livechat';}window.location.href=supportMailto(error);return'email';}

/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(673);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(17)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../lunch-team-client-checkout-msg/node_modules/css-loader/index.js!../../../../../../../lunch-team-client-checkout-msg/node_modules/sass-loader/dist/cjs.js!./errorReference.scss", function() {
			var newContent = require("!!../../../../../../../lunch-team-client-checkout-msg/node_modules/css-loader/index.js!../../../../../../../lunch-team-client-checkout-msg/node_modules/sass-loader/dist/cjs.js!./errorReference.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 673 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(14)(undefined);
// imports


// module
exports.push([module.i, ".lt-error-reference{margin-top:12px}.lt-error-reference__line{margin:0;font-size:12px;line-height:1.4;color:#4a5f54;user-select:text;word-break:break-word}.lt-error-reference__text{user-select:all}.lt-error-reference__copy{margin-left:8px;padding:0 4px;min-height:24px;border:0;background:rgba(0,0,0,0);color:#0e7a4b;font-size:12px;font-weight:600;text-decoration:underline;cursor:pointer}.lt-error-reference__contact{margin-top:8px;padding:8px 12px;min-height:40px;border:1px solid #dbe5df;border-radius:4px;background:rgba(0,0,0,0);color:#0b2318;font-size:14px;font-weight:600;cursor:pointer}.lt-error-reference__copy:focus-visible,.lt-error-reference__contact:focus-visible{outline:2px solid #0e7a4b;outline-offset:2px}", ""]);

// exports


/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(675);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(17)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../lunch-team-client-checkout-msg/node_modules/css-loader/index.js!../../../../../../../lunch-team-client-checkout-msg/node_modules/sass-loader/dist/cjs.js!./modalError.scss", function() {
			var newContent = require("!!../../../../../../../lunch-team-client-checkout-msg/node_modules/css-loader/index.js!../../../../../../../lunch-team-client-checkout-msg/node_modules/sass-loader/dist/cjs.js!./modalError.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(14)(undefined);
// imports


// module
exports.push([module.i, ".lt-modal-error__body{color:#0b2318;text-align:center}.lt-modal-error__title{display:block;margin-bottom:8px;font-size:18px;line-height:1.3}.lt-modal-error__message,.lt-modal-error__guidance,.lt-modal-error__order{margin:0 0 8px;font-size:14px;line-height:1.45}.error-popup-block .lb-content button.bt{display:block;float:none;margin:0 auto;border:0;cursor:pointer}", ""]);

// exports


/***/ }),
/* 676 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_hoc_ReactAux_ReactAux__ = __webpack_require__(4);
var PickOutOptions=function PickOutOptions(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pick-out'},props.productSelected.mealOptions.map(function(mealOption,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_hoc_ReactAux_ReactAux__["a" /* default */],{key:index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'choice',tabIndex:0},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,mealOption.name),mealOption.itemMaxQuantity?'(Choose max '+mealOption.itemMaxQuantity+' )':''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{style:{color:'var(--lt-color-danger)',marginTop:'10px'}},mealOption.flagRequired==='Y'?'You should select at least 1':''),mealOption.mealOptionItens.map(function(item,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_hoc_ReactAux_ReactAux__["a" /* default */],{key:item.id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{onChange:function onChange(evt){return props.selectMealOptions(evt,mealOption.idCategoryType,item.id);},type:'checkbox',id:item.name+mealOption.idCategoryType+item.id,className:'border-black singup',name:mealOption.name+item.id,checked:!!props.mealOptionsSelected.find(function(selected){return selected.idCategoryType===mealOption.idCategoryType&&selected.idMealOption===item.id;})}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{style:item.outOfStock?{color:'var(--lt-color-muted-foreground)'}:{},className:'singup ',htmlFor:item.name+mealOption.idCategoryType+item.id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,item.name),item.price!==null&&item.price!==0?'+ '+item.price.toFixed(2):null,item.outOfStock?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{'class':'right'},'It is out of stock')):null));})));}));};/* harmony default export */ __webpack_exports__["a"] = (PickOutOptions);

/***/ }),
/* 677 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 678 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 679 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(14)(undefined);
// imports


// module
exports.push([module.i, ".modal-receipt-test{position:absolute !important;top:5% !important;left:11% !important}@media only screen and (max-width: 600px){.modal-content-receipt{width:85% !important;top:75% !important}}", ""]);

// exports


/***/ }),
/* 680 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 681 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CartProduct */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PaymentOptions__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PaymentButton__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__DatePickerOrder__ = __webpack_require__(682);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__DefaultMenu_OptionsForOrder__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_utils_currency__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_utils_time__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_utils_object__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_actions_index__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Cart_css__ = __webpack_require__(308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Cart_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__Cart_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_hoc_ReactAux_ReactAux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_moment__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_components_UI_Modal_ModalConfirm__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_components_UI_Modal_ModalError__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_components_UI_Modal_ModalCartMessage__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_UI_Spinner_Spinner__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__config_guestOrdering__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__support_context__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__utils_userError__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__support_voiceOrder__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__support_AllergenGate__ = __webpack_require__(761);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__support_basketCheck__ = __webpack_require__(96);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var basketKey=function basketKey(products){return JSON.stringify(Object(__WEBPACK_IMPORTED_MODULE_24__support_basketCheck__["c" /* cartLines */])(products));};var RESTAURANT_GONE_ERROR=Object(__WEBPACK_IMPORTED_MODULE_21__utils_userError__["b" /* errorCopy */])(__WEBPACK_IMPORTED_MODULE_21__utils_userError__["a" /* ERROR_CODES */].MENU_RESTAURANT_UNAVAILABLE,{title:"This restaurant isn't taking orders now",message:'It stopped taking orders while your basket was open.',guidance:'Reload the menu to choose again. Your basket will be emptied.'});// A key that changes when the basket's split into people changes.
var partySignature=function partySignature(parties){return parties.map(function(party){return party.guestId+':'+party.subtotal;}).join('|');};var CartProduct=function(_Component){_inherits(CartProduct,_Component);function CartProduct(props){var _this2=this;_classCallCheck(this,CartProduct);var _this=_possibleConstructorReturn(this,(CartProduct.__proto__||Object.getPrototypeOf(CartProduct)).call(this,props));_this.handleConfirmOkCartModal=function(){_this.setState({openModalClearBasket:false});_this.setState({selectAddress:true});_this.props.onDeleteAllproductsFromCard();};_this.handleDenyCartModal=function(){_this.setState({openModalClearBasket:false});};_this.handleCampaignRate=function(prevProps){if(_this.props.restaurantSelected&&JSON.stringify(_this.props.restaurantSelected)!==JSON.stringify(prevProps.restaurantSelected)){_this.props.onFetchingCampaignRate(_this.props.restaurantSelected.id);}};_this.handleIncreaseQuantityProduct=function(product){_this.props.onAddProductToCartNow({product:product,business:_this.props.restaurantSelected});};_this.handleDecreaseProduct=function(product){_this.props.onDeleteProductFromCart({product:product});};_this.onHandleSelectPaymentMethod=function(id,type){switch(type){case'ideal':_this.setState({payOption:'ideal',payType:'I',payWithAnotherCard:true});break;case'bancontact':_this.setState({payOption:'bancontact',payType:'B',payWithAnotherCard:true});break;case'onAccount':_this.setState({payOption:'onAccount',payType:'A'});break;case'onCreditCard':if(id==='payWithAnotherCard'){_this.setState({payOption:'onCreditCard',payType:'C',cardSelected:null,payWithAnotherCard:true});}else{var card=_this.props.cards.find(function(item){return item.cardId===id;});_this.setState({payOption:'onCreditCard',payType:'C',cardSelected:card,payWithAnotherCard:false});}break;case'onVoucher':_this.setState({payOption:'onVoucher',payType:'A'});break;default:break;}};_this.onHandleAddCutlery=function(event){_this.setState({cutlery:event.target.checked});};_this.handleSpecialNotes=function(event){_this.setState({specialNotes:event.target.value});};_this.getParties=function(){return Object(__WEBPACK_IMPORTED_MODULE_19__config_guestOrdering__["u" /* splitBasket */])(_this.props.productsOnCart,_this.props.guests);};_this.getPartyValue=function(guestId){return(_this.props.partyValues||[]).find(function(value){return value.guestId===guestId;})||null;};_this.getPartyTotal=function(party,index){var value=_this.getPartyValue(party.guestId);var total=value?value.total:party.subtotal;return total+(index===0?_this.getTotalTip():0);};_this.onDeliveryTomorrow=function(_ref){var target=_ref.target;_this.props.changeDeliveryTomorrow(target.checked);if(target.checked){_this.setState({deliveryDateOnly:__WEBPACK_IMPORTED_MODULE_14_moment___default()().add(1,'day').format('DD/MM/YYYY')});}else{_this.setState({deliveryDateOnly:__WEBPACK_IMPORTED_MODULE_14_moment___default()().format('DD/MM/YYYY')});}};_this.handleDeliveryTomorrow=function(){if(_this.isBasketEmpty())return;_this.setState({isSpinnerVisible:true});if(_this.props.deliveryTomorrow){_this.setState({showDeliveryTomorrowConfirmationModal:true});}else{_this.onHandlePlaceOrder();}};_this.handleDeliveryTomorrowCancel=function(){_this.setState({showDeliveryTomorrowConfirmationModal:false});};_this.handleDeliveryTomorrowConfirm=function(){_this.setState({showDeliveryTomorrowConfirmationModal:false});_this.onHandlePlaceOrder();};_this.onHandlePlaceOrder=function(){if(_this.isBasketEmpty())return undefined;var restaurant=_this.props.restaurantSelected;if(!restaurant||!Object(__WEBPACK_IMPORTED_MODULE_24__support_basketCheck__["a" /* allergenGateApplies */])(restaurant.id))return _this.placeOrderNow();// One final check at a time: a second press while one runs places nothing (Codex r2: no double placement).
if(_this.finalCheckInFlight)return undefined;_this.finalCheckInFlight=true;var quoteHash=_this.state.allergenQuote||undefined;var seenAdviceText=_this.state.allergenSeenText||undefined;_this.setState({allergenQuote:null,allergenBusy:true,allergenError:''});// The check is bound to this restaurant, this basket and this allergy answer; each placement path checks the
// binding again just before it sends anything (Codex r2).
var token=_this.gateToken(restaurant.id);var release=function release(){_this.finalCheckInFlight=false;};return Object(__WEBPACK_IMPORTED_MODULE_24__support_basketCheck__["h" /* runBasketCheck */])({restaurantId:restaurant.id,products:_this.props.productsOnCart,quoteHash:quoteHash,seenAdviceText:seenAdviceText}).then(function(check){if(_this.unmounted)return release();if(!check||check.applies!==true){release();// A pilot restaurant without an answer from the allergen check is never placed (fail closed).
_this.setState({allergenBusy:false,isSpinnerVisible:false,allergenGate:{applies:true,blockers:['CHECK_FAILED']},allergenError:"We couldn't check allergens for this restaurant just now, so your order wasn't placed. Please try again."});return undefined;}if(!_this.gateRestaurantStill(token)){release();_this.setState({allergenBusy:false,isSpinnerVisible:false,allergenSeenText:null,allergenGate:null,allergenError:'The restaurant changed while we checked your order, so it wasn\'t placed.'});return undefined;}if(basketKey(_this.props.productsOnCart)!==token.lines){release();_this.setState({allergenBusy:false,isSpinnerVisible:false,allergenError:'Your basket changed while we checked it. Please read the allergen information again.'});_this.refreshAllergenGate();return undefined;}if(Object(__WEBPACK_IMPORTED_MODULE_24__support_basketCheck__["e" /* getAllergyRevision */])(restaurant.id)!==token.revision){release();// Codex retest 8 P1: the answer moved after this check started (a milk allergy added to "none"). The old
// quote and acknowledgement are void; a fresh check of the new answer needs fresh advice and a fresh tick.
_this.setState({allergenBusy:false,isSpinnerVisible:false,allergenQuote:null,allergenSeenText:null,allergenError:'Your allergy answer changed while we checked your order, so it wasn\'t placed. Please read the allergen information again.'});_this.refreshAllergenGate();return undefined;}if(check.confirmable){_this.setState({allergenBusy:false,allergenGate:null,allergenSeenText:null});var placing=_this.placeOrderNow(token);// Released only once the placement settles, so a second confirmation can't start another one meanwhile.
Promise.resolve(placing).then(release,release);return placing;}release();_this.setState({allergenBusy:false,allergenGate:check,isSpinnerVisible:false});return undefined;},function(error){release();if(_this.unmounted)return undefined;_this.setState({allergenBusy:false,isSpinnerVisible:false,allergenGate:_this.state.allergenGate||{applies:true,blockers:['CHECK_FAILED']},allergenError:error&&error.message||"We couldn't check the menu just now, so your order wasn't placed. Please try again."});return undefined;});};_this.gateToken=function(restaurantId){return{seq:_this.gateSeq||0,restaurantId:restaurantId,lines:basketKey(_this.props.productsOnCart),revision:Object(__WEBPACK_IMPORTED_MODULE_24__support_basketCheck__["e" /* getAllergyRevision */])(restaurantId)};};_this.gateRestaurantStill=function(token){var restaurant=_this.props.restaurantSelected;return!!token&&!!restaurant&&restaurant.id===token.restaurantId&&(_this.gateSeq||0)===token.seq;};_this.gateBroken=function(token){if(!token)return null;if(!_this.gateRestaurantStill(token))return"The restaurant changed while we checked your order, so it wasn't placed.";if(basketKey(_this.props.productsOnCart)!==token.lines)return'Your basket changed while we checked it. Please read the allergen information again.';if(Object(__WEBPACK_IMPORTED_MODULE_24__support_basketCheck__["e" /* getAllergyRevision */])(token.restaurantId)!==token.revision)return"Your allergy answer changed while we checked your order, so it wasn't placed. Please read the allergen information again.";return null;};_this.refuseStaleGate=function(reason){_this.setState({allergenBusy:false,isSpinnerVisible:false,sendingOrders:false,allergenQuote:null,allergenSeenText:null,allergenError:reason});_this.refreshAllergenGate();};_this.refreshAllergenGate=function(){var restaurant=_this.props.restaurantSelected;if(!restaurant)return;_this.setState({allergenBusy:true});Object(__WEBPACK_IMPORTED_MODULE_24__support_basketCheck__["h" /* runBasketCheck */])({restaurantId:restaurant.id,products:_this.props.productsOnCart}).then(function(check){if(!_this.unmounted)_this.setState({allergenBusy:false,allergenGate:check});},function(error){if(!_this.unmounted)_this.setState({allergenBusy:false,allergenError:error&&error.message||"We couldn't check the menu just now."});});};_this.onAllergenAnswer=function(answer){var restaurant=_this.props.restaurantSelected;if(!restaurant)return;_this.setState({allergenError:''});Object(__WEBPACK_IMPORTED_MODULE_24__support_basketCheck__["i" /* setAllergyAnswer */])(restaurant.id,answer);_this.refreshAllergenGate();};_this.onAllergenConfirm=function(){var check=_this.state.allergenGate;if(!check||!check.quoteHash)return;_this.setState({allergenQuote:check.quoteHash,allergenSeenText:check.advice&&check.advice.text},function(){return _this.onHandlePlaceOrder();});};_this.onAllergenClose=function(){_this.setState({allergenGate:null,allergenQuote:null,allergenError:'',isSpinnerVisible:false});};_this.placeOrderNow=function(gate){// An empty basket is never sent, whatever the payment choice.
if(_this.isBasketEmpty())return undefined;// On a pilot restaurant the allergen check must still hold for this restaurant, basket and answer (Codex r2).
var broken=_this.gateBroken(gate);if(broken){_this.refuseStaleGate(broken);return undefined;}if(_this.props.restaurantSelected&&!_this.props.restaurantSelected.isOpen){_this.props.triggerModalErrorPlacedOrder({code:__WEBPACK_IMPORTED_MODULE_21__utils_userError__["a" /* ERROR_CODES */].ORDER_CUTOFF_PASSED,title:"We couldn't place your order",message:_this.props.restaurantSelected.name+' has stopped taking orders for today.',guidance:'Choose another restaurant, or order for tomorrow.'});}else if(_this.props.restaurantSelected&&(_this.props.restaurantSelected.platter||_this.props.restaurantSelected.forCollection==='Y')&&!!!_this.state.timeForOrder){var what=_this.props.restaurantSelected.platter?'delivery':'collection';_this.props.triggerModalErrorPlacedOrder({code:__WEBPACK_IMPORTED_MODULE_21__utils_userError__["a" /* ERROR_CODES */].ORDER_TIME_MISSING,title:'Choose a '+what+' time',message:'This restaurant needs a '+what+' time for every order.',guidance:'Pick a '+what+' time in the basket, then place your order.'});}else if(_this.state.payOption==='onAccount'&&!!_this.props.business.valueLimit&&_this.largestOrderTotal()>_this.props.business.valueLimit){_this.props.triggerModalErrorPlacedOrder({code:__WEBPACK_IMPORTED_MODULE_21__utils_userError__["a" /* ERROR_CODES */].ORDER_MAX_EXCEEDED,title:"This order is over your company's limit",message:'Your company limits On account orders to '+_this.state.currencySimbol+_this.props.business.valueLimit.toFixed(2)+' per order.',guidance:'Remove some items, or pay for this order by card.'});}else if(_this.guestCheckoutRefusal()){_this.props.triggerModalErrorPlacedOrder({code:__WEBPACK_IMPORTED_MODULE_21__utils_userError__["a" /* ERROR_CODES */].ORDER_GUEST_NOT_ALLOWED,title:"We can't place this order yet",message:_this.guestCheckoutRefusal(),guidance:'Change the basket, then place your order.'});}else if(_this.props.restaurantSelected&&_this.getParties().length>1){return _this.placeOrdersForParties(gate);}else if(_this.props.restaurantSelected){// One person: the existing flow, so a new card still works. For a guest, the
// order carries their name and key.
var parties=_this.getParties();var order=_this.buildingOrder({guest:parties.length===1?parties[0].guest:null});var placing=void 0;if(_this.state.payType==='C'&&!_this.state.payWithAnotherCard){placing=_this.handlePlaceOrderAndPay(order);}else if(_this.state.payType==='C'&&!!_this.state.payWithAnotherCard||_this.state.payType==='I'||_this.state.payType==='B'){placing=_this.props.handlePlaceOrderAndGoToAddNewCard(order,_this.getPayInfo(),_this.props.history);}else{placing=_this.props.onPlaceOrder(order,_this.getPayInfo());}_this.trackPlacing(placing);return placing;}return undefined;};_this.voiceCheckoutRefusal=function(){var restaurant=_this.props.restaurantSelected;var business=_this.props.business;if(!restaurant||!_this.props.productsOnCart||!_this.props.productsOnCart.length)return'Your basket is empty.';if(!business||business.acceptOnAccount!=='Y'||_this.props.onlyCreditCard)return"Your company doesn't take On Account orders here. Open the basket to pay.";if(!restaurant.isOpen)return'Sorry, '+restaurant.name+' is closed now.';if(restaurant.platter||restaurant.forCollection==='Y')return'Open the basket to choose a time for this order.';if(_this.props.deliveryTomorrow)return"Open the basket to confirm tomorrow's delivery.";if(_this.getParties().length>1)return'Your basket has orders for guests. Open the basket to place them.';if(!!business.valueLimit&&_this.largestOrderTotal()>business.valueLimit)return'Your company limits orders to '+_this.state.currencySimbol+business.valueLimit.toFixed(2)+'. Open the basket to change it.';return null;};_this.voiceOrderSummary=function(){return{total:_this.getTotal(),currencySymbol:_this.state.currencySimbol,refusal:_this.voiceCheckoutRefusal(),restaurantId:_this.props.restaurantSelected&&_this.props.restaurantSelected.id,products:_this.props.productsOnCart||[]};};_this.voiceCheckout=function(){var _ref2=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{},quoteHash=_ref2.quoteHash,adviceText=_ref2.adviceText;var refusal=_this.voiceCheckoutRefusal();if(refusal)return Promise.resolve({placed:false,reason:refusal});return new Promise(function(resolve){_this.setState({payOption:'onAccount',payType:'A',payWithAnotherCard:false,allergenQuote:quoteHash||null,allergenSeenText:adviceText||null},function(){if(_this.state.payType!=='A'){resolve({placed:false,reason:'Open the basket to place your order.'});return;}var placing=_this.onHandlePlaceOrder();if(!placing){resolve({placed:false,reason:_this.state.allergenGate?'Something changed before your order was placed. Check the basket and confirm again.':'Your order was not placed. Open the basket to see why.'});return;}Promise.resolve(placing).then(function(data){return resolve(data&&data.id?{placed:true,orderId:data.id,publicOrderNumber:data.publicOrderNumber}:{placed:false,reason:_this.state.allergenGate?'Something changed before your order was placed. Check the basket and confirm again.':'Your order was not placed. Open the basket to try again.'});},function(){return resolve({placed:false,reason:'Your order was not placed. Open the basket to try again.'});});});});};_this.getAddressForOrder=function(){if(_this.props.restaurantSelected.forCollection==='Y'){return _this.props.addresses.find(function(item){return item.forCollection;}).idBusinessAddress;}else{return _this.props.addresses.find(function(item){return!item.forCollection;}).idBusinessAddress;}};_this.getCustomerAddressForOrder=function(){return _this.props.addresses.find(function(item){return!item.forCollection;}).idCustomerDeliveryAddress;};_this.guestCheckoutRefusal=function(){var parties=_this.getParties();var guests=parties.filter(function(party){return!!party.guest;}).map(function(party){return party.guest;});return Object(__WEBPACK_IMPORTED_MODULE_19__config_guestOrdering__["n" /* guestNamesRefusal */])(guests)||Object(__WEBPACK_IMPORTED_MODULE_19__config_guestOrdering__["g" /* checkoutRefusal */])({partyCount:parties.length,hasGuest:guests.length>0,payType:_this.state.payType,payWithAnotherCard:_this.state.payWithAnotherCard,policy:_this.props.guestPolicy});};_this.largestOrderTotal=function(){var parties=_this.getParties();if(parties.length<2)return _this.props.total;return Math.max.apply(null,parties.map(function(party){var value=_this.getPartyValue(party.guestId);return value?value.total:party.subtotal;}));};_this.placeOrdersForParties=function(gate){var parties=_this.getParties();var restaurant=_this.props.restaurantSelected;var withSubsidy=restaurant.forCollection==='N'&&_this.props.restaurantCurrentIsOpen;var taxDelivery=restaurant.taxDelivery&&_this.isDeliverAtHome()?restaurant.taxDelivery:0;var tipValue=_this.getTotalTip();var surcharge=_this.state.payType==='C'&&!!_this.props.campaignRateCC?_this.props.campaignRateCC.amount:0;_this.setState({sendingOrders:true});return Promise.resolve(_this.props.onCalculatePartySubsidies(restaurant.id,parties,taxDelivery,tipValue,withSubsidy)).then(function(values){// The subsidy answer can come back after the allergy answer, the basket or the restaurant changed: on a pilot
// restaurant nothing is sent unless the allergen check still holds right now (Codex r2 P1).
var broken=_this.unmounted?'gone':_this.gateBroken(gate);if(broken){if(!_this.unmounted)_this.refuseStaleGate(broken);return undefined;}var sends=parties.map(function(party,index){var value=(values||[]).find(function(item){return item.guestId===party.guestId;})||_this.getPartyValue(party.guestId)||{total:party.subtotal,discounts:_this.props.discounts};// The tip goes on the first order: yours, or the first guest's.
var tip=index===0?tipValue:0;return{guestId:party.guestId,name:party.guest?Object(__WEBPACK_IMPORTED_MODULE_19__config_guestOrdering__["k" /* guestDisplayName */])(party.guest):'you',order:_this.buildingOrder({products:party.products,totalAmount:value.total,tipValue:tip,guest:party.guest}),payInfo:Object.assign({},_this.getPayInfo(),{amount:value.total+surcharge,tipValue:tip,discounts:value.discounts})};});// Each guest order is checked again right before it is sent (Codex r3 P1): a change while an earlier order or
// payment waits stops the rest.
return _this.props.onPlacePartyOrders(sends,gate?{stillValid:function stillValid(){return _this.gateBroken(gate);}}:undefined);}).then(function(){return!_this.unmounted&&_this.setState({sendingOrders:false});},function(){return!_this.unmounted&&_this.setState({sendingOrders:false});});};_this.getOrderItems=function(){var products=arguments.length>0&&arguments[0]!==undefined?arguments[0]:_this.props.productsOnCart;return products.map(function(product){if(product.mealOptions){var mealOptions=product.mealOptions.map(function(mealOption){return{idProduct:mealOption.idProduct||mealOption.idMealOption,idCategoryType:mealOption.idCategoryType};});return{quantity:1,specialNotes:product.specialInstructions,product:{id:product.id},total:product.price,mealOptions:mealOptions};}else{return{quantity:1,product:{id:product.id},total:product.price};}});};_this.buildingOrder=function(){var _ref3=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{},_ref3$products=_ref3.products,products=_ref3$products===undefined?_this.props.productsOnCart:_ref3$products,_ref3$totalAmount=_ref3.totalAmount,totalAmount=_ref3$totalAmount===undefined?_this.props.total:_ref3$totalAmount,_ref3$tipValue=_ref3.tipValue,tipValue=_ref3$tipValue===undefined?_this.getTotalTip():_ref3$tipValue,_ref3$guest=_ref3.guest,guest=_ref3$guest===undefined?null:_ref3$guest;var orderItems=_this.getOrderItems(products);var specialNotes=_this.state.cutlery?_this.state.specialNotes+'. Please add cutlery':_this.state.specialNotes;var order=Object.assign({totalAmount:totalAmount,specialNotes:specialNotes,tipValue:tipValue,restaurant:{id:_this.props.restaurantSelected.id},orderItems:orderItems,businessDeliveryAddress:{id:_this.getAddressForOrder()},customerDeliveryAddress:{id:_this.getCustomerAddressForOrder()},payType:_this.state.payType,deliveryDateOnly:_this.props.deliveryTomorrow?_this.state.deliveryDateOnly:null},Object(__WEBPACK_IMPORTED_MODULE_19__config_guestOrdering__["l" /* guestFieldsForGuest */])(guest));var isDeliverAtHome=_this.getDeliverAddress()!=null?_this.getDeliverAddress().idCustomerDeliveryAddress!=null:false;if(_this.props.restaurantSelected.forCollection==='Y'||_this.props.restaurantSelected.platter||isDeliverAtHome){var deliveryDate=void 0;if(_this.state.timeForOrder==null){// 01:00 PM
deliveryDate=__WEBPACK_IMPORTED_MODULE_9_utils_time__["a" /* default */].getCurrentDate()+' '+__WEBPACK_IMPORTED_MODULE_9_utils_time__["a" /* default */].millisecondsToTime(46800);}else if(_this.state.timeForOrder._isAMomentObject){deliveryDate=_this.state.timeForOrder.format('DD/MM/YYYY HH:mm');}else{deliveryDate=__WEBPACK_IMPORTED_MODULE_9_utils_time__["a" /* default */].getCurrentDate()+' '+__WEBPACK_IMPORTED_MODULE_9_utils_time__["a" /* default */].millisecondsToTime(_this.state.timeForOrder);}order=Object.assign({},order,{deliveryDate:deliveryDate,deliverAtHome:isDeliverAtHome});}return order;};_this.isPayTypeEqualToCreditCard=function(){return _this.state.payType==='C';};_this.getAmountPayInfo=function(){var amount=_this.props.total;amount+=_this.state.payType==='C'&&!!_this.props.campaignRateCC?_this.props.campaignRateCC.amount:0;return amount;};_this.getPayInfo=function(){return{amount:_this.getAmountPayInfo(),currency:_this.state.currency,payType:_this.state.payType,paymentReference:__WEBPACK_IMPORTED_MODULE_10_utils_object__["a" /* default */].get(_this.state,'cardSelected.cardId',undefined),tipValue:_this.getTotalTip(),idBusinessRestaurant:__WEBPACK_IMPORTED_MODULE_10_utils_object__["a" /* default */].get(_this.props,'restaurantSelected.id',undefined),payObjectType:'O',discounts:_this.props.discounts};};_this.trackPlacing=function(placing){_this.orderRequestSettled=false;_this.setState({placingOrder:true});var done=function done(){_this.orderRequestSettled=true;if(!_this.unmounted&&!_this.props.isLoading)_this.setState({placingOrder:false});};Promise.resolve(placing).then(done,done);};_this.handlePlaceOrderAndPay=function(order){return _this.props.onPlaceOrderAndPay(order,_this.getPayInfo());};_this.handleTimeForOrder=function(date){_this.setState({timeForOrder:date});};_this.getTaxDelivery=function(){return!!_this.props.restaurantSelected&&_this.props.restaurantSelected.taxDelivery&&_this.isDeliverAtHome()?_this.props.restaurantSelected.taxDelivery.toFixed(2):Number(0).toFixed(2);};_this.getStyleInputTipCustom=function(){var number=_this.state.totalTip;return number>20?'tip-custom-amount-input-container':'tip-custom-amount-input-container-hidden';};_this.getStyleButtonTipCustom=function(){var number=_this.state.totalTip;return number>20?'tip-custom-selected':'tip-custom';};_this.getStyleButtonTip=function(button){var number=_this.state.totalTip;return number===button?'tip-percent-selected':'tip-percent';};_this.onClickTip=function(event){switch(event.target.value){case'0':if(_this.state.totalTip===0){_this.setState({totalTip:0});}else{_this.setState({totalTip:0});}break;case'5':if(_this.state.totalTip===5){_this.setState({totalTip:0});}else{_this.setState({totalTip:5});}break;case'10':if(_this.state.totalTip===10){_this.setState({totalTip:0});}else{_this.setState({totalTip:10});}break;case'20':if(_this.state.totalTip===20){_this.setState({totalTip:0});}else{_this.setState({totalTip:20});}break;default:if(_this.state.totalTip===21){_this.setState({totalTip:0});}else{_this.setState({totalTip:21});}break;}};_this.onChangeInputTip=function(event){_this.setState({tipCustom:_this.formatNumber(event.target.value)});};_this.verfifyNumber=function(number){var numberFormated=number;if(number.length>5){numberFormated=number.replace('.','');numberFormated=_this.formatNumber(numberFormated);}else{return Number(number);}return numberFormated;};_this.getTotalTip=function(){var tipValue=_this.state.totalTip<21?Number.parseFloat((_this.props.subtotal*_this.state.totalTip/100).toPrecision(2)):_this.state.tipCustom===0?Number(_this.state.tipCustom):Number(_this.verfifyNumber(_this.state.tipCustom));return tipValue;};_this.getTotal=function(){return _this.getTotalTip()+_this.props.total;};_this.getMaxBasketCost=function(){if(!!_this.props.maxBasketCost){return'(for '+_this.state.currencySimbol+' '+_this.props.maxBasketCost.toFixed(2)+' max)';}return'';};_this.getDeliverAddress=function(){return _this.props.addresses[0];};_this.showOptionsForOrder=function(){_this.setState({openModalClearBasket:true});};_this.showCollectionOption=function(){return!_this.props.addresses.find(function(address){return address.forCollection;})&&_this.props.showCollectionOption;};_this.toggleCart=function(){_this.props.onToggleCart();};_this.handleSelectOptionForOrder=function(address){_this.props.onSelectAddressForOrder([address]);_this.setState({selectAddress:false});_this.props.restaurantSelected&&_this.props.onCalculateSubsidy(_this.props.restaurantSelected.id,0,_this.props.restaurantSelected.taxDelivery&&_this.isDeliverAtHome()?_this.props.restaurantSelected.taxDelivery:0,_this.getTotalTip());};_this.closeModalErrorAndClearLocalStorageRestaurantCurrentIsOpen=function(){_this.props.onCartSetRestaurantOpen(true);_this.props.onDeleteAllproductsFromCard();window.location.reload();};_this.handleCreateCustomerDeliveryAddress=function(){var _ref4=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(place){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return _this.props.onCreateCustomerDeliveryAddress(place);case 2:_this.setState({selectAddress:false});_this.props.onCalculateSubsidy(_this.props.restaurantSelected.id,0,_this.props.restaurantSelected.taxDelivery&&_this.isDeliverAtHome()?_this.props.restaurantSelected.taxDelivery:0,_this.getTotalTip());case 4:case'end':return _context.stop();}}},_callee,_this2);}));return function(_x4){return _ref4.apply(this,arguments);};}();_this.isDeliverAtHome=function(){return _this.getDeliverAddress()!=null?_this.getDeliverAddress().idCustomerDeliveryAddress!=null:false;};_this.handleCalculateValuesCart=function(){var partiesChanged=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;var tipValue=_this.getTotalTip();var subtotal=_this.props.productsOnCart.reduce(function(a,product){return a+product.price;},0);var parties=_this.getParties();// Several people: the subsidy is worked out per order.
if(parties.length>1){if(!!_this.props.campaignRateCollection&&_this.props.restaurantSelected){_this.props.onCalculatePartySubsidies(_this.props.restaurantSelected.id,parties,_this.props.restaurantSelected.taxDelivery&&_this.isDeliverAtHome()?_this.props.restaurantSelected.taxDelivery:0,tipValue,_this.props.restaurantSelected.forCollection==='N'&&_this.props.restaurantCurrentIsOpen);}return;}if((_this.props.partyValues||[]).length>0){_this.props.onClearPartyValues();}if(!!_this.props.campaignRateCollection&&(_this.props.subtotal!==subtotal||partiesChanged)||!!_this.props.campaignRateCollection&&_this.props.tipValue!==_this.getTotalTip()){if(_this.props.restaurantSelected.forCollection==='N'&&_this.props.restaurantCurrentIsOpen){_this.props.onCalculateSubsidy(_this.props.restaurantSelected.id,subtotal,_this.props.restaurantSelected.taxDelivery&&_this.isDeliverAtHome()?_this.props.restaurantSelected.taxDelivery:0,tipValue);}else{_this.props.onAppliedCartValues(subtotal,0,subtotal,0,_this.props.discounts,tipValue);}}};_this.isWithVoucherOrNotAcceptTip=function(){var isVoucher=_this.props.total===0&&_this.props.subsidy>0&&!_this.props.onlyCreditCard;var acceptTip=_this.props.restaurantSelected!==null&&!_this.props.restaurantSelected.acceptTip;return isVoucher||acceptTip;};_this.renderItem=function(product,index){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('li',{key:index,className:'item'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{onClick:function onClick(){return _this.handleDecreaseProduct(product);},className:'remove-item','aria-label':'Remove '+product.name,'aria-describedby':'product-desc-'+index}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'flex-center',tabIndex:0},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{onClick:function onClick(){return _this.handleIncreaseQuantityProduct(product);},className:'btn-add-product','aria-label':'Increase quantity'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h3',{tabIndex:0},product.name,' ',_this.state.currencySimbol+product.price.toFixed(2))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{tabIndex:0,className:'product-cart-description',id:'product-desc-'+index},product.description));};_this.isBasketEmpty=function(){return!_this.props.productsOnCart||_this.props.productsOnCart.length===0;};_this.backToRestaurants=function(){_this.props.onToggleCart(false);if(_this.props.onToggleRestaurants)_this.props.onToggleRestaurants(true);};_this.renderEmptyBasket=function(){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_hoc_ReactAux_ReactAux__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h2',{tabIndex:0},'Your basket is empty'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'items basket-empty',role:'status'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{tabIndex:0},'Add something from a restaurant\'s menu to place an order.'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{type:'button',className:'btn orange-bold',onClick:_this.backToRestaurants},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('b',null,'Choose a restaurant'))));};_this.renderBasketItems=function(){var parties=_this.getParties();var products=_this.props.productsOnCart;if(!parties.some(function(party){return!!party.guest;})){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('ul',{className:'items'},products.map(function(product,index){return _this.renderItem(product,index);}));}return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('ul',{className:'items'},parties.map(function(party,partyIndex){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('li',{key:party.guestId||'you',className:'basket-party'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'basket-party-header'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h3',{tabIndex:0},Object(__WEBPACK_IMPORTED_MODULE_19__config_guestOrdering__["q" /* partyHeaderName */])(party),party.guest?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'basket-party-guest-tag'},'Guest'):null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'basket-party-total',tabIndex:0},_this.state.currencySimbol+_this.getPartyTotal(party,partyIndex).toFixed(2))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('ul',null,party.products.map(function(product){return _this.renderItem(product,products.indexOf(product));})));}));};_this.state={cutlery:false,timeForOrder:null,payOption:'',cardSelected:'',payType:null,payWithAnotherCard:false,currencySimbol:'€',currency:'EUR',specialNotes:'',discounts:{},showDeliveryTomorrowConfirmationModal:false,deliveryDateOnly:null,selectAddress:false,openModalClearBasket:false,totalTip:0,tipCustom:0,tipValue:0,sendingOrders:false,placingOrder:false};return _this;}_createClass(CartProduct,[{key:'componentDidMount',value:function componentDidMount(){this.unregisterVoiceCheckout=Object(__WEBPACK_IMPORTED_MODULE_22__support_voiceOrder__["g" /* registerVoiceOrderHandler */])('checkout',this.voiceCheckout);this.unregisterVoiceSummary=Object(__WEBPACK_IMPORTED_MODULE_22__support_voiceOrder__["g" /* registerVoiceOrderHandler */])('summary',this.voiceOrderSummary);if(this.props.checkout)this.showBasketSupportContext();this.props.onFetchGuestPolicy();}},{key:'componentWillUnmount',value:function componentWillUnmount(){this.unmounted=true;if(this.unregisterVoiceCheckout)this.unregisterVoiceCheckout();if(this.unregisterVoiceSummary)this.unregisterVoiceSummary();if(this.restoreSupportContext)this.restoreSupportContext();}// The basket is always mounted; it is the support context only while it is open.
},{key:'showBasketSupportContext',value:function showBasketSupportContext(){if(this.restoreSupportContext)this.restoreSupportContext();this.restoreSupportContext=Object(__WEBPACK_IMPORTED_MODULE_20__support_context__["b" /* overlaySupportContext */])('checkout.cart',{restaurantId:this.props.restaurantSelected&&this.props.restaurantSelected.id});}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){var restaurantId=function restaurantId(r){return r?r.id:null;};if(restaurantId(prevProps.restaurantSelected)!==restaurantId(this.props.restaurantSelected)){// Any allergen check still out was for the other restaurant: it can never authorise this one.
this.gateSeq=(this.gateSeq||0)+1;if(this.state.allergenQuote||this.state.allergenGate)this.setState({allergenQuote:null,allergenSeenText:null,allergenGate:null});}if(prevProps.total!==this.props.total||prevProps.productsOnCart!==this.props.productsOnCart||prevProps.business!==this.props.business)Object(__WEBPACK_IMPORTED_MODULE_22__support_voiceOrder__["d" /* notifyVoiceOrder */])();// A card payment runs after the order request settles; keep the overlay until it ends.
if(this.state.placingOrder&&this.orderRequestSettled&&!this.props.isLoading){this.setState({placingOrder:false});}// The guest policy is re-read whenever the basket opens.
if(this.props.checkout&&!prevProps.checkout){this.props.onFetchGuestPolicy();this.showBasketSupportContext();}if(!this.props.checkout&&prevProps.checkout&&this.restoreSupportContext){this.restoreSupportContext();this.restoreSupportContext=null;}this.handleCampaignRate(prevProps);var partiesChanged=partySignature(Object(__WEBPACK_IMPORTED_MODULE_19__config_guestOrdering__["u" /* splitBasket */])(prevProps.productsOnCart,prevProps.guests))!==partySignature(this.getParties());if(prevProps.productsOnCart.length!==this.props.productsOnCart.length||this.props.campaignRateCollection!==prevProps.campaignRateCollection||partiesChanged)this.handleCalculateValuesCart(partiesChanged);if(this.props.restaurantSelected&&JSON.stringify(this.props.restaurantSelected)!==JSON.stringify(prevProps.restaurantSelected)){var currency=this.props.restaurantSelected.currency;var currencySimbol=__WEBPACK_IMPORTED_MODULE_8_utils_currency__["a" /* default */].convertNameToSymbol(currency);localStorage.setItem('currency',currency);this.setState({specialNotes:'',timeForOrder:null,cardSelected:null,payType:null,currency:currency,currencySimbol:currencySimbol,isSpinnerVisible:false});}}// The basket's + adds another of the same item for the same person, without asking.
// One group per person: you first (when you have items), then guests in the order added.
// calculate-discount's answer for one person's order, once it has arrived.
// The header total for one person: their order total, plus the tip on the first order.
// On a pilot restaurant every Place Order passes the allergen gate: the server checks the live menu and the
// basket, and the order goes only when that check is confirmable for the quote the customer confirmed. Anything
// else (a change, an unanswered question, a dish that needs the restaurant) opens the gate instead. A failed
// check never falls back to the basket as it was.
// What a final allergen check was for: restaurant, basket lines and allergy-answer revision, plus a sequence that
// a restaurant change bumps so no outstanding check can authorise another restaurant.
// null while the check still holds; otherwise the reason nothing may be placed.
// A placement path found the check no longer holds: nothing is sent, the gate is checked again.
// The gate's own check after an answer, without placing anything.
// "I have read this. Confirm order": the customer confirms this exact quote; the server checks it once more.
// Voice ordering: why this basket can't be placed On Account from the composer, or null. Anything that
// needs a choice on the basket (a time, tomorrow, guests, the company's limit) is done there instead.
// Voice ordering's MEDIUM-risk action, run only after the customer taps "Place order On Account" in the
// composer: On Account, then exactly the basket's own Place Order. Never a card.
// On a pilot restaurant the composer passes the quote the customer confirmed (and heard), which the gate checks
// once more on the server before the order is placed.
// Checked before anything is sent: every guest's name, then the payment rules.
// The per-order value limit applies to each person's order.
// Several people: one order each, sent one after another (you first, then guests
// in the order they were added). The subsidy is asked for again per order first.
// The order for the whole basket, or for one person's items. The guest id stays
// here: only the guest's name and request key go to the server.
// "Placing your order" shows only while an order request is in flight, not for any
// other request (e.g. the lunch feedback card), which also sets the global loading flag.
},{key:'formatNumber',value:function formatNumber(n){return n.replace(/\D/g,'').replace(/(\d)(\d{2})$/,'$1.$2');}// Nothing to order: no totals, payment choice or Place Order, just a way back to the restaurants.
// Only your items: the basket looks exactly as before. With a guest: grouped by
// person ("You", then each guest with a "Guest" tag), each with their order total.
},{key:'render',value:function render(){var _this3=this;var orderCount=Math.max(1,this.getParties().length);var empty=this.isBasketEmpty();return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_hoc_ReactAux_ReactAux__["a" /* default */],{tabIndex:0},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{title:'Close (Esc)',type:'button',className:'btn-close',onClick:function onClick(){return _this3.toggleCart();},'aria-label':'Close cart'}),empty?this.renderEmptyBasket():__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_hoc_ReactAux_ReactAux__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h2',null,'Your Cart includes '),this.renderBasketItems(),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'items',hidden:this.isWithVoucherOrNotAcceptTip()},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'tip-title',tabIndex:0},'Tip the Driver (optional)'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'tip'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{value:'5',className:this.getStyleButtonTip(5),onClick:this.onClickTip},'5 %'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{value:'10',className:this.getStyleButtonTip(10),onClick:this.onClickTip},'10 %'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{value:'20',className:this.getStyleButtonTip(20),onClick:this.onClickTip},'20 %')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{value:'6',className:this.getStyleButtonTipCustom(),onClick:this.onClickTip},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('b',null,'Enter Custom Amount')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:this.getStyleInputTipCustom()},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{className:'tip-custom-amount-input',placeholder:' 0.00 ',value:this.state.tipCustom===0?undefined:this.state.tipCustom,onChange:this.onChangeInputTip,'data-type':'currency'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'sufix-tip-custom'},this.state.currencySimbol+' '),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('svg',{className:'icon-tip-custom','aria-hidden':'true',focusable:'false',width:'18',height:'18',viewBox:'0 0 18 18',fill:'none',xmlns:'http://www.w3.org/2000/svg'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('circle',{cx:'9',cy:'9',r:'9',style:{fill:"var(--lt-color-primary)"}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M6 10.2594L8.25 11.8359L12 7.50035',stroke:'white',strokeLinecap:'round',strokeLinejoin:'round'}))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'total-items'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'sub-total'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'left'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{tabIndex:0},'Sub Total')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'right'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{tabIndex:0},this.state.currencySimbol+this.props.subtotal.toFixed(2)))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'sub-total',hidden:this.isWithVoucherOrNotAcceptTip()},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'left'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{tabIndex:0},'Tip')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'right'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{tabIndex:0},this.state.currencySimbol+this.getTotalTip().toFixed(2)))),this.props.restaurantSelected&&this.props.restaurantSelected.forCollection==='N'&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'subsidy'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'left'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{tabIndex:0},'Subsidy ',this.getMaxBasketCost())),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'right'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{tabIndex:0},this.state.currencySimbol+this.props.subsidy))),this.props.restaurantSelected&&this.props.restaurantSelected.forCollection==='N'&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'subsidy'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'left'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{tabIndex:0},'Delivery Fee')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'right'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{tabIndex:0},this.state.currencySimbol+(this.getTaxDelivery()*orderCount).toFixed(2),' '))),!!this.props.campaignRateCollection&&this.props.restaurantSelected&&this.props.restaurantSelected.forCollection==='Y'&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'collection-discount'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'left'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{tabIndex:0},'Collection discount')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'right'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{tabIndex:0},this.props.campaignRateCollection.discountType==='P'?'% ':'- ',this.props.campaignRateCollection.amount))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'total'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'left'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{tabIndex:0},'Total')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'right',tabIndex:0},Object(__WEBPACK_IMPORTED_MODULE_19__config_guestOrdering__["f" /* cartTotalText */])(this.getTotal(),orderCount,this.state.currencySimbol)))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'items'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'checked-cutlery'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{onChange:function onChange(evt){return _this3.onHandleAddCutlery(evt);},type:'checkbox',id:'cutlery1',name:'cutlery'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{htmlFor:'cutlery1'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('b',null,'Add Cutlery (Free)')))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'special-notes',tabIndex:0},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'left'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{tabIndex:0},'Special notes')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('textarea',{value:this.state.specialNotes,onChange:this.handleSpecialNotes}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{tabIndex:0},'Deliver @',' ',this.getDeliverAddress()!=null?this.getDeliverAddress().street:null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{tabIndex:0},'or',' ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onClick:function onClick(e){return _this3.showOptionsForOrder();}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('u',null,'change here')))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__DatePickerOrder__["a" /* default */],{restaurantSelected:this.props.restaurantSelected,handleTimeForOrder:this.handleTimeForOrder,timeForOrder:this.state.timeForOrder,deliveryTomorrow:this.props.deliveryTomorrow,onDeliveryTomorrow:this.onDeliveryTomorrow,ordersAhead:this.props.business&&this.props.business.ordersAhead,isDeliverAtHome:this.isDeliverAtHome()})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__DefaultMenu_OptionsForOrder__["a" /* default */],{onFetchingMenu:this.props.onFetchingMenu,idBusiness:this.props.userDetails.idBusiness,listAddress:this.props.listAddress,showModal:this.state.selectAddress,showCollectionOption:this.showCollectionOption(),showDeliverAtHomeOption:this.props.showDeliverAtHomeOption,selectOptionForOrder:this.handleSelectOptionForOrder,onToggleCart:this.props.onToggleCart,onDeleteAllproductsFromCard:this.props.onDeleteAllproductsFromCard,createCustomerDeliveryAddress:this.handleCreateCustomerDeliveryAddress,onCartResetState:this.props.onCartResetState,onDeleteRestaurantSelected:this.props.onDeleteRestaurantSelected,onFetchingRecentlyOrdered:this.props.onFetchingRecentlyOrdered}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_components_UI_Modal_ModalError__["a" /* default */],{style:{zIndex:'99999',position:'absolute',margin:'5% 26%'},showModal:!this.props.restaurantCurrentIsOpen,errorMessage:RESTAURANT_GONE_ERROR,actionButtonTitle:'Reload the menu',actionButton:this.closeModalErrorAndClearLocalStorageRestaurantCurrentIsOpen}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_components_UI_Modal_ModalCartMessage__["a" /* default */],{clickButtonConfirm:this.handleConfirmOkCartModal,clickButtonDeny:this.handleDenyCartModal,message:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('strong',null,'Note!',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),'Clear current basket to change address?'),showModal:this.state.openModalClearBasket}),empty?null:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_hoc_ReactAux_ReactAux__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__PaymentOptions__["a" /* default */],{payTypeSelected:this.state.payType,cardSelected:this.state.cardSelected,selectPaymentMethod:this.onHandleSelectPaymentMethod,total:this.props.total,subsidy:this.props.subsidy,business:this.props.business,cards:this.props.cards}),this.state.placingOrder||this.state.sendingOrders?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__components_UI_Spinner_Spinner__["a" /* default */],{nameClass:'lds-third',label:'Placing your order\u2026'}):this.props.isLoading?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__components_UI_Spinner_Spinner__["a" /* default */],{nameClass:'lds-secondary'}):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__PaymentButton__["a" /* default */],{payTypeSelected:this.state.payType,campaignRateCC:this.props.campaignRateCC,handlePlaceOrder:this.handleDeliveryTomorrow,total:this.props.total})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__support_AllergenGate__["a" /* default */],{check:this.state.allergenGate,busy:this.state.allergenBusy,error:this.state.allergenError,onAnswer:this.onAllergenAnswer,onConfirm:this.onAllergenConfirm,onClose:this.onAllergenClose}),this.state.showDeliveryTomorrowConfirmationModal?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_components_UI_Modal_ModalConfirm__["a" /* default */],{title:'Confirm delivery for tomorrow',onClose:this.handleDeliveryTomorrowCancel,onConfirm:this.handleDeliveryTomorrowConfirm},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h2',{style:{textTransform:'none',fontSize:'20px'}},'Are you sure that you want your order delivery for tomorrow?'))):null);}}]);return CartProduct;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{subtotal:state.cartReducer.cart.subtotal,subsidy:state.cartReducer.cart.subsidy,tipValue:state.cartReducer.cart.tipValue,total:state.cartReducer.cart.total,isLoading:state.loadingReducer.loading,maxBasketCost:state.cartReducer.cart.maxBasketCost,productsOnCart:state.cartReducer.cart.products,productSelected:state.cartReducer.cart.productSelected,cards:state.cartReducer.cart.cards,restaurantCurrentIsOpen:state.cartReducer.cart.restaurantCurrentIsOpen,restaurantSelected:state.cartReducer.cart.restaurantSelected,business:state.businessReducer.business,addresses:state.menuReducer.addresses,listAddress:state.menuReducer.listAddress,showDeliverAtHomeOption:state.menuReducer.acceptDeliverAtHome,campaignRateCC:state.cartReducer.cart.campaignRateCC,campaignRateCollection:state.cartReducer.cart.campaignRateCollection,discounts:state.cartReducer.cart.discounts,deliveryTomorrow:state.cartReducer.cart.deliveryTomorrow,userDetails:state.authenticationReducer.userDetails,checkout:state.cartReducer.cart.checkout,guests:state.cartReducer.cart.guests||[],guestPolicy:state.cartReducer.cart.guestPolicy,partyValues:state.cartReducer.cart.partyValues};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{// A problem found before anything is sent: {code, title, message, guidance}.
triggerModalErrorPlacedOrder:function triggerModalErrorPlacedOrder(problem){return dispatch(__WEBPACK_IMPORTED_MODULE_11_actions_index__["_39" /* triggerModalErrorPlacedOrder */](problem.message,{preSubmitValidation:true,title:problem.title,guidance:problem.guidance,referenceCode:problem.code}));},onDeleteProductFromCart:function onDeleteProductFromCart(product){return dispatch(__WEBPACK_IMPORTED_MODULE_11_actions_index__["I" /* deleteProductFromCart */](product));},onAddProductToCartNow:function onAddProductToCartNow(product){return dispatch(__WEBPACK_IMPORTED_MODULE_11_actions_index__["b" /* addProductToCartNow */](product));},onFetchGuestPolicy:function onFetchGuestPolicy(){return dispatch(__WEBPACK_IMPORTED_MODULE_11_actions_index__["L" /* fetchGuestPolicy */]());},onCalculatePartySubsidies:function onCalculatePartySubsidies(idRestaurant,parties,taxDelivery,tipValue,withSubsidy){return dispatch(__WEBPACK_IMPORTED_MODULE_11_actions_index__["d" /* calculatePartySubsidies */](idRestaurant,parties,taxDelivery,tipValue,withSubsidy));},onClearPartyValues:function onClearPartyValues(){return dispatch(__WEBPACK_IMPORTED_MODULE_11_actions_index__["o" /* clearPartyValues */]());},onPlacePartyOrders:function onPlacePartyOrders(sends,options){return dispatch(__WEBPACK_IMPORTED_MODULE_11_actions_index__["_14" /* placePartyOrders */](sends,options));},onCalculateSubsidy:function onCalculateSubsidy(idRestaurant,subTotal,taxDelivery,tipValue){return dispatch(__WEBPACK_IMPORTED_MODULE_11_actions_index__["e" /* calculateSubsidy */](idRestaurant,subTotal,taxDelivery,tipValue));},onAppliedCartValues:function onAppliedCartValues(subTotal,subsidy,total,maxBasketCost,discounts,tipValue){return dispatch(__WEBPACK_IMPORTED_MODULE_11_actions_index__["c" /* appliedCartValues */](subTotal,subsidy,total,maxBasketCost,discounts,tipValue));},onFetchingMenu:function onFetchingMenu(idBusiness,idAddress){return dispatch(__WEBPACK_IMPORTED_MODULE_11_actions_index__["V" /* fetchingMenu */](idBusiness,idAddress));},onSelectForColectionOption:function onSelectForColectionOption(){return dispatch(__WEBPACK_IMPORTED_MODULE_11_actions_index__["m" /* changeRestaurantOptions */](2));},onFetchingCampaignRate:function onFetchingCampaignRate(idBusiness){return dispatch(__WEBPACK_IMPORTED_MODULE_11_actions_index__["P" /* fetchingCampaignRate */](idBusiness));},onPlaceOrder:function onPlaceOrder(order,payInfo){return dispatch(__WEBPACK_IMPORTED_MODULE_11_actions_index__["_11" /* placeOrder */](order,payInfo));},onPlaceOrderAndPay:function onPlaceOrderAndPay(order,payInfo){return dispatch(__WEBPACK_IMPORTED_MODULE_11_actions_index__["_13" /* placeOrderAndPay */](order,payInfo));},handlePlaceOrderAndGoToAddNewCard:function handlePlaceOrderAndGoToAddNewCard(order,payInfo,history){return dispatch(__WEBPACK_IMPORTED_MODULE_11_actions_index__["_12" /* placeOrderAndGoToAddNewCard */](order,payInfo,history));},onToggleCart:function onToggleCart(status){return dispatch(__WEBPACK_IMPORTED_MODULE_11_actions_index__["_34" /* toggleCart */](status));},onToggleRestaurants:function onToggleRestaurants(status){return dispatch(__WEBPACK_IMPORTED_MODULE_11_actions_index__["_38" /* toggleRestaurants */](status));},changeDeliveryTomorrow:function changeDeliveryTomorrow(payload){return dispatch(__WEBPACK_IMPORTED_MODULE_11_actions_index__["k" /* changeDeliveryTomorrow */](payload));},onSelectAddressForOrder:function onSelectAddressForOrder(address){return dispatch(__WEBPACK_IMPORTED_MODULE_11_actions_index__["_22" /* selectAddressForOrder */](address));},onCreateCustomerDeliveryAddress:function onCreateCustomerDeliveryAddress(place){return dispatch(__WEBPACK_IMPORTED_MODULE_11_actions_index__["F" /* createCustomerDeliveryAddress */](place));},onDeleteAllproductsFromCard:function onDeleteAllproductsFromCard(){return dispatch(__WEBPACK_IMPORTED_MODULE_11_actions_index__["G" /* deleteAllProductsFromCart */]());},onCartResetState:function onCartResetState(){return dispatch(__WEBPACK_IMPORTED_MODULE_11_actions_index__["g" /* cartResetState */]());},onDeleteRestaurantSelected:function onDeleteRestaurantSelected(){return dispatch(__WEBPACK_IMPORTED_MODULE_11_actions_index__["J" /* deleteRestaurantSelected */]());},onFetchingRecentlyOrdered:function onFetchingRecentlyOrdered(idAddress){return dispatch(__WEBPACK_IMPORTED_MODULE_11_actions_index__["Y" /* fetchingRecentlyOrdered */](idAddress));},onCartSetRestaurantOpen:function onCartSetRestaurantOpen(restaurantCurrentIsOpen){return dispatch(__WEBPACK_IMPORTED_MODULE_11_actions_index__["h" /* cartSetRestaurantOpen */](restaurantCurrentIsOpen));},closeModalError:function closeModalError(history){return dispatch(__WEBPACK_IMPORTED_MODULE_11_actions_index__["u" /* closeModalError */](history));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["g" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(CartProduct)));

/***/ }),
/* 682 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_bootstrap_time_picker__ = __webpack_require__(683);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_bootstrap_time_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap_time_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_datepicker__ = __webpack_require__(724);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_hoc_ReactAux_ReactAux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_utils_time__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_datepicker_dist_react_datepicker_css__ = __webpack_require__(748);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_datepicker_dist_react_datepicker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_datepicker_dist_react_datepicker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__DatePickerOrder_scss__ = __webpack_require__(749);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__DatePickerOrder_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__DatePickerOrder_scss__);
var DatePickerOrder=function DatePickerOrder(props){var datePickerComponent=null;if(props.restaurantSelected&&props.restaurantSelected.platter){datePickerComponent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_hoc_ReactAux_ReactAux__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Select Delivery Time'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_datepicker__["a" /* default */],{selected:props.timeForOrder,onChange:props.handleTimeForOrder,dateFormat:'DD/MM/YYYY HH:mm',minDate:__WEBPACK_IMPORTED_MODULE_4_moment___default()(),showTimeSelect:true,timeFormat:'HH:mm',timeCaption:'time',timeIntervals:10}));}else if(props.restaurantSelected&&props.restaurantSelected.forCollection==='Y'){datePickerComponent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'collection-time'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Select Collection Time'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap_time_picker___default.a,{'default':'00:00',start:__WEBPACK_IMPORTED_MODULE_5_utils_time__["a" /* default */].getCurrentHourMinutePlusMinutes(20),end:props.restaurantSelected.openingHour.closeHour,onChange:props.handleTimeForOrder,value:props.timeForOrder,step:10}));}else if(props.restaurantSelected&&props.isDeliverAtHome){datePickerComponent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'collection-time'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Delivery between 12:00 pm to 1:00 pm'));}else if(props.restaurantSelected&&props.ordersAhead){datePickerComponent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'checked-cutlery'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{checked:props.deliveryTomorrow,onChange:props.onDeliveryTomorrow,type:'checkbox',id:'deliveryTomorrow',name:'deliveryTomorrow'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'deliveryTomorrow'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Delivery Tomorrow')));}return datePickerComponent;};/* harmony default export */ __webpack_exports__["a"] = (DatePickerOrder);

/***/ }),
/* 683 */
/***/ (function(module, exports, __webpack_require__) {

module.exports=function(e){function t(n){if(r[n])return r[n].exports;var a=r[n]={exports:{},id:n,loaded:!1};return e[n].call(a.exports,a,a.exports,t),a.loaded=!0,a.exports}var r={};return t.m=e,t.c=r,t.p="",t(0)}([function(e,t,r){e.exports=r(2)},function(e,t,r){"use strict";function n(e){return e&&e.__esModule?e:{default:e}}function a(e,t){var r={};for(var n in e)t.indexOf(n)>=0||Object.prototype.hasOwnProperty.call(e,n)&&(r[n]=e[n]);return r}function o(e){function t(e){var t=(0,p.timeFromInt)(e,!1);if(24===c)return t;var r=t.match(/^(\d+):/),n=parseInt(r[1],10);if(0===n)return t.replace(/^\d+/,"12")+" AM";if(n<12)return t+" AM";if(12===n)return t+" PM";var a=n<22?"0"+(n-12):(n-12).toString();return t.replace(/^\d+/,a)+" PM"}function r(){for(var e=[],t=(0,p.timeToInt)(i,!1),r=(0,p.timeToInt)(g,!1);r<=t;r+=60*b)e.push(r);return e}function n(){return r().map(function(e){var r=t(e);return{key:e,val:r}})}var o=e.end,i=void 0===o?"23:59":o,f=e.format,c=void 0===f?12:f,d=e.initialValue,v=void 0===d?"00:00":d,m=e.onChange,y=void 0===m?function(){}:m,x=e.start,g=void 0===x?"00:00":x,h=e.step,b=void 0===h?30:h,I=e.value,M=void 0===I?null:I,O=a(e,["end","format","initialValue","onChange","start","step","value"]),_=n(),C=_.map(function(e){var t=e.key,r=e.val;return l.default.createElement("option",{key:t,value:t},r)}),P=M||v;try{P=(0,p.timeToInt)(P)}catch(e){P=parseInt(P,10)}return _.filter(function(e){var t=e.key;return P===t}).length||(P=(0,p.timeToInt)(g)),l.default.createElement(s.default,u({componentClass:"select",onChange:function(e){y(parseInt(e.target.value,10))},value:P},O),C)}Object.defineProperty(t,"__esModule",{value:!0});var u=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var r=arguments[t];for(var n in r)Object.prototype.hasOwnProperty.call(r,n)&&(e[n]=r[n])}return e},i=r(4),l=n(i),f=r(3),c=n(f),d=r(5),s=n(d),p=r(6),v={end:c.default.string,format:c.default.number,initialValue:c.default.any,onChange:c.default.func,start:c.default.string,step:c.default.number,value:c.default.any};o.propTypes=v,t.default=o},function(e,t,r){"use strict";function n(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var a=r(1),o=n(a);t.default=o.default},function(e,t){e.exports=__webpack_require__(7)},function(e,t){e.exports=__webpack_require__(0)},function(e,t){e.exports=__webpack_require__(684)},function(e,t){e.exports=__webpack_require__(723)}]);

/***/ }),
/* 684 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(91);

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(92));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(125));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(126));

var _classnames = _interopRequireDefault(__webpack_require__(49));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(7));

var _elementType = _interopRequireDefault(__webpack_require__(300));

var _warning = _interopRequireDefault(__webpack_require__(715));

var _FormControlFeedback = _interopRequireDefault(__webpack_require__(716));

var _FormControlStatic = _interopRequireDefault(__webpack_require__(722));

var _bootstrapUtils = __webpack_require__(127);

var _StyleConfig = __webpack_require__(301);

var propTypes = {
  componentClass: _elementType.default,

  /**
   * Only relevant if `componentClass` is `'input'`.
   */
  type: _propTypes.default.string,

  /**
   * Uses `controlId` from `<FormGroup>` if not explicitly specified.
   */
  id: _propTypes.default.string,

  /**
   * Attaches a ref to the `<input>` element. Only functions can be used here.
   *
   * ```js
   * <FormControl inputRef={ref => { this.input = ref; }} />
   * ```
   */
  inputRef: _propTypes.default.func
};
var defaultProps = {
  componentClass: 'input'
};
var contextTypes = {
  $bs_formGroup: _propTypes.default.object
};

var FormControl =
/*#__PURE__*/
function (_React$Component) {
  (0, _inheritsLoose2.default)(FormControl, _React$Component);

  function FormControl() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = FormControl.prototype;

  _proto.render = function render() {
    var formGroup = this.context.$bs_formGroup;
    var controlId = formGroup && formGroup.controlId;
    var _this$props = this.props,
        Component = _this$props.componentClass,
        type = _this$props.type,
        _this$props$id = _this$props.id,
        id = _this$props$id === void 0 ? controlId : _this$props$id,
        inputRef = _this$props.inputRef,
        className = _this$props.className,
        bsSize = _this$props.bsSize,
        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["componentClass", "type", "id", "inputRef", "className", "bsSize"]);

    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

     false ? (0, _warning.default)(controlId == null || id === controlId, '`controlId` is ignored on `<FormControl>` when `id` is specified.') : void 0; // input[type="file"] should not have .form-control.

    var classes;

    if (type !== 'file') {
      classes = (0, _bootstrapUtils.getClassSet)(bsProps);
    } // If user provides a size, make sure to append it to classes as input-
    // e.g. if bsSize is small, it will append input-sm


    if (bsSize) {
      var size = _StyleConfig.SIZE_MAP[bsSize] || bsSize;
      classes[(0, _bootstrapUtils.prefix)({
        bsClass: 'input'
      }, size)] = true;
    }

    return _react.default.createElement(Component, (0, _extends2.default)({}, elementProps, {
      type: type,
      id: id,
      ref: inputRef,
      className: (0, _classnames.default)(className, classes)
    }));
  };

  return FormControl;
}(_react.default.Component);

FormControl.propTypes = propTypes;
FormControl.defaultProps = defaultProps;
FormControl.contextTypes = contextTypes;
FormControl.Feedback = _FormControlFeedback.default;
FormControl.Static = _FormControlStatic.default;

var _default = (0, _bootstrapUtils.bsClass)('form-control', (0, _bootstrapUtils.bsSizes)([_StyleConfig.Size.SMALL, _StyleConfig.Size.LARGE], FormControl));

exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 685 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(686);

/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(687);
module.exports = __webpack_require__(71).Object.assign;


/***/ }),
/* 687 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(121);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(694) });


/***/ }),
/* 688 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(689);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 689 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(290);
var createDesc = __webpack_require__(693);
module.exports = __webpack_require__(80) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 691 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(80) && !__webpack_require__(123)(function () {
  return Object.defineProperty(__webpack_require__(291)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 692 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(189);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 693 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var DESCRIPTORS = __webpack_require__(80);
var getKeys = __webpack_require__(124);
var gOPS = __webpack_require__(703);
var pIE = __webpack_require__(298);
var toObject = __webpack_require__(299);
var IObject = __webpack_require__(293);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(123)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;


/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(292);
var toIObject = __webpack_require__(190);
var arrayIndexOf = __webpack_require__(697)(false);
var IE_PROTO = __webpack_require__(296)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 696 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 697 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(190);
var toLength = __webpack_require__(698);
var toAbsoluteIndex = __webpack_require__(699);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 698 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(295);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 699 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(295);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 700 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(71);
var global = __webpack_require__(122);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(701) ? 'pure' : 'global',
  copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 701 */
/***/ (function(module, exports) {

module.exports = true;


/***/ }),
/* 702 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 703 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 704 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(705);

/***/ }),
/* 705 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(706);
module.exports = __webpack_require__(71).Object.keys;


/***/ }),
/* 706 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(299);
var $keys = __webpack_require__(124);

__webpack_require__(707)('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),
/* 707 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(121);
var core = __webpack_require__(71);
var fails = __webpack_require__(123);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),
/* 708 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(709);

/***/ }),
/* 709 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(710);
var $Object = __webpack_require__(71).Object;
module.exports = function create(P, D) {
  return $Object.create(P, D);
};


/***/ }),
/* 710 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(121);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(711) });


/***/ }),
/* 711 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(188);
var dPs = __webpack_require__(712);
var enumBugKeys = __webpack_require__(297);
var IE_PROTO = __webpack_require__(296)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(291)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(713).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 712 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(290);
var anObject = __webpack_require__(188);
var getKeys = __webpack_require__(124);

module.exports = __webpack_require__(80) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(122).document;
module.exports = document && document.documentElement;


/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createChainableTypeChecker;
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */

// Mostly taken from ReactPropTypes.

function createChainableTypeChecker(validate) {
  function checkType(isRequired, props, propName, componentName, location, propFullName) {
    var componentNameSafe = componentName || '<<anonymous>>';
    var propFullNameSafe = propFullName || propName;

    if (props[propName] == null) {
      if (isRequired) {
        return new Error('Required ' + location + ' `' + propFullNameSafe + '` was not specified ' + ('in `' + componentNameSafe + '`.'));
      }

      return null;
    }

    for (var _len = arguments.length, args = Array(_len > 6 ? _len - 6 : 0), _key = 6; _key < _len; _key++) {
      args[_key - 6] = arguments[_key];
    }

    return validate.apply(undefined, [props, propName, componentNameSafe, location, propFullNameSafe].concat(args));
  }

  var chainedCheckType = checkType.bind(null, false);
  chainedCheckType.isRequired = checkType.bind(null, true);

  return chainedCheckType;
}
module.exports = exports['default'];

/***/ }),
/* 715 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function() {};

if (false) {
  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
        '`warning(condition, format, ...args)` requires a warning ' +
        'message argument'
      );
    }

    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
      throw new Error(
        'The warning format should be able to uniquely identify this ' +
        'warning. Please, use a more descriptive format than: ' + format
      );
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' +
        format.replace(/%s/g, function() {
          return args[argIndex++];
        });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch(x) {}
    }
  };
}

module.exports = warning;


/***/ }),
/* 716 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(91);

exports.__esModule = true;
exports.default = void 0;

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(125));

var _extends2 = _interopRequireDefault(__webpack_require__(92));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(126));

var _classnames = _interopRequireDefault(__webpack_require__(49));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(7));

var _Glyphicon = _interopRequireDefault(__webpack_require__(717));

var _bootstrapUtils = __webpack_require__(127);

var defaultProps = {
  bsRole: 'feedback'
};
var contextTypes = {
  $bs_formGroup: _propTypes.default.object
};

var FormControlFeedback =
/*#__PURE__*/
function (_React$Component) {
  (0, _inheritsLoose2.default)(FormControlFeedback, _React$Component);

  function FormControlFeedback() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = FormControlFeedback.prototype;

  _proto.getGlyph = function getGlyph(validationState) {
    switch (validationState) {
      case 'success':
        return 'ok';

      case 'warning':
        return 'warning-sign';

      case 'error':
        return 'remove';

      default:
        return null;
    }
  };

  _proto.renderDefaultFeedback = function renderDefaultFeedback(formGroup, className, classes, elementProps) {
    var glyph = this.getGlyph(formGroup && formGroup.validationState);

    if (!glyph) {
      return null;
    }

    return _react.default.createElement(_Glyphicon.default, (0, _extends2.default)({}, elementProps, {
      glyph: glyph,
      className: (0, _classnames.default)(className, classes)
    }));
  };

  _proto.render = function render() {
    var _this$props = this.props,
        className = _this$props.className,
        children = _this$props.children,
        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["className", "children"]);

    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);

    if (!children) {
      return this.renderDefaultFeedback(this.context.$bs_formGroup, className, classes, elementProps);
    }

    var child = _react.default.Children.only(children);

    return _react.default.cloneElement(child, (0, _extends2.default)({}, elementProps, {
      className: (0, _classnames.default)(child.props.className, className, classes)
    }));
  };

  return FormControlFeedback;
}(_react.default.Component);

FormControlFeedback.defaultProps = defaultProps;
FormControlFeedback.contextTypes = contextTypes;

var _default = (0, _bootstrapUtils.bsClass)('form-control-feedback', FormControlFeedback);

exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 717 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(91);

exports.__esModule = true;
exports.default = void 0;

var _extends3 = _interopRequireDefault(__webpack_require__(92));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(125));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(126));

var _classnames = _interopRequireDefault(__webpack_require__(49));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(7));

var _bootstrapUtils = __webpack_require__(127);

var propTypes = {
  /**
   * An icon name without "glyphicon-" prefix. See e.g. http://getbootstrap.com/components/#glyphicons
   */
  glyph: _propTypes.default.string.isRequired
};

var Glyphicon =
/*#__PURE__*/
function (_React$Component) {
  (0, _inheritsLoose2.default)(Glyphicon, _React$Component);

  function Glyphicon() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Glyphicon.prototype;

  _proto.render = function render() {
    var _extends2;

    var _this$props = this.props,
        glyph = _this$props.glyph,
        className = _this$props.className,
        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["glyph", "className"]);

    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = (0, _extends3.default)({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[(0, _bootstrapUtils.prefix)(bsProps, glyph)] = true, _extends2));
    return _react.default.createElement("span", (0, _extends3.default)({}, elementProps, {
      className: (0, _classnames.default)(className, classes)
    }));
  };

  return Glyphicon;
}(_react.default.Component);

Glyphicon.propTypes = propTypes;

var _default = (0, _bootstrapUtils.bsClass)('glyphicon', Glyphicon);

exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 718 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(719);

/***/ }),
/* 719 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(720);
module.exports = __webpack_require__(71).Object.entries;


/***/ }),
/* 720 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(121);
var $entries = __webpack_require__(721)(true);

$export($export.S, 'Object', {
  entries: function entries(it) {
    return $entries(it);
  }
});


/***/ }),
/* 721 */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(80);
var getKeys = __webpack_require__(124);
var toIObject = __webpack_require__(190);
var isEnum = __webpack_require__(298).f;
module.exports = function (isEntries) {
  return function (it) {
    var O = toIObject(it);
    var keys = getKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) {
      key = keys[i++];
      if (!DESCRIPTORS || isEnum.call(O, key)) {
        result.push(isEntries ? [key, O[key]] : O[key]);
      }
    }
    return result;
  };
};


/***/ }),
/* 722 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(91);

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(92));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(125));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(126));

var _classnames = _interopRequireDefault(__webpack_require__(49));

var _react = _interopRequireDefault(__webpack_require__(0));

var _elementType = _interopRequireDefault(__webpack_require__(300));

var _bootstrapUtils = __webpack_require__(127);

var propTypes = {
  componentClass: _elementType.default
};
var defaultProps = {
  componentClass: 'p'
};

var FormControlStatic =
/*#__PURE__*/
function (_React$Component) {
  (0, _inheritsLoose2.default)(FormControlStatic, _React$Component);

  function FormControlStatic() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = FormControlStatic.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        Component = _this$props.componentClass,
        className = _this$props.className,
        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["componentClass", "className"]);

    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
    return _react.default.createElement(Component, (0, _extends2.default)({}, elementProps, {
      className: (0, _classnames.default)(className, classes)
    }));
  };

  return FormControlStatic;
}(_react.default.Component);

FormControlStatic.propTypes = propTypes;
FormControlStatic.defaultProps = defaultProps;

var _default = (0, _bootstrapUtils.bsClass)('form-control-static', FormControlStatic);

exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 723 */
/***/ (function(module, exports) {

module.exports=function(e){function r(n){if(t[n])return t[n].exports;var o=t[n]={exports:{},id:n,loaded:!1};return e[n].call(o.exports,o,o.exports,r),o.loaded=!0,o.exports}var t={};return r.m=e,r.c=t,r.p="",r(0)}([function(e,r,t){e.exports=t(1)},function(e,r){"use strict";function t(e){return"time-number"===e.message.substring(0,11)}function n(e){for(var r=arguments.length>1&&void 0!==arguments[1]?arguments[1]:2,t=e.toString(),n=r-t.length,o="";o.length<n;)o+="0";return""+o+t}function o(e,r){var t=r.validate,o=r.format,a=r.leadingZero,i=parseInt(e,10);if(t&&(i<0||i>=86400))throw new RangeError("time-number, timeFromInt(): rangeError, value supposed to be between 0 and 86399");var u=Math.floor(i/3600),m=Math.floor((i-3600*u)/60),d=i-3600*u-60*m,s=null;12!==o&&"12"!==o||(s=u<12?"AM":"PM",0===u?u=12:u>12&&(u-=12));var f=[a?n(u):u,n(m)];d&&f.push(n(d));var l=f.join(":");return s?l+" "+s:l}function a(e){return"boolean"==typeof e?{validate:e}:e}function i(e){var r=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},n={validate:!0,format:24,leadingZero:!0},i=Object.assign({},n,a(r)),u=i.validate;if(!u)return o(e,i);try{if(e-parseFloat(e,10)+1>=0)return o(e,i);throw new Error}catch(r){if(t(r))throw r;throw new Error("time-number, timeFromInt(): invalud value: '"+e+"', supposed to be number")}}function u(e,r){for(var t=r.validate,n=e.split(":"),o=n.length;n.length<3;)n.push("0");var a=n.map(function(e){return parseInt(e,10)});if(t){var i=a[0];if(i<0||i>23)throw new RangeError("time-number, timeToInt(): hours must be between 0 and 23, provided value: '"+e+"'");if(o>1){var u=a[1];if(u<0||u>59)throw new RangeError("time-number, timeToInt(): minutes must be between 0 and 59, provided value: '"+e+"'")}if(o>2){var m=a[2];if(m<0||m>59)throw new RangeError("time-number, timeToInt(): seconds must be between 0 and 59, provided value: '"+e+"'")}}return 3600*a[0]+60*a[1]+a[2]}function m(e){if(!e||!e.match)return e;if(!e.match(/(am|pm)$/i))return e;if(e.match(/^0+:/))throw new Error("12h format can't have 00:30 AM, it should be 12:30 AM instead");return e.match(/am$/i)?e.replace(/^(\d+)/,function(e){return"12"===e?"0":e}).replace(/\s*am$/i,""):e.replace(/^(\d+)/,function(e){return"12"===e?e:(parseInt(e,10)+12).toString()}).replace(/\s*pm$/i,"")}function d(e){var r=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},n={validate:!0},o=Object.assign({},n,a(r)),i=o.validate;if(!i){var d=m(e);return u(d,o)}try{var s=m(e);if(!s.match(/^\d+(:\d+(:\d+)?)?$/))throw new Error;return u(s,o)}catch(r){if(t(r))throw r;throw new Error("time-number, timeToInt(): supported formats are 'HH', 'HH:mm', 'HH:mm:ss', provided value: '"+e+"' doesn't match any of them")}}Object.defineProperty(r,"__esModule",{value:!0}),r.timeFromInt=i,r.timeToInt=d}]);

/***/ }),
/* 724 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CalendarContainer */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_onclickoutside__ = __webpack_require__(725);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_popper__ = __webpack_require__(726);







var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};









var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();







var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};



var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};











var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

function generateYears(year, noOfYear, minDate, maxDate) {
  var list = [];
  for (var i = 0; i < 2 * noOfYear + 1; i++) {
    var newYear = year + noOfYear - i;
    var isInRange = true;

    if (minDate) {
      isInRange = minDate.year() <= newYear;
    }

    if (maxDate && isInRange) {
      isInRange = maxDate.year() >= newYear;
    }

    if (isInRange) {
      list.push(newYear);
    }
  }

  return list;
}

var YearDropdownOptions = function (_React$Component) {
  inherits(YearDropdownOptions, _React$Component);

  function YearDropdownOptions(props) {
    classCallCheck(this, YearDropdownOptions);

    var _this = possibleConstructorReturn(this, _React$Component.call(this, props));

    _this.renderOptions = function () {
      var selectedYear = _this.props.year;
      var options = _this.state.yearsList.map(function (year) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          {
            className: selectedYear === year ? "react-datepicker__year-option react-datepicker__year-option--selected_year" : "react-datepicker__year-option",
            key: year,
            ref: year,
            onClick: _this.onChange.bind(_this, year)
          },
          selectedYear === year ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "span",
            { className: "react-datepicker__year-option--selected" },
            "\u2713"
          ) : "",
          year
        );
      });

      var minYear = _this.props.minDate ? _this.props.minDate.year() : null;
      var maxYear = _this.props.maxDate ? _this.props.maxDate.year() : null;

      if (!maxYear || !_this.state.yearsList.find(function (year) {
        return year === maxYear;
      })) {
        options.unshift(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          {
            className: "react-datepicker__year-option",
            ref: "upcoming",
            key: "upcoming",
            onClick: _this.incrementYears
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", { className: "react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-upcoming" })
        ));
      }

      if (!minYear || !_this.state.yearsList.find(function (year) {
        return year === minYear;
      })) {
        options.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          {
            className: "react-datepicker__year-option",
            ref: "previous",
            key: "previous",
            onClick: _this.decrementYears
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", { className: "react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-previous" })
        ));
      }

      return options;
    };

    _this.onChange = function (year) {
      _this.props.onChange(year);
    };

    _this.handleClickOutside = function () {
      _this.props.onCancel();
    };

    _this.shiftYears = function (amount) {
      var years = _this.state.yearsList.map(function (year) {
        return year + amount;
      });

      _this.setState({
        yearsList: years
      });
    };

    _this.incrementYears = function () {
      return _this.shiftYears(1);
    };

    _this.decrementYears = function () {
      return _this.shiftYears(-1);
    };

    var yearDropdownItemNumber = props.yearDropdownItemNumber,
        scrollableYearDropdown = props.scrollableYearDropdown;

    var noOfYear = yearDropdownItemNumber || (scrollableYearDropdown ? 10 : 5);

    _this.state = {
      yearsList: generateYears(_this.props.year, noOfYear, _this.props.minDate, _this.props.maxDate)
    };
    return _this;
  }

  YearDropdownOptions.prototype.render = function render() {
    var dropdownClass = __WEBPACK_IMPORTED_MODULE_2_classnames___default()({
      "react-datepicker__year-dropdown": true,
      "react-datepicker__year-dropdown--scrollable": this.props.scrollableYearDropdown
    });

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { className: dropdownClass },
      this.renderOptions()
    );
  };

  return YearDropdownOptions;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

YearDropdownOptions.propTypes = {
  minDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  maxDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  onCancel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  scrollableYearDropdown: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  year: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  yearDropdownItemNumber: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
};

var dayOfWeekCodes = {
  1: "mon",
  2: "tue",
  3: "wed",
  4: "thu",
  5: "fri",
  6: "sat",
  7: "sun"
};

// These functions are not exported so
// that we avoid magic strings like 'days'
function set$1(date, unit, to) {
  return date.set(unit, to);
}

function add(date, amount, unit) {
  return date.add(amount, unit);
}

function subtract(date, amount, unit) {
  return date.subtract(amount, unit);
}

function get$1(date, unit) {
  return date.get(unit);
}

function getStartOf(date, unit) {
  return date.startOf(unit);
}

// ** Date Constructors **

function newDate(point) {
  return __WEBPACK_IMPORTED_MODULE_4_moment___default()(point);
}

function newDateWithOffset(utcOffset) {
  return __WEBPACK_IMPORTED_MODULE_4_moment___default()().utc().utcOffset(utcOffset);
}

function now(maybeFixedUtcOffset) {
  if (maybeFixedUtcOffset == null) {
    return newDate();
  }
  return newDateWithOffset(maybeFixedUtcOffset);
}

function cloneDate(date) {
  return date.clone();
}

function parseDate(value, _ref) {
  var dateFormat = _ref.dateFormat,
      locale = _ref.locale;

  var m = __WEBPACK_IMPORTED_MODULE_4_moment___default()(value, dateFormat, locale || __WEBPACK_IMPORTED_MODULE_4_moment___default.a.locale(), true);
  return m.isValid() ? m : null;
}

// ** Date "Reflection" **

function isMoment(date) {
  return __WEBPACK_IMPORTED_MODULE_4_moment___default.a.isMoment(date);
}

function isDate(date) {
  return __WEBPACK_IMPORTED_MODULE_4_moment___default.a.isDate(date);
}

// ** Date Formatting **

function formatDate(date, format) {
  return date.format(format);
}

function safeDateFormat(date, _ref2) {
  var dateFormat = _ref2.dateFormat,
      locale = _ref2.locale;

  return date && date.clone().locale(locale || __WEBPACK_IMPORTED_MODULE_4_moment___default.a.locale()).format(Array.isArray(dateFormat) ? dateFormat[0] : dateFormat) || "";
}

// ** Date Setters **

function setTime(date, _ref3) {
  var hour = _ref3.hour,
      minute = _ref3.minute,
      second = _ref3.second;

  date.set({ hour: hour, minute: minute, second: second });
  return date;
}

function setMonth(date, month) {
  return set$1(date, "month", month);
}

function setYear(date, year) {
  return set$1(date, "year", year);
}



// ** Date Getters **

function getSecond(date) {
  return get$1(date, "second");
}

function getMinute(date) {
  return get$1(date, "minute");
}

function getHour(date) {
  return get$1(date, "hour");
}

// Returns day of week
function getDay(date) {
  return get$1(date, "day");
}

function getWeek(date) {
  return get$1(date, "week");
}

function getMonth(date) {
  return get$1(date, "month");
}

function getYear(date) {
  return get$1(date, "year");
}

// Returns day of month
function getDate(date) {
  return get$1(date, "date");
}



function getDayOfWeekCode(day) {
  return dayOfWeekCodes[day.isoWeekday()];
}

// *** Start of ***

function getStartOfDay(date) {
  return getStartOf(date, "day");
}

function getStartOfWeek(date) {
  return getStartOf(date, "week");
}
function getStartOfMonth(date) {
  return getStartOf(date, "month");
}

function getStartOfDate(date) {
  return getStartOf(date, "date");
}

// *** End of ***





// ** Date Math **

// *** Addition ***

function addMinutes(date, amount) {
  return add(date, amount, "minutes");
}

function addHours(date, amount) {
  return add(date, amount, "hours");
}

function addDays(date, amount) {
  return add(date, amount, "days");
}

function addWeeks(date, amount) {
  return add(date, amount, "weeks");
}

function addMonths(date, amount) {
  return add(date, amount, "months");
}

function addYears(date, amount) {
  return add(date, amount, "years");
}

// *** Subtraction ***
function subtractDays(date, amount) {
  return subtract(date, amount, "days");
}

function subtractWeeks(date, amount) {
  return subtract(date, amount, "weeks");
}

function subtractMonths(date, amount) {
  return subtract(date, amount, "months");
}

function subtractYears(date, amount) {
  return subtract(date, amount, "years");
}

// ** Date Comparison **

function isBefore(date1, date2) {
  return date1.isBefore(date2);
}

function isAfter(date1, date2) {
  return date1.isAfter(date2);
}

function equals(date1, date2) {
  return date1.isSame(date2);
}

function isSameYear(date1, date2) {
  if (date1 && date2) {
    return date1.isSame(date2, "year");
  } else {
    return !date1 && !date2;
  }
}

function isSameMonth(date1, date2) {
  if (date1 && date2) {
    return date1.isSame(date2, "month");
  } else {
    return !date1 && !date2;
  }
}

function isSameDay(moment1, moment2) {
  if (moment1 && moment2) {
    return moment1.isSame(moment2, "day");
  } else {
    return !moment1 && !moment2;
  }
}



function isDayInRange(day, startDate, endDate) {
  var before = startDate.clone().startOf("day").subtract(1, "seconds");
  var after = endDate.clone().startOf("day").add(1, "seconds");
  return day.clone().startOf("day").isBetween(before, after);
}

// *** Diffing ***



// ** Date Localization **

function localizeDate(date, locale) {
  return date.clone().locale(locale || __WEBPACK_IMPORTED_MODULE_4_moment___default.a.locale());
}







function getLocaleData(date) {
  return date.localeData();
}

function getLocaleDataForLocale(locale) {
  return __WEBPACK_IMPORTED_MODULE_4_moment___default.a.localeData(locale);
}

function getFormattedWeekdayInLocale(locale, date, formatFunc) {
  return formatFunc(locale.weekdays(date));
}

function getWeekdayMinInLocale(locale, date) {
  return locale.weekdaysMin(date);
}

function getWeekdayShortInLocale(locale, date) {
  return locale.weekdaysShort(date);
}

// TODO what is this format exactly?
function getMonthInLocale(locale, date, format) {
  return locale.months(date, format);
}

function getMonthShortInLocale(locale, date) {
  return locale.monthsShort(date);
}

// ** Utils for some components **

function isDayDisabled(day) {
  var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      minDate = _ref4.minDate,
      maxDate = _ref4.maxDate,
      excludeDates = _ref4.excludeDates,
      includeDates = _ref4.includeDates,
      filterDate = _ref4.filterDate;

  return minDate && day.isBefore(minDate, "day") || maxDate && day.isAfter(maxDate, "day") || excludeDates && excludeDates.some(function (excludeDate) {
    return isSameDay(day, excludeDate);
  }) || includeDates && !includeDates.some(function (includeDate) {
    return isSameDay(day, includeDate);
  }) || filterDate && !filterDate(day.clone()) || false;
}

function isOutOfBounds(day) {
  var _ref5 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      minDate = _ref5.minDate,
      maxDate = _ref5.maxDate;

  return minDate && day.isBefore(minDate, "day") || maxDate && day.isAfter(maxDate, "day");
}

function isTimeDisabled(time, disabledTimes) {
  var l = disabledTimes.length;
  for (var i = 0; i < l; i++) {
    if (disabledTimes[i].get("hours") === time.get("hours") && disabledTimes[i].get("minutes") === time.get("minutes")) {
      return true;
    }
  }

  return false;
}

function isTimeInDisabledRange(time, _ref6) {
  var minTime = _ref6.minTime,
      maxTime = _ref6.maxTime;

  if (!minTime || !maxTime) {
    throw new Error("Both minTime and maxTime props required");
  }

  var base = __WEBPACK_IMPORTED_MODULE_4_moment___default()().hours(0).minutes(0).seconds(0);
  var baseTime = base.clone().hours(time.get("hours")).minutes(time.get("minutes"));
  var min = base.clone().hours(minTime.get("hours")).minutes(minTime.get("minutes"));
  var max = base.clone().hours(maxTime.get("hours")).minutes(maxTime.get("minutes"));

  return !(baseTime.isSameOrAfter(min) && baseTime.isSameOrBefore(max));
}

function allDaysDisabledBefore(day, unit) {
  var _ref7 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      minDate = _ref7.minDate,
      includeDates = _ref7.includeDates;

  var dateBefore = day.clone().subtract(1, unit);
  return minDate && dateBefore.isBefore(minDate, unit) || includeDates && includeDates.every(function (includeDate) {
    return dateBefore.isBefore(includeDate, unit);
  }) || false;
}

function allDaysDisabledAfter(day, unit) {
  var _ref8 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      maxDate = _ref8.maxDate,
      includeDates = _ref8.includeDates;

  var dateAfter = day.clone().add(1, unit);
  return maxDate && dateAfter.isAfter(maxDate, unit) || includeDates && includeDates.every(function (includeDate) {
    return dateAfter.isAfter(includeDate, unit);
  }) || false;
}

function getEffectiveMinDate(_ref9) {
  var minDate = _ref9.minDate,
      includeDates = _ref9.includeDates;

  if (includeDates && minDate) {
    return __WEBPACK_IMPORTED_MODULE_4_moment___default.a.min(includeDates.filter(function (includeDate) {
      return minDate.isSameOrBefore(includeDate, "day");
    }));
  } else if (includeDates) {
    return __WEBPACK_IMPORTED_MODULE_4_moment___default.a.min(includeDates);
  } else {
    return minDate;
  }
}

function getEffectiveMaxDate(_ref10) {
  var maxDate = _ref10.maxDate,
      includeDates = _ref10.includeDates;

  if (includeDates && maxDate) {
    return __WEBPACK_IMPORTED_MODULE_4_moment___default.a.max(includeDates.filter(function (includeDate) {
      return maxDate.isSameOrAfter(includeDate, "day");
    }));
  } else if (includeDates) {
    return __WEBPACK_IMPORTED_MODULE_4_moment___default.a.max(includeDates);
  } else {
    return maxDate;
  }
}

function getHightLightDaysMap() {
  var highlightDates = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var defaultClassName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "react-datepicker__day--highlighted";

  var dateClasses = new Map();
  for (var i = 0, len = highlightDates.length; i < len; i++) {
    var obj = highlightDates[i];
    if (isMoment(obj)) {
      var key = obj.format("MM.DD.YYYY");
      var classNamesArr = dateClasses.get(key) || [];
      if (!classNamesArr.includes(defaultClassName)) {
        classNamesArr.push(defaultClassName);
        dateClasses.set(key, classNamesArr);
      }
    } else if ((typeof obj === "undefined" ? "undefined" : _typeof(obj)) === "object") {
      var keys = Object.keys(obj);
      var className = keys[0];
      var arrOfMoments = obj[keys[0]];
      if (typeof className === "string" && arrOfMoments.constructor === Array) {
        for (var k = 0, _len = arrOfMoments.length; k < _len; k++) {
          var _key = arrOfMoments[k].format("MM.DD.YYYY");
          var _classNamesArr = dateClasses.get(_key) || [];
          if (!_classNamesArr.includes(className)) {
            _classNamesArr.push(className);
            dateClasses.set(_key, _classNamesArr);
          }
        }
      }
    }
  }

  return dateClasses;
}

function timesToInjectAfter(startOfDay, currentTime, currentMultiplier, intervals, injectedTimes) {
  var l = injectedTimes.length;
  var times = [];
  for (var i = 0; i < l; i++) {
    var injectedTime = addMinutes(addHours(cloneDate(startOfDay), getHour(injectedTimes[i])), getMinute(injectedTimes[i]));
    var nextTime = addMinutes(cloneDate(startOfDay), (currentMultiplier + 1) * intervals);

    if (injectedTime.isBetween(currentTime, nextTime)) {
      times.push(injectedTimes[i]);
    }
  }

  return times;
}

var WrappedYearDropdownOptions = Object(__WEBPACK_IMPORTED_MODULE_3_react_onclickoutside__["a" /* default */])(YearDropdownOptions);

var YearDropdown = function (_React$Component) {
  inherits(YearDropdown, _React$Component);

  function YearDropdown() {
    var _temp, _this, _ret;

    classCallCheck(this, YearDropdown);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      dropdownVisible: false
    }, _this.renderSelectOptions = function () {
      var minYear = _this.props.minDate ? getYear(_this.props.minDate) : 1900;
      var maxYear = _this.props.maxDate ? getYear(_this.props.maxDate) : 2100;

      var options = [];
      for (var i = minYear; i <= maxYear; i++) {
        options.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "option",
          { key: i, value: i },
          i
        ));
      }
      return options;
    }, _this.onSelectChange = function (e) {
      _this.onChange(e.target.value);
    }, _this.renderSelectMode = function () {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "select",
        {
          value: _this.props.year,
          className: "react-datepicker__year-select",
          onChange: _this.onSelectChange
        },
        _this.renderSelectOptions()
      );
    }, _this.renderReadView = function (visible) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        {
          key: "read",
          style: { visibility: visible ? "visible" : "hidden" },
          className: "react-datepicker__year-read-view",
          onClick: function onClick(event) {
            return _this.toggleDropdown(event);
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "react-datepicker__year-read-view--down-arrow" }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          { className: "react-datepicker__year-read-view--selected-year" },
          _this.props.year
        )
      );
    }, _this.renderDropdown = function () {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WrappedYearDropdownOptions, {
        key: "dropdown",
        ref: "options",
        year: _this.props.year,
        onChange: _this.onChange,
        onCancel: _this.toggleDropdown,
        minDate: _this.props.minDate,
        maxDate: _this.props.maxDate,
        scrollableYearDropdown: _this.props.scrollableYearDropdown,
        yearDropdownItemNumber: _this.props.yearDropdownItemNumber
      });
    }, _this.renderScrollMode = function () {
      var dropdownVisible = _this.state.dropdownVisible;

      var result = [_this.renderReadView(!dropdownVisible)];
      if (dropdownVisible) {
        result.unshift(_this.renderDropdown());
      }
      return result;
    }, _this.onChange = function (year) {
      _this.toggleDropdown();
      if (year === _this.props.year) return;
      _this.props.onChange(year);
    }, _this.toggleDropdown = function (event) {
      _this.setState({
        dropdownVisible: !_this.state.dropdownVisible
      }, function () {
        if (_this.props.adjustDateOnChange) {
          _this.handleYearChange(_this.props.date, event);
        }
      });
    }, _this.handleYearChange = function (date, event) {
      _this.onSelect(date, event);
      _this.setOpen();
    }, _this.onSelect = function (date, event) {
      if (_this.props.onSelect) {
        _this.props.onSelect(date, event);
      }
    }, _this.setOpen = function () {
      if (_this.props.setOpen) {
        _this.props.setOpen(true);
      }
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  YearDropdown.prototype.render = function render() {
    var renderedDropdown = void 0;
    switch (this.props.dropdownMode) {
      case "scroll":
        renderedDropdown = this.renderScrollMode();
        break;
      case "select":
        renderedDropdown = this.renderSelectMode();
        break;
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      {
        className: "react-datepicker__year-dropdown-container react-datepicker__year-dropdown-container--" + this.props.dropdownMode
      },
      renderedDropdown
    );
  };

  return YearDropdown;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

YearDropdown.propTypes = {
  adjustDateOnChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  dropdownMode: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["scroll", "select"]).isRequired,
  maxDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  minDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  scrollableYearDropdown: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  year: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  yearDropdownItemNumber: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  date: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  onSelect: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  setOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

var MonthDropdownOptions = function (_React$Component) {
  inherits(MonthDropdownOptions, _React$Component);

  function MonthDropdownOptions() {
    var _temp, _this, _ret;

    classCallCheck(this, MonthDropdownOptions);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.renderOptions = function () {
      return _this.props.monthNames.map(function (month, i) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          {
            className: _this.props.month === i ? "react-datepicker__month-option --selected_month" : "react-datepicker__month-option",
            key: month,
            ref: month,
            onClick: _this.onChange.bind(_this, i)
          },
          _this.props.month === i ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "span",
            { className: "react-datepicker__month-option--selected" },
            "\u2713"
          ) : "",
          month
        );
      });
    }, _this.onChange = function (month) {
      return _this.props.onChange(month);
    }, _this.handleClickOutside = function () {
      return _this.props.onCancel();
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  MonthDropdownOptions.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { className: "react-datepicker__month-dropdown" },
      this.renderOptions()
    );
  };

  return MonthDropdownOptions;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

MonthDropdownOptions.propTypes = {
  onCancel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  month: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  monthNames: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired).isRequired
};

var WrappedMonthDropdownOptions = Object(__WEBPACK_IMPORTED_MODULE_3_react_onclickoutside__["a" /* default */])(MonthDropdownOptions);

var MonthDropdown = function (_React$Component) {
  inherits(MonthDropdown, _React$Component);

  function MonthDropdown() {
    var _temp, _this, _ret;

    classCallCheck(this, MonthDropdown);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      dropdownVisible: false
    }, _this.renderSelectOptions = function (monthNames) {
      return monthNames.map(function (M, i) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "option",
          { key: i, value: i },
          M
        );
      });
    }, _this.renderSelectMode = function (monthNames) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "select",
        {
          value: _this.props.month,
          className: "react-datepicker__month-select",
          onChange: function onChange(e) {
            return _this.onChange(e.target.value);
          }
        },
        _this.renderSelectOptions(monthNames)
      );
    }, _this.renderReadView = function (visible, monthNames) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        {
          key: "read",
          style: { visibility: visible ? "visible" : "hidden" },
          className: "react-datepicker__month-read-view",
          onClick: _this.toggleDropdown
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "react-datepicker__month-read-view--down-arrow" }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          { className: "react-datepicker__month-read-view--selected-month" },
          monthNames[_this.props.month]
        )
      );
    }, _this.renderDropdown = function (monthNames) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WrappedMonthDropdownOptions, {
        key: "dropdown",
        ref: "options",
        month: _this.props.month,
        monthNames: monthNames,
        onChange: _this.onChange,
        onCancel: _this.toggleDropdown
      });
    }, _this.renderScrollMode = function (monthNames) {
      var dropdownVisible = _this.state.dropdownVisible;

      var result = [_this.renderReadView(!dropdownVisible, monthNames)];
      if (dropdownVisible) {
        result.unshift(_this.renderDropdown(monthNames));
      }
      return result;
    }, _this.onChange = function (month) {
      _this.toggleDropdown();
      if (month !== _this.props.month) {
        _this.props.onChange(month);
      }
    }, _this.toggleDropdown = function () {
      return _this.setState({
        dropdownVisible: !_this.state.dropdownVisible
      });
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  MonthDropdown.prototype.render = function render() {
    var _this2 = this;

    var localeData = getLocaleDataForLocale(this.props.locale);
    var monthNames = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11].map(this.props.useShortMonthInDropdown ? function (M) {
      return getMonthShortInLocale(localeData, newDate({ M: M }));
    } : function (M) {
      return getMonthInLocale(localeData, newDate({ M: M }), _this2.props.dateFormat);
    });

    var renderedDropdown = void 0;
    switch (this.props.dropdownMode) {
      case "scroll":
        renderedDropdown = this.renderScrollMode(monthNames);
        break;
      case "select":
        renderedDropdown = this.renderSelectMode(monthNames);
        break;
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      {
        className: "react-datepicker__month-dropdown-container react-datepicker__month-dropdown-container--" + this.props.dropdownMode
      },
      renderedDropdown
    );
  };

  return MonthDropdown;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

MonthDropdown.propTypes = {
  dropdownMode: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["scroll", "select"]).isRequired,
  locale: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  dateFormat: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  month: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  useShortMonthInDropdown: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

function generateMonthYears(minDate, maxDate) {
  var list = [];

  var currDate = getStartOfMonth(cloneDate(minDate));
  var lastDate = getStartOfMonth(cloneDate(maxDate));

  while (!isAfter(currDate, lastDate)) {
    list.push(cloneDate(currDate));

    addMonths(currDate, 1);
  }

  return list;
}

var MonthYearDropdownOptions = function (_React$Component) {
  inherits(MonthYearDropdownOptions, _React$Component);

  function MonthYearDropdownOptions(props) {
    classCallCheck(this, MonthYearDropdownOptions);

    var _this = possibleConstructorReturn(this, _React$Component.call(this, props));

    _this.renderOptions = function () {
      return _this.state.monthYearsList.map(function (monthYear) {
        var monthYearPoint = monthYear.valueOf();

        var isSameMonthYear = isSameYear(_this.props.date, monthYear) && isSameMonth(_this.props.date, monthYear);

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          {
            className: isSameMonthYear ? "react-datepicker__month-year-option --selected_month-year" : "react-datepicker__month-year-option",
            key: monthYearPoint,
            ref: monthYearPoint,
            onClick: _this.onChange.bind(_this, monthYearPoint)
          },
          isSameMonthYear ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "span",
            { className: "react-datepicker__month-year-option--selected" },
            "\u2713"
          ) : "",
          formatDate(monthYear, _this.props.dateFormat)
        );
      });
    };

    _this.onChange = function (monthYear) {
      return _this.props.onChange(monthYear);
    };

    _this.handleClickOutside = function () {
      _this.props.onCancel();
    };

    _this.state = {
      monthYearsList: generateMonthYears(_this.props.minDate, _this.props.maxDate)
    };
    return _this;
  }

  MonthYearDropdownOptions.prototype.render = function render() {
    var dropdownClass = __WEBPACK_IMPORTED_MODULE_2_classnames___default()({
      "react-datepicker__month-year-dropdown": true,
      "react-datepicker__month-year-dropdown--scrollable": this.props.scrollableMonthYearDropdown
    });

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { className: dropdownClass },
      this.renderOptions()
    );
  };

  return MonthYearDropdownOptions;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

MonthYearDropdownOptions.propTypes = {
  minDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  maxDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  onCancel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  scrollableMonthYearDropdown: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  date: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  dateFormat: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
};

var WrappedMonthYearDropdownOptions = Object(__WEBPACK_IMPORTED_MODULE_3_react_onclickoutside__["a" /* default */])(MonthYearDropdownOptions);

var MonthYearDropdown = function (_React$Component) {
  inherits(MonthYearDropdown, _React$Component);

  function MonthYearDropdown() {
    var _temp, _this, _ret;

    classCallCheck(this, MonthYearDropdown);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      dropdownVisible: false
    }, _this.renderSelectOptions = function () {
      var currDate = getStartOfMonth(localizeDate(_this.props.minDate, _this.props.locale));
      var lastDate = getStartOfMonth(localizeDate(_this.props.maxDate, _this.props.locale));

      var options = [];

      while (!isAfter(currDate, lastDate)) {
        var timepoint = currDate.valueOf();
        options.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "option",
          { key: timepoint, value: timepoint },
          formatDate(currDate, _this.props.dateFormat)
        ));

        addMonths(currDate, 1);
      }

      return options;
    }, _this.onSelectChange = function (e) {
      _this.onChange(e.target.value);
    }, _this.renderSelectMode = function () {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "select",
        {
          value: getStartOfMonth(_this.props.date).valueOf(),
          className: "react-datepicker__month-year-select",
          onChange: _this.onSelectChange
        },
        _this.renderSelectOptions()
      );
    }, _this.renderReadView = function (visible) {
      var yearMonth = formatDate(localizeDate(newDate(_this.props.date), _this.props.locale), _this.props.dateFormat);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        {
          key: "read",
          style: { visibility: visible ? "visible" : "hidden" },
          className: "react-datepicker__month-year-read-view",
          onClick: function onClick(event) {
            return _this.toggleDropdown(event);
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "react-datepicker__month-year-read-view--down-arrow" }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          { className: "react-datepicker__month-year-read-view--selected-month-year" },
          yearMonth
        )
      );
    }, _this.renderDropdown = function () {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WrappedMonthYearDropdownOptions, {
        key: "dropdown",
        ref: "options",
        date: _this.props.date,
        dateFormat: _this.props.dateFormat,
        onChange: _this.onChange,
        onCancel: _this.toggleDropdown,
        minDate: localizeDate(_this.props.minDate, _this.props.locale),
        maxDate: localizeDate(_this.props.maxDate, _this.props.locale),
        scrollableMonthYearDropdown: _this.props.scrollableMonthYearDropdown
      });
    }, _this.renderScrollMode = function () {
      var dropdownVisible = _this.state.dropdownVisible;

      var result = [_this.renderReadView(!dropdownVisible)];
      if (dropdownVisible) {
        result.unshift(_this.renderDropdown());
      }
      return result;
    }, _this.onChange = function (monthYearPoint) {
      _this.toggleDropdown();

      var changedDate = newDate(parseInt(monthYearPoint));

      if (isSameYear(_this.props.date, changedDate) && isSameMonth(_this.props.date, changedDate)) {
        return;
      }

      _this.props.onChange(changedDate);
    }, _this.toggleDropdown = function () {
      return _this.setState({
        dropdownVisible: !_this.state.dropdownVisible
      });
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  MonthYearDropdown.prototype.render = function render() {
    var renderedDropdown = void 0;
    switch (this.props.dropdownMode) {
      case "scroll":
        renderedDropdown = this.renderScrollMode();
        break;
      case "select":
        renderedDropdown = this.renderSelectMode();
        break;
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      {
        className: "react-datepicker__month-year-dropdown-container react-datepicker__month-year-dropdown-container--" + this.props.dropdownMode
      },
      renderedDropdown
    );
  };

  return MonthYearDropdown;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

MonthYearDropdown.propTypes = {
  dropdownMode: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["scroll", "select"]).isRequired,
  dateFormat: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  locale: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  maxDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  minDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  date: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  scrollableMonthYearDropdown: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

var Day = function (_React$Component) {
  inherits(Day, _React$Component);

  function Day() {
    var _temp, _this, _ret;

    classCallCheck(this, Day);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function (event) {
      if (!_this.isDisabled() && _this.props.onClick) {
        _this.props.onClick(event);
      }
    }, _this.handleMouseEnter = function (event) {
      if (!_this.isDisabled() && _this.props.onMouseEnter) {
        _this.props.onMouseEnter(event);
      }
    }, _this.isSameDay = function (other) {
      return isSameDay(_this.props.day, other);
    }, _this.isKeyboardSelected = function () {
      return !_this.props.disabledKeyboardNavigation && !_this.props.inline && !_this.isSameDay(_this.props.selected) && _this.isSameDay(_this.props.preSelection);
    }, _this.isDisabled = function () {
      return isDayDisabled(_this.props.day, _this.props);
    }, _this.getHighLightedClass = function (defaultClassName) {
      var _this$props = _this.props,
          day = _this$props.day,
          highlightDates = _this$props.highlightDates;


      if (!highlightDates) {
        return false;
      }

      // Looking for className in the Map of {'day string, 'className'}
      var dayStr = day.format("MM.DD.YYYY");
      return highlightDates.get(dayStr);
    }, _this.isInRange = function () {
      var _this$props2 = _this.props,
          day = _this$props2.day,
          startDate = _this$props2.startDate,
          endDate = _this$props2.endDate;

      if (!startDate || !endDate) {
        return false;
      }
      return isDayInRange(day, startDate, endDate);
    }, _this.isInSelectingRange = function () {
      var _this$props3 = _this.props,
          day = _this$props3.day,
          selectsStart = _this$props3.selectsStart,
          selectsEnd = _this$props3.selectsEnd,
          selectingDate = _this$props3.selectingDate,
          startDate = _this$props3.startDate,
          endDate = _this$props3.endDate;


      if (!(selectsStart || selectsEnd) || !selectingDate || _this.isDisabled()) {
        return false;
      }

      if (selectsStart && endDate && selectingDate.isSameOrBefore(endDate)) {
        return isDayInRange(day, selectingDate, endDate);
      }

      if (selectsEnd && startDate && selectingDate.isSameOrAfter(startDate)) {
        return isDayInRange(day, startDate, selectingDate);
      }

      return false;
    }, _this.isSelectingRangeStart = function () {
      if (!_this.isInSelectingRange()) {
        return false;
      }

      var _this$props4 = _this.props,
          day = _this$props4.day,
          selectingDate = _this$props4.selectingDate,
          startDate = _this$props4.startDate,
          selectsStart = _this$props4.selectsStart;


      if (selectsStart) {
        return isSameDay(day, selectingDate);
      } else {
        return isSameDay(day, startDate);
      }
    }, _this.isSelectingRangeEnd = function () {
      if (!_this.isInSelectingRange()) {
        return false;
      }

      var _this$props5 = _this.props,
          day = _this$props5.day,
          selectingDate = _this$props5.selectingDate,
          endDate = _this$props5.endDate,
          selectsEnd = _this$props5.selectsEnd;


      if (selectsEnd) {
        return isSameDay(day, selectingDate);
      } else {
        return isSameDay(day, endDate);
      }
    }, _this.isRangeStart = function () {
      var _this$props6 = _this.props,
          day = _this$props6.day,
          startDate = _this$props6.startDate,
          endDate = _this$props6.endDate;

      if (!startDate || !endDate) {
        return false;
      }
      return isSameDay(startDate, day);
    }, _this.isRangeEnd = function () {
      var _this$props7 = _this.props,
          day = _this$props7.day,
          startDate = _this$props7.startDate,
          endDate = _this$props7.endDate;

      if (!startDate || !endDate) {
        return false;
      }
      return isSameDay(endDate, day);
    }, _this.isWeekend = function () {
      var weekday = getDay(_this.props.day);
      return weekday === 0 || weekday === 6;
    }, _this.isOutsideMonth = function () {
      return _this.props.month !== undefined && _this.props.month !== getMonth(_this.props.day);
    }, _this.getClassNames = function (date) {
      var dayClassName = _this.props.dayClassName ? _this.props.dayClassName(date) : undefined;
      return __WEBPACK_IMPORTED_MODULE_2_classnames___default()("react-datepicker__day", dayClassName, "react-datepicker__day--" + getDayOfWeekCode(_this.props.day), {
        "react-datepicker__day--disabled": _this.isDisabled(),
        "react-datepicker__day--selected": _this.isSameDay(_this.props.selected),
        "react-datepicker__day--keyboard-selected": _this.isKeyboardSelected(),
        "react-datepicker__day--range-start": _this.isRangeStart(),
        "react-datepicker__day--range-end": _this.isRangeEnd(),
        "react-datepicker__day--in-range": _this.isInRange(),
        "react-datepicker__day--in-selecting-range": _this.isInSelectingRange(),
        "react-datepicker__day--selecting-range-start": _this.isSelectingRangeStart(),
        "react-datepicker__day--selecting-range-end": _this.isSelectingRangeEnd(),
        "react-datepicker__day--today": _this.isSameDay(now(_this.props.utcOffset)),
        "react-datepicker__day--weekend": _this.isWeekend(),
        "react-datepicker__day--outside-month": _this.isOutsideMonth()
      }, _this.getHighLightedClass("react-datepicker__day--highlighted"));
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  Day.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      {
        className: this.getClassNames(this.props.day),
        onClick: this.handleClick,
        onMouseEnter: this.handleMouseEnter,
        "aria-label": "day-" + getDate(this.props.day),
        role: "option"
      },
      this.props.renderDayContents ? this.props.renderDayContents(getDate(this.props.day)) : getDate(this.props.day)
    );
  };

  return Day;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Day.propTypes = {
  disabledKeyboardNavigation: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  day: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  dayClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  endDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  highlightDates: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Map),
  inline: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  month: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onMouseEnter: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  preSelection: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  selected: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  selectingDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  selectsEnd: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  selectsStart: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  startDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  utcOffset: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  renderDayContents: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

var WeekNumber = function (_React$Component) {
  inherits(WeekNumber, _React$Component);

  function WeekNumber() {
    var _temp, _this, _ret;

    classCallCheck(this, WeekNumber);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function (event) {
      if (_this.props.onClick) {
        _this.props.onClick(event);
      }
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  WeekNumber.prototype.render = function render() {
    var weekNumberClasses = {
      "react-datepicker__week-number": true,
      "react-datepicker__week-number--clickable": !!this.props.onClick
    };
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      {
        className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(weekNumberClasses),
        "aria-label": "week-" + this.props.weekNumber,
        onClick: this.handleClick
      },
      this.props.weekNumber
    );
  };

  return WeekNumber;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

WeekNumber.propTypes = {
  weekNumber: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

var Week = function (_React$Component) {
  inherits(Week, _React$Component);

  function Week() {
    var _temp, _this, _ret;

    classCallCheck(this, Week);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleDayClick = function (day, event) {
      if (_this.props.onDayClick) {
        _this.props.onDayClick(day, event);
      }
    }, _this.handleDayMouseEnter = function (day) {
      if (_this.props.onDayMouseEnter) {
        _this.props.onDayMouseEnter(day);
      }
    }, _this.handleWeekClick = function (day, weekNumber, event) {
      if (typeof _this.props.onWeekSelect === "function") {
        _this.props.onWeekSelect(day, weekNumber, event);
      }
    }, _this.formatWeekNumber = function (startOfWeek) {
      if (_this.props.formatWeekNumber) {
        return _this.props.formatWeekNumber(startOfWeek);
      }
      return getWeek(startOfWeek);
    }, _this.renderDays = function () {
      var startOfWeek = getStartOfWeek(cloneDate(_this.props.day));
      var days = [];
      var weekNumber = _this.formatWeekNumber(startOfWeek);
      if (_this.props.showWeekNumber) {
        var onClickAction = _this.props.onWeekSelect ? _this.handleWeekClick.bind(_this, startOfWeek, weekNumber) : undefined;
        days.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WeekNumber, { key: "W", weekNumber: weekNumber, onClick: onClickAction }));
      }
      return days.concat([0, 1, 2, 3, 4, 5, 6].map(function (offset) {
        var day = addDays(cloneDate(startOfWeek), offset);
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Day, {
          key: offset,
          day: day,
          month: _this.props.month,
          onClick: _this.handleDayClick.bind(_this, day),
          onMouseEnter: _this.handleDayMouseEnter.bind(_this, day),
          minDate: _this.props.minDate,
          maxDate: _this.props.maxDate,
          excludeDates: _this.props.excludeDates,
          includeDates: _this.props.includeDates,
          inline: _this.props.inline,
          highlightDates: _this.props.highlightDates,
          selectingDate: _this.props.selectingDate,
          filterDate: _this.props.filterDate,
          preSelection: _this.props.preSelection,
          selected: _this.props.selected,
          selectsStart: _this.props.selectsStart,
          selectsEnd: _this.props.selectsEnd,
          startDate: _this.props.startDate,
          endDate: _this.props.endDate,
          dayClassName: _this.props.dayClassName,
          utcOffset: _this.props.utcOffset,
          renderDayContents: _this.props.renderDayContents,
          disabledKeyboardNavigation: _this.props.disabledKeyboardNavigation
        });
      }));
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  Week.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { className: "react-datepicker__week" },
      this.renderDays()
    );
  };

  return Week;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Week.propTypes = {
  disabledKeyboardNavigation: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  day: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  dayClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  endDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  excludeDates: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  filterDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  formatWeekNumber: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  highlightDates: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Map),
  includeDates: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  inline: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  maxDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  minDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  month: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  onDayClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onDayMouseEnter: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onWeekSelect: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  preSelection: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  selected: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  selectingDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  selectsEnd: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  selectsStart: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  showWeekNumber: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  startDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  utcOffset: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  renderDayContents: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

var FIXED_HEIGHT_STANDARD_WEEK_COUNT = 6;

var Month = function (_React$Component) {
  inherits(Month, _React$Component);

  function Month() {
    var _temp, _this, _ret;

    classCallCheck(this, Month);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleDayClick = function (day, event) {
      if (_this.props.onDayClick) {
        _this.props.onDayClick(day, event);
      }
    }, _this.handleDayMouseEnter = function (day) {
      if (_this.props.onDayMouseEnter) {
        _this.props.onDayMouseEnter(day);
      }
    }, _this.handleMouseLeave = function () {
      if (_this.props.onMouseLeave) {
        _this.props.onMouseLeave();
      }
    }, _this.isWeekInMonth = function (startOfWeek) {
      var day = _this.props.day;
      var endOfWeek = addDays(cloneDate(startOfWeek), 6);
      return isSameMonth(startOfWeek, day) || isSameMonth(endOfWeek, day);
    }, _this.renderWeeks = function () {
      var weeks = [];
      var isFixedHeight = _this.props.fixedHeight;
      var currentWeekStart = getStartOfWeek(getStartOfMonth(cloneDate(_this.props.day)));
      var i = 0;
      var breakAfterNextPush = false;

      while (true) {
        weeks.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Week, {
          key: i,
          day: currentWeekStart,
          month: getMonth(_this.props.day),
          onDayClick: _this.handleDayClick,
          onDayMouseEnter: _this.handleDayMouseEnter,
          onWeekSelect: _this.props.onWeekSelect,
          formatWeekNumber: _this.props.formatWeekNumber,
          minDate: _this.props.minDate,
          maxDate: _this.props.maxDate,
          excludeDates: _this.props.excludeDates,
          includeDates: _this.props.includeDates,
          inline: _this.props.inline,
          highlightDates: _this.props.highlightDates,
          selectingDate: _this.props.selectingDate,
          filterDate: _this.props.filterDate,
          preSelection: _this.props.preSelection,
          selected: _this.props.selected,
          selectsStart: _this.props.selectsStart,
          selectsEnd: _this.props.selectsEnd,
          showWeekNumber: _this.props.showWeekNumbers,
          startDate: _this.props.startDate,
          endDate: _this.props.endDate,
          dayClassName: _this.props.dayClassName,
          utcOffset: _this.props.utcOffset,
          disabledKeyboardNavigation: _this.props.disabledKeyboardNavigation,
          renderDayContents: _this.props.renderDayContents
        }));

        if (breakAfterNextPush) break;

        i++;
        currentWeekStart = addWeeks(cloneDate(currentWeekStart), 1);

        // If one of these conditions is true, we will either break on this week
        // or break on the next week
        var isFixedAndFinalWeek = isFixedHeight && i >= FIXED_HEIGHT_STANDARD_WEEK_COUNT;
        var isNonFixedAndOutOfMonth = !isFixedHeight && !_this.isWeekInMonth(currentWeekStart);

        if (isFixedAndFinalWeek || isNonFixedAndOutOfMonth) {
          if (_this.props.peekNextMonth) {
            breakAfterNextPush = true;
          } else {
            break;
          }
        }
      }

      return weeks;
    }, _this.getClassNames = function () {
      var _this$props = _this.props,
          selectingDate = _this$props.selectingDate,
          selectsStart = _this$props.selectsStart,
          selectsEnd = _this$props.selectsEnd;

      return __WEBPACK_IMPORTED_MODULE_2_classnames___default()("react-datepicker__month", {
        "react-datepicker__month--selecting-range": selectingDate && (selectsStart || selectsEnd)
      });
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  Month.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      {
        className: this.getClassNames(),
        onMouseLeave: this.handleMouseLeave,
        role: "listbox",
        "aria-label": "month-" + this.props.day.format("YYYY-MM")
      },
      this.renderWeeks()
    );
  };

  return Month;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Month.propTypes = {
  disabledKeyboardNavigation: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  day: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  dayClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  endDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  excludeDates: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  filterDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  fixedHeight: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  formatWeekNumber: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  highlightDates: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Map),
  includeDates: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  inline: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  maxDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  minDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  onDayClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onDayMouseEnter: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onMouseLeave: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onWeekSelect: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  peekNextMonth: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  preSelection: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  selected: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  selectingDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  selectsEnd: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  selectsStart: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  showWeekNumbers: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  startDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  utcOffset: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  renderDayContents: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

var Time = function (_React$Component) {
  inherits(Time, _React$Component);

  function Time() {
    var _temp, _this, _ret;

    classCallCheck(this, Time);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function (time) {
      if ((_this.props.minTime || _this.props.maxTime) && isTimeInDisabledRange(time, _this.props) || _this.props.excludeTimes && isTimeDisabled(time, _this.props.excludeTimes) || _this.props.includeTimes && !isTimeDisabled(time, _this.props.includeTimes)) {
        return;
      }

      _this.props.onChange(time);
    }, _this.liClasses = function (time, currH, currM) {
      var classes = ["react-datepicker__time-list-item"];

      if (currH === getHour(time) && currM === getMinute(time)) {
        classes.push("react-datepicker__time-list-item--selected");
      }
      if ((_this.props.minTime || _this.props.maxTime) && isTimeInDisabledRange(time, _this.props) || _this.props.excludeTimes && isTimeDisabled(time, _this.props.excludeTimes) || _this.props.includeTimes && !isTimeDisabled(time, _this.props.includeTimes)) {
        classes.push("react-datepicker__time-list-item--disabled");
      }
      if (_this.props.injectTimes && (getHour(time) * 60 + getMinute(time)) % _this.props.intervals !== 0) {
        classes.push("react-datepicker__time-list-item--injected");
      }

      return classes.join(" ");
    }, _this.renderTimes = function () {
      var times = [];
      var format = _this.props.format ? _this.props.format : "hh:mm A";
      var intervals = _this.props.intervals;
      var activeTime = _this.props.selected ? _this.props.selected : newDate();
      var currH = getHour(activeTime);
      var currM = getMinute(activeTime);
      var base = getStartOfDay(newDate());
      var multiplier = 1440 / intervals;
      var sortedInjectTimes = _this.props.injectTimes && _this.props.injectTimes.sort(function (a, b) {
        return a - b;
      });
      for (var i = 0; i < multiplier; i++) {
        var currentTime = addMinutes(cloneDate(base), i * intervals);
        times.push(currentTime);

        if (sortedInjectTimes) {
          var timesToInject = timesToInjectAfter(base, currentTime, i, intervals, sortedInjectTimes);
          times = times.concat(timesToInject);
        }
      }

      return times.map(function (time, i) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "li",
          {
            key: i,
            onClick: _this.handleClick.bind(_this, time),
            className: _this.liClasses(time, currH, currM),
            ref: function ref(li) {
              if (currH === getHour(time) && currM === getMinute(time) || currH === getHour(time) && !_this.centerLi) {
                _this.centerLi = li;
              }
            }
          },
          formatDate(time, format)
        );
      });
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  Time.prototype.componentDidMount = function componentDidMount() {
    // code to ensure selected time will always be in focus within time window when it first appears
    this.list.scrollTop = Time.calcCenterPosition(this.props.monthRef ? this.props.monthRef.clientHeight - this.header.clientHeight : this.list.clientHeight, this.centerLi);
  };

  Time.prototype.render = function render() {
    var _this2 = this;

    var height = null;
    if (this.props.monthRef && this.header) {
      height = this.props.monthRef.clientHeight - this.header.clientHeight;
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      {
        className: "react-datepicker__time-container " + (this.props.todayButton ? "react-datepicker__time-container--with-today-button" : "")
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        {
          className: "react-datepicker__header react-datepicker__header--time",
          ref: function ref(header) {
            _this2.header = header;
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "react-datepicker-time__header" },
          this.props.timeCaption
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: "react-datepicker__time" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "react-datepicker__time-box" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "ul",
            {
              className: "react-datepicker__time-list",
              ref: function ref(list) {
                _this2.list = list;
              },
              style: height ? { height: height } : {}
            },
            this.renderTimes.bind(this)()
          )
        )
      )
    );
  };

  createClass(Time, null, [{
    key: "defaultProps",
    get: function get$$1() {
      return {
        intervals: 30,
        onTimeChange: function onTimeChange() {},
        todayButton: null,
        timeCaption: "Time"
      };
    }
  }]);
  return Time;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Time.propTypes = {
  format: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  includeTimes: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  intervals: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  selected: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  todayButton: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  minTime: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  maxTime: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  excludeTimes: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  monthRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  timeCaption: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  injectTimes: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array
};

Time.calcCenterPosition = function (listHeight, centerLiRef) {
  return centerLiRef.offsetTop - (listHeight / 2 - centerLiRef.clientHeight / 2);
};

function CalendarContainer(_ref) {
  var className = _ref.className,
      children = _ref.children,
      _ref$arrowProps = _ref.arrowProps,
      arrowProps = _ref$arrowProps === undefined ? {} : _ref$arrowProps;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { className: className },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", _extends({ className: "react-datepicker__triangle" }, arrowProps)),
    children
  );
}

CalendarContainer.propTypes = {
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  arrowProps: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object // react-popper arrow props
};

var DROPDOWN_FOCUS_CLASSNAMES = ["react-datepicker__year-select", "react-datepicker__month-select", "react-datepicker__month-year-select"];

var isDropdownSelect = function isDropdownSelect() {
  var element = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var classNames = (element.className || "").split(/\s+/);
  return DROPDOWN_FOCUS_CLASSNAMES.some(function (testClassname) {
    return classNames.indexOf(testClassname) >= 0;
  });
};

var Calendar = function (_React$Component) {
  inherits(Calendar, _React$Component);
  createClass(Calendar, null, [{
    key: "defaultProps",
    get: function get$$1() {
      return {
        onDropdownFocus: function onDropdownFocus() {},
        monthsShown: 1,
        forceShowMonthNavigation: false,
        timeCaption: "Time",
        previousMonthButtonLabel: "Previous Month",
        nextMonthButtonLabel: "Next Month"
      };
    }
  }]);

  function Calendar(props) {
    classCallCheck(this, Calendar);

    var _this = possibleConstructorReturn(this, _React$Component.call(this, props));

    _this.handleClickOutside = function (event) {
      _this.props.onClickOutside(event);
    };

    _this.handleDropdownFocus = function (event) {
      if (isDropdownSelect(event.target)) {
        _this.props.onDropdownFocus();
      }
    };

    _this.getDateInView = function () {
      var _this$props = _this.props,
          preSelection = _this$props.preSelection,
          selected = _this$props.selected,
          openToDate = _this$props.openToDate,
          utcOffset = _this$props.utcOffset;

      var minDate = getEffectiveMinDate(_this.props);
      var maxDate = getEffectiveMaxDate(_this.props);
      var current = now(utcOffset);
      var initialDate = openToDate || selected || preSelection;
      if (initialDate) {
        return initialDate;
      } else {
        if (minDate && isBefore(current, minDate)) {
          return minDate;
        } else if (maxDate && isAfter(current, maxDate)) {
          return maxDate;
        }
      }
      return current;
    };

    _this.localizeDate = function (date) {
      return localizeDate(date, _this.props.locale);
    };

    _this.increaseMonth = function () {
      _this.setState({
        date: addMonths(cloneDate(_this.state.date), 1)
      }, function () {
        return _this.handleMonthChange(_this.state.date);
      });
    };

    _this.decreaseMonth = function () {
      _this.setState({
        date: subtractMonths(cloneDate(_this.state.date), 1)
      }, function () {
        return _this.handleMonthChange(_this.state.date);
      });
    };

    _this.handleDayClick = function (day, event) {
      return _this.props.onSelect(day, event);
    };

    _this.handleDayMouseEnter = function (day) {
      return _this.setState({ selectingDate: day });
    };

    _this.handleMonthMouseLeave = function () {
      return _this.setState({ selectingDate: null });
    };

    _this.handleYearChange = function (date) {
      if (_this.props.onYearChange) {
        _this.props.onYearChange(date);
      }
    };

    _this.handleMonthChange = function (date) {
      if (_this.props.onMonthChange) {
        _this.props.onMonthChange(date);
      }
      if (_this.props.adjustDateOnChange) {
        if (_this.props.onSelect) {
          _this.props.onSelect(date);
        }
        if (_this.props.setOpen) {
          _this.props.setOpen(true);
        }
      }
    };

    _this.handleMonthYearChange = function (date) {
      _this.handleYearChange(date);
      _this.handleMonthChange(date);
    };

    _this.changeYear = function (year) {
      _this.setState({
        date: setYear(cloneDate(_this.state.date), year)
      }, function () {
        return _this.handleYearChange(_this.state.date);
      });
    };

    _this.changeMonth = function (month) {
      _this.setState({
        date: setMonth(cloneDate(_this.state.date), month)
      }, function () {
        return _this.handleMonthChange(_this.state.date);
      });
    };

    _this.changeMonthYear = function (monthYear) {
      _this.setState({
        date: setYear(setMonth(cloneDate(_this.state.date), getMonth(monthYear)), getYear(monthYear))
      }, function () {
        return _this.handleMonthYearChange(_this.state.date);
      });
    };

    _this.header = function () {
      var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.state.date;

      var startOfWeek = getStartOfWeek(cloneDate(date));
      var dayNames = [];
      if (_this.props.showWeekNumbers) {
        dayNames.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { key: "W", className: "react-datepicker__day-name" },
          _this.props.weekLabel || "#"
        ));
      }
      return dayNames.concat([0, 1, 2, 3, 4, 5, 6].map(function (offset) {
        var day = addDays(cloneDate(startOfWeek), offset);
        var localeData = getLocaleData(day);
        var weekDayName = _this.formatWeekday(localeData, day);

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { key: offset, className: "react-datepicker__day-name" },
          weekDayName
        );
      }));
    };

    _this.formatWeekday = function (localeData, day) {
      if (_this.props.formatWeekDay) {
        return getFormattedWeekdayInLocale(localeData, day, _this.props.formatWeekDay);
      }
      return _this.props.useWeekdaysShort ? getWeekdayShortInLocale(localeData, day) : getWeekdayMinInLocale(localeData, day);
    };

    _this.renderPreviousMonthButton = function () {
      if (_this.props.renderCustomHeader) {
        return;
      }

      var allPrevDaysDisabled = allDaysDisabledBefore(_this.state.date, "month", _this.props);

      if (!_this.props.forceShowMonthNavigation && !_this.props.showDisabledMonthNavigation && allPrevDaysDisabled || _this.props.showTimeSelectOnly) {
        return;
      }

      var classes = ["react-datepicker__navigation", "react-datepicker__navigation--previous"];

      var clickHandler = _this.decreaseMonth;

      if (allPrevDaysDisabled && _this.props.showDisabledMonthNavigation) {
        classes.push("react-datepicker__navigation--previous--disabled");
        clickHandler = null;
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "button",
        {
          type: "button",
          className: classes.join(" "),
          onClick: clickHandler
        },
        _this.props.previousMonthButtonLabel
      );
    };

    _this.renderNextMonthButton = function () {
      if (_this.props.renderCustomHeader) {
        return;
      }

      var allNextDaysDisabled = allDaysDisabledAfter(_this.state.date, "month", _this.props);

      if (!_this.props.forceShowMonthNavigation && !_this.props.showDisabledMonthNavigation && allNextDaysDisabled || _this.props.showTimeSelectOnly) {
        return;
      }

      var classes = ["react-datepicker__navigation", "react-datepicker__navigation--next"];
      if (_this.props.showTimeSelect) {
        classes.push("react-datepicker__navigation--next--with-time");
      }
      if (_this.props.todayButton) {
        classes.push("react-datepicker__navigation--next--with-today-button");
      }

      var clickHandler = _this.increaseMonth;

      if (allNextDaysDisabled && _this.props.showDisabledMonthNavigation) {
        classes.push("react-datepicker__navigation--next--disabled");
        clickHandler = null;
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "button",
        {
          type: "button",
          className: classes.join(" "),
          onClick: clickHandler
        },
        _this.props.nextMonthButtonLabel
      );
    };

    _this.renderCurrentMonth = function () {
      var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.state.date;

      var classes = ["react-datepicker__current-month"];

      if (_this.props.showYearDropdown) {
        classes.push("react-datepicker__current-month--hasYearDropdown");
      }
      if (_this.props.showMonthDropdown) {
        classes.push("react-datepicker__current-month--hasMonthDropdown");
      }
      if (_this.props.showMonthYearDropdown) {
        classes.push("react-datepicker__current-month--hasMonthYearDropdown");
      }
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: classes.join(" ") },
        formatDate(date, _this.props.dateFormat)
      );
    };

    _this.renderYearDropdown = function () {
      var overrideHide = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (!_this.props.showYearDropdown || overrideHide) {
        return;
      }
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(YearDropdown, {
        adjustDateOnChange: _this.props.adjustDateOnChange,
        date: _this.state.date,
        onSelect: _this.props.onSelect,
        setOpen: _this.props.setOpen,
        dropdownMode: _this.props.dropdownMode,
        onChange: _this.changeYear,
        minDate: _this.props.minDate,
        maxDate: _this.props.maxDate,
        year: getYear(_this.state.date),
        scrollableYearDropdown: _this.props.scrollableYearDropdown,
        yearDropdownItemNumber: _this.props.yearDropdownItemNumber
      });
    };

    _this.renderMonthDropdown = function () {
      var overrideHide = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (!_this.props.showMonthDropdown || overrideHide) {
        return;
      }
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MonthDropdown, {
        dropdownMode: _this.props.dropdownMode,
        locale: _this.props.locale,
        dateFormat: _this.props.dateFormat,
        onChange: _this.changeMonth,
        month: getMonth(_this.state.date),
        useShortMonthInDropdown: _this.props.useShortMonthInDropdown
      });
    };

    _this.renderMonthYearDropdown = function () {
      var overrideHide = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (!_this.props.showMonthYearDropdown || overrideHide) {
        return;
      }
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MonthYearDropdown, {
        dropdownMode: _this.props.dropdownMode,
        locale: _this.props.locale,
        dateFormat: _this.props.dateFormat,
        onChange: _this.changeMonthYear,
        minDate: _this.props.minDate,
        maxDate: _this.props.maxDate,
        date: _this.state.date,
        scrollableMonthYearDropdown: _this.props.scrollableMonthYearDropdown
      });
    };

    _this.renderTodayButton = function () {
      if (!_this.props.todayButton || _this.props.showTimeSelectOnly) {
        return;
      }
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        {
          className: "react-datepicker__today-button",
          onClick: function onClick(e) {
            return _this.props.onSelect(getStartOfDate(now(_this.props.utcOffset)), e);
          }
        },
        _this.props.todayButton
      );
    };

    _this.renderDefaultHeader = function (_ref) {
      var monthDate = _ref.monthDate,
          i = _ref.i;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: "react-datepicker__header" },
        _this.renderCurrentMonth(monthDate),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          {
            className: "react-datepicker__header__dropdown react-datepicker__header__dropdown--" + _this.props.dropdownMode,
            onFocus: _this.handleDropdownFocus
          },
          _this.renderMonthDropdown(i !== 0),
          _this.renderMonthYearDropdown(i !== 0),
          _this.renderYearDropdown(i !== 0)
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "react-datepicker__day-names" },
          _this.header(monthDate)
        )
      );
    };

    _this.renderCustomHeader = function (_ref2) {
      var monthDate = _ref2.monthDate,
          i = _ref2.i;

      if (i !== 0) {
        return null;
      }

      var prevMonthButtonDisabled = allDaysDisabledBefore(_this.state.date, "month", _this.props);

      var nextMonthButtonDisabled = allDaysDisabledAfter(_this.state.date, "month", _this.props);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        {
          className: "react-datepicker__header react-datepicker__header--custom",
          onFocus: _this.props.onDropdownFocus
        },
        _this.props.renderCustomHeader(_extends({}, _this.state, {
          changeMonth: _this.changeMonth,
          changeYear: _this.changeYear,
          decreaseMonth: _this.decreaseMonth,
          increaseMonth: _this.increaseMonth,
          prevMonthButtonDisabled: prevMonthButtonDisabled,
          nextMonthButtonDisabled: nextMonthButtonDisabled
        })),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "react-datepicker__day-names" },
          _this.header(monthDate)
        )
      );
    };

    _this.renderMonths = function () {
      if (_this.props.showTimeSelectOnly) {
        return;
      }

      var monthList = [];
      for (var i = 0; i < _this.props.monthsShown; ++i) {
        var monthDate = addMonths(cloneDate(_this.state.date), i);
        var monthKey = "month-" + i;
        monthList.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          {
            key: monthKey,
            ref: function ref(div) {
              _this.monthContainer = div;
            },
            className: "react-datepicker__month-container"
          },
          _this.props.renderCustomHeader ? _this.renderCustomHeader({ monthDate: monthDate, i: i }) : _this.renderDefaultHeader({ monthDate: monthDate, i: i }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Month, {
            day: monthDate,
            dayClassName: _this.props.dayClassName,
            onDayClick: _this.handleDayClick,
            onDayMouseEnter: _this.handleDayMouseEnter,
            onMouseLeave: _this.handleMonthMouseLeave,
            onWeekSelect: _this.props.onWeekSelect,
            formatWeekNumber: _this.props.formatWeekNumber,
            minDate: _this.props.minDate,
            maxDate: _this.props.maxDate,
            excludeDates: _this.props.excludeDates,
            highlightDates: _this.props.highlightDates,
            selectingDate: _this.state.selectingDate,
            includeDates: _this.props.includeDates,
            inline: _this.props.inline,
            fixedHeight: _this.props.fixedHeight,
            filterDate: _this.props.filterDate,
            preSelection: _this.props.preSelection,
            selected: _this.props.selected,
            selectsStart: _this.props.selectsStart,
            selectsEnd: _this.props.selectsEnd,
            showWeekNumbers: _this.props.showWeekNumbers,
            startDate: _this.props.startDate,
            endDate: _this.props.endDate,
            peekNextMonth: _this.props.peekNextMonth,
            utcOffset: _this.props.utcOffset,
            renderDayContents: _this.props.renderDayContents,
            disabledKeyboardNavigation: _this.props.disabledKeyboardNavigation
          })
        ));
      }
      return monthList;
    };

    _this.renderTimeSection = function () {
      if (_this.props.showTimeSelect && (_this.state.monthContainer || _this.props.showTimeSelectOnly)) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Time, {
          selected: _this.props.selected,
          onChange: _this.props.onTimeChange,
          format: _this.props.timeFormat,
          includeTimes: _this.props.includeTimes,
          intervals: _this.props.timeIntervals,
          minTime: _this.props.minTime,
          maxTime: _this.props.maxTime,
          excludeTimes: _this.props.excludeTimes,
          timeCaption: _this.props.timeCaption,
          todayButton: _this.props.todayButton,
          showMonthDropdown: _this.props.showMonthDropdown,
          showMonthYearDropdown: _this.props.showMonthYearDropdown,
          showYearDropdown: _this.props.showYearDropdown,
          withPortal: _this.props.withPortal,
          monthRef: _this.state.monthContainer,
          injectTimes: _this.props.injectTimes
        });
      }
    };

    _this.state = {
      date: _this.localizeDate(_this.getDateInView()),
      selectingDate: null,
      monthContainer: null
    };
    return _this;
  }

  Calendar.prototype.componentDidMount = function componentDidMount() {
    var _this2 = this;

    // monthContainer height is needed in time component
    // to determine the height for the ul in the time component
    // setState here so height is given after final component
    // layout is rendered
    if (this.props.showTimeSelect) {
      this.assignMonthContainer = function () {
        _this2.setState({ monthContainer: _this2.monthContainer });
      }();
    }
  };

  Calendar.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (this.props.preSelection && !isSameDay(this.props.preSelection, prevProps.preSelection)) {
      this.setState({
        date: this.localizeDate(this.props.preSelection)
      });
    } else if (this.props.openToDate && !isSameDay(this.props.openToDate, prevProps.openToDate)) {
      this.setState({
        date: this.localizeDate(this.props.openToDate)
      });
    }
  };

  Calendar.prototype.render = function render() {
    var Container = this.props.container || CalendarContainer;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      Container,
      {
        className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()("react-datepicker", this.props.className, {
          "react-datepicker--time-only": this.props.showTimeSelectOnly
        })
      },
      this.renderPreviousMonthButton(),
      this.renderNextMonthButton(),
      this.renderMonths(),
      this.renderTodayButton(),
      this.renderTimeSection(),
      this.props.children
    );
  };

  return Calendar;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Calendar.propTypes = {
  adjustDateOnChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  container: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  dateFormat: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array]).isRequired,
  dayClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  disabledKeyboardNavigation: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  dropdownMode: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["scroll", "select"]),
  endDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  excludeDates: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  filterDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  fixedHeight: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  formatWeekNumber: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  highlightDates: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Map),
  includeDates: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  includeTimes: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  injectTimes: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  inline: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  locale: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  maxDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  minDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  monthsShown: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  onClickOutside: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  onMonthChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onYearChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  forceShowMonthNavigation: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  onDropdownFocus: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onSelect: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  onWeekSelect: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  showTimeSelect: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  showTimeSelectOnly: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  timeFormat: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  timeIntervals: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  onTimeChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  minTime: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  maxTime: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  excludeTimes: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  timeCaption: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  openToDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  peekNextMonth: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  scrollableYearDropdown: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  scrollableMonthYearDropdown: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  preSelection: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  selected: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  selectsEnd: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  selectsStart: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  showMonthDropdown: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  showMonthYearDropdown: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  showWeekNumbers: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  showYearDropdown: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  startDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  todayButton: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  useWeekdaysShort: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  formatWeekDay: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  withPortal: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  utcOffset: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  weekLabel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  yearDropdownItemNumber: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  setOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  useShortMonthInDropdown: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  showDisabledMonthNavigation: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  previousMonthButtonLabel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  nextMonthButtonLabel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  renderCustomHeader: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  renderDayContents: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

var popperPlacementPositions = ["bottom", "bottom-end", "bottom-start", "left", "left-end", "left-start", "right", "right-end", "right-start", "top", "top-end", "top-start"];

var PopperComponent = function (_React$Component) {
  inherits(PopperComponent, _React$Component);

  function PopperComponent() {
    classCallCheck(this, PopperComponent);
    return possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  PopperComponent.prototype.render = function render() {
    var _props = this.props,
        className = _props.className,
        hidePopper = _props.hidePopper,
        popperComponent = _props.popperComponent,
        popperModifiers = _props.popperModifiers,
        popperPlacement = _props.popperPlacement,
        popperProps = _props.popperProps,
        targetComponent = _props.targetComponent;


    var popper = void 0;

    if (!hidePopper) {
      var classes = __WEBPACK_IMPORTED_MODULE_2_classnames___default()("react-datepicker-popper", className);
      popper = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5_react_popper__["b" /* Popper */],
        _extends({
          modifiers: popperModifiers,
          placement: popperPlacement
        }, popperProps),
        function (_ref) {
          var ref = _ref.ref,
              style = _ref.style,
              placement = _ref.placement,
              arrowProps = _ref.arrowProps;
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            _extends({ ref: ref, style: style }, {
              className: classes,
              "data-placement": placement
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(popperComponent, { arrowProps: arrowProps })
          );
        }
      );
    }

    if (this.props.popperContainer) {
      popper = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(this.props.popperContainer, {}, popper);
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_5_react_popper__["a" /* Manager */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5_react_popper__["c" /* Reference */],
        null,
        function (_ref2) {
          var ref = _ref2.ref;
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { ref: ref, className: "react-datepicker-wrapper" },
            targetComponent
          );
        }
      ),
      popper
    );
  };

  createClass(PopperComponent, null, [{
    key: "defaultProps",
    get: function get$$1() {
      return {
        hidePopper: true,
        popperModifiers: {
          preventOverflow: {
            enabled: true,
            escapeWithReference: true,
            boundariesElement: "viewport"
          }
        },
        popperProps: {},
        popperPlacement: "bottom-start"
      };
    }
  }]);
  return PopperComponent;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

PopperComponent.propTypes = {
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  hidePopper: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  popperComponent: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element,
  popperModifiers: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, // <datepicker/> props
  popperPlacement: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(popperPlacementPositions), // <datepicker/> props
  popperContainer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  popperProps: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  targetComponent: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element
};

var outsideClickIgnoreClass = "react-datepicker-ignore-onclickoutside";
var WrappedCalendar = Object(__WEBPACK_IMPORTED_MODULE_3_react_onclickoutside__["a" /* default */])(Calendar);

// Compares dates year+month combinations
function hasPreSelectionChanged(date1, date2) {
  if (date1 && date2) {
    return getMonth(date1) !== getMonth(date2) || getYear(date1) !== getYear(date2);
  }

  return date1 !== date2;
}

function hasSelectionChanged(date1, date2) {
  if (date1 && date2) {
    return !equals(date1, date2);
  }

  return false;
}

/**
 * General datepicker component.
 */
var INPUT_ERR_1 = "Date input not valid.";

var DatePicker = function (_React$Component) {
  inherits(DatePicker, _React$Component);
  createClass(DatePicker, null, [{
    key: "defaultProps",
    get: function get$$1() {
      return {
        allowSameDay: false,
        dateFormat: "L",
        dateFormatCalendar: "MMMM YYYY",
        onChange: function onChange() {},

        disabled: false,
        disabledKeyboardNavigation: false,
        dropdownMode: "scroll",
        onFocus: function onFocus() {},
        onBlur: function onBlur() {},
        onKeyDown: function onKeyDown() {},
        onInputClick: function onInputClick() {},
        onSelect: function onSelect() {},
        onClickOutside: function onClickOutside$$1() {},
        onMonthChange: function onMonthChange() {},

        preventOpenOnFocus: false,
        onYearChange: function onYearChange() {},
        onInputError: function onInputError() {},

        monthsShown: 1,
        readOnly: false,
        withPortal: false,
        shouldCloseOnSelect: true,
        showTimeSelect: false,
        timeIntervals: 30,
        timeCaption: "Time",
        previousMonthButtonLabel: "Previous Month",
        nextMonthButtonLabel: "Next month",
        renderDayContents: function renderDayContents(date) {
          return date;
        }
      };
    }
  }]);

  function DatePicker(props) {
    classCallCheck(this, DatePicker);

    var _this = possibleConstructorReturn(this, _React$Component.call(this, props));

    _this.getPreSelection = function () {
      return _this.props.openToDate ? newDate(_this.props.openToDate) : _this.props.selectsEnd && _this.props.startDate ? newDate(_this.props.startDate) : _this.props.selectsStart && _this.props.endDate ? newDate(_this.props.endDate) : now(_this.props.utcOffset);
    };

    _this.calcInitialState = function () {
      var defaultPreSelection = _this.getPreSelection();
      var minDate = getEffectiveMinDate(_this.props);
      var maxDate = getEffectiveMaxDate(_this.props);
      var boundedPreSelection = minDate && isBefore(defaultPreSelection, minDate) ? minDate : maxDate && isAfter(defaultPreSelection, maxDate) ? maxDate : defaultPreSelection;
      return {
        open: _this.props.startOpen || false,
        preventFocus: false,
        preSelection: _this.props.selected ? newDate(_this.props.selected) : boundedPreSelection,
        // transforming highlighted days (perhaps nested array)
        // to flat Map for faster access in day.jsx
        highlightDates: getHightLightDaysMap(_this.props.highlightDates),
        focused: false
      };
    };

    _this.clearPreventFocusTimeout = function () {
      if (_this.preventFocusTimeout) {
        clearTimeout(_this.preventFocusTimeout);
      }
    };

    _this.setFocus = function () {
      if (_this.input && _this.input.focus) {
        _this.input.focus();
      }
    };

    _this.setBlur = function () {
      if (_this.input && _this.input.blur) {
        _this.input.blur();
      }

      if (_this.props.onBlur) {
        _this.props.onBlur();
      }

      _this.cancelFocusInput();
    };

    _this.setOpen = function (open) {
      var skipSetBlur = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      _this.setState({
        open: open,
        preSelection: open && _this.state.open ? _this.state.preSelection : _this.calcInitialState().preSelection,
        lastPreSelectChange: PRESELECT_CHANGE_VIA_NAVIGATE
      }, function () {
        if (!open) {
          _this.setState(function (prev) {
            return {
              focused: skipSetBlur ? prev.focused : false
            };
          }, function () {
            !skipSetBlur && _this.setBlur();

            _this.setState({ inputValue: null });
          });
        }
      });
    };

    _this.inputOk = function () {
      return isMoment(_this.state.preSelection) || isDate(_this.state.preSelection);
    };

    _this.isCalendarOpen = function () {
      return _this.props.open === undefined ? _this.state.open && !_this.props.disabled && !_this.props.readOnly : _this.props.open;
    };

    _this.handleFocus = function (event) {
      if (!_this.state.preventFocus) {
        _this.props.onFocus(event);
        if (!_this.props.preventOpenOnFocus && !_this.props.readOnly) {
          _this.setOpen(true);
        }
      }
      _this.setState({ focused: true });
    };

    _this.cancelFocusInput = function () {
      clearTimeout(_this.inputFocusTimeout);
      _this.inputFocusTimeout = null;
    };

    _this.deferFocusInput = function () {
      _this.cancelFocusInput();
      _this.inputFocusTimeout = setTimeout(function () {
        return _this.setFocus();
      }, 1);
    };

    _this.handleDropdownFocus = function () {
      _this.cancelFocusInput();
    };

    _this.handleBlur = function (event) {
      if (_this.state.open && !_this.props.withPortal) {
        _this.deferFocusInput();
      } else {
        _this.props.onBlur(event);
      }
      _this.setState({ focused: false });
    };

    _this.handleCalendarClickOutside = function (event) {
      if (!_this.props.inline) {
        _this.setOpen(false);
      }
      _this.props.onClickOutside(event);
      if (_this.props.withPortal) {
        event.preventDefault();
      }
    };

    _this.handleChange = function () {
      for (var _len = arguments.length, allArgs = Array(_len), _key = 0; _key < _len; _key++) {
        allArgs[_key] = arguments[_key];
      }

      var event = allArgs[0];
      if (_this.props.onChangeRaw) {
        _this.props.onChangeRaw.apply(_this, allArgs);
        if (typeof event.isDefaultPrevented !== "function" || event.isDefaultPrevented()) {
          return;
        }
      }
      _this.setState({
        inputValue: event.target.value,
        lastPreSelectChange: PRESELECT_CHANGE_VIA_INPUT
      });
      var date = parseDate(event.target.value, _this.props);
      if (date || !event.target.value) {
        _this.setSelected(date, event, true);
      }
    };

    _this.handleSelect = function (date, event) {
      // Preventing onFocus event to fix issue
      // https://github.com/Hacker0x01/react-datepicker/issues/628
      _this.setState({ preventFocus: true }, function () {
        _this.preventFocusTimeout = setTimeout(function () {
          return _this.setState({ preventFocus: false });
        }, 50);
        return _this.preventFocusTimeout;
      });
      _this.setSelected(date, event);
      if (!_this.props.shouldCloseOnSelect || _this.props.showTimeSelect) {
        _this.setPreSelection(date);
      } else if (!_this.props.inline) {
        _this.setOpen(false);
      }
    };

    _this.setSelected = function (date, event, keepInput) {
      var changedDate = date;

      if (changedDate !== null && isDayDisabled(changedDate, _this.props)) {
        if (isOutOfBounds(changedDate, _this.props)) {
          _this.props.onChange(date, event);
          _this.props.onSelect(changedDate, event);
        }

        return;
      }

      if (!isSameDay(_this.props.selected, changedDate) || _this.props.allowSameDay) {
        if (changedDate !== null) {
          if (_this.props.selected) {
            var selected = _this.props.selected;
            if (keepInput) selected = newDate(changedDate);
            changedDate = setTime(newDate(changedDate), {
              hour: getHour(selected),
              minute: getMinute(selected),
              second: getSecond(selected)
            });
          }
          if (!_this.props.inline) {
            _this.setState({
              preSelection: changedDate
            });
          }
        }
        _this.props.onChange(changedDate, event);
      }

      _this.props.onSelect(changedDate, event);

      if (!keepInput) {
        _this.setState({ inputValue: null });
      }
    };

    _this.setPreSelection = function (date) {
      var isDateRangePresent = typeof _this.props.minDate !== "undefined" && typeof _this.props.maxDate !== "undefined";
      var isValidDateSelection = isDateRangePresent && date ? isDayInRange(date, _this.props.minDate, _this.props.maxDate) : true;
      if (isValidDateSelection) {
        _this.setState({
          preSelection: date
        });
      }
    };

    _this.handleTimeChange = function (time) {
      var selected = _this.props.selected ? _this.props.selected : _this.getPreSelection();
      var changedDate = setTime(cloneDate(selected), {
        hour: getHour(time),
        minute: getMinute(time)
      });

      _this.setState({
        preSelection: changedDate
      });

      _this.props.onChange(changedDate);
      if (_this.props.shouldCloseOnSelect) {
        _this.setOpen(false);
      }
      _this.setState({ inputValue: null });
    };

    _this.onInputClick = function () {
      if (!_this.props.disabled && !_this.props.readOnly) {
        _this.setOpen(true);
      }

      _this.props.onInputClick();
    };

    _this.onInputKeyDown = function (event) {
      _this.props.onKeyDown(event);
      var eventKey = event.key;
      if (!_this.state.open && !_this.props.inline && !_this.props.preventOpenOnFocus) {
        if (eventKey === "ArrowDown" || eventKey === "ArrowUp") {
          _this.onInputClick();
        }
        return;
      }
      var copy = newDate(_this.state.preSelection);
      if (eventKey === "Enter") {
        event.preventDefault();
        if (_this.inputOk() && _this.state.lastPreSelectChange === PRESELECT_CHANGE_VIA_NAVIGATE) {
          _this.handleSelect(copy, event);
          !_this.props.shouldCloseOnSelect && _this.setPreSelection(copy);
        } else {
          _this.setOpen(false);
        }
      } else if (eventKey === "Escape") {
        event.preventDefault();

        _this.setOpen(false);
        if (!_this.inputOk()) {
          _this.props.onInputError({ code: 1, msg: INPUT_ERR_1 });
        }
      } else if (eventKey === "Tab") {
        _this.setOpen(false, true);
      } else if (!_this.props.disabledKeyboardNavigation) {
        var newSelection = void 0;
        switch (eventKey) {
          case "ArrowLeft":
            newSelection = subtractDays(copy, 1);
            break;
          case "ArrowRight":
            newSelection = addDays(copy, 1);
            break;
          case "ArrowUp":
            newSelection = subtractWeeks(copy, 1);
            break;
          case "ArrowDown":
            newSelection = addWeeks(copy, 1);
            break;
          case "PageUp":
            newSelection = subtractMonths(copy, 1);
            break;
          case "PageDown":
            newSelection = addMonths(copy, 1);
            break;
          case "Home":
            newSelection = subtractYears(copy, 1);
            break;
          case "End":
            newSelection = addYears(copy, 1);
            break;
        }
        if (!newSelection) {
          if (_this.props.onInputError) {
            _this.props.onInputError({ code: 1, msg: INPUT_ERR_1 });
          }
          return; // Let the input component handle this keydown
        }
        event.preventDefault();
        _this.setState({ lastPreSelectChange: PRESELECT_CHANGE_VIA_NAVIGATE });
        if (_this.props.adjustDateOnChange) {
          _this.setSelected(newSelection);
        }
        _this.setPreSelection(newSelection);
      }
    };

    _this.onClearClick = function (event) {
      if (event) {
        if (event.preventDefault) {
          event.preventDefault();
        }
      }
      _this.props.onChange(null, event);
      _this.setState({ inputValue: null });
    };

    _this.clear = function () {
      _this.onClearClick();
    };

    _this.renderCalendar = function () {
      if (!_this.props.inline && !_this.isCalendarOpen()) {
        return null;
      }
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        WrappedCalendar,
        {
          ref: function ref(elem) {
            _this.calendar = elem;
          },
          locale: _this.props.locale,
          adjustDateOnChange: _this.props.adjustDateOnChange,
          setOpen: _this.setOpen,
          dateFormat: _this.props.dateFormatCalendar,
          useWeekdaysShort: _this.props.useWeekdaysShort,
          formatWeekDay: _this.props.formatWeekDay,
          dropdownMode: _this.props.dropdownMode,
          selected: _this.props.selected,
          preSelection: _this.state.preSelection,
          onSelect: _this.handleSelect,
          onWeekSelect: _this.props.onWeekSelect,
          openToDate: _this.props.openToDate,
          minDate: _this.props.minDate,
          maxDate: _this.props.maxDate,
          selectsStart: _this.props.selectsStart,
          selectsEnd: _this.props.selectsEnd,
          startDate: _this.props.startDate,
          endDate: _this.props.endDate,
          excludeDates: _this.props.excludeDates,
          filterDate: _this.props.filterDate,
          onClickOutside: _this.handleCalendarClickOutside,
          formatWeekNumber: _this.props.formatWeekNumber,
          highlightDates: _this.state.highlightDates,
          includeDates: _this.props.includeDates,
          includeTimes: _this.props.includeTimes,
          injectTimes: _this.props.injectTimes,
          inline: _this.props.inline,
          peekNextMonth: _this.props.peekNextMonth,
          showMonthDropdown: _this.props.showMonthDropdown,
          useShortMonthInDropdown: _this.props.useShortMonthInDropdown,
          showMonthYearDropdown: _this.props.showMonthYearDropdown,
          showWeekNumbers: _this.props.showWeekNumbers,
          showYearDropdown: _this.props.showYearDropdown,
          withPortal: _this.props.withPortal,
          forceShowMonthNavigation: _this.props.forceShowMonthNavigation,
          showDisabledMonthNavigation: _this.props.showDisabledMonthNavigation,
          scrollableYearDropdown: _this.props.scrollableYearDropdown,
          scrollableMonthYearDropdown: _this.props.scrollableMonthYearDropdown,
          todayButton: _this.props.todayButton,
          weekLabel: _this.props.weekLabel,
          utcOffset: _this.props.utcOffset,
          outsideClickIgnoreClass: outsideClickIgnoreClass,
          fixedHeight: _this.props.fixedHeight,
          monthsShown: _this.props.monthsShown,
          onDropdownFocus: _this.handleDropdownFocus,
          onMonthChange: _this.props.onMonthChange,
          onYearChange: _this.props.onYearChange,
          dayClassName: _this.props.dayClassName,
          showTimeSelect: _this.props.showTimeSelect,
          showTimeSelectOnly: _this.props.showTimeSelectOnly,
          onTimeChange: _this.handleTimeChange,
          timeFormat: _this.props.timeFormat,
          timeIntervals: _this.props.timeIntervals,
          minTime: _this.props.minTime,
          maxTime: _this.props.maxTime,
          excludeTimes: _this.props.excludeTimes,
          timeCaption: _this.props.timeCaption,
          className: _this.props.calendarClassName,
          container: _this.props.calendarContainer,
          yearDropdownItemNumber: _this.props.yearDropdownItemNumber,
          previousMonthButtonLabel: _this.props.previousMonthButtonLabel,
          nextMonthButtonLabel: _this.props.nextMonthButtonLabel,
          disabledKeyboardNavigation: _this.props.disabledKeyboardNavigation,
          renderCustomHeader: _this.props.renderCustomHeader,
          popperProps: _this.props.popperProps,
          renderDayContents: _this.props.renderDayContents
        },
        _this.props.children
      );
    };

    _this.renderDateInput = function () {
      var _classnames, _React$cloneElement;

      var className = __WEBPACK_IMPORTED_MODULE_2_classnames___default()(_this.props.className, (_classnames = {}, _classnames[outsideClickIgnoreClass] = _this.state.open, _classnames));

      var customInput = _this.props.customInput || __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", { type: "text" });
      var customInputRef = _this.props.customInputRef || "ref";
      var inputValue = typeof _this.props.value === "string" ? _this.props.value : typeof _this.state.inputValue === "string" ? _this.state.inputValue : safeDateFormat(_this.props.selected, _this.props);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(customInput, (_React$cloneElement = {}, _React$cloneElement[customInputRef] = function (input) {
        _this.input = input;
      }, _React$cloneElement.value = inputValue, _React$cloneElement.onBlur = _this.handleBlur, _React$cloneElement.onChange = _this.handleChange, _React$cloneElement.onClick = _this.onInputClick, _React$cloneElement.onFocus = _this.handleFocus, _React$cloneElement.onKeyDown = _this.onInputKeyDown, _React$cloneElement.id = _this.props.id, _React$cloneElement.name = _this.props.name, _React$cloneElement.autoFocus = _this.props.autoFocus, _React$cloneElement.placeholder = _this.props.placeholderText, _React$cloneElement.disabled = _this.props.disabled, _React$cloneElement.autoComplete = _this.props.autoComplete, _React$cloneElement.className = className, _React$cloneElement.title = _this.props.title, _React$cloneElement.readOnly = _this.props.readOnly, _React$cloneElement.required = _this.props.required, _React$cloneElement.tabIndex = _this.props.tabIndex, _React$cloneElement));
    };

    _this.renderClearButton = function () {
      if (_this.props.isClearable && _this.props.selected != null) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", {
          type: "button",
          className: "react-datepicker__close-icon",
          onClick: _this.onClearClick,
          title: _this.props.clearButtonTitle,
          tabIndex: -1
        });
      } else {
        return null;
      }
    };

    _this.state = _this.calcInitialState();
    return _this;
  }

  DatePicker.prototype.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
    if (prevProps.inline && hasPreSelectionChanged(prevProps.selected, this.props.selected)) {
      this.setPreSelection(this.props.selected);
    }
    if (prevProps.highlightDates !== this.props.highlightDates) {
      this.setState({
        highlightDates: getHightLightDaysMap(this.props.highlightDates)
      });
    }
    if (!prevState.focused && hasSelectionChanged(prevProps.selected, this.props.selected)) {
      this.setState({ inputValue: null });
    }
  };

  DatePicker.prototype.componentWillUnmount = function componentWillUnmount() {
    this.clearPreventFocusTimeout();
  };

  DatePicker.prototype.render = function render() {
    var calendar = this.renderCalendar();

    if (this.props.inline && !this.props.withPortal) {
      return calendar;
    }

    if (this.props.withPortal) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        null,
        !this.props.inline ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "react-datepicker__input-container" },
          this.renderDateInput(),
          this.renderClearButton()
        ) : null,
        this.state.open || this.props.inline ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "react-datepicker__portal" },
          calendar
        ) : null
      );
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PopperComponent, {
      className: this.props.popperClassName,
      hidePopper: !this.isCalendarOpen(),
      popperModifiers: this.props.popperModifiers,
      targetComponent: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: "react-datepicker__input-container" },
        this.renderDateInput(),
        this.renderClearButton()
      ),
      popperContainer: this.props.popperContainer,
      popperComponent: calendar,
      popperPlacement: this.props.popperPlacement,
      popperProps: this.props.popperProps
    });
  };

  return DatePicker;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

DatePicker.propTypes = {
  adjustDateOnChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  allowSameDay: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  autoComplete: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  autoFocus: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  calendarClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  calendarContainer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  customInput: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element,
  customInputRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  // eslint-disable-next-line react/no-unused-prop-types
  dateFormat: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array]),
  dateFormatCalendar: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  dayClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  disabledKeyboardNavigation: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  dropdownMode: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["scroll", "select"]).isRequired,
  endDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  excludeDates: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  filterDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  fixedHeight: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  formatWeekNumber: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  highlightDates: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  includeDates: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  includeTimes: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  injectTimes: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  inline: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  isClearable: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  locale: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  maxDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  minDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  monthsShown: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  onBlur: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  onSelect: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onWeekSelect: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onClickOutside: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onChangeRaw: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onFocus: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onInputClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onKeyDown: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onMonthChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onYearChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onInputError: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  open: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  openToDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  peekNextMonth: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  placeholderText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  popperContainer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  popperClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, // <PopperComponent/> props
  popperModifiers: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, // <PopperComponent/> props
  popperPlacement: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(popperPlacementPositions), // <PopperComponent/> props
  popperProps: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  preventOpenOnFocus: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  readOnly: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  required: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  scrollableYearDropdown: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  scrollableMonthYearDropdown: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  selected: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  selectsEnd: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  selectsStart: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  showMonthDropdown: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  showMonthYearDropdown: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  showWeekNumbers: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  showYearDropdown: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  forceShowMonthNavigation: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  showDisabledMonthNavigation: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  startDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  startOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  tabIndex: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  timeCaption: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  title: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  todayButton: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  useWeekdaysShort: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  formatWeekDay: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  utcOffset: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  weekLabel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  withPortal: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  yearDropdownItemNumber: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  shouldCloseOnSelect: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  showTimeSelect: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  showTimeSelectOnly: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  timeFormat: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  timeIntervals: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  minTime: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  maxTime: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  excludeTimes: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  useShortMonthInDropdown: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  clearButtonTitle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  previousMonthButtonLabel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  nextMonthButtonLabel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  renderCustomHeader: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  renderDayContents: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};
var PRESELECT_CHANGE_VIA_INPUT = "input";
var PRESELECT_CHANGE_VIA_NAVIGATE = "navigate";


/* harmony default export */ __webpack_exports__["a"] = (DatePicker);


/***/ }),
/* 725 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export IGNORE_CLASS_NAME */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);



function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

/**
 * Check whether some DOM node is our Component's node.
 */
function isNodeFound(current, componentNode, ignoreClass) {
  if (current === componentNode) {
    return true;
  } // SVG <use/> elements do not technically reside in the rendered DOM, so
  // they do not have classList directly, but they offer a link to their
  // corresponding element, which can have classList. This extra check is for
  // that case.
  // See: http://www.w3.org/TR/SVG11/struct.html#InterfaceSVGUseElement
  // Discussion: https://github.com/Pomax/react-onclickoutside/pull/17


  if (current.correspondingElement) {
    return current.correspondingElement.classList.contains(ignoreClass);
  }

  return current.classList.contains(ignoreClass);
}
/**
 * Try to find our node in a hierarchy of nodes, returning the document
 * node as highest node if our node is not found in the path up.
 */

function findHighest(current, componentNode, ignoreClass) {
  if (current === componentNode) {
    return true;
  } // If source=local then this event came from 'somewhere'
  // inside and should be ignored. We could handle this with
  // a layered approach, too, but that requires going back to
  // thinking in terms of Dom node nesting, running counter
  // to React's 'you shouldn't care about the DOM' philosophy.


  while (current.parentNode) {
    if (isNodeFound(current, componentNode, ignoreClass)) {
      return true;
    }

    current = current.parentNode;
  }

  return current;
}
/**
 * Check if the browser scrollbar was clicked
 */

function clickedScrollbar(evt) {
  return document.documentElement.clientWidth <= evt.clientX || document.documentElement.clientHeight <= evt.clientY;
}

// ideally will get replaced with external dep
// when rafrex/detect-passive-events#4 and rafrex/detect-passive-events#5 get merged in
var testPassiveEventSupport = function testPassiveEventSupport() {
  if (typeof window === 'undefined' || typeof window.addEventListener !== 'function') {
    return;
  }

  var passive = false;
  var options = Object.defineProperty({}, 'passive', {
    get: function get() {
      passive = true;
    }
  });

  var noop = function noop() {};

  window.addEventListener('testPassiveEventSupport', noop, options);
  window.removeEventListener('testPassiveEventSupport', noop, options);
  return passive;
};

function autoInc(seed) {
  if (seed === void 0) {
    seed = 0;
  }

  return function () {
    return ++seed;
  };
}

var uid = autoInc();

var passiveEventSupport;
var handlersMap = {};
var enabledInstances = {};
var touchEvents = ['touchstart', 'touchmove'];
var IGNORE_CLASS_NAME = 'ignore-react-onclickoutside';
/**
 * Options for addEventHandler and removeEventHandler
 */

function getEventHandlerOptions(instance, eventName) {
  var handlerOptions = null;
  var isTouchEvent = touchEvents.indexOf(eventName) !== -1;

  if (isTouchEvent && passiveEventSupport) {
    handlerOptions = {
      passive: !instance.props.preventDefault
    };
  }

  return handlerOptions;
}
/**
 * This function generates the HOC function that you'll use
 * in order to impart onOutsideClick listening to an
 * arbitrary component. It gets called at the end of the
 * bootstrapping code to yield an instance of the
 * onClickOutsideHOC function defined inside setupHOC().
 */


function onClickOutsideHOC(WrappedComponent, config) {
  var _class, _temp;

  var componentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
  return _temp = _class =
  /*#__PURE__*/
  function (_Component) {
    _inheritsLoose(onClickOutside, _Component);

    function onClickOutside(props) {
      var _this;

      _this = _Component.call(this, props) || this;

      _this.__outsideClickHandler = function (event) {
        if (typeof _this.__clickOutsideHandlerProp === 'function') {
          _this.__clickOutsideHandlerProp(event);

          return;
        }

        var instance = _this.getInstance();

        if (typeof instance.props.handleClickOutside === 'function') {
          instance.props.handleClickOutside(event);
          return;
        }

        if (typeof instance.handleClickOutside === 'function') {
          instance.handleClickOutside(event);
          return;
        }

        throw new Error("WrappedComponent: " + componentName + " lacks a handleClickOutside(event) function for processing outside click events.");
      };

      _this.__getComponentNode = function () {
        var instance = _this.getInstance();

        if (config && typeof config.setClickOutsideRef === 'function') {
          return config.setClickOutsideRef()(instance);
        }

        if (typeof instance.setClickOutsideRef === 'function') {
          return instance.setClickOutsideRef();
        }

        return Object(__WEBPACK_IMPORTED_MODULE_1_react_dom__["findDOMNode"])(instance);
      };

      _this.enableOnClickOutside = function () {
        if (typeof document === 'undefined' || enabledInstances[_this._uid]) {
          return;
        }

        if (typeof passiveEventSupport === 'undefined') {
          passiveEventSupport = testPassiveEventSupport();
        }

        enabledInstances[_this._uid] = true;
        var events = _this.props.eventTypes;

        if (!events.forEach) {
          events = [events];
        }

        handlersMap[_this._uid] = function (event) {
          if (_this.componentNode === null) return;

          if (_this.props.preventDefault) {
            event.preventDefault();
          }

          if (_this.props.stopPropagation) {
            event.stopPropagation();
          }

          if (_this.props.excludeScrollbar && clickedScrollbar(event)) return;
          var current = event.target;

          if (findHighest(current, _this.componentNode, _this.props.outsideClickIgnoreClass) !== document) {
            return;
          }

          _this.__outsideClickHandler(event);
        };

        events.forEach(function (eventName) {
          document.addEventListener(eventName, handlersMap[_this._uid], getEventHandlerOptions(_this, eventName));
        });
      };

      _this.disableOnClickOutside = function () {
        delete enabledInstances[_this._uid];
        var fn = handlersMap[_this._uid];

        if (fn && typeof document !== 'undefined') {
          var events = _this.props.eventTypes;

          if (!events.forEach) {
            events = [events];
          }

          events.forEach(function (eventName) {
            return document.removeEventListener(eventName, fn, getEventHandlerOptions(_this, eventName));
          });
          delete handlersMap[_this._uid];
        }
      };

      _this.getRef = function (ref) {
        return _this.instanceRef = ref;
      };

      _this._uid = uid();
      return _this;
    }
    /**
     * Access the WrappedComponent's instance.
     */


    var _proto = onClickOutside.prototype;

    _proto.getInstance = function getInstance() {
      if (!WrappedComponent.prototype.isReactComponent) {
        return this;
      }

      var ref = this.instanceRef;
      return ref.getInstance ? ref.getInstance() : ref;
    };

    /**
     * Add click listeners to the current document,
     * linked to this component's state.
     */
    _proto.componentDidMount = function componentDidMount() {
      // If we are in an environment without a DOM such
      // as shallow rendering or snapshots then we exit
      // early to prevent any unhandled errors being thrown.
      if (typeof document === 'undefined' || !document.createElement) {
        return;
      }

      var instance = this.getInstance();

      if (config && typeof config.handleClickOutside === 'function') {
        this.__clickOutsideHandlerProp = config.handleClickOutside(instance);

        if (typeof this.__clickOutsideHandlerProp !== 'function') {
          throw new Error("WrappedComponent: " + componentName + " lacks a function for processing outside click events specified by the handleClickOutside config option.");
        }
      }

      this.componentNode = this.__getComponentNode(); // return early so we dont initiate onClickOutside

      if (this.props.disableOnClickOutside) return;
      this.enableOnClickOutside();
    };

    _proto.componentDidUpdate = function componentDidUpdate() {
      this.componentNode = this.__getComponentNode();
    };
    /**
     * Remove all document's event listeners for this component
     */


    _proto.componentWillUnmount = function componentWillUnmount() {
      this.disableOnClickOutside();
    };
    /**
     * Can be called to explicitly enable event listening
     * for clicks and touches outside of this element.
     */


    /**
     * Pass-through render
     */
    _proto.render = function render() {
      // eslint-disable-next-line no-unused-vars
      var _props = this.props,
          excludeScrollbar = _props.excludeScrollbar,
          props = _objectWithoutProperties(_props, ["excludeScrollbar"]);

      if (WrappedComponent.prototype.isReactComponent) {
        props.ref = this.getRef;
      } else {
        props.wrappedRef = this.getRef;
      }

      props.disableOnClickOutside = this.disableOnClickOutside;
      props.enableOnClickOutside = this.enableOnClickOutside;
      return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(WrappedComponent, props);
    };

    return onClickOutside;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class.displayName = "OnClickOutside(" + componentName + ")", _class.defaultProps = {
    eventTypes: ['mousedown', 'touchstart'],
    excludeScrollbar: config && config.excludeScrollbar || false,
    outsideClickIgnoreClass: IGNORE_CLASS_NAME,
    preventDefault: false,
    stopPropagation: false
  }, _class.getClass = function () {
    return WrappedComponent.getClass ? WrappedComponent.getClass() : WrappedComponent;
  }, _temp;
}


/* harmony default export */ __webpack_exports__["a"] = (onClickOutsideHOC);


/***/ }),
/* 726 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Popper__ = __webpack_require__(727);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Manager__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Reference__ = __webpack_require__(747);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__Popper__["a"]; });
/* unused harmony reexport placements */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__Manager__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__Reference__["a"]; });
// Public components



 // Public types

/***/ }),
/* 727 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export InnerPopper */
/* unused harmony export placements */
/* harmony export (immutable) */ __webpack_exports__["a"] = Popper;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutPropertiesLoose__ = __webpack_require__(728);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutPropertiesLoose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutPropertiesLoose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends__ = __webpack_require__(302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_inheritsLoose__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_inheritsLoose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_inheritsLoose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_deep_equal__ = __webpack_require__(729);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_deep_equal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_deep_equal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_popper_js__ = __webpack_require__(743);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Manager__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils__ = __webpack_require__(307);










var initialStyle = {
  position: 'absolute',
  top: 0,
  left: 0,
  opacity: 0,
  pointerEvents: 'none'
};
var initialArrowStyle = {};
var InnerPopper =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_inheritsLoose___default()(InnerPopper, _React$Component);

  function InnerPopper() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default()(_this), "state", {
      data: undefined,
      placement: undefined
    });

    __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default()(_this), "popperInstance", void 0);

    __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default()(_this), "popperNode", null);

    __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default()(_this), "arrowNode", null);

    __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default()(_this), "setPopperNode", function (popperNode) {
      if (!popperNode || _this.popperNode === popperNode) return;
      Object(__WEBPACK_IMPORTED_MODULE_9__utils__["b" /* setRef */])(_this.props.innerRef, popperNode);
      _this.popperNode = popperNode;

      _this.updatePopperInstance();
    });

    __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default()(_this), "setArrowNode", function (arrowNode) {
      _this.arrowNode = arrowNode;
    });

    __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default()(_this), "updateStateModifier", {
      enabled: true,
      order: 900,
      fn: function fn(data) {
        var placement = data.placement;

        _this.setState({
          data: data,
          placement: placement
        });

        return data;
      }
    });

    __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default()(_this), "getOptions", function () {
      return {
        placement: _this.props.placement,
        eventsEnabled: _this.props.eventsEnabled,
        positionFixed: _this.props.positionFixed,
        modifiers: __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends___default()({}, _this.props.modifiers, {
          arrow: __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends___default()({}, _this.props.modifiers && _this.props.modifiers.arrow, {
            enabled: !!_this.arrowNode,
            element: _this.arrowNode
          }),
          applyStyle: {
            enabled: false
          },
          updateStateModifier: _this.updateStateModifier
        })
      };
    });

    __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default()(_this), "getPopperStyle", function () {
      return !_this.popperNode || !_this.state.data ? initialStyle : __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends___default()({
        position: _this.state.data.offsets.popper.position
      }, _this.state.data.styles);
    });

    __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default()(_this), "getPopperPlacement", function () {
      return !_this.state.data ? undefined : _this.state.placement;
    });

    __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default()(_this), "getArrowStyle", function () {
      return !_this.arrowNode || !_this.state.data ? initialArrowStyle : _this.state.data.arrowStyles;
    });

    __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default()(_this), "getOutOfBoundariesState", function () {
      return _this.state.data ? _this.state.data.hide : undefined;
    });

    __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default()(_this), "destroyPopperInstance", function () {
      if (!_this.popperInstance) return;

      _this.popperInstance.destroy();

      _this.popperInstance = null;
    });

    __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default()(_this), "updatePopperInstance", function () {
      _this.destroyPopperInstance();

      var _assertThisInitialize = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default()(_this),
          popperNode = _assertThisInitialize.popperNode;

      var referenceElement = _this.props.referenceElement;
      if (!referenceElement || !popperNode) return;
      _this.popperInstance = new __WEBPACK_IMPORTED_MODULE_7_popper_js__["a" /* default */](referenceElement, popperNode, _this.getOptions());
    });

    __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default()(_this), "scheduleUpdate", function () {
      if (_this.popperInstance) {
        _this.popperInstance.scheduleUpdate();
      }
    });

    return _this;
  }

  var _proto = InnerPopper.prototype;

  _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
    // If the Popper.js options have changed, update the instance (destroy + create)
    if (this.props.placement !== prevProps.placement || this.props.referenceElement !== prevProps.referenceElement || this.props.positionFixed !== prevProps.positionFixed || !__WEBPACK_IMPORTED_MODULE_5_deep_equal___default()(this.props.modifiers, prevProps.modifiers, {
      strict: true
    })) {
      // develop only check that modifiers isn't being updated needlessly
      if (false) {
        if (this.props.modifiers !== prevProps.modifiers && this.props.modifiers != null && prevProps.modifiers != null && shallowEqual(this.props.modifiers, prevProps.modifiers)) {
          console.warn("'modifiers' prop reference updated even though all values appear the same.\nConsider memoizing the 'modifiers' object to avoid needless rendering.");
        }
      }

      this.updatePopperInstance();
    } else if (this.props.eventsEnabled !== prevProps.eventsEnabled && this.popperInstance) {
      this.props.eventsEnabled ? this.popperInstance.enableEventListeners() : this.popperInstance.disableEventListeners();
    } // A placement difference in state means popper determined a new placement
    // apart from the props value. By the time the popper element is rendered with
    // the new position Popper has already measured it, if the place change triggers
    // a size change it will result in a misaligned popper. So we schedule an update to be sure.


    if (prevState.placement !== this.state.placement) {
      this.scheduleUpdate();
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    Object(__WEBPACK_IMPORTED_MODULE_9__utils__["b" /* setRef */])(this.props.innerRef, null);
    this.destroyPopperInstance();
  };

  _proto.render = function render() {
    return Object(__WEBPACK_IMPORTED_MODULE_9__utils__["c" /* unwrapArray */])(this.props.children)({
      ref: this.setPopperNode,
      style: this.getPopperStyle(),
      placement: this.getPopperPlacement(),
      outOfBoundaries: this.getOutOfBoundariesState(),
      scheduleUpdate: this.scheduleUpdate,
      arrowProps: {
        ref: this.setArrowNode,
        style: this.getArrowStyle()
      }
    });
  };

  return InnerPopper;
}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty___default()(InnerPopper, "defaultProps", {
  placement: 'bottom',
  eventsEnabled: true,
  referenceElement: undefined,
  positionFixed: false
});

var placements = __WEBPACK_IMPORTED_MODULE_7_popper_js__["a" /* default */].placements;

function Popper(_ref) {
  var referenceElement = _ref.referenceElement,
      props = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutPropertiesLoose___default()(_ref, ["referenceElement"]);

  return __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__Manager__["a" /* ManagerReferenceNodeContext */].Consumer, null, function (referenceNode) {
    return __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](InnerPopper, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends___default()({
      referenceElement: referenceElement !== undefined ? referenceElement : referenceNode
    }, props));
  });
}

/***/ }),
/* 728 */
/***/ (function(module, exports) {

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

module.exports = _objectWithoutPropertiesLoose;

/***/ }),
/* 729 */
/***/ (function(module, exports, __webpack_require__) {

var objectKeys = __webpack_require__(303);
var isArguments = __webpack_require__(731);
var is = __webpack_require__(732);
var isRegex = __webpack_require__(733);
var flags = __webpack_require__(736);
var isDate = __webpack_require__(742);

var getTime = Date.prototype.getTime;

function deepEqual(actual, expected, options) {
  var opts = options || {};

  // 7.1. All identical values are equivalent, as determined by ===.
  if (opts.strict ? is(actual, expected) : actual === expected) {
    return true;
  }

  // 7.3. Other pairs that do not both pass typeof value == 'object', equivalence is determined by ==.
  if (!actual || !expected || (typeof actual !== 'object' && typeof expected !== 'object')) {
    return opts.strict ? is(actual, expected) : actual == expected;
  }

  /*
   * 7.4. For all other Object pairs, including Array objects, equivalence is
   * determined by having the same number of owned properties (as verified
   * with Object.prototype.hasOwnProperty.call), the same set of keys
   * (although not necessarily the same order), equivalent values for every
   * corresponding key, and an identical 'prototype' property. Note: this
   * accounts for both named and indexed properties on Arrays.
   */
  // eslint-disable-next-line no-use-before-define
  return objEquiv(actual, expected, opts);
}

function isUndefinedOrNull(value) {
  return value === null || value === undefined;
}

function isBuffer(x) {
  if (!x || typeof x !== 'object' || typeof x.length !== 'number') {
    return false;
  }
  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
    return false;
  }
  if (x.length > 0 && typeof x[0] !== 'number') {
    return false;
  }
  return true;
}

function objEquiv(a, b, opts) {
  /* eslint max-statements: [2, 50] */
  var i, key;
  if (typeof a !== typeof b) { return false; }
  if (isUndefinedOrNull(a) || isUndefinedOrNull(b)) { return false; }

  // an identical 'prototype' property.
  if (a.prototype !== b.prototype) { return false; }

  if (isArguments(a) !== isArguments(b)) { return false; }

  var aIsRegex = isRegex(a);
  var bIsRegex = isRegex(b);
  if (aIsRegex !== bIsRegex) { return false; }
  if (aIsRegex || bIsRegex) {
    return a.source === b.source && flags(a) === flags(b);
  }

  if (isDate(a) && isDate(b)) {
    return getTime.call(a) === getTime.call(b);
  }

  var aIsBuffer = isBuffer(a);
  var bIsBuffer = isBuffer(b);
  if (aIsBuffer !== bIsBuffer) { return false; }
  if (aIsBuffer || bIsBuffer) { // && would work too, because both are true or both false here
    if (a.length !== b.length) { return false; }
    for (i = 0; i < a.length; i++) {
      if (a[i] !== b[i]) { return false; }
    }
    return true;
  }

  if (typeof a !== typeof b) { return false; }

  try {
    var ka = objectKeys(a);
    var kb = objectKeys(b);
  } catch (e) { // happens when one is a string literal and the other isn't
    return false;
  }
  // having the same number of owned properties (keys incorporates hasOwnProperty)
  if (ka.length !== kb.length) { return false; }

  // the same set of keys (although not necessarily the same order),
  ka.sort();
  kb.sort();
  // ~~~cheap key test
  for (i = ka.length - 1; i >= 0; i--) {
    if (ka[i] != kb[i]) { return false; }
  }
  // equivalent values for every corresponding key, and ~~~possibly expensive deep test
  for (i = ka.length - 1; i >= 0; i--) {
    key = ka[i];
    if (!deepEqual(a[key], b[key], opts)) { return false; }
  }

  return true;
}

module.exports = deepEqual;


/***/ }),
/* 730 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var keysShim;
if (!Object.keys) {
	// modified from https://github.com/es-shims/es5-shim
	var has = Object.prototype.hasOwnProperty;
	var toStr = Object.prototype.toString;
	var isArgs = __webpack_require__(304); // eslint-disable-line global-require
	var isEnumerable = Object.prototype.propertyIsEnumerable;
	var hasDontEnumBug = !isEnumerable.call({ toString: null }, 'toString');
	var hasProtoEnumBug = isEnumerable.call(function () {}, 'prototype');
	var dontEnums = [
		'toString',
		'toLocaleString',
		'valueOf',
		'hasOwnProperty',
		'isPrototypeOf',
		'propertyIsEnumerable',
		'constructor'
	];
	var equalsConstructorPrototype = function (o) {
		var ctor = o.constructor;
		return ctor && ctor.prototype === o;
	};
	var excludedKeys = {
		$applicationCache: true,
		$console: true,
		$external: true,
		$frame: true,
		$frameElement: true,
		$frames: true,
		$innerHeight: true,
		$innerWidth: true,
		$onmozfullscreenchange: true,
		$onmozfullscreenerror: true,
		$outerHeight: true,
		$outerWidth: true,
		$pageXOffset: true,
		$pageYOffset: true,
		$parent: true,
		$scrollLeft: true,
		$scrollTop: true,
		$scrollX: true,
		$scrollY: true,
		$self: true,
		$webkitIndexedDB: true,
		$webkitStorageInfo: true,
		$window: true
	};
	var hasAutomationEqualityBug = (function () {
		/* global window */
		if (typeof window === 'undefined') { return false; }
		for (var k in window) {
			try {
				if (!excludedKeys['$' + k] && has.call(window, k) && window[k] !== null && typeof window[k] === 'object') {
					try {
						equalsConstructorPrototype(window[k]);
					} catch (e) {
						return true;
					}
				}
			} catch (e) {
				return true;
			}
		}
		return false;
	}());
	var equalsConstructorPrototypeIfNotBuggy = function (o) {
		/* global window */
		if (typeof window === 'undefined' || !hasAutomationEqualityBug) {
			return equalsConstructorPrototype(o);
		}
		try {
			return equalsConstructorPrototype(o);
		} catch (e) {
			return false;
		}
	};

	keysShim = function keys(object) {
		var isObject = object !== null && typeof object === 'object';
		var isFunction = toStr.call(object) === '[object Function]';
		var isArguments = isArgs(object);
		var isString = isObject && toStr.call(object) === '[object String]';
		var theKeys = [];

		if (!isObject && !isFunction && !isArguments) {
			throw new TypeError('Object.keys called on a non-object');
		}

		var skipProto = hasProtoEnumBug && isFunction;
		if (isString && object.length > 0 && !has.call(object, 0)) {
			for (var i = 0; i < object.length; ++i) {
				theKeys.push(String(i));
			}
		}

		if (isArguments && object.length > 0) {
			for (var j = 0; j < object.length; ++j) {
				theKeys.push(String(j));
			}
		} else {
			for (var name in object) {
				if (!(skipProto && name === 'prototype') && has.call(object, name)) {
					theKeys.push(String(name));
				}
			}
		}

		if (hasDontEnumBug) {
			var skipConstructor = equalsConstructorPrototypeIfNotBuggy(object);

			for (var k = 0; k < dontEnums.length; ++k) {
				if (!(skipConstructor && dontEnums[k] === 'constructor') && has.call(object, dontEnums[k])) {
					theKeys.push(dontEnums[k]);
				}
			}
		}
		return theKeys;
	};
}
module.exports = keysShim;


/***/ }),
/* 731 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var hasToStringTag = typeof Symbol === 'function' && typeof Symbol.toStringTag === 'symbol';
var toStr = Object.prototype.toString;

var isStandardArguments = function isArguments(value) {
	if (hasToStringTag && value && typeof value === 'object' && Symbol.toStringTag in value) {
		return false;
	}
	return toStr.call(value) === '[object Arguments]';
};

var isLegacyArguments = function isArguments(value) {
	if (isStandardArguments(value)) {
		return true;
	}
	return value !== null &&
		typeof value === 'object' &&
		typeof value.length === 'number' &&
		value.length >= 0 &&
		toStr.call(value) !== '[object Array]' &&
		toStr.call(value.callee) === '[object Function]';
};

var supportsStandardArguments = (function () {
	return isStandardArguments(arguments);
}());

isStandardArguments.isLegacyArguments = isLegacyArguments; // for tests

module.exports = supportsStandardArguments ? isStandardArguments : isLegacyArguments;


/***/ }),
/* 732 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// http://www.ecma-international.org/ecma-262/6.0/#sec-object.is

var numberIsNaN = function (value) {
	return value !== value;
};

module.exports = function is(a, b) {
	if (a === 0 && b === 0) {
		return 1 / a === 1 / b;
	}
	if (a === b) {
		return true;
	}
	if (numberIsNaN(a) && numberIsNaN(b)) {
		return true;
	}
	return false;
};



/***/ }),
/* 733 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var has = __webpack_require__(734);
var regexExec = RegExp.prototype.exec;
var gOPD = Object.getOwnPropertyDescriptor;

var tryRegexExecCall = function tryRegexExec(value) {
	try {
		var lastIndex = value.lastIndex;
		value.lastIndex = 0; // eslint-disable-line no-param-reassign

		regexExec.call(value);
		return true;
	} catch (e) {
		return false;
	} finally {
		value.lastIndex = lastIndex; // eslint-disable-line no-param-reassign
	}
};
var toStr = Object.prototype.toString;
var regexClass = '[object RegExp]';
var hasToStringTag = typeof Symbol === 'function' && typeof Symbol.toStringTag === 'symbol';

module.exports = function isRegex(value) {
	if (!value || typeof value !== 'object') {
		return false;
	}
	if (!hasToStringTag) {
		return toStr.call(value) === regexClass;
	}

	var descriptor = gOPD(value, 'lastIndex');
	var hasLastIndexDataProperty = descriptor && has(descriptor, 'value');
	if (!hasLastIndexDataProperty) {
		return false;
	}

	return tryRegexExecCall(value);
};


/***/ }),
/* 734 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(193);

module.exports = bind.call(Function.call, Object.prototype.hasOwnProperty);


/***/ }),
/* 735 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint no-invalid-this: 1 */

var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var slice = Array.prototype.slice;
var toStr = Object.prototype.toString;
var funcType = '[object Function]';

module.exports = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || toStr.call(target) !== funcType) {
        throw new TypeError(ERROR_MESSAGE + target);
    }
    var args = slice.call(arguments, 1);

    var bound;
    var binder = function () {
        if (this instanceof bound) {
            var result = target.apply(
                this,
                args.concat(slice.call(arguments))
            );
            if (Object(result) === result) {
                return result;
            }
            return this;
        } else {
            return target.apply(
                that,
                args.concat(slice.call(arguments))
            );
        }
    };

    var boundLength = Math.max(0, target.length - args.length);
    var boundArgs = [];
    for (var i = 0; i < boundLength; i++) {
        boundArgs.push('$' + i);
    }

    bound = Function('binder', 'return function (' + boundArgs.join(',') + '){ return binder.apply(this,arguments); }')(binder);

    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }

    return bound;
};


/***/ }),
/* 736 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var define = __webpack_require__(194);
var callBind = __webpack_require__(737);

var implementation = __webpack_require__(305);
var getPolyfill = __webpack_require__(306);
var shim = __webpack_require__(741);

var flagsBound = callBind(implementation);

define(flagsBound, {
	getPolyfill: getPolyfill,
	implementation: implementation,
	shim: shim
});

module.exports = flagsBound;


/***/ }),
/* 737 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(193);

var GetIntrinsic = __webpack_require__(738);

var $Function = GetIntrinsic('%Function%');
var $apply = $Function.apply;
var $call = $Function.call;

module.exports = function callBind() {
	return bind.apply($call, arguments);
};

module.exports.apply = function applyBind() {
	return bind.apply($apply, arguments);
};


/***/ }),
/* 738 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* globals
	Atomics,
	SharedArrayBuffer,
*/

var undefined;

var $TypeError = TypeError;

var $gOPD = Object.getOwnPropertyDescriptor;
if ($gOPD) {
	try {
		$gOPD({}, '');
	} catch (e) {
		$gOPD = null; // this is IE 8, which has a broken gOPD
	}
}

var throwTypeError = function () { throw new $TypeError(); };
var ThrowTypeError = $gOPD
	? (function () {
		try {
			// eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
			arguments.callee; // IE 8 does not throw here
			return throwTypeError;
		} catch (calleeThrows) {
			try {
				// IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
				return $gOPD(arguments, 'callee').get;
			} catch (gOPDthrows) {
				return throwTypeError;
			}
		}
	}())
	: throwTypeError;

var hasSymbols = __webpack_require__(739)();

var getProto = Object.getPrototypeOf || function (x) { return x.__proto__; }; // eslint-disable-line no-proto

var generator; // = function * () {};
var generatorFunction = generator ? getProto(generator) : undefined;
var asyncFn; // async function() {};
var asyncFunction = asyncFn ? asyncFn.constructor : undefined;
var asyncGen; // async function * () {};
var asyncGenFunction = asyncGen ? getProto(asyncGen) : undefined;
var asyncGenIterator = asyncGen ? asyncGen() : undefined;

var TypedArray = typeof Uint8Array === 'undefined' ? undefined : getProto(Uint8Array);

var INTRINSICS = {
	'%Array%': Array,
	'%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
	'%ArrayBufferPrototype%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer.prototype,
	'%ArrayIteratorPrototype%': hasSymbols ? getProto([][Symbol.iterator]()) : undefined,
	'%ArrayPrototype%': Array.prototype,
	'%ArrayProto_entries%': Array.prototype.entries,
	'%ArrayProto_forEach%': Array.prototype.forEach,
	'%ArrayProto_keys%': Array.prototype.keys,
	'%ArrayProto_values%': Array.prototype.values,
	'%AsyncFromSyncIteratorPrototype%': undefined,
	'%AsyncFunction%': asyncFunction,
	'%AsyncFunctionPrototype%': asyncFunction ? asyncFunction.prototype : undefined,
	'%AsyncGenerator%': asyncGen ? getProto(asyncGenIterator) : undefined,
	'%AsyncGeneratorFunction%': asyncGenFunction,
	'%AsyncGeneratorPrototype%': asyncGenFunction ? asyncGenFunction.prototype : undefined,
	'%AsyncIteratorPrototype%': asyncGenIterator && hasSymbols && Symbol.asyncIterator ? asyncGenIterator[Symbol.asyncIterator]() : undefined,
	'%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
	'%Boolean%': Boolean,
	'%BooleanPrototype%': Boolean.prototype,
	'%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
	'%DataViewPrototype%': typeof DataView === 'undefined' ? undefined : DataView.prototype,
	'%Date%': Date,
	'%DatePrototype%': Date.prototype,
	'%decodeURI%': decodeURI,
	'%decodeURIComponent%': decodeURIComponent,
	'%encodeURI%': encodeURI,
	'%encodeURIComponent%': encodeURIComponent,
	'%Error%': Error,
	'%ErrorPrototype%': Error.prototype,
	'%eval%': eval, // eslint-disable-line no-eval
	'%EvalError%': EvalError,
	'%EvalErrorPrototype%': EvalError.prototype,
	'%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
	'%Float32ArrayPrototype%': typeof Float32Array === 'undefined' ? undefined : Float32Array.prototype,
	'%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
	'%Float64ArrayPrototype%': typeof Float64Array === 'undefined' ? undefined : Float64Array.prototype,
	'%Function%': Function,
	'%FunctionPrototype%': Function.prototype,
	'%Generator%': generator ? getProto(generator()) : undefined,
	'%GeneratorFunction%': generatorFunction,
	'%GeneratorPrototype%': generatorFunction ? generatorFunction.prototype : undefined,
	'%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
	'%Int8ArrayPrototype%': typeof Int8Array === 'undefined' ? undefined : Int8Array.prototype,
	'%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
	'%Int16ArrayPrototype%': typeof Int16Array === 'undefined' ? undefined : Int8Array.prototype,
	'%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
	'%Int32ArrayPrototype%': typeof Int32Array === 'undefined' ? undefined : Int32Array.prototype,
	'%isFinite%': isFinite,
	'%isNaN%': isNaN,
	'%IteratorPrototype%': hasSymbols ? getProto(getProto([][Symbol.iterator]())) : undefined,
	'%JSON%': typeof JSON === 'object' ? JSON : undefined,
	'%JSONParse%': typeof JSON === 'object' ? JSON.parse : undefined,
	'%Map%': typeof Map === 'undefined' ? undefined : Map,
	'%MapIteratorPrototype%': typeof Map === 'undefined' || !hasSymbols ? undefined : getProto(new Map()[Symbol.iterator]()),
	'%MapPrototype%': typeof Map === 'undefined' ? undefined : Map.prototype,
	'%Math%': Math,
	'%Number%': Number,
	'%NumberPrototype%': Number.prototype,
	'%Object%': Object,
	'%ObjectPrototype%': Object.prototype,
	'%ObjProto_toString%': Object.prototype.toString,
	'%ObjProto_valueOf%': Object.prototype.valueOf,
	'%parseFloat%': parseFloat,
	'%parseInt%': parseInt,
	'%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
	'%PromisePrototype%': typeof Promise === 'undefined' ? undefined : Promise.prototype,
	'%PromiseProto_then%': typeof Promise === 'undefined' ? undefined : Promise.prototype.then,
	'%Promise_all%': typeof Promise === 'undefined' ? undefined : Promise.all,
	'%Promise_reject%': typeof Promise === 'undefined' ? undefined : Promise.reject,
	'%Promise_resolve%': typeof Promise === 'undefined' ? undefined : Promise.resolve,
	'%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
	'%RangeError%': RangeError,
	'%RangeErrorPrototype%': RangeError.prototype,
	'%ReferenceError%': ReferenceError,
	'%ReferenceErrorPrototype%': ReferenceError.prototype,
	'%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
	'%RegExp%': RegExp,
	'%RegExpPrototype%': RegExp.prototype,
	'%Set%': typeof Set === 'undefined' ? undefined : Set,
	'%SetIteratorPrototype%': typeof Set === 'undefined' || !hasSymbols ? undefined : getProto(new Set()[Symbol.iterator]()),
	'%SetPrototype%': typeof Set === 'undefined' ? undefined : Set.prototype,
	'%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
	'%SharedArrayBufferPrototype%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer.prototype,
	'%String%': String,
	'%StringIteratorPrototype%': hasSymbols ? getProto(''[Symbol.iterator]()) : undefined,
	'%StringPrototype%': String.prototype,
	'%Symbol%': hasSymbols ? Symbol : undefined,
	'%SymbolPrototype%': hasSymbols ? Symbol.prototype : undefined,
	'%SyntaxError%': SyntaxError,
	'%SyntaxErrorPrototype%': SyntaxError.prototype,
	'%ThrowTypeError%': ThrowTypeError,
	'%TypedArray%': TypedArray,
	'%TypedArrayPrototype%': TypedArray ? TypedArray.prototype : undefined,
	'%TypeError%': $TypeError,
	'%TypeErrorPrototype%': $TypeError.prototype,
	'%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
	'%Uint8ArrayPrototype%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array.prototype,
	'%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
	'%Uint8ClampedArrayPrototype%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray.prototype,
	'%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
	'%Uint16ArrayPrototype%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array.prototype,
	'%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
	'%Uint32ArrayPrototype%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array.prototype,
	'%URIError%': URIError,
	'%URIErrorPrototype%': URIError.prototype,
	'%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
	'%WeakMapPrototype%': typeof WeakMap === 'undefined' ? undefined : WeakMap.prototype,
	'%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet,
	'%WeakSetPrototype%': typeof WeakSet === 'undefined' ? undefined : WeakSet.prototype
};

var bind = __webpack_require__(193);
var $replace = bind.call(Function.call, String.prototype.replace);

/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */
var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */
var stringToPath = function stringToPath(string) {
	var result = [];
	$replace(string, rePropName, function (match, number, quote, subString) {
		result[result.length] = quote ? $replace(subString, reEscapeChar, '$1') : (number || match);
	});
	return result;
};
/* end adaptation */

var getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
	if (!(name in INTRINSICS)) {
		throw new SyntaxError('intrinsic ' + name + ' does not exist!');
	}

	// istanbul ignore if // hopefully this is impossible to test :-)
	if (typeof INTRINSICS[name] === 'undefined' && !allowMissing) {
		throw new $TypeError('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
	}

	return INTRINSICS[name];
};

module.exports = function GetIntrinsic(name, allowMissing) {
	if (typeof name !== 'string' || name.length === 0) {
		throw new TypeError('intrinsic name must be a non-empty string');
	}
	if (arguments.length > 1 && typeof allowMissing !== 'boolean') {
		throw new TypeError('"allowMissing" argument must be a boolean');
	}

	var parts = stringToPath(name);

	var value = getBaseIntrinsic('%' + (parts.length > 0 ? parts[0] : '') + '%', allowMissing);
	for (var i = 1; i < parts.length; i += 1) {
		if (value != null) {
			if ($gOPD && (i + 1) >= parts.length) {
				var desc = $gOPD(value, parts[i]);
				if (!allowMissing && !(parts[i] in value)) {
					throw new $TypeError('base intrinsic for ' + name + ' exists, but the property is not available.');
				}
				value = desc ? (desc.get || desc.value) : value[parts[i]];
			} else {
				value = value[parts[i]];
			}
		}
	}
	return value;
};


/***/ }),
/* 739 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var origSymbol = global.Symbol;
var hasSymbolSham = __webpack_require__(740);

module.exports = function hasNativeSymbols() {
	if (typeof origSymbol !== 'function') { return false; }
	if (typeof Symbol !== 'function') { return false; }
	if (typeof origSymbol('foo') !== 'symbol') { return false; }
	if (typeof Symbol('bar') !== 'symbol') { return false; }

	return hasSymbolSham();
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(39)))

/***/ }),
/* 740 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint complexity: [2, 18], max-statements: [2, 33] */
module.exports = function hasSymbols() {
	if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') { return false; }
	if (typeof Symbol.iterator === 'symbol') { return true; }

	var obj = {};
	var sym = Symbol('test');
	var symObj = Object(sym);
	if (typeof sym === 'string') { return false; }

	if (Object.prototype.toString.call(sym) !== '[object Symbol]') { return false; }
	if (Object.prototype.toString.call(symObj) !== '[object Symbol]') { return false; }

	// temp disabled per https://github.com/ljharb/object.assign/issues/17
	// if (sym instanceof Symbol) { return false; }
	// temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
	// if (!(symObj instanceof Symbol)) { return false; }

	// if (typeof Symbol.prototype.toString !== 'function') { return false; }
	// if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }

	var symVal = 42;
	obj[sym] = symVal;
	for (sym in obj) { return false; } // eslint-disable-line no-restricted-syntax
	if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) { return false; }

	if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) { return false; }

	var syms = Object.getOwnPropertySymbols(obj);
	if (syms.length !== 1 || syms[0] !== sym) { return false; }

	if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) { return false; }

	if (typeof Object.getOwnPropertyDescriptor === 'function') {
		var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
		if (descriptor.value !== symVal || descriptor.enumerable !== true) { return false; }
	}

	return true;
};


/***/ }),
/* 741 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var supportsDescriptors = __webpack_require__(194).supportsDescriptors;
var getPolyfill = __webpack_require__(306);
var gOPD = Object.getOwnPropertyDescriptor;
var defineProperty = Object.defineProperty;
var TypeErr = TypeError;
var getProto = Object.getPrototypeOf;
var regex = /a/;

module.exports = function shimFlags() {
	if (!supportsDescriptors || !getProto) {
		throw new TypeErr('RegExp.prototype.flags requires a true ES5 environment that supports property descriptors');
	}
	var polyfill = getPolyfill();
	var proto = getProto(regex);
	var descriptor = gOPD(proto, 'flags');
	if (!descriptor || descriptor.get !== polyfill) {
		defineProperty(proto, 'flags', {
			configurable: true,
			enumerable: false,
			get: polyfill
		});
	}
	return polyfill;
};


/***/ }),
/* 742 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var getDay = Date.prototype.getDay;
var tryDateObject = function tryDateGetDayCall(value) {
	try {
		getDay.call(value);
		return true;
	} catch (e) {
		return false;
	}
};

var toStr = Object.prototype.toString;
var dateClass = '[object Date]';
var hasToStringTag = typeof Symbol === 'function' && typeof Symbol.toStringTag === 'symbol';

module.exports = function isDateObject(value) {
	if (typeof value !== 'object' || value === null) {
		return false;
	}
	return hasToStringTag ? tryDateObject(value) : toStr.call(value) === dateClass;
};


/***/ }),
/* 743 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/**!
 * @fileOverview Kickass library to create and place poppers near their reference elements.
 * @version 1.16.1
 * @license
 * Copyright (c) 2016 Federico Zivolo and contributors
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && typeof navigator !== 'undefined';

var timeoutDuration = function () {
  var longerTimeoutBrowsers = ['Edge', 'Trident', 'Firefox'];
  for (var i = 0; i < longerTimeoutBrowsers.length; i += 1) {
    if (isBrowser && navigator.userAgent.indexOf(longerTimeoutBrowsers[i]) >= 0) {
      return 1;
    }
  }
  return 0;
}();

function microtaskDebounce(fn) {
  var called = false;
  return function () {
    if (called) {
      return;
    }
    called = true;
    window.Promise.resolve().then(function () {
      called = false;
      fn();
    });
  };
}

function taskDebounce(fn) {
  var scheduled = false;
  return function () {
    if (!scheduled) {
      scheduled = true;
      setTimeout(function () {
        scheduled = false;
        fn();
      }, timeoutDuration);
    }
  };
}

var supportsMicroTasks = isBrowser && window.Promise;

/**
* Create a debounced version of a method, that's asynchronously deferred
* but called in the minimum time possible.
*
* @method
* @memberof Popper.Utils
* @argument {Function} fn
* @returns {Function}
*/
var debounce = supportsMicroTasks ? microtaskDebounce : taskDebounce;

/**
 * Check if the given variable is a function
 * @method
 * @memberof Popper.Utils
 * @argument {Any} functionToCheck - variable to check
 * @returns {Boolean} answer to: is a function?
 */
function isFunction(functionToCheck) {
  var getType = {};
  return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
}

/**
 * Get CSS computed property of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Eement} element
 * @argument {String} property
 */
function getStyleComputedProperty(element, property) {
  if (element.nodeType !== 1) {
    return [];
  }
  // NOTE: 1 DOM access here
  var window = element.ownerDocument.defaultView;
  var css = window.getComputedStyle(element, null);
  return property ? css[property] : css;
}

/**
 * Returns the parentNode or the host of the element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} parent
 */
function getParentNode(element) {
  if (element.nodeName === 'HTML') {
    return element;
  }
  return element.parentNode || element.host;
}

/**
 * Returns the scrolling parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} scroll parent
 */
function getScrollParent(element) {
  // Return body, `getScroll` will take care to get the correct `scrollTop` from it
  if (!element) {
    return document.body;
  }

  switch (element.nodeName) {
    case 'HTML':
    case 'BODY':
      return element.ownerDocument.body;
    case '#document':
      return element.body;
  }

  // Firefox want us to check `-x` and `-y` variations as well

  var _getStyleComputedProp = getStyleComputedProperty(element),
      overflow = _getStyleComputedProp.overflow,
      overflowX = _getStyleComputedProp.overflowX,
      overflowY = _getStyleComputedProp.overflowY;

  if (/(auto|scroll|overlay)/.test(overflow + overflowY + overflowX)) {
    return element;
  }

  return getScrollParent(getParentNode(element));
}

/**
 * Returns the reference node of the reference object, or the reference object itself.
 * @method
 * @memberof Popper.Utils
 * @param {Element|Object} reference - the reference element (the popper will be relative to this)
 * @returns {Element} parent
 */
function getReferenceNode(reference) {
  return reference && reference.referenceNode ? reference.referenceNode : reference;
}

var isIE11 = isBrowser && !!(window.MSInputMethodContext && document.documentMode);
var isIE10 = isBrowser && /MSIE 10/.test(navigator.userAgent);

/**
 * Determines if the browser is Internet Explorer
 * @method
 * @memberof Popper.Utils
 * @param {Number} version to check
 * @returns {Boolean} isIE
 */
function isIE(version) {
  if (version === 11) {
    return isIE11;
  }
  if (version === 10) {
    return isIE10;
  }
  return isIE11 || isIE10;
}

/**
 * Returns the offset parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} offset parent
 */
function getOffsetParent(element) {
  if (!element) {
    return document.documentElement;
  }

  var noOffsetParent = isIE(10) ? document.body : null;

  // NOTE: 1 DOM access here
  var offsetParent = element.offsetParent || null;
  // Skip hidden elements which don't have an offsetParent
  while (offsetParent === noOffsetParent && element.nextElementSibling) {
    offsetParent = (element = element.nextElementSibling).offsetParent;
  }

  var nodeName = offsetParent && offsetParent.nodeName;

  if (!nodeName || nodeName === 'BODY' || nodeName === 'HTML') {
    return element ? element.ownerDocument.documentElement : document.documentElement;
  }

  // .offsetParent will return the closest TH, TD or TABLE in case
  // no offsetParent is present, I hate this job...
  if (['TH', 'TD', 'TABLE'].indexOf(offsetParent.nodeName) !== -1 && getStyleComputedProperty(offsetParent, 'position') === 'static') {
    return getOffsetParent(offsetParent);
  }

  return offsetParent;
}

function isOffsetContainer(element) {
  var nodeName = element.nodeName;

  if (nodeName === 'BODY') {
    return false;
  }
  return nodeName === 'HTML' || getOffsetParent(element.firstElementChild) === element;
}

/**
 * Finds the root node (document, shadowDOM root) of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} node
 * @returns {Element} root node
 */
function getRoot(node) {
  if (node.parentNode !== null) {
    return getRoot(node.parentNode);
  }

  return node;
}

/**
 * Finds the offset parent common to the two provided nodes
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element1
 * @argument {Element} element2
 * @returns {Element} common offset parent
 */
function findCommonOffsetParent(element1, element2) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element1 || !element1.nodeType || !element2 || !element2.nodeType) {
    return document.documentElement;
  }

  // Here we make sure to give as "start" the element that comes first in the DOM
  var order = element1.compareDocumentPosition(element2) & Node.DOCUMENT_POSITION_FOLLOWING;
  var start = order ? element1 : element2;
  var end = order ? element2 : element1;

  // Get common ancestor container
  var range = document.createRange();
  range.setStart(start, 0);
  range.setEnd(end, 0);
  var commonAncestorContainer = range.commonAncestorContainer;

  // Both nodes are inside #document

  if (element1 !== commonAncestorContainer && element2 !== commonAncestorContainer || start.contains(end)) {
    if (isOffsetContainer(commonAncestorContainer)) {
      return commonAncestorContainer;
    }

    return getOffsetParent(commonAncestorContainer);
  }

  // one of the nodes is inside shadowDOM, find which one
  var element1root = getRoot(element1);
  if (element1root.host) {
    return findCommonOffsetParent(element1root.host, element2);
  } else {
    return findCommonOffsetParent(element1, getRoot(element2).host);
  }
}

/**
 * Gets the scroll value of the given element in the given side (top and left)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {String} side `top` or `left`
 * @returns {number} amount of scrolled pixels
 */
function getScroll(element) {
  var side = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top';

  var upperSide = side === 'top' ? 'scrollTop' : 'scrollLeft';
  var nodeName = element.nodeName;

  if (nodeName === 'BODY' || nodeName === 'HTML') {
    var html = element.ownerDocument.documentElement;
    var scrollingElement = element.ownerDocument.scrollingElement || html;
    return scrollingElement[upperSide];
  }

  return element[upperSide];
}

/*
 * Sum or subtract the element scroll values (left and top) from a given rect object
 * @method
 * @memberof Popper.Utils
 * @param {Object} rect - Rect object you want to change
 * @param {HTMLElement} element - The element from the function reads the scroll values
 * @param {Boolean} subtract - set to true if you want to subtract the scroll values
 * @return {Object} rect - The modifier rect object
 */
function includeScroll(rect, element) {
  var subtract = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var scrollTop = getScroll(element, 'top');
  var scrollLeft = getScroll(element, 'left');
  var modifier = subtract ? -1 : 1;
  rect.top += scrollTop * modifier;
  rect.bottom += scrollTop * modifier;
  rect.left += scrollLeft * modifier;
  rect.right += scrollLeft * modifier;
  return rect;
}

/*
 * Helper to detect borders of a given element
 * @method
 * @memberof Popper.Utils
 * @param {CSSStyleDeclaration} styles
 * Result of `getStyleComputedProperty` on the given element
 * @param {String} axis - `x` or `y`
 * @return {number} borders - The borders size of the given axis
 */

function getBordersSize(styles, axis) {
  var sideA = axis === 'x' ? 'Left' : 'Top';
  var sideB = sideA === 'Left' ? 'Right' : 'Bottom';

  return parseFloat(styles['border' + sideA + 'Width']) + parseFloat(styles['border' + sideB + 'Width']);
}

function getSize(axis, body, html, computedStyle) {
  return Math.max(body['offset' + axis], body['scroll' + axis], html['client' + axis], html['offset' + axis], html['scroll' + axis], isIE(10) ? parseInt(html['offset' + axis]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Top' : 'Left')]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Bottom' : 'Right')]) : 0);
}

function getWindowSizes(document) {
  var body = document.body;
  var html = document.documentElement;
  var computedStyle = isIE(10) && getComputedStyle(html);

  return {
    height: getSize('Height', body, html, computedStyle),
    width: getSize('Width', body, html, computedStyle)
  };
}

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();





var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/**
 * Given element offsets, generate an output similar to getBoundingClientRect
 * @method
 * @memberof Popper.Utils
 * @argument {Object} offsets
 * @returns {Object} ClientRect like output
 */
function getClientRect(offsets) {
  return _extends({}, offsets, {
    right: offsets.left + offsets.width,
    bottom: offsets.top + offsets.height
  });
}

/**
 * Get bounding client rect of given element
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} element
 * @return {Object} client rect
 */
function getBoundingClientRect(element) {
  var rect = {};

  // IE10 10 FIX: Please, don't ask, the element isn't
  // considered in DOM in some circumstances...
  // This isn't reproducible in IE10 compatibility mode of IE11
  try {
    if (isIE(10)) {
      rect = element.getBoundingClientRect();
      var scrollTop = getScroll(element, 'top');
      var scrollLeft = getScroll(element, 'left');
      rect.top += scrollTop;
      rect.left += scrollLeft;
      rect.bottom += scrollTop;
      rect.right += scrollLeft;
    } else {
      rect = element.getBoundingClientRect();
    }
  } catch (e) {}

  var result = {
    left: rect.left,
    top: rect.top,
    width: rect.right - rect.left,
    height: rect.bottom - rect.top
  };

  // subtract scrollbar size from sizes
  var sizes = element.nodeName === 'HTML' ? getWindowSizes(element.ownerDocument) : {};
  var width = sizes.width || element.clientWidth || result.width;
  var height = sizes.height || element.clientHeight || result.height;

  var horizScrollbar = element.offsetWidth - width;
  var vertScrollbar = element.offsetHeight - height;

  // if an hypothetical scrollbar is detected, we must be sure it's not a `border`
  // we make this check conditional for performance reasons
  if (horizScrollbar || vertScrollbar) {
    var styles = getStyleComputedProperty(element);
    horizScrollbar -= getBordersSize(styles, 'x');
    vertScrollbar -= getBordersSize(styles, 'y');

    result.width -= horizScrollbar;
    result.height -= vertScrollbar;
  }

  return getClientRect(result);
}

function getOffsetRectRelativeToArbitraryNode(children, parent) {
  var fixedPosition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var isIE10 = isIE(10);
  var isHTML = parent.nodeName === 'HTML';
  var childrenRect = getBoundingClientRect(children);
  var parentRect = getBoundingClientRect(parent);
  var scrollParent = getScrollParent(children);

  var styles = getStyleComputedProperty(parent);
  var borderTopWidth = parseFloat(styles.borderTopWidth);
  var borderLeftWidth = parseFloat(styles.borderLeftWidth);

  // In cases where the parent is fixed, we must ignore negative scroll in offset calc
  if (fixedPosition && isHTML) {
    parentRect.top = Math.max(parentRect.top, 0);
    parentRect.left = Math.max(parentRect.left, 0);
  }
  var offsets = getClientRect({
    top: childrenRect.top - parentRect.top - borderTopWidth,
    left: childrenRect.left - parentRect.left - borderLeftWidth,
    width: childrenRect.width,
    height: childrenRect.height
  });
  offsets.marginTop = 0;
  offsets.marginLeft = 0;

  // Subtract margins of documentElement in case it's being used as parent
  // we do this only on HTML because it's the only element that behaves
  // differently when margins are applied to it. The margins are included in
  // the box of the documentElement, in the other cases not.
  if (!isIE10 && isHTML) {
    var marginTop = parseFloat(styles.marginTop);
    var marginLeft = parseFloat(styles.marginLeft);

    offsets.top -= borderTopWidth - marginTop;
    offsets.bottom -= borderTopWidth - marginTop;
    offsets.left -= borderLeftWidth - marginLeft;
    offsets.right -= borderLeftWidth - marginLeft;

    // Attach marginTop and marginLeft because in some circumstances we may need them
    offsets.marginTop = marginTop;
    offsets.marginLeft = marginLeft;
  }

  if (isIE10 && !fixedPosition ? parent.contains(scrollParent) : parent === scrollParent && scrollParent.nodeName !== 'BODY') {
    offsets = includeScroll(offsets, parent);
  }

  return offsets;
}

function getViewportOffsetRectRelativeToArtbitraryNode(element) {
  var excludeScroll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var html = element.ownerDocument.documentElement;
  var relativeOffset = getOffsetRectRelativeToArbitraryNode(element, html);
  var width = Math.max(html.clientWidth, window.innerWidth || 0);
  var height = Math.max(html.clientHeight, window.innerHeight || 0);

  var scrollTop = !excludeScroll ? getScroll(html) : 0;
  var scrollLeft = !excludeScroll ? getScroll(html, 'left') : 0;

  var offset = {
    top: scrollTop - relativeOffset.top + relativeOffset.marginTop,
    left: scrollLeft - relativeOffset.left + relativeOffset.marginLeft,
    width: width,
    height: height
  };

  return getClientRect(offset);
}

/**
 * Check if the given element is fixed or is inside a fixed parent
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {Element} customContainer
 * @returns {Boolean} answer to "isFixed?"
 */
function isFixed(element) {
  var nodeName = element.nodeName;
  if (nodeName === 'BODY' || nodeName === 'HTML') {
    return false;
  }
  if (getStyleComputedProperty(element, 'position') === 'fixed') {
    return true;
  }
  var parentNode = getParentNode(element);
  if (!parentNode) {
    return false;
  }
  return isFixed(parentNode);
}

/**
 * Finds the first parent of an element that has a transformed property defined
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} first transformed parent or documentElement
 */

function getFixedPositionOffsetParent(element) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element || !element.parentElement || isIE()) {
    return document.documentElement;
  }
  var el = element.parentElement;
  while (el && getStyleComputedProperty(el, 'transform') === 'none') {
    el = el.parentElement;
  }
  return el || document.documentElement;
}

/**
 * Computed the boundaries limits and return them
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} popper
 * @param {HTMLElement} reference
 * @param {number} padding
 * @param {HTMLElement} boundariesElement - Element used to define the boundaries
 * @param {Boolean} fixedPosition - Is in fixed position mode
 * @returns {Object} Coordinates of the boundaries
 */
function getBoundaries(popper, reference, padding, boundariesElement) {
  var fixedPosition = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

  // NOTE: 1 DOM access here

  var boundaries = { top: 0, left: 0 };
  var offsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, getReferenceNode(reference));

  // Handle viewport case
  if (boundariesElement === 'viewport') {
    boundaries = getViewportOffsetRectRelativeToArtbitraryNode(offsetParent, fixedPosition);
  } else {
    // Handle other cases based on DOM element used as boundaries
    var boundariesNode = void 0;
    if (boundariesElement === 'scrollParent') {
      boundariesNode = getScrollParent(getParentNode(reference));
      if (boundariesNode.nodeName === 'BODY') {
        boundariesNode = popper.ownerDocument.documentElement;
      }
    } else if (boundariesElement === 'window') {
      boundariesNode = popper.ownerDocument.documentElement;
    } else {
      boundariesNode = boundariesElement;
    }

    var offsets = getOffsetRectRelativeToArbitraryNode(boundariesNode, offsetParent, fixedPosition);

    // In case of HTML, we need a different computation
    if (boundariesNode.nodeName === 'HTML' && !isFixed(offsetParent)) {
      var _getWindowSizes = getWindowSizes(popper.ownerDocument),
          height = _getWindowSizes.height,
          width = _getWindowSizes.width;

      boundaries.top += offsets.top - offsets.marginTop;
      boundaries.bottom = height + offsets.top;
      boundaries.left += offsets.left - offsets.marginLeft;
      boundaries.right = width + offsets.left;
    } else {
      // for all the other DOM elements, this one is good
      boundaries = offsets;
    }
  }

  // Add paddings
  padding = padding || 0;
  var isPaddingNumber = typeof padding === 'number';
  boundaries.left += isPaddingNumber ? padding : padding.left || 0;
  boundaries.top += isPaddingNumber ? padding : padding.top || 0;
  boundaries.right -= isPaddingNumber ? padding : padding.right || 0;
  boundaries.bottom -= isPaddingNumber ? padding : padding.bottom || 0;

  return boundaries;
}

function getArea(_ref) {
  var width = _ref.width,
      height = _ref.height;

  return width * height;
}

/**
 * Utility used to transform the `auto` placement to the placement with more
 * available space.
 * @method
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeAutoPlacement(placement, refRect, popper, reference, boundariesElement) {
  var padding = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;

  if (placement.indexOf('auto') === -1) {
    return placement;
  }

  var boundaries = getBoundaries(popper, reference, padding, boundariesElement);

  var rects = {
    top: {
      width: boundaries.width,
      height: refRect.top - boundaries.top
    },
    right: {
      width: boundaries.right - refRect.right,
      height: boundaries.height
    },
    bottom: {
      width: boundaries.width,
      height: boundaries.bottom - refRect.bottom
    },
    left: {
      width: refRect.left - boundaries.left,
      height: boundaries.height
    }
  };

  var sortedAreas = Object.keys(rects).map(function (key) {
    return _extends({
      key: key
    }, rects[key], {
      area: getArea(rects[key])
    });
  }).sort(function (a, b) {
    return b.area - a.area;
  });

  var filteredAreas = sortedAreas.filter(function (_ref2) {
    var width = _ref2.width,
        height = _ref2.height;
    return width >= popper.clientWidth && height >= popper.clientHeight;
  });

  var computedPlacement = filteredAreas.length > 0 ? filteredAreas[0].key : sortedAreas[0].key;

  var variation = placement.split('-')[1];

  return computedPlacement + (variation ? '-' + variation : '');
}

/**
 * Get offsets to the reference element
 * @method
 * @memberof Popper.Utils
 * @param {Object} state
 * @param {Element} popper - the popper element
 * @param {Element} reference - the reference element (the popper will be relative to this)
 * @param {Element} fixedPosition - is in fixed position mode
 * @returns {Object} An object containing the offsets which will be applied to the popper
 */
function getReferenceOffsets(state, popper, reference) {
  var fixedPosition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

  var commonOffsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, getReferenceNode(reference));
  return getOffsetRectRelativeToArbitraryNode(reference, commonOffsetParent, fixedPosition);
}

/**
 * Get the outer sizes of the given element (offset size + margins)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Object} object containing width and height properties
 */
function getOuterSizes(element) {
  var window = element.ownerDocument.defaultView;
  var styles = window.getComputedStyle(element);
  var x = parseFloat(styles.marginTop || 0) + parseFloat(styles.marginBottom || 0);
  var y = parseFloat(styles.marginLeft || 0) + parseFloat(styles.marginRight || 0);
  var result = {
    width: element.offsetWidth + y,
    height: element.offsetHeight + x
  };
  return result;
}

/**
 * Get the opposite placement of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement
 * @returns {String} flipped placement
 */
function getOppositePlacement(placement) {
  var hash = { left: 'right', right: 'left', bottom: 'top', top: 'bottom' };
  return placement.replace(/left|right|bottom|top/g, function (matched) {
    return hash[matched];
  });
}

/**
 * Get offsets to the popper
 * @method
 * @memberof Popper.Utils
 * @param {Object} position - CSS position the Popper will get applied
 * @param {HTMLElement} popper - the popper element
 * @param {Object} referenceOffsets - the reference offsets (the popper will be relative to this)
 * @param {String} placement - one of the valid placement options
 * @returns {Object} popperOffsets - An object containing the offsets which will be applied to the popper
 */
function getPopperOffsets(popper, referenceOffsets, placement) {
  placement = placement.split('-')[0];

  // Get popper node sizes
  var popperRect = getOuterSizes(popper);

  // Add position, width and height to our offsets object
  var popperOffsets = {
    width: popperRect.width,
    height: popperRect.height
  };

  // depending by the popper placement we have to compute its offsets slightly differently
  var isHoriz = ['right', 'left'].indexOf(placement) !== -1;
  var mainSide = isHoriz ? 'top' : 'left';
  var secondarySide = isHoriz ? 'left' : 'top';
  var measurement = isHoriz ? 'height' : 'width';
  var secondaryMeasurement = !isHoriz ? 'height' : 'width';

  popperOffsets[mainSide] = referenceOffsets[mainSide] + referenceOffsets[measurement] / 2 - popperRect[measurement] / 2;
  if (placement === secondarySide) {
    popperOffsets[secondarySide] = referenceOffsets[secondarySide] - popperRect[secondaryMeasurement];
  } else {
    popperOffsets[secondarySide] = referenceOffsets[getOppositePlacement(secondarySide)];
  }

  return popperOffsets;
}

/**
 * Mimics the `find` method of Array
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function find(arr, check) {
  // use native find if supported
  if (Array.prototype.find) {
    return arr.find(check);
  }

  // use `filter` to obtain the same behavior of `find`
  return arr.filter(check)[0];
}

/**
 * Return the index of the matching object
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function findIndex(arr, prop, value) {
  // use native findIndex if supported
  if (Array.prototype.findIndex) {
    return arr.findIndex(function (cur) {
      return cur[prop] === value;
    });
  }

  // use `find` + `indexOf` if `findIndex` isn't supported
  var match = find(arr, function (obj) {
    return obj[prop] === value;
  });
  return arr.indexOf(match);
}

/**
 * Loop trough the list of modifiers and run them in order,
 * each of them will then edit the data object.
 * @method
 * @memberof Popper.Utils
 * @param {dataObject} data
 * @param {Array} modifiers
 * @param {String} ends - Optional modifier name used as stopper
 * @returns {dataObject}
 */
function runModifiers(modifiers, data, ends) {
  var modifiersToRun = ends === undefined ? modifiers : modifiers.slice(0, findIndex(modifiers, 'name', ends));

  modifiersToRun.forEach(function (modifier) {
    if (modifier['function']) {
      // eslint-disable-line dot-notation
      console.warn('`modifier.function` is deprecated, use `modifier.fn`!');
    }
    var fn = modifier['function'] || modifier.fn; // eslint-disable-line dot-notation
    if (modifier.enabled && isFunction(fn)) {
      // Add properties to offsets to make them a complete clientRect object
      // we do this before each modifier to make sure the previous one doesn't
      // mess with these values
      data.offsets.popper = getClientRect(data.offsets.popper);
      data.offsets.reference = getClientRect(data.offsets.reference);

      data = fn(data, modifier);
    }
  });

  return data;
}

/**
 * Updates the position of the popper, computing the new offsets and applying
 * the new style.<br />
 * Prefer `scheduleUpdate` over `update` because of performance reasons.
 * @method
 * @memberof Popper
 */
function update() {
  // if popper is destroyed, don't perform any further update
  if (this.state.isDestroyed) {
    return;
  }

  var data = {
    instance: this,
    styles: {},
    arrowStyles: {},
    attributes: {},
    flipped: false,
    offsets: {}
  };

  // compute reference element offsets
  data.offsets.reference = getReferenceOffsets(this.state, this.popper, this.reference, this.options.positionFixed);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  data.placement = computeAutoPlacement(this.options.placement, data.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding);

  // store the computed placement inside `originalPlacement`
  data.originalPlacement = data.placement;

  data.positionFixed = this.options.positionFixed;

  // compute the popper offsets
  data.offsets.popper = getPopperOffsets(this.popper, data.offsets.reference, data.placement);

  data.offsets.popper.position = this.options.positionFixed ? 'fixed' : 'absolute';

  // run the modifiers
  data = runModifiers(this.modifiers, data);

  // the first `update` will call `onCreate` callback
  // the other ones will call `onUpdate` callback
  if (!this.state.isCreated) {
    this.state.isCreated = true;
    this.options.onCreate(data);
  } else {
    this.options.onUpdate(data);
  }
}

/**
 * Helper used to know if the given modifier is enabled.
 * @method
 * @memberof Popper.Utils
 * @returns {Boolean}
 */
function isModifierEnabled(modifiers, modifierName) {
  return modifiers.some(function (_ref) {
    var name = _ref.name,
        enabled = _ref.enabled;
    return enabled && name === modifierName;
  });
}

/**
 * Get the prefixed supported property name
 * @method
 * @memberof Popper.Utils
 * @argument {String} property (camelCase)
 * @returns {String} prefixed property (camelCase or PascalCase, depending on the vendor prefix)
 */
function getSupportedPropertyName(property) {
  var prefixes = [false, 'ms', 'Webkit', 'Moz', 'O'];
  var upperProp = property.charAt(0).toUpperCase() + property.slice(1);

  for (var i = 0; i < prefixes.length; i++) {
    var prefix = prefixes[i];
    var toCheck = prefix ? '' + prefix + upperProp : property;
    if (typeof document.body.style[toCheck] !== 'undefined') {
      return toCheck;
    }
  }
  return null;
}

/**
 * Destroys the popper.
 * @method
 * @memberof Popper
 */
function destroy() {
  this.state.isDestroyed = true;

  // touch DOM only if `applyStyle` modifier is enabled
  if (isModifierEnabled(this.modifiers, 'applyStyle')) {
    this.popper.removeAttribute('x-placement');
    this.popper.style.position = '';
    this.popper.style.top = '';
    this.popper.style.left = '';
    this.popper.style.right = '';
    this.popper.style.bottom = '';
    this.popper.style.willChange = '';
    this.popper.style[getSupportedPropertyName('transform')] = '';
  }

  this.disableEventListeners();

  // remove the popper if user explicitly asked for the deletion on destroy
  // do not use `remove` because IE11 doesn't support it
  if (this.options.removeOnDestroy) {
    this.popper.parentNode.removeChild(this.popper);
  }
  return this;
}

/**
 * Get the window associated with the element
 * @argument {Element} element
 * @returns {Window}
 */
function getWindow(element) {
  var ownerDocument = element.ownerDocument;
  return ownerDocument ? ownerDocument.defaultView : window;
}

function attachToScrollParents(scrollParent, event, callback, scrollParents) {
  var isBody = scrollParent.nodeName === 'BODY';
  var target = isBody ? scrollParent.ownerDocument.defaultView : scrollParent;
  target.addEventListener(event, callback, { passive: true });

  if (!isBody) {
    attachToScrollParents(getScrollParent(target.parentNode), event, callback, scrollParents);
  }
  scrollParents.push(target);
}

/**
 * Setup needed event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function setupEventListeners(reference, options, state, updateBound) {
  // Resize event listener on window
  state.updateBound = updateBound;
  getWindow(reference).addEventListener('resize', state.updateBound, { passive: true });

  // Scroll event listener on scroll parents
  var scrollElement = getScrollParent(reference);
  attachToScrollParents(scrollElement, 'scroll', state.updateBound, state.scrollParents);
  state.scrollElement = scrollElement;
  state.eventsEnabled = true;

  return state;
}

/**
 * It will add resize/scroll events and start recalculating
 * position of the popper element when they are triggered.
 * @method
 * @memberof Popper
 */
function enableEventListeners() {
  if (!this.state.eventsEnabled) {
    this.state = setupEventListeners(this.reference, this.options, this.state, this.scheduleUpdate);
  }
}

/**
 * Remove event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function removeEventListeners(reference, state) {
  // Remove resize event listener on window
  getWindow(reference).removeEventListener('resize', state.updateBound);

  // Remove scroll event listener on scroll parents
  state.scrollParents.forEach(function (target) {
    target.removeEventListener('scroll', state.updateBound);
  });

  // Reset state
  state.updateBound = null;
  state.scrollParents = [];
  state.scrollElement = null;
  state.eventsEnabled = false;
  return state;
}

/**
 * It will remove resize/scroll events and won't recalculate popper position
 * when they are triggered. It also won't trigger `onUpdate` callback anymore,
 * unless you call `update` method manually.
 * @method
 * @memberof Popper
 */
function disableEventListeners() {
  if (this.state.eventsEnabled) {
    cancelAnimationFrame(this.scheduleUpdate);
    this.state = removeEventListeners(this.reference, this.state);
  }
}

/**
 * Tells if a given input is a number
 * @method
 * @memberof Popper.Utils
 * @param {*} input to check
 * @return {Boolean}
 */
function isNumeric(n) {
  return n !== '' && !isNaN(parseFloat(n)) && isFinite(n);
}

/**
 * Set the style to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the style to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setStyles(element, styles) {
  Object.keys(styles).forEach(function (prop) {
    var unit = '';
    // add unit if the value is numeric and is one of the following
    if (['width', 'height', 'top', 'right', 'bottom', 'left'].indexOf(prop) !== -1 && isNumeric(styles[prop])) {
      unit = 'px';
    }
    element.style[prop] = styles[prop] + unit;
  });
}

/**
 * Set the attributes to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the attributes to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setAttributes(element, attributes) {
  Object.keys(attributes).forEach(function (prop) {
    var value = attributes[prop];
    if (value !== false) {
      element.setAttribute(prop, attributes[prop]);
    } else {
      element.removeAttribute(prop);
    }
  });
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} data.styles - List of style properties - values to apply to popper element
 * @argument {Object} data.attributes - List of attribute properties - values to apply to popper element
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The same data object
 */
function applyStyle(data) {
  // any property present in `data.styles` will be applied to the popper,
  // in this way we can make the 3rd party modifiers add custom styles to it
  // Be aware, modifiers could override the properties defined in the previous
  // lines of this modifier!
  setStyles(data.instance.popper, data.styles);

  // any property present in `data.attributes` will be applied to the popper,
  // they will be set as HTML attributes of the element
  setAttributes(data.instance.popper, data.attributes);

  // if arrowElement is defined and arrowStyles has some properties
  if (data.arrowElement && Object.keys(data.arrowStyles).length) {
    setStyles(data.arrowElement, data.arrowStyles);
  }

  return data;
}

/**
 * Set the x-placement attribute before everything else because it could be used
 * to add margins to the popper margins needs to be calculated to get the
 * correct popper offsets.
 * @method
 * @memberof Popper.modifiers
 * @param {HTMLElement} reference - The reference element used to position the popper
 * @param {HTMLElement} popper - The HTML element used as popper
 * @param {Object} options - Popper.js options
 */
function applyStyleOnLoad(reference, popper, options, modifierOptions, state) {
  // compute reference element offsets
  var referenceOffsets = getReferenceOffsets(state, popper, reference, options.positionFixed);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  var placement = computeAutoPlacement(options.placement, referenceOffsets, popper, reference, options.modifiers.flip.boundariesElement, options.modifiers.flip.padding);

  popper.setAttribute('x-placement', placement);

  // Apply `position` to popper before anything else because
  // without the position applied we can't guarantee correct computations
  setStyles(popper, { position: options.positionFixed ? 'fixed' : 'absolute' });

  return options;
}

/**
 * @function
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Boolean} shouldRound - If the offsets should be rounded at all
 * @returns {Object} The popper's position offsets rounded
 *
 * The tale of pixel-perfect positioning. It's still not 100% perfect, but as
 * good as it can be within reason.
 * Discussion here: https://github.com/FezVrasta/popper.js/pull/715
 *
 * Low DPI screens cause a popper to be blurry if not using full pixels (Safari
 * as well on High DPI screens).
 *
 * Firefox prefers no rounding for positioning and does not have blurriness on
 * high DPI screens.
 *
 * Only horizontal placement and left/right values need to be considered.
 */
function getRoundedOffsets(data, shouldRound) {
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;
  var round = Math.round,
      floor = Math.floor;

  var noRound = function noRound(v) {
    return v;
  };

  var referenceWidth = round(reference.width);
  var popperWidth = round(popper.width);

  var isVertical = ['left', 'right'].indexOf(data.placement) !== -1;
  var isVariation = data.placement.indexOf('-') !== -1;
  var sameWidthParity = referenceWidth % 2 === popperWidth % 2;
  var bothOddWidth = referenceWidth % 2 === 1 && popperWidth % 2 === 1;

  var horizontalToInteger = !shouldRound ? noRound : isVertical || isVariation || sameWidthParity ? round : floor;
  var verticalToInteger = !shouldRound ? noRound : round;

  return {
    left: horizontalToInteger(bothOddWidth && !isVariation && shouldRound ? popper.left - 1 : popper.left),
    top: verticalToInteger(popper.top),
    bottom: verticalToInteger(popper.bottom),
    right: horizontalToInteger(popper.right)
  };
}

var isFirefox = isBrowser && /Firefox/i.test(navigator.userAgent);

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeStyle(data, options) {
  var x = options.x,
      y = options.y;
  var popper = data.offsets.popper;

  // Remove this legacy support in Popper.js v2

  var legacyGpuAccelerationOption = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'applyStyle';
  }).gpuAcceleration;
  if (legacyGpuAccelerationOption !== undefined) {
    console.warn('WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!');
  }
  var gpuAcceleration = legacyGpuAccelerationOption !== undefined ? legacyGpuAccelerationOption : options.gpuAcceleration;

  var offsetParent = getOffsetParent(data.instance.popper);
  var offsetParentRect = getBoundingClientRect(offsetParent);

  // Styles
  var styles = {
    position: popper.position
  };

  var offsets = getRoundedOffsets(data, window.devicePixelRatio < 2 || !isFirefox);

  var sideA = x === 'bottom' ? 'top' : 'bottom';
  var sideB = y === 'right' ? 'left' : 'right';

  // if gpuAcceleration is set to `true` and transform is supported,
  //  we use `translate3d` to apply the position to the popper we
  // automatically use the supported prefixed version if needed
  var prefixedProperty = getSupportedPropertyName('transform');

  // now, let's make a step back and look at this code closely (wtf?)
  // If the content of the popper grows once it's been positioned, it
  // may happen that the popper gets misplaced because of the new content
  // overflowing its reference element
  // To avoid this problem, we provide two options (x and y), which allow
  // the consumer to define the offset origin.
  // If we position a popper on top of a reference element, we can set
  // `x` to `top` to make the popper grow towards its top instead of
  // its bottom.
  var left = void 0,
      top = void 0;
  if (sideA === 'bottom') {
    // when offsetParent is <html> the positioning is relative to the bottom of the screen (excluding the scrollbar)
    // and not the bottom of the html element
    if (offsetParent.nodeName === 'HTML') {
      top = -offsetParent.clientHeight + offsets.bottom;
    } else {
      top = -offsetParentRect.height + offsets.bottom;
    }
  } else {
    top = offsets.top;
  }
  if (sideB === 'right') {
    if (offsetParent.nodeName === 'HTML') {
      left = -offsetParent.clientWidth + offsets.right;
    } else {
      left = -offsetParentRect.width + offsets.right;
    }
  } else {
    left = offsets.left;
  }
  if (gpuAcceleration && prefixedProperty) {
    styles[prefixedProperty] = 'translate3d(' + left + 'px, ' + top + 'px, 0)';
    styles[sideA] = 0;
    styles[sideB] = 0;
    styles.willChange = 'transform';
  } else {
    // othwerise, we use the standard `top`, `left`, `bottom` and `right` properties
    var invertTop = sideA === 'bottom' ? -1 : 1;
    var invertLeft = sideB === 'right' ? -1 : 1;
    styles[sideA] = top * invertTop;
    styles[sideB] = left * invertLeft;
    styles.willChange = sideA + ', ' + sideB;
  }

  // Attributes
  var attributes = {
    'x-placement': data.placement
  };

  // Update `data` attributes, styles and arrowStyles
  data.attributes = _extends({}, attributes, data.attributes);
  data.styles = _extends({}, styles, data.styles);
  data.arrowStyles = _extends({}, data.offsets.arrow, data.arrowStyles);

  return data;
}

/**
 * Helper used to know if the given modifier depends from another one.<br />
 * It checks if the needed modifier is listed and enabled.
 * @method
 * @memberof Popper.Utils
 * @param {Array} modifiers - list of modifiers
 * @param {String} requestingName - name of requesting modifier
 * @param {String} requestedName - name of requested modifier
 * @returns {Boolean}
 */
function isModifierRequired(modifiers, requestingName, requestedName) {
  var requesting = find(modifiers, function (_ref) {
    var name = _ref.name;
    return name === requestingName;
  });

  var isRequired = !!requesting && modifiers.some(function (modifier) {
    return modifier.name === requestedName && modifier.enabled && modifier.order < requesting.order;
  });

  if (!isRequired) {
    var _requesting = '`' + requestingName + '`';
    var requested = '`' + requestedName + '`';
    console.warn(requested + ' modifier is required by ' + _requesting + ' modifier in order to work, be sure to include it before ' + _requesting + '!');
  }
  return isRequired;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function arrow(data, options) {
  var _data$offsets$arrow;

  // arrow depends on keepTogether in order to work
  if (!isModifierRequired(data.instance.modifiers, 'arrow', 'keepTogether')) {
    return data;
  }

  var arrowElement = options.element;

  // if arrowElement is a string, suppose it's a CSS selector
  if (typeof arrowElement === 'string') {
    arrowElement = data.instance.popper.querySelector(arrowElement);

    // if arrowElement is not found, don't run the modifier
    if (!arrowElement) {
      return data;
    }
  } else {
    // if the arrowElement isn't a query selector we must check that the
    // provided DOM node is child of its popper node
    if (!data.instance.popper.contains(arrowElement)) {
      console.warn('WARNING: `arrow.element` must be child of its popper element!');
      return data;
    }
  }

  var placement = data.placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var isVertical = ['left', 'right'].indexOf(placement) !== -1;

  var len = isVertical ? 'height' : 'width';
  var sideCapitalized = isVertical ? 'Top' : 'Left';
  var side = sideCapitalized.toLowerCase();
  var altSide = isVertical ? 'left' : 'top';
  var opSide = isVertical ? 'bottom' : 'right';
  var arrowElementSize = getOuterSizes(arrowElement)[len];

  //
  // extends keepTogether behavior making sure the popper and its
  // reference have enough pixels in conjunction
  //

  // top/left side
  if (reference[opSide] - arrowElementSize < popper[side]) {
    data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowElementSize);
  }
  // bottom/right side
  if (reference[side] + arrowElementSize > popper[opSide]) {
    data.offsets.popper[side] += reference[side] + arrowElementSize - popper[opSide];
  }
  data.offsets.popper = getClientRect(data.offsets.popper);

  // compute center of the popper
  var center = reference[side] + reference[len] / 2 - arrowElementSize / 2;

  // Compute the sideValue using the updated popper offsets
  // take popper margin in account because we don't have this info available
  var css = getStyleComputedProperty(data.instance.popper);
  var popperMarginSide = parseFloat(css['margin' + sideCapitalized]);
  var popperBorderSide = parseFloat(css['border' + sideCapitalized + 'Width']);
  var sideValue = center - data.offsets.popper[side] - popperMarginSide - popperBorderSide;

  // prevent arrowElement from being placed not contiguously to its popper
  sideValue = Math.max(Math.min(popper[len] - arrowElementSize, sideValue), 0);

  data.arrowElement = arrowElement;
  data.offsets.arrow = (_data$offsets$arrow = {}, defineProperty(_data$offsets$arrow, side, Math.round(sideValue)), defineProperty(_data$offsets$arrow, altSide, ''), _data$offsets$arrow);

  return data;
}

/**
 * Get the opposite placement variation of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement variation
 * @returns {String} flipped placement variation
 */
function getOppositeVariation(variation) {
  if (variation === 'end') {
    return 'start';
  } else if (variation === 'start') {
    return 'end';
  }
  return variation;
}

/**
 * List of accepted placements to use as values of the `placement` option.<br />
 * Valid placements are:
 * - `auto`
 * - `top`
 * - `right`
 * - `bottom`
 * - `left`
 *
 * Each placement can have a variation from this list:
 * - `-start`
 * - `-end`
 *
 * Variations are interpreted easily if you think of them as the left to right
 * written languages. Horizontally (`top` and `bottom`), `start` is left and `end`
 * is right.<br />
 * Vertically (`left` and `right`), `start` is top and `end` is bottom.
 *
 * Some valid examples are:
 * - `top-end` (on top of reference, right aligned)
 * - `right-start` (on right of reference, top aligned)
 * - `bottom` (on bottom, centered)
 * - `auto-end` (on the side with more space available, alignment depends by placement)
 *
 * @static
 * @type {Array}
 * @enum {String}
 * @readonly
 * @method placements
 * @memberof Popper
 */
var placements = ['auto-start', 'auto', 'auto-end', 'top-start', 'top', 'top-end', 'right-start', 'right', 'right-end', 'bottom-end', 'bottom', 'bottom-start', 'left-end', 'left', 'left-start'];

// Get rid of `auto` `auto-start` and `auto-end`
var validPlacements = placements.slice(3);

/**
 * Given an initial placement, returns all the subsequent placements
 * clockwise (or counter-clockwise).
 *
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement - A valid placement (it accepts variations)
 * @argument {Boolean} counter - Set to true to walk the placements counterclockwise
 * @returns {Array} placements including their variations
 */
function clockwise(placement) {
  var counter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var index = validPlacements.indexOf(placement);
  var arr = validPlacements.slice(index + 1).concat(validPlacements.slice(0, index));
  return counter ? arr.reverse() : arr;
}

var BEHAVIORS = {
  FLIP: 'flip',
  CLOCKWISE: 'clockwise',
  COUNTERCLOCKWISE: 'counterclockwise'
};

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function flip(data, options) {
  // if `inner` modifier is enabled, we can't use the `flip` modifier
  if (isModifierEnabled(data.instance.modifiers, 'inner')) {
    return data;
  }

  if (data.flipped && data.placement === data.originalPlacement) {
    // seems like flip is trying to loop, probably there's not enough space on any of the flippable sides
    return data;
  }

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, options.boundariesElement, data.positionFixed);

  var placement = data.placement.split('-')[0];
  var placementOpposite = getOppositePlacement(placement);
  var variation = data.placement.split('-')[1] || '';

  var flipOrder = [];

  switch (options.behavior) {
    case BEHAVIORS.FLIP:
      flipOrder = [placement, placementOpposite];
      break;
    case BEHAVIORS.CLOCKWISE:
      flipOrder = clockwise(placement);
      break;
    case BEHAVIORS.COUNTERCLOCKWISE:
      flipOrder = clockwise(placement, true);
      break;
    default:
      flipOrder = options.behavior;
  }

  flipOrder.forEach(function (step, index) {
    if (placement !== step || flipOrder.length === index + 1) {
      return data;
    }

    placement = data.placement.split('-')[0];
    placementOpposite = getOppositePlacement(placement);

    var popperOffsets = data.offsets.popper;
    var refOffsets = data.offsets.reference;

    // using floor because the reference offsets may contain decimals we are not going to consider here
    var floor = Math.floor;
    var overlapsRef = placement === 'left' && floor(popperOffsets.right) > floor(refOffsets.left) || placement === 'right' && floor(popperOffsets.left) < floor(refOffsets.right) || placement === 'top' && floor(popperOffsets.bottom) > floor(refOffsets.top) || placement === 'bottom' && floor(popperOffsets.top) < floor(refOffsets.bottom);

    var overflowsLeft = floor(popperOffsets.left) < floor(boundaries.left);
    var overflowsRight = floor(popperOffsets.right) > floor(boundaries.right);
    var overflowsTop = floor(popperOffsets.top) < floor(boundaries.top);
    var overflowsBottom = floor(popperOffsets.bottom) > floor(boundaries.bottom);

    var overflowsBoundaries = placement === 'left' && overflowsLeft || placement === 'right' && overflowsRight || placement === 'top' && overflowsTop || placement === 'bottom' && overflowsBottom;

    // flip the variation if required
    var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;

    // flips variation if reference element overflows boundaries
    var flippedVariationByRef = !!options.flipVariations && (isVertical && variation === 'start' && overflowsLeft || isVertical && variation === 'end' && overflowsRight || !isVertical && variation === 'start' && overflowsTop || !isVertical && variation === 'end' && overflowsBottom);

    // flips variation if popper content overflows boundaries
    var flippedVariationByContent = !!options.flipVariationsByContent && (isVertical && variation === 'start' && overflowsRight || isVertical && variation === 'end' && overflowsLeft || !isVertical && variation === 'start' && overflowsBottom || !isVertical && variation === 'end' && overflowsTop);

    var flippedVariation = flippedVariationByRef || flippedVariationByContent;

    if (overlapsRef || overflowsBoundaries || flippedVariation) {
      // this boolean to detect any flip loop
      data.flipped = true;

      if (overlapsRef || overflowsBoundaries) {
        placement = flipOrder[index + 1];
      }

      if (flippedVariation) {
        variation = getOppositeVariation(variation);
      }

      data.placement = placement + (variation ? '-' + variation : '');

      // this object contains `position`, we want to preserve it along with
      // any additional property we may add in the future
      data.offsets.popper = _extends({}, data.offsets.popper, getPopperOffsets(data.instance.popper, data.offsets.reference, data.placement));

      data = runModifiers(data.instance.modifiers, data, 'flip');
    }
  });
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function keepTogether(data) {
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var placement = data.placement.split('-')[0];
  var floor = Math.floor;
  var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
  var side = isVertical ? 'right' : 'bottom';
  var opSide = isVertical ? 'left' : 'top';
  var measurement = isVertical ? 'width' : 'height';

  if (popper[side] < floor(reference[opSide])) {
    data.offsets.popper[opSide] = floor(reference[opSide]) - popper[measurement];
  }
  if (popper[opSide] > floor(reference[side])) {
    data.offsets.popper[opSide] = floor(reference[side]);
  }

  return data;
}

/**
 * Converts a string containing value + unit into a px value number
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} str - Value + unit string
 * @argument {String} measurement - `height` or `width`
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @returns {Number|String}
 * Value in pixels, or original string if no values were extracted
 */
function toValue(str, measurement, popperOffsets, referenceOffsets) {
  // separate value from unit
  var split = str.match(/((?:\-|\+)?\d*\.?\d*)(.*)/);
  var value = +split[1];
  var unit = split[2];

  // If it's not a number it's an operator, I guess
  if (!value) {
    return str;
  }

  if (unit.indexOf('%') === 0) {
    var element = void 0;
    switch (unit) {
      case '%p':
        element = popperOffsets;
        break;
      case '%':
      case '%r':
      default:
        element = referenceOffsets;
    }

    var rect = getClientRect(element);
    return rect[measurement] / 100 * value;
  } else if (unit === 'vh' || unit === 'vw') {
    // if is a vh or vw, we calculate the size based on the viewport
    var size = void 0;
    if (unit === 'vh') {
      size = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
    } else {
      size = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    }
    return size / 100 * value;
  } else {
    // if is an explicit pixel unit, we get rid of the unit and keep the value
    // if is an implicit unit, it's px, and we return just the value
    return value;
  }
}

/**
 * Parse an `offset` string to extrapolate `x` and `y` numeric offsets.
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} offset
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @argument {String} basePlacement
 * @returns {Array} a two cells array with x and y offsets in numbers
 */
function parseOffset(offset, popperOffsets, referenceOffsets, basePlacement) {
  var offsets = [0, 0];

  // Use height if placement is left or right and index is 0 otherwise use width
  // in this way the first offset will use an axis and the second one
  // will use the other one
  var useHeight = ['right', 'left'].indexOf(basePlacement) !== -1;

  // Split the offset string to obtain a list of values and operands
  // The regex addresses values with the plus or minus sign in front (+10, -20, etc)
  var fragments = offset.split(/(\+|\-)/).map(function (frag) {
    return frag.trim();
  });

  // Detect if the offset string contains a pair of values or a single one
  // they could be separated by comma or space
  var divider = fragments.indexOf(find(fragments, function (frag) {
    return frag.search(/,|\s/) !== -1;
  }));

  if (fragments[divider] && fragments[divider].indexOf(',') === -1) {
    console.warn('Offsets separated by white space(s) are deprecated, use a comma (,) instead.');
  }

  // If divider is found, we divide the list of values and operands to divide
  // them by ofset X and Y.
  var splitRegex = /\s*,\s*|\s+/;
  var ops = divider !== -1 ? [fragments.slice(0, divider).concat([fragments[divider].split(splitRegex)[0]]), [fragments[divider].split(splitRegex)[1]].concat(fragments.slice(divider + 1))] : [fragments];

  // Convert the values with units to absolute pixels to allow our computations
  ops = ops.map(function (op, index) {
    // Most of the units rely on the orientation of the popper
    var measurement = (index === 1 ? !useHeight : useHeight) ? 'height' : 'width';
    var mergeWithPrevious = false;
    return op
    // This aggregates any `+` or `-` sign that aren't considered operators
    // e.g.: 10 + +5 => [10, +, +5]
    .reduce(function (a, b) {
      if (a[a.length - 1] === '' && ['+', '-'].indexOf(b) !== -1) {
        a[a.length - 1] = b;
        mergeWithPrevious = true;
        return a;
      } else if (mergeWithPrevious) {
        a[a.length - 1] += b;
        mergeWithPrevious = false;
        return a;
      } else {
        return a.concat(b);
      }
    }, [])
    // Here we convert the string values into number values (in px)
    .map(function (str) {
      return toValue(str, measurement, popperOffsets, referenceOffsets);
    });
  });

  // Loop trough the offsets arrays and execute the operations
  ops.forEach(function (op, index) {
    op.forEach(function (frag, index2) {
      if (isNumeric(frag)) {
        offsets[index] += frag * (op[index2 - 1] === '-' ? -1 : 1);
      }
    });
  });
  return offsets;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @argument {Number|String} options.offset=0
 * The offset value as described in the modifier description
 * @returns {Object} The data object, properly modified
 */
function offset(data, _ref) {
  var offset = _ref.offset;
  var placement = data.placement,
      _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var basePlacement = placement.split('-')[0];

  var offsets = void 0;
  if (isNumeric(+offset)) {
    offsets = [+offset, 0];
  } else {
    offsets = parseOffset(offset, popper, reference, basePlacement);
  }

  if (basePlacement === 'left') {
    popper.top += offsets[0];
    popper.left -= offsets[1];
  } else if (basePlacement === 'right') {
    popper.top += offsets[0];
    popper.left += offsets[1];
  } else if (basePlacement === 'top') {
    popper.left += offsets[0];
    popper.top -= offsets[1];
  } else if (basePlacement === 'bottom') {
    popper.left += offsets[0];
    popper.top += offsets[1];
  }

  data.popper = popper;
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function preventOverflow(data, options) {
  var boundariesElement = options.boundariesElement || getOffsetParent(data.instance.popper);

  // If offsetParent is the reference element, we really want to
  // go one step up and use the next offsetParent as reference to
  // avoid to make this modifier completely useless and look like broken
  if (data.instance.reference === boundariesElement) {
    boundariesElement = getOffsetParent(boundariesElement);
  }

  // NOTE: DOM access here
  // resets the popper's position so that the document size can be calculated excluding
  // the size of the popper element itself
  var transformProp = getSupportedPropertyName('transform');
  var popperStyles = data.instance.popper.style; // assignment to help minification
  var top = popperStyles.top,
      left = popperStyles.left,
      transform = popperStyles[transformProp];

  popperStyles.top = '';
  popperStyles.left = '';
  popperStyles[transformProp] = '';

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, boundariesElement, data.positionFixed);

  // NOTE: DOM access here
  // restores the original style properties after the offsets have been computed
  popperStyles.top = top;
  popperStyles.left = left;
  popperStyles[transformProp] = transform;

  options.boundaries = boundaries;

  var order = options.priority;
  var popper = data.offsets.popper;

  var check = {
    primary: function primary(placement) {
      var value = popper[placement];
      if (popper[placement] < boundaries[placement] && !options.escapeWithReference) {
        value = Math.max(popper[placement], boundaries[placement]);
      }
      return defineProperty({}, placement, value);
    },
    secondary: function secondary(placement) {
      var mainSide = placement === 'right' ? 'left' : 'top';
      var value = popper[mainSide];
      if (popper[placement] > boundaries[placement] && !options.escapeWithReference) {
        value = Math.min(popper[mainSide], boundaries[placement] - (placement === 'right' ? popper.width : popper.height));
      }
      return defineProperty({}, mainSide, value);
    }
  };

  order.forEach(function (placement) {
    var side = ['left', 'top'].indexOf(placement) !== -1 ? 'primary' : 'secondary';
    popper = _extends({}, popper, check[side](placement));
  });

  data.offsets.popper = popper;

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function shift(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var shiftvariation = placement.split('-')[1];

  // if shift shiftvariation is specified, run the modifier
  if (shiftvariation) {
    var _data$offsets = data.offsets,
        reference = _data$offsets.reference,
        popper = _data$offsets.popper;

    var isVertical = ['bottom', 'top'].indexOf(basePlacement) !== -1;
    var side = isVertical ? 'left' : 'top';
    var measurement = isVertical ? 'width' : 'height';

    var shiftOffsets = {
      start: defineProperty({}, side, reference[side]),
      end: defineProperty({}, side, reference[side] + reference[measurement] - popper[measurement])
    };

    data.offsets.popper = _extends({}, popper, shiftOffsets[shiftvariation]);
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function hide(data) {
  if (!isModifierRequired(data.instance.modifiers, 'hide', 'preventOverflow')) {
    return data;
  }

  var refRect = data.offsets.reference;
  var bound = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'preventOverflow';
  }).boundaries;

  if (refRect.bottom < bound.top || refRect.left > bound.right || refRect.top > bound.bottom || refRect.right < bound.left) {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === true) {
      return data;
    }

    data.hide = true;
    data.attributes['x-out-of-boundaries'] = '';
  } else {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === false) {
      return data;
    }

    data.hide = false;
    data.attributes['x-out-of-boundaries'] = false;
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function inner(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var isHoriz = ['left', 'right'].indexOf(basePlacement) !== -1;

  var subtractLength = ['top', 'left'].indexOf(basePlacement) === -1;

  popper[isHoriz ? 'left' : 'top'] = reference[basePlacement] - (subtractLength ? popper[isHoriz ? 'width' : 'height'] : 0);

  data.placement = getOppositePlacement(placement);
  data.offsets.popper = getClientRect(popper);

  return data;
}

/**
 * Modifier function, each modifier can have a function of this type assigned
 * to its `fn` property.<br />
 * These functions will be called on each update, this means that you must
 * make sure they are performant enough to avoid performance bottlenecks.
 *
 * @function ModifierFn
 * @argument {dataObject} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {dataObject} The data object, properly modified
 */

/**
 * Modifiers are plugins used to alter the behavior of your poppers.<br />
 * Popper.js uses a set of 9 modifiers to provide all the basic functionalities
 * needed by the library.
 *
 * Usually you don't want to override the `order`, `fn` and `onLoad` props.
 * All the other properties are configurations that could be tweaked.
 * @namespace modifiers
 */
var modifiers = {
  /**
   * Modifier used to shift the popper on the start or end of its reference
   * element.<br />
   * It will read the variation of the `placement` property.<br />
   * It can be one either `-end` or `-start`.
   * @memberof modifiers
   * @inner
   */
  shift: {
    /** @prop {number} order=100 - Index used to define the order of execution */
    order: 100,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: shift
  },

  /**
   * The `offset` modifier can shift your popper on both its axis.
   *
   * It accepts the following units:
   * - `px` or unit-less, interpreted as pixels
   * - `%` or `%r`, percentage relative to the length of the reference element
   * - `%p`, percentage relative to the length of the popper element
   * - `vw`, CSS viewport width unit
   * - `vh`, CSS viewport height unit
   *
   * For length is intended the main axis relative to the placement of the popper.<br />
   * This means that if the placement is `top` or `bottom`, the length will be the
   * `width`. In case of `left` or `right`, it will be the `height`.
   *
   * You can provide a single value (as `Number` or `String`), or a pair of values
   * as `String` divided by a comma or one (or more) white spaces.<br />
   * The latter is a deprecated method because it leads to confusion and will be
   * removed in v2.<br />
   * Additionally, it accepts additions and subtractions between different units.
   * Note that multiplications and divisions aren't supported.
   *
   * Valid examples are:
   * ```
   * 10
   * '10%'
   * '10, 10'
   * '10%, 10'
   * '10 + 10%'
   * '10 - 5vh + 3%'
   * '-10px + 5vh, 5px - 6%'
   * ```
   * > **NB**: If you desire to apply offsets to your poppers in a way that may make them overlap
   * > with their reference element, unfortunately, you will have to disable the `flip` modifier.
   * > You can read more on this at this [issue](https://github.com/FezVrasta/popper.js/issues/373).
   *
   * @memberof modifiers
   * @inner
   */
  offset: {
    /** @prop {number} order=200 - Index used to define the order of execution */
    order: 200,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: offset,
    /** @prop {Number|String} offset=0
     * The offset value as described in the modifier description
     */
    offset: 0
  },

  /**
   * Modifier used to prevent the popper from being positioned outside the boundary.
   *
   * A scenario exists where the reference itself is not within the boundaries.<br />
   * We can say it has "escaped the boundaries" — or just "escaped".<br />
   * In this case we need to decide whether the popper should either:
   *
   * - detach from the reference and remain "trapped" in the boundaries, or
   * - if it should ignore the boundary and "escape with its reference"
   *
   * When `escapeWithReference` is set to`true` and reference is completely
   * outside its boundaries, the popper will overflow (or completely leave)
   * the boundaries in order to remain attached to the edge of the reference.
   *
   * @memberof modifiers
   * @inner
   */
  preventOverflow: {
    /** @prop {number} order=300 - Index used to define the order of execution */
    order: 300,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: preventOverflow,
    /**
     * @prop {Array} [priority=['left','right','top','bottom']]
     * Popper will try to prevent overflow following these priorities by default,
     * then, it could overflow on the left and on top of the `boundariesElement`
     */
    priority: ['left', 'right', 'top', 'bottom'],
    /**
     * @prop {number} padding=5
     * Amount of pixel used to define a minimum distance between the boundaries
     * and the popper. This makes sure the popper always has a little padding
     * between the edges of its container
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='scrollParent'
     * Boundaries used by the modifier. Can be `scrollParent`, `window`,
     * `viewport` or any DOM element.
     */
    boundariesElement: 'scrollParent'
  },

  /**
   * Modifier used to make sure the reference and its popper stay near each other
   * without leaving any gap between the two. Especially useful when the arrow is
   * enabled and you want to ensure that it points to its reference element.
   * It cares only about the first axis. You can still have poppers with margin
   * between the popper and its reference element.
   * @memberof modifiers
   * @inner
   */
  keepTogether: {
    /** @prop {number} order=400 - Index used to define the order of execution */
    order: 400,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: keepTogether
  },

  /**
   * This modifier is used to move the `arrowElement` of the popper to make
   * sure it is positioned between the reference element and its popper element.
   * It will read the outer size of the `arrowElement` node to detect how many
   * pixels of conjunction are needed.
   *
   * It has no effect if no `arrowElement` is provided.
   * @memberof modifiers
   * @inner
   */
  arrow: {
    /** @prop {number} order=500 - Index used to define the order of execution */
    order: 500,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: arrow,
    /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */
    element: '[x-arrow]'
  },

  /**
   * Modifier used to flip the popper's placement when it starts to overlap its
   * reference element.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   *
   * **NOTE:** this modifier will interrupt the current update cycle and will
   * restart it if it detects the need to flip the placement.
   * @memberof modifiers
   * @inner
   */
  flip: {
    /** @prop {number} order=600 - Index used to define the order of execution */
    order: 600,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: flip,
    /**
     * @prop {String|Array} behavior='flip'
     * The behavior used to change the popper's placement. It can be one of
     * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
     * placements (with optional variations)
     */
    behavior: 'flip',
    /**
     * @prop {number} padding=5
     * The popper will flip if it hits the edges of the `boundariesElement`
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='viewport'
     * The element which will define the boundaries of the popper position.
     * The popper will never be placed outside of the defined boundaries
     * (except if `keepTogether` is enabled)
     */
    boundariesElement: 'viewport',
    /**
     * @prop {Boolean} flipVariations=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the reference element overlaps its boundaries.
     *
     * The original placement should have a set variation.
     */
    flipVariations: false,
    /**
     * @prop {Boolean} flipVariationsByContent=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the popper element overlaps its reference boundaries.
     *
     * The original placement should have a set variation.
     */
    flipVariationsByContent: false
  },

  /**
   * Modifier used to make the popper flow toward the inner of the reference element.
   * By default, when this modifier is disabled, the popper will be placed outside
   * the reference element.
   * @memberof modifiers
   * @inner
   */
  inner: {
    /** @prop {number} order=700 - Index used to define the order of execution */
    order: 700,
    /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */
    enabled: false,
    /** @prop {ModifierFn} */
    fn: inner
  },

  /**
   * Modifier used to hide the popper when its reference element is outside of the
   * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
   * be used to hide with a CSS selector the popper when its reference is
   * out of boundaries.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   * @memberof modifiers
   * @inner
   */
  hide: {
    /** @prop {number} order=800 - Index used to define the order of execution */
    order: 800,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: hide
  },

  /**
   * Computes the style that will be applied to the popper element to gets
   * properly positioned.
   *
   * Note that this modifier will not touch the DOM, it just prepares the styles
   * so that `applyStyle` modifier can apply it. This separation is useful
   * in case you need to replace `applyStyle` with a custom implementation.
   *
   * This modifier has `850` as `order` value to maintain backward compatibility
   * with previous versions of Popper.js. Expect the modifiers ordering method
   * to change in future major versions of the library.
   *
   * @memberof modifiers
   * @inner
   */
  computeStyle: {
    /** @prop {number} order=850 - Index used to define the order of execution */
    order: 850,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: computeStyle,
    /**
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: true,
    /**
     * @prop {string} [x='bottom']
     * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
     * Change this if your popper should grow in a direction different from `bottom`
     */
    x: 'bottom',
    /**
     * @prop {string} [x='left']
     * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
     * Change this if your popper should grow in a direction different from `right`
     */
    y: 'right'
  },

  /**
   * Applies the computed styles to the popper element.
   *
   * All the DOM manipulations are limited to this modifier. This is useful in case
   * you want to integrate Popper.js inside a framework or view library and you
   * want to delegate all the DOM manipulations to it.
   *
   * Note that if you disable this modifier, you must make sure the popper element
   * has its position set to `absolute` before Popper.js can do its work!
   *
   * Just disable this modifier and define your own to achieve the desired effect.
   *
   * @memberof modifiers
   * @inner
   */
  applyStyle: {
    /** @prop {number} order=900 - Index used to define the order of execution */
    order: 900,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: applyStyle,
    /** @prop {Function} */
    onLoad: applyStyleOnLoad,
    /**
     * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: undefined
  }
};

/**
 * The `dataObject` is an object containing all the information used by Popper.js.
 * This object is passed to modifiers and to the `onCreate` and `onUpdate` callbacks.
 * @name dataObject
 * @property {Object} data.instance The Popper.js instance
 * @property {String} data.placement Placement applied to popper
 * @property {String} data.originalPlacement Placement originally defined on init
 * @property {Boolean} data.flipped True if popper has been flipped by flip modifier
 * @property {Boolean} data.hide True if the reference element is out of boundaries, useful to know when to hide the popper
 * @property {HTMLElement} data.arrowElement Node used as arrow by arrow modifier
 * @property {Object} data.styles Any CSS property defined here will be applied to the popper. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.arrowStyles Any CSS property defined here will be applied to the popper arrow. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.boundaries Offsets of the popper boundaries
 * @property {Object} data.offsets The measurements of popper, reference and arrow elements
 * @property {Object} data.offsets.popper `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.reference `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.arrow] `top` and `left` offsets, only one of them will be different from 0
 */

/**
 * Default options provided to Popper.js constructor.<br />
 * These can be overridden using the `options` argument of Popper.js.<br />
 * To override an option, simply pass an object with the same
 * structure of the `options` object, as the 3rd argument. For example:
 * ```
 * new Popper(ref, pop, {
 *   modifiers: {
 *     preventOverflow: { enabled: false }
 *   }
 * })
 * ```
 * @type {Object}
 * @static
 * @memberof Popper
 */
var Defaults = {
  /**
   * Popper's placement.
   * @prop {Popper.placements} placement='bottom'
   */
  placement: 'bottom',

  /**
   * Set this to true if you want popper to position it self in 'fixed' mode
   * @prop {Boolean} positionFixed=false
   */
  positionFixed: false,

  /**
   * Whether events (resize, scroll) are initially enabled.
   * @prop {Boolean} eventsEnabled=true
   */
  eventsEnabled: true,

  /**
   * Set to true if you want to automatically remove the popper when
   * you call the `destroy` method.
   * @prop {Boolean} removeOnDestroy=false
   */
  removeOnDestroy: false,

  /**
   * Callback called when the popper is created.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onCreate}
   */
  onCreate: function onCreate() {},

  /**
   * Callback called when the popper is updated. This callback is not called
   * on the initialization/creation of the popper, but only on subsequent
   * updates.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onUpdate}
   */
  onUpdate: function onUpdate() {},

  /**
   * List of modifiers used to modify the offsets before they are applied to the popper.
   * They provide most of the functionalities of Popper.js.
   * @prop {modifiers}
   */
  modifiers: modifiers
};

/**
 * @callback onCreate
 * @param {dataObject} data
 */

/**
 * @callback onUpdate
 * @param {dataObject} data
 */

// Utils
// Methods
var Popper = function () {
  /**
   * Creates a new Popper.js instance.
   * @class Popper
   * @param {Element|referenceObject} reference - The reference element used to position the popper
   * @param {Element} popper - The HTML / XML element used as the popper
   * @param {Object} options - Your custom options to override the ones defined in [Defaults](#defaults)
   * @return {Object} instance - The generated Popper.js instance
   */
  function Popper(reference, popper) {
    var _this = this;

    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    classCallCheck(this, Popper);

    this.scheduleUpdate = function () {
      return requestAnimationFrame(_this.update);
    };

    // make update() debounced, so that it only runs at most once-per-tick
    this.update = debounce(this.update.bind(this));

    // with {} we create a new object with the options inside it
    this.options = _extends({}, Popper.Defaults, options);

    // init state
    this.state = {
      isDestroyed: false,
      isCreated: false,
      scrollParents: []
    };

    // get reference and popper elements (allow jQuery wrappers)
    this.reference = reference && reference.jquery ? reference[0] : reference;
    this.popper = popper && popper.jquery ? popper[0] : popper;

    // Deep merge modifiers options
    this.options.modifiers = {};
    Object.keys(_extends({}, Popper.Defaults.modifiers, options.modifiers)).forEach(function (name) {
      _this.options.modifiers[name] = _extends({}, Popper.Defaults.modifiers[name] || {}, options.modifiers ? options.modifiers[name] : {});
    });

    // Refactoring modifiers' list (Object => Array)
    this.modifiers = Object.keys(this.options.modifiers).map(function (name) {
      return _extends({
        name: name
      }, _this.options.modifiers[name]);
    })
    // sort the modifiers by order
    .sort(function (a, b) {
      return a.order - b.order;
    });

    // modifiers have the ability to execute arbitrary code when Popper.js get inited
    // such code is executed in the same order of its modifier
    // they could add new properties to their options configuration
    // BE AWARE: don't add options to `options.modifiers.name` but to `modifierOptions`!
    this.modifiers.forEach(function (modifierOptions) {
      if (modifierOptions.enabled && isFunction(modifierOptions.onLoad)) {
        modifierOptions.onLoad(_this.reference, _this.popper, _this.options, modifierOptions, _this.state);
      }
    });

    // fire the first update to position the popper in the right place
    this.update();

    var eventsEnabled = this.options.eventsEnabled;
    if (eventsEnabled) {
      // setup event listeners, they will take care of update the position in specific situations
      this.enableEventListeners();
    }

    this.state.eventsEnabled = eventsEnabled;
  }

  // We can't use class properties because they don't get listed in the
  // class prototype and break stuff like Sinon stubs


  createClass(Popper, [{
    key: 'update',
    value: function update$$1() {
      return update.call(this);
    }
  }, {
    key: 'destroy',
    value: function destroy$$1() {
      return destroy.call(this);
    }
  }, {
    key: 'enableEventListeners',
    value: function enableEventListeners$$1() {
      return enableEventListeners.call(this);
    }
  }, {
    key: 'disableEventListeners',
    value: function disableEventListeners$$1() {
      return disableEventListeners.call(this);
    }

    /**
     * Schedules an update. It will run on the next UI update available.
     * @method scheduleUpdate
     * @memberof Popper
     */


    /**
     * Collection of utilities useful when writing custom modifiers.
     * Starting from version 1.7, this method is available only if you
     * include `popper-utils.js` before `popper.js`.
     *
     * **DEPRECATION**: This way to access PopperUtils is deprecated
     * and will be removed in v2! Use the PopperUtils module directly instead.
     * Due to the high instability of the methods contained in Utils, we can't
     * guarantee them to follow semver. Use them at your own risk!
     * @static
     * @private
     * @type {Object}
     * @deprecated since version 1.8
     * @member Utils
     * @memberof Popper
     */

  }]);
  return Popper;
}();

/**
 * The `referenceObject` is an object that provides an interface compatible with Popper.js
 * and lets you use it as replacement of a real DOM node.<br />
 * You can use this method to position a popper relatively to a set of coordinates
 * in case you don't have a DOM node to use as reference.
 *
 * ```
 * new Popper(referenceObject, popperNode);
 * ```
 *
 * NB: This feature isn't supported in Internet Explorer 10.
 * @name referenceObject
 * @property {Function} data.getBoundingClientRect
 * A function that returns a set of coordinates compatible with the native `getBoundingClientRect` method.
 * @property {number} data.clientWidth
 * An ES6 getter that will return the width of the virtual reference element.
 * @property {number} data.clientHeight
 * An ES6 getter that will return the height of the virtual reference element.
 */


Popper.Utils = (typeof window !== 'undefined' ? window : global).PopperUtils;
Popper.placements = placements;
Popper.Defaults = Defaults;

/* harmony default export */ __webpack_exports__["a"] = (Popper);
//# sourceMappingURL=popper.js.map

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(39)))

/***/ }),
/* 744 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _implementation = __webpack_require__(745);

var _implementation2 = _interopRequireDefault(_implementation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _react2.default.createContext || _implementation2.default;
module.exports = exports['default'];

/***/ }),
/* 745 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(7);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _gud = __webpack_require__(746);

var _gud2 = _interopRequireDefault(_gud);

var _warning = __webpack_require__(37);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MAX_SIGNED_31_BIT_INT = 1073741823;

// Inlined Object.is polyfill.
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
function objectIs(x, y) {
  if (x === y) {
    return x !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function createEventEmitter(value) {
  var handlers = [];
  return {
    on: function on(handler) {
      handlers.push(handler);
    },
    off: function off(handler) {
      handlers = handlers.filter(function (h) {
        return h !== handler;
      });
    },
    get: function get() {
      return value;
    },
    set: function set(newValue, changedBits) {
      value = newValue;
      handlers.forEach(function (handler) {
        return handler(value, changedBits);
      });
    }
  };
}

function onlyChild(children) {
  return Array.isArray(children) ? children[0] : children;
}

function createReactContext(defaultValue, calculateChangedBits) {
  var _Provider$childContex, _Consumer$contextType;

  var contextProp = '__create-react-context-' + (0, _gud2.default)() + '__';

  var Provider = function (_Component) {
    _inherits(Provider, _Component);

    function Provider() {
      var _temp, _this, _ret;

      _classCallCheck(this, Provider);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.emitter = createEventEmitter(_this.props.value), _temp), _possibleConstructorReturn(_this, _ret);
    }

    Provider.prototype.getChildContext = function getChildContext() {
      var _ref;

      return _ref = {}, _ref[contextProp] = this.emitter, _ref;
    };

    Provider.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      if (this.props.value !== nextProps.value) {
        var oldValue = this.props.value;
        var newValue = nextProps.value;
        var changedBits = void 0;

        if (objectIs(oldValue, newValue)) {
          changedBits = 0; // No change
        } else {
          changedBits = typeof calculateChangedBits === 'function' ? calculateChangedBits(oldValue, newValue) : MAX_SIGNED_31_BIT_INT;
          if (false) {
            (0, _warning2.default)((changedBits & MAX_SIGNED_31_BIT_INT) === changedBits, 'calculateChangedBits: Expected the return value to be a ' + '31-bit integer. Instead received: %s', changedBits);
          }

          changedBits |= 0;

          if (changedBits !== 0) {
            this.emitter.set(nextProps.value, changedBits);
          }
        }
      }
    };

    Provider.prototype.render = function render() {
      return this.props.children;
    };

    return Provider;
  }(_react.Component);

  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[contextProp] = _propTypes2.default.object.isRequired, _Provider$childContex);

  var Consumer = function (_Component2) {
    _inherits(Consumer, _Component2);

    function Consumer() {
      var _temp2, _this2, _ret2;

      _classCallCheck(this, Consumer);

      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return _ret2 = (_temp2 = (_this2 = _possibleConstructorReturn(this, _Component2.call.apply(_Component2, [this].concat(args))), _this2), _this2.state = {
        value: _this2.getValue()
      }, _this2.onUpdate = function (newValue, changedBits) {
        var observedBits = _this2.observedBits | 0;
        if ((observedBits & changedBits) !== 0) {
          _this2.setState({ value: _this2.getValue() });
        }
      }, _temp2), _possibleConstructorReturn(_this2, _ret2);
    }

    Consumer.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      var observedBits = nextProps.observedBits;

      this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
      : observedBits;
    };

    Consumer.prototype.componentDidMount = function componentDidMount() {
      if (this.context[contextProp]) {
        this.context[contextProp].on(this.onUpdate);
      }
      var observedBits = this.props.observedBits;

      this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
      : observedBits;
    };

    Consumer.prototype.componentWillUnmount = function componentWillUnmount() {
      if (this.context[contextProp]) {
        this.context[contextProp].off(this.onUpdate);
      }
    };

    Consumer.prototype.getValue = function getValue() {
      if (this.context[contextProp]) {
        return this.context[contextProp].get();
      } else {
        return defaultValue;
      }
    };

    Consumer.prototype.render = function render() {
      return onlyChild(this.props.children)(this.state.value);
    };

    return Consumer;
  }(_react.Component);

  Consumer.contextTypes = (_Consumer$contextType = {}, _Consumer$contextType[contextProp] = _propTypes2.default.object, _Consumer$contextType);


  return {
    Provider: Provider,
    Consumer: Consumer
  };
}

exports.default = createReactContext;
module.exports = exports['default'];

/***/ }),
/* 746 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {// @flow


var key = '__global_unique_id__';

module.exports = function() {
  return global[key] = (global[key] || 0) + 1;
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(39)))

/***/ }),
/* 747 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Reference;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_inheritsLoose__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_inheritsLoose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_inheritsLoose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_warning__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Manager__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils__ = __webpack_require__(307);









var InnerReference =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_inheritsLoose___default()(InnerReference, _React$Component);

  function InnerReference() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_assertThisInitialized___default()(_this), "refHandler", function (node) {
      Object(__WEBPACK_IMPORTED_MODULE_7__utils__["b" /* setRef */])(_this.props.innerRef, node);
      Object(__WEBPACK_IMPORTED_MODULE_7__utils__["a" /* safeInvoke */])(_this.props.setReferenceNode, node);
    });

    return _this;
  }

  var _proto = InnerReference.prototype;

  _proto.componentWillUnmount = function componentWillUnmount() {
    Object(__WEBPACK_IMPORTED_MODULE_7__utils__["b" /* setRef */])(this.props.innerRef, null);
  };

  _proto.render = function render() {
    __WEBPACK_IMPORTED_MODULE_5_warning___default()(Boolean(this.props.setReferenceNode), '`Reference` should not be used outside of a `Manager` component.');
    return Object(__WEBPACK_IMPORTED_MODULE_7__utils__["c" /* unwrapArray */])(this.props.children)({
      ref: this.refHandler
    });
  };

  return InnerReference;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

function Reference(props) {
  return __WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__Manager__["b" /* ManagerReferenceNodeSetterContext */].Consumer, null, function (setReferenceNode) {
    return __WEBPACK_IMPORTED_MODULE_4_react__["createElement"](InnerReference, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({
      setReferenceNode: setReferenceNode
    }, props));
  });
}

/***/ }),
/* 748 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 749 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(750);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(17)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../../lunch-team-client-checkout-msg/node_modules/css-loader/index.js!../../../../../../../../lunch-team-client-checkout-msg/node_modules/sass-loader/dist/cjs.js!./DatePickerOrder.scss", function() {
			var newContent = require("!!../../../../../../../../lunch-team-client-checkout-msg/node_modules/css-loader/index.js!../../../../../../../../lunch-team-client-checkout-msg/node_modules/sass-loader/dist/cjs.js!./DatePickerOrder.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 750 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(14)(undefined);
// imports


// module
exports.push([module.i, ".react-datepicker{width:300px}.react-datepicker__month-container{width:75%;float:left}.react-datepicker__day-name{width:1.7rem}.react-datepicker-wrapper{width:100%}.react-datepicker__input-container{width:100%}.react-datepicker__input-container input{height:30px;border-radius:8px;margin-bottom:0}.react-datepicker__time-container{width:25%}ul.react-datepicker__time-list{padding-right:0 !important}li.react-datepicker__time-list-item{padding:5px 5px}", ""]);

// exports


/***/ }),
/* 751 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(752);


/***/ }),
/* 752 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ReactCustomGoogleAutocomplete = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(7);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ReactGoogleAutocomplete = function (_React$Component) {
  _inherits(ReactGoogleAutocomplete, _React$Component);

  function ReactGoogleAutocomplete(props) {
    _classCallCheck(this, ReactGoogleAutocomplete);

    var _this = _possibleConstructorReturn(this, (ReactGoogleAutocomplete.__proto__ || Object.getPrototypeOf(ReactGoogleAutocomplete)).call(this, props));

    _this.autocomplete = null;
    _this.event = null;
    return _this;
  }

  _createClass(ReactGoogleAutocomplete, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
          _props$types = _props.types,
          types = _props$types === undefined ? ['(cities)'] : _props$types,
          componentRestrictions = _props.componentRestrictions,
          bounds = _props.bounds,
          _props$fields = _props.fields,
          fields = _props$fields === undefined ? ['address_components', 'geometry.location', 'place_id', 'formatted_address'] : _props$fields;

      var config = {
        types: types,
        bounds: bounds,
        fields: fields
      };

      if (componentRestrictions) {
        config.componentRestrictions = componentRestrictions;
      }

      this.disableAutofill();

      this.autocomplete = new google.maps.places.Autocomplete(this.refs.input, config);

      this.event = this.autocomplete.addListener('place_changed', this.onSelected.bind(this));
    }
  }, {
    key: 'disableAutofill',
    value: function disableAutofill() {
      var _this2 = this;

      // Autofill workaround adapted from https://stackoverflow.com/questions/29931712/chrome-autofill-covers-autocomplete-for-google-maps-api-v3/49161445#49161445
      if (window.MutationObserver) {
        var observerHack = new MutationObserver(function () {
          observerHack.disconnect();
          if (_this2.refs && _this2.refs.input) {
            _this2.refs.input.autocomplete = 'disable-autofill';
          }
        });
        observerHack.observe(this.refs.input, {
          attributes: true,
          attributeFilter: ['autocomplete']
        });
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.event) this.event.remove();
    }
  }, {
    key: 'onSelected',
    value: function onSelected() {
      if (this.props.onPlaceSelected && this.autocomplete) {
        this.props.onPlaceSelected(this.autocomplete.getPlace(), this.refs.input);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          onPlaceSelected = _props2.onPlaceSelected,
          types = _props2.types,
          componentRestrictions = _props2.componentRestrictions,
          bounds = _props2.bounds,
          rest = _objectWithoutProperties(_props2, ['onPlaceSelected', 'types', 'componentRestrictions', 'bounds']);

      return _react2.default.createElement('input', _extends({ ref: 'input' }, rest));
    }
  }]);

  return ReactGoogleAutocomplete;
}(_react2.default.Component);

ReactGoogleAutocomplete.propTypes = {
  onPlaceSelected: _propTypes2.default.func,
  types: _propTypes2.default.array,
  componentRestrictions: _propTypes2.default.object,
  bounds: _propTypes2.default.object,
  fields: _propTypes2.default.array
};
exports.default = ReactGoogleAutocomplete;

var ReactCustomGoogleAutocomplete = exports.ReactCustomGoogleAutocomplete = function (_React$Component2) {
  _inherits(ReactCustomGoogleAutocomplete, _React$Component2);

  function ReactCustomGoogleAutocomplete(props) {
    _classCallCheck(this, ReactCustomGoogleAutocomplete);

    var _this3 = _possibleConstructorReturn(this, (ReactCustomGoogleAutocomplete.__proto__ || Object.getPrototypeOf(ReactCustomGoogleAutocomplete)).call(this, props));

    _this3.service = new google.maps.places.AutocompleteService();
    return _this3;
  }

  _createClass(ReactCustomGoogleAutocomplete, [{
    key: 'onChange',
    value: function onChange(e) {
      var _this4 = this;

      var _props$types2 = this.props.types,
          types = _props$types2 === undefined ? ['(cities)'] : _props$types2;


      if (e.target.value) {
        this.service.getPlacePredictions({ input: e.target.value, types: types }, function (predictions, status) {
          if (status === 'OK' && predictions && predictions.length > 0) {
            _this4.props.onOpen(predictions);
            console.log(predictions);
          } else {
            _this4.props.onClose();
          }
        });
      } else {
        this.props.onClose();
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this5 = this;

      if (this.props.input.value) {
        this.placeService = new google.maps.places.PlacesService(this.refs.div);
        this.placeService.getDetails({ placeId: this.props.input.value }, function (e, status) {
          if (status === 'OK') {
            _this5.refs.input.value = e.formatted_address;
          }
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this6 = this;

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.cloneElement(this.props.input, _extends({}, this.props, {
          ref: 'input',
          onChange: function onChange(e) {
            _this6.onChange(e);
          }
        })),
        _react2.default.createElement('div', { ref: 'div' })
      );
    }
  }]);

  return ReactCustomGoogleAutocomplete;
}(_react2.default.Component);

ReactCustomGoogleAutocomplete.propTypes = {
  input: _propTypes2.default.node.isRequired,
  onOpen: _propTypes2.default.func.isRequired,
  onClose: _propTypes2.default.func.isRequired
};

/***/ }),
/* 753 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 754 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 755 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */



var hyphenate = __webpack_require__(756);

var msPattern = /^ms-/;

/**
 * Hyphenates a camelcased CSS property name, for example:
 *
 *   > hyphenateStyleName('backgroundColor')
 *   < "background-color"
 *   > hyphenateStyleName('MozTransition')
 *   < "-moz-transition"
 *   > hyphenateStyleName('msTransition')
 *   < "-ms-transition"
 *
 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
 * is converted to `-ms-`.
 *
 * @param {string} string
 * @return {string}
 */
function hyphenateStyleName(string) {
  return hyphenate(string).replace(msPattern, '-ms-');
}

module.exports = hyphenateStyleName;

/***/ }),
/* 756 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var _uppercasePattern = /([A-Z])/g;

/**
 * Hyphenates a camelcased string, for example:
 *
 *   > hyphenate('backgroundColor')
 *   < "background-color"
 *
 * For CSS style names, use `hyphenateStyleName` instead which works properly
 * with all vendor prefixes, including `ms`.
 *
 * @param {string} string
 * @return {string}
 */
function hyphenate(string) {
  return string.replace(_uppercasePattern, '-$1').toLowerCase();
}

module.exports = hyphenate;

/***/ }),
/* 757 */
/***/ (function(module, exports, __webpack_require__) {

/*
 *          __        ___
 *    _____/ /___  __/ (_)____
 *   / ___/ __/ / / / / / ___/
 *  (__  ) /_/ /_/ / / (__  )
 * /____/\__/\__, /_/_/____/
 *          /____/
 *
 * light - weight css preprocessor @licence MIT
 */
(function (factory) {/* eslint-disable */
	 true ? (module['exports'] = factory(null)) :
		typeof define === 'function' && define['amd'] ? define(factory(null)) :
			(window['stylis'] = factory(null))
}(/** @param {*=} options */function factory (options) {/* eslint-disable */

	'use strict'

	/**
	 * Notes
	 *
	 * The ['<method name>'] pattern is used to support closure compiler
	 * the jsdoc signatures are also used to the same effect
	 *
	 * ----
	 *
	 * int + int + int === n4 [faster]
	 *
	 * vs
	 *
	 * int === n1 && int === n2 && int === n3
	 *
	 * ----
	 *
	 * switch (int) { case ints...} [faster]
	 *
	 * vs
	 *
	 * if (int == 1 && int === 2 ...)
	 *
	 * ----
	 *
	 * The (first*n1 + second*n2 + third*n3) format used in the property parser
	 * is a simple way to hash the sequence of characters
	 * taking into account the index they occur in
	 * since any number of 3 character sequences could produce duplicates.
	 *
	 * On the other hand sequences that are directly tied to the index of the character
	 * resolve a far more accurate measure, it's also faster
	 * to evaluate one condition in a switch statement
	 * than three in an if statement regardless of the added math.
	 *
	 * This allows the vendor prefixer to be both small and fast.
	 */

	var nullptn = /^\0+/g /* matches leading null characters */
	var formatptn = /[\0\r\f]/g /* matches new line, null and formfeed characters */
	var colonptn = /: */g /* splits animation rules */
	var cursorptn = /zoo|gra/ /* assert cursor varient */
	var transformptn = /([,: ])(transform)/g /* vendor prefix transform, older webkit */
	var animationptn = /,+\s*(?![^(]*[)])/g /* splits multiple shorthand notation animations */
	var propertiesptn = / +\s*(?![^(]*[)])/g /* animation properties */
	var elementptn = / *[\0] */g /* selector elements */
	var selectorptn = /,\r+?/g /* splits selectors */
	var andptn = /([\t\r\n ])*\f?&/g /* match & */
	var escapeptn = /:global\(((?:[^\(\)\[\]]*|\[.*\]|\([^\(\)]*\))*)\)/g /* matches :global(.*) */
	var invalidptn = /\W+/g /* removes invalid characters from keyframes */
	var keyframeptn = /@(k\w+)\s*(\S*)\s*/ /* matches @keyframes $1 */
	var plcholdrptn = /::(place)/g /* match ::placeholder varient */
	var readonlyptn = /:(read-only)/g /* match :read-only varient */
	var beforeptn = /\s+(?=[{\];=:>])/g /* matches \s before ] ; = : */
	var afterptn = /([[}=:>])\s+/g /* matches \s after characters [ } = : */
	var tailptn = /(\{[^{]+?);(?=\})/g /* matches tail semi-colons ;} */
	var whiteptn = /\s{2,}/g /* matches repeating whitespace */
	var pseudoptn = /([^\(])(:+) */g /* pseudo element */
	var writingptn = /[svh]\w+-[tblr]{2}/ /* match writing mode property values */
	var gradientptn = /([\w-]+t\()/g /* match *gradient property */
	var supportsptn = /\(\s*(.*)\s*\)/g /* match supports (groups) */
	var propertyptn = /([\s\S]*?);/g /* match properties leading semicolon */
	var selfptn = /-self|flex-/g /* match flex- and -self in align-self: flex-*; */
	var pseudofmt = /[^]*?(:[rp][el]a[\w-]+)[^]*/ /* extrats :readonly or :placholder from selector */
	var trimptn = /[ \t]+$/ /* match tail whitspace */
	var dimensionptn = /stretch|:\s*\w+\-(?:conte|avail)/ /* match max/min/fit-content, fill-available */
	var imgsrcptn = /([^-])(image-set\()/

	/* vendors */
	var webkit = '-webkit-'
	var moz = '-moz-'
	var ms = '-ms-'

	/* character codes */
	var SEMICOLON = 59 /* ; */
	var CLOSEBRACES = 125 /* } */
	var OPENBRACES = 123 /* { */
	var OPENPARENTHESES = 40 /* ( */
	var CLOSEPARENTHESES = 41 /* ) */
	var OPENBRACKET = 91 /* [ */
	var CLOSEBRACKET = 93 /* ] */
	var NEWLINE = 10 /* \n */
	var CARRIAGE = 13 /* \r */
	var TAB = 9 /* \t */
	var AT = 64 /* @ */
	var SPACE = 32 /*   */
	var AND = 38 /* & */
	var DASH = 45 /* - */
	var UNDERSCORE = 95 /* _ */
	var STAR = 42 /* * */
	var COMMA = 44 /* , */
	var COLON = 58 /* : */
	var SINGLEQUOTE = 39 /* ' */
	var DOUBLEQUOTE = 34 /* " */
	var FOWARDSLASH = 47 /* / */
	var GREATERTHAN = 62 /* > */
	var PLUS = 43 /* + */
	var TILDE = 126 /* ~ */
	var NULL = 0 /* \0 */
	var FORMFEED = 12 /* \f */
	var VERTICALTAB = 11 /* \v */

	/* special identifiers */
	var KEYFRAME = 107 /* k */
	var MEDIA = 109 /* m */
	var SUPPORTS = 115 /* s */
	var PLACEHOLDER = 112 /* p */
	var READONLY = 111 /* o */
	var IMPORT = 105 /* <at>i */
	var CHARSET = 99 /* <at>c */
	var DOCUMENT = 100 /* <at>d */
	var PAGE = 112 /* <at>p */

	var column = 1 /* current column */
	var line = 1 /* current line numebr */
	var pattern = 0 /* :pattern */

	var cascade = 1 /* #id h1 h2 vs h1#id h2#id  */
	var prefix = 1 /* vendor prefix */
	var escape = 1 /* escape :global() pattern */
	var compress = 0 /* compress output */
	var semicolon = 0 /* no/semicolon option */
	var preserve = 0 /* preserve empty selectors */

	/* empty reference */
	var array = []

	/* plugins */
	var plugins = []
	var plugged = 0
	var should = null

	/* plugin context */
	var POSTS = -2
	var PREPS = -1
	var UNKWN = 0
	var PROPS = 1
	var BLCKS = 2
	var ATRUL = 3

	/* plugin newline context */
	var unkwn = 0

	/* keyframe animation */
	var keyed = 1
	var key = ''

	/* selector namespace */
	var nscopealt = ''
	var nscope = ''

	/**
	 * Compile
	 *
	 * @param {Array<string>} parent
	 * @param {Array<string>} current
	 * @param {string} body
	 * @param {number} id
	 * @param {number} depth
	 * @return {string}
	 */
	function compile (parent, current, body, id, depth) {
		var bracket = 0 /* brackets [] */
		var comment = 0 /* comments /* // or /* */
		var parentheses = 0 /* functions () */
		var quote = 0 /* quotes '', "" */

		var first = 0 /* first character code */
		var second = 0 /* second character code */
		var code = 0 /* current character code */
		var tail = 0 /* previous character code */
		var trail = 0 /* character before previous code */
		var peak = 0 /* previous non-whitespace code */

		var counter = 0 /* count sequence termination */
		var context = 0 /* track current context */
		var atrule = 0 /* track @at-rule context */
		var pseudo = 0 /* track pseudo token index */
		var caret = 0 /* current character index */
		var format = 0 /* control character formating context */
		var insert = 0 /* auto semicolon insertion */
		var invert = 0 /* inverted selector pattern */
		var length = 0 /* generic length address */
		var eof = body.length /* end of file(length) */
		var eol = eof - 1 /* end of file(characters) */

		var char = '' /* current character */
		var chars = '' /* current buffer of characters */
		var child = '' /* next buffer of characters */
		var out = '' /* compiled body */
		var children = '' /* compiled children */
		var flat = '' /* compiled leafs */
		var selector /* generic selector address */
		var result /* generic address */

		// ...build body
		while (caret < eof) {
			code = body.charCodeAt(caret)

			// eof varient
			if (caret === eol) {
				// last character + noop context, add synthetic padding for noop context to terminate
				if (comment + quote + parentheses + bracket !== 0) {
					if (comment !== 0) {
						code = comment === FOWARDSLASH ? NEWLINE : FOWARDSLASH
					}

					quote = parentheses = bracket = 0
					eof++
					eol++
				}
			}

			if (comment + quote + parentheses + bracket === 0) {
				// eof varient
				if (caret === eol) {
					if (format > 0) {
						chars = chars.replace(formatptn, '')
					}

					if (chars.trim().length > 0) {
						switch (code) {
							case SPACE:
							case TAB:
							case SEMICOLON:
							case CARRIAGE:
							case NEWLINE: {
								break
							}
							default: {
								chars += body.charAt(caret)
							}
						}

						code = SEMICOLON
					}
				}

				// auto semicolon insertion
				if (insert === 1) {
					switch (code) {
						// false flags
						case OPENBRACES:
						case CLOSEBRACES:
						case SEMICOLON:
						case DOUBLEQUOTE:
						case SINGLEQUOTE:
						case OPENPARENTHESES:
						case CLOSEPARENTHESES:
						case COMMA: {
							insert = 0
						}
						// ignore
						case TAB:
						case CARRIAGE:
						case NEWLINE:
						case SPACE: {
							break
						}
						// valid
						default: {
							insert = 0
							length = caret
							first = code
							caret--
							code = SEMICOLON

							while (length < eof) {
								switch (body.charCodeAt(length++)) {
									case NEWLINE:
									case CARRIAGE:
									case SEMICOLON: {
										++caret
										code = first
										length = eof
										break
									}
									case COLON: {
										if (format > 0) {
											++caret
											code = first
										}
									}
									case OPENBRACES: {
										length = eof
									}
								}
							}
						}
					}
				}

				// token varient
				switch (code) {
					case OPENBRACES: {
						chars = chars.trim()
						first = chars.charCodeAt(0)
						counter = 1
						length = ++caret

						while (caret < eof) {
							switch (code = body.charCodeAt(caret)) {
								case OPENBRACES: {
									counter++
									break
								}
								case CLOSEBRACES: {
									counter--
									break
								}
								case FOWARDSLASH: {
									switch (second = body.charCodeAt(caret + 1)) {
										// /*, //
										case STAR:
										case FOWARDSLASH: {
											caret = delimited(second, caret, eol, body)
										}
									}
									break
								}
								// given "[" === 91 & "]" === 93 hence forth 91 + 1 + 1 === 93
								case OPENBRACKET: {
									code++
								}
								// given "(" === 40 & ")" === 41 hence forth 40 + 1 === 41
								case OPENPARENTHESES: {
									code++
								}
								// quote tail delimiter is identical to the head delimiter hence noop,
								// fallthrough clauses have been shifted to the correct tail delimiter
								case DOUBLEQUOTE:
								case SINGLEQUOTE: {
									while (caret++ < eol) {
										if (body.charCodeAt(caret) === code) {
											break
										}
									}
								}
							}

							if (counter === 0) {
								break
							}

							caret++
						}

						child = body.substring(length, caret)

						if (first === NULL) {
							first = (chars = chars.replace(nullptn, '').trim()).charCodeAt(0)
						}

						switch (first) {
							// @at-rule
							case AT: {
								if (format > 0) {
									chars = chars.replace(formatptn, '')
								}

								second = chars.charCodeAt(1)

								switch (second) {
									case DOCUMENT:
									case MEDIA:
									case SUPPORTS:
									case DASH: {
										selector = current
										break
									}
									default: {
										selector = array
									}
								}

								child = compile(current, selector, child, second, depth+1)
								length = child.length

								// preserve empty @at-rule
								if (preserve > 0 && length === 0) {
									length = chars.length
								}

								// execute plugins, @at-rule context
								if (plugged > 0) {
									selector = select(array, chars, invert)
									result = proxy(ATRUL, child, selector, current, line, column, length, second, depth, id)
									chars = selector.join('')

									if (result !== void 0) {
										if ((length = (child = result.trim()).length) === 0) {
											second = 0
											child = ''
										}
									}
								}

								if (length > 0) {
									switch (second) {
										case SUPPORTS: {
											chars = chars.replace(supportsptn, supports)
										}
										case DOCUMENT:
										case MEDIA:
										case DASH: {
											child = chars + '{' + child + '}'
											break
										}
										case KEYFRAME: {
											chars = chars.replace(keyframeptn, '$1 $2' + (keyed > 0 ? key : ''))
											child = chars + '{' + child + '}'

											if (prefix === 1 || (prefix === 2 && vendor('@'+child, 3))) {
												child = '@' + webkit + child + '@' + child
											} else {
												child = '@' + child
											}
											break
										}
										default: {
											child = chars + child

											if (id === PAGE) {
												child = (out += child, '')
											}
										}
									}
								} else {
									child = ''
								}

								break
							}
							// selector
							default: {
								child = compile(current, select(current, chars, invert), child, id, depth+1)
							}
						}

						children += child

						// reset
						context = 0
						insert = 0
						pseudo = 0
						format = 0
						invert = 0
						atrule = 0
						chars = ''
						child = ''
						code = body.charCodeAt(++caret)
						break
					}
					case CLOSEBRACES:
					case SEMICOLON: {
						chars = (format > 0 ? chars.replace(formatptn, '') : chars).trim()

						if ((length = chars.length) > 1) {
							// monkey-patch missing colon
							if (pseudo === 0) {
								first = chars.charCodeAt(0)

								// first character is a letter or dash, buffer has a space character
								if ((first === DASH || first > 96 && first < 123)) {
									length = (chars = chars.replace(' ', ':')).length
								}
							}

							// execute plugins, property context
							if (plugged > 0) {
								if ((result = proxy(PROPS, chars, current, parent, line, column, out.length, id, depth, id)) !== void 0) {
									if ((length = (chars = result.trim()).length) === 0) {
										chars = '\0\0'
									}
								}
							}

							first = chars.charCodeAt(0)
							second = chars.charCodeAt(1)

							switch (first) {
								case NULL: {
									break
								}
								case AT: {
									if (second === IMPORT || second === CHARSET) {
										flat += chars + body.charAt(caret)
										break
									}
								}
								default: {
									if (chars.charCodeAt(length-1) === COLON) {
										break
									}

									out += property(chars, first, second, chars.charCodeAt(2))
								}
							}
						}

						// reset
						context = 0
						insert = 0
						pseudo = 0
						format = 0
						invert = 0
						chars = ''
						code = body.charCodeAt(++caret)
						break
					}
				}
			}

			// parse characters
			switch (code) {
				case CARRIAGE:
				case NEWLINE: {
					// auto insert semicolon
					if (comment + quote + parentheses + bracket + semicolon === 0) {
						// valid non-whitespace characters that
						// may precede a newline
						switch (peak) {
							case CLOSEPARENTHESES:
							case SINGLEQUOTE:
							case DOUBLEQUOTE:
							case AT:
							case TILDE:
							case GREATERTHAN:
							case STAR:
							case PLUS:
							case FOWARDSLASH:
							case DASH:
							case COLON:
							case COMMA:
							case SEMICOLON:
							case OPENBRACES:
							case CLOSEBRACES: {
								break
							}
							default: {
								// current buffer has a colon
								if (pseudo > 0) {
									insert = 1
								}
							}
						}
					}

					// terminate line comment
					if (comment === FOWARDSLASH) {
						comment = 0
					} else if (cascade + context === 0 && id !== KEYFRAME && chars.length > 0) {
						format = 1
						chars += '\0'
					}

					// execute plugins, newline context
					if (plugged * unkwn > 0) {
						proxy(UNKWN, chars, current, parent, line, column, out.length, id, depth, id)
					}

					// next line, reset column position
					column = 1
					line++
					break
				}
				case SEMICOLON:
				case CLOSEBRACES: {
					if (comment + quote + parentheses + bracket === 0) {
						column++
						break
					}
				}
				default: {
					// increment column position
					column++

					// current character
					char = body.charAt(caret)

					// remove comments, escape functions, strings, attributes and prepare selectors
					switch (code) {
						case TAB:
						case SPACE: {
							if (quote + bracket + comment === 0) {
								switch (tail) {
									case COMMA:
									case COLON:
									case TAB:
									case SPACE: {
										char = ''
										break
									}
									default: {
										if (code !== SPACE) {
											char = ' '
										}
									}
								}
							}
							break
						}
						// escape breaking control characters
						case NULL: {
							char = '\\0'
							break
						}
						case FORMFEED: {
							char = '\\f'
							break
						}
						case VERTICALTAB: {
							char = '\\v'
							break
						}
						// &
						case AND: {
							// inverted selector pattern i.e html &
							if (quote + comment + bracket === 0 && cascade > 0) {
								invert = 1
								format = 1
								char = '\f' + char
							}
							break
						}
						// ::p<l>aceholder, l
						// :read-on<l>y, l
						case 108: {
							if (quote + comment + bracket + pattern === 0 && pseudo > 0) {
								switch (caret - pseudo) {
									// ::placeholder
									case 2: {
										if (tail === PLACEHOLDER && body.charCodeAt(caret-3) === COLON) {
											pattern = tail
										}
									}
									// :read-only
									case 8: {
										if (trail === READONLY) {
											pattern = trail
										}
									}
								}
							}
							break
						}
						// :<pattern>
						case COLON: {
							if (quote + comment + bracket === 0) {
								pseudo = caret
							}
							break
						}
						// selectors
						case COMMA: {
							if (comment + parentheses + quote + bracket === 0) {
								format = 1
								char += '\r'
							}
							break
						}
						// quotes
						case DOUBLEQUOTE:
						case SINGLEQUOTE: {
							if (comment === 0) {
								quote = quote === code ? 0 : (quote === 0 ? code : quote)
							}
							break
						}
						// attributes
						case OPENBRACKET: {
							if (quote + comment + parentheses === 0) {
								bracket++
							}
							break
						}
						case CLOSEBRACKET: {
							if (quote + comment + parentheses === 0) {
								bracket--
							}
							break
						}
						// functions
						case CLOSEPARENTHESES: {
							if (quote + comment + bracket === 0) {
								parentheses--
							}
							break
						}
						case OPENPARENTHESES: {
							if (quote + comment + bracket === 0) {
								if (context === 0) {
									switch (tail*2 + trail*3) {
										// :matches
										case 533: {
											break
										}
										// :global, :not, :nth-child etc...
										default: {
											counter = 0
											context = 1
										}
									}
								}

								parentheses++
							}
							break
						}
						case AT: {
							if (comment + parentheses + quote + bracket + pseudo + atrule === 0) {
								atrule = 1
							}
							break
						}
						// block/line comments
						case STAR:
						case FOWARDSLASH: {
							if (quote + bracket + parentheses > 0) {
								break
							}

							switch (comment) {
								// initialize line/block comment context
								case 0: {
									switch (code*2 + body.charCodeAt(caret+1)*3) {
										// //
										case 235: {
											comment = FOWARDSLASH
											break
										}
										// /*
										case 220: {
											length = caret
											comment = STAR
											break
										}
									}
									break
								}
								// end block comment context
								case STAR: {
									if (code === FOWARDSLASH && tail === STAR && length + 2 !== caret) {
										// /*<!> ... */, !
										if (body.charCodeAt(length+2) === 33) {
											out += body.substring(length, caret+1)
										}
										char = ''
										comment = 0
									}
								}
							}
						}
					}

					// ignore comment blocks
					if (comment === 0) {
						// aggressive isolation mode, divide each individual selector
						// including selectors in :not function but excluding selectors in :global function
						if (cascade + quote + bracket + atrule === 0 && id !== KEYFRAME && code !== SEMICOLON) {
							switch (code) {
								case COMMA:
								case TILDE:
								case GREATERTHAN:
								case PLUS:
								case CLOSEPARENTHESES:
								case OPENPARENTHESES: {
									if (context === 0) {
										// outside of an isolated context i.e nth-child(<...>)
										switch (tail) {
											case TAB:
											case SPACE:
											case NEWLINE:
											case CARRIAGE: {
												char = char + '\0'
												break
											}
											default: {
												char = '\0' + char + (code === COMMA ? '' : '\0')
											}
										}
										format = 1
									} else {
										// within an isolated context, sleep untill it's terminated
										switch (code) {
											case OPENPARENTHESES: {
												// :globa<l>(
												if (pseudo + 7 === caret && tail === 108) {
													pseudo = 0
												}
												context = ++counter
												break
											}
											case CLOSEPARENTHESES: {
												if ((context = --counter) === 0) {
													format = 1
													char += '\0'
												}
												break
											}
										}
									}
									break
								}
								case TAB:
								case SPACE: {
									switch (tail) {
										case NULL:
										case OPENBRACES:
										case CLOSEBRACES:
										case SEMICOLON:
										case COMMA:
										case FORMFEED:
										case TAB:
										case SPACE:
										case NEWLINE:
										case CARRIAGE: {
											break
										}
										default: {
											// ignore in isolated contexts
											if (context === 0) {
												format = 1
												char += '\0'
											}
										}
									}
								}
							}
						}

						// concat buffer of characters
						chars += char

						// previous non-whitespace character code
						if (code !== SPACE && code !== TAB) {
							peak = code
						}
					}
				}
			}

			// tail character codes
			trail = tail
			tail = code

			// visit every character
			caret++
		}

		length = out.length

		// preserve empty selector
 		if (preserve > 0) {
 			if (length === 0 && children.length === 0 && (current[0].length === 0) === false) {
 				if (id !== MEDIA || (current.length === 1 && (cascade > 0 ? nscopealt : nscope) === current[0])) {
					length = current.join(',').length + 2
 				}
 			}
		}

		if (length > 0) {
			// cascade isolation mode?
			selector = cascade === 0 && id !== KEYFRAME ? isolate(current) : current

			// execute plugins, block context
			if (plugged > 0) {
				result = proxy(BLCKS, out, selector, parent, line, column, length, id, depth, id)

				if (result !== void 0 && (out = result).length === 0) {
					return flat + out + children
				}
			}

			out = selector.join(',') + '{' + out + '}'

			if (prefix*pattern !== 0) {
				if (prefix === 2 && !vendor(out, 2))
					pattern = 0

				switch (pattern) {
					// ::read-only
					case READONLY: {
						out = out.replace(readonlyptn, ':'+moz+'$1')+out
						break
					}
					// ::placeholder
					case PLACEHOLDER: {
						out = (
							out.replace(plcholdrptn, '::' + webkit + 'input-$1') +
							out.replace(plcholdrptn, '::' + moz + '$1') +
							out.replace(plcholdrptn, ':' + ms + 'input-$1') + out
						)
						break
					}
				}

				pattern = 0
			}
		}

		return flat + out + children
	}

	/**
	 * Select
	 *
	 * @param {Array<string>} parent
	 * @param {string} current
	 * @param {number} invert
	 * @return {Array<string>}
	 */
	function select (parent, current, invert) {
		var selectors = current.trim().split(selectorptn)
		var out = selectors

		var length = selectors.length
		var l = parent.length

		switch (l) {
			// 0-1 parent selectors
			case 0:
			case 1: {
				for (var i = 0, selector = l === 0 ? '' : parent[0] + ' '; i < length; ++i) {
					out[i] = scope(selector, out[i], invert, l).trim()
				}
				break
			}
			// >2 parent selectors, nested
			default: {
				for (var i = 0, j = 0, out = []; i < length; ++i) {
					for (var k = 0; k < l; ++k) {
						out[j++] = scope(parent[k] + ' ', selectors[i], invert, l).trim()
					}
				}
			}
		}

		return out
	}

	/**
	 * Scope
	 *
	 * @param {string} parent
	 * @param {string} current
	 * @param {number} invert
	 * @param {number} level
	 * @return {string}
	 */
	function scope (parent, current, invert, level) {
		var selector = current
		var code = selector.charCodeAt(0)

		// trim leading whitespace
		if (code < 33) {
			code = (selector = selector.trim()).charCodeAt(0)
		}

		switch (code) {
			// &
			case AND: {
				switch (cascade + level) {
					case 0:
					case 1: {
						if (parent.trim().length === 0) {
							break
						}
					}
					default: {
						return selector.replace(andptn, '$1'+parent.trim())
					}
				}
				break
			}
			// :
			case COLON: {
				switch (selector.charCodeAt(1)) {
					// g in :global
					case 103: {
						if (escape > 0 && cascade > 0) {
							return selector.replace(escapeptn, '$1').replace(andptn, '$1'+nscope)
						}
						break
					}
					default: {
						// :hover
						return parent.trim() + selector.replace(andptn, '$1'+parent.trim())
					}
				}
			}
			default: {
				// html &
				if (invert*cascade > 0 && selector.indexOf('\f') > 0) {
					return selector.replace(andptn, (parent.charCodeAt(0) === COLON ? '' : '$1')+parent.trim())
				}
			}
		}

		return parent + selector
	}

	/**
	 * Property
	 *
	 * @param {string} input
	 * @param {number} first
	 * @param {number} second
	 * @param {number} third
	 * @return {string}
	 */
	function property (input, first, second, third) {
		var index = 0
		var out = input + ';'
		var hash = (first*2) + (second*3) + (third*4)
		var cache

		// animation: a, n, i characters
		if (hash === 944) {
			return animation(out)
		} else if (prefix === 0 || (prefix === 2 && !vendor(out, 1))) {
			return out
		}

		// vendor prefix
		switch (hash) {
			// text-decoration/text-size-adjust/text-shadow/text-align/text-transform: t, e, x
			case 1015: {
				// text-shadow/text-align/text-transform, a
				return out.charCodeAt(10) === 97 ? webkit + out + out : out
			}
			// filter/fill f, i, l
			case 951: {
				// filter, t
				return out.charCodeAt(3) === 116 ? webkit + out + out : out
			}
			// color/column, c, o, l
			case 963: {
				// column, n
				return out.charCodeAt(5) === 110 ? webkit + out + out : out
			}
			// box-decoration-break, b, o, x
			case 1009: {
				if (out.charCodeAt(4) !== 100) {
					break
				}
			}
			// mask, m, a, s
			// clip-path, c, l, i
			case 969:
			case 942: {
				return webkit + out + out
			}
			// appearance: a, p, p
			case 978: {
				return webkit + out + moz + out + out
			}
			// hyphens: h, y, p
			// user-select: u, s, e
			case 1019:
			case 983: {
				return webkit + out + moz + out + ms + out + out
			}
			// background/backface-visibility, b, a, c
			case 883: {
				// backface-visibility, -
				if (out.charCodeAt(8) === DASH) {
					return webkit + out + out
				}

				// image-set(...)
				if (out.indexOf('image-set(', 11) > 0) {
					return out.replace(imgsrcptn, '$1'+webkit+'$2') + out
				}

				return out
			}
			// flex: f, l, e
			case 932: {
				if (out.charCodeAt(4) === DASH) {
					switch (out.charCodeAt(5)) {
						// flex-grow, g
						case 103: {
							return webkit + 'box-' + out.replace('-grow', '') + webkit + out + ms + out.replace('grow', 'positive') + out
						}
						// flex-shrink, s
						case 115: {
							return webkit + out + ms + out.replace('shrink', 'negative') + out
						}
						// flex-basis, b
						case 98: {
							return webkit + out + ms + out.replace('basis', 'preferred-size') + out
						}
					}
				}

				return webkit + out + ms + out + out
			}
			// order: o, r, d
			case 964: {
				return webkit + out + ms + 'flex' + '-' + out + out
			}
			// justify-items/justify-content, j, u, s
			case 1023: {
				// justify-content, c
				if (out.charCodeAt(8) !== 99) {
					break
				}

				cache = out.substring(out.indexOf(':', 15)).replace('flex-', '').replace('space-between', 'justify')
				return webkit + 'box-pack' + cache + webkit + out + ms + 'flex-pack' + cache + out
			}
			// cursor, c, u, r
			case 1005: {
				return cursorptn.test(out) ? out.replace(colonptn, ':' + webkit) + out.replace(colonptn, ':' + moz) + out : out
			}
			// writing-mode, w, r, i
			case 1000: {
				cache = out.substring(13).trim()
				index = cache.indexOf('-') + 1

				switch (cache.charCodeAt(0)+cache.charCodeAt(index)) {
					// vertical-lr
					case 226: {
						cache = out.replace(writingptn, 'tb')
						break
					}
					// vertical-rl
					case 232: {
						cache = out.replace(writingptn, 'tb-rl')
						break
					}
					// horizontal-tb
					case 220: {
						cache = out.replace(writingptn, 'lr')
						break
					}
					default: {
						return out
					}
				}

				return webkit + out + ms + cache + out
			}
			// position: sticky
			case 1017: {
				if (out.indexOf('sticky', 9) === -1) {
					return out
				}
			}
			// display(flex/inline-flex/inline-box): d, i, s
			case 975: {
				index = (out = input).length - 10
				cache = (out.charCodeAt(index) === 33 ? out.substring(0, index) : out).substring(input.indexOf(':', 7) + 1).trim()

				switch (hash = cache.charCodeAt(0) + (cache.charCodeAt(7)|0)) {
					// inline-
					case 203: {
						// inline-box
						if (cache.charCodeAt(8) < 111) {
							break
						}
					}
					// inline-box/sticky
					case 115: {
						out = out.replace(cache, webkit+cache)+';'+out
						break
					}
					// inline-flex
					// flex
					case 207:
					case 102: {
						out = (
							out.replace(cache, webkit+(hash > 102 ? 'inline-' : '')+'box')+';'+
							out.replace(cache, webkit+cache)+';'+
							out.replace(cache, ms+cache+'box')+';'+
							out
						)
					}
				}

				return out + ';'
			}
			// align-items, align-center, align-self: a, l, i, -
			case 938: {
				if (out.charCodeAt(5) === DASH) {
					switch (out.charCodeAt(6)) {
						// align-items, i
						case 105: {
							cache = out.replace('-items', '')
							return webkit + out + webkit + 'box-' + cache + ms + 'flex-' + cache + out
						}
						// align-self, s
						case 115: {
							return webkit + out + ms + 'flex-item-' + out.replace(selfptn, '') + out
						}
						// align-content
						default: {
							return webkit + out + ms + 'flex-line-pack' + out.replace('align-content', '').replace(selfptn, '') + out
						}
					}
				}
				break
			}
			// min/max
			case 973:
			case 989: {
				// min-/max- height/width/block-size/inline-size
				if (out.charCodeAt(3) !== DASH || out.charCodeAt(4) === 122) {
					break
				}
			}
			// height/width: min-content / width: max-content
			case 931:
			case 953: {
				if (dimensionptn.test(input) === true) {
					// stretch
					if ((cache = input.substring(input.indexOf(':') + 1)).charCodeAt(0) === 115)
						return property(input.replace('stretch', 'fill-available'), first, second, third).replace(':fill-available', ':stretch')
					else
						return out.replace(cache, webkit + cache) + out.replace(cache, moz + cache.replace('fill-', '')) + out
				}
				break
			}
			// transform, transition: t, r, a
			case 962: {
				out = webkit + out + (out.charCodeAt(5) === 102 ? ms + out : '') + out

				// transitions
				if (second + third === 211 && out.charCodeAt(13) === 105 && out.indexOf('transform', 10) > 0) {
					return out.substring(0, out.indexOf(';', 27) + 1).replace(transformptn, '$1' + webkit + '$2') + out
				}

				break
			}
		}

		return out
	}

	/**
	 * Vendor
	 *
	 * @param {string} content
	 * @param {number} context
	 * @return {boolean}
	 */
	function vendor (content, context) {
		var index = content.indexOf(context === 1 ? ':' : '{')
		var key = content.substring(0, context !== 3 ? index : 10)
		var value = content.substring(index + 1, content.length - 1)

		return should(context !== 2 ? key : key.replace(pseudofmt, '$1'), value, context)
	}

	/**
	 * Supports
	 *
	 * @param {string} match
	 * @param {string} group
	 * @return {string}
	 */
	function supports (match, group) {
		var out = property(group, group.charCodeAt(0), group.charCodeAt(1), group.charCodeAt(2))

		return out !== group+';' ? out.replace(propertyptn, ' or ($1)').substring(4) : '('+group+')'
	}

	/**
	 * Animation
	 *
	 * @param {string} input
	 * @return {string}
	 */
	function animation (input) {
		var length = input.length
		var index = input.indexOf(':', 9) + 1
		var declare = input.substring(0, index).trim()
		var out = input.substring(index, length-1).trim()

		switch (input.charCodeAt(9)*keyed) {
			case 0: {
				break
			}
			// animation-*, -
			case DASH: {
				// animation-name, n
				if (input.charCodeAt(10) !== 110) {
					break
				}
			}
			// animation/animation-name
			default: {
				// split in case of multiple animations
				var list = out.split((out = '', animationptn))

				for (var i = 0, index = 0, length = list.length; i < length; index = 0, ++i) {
					var value = list[i]
					var items = value.split(propertiesptn)

					while (value = items[index]) {
						var peak = value.charCodeAt(0)

						if (keyed === 1 && (
							// letters
							(peak > AT && peak < 90) || (peak > 96 && peak < 123) || peak === UNDERSCORE ||
							// dash but not in sequence i.e --
							(peak === DASH && value.charCodeAt(1) !== DASH)
						)) {
							// not a number/function
							switch (isNaN(parseFloat(value)) + (value.indexOf('(') !== -1)) {
								case 1: {
									switch (value) {
										// not a valid reserved keyword
										case 'infinite': case 'alternate': case 'backwards': case 'running':
										case 'normal': case 'forwards': case 'both': case 'none': case 'linear':
										case 'ease': case 'ease-in': case 'ease-out': case 'ease-in-out':
										case 'paused': case 'reverse': case 'alternate-reverse': case 'inherit':
										case 'initial': case 'unset': case 'step-start': case 'step-end': {
											break
										}
										default: {
											value += key
										}
									}
								}
							}
						}

						items[index++] = value
					}

					out += (i === 0 ? '' : ',') + items.join(' ')
				}
			}
		}

		out = declare + out + ';'

		if (prefix === 1 || (prefix === 2 && vendor(out, 1)))
			return webkit + out + out

		return out
	}

	/**
	 * Isolate
	 *
	 * @param {Array<string>} current
	 */
	function isolate (current) {
		for (var i = 0, length = current.length, selector = Array(length), padding, element; i < length; ++i) {
			// split individual elements in a selector i.e h1 h2 === [h1, h2]
			var elements = current[i].split(elementptn)
			var out = ''

			for (var j = 0, size = 0, tail = 0, code = 0, l = elements.length; j < l; ++j) {
				// empty element
				if ((size = (element = elements[j]).length) === 0 && l > 1) {
					continue
				}

				tail = out.charCodeAt(out.length-1)
				code = element.charCodeAt(0)
				padding = ''

				if (j !== 0) {
					// determine if we need padding
					switch (tail) {
						case STAR:
						case TILDE:
						case GREATERTHAN:
						case PLUS:
						case SPACE:
						case OPENPARENTHESES:  {
							break
						}
						default: {
							padding = ' '
						}
					}
				}

				switch (code) {
					case AND: {
						element = padding + nscopealt
					}
					case TILDE:
					case GREATERTHAN:
					case PLUS:
					case SPACE:
					case CLOSEPARENTHESES:
					case OPENPARENTHESES: {
						break
					}
					case OPENBRACKET: {
						element = padding + element + nscopealt
						break
					}
					case COLON: {
						switch (element.charCodeAt(1)*2 + element.charCodeAt(2)*3) {
							// :global
							case 530: {
								if (escape > 0) {
									element = padding + element.substring(8, size - 1)
									break
								}
							}
							// :hover, :nth-child(), ...
							default: {
								if (j < 1 || elements[j-1].length < 1) {
									element = padding + nscopealt + element
								}
							}
						}
						break
					}
					case COMMA: {
						padding = ''
					}
					default: {
						if (size > 1 && element.indexOf(':') > 0) {
							element = padding + element.replace(pseudoptn, '$1' + nscopealt + '$2')
						} else {
							element = padding + element + nscopealt
						}
					}
				}

				out += element
			}

			selector[i] = out.replace(formatptn, '').trim()
		}

		return selector
	}

	/**
	 * Proxy
	 *
	 * @param {number} context
	 * @param {string} content
	 * @param {Array<string>} selectors
	 * @param {Array<string>} parents
	 * @param {number} line
	 * @param {number} column
	 * @param {number} length
	 * @param {number} id
	 * @param {number} depth
	 * @param {number} at
	 * @return {(string|void|*)}
	 */
	function proxy (context, content, selectors, parents, line, column, length, id, depth, at) {
		for (var i = 0, out = content, next; i < plugged; ++i) {
			switch (next = plugins[i].call(stylis, context, out, selectors, parents, line, column, length, id, depth, at)) {
				case void 0:
				case false:
				case true:
				case null: {
					break
				}
				default: {
					out = next
				}
			}
		}
		if (out !== content) {
		  return out
		}
	}

	/**
	 * @param {number} code
	 * @param {number} index
	 * @param {number} length
	 * @param {string} body
	 * @return {number}
	 */
	function delimited (code, index, length, body) {
		for (var i = index + 1; i < length; ++i) {
			switch (body.charCodeAt(i)) {
				// /*
				case FOWARDSLASH: {
					if (code === STAR) {
						if (body.charCodeAt(i - 1) === STAR &&  index + 2 !== i) {
							return i + 1
						}
					}
					break
				}
				// //
				case NEWLINE: {
					if (code === FOWARDSLASH) {
						return i + 1
					}
				}
			}
		}

		return i
	}

	/**
	 * @param {number} type
	 * @param {number} index
	 * @param {number} length
	 * @param {number} find
	 * @param {string} body
	 * @return {number}
	 */
	function match (type, index, length, body) {
		for (var i = index + 1; i < length; ++i) {
			switch (body.charCodeAt(i)) {
				case type: {
					return i
				}
			}
		}

		return i
	}

	/**
	 * Minify
	 *
	 * @param {(string|*)} output
	 * @return {string}
	 */
	function minify (output) {
		return output
			.replace(formatptn, '')
			.replace(beforeptn, '')
			.replace(afterptn, '$1')
			.replace(tailptn, '$1')
			.replace(whiteptn, ' ')
	}

	/**
	 * Use
	 *
	 * @param {(Array<function(...?)>|function(...?)|number|void)?} plugin
	 */
	function use (plugin) {
		switch (plugin) {
			case void 0:
			case null: {
				plugged = plugins.length = 0
				break
			}
			default: {
				if (typeof plugin === 'function') {
					plugins[plugged++] = plugin
				}	else if (typeof plugin === 'object') {
					for (var i = 0, length = plugin.length; i < length; ++i) {
						use(plugin[i])
					}
				} else {
					unkwn = !!plugin|0
				}
			}
 		}

 		return use
	}

	/**
	 * Set
	 *
	 * @param {*} options
	 */
	function set (options) {
		for (var name in options) {
			var value = options[name]
			switch (name) {
				case 'keyframe': keyed = value|0; break
				case 'global': escape = value|0; break
				case 'cascade': cascade = value|0; break
				case 'compress': compress = value|0; break
				case 'semicolon': semicolon = value|0; break
				case 'preserve': preserve = value|0; break
				case 'prefix':
					should = null

					if (!value) {
						prefix = 0
					} else if (typeof value !== 'function') {
						prefix = 1
					} else {
						prefix = 2
						should = value
					}
			}
		}

		return set
	}

	/**
	 * Stylis
	 *
	 * @param {string} selector
	 * @param {string} input
	 * @return {*}
	 */
	function stylis (selector, input) {
		if (this !== void 0 && this.constructor === stylis) {
			return factory(selector)
		}

		// setup
		var ns = selector
		var code = ns.charCodeAt(0)

		// trim leading whitespace
		if (code < 33) {
			code = (ns = ns.trim()).charCodeAt(0)
		}

		// keyframe/animation namespace
		if (keyed > 0) {
			key = ns.replace(invalidptn, code === OPENBRACKET ? '' : '-')
		}

		// reset, used to assert if a plugin is moneky-patching the return value
		code = 1

		// cascade/isolate
		if (cascade === 1) {
			nscope = ns
		} else {
			nscopealt = ns
		}

		var selectors = [nscope]
		var result

		// execute plugins, pre-process context
		if (plugged > 0) {
			result = proxy(PREPS, input, selectors, selectors, line, column, 0, 0, 0, 0)

			if (result !== void 0 && typeof result === 'string') {
				input = result
			}
		}

		// build
		var output = compile(array, selectors, input, 0, 0)

		// execute plugins, post-process context
		if (plugged > 0) {
			result = proxy(POSTS, output, selectors, selectors, line, column, output.length, 0, 0, 0)

			// bypass minification
			if (result !== void 0 && typeof(output = result) !== 'string') {
				code = 0
			}
		}

		// reset
		key = ''
		nscope = ''
		nscopealt = ''
		pattern = 0
		line = 1
		column = 1

		return compress*code === 0 ? output : minify(output)
	}

	stylis['use'] = use
	stylis['set'] = set

	if (options !== void 0) {
		set(options)
	}

	return stylis
}));


/***/ }),
/* 758 */
/***/ (function(module, exports, __webpack_require__) {

(function (factory) {
	 true ? (module['exports'] = factory()) :
		typeof define === 'function' && define['amd'] ? define(factory()) :
			(window['stylisRuleSheet'] = factory())
}(function () {

	'use strict'

	return function (insertRule) {
		var delimiter = '/*|*/'
		var needle = delimiter+'}'

		function toSheet (block) {
			if (block)
				try {
					insertRule(block + '}')
				} catch (e) {}
		}

		return function ruleSheet (context, content, selectors, parents, line, column, length, ns, depth, at) {
			switch (context) {
				// property
				case 1:
					// @import
					if (depth === 0 && content.charCodeAt(0) === 64)
						return insertRule(content+';'), ''
					break
				// selector
				case 2:
					if (ns === 0)
						return content + delimiter
					break
				// at-rule
				case 3:
					switch (ns) {
						// @font-face, @page
						case 102:
						case 112:
							return insertRule(selectors[0]+content), ''
						default:
							return content + (at === 0 ? delimiter : '')
					}
				case -2:
					content.split(needle).forEach(toSheet)
			}
		}
	}
}))


/***/ }),
/* 759 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 760 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 761 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__basketCheck__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AllergenGate_css__ = __webpack_require__(762);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AllergenGate_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__AllergenGate_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// The allergen gate before a basket is placed on a pilot restaurant: what changed or can't be ordered, the allergy
// question, then the restaurant's declared allergens in words with its cross-contact warning. "Confirm" is enabled
// only when the check waits for nothing but the customer's confirmation of exactly this quote.
var AllergenGate=function(_Component){_inherits(AllergenGate,_Component);function AllergenGate(){var _ref;var _temp,_this,_ret;_classCallCheck(this,AllergenGate);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=AllergenGate.__proto__||Object.getPrototypeOf(AllergenGate)).call.apply(_ref,[this].concat(args))),_this),_this.state={allergyText:''},_this.onAllergySubmit=function(event){event.preventDefault();var text=_this.state.allergyText.trim();if(text)_this.props.onAnswer({text:text});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(AllergenGate,[{key:'render',value:function render(){var _this2=this;var _props=this.props,check=_props.check,busy=_props.busy,error=_props.error,onAnswer=_props.onAnswer,onConfirm=_props.onConfirm,onClose=_props.onClose;if(!check)return null;var notices=[].concat(_toConsumableArray(check.problems||[]),_toConsumableArray(check.changes||[]));var answered=!check.allergyQuestion;var advice=check.advice||{};var ready=Object(__WEBPACK_IMPORTED_MODULE_2__basketCheck__["g" /* readyToConfirm */])(check);var reason=Object(__WEBPACK_IMPORTED_MODULE_2__basketCheck__["b" /* blockedReason */])(check);// On the page itself, not inside the basket: on a phone "Chat with us" closes the basket while support is open.
return __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.createPortal(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'lt-allergen-gate',role:'dialog','aria-modal':'true','aria-labelledby':'lt-allergen-gate-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'lt-allergen-gate__dialog'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{id:'lt-allergen-gate-title',className:'lt-allergen-gate__title'},'Before you confirm your order'),notices.length>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'lt-allergen-gate__notices','aria-label':'What changed'},notices.map(function(notice,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:notice.code+'-'+index},notice.message);})),!answered&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'lt-allergen-gate__question'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,check.allergyQuestion),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'lt-allergen-gate__secondary',disabled:busy,onClick:function onClick(){return onAnswer({none:true});}},'No allergies or dietary requirements'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{onSubmit:this.onAllergySubmit,className:'lt-allergen-gate__form'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'lt-allergen-gate-text'},'My allergies or dietary requirements'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{id:'lt-allergen-gate-text',type:'text',value:this.state.allergyText,placeholder:'For example: milk, nuts, coeliac, vegan',onChange:function onChange(event){return _this2.setState({allergyText:event.target.value});}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'submit',className:'lt-allergen-gate__secondary',disabled:busy},'Save'))),answered&&advice.text&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'lt-allergen-gate__advice','aria-label':'Allergen information'},(advice.lines||[]).map(function(line){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{key:line.productId,className:line.needsRestaurantConfirmation?'lt-allergen-gate__line--hold':undefined},line.text);}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,advice.crossContact),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'lt-allergen-gate__small'},'This is the restaurant\'s declaration, not a guarantee.',check.alterationsPolicy?' This restaurant does not make alterations.':''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'lt-allergen-gate__link',disabled:busy,onClick:function onClick(){return onAnswer(null);}},'Change my allergy answer')),reason&&!ready&&answered&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'lt-allergen-gate__reason'},reason),error&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'lt-allergen-gate__reason',role:'alert'},error),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'lt-allergen-gate__actions'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'lt-allergen-gate__primary',disabled:!ready||busy,onClick:onConfirm},busy?'Checking…':'I have read this. Confirm order'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'lt-allergen-gate__secondary',disabled:busy,onClick:onClose},'Back to basket')))),document.body);}}]);return AllergenGate;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (AllergenGate);

/***/ }),
/* 762 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 763 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PaymentOptions__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PaymentButton__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_utils_currency__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_utils_object__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_actions_index__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_hoc_ReactAux_ReactAux__ = __webpack_require__(4);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CartInvoice=function(_Component){_inherits(CartInvoice,_Component);function CartInvoice(props){_classCallCheck(this,CartInvoice);var _this=_possibleConstructorReturn(this,(CartInvoice.__proto__||Object.getPrototypeOf(CartInvoice)).call(this,props));_this.onHandleSelectPaymentMethod=function(id,type){if(id==='payWithAnotherCard'){_this.setState({payType:'C',cardSelected:null,payWithAnotherCard:true});}else{var card=_this.props.cards.find(function(item){return item.cardId===id;});_this.setState({payType:'C',cardSelected:card,payWithAnotherCard:false});}};_this.onHandlePlaceOrder=function(){console.log('onHandlePlaceOrder');_this.props.toggleIsButtonDisabled(true);if(_this.state.payType==='C'&&!_this.state.payWithAnotherCard){_this.props.onHandlePayInvoice(_this.getPayInfo(),_this.props.history);}else if(_this.state.payType==='C'&&!!_this.state.payWithAnotherCard){_this.props.history.push("/Menu/checkout");}};_this.getPayInfo=function(){return{idOrder:_this.props.invoice.invoiceNumber,amount:_this.props.invoice.total,currency:_this.props.invoice.currency,payType:_this.state.payType,paymentReference:__WEBPACK_IMPORTED_MODULE_6_utils_object__["a" /* default */].get(_this.state,'cardSelected.cardId',undefined),idBusinessRestaurant:0};};_this.state={cardSelected:null,payType:null,payWithAnotherCard:false};return _this;}_createClass(CartInvoice,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_hoc_ReactAux_ReactAux__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,'Your Cart invoice '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'items'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'product-cart-invoice-description'},'Invoice number : ',this.props.invoice.invoiceNumber)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'total-items'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'total'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Total')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right'},__WEBPACK_IMPORTED_MODULE_5_utils_currency__["a" /* default */].convertNameToSymbol(this.props.invoice.currency)+this.props.invoice.total.toFixed(2)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__PaymentOptions__["a" /* default */],{payTypeSelected:this.state.payType,cardSelected:this.state.cardSelected,selectPaymentMethod:this.onHandleSelectPaymentMethod,total:this.props.invoice.total,subsidy:0,business:0,cards:this.props.cards}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__PaymentButton__["a" /* default */],{buttonText:'Pay invoice',payTypeSelected:this.state.payType,campaignRateCC:null,disabled:this.props.isButtonDisabled,handlePlaceOrder:this.onHandlePlaceOrder}));}}]);return CartInvoice;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{business:state.businessReducer.business,cards:state.cartReducer.cart.cards,invoice:state.invoiceReducer.invoice};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onToggleCart:function onToggleCart(){return dispatch(__WEBPACK_IMPORTED_MODULE_7_actions_index__["_34" /* toggleCart */]());},toggleIsButtonDisabled:function toggleIsButtonDisabled(disabled){return dispatch(__WEBPACK_IMPORTED_MODULE_7_actions_index__["_35" /* toggleIsButtonDisabled */](disabled));},onHandlePayInvoice:function onHandlePayInvoice(payload,history){return dispatch(__WEBPACK_IMPORTED_MODULE_7_actions_index__["_4" /* handlePayInvoice */](payload,history));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["g" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(CartInvoice)));

/***/ }),
/* 764 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DynamicMenu */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__support_supportEntry__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MenuComponents_Products_Products__ = __webpack_require__(765);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__MenuComponents_Categories_Categories__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_hoc_ReactAux_ReactAux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_actions_index__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_actions_Cart__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_UI_Modal_ModalCartMessage__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_UI_Modal_ModalError__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_UI_Modal_ModalSuccessPayment__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_UI_Modal_ModalReceipt__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__MenuComponents_Products_ProductDetails_ProductDetails__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_hoc_ErroHandling__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Cart_Cart__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_utils_object__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_utils_currency__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__support_context__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__support_voiceOrder__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__support_basketCheck__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_services_menuService__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_utils_viewport__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_utils_userError__ = __webpack_require__(15);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var RESTAURANT_UNAVAILABLE_ERROR=Object(__WEBPACK_IMPORTED_MODULE_22_utils_userError__["b" /* errorCopy */])(__WEBPACK_IMPORTED_MODULE_22_utils_userError__["a" /* ERROR_CODES */].MENU_RESTAURANT_UNAVAILABLE,{title:"This restaurant isn't available today",guidance:"Choose another restaurant from today's menu."});var DynamicMenu=function(_Component){_inherits(DynamicMenu,_Component);function DynamicMenu(){var _ref;var _temp,_this,_ret;_classCallCheck(this,DynamicMenu);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=DynamicMenu.__proto__||Object.getPrototypeOf(DynamicMenu)).call.apply(_ref,[this].concat(args))),_this),_this.state={differentRestaurant:false,productStandyBy:null,showCategoriesMobile:false,handlingError:{showError:false,errorMessage:''}},_this.addVoiceOrderItems=function(items){var restaurant=_this.props.restaurantSelected;if(!restaurant)return Promise.resolve({error:'Open a restaurant menu to order.'});if(!restaurant.isOpen){return Promise.resolve({error:restaurant.name+' has closed for orders today.'});}if(_this.props.restaurantOnCart&&_this.props.restaurantOnCart.id!==restaurant.id){return Promise.resolve({error:'Your basket has dishes from another restaurant. Empty it first, then try again.'});}var currencySymbol=_this.getCurrencySymbolForMenu();var categories=Array.from(new Set(items.map(function(item){return item.categoryTypeId;})));return Promise.all(categories.map(function(idCategory){return __WEBPACK_IMPORTED_MODULE_20_services_menuService__["a" /* default */].getProducts(restaurant.id,idCategory,0).then(function(products){return Array.isArray(products)?products:[];},function(){return[];});})).then(function(lists){var _ref2;var products=(_ref2=[]).concat.apply(_ref2,_toConsumableArray(lists));var added=[];var withOptions=null;items.forEach(function(item){var product=products.find(function(candidate){return candidate.id===item.productId;});if(!product)return;if(product.mealOptions&&product.mealOptions.length>0){withOptions=withOptions||product;return;}for(var i=0;i<item.qty;i+=1){_this.props.onAddProductToCartNow({product:product,business:restaurant});}added.push(Object.assign({},item,{name:item.name,unitPrice:product.price}));});if(withOptions)_this.props.onSelectProduct(withOptions);// Adding opens the basket; on a phone its sheet would cover the composer's card and its confirm.
if(added.length&&Object(__WEBPACK_IMPORTED_MODULE_21_utils_viewport__["a" /* isNarrowMenuViewport */])())_this.props.onToggleCart(false);if(!added.length){return{currencySymbol:currencySymbol,error:withOptions?'Choose the options for '+withOptions.name+' to add it.':"That dish isn't on the menu right now."};}return{added:added,currencySymbol:currencySymbol,note:withOptions?'Choose the options for '+withOptions.name+' to add it too.':undefined};});},_this.applyVoiceDraft=function(draft){var restaurant=_this.props.restaurantSelected;if(!restaurant)return Promise.resolve({error:'Open a restaurant menu to order.'});if(!restaurant.isOpen){return Promise.resolve({error:restaurant.name+' has closed for orders today.'});}if(_this.props.restaurantOnCart&&_this.props.restaurantOnCart.id!==restaurant.id){return Promise.resolve({error:'Your basket has dishes from another restaurant. Empty it first, then try again.'});}var inCart=_this.props.cart&&_this.props.cart.products||[];var current=Object(__WEBPACK_IMPORTED_MODULE_19__support_basketCheck__["c" /* cartLines */])(inCart);var wanted=(draft||[]).map(function(line){return Object.assign({},line,{optionIds:(line.optionIds||[]).slice().sort(function(a,b){return a-b;})});});var unitsWithKey=function unitsWithKey(key){return inCart.filter(function(product){return Object(__WEBPACK_IMPORTED_MODULE_19__support_basketCheck__["f" /* lineKey */])(product.id,(product.mealOptions||[]).map(function(option){return option.idMealOption;}))===key;});};current.forEach(function(line){var key=Object(__WEBPACK_IMPORTED_MODULE_19__support_basketCheck__["f" /* lineKey */])(line.productId,line.optionIds);var target=wanted.find(function(candidate){return Object(__WEBPACK_IMPORTED_MODULE_19__support_basketCheck__["f" /* lineKey */])(candidate.productId,candidate.optionIds)===key;});var extra=line.qty-(target?target.qty:0);unitsWithKey(key).slice(0,Math.max(0,extra)).forEach(function(product){return _this.props.onDeleteProductFromCart({product:product});});});var toAdd=wanted.map(function(line){var have=current.find(function(candidate){return Object(__WEBPACK_IMPORTED_MODULE_19__support_basketCheck__["f" /* lineKey */])(candidate.productId,candidate.optionIds)===Object(__WEBPACK_IMPORTED_MODULE_19__support_basketCheck__["f" /* lineKey */])(line.productId,line.optionIds);});return Object.assign({},line,{missing:line.qty-(have?have.qty:0)});}).filter(function(line){return line.missing>0;});var currencySymbol=_this.getCurrencySymbolForMenu();var categories=Array.from(new Set(toAdd.map(function(line){return line.categoryTypeId;})));return Promise.all(categories.map(function(idCategory){return __WEBPACK_IMPORTED_MODULE_20_services_menuService__["a" /* default */].getProducts(restaurant.id,idCategory,0).then(function(products){return Array.isArray(products)?products:[];},function(){return null;});})).then(function(lists){var _ref3;if(lists.some(function(list){return list===null;})){// Never add from an older menu: the customer tries again.
return{currencySymbol:currencySymbol,error:"We couldn't load the menu just now. Please try again."};}var products=(_ref3=[]).concat.apply(_ref3,_toConsumableArray(lists));var refused=[];toAdd.forEach(function(line){var product=products.find(function(candidate){return candidate.id===line.productId;});if(!product||product.outOfStock){refused.push(line.name||'A dish');return;}var mealOptions=[];var missingChoice=false;line.optionIds.forEach(function(optionId){var group=(product.mealOptions||[]).find(function(candidate){return(candidate.mealOptionItens||[]).some(function(item){return item.id===optionId;});});var item=group&&group.mealOptionItens.find(function(candidate){return candidate.id===optionId;});if(!item||item.outOfStock)missingChoice=true;else mealOptions.push({idCategoryType:group.idCategoryType,idMealOption:item.id,price:item.price});});var required=(product.mealOptions||[]).filter(function(group){return group.flagRequired==='Y';});if(missingChoice||required.some(function(group){return!mealOptions.some(function(option){return option.idCategoryType===group.idCategoryType;});})){refused.push(line.name||product.name);return;}var unit=Object.assign({id:product.id,name:product.name,description:product.description,price:product.price+mealOptions.reduce(function(sum,option){return sum+(option.price||0);},0)},mealOptions.length?{mealOptions:mealOptions}:{});for(var i=0;i<line.missing;i+=1){_this.props.onAddProductToCartNow({product:unit,business:restaurant});}});if(_this.state.isMobile)_this.props.onToggleCart(false);return{currencySymbol:currencySymbol,refused:refused,error:refused.length?refused.join(', ')+' couldn\'t be added as asked. Nothing was swapped for it.':undefined};});},_this.getCurrencySymbolForMenu=function(){return __WEBPACK_IMPORTED_MODULE_16_utils_currency__["a" /* default */].convertNameToSymbol(_this.props.restaurantSelected&&_this.props.restaurantSelected.currency||'EUR');},_this.closeCategoriesSheet=function(){if(_this.state.showCategoriesMobile)_this.setState({showCategoriesMobile:false});},_this.toggleCategoriesNavClass=function(){_this.props.onToggleCart(false);_this.props.onToggleRestaurants(false);_this.setState({showCategoriesMobile:!_this.state.showCategoriesMobile});},_this.toggleCart=function(){_this.props.onToggleCart();_this.props.onToggleRestaurants(false);_this.setState({showCategoriesMobile:false});},_this.toggleRestaurants=function(){_this.props.onToggleCart(false);_this.props.onToggleRestaurants();_this.setState({showCategoriesMobile:false});},_this.handleSelectFirstCategoryFromRestaurant=function(){if(_this.props.restaurantSelected!==null&&_this.props.restaurantSelected.categoryType){var idCategory=_this.props.restaurantSelected.categoryType.length>0?_this.props.restaurantSelected.categoryType[0].id:0;_this.handleSelectCategory(idCategory);}},_this.handleSelectCategory=function(idCategory){// this.props.onFetchingProducts(this.props.restaurantSelected.id, idCategory);
_this.props.onFetchingProducts(_this.props.restaurantSelected!=null?_this.props.restaurantSelected.id:0,_this.props.restaurantSelected!=null?idCategory:0);},_this.handleSelectProduct=function(idProduct){if(_this.props.restaurantSelected.isOpen){var product=_this.props.products.find(function(product){return product.id===idProduct;});var isDiferrent=!_this.props.restaurantOnCart?false:_this.props.restaurantOnCart.id!==_this.props.restaurantSelected.id;_this.setState({differentRestaurant:isDiferrent});if(isDiferrent){_this.setState({productStandBy:product});}else{_this.verifyMealOptionsProduct(product);}}else{_this.setState({handlingError:{showError:true,errorMessage:Object(__WEBPACK_IMPORTED_MODULE_22_utils_userError__["e" /* knownError */])(__WEBPACK_IMPORTED_MODULE_22_utils_userError__["a" /* ERROR_CODES */].MENU_RESTAURANT_CLOSED,{title:"This restaurant is closed now",message:'It has stopped taking orders for today.',guidance:'Choose another restaurant, or order for tomorrow.'})}});}},_this.handleConfirmOkCartModal=function(){_this.props.onDeleteAllProductsFromCart();_this.verifyMealOptionsProduct(_this.state.productStandBy);_this.setState({differentRestaurant:false});},_this.verifyMealOptionsProduct=function(product){if(product.mealOptions&&product.mealOptions.length>0){_this.props.onSelectProduct(product);}else{_this.props.onAddProductToCart({product:product,business:_this.props.restaurantSelected});}},_this.getSurcharge=function(){var isPayTypeCreditCard=function isPayTypeCreditCard(payType){return payType==='C';};var payType=__WEBPACK_IMPORTED_MODULE_15_utils_object__["a" /* default */].get(_this.props,'cart.payInfo.payType',undefined);if(isPayTypeCreditCard(payType)){return __WEBPACK_IMPORTED_MODULE_15_utils_object__["a" /* default */].get(_this.props,'cart.campaignRateCC.amount',0);}return 0;},_this.getTaxDelivery=function(){return!!_this.props.restaurantSelected&&_this.props.restaurantSelected.taxDelivery&&_this.isDeliverAtHome()?_this.props.restaurantSelected.taxDelivery.toFixed(2):Number(0).toFixed(2);},_this.getCollectionDiscount=function(){var campaignRateCollection=__WEBPACK_IMPORTED_MODULE_15_utils_object__["a" /* default */].get(_this.props,'cart.campaignRateCollection',null);if(campaignRateCollection){var collectionDiscount=campaignRateCollection.discountType==='P'?'% '+campaignRateCollection.amount:'- '+campaignRateCollection.amount;return collectionDiscount;}else{return'';}},_this.isForCollection=function(){return __WEBPACK_IMPORTED_MODULE_15_utils_object__["a" /* default */].get(_this.props,'cart.restaurantSelected.forCollection','N');},_this.getReceiptData=function(){return{cart:_this.props.cart,total:_this.getAmount(),currency:_this.getCurrency(),surcharge:_this.getSurcharge(),subtotal:_this.getSubTotal(),taxDelivery:_this.getTaxDelivery(),userDetails:_this.props.userDetails,orderDeliveryDate:__WEBPACK_IMPORTED_MODULE_15_utils_object__["a" /* default */].get(_this.props,'cart.orderDeliveryDate',undefined),collectionDiscount:_this.getCollectionDiscount(),forCollection:_this.isForCollection(),address:_this.getAddress(),tipValue:__WEBPACK_IMPORTED_MODULE_15_utils_object__["a" /* default */].get(_this.props,'cart.tipValue',0)};},_this.handleDenyCartModal=function(){_this.setState({differentRestaurant:false});},_this.handleCloseHandlingError=function(){_this.setState({handlingError:{showError:false,errorMessage:''}});},_this.handleCloseModalPlacedOrderOnCart=function(){_this.props.closeModalPlacedOrderOnCart(_this.props.history);},_this.handleCloseModalReceiptOnCart=function(){_this.props.closeModalReceiptOnCart();_this.props.history.replace('/Menu');},_this.handleCloseModalNotAvailableRestaurant=function(){_this.props.onFetchingMenu(_this.props.userDetails.idBusiness);_this.props.onCloseModalAvailableRestaurant();_this.props.history.replace('/Menu');},_this.handleCloseModalReceipt=function(){_this.props.closeModalReceiptOnCart();_this.props.history.replace('/Menu');},_this.getAddress=function(){return _this.props.addresses[0];},_this.isDeliverAtHome=function(){return _this.getAddress()!=null?_this.getAddress().idCustomerDeliveryAddress!=null:false;},_this.getModalAvailableRestaurant=function(){var modalAvailableRestaurant=_this.props.restaurantSelected&&_this.props.restaurantSelected.isAvailable!=null&&!_this.props.restaurantSelected.isAvailable?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_UI_Modal_ModalError__["a" /* default */],{showModal:_this.props.restaurantSelected&&!_this.props.restaurantSelected.isAvailable,errorMessage:RESTAURANT_UNAVAILABLE_ERROR,actionButton:_this.handleCloseModalNotAvailableRestaurant,actionButtonTitle:'Close',closeModal:_this.handleCloseModalNotAvailableRestaurant}):null;return modalAvailableRestaurant;},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(DynamicMenu,[{key:'componentDidMount',value:function componentDidMount(){window.addEventListener(__WEBPACK_IMPORTED_MODULE_1__support_supportEntry__["b" /* PANEL_OPEN_EVENT */],this.closeCategoriesSheet);this.unregisterVoiceOrder=Object(__WEBPACK_IMPORTED_MODULE_18__support_voiceOrder__["g" /* registerVoiceOrderHandler */])('addToBasket',this.addVoiceOrderItems);this.unregisterVoiceDraft=Object(__WEBPACK_IMPORTED_MODULE_18__support_voiceOrder__["g" /* registerVoiceOrderHandler */])('applyDraft',this.applyVoiceDraft);Object(__WEBPACK_IMPORTED_MODULE_17__support_context__["c" /* setSupportContext */])('menu.restaurant',{restaurantId:this.props.restaurantSelected&&this.props.restaurantSelected.id});this.setState({differentRestaurant:false});if(this.props.restaurantSelected!==null){this.handleSelectFirstCategoryFromRestaurant();}else{this.props.history.replace('/Menu');}}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){if(prevProps.restaurantSelected!==this.props.restaurantSelected){Object(__WEBPACK_IMPORTED_MODULE_17__support_context__["c" /* setSupportContext */])('menu.restaurant',{restaurantId:this.props.restaurantSelected&&this.props.restaurantSelected.id});this.handleSelectFirstCategoryFromRestaurant();}}},{key:'componentWillUnmount',value:function componentWillUnmount(){window.removeEventListener(__WEBPACK_IMPORTED_MODULE_1__support_supportEntry__["b" /* PANEL_OPEN_EVENT */],this.closeCategoriesSheet);if(this.unregisterVoiceOrder)this.unregisterVoiceOrder();if(this.unregisterVoiceDraft)this.unregisterVoiceDraft();}// Voice ordering (LOW risk): the dishes the server matched on this menu go into the basket for the
// customer, as a tap on each would. A dish with meal options opens its own sheet instead. Each product is
// read from the menu service, so the basket gets exactly what the menu shows.
// Chat and voice ordering on a pilot restaurant (LOW risk): the server's draft is the whole basket after the
// customer's words, with real product and option ids. The basket is made to match it, as taps on + and − would:
// lines the draft drops or shrinks are removed, new ones are added with exactly the choices in the draft. A
// choice the menu no longer offers is not swapped: the line is left out and reported.
// The support conversation opened on a small screen: the Categories sheet mustn't cover it.
},{key:'getAmount',value:function getAmount(){return __WEBPACK_IMPORTED_MODULE_15_utils_object__["a" /* default */].get(this.props,'cart.payInfo.amount',0);}},{key:'getCurrency',value:function getCurrency(){return __WEBPACK_IMPORTED_MODULE_16_utils_currency__["a" /* default */].convertNameToSymbol(__WEBPACK_IMPORTED_MODULE_15_utils_object__["a" /* default */].get(this.props,'cart.restaurantSelected.currency','EUR'));}},{key:'getSubTotal',value:function getSubTotal(){return __WEBPACK_IMPORTED_MODULE_15_utils_object__["a" /* default */].get(this.props,'cart.subtotal',0);}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_hoc_ReactAux_ReactAux__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_hoc_ErroHandling__["a" /* default */],{handlingError:this.state.handlingError,closedErrorModal:this.handleCloseHandlingError},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__MenuComponents_Products_ProductDetails_ProductDetails__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_UI_Modal_ModalCartMessage__["a" /* default */],{clickButtonConfirm:this.handleConfirmOkCartModal,clickButtonDeny:this.handleDenyCartModal,message:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Note! You can only order from ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),' one restaurant at a time.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Clear current basket to add?'),showModal:this.state.differentRestaurant}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_UI_Modal_ModalError__["a" /* default */],{style:{zIndex:'99999',position:'absolute',margin:'5% 40%'},styleContent:{background:'gainsboro'},closeModal:this.props.closeModalErrorPlacedOrder,showModal:this.props.modalErrorPlacedOrder,errorMessage:this.props.checkoutError||this.props.errorMessage}),this.getModalAvailableRestaurant(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_UI_Modal_ModalSuccessPayment__["a" /* default */],{descriptionSuccess:this.props.cart.descriptionSuccess,isInvoice:this.props.cart.isInvoice,closeModal:this.handleCloseModalPlacedOrderOnCart,showModal:this.props.showPlacedModal,openReceipt:this.props.openModalReceiptOnCart}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_UI_Modal_ModalReceipt__["a" /* default */],{showModal:this.props.showReceiptModal,closeModal:this.handleCloseModalReceiptOnCart,data:this.getReceiptData()}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'main-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__MenuComponents_Categories_Categories__["a" /* default */],{categoriesType:this.props.categoriesRestaurant,selectCategory:this.handleSelectCategory,showCategoriesMobile:this.state.showCategoriesMobile,toggleCategoriesNavClass:this.toggleCategoriesNavClass,showRestaurantsMobile:this.props.showRestaurantsMobile,toggleRestaurants:this.toggleRestaurants,checkout:this.props.checkout,toggleCart:this.toggleCart}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__MenuComponents_Products_Products__["a" /* default */],{isPopularDish:false,checkout:this.props.checkout,selectProduct:this.handleSelectProduct,products:this.props.products,business:this.props.restaurantSelected}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__Cart_Cart__["a" /* default */],null))));}}]);return DynamicMenu;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{userDetails:state.authenticationReducer.userDetails,restaurantSelected:state.menuReducer.restaurantSelected,products:state.menuReducer.products,showRestaurantsMobile:state.menuReducer.showRestaurantsMobile,cart:state.cartReducer.cart,categoriesRestaurant:state.menuReducer.categoriesRestaurant,checkout:state.cartReducer.cart.checkout,showPlacedModal:state.cartReducer.cart.showPlacedModal,showReceiptModal:state.cartReducer.cart.showReceiptModal,restaurantOnCart:state.cartReducer.cart.restaurantSelected,modalErrorPlacedOrder:state.cartReducer.cart.modalErrorPlacedOrder,errorMessage:state.cartReducer.cart.errorLimit,checkoutError:state.cartReducer.cart.checkoutError,addresses:state.menuReducer.addresses};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onFetchingMenu:function onFetchingMenu(idBusiness){return dispatch(__WEBPACK_IMPORTED_MODULE_6_actions_index__["V" /* fetchingMenu */](idBusiness));},onFetchingProducts:function onFetchingProducts(idRestaurant,idCategory){return dispatch(__WEBPACK_IMPORTED_MODULE_6_actions_index__["X" /* fetchingProducts */](idRestaurant,idCategory));},onSelectProduct:function onSelectProduct(product){return dispatch(__WEBPACK_IMPORTED_MODULE_6_actions_index__["_25" /* selectProduct */](product));},onAddProductToCart:function onAddProductToCart(product){return dispatch(__WEBPACK_IMPORTED_MODULE_6_actions_index__["a" /* addProductToCart */](product));},onAddProductToCartNow:function onAddProductToCartNow(product){return dispatch(__WEBPACK_IMPORTED_MODULE_6_actions_index__["b" /* addProductToCartNow */](product));},onDeleteProductFromCart:function onDeleteProductFromCart(payload){return dispatch(__WEBPACK_IMPORTED_MODULE_6_actions_index__["I" /* deleteProductFromCart */](payload));},onDeleteAllProductsFromCart:function onDeleteAllProductsFromCart(){return dispatch(__WEBPACK_IMPORTED_MODULE_6_actions_index__["G" /* deleteAllProductsFromCart */]());},onToggleCart:function onToggleCart(state){return dispatch(__WEBPACK_IMPORTED_MODULE_6_actions_index__["_34" /* toggleCart */](state));},onToggleRestaurants:function onToggleRestaurants(state){return dispatch(__WEBPACK_IMPORTED_MODULE_6_actions_index__["_38" /* toggleRestaurants */](state));},onCloseModalAvailableRestaurant:function onCloseModalAvailableRestaurant(){return dispatch(__WEBPACK_IMPORTED_MODULE_6_actions_index__["s" /* closeModalAvailableRestaurant */]());},cartToggleShowModalReceipt:function cartToggleShowModalReceipt(isClosing){return dispatch(__WEBPACK_IMPORTED_MODULE_6_actions_index__["i" /* cartToggleShowModalReceipt */](isClosing));},closeModalErrorPlacedOrder:function closeModalErrorPlacedOrder(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_7_actions_Cart__["n" /* closeModalErrorPlacedOrder */])());},closeModalPlacedOrderOnCart:function closeModalPlacedOrderOnCart(history){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_7_actions_Cart__["o" /* closeModalPlacedOrderOnCart */])(history));},closeModalReceiptOnCart:function closeModalReceiptOnCart(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_7_actions_Cart__["p" /* closeModalReceiptOnCart */])());},openModalReceiptOnCart:function openModalReceiptOnCart(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_7_actions_Cart__["x" /* openModalReceiptOnCart */])());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(DynamicMenu));

/***/ }),
/* 765 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Product__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Products_css__ = __webpack_require__(766);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Products_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Products_css__);
var products=function products(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:props.checkout?'list-items cart-open':'list-items',tabIndex:0,'aria-label':'Order items, select products',id:'orders-items'},props.products.map(function(product){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Product__["a" /* default */],{isPopularDish:props.isPopularDish,key:product.id,product:product,business:props.business,selectProduct:props.selectProduct});}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cart-menu-category-overlay'}));};/* harmony default export */ __webpack_exports__["a"] = (products);

/***/ }),
/* 766 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 767 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__hoc_ReactAux_ReactAux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_UI_Modal_ModalCartMessage__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_UI_Modal_ModalError__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_UI_Modal_ModalSuccessPayment__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_UI_Modal_ModalReceipt__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__MenuComponents_RecentlyOrdered_RecentlyOrdered__ = __webpack_require__(288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_actions_index__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_actions_Cart__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Cart_Cart__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_utils_object__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_utils_currency__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__support_context__ = __webpack_require__(54);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var FastReOrder=function(_Component){_inherits(FastReOrder,_Component);function FastReOrder(){var _ref;var _temp,_this,_ret;_classCallCheck(this,FastReOrder);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=FastReOrder.__proto__||Object.getPrototypeOf(FastReOrder)).call.apply(_ref,[this].concat(args))),_this),_this.state={differentRestaurant:false,productStandBy:null,businessStandBy:null},_this.handleAddRecentlyOrderProduct=function(item){var productsLastOrder=item.orderItems.map(function(orderItem){var productMap=Object.assign({},orderItem.product,{mealOptions:orderItem.mealOptions?orderItem.mealOptions:[]});productMap.price=orderItem.total;return productMap;});if(_this.verifyIfRestaurantInCart(item.restaurant.id)){_this.setState({productStandBy:productsLastOrder});_this.setState({businessStandBy:item.restaurant});}else{_this.props.onAddProductToCart({product:productsLastOrder,business:item.restaurant});_this.props.onRestaurantSelected(item.restaurant);}},_this.verifyIfRestaurantInCart=function(idRestaurant){var isDifferent=!_this.props.restaurantOnCart?false:_this.props.restaurantOnCart.id!==idRestaurant;_this.setState({differentRestaurant:isDifferent});return isDifferent;},_this.handleConfirmOkCartModal=function(){_this.props.onDeleteAllProductsFromCart();_this.props.onAddProductToCart({product:_this.state.productStandBy,business:_this.state.businessStandBy});_this.props.onRestaurantSelected(_this.state.businessStandBy);_this.setState({differentRestaurant:false});},_this.handleDenyCartModal=function(){_this.setState({differentRestaurant:false});},_this.getSurcharge=function(){var isPayTypeCreditCard=function isPayTypeCreditCard(payType){return payType==='C';};var payType=__WEBPACK_IMPORTED_MODULE_11_utils_object__["a" /* default */].get(_this.props,'cart.payInfo.payType',undefined);if(isPayTypeCreditCard(payType)){return __WEBPACK_IMPORTED_MODULE_11_utils_object__["a" /* default */].get(_this.props,'cart.campaignRateCC.amount',0);}return 0;},_this.getTaxDelivery=function(){return!!_this.props.restaurantSelected&&_this.props.restaurantSelected.taxDelivery&&_this.isDeliverAtHome()?_this.props.restaurantSelected.taxDelivery.toFixed(2):Number(0).toFixed(2);},_this.getCollectionDiscount=function(){var campaignRateCollection=__WEBPACK_IMPORTED_MODULE_11_utils_object__["a" /* default */].get(_this.props,'cart.campaignRateCollection',null);if(campaignRateCollection){var collectionDiscount=campaignRateCollection.discountType==='P'?'% '+campaignRateCollection.amount:'- '+campaignRateCollection.amount;return collectionDiscount;}else{return'';}},_this.isForCollection=function(){return __WEBPACK_IMPORTED_MODULE_11_utils_object__["a" /* default */].get(_this.props,'cart.restaurantSelected.forCollection','N');},_this.getReceiptData=function(){return{cart:_this.props.cart,total:_this.getAmount(),currency:_this.getCurrency(),surcharge:_this.getSurcharge(),subtotal:_this.getSubTotal(),taxDelivery:_this.getTaxDelivery(),userDetails:_this.props.userDetails,orderDeliveryDate:__WEBPACK_IMPORTED_MODULE_11_utils_object__["a" /* default */].get(_this.props,'cart.orderDeliveryDate',undefined),collectionDiscount:_this.getCollectionDiscount(),forCollection:_this.isForCollection(),address:_this.getAddress(),tipValue:__WEBPACK_IMPORTED_MODULE_11_utils_object__["a" /* default */].get(_this.props,"cart.tipValue",0)};},_this.handleCloseModalPlacedOrderOnCart=function(){_this.props.onCloseModalPlacedOrder(_this.props.history);},_this.getAddress=function(){return _this.props.addresses[0];},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(FastReOrder,[{key:'componentDidMount',value:function componentDidMount(){Object(__WEBPACK_IMPORTED_MODULE_13__support_context__["c" /* setSupportContext */])('orders.list');this.setState({differentRestaurant:false});this.props.onChangeTitleHeader('Fast Re-order');// The list is otherwise only fetched when an address is picked in the menu,
// so opening this page directly left it empty. Address 0 returns all last orders.
var idAddress=Number(localStorage.getItem('idBusinessAddress'))||0;this.props.onFetchingRecentlyOrdered(idAddress);}},{key:'getAmount',value:function getAmount(){return __WEBPACK_IMPORTED_MODULE_11_utils_object__["a" /* default */].get(this.props,'cart.payInfo.amount',0);}},{key:'getCurrency',value:function getCurrency(){return __WEBPACK_IMPORTED_MODULE_12_utils_currency__["a" /* default */].convertNameToSymbol(__WEBPACK_IMPORTED_MODULE_11_utils_object__["a" /* default */].get(this.props,'cart.restaurantSelected.currency','EUR'));}},{key:'getSubTotal',value:function getSubTotal(){return __WEBPACK_IMPORTED_MODULE_11_utils_object__["a" /* default */].get(this.props,'cart.subtotal',0);}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__hoc_ReactAux_ReactAux__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_UI_Modal_ModalCartMessage__["a" /* default */],{clickButtonConfirm:this.handleConfirmOkCartModal,clickButtonDeny:this.handleDenyCartModal,message:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Note! You can only order from ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),' one restaurant at a time.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Clear current basket to add?'),showModal:this.state.differentRestaurant}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_UI_Modal_ModalError__["a" /* default */],{style:{zIndex:"99999",position:"absolute",margin:"5% 40%"},styleContent:{background:'gainsboro'},showModal:this.props.modalErrorPlacedOrder,closeModal:this.props.onCloseModalErrorPlacedOrder,errorMessage:this.props.checkoutError||this.props.errorMessage}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_UI_Modal_ModalSuccessPayment__["a" /* default */],{descriptionSuccess:this.props.cart.descriptionSuccess,isInvoice:this.props.cart.isInvoice,closeModal:this.handleCloseModalPlacedOrderOnCart,showModal:this.props.showPlacedModal,openReceipt:this.props.openModalReceiptOnCart}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_UI_Modal_ModalReceipt__["a" /* default */],{showModal:this.props.showReceiptModal,closeModal:this.props.onCloseModalReceiptOnCart,data:this.getReceiptData()}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'main-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__MenuComponents_RecentlyOrdered_RecentlyOrdered__["a" /* default */],{restaurantsOptions:this.props.restaurantsOptions,fastReOrderMenu:true,checkout:this.props.checkout,addRepeatOrderProduct:this.handleAddRecentlyOrderProduct,showLoading:this.props.loadingRecentlyOrder,recentlyOrdered:this.props.recentlyOrdered}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Cart_Cart__["a" /* default */],null)));}}]);return FastReOrder;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{userDetails:state.authenticationReducer.userDetails,restaurantsOptions:state.menuReducer.restaurantsOptions,recentlyOrdered:state.menuReducer.recentlyOrdered,loadingRecentlyOrder:state.menuReducer.loadingRecentlyOrder,checkout:state.cartReducer.cart.checkout,showPlacedModal:state.cartReducer.cart.showPlacedModal,showReceiptModal:state.cartReducer.cart.showReceiptModal,productsOnCart:state.cartReducer.cart.products,restaurantOnCart:state.cartReducer.cart.restaurantSelected,modalErrorPlacedOrder:state.cartReducer.cart.modalErrorPlacedOrder,errorMessage:state.cartReducer.cart.errorLimit,checkoutError:state.cartReducer.cart.checkoutError,cart:state.cartReducer.cart,addresses:state.menuReducer.addresses};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onRestaurantSelected:function onRestaurantSelected(restaurant){return dispatch(__WEBPACK_IMPORTED_MODULE_8_actions_index__["_21" /* restaurantSelected */](restaurant));},onAddProductToCart:function onAddProductToCart(product){return dispatch(__WEBPACK_IMPORTED_MODULE_8_actions_index__["a" /* addProductToCart */](product));},onDeleteAllProductsFromCart:function onDeleteAllProductsFromCart(){return dispatch(__WEBPACK_IMPORTED_MODULE_8_actions_index__["G" /* deleteAllProductsFromCart */]());},onCloseModalErrorPlacedOrder:function onCloseModalErrorPlacedOrder(){return dispatch(__WEBPACK_IMPORTED_MODULE_8_actions_index__["w" /* closeModalErrorPlacedOrder */]());},onCloseModalPlacedOrder:function onCloseModalPlacedOrder(history){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_9_actions_Cart__["o" /* closeModalPlacedOrderOnCart */])(history));},openModalReceiptOnCart:function openModalReceiptOnCart(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_9_actions_Cart__["x" /* openModalReceiptOnCart */])());},onCloseModalReceiptOnCart:function onCloseModalReceiptOnCart(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_9_actions_Cart__["p" /* closeModalReceiptOnCart */])());},onChangeTitleHeader:function onChangeTitleHeader(titleHeader){return dispatch(__WEBPACK_IMPORTED_MODULE_8_actions_index__["l" /* changeMenuTitleHeader */](titleHeader));},onFetchingRecentlyOrdered:function onFetchingRecentlyOrdered(idAddress){return dispatch(__WEBPACK_IMPORTED_MODULE_8_actions_index__["Y" /* fetchingRecentlyOrdered */](idAddress));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(FastReOrder));

/***/ }),
/* 768 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DeliveryTrackingItem__ = __webpack_require__(769);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_actions_index__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__DeliveryTracking_scss__ = __webpack_require__(770);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__DeliveryTracking_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__DeliveryTracking_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__support_context__ = __webpack_require__(54);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var DeliveryTracking=function(_Component){_inherits(DeliveryTracking,_Component);function DeliveryTracking(){_classCallCheck(this,DeliveryTracking);return _possibleConstructorReturn(this,(DeliveryTracking.__proto__||Object.getPrototypeOf(DeliveryTracking)).apply(this,arguments));}_createClass(DeliveryTracking,[{key:'componentDidMount',value:function componentDidMount(){this.reportSupportContext();this.props.onGetOrders();this.props.onChangeTitleHeader('Delivery Tracking');}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){// Orders load after the screen mounts: refresh the support context when they arrive.
if(prevProps.orders!==this.props.orders){this.reportSupportContext();}}},{key:'reportSupportContext',value:function reportSupportContext(){Object(__WEBPACK_IMPORTED_MODULE_5__support_context__["c" /* setSupportContext */])('order.tracking',{orderIds:(this.props.orders||[]).map(function(order){return order.id;})});}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'main-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-items tracking'},this.props.orders.length>0?this.props.orders.map(function(order,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__DeliveryTrackingItem__["a" /* default */],{order:order,key:index});}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'delivery-tracking-no-items'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',null,'There is no order to Track Today'))));}}]);return DeliveryTracking;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{orders:state.deliveryTrackingReducer.orders};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onChangeTitleHeader:function onChangeTitleHeader(titleHeader){return dispatch(__WEBPACK_IMPORTED_MODULE_3_actions_index__["l" /* changeMenuTitleHeader */](titleHeader));},onGetOrders:function onGetOrders(){return dispatch(__WEBPACK_IMPORTED_MODULE_3_actions_index__["_2" /* getOrders */]());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(DeliveryTracking));

/***/ }),
/* 769 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_hoc_ReactAux_ReactAux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_guestOrdering__ = __webpack_require__(68);
var STEPS=[{number:'ONE',title:'Awaiting Preparation'},{number:'TWO',title:'Awaiting Pickup'},{number:'THREE',title:'On The Way'},{number:'FOUR',title:'Delivered'}];// Which step is lit for each delivery status. DBO is tracked by no step.
var CURRENT_STEP={NOT_MADE:0,WAITING:1,IN_TRANSIT:2,DONE:3,DBO:-1// The lit step icon is the only colour cue, so the current step also has a "Now" pill
// and carries aria-current for screen readers.
};var DeliveryTrackingItem=function DeliveryTrackingItem(props){var status=props.order.statusOrderDelivery;if(!(status in CURRENT_STEP)){return null;}var current=CURRENT_STEP[status];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_hoc_ReactAux_ReactAux__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,Object(__WEBPACK_IMPORTED_MODULE_2__config_guestOrdering__["v" /* trackingHeading */])(props.order)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'steps'},STEPS.map(function(step,index){var isCurrent=index===current;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:step.number,className:'step '+step.number.toLowerCase(),'aria-current':isCurrent?'step':undefined},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'s'+(index+1)+'-'+(isCurrent?'on':'off')}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'step-info'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,'STEP ',step.number),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,step.title,isCurrent?' ':null,isCurrent?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'step-now'},'Now'):null)));})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'arrival-time'},status==='DBO'?"We can't track this order":'Estimated Arrival Time '+props.order.deliveryDateFormatted));};/* harmony default export */ __webpack_exports__["a"] = (DeliveryTrackingItem);

/***/ }),
/* 770 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(771);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(17)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../lunch-team-client-checkout-msg/node_modules/css-loader/index.js!../../../../../../lunch-team-client-checkout-msg/node_modules/sass-loader/dist/cjs.js!./DeliveryTracking.scss", function() {
			var newContent = require("!!../../../../../../lunch-team-client-checkout-msg/node_modules/css-loader/index.js!../../../../../../lunch-team-client-checkout-msg/node_modules/sass-loader/dist/cjs.js!./DeliveryTracking.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 771 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(14)(undefined);
// imports


// module
exports.push([module.i, ".delivery-tracking-no-items{text-align:center;height:150px}.delivery-tracking-no-items h1{padding:5%}", ""]);

// exports


/***/ }),
/* 772 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CompanyChange__ = __webpack_require__(773);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_UI_Modal_ModalSuccess__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_UI_Modal_ModalDeleteAccount__ = __webpack_require__(775);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_UI_TableCards__ = __webpack_require__(778);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Settings_scss__ = __webpack_require__(781);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Settings_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__Settings_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_actions_index__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_actions_Settings__ = __webpack_require__(332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__containers_Menu_DefaultMenu_OptionsForOrder__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__support_context__ = __webpack_require__(54);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Settings=function(_Component){_inherits(Settings,_Component);function Settings(){var _ref,_this2=this;var _temp,_this,_ret;_classCallCheck(this,Settings);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Settings.__proto__||Object.getPrototypeOf(Settings)).call.apply(_ref,[this].concat(args))),_this),_this.state={message:'',openChangeAddress:false,openModalDeleteAccount:false,isDeleteSuccess:false},_this.escFunction=function(event){if(event.keyCode===27){_this.props.onCloseRequestEmailResetPasswordModal();_this.props.onCloseSentEmailSupport();}},_this.handleForgotPassword=function(){_this.props.onRequestEmailResetPassword(_this.props.userDetails.username);},_this.handleChangeMessage=function(evt){_this.setState({message:evt.target.value});},_this.handleSendMessage=function(){var payload={body:_this.state.message,subject:'Change Company'};_this.props.onSendEmailSuport(payload);},_this.handleMenu=function(idBusiness,idAddress){_this.props.onFetchingMenu(idBusiness,idAddress);},_this.showOptionsForOrder=function(){return _this.props.restaurantsOptions[0].active?_this.props.listAddress.length>0&&!_this.props.addresses.some(function(item){return item.forCollection===false;}):false;},_this.showCollectionOption=function(){return!_this.props.addresses.find(function(address){return address.forCollection;})&&_this.props.showCollectionOption;},_this.getInfoAddressForDelivery=function(parameter){var address=_this.props.addresses.find(function(item){return!!!item.forCollection;});return!!address&&!!address[parameter]?address[parameter]:' - ';},_this.handleSelectOptionForOrder=function(address){_this.props.onSelectAddressForOrder([address]);_this.setState({openChangeAddress:false});},_this.handleCreateCustomerDeliveryAddress=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(place){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return _this.props.onCreateCustomerDeliveryAddress(place);case 2:_this.setState({openChangeAddress:false});case 3:case'end':return _context.stop();}}},_callee,_this2);}));return function(_x){return _ref2.apply(this,arguments);};}(),_this.openModalAddress=function(){_this.setState({openChangeAddress:true});},_this.openModalAccount=function(){_this.setState({openModalDeleteAccount:true});},_this.closeDeleteAccountModal=function(){_this.setState({openModalDeleteAccount:false});},_this.handleDeleteAccount=function(){_this.props.onDeleteAccount();_this.setState({openModalDeleteAccount:false});_this.setState({isDeleteSuccess:true});setTimeout(function(){_this.props.onLogout();},2000);},_this.handleCloseDeleteAccountSuccess=function(){_this.setState({isDeleteSuccess:false});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Settings,[{key:'componentDidMount',value:function componentDidMount(){Object(__WEBPACK_IMPORTED_MODULE_11__support_context__["c" /* setSupportContext */])('account.profile',{companyId:this.props.userDetails&&this.props.userDetails.idBusiness});this.props.onChangeTitleHeader('Settings');document.addEventListener('keydown',this.escFunction,false);}},{key:'componentWillUnmount',value:function componentWillUnmount(){document.removeEventListener('keydown',this.escFunction,false);}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'main-content'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__CompanyChange__["a" /* default */],{show:this.props.showCompanyChange,close:this.props.onCloseChangeCompany,handleChangeMessage:this.handleChangeMessage,invalid:this.state.message.length<10,sendMessage:this.handleSendMessage}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_UI_Modal_ModalSuccess__["a" /* default */],{showModal:this.props.isSentEmailResetPasswordSuccess,message:'Check your email to reset your password.',closeModal:this.props.onCloseRequestEmailResetPasswordModal}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_UI_Modal_ModalSuccess__["a" /* default */],{showModal:this.props.isSentEmailSupport,message:'Your message was sent to support. Give us some time to process your request.',closeModal:this.props.onCloseSentEmailSupport}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'list-items settings'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('form',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h2',null,'Personal Information'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'flex-row personal-info'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'config-item'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',null,'First Name '),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{disabled:true,value:this.props.userDetails.firstName,type:'text',name:'name',placeholder:'First Name'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'config-item'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',null,' Last Name '),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{disabled:true,value:this.props.userDetails.lastName,type:'text',name:'last-name',placeholder:'Last Name'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'config-item'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',null,' Email '),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{disabled:true,value:this.props.userDetails.username,type:'text',name:'email',placeholder:'Email'}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h2',null,'Delivery Address'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'span'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'flex-row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'config-item w25'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',null,' Company '),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{disabled:true,value:this.props.userDetails.businessName,type:'text',name:'company',placeholder:'Company'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'config-item w55'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',null,' Address '),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{disabled:true,value:this.getInfoAddressForDelivery('street'),type:'text',name:'address',placeholder:'Address'}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'tool'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onClick:this.openModalAddress,className:'modal-a tooltip popup-with-zoom-anim'},'Change Address?')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'flex-row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'config-item'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',null,' Zip Code '),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{disabled:true,value:this.getInfoAddressForDelivery('postalCode'),type:'text',name:'zipcode',placeholder:'Zip Code'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'config-item'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',null,' City '),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{disabled:true,value:this.getInfoAddressForDelivery('city'),type:'text',name:'city',placeholder:'City'}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'tool'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onClick:this.props.onShowChangeCompany,className:'modal-a tooltip popup-with-zoom-anim'},'How to change company?'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h2',{className:'margin-titles'},'Password'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'settings-reset-password'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{target:'_blank',onClick:this.handleForgotPassword},'Reset your Password')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h2',null,'Account'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'settings-reset-password'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{target:'_blank',onClick:this.openModalAccount},'Delete your account')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_UI_Modal_ModalDeleteAccount__["a" /* ModalDeleteAccount */],{closeModal:this.closeDeleteAccountModal,isOpen:this.state.openModalDeleteAccount,onConfirm:this.handleDeleteAccount}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_UI_Modal_ModalSuccess__["a" /* default */],{showModal:this.state.isDeleteSuccess,message:'Your account was deleted successfully.',closeModal:this.handleCloseDeleteAccountSuccess}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_UI_TableCards__["a" /* default */],null)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__containers_Menu_DefaultMenu_OptionsForOrder__["a" /* default */],{onFetchingMenu:this.handleMenu,idBusiness:this.props.userDetails.idBusiness,listAddress:this.props.listAddress,showModal:this.state.openChangeAddress,showCollectionOption:this.showCollectionOption(),onToggleCart:this.props.onToggleCart,onDeleteAllproductsFromCard:this.props.onDeleteAllproductsFromCard,showDeliverAtHomeOption:this.props.showDeliverAtHomeOption,selectOptionForOrder:this.handleSelectOptionForOrder,createCustomerDeliveryAddress:this.handleCreateCustomerDeliveryAddress,onCartResetState:this.props.onCartResetState,onDeleteRestaurantSelected:this.props.onDeleteRestaurantSelected,onFetchingRecentlyOrdered:this.props.onFetchingRecentlyOrdered}));}}]);return Settings;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{addresses:state.menuReducer.addresses,listAddress:state.menuReducer.listAddress,restaurantsOptions:state.menuReducer.restaurantsOptions,userDetails:state.authenticationReducer.userDetails,showCompanyChange:state.settingsReducer.showCompanyChange,showCollectionOption:state.menuReducer.showCollectionOption,isSentEmailResetPasswordSuccess:state.passwordReducer.isRequestSentEmailResetPasswordSuccess,isSentEmailSupport:state.settingsReducer.isSentEmailSupport,showDeliverAtHomeOption:state.menuReducer.acceptDeliverAtHome};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onChangeTitleHeader:function onChangeTitleHeader(titleHeader){return dispatch(__WEBPACK_IMPORTED_MODULE_8_actions_index__["l" /* changeMenuTitleHeader */](titleHeader));},onShowChangeCompany:function onShowChangeCompany(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_9_actions_Settings__["f" /* showChangeCompany */])());},onCloseChangeCompany:function onCloseChangeCompany(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_9_actions_Settings__["a" /* closeChangeCompany */])());},onRequestEmailResetPassword:function onRequestEmailResetPassword(email){return dispatch(__WEBPACK_IMPORTED_MODULE_8_actions_index__["_15" /* requestEmailResetPassword */](email));},onCloseRequestEmailResetPasswordModal:function onCloseRequestEmailResetPasswordModal(){return dispatch(__WEBPACK_IMPORTED_MODULE_8_actions_index__["_7" /* onCloseRequestEmailResetPasswordModal */]());},onSendEmailSuport:function onSendEmailSuport(payload){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_9_actions_Settings__["e" /* sendEmailSuport */])(payload));},onCloseSentEmailSupport:function onCloseSentEmailSupport(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_9_actions_Settings__["c" /* closeSentEmailSupport */])());},onToggleCart:function onToggleCart(status){return dispatch(__WEBPACK_IMPORTED_MODULE_8_actions_index__["_34" /* toggleCart */](status));},onDeleteAllproductsFromCard:function onDeleteAllproductsFromCard(){return dispatch(__WEBPACK_IMPORTED_MODULE_8_actions_index__["G" /* deleteAllProductsFromCart */]());},onSelectForColectionOption:function onSelectForColectionOption(){return dispatch(__WEBPACK_IMPORTED_MODULE_8_actions_index__["m" /* changeRestaurantOptions */](2));},onSelectAddressForOrder:function onSelectAddressForOrder(address){return dispatch(__WEBPACK_IMPORTED_MODULE_8_actions_index__["_22" /* selectAddressForOrder */](address));},onFetchingMenu:function onFetchingMenu(idBusiness,idAddress){return dispatch(__WEBPACK_IMPORTED_MODULE_8_actions_index__["V" /* fetchingMenu */](idBusiness,idAddress));},onCreateCustomerDeliveryAddress:function onCreateCustomerDeliveryAddress(place){return dispatch(__WEBPACK_IMPORTED_MODULE_8_actions_index__["F" /* createCustomerDeliveryAddress */](place));},onCartResetState:function onCartResetState(){return dispatch(__WEBPACK_IMPORTED_MODULE_8_actions_index__["g" /* cartResetState */]());},onDeleteRestaurantSelected:function onDeleteRestaurantSelected(){return dispatch(__WEBPACK_IMPORTED_MODULE_8_actions_index__["J" /* deleteRestaurantSelected */]());},onFetchingRecentlyOrdered:function onFetchingRecentlyOrdered(idAddress){return dispatch(__WEBPACK_IMPORTED_MODULE_8_actions_index__["Y" /* fetchingRecentlyOrdered */](idAddress));},onDeleteAccount:function onDeleteAccount(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_9_actions_Settings__["d" /* deleteAccount */])());},onLogout:function onLogout(){return dispatch(__WEBPACK_IMPORTED_MODULE_8_actions_index__["_5" /* logoutRequest */]());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(Settings));

/***/ }),
/* 773 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CompanyChange_css__ = __webpack_require__(774);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CompanyChange_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__CompanyChange_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_UI_Backdrop_Backdrop__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_hoc_ReactAux_ReactAux__ = __webpack_require__(4);
var CompanyChange=function CompanyChange(props){if(!props.show){return null;}var disabled=null;if(props.invalid){disabled={background:'var(--lt-color-muted)',color:'var(--lt-color-muted-foreground)',border:'1px solid var(--lt-color-border)',cursor:'not-allowed'};}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_hoc_ReactAux_ReactAux__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_UI_Backdrop_Backdrop__["a" /* default */],{show:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'settings',className:'mfp-bg-login white-popup-block lb-centralizar singup zoom-anim-dialog moda-company-change'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'lb-settings lb-padrao-singup6 mfp-content-login modal-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:function onClick(){return props.close();},title:'Close (Esc)',type:'button',className:'mfp-close lb-fechar fa fa-times'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('article',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'Company Change Request')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'config-item'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Email'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',name:'email',value:'support@lunch.team',disabled:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'config-item'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Message'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea',{onChange:function onChange(evt){return props.handleChangeMessage(evt);},name:'message'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{disabled:props.invalid,style:disabled,onClick:props.sendMessage,className:'orange-bold'},' Send '))))));};/* harmony default export */ __webpack_exports__["a"] = (CompanyChange);

/***/ }),
/* 774 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 775 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ModalDeleteAccount; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_modal__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__hoc_ReactAux_ReactAux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modalDeleteAccount_scss__ = __webpack_require__(776);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modalDeleteAccount_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__modalDeleteAccount_scss__);
var ModalDeleteAccount=function ModalDeleteAccount(_ref){var closeModal=_ref.closeModal,isOpen=_ref.isOpen,onConfirm=_ref.onConfirm;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__hoc_ReactAux_ReactAux__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_modal___default.a,{isOpen:isOpen,shouldCloseOnOverlayClick:true,shouldCloseOnEsc:true,onRequestClose:closeModal,contentLabel:'Delete Account',className:'modal-delete',overlayClassName:'modal-delete-overlay'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-delete-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'Delete Account'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'All your account information will be permanently deleted.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-delete-buttons'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn-cancel-delete',onClick:closeModal},'Cancel'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn-delete',onClick:onConfirm},'Delete')))));};

/***/ }),
/* 776 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(777);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(17)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../lunch-team-client-checkout-msg/node_modules/css-loader/index.js!../../../../../../../lunch-team-client-checkout-msg/node_modules/sass-loader/dist/cjs.js!./modalDeleteAccount.scss", function() {
			var newContent = require("!!../../../../../../../lunch-team-client-checkout-msg/node_modules/css-loader/index.js!../../../../../../../lunch-team-client-checkout-msg/node_modules/sass-loader/dist/cjs.js!./modalDeleteAccount.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 777 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(14)(undefined);
// imports


// module
exports.push([module.i, ".modal-delete{background:#fff;border:none;width:fit-content;height:fit-content;top:35%;left:35%;position:absolute}.modal-delete-overlay{position:fixed;z-index:9999999;width:100%;height:100%;left:0;top:0;background-color:rgba(0,0,0,.7)}.modal-delete-content{display:flex;flex-direction:column;align-items:center;justify-content:center;padding:53px 58px}.modal-delete-content h3{font-size:26px;font-weight:600}.modal-delete-content p{font-weight:500;font-size:15px;line-height:18px;text-align:center;margin:33px 0 40px 0}.modal-delete-buttons{display:flex;align-items:center;justify-content:space-between;width:100%;gap:22px}.btn-cancel-delete{display:flex;align-items:center;justify-content:center;height:32px;color:#0e7a4b;background-color:#fff;width:100%;border:1px solid #0e7a4b;border-radius:8px;transition:all .2s ease-in-out}.btn-cancel-delete:hover{color:#fff;background-color:#0e7a4b}.btn-delete{display:flex;align-items:center;justify-content:center;height:32px;width:100%;color:#fff;background-color:#0e7a4b;border-radius:8px;border:none;transition:all .2s ease-in-out}.btn-delete:hover{filter:brightness(0.9)}@media only screen and (max-width: 768px){.modal-delete{left:0}}@media screen and (min-width: 768px)and (max-width: 1024px){.modal-delete{left:18%}}", ""]);

// exports


/***/ }),
/* 778 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoc_ReactAux_ReactAux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TableRow__ = __webpack_require__(779);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_UI_Modal_ModalConfirm__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__index_css__ = __webpack_require__(780);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_actions_index__ = __webpack_require__(13);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Table=function(_Component){_inherits(Table,_Component);function Table(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Table);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Table.__proto__||Object.getPrototypeOf(Table)).call.apply(_ref,[this].concat(args))),_this),_this.state={showConfirmModal:false,cardId:0},_this.showConfirmDeleteCardModal=function(cardId){_this.setState({showConfirmModal:true,cardId:cardId});},_this.cancelDeleteCardModal=function(){_this.setState({showConfirmModal:false,cardId:0});},_this.handleConfirmDeleteCard=function(){_this.setState({showConfirmModal:false});_this.props.onDeleteCard(_this.state.cardId);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Table,[{key:'componentDidMount',value:function componentDidMount(){this.props.onFetchingCards();}},{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_hoc_ReactAux_ReactAux__["a" /* default */],null,this.state.showConfirmModal?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_UI_Modal_ModalConfirm__["a" /* default */],{title:'Confirm delete card',onClose:this.cancelDeleteCardModal,onConfirm:this.handleConfirmDeleteCard},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{style:{textTransform:'none',fontSize:'20px'}},'Are you sure you want delete this card ?'))):null,this.props.cards.length>0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_hoc_ReactAux_ReactAux__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'margin-tittles'},'Manage Cards'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table-cards'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:'table-cards-head'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Brand'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Last 4 digits'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Expiry date'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null)),this.props.cards.map(function(row,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__TableRow__["a" /* default */],{key:index,row:row,deleteCard:_this2.showConfirmDeleteCardModal});})))):null);}}]);return Table;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{cards:state.cartReducer.cart.cards};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onFetchingCards:function onFetchingCards(){return dispatch(__WEBPACK_IMPORTED_MODULE_6_actions_index__["Q" /* fetchingCards */]());},onDeleteCard:function onDeleteCard(cardId){return dispatch(__WEBPACK_IMPORTED_MODULE_6_actions_index__["H" /* deleteCard */](cardId));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(Table));

/***/ }),
/* 779 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var TableRow=function TableRow(_ref){var row=_ref.row,deleteCard=_ref.deleteCard;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{key:row.cardId},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:row.expired?"table-row-cards expired-card":"table-row-cards",key:row.brandName},row.brandName),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:row.expired?"table-row-cards expired-card":"table-row-cards",key:row.lastFour},row.lastFour),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:row.expired?"table-row-cards expired-card":"table-row-cards",key:row.expiryDate},row.expiryDate,row.expired?" (expired)":null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"table-column-button"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{onClick:function onClick(){return deleteCard(row.cardId);},className:"btn-delete-card"},"Delete card")));};/* harmony default export */ __webpack_exports__["a"] = (TableRow);

/***/ }),
/* 780 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 781 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(782);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(17)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../lunch-team-client-checkout-msg/node_modules/css-loader/index.js!../../../../../../lunch-team-client-checkout-msg/node_modules/sass-loader/dist/cjs.js!./Settings.scss", function() {
			var newContent = require("!!../../../../../../lunch-team-client-checkout-msg/node_modules/css-loader/index.js!../../../../../../lunch-team-client-checkout-msg/node_modules/sass-loader/dist/cjs.js!./Settings.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 782 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(14)(undefined);
// imports


// module
exports.push([module.i, ".settings-reset-password a[target=_blank]{font-size:18px;color:#0e7a4b;text-decoration:none;border-bottom:1px}.settings-reset-password a[target=_blank]:hover{opacity:.7}", ""]);

// exports


/***/ }),
/* 783 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_utils_http__ = __webpack_require__(19);
var sendEmailSuport=function sendEmailSuport(payload){return __WEBPACK_IMPORTED_MODULE_0_utils_http__["a" /* default */].post('/settings/v1/settings/sendmailsupport',payload);};var unsubscribe=function unsubscribe(token){return __WEBPACK_IMPORTED_MODULE_0_utils_http__["a" /* default */].get('/settings/v1/unsubscribe/'+token);};var deleteAccount=function deleteAccount(){return __WEBPACK_IMPORTED_MODULE_0_utils_http__["a" /* default */].delete('/user/v1/user/delete-account');};/* harmony default export */ __webpack_exports__["a"] = ({sendEmailSuport:sendEmailSuport,unsubscribe:unsubscribe,deleteAccount:deleteAccount});

/***/ }),
/* 784 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__GDPRModal__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__GDPR_scss__ = __webpack_require__(785);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__GDPR_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__GDPR_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_actions_Menu__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_actions_Gdpr__ = __webpack_require__(206);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Gdpr=function(_Component){_inherits(Gdpr,_Component);function Gdpr(props){_classCallCheck(this,Gdpr);var _this=_possibleConstructorReturn(this,(Gdpr.__proto__||Object.getPrototypeOf(Gdpr)).call(this,props));_this.state={showModal:false,isTermsConditions:true};_this.escFunction=function(event){if(event.keyCode===27){_this.setState({showModal:false});}};_this.handleOpenTermsConditions=function(){_this.setState({showModal:true,isTermsConditions:true});};_this.handleOpenPrivacyPolicy=function(){_this.setState({showModal:true,isTermsConditions:false});};_this.handleCloseModal=function(){_this.setState({showModal:false});};_this.escFunction=_this.escFunction.bind(_this);return _this;}_createClass(Gdpr,[{key:'componentDidMount',value:function componentDidMount(){this.props.onChangeTitleHeader('GDPR Info');this.props.onFetchingTermsConditions();this.props.onFetchingPrivacyPolicy();document.addEventListener("keydown",this.escFunction,false);}},{key:'componentWillUnmount',value:function componentWillUnmount(){document.removeEventListener("keydown",this.escFunction,false);}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'main-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-items gdpr-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__GDPRModal__["a" /* default */],{style:{top:'5%',right:'5%',height:'450px',width:'85%',overflow:'hidden'},show:this.state.showModal,termsConditions:this.props.termsConditions,privacyPolicy:this.props.privacyPolicy,closeModal:this.handleCloseModal,isTermsConditions:this.state.isTermsConditions}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'gdpr-terms-conditions'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{target:'_blank',onClick:this.handleOpenTermsConditions},'Terms and Conditions')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'gdpr-privacy-policy'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{target:'_blank',onClick:this.handleOpenPrivacyPolicy},'Privacy Policy'))));}}]);return Gdpr;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{termsConditions:state.gdprReducer.termsConditions,privacyPolicy:state.gdprReducer.privacyPolicy};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onChangeTitleHeader:function onChangeTitleHeader(titleHeader){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_actions_Menu__["b" /* changeMenuTitleHeader */])(titleHeader));},onFetchingTermsConditions:function onFetchingTermsConditions(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_actions_Gdpr__["b" /* fetchingTermsConditions */])());},onFetchingPrivacyPolicy:function onFetchingPrivacyPolicy(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_actions_Gdpr__["a" /* fetchingPrivacyPolicy */])());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(Gdpr));

/***/ }),
/* 785 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(786);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(17)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../lunch-team-client-checkout-msg/node_modules/css-loader/index.js!../../../../../../lunch-team-client-checkout-msg/node_modules/sass-loader/dist/cjs.js!./GDPR.scss", function() {
			var newContent = require("!!../../../../../../lunch-team-client-checkout-msg/node_modules/css-loader/index.js!../../../../../../lunch-team-client-checkout-msg/node_modules/sass-loader/dist/cjs.js!./GDPR.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 786 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(14)(undefined);
// imports


// module
exports.push([module.i, ".gdpr-terms-conditions a[target=_blank]{font-size:18px;color:#0e7a4b;text-decoration:none;border-bottom:1px;margin-top:30px}.gdpr-terms-conditions a[target=_blank]:hover{opacity:.7}.gdpr-privacy-policy a[target=_blank]{font-size:18px;color:#0e7a4b;text-decoration:none;border-bottom:1px;margin-top:30px}.gdpr-privacy-policy a[target=_blank]:hover{opacity:.7}", ""]);

// exports


/***/ }),
/* 787 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services_restaurantService__ = __webpack_require__(788);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_hoc_ReactAux_ReactAux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Logo_Logo__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles__ = __webpack_require__(789);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_images_header_jpg__ = __webpack_require__(311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_images_header_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__assets_images_header_jpg__);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _templateObject=_taggedTemplateLiteral(['\n                &:after {\n                  content: \'','\';\n                  background:var(--lt-color-primary);\n                  width:17px;\n                  height:17px;\n                  display:-webkit-inline-box;\n                  display:-ms-inline-flexbox;\n                  display:inline-flex;\n                  -webkit-box-align:center;\n                  -ms-flex-align:center;\n                  align-items:center;\n                  -webkit-box-pack:center;\n                  -ms-flex-pack:center;\n                  justify-content:center;\n                  color:white;\n                  border-radius:100%;\n                  padding:0.1px;\n                  font-size:10.2px;\n                  text-align:center;\n                  position:absolute;\n                  padding:0.7px;\n                  margin-top:-9px;\n                  margin-left:-6px\n                }\n              '],['\n                &:after {\n                  content: \'','\';\n                  background:var(--lt-color-primary);\n                  width:17px;\n                  height:17px;\n                  display:-webkit-inline-box;\n                  display:-ms-inline-flexbox;\n                  display:inline-flex;\n                  -webkit-box-align:center;\n                  -ms-flex-align:center;\n                  align-items:center;\n                  -webkit-box-pack:center;\n                  -ms-flex-pack:center;\n                  justify-content:center;\n                  color:white;\n                  border-radius:100%;\n                  padding:0.1px;\n                  font-size:10.2px;\n                  text-align:center;\n                  position:absolute;\n                  padding:0.7px;\n                  margin-top:-9px;\n                  margin-left:-6px\n                }\n              ']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Header=function Header(props){var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(__WEBPACK_IMPORTED_MODULE_6__assets_images_header_jpg___default.a),_useState2=_slicedToArray(_useState,2),urlImage=_useState2[0],setUrlImage=_useState2[1];Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){props.restaurantSelected&&fetchRestaurantCover(props.restaurantSelected.id).then(function(value){value.url?setUrlImage(value.url):setUrlImage(__WEBPACK_IMPORTED_MODULE_6__assets_images_header_jpg___default.a);});},[props.restaurantSelected]);function mountHeader(title,showRestaurantOption){var CartComponent=__WEBPACK_IMPORTED_MODULE_2_styled_components__["a" /* default */].a(_templateObject,props.quantityProductsSelected);var classesHeader='office-hours';if(!!props.restaurantSelected&&props.restaurantSelected.isOpen){classesHeader='office-hours open';}else if(!!props.restaurantSelected&&!!!props.restaurantSelected.isOpen){classesHeader='office-hours closed';}var changeHour=function changeHour(hour){var _hour$split=hour.split(':'),_hour$split2=_slicedToArray(_hour$split,2),hours=_hour$split2[0],minutes=_hour$split2[1];var formatedHours=null;if(hours>=0&&hours<=12){formatedHours=hours+':'+minutes+' AM';}else if(hours>12){formatedHours=hours-12+':'+minutes+' PM';}return formatedHours;};var contentHeader=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_hoc_ReactAux_ReactAux__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',null,props.restaurantSelected?props.restaurantSelected.name:title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'infos','aria-label':'Restaurant infos'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'left'},props.restaurantSelected&&props.restaurantSelected.openingHour&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:classesHeader},props.restaurantSelected&&props.restaurantSelected.isOpen?'OPEN '+changeHour(props.restaurantSelected.openingHour.openHour)+' - '+changeHour(props.restaurantSelected.openingHour.closeHour):props.restaurantSelected?'CLOSED '+changeHour(props.restaurantSelected.openingHour.openHour)+' - '+changeHour(props.restaurantSelected.openingHour.closeHour):'',' ',props.restaurantSelected&&props.restaurantSelected.forCollection==='Y'?'Address : '+props.restaurantSelected.address.substring(0,50):'')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right','aria-label':'Delivery and collection infos',tabIndex:2},props.showCollectionOption&&showRestaurantOption&&props.restaurantsOptions.map(function(options){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_hoc_ReactAux_ReactAux__["a" /* default */],{key:options.id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{onChange:function onChange(){return props.toggleRestaurantOptions(options.id);},type:'radio',name:'restaurantOptions',id:options.type,checked:options.active,'aria-checked':options.active}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:options.type},options.type));}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CartComponent,{className:'cart-bar'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{'aria-label':'cart icon',ref:function ref(btnCart){return btnCart;},onClick:function onClick(){return props.toggleCart();},className:'sprite white-cart25','aria-haspopup':'true'})))));return contentHeader;}function fetchRestaurantCover(id){var response=__WEBPACK_IMPORTED_MODULE_1_services_restaurantService__["a" /* default */].fetchingRestaurantCover(id);return response;}var itemActive=props.itemsSideBarMenu.find(function(item){return item.active===true;});var contentHeader=null;switch(itemActive.index){case 1:case 2:contentHeader=mountHeader(props.titleHeader,true);break;case 3:case 4:case 5:contentHeader=mountHeader(props.titleHeader,false);break;case 6:case 7:case 8:contentHeader=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_hoc_ReactAux_ReactAux__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',null,props.titleHeader),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'infos'}));break;default:break;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'top-header','aria-label':'Banner '+(props.restaurantSelected?props.restaurantSelected.name:'Popular Dishes')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',{className:'menu-mobile'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Logo_Logo__["a" /* default */],{goToMenu:props.goToDefaultMenu}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{id:'menu_toggle',className:props.showMenuMobile?'menu open':'menu',onClick:function onClick(){return props.toggleMenuMobile();},alt:'Menu bar'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg',{className:'svg-inline--fa fa-bars fa-w-14','aria-hidden':'true','data-prefix':'fas','data-icon':'bars',role:'img',xmlns:'http://www.w3.org/2000/svg',viewBox:'0 0 448 512','data-fa-i2svg':''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'currentColor',d:'M16 132h416c8.837 0 16-7.163 16-16V76c0-8.837-7.163-16-16-16H16C7.163 60 0 67.163 0 76v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16z'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__styles__["a" /* CustomHeader */],{className:'header-restaurant',style:{backgroundImage:'url('+urlImage+')'}},contentHeader)));};/* harmony default export */ __webpack_exports__["a"] = (Header);

/***/ }),
/* 788 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_utils_http__ = __webpack_require__(19);
var fetchingRestaurantLogo=function fetchingRestaurantLogo(idBusiness){return __WEBPACK_IMPORTED_MODULE_0_utils_http__["a" /* default */].get('/menu/v1/image/business/'+idBusiness);};var fetchingRestaurantCover=function fetchingRestaurantCover(idRestaurant){return __WEBPACK_IMPORTED_MODULE_0_utils_http__["a" /* default */].get('/menu/v1/image/url/restaurant/cover/'+idRestaurant);};/* harmony default export */ __webpack_exports__["a"] = ({fetchingRestaurantLogo:fetchingRestaurantLogo,fetchingRestaurantCover:fetchingRestaurantCover});

/***/ }),
/* 789 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CustomHeader; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_images_header_jpg__ = __webpack_require__(311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_images_header_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_images_header_jpg__);
var _templateObject=_taggedTemplateLiteral(["\n  background-image: \n  ","\n"],["\n  background-image: \n  ","\n"]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var CustomHeader=__WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].header(_templateObject,function(props){return!!props.image?"url("+props.image+"), url("+__WEBPACK_IMPORTED_MODULE_1__assets_images_header_jpg___default.a+")":"url("+__WEBPACK_IMPORTED_MODULE_1__assets_images_header_jpg___default.a+")";});

/***/ }),
/* 790 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_Logo_Logo__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Restaurants_Restaurants__ = __webpack_require__(791);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__hoc_ReactAux_ReactAux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SideBar_css__ = __webpack_require__(792);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SideBar_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__SideBar_css__);
var sideBar=function sideBar(props){// On phones the bottom "Restaurants" tab opens this list as a sheet. Show the
// expanded restaurants section, or the delivery list if none is expanded, so
// the sheet is never an empty dimmed screen.
var restaurantItems=props.itemsSideBarMenu.filter(function(item){return item.restaurants;});var sheetItem=restaurantItems.find(function(item){return item.active;})||restaurantItems.find(function(item){return item.restaurants.businessDelivery;});var isOpenOnMobile=function isOpenOnMobile(item){return props.showRestaurantsMobile&&sheetItem&&item.index===sheetItem.index;};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:props.showMenuMobile?'principal-left menu-open':'principal-left','aria-label':'Left Menu, restaurants list',tabIndex:1},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:props.showRestaurantsMobile?'menu-left menu-open':'menu-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{title:'Close (Esc)',type:'button',className:'btn-close','aria-describedby':'Close modal button',onClick:function onClick(){return props.toggleMenuMobile();}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Logo_Logo__["a" /* default */],{goToMenu:props.goToDefaultMenu}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('nav',{className:'menu-nav','aria-label':'Restaurants list'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,props.itemsSideBarMenu.map(function(item,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__hoc_ReactAux_ReactAux__["a" /* default */],{key:item.index},item.restaurants?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__hoc_ReactAux_ReactAux__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{onClick:function onClick(){return props.selectItemSideBar(item.index);},className:item.active?'active':null,role:'button','aria-expanded':item.active?'true':'false'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:item.class,'aria-hidden':'true'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',{className:'xfirst-item'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{'aria-label':item.title},item.title)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'d-arrow','aria-hidden':'true'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{'aria-label':'Restaurants List',className:item.active||isOpenOnMobile(item)?'submenu':'submenu-hide'},item.restaurants.businessDelivery?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Restaurants_Restaurants__["a" /* default */],{activeItem:props.activeRestaurant,selectRestaurantItem:props.selectRestaurantDelivery,toggleMenuMobile:props.toggleMenuMobile,items:props.restaurantsOptions[0].active?item.restaurants.businessDelivery:item.restaurants.businessCollection}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Restaurants_Restaurants__["a" /* default */],{activeItem:props.activeRestaurant,selectRestaurantItem:props.selectRestaurantPlatter,toggleMenuMobile:props.toggleMenuMobile,items:item.restaurants.businessPlatter}))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{onClick:function onClick(){return props.selectItemSideBar(item.index);},className:item.active?'active':null},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:item.class,'aria-hidden':'true'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{'aria-label':item.title},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,item.title))));})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cart-menu-category-overlay',onClick:function onClick(){return(props.showMenuMobile||props.showRestaurantsMobile)&&props.toggleMenuMobile();}}));};/* harmony default export */ __webpack_exports__["a"] = (sideBar);

/***/ }),
/* 791 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__hoc_ReactAux_ReactAux__ = __webpack_require__(4);
var restaurants=function restaurants(props){var teste=function teste(id){props.selectRestaurantItem(id);props.toggleMenuMobile();window.document.getElementById('categories-container').focus();};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__hoc_ReactAux_ReactAux__["a" /* default */],null,props.items&&props.items.map(function(item){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__hoc_ReactAux_ReactAux__["a" /* default */],{key:item.id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{role:'button','aria-current':props.activeItem&&props.activeItem.id===item.id?'page':undefined,className:props.activeItem&&props.activeItem.id===item.id?'active':null,onClick:function onClick(){return teste(item.id);},'aria-label':item.name,tabIndex:0},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{role:'presentation'},item.name)));}));};/* harmony default export */ __webpack_exports__["a"] = (restaurants);

/***/ }),
/* 792 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 793 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_utils_currency__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_utils_object__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_utils_json__ = __webpack_require__(794);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_utils_orderConfirmation__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_actions_Checkout__ = __webpack_require__(795);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Stripe_index__ = __webpack_require__(796);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_UI_Modal_ModalReceipt__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_UI_Modal_ModalSuccessPayment__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_UI_Modal_ModalError__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__stripe_react_stripe_js__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__stripe_react_stripe_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__stripe_react_stripe_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__stripe_stripe_js__ = __webpack_require__(800);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__checkout_scss__ = __webpack_require__(801);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__checkout_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__checkout_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_utils_userError__ = __webpack_require__(15);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// Stripe sent the customer back with a failed payment (iDEAL, Bancontact, 3-D Secure).
var PAYMENT_NOT_COMPLETED_ERROR=Object(__WEBPACK_IMPORTED_MODULE_15_utils_userError__["b" /* errorCopy */])(__WEBPACK_IMPORTED_MODULE_15_utils_userError__["a" /* ERROR_CODES */].PAYMENT_DECLINED,{title:"Your payment didn't go through",message:'The payment was not completed, so this order is not confirmed.',guidance:'Try again, or choose another payment method.'});var RenderDiscount=function RenderDiscount(props){var classes='flex flex-justify-space-between '+props.className;return!!props.value&&props.forCollection==='Y'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:classes},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,props.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,''+props.value)):null;};var RenderValueLines=function RenderValueLines(props){var classes='flex flex-justify-space-between '+props.className;return!!props.value?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:classes},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,props.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,props.currency+' '+Number(props.value).toFixed(2))):null;};var HeaderCheckout=function HeaderCheckout(props){return props.isInvoice?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,'Invoice '):props.isForCollection==='Y'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,'For collection'):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,'For delivery');};var Checkout=function(_Component){_inherits(Checkout,_Component);function Checkout(props){_classCallCheck(this,Checkout);var _this=_possibleConstructorReturn(this,(Checkout.__proto__||Object.getPrototypeOf(Checkout)).call(this,props));_this.getCartItensFromTeamVouchers=function(){if(!!_this.props.teamVoucherOrder.orderItems){return{idOrder:_this.props.teamVoucherOrder.idOrder,publicOrderNumber:_this.props.teamVoucherOrder.publicOrderNumber,products:_this.props.teamVoucherOrder.orderItems.map(function(item){return item.product;})};}return _this.props.cart;};_this.getProducts=function(){if(_this.props.cart.products.length>0){return _this.props.cart.products;}return _this.getCartItensFromTeamVouchers().products;};_this.getCollectionDiscount=function(){var campaignRateCollection=__WEBPACK_IMPORTED_MODULE_4_utils_object__["a" /* default */].get(_this.props,'cart.campaignRateCollection',null);if(campaignRateCollection){var collectionDiscount=campaignRateCollection.discountType==='P'?'% '+campaignRateCollection.amount:'- '+campaignRateCollection.amount;return collectionDiscount;}else{return'';}};_this.isForCollection=function(){return __WEBPACK_IMPORTED_MODULE_4_utils_object__["a" /* default */].get(_this.props,'cart.restaurantSelected.forCollection','N');};_this.getTipValue=function(){return __WEBPACK_IMPORTED_MODULE_4_utils_object__["a" /* default */].get(_this.props,'cart.tipValue',0);};_this.getIsInvoice=function(){return __WEBPACK_IMPORTED_MODULE_4_utils_object__["a" /* default */].get(_this.props,'cart.isInvoice');};_this.getAddress=function(){return _this.props.addresses[0];};_this.renderProductsOnCart=function(product,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'item'+index,className:'item'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'flex flex-justify-space-between'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,product.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,_this.getCurrency()+product.price.toFixed(2))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,product.description));};_this.getTaxDelivery=function(){return!!_this.props.restaurantSelected&&_this.props.restaurantSelected.taxDelivery&&_this.isDeliverAtHome()?_this.props.restaurantSelected.taxDelivery.toFixed(2):Number(0).toFixed(2);};_this.getSurcharge=function(){var amountFromTeamVoucher=__WEBPACK_IMPORTED_MODULE_4_utils_object__["a" /* default */].get(_this.props,'teamVoucherCampaignRateCC.amount',undefined);var amountFromCart=__WEBPACK_IMPORTED_MODULE_4_utils_object__["a" /* default */].get(_this.props,'cart.campaignRateCC.amount',0);return!!amountFromTeamVoucher?amountFromTeamVoucher:amountFromCart;};_this.getCollectionDiscount=function(){var campaignRateCollection=__WEBPACK_IMPORTED_MODULE_4_utils_object__["a" /* default */].get(_this.props,'cart.campaignRateCollection',null);if(campaignRateCollection){var collectionDiscount=campaignRateCollection.discountType==='P'?'% '+campaignRateCollection.amount:'- '+campaignRateCollection.amount;return collectionDiscount;}else{return'';}};_this.isForCollection=function(){return!!_this.props.cart.restaurantSelected?__WEBPACK_IMPORTED_MODULE_4_utils_object__["a" /* default */].get(_this.props,'cart.restaurantSelected.forCollection','N'):'N';};_this.state={isSubmitted:false,returnStripeSucess:false,returnStripeFail:false};_this.formReference=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();_this.renderProductsOnCart=_this.renderProductsOnCart.bind(_this);_this.getCurrency=_this.getCurrency.bind(_this);_this.eventFunction=_this.eventFunction.bind(_this);_this.initStripePayment=_this.initStripePayment.bind(_this);_this.tryPaymentAgain=_this.tryPaymentAgain.bind(_this);if(!!_this.getOrderId()){_this.initStripePayment();}return _this;}_createClass(Checkout,[{key:'getReceiptData',value:function getReceiptData(){return{cart:this.getCartItensFromTeamVouchers(),total:this.getAmount(),currency:this.getCurrency(),surcharge:this.getSurcharge(),subtotal:this.getSubTotal(),taxDelivery:this.getTaxDelivery(),userDetails:this.props.userDetails,orderDeliveryDate:this.props.cart.orderDeliveryDate,collectionDiscount:this.getCollectionDiscount(),forCollection:this.isForCollection(),address:this.getAddress(),tipValue:this.getTipValue(),isVoucher:!this.props.teamVoucherOrder};}},{key:'componentWillUnmount',value:function componentWillUnmount(props){this.props.checkoutResetState();this.removeEvent();}},{key:'componentWillMount',value:function componentWillMount(props){if(!!this.props&&!!this.props.location.search&&this.props.location.search.indexOf('succeeded')!==-1){this.setState({returnStripeSucess:true});return;}else if(!!this.props&&!!this.props.location.search&&this.props.location.search.indexOf('failed')!==-1){this.setState({returnStripeFail:true});return;}else{if(!this.getOrderId()){this.props.history.replace('/Menu');}}}},{key:'componentDidUpdate',value:function componentDidUpdate(){if(!this.state.isSubmitted&&!!this.props.stripeData.urlStripe&&!!this.formReference.current){this.addEvent();this.setState({isSubmitted:true});}}},{key:'tryPaymentAgain',value:function tryPaymentAgain(){this.setState({isSubmitted:false});this.props.history.replace('/Menu/Dynamic');}},{key:'getAmount',value:function getAmount(){if(this.getIsInvoice()){return this.props.invoice.total;}else{var totalCart=__WEBPACK_IMPORTED_MODULE_4_utils_object__["a" /* default */].get(this.props,'cart.subtotal',0);var forCollection=__WEBPACK_IMPORTED_MODULE_4_utils_object__["a" /* default */].get(this.props,'cart.restaurantSelected.forCollection','N');if(forCollection==='Y'){var discountCollection=__WEBPACK_IMPORTED_MODULE_4_utils_object__["a" /* default */].get(this.props,'cart.campaignRateCollection.amount',0);totalCart-=totalCart*(discountCollection/100);}else{var subsidy=__WEBPACK_IMPORTED_MODULE_4_utils_object__["a" /* default */].get(this.props,'cart.subsidy',0);totalCart-=subsidy;}totalCart=totalCart+__WEBPACK_IMPORTED_MODULE_4_utils_object__["a" /* default */].get(this.props,'cart.campaignRateCC.amount',0);var totalFromTeamVoucher=__WEBPACK_IMPORTED_MODULE_4_utils_object__["a" /* default */].get(this.props,'teamVoucherPayInfo.amount',0);totalCart=totalCart+__WEBPACK_IMPORTED_MODULE_4_utils_object__["a" /* default */].get(this.props,'cart.tipValue',0);return!!totalCart?totalCart:totalFromTeamVoucher;}}},{key:'getSubTotal',value:function getSubTotal(){var subTotalFromCart=__WEBPACK_IMPORTED_MODULE_4_utils_object__["a" /* default */].get(this.props,'cart.subtotal',undefined);var subTotalFromTeamVoucher=__WEBPACK_IMPORTED_MODULE_4_utils_object__["a" /* default */].get(this.props,'teamVoucherOrder.totalAmount',0);return!!subTotalFromCart?subTotalFromCart:subTotalFromTeamVoucher;}},{key:'getOrderId',value:function getOrderId(){if(this.getIsInvoice()){return this.props.invoice.invoiceNumber;}else{var idFromCart=__WEBPACK_IMPORTED_MODULE_4_utils_object__["a" /* default */].get(this.props,'cart.idOrder',undefined);var idFromTeamVoucher=__WEBPACK_IMPORTED_MODULE_4_utils_object__["a" /* default */].get(this.props,'teamVoucherOrder.idOrder',undefined);return!!idFromCart?idFromCart:idFromTeamVoucher;}}},{key:'getBusinessRestaurantId',value:function getBusinessRestaurantId(){if(this.getIsInvoice()){return 0;}else{var idFromCart=__WEBPACK_IMPORTED_MODULE_4_utils_object__["a" /* default */].get(this.props,'cart.restaurantSelected.id',undefined);var idFromTeamVoucher=__WEBPACK_IMPORTED_MODULE_4_utils_object__["a" /* default */].get(this.props,'teamVoucherOrder.idBusinessRestaurant',undefined);return!!idFromCart?idFromCart:idFromTeamVoucher;}}},{key:'removePayInfo',value:function removePayInfo(){localStorage.removeItem('PayInfo');}},{key:'setPayInfo',value:function setPayInfo(){localStorage.setItem('PayInfo',JSON.stringify(this.getReceiptData()));}},{key:'getPayInfo',value:function getPayInfo(){JSON.parse(localStorage.getItem('payInfo'));var payInfo=JSON.parse(localStorage.getItem('payInfo'));this.removePayInfo();return payInfo;}},{key:'initStripePayment',value:function initStripePayment(){this.setPayInfo();if(!!this.props.showModalError){this.props.openModalError();}var currency=this.getIsInvoice()?this.props.invoice.currency:__WEBPACK_IMPORTED_MODULE_4_utils_object__["a" /* default */].get(this.props,'cart.restaurantSelected.currency','EUR');var payType=!!this.props.cart&&!!this.props.cart.payInfo?this.props.cart.payInfo.payType:!!this.props.teamVoucherPayInfo&&!!this.props.teamVoucherPayInfo.payType?this.props.teamVoucherPayInfo.payType:'C';var requestConfigDTO={idBusinessRestaurant:this.getBusinessRestaurantId(),idOrder:this.getOrderId(),currency:currency,amount:this.getAmount(),payType:payType};this.props.getStripeConfig(requestConfigDTO);}},{key:'eventFunction',value:function eventFunction(message){var messageIsFromRealexOrigin=!!this.props.stripeData.urlStripe&&this.props.stripeData.urlStripe.startsWith(message.origin);var messageData=__WEBPACK_IMPORTED_MODULE_5_utils_json__["a" /* default */].isValid(message.data)&&JSON.parse(message.data);if(!messageIsFromRealexOrigin)return;var loopCheckingPaymentResponseIsValid=__WEBPACK_IMPORTED_MODULE_5_utils_json__["a" /* default */].isValid(message.data)&&messageData.message&&messageData.message.payload&&messageData.message.payload.nonce&&messageData.message.payload.response&&messageData.message.payload.response.object&&(''+messageData.message.payload.response.object.status).startsWith('succeeded')&&(''+messageData.message.payload.response.object.object).startsWith('payment_intent')&&!(''+messageData.message.payload.response.type).startsWith('error');if(loopCheckingPaymentResponseIsValid){this.props.loopCheckingPaymentResponse({messageRealex:message.data,isInvoice:this.getIsInvoice(),idOrder:this.getOrderId(),payInfo:Object.assign({},__WEBPACK_IMPORTED_MODULE_4_utils_object__["a" /* default */].get(this.props,'cart',{}),{publicOrderNumber:__WEBPACK_IMPORTED_MODULE_4_utils_object__["a" /* default */].get(this.props,'cart.publicOrderNumber',undefined)||__WEBPACK_IMPORTED_MODULE_4_utils_object__["a" /* default */].get(this.props,'teamVoucherOrder.publicOrderNumber',undefined)})});}}},{key:'addEvent',value:function addEvent(){window.addEventListener('message',this.eventFunction);}},{key:'removeEvent',value:function removeEvent(){window.removeEventListener('message',this.eventFunction);}},{key:'getCurrency',value:function getCurrency(){if(!!this.props.cart.restaurantSelected&&!!!this.getIsInvoice()){return __WEBPACK_IMPORTED_MODULE_3_utils_currency__["a" /* default */].convertNameToSymbol(__WEBPACK_IMPORTED_MODULE_4_utils_object__["a" /* default */].get(this.props,'cart.restaurantSelected.currency','EUR'));}else if(this.getIsInvoice()){return __WEBPACK_IMPORTED_MODULE_3_utils_currency__["a" /* default */].convertNameToSymbol(this.props.invoice.currency,'EUR');}else{return'€';}}},{key:'renderHideInputsStripeForm',value:function renderHideInputsStripeForm(){var currency=localStorage.getItem('currency');var stripePromise=currency==='USD'?Object(__WEBPACK_IMPORTED_MODULE_13__stripe_stripe_js__["a" /* loadStripe */])('pk_live_51Kgm5jBvVgLKLmZVA2xa3j1x2C2s7tj49lOHoaihe9m7Skce5mowr1VUwKkZgr7zBcUb1UGVZxIYcrpEFgFwCxCF00N5Z32Y5j'):Object(__WEBPACK_IMPORTED_MODULE_13__stripe_stripe_js__["a" /* loadStripe */])('pk_live_4U4PYH6Q22nWYMstPtAFawvr');return!!this.props.stripeData.urlStripe?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__stripe_react_stripe_js__["Elements"],{stripe:stripePromise},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Stripe_index__["a" /* default */],{props:this.props,formReference:this.formReference})):null;}},{key:'render',value:function render(){var _this2=this;var currency=this.getCurrency();return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'checkout'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_UI_Modal_ModalSuccessPayment__["a" /* default */],{descriptionSuccess:Object(__WEBPACK_IMPORTED_MODULE_6_utils_orderConfirmation__["a" /* orderPlacedMessage */])(JSON.parse(localStorage.getItem('PayInfo')).cart.publicOrderNumber),isInvoice:JSON.parse(localStorage.getItem('PayInfo')).cart.isInvoice,showModal:this.state.returnStripeSucess?this.state.returnStripeSucess:this.props.showModalPlaceOrder,closeModal:function closeModal(){return _this2.props.closeModalPlaceOrderAndRedirect(_this2.props.history);},openReceipt:function openReceipt(){return _this2.props.openModalReceipt();}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_UI_Modal_ModalReceipt__["a" /* default */],{showModal:this.props.showModalReceipt,closeModal:function closeModal(){return _this2.props.closeModalReceiptAndRedirect(_this2.props.history);},data:JSON.parse(localStorage.getItem('PayInfo'))}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_UI_Modal_ModalError__["a" /* default */],{style:{zIndex:'99999',position:'absolute',margin:'5% 26%'},showModal:this.state.returnStripeFail?this.state.returnStripeFail:this.props.showModalError,closeModal:function closeModal(){return _this2.props.closeModalError(_this2.props.history);},errorMessage:!this.state.returnStripeFail&&this.props.messageError||PAYMENT_NOT_COMPLETED_ERROR,actionButton:this.tryPaymentAgain,actionButtonTitle:'Try again'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cart-page'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,'Payment'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(HeaderCheckout,{isInvoice:this.getIsInvoice(),isForCollection:this.isForCollection()}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'items'},this.getProducts().map(this.renderProductsOnCart)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'total-items'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(RenderValueLines,{name:'Sub Total',currency:currency,value:this.getSubTotal()}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(RenderValueLines,{name:'Subsidy',currency:currency,value:this.props.cart.subsidy}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(RenderValueLines,{name:'Tip',currency:currency,value:this.getTipValue()}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(RenderValueLines,{name:'Tax Delivery',currency:currency,value:this.getTaxDelivery()}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(RenderDiscount,{name:'Collection Discount',forCollection:this.isForCollection(),currency:currency,value:this.getCollectionDiscount()}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(RenderValueLines,{name:'Surcharge',currency:currency,value:this.getSurcharge()}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(RenderValueLines,{className:'total',name:'Total',currency:currency,value:this.getAmount()})),this.renderHideInputsStripeForm()));}}]);return Checkout;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{cart:state.cartReducer.cart,invoice:state.invoiceReducer.invoice,realexData:state.checkoutReducer.realex,stripeData:state.checkoutReducer.stripe,showModalReceipt:state.checkoutReducer.showModalReceipt,showModalError:state.checkoutReducer.showModalError,showModalPlaceOrder:state.checkoutReducer.showModalPlaceOrder,messageSuccess:state.checkoutReducer.messageSuccess,userDetails:state.authenticationReducer.userDetails,teamVoucherOrder:state.teamVoucherReducer.order,teamVoucherPayInfo:state.teamVoucherReducer.payInfo,teamVoucherCampaignRateCC:state.teamVoucherReducer.campaignRateCC,messageError:state.checkoutReducer.messageError,addresses:state.menuReducer.addresses};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{getRealexConfig:function getRealexConfig(realexConfigRequestDTO){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_7_actions_Checkout__["e" /* getRealexConfig */])(realexConfigRequestDTO));},getStripeConfig:function getStripeConfig(stripeConfigRequestDTO){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_7_actions_Checkout__["f" /* getStripeConfig */])(stripeConfigRequestDTO));},loopCheckingPaymentResponse:function loopCheckingPaymentResponse(idOrder){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_7_actions_Checkout__["g" /* loopCheckingPaymentResponse */])(idOrder));},checkoutResetState:function checkoutResetState(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_7_actions_Checkout__["a" /* checkoutResetState */])());},openModalError:function openModalError(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_7_actions_Checkout__["h" /* openModalError */])());},openModalReceipt:function openModalReceipt(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_7_actions_Checkout__["i" /* openModalReceipt */])());},closeModalError:function closeModalError(history){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_7_actions_Checkout__["b" /* closeModalError */])(history));},closeModalPlaceOrderAndRedirect:function closeModalPlaceOrderAndRedirect(history){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_7_actions_Checkout__["c" /* closeModalPlaceOrderAndRedirect */])(history));},closeModalReceiptAndRedirect:function closeModalReceiptAndRedirect(history){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_7_actions_Checkout__["d" /* closeModalReceiptAndRedirect */])(history));},resizeRealexForm:function resizeRealexForm(size){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_7_actions_Checkout__["j" /* resizeRealexForm */])(size));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["g" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(Checkout)));

/***/ }),
/* 794 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var isValid=function isValid(content){if(typeof content==='string'&&/^[\],:{}\s]*$/.test(content.replace(/\\["\\bfnrtu]/g,'@').replace(/"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+-]?\d+)?/g,']').replace(/(?:^|:|,)(?:\s*\[)+/g,''))){return true;}else{return false;}};/* harmony default export */ __webpack_exports__["a"] = ({isValid:isValid});

/***/ }),
/* 795 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return checkoutResetState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return resizeRealexForm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return openModalReceipt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return closeModalReceiptAndRedirect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return closeModalError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return openModalError; });
/* unused harmony export closeModalErrorAndRedirect */
/* unused harmony export openModalPlaceOrder */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return closeModalPlaceOrderAndRedirect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getRealexConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getStripeConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return loopCheckingPaymentResponse; });
/* unused harmony export successPayOrder */
/* unused harmony export consumeVoucher */
/* unused harmony export triggerModalErrorPlacedOrder */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actionTypes__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services_paymentService__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_services_orderService__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_services_voucherService__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__TeamVoucher__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_utils_checkoutError__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_utils_userError__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_utils_orderConfirmation__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_utils_vouchers__ = __webpack_require__(281);
var isSuccessOrder=function isSuccessOrder(orderStatus){return'T'===orderStatus;};var isFailureOrder=function isFailureOrder(orderStatus){return'F'===orderStatus;};var realexConfigDataLoaded=function realexConfigDataLoaded(payload){return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["_18" /* REALEX_CONFIG_DATA_LOADED */],payload:payload};};var stripeConfigDataLoaded=function stripeConfigDataLoaded(payload){return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["_45" /* STRIPE_CONFIG_DATA_LOADED */],payload:payload};};var cartResetState=function cartResetState(){return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["h" /* CART_RESET_STATE */]};};var menuResetState=function menuResetState(){return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["_10" /* MENU_RESET_STATE */]};};var invoiceResetState=function invoiceResetState(){return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["_3" /* INVOICE_RESET_STATE */]};};var checkoutSetIntervalReference=function checkoutSetIntervalReference(intervalReference){return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["w" /* CHECKOUT_SET_INTERVAL_REFERENCE */],payload:intervalReference};};var checkoutResetState=function checkoutResetState(){return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["u" /* CHECKOUT_RESET_STATE */]};};var resizeRealexForm=function resizeRealexForm(size){return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["v" /* CHECKOUT_RESIZE_REALEX_FORM */],payload:size};};var openModalReceipt=function openModalReceipt(){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__TeamVoucher__["c" /* closeModalPlacedOrder */])());dispatch({type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["t" /* CHECKOUT_REALEX_TOGGLE_SHOW_MODAL_RECEIPT */],payload:true});};};var closeModalReceiptAndRedirect=function closeModalReceiptAndRedirect(history){return function(dispatch){dispatch(checkoutResetState());dispatch(cartResetState());dispatch(menuResetState());history.replace('/Menu');};};var closeModalError=function closeModalError(){return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["r" /* CHECKOUT_REALEX_TOGGLE_SHOW_MODAL_ERROR */],payload:{show:false,messageError:''}};};var openModalError=function openModalError(messageError){return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["r" /* CHECKOUT_REALEX_TOGGLE_SHOW_MODAL_ERROR */],payload:{show:true,messageError:messageError}};};var closeModalErrorAndRedirect=function closeModalErrorAndRedirect(history){return function(dispatch){dispatch(checkoutResetState());dispatch(cartResetState());dispatch(menuResetState());dispatch(invoiceResetState());history.replace('/Menu');};};var openModalPlaceOrder=function openModalPlaceOrder(message){return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["s" /* CHECKOUT_REALEX_TOGGLE_SHOW_MODAL_PLACE_ORDER */],payload:{show:true,messageSuccess:message}};};var closeModalPlaceOrderAndRedirect=function closeModalPlaceOrderAndRedirect(history){return function(dispatch){dispatch(checkoutResetState());dispatch(cartResetState());dispatch(invoiceResetState());dispatch(menuResetState());history.replace('/Menu');};};var getRealexConfig=function getRealexConfig(realexConfigRequestDTO){return function(dispatch){__WEBPACK_IMPORTED_MODULE_1_services_paymentService__["a" /* default */].getRealexConfig(realexConfigRequestDTO).then(function(payload){dispatch(realexConfigDataLoaded(payload));}).catch(function(err){console.log(err);});};};var getStripeConfig=function getStripeConfig(stripeConfigRequestDTO){return function(dispatch){__WEBPACK_IMPORTED_MODULE_1_services_paymentService__["a" /* default */].getStripeConfig(stripeConfigRequestDTO).then(function(payload){dispatch(stripeConfigDataLoaded(payload));}).catch(function(err){console.log(err);});};};var loopCheckingPaymentResponse=function loopCheckingPaymentResponse(payload){return function(dispatch){if(payload.isInvoice){dispatch(checkInvoice(payload));}else{dispatch(checkOrder(payload));}};};var checkOrder=function checkOrder(payload){return function(dispatch){var attempts=0;var intervalReference=setInterval(function(){__WEBPACK_IMPORTED_MODULE_2_services_orderService__["a" /* default */].getOrderStatus(payload.idOrder).then(function(_payload){if(isSuccessOrder(_payload.orderStatus)){clearInterval(intervalReference);dispatch(consumeVoucher(payload.payInfo));dispatch(openModalPlaceOrder(Object(__WEBPACK_IMPORTED_MODULE_7_utils_orderConfirmation__["a" /* orderPlacedMessage */])(payload.payInfo&&payload.payInfo.publicOrderNumber)));dispatch(checkoutSetIntervalReference(undefined));}else if(isFailureOrder(_payload.orderStatus)&&attempts>4){clearInterval(intervalReference);dispatch(openModalError(Object(__WEBPACK_IMPORTED_MODULE_6_utils_userError__["e" /* knownError */])(__WEBPACK_IMPORTED_MODULE_6_utils_userError__["a" /* ERROR_CODES */].PAYMENT_DECLINED,{title:"Your payment didn't go through",message:'The order was not paid, so it is not confirmed.',guidance:'Try again, or choose another payment method.'})));dispatch(checkoutSetIntervalReference(undefined));}attempts++;}).catch(function(err){console.log(err);});},1500);dispatch(checkoutSetIntervalReference(intervalReference));};};var successPayOrder=function successPayOrder(payload){return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["_48" /* SUCCESS_PLACE_ORDER */],payload:{idOrder:payload.idOrder,isInvoice:false,descriptionSuccess:Object(__WEBPACK_IMPORTED_MODULE_7_utils_orderConfirmation__["a" /* orderPlacedMessage */])(payload.publicOrderNumber)}};};var consumeVoucher=function consumeVoucher(payload){return function(dispatch){var vouchers=Object(__WEBPACK_IMPORTED_MODULE_8_utils_vouchers__["a" /* normalizeVoucherDiscounts */])(payload&&payload.discounts);if(vouchers.length===0){return Promise.resolve();}var confirmVoucher=payload.payType==='A';var voucher={idOrder:payload.idOrder,totalOrder:payload.total,confirmVoucher:confirmVoucher,vouchers:vouchers};return __WEBPACK_IMPORTED_MODULE_3_services_voucherService__["a" /* default */].consume(voucher).catch(function(err){dispatch(triggerModalErrorPlacedOrder(err,{outcome:__WEBPACK_IMPORTED_MODULE_5_utils_checkoutError__["a" /* CHECKOUT_OUTCOME */].CONFIRMED,orderNumber:payload.publicOrderNumber,postOrderFailure:true}));});};};var triggerModalErrorPlacedOrder=function triggerModalErrorPlacedOrder(error,context){return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["_71" /* TRIGGER_MODAL_ERROR_PLACED_ORDER */],checkoutError:Object(__WEBPACK_IMPORTED_MODULE_5_utils_checkoutError__["b" /* mapCheckoutError */])(error,context)};};var checkInvoice=function checkInvoice(payload){return function(dispatch){if(payload.messageRealex.startsWith("Error: 501")){dispatch(openModalError(Object(__WEBPACK_IMPORTED_MODULE_6_utils_userError__["e" /* knownError */])(__WEBPACK_IMPORTED_MODULE_6_utils_userError__["a" /* ERROR_CODES */].PAYMENT_ALREADY_PROCESSED,{title:'This invoice has already been paid',message:'The payment for invoice '+payload.idOrder+' was processed earlier.',guidance:"If you think this is wrong, contact support with the reference below. Don't pay again."})));}else{var attempts=0;var intervalReference=setInterval(function(){__WEBPACK_IMPORTED_MODULE_2_services_orderService__["a" /* default */].getInvoiceStatus(payload.idOrder).then(function(data){if(data.invoiceStatus==="R"){clearInterval(intervalReference);dispatch(openModalPlaceOrder('Thank You - Your payment has been accepted. Invoice Confirmed! Invoice Number: '+payload.idOrder));dispatch(checkoutSetIntervalReference(undefined));}else if((data.invoiceStatus==='F'||data.invoiceStatus==='0')&&attempts>4){clearInterval(intervalReference);dispatch(openModalError(Object(__WEBPACK_IMPORTED_MODULE_6_utils_userError__["e" /* knownError */])(__WEBPACK_IMPORTED_MODULE_6_utils_userError__["a" /* ERROR_CODES */].PAYMENT_DECLINED,{title:"Your invoice payment didn't go through",message:'The invoice was not paid.',guidance:'Try again, or choose another payment method.'})));dispatch(checkoutSetIntervalReference(undefined));}attempts++;}).catch(function(err){console.log(err);});},1500);dispatch(checkoutSetIntervalReference(intervalReference));}};};

/***/ }),
/* 796 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stripeCard__ = __webpack_require__(797);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__stripeIdeal__ = __webpack_require__(798);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__stripeBancontact__ = __webpack_require__(799);
var Stripe=function Stripe(props){var render=function render(){if(!!props.props.stripeData.clientSecretIdeal){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__stripeIdeal__["a" /* default */],{clientSecretIdeal:props.props.stripeData.clientSecretIdeal});}if(!!props.props.stripeData.clientSecretBancontact){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__stripeBancontact__["a" /* default */],{clientSecretBancontact:props.props.stripeData.clientSecretBancontact});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__stripeCard__["a" /* default */],{clientSecretSaveCard:props.props.stripeData.clientSecretSaveCard,clientSecretNotSaveCard:props.props.stripeData.clientSecretNotSaveCard,formReference:props.formReference});};return render();};/* harmony default export */ __webpack_exports__["a"] = (Stripe);

/***/ }),
/* 797 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__stripe_react_stripe_js__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__stripe_react_stripe_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__stripe_react_stripe_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_UI_Modal_ModalError__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_utils_stripeError__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__stripeCard_css__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__stripeCard_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__stripeCard_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_UI_Spinner_Spinner__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__store_actions__ = __webpack_require__(13);
var _this=this;var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}var PaymentIntentComponent=function PaymentIntentComponent(props){var _useState=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(false),_useState2=_slicedToArray(_useState,2),succeeded=_useState2[0],setSucceeded=_useState2[1];var _useState3=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(null),_useState4=_slicedToArray(_useState3,2),error=_useState4[0],setError=_useState4[1];var _useState5=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(false),_useState6=_slicedToArray(_useState5,2),isOpenModal=_useState6[0],setIsOpenModal=_useState6[1];var _useState7=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(''),_useState8=_slicedToArray(_useState7,2),processing=_useState8[0],setProcessing=_useState8[1];var _useState9=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(true),_useState10=_slicedToArray(_useState9,2),disabled=_useState10[0],setDisabled=_useState10[1];var _useState11=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(false),_useState12=_slicedToArray(_useState11,2),saveCard=_useState12[0],setSaveCard=_useState12[1];var stripe=Object(__WEBPACK_IMPORTED_MODULE_4__stripe_react_stripe_js__["useStripe"])();var elements=Object(__WEBPACK_IMPORTED_MODULE_4__stripe_react_stripe_js__["useElements"])();var clientSecretSaveCard=props.clientSecretSaveCard;var clientSecretNotSaveCard=props.clientSecretNotSaveCard;var dispatch=Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["useDispatch"])();var cardNumberStyle={placeholder:"Card Number"};var experyCardStyle={placeholder:"MM/YY"};var securityCardStyle={placeholder:"Security Code"};var handleChange=function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(event){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:setDisabled(event.empty);setError(event.error?Object(__WEBPACK_IMPORTED_MODULE_6_utils_stripeError__["b" /* stripePaymentError */])(event.error):null);case 2:case'end':return _context.stop();}}},_callee,_this);}));return function handleChange(_x){return _ref.apply(this,arguments);};}();var onChangeSaveCard=function onChangeSaveCard(){setSaveCard(!saveCard);};var closeModalError=function closeModalError(){setIsOpenModal(false);};var handleSubmitStripe=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(event){var clientSecret,payload;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:event.preventDefault();dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__store_actions__["_30" /* startRequest */])());setProcessing(true);clientSecret=saveCard?clientSecretSaveCard:clientSecretNotSaveCard;_context2.next=6;return stripe.confirmCardPayment(clientSecret,{payment_method:{card:elements.getElement(__WEBPACK_IMPORTED_MODULE_4__stripe_react_stripe_js__["CardCvcElement"])}});case 6:payload=_context2.sent;if(payload.error){console.log("error stripe",payload.error.message);setError(Object(__WEBPACK_IMPORTED_MODULE_6_utils_stripeError__["b" /* stripePaymentError */])(payload.error));setProcessing(false);dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__store_actions__["_1" /* finishRequest */])());setIsOpenModal(true);}else{console.log("Stripe status",payload.status);setError(null);setProcessing(false);setSucceeded(true);}case 8:case'end':return _context2.stop();}}},_callee2,_this);}));return function handleSubmitStripe(_x2){return _ref2.apply(this,arguments);};}();return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('form',{className:'payment-form',onSubmit:handleSubmitStripe,ref:props.formReference},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{className:'payment-details'},'Payment Details'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'stripe-card'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',null,'Card Number'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__stripe_react_stripe_js__["CardNumberElement"],{id:'card-element',options:cardNumberStyle,onChange:handleChange}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',null,'Expiry'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__stripe_react_stripe_js__["CardExpiryElement"],{id:'card-element',options:experyCardStyle,onChange:handleChange}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',null,'Security Code'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__stripe_react_stripe_js__["CardCvcElement"],{id:'card-element',options:securityCardStyle,onChange:handleChange}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'stripe-save-card'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'checkbox',className:'checkStripe',value:saveCard,onChange:onChangeSaveCard}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{className:'labelStripe'},'Save Card Details')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{className:'stripe-label-save-card'},'These card details can be stored so that subsequent transaction do not require you card details. To avail of this service please tick the checkbox.'),props.isLoading?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_UI_Spinner_Spinner__["a" /* default */],{nameClass:"lds-secondary"}):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'buttonStripe',disabled:processing||disabled||succeeded,id:'submit',type:'submit'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{id:'button-text'},'PAY NOW')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_UI_Modal_ModalError__["a" /* default */],{style:{zIndex:"99999",position:"absolute",margin:"5% 26%"},showModal:isOpenModal,closeModal:closeModalError,errorMessage:error})));};var mapStateToProps=function mapStateToProps(state){return{isLoading:state.loadingReducer.loading};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["g" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(mapStateToProps)(PaymentIntentComponent)));

/***/ }),
/* 798 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__stripe_react_stripe_js__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__stripe_react_stripe_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__stripe_react_stripe_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_UI_Modal_ModalError__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_utils_stripeError__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__stripeCard_css__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__stripeCard_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__stripeCard_css__);
var _this=this;var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}var PaymentIntentIdeal=function PaymentIntentIdeal(props){var _useState=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(false),_useState2=_slicedToArray(_useState,2),succeeded=_useState2[0],setSucceeded=_useState2[1];var _useState3=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(null),_useState4=_slicedToArray(_useState3,2),error=_useState4[0],setError=_useState4[1];var _useState5=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(false),_useState6=_slicedToArray(_useState5,2),isOpenModal=_useState6[0],setIsOpenModal=_useState6[1];var _useState7=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(''),_useState8=_slicedToArray(_useState7,2),processing=_useState8[0],setProcessing=_useState8[1];var _useState9=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(true),_useState10=_slicedToArray(_useState9,2),disabled=_useState10[0],setDisabled=_useState10[1];var _useState11=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(''),_useState12=_slicedToArray(_useState11,2),name=_useState12[0],setName=_useState12[1];var stripe=Object(__WEBPACK_IMPORTED_MODULE_2__stripe_react_stripe_js__["useStripe"])();var elements=Object(__WEBPACK_IMPORTED_MODULE_2__stripe_react_stripe_js__["useElements"])();var clientSecretIdeal=props.clientSecretIdeal;var closeModalError=function closeModalError(){setIsOpenModal(false);};var onChangeName=function onChangeName(event){setDisabled(event.target.value.length<1?true:false);if(event.target.value.length>=99){setError(Object(__WEBPACK_IMPORTED_MODULE_4_utils_stripeError__["a" /* paymentDetailsError */])('Use a shorter name','Enter the account holder name in fewer than 100 characters.'));document.getElementById("card-element").focus();setIsOpenModal(true);return;}setName(event.target.value);};var handleChange=function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(event){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:setDisabled(event.empty||name.length<1?true:false);setError(event.error?Object(__WEBPACK_IMPORTED_MODULE_4_utils_stripeError__["b" /* stripePaymentError */])(event.error):null);case 2:case"end":return _context.stop();}}},_callee,_this);}));return function handleChange(_x){return _ref.apply(this,arguments);};}();var handleSubmitStripe=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(event){var clientSecret,payload;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:event.preventDefault();if(!(document.getElementById("card-element").value.length<1)){_context2.next=6;break;}setError(Object(__WEBPACK_IMPORTED_MODULE_4_utils_stripeError__["a" /* paymentDetailsError */])('Enter the account holder name','Type the name on the bank account, then pay.'));document.getElementById("card-element").focus();setIsOpenModal(true);return _context2.abrupt("return");case 6:setProcessing(true);clientSecret=clientSecretIdeal;_context2.next=10;return stripe.confirmIdealPayment(clientSecret,{payment_method:{ideal:elements.getElement(__WEBPACK_IMPORTED_MODULE_2__stripe_react_stripe_js__["IdealBankElement"]),billing_details:{name:name}},return_url:window.location.origin+"/Menu/checkout"});case 10:payload=_context2.sent;if(payload.error){console.log("error stripe",payload.error.message);setError(Object(__WEBPACK_IMPORTED_MODULE_4_utils_stripeError__["b" /* stripePaymentError */])(payload.error));setProcessing(false);setIsOpenModal(true);}else{console.log("Stripe status",payload.status);setError(null);setProcessing(false);setSucceeded(true);}case 12:case"end":return _context2.stop();}}},_callee2,_this);}));return function handleSubmitStripe(_x2){return _ref2.apply(this,arguments);};}();return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("form",{className:"payment-form",onSubmit:handleSubmitStripe,ref:props.formReference},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("label",{className:"payment-details"},"Payment Ideal Details"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"stripe-card"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("label",null,"Name"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{type:"text",id:"card-element",value:name,onChange:onChangeName,maxlength:"99"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("label",{className:"idealBankElement",htmlFor:"ideal-bank-element"},"Bank"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__stripe_react_stripe_js__["IdealBankElement"],{id:"card-element",onChange:handleChange}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button",{className:"buttonStripe",disabled:processing||disabled||succeeded,id:"submit",type:"submit"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{id:"button-text"},processing?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"spinner",id:"spinner"}):"PAY NOW")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_UI_Modal_ModalError__["a" /* default */],{style:{zIndex:"99999",position:"absolute",margin:"5% 26%"},showModal:isOpenModal,closeModal:closeModalError,errorMessage:error})));};/* harmony default export */ __webpack_exports__["a"] = (PaymentIntentIdeal);

/***/ }),
/* 799 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__stripe_react_stripe_js__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__stripe_react_stripe_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__stripe_react_stripe_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_UI_Modal_ModalError__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_utils_stripeError__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__stripeCard_css__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__stripeCard_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__stripeCard_css__);
var _this=this;var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}var PaymentIntentBancontact=function PaymentIntentBancontact(props){var _useState=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(false),_useState2=_slicedToArray(_useState,2),succeeded=_useState2[0],setSucceeded=_useState2[1];var _useState3=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(null),_useState4=_slicedToArray(_useState3,2),error=_useState4[0],setError=_useState4[1];var _useState5=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(false),_useState6=_slicedToArray(_useState5,2),isOpenModal=_useState6[0],setIsOpenModal=_useState6[1];var _useState7=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(''),_useState8=_slicedToArray(_useState7,2),processing=_useState8[0],setProcessing=_useState8[1];var _useState9=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(true),_useState10=_slicedToArray(_useState9,2),disabled=_useState10[0],setDisabled=_useState10[1];var _useState11=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(''),_useState12=_slicedToArray(_useState11,2),name=_useState12[0],setName=_useState12[1];var stripe=Object(__WEBPACK_IMPORTED_MODULE_2__stripe_react_stripe_js__["useStripe"])();var clientSecretBancontact=props.clientSecretBancontact;var closeModalError=function closeModalError(){setIsOpenModal(false);};var onChangeName=function onChangeName(event){setDisabled(event.target.value.length<1?true:false);if(event.target.value.length>=99){setError(Object(__WEBPACK_IMPORTED_MODULE_4_utils_stripeError__["a" /* paymentDetailsError */])('Use a shorter name','Enter the account holder name in fewer than 100 characters.'));document.getElementById("card-element").focus();setIsOpenModal(true);return;}setName(event.target.value);setError(event.error?Object(__WEBPACK_IMPORTED_MODULE_4_utils_stripeError__["b" /* stripePaymentError */])(event.error):null);};var handleSubmitStripe=function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(event){var clientSecret,payload;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:event.preventDefault();if(!(document.getElementById("card-element").value.length<1)){_context.next=6;break;}setError(Object(__WEBPACK_IMPORTED_MODULE_4_utils_stripeError__["a" /* paymentDetailsError */])('Enter the account holder name','Type the name on the bank account, then pay.'));document.getElementById("card-element").focus();setIsOpenModal(true);return _context.abrupt("return");case 6:setProcessing(true);clientSecret=clientSecretBancontact;_context.next=10;return stripe.confirmBancontactPayment(clientSecret,{payment_method:{billing_details:{name:name}},return_url:window.location.origin+"/Menu/checkout"});case 10:payload=_context.sent;if(payload.error){console.log("error stripe",payload.error.message);setError(Object(__WEBPACK_IMPORTED_MODULE_4_utils_stripeError__["b" /* stripePaymentError */])(payload.error));setProcessing(false);setIsOpenModal(true);}else{console.log("Stripe status",payload.status);setError(null);setProcessing(false);setSucceeded(true);}case 12:case"end":return _context.stop();}}},_callee,_this);}));return function handleSubmitStripe(_x){return _ref.apply(this,arguments);};}();return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("form",{className:"payment-form",onSubmit:handleSubmitStripe,ref:props.formReference},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("label",{className:"payment-details"},"Payment Bancontact Details"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"stripe-card"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("label",null,"Name"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{type:"text",id:"card-element",value:name,onChange:onChangeName,maxlength:"99"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button",{className:"buttonStripe",disabled:processing||disabled||succeeded,id:"submit",type:"submit"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{id:"button-text"},processing?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"spinner",id:"spinner"}):"PAY NOW")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_UI_Modal_ModalError__["a" /* default */],{style:{zIndex:"99999",position:"absolute",margin:"5% 26%"},showModal:isOpenModal,closeModal:closeModalError,errorMessage:error})));};/* harmony default export */ __webpack_exports__["a"] = (PaymentIntentBancontact);

/***/ }),
/* 800 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return loadStripe; });
var V3_URL = 'https://js.stripe.com/v3';
var V3_URL_REGEX = /^https:\/\/js\.stripe\.com\/v3\/?(\?.*)?$/;
var EXISTING_SCRIPT_MESSAGE = 'loadStripe.setLoadParameters was called but an existing Stripe.js script already exists in the document; existing script parameters will be used';
var findScript = function findScript() {
  var scripts = document.querySelectorAll("script[src^=\"".concat(V3_URL, "\"]"));

  for (var i = 0; i < scripts.length; i++) {
    var script = scripts[i];

    if (!V3_URL_REGEX.test(script.src)) {
      continue;
    }

    return script;
  }

  return null;
};

var injectScript = function injectScript(params) {
  var queryString = params && !params.advancedFraudSignals ? '?advancedFraudSignals=false' : '';
  var script = document.createElement('script');
  script.src = "".concat(V3_URL).concat(queryString);
  var headOrBody = document.head || document.body;

  if (!headOrBody) {
    throw new Error('Expected document.body not to be null. Stripe.js requires a <body> element.');
  }

  headOrBody.appendChild(script);
  return script;
};

var registerWrapper = function registerWrapper(stripe, startTime) {
  if (!stripe || !stripe._registerWrapper) {
    return;
  }

  stripe._registerWrapper({
    name: 'stripe-js',
    version: "1.19.1",
    startTime: startTime
  });
};

var stripePromise = null;
var loadScript = function loadScript(params) {
  // Ensure that we only attempt to load Stripe.js at most once
  if (stripePromise !== null) {
    return stripePromise;
  }

  stripePromise = new Promise(function (resolve, reject) {
    if (typeof window === 'undefined') {
      // Resolve to null when imported server side. This makes the module
      // safe to import in an isomorphic code base.
      resolve(null);
      return;
    }

    if (window.Stripe && params) {
      console.warn(EXISTING_SCRIPT_MESSAGE);
    }

    if (window.Stripe) {
      resolve(window.Stripe);
      return;
    }

    try {
      var script = findScript();

      if (script && params) {
        console.warn(EXISTING_SCRIPT_MESSAGE);
      } else if (!script) {
        script = injectScript(params);
      }

      script.addEventListener('load', function () {
        if (window.Stripe) {
          resolve(window.Stripe);
        } else {
          reject(new Error('Stripe.js not available'));
        }
      });
      script.addEventListener('error', function () {
        reject(new Error('Failed to load Stripe.js'));
      });
    } catch (error) {
      reject(error);
      return;
    }
  });
  return stripePromise;
};
var initStripe = function initStripe(maybeStripe, args, startTime) {
  if (maybeStripe === null) {
    return null;
  }

  var stripe = maybeStripe.apply(undefined, args);
  registerWrapper(stripe, startTime);
  return stripe;
};

// own script injection.

var stripePromise$1 = Promise.resolve().then(function () {
  return loadScript(null);
});
var loadCalled = false;
stripePromise$1["catch"](function (err) {
  if (!loadCalled) {
    console.warn(err);
  }
});
var loadStripe = function loadStripe() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  loadCalled = true;
  var startTime = Date.now();
  return stripePromise$1.then(function (maybeStripe) {
    return initStripe(maybeStripe, args, startTime);
  });
};




/***/ }),
/* 801 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(802);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(17)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../lunch-team-client-checkout-msg/node_modules/css-loader/index.js!../../../../../../lunch-team-client-checkout-msg/node_modules/sass-loader/dist/cjs.js!./checkout.scss", function() {
			var newContent = require("!!../../../../../../lunch-team-client-checkout-msg/node_modules/css-loader/index.js!../../../../../../lunch-team-client-checkout-msg/node_modules/sass-loader/dist/cjs.js!./checkout.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 802 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(14)(undefined);
// imports


// module
exports.push([module.i, ".checkout .realexIFrame{border-width:0px;width:100%;margin-top:10px}.checkout .wrapIframeRealex-ios{position:fixed;width:100%;height:100%;top:0px;left:0px;transition:all .3s ease-in-out 0s;z-index:1000;background:rgba(0,0,0,.7);overflow:auto;-webkit-overflow-scrolling:touch}.checkout .realexIFrame-ios{z-index:10001;position:absolute;transition:transform .5s ease-in-out 0s;transform:scale(1);opacity:1;top:0px;left:0px;width:100% !important;margin-left:0px;background-color:#fff;-webkit-overflow-scrolling:touch}.checkout .flex-justify-space-between{justify-content:space-between}.checkout .total p{font-weight:bold}", ""]);

// exports


/***/ }),
/* 803 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TeamVoucherComponent__ = __webpack_require__(804);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__VoucherBalance__ = __webpack_require__(831);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_actions_index__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__voucher_scss__ = __webpack_require__(835);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__voucher_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__voucher_scss__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var TeamVoucher=function(_Component){_inherits(TeamVoucher,_Component);function TeamVoucher(){_classCallCheck(this,TeamVoucher);return _possibleConstructorReturn(this,(TeamVoucher.__proto__||Object.getPrototypeOf(TeamVoucher)).apply(this,arguments));}_createClass(TeamVoucher,[{key:'componentDidMount',value:function componentDidMount(){this.props.onChangeTitleHeader('Vouchers');}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'main-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-items team-voucher'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'header-list-team-voucher'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* NavLink */],{activeClassName:'active',to:'/Menu/teamvoucher',exact:true},'Team Voucher')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* NavLink */],{activeClassName:'active',to:'/Menu/teamvoucher/companyvoucher'},'Voucher Balance'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["f" /* Switch */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{path:'/Menu/teamvoucher',exact:true,render:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__TeamVoucherComponent__["a" /* default */],null);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{path:'/Menu/teamvoucher/companyvoucher',render:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__VoucherBalance__["a" /* default */],null);},exact:true})))));}}]);return TeamVoucher;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onChangeTitleHeader:function onChangeTitleHeader(titleHeader){return dispatch(__WEBPACK_IMPORTED_MODULE_5_actions_index__["l" /* changeMenuTitleHeader */](titleHeader));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(null,mapDispatchToProps)(TeamVoucher));

/***/ }),
/* 804 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_hooks_usePrevious__ = __webpack_require__(805);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_utils_currency__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_utils_orderConfirmation__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_UI_TaggedInputText__ = __webpack_require__(806);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_UI_TextInput__ = __webpack_require__(822);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_UI_Tooltip__ = __webpack_require__(826);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_UI_Spinner_Spinner__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_containers_Menu_Cart_PaymentOptions__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_containers_Menu_Cart_PaymentButton__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_services_loginService__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_components_UI_Modal_ModalSuccessPayment__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_components_UI_Modal_ModalError__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_UI_Modal_ModalReceiptVoucher__ = __webpack_require__(829);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_components_UI_Modal_ModalValidateEmails__ = __webpack_require__(830);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_actions_TaggedInputText__ = __webpack_require__(321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_actions_SignUp__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_actions_TeamVoucher__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_actions_index__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_utils_userError__ = __webpack_require__(15);
var _this=this;var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}var TEAM_VOUCHER_ORDER_UNKNOWN=Object(__WEBPACK_IMPORTED_MODULE_22_utils_userError__["b" /* errorCopy */])(__WEBPACK_IMPORTED_MODULE_22_utils_userError__["a" /* ERROR_CODES */].ORDER_UNKNOWN_STATE,{title:"We couldn't confirm your voucher order",guidance:'Check My Orders before trying again, or contact support with the reference below.'});var TeamVoucherComponent=function TeamVoucherComponent(_ref){var cards=_ref.cards,order=_ref.order,campaignRateCC=_ref.campaignRateCC,isLoading=_ref.isLoading,teamVoucherList=_ref.teamVoucherList,onOpenModalConfirmEmails=_ref.onOpenModalConfirmEmails,onFetchingCards=_ref.onFetchingCards,cartResetState=_ref.cartResetState,listAddress=_ref.listAddress,onTeamVoucherSetOrder=_ref.onTeamVoucherSetOrder,onPlaceOrderAndPay=_ref.onPlaceOrderAndPay,handlePlaceOrderAndGoToAddNewCard=_ref.handlePlaceOrderAndGoToAddNewCard,showModalPlaceOrder=_ref.showModalPlaceOrder,history=_ref.history,onCloseModalPlacedOrderAndRedirect=_ref.onCloseModalPlacedOrderAndRedirect,onOpenModalReceipt=_ref.onOpenModalReceipt,showModalReceipt=_ref.showModalReceipt,onCloseModalReceiptAndRedirect=_ref.onCloseModalReceiptAndRedirect,userDetails=_ref.userDetails,showModalError=_ref.showModalError,onCloseModalError=_ref.onCloseModalError,errorMessage=_ref.errorMessage,errorType=_ref.errorType,errorObject=_ref.errorObject,onInvalidTeamVoucherEmail=_ref.onInvalidTeamVoucherEmail,createNewUserByEmail=_ref.createNewUserByEmail,showModalConfirmEmails=_ref.showModalConfirmEmails,onCloseModalConfirmEmails=_ref.onCloseModalConfirmEmails,onVerifyUnregisteredEmails=_ref.onVerifyUnregisteredEmails,onFetchValidTeamVouchers=_ref.onFetchValidTeamVouchers,onFetchTeamVoucherCampaignRate=_ref.onFetchTeamVoucherCampaignRate;var _useState=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])([]),_useState2=_slicedToArray(_useState,2),vouchersEmail=_useState2[0],setVouchersEmail=_useState2[1];var _useState3=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(false),_useState4=_slicedToArray(_useState3,2),amountDisabled=_useState4[0],setAmountDisabled=_useState4[1];var _useState5=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(false),_useState6=_slicedToArray(_useState5,2),isButtonDisabled=_useState6[0],setIsButtonDisabled=_useState6[1];var _useState7=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(0),_useState8=_slicedToArray(_useState7,2),voucherUnitValue=_useState8[0],setVoucherUnitValue=_useState8[1];var _useState9=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(0),_useState10=_slicedToArray(_useState9,2),total=_useState10[0],setTotal=_useState10[1];var _useState11=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(null),_useState12=_slicedToArray(_useState11,2),payType=_useState12[0],setPayType=_useState12[1];var _useState13=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(null),_useState14=_slicedToArray(_useState13,2),cardSelected=_useState14[0],setCardSelected=_useState14[1];var _useState15=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])([]),_useState16=_slicedToArray(_useState15,2),filteredUnregisteredEmails=_useState16[0],setFilteredUnregisteredEmails=_useState16[1];var previousVouchersEmail=Object(__WEBPACK_IMPORTED_MODULE_4_hooks_usePrevious__["a" /* default */])(vouchersEmail);Object(__WEBPACK_IMPORTED_MODULE_1_react__["useEffect"])(function(){onFetchingCards();onFetchValidTeamVouchers();onFetchTeamVoucherCampaignRate();},[]);Object(__WEBPACK_IMPORTED_MODULE_1_react__["useEffect"])(function(){if(teamVoucherList.length!==vouchersEmail.length){setVouchersEmail(teamVoucherList);setTotal(voucherUnitValue*teamVoucherList.length);}},[teamVoucherList,vouchersEmail]);Object(__WEBPACK_IMPORTED_MODULE_1_react__["useEffect"])(function(){if(previousVouchersEmail<vouchersEmail){setAmountDisabled(false);}},[vouchersEmail,previousVouchersEmail]);var isPositiveNumber=function isPositiveNumber(value){return!!value&&!!isFinite(value)&&parseFloat(value)>=0;};var handleValidateEmails=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var emails,emailsToFilter,i,emailSet,uniqueEmails,unregisteredEmails;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:emails=vouchersEmail;emailsToFilter=emails.filter(function(email){return!email.created;});i=0;case 3:if(!(i<emailsToFilter.length)){_context.next=10;break;}_context.next=6;return checkUserRegistered(emailsToFilter[i]);case 6:emailsToFilter[i].registered=_context.sent;case 7:i++;_context.next=3;break;case 10:emailSet=[].concat(_toConsumableArray(new Set(emailsToFilter)));uniqueEmails=emailSet.filter(function(_ref3){var label=_ref3.label;return!this.has(label)&&this.add(label);},new Set());unregisteredEmails=uniqueEmails.filter(function(email){return email.registered===false;});setFilteredUnregisteredEmails(unregisteredEmails);if(unregisteredEmails.length!==0){onOpenModalConfirmEmails();}else{setAmountDisabled(true);}case 15:case'end':return _context.stop();}}},_callee,_this);}));return function handleValidateEmails(){return _ref2.apply(this,arguments);};}();var checkUserRegistered=function(){var _ref4=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(email){var response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.prev=0;_context2.next=3;return __WEBPACK_IMPORTED_MODULE_13_services_loginService__["a" /* default */].preLogin({email:email.value});case 3:response=_context2.sent;if(!(response.userAlreadyRegistered&&response.hasRelatedBusiness)){_context2.next=8;break;}return _context2.abrupt('return',true);case 8:return _context2.abrupt('return',false);case 9:_context2.next=14;break;case 11:_context2.prev=11;_context2.t0=_context2['catch'](0);console.log(_context2.t0.message);case 14:case'end':return _context2.stop();}}},_callee2,_this,[[0,11]]);}));return function checkUserRegistered(_x){return _ref4.apply(this,arguments);};}();var updateField=function updateField(_ref5){var target=_ref5.target;var newValue='';var newTotal=total;switch(target.type){case'number':newValue=isPositiveNumber(target.value)?parseFloat(target.value):1;newTotal=newValue*vouchersEmail.length;break;default:newValue=target.value;break;}setVoucherUnitValue(newValue);setTotal(newTotal);};var onHandleSelectPaymentMethod=function onHandleSelectPaymentMethod(id,type){switch(type){case"ideal":setPayType('I');setCardSelected(null);break;case"bancontact":setPayType('B');setCardSelected(null);break;case'onCreditCard':if(id==='payWithAnotherCard'){setPayType('C');setCardSelected(null);}else{var card=cards.find(function(item){return item.cardId===id;});setPayType('C');setCardSelected(card);}break;default:break;}};var getAddressForVoucher=function getAddressForVoucher(){var address=listAddress.find(function(address){return!!!address.forCollection;});return address.idBusinessAddress;};var buildingOrder=function buildingOrder(){var orderItems=vouchersEmail.map(function(emailOption){return{quantity:1,product:{name:emailOption.value,price:voucherUnitValue},total:voucherUnitValue};});return{totalAmount:total,payType:payType,orderItems:orderItems,businessDeliveryAddress:{id:getAddressForVoucher()}};};var getTotalOrderValuePlusCampaignRateValue=function getTotalOrderValuePlusCampaignRateValue(){return campaignRateCC.amount+total;};var getPaymentReference=function getPaymentReference(){return cardSelected?cardSelected.cardId:null;};var getPayInfo=function getPayInfo(){return{amount:getTotalOrderValuePlusCampaignRateValue(),currency:'EUR',paymentReference:getPaymentReference(),idBusinessRestaurant:getAddressForVoucher(),payObjectType:'O',payType:payType};};var onHandlePlaceOrder=function onHandlePlaceOrder(){setIsButtonDisabled(true);cartResetState();var order=buildingOrder();onTeamVoucherSetOrder(order);if(payType==='C'&&!!cardSelected){onPlaceOrderAndPay(order,getPayInfo());}else{handlePlaceOrderAndGoToAddNewCard(order,getPayInfo(),history);}};var getCartItensFromTeamVouchers=function getCartItensFromTeamVouchers(){if(!!order.orderItems){return{idOrder:order.idOrder,products:order.orderItems.map(function(item){return item.product;})};}return{};};var getSurcharge=function getSurcharge(){return campaignRateCC.amount;};var getReceiptData=function getReceiptData(){return{cart:getCartItensFromTeamVouchers(),total:getTotalOrderValuePlusCampaignRateValue(),currency:__WEBPACK_IMPORTED_MODULE_5_utils_currency__["a" /* default */].convertNameToSymbol('EUR'),surcharge:getSurcharge(),subtotal:total,userDetails:userDetails,forCollection:false};};var modalErrorClose=function modalErrorClose(){if(errorType==='invalid-team-voucher'){onInvalidTeamVoucherEmail(errorObject);}else if(errorType==='not-accepted-invalid-team-voucher'){onInvalidTeamVoucherEmail(errorObject);}else{setIsButtonDisabled(false);}onCloseModalError();};var modalErrorActionButton=function modalErrorActionButton(){if(errorType==='invalid-team-voucher'){createNewUserByEmail(errorObject);}else if(errorType==='not-accepted-invalid-team-voucher'){onInvalidTeamVoucherEmail(errorObject);}else{setIsButtonDisabled(false);}onCloseModalError();};var modalErrorActionButtonTitle=function modalErrorActionButtonTitle(){if(errorType==='invalid-team-voucher'){return'Create account';}else{return'Close';}};var createUnregisteredEmails=function createUnregisteredEmails(emails){var createdEmails=[];var emailsToCreate=emails.filter(function(email){return!email.created;});for(var i=0;i<emailsToCreate.length;i++){try{emailsToCreate[i].created=true;var email=createNewUserByEmail(emailsToCreate[i]);createdEmails.push(email);}catch(err){console.log(err.message);}}setAmountDisabled(true);setFilteredUnregisteredEmails(createdEmails);onCloseModalConfirmEmails();};var handleFilterUnregisterEmails=function handleFilterUnregisterEmails(mail){var filtered=filteredUnregisteredEmails.filter(function(email){return email.label!==mail.label;});onInvalidTeamVoucherEmail(mail);setFilteredUnregisteredEmails(filtered);setVouchersEmail(filtered);setAmountDisabled(true);};var tooltipText='Vouchers will be sent to the email addresses provided.'+'Email addresses do not need to be company emails.'+'Any voucher money not spent will be refunded to your card.';return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_UI_Modal_ModalSuccessPayment__["a" /* default */],{descriptionSuccess:Object(__WEBPACK_IMPORTED_MODULE_6_utils_orderConfirmation__["a" /* orderPlacedMessage */])(order.publicOrderNumber),isInvoice:false,showModal:showModalPlaceOrder,closeModal:function closeModal(){return onCloseModalPlacedOrderAndRedirect(history);},openReceipt:function openReceipt(){return onOpenModalReceipt();}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__components_UI_Modal_ModalReceiptVoucher__["a" /* default */],{showModal:showModalReceipt,closeModal:function closeModal(){return onCloseModalReceiptAndRedirect(history);},data:getReceiptData()}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_components_UI_Modal_ModalError__["a" /* default */],{style:{zIndex:'99999',position:'absolute',margin:'5% 26%'},styleContent:{background:'gainsboro'},showModal:showModalError,closeModal:function closeModal(){return modalErrorClose();},actionButton:function actionButton(){return modalErrorActionButton();},actionButtonTitle:modalErrorActionButtonTitle(),errorMessage:errorMessage||TEAM_VOUCHER_ORDER_UNKNOWN}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_components_UI_Modal_ModalValidateEmails__["a" /* default */],{style:{zIndex:'99999',position:'absolute',margin:'5% 26%'},styleContent:{background:'gainsboro'},showModal:showModalConfirmEmails,closeModal:function closeModal(){return onCloseModalConfirmEmails();},actionButton:function actionButton(){return createUnregisteredEmails(filteredUnregisteredEmails);},actionButtonTitle:'CREATE USERS',unregistered:filteredUnregisteredEmails,filterAction:handleFilterUnregisterEmails,validateAction:onVerifyUnregisteredEmails}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'order-voucher'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h4',{className:'fl'},'Order Vouchers'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_UI_Tooltip__["a" /* default */],{className:'fr',tooltipText:tooltipText,tooltipSpanText:'How it Works'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'clear flex-row clearfix'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'email fl'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',null,'Email(s)'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_UI_TaggedInputText__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{onClick:handleValidateEmails,className:'btn orange-bold',type:'button'},'Validate')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'voucher fr'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',null,'Amount of Voucher'),!amountDisabled?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,'Validate options first!'):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_UI_TextInput__["a" /* default */],{name:'voucherUnitValue',type:'number',step:'.01',placeholder:'',onChange:updateField,value:voucherUnitValue,className:'amount-voucher'}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'clear valor-final'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'quant-voucher fl'},vouchersEmail.length,' Vouchers x \u20AC',voucherUnitValue!==null&&voucherUnitValue.toFixed(2),' '),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'total fr'},' Total \u20AC',total,' '))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_containers_Menu_Cart_PaymentOptions__["a" /* default */],{disabled:isButtonDisabled,payTypeSelected:payType,cardSelected:cardSelected,selectPaymentMethod:onHandleSelectPaymentMethod,cards:cards}),isLoading?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_UI_Spinner_Spinner__["a" /* default */],{nameClass:"lds-secondary"}):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_containers_Menu_Cart_PaymentButton__["a" /* default */],{payTypeSelected:payType,handlePlaceOrder:onHandlePlaceOrder,containerClassName:'tools',buttonText:'Purchase Vouchers Now',campaignRateCC:campaignRateCC,disabled:isButtonDisabled||vouchersEmail.length<1||total<=0}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h5',{className:'note'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('strong',null,'Note: '),'Vouchers currently expire at 12pm the following morning.'));};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onOpenModalConfirmEmails:function onOpenModalConfirmEmails(){return dispatch(__WEBPACK_IMPORTED_MODULE_21_actions_index__["_8" /* openModalConfirmEmails */]());},onCloseModalConfirmEmails:function onCloseModalConfirmEmails(){return dispatch(__WEBPACK_IMPORTED_MODULE_21_actions_index__["t" /* closeModalConfirmEmails */]());},onFetchingCards:function onFetchingCards(){return dispatch(__WEBPACK_IMPORTED_MODULE_21_actions_index__["_32" /* teamVoucherFetchingCards */]());},onFetchValidTeamVouchers:function onFetchValidTeamVouchers(){return dispatch(__WEBPACK_IMPORTED_MODULE_21_actions_index__["N" /* fetchValidTeamVouchers */]());},cartResetState:function cartResetState(){return dispatch(__WEBPACK_IMPORTED_MODULE_21_actions_index__["g" /* cartResetState */]());},onTeamVoucherSetOrder:function onTeamVoucherSetOrder(order){return dispatch(__WEBPACK_IMPORTED_MODULE_21_actions_index__["_33" /* teamVoucherSetOrder */](order));},onPlaceOrderAndPay:function onPlaceOrderAndPay(order,payInfo){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_20_actions_TeamVoucher__["k" /* placeOrderAndPay */])(order,payInfo));},handlePlaceOrderAndGoToAddNewCard:function handlePlaceOrderAndGoToAddNewCard(order,payInfo,history){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_20_actions_TeamVoucher__["j" /* placeOrderAndGoToAddNewCard */])(order,payInfo,history));},onCloseModalPlacedOrderAndRedirect:function onCloseModalPlacedOrderAndRedirect(history){return dispatch(__WEBPACK_IMPORTED_MODULE_21_actions_index__["x" /* closeModalPlacedOrderAndRedirect */](history));},onOpenModalReceipt:function onOpenModalReceipt(){return dispatch(__WEBPACK_IMPORTED_MODULE_21_actions_index__["_9" /* openModalReceipt */]());},onCloseModalReceiptAndRedirect:function onCloseModalReceiptAndRedirect(history){return dispatch(__WEBPACK_IMPORTED_MODULE_21_actions_index__["z" /* closeModalReceiptAndRedirect */](history));},onCloseModalError:function onCloseModalError(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_20_actions_TeamVoucher__["b" /* closeModalError */])());},onInvalidTeamVoucherEmail:function onInvalidTeamVoucherEmail(option){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_18_actions_TaggedInputText__["b" /* remove */])(option));},createNewUserByEmail:function createNewUserByEmail(option){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_19_actions_SignUp__["d" /* createNewUserByEmail */])(option.value));},onVerifyUnregisteredEmails:function onVerifyUnregisteredEmails(emailList,newEmail){return dispatch(__WEBPACK_IMPORTED_MODULE_21_actions_index__["_42" /* verifyUnregisteredEmails */](emailList,newEmail));},onFetchTeamVoucherCampaignRate:function onFetchTeamVoucherCampaignRate(){return dispatch(__WEBPACK_IMPORTED_MODULE_21_actions_index__["M" /* fetchTeamVoucherCampaignRate */]());}};};var mapStateToProps=function mapStateToProps(state){return{order:state.teamVoucherReducer.order,isLoading:state.loadingReducer.loading,showModalError:state.teamVoucherReducer.showModalError,showModalPlaceOrder:state.teamVoucherReducer.showModalPlaceOrder,showModalReceipt:state.teamVoucherReducer.showModalReceipt,showModalConfirmEmails:state.teamVoucherReducer.showModalConfirmEmails,errorMessage:state.teamVoucherReducer.errorMessage,errorType:state.teamVoucherReducer.errorType,errorObject:state.teamVoucherReducer.errorObject,listAddress:state.menuReducer.listAddress,userDetails:state.authenticationReducer.userDetails,teamVoucherList:state.taggedInputTextReducer.values,cards:state.teamVoucherReducer.cards,campaignRateCC:state.teamVoucherReducer.campaignRateCC};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["g" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(TeamVoucherComponent)));

/***/ }),
/* 805 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var usePrevious=function usePrevious(value){var ref=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])();Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){ref.current=value;});return ref.current;};/* harmony default export */ __webpack_exports__["a"] = (usePrevious);

/***/ }),
/* 806 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_select__ = __webpack_require__(807);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_actions_TaggedInputText__ = __webpack_require__(321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_utils_emailRegex__ = __webpack_require__(819);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__taggedInputText_scss__ = __webpack_require__(820);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__taggedInputText_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__taggedInputText_scss__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var components={DropdownIndicator:null};var colourStyles={control:function control(styles){return Object.assign({},styles,{backgroundColor:"white",border:"1px solid var(--lt-color-input)","box-shadow":"none",":hover":{border:"1px solid var(--lt-color-input)"}});},clearIndicator:function clearIndicator(styles){return Object.assign({},styles,{cursor:"pointer"});},multiValueLabel:function multiValueLabel(styles,_ref){var data=_ref.data;return Object.assign({},styles,{color:data.color,backgroundColor:"var(--lt-color-muted)"});},multiValueRemove:function multiValueRemove(styles,_ref2){var data=_ref2.data;return Object.assign({},styles,{color:data.color,":hover":{cursor:"pointer"}});}};var createOption=function createOption(label){return{label:label,value:label};};var callPropsOnChange=function callPropsOnChange(props,newOptions,newOptionFromInputValue){if(!!props.onChange){props.onChange(newOptions,{action:"add-value",addedValue:newOptionFromInputValue});}};var TaggedInputText=function(_Component){_inherits(TaggedInputText,_Component);function TaggedInputText(props){_classCallCheck(this,TaggedInputText);var _this=_possibleConstructorReturn(this,(TaggedInputText.__proto__||Object.getPrototypeOf(TaggedInputText)).call(this,props));_this.handleChange=function(value,actionMeta){if(actionMeta.action==="remove-value"||actionMeta.action==="pop-value"){_this.props.remove(actionMeta.removedValue);}if(actionMeta.action==="clear"){_this.props.reset(actionMeta.removedValue);}callPropsOnChange(_this.props,value,actionMeta);};_this.handleInputChange=function(inputValue){if(inputValue.includes(",")){var newValue=inputValue.replace(new RegExp(",","g"),"");_this.setState({inputValue:newValue});}else{_this.setState({inputValue:inputValue});}};_this.dealWithKeyInputAndLostFocus=function(event){if(!_this.state.inputValue){return;}if(_this.state.inputValue.includes(" ")){var multiValue=_this.state.inputValue.split(" ");var validEmails=multiValue.map(function(value){return Object(__WEBPACK_IMPORTED_MODULE_4_utils_emailRegex__["a" /* validateEmail */])(value);}).filter(Boolean);validEmails.map(function(value){return _this.handleMultiOption(value);});return;}if(Object(__WEBPACK_IMPORTED_MODULE_4_utils_emailRegex__["a" /* validateEmail */])(_this.state.inputValue)){var newOptionFromInputValue=createOption(_this.state.inputValue);var newOptions=[].concat(_toConsumableArray(_this.props.values),[newOptionFromInputValue]);if(!!_this.props.validate){_this.props.validate(newOptions,newOptionFromInputValue);}_this.handleInputChange("");_this.props.add(newOptionFromInputValue);callPropsOnChange(_this.props,newOptions,newOptionFromInputValue);event.preventDefault();}};_this.handleKeyDown=function(event){var inputValue=_this.state.inputValue;if(!inputValue){return;}switch(event.key){case"Enter":_this.dealWithKeyInputAndLostFocus(event);break;case"Tab":_this.dealWithKeyInputAndLostFocus(event);break;default:break;}};_this.state={inputValue:""};_this.props.reset();return _this;}_createClass(TaggedInputText,[{key:"handleMultiOption",value:function handleMultiOption(value){var newOptionFromInputValue=createOption(value);var newOptions=[].concat(_toConsumableArray(this.props.values),[newOptionFromInputValue]);if(!!this.props.validate){this.props.validate(newOptions,newOptionFromInputValue);}this.handleInputChange("");this.props.add(newOptionFromInputValue);callPropsOnChange(this.props,newOptions,newOptionFromInputValue);}},{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_select__["a" /* default */],{components:components,inputValue:this.state.inputValue,isClearable:true,isMulti:true,menuIsOpen:false,onChange:this.handleChange,onBlur:this.dealWithKeyInputAndLostFocus,onInputChange:this.handleInputChange,onKeyDown:this.handleKeyDown,placeholder:"",value:this.props.values,styles:colourStyles,className:"lc_react-select-container",classNamePrefix:"lc_react-select"});}}]);return TaggedInputText;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{values:state.taggedInputTextReducer.values};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{add:function add(option){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_actions_TaggedInputText__["a" /* add */])(option));},remove:function remove(option){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_actions_TaggedInputText__["b" /* remove */])(option));},reset:function reset(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_actions_TaggedInputText__["c" /* reset */])());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(TaggedInputText));

/***/ }),
/* 807 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export NonceProvider */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_toConsumableArray__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_objectSpread__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_createClass__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_possibleConstructorReturn__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_getPrototypeOf__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_inherits__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_memoize_one__ = __webpack_require__(313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__emotion_core__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_dom__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__babel_runtime_helpers_esm_typeof__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__chunk_39d3fda8_browser_esm_js__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__chunk_80640036_browser_esm_js__ = __webpack_require__(317);
/* unused harmony reexport components */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__base_dist_react_select_cac0a5ae_browser_esm_js__ = __webpack_require__(320);
/* unused harmony reexport createFilter */
/* unused harmony reexport defaultTheme */
/* unused harmony reexport mergeStyles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__emotion_css__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__babel_runtime_helpers_esm_taggedTemplateLiteral__ = __webpack_require__(318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_react_input_autosize__ = __webpack_require__(319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_react_input_autosize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_react_input_autosize__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__chunk_b36baf1a_browser_esm_js__ = __webpack_require__(818);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__emotion_cache__ = __webpack_require__(314);



























var NonceProvider =
/*#__PURE__*/
function (_Component) {
  Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_inherits__["a" /* default */])(NonceProvider, _Component);

  function NonceProvider(props) {
    var _this;

    Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, NonceProvider);

    _this = Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_possibleConstructorReturn__["a" /* default */])(this, Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_getPrototypeOf__["a" /* default */])(NonceProvider).call(this, props));

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "createEmotionCache", function (nonce) {
      return Object(__WEBPACK_IMPORTED_MODULE_24__emotion_cache__["a" /* default */])({
        nonce: nonce
      });
    });

    _this.createEmotionCache = Object(__WEBPACK_IMPORTED_MODULE_12_memoize_one__["a" /* default */])(_this.createEmotionCache);
    return _this;
  }

  Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_createClass__["a" /* default */])(NonceProvider, [{
    key: "render",
    value: function render() {
      var emotionCache = this.createEmotionCache(this.props.nonce);
      return __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__emotion_core__["a" /* CacheProvider */], {
        value: emotionCache
      }, this.props.children);
    }
  }]);

  return NonceProvider;
}(__WEBPACK_IMPORTED_MODULE_11_react__["Component"]);

var index = Object(__WEBPACK_IMPORTED_MODULE_23__chunk_b36baf1a_browser_esm_js__["a" /* m */])(__WEBPACK_IMPORTED_MODULE_19__base_dist_react_select_cac0a5ae_browser_esm_js__["a" /* S */]);

/* harmony default export */ __webpack_exports__["a"] = (index);



/***/ }),
/* 808 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _arrayWithoutHoles;
function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}

/***/ }),
/* 809 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _iterableToArray;
function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

/***/ }),
/* 810 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _nonIterableSpread;
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

/***/ }),
/* 811 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _setPrototypeOf;
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

/***/ }),
/* 812 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function stylis_min (W) {
  function M(d, c, e, h, a) {
    for (var m = 0, b = 0, v = 0, n = 0, q, g, x = 0, K = 0, k, u = k = q = 0, l = 0, r = 0, I = 0, t = 0, B = e.length, J = B - 1, y, f = '', p = '', F = '', G = '', C; l < B;) {
      g = e.charCodeAt(l);
      l === J && 0 !== b + n + v + m && (0 !== b && (g = 47 === b ? 10 : 47), n = v = m = 0, B++, J++);

      if (0 === b + n + v + m) {
        if (l === J && (0 < r && (f = f.replace(N, '')), 0 < f.trim().length)) {
          switch (g) {
            case 32:
            case 9:
            case 59:
            case 13:
            case 10:
              break;

            default:
              f += e.charAt(l);
          }

          g = 59;
        }

        switch (g) {
          case 123:
            f = f.trim();
            q = f.charCodeAt(0);
            k = 1;

            for (t = ++l; l < B;) {
              switch (g = e.charCodeAt(l)) {
                case 123:
                  k++;
                  break;

                case 125:
                  k--;
                  break;

                case 47:
                  switch (g = e.charCodeAt(l + 1)) {
                    case 42:
                    case 47:
                      a: {
                        for (u = l + 1; u < J; ++u) {
                          switch (e.charCodeAt(u)) {
                            case 47:
                              if (42 === g && 42 === e.charCodeAt(u - 1) && l + 2 !== u) {
                                l = u + 1;
                                break a;
                              }

                              break;

                            case 10:
                              if (47 === g) {
                                l = u + 1;
                                break a;
                              }

                          }
                        }

                        l = u;
                      }

                  }

                  break;

                case 91:
                  g++;

                case 40:
                  g++;

                case 34:
                case 39:
                  for (; l++ < J && e.charCodeAt(l) !== g;) {
                  }

              }

              if (0 === k) break;
              l++;
            }

            k = e.substring(t, l);
            0 === q && (q = (f = f.replace(ca, '').trim()).charCodeAt(0));

            switch (q) {
              case 64:
                0 < r && (f = f.replace(N, ''));
                g = f.charCodeAt(1);

                switch (g) {
                  case 100:
                  case 109:
                  case 115:
                  case 45:
                    r = c;
                    break;

                  default:
                    r = O;
                }

                k = M(c, r, k, g, a + 1);
                t = k.length;
                0 < A && (r = X(O, f, I), C = H(3, k, r, c, D, z, t, g, a, h), f = r.join(''), void 0 !== C && 0 === (t = (k = C.trim()).length) && (g = 0, k = ''));
                if (0 < t) switch (g) {
                  case 115:
                    f = f.replace(da, ea);

                  case 100:
                  case 109:
                  case 45:
                    k = f + '{' + k + '}';
                    break;

                  case 107:
                    f = f.replace(fa, '$1 $2');
                    k = f + '{' + k + '}';
                    k = 1 === w || 2 === w && L('@' + k, 3) ? '@-webkit-' + k + '@' + k : '@' + k;
                    break;

                  default:
                    k = f + k, 112 === h && (k = (p += k, ''));
                } else k = '';
                break;

              default:
                k = M(c, X(c, f, I), k, h, a + 1);
            }

            F += k;
            k = I = r = u = q = 0;
            f = '';
            g = e.charCodeAt(++l);
            break;

          case 125:
          case 59:
            f = (0 < r ? f.replace(N, '') : f).trim();
            if (1 < (t = f.length)) switch (0 === u && (q = f.charCodeAt(0), 45 === q || 96 < q && 123 > q) && (t = (f = f.replace(' ', ':')).length), 0 < A && void 0 !== (C = H(1, f, c, d, D, z, p.length, h, a, h)) && 0 === (t = (f = C.trim()).length) && (f = '\x00\x00'), q = f.charCodeAt(0), g = f.charCodeAt(1), q) {
              case 0:
                break;

              case 64:
                if (105 === g || 99 === g) {
                  G += f + e.charAt(l);
                  break;
                }

              default:
                58 !== f.charCodeAt(t - 1) && (p += P(f, q, g, f.charCodeAt(2)));
            }
            I = r = u = q = 0;
            f = '';
            g = e.charCodeAt(++l);
        }
      }

      switch (g) {
        case 13:
        case 10:
          47 === b ? b = 0 : 0 === 1 + q && 107 !== h && 0 < f.length && (r = 1, f += '\x00');
          0 < A * Y && H(0, f, c, d, D, z, p.length, h, a, h);
          z = 1;
          D++;
          break;

        case 59:
        case 125:
          if (0 === b + n + v + m) {
            z++;
            break;
          }

        default:
          z++;
          y = e.charAt(l);

          switch (g) {
            case 9:
            case 32:
              if (0 === n + m + b) switch (x) {
                case 44:
                case 58:
                case 9:
                case 32:
                  y = '';
                  break;

                default:
                  32 !== g && (y = ' ');
              }
              break;

            case 0:
              y = '\\0';
              break;

            case 12:
              y = '\\f';
              break;

            case 11:
              y = '\\v';
              break;

            case 38:
              0 === n + b + m && (r = I = 1, y = '\f' + y);
              break;

            case 108:
              if (0 === n + b + m + E && 0 < u) switch (l - u) {
                case 2:
                  112 === x && 58 === e.charCodeAt(l - 3) && (E = x);

                case 8:
                  111 === K && (E = K);
              }
              break;

            case 58:
              0 === n + b + m && (u = l);
              break;

            case 44:
              0 === b + v + n + m && (r = 1, y += '\r');
              break;

            case 34:
            case 39:
              0 === b && (n = n === g ? 0 : 0 === n ? g : n);
              break;

            case 91:
              0 === n + b + v && m++;
              break;

            case 93:
              0 === n + b + v && m--;
              break;

            case 41:
              0 === n + b + m && v--;
              break;

            case 40:
              if (0 === n + b + m) {
                if (0 === q) switch (2 * x + 3 * K) {
                  case 533:
                    break;

                  default:
                    q = 1;
                }
                v++;
              }

              break;

            case 64:
              0 === b + v + n + m + u + k && (k = 1);
              break;

            case 42:
            case 47:
              if (!(0 < n + m + v)) switch (b) {
                case 0:
                  switch (2 * g + 3 * e.charCodeAt(l + 1)) {
                    case 235:
                      b = 47;
                      break;

                    case 220:
                      t = l, b = 42;
                  }

                  break;

                case 42:
                  47 === g && 42 === x && t + 2 !== l && (33 === e.charCodeAt(t + 2) && (p += e.substring(t, l + 1)), y = '', b = 0);
              }
          }

          0 === b && (f += y);
      }

      K = x;
      x = g;
      l++;
    }

    t = p.length;

    if (0 < t) {
      r = c;
      if (0 < A && (C = H(2, p, r, d, D, z, t, h, a, h), void 0 !== C && 0 === (p = C).length)) return G + p + F;
      p = r.join(',') + '{' + p + '}';

      if (0 !== w * E) {
        2 !== w || L(p, 2) || (E = 0);

        switch (E) {
          case 111:
            p = p.replace(ha, ':-moz-$1') + p;
            break;

          case 112:
            p = p.replace(Q, '::-webkit-input-$1') + p.replace(Q, '::-moz-$1') + p.replace(Q, ':-ms-input-$1') + p;
        }

        E = 0;
      }
    }

    return G + p + F;
  }

  function X(d, c, e) {
    var h = c.trim().split(ia);
    c = h;
    var a = h.length,
        m = d.length;

    switch (m) {
      case 0:
      case 1:
        var b = 0;

        for (d = 0 === m ? '' : d[0] + ' '; b < a; ++b) {
          c[b] = Z(d, c[b], e).trim();
        }

        break;

      default:
        var v = b = 0;

        for (c = []; b < a; ++b) {
          for (var n = 0; n < m; ++n) {
            c[v++] = Z(d[n] + ' ', h[b], e).trim();
          }
        }

    }

    return c;
  }

  function Z(d, c, e) {
    var h = c.charCodeAt(0);
    33 > h && (h = (c = c.trim()).charCodeAt(0));

    switch (h) {
      case 38:
        return c.replace(F, '$1' + d.trim());

      case 58:
        return d.trim() + c.replace(F, '$1' + d.trim());

      default:
        if (0 < 1 * e && 0 < c.indexOf('\f')) return c.replace(F, (58 === d.charCodeAt(0) ? '' : '$1') + d.trim());
    }

    return d + c;
  }

  function P(d, c, e, h) {
    var a = d + ';',
        m = 2 * c + 3 * e + 4 * h;

    if (944 === m) {
      d = a.indexOf(':', 9) + 1;
      var b = a.substring(d, a.length - 1).trim();
      b = a.substring(0, d).trim() + b + ';';
      return 1 === w || 2 === w && L(b, 1) ? '-webkit-' + b + b : b;
    }

    if (0 === w || 2 === w && !L(a, 1)) return a;

    switch (m) {
      case 1015:
        return 97 === a.charCodeAt(10) ? '-webkit-' + a + a : a;

      case 951:
        return 116 === a.charCodeAt(3) ? '-webkit-' + a + a : a;

      case 963:
        return 110 === a.charCodeAt(5) ? '-webkit-' + a + a : a;

      case 1009:
        if (100 !== a.charCodeAt(4)) break;

      case 969:
      case 942:
        return '-webkit-' + a + a;

      case 978:
        return '-webkit-' + a + '-moz-' + a + a;

      case 1019:
      case 983:
        return '-webkit-' + a + '-moz-' + a + '-ms-' + a + a;

      case 883:
        if (45 === a.charCodeAt(8)) return '-webkit-' + a + a;
        if (0 < a.indexOf('image-set(', 11)) return a.replace(ja, '$1-webkit-$2') + a;
        break;

      case 932:
        if (45 === a.charCodeAt(4)) switch (a.charCodeAt(5)) {
          case 103:
            return '-webkit-box-' + a.replace('-grow', '') + '-webkit-' + a + '-ms-' + a.replace('grow', 'positive') + a;

          case 115:
            return '-webkit-' + a + '-ms-' + a.replace('shrink', 'negative') + a;

          case 98:
            return '-webkit-' + a + '-ms-' + a.replace('basis', 'preferred-size') + a;
        }
        return '-webkit-' + a + '-ms-' + a + a;

      case 964:
        return '-webkit-' + a + '-ms-flex-' + a + a;

      case 1023:
        if (99 !== a.charCodeAt(8)) break;
        b = a.substring(a.indexOf(':', 15)).replace('flex-', '').replace('space-between', 'justify');
        return '-webkit-box-pack' + b + '-webkit-' + a + '-ms-flex-pack' + b + a;

      case 1005:
        return ka.test(a) ? a.replace(aa, ':-webkit-') + a.replace(aa, ':-moz-') + a : a;

      case 1e3:
        b = a.substring(13).trim();
        c = b.indexOf('-') + 1;

        switch (b.charCodeAt(0) + b.charCodeAt(c)) {
          case 226:
            b = a.replace(G, 'tb');
            break;

          case 232:
            b = a.replace(G, 'tb-rl');
            break;

          case 220:
            b = a.replace(G, 'lr');
            break;

          default:
            return a;
        }

        return '-webkit-' + a + '-ms-' + b + a;

      case 1017:
        if (-1 === a.indexOf('sticky', 9)) break;

      case 975:
        c = (a = d).length - 10;
        b = (33 === a.charCodeAt(c) ? a.substring(0, c) : a).substring(d.indexOf(':', 7) + 1).trim();

        switch (m = b.charCodeAt(0) + (b.charCodeAt(7) | 0)) {
          case 203:
            if (111 > b.charCodeAt(8)) break;

          case 115:
            a = a.replace(b, '-webkit-' + b) + ';' + a;
            break;

          case 207:
          case 102:
            a = a.replace(b, '-webkit-' + (102 < m ? 'inline-' : '') + 'box') + ';' + a.replace(b, '-webkit-' + b) + ';' + a.replace(b, '-ms-' + b + 'box') + ';' + a;
        }

        return a + ';';

      case 938:
        if (45 === a.charCodeAt(5)) switch (a.charCodeAt(6)) {
          case 105:
            return b = a.replace('-items', ''), '-webkit-' + a + '-webkit-box-' + b + '-ms-flex-' + b + a;

          case 115:
            return '-webkit-' + a + '-ms-flex-item-' + a.replace(ba, '') + a;

          default:
            return '-webkit-' + a + '-ms-flex-line-pack' + a.replace('align-content', '').replace(ba, '') + a;
        }
        break;

      case 973:
      case 989:
        if (45 !== a.charCodeAt(3) || 122 === a.charCodeAt(4)) break;

      case 931:
      case 953:
        if (!0 === la.test(d)) return 115 === (b = d.substring(d.indexOf(':') + 1)).charCodeAt(0) ? P(d.replace('stretch', 'fill-available'), c, e, h).replace(':fill-available', ':stretch') : a.replace(b, '-webkit-' + b) + a.replace(b, '-moz-' + b.replace('fill-', '')) + a;
        break;

      case 962:
        if (a = '-webkit-' + a + (102 === a.charCodeAt(5) ? '-ms-' + a : '') + a, 211 === e + h && 105 === a.charCodeAt(13) && 0 < a.indexOf('transform', 10)) return a.substring(0, a.indexOf(';', 27) + 1).replace(ma, '$1-webkit-$2') + a;
    }

    return a;
  }

  function L(d, c) {
    var e = d.indexOf(1 === c ? ':' : '{'),
        h = d.substring(0, 3 !== c ? e : 10);
    e = d.substring(e + 1, d.length - 1);
    return R(2 !== c ? h : h.replace(na, '$1'), e, c);
  }

  function ea(d, c) {
    var e = P(c, c.charCodeAt(0), c.charCodeAt(1), c.charCodeAt(2));
    return e !== c + ';' ? e.replace(oa, ' or ($1)').substring(4) : '(' + c + ')';
  }

  function H(d, c, e, h, a, m, b, v, n, q) {
    for (var g = 0, x = c, w; g < A; ++g) {
      switch (w = S[g].call(B, d, x, e, h, a, m, b, v, n, q)) {
        case void 0:
        case !1:
        case !0:
        case null:
          break;

        default:
          x = w;
      }
    }

    if (x !== c) return x;
  }

  function T(d) {
    switch (d) {
      case void 0:
      case null:
        A = S.length = 0;
        break;

      default:
        if ('function' === typeof d) S[A++] = d;else if ('object' === typeof d) for (var c = 0, e = d.length; c < e; ++c) {
          T(d[c]);
        } else Y = !!d | 0;
    }

    return T;
  }

  function U(d) {
    d = d.prefix;
    void 0 !== d && (R = null, d ? 'function' !== typeof d ? w = 1 : (w = 2, R = d) : w = 0);
    return U;
  }

  function B(d, c) {
    var e = d;
    33 > e.charCodeAt(0) && (e = e.trim());
    V = e;
    e = [V];

    if (0 < A) {
      var h = H(-1, c, e, e, D, z, 0, 0, 0, 0);
      void 0 !== h && 'string' === typeof h && (c = h);
    }

    var a = M(O, e, c, 0, 0);
    0 < A && (h = H(-2, a, e, e, D, z, a.length, 0, 0, 0), void 0 !== h && (a = h));
    V = '';
    E = 0;
    z = D = 1;
    return a;
  }

  var ca = /^\0+/g,
      N = /[\0\r\f]/g,
      aa = /: */g,
      ka = /zoo|gra/,
      ma = /([,: ])(transform)/g,
      ia = /,\r+?/g,
      F = /([\t\r\n ])*\f?&/g,
      fa = /@(k\w+)\s*(\S*)\s*/,
      Q = /::(place)/g,
      ha = /:(read-only)/g,
      G = /[svh]\w+-[tblr]{2}/,
      da = /\(\s*(.*)\s*\)/g,
      oa = /([\s\S]*?);/g,
      ba = /-self|flex-/g,
      na = /[^]*?(:[rp][el]a[\w-]+)[^]*/,
      la = /stretch|:\s*\w+\-(?:conte|avail)/,
      ja = /([^-])(image-set\()/,
      z = 1,
      D = 1,
      E = 0,
      w = 1,
      O = [],
      S = [],
      A = 0,
      R = null,
      Y = 0,
      V = '';
  B.use = T;
  B.set = U;
  void 0 !== W && U(W);
  return B;
}

/* harmony default export */ __webpack_exports__["a"] = (stylis_min);


/***/ }),
/* 813 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var weakMemoize = function weakMemoize(func) {
  // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
  var cache = new WeakMap();
  return function (arg) {
    if (cache.has(arg)) {
      // $FlowFixMe
      return cache.get(arg);
    }

    var ret = func(arg);
    cache.set(arg, ret);
    return ret;
  };
};

/* unused harmony default export */ var _unused_webpack_default_export = (weakMemoize);


/***/ }),
/* 814 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getRegisteredStyles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return insertStyles; });
var isBrowser = "object" !== 'undefined';
function getRegisteredStyles(registered, registeredStyles, classNames) {
  var rawClassName = '';
  classNames.split(' ').forEach(function (className) {
    if (registered[className] !== undefined) {
      registeredStyles.push(registered[className]);
    } else {
      rawClassName += className + " ";
    }
  });
  return rawClassName;
}
var insertStyles = function insertStyles(cache, serialized, isStringTag) {
  var className = cache.key + "-" + serialized.name;

  if ( // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (isStringTag === false || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  isBrowser === false && cache.compat !== undefined) && cache.registered[className] === undefined) {
    cache.registered[className] = serialized.styles;
  }

  if (cache.inserted[serialized.name] === undefined) {
    var current = serialized;

    do {
      var maybeStyles = cache.insert("." + className, current, cache.sheet, true);

      current = current.next;
    } while (current !== undefined);
  }
};




/***/ }),
/* 815 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* eslint-disable */
// Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function murmur2(str) {
  // 'm' and 'r' are mixing constants generated offline.
  // They're not really 'magic', they just happen to work well.
  // const m = 0x5bd1e995;
  // const r = 24;
  // Initialize the hash
  var h = 0; // Mix 4 bytes at a time into the hash

  var k,
      i = 0,
      len = str.length;

  for (; len >= 4; ++i, len -= 4) {
    k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
    k =
    /* Math.imul(k, m): */
    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
    k ^=
    /* k >>> r: */
    k >>> 24;
    h =
    /* Math.imul(k, m): */
    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^
    /* Math.imul(h, m): */
    (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  } // Handle the last few bytes of the input array


  switch (len) {
    case 3:
      h ^= (str.charCodeAt(i + 2) & 0xff) << 16;

    case 2:
      h ^= (str.charCodeAt(i + 1) & 0xff) << 8;

    case 1:
      h ^= str.charCodeAt(i) & 0xff;
      h =
      /* Math.imul(h, m): */
      (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  } // Do a few final mixes of the hash to ensure the last few
  // bytes are well-incorporated.


  h ^= h >>> 13;
  h =
  /* Math.imul(h, m): */
  (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  return ((h ^ h >>> 15) >>> 0).toString(36);
}

/* harmony default export */ __webpack_exports__["a"] = (murmur2);


/***/ }),
/* 816 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var unitlessKeys = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};

/* harmony default export */ __webpack_exports__["a"] = (unitlessKeys);


/***/ }),
/* 817 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function memoize(fn) {
  var cache = {};
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}

/* harmony default export */ __webpack_exports__["a"] = (memoize);


/***/ }),
/* 818 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return manageState; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_createClass__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_possibleConstructorReturn__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_getPrototypeOf__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_inherits__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react__);











var defaultProps = {
  defaultInputValue: '',
  defaultMenuIsOpen: false,
  defaultValue: null
};

var manageState = function manageState(SelectComponent) {
  var _class, _temp;

  return _temp = _class =
  /*#__PURE__*/
  function (_Component) {
    Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_inherits__["a" /* default */])(StateManager, _Component);

    function StateManager() {
      var _getPrototypeOf2;

      var _this;

      Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, StateManager);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_possibleConstructorReturn__["a" /* default */])(this, (_getPrototypeOf2 = Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_getPrototypeOf__["a" /* default */])(StateManager)).call.apply(_getPrototypeOf2, [this].concat(args)));

      Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "select", void 0);

      Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "state", {
        inputValue: _this.props.inputValue !== undefined ? _this.props.inputValue : _this.props.defaultInputValue,
        menuIsOpen: _this.props.menuIsOpen !== undefined ? _this.props.menuIsOpen : _this.props.defaultMenuIsOpen,
        value: _this.props.value !== undefined ? _this.props.value : _this.props.defaultValue
      });

      Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "onChange", function (value, actionMeta) {
        _this.callProp('onChange', value, actionMeta);

        _this.setState({
          value: value
        });
      });

      Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "onInputChange", function (value, actionMeta) {
        // TODO: for backwards compatibility, we allow the prop to return a new
        // value, but now inputValue is a controllable prop we probably shouldn't
        var newValue = _this.callProp('onInputChange', value, actionMeta);

        _this.setState({
          inputValue: newValue !== undefined ? newValue : value
        });
      });

      Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "onMenuOpen", function () {
        _this.callProp('onMenuOpen');

        _this.setState({
          menuIsOpen: true
        });
      });

      Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "onMenuClose", function () {
        _this.callProp('onMenuClose');

        _this.setState({
          menuIsOpen: false
        });
      });

      return _this;
    }

    Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_createClass__["a" /* default */])(StateManager, [{
      key: "focus",
      value: function focus() {
        this.select.focus();
      }
    }, {
      key: "blur",
      value: function blur() {
        this.select.blur();
      } // FIXME: untyped flow code, return any

    }, {
      key: "getProp",
      value: function getProp(key) {
        return this.props[key] !== undefined ? this.props[key] : this.state[key];
      } // FIXME: untyped flow code, return any

    }, {
      key: "callProp",
      value: function callProp(name) {
        if (typeof this.props[name] === 'function') {
          var _this$props;

          for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
            args[_key2 - 1] = arguments[_key2];
          }

          return (_this$props = this.props)[name].apply(_this$props, args);
        }
      }
    }, {
      key: "render",
      value: function render() {
        var _this2 = this;

        var _this$props2 = this.props,
            defaultInputValue = _this$props2.defaultInputValue,
            defaultMenuIsOpen = _this$props2.defaultMenuIsOpen,
            defaultValue = _this$props2.defaultValue,
            props = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(_this$props2, ["defaultInputValue", "defaultMenuIsOpen", "defaultValue"]);

        return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(SelectComponent, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props, {
          ref: function ref(_ref) {
            _this2.select = _ref;
          },
          inputValue: this.getProp('inputValue'),
          menuIsOpen: this.getProp('menuIsOpen'),
          onChange: this.onChange,
          onInputChange: this.onInputChange,
          onMenuClose: this.onMenuClose,
          onMenuOpen: this.onMenuOpen,
          value: this.getProp('value')
        }));
      }
    }]);

    return StateManager;
  }(__WEBPACK_IMPORTED_MODULE_9_react__["Component"]), Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_class, "defaultProps", defaultProps), _temp;
};




/***/ }),
/* 819 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = validateEmail;
var EmailRegex=/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;function validateEmail(email){var pattern=new RegExp(EmailRegex);if(pattern.test(email)){return email;}else{return"";}}

/***/ }),
/* 820 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(821);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(17)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../lunch-team-client-checkout-msg/node_modules/css-loader/index.js!../../../../../../../lunch-team-client-checkout-msg/node_modules/sass-loader/dist/cjs.js!./taggedInputText.scss", function() {
			var newContent = require("!!../../../../../../../lunch-team-client-checkout-msg/node_modules/css-loader/index.js!../../../../../../../lunch-team-client-checkout-msg/node_modules/sass-loader/dist/cjs.js!./taggedInputText.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 821 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(14)(undefined);
// imports


// module
exports.push([module.i, ".lc_react-select-container{margin-top:10px}.lc_react-select-container #react-select-2-input{height:27px;margin-bottom:0px}.lc_react-select-container .lc_react-select__value-container{max-width:800px;overflow:hidden;text-overflow:ellipsis}", ""]);

// exports


/***/ }),
/* 822 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_object__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Label__ = __webpack_require__(823);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__text_input_scss__ = __webpack_require__(824);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__text_input_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__text_input_scss__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var TextInput=function(_Component){_inherits(TextInput,_Component);function TextInput(props){_classCallCheck(this,TextInput);var _this=_possibleConstructorReturn(this,(TextInput.__proto__||Object.getPrototypeOf(TextInput)).call(this,props));_this.state={active:false};_this.getRef=_this.getRef.bind(_this);return _this;}_createClass(TextInput,[{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){var arePropsEqual=Object(__WEBPACK_IMPORTED_MODULE_1__utils_object__["b" /* shallowEquals */])(nextProps,this.props,'disabled','readOnly','value','type','hasError');return!arePropsEqual||this.state.active!==nextState.active;}},{key:'getRef',value:function getRef(input){this.input=input;this.props.getRef&&this.props.getRef(input);if(input&&this.props.autoFocus){setTimeout(function(){return input.focus();},10);}}},{key:'handleBlur',value:function handleBlur(event){this.setState({active:false});!!this.props.onBlur&&this.props.onBlur(event);}},{key:'handleFocus',value:function handleFocus(event){this.setState({active:true});!!this.props.onFocus&&this.props.onFocus(event);}},{key:'handleClick',value:function handleClick(){this.input&&this.input.focus();}},{key:'renderInput',value:function renderInput(){var _this2=this;var options={id:this.props.id||this.props.name,name:this.props.name,required:this.props.required,onFocus:function onFocus(event){return _this2.handleFocus(event);},onBlur:function onBlur(event){return _this2.handleBlur(event);},onKeyUp:function onKeyUp(event){return _this2.props.onKeyUp&&_this2.props.onKeyUp(event);},onChange:this.props.onChange,disabled:this.props.disabled,'aria-description':this.props.aria_description,value:this.props.value,type:this.props.type,readOnly:this.props.readOnly,placeholder:this.props.placeholder,maxLength:this.props.maxLength,minLength:this.props.minLength,autoComplete:'off',ref:this.getRef,className:!!this.props.className?'text-input '+this.props.className:'text-input'};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',Object.assign({onClick:this.handleClick.bind(this)},options));}},{key:'render',value:function render(){return this.renderInput();}}]);return TextInput;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2__Label__["a" /* default */])(TextInput));

/***/ }),
/* 823 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function withLabel(WrappedComponent){var preventClick=arguments.length>1&&arguments[1]!==undefined?arguments[1]:false;return function(_ref){var _ref$label=_ref.label,label=_ref$label===undefined?'':_ref$label,name=_ref.name,required=_ref.required,hasError=_ref.hasError,_ref$hint=_ref.hint,hint=_ref$hint===undefined?'':_ref$hint,disabled=_ref.disabled,rest=_objectWithoutProperties(_ref,['label','name','required','hasError','hint','disabled']);var wrapped=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WrappedComponent,Object.assign({id:name,name:name,disabled:disabled,hasError:hasError},rest));return!!label?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:name,onClick:function onClick(e){return preventClick&&e.preventDefault();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,label,required&&' *',!!hint&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'\xA0\xA0(',hint,')')),wrapped):wrapped;};}/* harmony default export */ __webpack_exports__["a"] = (withLabel);

/***/ }),
/* 824 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(825);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(17)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../lunch-team-client-checkout-msg/node_modules/css-loader/index.js!../../../../../../../lunch-team-client-checkout-msg/node_modules/sass-loader/dist/cjs.js!./text-input.scss", function() {
			var newContent = require("!!../../../../../../../lunch-team-client-checkout-msg/node_modules/css-loader/index.js!../../../../../../../lunch-team-client-checkout-msg/node_modules/sass-loader/dist/cjs.js!./text-input.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 825 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(14)(undefined);
// imports


// module
exports.push([module.i, ".text-input{margin:0px 0px 0px 0px !important}", ""]);

// exports


/***/ }),
/* 826 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tooltip_scss__ = __webpack_require__(827);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tooltip_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__tooltip_scss__);
/* harmony default export */ __webpack_exports__["a"] = (function(props){var classes='lc_tooltip '+(props.className||'');return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:classes},props.tooltipSpanText,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'tooltiptext'},props.tooltipText));});

/***/ }),
/* 827 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(828);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(17)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../lunch-team-client-checkout-msg/node_modules/css-loader/index.js!../../../../../../../lunch-team-client-checkout-msg/node_modules/sass-loader/dist/cjs.js!./tooltip.scss", function() {
			var newContent = require("!!../../../../../../../lunch-team-client-checkout-msg/node_modules/css-loader/index.js!../../../../../../../lunch-team-client-checkout-msg/node_modules/sass-loader/dist/cjs.js!./tooltip.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 828 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(14)(undefined);
// imports


// module
exports.push([module.i, ".lc_tooltip{font-size:15px;border-bottom:1px solid #0b2318;right:0;left:auto;position:relative;display:inline-block;line-height:1.42857143;text-decoration:none;text-shadow:none;text-transform:none;letter-spacing:normal;word-break:normal;word-spacing:normal;word-wrap:normal;white-space:normal;filter:alpha(opacity=0);line-break:auto;cursor:pointer}.lc_tooltip .tooltiptext{font-weight:400;font-size:12px;visibility:hidden;width:300px;background-color:#0b2318;color:#fff;text-align:center;padding:5px 0;border-radius:6px;bottom:100%;left:50%;margin-left:-150px;position:absolute;z-index:1}.lc_tooltip:hover .tooltiptext{visibility:visible}", ""]);

// exports


/***/ }),
/* 829 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_modal__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__hoc_ReactAux_ReactAux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_utils_time__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_utils_orderConfirmation__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modalReceiptTest_scss__ = __webpack_require__(287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modalReceiptTest_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__modalReceiptTest_scss__);
var customStyles={content:{background:'none',border:'none',height:'100%',left:'0',right:'0',top:'0',bottom:'0',overflowY:'scroll'},overlay:{position:'fixed',zIndex:'9999999',width:'100%',height:'100%',backgroundColor:'rgba(0, 0, 0, 0.8)'}};var Product=function Product(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bloco'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',{className:'left'},props.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',{className:'right'},props.price)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,props.description));};var ResumeLine=function ResumeLine(props){var classes=!!props.bold?'wrapper total':'wrapper';return props.showResume?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:classes},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'left'},props.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right'},props.value)):null;};var CustomerDetails=function CustomerDetails(_ref){var firstName=_ref.firstName,lastName=_ref.lastName,businessName=_ref.businessName,isCollection=_ref.isCollection,address=_ref.address;var customerName=firstName+' '+lastName;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'head'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,isCollection?'Collection by '+customerName:'Delivery to '+customerName+', '+businessName));};var OrderDateDetails=function OrderDateDetails(_ref2){var cart=_ref2.cart,isCollection=_ref2.isCollection;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__hoc_ReactAux_ReactAux__["a" /* default */],null,!!cart&&!!cart.orderDeliveryDate&&isCollection?'Time for collection : '+__WEBPACK_IMPORTED_MODULE_3_utils_time__["a" /* default */].formatDateToDateTimeAmPm(cart.orderDeliveryDate):'Date: '+__WEBPACK_IMPORTED_MODULE_3_utils_time__["a" /* default */].formatDateToDateTimeAmPm(cart.orderDeliveryDate));};var modalReceiptVoucher=function modalReceiptVoucher(props){if(!props.showModal){return null;}var publicOrderNumber=props.data.cart.publicOrderNumber;var orderReference=publicOrderNumber?'Order '+publicOrderNumber:'Order details';var renderProduct=function renderProduct(item,currency,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Product,{key:index,name:item.name,price:currency+' '+Number(item.price).toFixed(2),description:(item.description||'')+' '+(item.calory||'')});};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__hoc_ReactAux_ReactAux__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_modal___default.a,{isOpen:true,style:customStyles,onRequestClose:props.closeModal,shouldCloseOnOverlayClick:true,shouldCloseOnEsc:true,contentLabel:'Example Modal'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'lb-receipt',className:'lb-geral lb-receipt_'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-content modal-content-receipt',tabIndex:0},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'bt-close mfp-close lb-fechar fa fa-times',onClick:props.closeModal}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'check-mark'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'fa fa-check-circle lt-success-tick','aria-hidden':'true'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'lb-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'order'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,Object(__WEBPACK_IMPORTED_MODULE_4_utils_orderConfirmation__["a" /* orderPlacedMessage */])(publicOrderNumber))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'purchase'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'Receipt'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',{className:'thank-you'},'Thank you for your purchase,',' ',props.data.userDetails.firstName,' :)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'order-date'},orderReference,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(OrderDateDetails,{cart:props.data.cart,isCollection:props.data.forCollection==='Y'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'delivery'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CustomerDetails,{businessName:props.data.userDetails.businessName,firstName:props.data.userDetails.firstName,lastName:props.data.userDetails.lastName,isCollection:props.data.forCollection==='Y'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content'},props.data.cart.products.map(function(product,index){return renderProduct(product,props.data.currency,index);})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'foot'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ResumeLine,{showResume:true,name:'Subtotal',value:props.data.currency+' '+Number(props.data.subtotal).toFixed(2)}),!!props.data.surcharge&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ResumeLine,{showResume:true,name:'Surcharge',value:props.data.currency+' '+Number(props.data.surcharge).toFixed(2)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ResumeLine,{showResume:true,name:'Total',value:props.data.currency+' '+Number(props.data.total).toFixed(2),bold:true})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{onClick:props.closeModal,className:'bt'},'Got it'))))));};/* harmony default export */ __webpack_exports__["a"] = (modalReceiptVoucher);

/***/ }),
/* 830 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__hoc_ReactAux_ReactAux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_modal__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_modal__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var customStyles={content:{background:"none",border:"none"},overlay:{zIndex:"9999999",width:"100%",height:"100%",left:"0",top:"0",backgroundColor:"rgba(0, 0, 0, 0.7)"}};var ModalValidateEmails=function(_Component){_inherits(ModalValidateEmails,_Component);function ModalValidateEmails(){_classCallCheck(this,ModalValidateEmails);return _possibleConstructorReturn(this,(ModalValidateEmails.__proto__||Object.getPrototypeOf(ModalValidateEmails)).apply(this,arguments));}_createClass(ModalValidateEmails,[{key:"render",value:function render(){var _this2=this;if(!this.props.showModal){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__hoc_ReactAux_ReactAux__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_modal___default.a,{isOpen:this.props.showModal,style:customStyles,onRequestClose:this.props.closeModal,shouldCloseOnOverlayClick:true,shouldCloseOnEsc:true,contentLabel:"Example Modal"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:this.props.style,id:"lb-error",className:"lb-geral mfp-bg-login error-popup-block  lb-centralizar singup zoom-anim-dialog"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"lb-padrao-singup6 mfp-content-login modal-content"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{type:"button",onClick:this.props.closeModal,style:{backgroundColor:"var(--lt-color-primary)"},className:"bt-close mfp-close lb-fechar fa fa-times"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"check-mark"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:__webpack_require__(322),alt:"error"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"Validate Emails")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:this.props.styleContent,className:"lb-content scrolling"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"order"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"The following emails are not registered, confirm the ones you wish to Create or Remove them with the X button."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),this.props.unregistered.map(function(email,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{key:index,className:"confirmContainer"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{onClick:function onClick(){return _this2.props.filterAction(email);},type:"button",className:"small"},"X"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,email.value));})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),!!this.props.actionButton?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{onClick:this.props.actionButton,className:"bt"},this.props.actionButtonTitle):null)))));}}]);return ModalValidateEmails;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (ModalValidateEmails);

/***/ }),
/* 831 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VoucherBalanceList__ = __webpack_require__(832);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_actions_index__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__style_css__ = __webpack_require__(834);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__style_css__);
var VoucherBalance=function VoucherBalance(_ref){var voucherBalance=_ref.voucherBalance,onFetchingVoucherBalance=_ref.onFetchingVoucherBalance;Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){onFetchingVoucherBalance();},[]);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'company-voucher-container'},voucherBalance.length>0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__VoucherBalanceList__["a" /* default */],{items:voucherBalance}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'You don\'t have any voucher yet'));};var mapStateToProps=function mapStateToProps(state){return{voucherBalance:state.teamVoucherReducer.voucherBalance};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onFetchingVoucherBalance:function onFetchingVoucherBalance(){return dispatch(__WEBPACK_IMPORTED_MODULE_3_actions_index__["Z" /* fetchingVoucherBalance */]());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(VoucherBalance));

/***/ }),
/* 832 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_utils_time__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_css__ = __webpack_require__(833);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__styles_css__);
var VoucherBalanceList=function VoucherBalanceList(_ref){var items=_ref.items;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,items.some(function(item){return item.type==='T';})&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'company-voucher-group'},items.filter(function(item){return item.type==='T';}).map(function(item){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'company-voucher-item'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'title'},item.title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'total'},(item.discountOperation==='value'?'€':'%')+' '+item.value),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'title-bottom'},'Balance'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'bottom'},'Expire '+__WEBPACK_IMPORTED_MODULE_1_utils_time__["a" /* default */].formatDate(item.expireDate)));})),items.some(function(item){return item.type==='F';})&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'company-voucher-group'},items.filter(function(item){return item.type==='F';}).map(function(item){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'company-voucher-item'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'title'},item.title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'total'},(item.discountOperation==='value'?'€':'%')+' '+item.value),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'title-bottom'},'Balance'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'bottom'},'Expire '+__WEBPACK_IMPORTED_MODULE_1_utils_time__["a" /* default */].formatDate(item.expireDate)));})),items.some(function(item){return item.type==='R';})&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'company-voucher-group'},items.filter(function(item){return item.type==='R';}).map(function(item){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'company-voucher-item'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Applicable for \u20AC 8 max'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'title'},item.title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'total'},(item.discountOperation==='value'?'€':'%')+' '+item.value),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'title-bottom'},'Balance'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'bottom'},'Expire '+__WEBPACK_IMPORTED_MODULE_1_utils_time__["a" /* default */].formatDate(item.expireDate)));})));};/* harmony default export */ __webpack_exports__["a"] = (VoucherBalanceList);

/***/ }),
/* 833 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 834 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 835 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(836);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(17)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../lunch-team-client-checkout-msg/node_modules/css-loader/index.js!../../../../../../lunch-team-client-checkout-msg/node_modules/sass-loader/dist/cjs.js!./voucher.scss", function() {
			var newContent = require("!!../../../../../../lunch-team-client-checkout-msg/node_modules/css-loader/index.js!../../../../../../lunch-team-client-checkout-msg/node_modules/sass-loader/dist/cjs.js!./voucher.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 836 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(14)(undefined);
// imports


// module
exports.push([module.i, ".top-header .header-voucher{justify-content:center}.team-voucher{margin:0 auto;float:none !important;width:95% !important;padding:0 !important}.team-voucher .header-list-team-voucher{display:flex;height:48px;box-shadow:0 10px 10px -10px rgba(0,0,0,.31);background-color:#fff}.team-voucher .header-list-team-voucher li{margin-right:10%}.team-voucher .header-list-team-voucher a{padding-top:10%;font-size:16px;color:#0b2318;height:100%}.team-voucher .header-list-team-voucher .active{font-weight:bold;color:#0b2318;border-bottom:5px solid #0e7a4b}.team-voucher .balance{border-bottom:1px solid #dbe5df;margin-bottom:20px}.team-voucher .balance h3{font-size:23.82px;font-family:\"Geist\";color:#0b2318;font-weight:bold;text-align:left;margin-top:1em;margin-bottom:1em}.team-voucher .balance h4{font-size:18.38px;font-family:\"Geist\";color:#0b2318;font-weight:bold;text-align:left;margin-top:14px;margin-bottom:43px;display:inline-block}.team-voucher .balance span b{font-size:18.38px;font-family:\"Geist\";color:#075c38;font-weight:bold;text-align:left}.team-voucher .balance span{font-size:14.29px;font-family:\"Geist\";color:#075c38;font-weight:600;text-align:left}.team-voucher h5.note{text-align:center;margin-top:1rem}.team-voucher:before{position:static !important}.team-voucher .order-voucher{margin-top:2%;position:relative}.team-voucher .order-voucher h4{font-size:18.38px;font-family:\"Geist\";color:#0b2318;font-weight:bold;text-align:left;margin-bottom:1.5em}.team-voucher .payment-options{height:auto;display:table;width:100%;padding-bottom:25px;border-bottom:1px solid #dbe5df;margin-bottom:30px}.team-voucher .payment-options h4{margin-bottom:0}.team-voucher .payment-options .radio-payment{padding-top:8px;clear:both;display:block}.team-voucher .payment-options .radio-payment input[type=radio]+label{margin-top:-8px}.team-voucher .payment-options .radio-payment input[type=radio]+label::before{border-color:#0b2318}.team-voucher .payment-options .add-card{font-size:14px;padding-top:15px;display:block}.team-voucher .payment-options .add-card span{font-size:14px;color:#0e7a4b}.team-voucher .payment-options .box-add-card{width:100%;height:auto;display:none}.team-voucher .payment-options .box-add-card.open{display:table}.team-voucher .flex-row{width:100%;display:block;margin:0}.team-voucher .flex-row .email{width:78%}.team-voucher .flex-row .voucher{width:19%}.team-voucher .flex-row .voucher label{text-align:end}.team-voucher .flex-row>div{margin-bottom:5px}.team-voucher .flex-row>div label{font-size:14px;font-weight:600;display:block}.team-voucher .flex-row>div .amount-voucher{height:38px;border-radius:8px;margin-top:10px !important;border:1px solid #769885}.team-voucher .valor-final{display:table;width:100%;height:auto;padding-bottom:25px;border-bottom:1px solid #dbe5df;margin-bottom:30px}.team-voucher .valor-final .quant-voucher{font-size:15px}.team-voucher .valor-final .total{font-size:15px;font-weight:bold}.team-voucher .tools{width:100%;position:relative;clear:both}.team-voucher .tools span{font-size:15px;font-weight:bold;border-bottom:1px solid #0b2318}.team-voucher .tools button.orange-bold{width:243px !important;display:inline-block;float:none;margin:0 auto;display:table}@media only screen and (max-width: 760px){.list-items.team-voucher{padding:1em 1em 5em}.tools{width:100%;display:flex;align-items:center;justify-content:center;flex-wrap:wrap}}@media only screen and (max-width: 700px){.team-voucher .flex-row .email,.team-voucher .flex-row .voucher{width:50%;clear:both;float:left}.team-voucher .flex-row .email input,.team-voucher .flex-row .voucher input{width:100%}}@media only screen and (max-width: 500px){.team-voucher .flex-row .email,.team-voucher .flex-row .voucher{width:100%;clear:both;float:left}.team-voucher .balance h4{margin-top:0;margin-bottom:10px}}@media only screen and (max-width: 523px){.team-voucher .flex-row{margin-bottom:20px}.team-voucher .tools{padding-bottom:20px}.team-voucher .tools .orange-bold{margin-top:40px}}", ""]);

// exports


/***/ }),
/* 837 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_actions_index__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_actions_Cart__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__GuestRecipientSheet__ = __webpack_require__(838);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__GuestOrdersResult__ = __webpack_require__(839);
// Mounted once in the menu: the "Who's this for?" sheet every Add to basket goes
// through when guest ordering is on, and the result of sending one order per person.
var GuestRecipient=function GuestRecipient(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,props.prompt&&props.policy?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__GuestRecipientSheet__["a" /* default */],{policy:props.policy,guests:props.guests,lastRecipientId:props.lastRecipientId,subtitle:props.prompt.subtitle,onAdd:props.onChoose,onCancel:props.onCancel}):null,props.batchResult?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__GuestOrdersResult__["a" /* default */],{result:props.batchResult,onClose:function onClose(){return props.batchResult.allPlaced?props.onAllPlacedClose(props.history):props.onCloseResult();}}):null);};var mapStateToProps=function mapStateToProps(state){return{prompt:state.cartReducer.cart.guestPrompt,policy:state.cartReducer.cart.guestPolicy,guests:state.cartReducer.cart.guests||[],lastRecipientId:state.cartReducer.cart.lastRecipientId,batchResult:state.cartReducer.cart.batchResult};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onChoose:function onChoose(choice){return dispatch(__WEBPACK_IMPORTED_MODULE_3_actions_index__["n" /* chooseGuestRecipient */](choice));},onCancel:function onCancel(){return dispatch(__WEBPACK_IMPORTED_MODULE_3_actions_index__["f" /* cancelGuestRecipient */]());},onCloseResult:function onCloseResult(){return dispatch(__WEBPACK_IMPORTED_MODULE_3_actions_index__["p" /* closeBatchResult */]());},// Everything placed: the basket is cleared, as after any placed order.
onAllPlacedClose:function onAllPlacedClose(history){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_actions_Cart__["o" /* closeModalPlacedOrderOnCart */])(history));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["g" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(GuestRecipient)));

/***/ }),
/* 838 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_modal__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoc_ReactAux_ReactAux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_images_cart_mark_png__ = __webpack_require__(286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_images_cart_mark_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_images_cart_mark_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config_guestOrdering__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Cart_css__ = __webpack_require__(308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Cart_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Cart_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ME='me';var NEW_GUEST='new';var customStyles={// Same as the other .lb-geral modals: the .lb-geral layer is position: fixed and
// centres itself. A transform or overflow here traps it in a 0x0 box, so the
// sheet was invisible behind the dimmed overlay on phones.
content:{background:'none',border:'none',padding:0},overlay:{zIndex:'9999999',width:'100%',height:'100%',left:'0',top:'0',backgroundColor:'rgba(0, 0, 0, 0.7)'}};// "Who's this for?": Me, each guest already in the basket, or + New guest.
// Mounted fresh for every Add to basket, so it starts on whoever was picked last.
var GuestRecipientSheet=function(_Component){_inherits(GuestRecipientSheet,_Component);function GuestRecipientSheet(props){_classCallCheck(this,GuestRecipientSheet);var _this=_possibleConstructorReturn(this,(GuestRecipientSheet.__proto__||Object.getPrototypeOf(GuestRecipientSheet)).call(this,props));_this.select=function(choice){_this.setState({choice:choice,showError:false});};_this.handleFirstName=function(event){_this.setState({firstName:event.target.value,showError:false});};_this.handleLastName=function(event){_this.setState({lastName:event.target.value,showError:false});};_this.handleSubmit=function(event){if(event)event.preventDefault();var _this$state=_this.state,choice=_this$state.choice,firstName=_this$state.firstName,lastName=_this$state.lastName;if(choice===ME){_this.props.onAdd({});}else if(choice===NEW_GUEST){if(!Object(__WEBPACK_IMPORTED_MODULE_4__config_guestOrdering__["p" /* isValidGuestName */])(firstName)||!Object(__WEBPACK_IMPORTED_MODULE_4__config_guestOrdering__["p" /* isValidGuestName */])(lastName)){_this.setState({showError:true});return;}_this.props.onAdd({newGuest:{firstName:firstName,lastName:lastName}});}else{_this.props.onAdd({guestId:choice});}};var lastId=Object(__WEBPACK_IMPORTED_MODULE_4__config_guestOrdering__["j" /* defaultRecipient */])(props.lastRecipientId,props.guests);_this.state={choice:lastId||ME,firstName:'',lastName:'',showError:false};return _this;}_createClass(GuestRecipientSheet,[{key:'renderRow',value:function renderRow(value,label,tag){var _this2=this;var id='guest-recipient-'+value;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'guest-recipient-row',key:value},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'radio',name:'guestRecipient',id:id,checked:this.state.choice===value,onChange:function onChange(){return _this2.select(value);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:id,className:value===NEW_GUEST?'guest-recipient-new':''},label,tag?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'guest-recipient-tag'},tag):null));}},{key:'render',value:function render(){var _this3=this;var _props=this.props,policy=_props.policy,guests=_props.guests,subtitle=_props.subtitle,onCancel=_props.onCancel;var addingAllowed=Object(__WEBPACK_IMPORTED_MODULE_4__config_guestOrdering__["e" /* canAddGuest */])(policy,guests.length);var isNew=this.state.choice===NEW_GUEST;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_modal___default.a,{isOpen:true,style:customStyles,onRequestClose:onCancel,shouldCloseOnOverlayClick:true,shouldCloseOnEsc:true,aria:{labelledby:'guest-recipient-title'},contentLabel:'Who\'s this for?'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'lb-geral lb-guest-recipient_ mfp-bg-login white-popup-block singup zoom-anim-dialog'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'lb-padrao-singup6 mfp-content-login modal-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:onCancel,type:'button',className:'bt-close mfp-close lb-fechar fa fa-times','aria-label':'Close'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'check-mark'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{alt:'',src:__WEBPACK_IMPORTED_MODULE_3_images_cart_mark_png___default.a})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{className:'lb-content',onSubmit:this.handleSubmit,noValidate:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{id:'guest-recipient-title',className:'guest-recipient-title'},'Who\'s this for?'),subtitle?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'guest-recipient-subtitle'},subtitle):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'guest-recipient-rows',role:'radiogroup','aria-labelledby':'guest-recipient-title'},this.renderRow(ME,'Me'),guests.map(function(guest){return _this3.renderRow(guest.id,Object(__WEBPACK_IMPORTED_MODULE_4__config_guestOrdering__["k" /* guestDisplayName */])(guest),'Guest');}),addingAllowed?this.renderRow(NEW_GUEST,'+ New guest'):null),addingAllowed&&isNew?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_hoc_ReactAux_ReactAux__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'guestFirstName',className:'guest-recipient-field-label'},'Guest\'s first name'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{id:'guestFirstName',className:'guest-recipient-field',type:'text',maxLength:__WEBPACK_IMPORTED_MODULE_4__config_guestOrdering__["b" /* GUEST_NAME_MAX */],autoComplete:'off',autoFocus:true,'aria-invalid':this.state.showError,'aria-describedby':'guestRecipientError',value:this.state.firstName,onChange:this.handleFirstName}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'guestLastName',className:'guest-recipient-field-label'},'Guest\'s last name'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{id:'guestLastName',className:'guest-recipient-field',type:'text',maxLength:__WEBPACK_IMPORTED_MODULE_4__config_guestOrdering__["b" /* GUEST_NAME_MAX */],autoComplete:'off','aria-invalid':this.state.showError,'aria-describedby':'guestRecipientError',value:this.state.lastName,onChange:this.handleLastName})):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'guest-recipient-note'},Object(__WEBPACK_IMPORTED_MODULE_4__config_guestOrdering__["s" /* recipientNote */])(policy,guests.length)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{id:'guestRecipientError',className:'guest-recipient-error',role:'alert'},this.state.showError?__WEBPACK_IMPORTED_MODULE_4__config_guestOrdering__["a" /* GUEST_NAME_ERROR */]:''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'submit',className:'orange-bold guest-recipient-add'},'Add to basket')))));}}]);return GuestRecipientSheet;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (GuestRecipientSheet);

/***/ }),
/* 839 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_modal__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_guestOrdering__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_UI_ErrorReference__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_userError__ = __webpack_require__(15);
var customStyles={content:{background:'none',border:'none',padding:0,top:'50%',left:'50%',right:'auto',bottom:'auto',transform:'translate(-50%, -50%)',maxHeight:'95vh',overflow:'auto'},overlay:{zIndex:'9999999',width:'100%',height:'100%',left:'0',top:'0',backgroundColor:'rgba(0, 0, 0, 0.7)'}};// "2 orders placed" (the existing green success look) or "Some orders weren't placed"
// (the existing red error look) after sending one order per person.
var GuestOrdersResult=function GuestOrdersResult(_ref){var result=_ref.result,onClose=_ref.onClose;var title=Object(__WEBPACK_IMPORTED_MODULE_2__config_guestOrdering__["d" /* batchResultTitle */])(result);var lines=Object(__WEBPACK_IMPORTED_MODULE_2__config_guestOrdering__["c" /* batchResultLines */])(result);// What support needs when an order wasn't placed: the code, when, and the server's id.
var failure=!result.allPlaced&&result.failureCode?Object(__WEBPACK_IMPORTED_MODULE_4__utils_userError__["g" /* toDisplayError */])({title:title,referenceCode:result.failureCode,at:result.failureAt,serverId:result.failureServerId}):null;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_modal___default.a,{isOpen:true,style:customStyles,onRequestClose:onClose,shouldCloseOnOverlayClick:true,shouldCloseOnEsc:true,role:result.allPlaced?'dialog':'alertdialog',aria:{labelledby:'guest-orders-result-title',describedby:'guest-orders-result-message'},contentLabel:title},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'lb-geral '+(result.allPlaced?'lb-placed_':'lb-error_')+' mfp-bg-login white-popup-block singup zoom-anim-dialog guest-orders-result'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'lb-padrao-singup6 mfp-content-login modal-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:onClose,type:'button',className:'bt-close mfp-close lb-fechar fa fa-times','aria-label':'Close'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'check-mark'},result.allPlaced?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'fa fa-check-circle lt-success-tick','aria-hidden':'true'}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{alt:'',src:__webpack_require__(840)})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'lb-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'order',id:'guest-orders-result-message'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',{id:'guest-orders-result-title'},title),lines.map(function(line,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'guest-orders-result-line',key:index},line);}),failure&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_UI_ErrorReference__["a" /* default */],{error:failure,showContact:true,onContactSupport:onClose})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{onClick:onClose,className:'bt',role:'button',tabIndex:0},result.allPlaced?'Got it':'Close')))));};/* harmony default export */ __webpack_exports__["a"] = (GuestOrdersResult);

/***/ }),
/* 840 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEMAAABDCAMAAADwFEhBAAAAnFBMVEUAAAD///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////+TINBkAAAAM3RSTlMA/QT4Xgrx5HMGb73Jwh0T9HhaVCPoh063QCne17rs2b8PnI9rYkMfobOsl0aUGDYx04EidUY9AAADIUlEQVRYw61YbXeyMAwNCAgovivqFJgC4nS6jf//356TgCv0hcHhuV+208aSpvcmTUEJc2efojDQci0Io5OdmtARk/lokNehefMJtIZjRFougxYZDrSBaa9zNdZ2iz0th8x+e3YXfuov3POWrTtcQjNW25fb23hfm9nH29cGjytogGEVVm/2QzL7cN+KacsAFfRbYXIwdJWFcShMbgqL9yNNz2yaV61iz4r9vMtmp2Oa9CZ/Uccju/FU4gUtoW10+Av6RqNFBE+cEY4PFtAGC+LwiOfbJ4XiDu1wp6B8cswiL1Joizt5sqxRy8JYLKA9FhrypEo2CsYGumBDIaksSoeqQxfodMTGr1KHGM8LdMNlhgJ8qdjGFefQFXP8mV1SA90InWrAMkfB0WNFzE6IjhSWRrExhljLj9JMsx/mwRMQ/A8jFHsloD8qOXwFdR7qmAoiig2etAsM5xzxLWhvZxERfTbiIqsuZWgGUy5Y6BqXrXyiprWrSh2H5iW/rnXzhIS5/hLHgtoYXAuembhWzCdm4Zt2kY8532Lcgwk7nNsDh3RGOvYZsxEHPkZ7HN3RB9Yg4BlQSjKKAzipUteaaIbTIzkXEC6S6YP+HUk4g6UkA5TOTcrJkH75A2aRqz8k3CUeeHCgjzUk6VP5RyprF6ME6HKiKBZRTmhILgkeFliU0+Qwr68lbFV1RgoAWvjKRFMu4qoMfJzl/RAlQuJ5NPgx4OMhSoSJRxGPoOFcwNCI8Uw88nMJweOKjSgRJlgVPzKep6JEUouJR8pTUS+CRJh45HqR65ZJhBOPVLfy/GGOOIlMDqV4pPmD5TFRKbowdNPFPCbmU/bRTV08zDUunwp5nW3elofoaIp5Xawv5LWWqI5qI9YXsc5NvrGKqBiV6bI65+ByYS1+1k5Vps8Vvyr1FmK+7pt7UODJl7L4P94/YNn3HkTS6XEf630v7HM/Tbn7ac97cv/7ev++oX//ou6jLLexj3Itvo/q38+p+0q3e1/JyHb87W+TVX0m4frb7n32kOuze/b7Pd8dPMPp9/4x7vD+wd5hMq98h/GypneYf2Ue0754y43FAAAAAElFTkSuQmCC"

/***/ }),
/* 841 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__OrderFeedbackCard_css__ = __webpack_require__(842);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__OrderFeedbackCard_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__OrderFeedbackCard_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var REORDER_SCORE_OPTIONS=[1,2,3,4,5,6,7,8,9,10];var IMPROVEMENT_OPTIONS=[{label:'Food quality',value:'food_quality'},{label:'Portion size',value:'portion_size'},{label:'Delivery timing',value:'delivery_timing'},{label:'Packaging',value:'packaging'},{label:'Menu choice',value:'menu_choice'},{label:'Nothing',value:'nothing'}];var OrderFeedbackCard=function(_Component){_inherits(OrderFeedbackCard,_Component);function OrderFeedbackCard(){var _ref;var _temp,_this,_ret;_classCallCheck(this,OrderFeedbackCard);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=OrderFeedbackCard.__proto__||Object.getPrototypeOf(OrderFeedbackCard)).call.apply(_ref,[this].concat(args))),_this),_this.state={reorderScore:null,overallScore:null,improvementTags:[],otherComments:''},_this.toggleImprovement=function(value){_this.setState(function(previousState){if(value==='nothing'){return{improvementTags:['nothing']};}var withoutNothing=previousState.improvementTags.filter(function(tag){return tag!=='nothing';});return withoutNothing.includes(value)?{improvementTags:withoutNothing.filter(function(tag){return tag!==value;})}:{improvementTags:[].concat(_toConsumableArray(withoutNothing),[value])};});},_this.handleSubmit=function(){_this.props.onSubmit({previousOrderId:_this.props.feedback.previousOrderId,restaurantId:_this.props.feedback.restaurantId,orderedItemsSnapshot:_this.props.feedback.orderedItemsSnapshot,reorderScore:_this.state.reorderScore,overallScore:_this.state.overallScore,improvementTags:_this.state.improvementTags,otherComments:_this.state.otherComments.trim()});},_this.handleSkip=function(){_this.props.onSkip({previousOrderId:_this.props.feedback.previousOrderId,restaurantId:_this.props.feedback.restaurantId,orderedItemsSnapshot:_this.props.feedback.orderedItemsSnapshot});},_this.renderOption=function(option,selected,_onClick){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',key:option.value,className:'order-feedback-chip'+(selected?' is-selected':''),'aria-pressed':selected,'aria-label':option.label,onClick:function onClick(){return _onClick(option.value);}},option.label);},_this.renderScoreOption=function(score,fieldName){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',key:score,className:'order-feedback-chip order-feedback-score'+(_this.state[fieldName]===score?' is-selected':''),'aria-pressed':_this.state[fieldName]===score,'aria-label':score+' out of 10',onClick:function onClick(){return _this.setState(_defineProperty({},fieldName,score));}},score);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(OrderFeedbackCard,[{key:'render',value:function render(){var _this2=this;if(!this.props.feedback){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'order-feedback-card','aria-label':'Lunch feedback'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,'Help us improve lunch in 10 seconds'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'order-feedback-summary'},'Last order:',' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,this.props.feedback.orderedItemsSnapshot),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'From: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,this.props.feedback.restaurantName))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('fieldset',{className:'order-feedback-question'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('legend',null,'How was it overall?'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'order-feedback-scale-hint'},'1 = bad, 10 = great'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'order-feedback-options order-feedback-score-options'},REORDER_SCORE_OPTIONS.map(function(score){return _this2.renderScoreOption(score,'overallScore');}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('fieldset',{className:'order-feedback-question'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('legend',null,'How likely are you to order this again?'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'order-feedback-scale-hint'},'1 = not likely, 10 = definitely'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'order-feedback-options order-feedback-score-options'},REORDER_SCORE_OPTIONS.map(function(score){return _this2.renderScoreOption(score,'reorderScore');}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('fieldset',{className:'order-feedback-question'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('legend',null,'What could be better?'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'order-feedback-options'},IMPROVEMENT_OPTIONS.map(function(option){return _this2.renderOption(option,_this2.state.improvementTags.includes(option.value),_this2.toggleImprovement);}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'order-feedback-comments'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Other comments'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea',{value:this.state.otherComments,rows:'2',maxLength:'500',onChange:function onChange(event){return _this2.setState({otherComments:event.target.value});}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'order-feedback-actions'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'order-feedback-submit',onClick:this.handleSubmit},'Done'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'order-feedback-skip',onClick:this.handleSkip},'Skip')));}}]);return OrderFeedbackCard;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);OrderFeedbackCard.propTypes={feedback:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({previousOrderId:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,restaurantId:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,restaurantName:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,orderedItemsSnapshot:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired}),onSubmit:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,onSkip:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (OrderFeedbackCard);

/***/ }),
/* 842 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 843 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export LandingBuilder */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Header__ = __webpack_require__(844);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Footer__ = __webpack_require__(851);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Clients__ = __webpack_require__(853);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__WhyUseUs__ = __webpack_require__(918);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__WhatWeDo__ = __webpack_require__(919);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__LunchMadeSimple__ = __webpack_require__(922);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__LunchTeamMainPresentation__ = __webpack_require__(926);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__RegisterCompany__ = __webpack_require__(930);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_utils_queryString__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_utils_magicLink__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_actions_SignUp__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_actions_Landing__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_ismobilejs__ = __webpack_require__(933);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_ismobilejs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_ismobilejs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__landing_scss__ = __webpack_require__(934);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__landing_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__landing_scss__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var pendingSignIn=false;var LandingBuilder=function(_Component){_inherits(LandingBuilder,_Component);function LandingBuilder(props){_classCallCheck(this,LandingBuilder);var _this=_possibleConstructorReturn(this,(LandingBuilder.__proto__||Object.getPrototypeOf(LandingBuilder)).call(this,props));_this.onHandeReferralFriend=function(){var values=__WEBPACK_IMPORTED_MODULE_11_utils_queryString__["a" /* default */].parse(_this.props.location.search);if(values.isReferalLink){var combinedToken=values.combinedToken.substr(0,values.combinedToken.indexOf('+'));_this.props.onSetReferalFriendCode(combinedToken);}};_this.onHandleLinkCode=function(){var values=__WEBPACK_IMPORTED_MODULE_11_utils_queryString__["a" /* default */].parse(_this.props.location.search);if(values.isCodeLink){var code=values.code;_this.props.onSetLinkCode(code);}};_this.redirectPath=function(){var values=__WEBPACK_IMPORTED_MODULE_11_utils_queryString__["a" /* default */].parse(_this.props.location&&_this.props.location.search||'');return Object(__WEBPACK_IMPORTED_MODULE_12_utils_magicLink__["s" /* safeRedirectPath */])(values.redirect);};_this.wantsSignIn=function(){var values=__WEBPACK_IMPORTED_MODULE_11_utils_queryString__["a" /* default */].parse(_this.props.location&&_this.props.location.search||'');if(values.signin==='1'){pendingSignIn=true;}return pendingSignIn;};_this.onSignInClosed=function(){pendingSignIn=false;};_this.onHandleHowItWorks=function(){var domNode=__WEBPACK_IMPORTED_MODULE_2_react_dom___default.a.findDOMNode(_this.howItWorksElement);domNode.scrollIntoView();};_this.onHandleWhatWeDo=function(){var domNode=__WEBPACK_IMPORTED_MODULE_2_react_dom___default.a.findDOMNode(_this.whatWeDoElement);domNode.scrollIntoView();};_this.onHandleOurClients=function(){var domNode=__WEBPACK_IMPORTED_MODULE_2_react_dom___default.a.findDOMNode(_this.ourClientsElement);domNode.scrollIntoView();};_this.onHandleWhyUseUs=function(){var domNode=__WEBPACK_IMPORTED_MODULE_2_react_dom___default.a.findDOMNode(_this.whyUseUsElement);domNode.scrollIntoView();};_this.onHandleFindOutMore=function(){if(__WEBPACK_IMPORTED_MODULE_15_ismobilejs___default.a.any){_this.props.onToggleRegisterCompany(true);}else{window.LC_API.open_mobile_window();}};_this.howItWorksElement=null;_this.whatWeDoElement=null;_this.ourClientsElement=null;_this.whyUseUsElement=null;return _this;}_createClass(LandingBuilder,[{key:'componentDidMount',value:function componentDidMount(){this.onHandeReferralFriend();this.onHandleLinkCode();}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){// Only when an email check has just started a signup. Never for an account that
// pre-login says is registered (preLogin), and never again on unrelated updates.
if(this.props.goToSignup&&!prevProps.goToSignup&&!this.props.preLogin){this.props.history.push('/Signup');}}// Where to go after signing in (?redirect=, same-site paths only).
// /?signin=1 opens the sign-in panel straight away (used by "Use my password instead"
// on /MagicLogin and by the Signup guard). The first automatic-login check bounces
// the page to /Menu and back to /?redirect=/Menu, dropping the query, so the request
// is remembered until the person closes the panel.
},{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'home'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Header__["a" /* default */],{handleHowItWorks:this.onHandleHowItWorks,handleWhatWeDo:this.onHandleWhatWeDo,handleOurClients:this.onHandleOurClients,preLogin:this.props.preLogin,redirect:this.redirectPath(),openSignIn:this.wantsSignIn(),onSignInClosed:this.onSignInClosed,handleWhyUseUs:this.onHandleWhyUseUs}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__LunchTeamMainPresentation__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__RegisterCompany__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__WhatWeDo__["a" /* default */],{whatWeDoRef:function whatWeDoRef(el){return _this2.whatWeDoElement=el;},HandleFindOutMore:this.onHandleFindOutMore}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__LunchMadeSimple__["a" /* default */],{howItWorksRef:function howItWorksRef(el){return _this2.howItWorksElement=el;},HandleFindOutMore:this.onHandleFindOutMore}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__WhyUseUs__["a" /* default */],{whyUseUsRef:function whyUseUsRef(el){return _this2.whyUseUsElement=el;},HandleFindOutMore:this.onHandleFindOutMore}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Clients__["a" /* default */],{ourClientsRef:function ourClientsRef(el){return _this2.ourClientsElement=el;},HandleFindOutMore:this.onHandleFindOutMore}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Footer__["a" /* default */],{handleHowItWorks:this.onHandleHowItWorks,handleWhatWeDo:this.onHandleWhatWeDo,handleOurClients:this.onHandleOurClients,handleWhyUseUs:this.onHandleWhyUseUs}));}}]);return LandingBuilder;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{goToSignup:state.signupReducer.goToSignup,preLogin:state.signupReducer.preLogin};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onSetReferalFriendCode:function onSetReferalFriendCode(combinedToken){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_13_actions_SignUp__["i" /* setReferalFriendCode */])(combinedToken));},onSetLinkCode:function onSetLinkCode(code){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_13_actions_SignUp__["h" /* setLinkCode */])(code));},onToggleRegisterCompany:function onToggleRegisterCompany(toggle){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_14_actions_Landing__["m" /* toggleRegisterCompany */])(toggle));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(LandingBuilder));

/***/ }),
/* 844 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Header */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Login_scss__ = __webpack_require__(845);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Login_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Login_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_hoc_ReactAux_ReactAux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_images_logo_3_png__ = __webpack_require__(847);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_images_logo_3_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_images_logo_3_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_images_close_svg__ = __webpack_require__(848);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_images_close_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_images_close_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_actions_index__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__SignInPanel__ = __webpack_require__(849);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/* eslint-disable jsx-a11y/no-redundant-roles */var Header=function(_Component){_inherits(Header,_Component);function Header(props){_classCallCheck(this,Header);var _this=_possibleConstructorReturn(this,(Header.__proto__||Object.getPrototypeOf(Header)).call(this,props));_this.openSignIn=function(){_this.setState({signInOpen:true,menuMobileActive:false});};_this.closeSignIn=function(){_this.setState({signInOpen:false});_this.props.onSignInClosed&&_this.props.onSignInClosed();};_this.handleSubmitEmail=function(email){return _this.props.onRequestVerifyEmail({email:email.trim()});};_this.handleLogin=function(_ref){var password=_ref.password,staySigned=_ref.staySigned;var credentials={email:(_this.props.email||'').trim(),password:password,staySigned:staySigned};return _this.props.onRequestLogin(credentials);};_this.handleForgotPassword=function(){_this.props.onRequestEmailResetPassword(_this.props.email);};_this.handleUseDifferentEmail=function(){_this.props.onResetPreLogin&&_this.props.onResetPreLogin();};_this.state={menuMobileActive:false,// Open straight away when coming back mid sign-in (pre-login already done) or
// from a "sign in" link (/?signin=1).
signInOpen:!!props.preLogin||!!props.openSignIn};_this.changeMenuClass=_this.changeMenuClass.bind(_this);return _this;}_createClass(Header,[{key:'changeMenuClass',value:function changeMenuClass(){this.setState({menuMobileActive:!this.state.menuMobileActive});}},{key:'componentDidMount',value:function componentDidMount(){if(!!this.props.needToTryAutomaticLogin){this.props.tryAutomaticallyLogin();}}},{key:'componentDidUpdate',value:function componentDidUpdate(previousProps){if(!previousProps.preLogin&&this.props.preLogin&&!this.state.signInOpen){this.setState({signInOpen:true,menuMobileActive:false});}if(!previousProps.openSignIn&&this.props.openSignIn&&!this.state.signInOpen){this.setState({signInOpen:true,menuMobileActive:false});}}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_hoc_ReactAux_ReactAux__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',{className:'header','aria-label':'Lunch Team Header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'wrap'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'logo left',href:'./'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{alt:'Lunch Team Logo',src:__WEBPACK_IMPORTED_MODULE_4_images_logo_3_png___default.a})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:this.state.menuMobileActive?'menu-bt-mobile right open':'menu-bt-mobile right',onClick:this.changeMenuClass,'aria-label':'Open menu','aria-expanded':this.state.menuMobileActive},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg',{className:'svg-inline--fa fa-bars fa-w-14','aria-hidden':'true','data-prefix':'fas','data-icon':'bars',role:'img',xmlns:'http://www.w3.org/2000/svg',viewBox:'0 0 448 512','data-fa-i2svg':''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'currentColor',d:'M16 132h416c8.837 0 16-7.163 16-16V76c0-8.837-7.163-16-16-16H16C7.163 60 0 67.163 0 76v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16z'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'header-sign-in right',onClick:this.openSignIn,'aria-haspopup':'dialog'},'Sign in'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('nav',{className:'menu left',role:'navigation'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'lista-menu'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{onClick:this.props.handleHowItWorks},'How It Works')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{onClick:this.props.handleWhatWeDo},'What We Do')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{onClick:this.props.handleOurClients},'Some Of Our Clients')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{onClick:this.props.handleWhyUseUs},'Benefits')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{onClick:function onClick(){return window.open('https://forms.gle/tP6qdYZrb8K8fh7i7');}},'Become a Driver today!')))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:this.state.menuMobileActive?'menu-mobile-drop open':'menu-mobile-drop','aria-hidden':!this.state.menuMobileActive},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button','aria-label':'Close menu',className:'close-drop',onClick:this.changeMenuClass,tabIndex:this.state.menuMobileActive?0:-1},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{alt:'',src:__WEBPACK_IMPORTED_MODULE_5_images_close_svg___default.a})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'login'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'header-sign-in header-sign-in--menu',onClick:this.openSignIn,'aria-haspopup':'dialog',tabIndex:this.state.menuMobileActive?0:-1},'Sign in or create an account'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__SignInPanel__["a" /* default */],{open:this.state.signInOpen,onClose:this.closeSignIn,preLogin:!!this.props.preLogin,email:this.props.email,redirect:this.props.redirect,onSubmitEmail:this.handleSubmitEmail,onLogin:this.handleLogin,onForgotPassword:this.handleForgotPassword,onUseDifferentEmail:this.handleUseDifferentEmail}));}}]);return Header;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onRequestVerifyEmail:function onRequestVerifyEmail(credentials){return dispatch(__WEBPACK_IMPORTED_MODULE_6_actions_index__["_18" /* requestVerifyEmail */](credentials));},onRequestEmailResetPassword:function onRequestEmailResetPassword(email){return dispatch(__WEBPACK_IMPORTED_MODULE_6_actions_index__["_15" /* requestEmailResetPassword */](email));},onRequestLogin:function onRequestLogin(credentials){return dispatch(__WEBPACK_IMPORTED_MODULE_6_actions_index__["_16" /* requestLogin */](credentials,{showSpinner:false}));},onResetPreLogin:function onResetPreLogin(){return dispatch(__WEBPACK_IMPORTED_MODULE_6_actions_index__["_20" /* resetPreLogin */]());},tryAutomaticallyLogin:function tryAutomaticallyLogin(credentials){return dispatch(__WEBPACK_IMPORTED_MODULE_6_actions_index__["_40" /* tryAutomaticallyLogin */](credentials));}};};var mapStateToProps=function mapStateToProps(state){return{email:state.signupReducer.email,needToTryAutomaticLogin:state.signupReducer.needToTryAutomaticLogin};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(Header));

/***/ }),
/* 845 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(846);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(17)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../lunch-team-client-checkout-msg/node_modules/css-loader/index.js!../../../../../../../lunch-team-client-checkout-msg/node_modules/sass-loader/dist/cjs.js!./Login.scss", function() {
			var newContent = require("!!../../../../../../../lunch-team-client-checkout-msg/node_modules/css-loader/index.js!../../../../../../../lunch-team-client-checkout-msg/node_modules/sass-loader/dist/cjs.js!./Login.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 846 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(14)(undefined);
// imports


// module
exports.push([module.i, ".login-flex{display:flex;align-items:baseline}.login-flex input{color:#fff}.forgot{margin-top:7px}.forgot>span{font-size:12px}.checkbox-remember{margin-top:10px}.container{font-size:12px;position:relative;padding-left:23px;cursor:pointer;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.container input{position:absolute;opacity:0;cursor:pointer}.checkmark{border:1px solid #769885;position:absolute;top:0;left:0;height:18px;width:18px;border-radius:8px;margin:0 8px 0 0;vertical-align:middle;background-color:#0e7a4b}.container input:checked~.checkmark{background-color:#0e7a4b}.checkmark:after{content:\"\";position:absolute;display:none}.container input:checked~.checkmark:after{display:block}.container .checkmark:after{left:4px;top:4px;width:4px;height:4px;border:solid #fff;border-width:0 2px 2px 0;-webkit-transform:rotate(35deg);-ms-transform:rotate(35deg);transform:rotate(35deg)}a[target=_blank]{color:#0e7a4b;text-decoration:none;border-bottom:1px}a[target=_blank]:hover{opacity:.7}.header-sign-in{min-height:44px;margin:6px 0 0 0;padding:0 24px;border:2px solid #0e7a4b;border-radius:6px;background:#0e7a4b;color:#fff;cursor:pointer;font-family:inherit;font-size:15px;font-weight:700;line-height:1;transition:background-color .2s,border-color .2s}.header-sign-in:hover{background:#075c38;border-color:#075c38}.header-sign-in:focus{outline:3px solid #fff;outline-offset:2px}.header .menu-bt-mobile{border:0;cursor:pointer;line-height:1}@media only screen and (max-width: 1214px){.header .header-sign-in{min-height:44px;margin:12px 10px 0 0;padding:0 18px}}.menu-mobile-drop .close-drop{padding:0;border:0;background:none;cursor:pointer}.menu-mobile-drop .header-sign-in--menu{display:block;width:calc(100% - 32px);max-width:360px;min-height:48px;margin:48px auto 0;font-size:16px}.menu-mobile-drop .header-sign-in--menu:focus{outline-color:#0b2318}", ""]);

// exports


/***/ }),
/* 847 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 848 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/close.4ceeeab0.svg";

/***/ }),
/* 849 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VIEWS */
/* unused harmony export SignInPanel */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services_magicLinkService__ = __webpack_require__(333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_utils_googleAnalytics__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_SignIn_CheckEmail__ = __webpack_require__(334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_utils_magicLink__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_SignIn_SignIn_scss__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_SignIn_SignIn_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_components_SignIn_SignIn_scss__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var VIEWS={EMAIL:'email',CHECKING:'checking',LINK:'link',PASSWORD:'password',SENT:'sent'};var FOCUSABLE='a[href], button:not([disabled]), input:not([disabled]):not([tabindex="-1"]), [tabindex="0"]';// The whole web sign-in in one dialog (full-screen sheet on phones).
//
// 1. Email first: pre-login decides between sign-in and signup.
// 2. Registered email: if POST /user/v1/login/magic-link-status says links are enabled,
//    "Email me a sign-in link" is the main button and "Use my password instead" opens
//    the password form. Otherwise it is the password form as before. "enforced" is
//    ignored on purpose: password sign-in is always one tap away.
// 3. After sending: "Check your email" with a 30-second resend countdown.
var SignInPanel=function(_Component){_inherits(SignInPanel,_Component);function SignInPanel(props){_classCallCheck(this,SignInPanel);var _this=_possibleConstructorReturn(this,(SignInPanel.__proto__||Object.getPrototypeOf(SignInPanel)).call(this,props));_this.handleDocumentKeyDown=function(event){if(event.key==='Escape'||event.keyCode===27){_this.props.onClose&&_this.props.onClose();}};_this.handleDialogKeyDown=function(event){if(event.key!=='Tab'||!_this.dialog){return;}var nodes=Array.prototype.slice.call(_this.dialog.querySelectorAll(FOCUSABLE));if(!nodes.length){return;}var first=nodes[0];var last=nodes[nodes.length-1];if(event.shiftKey&&document.activeElement===first){event.preventDefault();last.focus();}else if(!event.shiftKey&&document.activeElement===last){event.preventDefault();first.focus();}};_this.handleOverlayClick=function(event){if(event.target===event.currentTarget){_this.props.onClose&&_this.props.onClose();}};_this.updateField=function(_ref){var target=_ref.target;_this.setState(_defineProperty({},target.name,target.type==='checkbox'?target.checked:target.value));};_this.handleSubmitEmail=function(event){event&&event.preventDefault&&event.preventDefault();var email=_this.state.emailInput.trim();if(!email||_this.state.submittingEmail){return undefined;}_this.setState({submittingEmail:true});var done=function done(){return _this.safeSetState({submittingEmail:false});};return Promise.resolve(_this.props.onSubmitEmail&&_this.props.onSubmitEmail(email)).then(done,done);};_this.handleLogin=function(event){event&&event.preventDefault&&event.preventDefault();if(_this.state.loggingIn||!_this.state.password){return undefined;}_this.setState({loggingIn:true});var done=function done(){return _this.safeSetState({loggingIn:false});};return Promise.resolve(_this.props.onLogin&&_this.props.onLogin({password:_this.state.password,staySigned:_this.state.staySigned})).then(done,done);};_this.handleUsePassword=function(){_this.track(__WEBPACK_IMPORTED_MODULE_2_utils_googleAnalytics__["a" /* SIGN_IN_EVENTS */].PASSWORD_FALLBACK_CLICKED,_this.view());_this.setState({choice:'password',message:'',messageIsError:false});};_this.handleUseLink=function(){_this.setState({choice:'link',message:'',messageIsError:false});};_this.handleChangeEmail=function(){_this.setState({emailInput:_this.props.email||_this.state.emailInput});_this.props.onUseDifferentEmail&&_this.props.onUseDifferentEmail();};_this.handleRequestLink=function(){var email=(_this.props.email||'').trim();if(!email||_this.state.sending){return undefined;}var resend=_this.state.choice==='sent';_this.track(__WEBPACK_IMPORTED_MODULE_2_utils_googleAnalytics__["a" /* SIGN_IN_EVENTS */].MAGIC_LINK_REQUESTED,resend?'resend':'first');Object(__WEBPACK_IMPORTED_MODULE_4_utils_magicLink__["q" /* rememberMagicLinkContext */])({email:email,redirect:_this.props.redirect});_this.setState({sending:true,message:'',messageIsError:false});return _this.service().request(email).then(function(){_this.safeSetState(function(state){return{sending:false,choice:'sent',message:resend?'We sent you a new link. Use the newest email.':'',messageIsError:false,cooldownSeconds:__WEBPACK_IMPORTED_MODULE_4_utils_magicLink__["e" /* MAGIC_LINK_RESEND_SECONDS */],cooldownKey:state.cooldownKey+1};});}).catch(function(error){var throttled=Object(__WEBPACK_IMPORTED_MODULE_4_utils_magicLink__["j" /* isThrottled */])(error);_this.safeSetState(function(state){return{sending:false,message:Object(__WEBPACK_IMPORTED_MODULE_4_utils_magicLink__["m" /* magicLinkRequestErrorMessage */])(error),messageIsError:true,cooldownSeconds:throttled?Object(__WEBPACK_IMPORTED_MODULE_4_utils_magicLink__["r" /* retryAfterSeconds */])(error)||__WEBPACK_IMPORTED_MODULE_4_utils_magicLink__["b" /* MAGIC_LINK_DEFAULT_RETRY_SECONDS */]:state.cooldownSeconds,cooldownKey:throttled&&resend?state.cooldownKey+1:state.cooldownKey};});});};_this.state={emailInput:'',submittingEmail:false,password:'',staySigned:false,loggingIn:false,linkStatus:'idle',// idle | checking | enabled | disabled
choice:null,// null (default for the status) | 'link' | 'password' | 'sent'
sending:false,message:'',messageIsError:false,cooldownSeconds:__WEBPACK_IMPORTED_MODULE_4_utils_magicLink__["e" /* MAGIC_LINK_RESEND_SECONDS */],cooldownKey:0};return _this;}_createClass(SignInPanel,[{key:'componentDidMount',value:function componentDidMount(){if(this.props.preLogin&&this.props.email){this.loadStatus(this.props.email);}if(this.props.open){this.onOpened();}}},{key:'componentDidUpdate',value:function componentDidUpdate(previousProps,previousState){var emailChanged=previousProps.email!==this.props.email||previousProps.preLogin!==this.props.preLogin;if(emailChanged){this.resetAccountStep();if(this.props.preLogin&&this.props.email){this.loadStatus(this.props.email);}}if(!previousProps.open&&this.props.open){this.onOpened();}if(previousProps.open&&!this.props.open){this.onClosed();}if(this.props.open&&this.view(previousProps,previousState)!==this.view()){this.focusView();}}},{key:'componentWillUnmount',value:function componentWillUnmount(){this.unmounted=true;clearTimeout(this.statusTimer);this.onClosed();}},{key:'service',value:function service(){return this.props.service||__WEBPACK_IMPORTED_MODULE_1_services_magicLinkService__["a" /* default */];}},{key:'track',value:function track(action,label){var analytics=this.props.analytics||__WEBPACK_IMPORTED_MODULE_2_utils_googleAnalytics__["b" /* default */];analytics.sendSignInEvent(action,label);}},{key:'safeSetState',value:function safeSetState(update){if(!this.unmounted){this.setState(update);}}// ---- Dialog behaviour -------------------------------------------------------------
},{key:'onOpened',value:function onOpened(){this.returnFocusTo=typeof document!=='undefined'?document.activeElement:null;if(typeof document!=='undefined'&&document.body){document.body.classList.add('sign-in-open');document.addEventListener('keydown',this.handleDocumentKeyDown);}this.focusView();}},{key:'onClosed',value:function onClosed(){if(typeof document!=='undefined'&&document.body){document.body.classList.remove('sign-in-open');document.removeEventListener('keydown',this.handleDocumentKeyDown);}if(this.returnFocusTo&&typeof this.returnFocusTo.focus==='function'){this.returnFocusTo.focus();}this.returnFocusTo=null;}// Keep Tab inside the dialog.
},{key:'focusView',value:function focusView(){var _this2=this;// After the DOM for the new step exists.
setTimeout(function(){if(_this2.unmounted||!_this2.dialog){return;}var target=_this2.dialog.querySelector('[data-autofocus]')||_this2.dialog.querySelector('h2');if(target&&typeof target.focus==='function'){target.focus();}},20);}// ---- State ------------------------------------------------------------------------
},{key:'view',value:function view(){var props=arguments.length>0&&arguments[0]!==undefined?arguments[0]:this.props;var state=arguments.length>1&&arguments[1]!==undefined?arguments[1]:this.state;if(!props.preLogin||!props.email){return VIEWS.EMAIL;}if(state.choice==='sent'){return VIEWS.SENT;}if(state.choice==='password'){return VIEWS.PASSWORD;}if(state.linkStatus==='checking'||state.linkStatus==='idle'){return VIEWS.CHECKING;}if(state.linkStatus==='enabled'){return VIEWS.LINK;}return VIEWS.PASSWORD;}},{key:'resetAccountStep',value:function resetAccountStep(){clearTimeout(this.statusTimer);this.setState({linkStatus:'idle',choice:null,sending:false,password:'',loggingIn:false,message:'',messageIsError:false});}},{key:'loadStatus',value:function loadStatus(email){var _this3=this;var trimmed=(email||'').trim();if(!trimmed){return undefined;}this.setState({linkStatus:'checking'});clearTimeout(this.statusTimer);// A slow status call must never block sign-in: fall back to the password form.
this.statusTimer=setTimeout(function(){if(!_this3.unmounted&&_this3.state.linkStatus==='checking'&&_this3.props.email===email){_this3.setState({linkStatus:'disabled'});}},this.props.statusTimeoutMs);return this.service().status(trimmed).then(function(result){return!!(result&&result.enabled);},function(){return false;}).then(function(enabled){if(_this3.unmounted||_this3.props.email!==email||_this3.state.linkStatus!=='checking'){return;}clearTimeout(_this3.statusTimer);_this3.setState({linkStatus:enabled?'enabled':'disabled'});});}// ---- Handlers ---------------------------------------------------------------------
},{key:'renderMessage',// ---- Rendering --------------------------------------------------------------------
value:function renderMessage(){var _state=this.state,message=_state.message,messageIsError=_state.messageIsError;if(!message){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:messageIsError?'sign-in__message sign-in__message--error':'sign-in__message',role:messageIsError?'alert':'status'},message);}},{key:'renderAccount',value:function renderAccount(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'sign-in__account'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'sign-in__account-email'},this.props.email),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'sign-in-link sign-in__change-email',onClick:this.handleChangeEmail,'aria-label':'Use a different email'},'Change'));}},{key:'renderEmailStep',value:function renderEmailStep(){var _state2=this.state,emailInput=_state2.emailInput,submittingEmail=_state2.submittingEmail;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{className:'sign-in__email-step',onSubmit:this.handleSubmitEmail,noValidate:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{id:'sign-in-title',className:'sign-in__title',tabIndex:-1},'Sign in'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'sign-in__intro'},'Enter your work email. New to Lunch.Team? We\u2019ll help you create an account.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'sign-in__label',htmlFor:'sign-in-email'},'Work email'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{id:'sign-in-email',className:'sign-in__input',name:'emailInput',type:'email',inputMode:'email',autoComplete:'username email',autoCapitalize:'none',autoCorrect:'off',spellCheck:false,placeholder:'name@company.com',value:emailInput,onChange:this.updateField,'data-autofocus':true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'submit',className:'sign-in-btn sign-in-btn--primary sign-in__next',disabled:submittingEmail||!emailInput.trim()},submittingEmail?'Checking…':'Next'));}},{key:'renderChecking',value:function renderChecking(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'sign-in__checking'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{id:'sign-in-title',className:'sign-in__title',tabIndex:-1},'Welcome back'),this.renderAccount(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'sign-in__message',role:'status'},'One moment\u2026'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'sign-in__links'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'sign-in-link sign-in__use-password',onClick:this.handleUsePassword},'Use my password instead')));}},{key:'renderLinkStep',value:function renderLinkStep(){var sending=this.state.sending;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'sign-in__link-step'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{id:'sign-in-title',className:'sign-in__title',tabIndex:-1},'Welcome back'),this.renderAccount(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'sign-in__intro'},'We\u2019ll email you a link that signs you in. No password needed.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'sign-in-btn sign-in-btn--primary sign-in__send-link',onClick:this.handleRequestLink,disabled:sending,'data-autofocus':true},sending?'Sending…':'Email me a sign-in link'),this.renderMessage(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'sign-in__links'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'sign-in-link sign-in__use-password',onClick:this.handleUsePassword},'Use my password instead')));}},{key:'renderPasswordStep',value:function renderPasswordStep(){var _state3=this.state,password=_state3.password,staySigned=_state3.staySigned,loggingIn=_state3.loggingIn,linkStatus=_state3.linkStatus;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{className:'sign-in__password-step',onSubmit:this.handleLogin,'aria-label':'Sign in with password'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{id:'sign-in-title',className:'sign-in__title',tabIndex:-1},'Welcome back'),this.renderAccount(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'sign-in-visually-hidden',type:'email',name:'username',autoComplete:'username',value:this.props.email||'',readOnly:true,tabIndex:-1,'aria-hidden':'true'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'sign-in__label',htmlFor:'sign-in-password'},'Password'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{id:'sign-in-password',className:'sign-in__input',name:'password',type:'password',autoComplete:'current-password',value:password,onChange:this.updateField,'data-autofocus':true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'sign-in__checkbox',htmlFor:'sign-in-stay'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{id:'sign-in-stay',name:'staySigned',type:'checkbox',checked:staySigned,onChange:this.updateField}),'Stay signed in'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'submit',className:'sign-in-btn sign-in-btn--primary sign-in__login',disabled:loggingIn||!password},loggingIn?'Signing in…':'Log in'),this.renderMessage(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'sign-in__links'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'sign-in-link sign-in__forgot',onClick:this.props.onForgotPassword},'Forgot your password?'),linkStatus==='enabled'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'sign-in-link sign-in__use-link',onClick:this.handleUseLink},'Email me a sign-in link instead')));}},{key:'renderSent',value:function renderSent(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_SignIn_CheckEmail__["a" /* default */],{email:this.props.email,onResend:this.handleRequestLink,resending:this.state.sending,cooldownSeconds:this.state.cooldownSeconds,cooldownKey:this.state.cooldownKey,message:this.state.message,messageIsError:this.state.messageIsError,onUsePassword:this.handleUsePassword});}},{key:'renderView',value:function renderView(){switch(this.view()){case VIEWS.EMAIL:return this.renderEmailStep();case VIEWS.CHECKING:return this.renderChecking();case VIEWS.LINK:return this.renderLinkStep();case VIEWS.SENT:return this.renderSent();default:return this.renderPasswordStep();}}},{key:'render',value:function render(){var _this4=this;if(!this.props.open){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'sign-in-overlay',onClick:this.handleOverlayClick},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'sign-in-dialog sign-in',role:'dialog','aria-modal':'true','aria-labelledby':'sign-in-title',onKeyDown:this.handleDialogKeyDown,ref:function ref(node){_this4.dialog=node;}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'sign-in-dialog__close',onClick:this.props.onClose,'aria-label':'Close sign in'},'\xD7'),this.renderView()));}}]);return SignInPanel;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);SignInPanel.defaultProps={statusTimeoutMs:5000};/* harmony default export */ __webpack_exports__["a"] = (SignInPanel);

/***/ }),
/* 850 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(14)(undefined);
// imports


// module
exports.push([module.i, ".sign-in{color:#0b2318;font-family:\"Geist\",Arial,sans-serif;font-size:16px;line-height:1.45;text-align:left}.sign-in *,.sign-in *:before,.sign-in *:after{box-sizing:border-box}.sign-in p{margin:0 0 12px}.sign-in__title{font-size:24px;font-weight:700;line-height:1.25;margin:0 0 8px;outline:none;color:#0b2318;text-transform:none;letter-spacing:normal}.sign-in .sign-in__intro{color:#4a5f54;font-size:16px;line-height:1.45}.sign-in__label{display:block;font-size:15px;font-weight:600;margin:16px 0 6px}.sign-in .sign-in__input{display:block;width:100%;height:48px;padding:0 14px;border:1px solid #769885;border-radius:6px;background:#fff;color:#0b2318;font-size:16px}.sign-in .sign-in__input:focus{border-color:#0e7a4b;outline:2px solid rgba(14,122,75,.35);outline-offset:1px}.sign-in .sign-in-btn{display:flex;align-items:center;justify-content:center;width:100%;min-height:48px;margin:16px 0 0;padding:12px 16px;border:2px solid rgba(0,0,0,0);border-radius:6px;font-family:inherit;font-size:16px;font-weight:700;line-height:1.2;text-align:center;text-decoration:none;text-transform:none;cursor:pointer;transition:background-color .2s,border-color .2s,color .2s}.sign-in .sign-in-btn:focus{outline:3px solid rgba(14,122,75,.45);outline-offset:2px}.sign-in .sign-in-btn:disabled{cursor:not-allowed;opacity:.6}.sign-in .sign-in-btn--primary{background:#0e7a4b;color:#fff}.sign-in .sign-in-btn--primary:hover:not(:disabled){background:#075c38}.sign-in .sign-in-btn--secondary{background:#fff;border-color:#0e7a4b;color:#075c38}.sign-in .sign-in-btn--outline{background:#fff;border:1px solid #769885;color:#0b2318}.sign-in .sign-in-btn--outline:hover{border-color:#0e7a4b;color:#0b2318;opacity:1}.sign-in .sign-in-link{display:inline-block;min-height:44px;margin:12px 0 0;padding:10px 0;border:0;background:none;color:#075c38;font-family:inherit;font-size:16px;font-weight:600;text-decoration:underline;cursor:pointer}.sign-in .sign-in-link:focus{outline:3px solid rgba(14,122,75,.45);outline-offset:2px}.sign-in__links{display:flex;flex-direction:column;align-items:center;margin-top:4px;text-align:center}.sign-in__message{margin:12px 0 0 !important;font-size:15px;color:#4a5f54}.sign-in__message--error{color:#c22525}.sign-in__account{display:flex;align-items:center;justify-content:space-between;margin:8px 0 4px;padding:8px 12px;border-radius:6px;background:#eef4f0;font-size:15px}.sign-in__account .sign-in__account-email{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;font-weight:600}.sign-in__account .sign-in-link{flex-shrink:0;margin:0 0 0 8px;min-height:40px;font-size:14px}.sign-in__checkbox{display:flex;align-items:center;min-height:44px;margin-top:8px;font-size:15px;cursor:pointer}.sign-in__checkbox input[type=checkbox]{display:inline-block !important;position:static !important;flex-shrink:0;width:20px;height:20px;margin:0 10px 0 0;opacity:1 !important;-webkit-appearance:checkbox;appearance:auto;accent-color:#0e7a4b}.sign-in-check{text-align:center}.sign-in-check .sign-in__title{text-align:center}.sign-in-check__icon{color:#0e7a4b;margin-bottom:8px}.sign-in .sign-in-check__sent{font-size:17px;word-break:break-word}.sign-in .sign-in-check__help{margin:0 0 4px;padding:0;list-style:none;color:#4a5f54;font-size:15px}.sign-in .sign-in-check__help li{margin:4px 0}.sign-in-check__apps{display:flex}.sign-in-check__apps .sign-in-btn{flex:1 1 0}.sign-in-check__apps .sign-in-btn+.sign-in-btn{margin-left:12px}.sign-in-visually-hidden{position:absolute !important;width:1px !important;height:1px !important;padding:0 !important;margin:-1px !important;overflow:hidden !important;clip:rect(0, 0, 0, 0) !important;white-space:nowrap !important;border:0 !important}.sign-in-overlay{position:fixed;top:0;right:0;bottom:0;left:0;z-index:100000;display:flex;align-items:stretch;justify-content:center;background:rgba(0,0,0,.6);overflow-y:auto;-webkit-overflow-scrolling:touch}.sign-in-dialog{position:relative;width:100%;min-height:100%;padding:56px 16px 32px;background:#fff}.sign-in-dialog__close{position:absolute;top:8px;right:8px;width:44px;height:44px;border:0;border-radius:50%;background:none;color:#0b2318;font-size:28px;line-height:1;cursor:pointer}.sign-in-dialog__close:focus{outline:3px solid rgba(14,122,75,.45)}@media only screen and (min-width: 600px){.sign-in-overlay{align-items:flex-start;padding:64px 16px}.sign-in-dialog{max-width:440px;min-height:0;padding:48px 32px 32px;border-radius:16px;box-shadow:0 12px 40px rgba(0,0,0,.25)}}body.sign-in-open{overflow:hidden}", ""]);

// exports


/***/ }),
/* 851 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_utility__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_images_logo_2_png__ = __webpack_require__(852);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_images_logo_2_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_images_logo_2_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_actions_index__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__support_supportEntry__ = __webpack_require__(81);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var initialState={formIsValid:false,contactForm:{senderNameFrom:{value:'',validation:{required:true},valid:false,touched:false},company:{value:'',validation:{required:true},valid:false,touched:false},emailFrom:{value:'',validation:{required:true,email:true},valid:false,touched:false},body:{value:'',validation:{required:true},valid:false,touched:false}}};var footer=function(_Component){_inherits(footer,_Component);function footer(props){_classCallCheck(this,footer);// supportChat: the support composer is on screen, so "Chat with us" takes the contact form's place.
var _this=_possibleConstructorReturn(this,(footer.__proto__||Object.getPrototypeOf(footer)).call(this,props));_this.handleInput=function(event){var updatecontactForm=Object.assign({},_this.state.contactForm);var updateFormElement=Object.assign({},updatecontactForm[event.target.name]);updateFormElement.value=event.target.value;updateFormElement.valid=Object(__WEBPACK_IMPORTED_MODULE_2__shared_utility__["a" /* checkValidity */])(updateFormElement.value,updateFormElement.validation);updateFormElement.touched=true;updatecontactForm[event.target.name]=updateFormElement;var formIsValid=true;for(var inputIdentifier in updatecontactForm){formIsValid=updatecontactForm[inputIdentifier].valid&&formIsValid;}_this.setState({contactForm:updatecontactForm,formIsValid:formIsValid});};_this.handleSendEmail=function(event){event.preventDefault();var payload={};for(var formElementIndentifier in _this.state.contactForm){payload[formElementIndentifier]=_this.state.contactForm[formElementIndentifier].value;}_this.props.onSendEmailContact(payload);};_this.resetContactForm=function(){_this.setState(initialState);};_this.state=Object.assign({},initialState,{supportChat:Object(__WEBPACK_IMPORTED_MODULE_5__support_supportEntry__["c" /* isComposerShown */])()});return _this;}_createClass(footer,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;this.stopWatchingSupport=Object(__WEBPACK_IMPORTED_MODULE_5__support_supportEntry__["g" /* subscribeComposerShown */])(function(supportChat){return _this2.setState({supportChat:supportChat});});if(this.state.supportChat!==Object(__WEBPACK_IMPORTED_MODULE_5__support_supportEntry__["c" /* isComposerShown */])()){this.setState({supportChat:Object(__WEBPACK_IMPORTED_MODULE_5__support_supportEntry__["c" /* isComposerShown */])()});}}},{key:'componentWillUnmount',value:function componentWillUnmount(){if(this.stopWatchingSupport)this.stopWatchingSupport();}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){if(this.props.isSentEmailContact!==prevProps.isSentEmailContact){this.resetContactForm();}}},{key:'renderSupportChat',// Where the support composer is on screen: it takes questions and new sales leads (name, email and
// company before the first message), so the footer points to it instead of the contact form.
value:function renderSupportChat(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-contact form-contact--chat'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Contact'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Questions about Lunch.Team or signing up your company? Chat with us.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'bt form-contact__chat',onClick:__WEBPACK_IMPORTED_MODULE_5__support_supportEntry__["e" /* openSupportComposer */]},'Chat with us'));}},{key:'render',value:function render(){var disable={cursor:'pointer'};if(!this.state.formIsValid){disable={background:'var(--lt-color-muted)',color:'var(--lt-color-muted-foreground)',border:'1px solid var(--lt-color-border)',cursor:'not-allowed'};}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('footer',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'wrap'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{ref:this.props.footRef,className:'wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{alt:'logo',className:'logo-2',src:__WEBPACK_IMPORTED_MODULE_3_images_logo_2_png___default.a})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('nav',{className:'menu'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{onClick:this.props.handleHowItWorks,className:'get-more-info'},'How It Works'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{onClick:this.props.handleWhatWeDo},'What We Do'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{onClick:this.props.handleOurClients},'Some of Our Clients'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{onClick:this.props.handleWhyUseUs},'Benefits'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{onClick:function onClick(){return window.open('https://forms.gle/tP6qdYZrb8K8fh7i7');}},'Become a Driver today!')),this.state.supportChat?this.renderSupportChat():__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-contact'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Contact'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-1 w-50 left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{placeholder:'Enter Name',className:!this.state.contactForm['senderNameFrom'].valid&&this.state.contactForm['senderNameFrom'].touched?'Invalid':null,name:'senderNameFrom',type:'text',value:this.state.contactForm.senderNameFrom.value,onChange:this.handleInput}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{placeholder:'Enter Email',className:!this.state.contactForm['emailFrom'].valid&&this.state.contactForm['emailFrom'].touched?'Invalid':null,name:'emailFrom',type:'text',value:this.state.contactForm.emailFrom.value,onChange:this.handleInput}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{placeholder:'Enter Company',className:!this.state.contactForm['company'].valid&&this.state.contactForm['company'].touched?'Invalid':null,name:'company',type:'text',value:this.state.contactForm.company.value,onChange:this.handleInput})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-2 w-50 left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea',{placeholder:'Enter Message',className:!this.state.contactForm['body'].valid&&this.state.contactForm['body'].touched?'Invalid':null,name:'body',value:this.state.contactForm.body.value,onChange:this.handleInput}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'bt right',disabled:!this.state.formIsValid,type:'submit',style:disable,onClick:this.handleSendEmail,value:'Send'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:this.props.isSentEmailContact?'block':'none'},className:'message-sent'},'Message sent!')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'lets'},'Lets Do Lunch',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'social'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{rel:'noopener noreferrer',href:'https://www.instagram.com/lunch.team',target:'_blank'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-instagram'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'/Privacy',style:{padding:'10px 0',marginRight:'30px'}},'Privacy'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'/Terms',style:{padding:'10px 0'}},'Terms')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'copyright'},'Lunch.Team is a registered business name of Downthesofa Ireland Limited. Bookd is developed and operated by Downthesofa Ireland Limited.')));}}]);return footer;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{isSentEmailContact:state.landingReducer.isSentEmailContact};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onSendEmailContact:function onSendEmailContact(payload){return dispatch(__WEBPACK_IMPORTED_MODULE_4_actions_index__["_26" /* sendEmailContact */](payload));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(footer));

/***/ }),
/* 852 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 853 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_slick__ = __webpack_require__(323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_slick___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_slick__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_images_clients_bvlgari_jpg__ = __webpack_require__(869);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_images_clients_bvlgari_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_images_clients_bvlgari_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_images_clients_salesforce_jpg__ = __webpack_require__(870);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_images_clients_salesforce_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_images_clients_salesforce_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_images_clients_ibm_jpg__ = __webpack_require__(871);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_images_clients_ibm_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_images_clients_ibm_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_images_clients_logitech_jpg__ = __webpack_require__(872);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_images_clients_logitech_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_images_clients_logitech_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_images_clients_marketo_jpg__ = __webpack_require__(873);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_images_clients_marketo_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_images_clients_marketo_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_images_clients_mcafee_jpg__ = __webpack_require__(874);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_images_clients_mcafee_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_images_clients_mcafee_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_images_clients_pwc_jpg__ = __webpack_require__(875);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_images_clients_pwc_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_images_clients_pwc_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_images_clients_qualtrics_jpg__ = __webpack_require__(876);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_images_clients_qualtrics_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_images_clients_qualtrics_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_images_clients_tripadvisor_jpg__ = __webpack_require__(877);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_images_clients_tripadvisor_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_images_clients_tripadvisor_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_images_clients_wellsfargo_jpg__ = __webpack_require__(878);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_images_clients_wellsfargo_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_images_clients_wellsfargo_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_images_clients_twilio_jpg__ = __webpack_require__(879);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_images_clients_twilio_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_images_clients_twilio_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_images_clients_cadence_jpg__ = __webpack_require__(880);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_images_clients_cadence_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_images_clients_cadence_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_images_clients_capita_jpg__ = __webpack_require__(881);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_images_clients_capita_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_images_clients_capita_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_images_clients_zynga_jpg__ = __webpack_require__(882);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_images_clients_zynga_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_images_clients_zynga_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_images_clients_heineken_jpg__ = __webpack_require__(883);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_images_clients_heineken_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_images_clients_heineken_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_images_clients_omnicom_jpg__ = __webpack_require__(884);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_images_clients_omnicom_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_images_clients_omnicom_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_images_clients_websummit_jpg__ = __webpack_require__(885);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_images_clients_websummit_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_images_clients_websummit_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_images_clients_wrike_jpg__ = __webpack_require__(886);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_images_clients_wrike_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_images_clients_wrike_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_images_clients_mastercard_jpeg__ = __webpack_require__(887);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_images_clients_mastercard_jpeg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_images_clients_mastercard_jpeg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_images_clients_cantor_jpg__ = __webpack_require__(888);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_images_clients_cantor_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_images_clients_cantor_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_images_clients_8w_jpg__ = __webpack_require__(889);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_images_clients_8w_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_images_clients_8w_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_images_clients_cognex_jpg__ = __webpack_require__(890);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_images_clients_cognex_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_images_clients_cognex_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_images_clients_coupa_jpg__ = __webpack_require__(891);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_images_clients_coupa_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_images_clients_coupa_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_images_clients_datalex_jpg__ = __webpack_require__(892);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_images_clients_datalex_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_images_clients_datalex_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_images_clients_goodbody_jpg__ = __webpack_require__(893);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_images_clients_goodbody_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_images_clients_goodbody_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_images_clients_gso_jpg__ = __webpack_require__(894);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_images_clients_gso_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27_images_clients_gso_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_images_clients_hedgeserv_jpg__ = __webpack_require__(895);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_images_clients_hedgeserv_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28_images_clients_hedgeserv_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_images_clients_mckesson_jpg__ = __webpack_require__(896);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_images_clients_mckesson_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29_images_clients_mckesson_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_images_clients_fineos_jpg__ = __webpack_require__(897);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_images_clients_fineos_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30_images_clients_fineos_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_images_clients_avolon_jpg__ = __webpack_require__(898);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_images_clients_avolon_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31_images_clients_avolon_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_images_clients_standardlife_jpg__ = __webpack_require__(899);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_images_clients_standardlife_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32_images_clients_standardlife_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_images_clients_paulson_jpg__ = __webpack_require__(900);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_images_clients_paulson_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33_images_clients_paulson_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_images_clients_irishjobs_jpg__ = __webpack_require__(901);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_images_clients_irishjobs_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34_images_clients_irishjobs_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_images_clients_socialtalent_jpg__ = __webpack_require__(902);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_images_clients_socialtalent_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35_images_clients_socialtalent_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_images_clients_workday_jpg__ = __webpack_require__(903);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_images_clients_workday_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36_images_clients_workday_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_images_clients_quantcast_jpg__ = __webpack_require__(904);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_images_clients_quantcast_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_37_images_clients_quantcast_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38_images_clients_teneo_jpg__ = __webpack_require__(905);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38_images_clients_teneo_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_38_images_clients_teneo_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39_images_clients_orix_jpg__ = __webpack_require__(906);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39_images_clients_orix_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_39_images_clients_orix_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40_images_clients_corehr_jpg__ = __webpack_require__(907);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40_images_clients_corehr_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_40_images_clients_corehr_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41_images_clients_pilz_jpg__ = __webpack_require__(908);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41_images_clients_pilz_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_41_images_clients_pilz_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42_images_clients_segment_jpg__ = __webpack_require__(909);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42_images_clients_segment_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_42_images_clients_segment_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43_images_clients_kooomo_jpg__ = __webpack_require__(910);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43_images_clients_kooomo_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_43_images_clients_kooomo_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44_images_clients_mazars_jpg__ = __webpack_require__(911);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44_images_clients_mazars_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_44_images_clients_mazars_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45_images_clients_glanbia_jpg__ = __webpack_require__(912);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45_images_clients_glanbia_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_45_images_clients_glanbia_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46_images_clients_applovin_jpg__ = __webpack_require__(913);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46_images_clients_applovin_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_46_images_clients_applovin_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47_images_clients_genesis_jpg__ = __webpack_require__(914);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47_images_clients_genesis_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_47_images_clients_genesis_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48_images_clients_lbec_jpg__ = __webpack_require__(915);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48_images_clients_lbec_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_48_images_clients_lbec_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49_images_clients_rockall_jpg__ = __webpack_require__(916);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49_images_clients_rockall_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_49_images_clients_rockall_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50_images_clients_neam_jpg__ = __webpack_require__(917);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50_images_clients_neam_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_50_images_clients_neam_jpg__);
var clients=function clients(props){var settings={speed:500,responsive:[{breakpoint:5000,settings:'unslick'},{breakpoint:768,settings:{slidesToShow:4,slidesToScroll:1}},{breakpoint:500,settings:{slidesToShow:2,slidesToScroll:1}}]};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{ref:props.ourClientsRef,className:"secao-6",id:"some-of"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"wrap"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h1",null,"Some of Our Clients"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",{className:"clients"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{alt:"Bvlgari",src:__WEBPACK_IMPORTED_MODULE_2_images_clients_bvlgari_jpg___default.a}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{alt:"Salesforce",src:__WEBPACK_IMPORTED_MODULE_3_images_clients_salesforce_jpg___default.a}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{alt:"IBM",src:__WEBPACK_IMPORTED_MODULE_4_images_clients_ibm_jpg___default.a}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{alt:"Logitech",src:__WEBPACK_IMPORTED_MODULE_5_images_clients_logitech_jpg___default.a}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{alt:"Marketo",src:__WEBPACK_IMPORTED_MODULE_6_images_clients_marketo_jpg___default.a}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{alt:"McAfee",src:__WEBPACK_IMPORTED_MODULE_7_images_clients_mcafee_jpg___default.a}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{alt:"PWC",src:__WEBPACK_IMPORTED_MODULE_8_images_clients_pwc_jpg___default.a}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{alt:"Qualtrics",src:__WEBPACK_IMPORTED_MODULE_9_images_clients_qualtrics_jpg___default.a}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{alt:"Tripadvisor",src:__WEBPACK_IMPORTED_MODULE_10_images_clients_tripadvisor_jpg___default.a}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{alt:"Wells Fargo",src:__WEBPACK_IMPORTED_MODULE_11_images_clients_wellsfargo_jpg___default.a}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{alt:"Twilio",src:__WEBPACK_IMPORTED_MODULE_12_images_clients_twilio_jpg___default.a}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{alt:"Cadence Bank",src:__WEBPACK_IMPORTED_MODULE_13_images_clients_cadence_jpg___default.a}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{alt:"Capita",src:__WEBPACK_IMPORTED_MODULE_14_images_clients_capita_jpg___default.a}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{alt:"Zynga",src:__WEBPACK_IMPORTED_MODULE_15_images_clients_zynga_jpg___default.a}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{alt:"Heineken",src:__WEBPACK_IMPORTED_MODULE_16_images_clients_heineken_jpg___default.a}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{alt:"Omnicon",src:__WEBPACK_IMPORTED_MODULE_17_images_clients_omnicom_jpg___default.a}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{alt:"Websummit",src:__WEBPACK_IMPORTED_MODULE_18_images_clients_websummit_jpg___default.a}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{alt:"Wrike",src:__WEBPACK_IMPORTED_MODULE_19_images_clients_wrike_jpg___default.a}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{alt:"Mastercard",src:__WEBPACK_IMPORTED_MODULE_20_images_clients_mastercard_jpeg___default.a}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{alt:"Cantor",src:__WEBPACK_IMPORTED_MODULE_21_images_clients_cantor_jpg___default.a}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{alt:"8w",src:__WEBPACK_IMPORTED_MODULE_22_images_clients_8w_jpg___default.a}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{alt:"Cognex",src:__WEBPACK_IMPORTED_MODULE_23_images_clients_cognex_jpg___default.a}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{alt:"Coupa",src:__WEBPACK_IMPORTED_MODULE_24_images_clients_coupa_jpg___default.a}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{alt:"Datalex",src:__WEBPACK_IMPORTED_MODULE_25_images_clients_datalex_jpg___default.a}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{alt:"Goodbody",src:__WEBPACK_IMPORTED_MODULE_26_images_clients_goodbody_jpg___default.a}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{alt:"GSO",src:__WEBPACK_IMPORTED_MODULE_27_images_clients_gso_jpg___default.a}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{alt:"Hedgeserv",src:__WEBPACK_IMPORTED_MODULE_28_images_clients_hedgeserv_jpg___default.a}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{alt:"McKesson",src:__WEBPACK_IMPORTED_MODULE_29_images_clients_mckesson_jpg___default.a}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{alt:"Fineos",src:__WEBPACK_IMPORTED_MODULE_30_images_clients_fineos_jpg___default.a}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{alt:"Avolon",src:__WEBPACK_IMPORTED_MODULE_31_images_clients_avolon_jpg___default.a}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{alt:"Standard Life",src:__WEBPACK_IMPORTED_MODULE_32_images_clients_standardlife_jpg___default.a}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{alt:"Paulson",src:__WEBPACK_IMPORTED_MODULE_33_images_clients_paulson_jpg___default.a}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{alt:"Irish Jobs",src:__WEBPACK_IMPORTED_MODULE_34_images_clients_irishjobs_jpg___default.a}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{alt:"Social Talent",src:__WEBPACK_IMPORTED_MODULE_35_images_clients_socialtalent_jpg___default.a}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{alt:"Workday",src:__WEBPACK_IMPORTED_MODULE_36_images_clients_workday_jpg___default.a}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{alt:"Quantcast",src:__WEBPACK_IMPORTED_MODULE_37_images_clients_quantcast_jpg___default.a}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{alt:"Teneo",src:__WEBPACK_IMPORTED_MODULE_38_images_clients_teneo_jpg___default.a}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{alt:"Orix",src:__WEBPACK_IMPORTED_MODULE_39_images_clients_orix_jpg___default.a}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{alt:"Corehr",src:__WEBPACK_IMPORTED_MODULE_40_images_clients_corehr_jpg___default.a}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{alt:"Pilz",src:__WEBPACK_IMPORTED_MODULE_41_images_clients_pilz_jpg___default.a}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{alt:"Segment",src:__WEBPACK_IMPORTED_MODULE_42_images_clients_segment_jpg___default.a}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{alt:"Kooomo",src:__WEBPACK_IMPORTED_MODULE_43_images_clients_kooomo_jpg___default.a}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{alt:"Mazars",src:__WEBPACK_IMPORTED_MODULE_44_images_clients_mazars_jpg___default.a}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{alt:"Glanbia",src:__WEBPACK_IMPORTED_MODULE_45_images_clients_glanbia_jpg___default.a}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{alt:"Applovin",src:__WEBPACK_IMPORTED_MODULE_46_images_clients_applovin_jpg___default.a}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{alt:"Genesis",src:__WEBPACK_IMPORTED_MODULE_47_images_clients_genesis_jpg___default.a}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{alt:"Lbec",src:__WEBPACK_IMPORTED_MODULE_48_images_clients_lbec_jpg___default.a}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{alt:"Rockall",src:__WEBPACK_IMPORTED_MODULE_49_images_clients_rockall_jpg___default.a}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{alt:"Neam",src:__WEBPACK_IMPORTED_MODULE_50_images_clients_neam_jpg___default.a})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_slick___default.a,Object.assign({className:"clients-mobile"},settings),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{alt:"Bvlgari",src:__WEBPACK_IMPORTED_MODULE_2_images_clients_bvlgari_jpg___default.a}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{alt:"Salesforce",src:__WEBPACK_IMPORTED_MODULE_3_images_clients_salesforce_jpg___default.a}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{alt:"IBM",src:__WEBPACK_IMPORTED_MODULE_4_images_clients_ibm_jpg___default.a}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{alt:"Logitech",src:__WEBPACK_IMPORTED_MODULE_5_images_clients_logitech_jpg___default.a}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{alt:"Marketo",src:__WEBPACK_IMPORTED_MODULE_6_images_clients_marketo_jpg___default.a}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{alt:"McAfee",src:__WEBPACK_IMPORTED_MODULE_7_images_clients_mcafee_jpg___default.a}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{alt:"PWC",src:__WEBPACK_IMPORTED_MODULE_8_images_clients_pwc_jpg___default.a}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{alt:"Qualtrics",src:__WEBPACK_IMPORTED_MODULE_9_images_clients_qualtrics_jpg___default.a}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{alt:"Tripadvisor",src:__WEBPACK_IMPORTED_MODULE_10_images_clients_tripadvisor_jpg___default.a}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{alt:"Wells Fargo",src:__WEBPACK_IMPORTED_MODULE_11_images_clients_wellsfargo_jpg___default.a}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{alt:"Twilio",src:__WEBPACK_IMPORTED_MODULE_12_images_clients_twilio_jpg___default.a}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{alt:"Cadence Bank",src:__WEBPACK_IMPORTED_MODULE_13_images_clients_cadence_jpg___default.a}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{alt:"Capita",src:__WEBPACK_IMPORTED_MODULE_14_images_clients_capita_jpg___default.a}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{alt:"Zynga",src:__WEBPACK_IMPORTED_MODULE_15_images_clients_zynga_jpg___default.a}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{alt:"Heineken",src:__WEBPACK_IMPORTED_MODULE_16_images_clients_heineken_jpg___default.a}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{alt:"Omnicon",src:__WEBPACK_IMPORTED_MODULE_17_images_clients_omnicom_jpg___default.a}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{alt:"Websummit",src:__WEBPACK_IMPORTED_MODULE_18_images_clients_websummit_jpg___default.a}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{alt:"Wrike",src:__WEBPACK_IMPORTED_MODULE_19_images_clients_wrike_jpg___default.a}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{alt:"Udemy",src:__WEBPACK_IMPORTED_MODULE_20_images_clients_mastercard_jpeg___default.a}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{alt:"Cantor",src:__WEBPACK_IMPORTED_MODULE_21_images_clients_cantor_jpg___default.a}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{alt:"8w",src:__WEBPACK_IMPORTED_MODULE_22_images_clients_8w_jpg___default.a}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{alt:"Cognex",src:__WEBPACK_IMPORTED_MODULE_23_images_clients_cognex_jpg___default.a}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{alt:"Coupa",src:__WEBPACK_IMPORTED_MODULE_24_images_clients_coupa_jpg___default.a}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{alt:"Datalex",src:__WEBPACK_IMPORTED_MODULE_25_images_clients_datalex_jpg___default.a}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{alt:"Goodbody",src:__WEBPACK_IMPORTED_MODULE_26_images_clients_goodbody_jpg___default.a}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{alt:"GSO",src:__WEBPACK_IMPORTED_MODULE_27_images_clients_gso_jpg___default.a}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{alt:"Hedgeserv",src:__WEBPACK_IMPORTED_MODULE_28_images_clients_hedgeserv_jpg___default.a}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{alt:"McKesson",src:__WEBPACK_IMPORTED_MODULE_29_images_clients_mckesson_jpg___default.a}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{alt:"Fineos",src:__WEBPACK_IMPORTED_MODULE_30_images_clients_fineos_jpg___default.a}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{alt:"Avolon",src:__WEBPACK_IMPORTED_MODULE_31_images_clients_avolon_jpg___default.a}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{alt:"Paulson",src:__WEBPACK_IMPORTED_MODULE_33_images_clients_paulson_jpg___default.a}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{alt:"Irish Jobs",src:__WEBPACK_IMPORTED_MODULE_34_images_clients_irishjobs_jpg___default.a}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{alt:"Social Talent",src:__WEBPACK_IMPORTED_MODULE_35_images_clients_socialtalent_jpg___default.a}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{alt:"Workday",src:__WEBPACK_IMPORTED_MODULE_36_images_clients_workday_jpg___default.a}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{alt:"Quantcast",src:__WEBPACK_IMPORTED_MODULE_37_images_clients_quantcast_jpg___default.a}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{alt:"Teneo",src:__WEBPACK_IMPORTED_MODULE_38_images_clients_teneo_jpg___default.a}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{alt:"Orix",src:__WEBPACK_IMPORTED_MODULE_39_images_clients_orix_jpg___default.a}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{alt:"Corehr",src:__WEBPACK_IMPORTED_MODULE_40_images_clients_corehr_jpg___default.a}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{alt:"Pilz",src:__WEBPACK_IMPORTED_MODULE_41_images_clients_pilz_jpg___default.a}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{alt:"Segment",src:__WEBPACK_IMPORTED_MODULE_42_images_clients_segment_jpg___default.a}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{alt:"Kooomo",src:__WEBPACK_IMPORTED_MODULE_43_images_clients_kooomo_jpg___default.a}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{alt:"Mazars",src:__WEBPACK_IMPORTED_MODULE_44_images_clients_mazars_jpg___default.a}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{alt:"Glanbia",src:__WEBPACK_IMPORTED_MODULE_45_images_clients_glanbia_jpg___default.a}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{alt:"Applovin",src:__WEBPACK_IMPORTED_MODULE_46_images_clients_applovin_jpg___default.a}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{alt:"Genesis",src:__WEBPACK_IMPORTED_MODULE_47_images_clients_genesis_jpg___default.a}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{alt:"Lbec",src:__WEBPACK_IMPORTED_MODULE_48_images_clients_lbec_jpg___default.a}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{alt:"Rockall",src:__WEBPACK_IMPORTED_MODULE_49_images_clients_rockall_jpg___default.a}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{alt:"Neam",src:__WEBPACK_IMPORTED_MODULE_50_images_clients_neam_jpg___default.a})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{onClick:props.HandleFindOutMore,className:"bt get-more-info"},"Find out more")));};/* harmony default export */ __webpack_exports__["a"] = (clients);

/***/ }),
/* 854 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _innerSlider = __webpack_require__(855);

var _json2mq = __webpack_require__(862);

var _json2mq2 = _interopRequireDefault(_json2mq);

var _defaultProps = __webpack_require__(864);

var _defaultProps2 = _interopRequireDefault(_defaultProps);

var _innerSliderUtils = __webpack_require__(137);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var enquire = (0, _innerSliderUtils.canUseDOM)() && __webpack_require__(865);

var Slider = function (_React$Component) {
  _inherits(Slider, _React$Component);

  function Slider(props) {
    _classCallCheck(this, Slider);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    _this.innerSliderRefHandler = function (ref) {
      return _this.innerSlider = ref;
    };

    _this.slickPrev = function () {
      return _this.innerSlider.slickPrev();
    };

    _this.slickNext = function () {
      return _this.innerSlider.slickNext();
    };

    _this.slickGoTo = function (slide) {
      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      return _this.innerSlider.slickGoTo(slide, dontAnimate);
    };

    _this.slickPause = function () {
      return _this.innerSlider.pause("paused");
    };

    _this.slickPlay = function () {
      return _this.innerSlider.autoPlay("play");
    };

    _this.state = {
      breakpoint: null
    };
    _this._responsiveMediaHandlers = [];
    return _this;
  }

  Slider.prototype.media = function media(query, handler) {
    // javascript handler for  css media query
    enquire.register(query, handler);
    this._responsiveMediaHandlers.push({ query: query, handler: handler });
  };

  // handles responsive breakpoints


  Slider.prototype.componentWillMount = function componentWillMount() {
    var _this2 = this;

    // performance monitoring
    //if (process.env.NODE_ENV !== 'production') {
    //const { whyDidYouUpdate } = require('why-did-you-update')
    //whyDidYouUpdate(React)
    //}
    if (this.props.responsive) {
      var breakpoints = this.props.responsive.map(function (breakpt) {
        return breakpt.breakpoint;
      });
      // sort them in increasing order of their numerical value
      breakpoints.sort(function (x, y) {
        return x - y;
      });

      breakpoints.forEach(function (breakpoint, index) {
        // media query for each breakpoint
        var bQuery = void 0;
        if (index === 0) {
          bQuery = (0, _json2mq2.default)({ minWidth: 0, maxWidth: breakpoint });
        } else {
          bQuery = (0, _json2mq2.default)({
            minWidth: breakpoints[index - 1] + 1,
            maxWidth: breakpoint
          });
        }
        // when not using server side rendering
        (0, _innerSliderUtils.canUseDOM)() && _this2.media(bQuery, function () {
          _this2.setState({ breakpoint: breakpoint });
        });
      });

      // Register media query for full screen. Need to support resize from small to large
      // convert javascript object to media query string
      var query = (0, _json2mq2.default)({ minWidth: breakpoints.slice(-1)[0] });

      (0, _innerSliderUtils.canUseDOM)() && this.media(query, function () {
        _this2.setState({ breakpoint: null });
      });
    }
  };

  Slider.prototype.componentWillUnmount = function componentWillUnmount() {
    this._responsiveMediaHandlers.forEach(function (obj) {
      enquire.unregister(obj.query, obj.handler);
    });
  };

  Slider.prototype.render = function render() {
    var _this3 = this;

    var settings;
    var newProps;
    if (this.state.breakpoint) {
      newProps = this.props.responsive.filter(function (resp) {
        return resp.breakpoint === _this3.state.breakpoint;
      });
      settings = newProps[0].settings === "unslick" ? "unslick" : _extends({}, _defaultProps2.default, this.props, newProps[0].settings);
    } else {
      settings = _extends({}, _defaultProps2.default, this.props);
    }

    // force scrolling by one if centerMode is on
    if (settings.centerMode) {
      if (settings.slidesToScroll > 1 && "production" !== "production") {
        console.warn("slidesToScroll should be equal to 1 in centerMode, you are using " + settings.slidesToScroll);
      }
      settings.slidesToScroll = 1;
    }
    // force showing one slide and scrolling by one if the fade mode is on
    if (settings.fade) {
      if (settings.slidesToShow > 1 && "production" !== "production") {
        console.warn("slidesToShow should be equal to 1 when fade is true, you're using " + settings.slidesToShow);
      }
      if (settings.slidesToScroll > 1 && "production" !== "production") {
        console.warn("slidesToScroll should be equal to 1 when fade is true, you're using " + settings.slidesToScroll);
      }
      settings.slidesToShow = 1;
      settings.slidesToScroll = 1;
    }

    // makes sure that children is an array, even when there is only 1 child
    var children = _react2.default.Children.toArray(this.props.children);

    // Children may contain false or null, so we should filter them
    // children may also contain string filled with spaces (in certain cases where we use jsx strings)
    children = children.filter(function (child) {
      if (typeof child === "string") {
        return !!child.trim();
      }
      return !!child;
    });

    // rows and slidesPerRow logic is handled here
    if (settings.variableWidth && (settings.rows > 1 || settings.slidesPerRow > 1)) {
      console.warn("variableWidth is not supported in case of rows > 1 or slidesPerRow > 1");
      settings.variableWidth = false;
    }
    var newChildren = [];
    var currentWidth = null;
    for (var i = 0; i < children.length; i += settings.rows * settings.slidesPerRow) {
      var newSlide = [];
      for (var j = i; j < i + settings.rows * settings.slidesPerRow; j += settings.slidesPerRow) {
        var row = [];
        for (var k = j; k < j + settings.slidesPerRow; k += 1) {
          if (settings.variableWidth && children[k].props.style) {
            currentWidth = children[k].props.style.width;
          }
          if (k >= children.length) break;
          row.push(_react2.default.cloneElement(children[k], {
            key: 100 * i + 10 * j + k,
            tabIndex: -1,
            style: {
              width: 100 / settings.slidesPerRow + "%",
              display: "inline-block"
            }
          }));
        }
        newSlide.push(_react2.default.createElement(
          "div",
          { key: 10 * i + j },
          row
        ));
      }
      if (settings.variableWidth) {
        newChildren.push(_react2.default.createElement(
          "div",
          { key: i, style: { width: currentWidth } },
          newSlide
        ));
      } else {
        newChildren.push(_react2.default.createElement(
          "div",
          { key: i },
          newSlide
        ));
      }
    }

    if (settings === "unslick") {
      var className = "regular slider " + (this.props.className || "");
      return _react2.default.createElement(
        "div",
        { className: className },
        newChildren
      );
    } else if (newChildren.length <= settings.slidesToShow) {
      settings.unslick = true;
    }
    return _react2.default.createElement(
      _innerSlider.InnerSlider,
      _extends({ ref: this.innerSliderRefHandler }, settings),
      newChildren
    );
  };

  return Slider;
}(_react2.default.Component);

exports.default = Slider;

/***/ }),
/* 855 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.InnerSlider = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(36);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _initialState = __webpack_require__(856);

var _initialState2 = _interopRequireDefault(_initialState);

var _lodash = __webpack_require__(857);

var _lodash2 = _interopRequireDefault(_lodash);

var _classnames = __webpack_require__(49);

var _classnames2 = _interopRequireDefault(_classnames);

var _innerSliderUtils = __webpack_require__(137);

var _track = __webpack_require__(858);

var _dots = __webpack_require__(859);

var _arrows = __webpack_require__(860);

var _resizeObserverPolyfill = __webpack_require__(861);

var _resizeObserverPolyfill2 = _interopRequireDefault(_resizeObserverPolyfill);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var InnerSlider = exports.InnerSlider = function (_React$Component) {
  _inherits(InnerSlider, _React$Component);

  function InnerSlider(props) {
    _classCallCheck(this, InnerSlider);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    _this.listRefHandler = function (ref) {
      return _this.list = ref;
    };

    _this.trackRefHandler = function (ref) {
      return _this.track = ref;
    };

    _this.adaptHeight = function () {
      if (_this.props.adaptiveHeight && _this.list) {
        var elem = _this.list.querySelector("[data-index=\"" + _this.state.currentSlide + "\"]");
        _this.list.style.height = (0, _innerSliderUtils.getHeight)(elem) + "px";
      }
    };

    _this.componentWillMount = function () {
      _this.ssrInit();
      _this.props.onInit && _this.props.onInit();
      if (_this.props.lazyLoad) {
        var slidesToLoad = (0, _innerSliderUtils.getOnDemandLazySlides)(_extends({}, _this.props, _this.state));
        if (slidesToLoad.length > 0) {
          _this.setState(function (prevState) {
            return {
              lazyLoadedList: prevState.lazyLoadedList.concat(slidesToLoad)
            };
          });
          if (_this.props.onLazyLoad) {
            _this.props.onLazyLoad(slidesToLoad);
          }
        }
      }
    };

    _this.componentDidMount = function () {
      var spec = _extends({ listRef: _this.list, trackRef: _this.track }, _this.props);
      _this.updateState(spec, true, function () {
        _this.adaptHeight();
        _this.props.autoplay && _this.autoPlay("update");
      });
      if (_this.props.lazyLoad === "progressive") {
        _this.lazyLoadTimer = setInterval(_this.progressiveLazyLoad, 1000);
      }
      _this.ro = new _resizeObserverPolyfill2.default(function () {
        if (_this.state.animating) {
          _this.onWindowResized(false); // don't set trackStyle hence don't break animation
          _this.callbackTimers.push(setTimeout(function () {
            return _this.onWindowResized();
          }, _this.props.speed));
        } else {
          _this.onWindowResized();
        }
      });
      _this.ro.observe(_this.list);
      Array.prototype.forEach.call(document.querySelectorAll(".slick-slide"), function (slide) {
        slide.onfocus = _this.props.pauseOnFocus ? _this.onSlideFocus : null;
        slide.onblur = _this.props.pauseOnFocus ? _this.onSlideBlur : null;
      });
      // To support server-side rendering
      if (!window) {
        return;
      }
      if (window.addEventListener) {
        window.addEventListener("resize", _this.onWindowResized);
      } else {
        window.attachEvent("onresize", _this.onWindowResized);
      }
    };

    _this.componentWillUnmount = function () {
      if (_this.animationEndCallback) {
        clearTimeout(_this.animationEndCallback);
      }
      if (_this.lazyLoadTimer) {
        clearInterval(_this.lazyLoadTimer);
      }
      if (_this.callbackTimers.length) {
        _this.callbackTimers.forEach(function (timer) {
          return clearTimeout(timer);
        });
        _this.callbackTimers = [];
      }
      if (window.addEventListener) {
        window.removeEventListener("resize", _this.onWindowResized);
      } else {
        window.detachEvent("onresize", _this.onWindowResized);
      }
      if (_this.autoplayTimer) {
        clearInterval(_this.autoplayTimer);
      }
    };

    _this.componentWillReceiveProps = function (nextProps) {
      var spec = _extends({
        listRef: _this.list,
        trackRef: _this.track
      }, nextProps, _this.state);
      var setTrackStyle = false;
      for (var _iterator = Object.keys(_this.props), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
        var _ref;

        if (_isArray) {
          if (_i >= _iterator.length) break;
          _ref = _iterator[_i++];
        } else {
          _i = _iterator.next();
          if (_i.done) break;
          _ref = _i.value;
        }

        var key = _ref;

        if (!nextProps.hasOwnProperty(key)) {
          setTrackStyle = true;
          break;
        }
        if (_typeof(nextProps[key]) === "object" || typeof nextProps[key] === "function") {
          continue;
        }
        if (nextProps[key] !== _this.props[key]) {
          setTrackStyle = true;
          break;
        }
      }
      _this.updateState(spec, setTrackStyle, function () {
        if (_this.state.currentSlide >= _react2.default.Children.count(nextProps.children)) {
          _this.changeSlide({
            message: "index",
            index: _react2.default.Children.count(nextProps.children) - nextProps.slidesToShow,
            currentSlide: _this.state.currentSlide
          });
        }
        if (nextProps.autoplay) {
          _this.autoPlay("update");
        } else {
          _this.pause("paused");
        }
      });
    };

    _this.componentDidUpdate = function () {
      _this.checkImagesLoad();
      _this.props.onReInit && _this.props.onReInit();
      if (_this.props.lazyLoad) {
        var slidesToLoad = (0, _innerSliderUtils.getOnDemandLazySlides)(_extends({}, _this.props, _this.state));
        if (slidesToLoad.length > 0) {
          _this.setState(function (prevState) {
            return {
              lazyLoadedList: prevState.lazyLoadedList.concat(slidesToLoad)
            };
          });
          if (_this.props.onLazyLoad) {
            _this.props.onLazyLoad(slidesToLoad);
          }
        }
      }
      // if (this.props.onLazyLoad) {
      //   this.props.onLazyLoad([leftMostSlide])
      // }
      _this.adaptHeight();
    };

    _this.onWindowResized = function (setTrackStyle) {
      if (_this.debouncedResize) _this.debouncedResize.cancel();
      _this.debouncedResize = (0, _lodash2.default)(function () {
        return _this.resizeWindow(setTrackStyle);
      }, 50);
      _this.debouncedResize();
    };

    _this.resizeWindow = function () {
      var setTrackStyle = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      if (!_reactDom2.default.findDOMNode(_this.track)) return;
      var spec = _extends({
        listRef: _this.list,
        trackRef: _this.track
      }, _this.props, _this.state);
      _this.updateState(spec, setTrackStyle, function () {
        if (_this.props.autoplay) _this.autoPlay("update");else _this.pause("paused");
      });
      // animating state should be cleared while resizing, otherwise autoplay stops working
      _this.setState({
        animating: false
      });
      clearTimeout(_this.animationEndCallback);
      delete _this.animationEndCallback;
    };

    _this.updateState = function (spec, setTrackStyle, callback) {
      var updatedState = (0, _innerSliderUtils.initializedState)(spec);
      spec = _extends({}, spec, updatedState, { slideIndex: updatedState.currentSlide });
      var targetLeft = (0, _innerSliderUtils.getTrackLeft)(spec);
      spec = _extends({}, spec, { left: targetLeft });
      var trackStyle = (0, _innerSliderUtils.getTrackCSS)(spec);
      if (setTrackStyle || _react2.default.Children.count(_this.props.children) !== _react2.default.Children.count(spec.children)) {
        updatedState["trackStyle"] = trackStyle;
      }
      _this.setState(updatedState, callback);
    };

    _this.ssrInit = function () {
      if (_this.props.variableWidth) {
        var _trackWidth = 0,
            _trackLeft = 0;
        var childrenWidths = [];
        var preClones = (0, _innerSliderUtils.getPreClones)(_extends({}, _this.props, _this.state, {
          slideCount: _this.props.children.length
        }));
        var postClones = (0, _innerSliderUtils.getPostClones)(_extends({}, _this.props, _this.state, {
          slideCount: _this.props.children.length
        }));
        _this.props.children.forEach(function (child) {
          childrenWidths.push(child.props.style.width);
          _trackWidth += child.props.style.width;
        });
        for (var i = 0; i < preClones; i++) {
          _trackLeft += childrenWidths[childrenWidths.length - 1 - i];
          _trackWidth += childrenWidths[childrenWidths.length - 1 - i];
        }
        for (var _i2 = 0; _i2 < postClones; _i2++) {
          _trackWidth += childrenWidths[_i2];
        }
        for (var _i3 = 0; _i3 < _this.state.currentSlide; _i3++) {
          _trackLeft += childrenWidths[_i3];
        }
        var _trackStyle = {
          width: _trackWidth + "px",
          left: -_trackLeft + "px"
        };
        if (_this.props.centerMode) {
          var currentWidth = childrenWidths[_this.state.currentSlide] + "px";
          _trackStyle.left = "calc(" + _trackStyle.left + " + (100% - " + currentWidth + ") / 2 ) ";
        }
        _this.setState({
          trackStyle: _trackStyle
        });
        return;
      }
      var childrenCount = _react2.default.Children.count(_this.props.children);
      var spec = _extends({}, _this.props, _this.state, { slideCount: childrenCount });
      var slideCount = (0, _innerSliderUtils.getPreClones)(spec) + (0, _innerSliderUtils.getPostClones)(spec) + childrenCount;
      var trackWidth = 100 / _this.props.slidesToShow * slideCount;
      var slideWidth = 100 / slideCount;
      var trackLeft = -slideWidth * ((0, _innerSliderUtils.getPreClones)(spec) + _this.state.currentSlide) * trackWidth / 100;
      if (_this.props.centerMode) {
        trackLeft += (100 - slideWidth * trackWidth / 100) / 2;
      }
      var trackStyle = {
        width: trackWidth + "%",
        left: trackLeft + "%"
      };
      _this.setState({
        slideWidth: slideWidth + "%",
        trackStyle: trackStyle
      });
    };

    _this.checkImagesLoad = function () {
      var images = document.querySelectorAll(".slick-slide img");
      var imagesCount = images.length,
          loadedCount = 0;
      Array.prototype.forEach.call(images, function (image) {
        var handler = function handler() {
          return ++loadedCount && loadedCount >= imagesCount && _this.onWindowResized();
        };
        if (!image.onclick) {
          image.onclick = function () {
            return image.parentNode.focus();
          };
        } else {
          var prevClickHandler = image.onclick;
          image.onclick = function () {
            prevClickHandler();
            image.parentNode.focus();
          };
        }
        if (!image.onload) {
          if (_this.props.lazyLoad) {
            image.onload = function () {
              _this.adaptHeight();
              _this.callbackTimers.push(setTimeout(_this.onWindowResized, _this.props.speed));
            };
          } else {
            image.onload = handler;
            image.onerror = function () {
              handler();
              _this.props.onLazyLoadError && _this.props.onLazyLoadError();
            };
          }
        }
      });
    };

    _this.progressiveLazyLoad = function () {
      var slidesToLoad = [];
      var spec = _extends({}, _this.props, _this.state);
      for (var index = _this.state.currentSlide; index < _this.state.slideCount + (0, _innerSliderUtils.getPostClones)(spec); index++) {
        if (_this.state.lazyLoadedList.indexOf(index) < 0) {
          slidesToLoad.push(index);
          break;
        }
      }
      for (var _index = _this.state.currentSlide - 1; _index >= -(0, _innerSliderUtils.getPreClones)(spec); _index--) {
        if (_this.state.lazyLoadedList.indexOf(_index) < 0) {
          slidesToLoad.push(_index);
          break;
        }
      }
      if (slidesToLoad.length > 0) {
        _this.setState(function (state) {
          return {
            lazyLoadedList: state.lazyLoadedList.concat(slidesToLoad)
          };
        });
        if (_this.props.onLazyLoad) {
          _this.props.onLazyLoad(slidesToLoad);
        }
      } else {
        if (_this.lazyLoadTimer) {
          clearInterval(_this.lazyLoadTimer);
          delete _this.lazyLoadTimer;
        }
      }
    };

    _this.slideHandler = function (index) {
      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var _this$props = _this.props,
          asNavFor = _this$props.asNavFor,
          beforeChange = _this$props.beforeChange,
          onLazyLoad = _this$props.onLazyLoad,
          speed = _this$props.speed,
          afterChange = _this$props.afterChange;
      // capture currentslide before state is updated

      var currentSlide = _this.state.currentSlide;

      var _slideHandler = (0, _innerSliderUtils.slideHandler)(_extends({
        index: index
      }, _this.props, _this.state, {
        trackRef: _this.track,
        useCSS: _this.props.useCSS && !dontAnimate
      })),
          state = _slideHandler.state,
          nextState = _slideHandler.nextState;

      if (!state) return;
      beforeChange && beforeChange(currentSlide, state.currentSlide);
      var slidesToLoad = state.lazyLoadedList.filter(function (value) {
        return _this.state.lazyLoadedList.indexOf(value) < 0;
      });
      onLazyLoad && slidesToLoad.length > 0 && onLazyLoad(slidesToLoad);
      _this.setState(state, function () {
        asNavFor && asNavFor.innerSlider.state.currentSlide !== currentSlide && asNavFor.innerSlider.slideHandler(index);
        if (!nextState) return;
        _this.animationEndCallback = setTimeout(function () {
          var animating = nextState.animating,
              firstBatch = _objectWithoutProperties(nextState, ["animating"]);

          _this.setState(firstBatch, function () {
            _this.callbackTimers.push(setTimeout(function () {
              return _this.setState({ animating: animating });
            }, 10));
            afterChange && afterChange(state.currentSlide);
            delete _this.animationEndCallback;
          });
        }, speed);
      });
    };

    _this.changeSlide = function (options) {
      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      var spec = _extends({}, _this.props, _this.state);
      var targetSlide = (0, _innerSliderUtils.changeSlide)(spec, options);
      if (targetSlide !== 0 && !targetSlide) return;
      if (dontAnimate === true) {
        _this.slideHandler(targetSlide, dontAnimate);
      } else {
        _this.slideHandler(targetSlide);
      }
    };

    _this.clickHandler = function (e) {
      if (_this.clickable === false) {
        e.stopPropagation();
        e.preventDefault();
      }
      _this.clickable = true;
    };

    _this.keyHandler = function (e) {
      var dir = (0, _innerSliderUtils.keyHandler)(e, _this.props.accessibility, _this.props.rtl);
      dir !== "" && _this.changeSlide({ message: dir });
    };

    _this.selectHandler = function (options) {
      _this.changeSlide(options);
    };

    _this.disableBodyScroll = function () {
      var preventDefault = function preventDefault(e) {
        e = e || window.event;
        if (e.preventDefault) e.preventDefault();
        e.returnValue = false;
      };
      window.ontouchmove = preventDefault;
    };

    _this.enableBodyScroll = function () {
      window.ontouchmove = null;
    };

    _this.swipeStart = function (e) {
      if (_this.props.verticalSwiping) {
        _this.disableBodyScroll();
      }
      var state = (0, _innerSliderUtils.swipeStart)(e, _this.props.swipe, _this.props.draggable);
      state !== "" && _this.setState(state);
    };

    _this.swipeMove = function (e) {
      var state = (0, _innerSliderUtils.swipeMove)(e, _extends({}, _this.props, _this.state, {
        trackRef: _this.track,
        listRef: _this.list,
        slideIndex: _this.state.currentSlide
      }));
      if (!state) return;
      if (state["swiping"]) {
        _this.clickable = false;
      }
      _this.setState(state);
    };

    _this.swipeEnd = function (e) {
      var state = (0, _innerSliderUtils.swipeEnd)(e, _extends({}, _this.props, _this.state, {
        trackRef: _this.track,
        listRef: _this.list,
        slideIndex: _this.state.currentSlide
      }));
      if (!state) return;
      var triggerSlideHandler = state["triggerSlideHandler"];
      delete state["triggerSlideHandler"];
      _this.setState(state);
      if (triggerSlideHandler === undefined) return;
      _this.slideHandler(triggerSlideHandler);
      if (_this.props.verticalSwiping) {
        _this.enableBodyScroll();
      }
    };

    _this.slickPrev = function () {
      // this and fellow methods are wrapped in setTimeout
      // to make sure initialize setState has happened before
      // any of such methods are called
      _this.callbackTimers.push(setTimeout(function () {
        return _this.changeSlide({ message: "previous" });
      }, 0));
    };

    _this.slickNext = function () {
      _this.callbackTimers.push(setTimeout(function () {
        return _this.changeSlide({ message: "next" });
      }, 0));
    };

    _this.slickGoTo = function (slide) {
      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      slide = Number(slide);
      if (isNaN(slide)) return "";
      _this.callbackTimers.push(setTimeout(function () {
        return _this.changeSlide({
          message: "index",
          index: slide,
          currentSlide: _this.state.currentSlide
        }, dontAnimate);
      }, 0));
    };

    _this.play = function () {
      var nextIndex;
      if (_this.props.rtl) {
        nextIndex = _this.state.currentSlide - _this.props.slidesToScroll;
      } else {
        if ((0, _innerSliderUtils.canGoNext)(_extends({}, _this.props, _this.state))) {
          nextIndex = _this.state.currentSlide + _this.props.slidesToScroll;
        } else {
          return false;
        }
      }

      _this.slideHandler(nextIndex);
    };

    _this.autoPlay = function (playType) {
      if (_this.autoplayTimer) {
        clearInterval(_this.autoplayTimer);
      }
      var autoplaying = _this.state.autoplaying;
      if (playType === "update") {
        if (autoplaying === "hovered" || autoplaying === "focused" || autoplaying === "paused") {
          return;
        }
      } else if (playType === "leave") {
        if (autoplaying === "paused" || autoplaying === "focused") {
          return;
        }
      } else if (playType === "blur") {
        if (autoplaying === "paused" || autoplaying === "hovered") {
          return;
        }
      }
      _this.autoplayTimer = setInterval(_this.play, _this.props.autoplaySpeed + 50);
      _this.setState({ autoplaying: "playing" });
    };

    _this.pause = function (pauseType) {
      if (_this.autoplayTimer) {
        clearInterval(_this.autoplayTimer);
        _this.autoplayTimer = null;
      }
      var autoplaying = _this.state.autoplaying;
      if (pauseType === "paused") {
        _this.setState({ autoplaying: "paused" });
      } else if (pauseType === "focused") {
        if (autoplaying === "hovered" || autoplaying === "playing") {
          _this.setState({ autoplaying: "focused" });
        }
      } else {
        // pauseType  is 'hovered'
        if (autoplaying === "playing") {
          _this.setState({ autoplaying: "hovered" });
        }
      }
    };

    _this.onDotsOver = function () {
      return _this.props.autoplay && _this.pause("hovered");
    };

    _this.onDotsLeave = function () {
      return _this.props.autoplay && _this.state.autoplaying === "hovered" && _this.autoPlay("leave");
    };

    _this.onTrackOver = function () {
      return _this.props.autoplay && _this.pause("hovered");
    };

    _this.onTrackLeave = function () {
      return _this.props.autoplay && _this.state.autoplaying === "hovered" && _this.autoPlay("leave");
    };

    _this.onSlideFocus = function () {
      return _this.props.autoplay && _this.pause("focused");
    };

    _this.onSlideBlur = function () {
      return _this.props.autoplay && _this.state.autoplaying === "focused" && _this.autoPlay("blur");
    };

    _this.render = function () {
      var className = (0, _classnames2.default)("slick-slider", _this.props.className, {
        "slick-vertical": _this.props.vertical,
        "slick-initialized": true
      });
      var spec = _extends({}, _this.props, _this.state);
      var trackProps = (0, _innerSliderUtils.extractObject)(spec, ["fade", "cssEase", "speed", "infinite", "centerMode", "focusOnSelect", "currentSlide", "lazyLoad", "lazyLoadedList", "rtl", "slideWidth", "slideHeight", "listHeight", "vertical", "slidesToShow", "slidesToScroll", "slideCount", "trackStyle", "variableWidth", "unslick", "centerPadding"]);
      var pauseOnHover = _this.props.pauseOnHover;

      trackProps = _extends({}, trackProps, {
        onMouseEnter: pauseOnHover ? _this.onTrackOver : null,
        onMouseLeave: pauseOnHover ? _this.onTrackLeave : null,
        onMouseOver: pauseOnHover ? _this.onTrackOver : null,
        focusOnSelect: _this.props.focusOnSelect ? _this.selectHandler : null
      });

      var dots;
      if (_this.props.dots === true && _this.state.slideCount >= _this.props.slidesToShow) {
        var dotProps = (0, _innerSliderUtils.extractObject)(spec, ["dotsClass", "slideCount", "slidesToShow", "currentSlide", "slidesToScroll", "clickHandler", "children", "customPaging", "infinite", "appendDots"]);
        var pauseOnDotsHover = _this.props.pauseOnDotsHover;

        dotProps = _extends({}, dotProps, {
          clickHandler: _this.changeSlide,
          onMouseEnter: pauseOnDotsHover ? _this.onDotsLeave : null,
          onMouseOver: pauseOnDotsHover ? _this.onDotsOver : null,
          onMouseLeave: pauseOnDotsHover ? _this.onDotsLeave : null
        });
        dots = _react2.default.createElement(_dots.Dots, dotProps);
      }

      var prevArrow, nextArrow;
      var arrowProps = (0, _innerSliderUtils.extractObject)(spec, ["infinite", "centerMode", "currentSlide", "slideCount", "slidesToShow", "prevArrow", "nextArrow"]);
      arrowProps.clickHandler = _this.changeSlide;

      if (_this.props.arrows) {
        prevArrow = _react2.default.createElement(_arrows.PrevArrow, arrowProps);
        nextArrow = _react2.default.createElement(_arrows.NextArrow, arrowProps);
      }

      var verticalHeightStyle = null;

      if (_this.props.vertical) {
        verticalHeightStyle = {
          height: _this.state.listHeight
        };
      }

      var centerPaddingStyle = null;

      if (_this.props.vertical === false) {
        if (_this.props.centerMode === true) {
          centerPaddingStyle = {
            padding: "0px " + _this.props.centerPadding
          };
        }
      } else {
        if (_this.props.centerMode === true) {
          centerPaddingStyle = {
            padding: _this.props.centerPadding + " 0px"
          };
        }
      }

      var listStyle = _extends({}, verticalHeightStyle, centerPaddingStyle);
      var touchMove = _this.props.touchMove;
      var listProps = {
        className: "slick-list",
        style: listStyle,
        onClick: _this.clickHandler,
        onMouseDown: touchMove ? _this.swipeStart : null,
        onMouseMove: _this.state.dragging && touchMove ? _this.swipeMove : null,
        onMouseUp: touchMove ? _this.swipeEnd : null,
        onMouseLeave: _this.state.dragging && touchMove ? _this.swipeEnd : null,
        onTouchStart: touchMove ? _this.swipeStart : null,
        onTouchMove: _this.state.dragging && touchMove ? _this.swipeMove : null,
        onTouchEnd: touchMove ? _this.swipeEnd : null,
        onTouchCancel: _this.state.dragging && touchMove ? _this.swipeEnd : null,
        onKeyDown: _this.props.accessibility ? _this.keyHandler : null
      };

      var innerSliderProps = {
        className: className,
        dir: "ltr"
      };

      if (_this.props.unslick) {
        listProps = { className: "slick-list" };
        innerSliderProps = { className: className };
      }
      return _react2.default.createElement(
        "div",
        innerSliderProps,
        !_this.props.unslick ? prevArrow : "",
        _react2.default.createElement(
          "div",
          _extends({ ref: _this.listRefHandler }, listProps),
          _react2.default.createElement(
            _track.Track,
            _extends({ ref: _this.trackRefHandler }, trackProps),
            _this.props.children
          )
        ),
        !_this.props.unslick ? nextArrow : "",
        !_this.props.unslick ? dots : ""
      );
    };

    _this.list = null;
    _this.track = null;
    _this.state = _extends({}, _initialState2.default, {
      currentSlide: _this.props.initialSlide,
      slideCount: _react2.default.Children.count(_this.props.children)
    });
    _this.callbackTimers = [];
    _this.clickable = true;
    _this.debouncedResize = null;
    return _this;
  }

  return InnerSlider;
}(_react2.default.Component);

/***/ }),
/* 856 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var initialState = {
  animating: false,
  autoplaying: null,
  currentDirection: 0,
  currentLeft: null,
  currentSlide: 0,
  direction: 1,
  dragging: false,
  edgeDragged: false,
  initialized: false,
  lazyLoadedList: [],
  listHeight: null,
  listWidth: null,
  scrolling: false,
  slideCount: null,
  slideHeight: null,
  slideWidth: null,
  swipeLeft: null,
  swiped: false, // used by swipeEvent. differentites between touch and swipe.
  swiping: false,
  touchObject: { startX: 0, startY: 0, curX: 0, curY: 0 },
  trackStyle: {},
  trackWidth: 0
};

exports.default = initialState;

/***/ }),
/* 857 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = debounce;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(39)))

/***/ }),
/* 858 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.Track = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(49);

var _classnames2 = _interopRequireDefault(_classnames);

var _innerSliderUtils = __webpack_require__(137);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// given specifications/props for a slide, fetch all the classes that need to be applied to the slide
var getSlideClasses = function getSlideClasses(spec) {
  var slickActive, slickCenter, slickCloned;
  var centerOffset, index;

  if (spec.rtl) {
    index = spec.slideCount - 1 - spec.index;
  } else {
    index = spec.index;
  }
  slickCloned = index < 0 || index >= spec.slideCount;
  if (spec.centerMode) {
    centerOffset = Math.floor(spec.slidesToShow / 2);
    slickCenter = (index - spec.currentSlide) % spec.slideCount === 0;
    if (index > spec.currentSlide - centerOffset - 1 && index <= spec.currentSlide + centerOffset) {
      slickActive = true;
    }
  } else {
    slickActive = spec.currentSlide <= index && index < spec.currentSlide + spec.slidesToShow;
  }
  var slickCurrent = index === spec.currentSlide;
  return {
    "slick-slide": true,
    "slick-active": slickActive,
    "slick-center": slickCenter,
    "slick-cloned": slickCloned,
    "slick-current": slickCurrent // dubious in case of RTL
  };
};

var getSlideStyle = function getSlideStyle(spec) {
  var style = {};

  if (spec.variableWidth === undefined || spec.variableWidth === false) {
    style.width = spec.slideWidth;
  }

  if (spec.fade) {
    style.position = "relative";
    if (spec.vertical) {
      style.top = -spec.index * parseInt(spec.slideHeight);
    } else {
      style.left = -spec.index * parseInt(spec.slideWidth);
    }
    style.opacity = spec.currentSlide === spec.index ? 1 : 0;
    style.transition = "opacity " + spec.speed + "ms " + spec.cssEase + ", " + "visibility " + spec.speed + "ms " + spec.cssEase;
    style.WebkitTransition = "opacity " + spec.speed + "ms " + spec.cssEase + ", " + "visibility " + spec.speed + "ms " + spec.cssEase;
  }

  return style;
};

var getKey = function getKey(child, fallbackKey) {
  return child.key || fallbackKey;
};

var renderSlides = function renderSlides(spec) {
  var key;
  var slides = [];
  var preCloneSlides = [];
  var postCloneSlides = [];
  var childrenCount = _react2.default.Children.count(spec.children);
  var startIndex = (0, _innerSliderUtils.lazyStartIndex)(spec);
  var endIndex = (0, _innerSliderUtils.lazyEndIndex)(spec);

  _react2.default.Children.forEach(spec.children, function (elem, index) {
    var child = void 0;
    var childOnClickOptions = {
      message: "children",
      index: index,
      slidesToScroll: spec.slidesToScroll,
      currentSlide: spec.currentSlide
    };

    // in case of lazyLoad, whether or not we want to fetch the slide
    if (!spec.lazyLoad || spec.lazyLoad && spec.lazyLoadedList.indexOf(index) >= 0) {
      child = elem;
    } else {
      child = _react2.default.createElement("div", null);
    }
    var childStyle = getSlideStyle(_extends({}, spec, { index: index }));
    var slideClass = child.props.className || "";
    var slideClasses = getSlideClasses(_extends({}, spec, { index: index }));
    // push a cloned element of the desired slide
    slides.push(_react2.default.cloneElement(child, {
      key: "original" + getKey(child, index),
      "data-index": index,
      className: (0, _classnames2.default)(slideClasses, slideClass),
      tabIndex: "-1",
      "aria-hidden": !slideClasses["slick-active"],
      style: _extends({ outline: "none" }, child.props.style || {}, childStyle),
      onClick: function onClick(e) {
        child.props && child.props.onClick && child.props.onClick(e);
        if (spec.focusOnSelect) {
          spec.focusOnSelect(childOnClickOptions);
        }
      }
    }));

    // if slide needs to be precloned or postcloned
    if (spec.infinite && spec.fade === false) {
      var preCloneNo = childrenCount - index;
      if (preCloneNo <= (0, _innerSliderUtils.getPreClones)(spec) && childrenCount !== spec.slidesToShow) {
        key = -preCloneNo;
        if (key >= startIndex) {
          child = elem;
        }
        slideClasses = getSlideClasses(_extends({}, spec, { index: key }));
        preCloneSlides.push(_react2.default.cloneElement(child, {
          key: "precloned" + getKey(child, key),
          "data-index": key,
          tabIndex: "-1",
          className: (0, _classnames2.default)(slideClasses, slideClass),
          "aria-hidden": !slideClasses["slick-active"],
          style: _extends({}, child.props.style || {}, childStyle),
          onClick: function onClick(e) {
            child.props && child.props.onClick && child.props.onClick(e);
            if (spec.focusOnSelect) {
              spec.focusOnSelect(childOnClickOptions);
            }
          }
        }));
      }

      if (childrenCount !== spec.slidesToShow) {
        key = childrenCount + index;
        if (key < endIndex) {
          child = elem;
        }
        slideClasses = getSlideClasses(_extends({}, spec, { index: key }));
        postCloneSlides.push(_react2.default.cloneElement(child, {
          key: "postcloned" + getKey(child, key),
          "data-index": key,
          tabIndex: "-1",
          className: (0, _classnames2.default)(slideClasses, slideClass),
          "aria-hidden": !slideClasses["slick-active"],
          style: _extends({}, child.props.style || {}, childStyle),
          onClick: function onClick(e) {
            child.props && child.props.onClick && child.props.onClick(e);
            if (spec.focusOnSelect) {
              spec.focusOnSelect(childOnClickOptions);
            }
          }
        }));
      }
    }
  });

  if (spec.rtl) {
    return preCloneSlides.concat(slides, postCloneSlides).reverse();
  } else {
    return preCloneSlides.concat(slides, postCloneSlides);
  }
};

var Track = exports.Track = function (_React$PureComponent) {
  _inherits(Track, _React$PureComponent);

  function Track() {
    _classCallCheck(this, Track);

    return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
  }

  Track.prototype.render = function render() {
    var slides = renderSlides(this.props);
    var _props = this.props,
        onMouseEnter = _props.onMouseEnter,
        onMouseOver = _props.onMouseOver,
        onMouseLeave = _props.onMouseLeave;

    var mouseEvents = { onMouseEnter: onMouseEnter, onMouseOver: onMouseOver, onMouseLeave: onMouseLeave };
    return _react2.default.createElement(
      "div",
      _extends({
        className: "slick-track",
        style: this.props.trackStyle
      }, mouseEvents),
      slides
    );
  };

  return Track;
}(_react2.default.PureComponent);

/***/ }),
/* 859 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.Dots = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(49);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var getDotCount = function getDotCount(spec) {
  var dots;

  if (spec.infinite) {
    dots = Math.ceil(spec.slideCount / spec.slidesToScroll);
  } else {
    dots = Math.ceil((spec.slideCount - spec.slidesToShow) / spec.slidesToScroll) + 1;
  }

  return dots;
};

var Dots = exports.Dots = function (_React$PureComponent) {
  _inherits(Dots, _React$PureComponent);

  function Dots() {
    _classCallCheck(this, Dots);

    return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
  }

  Dots.prototype.clickHandler = function clickHandler(options, e) {
    // In Autoplay the focus stays on clicked button even after transition
    // to next slide. That only goes away by click somewhere outside
    e.preventDefault();
    this.props.clickHandler(options);
  };

  Dots.prototype.render = function render() {
    var _this2 = this;

    var dotCount = getDotCount({
      slideCount: this.props.slideCount,
      slidesToScroll: this.props.slidesToScroll,
      slidesToShow: this.props.slidesToShow,
      infinite: this.props.infinite
    });

    // Apply join & split to Array to pre-fill it for IE8
    //
    // Credit: http://stackoverflow.com/a/13735425/1849458
    var _props = this.props,
        onMouseEnter = _props.onMouseEnter,
        onMouseOver = _props.onMouseOver,
        onMouseLeave = _props.onMouseLeave;

    var mouseEvents = { onMouseEnter: onMouseEnter, onMouseOver: onMouseOver, onMouseLeave: onMouseLeave };
    var dots = Array.apply(null, Array(dotCount + 1).join("0").split("")).map(function (x, i) {
      var leftBound = i * _this2.props.slidesToScroll;
      var rightBound = i * _this2.props.slidesToScroll + (_this2.props.slidesToScroll - 1);
      var className = (0, _classnames2.default)({
        "slick-active": _this2.props.currentSlide >= leftBound && _this2.props.currentSlide <= rightBound
      });

      var dotOptions = {
        message: "dots",
        index: i,
        slidesToScroll: _this2.props.slidesToScroll,
        currentSlide: _this2.props.currentSlide
      };

      var onClick = _this2.clickHandler.bind(_this2, dotOptions);
      return _react2.default.createElement(
        "li",
        { key: i, className: className },
        _react2.default.cloneElement(_this2.props.customPaging(i), { onClick: onClick })
      );
    });

    return _react2.default.cloneElement(this.props.appendDots(dots), _extends({
      className: this.props.dotsClass
    }, mouseEvents));
  };

  return Dots;
}(_react2.default.PureComponent);

/***/ }),
/* 860 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.NextArrow = exports.PrevArrow = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(49);

var _classnames2 = _interopRequireDefault(_classnames);

var _innerSliderUtils = __webpack_require__(137);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PrevArrow = exports.PrevArrow = function (_React$PureComponent) {
  _inherits(PrevArrow, _React$PureComponent);

  function PrevArrow() {
    _classCallCheck(this, PrevArrow);

    return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
  }

  PrevArrow.prototype.clickHandler = function clickHandler(options, e) {
    if (e) {
      e.preventDefault();
    }
    this.props.clickHandler(options, e);
  };

  PrevArrow.prototype.render = function render() {
    var prevClasses = { "slick-arrow": true, "slick-prev": true };
    var prevHandler = this.clickHandler.bind(this, { message: "previous" });

    if (!this.props.infinite && (this.props.currentSlide === 0 || this.props.slideCount <= this.props.slidesToShow)) {
      prevClasses["slick-disabled"] = true;
      prevHandler = null;
    }

    var prevArrowProps = {
      key: "0",
      "data-role": "none",
      className: (0, _classnames2.default)(prevClasses),
      style: { display: "block" },
      onClick: prevHandler
    };
    var customProps = {
      currentSlide: this.props.currentSlide,
      slideCount: this.props.slideCount
    };
    var prevArrow = void 0;

    if (this.props.prevArrow) {
      prevArrow = _react2.default.cloneElement(this.props.prevArrow, _extends({}, prevArrowProps, customProps));
    } else {
      prevArrow = _react2.default.createElement(
        "button",
        _extends({ key: "0", type: "button" }, prevArrowProps),
        " ",
        "Previous"
      );
    }

    return prevArrow;
  };

  return PrevArrow;
}(_react2.default.PureComponent);

var NextArrow = exports.NextArrow = function (_React$PureComponent2) {
  _inherits(NextArrow, _React$PureComponent2);

  function NextArrow() {
    _classCallCheck(this, NextArrow);

    return _possibleConstructorReturn(this, _React$PureComponent2.apply(this, arguments));
  }

  NextArrow.prototype.clickHandler = function clickHandler(options, e) {
    if (e) {
      e.preventDefault();
    }
    this.props.clickHandler(options, e);
  };

  NextArrow.prototype.render = function render() {
    var nextClasses = { "slick-arrow": true, "slick-next": true };
    var nextHandler = this.clickHandler.bind(this, { message: "next" });

    if (!(0, _innerSliderUtils.canGoNext)(this.props)) {
      nextClasses["slick-disabled"] = true;
      nextHandler = null;
    }

    var nextArrowProps = {
      key: "1",
      "data-role": "none",
      className: (0, _classnames2.default)(nextClasses),
      style: { display: "block" },
      onClick: nextHandler
    };
    var customProps = {
      currentSlide: this.props.currentSlide,
      slideCount: this.props.slideCount
    };
    var nextArrow = void 0;

    if (this.props.nextArrow) {
      nextArrow = _react2.default.cloneElement(this.props.nextArrow, _extends({}, nextArrowProps, customProps));
    } else {
      nextArrow = _react2.default.createElement(
        "button",
        _extends({ key: "1", type: "button" }, nextArrowProps),
        " ",
        "Next"
      );
    }

    return nextArrow;
  };

  return NextArrow;
}(_react2.default.PureComponent);

/***/ }),
/* 861 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global) {/**
 * A collection of shims that provide minimal functionality of the ES6 collections.
 *
 * These implementations are not meant to be used outside of the ResizeObserver
 * modules as they cover only a limited range of use cases.
 */
/* eslint-disable require-jsdoc, valid-jsdoc */
var MapShim = (function () {
    if (typeof Map !== 'undefined') {
        return Map;
    }
    /**
     * Returns index in provided array that matches the specified key.
     *
     * @param {Array<Array>} arr
     * @param {*} key
     * @returns {number}
     */
    function getIndex(arr, key) {
        var result = -1;
        arr.some(function (entry, index) {
            if (entry[0] === key) {
                result = index;
                return true;
            }
            return false;
        });
        return result;
    }
    return /** @class */ (function () {
        function class_1() {
            this.__entries__ = [];
        }
        Object.defineProperty(class_1.prototype, "size", {
            /**
             * @returns {boolean}
             */
            get: function () {
                return this.__entries__.length;
            },
            enumerable: true,
            configurable: true
        });
        /**
         * @param {*} key
         * @returns {*}
         */
        class_1.prototype.get = function (key) {
            var index = getIndex(this.__entries__, key);
            var entry = this.__entries__[index];
            return entry && entry[1];
        };
        /**
         * @param {*} key
         * @param {*} value
         * @returns {void}
         */
        class_1.prototype.set = function (key, value) {
            var index = getIndex(this.__entries__, key);
            if (~index) {
                this.__entries__[index][1] = value;
            }
            else {
                this.__entries__.push([key, value]);
            }
        };
        /**
         * @param {*} key
         * @returns {void}
         */
        class_1.prototype.delete = function (key) {
            var entries = this.__entries__;
            var index = getIndex(entries, key);
            if (~index) {
                entries.splice(index, 1);
            }
        };
        /**
         * @param {*} key
         * @returns {void}
         */
        class_1.prototype.has = function (key) {
            return !!~getIndex(this.__entries__, key);
        };
        /**
         * @returns {void}
         */
        class_1.prototype.clear = function () {
            this.__entries__.splice(0);
        };
        /**
         * @param {Function} callback
         * @param {*} [ctx=null]
         * @returns {void}
         */
        class_1.prototype.forEach = function (callback, ctx) {
            if (ctx === void 0) { ctx = null; }
            for (var _i = 0, _a = this.__entries__; _i < _a.length; _i++) {
                var entry = _a[_i];
                callback.call(ctx, entry[1], entry[0]);
            }
        };
        return class_1;
    }());
})();

/**
 * Detects whether window and document objects are available in current environment.
 */
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && window.document === document;

// Returns global object of a current environment.
var global$1 = (function () {
    if (typeof global !== 'undefined' && global.Math === Math) {
        return global;
    }
    if (typeof self !== 'undefined' && self.Math === Math) {
        return self;
    }
    if (typeof window !== 'undefined' && window.Math === Math) {
        return window;
    }
    // eslint-disable-next-line no-new-func
    return Function('return this')();
})();

/**
 * A shim for the requestAnimationFrame which falls back to the setTimeout if
 * first one is not supported.
 *
 * @returns {number} Requests' identifier.
 */
var requestAnimationFrame$1 = (function () {
    if (typeof requestAnimationFrame === 'function') {
        // It's required to use a bounded function because IE sometimes throws
        // an "Invalid calling object" error if rAF is invoked without the global
        // object on the left hand side.
        return requestAnimationFrame.bind(global$1);
    }
    return function (callback) { return setTimeout(function () { return callback(Date.now()); }, 1000 / 60); };
})();

// Defines minimum timeout before adding a trailing call.
var trailingTimeout = 2;
/**
 * Creates a wrapper function which ensures that provided callback will be
 * invoked only once during the specified delay period.
 *
 * @param {Function} callback - Function to be invoked after the delay period.
 * @param {number} delay - Delay after which to invoke callback.
 * @returns {Function}
 */
function throttle (callback, delay) {
    var leadingCall = false, trailingCall = false, lastCallTime = 0;
    /**
     * Invokes the original callback function and schedules new invocation if
     * the "proxy" was called during current request.
     *
     * @returns {void}
     */
    function resolvePending() {
        if (leadingCall) {
            leadingCall = false;
            callback();
        }
        if (trailingCall) {
            proxy();
        }
    }
    /**
     * Callback invoked after the specified delay. It will further postpone
     * invocation of the original function delegating it to the
     * requestAnimationFrame.
     *
     * @returns {void}
     */
    function timeoutCallback() {
        requestAnimationFrame$1(resolvePending);
    }
    /**
     * Schedules invocation of the original function.
     *
     * @returns {void}
     */
    function proxy() {
        var timeStamp = Date.now();
        if (leadingCall) {
            // Reject immediately following calls.
            if (timeStamp - lastCallTime < trailingTimeout) {
                return;
            }
            // Schedule new call to be in invoked when the pending one is resolved.
            // This is important for "transitions" which never actually start
            // immediately so there is a chance that we might miss one if change
            // happens amids the pending invocation.
            trailingCall = true;
        }
        else {
            leadingCall = true;
            trailingCall = false;
            setTimeout(timeoutCallback, delay);
        }
        lastCallTime = timeStamp;
    }
    return proxy;
}

// Minimum delay before invoking the update of observers.
var REFRESH_DELAY = 20;
// A list of substrings of CSS properties used to find transition events that
// might affect dimensions of observed elements.
var transitionKeys = ['top', 'right', 'bottom', 'left', 'width', 'height', 'size', 'weight'];
// Check if MutationObserver is available.
var mutationObserverSupported = typeof MutationObserver !== 'undefined';
/**
 * Singleton controller class which handles updates of ResizeObserver instances.
 */
var ResizeObserverController = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserverController.
     *
     * @private
     */
    function ResizeObserverController() {
        /**
         * Indicates whether DOM listeners have been added.
         *
         * @private {boolean}
         */
        this.connected_ = false;
        /**
         * Tells that controller has subscribed for Mutation Events.
         *
         * @private {boolean}
         */
        this.mutationEventsAdded_ = false;
        /**
         * Keeps reference to the instance of MutationObserver.
         *
         * @private {MutationObserver}
         */
        this.mutationsObserver_ = null;
        /**
         * A list of connected observers.
         *
         * @private {Array<ResizeObserverSPI>}
         */
        this.observers_ = [];
        this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
        this.refresh = throttle(this.refresh.bind(this), REFRESH_DELAY);
    }
    /**
     * Adds observer to observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be added.
     * @returns {void}
     */
    ResizeObserverController.prototype.addObserver = function (observer) {
        if (!~this.observers_.indexOf(observer)) {
            this.observers_.push(observer);
        }
        // Add listeners if they haven't been added yet.
        if (!this.connected_) {
            this.connect_();
        }
    };
    /**
     * Removes observer from observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be removed.
     * @returns {void}
     */
    ResizeObserverController.prototype.removeObserver = function (observer) {
        var observers = this.observers_;
        var index = observers.indexOf(observer);
        // Remove observer if it's present in registry.
        if (~index) {
            observers.splice(index, 1);
        }
        // Remove listeners if controller has no connected observers.
        if (!observers.length && this.connected_) {
            this.disconnect_();
        }
    };
    /**
     * Invokes the update of observers. It will continue running updates insofar
     * it detects changes.
     *
     * @returns {void}
     */
    ResizeObserverController.prototype.refresh = function () {
        var changesDetected = this.updateObservers_();
        // Continue running updates if changes have been detected as there might
        // be future ones caused by CSS transitions.
        if (changesDetected) {
            this.refresh();
        }
    };
    /**
     * Updates every observer from observers list and notifies them of queued
     * entries.
     *
     * @private
     * @returns {boolean} Returns "true" if any observer has detected changes in
     *      dimensions of it's elements.
     */
    ResizeObserverController.prototype.updateObservers_ = function () {
        // Collect observers that have active observations.
        var activeObservers = this.observers_.filter(function (observer) {
            return observer.gatherActive(), observer.hasActive();
        });
        // Deliver notifications in a separate cycle in order to avoid any
        // collisions between observers, e.g. when multiple instances of
        // ResizeObserver are tracking the same element and the callback of one
        // of them changes content dimensions of the observed target. Sometimes
        // this may result in notifications being blocked for the rest of observers.
        activeObservers.forEach(function (observer) { return observer.broadcastActive(); });
        return activeObservers.length > 0;
    };
    /**
     * Initializes DOM listeners.
     *
     * @private
     * @returns {void}
     */
    ResizeObserverController.prototype.connect_ = function () {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already added.
        if (!isBrowser || this.connected_) {
            return;
        }
        // Subscription to the "Transitionend" event is used as a workaround for
        // delayed transitions. This way it's possible to capture at least the
        // final state of an element.
        document.addEventListener('transitionend', this.onTransitionEnd_);
        window.addEventListener('resize', this.refresh);
        if (mutationObserverSupported) {
            this.mutationsObserver_ = new MutationObserver(this.refresh);
            this.mutationsObserver_.observe(document, {
                attributes: true,
                childList: true,
                characterData: true,
                subtree: true
            });
        }
        else {
            document.addEventListener('DOMSubtreeModified', this.refresh);
            this.mutationEventsAdded_ = true;
        }
        this.connected_ = true;
    };
    /**
     * Removes DOM listeners.
     *
     * @private
     * @returns {void}
     */
    ResizeObserverController.prototype.disconnect_ = function () {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already removed.
        if (!isBrowser || !this.connected_) {
            return;
        }
        document.removeEventListener('transitionend', this.onTransitionEnd_);
        window.removeEventListener('resize', this.refresh);
        if (this.mutationsObserver_) {
            this.mutationsObserver_.disconnect();
        }
        if (this.mutationEventsAdded_) {
            document.removeEventListener('DOMSubtreeModified', this.refresh);
        }
        this.mutationsObserver_ = null;
        this.mutationEventsAdded_ = false;
        this.connected_ = false;
    };
    /**
     * "Transitionend" event handler.
     *
     * @private
     * @param {TransitionEvent} event
     * @returns {void}
     */
    ResizeObserverController.prototype.onTransitionEnd_ = function (_a) {
        var _b = _a.propertyName, propertyName = _b === void 0 ? '' : _b;
        // Detect whether transition may affect dimensions of an element.
        var isReflowProperty = transitionKeys.some(function (key) {
            return !!~propertyName.indexOf(key);
        });
        if (isReflowProperty) {
            this.refresh();
        }
    };
    /**
     * Returns instance of the ResizeObserverController.
     *
     * @returns {ResizeObserverController}
     */
    ResizeObserverController.getInstance = function () {
        if (!this.instance_) {
            this.instance_ = new ResizeObserverController();
        }
        return this.instance_;
    };
    /**
     * Holds reference to the controller's instance.
     *
     * @private {ResizeObserverController}
     */
    ResizeObserverController.instance_ = null;
    return ResizeObserverController;
}());

/**
 * Defines non-writable/enumerable properties of the provided target object.
 *
 * @param {Object} target - Object for which to define properties.
 * @param {Object} props - Properties to be defined.
 * @returns {Object} Target object.
 */
var defineConfigurable = (function (target, props) {
    for (var _i = 0, _a = Object.keys(props); _i < _a.length; _i++) {
        var key = _a[_i];
        Object.defineProperty(target, key, {
            value: props[key],
            enumerable: false,
            writable: false,
            configurable: true
        });
    }
    return target;
});

/**
 * Returns the global object associated with provided element.
 *
 * @param {Object} target
 * @returns {Object}
 */
var getWindowOf = (function (target) {
    // Assume that the element is an instance of Node, which means that it
    // has the "ownerDocument" property from which we can retrieve a
    // corresponding global object.
    var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
    // Return the local global object if it's not possible extract one from
    // provided element.
    return ownerGlobal || global$1;
});

// Placeholder of an empty content rectangle.
var emptyRect = createRectInit(0, 0, 0, 0);
/**
 * Converts provided string to a number.
 *
 * @param {number|string} value
 * @returns {number}
 */
function toFloat(value) {
    return parseFloat(value) || 0;
}
/**
 * Extracts borders size from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @param {...string} positions - Borders positions (top, right, ...)
 * @returns {number}
 */
function getBordersSize(styles) {
    var positions = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        positions[_i - 1] = arguments[_i];
    }
    return positions.reduce(function (size, position) {
        var value = styles['border-' + position + '-width'];
        return size + toFloat(value);
    }, 0);
}
/**
 * Extracts paddings sizes from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @returns {Object} Paddings box.
 */
function getPaddings(styles) {
    var positions = ['top', 'right', 'bottom', 'left'];
    var paddings = {};
    for (var _i = 0, positions_1 = positions; _i < positions_1.length; _i++) {
        var position = positions_1[_i];
        var value = styles['padding-' + position];
        paddings[position] = toFloat(value);
    }
    return paddings;
}
/**
 * Calculates content rectangle of provided SVG element.
 *
 * @param {SVGGraphicsElement} target - Element content rectangle of which needs
 *      to be calculated.
 * @returns {DOMRectInit}
 */
function getSVGContentRect(target) {
    var bbox = target.getBBox();
    return createRectInit(0, 0, bbox.width, bbox.height);
}
/**
 * Calculates content rectangle of provided HTMLElement.
 *
 * @param {HTMLElement} target - Element for which to calculate the content rectangle.
 * @returns {DOMRectInit}
 */
function getHTMLElementContentRect(target) {
    // Client width & height properties can't be
    // used exclusively as they provide rounded values.
    var clientWidth = target.clientWidth, clientHeight = target.clientHeight;
    // By this condition we can catch all non-replaced inline, hidden and
    // detached elements. Though elements with width & height properties less
    // than 0.5 will be discarded as well.
    //
    // Without it we would need to implement separate methods for each of
    // those cases and it's not possible to perform a precise and performance
    // effective test for hidden elements. E.g. even jQuery's ':visible' filter
    // gives wrong results for elements with width & height less than 0.5.
    if (!clientWidth && !clientHeight) {
        return emptyRect;
    }
    var styles = getWindowOf(target).getComputedStyle(target);
    var paddings = getPaddings(styles);
    var horizPad = paddings.left + paddings.right;
    var vertPad = paddings.top + paddings.bottom;
    // Computed styles of width & height are being used because they are the
    // only dimensions available to JS that contain non-rounded values. It could
    // be possible to utilize the getBoundingClientRect if only it's data wasn't
    // affected by CSS transformations let alone paddings, borders and scroll bars.
    var width = toFloat(styles.width), height = toFloat(styles.height);
    // Width & height include paddings and borders when the 'border-box' box
    // model is applied (except for IE).
    if (styles.boxSizing === 'border-box') {
        // Following conditions are required to handle Internet Explorer which
        // doesn't include paddings and borders to computed CSS dimensions.
        //
        // We can say that if CSS dimensions + paddings are equal to the "client"
        // properties then it's either IE, and thus we don't need to subtract
        // anything, or an element merely doesn't have paddings/borders styles.
        if (Math.round(width + horizPad) !== clientWidth) {
            width -= getBordersSize(styles, 'left', 'right') + horizPad;
        }
        if (Math.round(height + vertPad) !== clientHeight) {
            height -= getBordersSize(styles, 'top', 'bottom') + vertPad;
        }
    }
    // Following steps can't be applied to the document's root element as its
    // client[Width/Height] properties represent viewport area of the window.
    // Besides, it's as well not necessary as the <html> itself neither has
    // rendered scroll bars nor it can be clipped.
    if (!isDocumentElement(target)) {
        // In some browsers (only in Firefox, actually) CSS width & height
        // include scroll bars size which can be removed at this step as scroll
        // bars are the only difference between rounded dimensions + paddings
        // and "client" properties, though that is not always true in Chrome.
        var vertScrollbar = Math.round(width + horizPad) - clientWidth;
        var horizScrollbar = Math.round(height + vertPad) - clientHeight;
        // Chrome has a rather weird rounding of "client" properties.
        // E.g. for an element with content width of 314.2px it sometimes gives
        // the client width of 315px and for the width of 314.7px it may give
        // 314px. And it doesn't happen all the time. So just ignore this delta
        // as a non-relevant.
        if (Math.abs(vertScrollbar) !== 1) {
            width -= vertScrollbar;
        }
        if (Math.abs(horizScrollbar) !== 1) {
            height -= horizScrollbar;
        }
    }
    return createRectInit(paddings.left, paddings.top, width, height);
}
/**
 * Checks whether provided element is an instance of the SVGGraphicsElement.
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
var isSVGGraphicsElement = (function () {
    // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
    // interface.
    if (typeof SVGGraphicsElement !== 'undefined') {
        return function (target) { return target instanceof getWindowOf(target).SVGGraphicsElement; };
    }
    // If it's so, then check that element is at least an instance of the
    // SVGElement and that it has the "getBBox" method.
    // eslint-disable-next-line no-extra-parens
    return function (target) { return (target instanceof getWindowOf(target).SVGElement &&
        typeof target.getBBox === 'function'); };
})();
/**
 * Checks whether provided element is a document element (<html>).
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
function isDocumentElement(target) {
    return target === getWindowOf(target).document.documentElement;
}
/**
 * Calculates an appropriate content rectangle for provided html or svg element.
 *
 * @param {Element} target - Element content rectangle of which needs to be calculated.
 * @returns {DOMRectInit}
 */
function getContentRect(target) {
    if (!isBrowser) {
        return emptyRect;
    }
    if (isSVGGraphicsElement(target)) {
        return getSVGContentRect(target);
    }
    return getHTMLElementContentRect(target);
}
/**
 * Creates rectangle with an interface of the DOMRectReadOnly.
 * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
 *
 * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
 * @returns {DOMRectReadOnly}
 */
function createReadOnlyRect(_a) {
    var x = _a.x, y = _a.y, width = _a.width, height = _a.height;
    // If DOMRectReadOnly is available use it as a prototype for the rectangle.
    var Constr = typeof DOMRectReadOnly !== 'undefined' ? DOMRectReadOnly : Object;
    var rect = Object.create(Constr.prototype);
    // Rectangle's properties are not writable and non-enumerable.
    defineConfigurable(rect, {
        x: x, y: y, width: width, height: height,
        top: y,
        right: x + width,
        bottom: height + y,
        left: x
    });
    return rect;
}
/**
 * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
 * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
 *
 * @param {number} x - X coordinate.
 * @param {number} y - Y coordinate.
 * @param {number} width - Rectangle's width.
 * @param {number} height - Rectangle's height.
 * @returns {DOMRectInit}
 */
function createRectInit(x, y, width, height) {
    return { x: x, y: y, width: width, height: height };
}

/**
 * Class that is responsible for computations of the content rectangle of
 * provided DOM element and for keeping track of it's changes.
 */
var ResizeObservation = /** @class */ (function () {
    /**
     * Creates an instance of ResizeObservation.
     *
     * @param {Element} target - Element to be observed.
     */
    function ResizeObservation(target) {
        /**
         * Broadcasted width of content rectangle.
         *
         * @type {number}
         */
        this.broadcastWidth = 0;
        /**
         * Broadcasted height of content rectangle.
         *
         * @type {number}
         */
        this.broadcastHeight = 0;
        /**
         * Reference to the last observed content rectangle.
         *
         * @private {DOMRectInit}
         */
        this.contentRect_ = createRectInit(0, 0, 0, 0);
        this.target = target;
    }
    /**
     * Updates content rectangle and tells whether it's width or height properties
     * have changed since the last broadcast.
     *
     * @returns {boolean}
     */
    ResizeObservation.prototype.isActive = function () {
        var rect = getContentRect(this.target);
        this.contentRect_ = rect;
        return (rect.width !== this.broadcastWidth ||
            rect.height !== this.broadcastHeight);
    };
    /**
     * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
     * from the corresponding properties of the last observed content rectangle.
     *
     * @returns {DOMRectInit} Last observed content rectangle.
     */
    ResizeObservation.prototype.broadcastRect = function () {
        var rect = this.contentRect_;
        this.broadcastWidth = rect.width;
        this.broadcastHeight = rect.height;
        return rect;
    };
    return ResizeObservation;
}());

var ResizeObserverEntry = /** @class */ (function () {
    /**
     * Creates an instance of ResizeObserverEntry.
     *
     * @param {Element} target - Element that is being observed.
     * @param {DOMRectInit} rectInit - Data of the element's content rectangle.
     */
    function ResizeObserverEntry(target, rectInit) {
        var contentRect = createReadOnlyRect(rectInit);
        // According to the specification following properties are not writable
        // and are also not enumerable in the native implementation.
        //
        // Property accessors are not being used as they'd require to define a
        // private WeakMap storage which may cause memory leaks in browsers that
        // don't support this type of collections.
        defineConfigurable(this, { target: target, contentRect: contentRect });
    }
    return ResizeObserverEntry;
}());

var ResizeObserverSPI = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback function that is invoked
     *      when one of the observed elements changes it's content dimensions.
     * @param {ResizeObserverController} controller - Controller instance which
     *      is responsible for the updates of observer.
     * @param {ResizeObserver} callbackCtx - Reference to the public
     *      ResizeObserver instance which will be passed to callback function.
     */
    function ResizeObserverSPI(callback, controller, callbackCtx) {
        /**
         * Collection of resize observations that have detected changes in dimensions
         * of elements.
         *
         * @private {Array<ResizeObservation>}
         */
        this.activeObservations_ = [];
        /**
         * Registry of the ResizeObservation instances.
         *
         * @private {Map<Element, ResizeObservation>}
         */
        this.observations_ = new MapShim();
        if (typeof callback !== 'function') {
            throw new TypeError('The callback provided as parameter 1 is not a function.');
        }
        this.callback_ = callback;
        this.controller_ = controller;
        this.callbackCtx_ = callbackCtx;
    }
    /**
     * Starts observing provided element.
     *
     * @param {Element} target - Element to be observed.
     * @returns {void}
     */
    ResizeObserverSPI.prototype.observe = function (target) {
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) {
            return;
        }
        if (!(target instanceof getWindowOf(target).Element)) {
            throw new TypeError('parameter 1 is not of type "Element".');
        }
        var observations = this.observations_;
        // Do nothing if element is already being observed.
        if (observations.has(target)) {
            return;
        }
        observations.set(target, new ResizeObservation(target));
        this.controller_.addObserver(this);
        // Force the update of observations.
        this.controller_.refresh();
    };
    /**
     * Stops observing provided element.
     *
     * @param {Element} target - Element to stop observing.
     * @returns {void}
     */
    ResizeObserverSPI.prototype.unobserve = function (target) {
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) {
            return;
        }
        if (!(target instanceof getWindowOf(target).Element)) {
            throw new TypeError('parameter 1 is not of type "Element".');
        }
        var observations = this.observations_;
        // Do nothing if element is not being observed.
        if (!observations.has(target)) {
            return;
        }
        observations.delete(target);
        if (!observations.size) {
            this.controller_.removeObserver(this);
        }
    };
    /**
     * Stops observing all elements.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.disconnect = function () {
        this.clearActive();
        this.observations_.clear();
        this.controller_.removeObserver(this);
    };
    /**
     * Collects observation instances the associated element of which has changed
     * it's content rectangle.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.gatherActive = function () {
        var _this = this;
        this.clearActive();
        this.observations_.forEach(function (observation) {
            if (observation.isActive()) {
                _this.activeObservations_.push(observation);
            }
        });
    };
    /**
     * Invokes initial callback function with a list of ResizeObserverEntry
     * instances collected from active resize observations.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.broadcastActive = function () {
        // Do nothing if observer doesn't have active observations.
        if (!this.hasActive()) {
            return;
        }
        var ctx = this.callbackCtx_;
        // Create ResizeObserverEntry instance for every active observation.
        var entries = this.activeObservations_.map(function (observation) {
            return new ResizeObserverEntry(observation.target, observation.broadcastRect());
        });
        this.callback_.call(ctx, entries, ctx);
        this.clearActive();
    };
    /**
     * Clears the collection of active observations.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.clearActive = function () {
        this.activeObservations_.splice(0);
    };
    /**
     * Tells whether observer has active observations.
     *
     * @returns {boolean}
     */
    ResizeObserverSPI.prototype.hasActive = function () {
        return this.activeObservations_.length > 0;
    };
    return ResizeObserverSPI;
}());

// Registry of internal observers. If WeakMap is not available use current shim
// for the Map collection as it has all required methods and because WeakMap
// can't be fully polyfilled anyway.
var observers = typeof WeakMap !== 'undefined' ? new WeakMap() : new MapShim();
/**
 * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
 * exposing only those methods and properties that are defined in the spec.
 */
var ResizeObserver = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback that is invoked when
     *      dimensions of the observed elements change.
     */
    function ResizeObserver(callback) {
        if (!(this instanceof ResizeObserver)) {
            throw new TypeError('Cannot call a class as a function.');
        }
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        var controller = ResizeObserverController.getInstance();
        var observer = new ResizeObserverSPI(callback, controller, this);
        observers.set(this, observer);
    }
    return ResizeObserver;
}());
// Expose public methods of ResizeObserver.
[
    'observe',
    'unobserve',
    'disconnect'
].forEach(function (method) {
    ResizeObserver.prototype[method] = function () {
        var _a;
        return (_a = observers.get(this))[method].apply(_a, arguments);
    };
});

var index = (function () {
    // Export existing implementation if available.
    if (typeof global$1.ResizeObserver !== 'undefined') {
        return global$1.ResizeObserver;
    }
    return ResizeObserver;
})();

/* harmony default export */ __webpack_exports__["default"] = (index);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(39)))

/***/ }),
/* 862 */
/***/ (function(module, exports, __webpack_require__) {

var camel2hyphen = __webpack_require__(863);

var isDimension = function (feature) {
  var re = /[height|width]$/;
  return re.test(feature);
};

var obj2mq = function (obj) {
  var mq = '';
  var features = Object.keys(obj);
  features.forEach(function (feature, index) {
    var value = obj[feature];
    feature = camel2hyphen(feature);
    // Add px to dimension features
    if (isDimension(feature) && typeof value === 'number') {
      value = value + 'px';
    }
    if (value === true) {
      mq += feature;
    } else if (value === false) {
      mq += 'not ' + feature;
    } else {
      mq += '(' + feature + ': ' + value + ')';
    }
    if (index < features.length-1) {
      mq += ' and '
    }
  });
  return mq;
};

var json2mq = function (query) {
  var mq = '';
  if (typeof query === 'string') {
    return query;
  }
  // Handling array of media queries
  if (query instanceof Array) {
    query.forEach(function (q, index) {
      mq += obj2mq(q);
      if (index < query.length-1) {
        mq += ', '
      }
    });
    return mq;
  }
  // Handling single media query
  return obj2mq(query);
};

module.exports = json2mq;

/***/ }),
/* 863 */
/***/ (function(module, exports) {

var camel2hyphen = function (str) {
  return str
          .replace(/[A-Z]/g, function (match) {
            return '-' + match.toLowerCase();
          })
          .toLowerCase();
};

module.exports = camel2hyphen;

/***/ }),
/* 864 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultProps = {
  accessibility: true,
  adaptiveHeight: false,
  afterChange: null,
  appendDots: function appendDots(dots) {
    return _react2.default.createElement(
      "ul",
      { style: { display: "block" } },
      dots
    );
  },
  arrows: true,
  autoplay: false,
  autoplaySpeed: 3000,
  beforeChange: null,
  centerMode: false,
  centerPadding: "50px",
  className: "",
  cssEase: "ease",
  customPaging: function customPaging(i) {
    return _react2.default.createElement(
      "button",
      null,
      i + 1
    );
  },
  dots: false,
  dotsClass: "slick-dots",
  draggable: true,
  easing: "linear",
  edgeFriction: 0.35,
  fade: false,
  focusOnSelect: false,
  infinite: true,
  initialSlide: 0,
  lazyLoad: null,
  nextArrow: null,
  onEdge: null,
  onInit: null,
  onLazyLoadError: null,
  onReInit: null,
  pauseOnDotsHover: false,
  pauseOnFocus: false,
  pauseOnHover: true,
  prevArrow: null,
  responsive: null,
  rows: 1,
  rtl: false,
  slide: "div",
  slidesPerRow: 1,
  slidesToScroll: 1,
  slidesToShow: 1,
  speed: 500,
  swipe: true,
  swipeEvent: null,
  swipeToSlide: false,
  touchMove: true,
  touchThreshold: 5,
  useCSS: true,
  useTransform: true,
  variableWidth: false,
  vertical: false,
  waitForAnimate: true
};

exports.default = defaultProps;

/***/ }),
/* 865 */
/***/ (function(module, exports, __webpack_require__) {

var MediaQueryDispatch = __webpack_require__(866);
module.exports = new MediaQueryDispatch();


/***/ }),
/* 866 */
/***/ (function(module, exports, __webpack_require__) {

var MediaQuery = __webpack_require__(867);
var Util = __webpack_require__(324);
var each = Util.each;
var isFunction = Util.isFunction;
var isArray = Util.isArray;

/**
 * Allows for registration of query handlers.
 * Manages the query handler's state and is responsible for wiring up browser events
 *
 * @constructor
 */
function MediaQueryDispatch () {
    if(!window.matchMedia) {
        throw new Error('matchMedia not present, legacy browsers require a polyfill');
    }

    this.queries = {};
    this.browserIsIncapable = !window.matchMedia('only all').matches;
}

MediaQueryDispatch.prototype = {

    constructor : MediaQueryDispatch,

    /**
     * Registers a handler for the given media query
     *
     * @param {string} q the media query
     * @param {object || Array || Function} options either a single query handler object, a function, or an array of query handlers
     * @param {function} options.match fired when query matched
     * @param {function} [options.unmatch] fired when a query is no longer matched
     * @param {function} [options.setup] fired when handler first triggered
     * @param {boolean} [options.deferSetup=false] whether setup should be run immediately or deferred until query is first matched
     * @param {boolean} [shouldDegrade=false] whether this particular media query should always run on incapable browsers
     */
    register : function(q, options, shouldDegrade) {
        var queries         = this.queries,
            isUnconditional = shouldDegrade && this.browserIsIncapable;

        if(!queries[q]) {
            queries[q] = new MediaQuery(q, isUnconditional);
        }

        //normalise to object in an array
        if(isFunction(options)) {
            options = { match : options };
        }
        if(!isArray(options)) {
            options = [options];
        }
        each(options, function(handler) {
            if (isFunction(handler)) {
                handler = { match : handler };
            }
            queries[q].addHandler(handler);
        });

        return this;
    },

    /**
     * unregisters a query and all it's handlers, or a specific handler for a query
     *
     * @param {string} q the media query to target
     * @param {object || function} [handler] specific handler to unregister
     */
    unregister : function(q, handler) {
        var query = this.queries[q];

        if(query) {
            if(handler) {
                query.removeHandler(handler);
            }
            else {
                query.clear();
                delete this.queries[q];
            }
        }

        return this;
    }
};

module.exports = MediaQueryDispatch;


/***/ }),
/* 867 */
/***/ (function(module, exports, __webpack_require__) {

var QueryHandler = __webpack_require__(868);
var each = __webpack_require__(324).each;

/**
 * Represents a single media query, manages it's state and registered handlers for this query
 *
 * @constructor
 * @param {string} query the media query string
 * @param {boolean} [isUnconditional=false] whether the media query should run regardless of whether the conditions are met. Primarily for helping older browsers deal with mobile-first design
 */
function MediaQuery(query, isUnconditional) {
    this.query = query;
    this.isUnconditional = isUnconditional;
    this.handlers = [];
    this.mql = window.matchMedia(query);

    var self = this;
    this.listener = function(mql) {
        // Chrome passes an MediaQueryListEvent object, while other browsers pass MediaQueryList directly
        self.mql = mql.currentTarget || mql;
        self.assess();
    };
    this.mql.addListener(this.listener);
}

MediaQuery.prototype = {

    constuctor : MediaQuery,

    /**
     * add a handler for this query, triggering if already active
     *
     * @param {object} handler
     * @param {function} handler.match callback for when query is activated
     * @param {function} [handler.unmatch] callback for when query is deactivated
     * @param {function} [handler.setup] callback for immediate execution when a query handler is registered
     * @param {boolean} [handler.deferSetup=false] should the setup callback be deferred until the first time the handler is matched?
     */
    addHandler : function(handler) {
        var qh = new QueryHandler(handler);
        this.handlers.push(qh);

        this.matches() && qh.on();
    },

    /**
     * removes the given handler from the collection, and calls it's destroy methods
     *
     * @param {object || function} handler the handler to remove
     */
    removeHandler : function(handler) {
        var handlers = this.handlers;
        each(handlers, function(h, i) {
            if(h.equals(handler)) {
                h.destroy();
                return !handlers.splice(i,1); //remove from array and exit each early
            }
        });
    },

    /**
     * Determine whether the media query should be considered a match
     *
     * @return {Boolean} true if media query can be considered a match, false otherwise
     */
    matches : function() {
        return this.mql.matches || this.isUnconditional;
    },

    /**
     * Clears all handlers and unbinds events
     */
    clear : function() {
        each(this.handlers, function(handler) {
            handler.destroy();
        });
        this.mql.removeListener(this.listener);
        this.handlers.length = 0; //clear array
    },

    /*
        * Assesses the query, turning on all handlers if it matches, turning them off if it doesn't match
        */
    assess : function() {
        var action = this.matches() ? 'on' : 'off';

        each(this.handlers, function(handler) {
            handler[action]();
        });
    }
};

module.exports = MediaQuery;


/***/ }),
/* 868 */
/***/ (function(module, exports) {

/**
 * Delegate to handle a media query being matched and unmatched.
 *
 * @param {object} options
 * @param {function} options.match callback for when the media query is matched
 * @param {function} [options.unmatch] callback for when the media query is unmatched
 * @param {function} [options.setup] one-time callback triggered the first time a query is matched
 * @param {boolean} [options.deferSetup=false] should the setup callback be run immediately, rather than first time query is matched?
 * @constructor
 */
function QueryHandler(options) {
    this.options = options;
    !options.deferSetup && this.setup();
}

QueryHandler.prototype = {

    constructor : QueryHandler,

    /**
     * coordinates setup of the handler
     *
     * @function
     */
    setup : function() {
        if(this.options.setup) {
            this.options.setup();
        }
        this.initialised = true;
    },

    /**
     * coordinates setup and triggering of the handler
     *
     * @function
     */
    on : function() {
        !this.initialised && this.setup();
        this.options.match && this.options.match();
    },

    /**
     * coordinates the unmatch event for the handler
     *
     * @function
     */
    off : function() {
        this.options.unmatch && this.options.unmatch();
    },

    /**
     * called when a handler is to be destroyed.
     * delegates to the destroy or unmatch callbacks, depending on availability.
     *
     * @function
     */
    destroy : function() {
        this.options.destroy ? this.options.destroy() : this.off();
    },

    /**
     * determines equality by reference.
     * if object is supplied compare options, if function, compare match callback
     *
     * @function
     * @param {object || function} [target] the target for comparison
     */
    equals : function(target) {
        return this.options === target || this.options.match === target;
    }

};

module.exports = QueryHandler;


/***/ }),
/* 869 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 870 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 871 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 872 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 873 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 874 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 875 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 876 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 877 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 878 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 879 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wBDAAIBAQIBAQICAgICAgICAwUDAwMDAwYEBAMFBwYHBwcGBwcICQsJCAgKCAcHCg0KCgsMDAwMBwkODw0MDgsMDAz/2wBDAQICAgMDAwYDAwYMCAcIDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAz/wgARCAAVAEgDAREAAhEBAxEB/8QAGwAAAQUBAQAAAAAAAAAAAAAABgQFBwgJAgP/xAAcAQACAgMBAQAAAAAAAAAAAAAFBgMEAgcIAQD/2gAMAwEAAhADEAAAALkJ/TUd1GK15zU5JKMnsmhMUd6ooLbs7EkWZSCZl0m9SNUdqeCSHSZe3YLQlvDzMFrHTCcN379qq6cp0jXt3abuHMZjOGXZQIsZ2rC09SUk3kv/xAAuEAABAwMDAwMDAwUAAAAAAAABAgMFBAYHCBESABMhCSIxFSRBFCNhMkJRg5L/2gAIAQEAAT8A1U6tLx1iZeyDAW5f7+IcC4hc/S3deFIFmskann2ywwUe8kr9iEI+fk/KUmb036bbNsmyrlsvU1ka1rmvhxaIOadrH3u8+hztLNU2lCFsoDpCFFZT16busO+5zKV24JzOGDk2xG01FPJtAJRcFCdtnvwCrZSFcgBySvyAQd4r1Y8dzWsuqxCwlbP01D4rrjrK2np4tt1psL7bais9zffjv7fII6azlZb0BUyyLvtdyKo3EM1FYmUYNOwtf9KVr58UqP4BPnrNOpi3MR4zr51qRhZivTFrk4uLRLMMPTYCSUJYUo7ELPgKAI6uv10DYcDbFXN4emo1+5pF6gbYXPsLLQbLQ7nJLZBBLnx1pR13yepPM122pX45krPprZZddTJ1MsxUt1nbfDQAQgAo3B5+erTzNaF9zL8dCXTbsxI04JcpqKRZfeQAdiSlKiQB1pHmGbG0PansTyFjMX/f9rXDU1ddbD/PuSrKnm0CqSG9nVhooLv7fu8J2PU3QSJwxpmCdI1LVn6jU70/CS+33rkkeOfNHdH3H3ZWnq2pWnzp6+r0pa5RVRuOLMVGztUyQWkVCuY7PIeCQXQk/wAtq6uvEuHsReq7d1oZGZlKPG8fMOllpC3Vvl91DbzG5SORQp5xXWf8B3ZjnVnkDTtbDAeobsutito4wtpaRW8Q8/Rq/wAAJbfV/wAjrTbZEjqem7nqbmArIzCOMZNumQtsEUiWG30UrJ3+CHXln/WOosssYRxeEFpAN4SB9uw3PKj6XXXRDzWph2zzUshb62512h3S8iOMt+6SU+4NlXALI/tJ6oGbCgLgwZVaf6673cuOuMidbKCnhIcm+KWOIAKCruAgEoLYBV16gvp7x1+3I9meybrmMZZOt+lK3JeKRzEm2hJAQ83yTudhx5b+R4UFdY81m6jNVd80eNqvMRgKaWdFE9JR0Aw1V8T4JCkLSoE/wodaJ9EFn6G8ZuwdsiprpGScFRLzNYQqslXvPvWfwBueKR4G5+SSTfGm3H2TbwpJ+4rJtacm6Dj2K6ujGX6hvid0+9SSSAfIB+Oq/CNnSmRmLwqbWt+ouukSEMzDlA0quaSAUgJdKeY2BI8HqA034+tVudbjLJtWgRc7ampcU8Wy2JNCioqS9skdwHkrcK3+T0NG2JUUNJSjGliimoXlVFM0ISn4MOK25LSOHhR4p3I6s/T7YlhzcpJQlnWzEyE2hbUhU0kayy7XIWrktLqkpBWCryQd9z1j7TDjnFVzVE1bNi2nAy9VuXKygimWHvO+4CkpBSD+QOv/xAAuEQABAwIFAgUCBwAAAAAAAAABAgMEABEFEiExURNBFDJhcYGhwQYVIiRy0eH/2gAIAQIBAT8AmTnZTq0IXkab8yu5PApUSAhCHGpCkqVsf74rCJ7xcXDl+dPfkUnG2DKMUdtz20oSWsubMLc3qRLbabK7g6XAuNfal/iPIlJW0Rc23FQcSVIdU0W8uXvem5DSzlQoE+hqCckORGKMy0nUc67/ABvSgrox/wBrfU88/ff9VIUHsaKm9kJsaWxFaxJbT/kv/oqVFcbkuQW9lKGnO9qhtqkFXU1DaD9L2pNuk3/I/aruAyC18+2akhhKmTCJ6ml/f0+vxWKYWlavFMqKFjuO9MT58lfhy7a/cAXrDcNahtlDe53Pc0uIw4oLWgE82oxmivqlIzc21pERhObKgC++m9fl8a1umNPQU3FZQSpCQCd9KahsNKztoAPoK//EADERAAEDAwQAAwYFBQAAAAAAAAECAwQFESEABhIxBxORFBYiMlFhFSNBU4ElcXLBw//aAAgBAwEBPwDam0adt6nxJUyIJlRmZZZNuKU2vyVfGBkk6Y3JvGRJkw6lRWXWWLeYgBIski44EkhR45FgdeJGzqW1BY3Rty/sj+Cn9tecf2wRY9Ead8Jau1t0bgXnlx4thKiuxJFyLY0aFUg6GDHXzIJCeCrkDsgWvqibZmT5qYqkKQnmErVwUQjOeVurdkah+BXtTr7caoJUGkhV/LVm/LGT9tbr2GzR6cxOamJeLpA4hCgRdN+z39NS6LUIrYeksLQk9FSSB6ka3ayZO5aLXWpJjxnW0hLotZJAJ4Zukcr8fixphxn8RrX9fI+FOfy8/AftY8fk/KsdSWlUzwrDE7C5LwU2D2U4z6C/8jUSrbhn7Fjz6QUqlKQLnAFgSlXeLhIGtvV+DLoMTd00/E00UleTxyEr9Ska3JOZorTKIWFzpTd/vyKSs+iR66d5GpTb/so/6aQiC41Rk1CxwOAV0V+VjvF7Xt99LNVdZqiN1pb9iAPD/DNyr72sQcHl1rw88QnorPu7UmEyojh+ReOJJ7SbHVQ2ZtChxlVhuneYUC4SpxRT6EEeo1vbfNQ3NNEmZZKUiyEJ+VA+g/2dQdy1aFHVEiSVobV2lKiBnvAOkVuoNwzT0PrDJ7RyPE/rlN7akbkqz5aL0lxXlG6LrUeJ+qc4/jXvnXual+2O3UACeasgXsDnrJ1L3DVJTSGZMha0osUgqJCSMC2cW1UN0VicwI0yU44gfopaiPQnX//Z"

/***/ }),
/* 880 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 881 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 882 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 883 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 884 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wBDAAICAgICAQICAgIDAgIDAwYEAwMDAwcFBQQGCAcJCAgHCAgJCg0LCQoMCggICw8LDA0ODg8OCQsQERAOEQ0ODg7/2wBDAQIDAwMDAwcEBAcOCQgJDg4ODg4ODg4ODg4ODg4ODg4ODg4ODg4ODg4ODg4ODg4ODg4ODg4ODg4ODg4ODg4ODg7/wgARCAAVAE0DAREAAhEBAxEB/8QAHQAAAAYDAQAAAAAAAAAAAAAAAQQFBgcIAAIJA//EABQBAQAAAAAAAAAAAAAAAAAAAAD/2gAMAwEAAhADEAAAAOtpFJYUEaorDpPAbRNZz9I/K8iiLgbCpHRcAlsuUJAZMNhODwAaBP/EAC0QAAEEAgEEAgEDAwUAAAAAAAECAwQFBgcRAAgSIRMiMQkUUQpBQxUWUmGR/9oACAEBAAE/AN+9w0bTL+I4tj+Hz9obazB9xjFcOq30Muyg0AXn3nVcpYYbBHk4QeqDui2nhu7sRwzue0rG1XAy2aIGOZdRZELSpM1ftuFJJQhTDiv7LPKSeoncDo6dsiNh8PbeJycofacdarEXrBfKWlqQ59fL0UqQsEH39T1Q7/0hlGG5DkOO7YxW5o6J9DNzOiXbK2oKlrDaPlIV9ApRACj6PVv3K6xn6v2VP1bnWH7HyvEa12VKpmMpYZQCgf5Xh5Btv+XOCB1f9xOosAw3C5m1diYxr63yKuYlR4E68aPJcQFHwV682wSQHeAk9ZpuLVeutUxM5zfYVDjWISwgwraZZNhiWFjlPwqBPy8j2PDn11C3bp+w1HU59D2ZjTuE2b/7eDeG4ZTDdd8Sr4/lKgkL4SSUkg9K7nu3dGsIuaL3XhwxaTO/YsWRvmPiXI/u2Pt+eoE+DaUkSyrJrFlXSmUvRZcV1LrTzahylaFpJCkkEEEHg9dw9qdF/qpaq7nMsrJk/Ui8Gl4Tf2kKKp//AG2+7LEliY6lIJDTntpSh13Mbj133b4nhnbx2+5DG2XkNxk9da3F7TgvQMZgQ3w+7KffA8UOeghCPySrrJ9a4E//AE3N1kpxGEMkk7GdlrtxCCZ5WvKTHK/lA8x5MfQ9fqKYVi+JbVnwMQxuHjFdd6TkwbdmmhBhuU0zkVSGAtDYAJQHHPE9d/8AgWE681bouVg2JV2KGTjN5Szv9GgJZ/cwDWoWY7vgPunyAP260HmOhtY7L2qO7F2iqMzuaWlk43a5hGQuJZY6KlhDEeAXElPDaw8FtI+3l1hVv2/YZ3hag2FmeITsD7WpuAT42p151FWayotF2rrspZbe8hGMhhTSmC5/j9DrJKjCdkd6km+1vTRZ/a3ke78VitMMRCipubhqNIM6TFb4CS0QGkrWkeC1DrHtWa3d/Xz3XAewKkdrDqCukiEuqbMUPOyVtOuhvx8AtSEJSVAckddgCDF/TGxirHmiHWZFfwIDLpJLEZm5loZaHPvxSgADp5lmREdjyGkPsOoKHG3EhSVpPogg+iCOqTGcbxmC/FxvH63H4zy/N5mtgtxkOK/5KCAAT0aWmNCao1MI1fn5mGYqPh8vLz58OOOfL7fj8++p1JTWb4dsqiFYuhotBcmKhwhBUFFPKgfXKUnj+QOptRVWbTTdlWRLBtsENpkxkOBAI4PAUDxyPXVxiGJZDFrmL/F6i8YgLC4Dc+tafTFUOOC2FpPgfQ/HHVtR0t/jz1Re08K7qXQA7CnxUPsLA/HKFgpP/nTNFSRqevr49PBYgQFJVBjNxEJailPPiW0gcII5PHHHQgwUXDtgmEwme40GnJIZSHVoB5CSrjkgfx1Dgwq6CI1fDYgxgpSg1HaDaPJRKlHgeuSSSf8As9f/xAAUEQEAAAAAAAAAAAAAAAAAAABA/9oACAECAQE/AHf/xAAUEQEAAAAAAAAAAAAAAAAAAABA/9oACAEDAQE/AHf/2Q=="

/***/ }),
/* 885 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wBDAAMCAgMCAgMDAwMEAwMEBQgFBQQEBQoHBwYIDAoMDAsKCwsNDhIQDQ4RDgsLEBYQERMUFRUVDA8XGBYUGBIUFRT/2wBDAQMEBAUEBQkFBQkUDQsNFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBT/wgARCAAfAEADAREAAhEBAxEB/8QAHAAAAgICAwAAAAAAAAAAAAAABQYHCAAEAQIJ/8QAHAEAAgEFAQAAAAAAAAAAAAAAAAEFAgMEBgcI/9oADAMBAAIQAxAAAAD1TDA1g2QAqRo3MZF8IzWSVvNjcOGhw2oVVcf0TX/ofgG1MfjWx1Pv8NNEGAAHhGq3LtM8IZaL7JFb8k1I+hYYyoOphmKrTij/xAAzEAABBAECBAMGBAcAAAAAAAACAQMEBREABgcSITETIkEIEBRCUmEjMlHBGGJxgYKRof/aAAgBAQABPwD3Tp7FcwLsg+QCcBpFxnJGSCKf3VUT3b23dC2JtSzvbA+WNCZVzHqZfKKfdVwmqj2xd0SePEm9OuzRLASKtSj68gAnm8TP1qWtu30PdFJCta91H4cxoXWjT9F/dPdOv7katKmNLVbuPMdR18gTJstfiZx/MCiOf1zq73hPmSWXq5yQMN9WYiNxQE3ecwJ01HK45kEUH7Kq6u7O4ZgS2mmp8aEjsNxh+7BPwnvigymUJVJFTC9dS4s/a82vlBaybAJUpuNIjSVTlLnLHOHTyqPfHbCa9tTi4l3es7Lrnswq5fFmqHY3/QP8U1AiJDjJlMPOJzGvrj0TXsd8UfAfkbLnv+RzL9epehfOH7+6y4wUFXvq3er9v2dzLjAMObNhBziCIS9OX7L0zqHf7dZ3RG4fM1k1v4ttbFuQbmFZJRV3KfMJJjUniDtqbWbyanwLW0bqDaCT8ZIQldQXsCg+iJzDnUDjjs6HZ1zkhi7djcikxKmFztxSVFRUBO5Knbm66Wn4M2VtPen0G4fjlNXxV2QRnKJVz2z0z30kbg29Vuyx21eHLA8HESQvlH61LOETUHbvCujDad9WVNsjlnNRlgwlqJMOCYj5uv31ccf7Sj4tT6w4b8mlimTHwjLSK8Rp86L9OuIzyVm87Qqussdt7jOWpAcOcCsPipfnJPRV741vY9y7D4m7W3TIhs2Ux6vajOJ4oijj3Iomn/c57agwbN/bvFJ2ZGFiZJVkyaA0VBJXyVURc+mt90xnt3hGyEYFbBtnxQ6Y6kzzf1z11b1Z/wAUVc+jA+AjQfp3RldbHqXWHuLnNHBEcbfFv8v1H00xVSg2Xw4FWurd4ZH5k7eM3rf9nY8PuPY3wV4z25UUW2Q8VAzkeVf9Y1//xAApEQABAgQEBAcAAAAAAAAAAAACAAEDBBFBBRAhMRIUIIEVIjJScZHR/9oACAECAQE/AOh9GUlKjOAwj3dRIZQjcC3bqN7LCZPlYHm9RausZlKtzAd/3KitVUVEA8Bsd14rN+5vpFic0YuJO1PhU0ytk27q2bbL/8QALREAAQIEBQIDCQAAAAAAAAAAAQIDAAQFEQYSICFBBxQWccEQIlFSU2GBgpL/2gAIAQMBAT8A0U2Rdqc23KMjdRt5fExj7tsB09ZmveXmARwV39AIkptqel0TTBulYBGrp5Qu3YNTeFlObJvwnk/mOs+OfGmJFplVXlZa7bf3+Zf7GOnNeyKVSHzsd0efI9dINjeJrGFYm5FynqdytrSUHKAkhJFiARuNo8A0D6R/oxL4Hoss6l9pCgpJuDmOxi/tHOr/2Q=="

/***/ }),
/* 886 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wBDAAQDAwQDAwQEAwQFBAQFBgoHBgYGBg0JCggKDw0QEA8NDw4RExgUERIXEg4PFRwVFxkZGxsbEBQdHx0aHxgaGxr/2wBDAQQFBQYFBgwHBwwaEQ8RGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhr/wgARCAAZADsDAREAAhEBAxEB/8QAHAAAAQQDAQAAAAAAAAAAAAAABgABBAcDBQgC/8QAGgEBAAMBAQEAAAAAAAAAAAAAAAECAwUEBv/aAAwDAQACEAMQAAAA70kkMDHAxqzbldCdjuOIob0Y66wgpMr5+InfEEWhSM87UdrnnCSs5E6WYxICL1vvHU/pdhDDnkjk4//EADIQAAEDAwIDBgMJAQAAAAAAAAECAwQFBhEAEgchMRMUM0FRcRAVgSIyRVJhYnKRsZL/2gAIAQEAAT8AhVKHUe17hKZk9kra52awrafQ6iVGJPDvcpLUgMq2OFtYVtPodQanCqQcNPlMyg2dqy0sK2n0ONV/ihbltM1FdVkutOQBlxosKClHySn1J1Qb6u+85prsieq27XcfS1FZQ0lbj5zgIbyMqJ81dBpIwACScD40q5k2lGv0IUESRM7OMP3qU4M/QDOrTuN21aRdkeVliWqM2ppK+u9X2f8AFg6g16Rw4sugmLGaemVZxb7qXc5wQNvTzxt1dUeHJoUWvcRaeGppcW0mnsjHeUc9jbnX3J9NX3Piw7qs5mWGoMOIwh91CE4Q0M5wAP4aonEKq1xc6qCExAteFlS5L4UXFgeSRnBOhxCuyfDdrNJoDPyVvJBcVlakDqev+DVCvel1qkxZxeTGLycqaWeaCCQR/Y0m05Fw8aqnT3W3hT2pypUhRSQgtgBWM9OZIGuJVsSalxehwIzboYqoYUpaUHaAMpXz9ka4iNKm8UrHpDLLhiMbFrCUHaBv9fZvXHQvTKjaFKjIdX3iYSvYgkAZSnn/ANHV3UJy+OMMuj7347DNOwh4IO1KwjI+m5Q1SKnWajaVe4dVaO4xXYbREBWwhL4QoL7Pd0JwOR8wdQKlR48FuBPoNxyK+hXZrYbmraQrn+QAkH9Mat/hpRPk0NS4lRgqW3vVHflZW2SclJI0nxF6Pip9tHxRpz76dJ8VWleMPfX4h8P/xAAkEQABAwMEAQUAAAAAAAAAAAABAAIRAwQSBSFBUSITIDAxkf/aAAgBAgEBPwCCFBCghDXbA3LrXKKjeCCPxWxurup6k4s679kZQnDIhRm4q90Oz1C7p3Dx5M656lMENICLANuVg36JRaQVlDE13immGlU9pKacWraclui8/D//xAAiEQEAAgEDAwUAAAAAAAAAAAABAAIRAwQSEBMxICIwQVH/2gAIAQMBAT8A662tTQo3v4JttTc7u/ds8afR++gcZg4GDxJYLV9xHAhCyzkwRnHNpYzaPkl4mbQ8cehU+H//2Q=="

/***/ }),
/* 887 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wBDAAYEBQYFBAYGBQYHBwYIChAKCgkJChQODwwQFxQYGBcUFhYaHSUfGhsjHBYWICwgIyYnKSopGR8tMC0oMCUoKSj/2wBDAQcHBwoIChMKChMoGhYaKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCj/wgARCAAsAEkDASIAAhEBAxEB/8QAGwAAAgMBAQEAAAAAAAAAAAAABQYDBAcAAQL/xAAaAQADAAMBAAAAAAAAAAAAAAADBAUAAQYC/9oADAMBAAIQAxAAAAHUc69RVL5C2E9BW1iNHY50u5eF8lp2lU2zpYyB5SqFpEoxs2vR6wI+kxFLQyYQrVsexZgfJt+E0SYpxZkUvBWR4Fqxl3pmSeSoc7umi//EACAQAAICAgMBAAMAAAAAAAAAAAIDAQQABRATFBEGFSH/2gAIAQEAAQUCMxWF/emUncsnKNpbTNHbhYSy2087WYq4wcWYsHPyW5JN4j+4EJHFHDA4pt625rgW6+dRQaz9QmWJrIFTqhwKRBZLknH0B9iFdfoLLliaFxe3IcnYoIGbYnxLB9FKWpkT+Yb2TPbLI845u9f7EkMiXFFQuEYgR4o15jm7r69vLtcUO1GsRYFawWuzVXAwP0kVlhz/AP/EACARAAEEAQQDAAAAAAAAAAAAAAEAAgMRBAUSEyEiIzH/2gAIAQMBAT8B0/T2loll7RhjIotRw4ozuaE6JjuiFkQ8TqXHkOPIz50tuaftqpy3yVZF+PQTiGD2rA1Aw+t/YUk7Y2byhniZ9UpphELKllMrtxX/xAAhEQABBQABBAMAAAAAAAAAAAABAAIDBBESEyEiMRQjQf/aAAgBAgEBPwGWU7gXIq3amd6PZMsSRnWuVOz8hm/q1mYUeinuqAeOatp8fMglMaZD9HoZ6UsXLuEG6cV2i4DmCq9V07sBUEDYGcGr/8QALxAAAgEDAQUGBQUAAAAAAAAAAQIDABESIgQQEyExIzJBUVJhFDNxgaEgNJGSwf/aAAgBAQAGPwIs5so6k0V2QYr6z1q7Ty/2rlMzDyfnRLIRIvh4GuuI9q77fzWvUKyU8tw2VDpXm31/Ry+JH0rIX++8ek9d23SbQiv2mAyF/GoojDlKXCsUXX5mofnRhsro9suVTMkcyPxBFHn3larJLtAZXVSWtZ7+VbSQ5m4Rw1+qiZIGNrC8NgPzWN2yZyi1tBTLTo1D87pI+HftxPe/UeVLlFlzctq65VEjbHoi7gEpFqIMSiTiiRGy7ppZxs0QlyyY8frUxYRyJM2RW/8AtMGhjZeLxU1HlUbKFDRsW69b1wxEqBmvpO4NH85Onv7UVYEEeB3/ALa4XvPegByA38R/tv7VNXqHWiqk296zlzNvC9BEUKvkKyXl9KtQa1z77//EACQQAQACAQMEAgMBAAAAAAAAAAERIQAxQVEQYXGRgaHB0eHw/9oACAEBAAE/ISGlnQBkNa2ZXg2yWE+ZhZ5gRfeaj/BfgcYrtMgMk/njofL1w3KX10gAQQ77DqFACrxgJeLpF4aAnBh6qZdn9ugDBAhZX6MQQRQyajwVmrxUprsSsWoaXJN9ov1keANxkC+OHmhESPTgj7whL7AFF4yIKgjSiZfTki0ogWvB7z9Z38q3IKaOzmbx2KNr+KqjAG3yQ5mZjGK6RoCIk30+8gK94RXoRV4t9EuQ8kP9GMBQAQlVNXHOHvaCkukaqnBIsBKq966cEyD4cNiaEITrY9GlAf3BDAQB1Vgh2/nrY6Wq8LGh4Y8+FQ/nDB0gKDGhL4VYVhwoFrzaOv8A/9oADAMBAAIAAwAAABBY1f7Vb1+/k3MHT3//xAAhEQEAAgICAgIDAAAAAAAAAAABABEhMUFRceFhoZHw8f/aAAgBAwEBPxAqLOQdV293K9K8EY4L3mvENpMetp1EcVdgE0CHP18ygBVfIcrnOTVvWMxuk0VZgW3JjryblDChoUdXR++4Yoqql7rBxBAumtnqUia+44aDjN/n1KSXEn8Z/8QAIhEBAAICAQMFAQAAAAAAAAAAAQARITFBYYHBUXGR0fDx/9oACAECAQE/ELx6qBt3CAQ6MfLzLoDv4g3yhhPPeA2i4KN1T3x+4joZQ01YPDplwWKWgm6trpn64iW4AHILyu/eDwmPUmos2K76b8SpQhD+r6z/xAAiEAEAAQQCAwEBAQEAAAAAAAABEQAhMUFRYRBxoYGx4fD/2gAIAQEAAT8QYNxiAZVo2Skg9lLD2L6pStdI9AgUVFZiDjY/EqIQwdQ709jc7pPPqtfctQEOX+lOxzWB9O/2vuai4TT4eCKWzEp0EPt68qWCAErUXmCQjtFKfSjBE5PLIJwtHH4flXosNTQLtJZCiDHcqEy8hcwAzSelsUyITLxnLbi8KyfRGCwHKJbtyVDgsYDQCl2+N5qQnA4K6MCRPd0tT6YEmStwRBsFUlNFLNoASiRYtB7EDdDLarBOYWgOEp2KMBm1zrISj2MYqGGXk5luLogMycVEryTzaiU83zLul/4sIzZaoWS2BFIKDJG0pIyQ41+06oaEnkMr6SNES5V3p6FkgXIMYNpCKEjXk1IQZKSDDDfFTnxBQRkMO+DBXZ8pwA6KwZVPOx5nmlcmcIMiOHzEigdNUn8T3ajzkwAHkg6O6XDl/DyExRBMZxOzpGmvaBafgVgyTA+1AfVQZjBA9V/wZ4CMflHUBMWiaVySD3OjHn//2Q=="

/***/ }),
/* 888 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 889 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wBDAAIBAQEBAQIBAQECAgICAgQDAgICAgUEBAMEBgUGBgYFBgYGBwkIBgcJBwYGCAsICQoKCgoKBggLDAsKDAkKCgr/2wBDAQICAgICAgUDAwUKBwYHCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgr/wgARCAAYACcDAREAAhEBAxEB/8QAGAABAQEBAQAAAAAAAAAAAAAACAYJBwr/xAAUAQEAAAAAAAAAAAAAAAAAAAAA/9oADAMBAAIQAxAAAABAGSZ3oV5QhCAgV5FHssMTgnDjLE1vP//EADAQAAAFAwMDAQYHAQAAAAAAAAECAwQFBgcIAAkRChIhEyIxNFJzdBQVQlFTgpLx/9oACAEBAAE/AOp13n8n8C5Wg8QsKlwh62rxid/I1UDIjlw1bCsKCDZoRQBICyinPJxAdZe7hvUT4CXNQsxlZlncmlKheRCMq2ZOJdo4BVssJuDlUSA5fBiHKJefAl1kpuybll6dr21uf+OWZtZQsrRbsLe34hotyiBAkicqx00JOwRD8WhyRQ/gvrJ66cfdLyD3NMerxYE5DZRTyF2UIdeToO4RF0iyiLVYgJCcnzi1cekfyXyRfXTlPd3G8uX94nuf+UNby9O2afr0mtTcouUGz6eMbgx/CZRORJAO8v3KRtdWdeAmWW6Hb7Cyw1oVX1fUiwaRITDNYwPJV9JKEVbMSF8FAifeQwH+ZY+t23E3csxgvdAjuazErM1RPU2l+Qz8lUoSoLsW/segVYDDwKQm8k/c/OtjW9NABkHUWA+QkkYlrsmqfGiJ79QR0uobuh5Ihf5UXvpgX6usY7s3w2Ut1GOqWr4xZtP2ordWKrGKIcQK/Yd4oukw+YiqBhOmP0zatae3E5S6Vy7YxbRFhWaaE6Z62ZegaQFdBMSOFQEAMJzJAkHJva4KAD7tdRnsvZsz+ZUPus7dMPJT1QswYOZ2GgeBlYySYfDP2qRviCCQiQGTLyYBT1J4Kb9O/wD5V0k7zltNP0PTtLoEYPKkqWjxg2USyMcDLnQbqAU7pwp/0SF1iL031N4279b+/MNQvZYyjoBCqLfIueVEizaoegVmIm57zNlCKuv7oa3edg9rmtu0WJykpSlxPSU/KkbXxBBLggIRxPXQWP8AcJkBn/jSCCDVAjZsiVNNMoFTTTLwUpQ8AAAHuDX/xAAUEQEAAAAAAAAAAAAAAAAAAAAw/9oACAECAQE/AH//xAAUEQEAAAAAAAAAAAAAAAAAAAAw/9oACAEDAQE/AH//2Q=="

/***/ }),
/* 890 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 891 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 892 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wBDAAIBAQEBAQIBAQECAgICAgQDAgICAgUEBAMEBgUGBgYFBgYGBwkIBgcJBwYGCAsICQoKCgoKBggLDAsKDAkKCgr/2wBDAQICAgICAgUDAwUKBwYHCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgr/wgARCAAUAEIDAREAAhEBAxEB/8QAHAAAAgICAwAAAAAAAAAAAAAABwgGCQEFAgME/8QAFwEBAQEBAAAAAAAAAAAAAAAAAAECBv/aAAwDAQACEAMQAAAAtxGDO81xsgXnp4frcKSO45GsPQSDGwtdGCIwc86kW8vhlSdq2Xwp9hvhQacCFrqdRII//8QAIRAAAQQDAQACAwAAAAAAAAAABQQGBwgBAgMJABESEzH/2gAIAQEAARIAQ+tvm0RI6Cktwmh+/r1xz0wLJjTY7gYCkeCtIq5a9UqrOca6522z9Yx/ctZ5NB7oOhRlusaYTcu+3Dqp+RJbmHprmx+wAx1RDdwxwp4cHLpaF6vtgRYodEejeqlcl643/GsJqUTcZJFEnjOCRXrpjTTl88RKo1on/wA3Duk1Q22TO6x5Gk3crVG6Vp41pUxajVrcibDne01F2iwXhEcx3wpjeFlU6uBPI6VW7LYhZs3D9KrFzzRXz2lq0DafSQuMISErb7KZD0lv1N85lMb2Js3Z0PJrPfDlRCXc0+tqS1KLGXrsI3gvEgWQGwKMGlky1foFQqUI+LznazSWFrwwmVPqK7a3WvnUmx7hpeAklG5ycvKUHaE3Wz4KlEW0hYx22hdxMqmHcORMjXVryNz78qstuy8jgWO4i3XBUJb7zUq8O8+x8XNMKUA8os4ZMM0zWJ3v+drCVJfkxSEWcRsG43Sg4FvOWq0R2C81ZKgOURyleCLyId365Ur388a5GoAf8tuVxgGBMrZ0auYlrBFlgraXOiiT0itaHde4rUhy84z80z/dQZWSVbNSESZcd999gghn14YFyYJtRZ2f8rjD30cHdMGORZ6c21TRi3OC12j13bmBR69Vv//EACgQAAICAQQCAQMFAQAAAAAAAAECAxEEAAUSIRMxIgYQIxQVMkFDU//aAAgBAQATPwCTJkQciaosyADWLMJI5Y2Fq6spIZSKII6Ojra86PIjSVTTIWjYgMD7HsfbJwTHCryglfG9/PUXypBfIstfJON32COjoB1lAH/RW/uu7BIN/bctnhfJiiCQ0VmI5pwskEEVrfgJodt2eAwsZFElq5DT0tggCwATqPakxcvbM2BCWRgircZNDvl04IqiDl7aoh23epcsBs+WbpnTx/58qtNDZ4YG2p8tS4bGkjRb4BWFj42ACpB1k34jl5IKRPJRBKL25GsP6G/Bte3ZDUZMfKgi4gp2ALHIj0RrdjgwP9Lx5GQY5ocpBGAwT0hdTqODBiXKyFjAklCDHpAzAtxHq61se+xY8cpmYCU9QntgBetm3ARbhi5v8pJmmKHmZW7ex7oiqFbk8bTzwIuMUEzBB5CPIw5e9CZVngmjnVo5onC0royBgaOt8y458jCjP6yIxCXxglKRfj6BHWkmCPE6Qc45YmC/B0cBgTev3xI/PHikiKHJdIg8sdKAVsda86pJscO3OXxkwqT8AFAH3Y1m7UjzZDCFQZJGFAux7JoWTr//xAAjEQABAwMEAgMAAAAAAAAAAAABAAIRBSFBAwQGECAxUYKR/9oACAECAQE/APLn9Uq9G4+/dU5hdqNINr2zIyImbhcB3Vf3dBY6qMDXARFw77A/sgnozKhYXsqx6cxmowtcJBwgBHUoe18rPeO//8QAIhEAAgEDAwUBAAAAAAAAAAAAAQIFBBEhAAYwEBIgMUGB/9oACAEDAQE/APLZUdGSk0tNXMFRhbOM/LH4b+tbzpoWmmXWOYspzfBH4RwKzI3cpsR1AvoZPB//2Q=="

/***/ }),
/* 893 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 894 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 895 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wBDAAQDAwQDAwQEBAQFBQQFBwsHBwYGBw4KCggLEA4RERAOEA8SFBoWEhMYEw8QFh8XGBsbHR0dERYgIh8cIhocHRz/2wBDAQUFBQcGBw0HBw0cEhASHBwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcHBz/wgARCAAPAFcDAREAAhEBAxEB/8QAGwAAAgIDAQAAAAAAAAAAAAAAAwUEBgABAgj/xAAZAQACAwEAAAAAAAAAAAAAAAAAAQIEBQP/2gAMAwEAAhADEAAAAPZ0NCsq+ydc5FWu+AsnhyhyQEFyaMrNaV2UQ7SVqxMlyA8oI2AbB+1//8QAKhAAAQQBBAIBAwQDAAAAAAAAAwECBAURAAYHEhMhIjFRYRQVJTJCUmL/2gAIAQEAAT8APyPR1+57SitJ0SuLBCAzSy5LBodC9/6oqp9OnvU3m2EKtgzYcEJxTbSVWCKaeMAF8HfJPKuW9XdPWpfI1lA27FtTbdG8s+cCFCDHshlYfzLhr/KiYRM6HyMeBNLB3DQyKqX+jPOj9DskDkMCiKRrXtxh6I5FwqJqDyrZHSlNJ20CNGtkAULVuQKfxFxh/iXCrjOVRF1B5YmW97YVNXRw5Bocw0PxkuAiO/xOw56BVO2Nbj54HR7hvKgNbWvWoKgSLPvo0EpXqJpPgIntW4fhHa3PzX+w39ZShp4rpM6rFZ5n3EeG1EI9zEGiuyj3orf8V1uLla023LoK2TtgDbi2jSJLwHtwhFHQT2Nx5XJh6r5GqmNUHNka2FVnmU5YMaVcHoZElJIzBjS2Y8ad2+nMIvxR3+2E1RbuFuG/v66JFIsSlKyKSd2ToWQrezxNT/hFZlfu7GgbUgh3BaXTkU0mxEAT2Fa1WMQXfr19Z991zqRxNBeKKkW0nQjRbOTaCKJgXYIfuj29Xsc3rh649an8dmtagcCbua0MQEwM6PK8UZjwPEuWo1GiRmM/dq6BxzHLLNNuLizuZj4hYQyy3DYgBFwhEY0bGtRzsJl2FXTOIRPiVUGZuS1m1tY+O4EcwYqegOa4bVI0KPwisb9HajcaGrptgeu3Taw2TphZrxMBFejXkd2dhzwq7Gfzq74rNczLQybvuo8exVVfG8EM7R5ajVaxxQPe1v47YTR+HYrJ9XMqL+1qSV1SCmYgRxjI8AnKrM+YT/l+UxqTxbV3E6pm7jkFvz10OTC/kQAcw7DuYrlexrEblEYjUwiag8V08LYs3ZTjSj0BkewAyq3vEYq5Y1j0RF+DvbXOy5MJ71tHa8PZtBEpoLzFFHRyvOd3YsgjnK4hSO9Ze96ucq/ddf/EAB4RAAICAgIDAAAAAAAAAAAAAAERABICIRMgMUFh/9oACAECAQE/AL4gomcgTltOX2iJf5Bmyh2QblBK6TlPZlAk4MV4MUXT/8QAKhEAAgIBAwIEBgMAAAAAAAAAAQIDESEABTEEEhAgIkETFTJCUXGBodH/2gAIAQMBAT8AXbJ36dOoiUsGJGATVVz+71FsLl2SRiO1VY0pJ9VYrnF6j22GSdollwqkklSCK5FXo7arqJOmlDrYU4IIJ4wfbUu0xL8QJMSUu/Q1WPa86faI4YFmmkI7lB+gkZGBfHkrwbq5DCkHAUkj+a/zSbxKCe9AwKqpGeFqsgg3jUW5CKUyRxKLBUi2og88tf8Aem3JgoSBFQWGNXkjiySTr5yQzvHEqs92QW+6wcFiPf8AGn3NZEVJYVbtAW7cYGBgMB4X5P/Z"

/***/ }),
/* 896 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 897 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wBDAAMCAgMCAgMDAwMEAwMEBQgFBQQEBQoHBwYIDAoMDAsKCwsNDhIQDQ4RDgsLEBYQERMUFRUVDA8XGBYUGBIUFRT/2wBDAQMEBAUEBQkFBQkUDQsNFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBT/wgARCAAmAD4DAREAAhEBAxEB/8QAGwAAAwEBAAMAAAAAAAAAAAAAAAUGBwEECAn/xAAaAQEAAwEBAQAAAAAAAAAAAAAAAQIEAwUG/9oADAMBAAIQAxAAAAD6pnDG69Kia3s1AADhjdLvbNImgAGF8/eSND9maTyi67q+2KdjToc+djlfacOGjX83L6erGRus5wrnWmnL7AdPneCeJ8iTFAAH/8QALxAAAQQBBAEDAQcFAQAAAAAAAQIDBAUGAAcREiEIExQxFSAiIzJBkRAkQkNhgf/aAAgBAQABPwDR/Sf2061mvynG2Xpz6O56uMrCkKHPghX01hca8hXfS5s1LWtgqTDUsrP1H4iQOB/P3lfpOpjWYPBbDEGTBihR6sQ2vbT9f+eTrbmNkUO4dRZNzEwlNE/3JKgF8jjgn7uRbpZPB9SsPb5mfAi0cqgfu1S3YZU8yW3Ajpz3AKf3JI1vBu5uDtbtLlWXty6ezagy4i6iSIC0szYj/tDlY93kKSVr8g63lzPcjDsMrbTEFVd3bfFXMfrpkJQ+ShtHuOBopcBC+v0HnW328aN3qrFrzGp7TVXeQpAcYdY7uwpTQSVJUew8pJII1s/u7nO6+3NxbfbNJVX6LqfTVcVdcpTMlyP3KAr83typKCTwdUO7NlnG5c7A4C2auxoqmNNvJgbDpRJeA4jtJJ48DkqUef2A1eeplGIWeY41euxYdvjc6Ay/bls/GEOX16S1o55HQnqpPPHbrrA8jt76+fWxc1WT4euEl2LbwOvufI7kLaX0UUkBPUggDW4mDtZr6va523oJs/E14nJqpUwwXVRkvreHVHcJ45669X2IzHvTDKxGggT7qwSiCxFjQ4y3nXUsvNck9Qf8U86+1GXr7BilmYUoYdC1GE8A2VNhA7Hp+HyCPPGsR2YsNmvUrZW9OHhtvdwJVk7DZbK24Njy2F9UpBIC0+QBr04YjCwjDJ2RZLjV1FyinyW3s4DSKmQqTJYdDiUoACPKVhfjW2WM2eB72X2f3ldIhVucUkKQ90YWv4E5A/NYdSAVJ5BBBPj6jSMLfb3Z3D3HtMTl3+N5U9Ax1FW5ELjq4KGwH5a2SOendI4BHJSCdbO7NY9t7ulc2u3USXUYvPrEtzYbnupimWHQUFpDnkEI7hXHjyP6k3/J4Nb/AA5qAbUvn5nw/Z4/0d+3P/v3f//EAB8RAQACAgICAwAAAAAAAAAAAAEAEQIhEDASICIxQf/aAAgBAgEBPwDk6D1tuoqFxWDcFSDbU8qsYR3lMj41wFZTH63DTbP1ZiA66f/EACcRAAEEAgEEAgEFAAAAAAAAAAECAwQRACFBBRJRgTFhIBATMDOx/9oACAEDAQE/AP01h/PWGvxaiMq6eZZBKgoJq/PrIUOJLkojkEWDe/gi/rILER91SH7Sm6sH4vW9ZIgmEpxp4bSR7BvJkONDfS32kp7UqO9i/WOQ0R44lK2FKISPocnG+lF5LbzW0rCtc2njJDTbaNpKV3sHx5yM+WOlkNrAX3ggWLoDOivJHUQ+6QkbuzXyDnYQh3Y45HnHpyJvTw25/akgX5Tv/M6m8p90NMrBQpKQdigR74yU6iRDTFaVZaUfY4Iz98GMzDQ4ErRarvm9JvzWTJzsmMlEsgrB0dXVbuvv+H//2Q=="

/***/ }),
/* 898 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wBDAAIBAQEBAQIBAQECAgICAgQDAgICAgUEBAMEBgUGBgYFBgYGBwkIBgcJBwYGCAsICQoKCgoKBggLDAsKDAkKCgr/2wBDAQICAgICAgUDAwUKBwYHCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgr/wgARCAAVAFEDAREAAhEBAxEB/8QAGwAAAgMBAQEAAAAAAAAAAAAAAAgFBgcJAQL/xAAcAQEAAgMAAwAAAAAAAAAAAAAAAQIDBQYEBwj/2gAMAwEAAhADEAAAAO/gAAAVTm7rn65x0LnKeaXynR+jsSIbml4MXJA3BOZIyGGiyc7gs176Ktg3deQCuKocBKJzX5iZUkphgYnq0vKgf//EADwQAAAGAQMDAAQHEQAAAAAAAAECAwQGBwUICREAEhMhIjJBChAxM1FhchQVFhcgJEJDUldjg5GUotHy/9oACAEBAAE/APyrqskKlrbJTgmMF4u2KQjRqH61Y5wIQB49PHIgI8enjqFWXuBWHnBR/AZY2AfG4Wc+NLFqtSc+2gqoAiIh9ZVAH5PrDVRZl601ZKteEDPHIKQLY/NPZg/USeJD+mVJNQhAEBAQMUQ9Ah9HAjpjq62NTk1B7YkvyR49jTlUynYuchVf2UCiA88m9488gXkfo6/E7VX7vsR/ZE/11vCbwt4aF7zidRaXKcZzo8bjp59fCZ0DKKYWGpPEmpjpCCpAIucx1RAxu7tBIBEnUA3LZ8jueR3TPYa0af09e1ZIyvTnOMQ0VSVfOEUSqvMc5UMoZNVQUhFcgkKTgniKPJj+i+t9e3axty/5zXlWYuV1ZVEjxVZwXHNUDkfzKxHh+FWxXnkFJJq27FAUDxCcfU4Hq7daO+ht8VeGsvW7VtATCq8W5amn8Wq5XKoZ6PM3C5EfOiq6OZB14TKFA5f+w0Z7glj6mdynUJpgXJgVoBXUXhuYguSYMlSPHaWYxhXhzrnOoJTh64CQAIQQDrL699y3XFqhtKlNq+IVHgYZS0kNGpbYlwhkXAZnOp/PtGTdjwJCIj6DHPzz1qE3ztc1A6T7ri1mUFCMNqPoiYxbHZtg1Fw9jkhx2ZX4bP2fKqaxO8oD6hj8k5J9gl7b7y2S2jLS1m6eYmyj1yVO6xmMn1WTtmqovGcorlGzNdFyiU6Sh0hBRXxKgJQN9ohyBfFKn1H1HiFUvuVDOJFbumTpQBAiflAvmL7x7RKPdx7xIXqr63jtTwpnCIyjwg1J66pgDvXUH2lDfWI/0DgPkD4tsPQ/ntxWz7m3L7P1YWDgMvOrVyMekUDjYsgweVjjEiSKGHepuEFTuUPAodE3Bk+S/QfqQ05JMLtT3pTWJtF43kOhC/1n1C2CRnzkWDZJ8BiNFO4495QBVUPa7fmeScI8DD9o+rrN2HILpswNlZWP59PDY2zWlhtmgLPAlZk/viZ+qmY4ebk6p0u0T8+Pt4P1U25Lrk33LKa7R2oSeQ+HQ7MPUk55KYVD1iZWQNGShXBkA8z06TTymRDuMmT/AA5IOt/cQvHZ23kb9f6WYjCn7OU4CHYccbLMS7XIxaY3Btk25EhQdoj7JuB7ur0136l9m8+F1taZXMSyeH1hYBhYUwrGUYByqwwMicoEM9csV0XiaoJrKHMbxn54DgvJur/08zO0doex9ya8rgGR2XqPsSFPM4o2wYM2GFx2OyIItMc1Q8xx7Ce85j8mACe8onP8J820qlnGmOV68a7kj6FTpozYYianwxPzaZYo71AE2z9MDEA50VSoKkV/ggUQHggkgpfHCcQnzz24tuHP8svx/wD/xAArEQACAAUCBAQHAAAAAAAAAAABAgMEBQYRAFESITFBBxYggRAUIjBUYZL/2gAIAQIBAT8A9V2V7y1QI0+E42XAVd2Y4X2ycnVq13xHrR45qARCbuVEMqN1zzPuG1edWumhz7S8xNMqnmpUkcS75J5HcdtWXS6rfFWPzEaI0tDwYjM7HOyDJxk98dBry7Qvxk/kevhVvh4gWgbvo4gwSFjIwKsegBOGB74xzxuBq3qFI23SYchKD6V6nuxPVj+z6eh+x//EACYRAAICAQIDCQAAAAAAAAAAAAABAhEDECEEIDESEyIyQUJhcbH/2gAIAQMBAT8A5sUO8nRxEZRlWMXm7MY38tv8Q4PHG5dfrRsT3L6m4nuJst0y9mYcixytk5ucreiV2e0S8JZdNi9RbofJ/9k="

/***/ }),
/* 899 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 900 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 901 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wBDAAQDAwMDAgQDAwMEBAQFBgoGBgUFBgwICQcKDgwPDg4MDQ0PERYTDxAVEQ0NExoTFRcYGRkZDxIbHRsYHRYYGRj/2wBDAQQEBAYFBgsGBgsYEA0QGBgYGBgYGBgYGBgYGBgYGBgYGBgYGBgYGBgYGBgYGBgYGBgYGBgYGBgYGBgYGBgYGBj/wgARCAAgAFUDAREAAhEBAxEB/8QAGwAAAgMBAQEAAAAAAAAAAAAABAUCAwgHBgH/xAAZAQEAAwEBAAAAAAAAAAAAAAAAAQIFBgT/2gAMAwEAAhADEAAAANzY8p8e07vlTfYjjOvAxYdSQqPaCLj7+P5G5vtV0Luirm7sqDjY0oZNN3ovz5TeCZSjUl0YT++AkkoZCE6qGiUiGABIkSKw0dH/xAAmEAACAgMAAQQCAgMAAAAAAAADBAIFAQYHFAAIExUREhchNWd1/9oACAEBAAESALq8+obrQZWybzWcL/kO9Yls2aw1SWAfLylho+7wBWWLWa2cpqu+DAY94/anC2SqIM2X8IFDQ3mLuD2cLZB4rU1vRfcwKHKD7YLSzmezsk9aSrTe5838cUt8hztxu2sLo1ASod90C0+Za1f0GkP2NvfOsICqec9BQ6JydDeQJHrgNDnMgG+78nR1Gt2dvcVx1NkQoU2qG+qdn1pLYKJ2Dla6LBl2N0/y+tf9KHpGM2eoZTOX41ftimjmMKstLsIrUpxQnc5wIljYWdlqYFmzjy4pdRViyToyHMdcie6VbsTWmx4qhegxzDi1RD/bcvWFX3dD1xKrfzXPH6i8Jd3WQaxZ+3XRUs2NlQbkK/sfobHkO8WfQfbOns12JUT51WRFwgK0Pw3iIKRRBuynsNlhVfVAPK6PUr2iaCb0FR4YXs6lGxIoy7KePCLhgch0mqHbEwCwHMx2c2IZSotVaqmRZbGRewLJ390qHUy1adei8Mw8n84Wdv5xzvcNTsNZ2Fj8gg3iyLKfEORz5JjnX94q1zfb/O1wDjz/ADyo0zyWhoKnLaLzc4Rx+95pS6gDGR1tcaZ0WqvkfM6qesN1ZCgFrarC6GD+3rkVzz6g0/Dz5KysMdlDOra5XahptdrFR8+Ua8EVwerJBe1pm6xvEsrtBkAmM6VVFtK6ybO2y4gOYhGU0anUZpDwO9MlKGQFMo6vW1r6DSkjwkin4IoMaDSNuWBjzblF6M4zGbQdaNBjEU5hkVYacZKaPSp2ldYxywRpD5fiIPSqgR6uYptQhWwiMY6LQ6DXYDHWQYiMTGWYQU1anTaqWRLfk1UrJNUnr//EACwQAAICAgECBQMDBQAAAAAAAAECAxEAEiEEQQUTMTJREEJhFCQzRFJikZL/2gAIAQEAEz8A310vv6c4JARvfHFYJP5W7G64wyexj3BrnN9tte+J1gP6iYchy5Uag5+uVGj6mMA0r6He7HYYepWPypIK8y5KN+orjJ+TEUYq3I9wtTRwwTVK8RqQVpYrEBAkQ+hAIB+mvrItkLf5yAWyyc6msVa2IBpyPm86UKLlf72sil+gTcwSERhX170c6FDMj9UhVpHmB4CsNBnTDRGMZdNgvawM8R56aWTzlpZf8M8OXXp45NRssY/su6wPqAR8/jI+qUl2HuK/K/ODqRyy+50PwMj6oO0zLwWse4D0xOtEc3SS9pA32cEjnB1/7pJT/UGT8ji6qsh8SqbqJGWnmZ/u4zoevqfeQ058yztuci68+WVnQmVpBdOSGL3kHiQ8xzMSXOw9wtDWTyGR9R8t3OKaOrAg0cZlS1cMGtUUKeHPbGm4CMKYMoADWKHI7DLBUx8e7j14wSBQnmOjuVIG3JiT1JrtWRP/AAxRlSioDYFFEPIN6i7GO/DGUu0hZQAvJkY8AV2oYHGsgVtl34vhueCMeTYKxhEJAHZdRdfJONRKxsFBv/gf7P0//8QALxEAAQIEBAMFCQAAAAAAAAAAAQIDAAQREgUGEzEhQVEUFSBCcRYiNEBhc4LB0f/aAAgBAgEBPwDE8V7C4wiyuooJ3pT6w3mus72VbJCb7Lq8/SHc1JbZedLRqhemBXc/qEZqrLpdUyQrUDZFdj1rzjCMV7wDpstsUU71rTn48z/ESP3REqC7jeis0RrKV+Q5QESq5acTNkgF7gRuFconZyam5FDTyhqIfCLqdNiRGTErSzMBZqoOKqep4cfHO4azOLbW7Wrarh6x7OSd5c41vv3838heXJJxp1pQNHFXHj5uohvLUk2wmXSDRKgvfiVDmTEhhzMiFhmvvqKjXqfkv//EAB4RAAICAgIDAAAAAAAAAAAAAAABERICICExQEJR/9oACAEDAQE/AEpKcSUKDUb4dM9T5AkkzPdOCzLMuyX4X//Z"

/***/ }),
/* 902 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 903 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 904 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 905 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 906 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 907 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wBDAAIBAQEBAQIBAQECAgICAgQDAgICAgUEBAMEBgUGBgYFBgYGBwkIBgcJBwYGCAsICQoKCgoKBggLDAsKDAkKCgr/2wBDAQICAgICAgUDAwUKBwYHCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgr/wgARCAAQAEUDAREAAhEBAxEB/8QAGgAAAwADAQAAAAAAAAAAAAAABgcIAgQJBf/EABgBAQADAQAAAAAAAAAAAAAAAAAEBgcF/9oADAMBAAIQAxAAAACzTyxYh6Loe8mLjq2O0NU7ke8vrc4OBZNMFgGF+VbIi31Y6vLF3oXSLINr/8QALRAAAQMDBAIBAwIHAAAAAAAAAgEDBAUGBwgJERIAEyEKIjEUMhYjJDRCYnL/2gAIAQEAAT8A1tbteu2+tcVd229n3Tlbl6XxZFNZmZIva+HzCkUJXEEwjoiONIR9TD7lP9y9UAvNMm+1nDCF/ZH0y70OBKdjK/8AHdhybviV20zV6lXPTmA7GEVCcNPeX4ARcLuXcfsUfLW3WvqKdQeLHNfOm3bvx0mEPQ7UaNadaqLh3FWKU2pcvtKkgFVSBOR6s/8AIueZO+pRgZF0yYXn6A9O8m+s452kyYNu44qcnq1QpERxWpZzDHqptgaL04UEJtCMiDyfvabt+acjSdFOkrB+HTyri+kst55vi7q+3Gt+DW1cIXYEATlh39Zp6lL2OEpg9wHUO67bW8PlzVXfWUNAmufD9FsXOdj2s/UCS1aqMuk1+B6uCkxTFxzr17gvCOGiifKF5tv5D3H720oUKgaaMf2BSrZtp2XGbr1/SpbrleeSS4bgsAxx6wEj6di5TkV+fMcbjdKiYYyPdWpGwXbRu/EhizetsxpCPo6bn9scU/8AMH1VEHzSXf2qnKtnzMh6g8d0G0WKsbL9rW9DkuPzIsQg5/qzX7fYvIrwKD1+UVEXzONua4NmDdMytrkwxpHrmcMLZ8ajSrmgWbydXt6pMjx+zglIVLuQ/HRRd45RQ+WMM7pG/E/l6vahbAn6fsH1rGkmg44sW5KbGKpVKr90djTpTis/qQZB4eziCoIvwIp5grc03cNFukambady7Qd9XHlmzbdC07Ou2i/zaBNjMt+iLKccAOq9WkD8GiH+V6ebdO1XqP0C7q+lCJkyyKtVak9j25a5ka4qVTXHqVSKnOOaqQlkCnrEgD1D/sp+a/toRjSNuN5Wz5n/AG5b71HYbytXn6/btUxtW32Klbk6S+4+/FeaaEu6d3DFO35AQVC82Ntua27Mrd76yg2vpmAA/hafSbBZrl/zqnW6ow+K+wn4boCDI9Qb4X4JS82qrXuazNB9j23eFuzaTUYzc33wJ8YmXmuZr5J2AvlOUVF81w4kypcGUdSc2gYzrs5mrxrISluxKW44M31TBV31qicH0T5Lj8eUADaoUJpxFEhiNIQknCovXz//xAAoEQABBAADBwUBAAAAAAAAAAABAgMEEQAFBhITICFBcbEiJDEyQnL/2gAIAQIBAT8A4YQ943/SfONXxNHxs8cXmDjinF0dlsJAQKAFk/JNXiXpBasxjNZe5vGpPNCqqq+wUOhT1xnsXI4MgMQHFOFNhajQSTf561xQ1BMtsk8goeca4fZkankONKCknZog2D6RjTM+C1BywLdSNkv3ZHK0mr74dI3qu58nH//EACcRAAEEAAUDBAMAAAAAAAAAAAECAwQRAAUGEiEgMUETImKxMlFh/9oACAEDAQE/AOmdxBdPxP0caKma0laebbyxppLTdjc6VErO4k7QnsBdWcQdaNpyyW7mTfpPReHEA3d/iUnyFeMael5/mEZUjMGktBVFCRZUE/M9r6pqSqE6BySk/RxoFh+NpOO08kpUN1giiPerxjVOXT3p+bFtlRChH20km6VzX7rzhnhpI/gx/9k="

/***/ }),
/* 908 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wBDAAUEBAUEAwUFBAUGBgUGCA4JCAcHCBEMDQoOFBEVFBMRExMWGB8bFhceFxMTGyUcHiAhIyMjFRomKSYiKR8iIyL/2wBDAQYGBggHCBAJCRAiFhMWIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiL/wgARCAAZACwDAREAAhEBAxEB/8QAGwAAAQUBAQAAAAAAAAAAAAAABgADBAUHAgj/xAAUAQEAAAAAAAAAAAAAAAAAAAAA/9oADAMBAAIQAxAAAAD1cPgEOhYTzHB0hFoUhr5lgRlgUx2GAQksQhCP/8QAMBAAAQQCAQIDBQgDAAAAAAAAAwECBAUGEQAHEhMhYRQxQUJRFiAiIzRSVZGBk6H/2gAIAQEAAT8AlZfQQpZY0u2iiOF3a8bn+bV5X5JT2p1DXWUU5f2MIm+T5l3G6l2bmX8f2UUYj2QULtyaHtE8P67898wDOnSceky8ttAtd7T4QXkRGfIi68ufbnGv5qH/ALOQshqrELiwZ4Dja7tVzHbTfI1TCuuutnCswNPGeQrlY76oxOdScUrcVZXWdBuEdTa7GPX3om0c3iSnzuqB5Zm6KeqUj09Vjc6YUlTdYdPS9jiMCNL8RFKukZ+W3a8sa+tynIm1OBU4RhEuyzvP+/Rv/V5jeGV+O0rYbNneru8pX/O9URFXXwTy4gLE/We7FSmaCwepkCZ6fhavYnBdNrq7tgys1uUlBD7gB+KfT05KwGcXP5lyE8VkM0ZwRi0u27F2JwHTK9BhhacVnFYp5fjG13I17EYiI1f88qsDzSkiqCpvYMYTndzkYH3r6rrlFV5PFgkZc24ZR1Kqte1mtN0nl/e+D/XO+9//xAAUEQEAAAAAAAAAAAAAAAAAAABA/9oACAECAQE/AEf/xAAUEQEAAAAAAAAAAAAAAAAAAABA/9oACAEDAQE/AEf/2Q=="

/***/ }),
/* 909 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 910 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 911 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 912 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 913 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 914 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 915 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wBDAAIBAQEBAQIBAQECAgICAgQDAgICAgUEBAMEBgUGBgYFBgYGBwkIBgcJBwYGCAsICQoKCgoKBggLDAsKDAkKCgr/2wBDAQICAgICAgUDAwUKBwYHCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgr/wgARCAAXAEcDAREAAhEBAxEB/8QAGQABAAMBAQAAAAAAAAAAAAAACAUGCQcD/8QAGgEAAgMBAQAAAAAAAAAAAAAAAAECBQYDBP/aAAwDAQACEAMQAAAA1ktweX4j6hADTLVfFy6r4im+gk4E3zMxNkcQsSy8DPTVR1JxbI16uxeBsrPiDqj2GUbxIWpBboSMmlhSFS6q8+eVt4r/xAAnEAABBAMBAAAFBQEAAAAAAAAGBAUHCAECAwkKExQVFgAREhkhIv/aAAgBAQABEgC+N896z5RA0ZpW10KlecdlXIW9ILgjpHzJlslfduHRTz7LGqevSgo5eXMrXAhlqb2o1Ah/r1w2D3xAXoSvoLEdjVyoD/JDSyncHe9xn008+zGYcwCMXDAFph9XlLoySVKUbQ0GrJElo9aBphb9P5LXeut1qk240W5rNYoSN9m7/V/GdrS1uq+zp3+xM6ioUkWb50R9Ysl6KpyDE8iQxJDGVsKrOcJ3j0ebSVtuKVZJ1mO+ynkk7t++ccPp/m46a7Z/f/r9GTKQf1eW0JscFuGnaMcJs7/YEBd4vweIOz9o1JHi4jqgVunqL4O+ZcG+XJqfxFFiQRKo2EtnhlPuFn5SvJIVRQW3VbpCnIZYoI/Ke8aTyGyKusTEdmKAeKUwQPIYgcIdHp18voUie2xFKN/bDCDaYyE7ywRjbZmKKAwLX+0LzZWBsLAvoWMv0RYD3DpIB2uZOKzsq1aCdBrjRtfh/wAfZ+Wuu6UhPxluQ81GMaqZi83Q038+juikdmfVkwbsvZIpKevwwWXqj4ZSknt989CNS8uMXN5Kfh074y+hba2z/wCuxMSQGzr+eyQUuH45xrNIFGHWrUmOULSHCLdq3xYcQn5LWiOrGCVlPTq9neYO8dLMLQILkLz6shFE7llgvOWzrSAdZCX4cT0AqfSOV49md0tfbqyCqTZOcWbDO3bf/8QAJxAAAgEEAgICAQUBAAAAAAAAAQIDBAUREgAGEyEUQSIxQmGCkVL/2gAIAQEAEz8ArGLxW+nH3KiMG3f9o5XW6HwSpH6Ma6KDEGA9lfs55dcVcEVWgiO5QMrPC251J1PB1l1phaUpaSUFEM/4SbTPly3IOwwmSScHHiRs6O+fQVWJJ5fLhHS08Q/l5CBk/Q/UnnX7zHPLAM42aMHYLkgbYxzst8hpPkEfqIxIwL4+9QedeukVZTuwxlRJEzDYZGRnI42gIozHrGoCscasJANsH7wM+2UghcnGpyf9/rj75gCnkqfOrgH8smRU/g4D+yMjZ8Yo4p7TRRPN/RXLcgr5fm1lVAAw+TIXxN5m/wAZwU51YxPL2u6LVz0i3KrSaSNZ4kjgTYEn3n1h3zBY7bbbVe7DIdKqiqoaWfEpKYwdc6787HSJWL1Kz2uvloqa10kUoZab8IvNIVAaR5snnXjDT2K9VKOGjuMlII/wrEGU8sRTZHIcNxIS4CbZaOZAR5VxtgZBUnIPIBNPJPGHGTpqoQlSSMk+x75XUQqphNI4YzyRqUD411C5GFwOU3UBHJW01VRQ0j0aIZyInAiJEpLce1uLjNRxHMUEkhkKFkX0HbcA+wnOuQCY0NEECGiqYiR8mBgMkEg5Lf8AbA2Dros1lo68Y1rp4kYmomXAIzgZ53XrDXfr9xumgRrlAkcsU1HUyKqeTRikhUEry3242qw9dtu4kemoKBZHG0jgNJPKzyvqBkD0f//EAC4RAAEEAQQABAMJAQAAAAAAAAECAwQRBQASIVEGEzFBFBVhFiJCcYGRocHR8P/aAAgBAgEBPwDGYz4y1uWEj+TpeJgLQUhNfWz/AMdRcOj5y1FdNoWfUccc6V4XxYybzA3bUthY55uyOtLw+URH89TKgjutMMPSFhDSSpR9gLOpWOnQa+IbKb7GosKXNUUsNlRHQJ08w/Gc2OpKT0RWsQUHHp2/W/z0L00pHzmIn33frX+aClI8QvqAumQa7pSjWsL4ly8nMoQ6vclZoprgA9dVoQmMazLXGcS0pTm3cfwir2igaPOorjIiPR5s1DyFJNCyVBXsQTrMSH4CGoTCilAQlRrjcVCyo96eycmVCDD33tp4Ub3AdX0ejrH5F2CqqtJ9tKz0UJtKST+2o+WcbyiJi03tPoOO9fbKsiuWlnkoCQL9KJN+mmvFeNYJfYiBLx974vUDPvR3XRJT5iHTakn3PY6On83Cairj49jy9/CiTZI6HQ0zlIb8ZLM9or2cJUk0oDo8EEdam5Fh2OI0VvY2DfalHsn+hr//xAAdEQADAAICAwAAAAAAAAAAAAAAAREQIQISIjBB/9oACAEDAQE/AM79XVC8uJBQSSdxMQj3sguL+sS2JSs//9k="

/***/ }),
/* 916 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 917 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wBDAAIBAQEBAQIBAQECAgICAgQDAgICAgUEBAMEBgUGBgYFBgYGBwkIBgcJBwYGCAsICQoKCgoKBggLDAsKDAkKCgr/2wBDAQICAgICAgUDAwUKBwYHCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgr/wgARCAAaADIDAREAAhEBAxEB/8QAGgAAAgMBAQAAAAAAAAAAAAAABwgDBQkEBv/EABoBAAIDAQEAAAAAAAAAAAAAAAYHAgQFAwj/2gAMAwEAAhADEAAAAOp3IR1w81aYUKKtbUAwKjgiGsB628zlubmGFNjFZEfJDEp79nY7yylzQhhT6gSQu0svWxTNkf8AkIT99satHUrNIwjQZOriopUIzDcNOlEzF0BRBlj8yHl7P//EACUQAAEEAwEAAQMFAAAAAAAAAAUDBAYHAQIICRIACjERExQ3dv/aAAgBAQABEgDjj3h6u4zX3pu7Y4tO42JdbNkWMT+5m4gLMNVpTW8/FOtvy25u7Gk/WIVxJq35tmMbC5aZ3GH7E5w7DtHdXJjq9AM33/A+beZfSqWm5EDdjY4v+fgbN9q8oGdNDh6VA8Y3/RDar7tnMprSOyYvuz2dkQTR062576j8wvX6YSSMyfmcW7k8bY4d50q/0h8gqHrZO/6u4G3EfGVqA0HHJftNSfW98BaAiFIT4O/N6Odm5Gz+6Khqi50KUkLUgo9UVbpuX3RPXde80GgYecCSK2DmN9kl+m77p6o6uQP2aI1OCjiujdsMryR0wTgAMlGYQ5aDXAdqoPa8WVrbtX0zJvSjnpw4XkdQWAmjIg2XWXHC7J82Xw0zveS++ivnD0rMgtwFGnQnqnXFutnMZcZCRkxMErNjFhTs/Xh98ckZpF8JOdBzJr0nGqIcFX+dFSaK4kqtcEBuwvWhdO3f5SA2pEkgYTajf6Uh/wDlh/15TV1XwajbTACIKGasCJHZN+yzTdQ55gSG5qqN5bYsJVTDfmKnqjEXEyfiatjjVfRm811W53Ag2HMmBDEM0RaKNXuFGsDhMM0IxjGkSGYwjJfmj9dcCxhekCDEsOQdIbOm+coxLOWMVGMmWf2UUR6OiKX/xAAuEAACAQMDAQYEBwAAAAAAAAABAgMABBEFEiExBiIyQVFxBxNhghRCcoGEkaL/2gAIAQEAEz8A1+aS31bTEVsfJE7gswXoElUlai063uf9Cda+IFmmnxXsh8IjgDvM6ee/AX0Jrs5pUltGn3iT5jfu1Xl5cQSN9zFhU921xZTfp3F4m9utJblQZJIVdiADxyTXa/QrUX13ag7GeGaMmQhG2hl3cb1qLs3YyX0dwkCTl1kkkZkGH8mrWtLRLWIQ28k53srkjKxkCoFQwWzTdAxLZ4DAnirJFZYURkVmbLA/nB4pII5heKyl921ztKhec/UUZGzDA0SmNPGei4FdYL3QriAifcByQCSH9Eff1SpORDnTISCfauztrHDcx3EIE8kwItoiQsEUvnVrYl7XT44pHaRHfyyjheOmxaTxRzrPBC74/p/ZqkhZVv5JbwoHBbhwIgO8PJI6/jR1baZEkNyhtWUrIirhwVJGDR0O32B/wMY3bdmM4q30O3RwGt5FYAhM8qSD6g1FbKsbbmfOVAwc0LCPuMTBlhxwe6vP0FXEIdCRKMcHIqLuqihAAoA4AAHSv//EADIRAAECBQEFBgQHAAAAAAAAAAECBAADBREhBhIiMUFRE2FxkbHBBzJSshQVIzVicuH/2gAIAQIBAT8Aq2iaZVx27dXZrObjKT329xE34d1lCtxaCPEj2isUldKllAnIXN+kEkDxIGPWHtD1PUCdt8EDohJA873MOtBV4AqluAs95UPW8TZuqtOTbTFLR0uSUn1Bin1V24YSpq7XUlJOOZF4fU3UelJKFInkIUbbpNge8HGYc6f1W9cFrOd33driq1r24ARVNIPKWxW6XNQoJtgHOTaH+rqZTqqGMwHawCRawv1zFb1KyoM2WieknbvkcrdYr1YplMp4mOk7aF4AsDteeLWhlPpcxlLVKlEJKUkDoLYHGKu4auXaKS6wmcjB5hYOP8i1qyQc/pD7jGq5DRpSVupTFchMveUpRxs+Z52ia5D9u7cTJSlTJigUqA3UgE3BPgYrLpNdb0wrOVAoUehCkpJ94qbOqzGEwPbhLWyE4+YlVr+XMd0Uj9pb/wBEfbGpnE9buQpSySBg3NxmPxbr8yJ7RV9gcz9Ua+cT52kHaJiypJAuCSQd7mIocmUjT2wlIAsvFscTDNq2EyRuDC+g/jGpkImUdaVi4uOPjFLbtxTJACB8ieQ6R//EADIRAAEDAwEFBgMJAAAAAAAAAAECBBEAAwUhBhIxUWEUIjJBccEHE7EVIzVicpGy0eH/2gAIAQMBAT8Aw23eVwxLdyn5iBpB0UOk+xqz8TMGtMrQsHlAPvWOzF7LWyuxYUlMaFY3QT0EkkU7w+0L2d54EjklJA/eZpzsZmfEi+FnqSD71cu7R4K531LR6mUn6pNMsk6vsrdxcSpKSfUisdldmNr7txC24K0Ce8kSR0I1096a7SbHsG3a7DPd7274UzIE8SaxO2jLLvkNbdlaSqdSBGgJ59KebT49hkQzWDOkkcBNZfPtMNcQi8Cd+dR5RzrM5TH49kFuRvpXoBAMz60zu45bS2q3bISUiBroI0HGsK2eNWVzMtNV2FwoeRQRr/vQz5VM4IHh96f4itncpdtOl9ryNu+N0wlIAMjUnwjyBpd8PbLm/ctqK1qBSoDRIBMyfQ1lXAzFhgVHVUpPqCAf7rINclcZXO1SEtoQnqSqJ66e1Yz8Ns/oT9K2Ubt0MXCEoABOogQdPOuxM/suPlpjf5DlWPZtE3yRbTwPkOVYi1aRhd1KQBCtI6mmrZvv2u4NF8h+Ws8hFzGKCxIkcfWmwCWyAOED6V//2Q=="

/***/ }),
/* 918 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var WhyUseUs=function(_Component){_inherits(WhyUseUs,_Component);function WhyUseUs(props){_classCallCheck(this,WhyUseUs);var _this=_possibleConstructorReturn(this,(WhyUseUs.__proto__||Object.getPrototypeOf(WhyUseUs)).call(this,props));_this.toggleIsCompanies=function(){_this.setState({isCompanies:!_this.state.isCompanies});};_this.renderAbas=function(){if(!_this.state.isCompanies){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",{className:"abas"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",{className:"active"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{className:"#aba-1"},"Companies")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{className:"#aba-2",onClick:_this.toggleIsCompanies},"Employees")));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",{className:"abas"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{className:"#aba-1",onClick:_this.toggleIsCompanies},"Companies")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",{className:"active"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{className:"#aba-2"},"Employees")));};_this.renderContent=function(){if(!_this.state.isCompanies){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{id:"aba-1",className:"aba"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",{className:"lista-benefits companies"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4",null,"When the employee pays all of the cost:"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",{className:"first"},"Use Lunch.Team for free as a core part of your health and well being programme offering healthy eating for employees from some of the cities finest restaurants at the touch of a button."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4",null,"When the company pays part or all of the cost:"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"Attract top talent, increase productivity and make the team feel loved with Lunch.Team Premium, our canteen replacement solution."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"Use our variable subsidy programme to offer lunches for individual teams or the whole company in a way that works practically and financially."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"Our simple, quick ordering software with native apps and integrated accounts package means the Lunch.Team solution is completely management free for your company."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"Whether ordering platters for meetings, doughnuts for the team or lunches for the whole company get one simple bi-weekly bill with full traceability.")));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{id:"aba-2",className:"aba"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",{className:"lista-benefits"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"Have a meeting, taking some exercise or simply don't like the weather out there? Get your lunch delivered for the same price as if you walked to the store."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"Tired of the local options, trying to eat healthily or have specific dietary requirements? Let Lunch.Team broaden your lunch horizons with our daily rotation of some of the best restaurants in town."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"Time pressed or out of the office? Use our super simple suite of software with native apps, customisable notifications, and one touch reordering to make sure you're properly fueled to get the job done.")));};_this.state={isCompanies:false};_this.renderAbas=_this.renderAbas.bind(_this);_this.renderContent=_this.renderContent.bind(_this);_this.toggleIsCompanies=_this.toggleIsCompanies.bind(_this);return _this;}_createClass(WhyUseUs,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"secao-4"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{ref:this.props.whyUseUsRef,className:"wrap"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"w-72 left"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h3",null,"Why Use Us"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"tabs"},this.renderAbas(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"abas-content"},this.renderContent())),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{onClick:this.props.HandleFindOutMore,className:"bt get-more-info"},"Find out more"))));}}]);return WhyUseUs;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (WhyUseUs);

/***/ }),
/* 919 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_images_macbook_png__ = __webpack_require__(920);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_images_macbook_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_images_macbook_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_images_iphone_png__ = __webpack_require__(921);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_images_iphone_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_images_iphone_png__);
var whatwedo=function whatwedo(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{ref:props.whatWeDoRef,className:"secao-2",id:"what-we-do"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{alt:"macbook",className:"macbook wow animated bounceInDown",src:__WEBPACK_IMPORTED_MODULE_1_images_macbook_png___default.a}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{alt:"iphone",className:"iphone wow animated bounceInUp",src:__WEBPACK_IMPORTED_MODULE_2_images_iphone_png___default.a}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"wrap"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"w-50 left"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h3",null,"What We Do"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Lunch Team pairs up with your city's best health food restaurants to provide free lunch delivery, straight to your company's office. That's right, completely free with no minimum orders and no delivery fees. From individuals ordering a healthy salad, team leaders holding a brown bag meeting or office managers offering lunch to the company, our bespoke food solution fuels the performance of some of the worlds best companies."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{onClick:props.HandleFindOutMore,className:"bt get-more-info"},"Find out more"))));};/* harmony default export */ __webpack_exports__["a"] = (whatwedo);

/***/ }),
/* 920 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/macbook.921bd307.png";

/***/ }),
/* 921 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/iphone.11b85199.png";

/***/ }),
/* 922 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_images_join_the_team_png__ = __webpack_require__(923);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_images_join_the_team_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_images_join_the_team_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_images_choose_your_favorite_png__ = __webpack_require__(924);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_images_choose_your_favorite_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_images_choose_your_favorite_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_images_eat_and_enjoy_png__ = __webpack_require__(925);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_images_eat_and_enjoy_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_images_eat_and_enjoy_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_slick__ = __webpack_require__(323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_slick___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_slick__);
var lunchmadesimple=function lunchmadesimple(props){var settings={speed:500,responsive:[{breakpoint:5000,settings:'unslick'},{breakpoint:768,settings:{slidesToShow:1,slidesToScroll:1}}]};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{ref:props.howItWorksRef,className:"secao-3-2"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"wrap"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h1",null,"Lunch Made Simple"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"columns"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col left wow animated bounceInLeft"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{alt:"join the team",src:__WEBPACK_IMPORTED_MODULE_1_images_join_the_team_png___default.a}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"Join the Team"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Everyone creates their own individual account by entering their email in the Order Now box, hitting return and following the set up instructions.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col left wow animated bounceInDown"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{alt:"choose your favorite",src:__WEBPACK_IMPORTED_MODULE_2_images_choose_your_favorite_png___default.a}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"Choose Your Favorite"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"They choose their lunch their way from any of the fabulous restaurants on display, charging to their card or to account if the boss is feeling generous.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col left wow animated bounceInRight"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{alt:"eat and enjoy",src:__WEBPACK_IMPORTED_MODULE_3_images_eat_and_enjoy_png___default.a}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"Eat and Enjoy"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Food will then be delivered to the agreed drop off location by the agreed time, individually bagged and labelled, with an email notification sent on arrival."))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_slick___default.a,Object.assign({className:"lunch-made-simple-mobile"},settings),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{alt:"join the team",src:__WEBPACK_IMPORTED_MODULE_1_images_join_the_team_png___default.a}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"Join the Team"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Everyone creates their own individual account by entering their email in the Order Now box, hitting return and following the set up instructions.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{alt:"choose your favorite",src:__WEBPACK_IMPORTED_MODULE_2_images_choose_your_favorite_png___default.a}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"Choose Your Favorite"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"They choose their lunch their way from any of the fabulous restaurants on display, charging to their card or to account if the boss is feeling generous.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{alt:"eat and enjoy",src:__WEBPACK_IMPORTED_MODULE_3_images_eat_and_enjoy_png___default.a}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"Eat and Enjoy"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Food will then be delivered to the agreed drop off location by the agreed time, individually bagged and labelled, with an email notification sent on arrival."))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{onClick:props.HandleFindOutMore,className:"bt get-more-info"},"Find out more")));};/* harmony default export */ __webpack_exports__["a"] = (lunchmadesimple);

/***/ }),
/* 923 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 924 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 925 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 926 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_actions_index__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_UI_Modal_ModalError__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_UI_Modal_ModalSuccess__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__video_video_mp4__ = __webpack_require__(927);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__video_video_mp4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__video_video_mp4__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lunchTeamMainPresentation_scss__ = __webpack_require__(928);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lunchTeamMainPresentation_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__lunchTeamMainPresentation_scss__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var LunchTeamMainPresentation=function(_Component){_inherits(LunchTeamMainPresentation,_Component);function LunchTeamMainPresentation(){var _ref;var _temp,_this,_ret;_classCallCheck(this,LunchTeamMainPresentation);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=LunchTeamMainPresentation.__proto__||Object.getPrototypeOf(LunchTeamMainPresentation)).call.apply(_ref,[this].concat(args))),_this),_this.escFunction=function(event){if(event.keyCode===27){_this.props.onCloseModalError();}},_this.handleCloseModalSuccess=function(){window.location.assign("/");},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(LunchTeamMainPresentation,[{key:"componentDidMount",value:function componentDidMount(){document.addEventListener("keydown",this.escFunction,false);}},{key:"componentWillUnmount",value:function componentWillUnmount(){document.removeEventListener("keydown",this.escFunction,false);}},{key:"render",value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"secao-1"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"overlay-video"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("video",{preload:"auto",autoPlay:true,muted:true,loop:true,nocontrols:"",playsInline:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("source",{src:__WEBPACK_IMPORTED_MODULE_5__video_video_mp4___default.a,type:"video/mp4"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"wrap"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"centerer"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h1",null,"Your one-stop team for office lunch delivery"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{onClick:function onClick(){return _this2.props.onToggleRegisterCompany(true);},className:"bt get-more-info"},"Find out more or register your company"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_UI_Modal_ModalError__["a" /* default */],{style:{zIndex:"99999",position:"absolute",margin:"5% 40%"},errorMessage:this.props.errorMessage,showModal:this.props.error,closeModal:this.props.onCloseModalError,styleContent:{color:"var(--lt-color-muted-foreground)"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_UI_Modal_ModalSuccess__["a" /* default */],{message:"Check your email to reset your password.",showModal:this.props.isRequestSentEmailResetPasswordSuccess,closeModal:this.props.onCloseRequestEmailResetPasswordModal}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_UI_Modal_ModalSuccess__["a" /* default */],{showModal:this.props.showSuccessModalRegister,message:"Thank you for registering! Check your email.",closeModal:this.handleCloseModalSuccess})," ");}}]);return LunchTeamMainPresentation;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onCloseModalError:function onCloseModalError(){return dispatch(__WEBPACK_IMPORTED_MODULE_2_actions_index__["u" /* closeModalError */]());},onCloseRequestEmailResetPasswordModal:function onCloseRequestEmailResetPasswordModal(){return dispatch(__WEBPACK_IMPORTED_MODULE_2_actions_index__["_7" /* onCloseRequestEmailResetPasswordModal */]());},onToggleRegisterCompany:function onToggleRegisterCompany(toggle){return dispatch(__WEBPACK_IMPORTED_MODULE_2_actions_index__["_37" /* toggleRegisterCompany */](toggle));}};};var mapStateToProps=function mapStateToProps(state){return{isRequestSentEmailResetPasswordSuccess:state.passwordReducer.isRequestSentEmailResetPasswordSuccess,error:state.signupReducer.error,errorMessage:state.signupReducer.errorMessage,showSuccessModalRegister:state.landingReducer.showSuccessModal};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(LunchTeamMainPresentation));

/***/ }),
/* 927 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/video.c1bfd26d.mp4";

/***/ }),
/* 928 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(929);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(17)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../lunch-team-client-checkout-msg/node_modules/css-loader/index.js!../../../../../../../lunch-team-client-checkout-msg/node_modules/sass-loader/dist/cjs.js!./lunchTeamMainPresentation.scss", function() {
			var newContent = require("!!../../../../../../../lunch-team-client-checkout-msg/node_modules/css-loader/index.js!../../../../../../../lunch-team-client-checkout-msg/node_modules/sass-loader/dist/cjs.js!./lunchTeamMainPresentation.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 929 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(14)(undefined);
// imports


// module
exports.push([module.i, ".overlay-video{height:100%;width:100%;position:absolute;top:0px;left:0px;z-index:2;background:rgba(19,7,0,.4)}video{min-width:100%;min-height:100%;position:relative;z-index:1}body.modal-open{overflow:hidden !important;position:fixed}", ""]);

// exports


/***/ }),
/* 930 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_UI_Backdrop_Backdrop__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_hoc_ReactAux_ReactAux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_UI_FieldError__ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_utility__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_actions_index__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__RegisterCompany_css__ = __webpack_require__(932);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__RegisterCompany_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__RegisterCompany_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var RegisterCompany=function(_Component){_inherits(RegisterCompany,_Component);function RegisterCompany(props){_classCallCheck(this,RegisterCompany);var _this=_possibleConstructorReturn(this,(RegisterCompany.__proto__||Object.getPrototypeOf(RegisterCompany)).call(this,props));_this.state={formIsValid:false,registerCompanyForm:{senderNameFrom:{value:"",validation:{required:true},valid:false,touched:false},company:{value:"",validation:{required:true},valid:false,touched:false},numberOfEmployees:{value:0,validation:{required:true},valid:false,touched:false},senderLastNameFrom:{value:"",validation:{required:true},valid:false,touched:false},emailFrom:{value:"",validation:{required:true,email:true},valid:false,touched:false},phone:{value:"",validation:{required:true},valid:false,touched:false}}};_this.isInvalid=function(name){var field=_this.state.registerCompanyForm[name];return!field.valid&&field.touched;};_this.escFunction=function(event){if(event.keyCode===27){_this.props.onToggleRegisterCompany(false);}};_this.handleSendEmail=function(){var payload={};for(var formElementIndentifier in _this.state.registerCompanyForm){payload[formElementIndentifier]=_this.state.registerCompanyForm[formElementIndentifier].value;}_this.props.onSendEmailToRegisterCompany(payload);_this.setState({showModal:true});};_this.handleInputs=function(event){var updateRegisterCompanyForm=Object.assign({},_this.state.registerCompanyForm);var updateFormElement=Object.assign({},updateRegisterCompanyForm[event.target.name]);updateFormElement.value=event.target.value;updateFormElement.valid=Object(__WEBPACK_IMPORTED_MODULE_5__shared_utility__["a" /* checkValidity */])(updateFormElement.value,updateFormElement.validation);updateFormElement.touched=true;updateRegisterCompanyForm[event.target.name]=updateFormElement;var formIsValid=true;for(var inputIdentifier in updateRegisterCompanyForm){formIsValid=updateRegisterCompanyForm[inputIdentifier].valid&&formIsValid;}_this.setState({registerCompanyForm:updateRegisterCompanyForm,formIsValid:formIsValid});};_this.escFunction=_this.escFunction.bind(_this);return _this;}_createClass(RegisterCompany,[{key:"componentDidMount",value:function componentDidMount(){document.addEventListener("keydown",this.escFunction,false);}},{key:"componentWillUnmount",value:function componentWillUnmount(){document.removeEventListener("keydown",this.escFunction,false);}},{key:"render",value:function render(){var _this2=this;var registerCompany=null;if(this.props.showRegisterCompany){var disable={cursor:"pointer"};if(!this.state.formIsValid){disable={background:"var(--lt-color-muted)",color:"var(--lt-color-muted-foreground)",border:"1px solid var(--lt-color-border)",cursor:"not-allowed"};}registerCompany=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_hoc_ReactAux_ReactAux__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_UI_Backdrop_Backdrop__["a" /* default */],{show:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"overlay connected"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"overlay-box"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{onClick:function onClick(){return _this2.props.onToggleRegisterCompany(false);},type:"button",className:"bt-close mfp-close lb-fechar fa fa-times"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h5",null,"Please complete the form below to be connected with a lunch specialist"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("form",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"w-48 left"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",null,"Name"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{tabIndex:"1",type:"text",name:"senderNameFrom",className:this.isInvalid("senderNameFrom")?"Invalid":null,"aria-invalid":this.isInvalid("senderNameFrom"),"aria-describedby":this.isInvalid("senderNameFrom")?"senderNameFrom-error":undefined,onChange:this.handleInputs}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_UI_FieldError__["a" /* default */],{id:"senderNameFrom-error",show:this.isInvalid("senderNameFrom")},"Enter your first name."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",null,"Company Name"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{tabIndex:"3",type:"text",name:"company",className:this.isInvalid("company")?"Invalid":null,"aria-invalid":this.isInvalid("company"),"aria-describedby":this.isInvalid("company")?"company-error":undefined,onChange:this.handleInputs}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_UI_FieldError__["a" /* default */],{id:"company-error",show:this.isInvalid("company")},"Enter your company name."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",null,"Number of Employees"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{tabIndex:"5",type:"number",name:"numberOfEmployees",className:this.isInvalid("numberOfEmployees")?"Invalid":null,"aria-invalid":this.isInvalid("numberOfEmployees"),"aria-describedby":this.isInvalid("numberOfEmployees")?"numberOfEmployees-error":undefined,onChange:this.handleInputs}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_UI_FieldError__["a" /* default */],{id:"numberOfEmployees-error",show:this.isInvalid("numberOfEmployees")},"Enter the number of employees.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"w-48 right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",null,"Last Name"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{tabIndex:"2",type:"text",name:"senderLastNameFrom",className:this.isInvalid("senderLastNameFrom")?"Invalid":null,"aria-invalid":this.isInvalid("senderLastNameFrom"),"aria-describedby":this.isInvalid("senderLastNameFrom")?"senderLastNameFrom-error":undefined,onChange:this.handleInputs}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_UI_FieldError__["a" /* default */],{id:"senderLastNameFrom-error",show:this.isInvalid("senderLastNameFrom")},"Enter your last name."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",null,"Email"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{tabIndex:"4",type:"email",name:"emailFrom",className:this.isInvalid("emailFrom")?"Invalid":null,"aria-invalid":this.isInvalid("emailFrom"),"aria-describedby":this.isInvalid("emailFrom")?"emailFrom-error":undefined,onChange:this.handleInputs}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_UI_FieldError__["a" /* default */],{id:"emailFrom-error",show:this.isInvalid("emailFrom")},"Enter a valid email address."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",null,"Phone"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{tabIndex:"6",type:"number",name:"phone",className:this.isInvalid("phone")?"Invalid":null,"aria-invalid":this.isInvalid("phone"),"aria-describedby":this.isInvalid("phone")?"phone-error":undefined,onChange:this.handleInputs}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_UI_FieldError__["a" /* default */],{id:"phone-error",show:this.isInvalid("phone")},"Enter your phone number."))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{disabled:!this.state.formIsValid,style:disable,onClick:this.handleSendEmail,className:"bt"},"Send"))));}return registerCompany;}}]);return RegisterCompany;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{showRegisterCompany:state.landingReducer.showRegisterCompany};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onToggleRegisterCompany:function onToggleRegisterCompany(toggle){return dispatch(__WEBPACK_IMPORTED_MODULE_6_actions_index__["_37" /* toggleRegisterCompany */](toggle));},onSendEmailToRegisterCompany:function onSendEmailToRegisterCompany(payload){return dispatch(__WEBPACK_IMPORTED_MODULE_6_actions_index__["_27" /* sendEmailToRegisterCompany */](payload));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(RegisterCompany));

/***/ }),
/* 931 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 932 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 933 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * isMobile.js v0.4.1
 *
 * A simple library to detect Apple phones and tablets,
 * Android phones and tablets, other mobile devices (like blackberry, mini-opera and windows phone),
 * and any kind of seven inch device, via user agent sniffing.
 *
 * @author: Kai Mallea (kmallea@gmail.com)
 *
 * @license: http://creativecommons.org/publicdomain/zero/1.0/
 */
(function (global) {

    var apple_phone         = /iPhone/i,
        apple_ipod          = /iPod/i,
        apple_tablet        = /iPad/i,
        android_phone       = /(?=.*\bAndroid\b)(?=.*\bMobile\b)/i, // Match 'Android' AND 'Mobile'
        android_tablet      = /Android/i,
        amazon_phone        = /(?=.*\bAndroid\b)(?=.*\bSD4930UR\b)/i,
        amazon_tablet       = /(?=.*\bAndroid\b)(?=.*\b(?:KFOT|KFTT|KFJWI|KFJWA|KFSOWI|KFTHWI|KFTHWA|KFAPWI|KFAPWA|KFARWI|KFASWI|KFSAWI|KFSAWA)\b)/i,
        windows_phone       = /Windows Phone/i,
        windows_tablet      = /(?=.*\bWindows\b)(?=.*\bARM\b)/i, // Match 'Windows' AND 'ARM'
        other_blackberry    = /BlackBerry/i,
        other_blackberry_10 = /BB10/i,
        other_opera         = /Opera Mini/i,
        other_chrome        = /(CriOS|Chrome)(?=.*\bMobile\b)/i,
        other_firefox       = /(?=.*\bFirefox\b)(?=.*\bMobile\b)/i, // Match 'Firefox' AND 'Mobile'
        seven_inch = new RegExp(
            '(?:' +         // Non-capturing group

            'Nexus 7' +     // Nexus 7

            '|' +           // OR

            'BNTV250' +     // B&N Nook Tablet 7 inch

            '|' +           // OR

            'Kindle Fire' + // Kindle Fire

            '|' +           // OR

            'Silk' +        // Kindle Fire, Silk Accelerated

            '|' +           // OR

            'GT-P1000' +    // Galaxy Tab 7 inch

            ')',            // End non-capturing group

            'i');           // Case-insensitive matching

    var match = function(regex, userAgent) {
        return regex.test(userAgent);
    };

    var IsMobileClass = function(userAgent) {
        var ua = userAgent || navigator.userAgent;

        // Facebook mobile app's integrated browser adds a bunch of strings that
        // match everything. Strip it out if it exists.
        var tmp = ua.split('[FBAN');
        if (typeof tmp[1] !== 'undefined') {
            ua = tmp[0];
        }

        // Twitter mobile app's integrated browser on iPad adds a "Twitter for
        // iPhone" string. Same probable happens on other tablet platforms.
        // This will confuse detection so strip it out if it exists.
        tmp = ua.split('Twitter');
        if (typeof tmp[1] !== 'undefined') {
            ua = tmp[0];
        }

        this.apple = {
            phone:  match(apple_phone, ua),
            ipod:   match(apple_ipod, ua),
            tablet: !match(apple_phone, ua) && match(apple_tablet, ua),
            device: match(apple_phone, ua) || match(apple_ipod, ua) || match(apple_tablet, ua)
        };
        this.amazon = {
            phone:  match(amazon_phone, ua),
            tablet: !match(amazon_phone, ua) && match(amazon_tablet, ua),
            device: match(amazon_phone, ua) || match(amazon_tablet, ua)
        };
        this.android = {
            phone:  match(amazon_phone, ua) || match(android_phone, ua),
            tablet: !match(amazon_phone, ua) && !match(android_phone, ua) && (match(amazon_tablet, ua) || match(android_tablet, ua)),
            device: match(amazon_phone, ua) || match(amazon_tablet, ua) || match(android_phone, ua) || match(android_tablet, ua)
        };
        this.windows = {
            phone:  match(windows_phone, ua),
            tablet: match(windows_tablet, ua),
            device: match(windows_phone, ua) || match(windows_tablet, ua)
        };
        this.other = {
            blackberry:   match(other_blackberry, ua),
            blackberry10: match(other_blackberry_10, ua),
            opera:        match(other_opera, ua),
            firefox:      match(other_firefox, ua),
            chrome:       match(other_chrome, ua),
            device:       match(other_blackberry, ua) || match(other_blackberry_10, ua) || match(other_opera, ua) || match(other_firefox, ua) || match(other_chrome, ua)
        };
        this.seven_inch = match(seven_inch, ua);
        this.any = this.apple.device || this.android.device || this.windows.device || this.other.device || this.seven_inch;

        // excludes 'other' devices and ipods, targeting touchscreen phones
        this.phone = this.apple.phone || this.android.phone || this.windows.phone;

        // excludes 7 inch devices, classifying as phone or tablet is left to the user
        this.tablet = this.apple.tablet || this.android.tablet || this.windows.tablet;

        if (typeof window === 'undefined') {
            return this;
        }
    };

    var instantiate = function() {
        var IM = new IsMobileClass();
        IM.Class = IsMobileClass;
        return IM;
    };

    if (typeof module !== 'undefined' && module.exports && typeof window === 'undefined') {
        //node
        module.exports = IsMobileClass;
    } else if (typeof module !== 'undefined' && module.exports && typeof window !== 'undefined') {
        //browserify
        module.exports = instantiate();
    } else if (true) {
        //AMD
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (global.isMobile = instantiate()),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else {
        global.isMobile = instantiate();
    }

})(this);


/***/ }),
/* 934 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(935);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(17)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../lunch-team-client-checkout-msg/node_modules/css-loader/index.js!../../../../../../lunch-team-client-checkout-msg/node_modules/sass-loader/dist/cjs.js!./landing.scss", function() {
			var newContent = require("!!../../../../../../lunch-team-client-checkout-msg/node_modules/css-loader/index.js!../../../../../../lunch-team-client-checkout-msg/node_modules/sass-loader/dist/cjs.js!./landing.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 935 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(14)(undefined);
// imports


// module
exports.push([module.i, ".white-popup-block{width:100%;height:100%;top:0;left:0;right:0;z-index:99999 !important;margin:auto !important;display:table;position:fixed !important}.error-popup-block{width:100%;height:100%;top:0;left:0;right:0;z-index:9999999 !important;margin:auto !important;display:table;position:fixed !important}.modal-content{top:50%;left:50%;transform:translate(-50%, -50%);position:absolute !important;overflow:initial !important}.cintas-terms-conditions-description{height:initial !important}#login1,#login2,#login4,#login5{padding-top:2em !important;padding-bottom:2em !important}.overlay .overlay-box{top:50% !important;transform:translate(-50%, -50%) !important}@media only screen and (max-width: 375px){.overlay.connected .overlay-box h5{margin:0 !important}.overlay .overlay-box form{margin:20px 0 !important}.overlay .overlay-box form input{margin-bottom:0 !important}.overlay.connected .overlay-box .bt{margin:0 !important}}.slick-prev,.slick-next{border:none;cursor:pointer;font-size:0;height:40px;width:23px;position:absolute;top:50%;transform:translateY(-50%);z-index:999}.slick-prev{background:url(" + __webpack_require__(936) + ") no-repeat;left:0}.slick-next{background:url(" + __webpack_require__(937) + ") no-repeat;right:0}::-webkit-input-placeholder{color:inherit;opacity:1}::-moz-placeholder{color:inherit;opacity:1}:-ms-input-placeholder{color:inherit;opacity:1}:-moz-placeholder{color:inherit;opacity:1}input:-webkit-autofill{-webkit-box-shadow:0 0 0 30px #fff inset}*{box-sizing:border-box;margin:0;padding:0}*:focus{outline:none}html{background-color:#f7faf8;color:#4a5f54;font-family:\"Geist\";font-weight:600;font-size:16px;letter-spacing:-1px;line-height:1;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}body{position:relative}body.open{overflow-y:hidden}a{color:inherit;cursor:pointer;display:inline-block;text-decoration:none}ul:before,ul:after{content:\"\";display:table}ul:after{clear:both}h2{font-weight:700;font-size:3.125em;text-transform:uppercase}h3{font-weight:700;font-size:2.8125em}p{line-height:30px}strong{font-weight:700}span{display:inline-block}label{display:block}.form-contact input[type=text]{border:1px solid #4a5f54;color:inherit}.form-contact input{border-radius:8px;width:100%;padding:8px 15px;margin-bottom:0px}.form-contact textarea{border:1px solid #4a5f54;border-radius:8px;width:100%;padding:8px 15px;resize:none;margin-bottom:0px}select{background-color:inherit;border:1px solid #4a5f54;border-radius:8px;color:inherit;width:100%}img{height:auto;max-width:100%}@media only screen and (max-width: 1279px){.wrap{width:95% !important}}.w-48{width:48%}.w-62{width:62%}.w-72{width:72%}.w-50{width:50%}.wrap{width:1186px;margin:auto;position:relative}.wrap:before,.wrap:after{content:\"\";display:table}.wrap:after{clear:both}.wrapper:before,.wrapper:after{content:\"\";display:table}.wrapper:after{clear:both}.left{float:left}.right{float:right}.bt{background-color:#0e7a4b;border:1px solid rgba(0,0,0,0);border-radius:8px;color:#fff;cursor:pointer;font-weight:700;padding:12px 75px;text-transform:uppercase;transition:.35s}.bt:hover{background-color:inherit;border-color:#0e7a4b;color:#0e7a4b}.va{display:inline-block;vertical-align:middle}.centerer{left:50%;position:absolute;top:50%;transform:translate(-50%, -50%)}.tabs .abas{font-weight:700;font-size:1.375em;text-transform:uppercase}.tabs .abas li{cursor:pointer;float:left;margin:0 35px 0 0}.tabs .abas li.active,.tabs .abas li:hover{border-bottom:3px solid #0e7a4b;color:#0e7a4b;padding:0 0 5px 0}.tabs .aba ul{font-weight:700;font-size:17px;line-height:26px}.tabs .aba ul li{margin:0 0 50px 0;padding:0 0 0 33px;position:relative}.tabs .aba ul li:before{background:url(" + __webpack_require__(938) + ") no-repeat;content:\"\";height:20px;width:23px;left:0;position:absolute;top:6px}.tabs .aba ul li:last-child{margin:0}@media only screen and (max-width: 500px){.tabs .aba ul{line-height:30px}.bt{font-size:12px}}.home .header{background:none;color:#fff;left:0;position:absolute;top:0}.internas .header .menu>.lista-menu>li>ul{background-color:#fff}.internas .header .login form input[type=text]{background-color:#fff;border-color:#4a5f54}.internas .header .login form input[type=password]{background-color:#fff;border-color:#4a5f54}.internas .header .login form .bt:hover{background:none;border-color:#0e7a4b;color:#0e7a4b}.header{background-color:#fff;width:100%;padding:15px 0;z-index:999}.header.sticky{background-color:#fff;color:#4a5f54;padding:28px 0;position:fixed;top:-126px;transition:.35s;z-index:9999}.header.sticky.open{top:0}.header.sticky .menu>.lista-menu>li>ul{background-color:#fff}.header.sticky .login form input[type=text]{background-color:#fff;border-color:#4a5f54}.header.sticky .login .form-password .forgot .signed-in{margin:0 0 0 10px}.header.sticky .login form .bt:hover{background:none;border-color:#0e7a4b;color:#0e7a4b}.header .logo{margin:4px 0 0 0}.header .menu{font-weight:700;font-size:.875em;margin:0 0 0 40px}.header .menu>.lista-menu{line-height:35px}.header .menu>.lista-menu>li{float:left;letter-spacing:-0.25px;padding:0 15px;position:relative;transition:.35s}.header .menu>.lista-menu>li>a{color:inherit}.header .menu>.lista-menu>li.active>a{color:#0e7a4b}.header .menu>.lista-menu>li:hover>a{color:#0e7a4b}.header .menu>.lista-menu>li:hover ul{opacity:1}.header .menu>.lista-menu>li>ul{border-top:1px solid;width:100%;left:0;opacity:0;position:absolute;text-align:center;top:100%;z-index:999;transition:.35s}.header .menu>.lista-menu>li>ul>li{font-size:13px;line-height:1;margin:12px 0}.header .menu>.lista-menu>li>ul>li a{color:inherit;display:block}.header .menu>.lista-menu>li>ul>li:hover a{color:#0e7a4b}.header .login{margin:5px 0 0 0}.header .login input{border-radius:8px}.header .login.password .form-email{opacity:0}.header .login.password .form-password{opacity:1;top:5px}.header .login h4{font-weight:700;font-size:12px;letter-spacing:normal;margin:0 10px 0 0;text-transform:uppercase}.header .login form{position:relative}.header .login .form-email .error{background-color:rgba(194,37,37,.82);border:1px solid #c22525;border-radius:8px;color:#fff;font-size:12px;width:430px;left:-185px;line-height:1.2;opacity:0;padding:5px 10px;position:absolute;top:41px}.header .login .form-password{opacity:0;position:absolute;right:-8px;top:-100px;transition:.35s}.header .login .form-password .forgot{left:0;position:absolute;top:32px}.header .login .form-password .forgot span{font-size:12px}.header .login .form-password .forgot .signed-in{font-size:12px;margin:10px 0}.header .login .form-password .forgot .signed-in .checkbox{display:none}.header .login .form-password .forgot .signed-in .checkbox+label{position:relative;cursor:pointer}.header .login .form-password .forgot .signed-in .checkbox+label:before{background-color:#0e7a4b;border-radius:8px;content:\"\";display:inline-block;height:16px;width:16px;margin:0 8px 0 0;vertical-align:middle}.header .login .form-password .forgot .signed-in .checkbox:checked+label:after{background:url(" + __webpack_require__(325) + ") no-repeat;content:\"\";height:8px;width:8px;left:4px;position:absolute;top:4px}.header .login form input[type=text]{background-color:rgba(0,0,0,.27);border-color:#fff;font-size:12px;height:26px;width:auto;padding:0 15px}.header .login form input[type=password]{background-color:rgba(0,0,0,.27);border-color:#fff;font-size:12px;height:26px;width:auto;padding:0 15px}.header .login form .bt{font-size:12px;height:26px;width:auto;line-height:24px;margin:0 0 0 20px;padding:0 20px;text-transform:none}.header .login form .bt:hover{border-color:#fff;color:#fff}.header .member{font-size:.75em;margin:0 0 0 25px;padding:10px 25px;text-transform:none}.header .menu-bt-mobile{background-color:#0e7a4b;border-radius:8px;color:#fff;display:none;padding:12px}.header .menu-bt-mobile svg,.menu-mobile-drop svg{font-size:1.8em;float:left}.svg-inline--fa.fa-w-14{width:.875em}.menu-mobile-drop{background-color:#fff;color:#4a5f54;font-size:1.3em;width:100%;left:-100%;padding:25px 0 85px 0;position:fixed;text-align:center;top:0;z-index:9999;transition:.35s}.menu-mobile-drop.open{left:0}.menu-mobile-drop .close-drop{width:35px;position:absolute;right:5%;top:5%}.menu-mobile-drop .menu-drop li a{display:table;line-height:60px;margin:auto;padding:0 20px}.menu-mobile-drop .login{margin:25px 0 0 0}.menu-mobile-drop .login.password .form-email{opacity:0}.menu-mobile-drop .login.password .form-password{opacity:1;top:0}.menu-mobile-drop .login h4{font-weight:600;font-size:1em;text-transform:uppercase}.menu-mobile-drop .login .formularios{display:inline-block;margin:15px 0;position:relative}.menu-mobile-drop .login form{position:relative}.menu-mobile-drop .login .form-email .error{background-color:rgba(194,37,37,.82);border:1px solid #c22525;border-radius:8px;color:#fff;font-size:12px;width:110%;left:50%;line-height:1.2;opacity:0;padding:5px 10px;position:absolute;top:41px;transform:translateX(-50%)}.menu-mobile-drop .login .form-password{left:0;opacity:0;top:-100px;transition:.35s}.menu-mobile-drop .login .form-password .forgot{text-align:left;margin-top:20px}.menu-mobile-drop .login .form-password .forgot a{font-size:12px;color:inherit;border:0}.menu-mobile-drop .login .form-password .checkbox-remember{font-size:12px;margin:10px 0;text-align:left;line-height:17px}.menu-mobile-drop .login .form-password .checkbox-remember .container{padding-left:26px}.menu-mobile-drop .login .form-password .checkbox-remember input[type=checkbox]{display:none}.menu-mobile-drop .login .form-password .checkbox-remember .checkmark{border:0}.menu-mobile-drop .login .form-password .forgot .checkbox+label{position:relative;cursor:pointer;padding:0}.menu-mobile-drop .login .form-password .forgot .signed-in .checkbox+label:before{background-color:#0e7a4b;border-radius:8px;content:\"\";display:inline-block;height:16px;width:16px;margin:0 8px 0 0;vertical-align:middle}.menu-mobile-drop .login .form-password .forgot .signed-in .checkbox:checked+label:after{background:url(" + __webpack_require__(325) + ") no-repeat;content:\"\";height:8px;width:8px;left:4px;position:absolute;top:4px}.menu-mobile-drop .login form input[type=text],.menu-mobile-drop .login form input[type=password]{border-color:#4a5f54;font-size:12px;border-radius:8px;height:26px;width:auto;padding:0 15px}.menu-mobile-drop .login form .bt{font-size:12px;height:26px;width:75px;line-height:24px;margin:0 0 0 20px;padding:0 20px;text-transform:none}.menu-mobile-drop .login form .bt:hover{border-color:#0e7a4b;color:#0e7a4b}@media only screen and (max-width: 1214px){.header{padding:10px 0}.header.sticky{display:none}.header .login{display:none}.header .logo{margin:15px 0 0 0}.header .menu,.header .member{display:none}.header .menu-bt-mobile{display:block}.menu-mobile-drop .menu-drop li .bt{display:inline-block;font-size:.8em;line-height:1;padding:2.5% 8%}}footer{background-color:#eef4f0;padding:45px 0 10px 0;text-align:center}footer .menu{font-size:.875em;margin:15px 0 30px 0}footer .menu a{margin:0 20px;transition:.35s}footer .menu a:hover{color:#0e7a4b}footer .form-contact{width:48%;margin:auto}footer .form-contact:before,footer .form-contact:after{content:\"\";display:table}footer .form-contact:after{clear:both}footer .form-contact.sent span{display:none}footer .form-contact.sent form{display:none}footer .form-contact.sent .message-sent{display:block}footer .form-contact span{display:block;font-size:14px;margin:0 0 8px 0;text-align:left}footer .form-contact form:before,footer .form-contact form:after{content:\"\";display:table}footer .form-contact form:after{clear:both}footer .form-contact form .col-1 input[type=text]{background:none;font-size:14px}footer .form-contact form .col-1 input[type=text]:nth-child(2){margin:8px 0}footer .form-contact form .col-1.w-50{width:calc(50% - 20px);margin:0 20px 0 0}footer .form-contact form .col-2 textarea{background:none;color:#4a5f54;float:left;font-size:14px;margin:0 0 10px 0;min-height:118px}footer .form-contact form .col-2 .bt{font-size:12px;height:26px;width:auto;line-height:1;padding:0 20px;text-transform:none}footer .form-contact .message-sent{color:#0e7a4b;display:none;margin:50px 0;text-align:center}footer .form-contact--chat p{font-size:14px;margin:0 0 12px 0;text-align:left}footer .form-contact--chat .form-contact__chat{display:block;font-size:14px;padding:10px 24px;text-transform:none}footer .lets{font-weight:700;font-size:.875em;margin:10px 0 20px 0}footer .lets .social{display:table;margin:10px auto auto auto}footer .lets .social li{margin:0 20px;transition:.35s}footer .lets .social li:hover{opacity:.5}footer .lets .social li svg{font-size:33px}footer .lets .social li svg.fa-instagram{color:#c1558b}footer .lets .social li svg.fa-linkedin{color:#0077b5}footer .copyright{display:block;font-size:.75em}@media only screen and (max-width: 1279px){footer .w-50{width:50%}}@media only screen and (max-width: 992px){footer .form-contact{width:100%}}@media only screen and (max-width: 550px){footer .menu a{margin:0 15px}}@media only screen and (max-width: 500px){footer .menu{display:none}footer .form-contact{width:100%;margin:35px 0 0 0}footer .lets{margin:35px 0}}@media only screen and (max-width: 375px){footer .w-50{width:100%}footer .form-contact form .col-1.w-50{width:100%;margin:0}footer .form-contact form .col-2 textarea{margin:10px 0}}.overlay{background-color:rgba(0,0,0,.52);height:100%;width:100%;left:0;position:absolute;top:0;z-index:9999}.overlay.login .overlay-box{width:342px}.overlay.connected .overlay-box{background:#fff url(" + __webpack_require__(322) + ") no-repeat right 45px top 45px;padding:45px;text-align:left;width:590px}.overlay.connected .overlay-box h5{font-weight:700;font-size:1.375em;line-height:26px;margin:15px 0 0 0;padding:0 24% 0 0}.overlay.connected .overlay-box .bt{width:100%;margin:25px 0;text-align:center}.overlay.connected .overlay-box .already{font-size:.875em;text-decoration:underline}.overlay.connected .overlay-box .agreement{font-size:.6875em;text-decoration:underline}.overlay .overlay-box{background-color:#fff;border-radius:8px;left:50%;padding:25px;position:fixed;text-align:center;top:100px;transform:translateX(-50%);z-index:999}.overlay .overlay-box .close{position:absolute;right:0;top:-35px}.overlay .overlay-box .close svg{color:#fff;font-size:1.6em}.overlay .overlay-box h5{font-size:1.125em}.overlay .overlay-box form{margin:35px 0}.overlay .overlay-box form:before,.overlay .overlay-box form:after{content:\"\";display:table}.overlay .overlay-box form:after{clear:both}.overlay .overlay-box form label{font-size:.875em;margin:10px 0;text-align:left}.overlay .overlay-box form input{font-size:.875em}.overlay .overlay-box form select{font-size:.875em;height:34px}.overlay .overlay-box form a{font-size:.8125em;margin:10px 0}.overlay .overlay-box .bt{font-size:.875em;text-transform:none}.overlay .overlay-box strong{display:block;font-size:.8125em;margin:15px 0}.overlay .overlay-box strong a{color:#0e7a4b}@media only screen and (max-width: 768px){.overlay.connected .overlay-box{overflow-y:scroll;height:90%}}@media only screen and (max-width: 500px){.overlay.connected .overlay-box{background-image:none;width:95%;padding:20px}.overlay.connected .overlay-box h5{padding:0}.overlay .overlay-box{width:95% !important}}@media only screen and (max-width: 375px){.overlay.connected .overlay-box .w-48{width:100%}}.secao-1{background:url(" + __webpack_require__(939) + ") no-repeat center center/cover;color:#fff;height:100vh;overflow:hidden;position:relative;text-align:center}.secao-1:before{background-color:rgba(19,7,0,.4);content:\"\";height:100%;width:100%;left:0;position:absolute;top:0;z-index:99}.secao-1 video{display:block;height:auto;width:auto;min-height:100%;min-width:100%;left:50%;position:absolute;top:50%;transform:translate(-50%, -50%)}.secao-1 .wrap{position:absolute;left:50%;top:50%;transform:translate(-50%, -50%);z-index:99}.secao-1 .wrap .centerer{width:68%}.secao-1 .wrap .centerer h1{font-size:3.125em;line-height:70px;text-transform:uppercase}.secao-1 .wrap .centerer .bt{margin:15px 0;padding:10px 35px}.secao-1 .wrap .centerer .bt:hover{border-color:#fff;color:#fff}.secao-2{background:#fff url(" + __webpack_require__(940) + ") no-repeat center right -350px;padding:40px 0 60px 0;overflow:hidden;position:relative}.secao-2 h3{font-size:34px}.secao-2 p{font-size:18px;line-height:46px;margin:100px 0}.secao-2 .macbook,.secao-2 .iphone{position:absolute}.secao-2 .macbook{right:-300px;top:70px}.secao-2 .iphone{right:380px;top:300px}.secao-2 .slick .slick-list li p{font-size:1.4375em;line-height:28px;margin:60px 0}.secao-3-2{background:#4a5f54 url(" + __webpack_require__(941) + ") no-repeat top/cover;color:#fff !important;overflow:hidden;padding:50px 0;position:relative;text-align:center}.secao-3-2:before{background-color:rgba(19,7,0,.6);content:\"\";height:100%;width:100%;left:0;position:absolute;top:0}.secao-3-2 .wrap h1{font-size:34px;margin:0;text-align:left}.secao-3-2 .wrap .columns{margin:170px 0 50px 0}.secao-3-2 .wrap .columns:before,.secao-3-2 .wrap .columns:after{content:\"\";display:table}.secao-3-2 .wrap .columns:after{clear:both}.secao-3-2 .wrap .columns .col{width:33.333%}.secao-3-2 .wrap .columns .col:first-child{width:calc(33.333% - 38px);margin:0 38px 0 0}.secao-3-2 .wrap .columns .col:nth-child(2){width:calc(33.333% - 76px);margin:0 38px}.secao-3-2 .wrap .columns .col:last-child{width:calc(33.333% - 38px);margin:0 0 0 38px}.secao-3-2 .wrap .columns .col span{display:block;font-size:21px;margin:25px 0}.secao-3-2 .wrap .columns .col p{font-weight:400;line-height:26px;color:inherit}.secao-3-2 .wrap .lunch-made-simple-mobile .slick-list{margin:35px 50px}.secao-3-2 .wrap .lunch-made-simple-mobile .slick-list .slick-slide img{display:inline-block !important}.secao-3-2 .wrap .lunch-made-simple-mobile .slick-list .slick-slide span{display:block;font-size:22px;margin:15px 0}.secao-3-2 .wrap .lunch-made-simple-mobile .slick-list .slick-slide p{color:#fff;font-size:16px}.secao-3{background:#4a5f54 url(" + __webpack_require__(942) + ") no-repeat center/cover;color:#fff;overflow:hidden;padding:166px 0;position:relative;text-align:center}.secao-3:before{background-color:rgba(19,7,0,.4);content:\"\";height:100%;width:100%;left:0;position:absolute;top:0}.secao-3 .slick{font-size:1.5em}.secao-3 .slick .slick-list h2{font-size:2.0833333333em}.secao-3 .slick .slick-list strong{display:block;margin:20px 0}.secao-3 .slick .slick-list strong span{color:#eaf5ee}.secao-3 .slick .slick-list .lista-spoilt{display:inline-block;line-height:60px;text-align:left}.secao-3 .slick .slick-list .lista-spoilt li:before{background-color:#0e7a4b;border-radius:50%;content:\"\";display:inline-block;height:10px;width:10px;margin:0 45px 0 0;vertical-align:middle}.secao-3 .bt{margin:60px 0 0 0}.secao-3 .bt:hover{border-color:#fff;color:#fff}.secao-4{background:#fff url(" + __webpack_require__(943) + ") no-repeat center right -55px;overflow:hidden;padding:40px 0}.secao-4 h3{font-size:40px}.secao-4 .tabs .abas{margin:35px 0 75px 0}.secao-4 .tabs .abas-content{text-align:left}.secao-4 .tabs .abas-content .lista-benefits.companies h4{font-size:18px;margin:0 0 15px 0;text-transform:uppercase}.secao-4 .tabs .abas-content .lista-benefits.companies li{margin:0 0 20px 0}.secao-4 .tabs .abas-content .lista-benefits.companies li.first{margin:0 0 50px 0}.secao-4 .bt{margin:75px 0 0 0}.secao-5{background:#fff url(" + __webpack_require__(944) + ") no-repeat center left -200px;overflow:hidden;padding:70px 0;text-align:center}.secao-5 .slick .slick-list li .qualtrics{display:inline-block;margin:35px 0}.secao-5 .slick .slick-list li strong{display:block;font-size:1.625em}.secao-5 .slick .slick-list li span{margin:35px 0}.secao-5 .slick .slick-list li span strong{display:block;font-size:1.125em}.secao-5 .slick .slick-dots{display:inline-block}.secao-5 .bt{margin:35px 0 0 0}.secao-6{background-color:#fff;padding:50px 0}.secao-6 .wrap h1{margin:0}.secao-6 .wrap .clients{margin:50px 0}.secao-6 .wrap .clients li{display:inline-block;width:9.7%;margin:15px 0;text-align:center;vertical-align:middle}.secao-6 .wrap .clients li a{display:block;cursor:auto}.secao-6 .wrap .clients-mobile{margin:50px 0;text-align:center}.secao-6 .wrap .clients-mobile .slick-list{margin:0 50px}.secao-6 .wrap .clients-mobile .slick-dots{margin:25px 0}.secao-6 .wrap .bt{display:table;margin:auto}@media only screen and (max-width: 1279px){.secao-2 .w-50{width:45%}.secao-4 .w-72{width:72%}.secao-5{background-image:none}.w-50,.w-62,.w-72{width:100%}.slick-dots li{display:inline-block;float:none}.tabs .abas li{display:inline-block;float:none}}@media only screen and (max-width: 1100px){.secao-2{background:#fff;text-align:center}.secao-2 .iphone,.secao-2 .macbook{display:none}.secao-2 .w-50{width:100%}.secao-4{background:#fff;text-align:center}.secao-4 .w-72{width:100%}}@media only screen and (max-width: 1214px){.secao-6 .wrap .clients li{width:24.6%}}@media only screen and (max-width: 1006px){.secao-1 .wrap .centerer h1{font-size:2.525em;line-height:60px}}@media only screen and (max-width: 807px){.secao-1 .wrap .centerer h1{font-size:2.025em;line-height:50px}}@media only screen and (max-width: 640px){.secao-1 .wrap .centerer{width:85%}}@media only screen and (max-width: 512px){.secao-1 .wrap .centerer{width:100%}}@media only screen and (max-width: 768px){.secao-3-2 .wrap,.secao-6 .wrap{display:block}.secao-3-2 .wrap h1{text-align:center}.secao-3-2 .wrap .columns{display:none}.secao-6 .wrap h1{text-align:center}.secao-6 .wrap .clients{display:none}.secao-3-2 .wrap .lunch-made-simple-mobile,.secao-6 .wrap .clients-mobile{display:block}}@media only screen and (max-width: 500px){.secao-1{background:url(" + __webpack_require__(945) + ") no-repeat center center/cover;height:480px;padding:165px 0 0 0}.secao-1 video{display:none}.secao-1 .wrap .centerer h1{font-size:1.8em;line-height:30px;padding:0 8%}.secao-2{padding:8% 0}.secao-2 p{line-height:2;margin:8% 0}.secao-2 .slick .slick-list li p{margin:25px 0}.secao-2 .bt{margin:0}.secao-3{padding:8% 0}.secao-3 .slick .slick-list li{margin:15px 0}.secao-3 .slick .slick-list li .lista-spoilt{line-height:35px}.secao-3 .slick .slick-list li .lista-spoilt li:before{margin:0 15px 0 0}.secao-3 .bt{margin:25px 0 0 0}.secao-4{padding:8% 0}.secao-4 .tabs .abas{margin:8% 0}.secao-4 .tabs .abas li{margin:15px 5px}.secao-4 .tabs .abas-content{width:85%;margin:auto}body{font-size:14px}.slick-dots li button{border-color:#0e7a4b}.slick-dots li.slick-active button{background-color:#0e7a4b}}@media only screen and (max-width: 375px){.secao-1{height:280px;padding:85px 0 0 0}.secao-1 .wrap .centerer h1{font-size:1.4em}}.benefits{background:#f7faf8 url(" + __webpack_require__(946) + ") no-repeat center right -115px;overflow:hidden;padding:60px 0}.benefits .tabs .abas{margin:50px 0 90px 0}.benefits .bt{margin:50px 0 0 0}@media only screen and (max-width: 1279px){.benefits{background-image:none;text-align:center}}@media only screen and (max-width: 500px){.benefits .tabs .abas{margin:50px 0 15px 0}.benefits .tabs .abas li{margin:15px 5px}}@media only screen and (max-width: 1024px){.menu-mobile-drop .login form input[type=text],.menu-mobile-drop .login form input[type=password]{font-size:16px;float:left;height:38px}.menu-mobile-drop .login form .bt{height:38px}}", ""]);

// exports


/***/ }),
/* 936 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAAoCAYAAAAVBmHYAAACVUlEQVR4AayXwW7TQBCGZ3IjUtwDj8CDcI977RFaJIqUXkihgGJLHJDiCChQLq1EkQhw5FrnznvAG7SHOlJ663T+pE2ddte76zTayW52Z75/vBvv2g26o89KL+5ESfxP7ThK4yFtr927E3grjfvCtK95PlC7T0LrUXNysDQcYBZKFLpYhNaWglvBM5mz2nAHWGdGdmrBV9L4o3EqZhmTCL8ZZ6NhMBxgEdq55Bgq7o4HRx8wEATXv9lnF7jIjr4CDPOGA6wB22qWwt0yGE5e8DpgL3iUtPfUMShj9Z+WysyjJNa7jp9PPQ1fLLR1cyrKblb4DEydsnO5DfDpID8o991sG+EusJBsusAQugXXO++bDlgzBnicjb6rj7MswAHWy920RYWAwZjDPcBPfDMGGDaFR2k8dGQM8BABIdbQxXunW9i6NUjksWYcDAYPmb9Ew2CTc5aHxWD02zDm1QW4l2MdJ8A/WQKbDeG/Ua/9yDLu7G4UWf6WmH5aPZl/tZL2hnW8YgCZU9HPN/T0PrT5MfGPOgJTOKDjfv7MQ+ApfH1tDkeAh8ChXoG3wAL8SkBr626nU+QtcAuuYNJF3tK6UgCPb+pTWYxwRMwEZH7Yoq9swrTvErDCASqyUZdIKgWiZNV6UlXCrwXoC9pmkz2bgBMOoE7RC62DBbzgCsYiBwt4w68EmGkXbbMtTlEQHMDTfv7KJdDqrb6GbzAcQRAQpgxtkzHL+5ZudrXgAOpWkVYKEO/WhnsILP/CZb0Cpj9LZY7sYRDQpwfsR//19wnp4VNMmp0LAAAA//8rCR7xAAAABklEQVQDAA7x7j7jJ8ZzAAAAAElFTkSuQmCC"

/***/ }),
/* 937 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAAoCAYAAAAVBmHYAAACX0lEQVR4AayWTWvVQBSGz2R3C8ld+BP8Ie47XQnuFPyigh/QYlVuAi6E5KJWLPgBXtQKunbVdO//0H+gi5tAu/P0vOnNbdPMJJPklnmbk5k5zzsZck/Go+1ro3G0/jUI9V/R7yDaeEgr+vOC0dGMWd0S3iXRZWJ+50c6lnhw84RwVVRpiilchQHgxxXy4mYVBh4T7yx4tctQAy9PDr/Jnj+rkRcdMBhH+vXittMF20L59OAVKdq2ZTLTTh+DAg5oFqd71GIQTPRbzHXVEo6ENgMx3+piUIGfGahHiI1S5GxQgwOYxQfvSQ03MMKdDUL9AXNtssKRgCdQRPcQW3TfD/Unyxg1wpE0T9JZk4GMbdoMWuGlgbzrdxGbZDNwggOYT9MvXQ2c4UsDYpRn3NaEJxjLt6Ec6ARHUlGLGgxYvg2lQWd4aSDXGyJjg4F81V70goOYJemP/4qvSHwkMrXHveEm2sW+3nB57Oseq18CXBOZ2ptecD9cvym07yJjU4r3Zdued4YDrEjtG6nSCfA8PrwtYfvPH5NK+RN9pwnMRLMSjBznlRdgRZ+RZBLAeZJWipwTfBzqTdURjAW0wgGWVVnLqkA+Xlyx9BWtER7IubENLG/Fg4Jk+GeFA4xzoyHntItprwmMSUa4E3iaWs85AEM1eBDprdYVO4Br8FMwWQ8+8sbsZo7gCtwFPI/TJ0hyVbEt/mTjKTE1rrgrGAvwilqh+CVuTGJFSR8wWJ7Uil0EJgGcx2lkGnPpw7aMTBOHgsEE/CeC81oFGDwvO16TosSoz/+k4w8OoEO2QhjLdgIAAP//0vZw7gAAAAZJREFUAwBqNPBB1Pyh/gAAAABJRU5ErkJggg=="

/***/ }),
/* 938 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAAUCAYAAABmvqYOAAADnklEQVR4AYxUW2iTWRCeOYl/ttn86ZZdtsv6vsIuLKwsLCz6oOCtSaFCrXhBH4qId0VUkgoGsY2KD6IPasUbVvGGCm1aH7wg2AefCgpCRUXQCvqiTdrUxOSM3/zGapN4CTM5Z2a+882cy/yGSr/fE41BNxZZ7saiN8LxyChUoI/D8Yb9odi8P0swbwjHGv5z2yKdtfHI83A8ojjgo7218YYWSixwPBD+PPKf26KTR/JyiZlOMstMYh4U4ZtE9CMRbzBsbnsLichFAYjfZKEVMCHcB3uQSOYJ8flwPttVn5j/KwJktOJ3Qkc1SMR9xtqpvsLbGW6AG2sc529i2kREdVh4VqvVAmCTELX+4DhT005Nk+KFeTr8/dAFY7ncAd2BGc3bpR4xc0/I4eY3u/sGXu+5Pvwi0Z19mbjyKt2e2i9imrEoU6r2JYjmZDpSxzVOiYt5xWfae+74irkIcP3EvNDNvW3QY1kCB1lb3KaEOi/XTLL7Knwogs6BuFmJYFeIJiGRzRpgtosNtvcvMg2MBEKP1Fmueh/u9rlT0h2pFI5srxKHcMEfz7UcHwr47sP3kIn+18qDLJKBo6oUhJax+PcpoTXmnCbDBXeO5fMLqy5QJ/Moig4YZBjCZErd2Osa9ZeriEzC7fn8QgHE/HkuhDAa+WBjOlFy76QOR/MXTuOZsUy9CNcXfYFlGL9X7JeAebFrEHNE7DXDVo7BeAPdjbc8C2OlMBWLfskiUHDEP4LdFjGvEKxvYeKtTDQkIl0mney9iy1uBDIoxBcAqJZgMlvfbGBqCyIRIfqNDRVgjwvWtQjxaTiKVszakWTfA71QyiRTp+BcD/0JADRLdBrmngjTcxL5B8YBaL0QHcH4h1jzFKMn+AQgIZ+A4UN8VenpkoHDEzy1g/ShG3/B6+lGJd4Ogo7TA8AT6CdhHvDbsVvqcGONTRgvQ4M4jtXaXJh7Mk6ulnZjKcH4DrQL8b6bCYSKgfYLFxZpw2jFaJYz8PlQcetwR6oT83GZQK5eTSBCWzDXHVxx26LT9JNAVrRLkYO7MruuDSoxMBegQWZe+3nF8HlSQa5e3MG+zxNoA6nfUxGrCTH3iIWodbi95zDsCqlKrqgJCYzZCBJ9iugnbsKdXALGz0Qrq1WMmCdfJNeoJgDbDpBlDfMk9RG+2xjrQbyu/IzhnyBfJVdkOpnaKcYe0nlJsyBe+S1ixX6TXEF6gUJyD6RDuLzN30Os694DAAD///lrTU4AAAAGSURBVAMAlMqTTD1+2mkAAAAASUVORK5CYII="

/***/ }),
/* 939 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/secao-1-bg.146783db.jpg";

/***/ }),
/* 940 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/secao-2-bg.1bc0f046.png";

/***/ }),
/* 941 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/secao-3-2-bg.de599319.jpg";

/***/ }),
/* 942 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/secao-3-bg.948a772e.jpg";

/***/ }),
/* 943 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/secao-4-bg.0556c55c.jpg";

/***/ }),
/* 944 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/secao-5-bg.fb581d36.png";

/***/ }),
/* 945 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/secao-1-500-bg_.076ab457.jpg";

/***/ }),
/* 946 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/secao-4-bg.96737aa0.png";

/***/ }),
/* 947 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = PrivacyTerms;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__img_logo_lunch_team_svg__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__img_logo_lunch_team_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__img_logo_lunch_team_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__privacyTerms_scss__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__privacyTerms_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__privacyTerms_scss__);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function PrivacyTerms(){var _this=this;var _useState=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(),_useState2=_slicedToArray(_useState,2),content=_useState2[0],setContent=_useState2[1];var privacyPolicyTermsURL='https://s3-eu-west-1.amazonaws.com/lunchteam-privacy-policy/staging/en/privacy_policy1.1.txt';var getPrivacyContent=function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return fetch(privacyPolicyTermsURL).then(function(result){return result.text();});case 2:result=_context.sent;setContent(result);case 4:case'end':return _context.stop();}}},_callee,_this);}));return function getPrivacyContent(){return _ref.apply(this,arguments);};}();Object(__WEBPACK_IMPORTED_MODULE_1_react__["useEffect"])(function(){getPrivacyContent();},[]);return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('main',{className:'main'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('header',{className:'head'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_2__img_logo_lunch_team_svg___default.a,alt:'Lunch Team Logo'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'content-terms'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{href:'/Menu',className:'back-link'},'Back'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h2',null,'Privacy Policy'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'text-content',dangerouslySetInnerHTML:{__html:content}})));}

/***/ }),
/* 948 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(14)(undefined);
// imports


// module
exports.push([module.i, ".main{padding:40px 20%}.head{width:100%;display:flex;align-items:center;justify-content:center;margin-bottom:60px}.content-terms .text-content{font-size:14px}.content-terms .back-link{color:#0e7a4b;font-size:16px;padding-bottom:20px}.content-terms .back-link:hover{text-decoration:underline}.content-terms p{padding:10px 0}.content-terms h2{font-size:28px;font-weight:bold;text-transform:unset;margin-bottom:40px}", ""]);

// exports


/***/ }),
/* 949 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = TermsAndConditions;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__img_logo_lunch_team_svg__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__img_logo_lunch_team_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__img_logo_lunch_team_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PrivacyTerms_privacyTerms_scss__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PrivacyTerms_privacyTerms_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__PrivacyTerms_privacyTerms_scss__);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function TermsAndConditions(){var _this=this;var _useState=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(),_useState2=_slicedToArray(_useState,2),content=_useState2[0],setContent=_useState2[1];var termsURL='https://s3-eu-west-1.amazonaws.com/lunchteam-terms-conditions/staging/en/terms_conditions1.1.txt';var getTermsConditions=function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return fetch(termsURL).then(function(result){return result.text();});case 2:result=_context.sent;setContent(result);case 4:case'end':return _context.stop();}}},_callee,_this);}));return function getTermsConditions(){return _ref.apply(this,arguments);};}();Object(__WEBPACK_IMPORTED_MODULE_1_react__["useEffect"])(function(){getTermsConditions();},[]);return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('main',{className:'main'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('header',{className:'head'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_2__img_logo_lunch_team_svg___default.a,alt:'Lunch Team Logo'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'content-terms'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{href:'/Menu',className:'back-link'},'Back'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h2',null,'Terms and Conditions'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'text-content',dangerouslySetInnerHTML:{__html:content}})));}

/***/ }),
/* 950 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = DeleteAccount;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__img_logo_lunch_team_svg__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__img_logo_lunch_team_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__img_logo_lunch_team_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PrivacyTerms_privacyTerms_scss__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PrivacyTerms_privacyTerms_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__PrivacyTerms_privacyTerms_scss__);
// Public page for app-store account-deletion requirements (Google Play asks for a web URL).
function DeleteAccount(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('main',{className:'main'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',{className:'head'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_1__img_logo_lunch_team_svg___default.a,alt:'Lunch Team Logo'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content-terms'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'/Menu',className:'back-link'},'Back'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,'Delete your Lunch.Team account'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'You can delete your Lunch.Team account and the personal data linked to it at any time.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'In the app'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Open the Lunch.Team app on iPhone or Android, go to ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Settings'),' and tap',' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Delete Account'),'. Your account is closed straight away and you can no longer sign in. We then erase your personal data as described below.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'By email'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'If you can\'t use the app, email',' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'mailto:support@lunch.team?subject=Delete%20my%20Lunch.Team%20account'},'support@lunch.team'),' ','from the email address you sign in with, with the subject "Delete my Lunch.Team account". We confirm by email when your request has been completed, within one month.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'What we erase and what we keep'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'We erase your profile (name, email address and phone number), your saved delivery addresses and your app notification details, and remove any saved cards from our payment provider.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Records of orders and payments that we must keep for tax, accounting and your company\'s invoices are kept only for as long as the law requires, then deleted. They are not used for marketing.'))));}

/***/ }),
/* 951 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export userIsAuthenticated */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return userIsAuthenticatedRedir; });
/* unused harmony export userIsNotAuthenticated */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return userIsNotAuthenticatedRedir; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_auth_wrapper_history4_locationHelper__ = __webpack_require__(326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_auth_wrapper_history4_locationHelper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_redux_auth_wrapper_history4_locationHelper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_auth_wrapper_history4_redirect__ = __webpack_require__(960);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_auth_wrapper_history4_redirect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_redux_auth_wrapper_history4_redirect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_auth_wrapper_connectedAuthWrapper__ = __webpack_require__(964);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_auth_wrapper_connectedAuthWrapper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_redux_auth_wrapper_connectedAuthWrapper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_UI_Spinner_Spinner__ = __webpack_require__(97);
var locationHelper=__WEBPACK_IMPORTED_MODULE_0_redux_auth_wrapper_history4_locationHelper___default()({});var userIsAuthenticatedDefaults={authenticatedSelector:function authenticatedSelector(state){return state.authenticationReducer.userDetails!==null;},authenticatingSelector:function authenticatingSelector(state){return state.loadingReducer.loading;},wrapperDisplayName:'UserIsAuthenticated'};var userIsAuthenticated=__WEBPACK_IMPORTED_MODULE_2_redux_auth_wrapper_connectedAuthWrapper___default()(userIsAuthenticatedDefaults);var userIsAuthenticatedRedir=Object(__WEBPACK_IMPORTED_MODULE_1_redux_auth_wrapper_history4_redirect__["connectedRouterRedirect"])(Object.assign({},userIsAuthenticatedDefaults,{AuthenticatingComponent:__WEBPACK_IMPORTED_MODULE_3__components_UI_Spinner_Spinner__["a" /* default */],redirectPath:'/'}));var userIsNotAuthenticatedDefaults={authenticatedSelector:function authenticatedSelector(state){return state.authenticationReducer.userDetails===null&&state.loadingReducer.loading===false;},wrapperDisplayName:'UserIsNotAuthenticated'};var userIsNotAuthenticated=__WEBPACK_IMPORTED_MODULE_2_redux_auth_wrapper_connectedAuthWrapper___default()(userIsNotAuthenticatedDefaults);var userIsNotAuthenticatedRedir=Object(__WEBPACK_IMPORTED_MODULE_1_redux_auth_wrapper_history4_redirect__["connectedRouterRedirect"])(Object.assign({},userIsNotAuthenticatedDefaults,{redirectPath:function redirectPath(state,ownProps){return locationHelper.getRedirectQueryParam(ownProps)||'/Menu';},allowRedirectBack:false}));

/***/ }),
/* 952 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



var punycode = __webpack_require__(953);
var util = __webpack_require__(954);

exports.parse = urlParse;
exports.resolve = urlResolve;
exports.resolveObject = urlResolveObject;
exports.format = urlFormat;

exports.Url = Url;

function Url() {
  this.protocol = null;
  this.slashes = null;
  this.auth = null;
  this.host = null;
  this.port = null;
  this.hostname = null;
  this.hash = null;
  this.search = null;
  this.query = null;
  this.pathname = null;
  this.path = null;
  this.href = null;
}

// Reference: RFC 3986, RFC 1808, RFC 2396

// define these here so at least they only have to be
// compiled once on the first module load.
var protocolPattern = /^([a-z0-9.+-]+:)/i,
    portPattern = /:[0-9]*$/,

    // Special case for a simple path URL
    simplePathPattern = /^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/,

    // RFC 2396: characters reserved for delimiting URLs.
    // We actually just auto-escape these.
    delims = ['<', '>', '"', '`', ' ', '\r', '\n', '\t'],

    // RFC 2396: characters not allowed for various reasons.
    unwise = ['{', '}', '|', '\\', '^', '`'].concat(delims),

    // Allowed by RFCs, but cause of XSS attacks.  Always escape these.
    autoEscape = ['\''].concat(unwise),
    // Characters that are never ever allowed in a hostname.
    // Note that any invalid chars are also handled, but these
    // are the ones that are *expected* to be seen, so we fast-path
    // them.
    nonHostChars = ['%', '/', '?', ';', '#'].concat(autoEscape),
    hostEndingChars = ['/', '?', '#'],
    hostnameMaxLen = 255,
    hostnamePartPattern = /^[+a-z0-9A-Z_-]{0,63}$/,
    hostnamePartStart = /^([+a-z0-9A-Z_-]{0,63})(.*)$/,
    // protocols that can allow "unsafe" and "unwise" chars.
    unsafeProtocol = {
      'javascript': true,
      'javascript:': true
    },
    // protocols that never have a hostname.
    hostlessProtocol = {
      'javascript': true,
      'javascript:': true
    },
    // protocols that always contain a // bit.
    slashedProtocol = {
      'http': true,
      'https': true,
      'ftp': true,
      'gopher': true,
      'file': true,
      'http:': true,
      'https:': true,
      'ftp:': true,
      'gopher:': true,
      'file:': true
    },
    querystring = __webpack_require__(955);

function urlParse(url, parseQueryString, slashesDenoteHost) {
  if (url && util.isObject(url) && url instanceof Url) return url;

  var u = new Url;
  u.parse(url, parseQueryString, slashesDenoteHost);
  return u;
}

Url.prototype.parse = function(url, parseQueryString, slashesDenoteHost) {
  if (!util.isString(url)) {
    throw new TypeError("Parameter 'url' must be a string, not " + typeof url);
  }

  // Copy chrome, IE, opera backslash-handling behavior.
  // Back slashes before the query string get converted to forward slashes
  // See: https://code.google.com/p/chromium/issues/detail?id=25916
  var queryIndex = url.indexOf('?'),
      splitter =
          (queryIndex !== -1 && queryIndex < url.indexOf('#')) ? '?' : '#',
      uSplit = url.split(splitter),
      slashRegex = /\\/g;
  uSplit[0] = uSplit[0].replace(slashRegex, '/');
  url = uSplit.join(splitter);

  var rest = url;

  // trim before proceeding.
  // This is to support parse stuff like "  http://foo.com  \n"
  rest = rest.trim();

  if (!slashesDenoteHost && url.split('#').length === 1) {
    // Try fast path regexp
    var simplePath = simplePathPattern.exec(rest);
    if (simplePath) {
      this.path = rest;
      this.href = rest;
      this.pathname = simplePath[1];
      if (simplePath[2]) {
        this.search = simplePath[2];
        if (parseQueryString) {
          this.query = querystring.parse(this.search.substr(1));
        } else {
          this.query = this.search.substr(1);
        }
      } else if (parseQueryString) {
        this.search = '';
        this.query = {};
      }
      return this;
    }
  }

  var proto = protocolPattern.exec(rest);
  if (proto) {
    proto = proto[0];
    var lowerProto = proto.toLowerCase();
    this.protocol = lowerProto;
    rest = rest.substr(proto.length);
  }

  // figure out if it's got a host
  // user@server is *always* interpreted as a hostname, and url
  // resolution will treat //foo/bar as host=foo,path=bar because that's
  // how the browser resolves relative URLs.
  if (slashesDenoteHost || proto || rest.match(/^\/\/[^@\/]+@[^@\/]+/)) {
    var slashes = rest.substr(0, 2) === '//';
    if (slashes && !(proto && hostlessProtocol[proto])) {
      rest = rest.substr(2);
      this.slashes = true;
    }
  }

  if (!hostlessProtocol[proto] &&
      (slashes || (proto && !slashedProtocol[proto]))) {

    // there's a hostname.
    // the first instance of /, ?, ;, or # ends the host.
    //
    // If there is an @ in the hostname, then non-host chars *are* allowed
    // to the left of the last @ sign, unless some host-ending character
    // comes *before* the @-sign.
    // URLs are obnoxious.
    //
    // ex:
    // http://a@b@c/ => user:a@b host:c
    // http://a@b?@c => user:a host:c path:/?@c

    // v0.12 TODO(isaacs): This is not quite how Chrome does things.
    // Review our test case against browsers more comprehensively.

    // find the first instance of any hostEndingChars
    var hostEnd = -1;
    for (var i = 0; i < hostEndingChars.length; i++) {
      var hec = rest.indexOf(hostEndingChars[i]);
      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd))
        hostEnd = hec;
    }

    // at this point, either we have an explicit point where the
    // auth portion cannot go past, or the last @ char is the decider.
    var auth, atSign;
    if (hostEnd === -1) {
      // atSign can be anywhere.
      atSign = rest.lastIndexOf('@');
    } else {
      // atSign must be in auth portion.
      // http://a@b/c@d => host:b auth:a path:/c@d
      atSign = rest.lastIndexOf('@', hostEnd);
    }

    // Now we have a portion which is definitely the auth.
    // Pull that off.
    if (atSign !== -1) {
      auth = rest.slice(0, atSign);
      rest = rest.slice(atSign + 1);
      this.auth = decodeURIComponent(auth);
    }

    // the host is the remaining to the left of the first non-host char
    hostEnd = -1;
    for (var i = 0; i < nonHostChars.length; i++) {
      var hec = rest.indexOf(nonHostChars[i]);
      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd))
        hostEnd = hec;
    }
    // if we still have not hit it, then the entire thing is a host.
    if (hostEnd === -1)
      hostEnd = rest.length;

    this.host = rest.slice(0, hostEnd);
    rest = rest.slice(hostEnd);

    // pull out port.
    this.parseHost();

    // we've indicated that there is a hostname,
    // so even if it's empty, it has to be present.
    this.hostname = this.hostname || '';

    // if hostname begins with [ and ends with ]
    // assume that it's an IPv6 address.
    var ipv6Hostname = this.hostname[0] === '[' &&
        this.hostname[this.hostname.length - 1] === ']';

    // validate a little.
    if (!ipv6Hostname) {
      var hostparts = this.hostname.split(/\./);
      for (var i = 0, l = hostparts.length; i < l; i++) {
        var part = hostparts[i];
        if (!part) continue;
        if (!part.match(hostnamePartPattern)) {
          var newpart = '';
          for (var j = 0, k = part.length; j < k; j++) {
            if (part.charCodeAt(j) > 127) {
              // we replace non-ASCII char with a temporary placeholder
              // we need this to make sure size of hostname is not
              // broken by replacing non-ASCII by nothing
              newpart += 'x';
            } else {
              newpart += part[j];
            }
          }
          // we test again with ASCII char only
          if (!newpart.match(hostnamePartPattern)) {
            var validParts = hostparts.slice(0, i);
            var notHost = hostparts.slice(i + 1);
            var bit = part.match(hostnamePartStart);
            if (bit) {
              validParts.push(bit[1]);
              notHost.unshift(bit[2]);
            }
            if (notHost.length) {
              rest = '/' + notHost.join('.') + rest;
            }
            this.hostname = validParts.join('.');
            break;
          }
        }
      }
    }

    if (this.hostname.length > hostnameMaxLen) {
      this.hostname = '';
    } else {
      // hostnames are always lower case.
      this.hostname = this.hostname.toLowerCase();
    }

    if (!ipv6Hostname) {
      // IDNA Support: Returns a punycoded representation of "domain".
      // It only converts parts of the domain name that
      // have non-ASCII characters, i.e. it doesn't matter if
      // you call it with a domain that already is ASCII-only.
      this.hostname = punycode.toASCII(this.hostname);
    }

    var p = this.port ? ':' + this.port : '';
    var h = this.hostname || '';
    this.host = h + p;
    this.href += this.host;

    // strip [ and ] from the hostname
    // the host field still retains them, though
    if (ipv6Hostname) {
      this.hostname = this.hostname.substr(1, this.hostname.length - 2);
      if (rest[0] !== '/') {
        rest = '/' + rest;
      }
    }
  }

  // now rest is set to the post-host stuff.
  // chop off any delim chars.
  if (!unsafeProtocol[lowerProto]) {

    // First, make 100% sure that any "autoEscape" chars get
    // escaped, even if encodeURIComponent doesn't think they
    // need to be.
    for (var i = 0, l = autoEscape.length; i < l; i++) {
      var ae = autoEscape[i];
      if (rest.indexOf(ae) === -1)
        continue;
      var esc = encodeURIComponent(ae);
      if (esc === ae) {
        esc = escape(ae);
      }
      rest = rest.split(ae).join(esc);
    }
  }


  // chop off from the tail first.
  var hash = rest.indexOf('#');
  if (hash !== -1) {
    // got a fragment string.
    this.hash = rest.substr(hash);
    rest = rest.slice(0, hash);
  }
  var qm = rest.indexOf('?');
  if (qm !== -1) {
    this.search = rest.substr(qm);
    this.query = rest.substr(qm + 1);
    if (parseQueryString) {
      this.query = querystring.parse(this.query);
    }
    rest = rest.slice(0, qm);
  } else if (parseQueryString) {
    // no query string, but parseQueryString still requested
    this.search = '';
    this.query = {};
  }
  if (rest) this.pathname = rest;
  if (slashedProtocol[lowerProto] &&
      this.hostname && !this.pathname) {
    this.pathname = '/';
  }

  //to support http.request
  if (this.pathname || this.search) {
    var p = this.pathname || '';
    var s = this.search || '';
    this.path = p + s;
  }

  // finally, reconstruct the href based on what has been validated.
  this.href = this.format();
  return this;
};

// format a parsed object into a url string
function urlFormat(obj) {
  // ensure it's an object, and not a string url.
  // If it's an obj, this is a no-op.
  // this way, you can call url_format() on strings
  // to clean up potentially wonky urls.
  if (util.isString(obj)) obj = urlParse(obj);
  if (!(obj instanceof Url)) return Url.prototype.format.call(obj);
  return obj.format();
}

Url.prototype.format = function() {
  var auth = this.auth || '';
  if (auth) {
    auth = encodeURIComponent(auth);
    auth = auth.replace(/%3A/i, ':');
    auth += '@';
  }

  var protocol = this.protocol || '',
      pathname = this.pathname || '',
      hash = this.hash || '',
      host = false,
      query = '';

  if (this.host) {
    host = auth + this.host;
  } else if (this.hostname) {
    host = auth + (this.hostname.indexOf(':') === -1 ?
        this.hostname :
        '[' + this.hostname + ']');
    if (this.port) {
      host += ':' + this.port;
    }
  }

  if (this.query &&
      util.isObject(this.query) &&
      Object.keys(this.query).length) {
    query = querystring.stringify(this.query);
  }

  var search = this.search || (query && ('?' + query)) || '';

  if (protocol && protocol.substr(-1) !== ':') protocol += ':';

  // only the slashedProtocols get the //.  Not mailto:, xmpp:, etc.
  // unless they had them to begin with.
  if (this.slashes ||
      (!protocol || slashedProtocol[protocol]) && host !== false) {
    host = '//' + (host || '');
    if (pathname && pathname.charAt(0) !== '/') pathname = '/' + pathname;
  } else if (!host) {
    host = '';
  }

  if (hash && hash.charAt(0) !== '#') hash = '#' + hash;
  if (search && search.charAt(0) !== '?') search = '?' + search;

  pathname = pathname.replace(/[?#]/g, function(match) {
    return encodeURIComponent(match);
  });
  search = search.replace('#', '%23');

  return protocol + host + pathname + search + hash;
};

function urlResolve(source, relative) {
  return urlParse(source, false, true).resolve(relative);
}

Url.prototype.resolve = function(relative) {
  return this.resolveObject(urlParse(relative, false, true)).format();
};

function urlResolveObject(source, relative) {
  if (!source) return relative;
  return urlParse(source, false, true).resolveObject(relative);
}

Url.prototype.resolveObject = function(relative) {
  if (util.isString(relative)) {
    var rel = new Url();
    rel.parse(relative, false, true);
    relative = rel;
  }

  var result = new Url();
  var tkeys = Object.keys(this);
  for (var tk = 0; tk < tkeys.length; tk++) {
    var tkey = tkeys[tk];
    result[tkey] = this[tkey];
  }

  // hash is always overridden, no matter what.
  // even href="" will remove it.
  result.hash = relative.hash;

  // if the relative url is empty, then there's nothing left to do here.
  if (relative.href === '') {
    result.href = result.format();
    return result;
  }

  // hrefs like //foo/bar always cut to the protocol.
  if (relative.slashes && !relative.protocol) {
    // take everything except the protocol from relative
    var rkeys = Object.keys(relative);
    for (var rk = 0; rk < rkeys.length; rk++) {
      var rkey = rkeys[rk];
      if (rkey !== 'protocol')
        result[rkey] = relative[rkey];
    }

    //urlParse appends trailing / to urls like http://www.example.com
    if (slashedProtocol[result.protocol] &&
        result.hostname && !result.pathname) {
      result.path = result.pathname = '/';
    }

    result.href = result.format();
    return result;
  }

  if (relative.protocol && relative.protocol !== result.protocol) {
    // if it's a known url protocol, then changing
    // the protocol does weird things
    // first, if it's not file:, then we MUST have a host,
    // and if there was a path
    // to begin with, then we MUST have a path.
    // if it is file:, then the host is dropped,
    // because that's known to be hostless.
    // anything else is assumed to be absolute.
    if (!slashedProtocol[relative.protocol]) {
      var keys = Object.keys(relative);
      for (var v = 0; v < keys.length; v++) {
        var k = keys[v];
        result[k] = relative[k];
      }
      result.href = result.format();
      return result;
    }

    result.protocol = relative.protocol;
    if (!relative.host && !hostlessProtocol[relative.protocol]) {
      var relPath = (relative.pathname || '').split('/');
      while (relPath.length && !(relative.host = relPath.shift()));
      if (!relative.host) relative.host = '';
      if (!relative.hostname) relative.hostname = '';
      if (relPath[0] !== '') relPath.unshift('');
      if (relPath.length < 2) relPath.unshift('');
      result.pathname = relPath.join('/');
    } else {
      result.pathname = relative.pathname;
    }
    result.search = relative.search;
    result.query = relative.query;
    result.host = relative.host || '';
    result.auth = relative.auth;
    result.hostname = relative.hostname || relative.host;
    result.port = relative.port;
    // to support http.request
    if (result.pathname || result.search) {
      var p = result.pathname || '';
      var s = result.search || '';
      result.path = p + s;
    }
    result.slashes = result.slashes || relative.slashes;
    result.href = result.format();
    return result;
  }

  var isSourceAbs = (result.pathname && result.pathname.charAt(0) === '/'),
      isRelAbs = (
          relative.host ||
          relative.pathname && relative.pathname.charAt(0) === '/'
      ),
      mustEndAbs = (isRelAbs || isSourceAbs ||
                    (result.host && relative.pathname)),
      removeAllDots = mustEndAbs,
      srcPath = result.pathname && result.pathname.split('/') || [],
      relPath = relative.pathname && relative.pathname.split('/') || [],
      psychotic = result.protocol && !slashedProtocol[result.protocol];

  // if the url is a non-slashed url, then relative
  // links like ../.. should be able
  // to crawl up to the hostname, as well.  This is strange.
  // result.protocol has already been set by now.
  // Later on, put the first path part into the host field.
  if (psychotic) {
    result.hostname = '';
    result.port = null;
    if (result.host) {
      if (srcPath[0] === '') srcPath[0] = result.host;
      else srcPath.unshift(result.host);
    }
    result.host = '';
    if (relative.protocol) {
      relative.hostname = null;
      relative.port = null;
      if (relative.host) {
        if (relPath[0] === '') relPath[0] = relative.host;
        else relPath.unshift(relative.host);
      }
      relative.host = null;
    }
    mustEndAbs = mustEndAbs && (relPath[0] === '' || srcPath[0] === '');
  }

  if (isRelAbs) {
    // it's absolute.
    result.host = (relative.host || relative.host === '') ?
                  relative.host : result.host;
    result.hostname = (relative.hostname || relative.hostname === '') ?
                      relative.hostname : result.hostname;
    result.search = relative.search;
    result.query = relative.query;
    srcPath = relPath;
    // fall through to the dot-handling below.
  } else if (relPath.length) {
    // it's relative
    // throw away the existing file, and take the new path instead.
    if (!srcPath) srcPath = [];
    srcPath.pop();
    srcPath = srcPath.concat(relPath);
    result.search = relative.search;
    result.query = relative.query;
  } else if (!util.isNullOrUndefined(relative.search)) {
    // just pull out the search.
    // like href='?foo'.
    // Put this after the other two cases because it simplifies the booleans
    if (psychotic) {
      result.hostname = result.host = srcPath.shift();
      //occationaly the auth can get stuck only in host
      //this especially happens in cases like
      //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
      var authInHost = result.host && result.host.indexOf('@') > 0 ?
                       result.host.split('@') : false;
      if (authInHost) {
        result.auth = authInHost.shift();
        result.host = result.hostname = authInHost.shift();
      }
    }
    result.search = relative.search;
    result.query = relative.query;
    //to support http.request
    if (!util.isNull(result.pathname) || !util.isNull(result.search)) {
      result.path = (result.pathname ? result.pathname : '') +
                    (result.search ? result.search : '');
    }
    result.href = result.format();
    return result;
  }

  if (!srcPath.length) {
    // no path at all.  easy.
    // we've already handled the other stuff above.
    result.pathname = null;
    //to support http.request
    if (result.search) {
      result.path = '/' + result.search;
    } else {
      result.path = null;
    }
    result.href = result.format();
    return result;
  }

  // if a url ENDs in . or .., then it must get a trailing slash.
  // however, if it ends in anything else non-slashy,
  // then it must NOT get a trailing slash.
  var last = srcPath.slice(-1)[0];
  var hasTrailingSlash = (
      (result.host || relative.host || srcPath.length > 1) &&
      (last === '.' || last === '..') || last === '');

  // strip single dots, resolve double dots to parent dir
  // if the path tries to go above the root, `up` ends up > 0
  var up = 0;
  for (var i = srcPath.length; i >= 0; i--) {
    last = srcPath[i];
    if (last === '.') {
      srcPath.splice(i, 1);
    } else if (last === '..') {
      srcPath.splice(i, 1);
      up++;
    } else if (up) {
      srcPath.splice(i, 1);
      up--;
    }
  }

  // if the path is allowed to go above the root, restore leading ..s
  if (!mustEndAbs && !removeAllDots) {
    for (; up--; up) {
      srcPath.unshift('..');
    }
  }

  if (mustEndAbs && srcPath[0] !== '' &&
      (!srcPath[0] || srcPath[0].charAt(0) !== '/')) {
    srcPath.unshift('');
  }

  if (hasTrailingSlash && (srcPath.join('/').substr(-1) !== '/')) {
    srcPath.push('');
  }

  var isAbsolute = srcPath[0] === '' ||
      (srcPath[0] && srcPath[0].charAt(0) === '/');

  // put the host back
  if (psychotic) {
    result.hostname = result.host = isAbsolute ? '' :
                                    srcPath.length ? srcPath.shift() : '';
    //occationaly the auth can get stuck only in host
    //this especially happens in cases like
    //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
    var authInHost = result.host && result.host.indexOf('@') > 0 ?
                     result.host.split('@') : false;
    if (authInHost) {
      result.auth = authInHost.shift();
      result.host = result.hostname = authInHost.shift();
    }
  }

  mustEndAbs = mustEndAbs || (result.host && srcPath.length);

  if (mustEndAbs && !isAbsolute) {
    srcPath.unshift('');
  }

  if (!srcPath.length) {
    result.pathname = null;
    result.path = null;
  } else {
    result.pathname = srcPath.join('/');
  }

  //to support request.http
  if (!util.isNull(result.pathname) || !util.isNull(result.search)) {
    result.path = (result.pathname ? result.pathname : '') +
                  (result.search ? result.search : '');
  }
  result.auth = relative.auth || result.auth;
  result.slashes = result.slashes || relative.slashes;
  result.href = result.format();
  return result;
};

Url.prototype.parseHost = function() {
  var host = this.host;
  var port = portPattern.exec(host);
  if (port) {
    port = port[0];
    if (port !== ':') {
      this.port = port.substr(1);
    }
    host = host.substr(0, host.length - port.length);
  }
  if (host) this.hostname = host;
};


/***/ }),
/* 953 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, global) {var __WEBPACK_AMD_DEFINE_RESULT__;/*! https://mths.be/punycode v1.4.1 by @mathias */
;(function(root) {

	/** Detect free variables */
	var freeExports = typeof exports == 'object' && exports &&
		!exports.nodeType && exports;
	var freeModule = typeof module == 'object' && module &&
		!module.nodeType && module;
	var freeGlobal = typeof global == 'object' && global;
	if (
		freeGlobal.global === freeGlobal ||
		freeGlobal.window === freeGlobal ||
		freeGlobal.self === freeGlobal
	) {
		root = freeGlobal;
	}

	/**
	 * The `punycode` object.
	 * @name punycode
	 * @type Object
	 */
	var punycode,

	/** Highest positive signed 32-bit float value */
	maxInt = 2147483647, // aka. 0x7FFFFFFF or 2^31-1

	/** Bootstring parameters */
	base = 36,
	tMin = 1,
	tMax = 26,
	skew = 38,
	damp = 700,
	initialBias = 72,
	initialN = 128, // 0x80
	delimiter = '-', // '\x2D'

	/** Regular expressions */
	regexPunycode = /^xn--/,
	regexNonASCII = /[^\x20-\x7E]/, // unprintable ASCII chars + non-ASCII chars
	regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g, // RFC 3490 separators

	/** Error messages */
	errors = {
		'overflow': 'Overflow: input needs wider integers to process',
		'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
		'invalid-input': 'Invalid input'
	},

	/** Convenience shortcuts */
	baseMinusTMin = base - tMin,
	floor = Math.floor,
	stringFromCharCode = String.fromCharCode,

	/** Temporary variable */
	key;

	/*--------------------------------------------------------------------------*/

	/**
	 * A generic error utility function.
	 * @private
	 * @param {String} type The error type.
	 * @returns {Error} Throws a `RangeError` with the applicable error message.
	 */
	function error(type) {
		throw new RangeError(errors[type]);
	}

	/**
	 * A generic `Array#map` utility function.
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} callback The function that gets called for every array
	 * item.
	 * @returns {Array} A new array of values returned by the callback function.
	 */
	function map(array, fn) {
		var length = array.length;
		var result = [];
		while (length--) {
			result[length] = fn(array[length]);
		}
		return result;
	}

	/**
	 * A simple `Array#map`-like wrapper to work with domain name strings or email
	 * addresses.
	 * @private
	 * @param {String} domain The domain name or email address.
	 * @param {Function} callback The function that gets called for every
	 * character.
	 * @returns {Array} A new string of characters returned by the callback
	 * function.
	 */
	function mapDomain(string, fn) {
		var parts = string.split('@');
		var result = '';
		if (parts.length > 1) {
			// In email addresses, only the domain name should be punycoded. Leave
			// the local part (i.e. everything up to `@`) intact.
			result = parts[0] + '@';
			string = parts[1];
		}
		// Avoid `split(regex)` for IE8 compatibility. See #17.
		string = string.replace(regexSeparators, '\x2E');
		var labels = string.split('.');
		var encoded = map(labels, fn).join('.');
		return result + encoded;
	}

	/**
	 * Creates an array containing the numeric code points of each Unicode
	 * character in the string. While JavaScript uses UCS-2 internally,
	 * this function will convert a pair of surrogate halves (each of which
	 * UCS-2 exposes as separate characters) into a single code point,
	 * matching UTF-16.
	 * @see `punycode.ucs2.encode`
	 * @see <https://mathiasbynens.be/notes/javascript-encoding>
	 * @memberOf punycode.ucs2
	 * @name decode
	 * @param {String} string The Unicode input string (UCS-2).
	 * @returns {Array} The new array of code points.
	 */
	function ucs2decode(string) {
		var output = [],
		    counter = 0,
		    length = string.length,
		    value,
		    extra;
		while (counter < length) {
			value = string.charCodeAt(counter++);
			if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
				// high surrogate, and there is a next character
				extra = string.charCodeAt(counter++);
				if ((extra & 0xFC00) == 0xDC00) { // low surrogate
					output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
				} else {
					// unmatched surrogate; only append this code unit, in case the next
					// code unit is the high surrogate of a surrogate pair
					output.push(value);
					counter--;
				}
			} else {
				output.push(value);
			}
		}
		return output;
	}

	/**
	 * Creates a string based on an array of numeric code points.
	 * @see `punycode.ucs2.decode`
	 * @memberOf punycode.ucs2
	 * @name encode
	 * @param {Array} codePoints The array of numeric code points.
	 * @returns {String} The new Unicode string (UCS-2).
	 */
	function ucs2encode(array) {
		return map(array, function(value) {
			var output = '';
			if (value > 0xFFFF) {
				value -= 0x10000;
				output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
				value = 0xDC00 | value & 0x3FF;
			}
			output += stringFromCharCode(value);
			return output;
		}).join('');
	}

	/**
	 * Converts a basic code point into a digit/integer.
	 * @see `digitToBasic()`
	 * @private
	 * @param {Number} codePoint The basic numeric code point value.
	 * @returns {Number} The numeric value of a basic code point (for use in
	 * representing integers) in the range `0` to `base - 1`, or `base` if
	 * the code point does not represent a value.
	 */
	function basicToDigit(codePoint) {
		if (codePoint - 48 < 10) {
			return codePoint - 22;
		}
		if (codePoint - 65 < 26) {
			return codePoint - 65;
		}
		if (codePoint - 97 < 26) {
			return codePoint - 97;
		}
		return base;
	}

	/**
	 * Converts a digit/integer into a basic code point.
	 * @see `basicToDigit()`
	 * @private
	 * @param {Number} digit The numeric value of a basic code point.
	 * @returns {Number} The basic code point whose value (when used for
	 * representing integers) is `digit`, which needs to be in the range
	 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
	 * used; else, the lowercase form is used. The behavior is undefined
	 * if `flag` is non-zero and `digit` has no uppercase form.
	 */
	function digitToBasic(digit, flag) {
		//  0..25 map to ASCII a..z or A..Z
		// 26..35 map to ASCII 0..9
		return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
	}

	/**
	 * Bias adaptation function as per section 3.4 of RFC 3492.
	 * https://tools.ietf.org/html/rfc3492#section-3.4
	 * @private
	 */
	function adapt(delta, numPoints, firstTime) {
		var k = 0;
		delta = firstTime ? floor(delta / damp) : delta >> 1;
		delta += floor(delta / numPoints);
		for (/* no initialization */; delta > baseMinusTMin * tMax >> 1; k += base) {
			delta = floor(delta / baseMinusTMin);
		}
		return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
	}

	/**
	 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
	 * symbols.
	 * @memberOf punycode
	 * @param {String} input The Punycode string of ASCII-only symbols.
	 * @returns {String} The resulting string of Unicode symbols.
	 */
	function decode(input) {
		// Don't use UCS-2
		var output = [],
		    inputLength = input.length,
		    out,
		    i = 0,
		    n = initialN,
		    bias = initialBias,
		    basic,
		    j,
		    index,
		    oldi,
		    w,
		    k,
		    digit,
		    t,
		    /** Cached calculation results */
		    baseMinusT;

		// Handle the basic code points: let `basic` be the number of input code
		// points before the last delimiter, or `0` if there is none, then copy
		// the first basic code points to the output.

		basic = input.lastIndexOf(delimiter);
		if (basic < 0) {
			basic = 0;
		}

		for (j = 0; j < basic; ++j) {
			// if it's not a basic code point
			if (input.charCodeAt(j) >= 0x80) {
				error('not-basic');
			}
			output.push(input.charCodeAt(j));
		}

		// Main decoding loop: start just after the last delimiter if any basic code
		// points were copied; start at the beginning otherwise.

		for (index = basic > 0 ? basic + 1 : 0; index < inputLength; /* no final expression */) {

			// `index` is the index of the next character to be consumed.
			// Decode a generalized variable-length integer into `delta`,
			// which gets added to `i`. The overflow checking is easier
			// if we increase `i` as we go, then subtract off its starting
			// value at the end to obtain `delta`.
			for (oldi = i, w = 1, k = base; /* no condition */; k += base) {

				if (index >= inputLength) {
					error('invalid-input');
				}

				digit = basicToDigit(input.charCodeAt(index++));

				if (digit >= base || digit > floor((maxInt - i) / w)) {
					error('overflow');
				}

				i += digit * w;
				t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);

				if (digit < t) {
					break;
				}

				baseMinusT = base - t;
				if (w > floor(maxInt / baseMinusT)) {
					error('overflow');
				}

				w *= baseMinusT;

			}

			out = output.length + 1;
			bias = adapt(i - oldi, out, oldi == 0);

			// `i` was supposed to wrap around from `out` to `0`,
			// incrementing `n` each time, so we'll fix that now:
			if (floor(i / out) > maxInt - n) {
				error('overflow');
			}

			n += floor(i / out);
			i %= out;

			// Insert `n` at position `i` of the output
			output.splice(i++, 0, n);

		}

		return ucs2encode(output);
	}

	/**
	 * Converts a string of Unicode symbols (e.g. a domain name label) to a
	 * Punycode string of ASCII-only symbols.
	 * @memberOf punycode
	 * @param {String} input The string of Unicode symbols.
	 * @returns {String} The resulting Punycode string of ASCII-only symbols.
	 */
	function encode(input) {
		var n,
		    delta,
		    handledCPCount,
		    basicLength,
		    bias,
		    j,
		    m,
		    q,
		    k,
		    t,
		    currentValue,
		    output = [],
		    /** `inputLength` will hold the number of code points in `input`. */
		    inputLength,
		    /** Cached calculation results */
		    handledCPCountPlusOne,
		    baseMinusT,
		    qMinusT;

		// Convert the input in UCS-2 to Unicode
		input = ucs2decode(input);

		// Cache the length
		inputLength = input.length;

		// Initialize the state
		n = initialN;
		delta = 0;
		bias = initialBias;

		// Handle the basic code points
		for (j = 0; j < inputLength; ++j) {
			currentValue = input[j];
			if (currentValue < 0x80) {
				output.push(stringFromCharCode(currentValue));
			}
		}

		handledCPCount = basicLength = output.length;

		// `handledCPCount` is the number of code points that have been handled;
		// `basicLength` is the number of basic code points.

		// Finish the basic string - if it is not empty - with a delimiter
		if (basicLength) {
			output.push(delimiter);
		}

		// Main encoding loop:
		while (handledCPCount < inputLength) {

			// All non-basic code points < n have been handled already. Find the next
			// larger one:
			for (m = maxInt, j = 0; j < inputLength; ++j) {
				currentValue = input[j];
				if (currentValue >= n && currentValue < m) {
					m = currentValue;
				}
			}

			// Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
			// but guard against overflow
			handledCPCountPlusOne = handledCPCount + 1;
			if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) {
				error('overflow');
			}

			delta += (m - n) * handledCPCountPlusOne;
			n = m;

			for (j = 0; j < inputLength; ++j) {
				currentValue = input[j];

				if (currentValue < n && ++delta > maxInt) {
					error('overflow');
				}

				if (currentValue == n) {
					// Represent delta as a generalized variable-length integer
					for (q = delta, k = base; /* no condition */; k += base) {
						t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);
						if (q < t) {
							break;
						}
						qMinusT = q - t;
						baseMinusT = base - t;
						output.push(
							stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0))
						);
						q = floor(qMinusT / baseMinusT);
					}

					output.push(stringFromCharCode(digitToBasic(q, 0)));
					bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
					delta = 0;
					++handledCPCount;
				}
			}

			++delta;
			++n;

		}
		return output.join('');
	}

	/**
	 * Converts a Punycode string representing a domain name or an email address
	 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
	 * it doesn't matter if you call it on a string that has already been
	 * converted to Unicode.
	 * @memberOf punycode
	 * @param {String} input The Punycoded domain name or email address to
	 * convert to Unicode.
	 * @returns {String} The Unicode representation of the given Punycode
	 * string.
	 */
	function toUnicode(input) {
		return mapDomain(input, function(string) {
			return regexPunycode.test(string)
				? decode(string.slice(4).toLowerCase())
				: string;
		});
	}

	/**
	 * Converts a Unicode string representing a domain name or an email address to
	 * Punycode. Only the non-ASCII parts of the domain name will be converted,
	 * i.e. it doesn't matter if you call it with a domain that's already in
	 * ASCII.
	 * @memberOf punycode
	 * @param {String} input The domain name or email address to convert, as a
	 * Unicode string.
	 * @returns {String} The Punycode representation of the given domain name or
	 * email address.
	 */
	function toASCII(input) {
		return mapDomain(input, function(string) {
			return regexNonASCII.test(string)
				? 'xn--' + encode(string)
				: string;
		});
	}

	/*--------------------------------------------------------------------------*/

	/** Define the public API */
	punycode = {
		/**
		 * A string representing the current Punycode.js version number.
		 * @memberOf punycode
		 * @type String
		 */
		'version': '1.4.1',
		/**
		 * An object of methods to convert from JavaScript's internal character
		 * representation (UCS-2) to Unicode code points, and back.
		 * @see <https://mathiasbynens.be/notes/javascript-encoding>
		 * @memberOf punycode
		 * @type Object
		 */
		'ucs2': {
			'decode': ucs2decode,
			'encode': ucs2encode
		},
		'decode': decode,
		'encode': encode,
		'toASCII': toASCII,
		'toUnicode': toUnicode
	};

	/** Expose `punycode` */
	// Some AMD build optimizers, like r.js, check for specific condition patterns
	// like the following:
	if (
		true
	) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
			return punycode;
		}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (freeExports && freeModule) {
		if (module.exports == freeExports) {
			// in Node.js, io.js, or RingoJS v0.8.0+
			freeModule.exports = punycode;
		} else {
			// in Narwhal or RingoJS v0.7.0-
			for (key in punycode) {
				punycode.hasOwnProperty(key) && (freeExports[key] = punycode[key]);
			}
		}
	} else {
		// in Rhino or a web browser
		root.punycode = punycode;
	}

}(this));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(279)(module), __webpack_require__(39)))

/***/ }),
/* 954 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
  isString: function(arg) {
    return typeof(arg) === 'string';
  },
  isObject: function(arg) {
    return typeof(arg) === 'object' && arg !== null;
  },
  isNull: function(arg) {
    return arg === null;
  },
  isNullOrUndefined: function(arg) {
    return arg == null;
  }
};


/***/ }),
/* 955 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.decode = exports.parse = __webpack_require__(956);
exports.encode = exports.stringify = __webpack_require__(957);


/***/ }),
/* 956 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



// If obj.hasOwnProperty has been overridden, then calling
// obj.hasOwnProperty(prop) will break.
// See: https://github.com/joyent/node/issues/1707
function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

module.exports = function(qs, sep, eq, options) {
  sep = sep || '&';
  eq = eq || '=';
  var obj = {};

  if (typeof qs !== 'string' || qs.length === 0) {
    return obj;
  }

  var regexp = /\+/g;
  qs = qs.split(sep);

  var maxKeys = 1000;
  if (options && typeof options.maxKeys === 'number') {
    maxKeys = options.maxKeys;
  }

  var len = qs.length;
  // maxKeys <= 0 means that we should not limit keys count
  if (maxKeys > 0 && len > maxKeys) {
    len = maxKeys;
  }

  for (var i = 0; i < len; ++i) {
    var x = qs[i].replace(regexp, '%20'),
        idx = x.indexOf(eq),
        kstr, vstr, k, v;

    if (idx >= 0) {
      kstr = x.substr(0, idx);
      vstr = x.substr(idx + 1);
    } else {
      kstr = x;
      vstr = '';
    }

    k = decodeURIComponent(kstr);
    v = decodeURIComponent(vstr);

    if (!hasOwnProperty(obj, k)) {
      obj[k] = v;
    } else if (isArray(obj[k])) {
      obj[k].push(v);
    } else {
      obj[k] = [obj[k], v];
    }
  }

  return obj;
};

var isArray = Array.isArray || function (xs) {
  return Object.prototype.toString.call(xs) === '[object Array]';
};


/***/ }),
/* 957 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



var stringifyPrimitive = function(v) {
  switch (typeof v) {
    case 'string':
      return v;

    case 'boolean':
      return v ? 'true' : 'false';

    case 'number':
      return isFinite(v) ? v : '';

    default:
      return '';
  }
};

module.exports = function(obj, sep, eq, name) {
  sep = sep || '&';
  eq = eq || '=';
  if (obj === null) {
    obj = undefined;
  }

  if (typeof obj === 'object') {
    return map(objectKeys(obj), function(k) {
      var ks = encodeURIComponent(stringifyPrimitive(k)) + eq;
      if (isArray(obj[k])) {
        return map(obj[k], function(v) {
          return ks + encodeURIComponent(stringifyPrimitive(v));
        }).join(sep);
      } else {
        return ks + encodeURIComponent(stringifyPrimitive(obj[k]));
      }
    }).join(sep);

  }

  if (!name) return '';
  return encodeURIComponent(stringifyPrimitive(name)) + eq +
         encodeURIComponent(stringifyPrimitive(obj));
};

var isArray = Array.isArray || function (xs) {
  return Object.prototype.toString.call(xs) === '[object Array]';
};

function map (xs, f) {
  if (xs.map) return xs.map(f);
  var res = [];
  for (var i = 0; i < xs.length; i++) {
    res.push(f(xs[i], i));
  }
  return res;
}

var objectKeys = Object.keys || function (obj) {
  var res = [];
  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) res.push(key);
  }
  return res;
};


/***/ }),
/* 958 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = function (str) {
	return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
		return '%' + c.charCodeAt(0).toString(16).toUpperCase();
	});
};


/***/ }),
/* 959 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var token = '%[a-f0-9]{2}';
var singleMatcher = new RegExp(token, 'gi');
var multiMatcher = new RegExp('(' + token + ')+', 'gi');

function decodeComponents(components, split) {
	try {
		// Try to decode the entire string first
		return decodeURIComponent(components.join(''));
	} catch (err) {
		// Do nothing
	}

	if (components.length === 1) {
		return components;
	}

	split = split || 1;

	// Split the array in 2 parts
	var left = components.slice(0, split);
	var right = components.slice(split);

	return Array.prototype.concat.call([], decodeComponents(left), decodeComponents(right));
}

function decode(input) {
	try {
		return decodeURIComponent(input);
	} catch (err) {
		var tokens = input.match(singleMatcher);

		for (var i = 1; i < tokens.length; i++) {
			input = decodeComponents(tokens, i).join('');

			tokens = input.match(singleMatcher);
		}

		return input;
	}
}

function customDecodeURIComponent(input) {
	// Keep track of all the replacements and prefill the map with the `BOM`
	var replaceMap = {
		'%FE%FF': '\uFFFD\uFFFD',
		'%FF%FE': '\uFFFD\uFFFD'
	};

	var match = multiMatcher.exec(input);
	while (match) {
		try {
			// Decode as big chunks as possible
			replaceMap[match[0]] = decodeURIComponent(match[0]);
		} catch (err) {
			var result = decode(match[0]);

			if (result !== match[0]) {
				replaceMap[match[0]] = result;
			}
		}

		match = multiMatcher.exec(input);
	}

	// Add `%C2` at the end of the map to make sure it does not replace the combinator before everything else
	replaceMap['%C2'] = '\uFFFD';

	var entries = Object.keys(replaceMap);

	for (var i = 0; i < entries.length; i++) {
		// Replace all decoded components
		var key = entries[i];
		input = input.replace(new RegExp(key, 'g'), replaceMap[key]);
	}

	return input;
}

module.exports = function (encodedURI) {
	if (typeof encodedURI !== 'string') {
		throw new TypeError('Expected `encodedURI` to be of type `string`, got `' + typeof encodedURI + '`');
	}

	try {
		encodedURI = encodedURI.replace(/\+/g, ' ');

		// Try the built in decoder first
		return decodeURIComponent(encodedURI);
	} catch (err) {
		// Fallback to a more advanced decoder
		return customDecodeURIComponent(encodedURI);
	}
};


/***/ }),
/* 960 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.connectedReduxRedirect = exports.connectedRouterRedirect = undefined;

var _locationHelper = __webpack_require__(326);

var _locationHelper2 = _interopRequireDefault(_locationHelper);

var _redirect = __webpack_require__(961);

var _redirect2 = _interopRequireDefault(_redirect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _redirectUtil = (0, _redirect2.default)({
  locationHelperBuilder: _locationHelper2.default,
  getRouterRedirect: function getRouterRedirect(_ref) {
    var history = _ref.history;
    return history.replace;
  }
});

var connectedRouterRedirect = _redirectUtil.connectedRouterRedirect,
    connectedReduxRedirect = _redirectUtil.connectedReduxRedirect;
exports.connectedRouterRedirect = connectedRouterRedirect;
exports.connectedReduxRedirect = connectedReduxRedirect;

/***/ }),
/* 961 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reactRedux = __webpack_require__(8);

var _invariant = __webpack_require__(48);

var _invariant2 = _interopRequireDefault(_invariant);

var _authWrapper = __webpack_require__(327);

var _authWrapper2 = _interopRequireDefault(_authWrapper);

var _redirect = __webpack_require__(963);

var _redirect2 = _interopRequireDefault(_redirect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var connectedDefaults = {
  authenticatingSelector: function authenticatingSelector() {
    return false;
  },
  allowRedirectBack: true,
  FailureComponent: _redirect2.default,
  redirectQueryParamName: 'redirect'
};

exports.default = function (_ref) {
  var locationHelperBuilder = _ref.locationHelperBuilder,
      getRouterRedirect = _ref.getRouterRedirect;


  var connectedRouterRedirect = function connectedRouterRedirect(args) {
    var allArgs = _extends({}, connectedDefaults, args);
    var FailureComponent = allArgs.FailureComponent,
        redirectPath = allArgs.redirectPath,
        authenticatedSelector = allArgs.authenticatedSelector,
        authenticatingSelector = allArgs.authenticatingSelector,
        allowRedirectBack = allArgs.allowRedirectBack,
        redirectQueryParamName = allArgs.redirectQueryParamName;

    var _locationHelperBuilde = locationHelperBuilder({
      redirectQueryParamName: redirectQueryParamName
    }),
        createRedirectLoc = _locationHelperBuilde.createRedirectLoc;

    var redirectPathSelector = void 0;
    if (typeof redirectPath === 'string') {
      redirectPathSelector = function redirectPathSelector() {
        return redirectPath;
      };
    } else if (typeof redirectPath === 'function') {
      redirectPathSelector = redirectPath;
    } else {
      (0, _invariant2.default)(false, 'redirectPath must be either a string or a function');
    }

    var allowRedirectBackFn = void 0;
    if (typeof allowRedirectBack === 'boolean') {
      allowRedirectBackFn = function allowRedirectBackFn() {
        return allowRedirectBack;
      };
    } else if (typeof allowRedirectBack === 'function') {
      allowRedirectBackFn = allowRedirectBack;
    } else {
      (0, _invariant2.default)(false, 'allowRedirectBack must be either a boolean or a function');
    }

    var redirect = function redirect(replace) {
      return function (props, path) {
        return replace(createRedirectLoc(allowRedirectBackFn(props, path))(props, path));
      };
    };

    var ConnectedFailureComponent = (0, _reactRedux.connect)(function (state, ownProps) {
      return {
        redirect: redirect(getRouterRedirect(ownProps))
      };
    })(FailureComponent);

    return function (DecoratedComponent) {
      return (0, _reactRedux.connect)(function (state, ownProps) {
        return {
          redirectPath: redirectPathSelector(state, ownProps),
          isAuthenticated: authenticatedSelector(state, ownProps),
          isAuthenticating: authenticatingSelector(state, ownProps)
        };
      })((0, _authWrapper2.default)(_extends({}, allArgs, { FailureComponent: ConnectedFailureComponent }))(DecoratedComponent));
    };
  };

  var connectedReduxRedirect = function connectedReduxRedirect(args) {
    var allArgs = _extends({}, connectedDefaults, args);
    var FailureComponent = allArgs.FailureComponent,
        redirectPath = allArgs.redirectPath,
        authenticatedSelector = allArgs.authenticatedSelector,
        authenticatingSelector = allArgs.authenticatingSelector,
        allowRedirectBack = allArgs.allowRedirectBack,
        redirectAction = allArgs.redirectAction,
        redirectQueryParamName = allArgs.redirectQueryParamName;

    var _locationHelperBuilde2 = locationHelperBuilder({
      redirectQueryParamName: redirectQueryParamName
    }),
        createRedirectLoc = _locationHelperBuilde2.createRedirectLoc;

    var redirectPathSelector = void 0;
    if (typeof redirectPath === 'string') {
      redirectPathSelector = function redirectPathSelector() {
        return redirectPath;
      };
    } else if (typeof redirectPath === 'function') {
      redirectPathSelector = redirectPath;
    } else {
      (0, _invariant2.default)(false, 'redirectPath must be either a string or a function');
    }

    var allowRedirectBackFn = void 0;
    if (typeof allowRedirectBack === 'boolean') {
      allowRedirectBackFn = function allowRedirectBackFn() {
        return allowRedirectBack;
      };
    } else if (typeof allowRedirectBack === 'function') {
      allowRedirectBackFn = allowRedirectBack;
    } else {
      (0, _invariant2.default)(false, 'allowRedirectBack must be either a boolean or a function');
    }

    var createRedirect = function createRedirect(dispatch) {
      return {
        redirect: function redirect(props, path) {
          return dispatch(redirectAction(createRedirectLoc(allowRedirectBackFn(props, path))(props, path)));
        }
      };
    };

    var ConnectedFailureComponent = (0, _reactRedux.connect)(null, createRedirect)(FailureComponent);

    return function (DecoratedComponent) {
      return (0, _reactRedux.connect)(function (state, ownProps) {
        return {
          redirectPath: redirectPathSelector(state, ownProps),
          isAuthenticated: authenticatedSelector(state, ownProps),
          isAuthenticating: authenticatingSelector(state, ownProps)
        };
      })((0, _authWrapper2.default)(_extends({}, allArgs, { FailureComponent: ConnectedFailureComponent }))(DecoratedComponent));
    };
  };

  return {
    connectedRouterRedirect: connectedRouterRedirect,
    connectedReduxRedirect: connectedReduxRedirect
  };
};

/***/ }),
/* 962 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var reactIs = __webpack_require__(88);

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;

function getStatics(component) {
  // React v16.11 and below
  if (reactIs.isMemo(component)) {
    return MEMO_STATICS;
  } // React v16.12 and above


  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames(sourceComponent);

    if (getOwnPropertySymbols) {
      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
    }

    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
  }

  return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 963 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = __webpack_require__(0);

var _propTypes = __webpack_require__(7);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Redirect = (_temp = _class = function (_Component) {
  _inherits(Redirect, _Component);

  function Redirect() {
    _classCallCheck(this, Redirect);

    return _possibleConstructorReturn(this, (Redirect.__proto__ || Object.getPrototypeOf(Redirect)).apply(this, arguments));
  }

  _createClass(Redirect, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.props.redirect(this.props, this.props.redirectPath);
    }
  }, {
    key: 'render',
    value: function render() {
      // Redirect should happen before this is rendered
      return null;
    }
  }]);

  return Redirect;
}(_react.Component), _class.propTypes = {
  redirectPath: _propTypes2.default.string.isRequired,
  redirect: _propTypes2.default.func.isRequired
}, _temp);
exports.default = Redirect;

/***/ }),
/* 964 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reactRedux = __webpack_require__(8);

var _authWrapper = __webpack_require__(327);

var _authWrapper2 = _interopRequireDefault(_authWrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var connectedDefaults = {
  authenticatingSelector: function authenticatingSelector() {
    return false;
  }
};

exports.default = function (args) {
  var _connectedDefaults$ar = _extends({}, connectedDefaults, args),
      authenticatedSelector = _connectedDefaults$ar.authenticatedSelector,
      authenticatingSelector = _connectedDefaults$ar.authenticatingSelector;

  return function (DecoratedComponent) {
    return (0, _reactRedux.connect)(function (state, ownProps) {
      return {
        isAuthenticated: authenticatedSelector(state, ownProps),
        isAuthenticating: authenticatingSelector(state, ownProps)
      };
    })((0, _authWrapper2.default)(args)(DecoratedComponent));
  };
};

/***/ }),
/* 965 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var asyncComponent=function asyncComponent(importComponent){return function(_Component){_inherits(_class2,_Component);function _class2(){var _ref;var _temp,_this,_ret;_classCallCheck(this,_class2);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=_class2.__proto__||Object.getPrototypeOf(_class2)).call.apply(_ref,[this].concat(args))),_this),_this.state={component:null},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(_class2,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;importComponent().then(function(cmp){_this2.setState({component:cmp.default});});}},{key:'render',value:function render(){var C=this.state.component;return C?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(C,this.props):null;}}]);return _class2;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);};/* harmony default export */ __webpack_exports__["a"] = (asyncComponent);

/***/ }),
/* 966 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LICENSE_ID; });
var LICENSE_ID=6817451;

/***/ }),
/* 967 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export composerFlagOn */
/* unused harmony export SupportDock */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_utils_viewport__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__breadcrumbs__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__conversationStore__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__deepLink__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__supportApi__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__supportEntry__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__store_actions_Menu__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__store_actions_Cart__ = __webpack_require__(69);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// Decides what support entry the page shows. With the composer flag on, a
// signed-in customer gets the composer when support is switched on for the web
// app and their company; otherwise (switched off or unreachable) the page keeps
// LiveChat. Once a signed-in customer has LiveChat it stays for the rest of that
// sign-in, so an open chat never disappears; the next sign-in or a reload checks
// again (phones, where LiveChat is hidden, retry a few times). Signed out, once
// sign-in has settled, the composer shows in visitor mode (text only) when the
// availability check says visitorEnabled, and LiveChat otherwise, until the next
// sign-in or sign-out. The composer's code loads only when it is shown. A support
// reply email's link (deepLink.js) waits for the composer, and is dropped where
// there will be none; signed out it waits for a sign-in, unless it is the
// visitor's own conversation (SupportComposer). A sign-in clears what a visitor
// left in the browser. Whether the composer is on screen is published
// (supportEntry) for the landing page footer's "Chat with us".
var FLAG_KEY='@LT/SUPPORT_COMPOSER';// checkedUser while signed out: the visitor check.
var VISITOR='@visitor';// Sign-in is restored after the first render; wait this long for it before showing LiveChat.
var AUTH_SETTLE_MS=4000;// Where LiveChat hides itself (phones), a failed check would leave no support at all: check again.
var PHONE_RETRY_MS=[15000,60000,180000];// Same test as LiveChatLoader.isMobileSurface in App.js.
function liveChatHiddenHere(){var userAgent=typeof navigator!=='undefined'&&navigator.userAgent||'';return /Android|iPhone|iPad|iPod/i.test(userAgent)||typeof window!=='undefined'&&!!window.matchMedia&&window.matchMedia('(max-width: 767px)').matches;}/**
 * Build flag REACT_APP_SUPPORT_COMPOSER=true, or per browser: localStorage '@LT/SUPPORT_COMPOSER'
 * = 'on' / 'off'. 'on' is honoured only in non-production builds (those built with REACT_APP_API_HOST);
 * 'off' always works.
 */function composerFlagOn(){var override=null;try{override=window.localStorage.getItem(FLAG_KEY);}catch(e){override=null;}if(override==='off')return false;if(override==='on'&&Object({"NODE_ENV":"production","PUBLIC_URL":"","REACT_APP_SUPPORT_COMPOSER":"true","REACT_APP_SUPPORT_HOURS":"Mon-Fri 07:00-15:00","REACT_APP_ALLERGEN_GATE_RESTAURANTS":"8630"}).REACT_APP_API_HOST)return true;return "true"==='true';}var SupportDock=function(_Component){_inherits(SupportDock,_Component);function SupportDock(){var _ref;var _temp,_this,_ret;_classCallCheck(this,SupportDock);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=SupportDock.__proto__||Object.getPrototypeOf(SupportDock)).call.apply(_ref,[this].concat(args))),_this),_this.state={available:null,checkedUser:null,authTimedOut:false,Composer:null,// A visitor chat was in this browser when a customer signed in: the composer says where it went.
visitorChatLeft:false},_this.flagOn=composerFlagOn(),_this.availabilityCheck=0,_this.markUnavailable=function(){if(_this.props.signedIn)Object(__WEBPACK_IMPORTED_MODULE_5__conversationStore__["m" /* writePendingConversation */])(null);_this.setState({available:false,checkedUser:_this.props.signedIn?_this.props.userId:VISITOR});},_this.visitorChatNoteSeen=function(){return _this.setState({visitorChatLeft:false});},_this.closeMenusOnSmallScreens=function(){if(!Object(__WEBPACK_IMPORTED_MODULE_3_utils_viewport__["a" /* isNarrowMenuViewport */])())return;if((_this.props.menuOpen||_this.props.restaurantsOpen)&&_this.props.onCloseMenus){_this.props.onCloseMenus();}// The Categories sheet is page state (DefaultMenu, DynamicMenu): it listens for this.
Object(__WEBPACK_IMPORTED_MODULE_8__supportEntry__["d" /* notifySupportPanelOpen */])();},_this.onSupportRequested=function(){if(!Object(__WEBPACK_IMPORTED_MODULE_3_utils_viewport__["a" /* isNarrowMenuViewport */])())return;if(_this.props.basketOpen&&_this.props.onCloseBasket)_this.props.onCloseBasket();_this.closeMenusOnSmallScreens();},_temp),_possibleConstructorReturn(_this,_ret);}// available: what the last check said, for the user in checkedUser (null while checking).
_createClass(SupportDock,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;window.addEventListener(__WEBPACK_IMPORTED_MODULE_8__supportEntry__["a" /* OPEN_EVENT */],this.onSupportRequested);if(this.flagOn){Object(__WEBPACK_IMPORTED_MODULE_4__breadcrumbs__["d" /* installBreadcrumbListeners */])();Object(__WEBPACK_IMPORTED_MODULE_4__breadcrumbs__["a" /* addBreadcrumb */])('screen',Object(__WEBPACK_IMPORTED_MODULE_4__breadcrumbs__["e" /* sanitizePath */])(this.props.location.pathname));if(this.props.signedIn)Object(__WEBPACK_IMPORTED_MODULE_5__conversationStore__["c" /* noteSignedInUser */])(this.props.userId);}else{// No composer at all: a link has nowhere to open.
Object(__WEBPACK_IMPORTED_MODULE_5__conversationStore__["m" /* writePendingConversation */])(null);}// A customer is signed in here: a visitor's chat and details (perhaps someone else's, on a shared
// browser) go, whether or not the composer is on.
if(this.props.signedIn)this.forgetVisitorForSignIn();this.authTimer=window.setTimeout(function(){return _this2.setState({authTimedOut:true});},AUTH_SETTLE_MS);this.checkAvailability();Object(__WEBPACK_IMPORTED_MODULE_8__supportEntry__["f" /* setComposerShown */])(this.composerShown);}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps,prevState){// After the composer has mounted (children first), so it is listening for "Chat with us".
Object(__WEBPACK_IMPORTED_MODULE_8__supportEntry__["f" /* setComposerShown */])(this.composerShown);if(this.flagOn&&prevProps.location.pathname!==this.props.location.pathname){Object(__WEBPACK_IMPORTED_MODULE_4__breadcrumbs__["a" /* addBreadcrumb */])('screen',Object(__WEBPACK_IMPORTED_MODULE_4__breadcrumbs__["e" /* sanitizePath */])(this.props.location.pathname));}// index.js reads the link as the page loads; one can still arrive later, in an address a
// sign-in redirect carried it in (/?redirect=/Menu?support=...), or where an email sign-in
// link goes after signing in (magicLink.js: the link was waiting in another tab).
if(prevProps.location.search!==this.props.location.search){this.takeSupportLink();}// Breadcrumbs from one account's session don't go with the next one's messages: sign-out, or a
// switch without one (a magic link for another account opened in this tab). Stored conversations
// and drafts are per user and survive a sign-out; noteSignedInUser clears them for another user.
if(prevProps.signedIn&&!this.props.signedIn||prevProps.userId&&this.props.userId&&prevProps.userId!==this.props.userId){Object(__WEBPACK_IMPORTED_MODULE_4__breadcrumbs__["b" /* clearBreadcrumbs */])();}if(prevProps.signedIn!==this.props.signedIn||prevProps.userId!==this.props.userId){if(this.flagOn&&this.props.signedIn)Object(__WEBPACK_IMPORTED_MODULE_5__conversationStore__["c" /* noteSignedInUser */])(this.props.userId);if(this.props.signedIn)this.forgetVisitorForSignIn();this.checkAvailability();}else if(!this.props.signedIn&&this.authSettled()&&!(prevProps.authSettled||prevState.authTimedOut)){// Signed out, and sign-in has just settled: the visitor check can run.
this.checkAvailability();}}},{key:'authSettled',value:function authSettled(){return!!this.props.authSettled||this.state.authTimedOut;}},{key:'componentWillUnmount',value:function componentWillUnmount(){window.removeEventListener(__WEBPACK_IMPORTED_MODULE_8__supportEntry__["a" /* OPEN_EVENT */],this.onSupportRequested);this.unmounted=true;Object(__WEBPACK_IMPORTED_MODULE_8__supportEntry__["f" /* setComposerShown */])(false);window.clearTimeout(this.authTimer);window.clearTimeout(this.retryTimer);}// Through the router, not history.replaceState as at load: its own copy of the address loses the
// parameter too, so a later redirect (a sign-out on this page) can't carry it back.
},{key:'takeSupportLink',value:function takeSupportLink(){var _props=this.props,location=_props.location,history=_props.history;var conversationId=Object(__WEBPACK_IMPORTED_MODULE_6__deepLink__["b" /* supportLinkFrom */])(location.search);if(!conversationId)return;// No composer at all: a link has nowhere to open.
Object(__WEBPACK_IMPORTED_MODULE_5__conversationStore__["m" /* writePendingConversation */])(this.flagOn?conversationId:null);history.replace(Object.assign({},location,{search:Object(__WEBPACK_IMPORTED_MODULE_6__deepLink__["d" /* withoutSupportLink */])(location.search)}));}// Once per sign-in: a failed check means LiveChat for the rest of it, except on phones, where
// LiveChat is hidden and the check is retried a few times. Each check (and each sign-in change)
// bumps the generation, so a late answer for an earlier user is ignored.
},{key:'checkAvailability',value:function checkAvailability(){var _this3=this;var attempt=arguments.length>0&&arguments[0]!==undefined?arguments[0]:0;window.clearTimeout(this.retryTimer);var check=++this.availabilityCheck;if(this.state.checkedUser!==null){this.setState({available:null,checkedUser:null});}if(!this.flagOn)return;if(!this.props.signedIn){this.checkVisitor(check);return;}var userId=this.props.userId;var settle=function settle(available,retrying){if(_this3.unmounted||check!==_this3.availabilityCheck)return;_this3.setState({available:available,checkedUser:userId});if(available)_this3.loadComposer();// No composer for this sign-in: a link has nowhere to open.
else if(!retrying)Object(__WEBPACK_IMPORTED_MODULE_5__conversationStore__["m" /* writePendingConversation */])(null);};Object(__WEBPACK_IMPORTED_MODULE_7__supportApi__["c" /* getAvailability */])().then(function(status){return settle(!!(status&&status.enabled));},function(){var delay=PHONE_RETRY_MS[attempt];var retrying=!!delay&&liveChatHiddenHere();settle(false,retrying);if(retrying&&check===_this3.availabilityCheck){_this3.retryTimer=window.setTimeout(function(){if(!_this3.unmounted&&check===_this3.availabilityCheck)_this3.checkAvailability(attempt+1);},delay);}});}// Signed out, once sign-in has settled (until then the page shows nothing, as before): the composer
// in visitor mode when the check says visitorEnabled, otherwise LiveChat, with no retries. A link
// waiting for a sign-in stays.
},{key:'checkVisitor',value:function checkVisitor(check){var _this4=this;if(!this.authSettled())return;var settle=function settle(available){if(_this4.unmounted||check!==_this4.availabilityCheck)return;_this4.setState({available:available,checkedUser:VISITOR});if(available)_this4.loadComposer();};new Promise(function(resolve){return resolve(Object(__WEBPACK_IMPORTED_MODULE_7__supportApi__["c" /* getAvailability */])());}).then(function(status){return settle(!!(status&&status.visitorEnabled));},function(){return settle(false);});}},{key:'loadComposer',value:function loadComposer(){var _this5=this;if(this.state.Composer||this.loadingComposer)return;this.loadingComposer=true;__webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 1001)).then(function(module){if(!_this5.unmounted)_this5.setState({Composer:module.default});},function(){_this5.loadingComposer=false;// LiveChat instead, for the rest of this sign-in. Signed out, a link still waits for one.
if(_this5.props.signedIn)Object(__WEBPACK_IMPORTED_MODULE_5__conversationStore__["m" /* writePendingConversation */])(null);if(!_this5.unmounted)_this5.setState({available:false});});}// Support was switched off after the composer appeared (a 403 on send or dictation): LiveChat for the
// rest of this sign-in, as when the check says off.
},{key:'render',value:function render(){this.composerShown=false;return this.renderEntry();}},{key:'renderEntry',value:function renderEntry(){var _props2=this.props,fallback=_props2.fallback,signedIn=_props2.signedIn,authSettled=_props2.authSettled,userId=_props2.userId,location=_props2.location;var _state=this.state,authTimedOut=_state.authTimedOut,Composer=_state.Composer;if(!this.flagOn)return this.showFallback(fallback);if(!signedIn&&!authSettled&&!authTimedOut)return null;// A result for another user, or for the visitor (or none yet), is still being checked.
var available=this.state.checkedUser===(signedIn?userId:VISITOR)?this.state.available:null;if(available===false)return this.showFallback(fallback);if(!available||!Composer){// While checking, LiveChat that is already on screen stays (an open chat isn't collapsed);
// otherwise nothing, so LiveChat isn't loaded only to be replaced by the composer.
return this.fallbackShown?fallback||null:null;}this.fallbackShown=false;this.composerShown=true;if(!signedIn){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Composer,{key:'visitor',visitor:true,pathname:location.pathname,onUnavailable:this.markUnavailable,onPanelOpen:this.closeMenusOnSmallScreens});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Composer,{key:userId||'user',userId:userId,pathname:location.pathname,onUnavailable:this.markUnavailable,visitorChatLeft:this.state.visitorChatLeft,onVisitorChatNoteSeen:this.visitorChatNoteSeen,onPanelOpen:this.closeMenusOnSmallScreens});}// The visitor chat isn't carried over (the typed email proves nothing), but it isn't lost either: staff
// reply to the email given in it. The note doesn't say whose chat it was.
},{key:'forgetVisitorForSignIn',value:function forgetVisitorForSignIn(){var hadChat=!!Object(__WEBPACK_IMPORTED_MODULE_5__conversationStore__["i" /* readVisitorConversation */])();Object(__WEBPACK_IMPORTED_MODULE_5__conversationStore__["b" /* forgetVisitor */])();if(hadChat)this.setState({visitorChatLeft:true});}// On a phone or tablet the menu and restaurants drawers sit above the composer (z-index 4999+): when the
// conversation opens (the customer opened it, or a reply opened it) they close, so the conversation, the reply box
// and Send are never under a drawer. The basket is left alone: it may hold a checkout.
// "Chat with us" or "Contact support" (a checkout error's reference): the customer asked for support, so on a
// small screen the basket closes too.
},{key:'showFallback',value:function showFallback(fallback){this.fallbackShown=!!fallback;return fallback||null;}}]);return SupportDock;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){var user=state.authenticationReducer&&state.authenticationReducer.userDetails;return{signedIn:!!user,userId:user?user.idUser:null,authSettled:!!user||!(state.signupReducer&&state.signupReducer.needToTryAutomaticLogin),menuOpen:!!(state.menuReducer&&state.menuReducer.showMenuMobile),restaurantsOpen:!!(state.menuReducer&&state.menuReducer.showRestaurantsMobile),basketOpen:!!(state.cartReducer&&state.cartReducer.cart&&state.cartReducer.cart.checkout)};};// toggleMenuMobile(false) closes both the menu and the restaurants drawer (menuReducer).
var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onCloseMenus:function onCloseMenus(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__store_actions_Menu__["x" /* toggleMenuMobile */])(false));},onCloseBasket:function onCloseBasket(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__store_actions_Cart__["C" /* toggleCart */])(false));}};};// No sign-out from support: a 401 from the support API only stops the composer (see SupportComposer).
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["g" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(SupportDock)));

/***/ }),
/* 968 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(969);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(17)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../lunch-team-client-checkout-msg/node_modules/css-loader/index.js!../../../../lunch-team-client-checkout-msg/node_modules/sass-loader/dist/cjs.js!./App.scss", function() {
			var newContent = require("!!../../../../lunch-team-client-checkout-msg/node_modules/css-loader/index.js!../../../../lunch-team-client-checkout-msg/node_modules/sass-loader/dist/cjs.js!./App.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 969 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(14)(undefined);
// imports
exports.i(__webpack_require__(970), "");
exports.push([module.i, "@import url(https://fonts.googleapis.com/css?family=Open+Sans:300,400,600,700);", ""]);

// module
exports.push([module.i, ":root{--lt-color-background: #f7faf8;--lt-color-foreground: #0b2318;--lt-color-surface: #ffffff;--lt-color-primary: #0e7a4b;--lt-color-on-primary: #ffffff;--lt-color-primary-strong: #075c38;--lt-color-primary-soft: #eaf5ee;--lt-color-on-primary-soft: #075c38;--lt-color-muted: #eef4f0;--lt-color-muted-foreground: #4a5f54;--lt-color-border: #dbe5df;--lt-color-input: #769885;--lt-color-focus: #0e7a4b;--lt-color-success: #146c43;--lt-color-on-success: #ffffff;--lt-color-warning: #e8b931;--lt-color-on-warning: #2b2000;--lt-color-danger: #c22525;--lt-color-on-danger: #ffffff;--lt-color-danger-soft: #fdecec;--lt-color-info: #1f67ad;--lt-color-on-info: #ffffff;--lt-radius-control: 6px;--lt-radius-component: 8px;--lt-radius-container: 12px;--lt-radius-overlay: 16px}.animated{-webkit-animation-duration:1s;animation-duration:1s;-webkit-animation-fill-mode:both;animation-fill-mode:both}.animated.infinite{-webkit-animation-iteration-count:infinite;animation-iteration-count:infinite}.animated.hinge{-webkit-animation-duration:2s;animation-duration:2s}.animated.flipOutX,.animated.flipOutY,.animated.bounceIn,.animated.bounceOut{-webkit-animation-duration:.75s;animation-duration:.75s}@-webkit-keyframes bounce{from,20%,53%,80%,to{-webkit-animation-timing-function:cubic-bezier(0.215, 0.61, 0.355, 1);animation-timing-function:cubic-bezier(0.215, 0.61, 0.355, 1);-webkit-transform:translate3d(0, 0, 0);transform:translate3d(0, 0, 0)}40%,43%{-webkit-animation-timing-function:cubic-bezier(0.755, 0.05, 0.855, 0.06);animation-timing-function:cubic-bezier(0.755, 0.05, 0.855, 0.06);-webkit-transform:translate3d(0, -30px, 0);transform:translate3d(0, -30px, 0)}70%{-webkit-animation-timing-function:cubic-bezier(0.755, 0.05, 0.855, 0.06);animation-timing-function:cubic-bezier(0.755, 0.05, 0.855, 0.06);-webkit-transform:translate3d(0, -15px, 0);transform:translate3d(0, -15px, 0)}90%{-webkit-transform:translate3d(0, -4px, 0);transform:translate3d(0, -4px, 0)}}@keyframes bounce{from,20%,53%,80%,to{-webkit-animation-timing-function:cubic-bezier(0.215, 0.61, 0.355, 1);animation-timing-function:cubic-bezier(0.215, 0.61, 0.355, 1);-webkit-transform:translate3d(0, 0, 0);transform:translate3d(0, 0, 0)}40%,43%{-webkit-animation-timing-function:cubic-bezier(0.755, 0.05, 0.855, 0.06);animation-timing-function:cubic-bezier(0.755, 0.05, 0.855, 0.06);-webkit-transform:translate3d(0, -30px, 0);transform:translate3d(0, -30px, 0)}70%{-webkit-animation-timing-function:cubic-bezier(0.755, 0.05, 0.855, 0.06);animation-timing-function:cubic-bezier(0.755, 0.05, 0.855, 0.06);-webkit-transform:translate3d(0, -15px, 0);transform:translate3d(0, -15px, 0)}90%{-webkit-transform:translate3d(0, -4px, 0);transform:translate3d(0, -4px, 0)}}.bounce{-webkit-animation-name:bounce;animation-name:bounce;-webkit-transform-origin:center bottom;transform-origin:center bottom}@-webkit-keyframes flash{from,50%,to{opacity:1}25%,75%{opacity:0}}@keyframes flash{from,50%,to{opacity:1}25%,75%{opacity:0}}.flash{-webkit-animation-name:flash;animation-name:flash}@-webkit-keyframes pulse{from{-webkit-transform:scale3d(1, 1, 1);transform:scale3d(1, 1, 1)}50%{-webkit-transform:scale3d(1.05, 1.05, 1.05);transform:scale3d(1.05, 1.05, 1.05)}to{-webkit-transform:scale3d(1, 1, 1);transform:scale3d(1, 1, 1)}}@keyframes pulse{from{-webkit-transform:scale3d(1, 1, 1);transform:scale3d(1, 1, 1)}50%{-webkit-transform:scale3d(1.05, 1.05, 1.05);transform:scale3d(1.05, 1.05, 1.05)}to{-webkit-transform:scale3d(1, 1, 1);transform:scale3d(1, 1, 1)}}.pulse{-webkit-animation-name:pulse;animation-name:pulse}@-webkit-keyframes rubberBand{from{-webkit-transform:scale3d(1, 1, 1);transform:scale3d(1, 1, 1)}30%{-webkit-transform:scale3d(1.25, 0.75, 1);transform:scale3d(1.25, 0.75, 1)}40%{-webkit-transform:scale3d(0.75, 1.25, 1);transform:scale3d(0.75, 1.25, 1)}50%{-webkit-transform:scale3d(1.15, 0.85, 1);transform:scale3d(1.15, 0.85, 1)}65%{-webkit-transform:scale3d(0.95, 1.05, 1);transform:scale3d(0.95, 1.05, 1)}75%{-webkit-transform:scale3d(1.05, 0.95, 1);transform:scale3d(1.05, 0.95, 1)}to{-webkit-transform:scale3d(1, 1, 1);transform:scale3d(1, 1, 1)}}@keyframes rubberBand{from{-webkit-transform:scale3d(1, 1, 1);transform:scale3d(1, 1, 1)}30%{-webkit-transform:scale3d(1.25, 0.75, 1);transform:scale3d(1.25, 0.75, 1)}40%{-webkit-transform:scale3d(0.75, 1.25, 1);transform:scale3d(0.75, 1.25, 1)}50%{-webkit-transform:scale3d(1.15, 0.85, 1);transform:scale3d(1.15, 0.85, 1)}65%{-webkit-transform:scale3d(0.95, 1.05, 1);transform:scale3d(0.95, 1.05, 1)}75%{-webkit-transform:scale3d(1.05, 0.95, 1);transform:scale3d(1.05, 0.95, 1)}to{-webkit-transform:scale3d(1, 1, 1);transform:scale3d(1, 1, 1)}}.rubberBand{-webkit-animation-name:rubberBand;animation-name:rubberBand}@-webkit-keyframes shake{from,to{-webkit-transform:translate3d(0, 0, 0);transform:translate3d(0, 0, 0)}10%,30%,50%,70%,90%{-webkit-transform:translate3d(-10px, 0, 0);transform:translate3d(-10px, 0, 0)}20%,40%,60%,80%{-webkit-transform:translate3d(10px, 0, 0);transform:translate3d(10px, 0, 0)}}@keyframes shake{from,to{-webkit-transform:translate3d(0, 0, 0);transform:translate3d(0, 0, 0)}10%,30%,50%,70%,90%{-webkit-transform:translate3d(-10px, 0, 0);transform:translate3d(-10px, 0, 0)}20%,40%,60%,80%{-webkit-transform:translate3d(10px, 0, 0);transform:translate3d(10px, 0, 0)}}.shake{-webkit-animation-name:shake;animation-name:shake}@-webkit-keyframes headShake{0%{-webkit-transform:translateX(0);transform:translateX(0)}6.5%{-webkit-transform:translateX(-6px) rotateY(-9deg);transform:translateX(-6px) rotateY(-9deg)}18.5%{-webkit-transform:translateX(5px) rotateY(7deg);transform:translateX(5px) rotateY(7deg)}31.5%{-webkit-transform:translateX(-3px) rotateY(-5deg);transform:translateX(-3px) rotateY(-5deg)}43.5%{-webkit-transform:translateX(2px) rotateY(3deg);transform:translateX(2px) rotateY(3deg)}50%{-webkit-transform:translateX(0);transform:translateX(0)}}@keyframes headShake{0%{-webkit-transform:translateX(0);transform:translateX(0)}6.5%{-webkit-transform:translateX(-6px) rotateY(-9deg);transform:translateX(-6px) rotateY(-9deg)}18.5%{-webkit-transform:translateX(5px) rotateY(7deg);transform:translateX(5px) rotateY(7deg)}31.5%{-webkit-transform:translateX(-3px) rotateY(-5deg);transform:translateX(-3px) rotateY(-5deg)}43.5%{-webkit-transform:translateX(2px) rotateY(3deg);transform:translateX(2px) rotateY(3deg)}50%{-webkit-transform:translateX(0);transform:translateX(0)}}.headShake{-webkit-animation-timing-function:ease-in-out;animation-timing-function:ease-in-out;-webkit-animation-name:headShake;animation-name:headShake}@-webkit-keyframes swing{20%{-webkit-transform:rotate3d(0, 0, 1, 15deg);transform:rotate3d(0, 0, 1, 15deg)}40%{-webkit-transform:rotate3d(0, 0, 1, -10deg);transform:rotate3d(0, 0, 1, -10deg)}60%{-webkit-transform:rotate3d(0, 0, 1, 5deg);transform:rotate3d(0, 0, 1, 5deg)}80%{-webkit-transform:rotate3d(0, 0, 1, -5deg);transform:rotate3d(0, 0, 1, -5deg)}to{-webkit-transform:rotate3d(0, 0, 1, 0deg);transform:rotate3d(0, 0, 1, 0deg)}}@keyframes swing{20%{-webkit-transform:rotate3d(0, 0, 1, 15deg);transform:rotate3d(0, 0, 1, 15deg)}40%{-webkit-transform:rotate3d(0, 0, 1, -10deg);transform:rotate3d(0, 0, 1, -10deg)}60%{-webkit-transform:rotate3d(0, 0, 1, 5deg);transform:rotate3d(0, 0, 1, 5deg)}80%{-webkit-transform:rotate3d(0, 0, 1, -5deg);transform:rotate3d(0, 0, 1, -5deg)}to{-webkit-transform:rotate3d(0, 0, 1, 0deg);transform:rotate3d(0, 0, 1, 0deg)}}.swing{-webkit-transform-origin:top center;transform-origin:top center;-webkit-animation-name:swing;animation-name:swing}@-webkit-keyframes tada{from{-webkit-transform:scale3d(1, 1, 1);transform:scale3d(1, 1, 1)}10%,20%{-webkit-transform:scale3d(0.9, 0.9, 0.9) rotate3d(0, 0, 1, -3deg);transform:scale3d(0.9, 0.9, 0.9) rotate3d(0, 0, 1, -3deg)}30%,50%,70%,90%{-webkit-transform:scale3d(1.1, 1.1, 1.1) rotate3d(0, 0, 1, 3deg);transform:scale3d(1.1, 1.1, 1.1) rotate3d(0, 0, 1, 3deg)}40%,60%,80%{-webkit-transform:scale3d(1.1, 1.1, 1.1) rotate3d(0, 0, 1, -3deg);transform:scale3d(1.1, 1.1, 1.1) rotate3d(0, 0, 1, -3deg)}to{-webkit-transform:scale3d(1, 1, 1);transform:scale3d(1, 1, 1)}}@keyframes tada{from{-webkit-transform:scale3d(1, 1, 1);transform:scale3d(1, 1, 1)}10%,20%{-webkit-transform:scale3d(0.9, 0.9, 0.9) rotate3d(0, 0, 1, -3deg);transform:scale3d(0.9, 0.9, 0.9) rotate3d(0, 0, 1, -3deg)}30%,50%,70%,90%{-webkit-transform:scale3d(1.1, 1.1, 1.1) rotate3d(0, 0, 1, 3deg);transform:scale3d(1.1, 1.1, 1.1) rotate3d(0, 0, 1, 3deg)}40%,60%,80%{-webkit-transform:scale3d(1.1, 1.1, 1.1) rotate3d(0, 0, 1, -3deg);transform:scale3d(1.1, 1.1, 1.1) rotate3d(0, 0, 1, -3deg)}to{-webkit-transform:scale3d(1, 1, 1);transform:scale3d(1, 1, 1)}}.tada{-webkit-animation-name:tada;animation-name:tada}@-webkit-keyframes wobble{from{-webkit-transform:none;transform:none}15%{-webkit-transform:translate3d(-25%, 0, 0) rotate3d(0, 0, 1, -5deg);transform:translate3d(-25%, 0, 0) rotate3d(0, 0, 1, -5deg)}30%{-webkit-transform:translate3d(20%, 0, 0) rotate3d(0, 0, 1, 3deg);transform:translate3d(20%, 0, 0) rotate3d(0, 0, 1, 3deg)}45%{-webkit-transform:translate3d(-15%, 0, 0) rotate3d(0, 0, 1, -3deg);transform:translate3d(-15%, 0, 0) rotate3d(0, 0, 1, -3deg)}60%{-webkit-transform:translate3d(10%, 0, 0) rotate3d(0, 0, 1, 2deg);transform:translate3d(10%, 0, 0) rotate3d(0, 0, 1, 2deg)}75%{-webkit-transform:translate3d(-5%, 0, 0) rotate3d(0, 0, 1, -1deg);transform:translate3d(-5%, 0, 0) rotate3d(0, 0, 1, -1deg)}to{-webkit-transform:none;transform:none}}@keyframes wobble{from{-webkit-transform:none;transform:none}15%{-webkit-transform:translate3d(-25%, 0, 0) rotate3d(0, 0, 1, -5deg);transform:translate3d(-25%, 0, 0) rotate3d(0, 0, 1, -5deg)}30%{-webkit-transform:translate3d(20%, 0, 0) rotate3d(0, 0, 1, 3deg);transform:translate3d(20%, 0, 0) rotate3d(0, 0, 1, 3deg)}45%{-webkit-transform:translate3d(-15%, 0, 0) rotate3d(0, 0, 1, -3deg);transform:translate3d(-15%, 0, 0) rotate3d(0, 0, 1, -3deg)}60%{-webkit-transform:translate3d(10%, 0, 0) rotate3d(0, 0, 1, 2deg);transform:translate3d(10%, 0, 0) rotate3d(0, 0, 1, 2deg)}75%{-webkit-transform:translate3d(-5%, 0, 0) rotate3d(0, 0, 1, -1deg);transform:translate3d(-5%, 0, 0) rotate3d(0, 0, 1, -1deg)}to{-webkit-transform:none;transform:none}}.wobble{-webkit-animation-name:wobble;animation-name:wobble}@-webkit-keyframes jello{from,11.1%,to{-webkit-transform:none;transform:none}22.2%{-webkit-transform:skewX(-12.5deg) skewY(-12.5deg);transform:skewX(-12.5deg) skewY(-12.5deg)}33.3%{-webkit-transform:skewX(6.25deg) skewY(6.25deg);transform:skewX(6.25deg) skewY(6.25deg)}44.4%{-webkit-transform:skewX(-3.125deg) skewY(-3.125deg);transform:skewX(-3.125deg) skewY(-3.125deg)}55.5%{-webkit-transform:skewX(1.5625deg) skewY(1.5625deg);transform:skewX(1.5625deg) skewY(1.5625deg)}66.6%{-webkit-transform:skewX(-0.78125deg) skewY(-0.78125deg);transform:skewX(-0.78125deg) skewY(-0.78125deg)}77.7%{-webkit-transform:skewX(0.390625deg) skewY(0.390625deg);transform:skewX(0.390625deg) skewY(0.390625deg)}88.8%{-webkit-transform:skewX(-0.1953125deg) skewY(-0.1953125deg);transform:skewX(-0.1953125deg) skewY(-0.1953125deg)}}@keyframes jello{from,11.1%,to{-webkit-transform:none;transform:none}22.2%{-webkit-transform:skewX(-12.5deg) skewY(-12.5deg);transform:skewX(-12.5deg) skewY(-12.5deg)}33.3%{-webkit-transform:skewX(6.25deg) skewY(6.25deg);transform:skewX(6.25deg) skewY(6.25deg)}44.4%{-webkit-transform:skewX(-3.125deg) skewY(-3.125deg);transform:skewX(-3.125deg) skewY(-3.125deg)}55.5%{-webkit-transform:skewX(1.5625deg) skewY(1.5625deg);transform:skewX(1.5625deg) skewY(1.5625deg)}66.6%{-webkit-transform:skewX(-0.78125deg) skewY(-0.78125deg);transform:skewX(-0.78125deg) skewY(-0.78125deg)}77.7%{-webkit-transform:skewX(0.390625deg) skewY(0.390625deg);transform:skewX(0.390625deg) skewY(0.390625deg)}88.8%{-webkit-transform:skewX(-0.1953125deg) skewY(-0.1953125deg);transform:skewX(-0.1953125deg) skewY(-0.1953125deg)}}.jello{-webkit-animation-name:jello;animation-name:jello;-webkit-transform-origin:center;transform-origin:center}@-webkit-keyframes bounceIn{from,20%,40%,60%,80%,to{-webkit-animation-timing-function:cubic-bezier(0.215, 0.61, 0.355, 1);animation-timing-function:cubic-bezier(0.215, 0.61, 0.355, 1)}0%{opacity:0;-webkit-transform:scale3d(0.3, 0.3, 0.3);transform:scale3d(0.3, 0.3, 0.3)}20%{-webkit-transform:scale3d(1.1, 1.1, 1.1);transform:scale3d(1.1, 1.1, 1.1)}40%{-webkit-transform:scale3d(0.9, 0.9, 0.9);transform:scale3d(0.9, 0.9, 0.9)}60%{opacity:1;-webkit-transform:scale3d(1.03, 1.03, 1.03);transform:scale3d(1.03, 1.03, 1.03)}80%{-webkit-transform:scale3d(0.97, 0.97, 0.97);transform:scale3d(0.97, 0.97, 0.97)}to{opacity:1;-webkit-transform:scale3d(1, 1, 1);transform:scale3d(1, 1, 1)}}@keyframes bounceIn{from,20%,40%,60%,80%,to{-webkit-animation-timing-function:cubic-bezier(0.215, 0.61, 0.355, 1);animation-timing-function:cubic-bezier(0.215, 0.61, 0.355, 1)}0%{opacity:0;-webkit-transform:scale3d(0.3, 0.3, 0.3);transform:scale3d(0.3, 0.3, 0.3)}20%{-webkit-transform:scale3d(1.1, 1.1, 1.1);transform:scale3d(1.1, 1.1, 1.1)}40%{-webkit-transform:scale3d(0.9, 0.9, 0.9);transform:scale3d(0.9, 0.9, 0.9)}60%{opacity:1;-webkit-transform:scale3d(1.03, 1.03, 1.03);transform:scale3d(1.03, 1.03, 1.03)}80%{-webkit-transform:scale3d(0.97, 0.97, 0.97);transform:scale3d(0.97, 0.97, 0.97)}to{opacity:1;-webkit-transform:scale3d(1, 1, 1);transform:scale3d(1, 1, 1)}}.bounceIn{-webkit-animation-name:bounceIn;animation-name:bounceIn}@-webkit-keyframes bounceInDown{from,60%,75%,90%,to{-webkit-animation-timing-function:cubic-bezier(0.215, 0.61, 0.355, 1);animation-timing-function:cubic-bezier(0.215, 0.61, 0.355, 1)}0%{opacity:0;-webkit-transform:translate3d(0, -3000px, 0);transform:translate3d(0, -3000px, 0)}60%{opacity:1;-webkit-transform:translate3d(0, 25px, 0);transform:translate3d(0, 25px, 0)}75%{-webkit-transform:translate3d(0, -10px, 0);transform:translate3d(0, -10px, 0)}90%{-webkit-transform:translate3d(0, 5px, 0);transform:translate3d(0, 5px, 0)}to{-webkit-transform:none;transform:none}}@keyframes bounceInDown{from,60%,75%,90%,to{-webkit-animation-timing-function:cubic-bezier(0.215, 0.61, 0.355, 1);animation-timing-function:cubic-bezier(0.215, 0.61, 0.355, 1)}0%{opacity:0;-webkit-transform:translate3d(0, -3000px, 0);transform:translate3d(0, -3000px, 0)}60%{opacity:1;-webkit-transform:translate3d(0, 25px, 0);transform:translate3d(0, 25px, 0)}75%{-webkit-transform:translate3d(0, -10px, 0);transform:translate3d(0, -10px, 0)}90%{-webkit-transform:translate3d(0, 5px, 0);transform:translate3d(0, 5px, 0)}to{-webkit-transform:none;transform:none}}.bounceInDown{-webkit-animation-name:bounceInDown;animation-name:bounceInDown}@-webkit-keyframes bounceInLeft{from,60%,75%,90%,to{-webkit-animation-timing-function:cubic-bezier(0.215, 0.61, 0.355, 1);animation-timing-function:cubic-bezier(0.215, 0.61, 0.355, 1)}0%{opacity:0;-webkit-transform:translate3d(-3000px, 0, 0);transform:translate3d(-3000px, 0, 0)}60%{opacity:1;-webkit-transform:translate3d(25px, 0, 0);transform:translate3d(25px, 0, 0)}75%{-webkit-transform:translate3d(-10px, 0, 0);transform:translate3d(-10px, 0, 0)}90%{-webkit-transform:translate3d(5px, 0, 0);transform:translate3d(5px, 0, 0)}to{-webkit-transform:none;transform:none}}@keyframes bounceInLeft{from,60%,75%,90%,to{-webkit-animation-timing-function:cubic-bezier(0.215, 0.61, 0.355, 1);animation-timing-function:cubic-bezier(0.215, 0.61, 0.355, 1)}0%{opacity:0;-webkit-transform:translate3d(-3000px, 0, 0);transform:translate3d(-3000px, 0, 0)}60%{opacity:1;-webkit-transform:translate3d(25px, 0, 0);transform:translate3d(25px, 0, 0)}75%{-webkit-transform:translate3d(-10px, 0, 0);transform:translate3d(-10px, 0, 0)}90%{-webkit-transform:translate3d(5px, 0, 0);transform:translate3d(5px, 0, 0)}to{-webkit-transform:none;transform:none}}.bounceInLeft{-webkit-animation-name:bounceInLeft;animation-name:bounceInLeft}@-webkit-keyframes bounceInRight{from,60%,75%,90%,to{-webkit-animation-timing-function:cubic-bezier(0.215, 0.61, 0.355, 1);animation-timing-function:cubic-bezier(0.215, 0.61, 0.355, 1)}from{opacity:0;-webkit-transform:translate3d(3000px, 0, 0);transform:translate3d(3000px, 0, 0)}60%{opacity:1;-webkit-transform:translate3d(-25px, 0, 0);transform:translate3d(-25px, 0, 0)}75%{-webkit-transform:translate3d(10px, 0, 0);transform:translate3d(10px, 0, 0)}90%{-webkit-transform:translate3d(-5px, 0, 0);transform:translate3d(-5px, 0, 0)}to{-webkit-transform:none;transform:none}}@keyframes bounceInRight{from,60%,75%,90%,to{-webkit-animation-timing-function:cubic-bezier(0.215, 0.61, 0.355, 1);animation-timing-function:cubic-bezier(0.215, 0.61, 0.355, 1)}from{opacity:0;-webkit-transform:translate3d(3000px, 0, 0);transform:translate3d(3000px, 0, 0)}60%{opacity:1;-webkit-transform:translate3d(-25px, 0, 0);transform:translate3d(-25px, 0, 0)}75%{-webkit-transform:translate3d(10px, 0, 0);transform:translate3d(10px, 0, 0)}90%{-webkit-transform:translate3d(-5px, 0, 0);transform:translate3d(-5px, 0, 0)}to{-webkit-transform:none;transform:none}}.bounceInRight{-webkit-animation-name:bounceInRight;animation-name:bounceInRight}@-webkit-keyframes bounceInUp{from,60%,75%,90%,to{-webkit-animation-timing-function:cubic-bezier(0.215, 0.61, 0.355, 1);animation-timing-function:cubic-bezier(0.215, 0.61, 0.355, 1)}from{opacity:0;-webkit-transform:translate3d(0, 3000px, 0);transform:translate3d(0, 3000px, 0)}60%{opacity:1;-webkit-transform:translate3d(0, -20px, 0);transform:translate3d(0, -20px, 0)}75%{-webkit-transform:translate3d(0, 10px, 0);transform:translate3d(0, 10px, 0)}90%{-webkit-transform:translate3d(0, -5px, 0);transform:translate3d(0, -5px, 0)}to{-webkit-transform:translate3d(0, 0, 0);transform:translate3d(0, 0, 0)}}@keyframes bounceInUp{from,60%,75%,90%,to{-webkit-animation-timing-function:cubic-bezier(0.215, 0.61, 0.355, 1);animation-timing-function:cubic-bezier(0.215, 0.61, 0.355, 1)}from{opacity:0;-webkit-transform:translate3d(0, 3000px, 0);transform:translate3d(0, 3000px, 0)}60%{opacity:1;-webkit-transform:translate3d(0, -20px, 0);transform:translate3d(0, -20px, 0)}75%{-webkit-transform:translate3d(0, 10px, 0);transform:translate3d(0, 10px, 0)}90%{-webkit-transform:translate3d(0, -5px, 0);transform:translate3d(0, -5px, 0)}to{-webkit-transform:translate3d(0, 0, 0);transform:translate3d(0, 0, 0)}}.bounceInUp{-webkit-animation-name:bounceInUp;animation-name:bounceInUp}@-webkit-keyframes bounceOut{20%{-webkit-transform:scale3d(0.9, 0.9, 0.9);transform:scale3d(0.9, 0.9, 0.9)}50%,55%{opacity:1;-webkit-transform:scale3d(1.1, 1.1, 1.1);transform:scale3d(1.1, 1.1, 1.1)}to{opacity:0;-webkit-transform:scale3d(0.3, 0.3, 0.3);transform:scale3d(0.3, 0.3, 0.3)}}@keyframes bounceOut{20%{-webkit-transform:scale3d(0.9, 0.9, 0.9);transform:scale3d(0.9, 0.9, 0.9)}50%,55%{opacity:1;-webkit-transform:scale3d(1.1, 1.1, 1.1);transform:scale3d(1.1, 1.1, 1.1)}to{opacity:0;-webkit-transform:scale3d(0.3, 0.3, 0.3);transform:scale3d(0.3, 0.3, 0.3)}}.bounceOut{-webkit-animation-name:bounceOut;animation-name:bounceOut}@-webkit-keyframes bounceOutDown{20%{-webkit-transform:translate3d(0, 10px, 0);transform:translate3d(0, 10px, 0)}40%,45%{opacity:1;-webkit-transform:translate3d(0, -20px, 0);transform:translate3d(0, -20px, 0)}to{opacity:0;-webkit-transform:translate3d(0, 2000px, 0);transform:translate3d(0, 2000px, 0)}}@keyframes bounceOutDown{20%{-webkit-transform:translate3d(0, 10px, 0);transform:translate3d(0, 10px, 0)}40%,45%{opacity:1;-webkit-transform:translate3d(0, -20px, 0);transform:translate3d(0, -20px, 0)}to{opacity:0;-webkit-transform:translate3d(0, 2000px, 0);transform:translate3d(0, 2000px, 0)}}.bounceOutDown{-webkit-animation-name:bounceOutDown;animation-name:bounceOutDown}@-webkit-keyframes bounceOutLeft{20%{opacity:1;-webkit-transform:translate3d(20px, 0, 0);transform:translate3d(20px, 0, 0)}to{opacity:0;-webkit-transform:translate3d(-2000px, 0, 0);transform:translate3d(-2000px, 0, 0)}}@keyframes bounceOutLeft{20%{opacity:1;-webkit-transform:translate3d(20px, 0, 0);transform:translate3d(20px, 0, 0)}to{opacity:0;-webkit-transform:translate3d(-2000px, 0, 0);transform:translate3d(-2000px, 0, 0)}}.bounceOutLeft{-webkit-animation-name:bounceOutLeft;animation-name:bounceOutLeft}@-webkit-keyframes bounceOutRight{20%{opacity:1;-webkit-transform:translate3d(-20px, 0, 0);transform:translate3d(-20px, 0, 0)}to{opacity:0;-webkit-transform:translate3d(2000px, 0, 0);transform:translate3d(2000px, 0, 0)}}@keyframes bounceOutRight{20%{opacity:1;-webkit-transform:translate3d(-20px, 0, 0);transform:translate3d(-20px, 0, 0)}to{opacity:0;-webkit-transform:translate3d(2000px, 0, 0);transform:translate3d(2000px, 0, 0)}}.bounceOutRight{-webkit-animation-name:bounceOutRight;animation-name:bounceOutRight}@-webkit-keyframes bounceOutUp{20%{-webkit-transform:translate3d(0, -10px, 0);transform:translate3d(0, -10px, 0)}40%,45%{opacity:1;-webkit-transform:translate3d(0, 20px, 0);transform:translate3d(0, 20px, 0)}to{opacity:0;-webkit-transform:translate3d(0, -2000px, 0);transform:translate3d(0, -2000px, 0)}}@keyframes bounceOutUp{20%{-webkit-transform:translate3d(0, -10px, 0);transform:translate3d(0, -10px, 0)}40%,45%{opacity:1;-webkit-transform:translate3d(0, 20px, 0);transform:translate3d(0, 20px, 0)}to{opacity:0;-webkit-transform:translate3d(0, -2000px, 0);transform:translate3d(0, -2000px, 0)}}.bounceOutUp{-webkit-animation-name:bounceOutUp;animation-name:bounceOutUp}@-webkit-keyframes fadeIn{from{opacity:0}to{opacity:1}}@keyframes fadeIn{from{opacity:0}to{opacity:1}}.fadeIn{-webkit-animation-name:fadeIn;animation-name:fadeIn}@-webkit-keyframes fadeInDown{from{opacity:0;-webkit-transform:translate3d(0, -100%, 0);transform:translate3d(0, -100%, 0)}to{opacity:1;-webkit-transform:none;transform:none}}@keyframes fadeInDown{from{opacity:0;-webkit-transform:translate3d(0, -100%, 0);transform:translate3d(0, -100%, 0)}to{opacity:1;-webkit-transform:none;transform:none}}.fadeInDown{-webkit-animation-name:fadeInDown;animation-name:fadeInDown}@-webkit-keyframes fadeInDownBig{from{opacity:0;-webkit-transform:translate3d(0, -2000px, 0);transform:translate3d(0, -2000px, 0)}to{opacity:1;-webkit-transform:none;transform:none}}@keyframes fadeInDownBig{from{opacity:0;-webkit-transform:translate3d(0, -2000px, 0);transform:translate3d(0, -2000px, 0)}to{opacity:1;-webkit-transform:none;transform:none}}.fadeInDownBig{-webkit-animation-name:fadeInDownBig;animation-name:fadeInDownBig}@-webkit-keyframes fadeInLeft{from{opacity:0;-webkit-transform:translate3d(-100%, 0, 0);transform:translate3d(-100%, 0, 0)}to{opacity:1;-webkit-transform:none;transform:none}}@keyframes fadeInLeft{from{opacity:0;-webkit-transform:translate3d(-100%, 0, 0);transform:translate3d(-100%, 0, 0)}to{opacity:1;-webkit-transform:none;transform:none}}.fadeInLeft{-webkit-animation-name:fadeInLeft;animation-name:fadeInLeft}@-webkit-keyframes fadeInLeftBig{from{opacity:0;-webkit-transform:translate3d(-2000px, 0, 0);transform:translate3d(-2000px, 0, 0)}to{opacity:1;-webkit-transform:none;transform:none}}@keyframes fadeInLeftBig{from{opacity:0;-webkit-transform:translate3d(-2000px, 0, 0);transform:translate3d(-2000px, 0, 0)}to{opacity:1;-webkit-transform:none;transform:none}}.fadeInLeftBig{-webkit-animation-name:fadeInLeftBig;animation-name:fadeInLeftBig}@-webkit-keyframes fadeInRight{from{opacity:0;-webkit-transform:translate3d(100%, 0, 0);transform:translate3d(100%, 0, 0)}to{opacity:1;-webkit-transform:none;transform:none}}@keyframes fadeInRight{from{opacity:0;-webkit-transform:translate3d(100%, 0, 0);transform:translate3d(100%, 0, 0)}to{opacity:1;-webkit-transform:none;transform:none}}.fadeInRight{-webkit-animation-name:fadeInRight;animation-name:fadeInRight}@-webkit-keyframes fadeInRightBig{from{opacity:0;-webkit-transform:translate3d(2000px, 0, 0);transform:translate3d(2000px, 0, 0)}to{opacity:1;-webkit-transform:none;transform:none}}@keyframes fadeInRightBig{from{opacity:0;-webkit-transform:translate3d(2000px, 0, 0);transform:translate3d(2000px, 0, 0)}to{opacity:1;-webkit-transform:none;transform:none}}.fadeInRightBig{-webkit-animation-name:fadeInRightBig;animation-name:fadeInRightBig}@-webkit-keyframes fadeInUp{from{opacity:0;-webkit-transform:translate3d(0, 100%, 0);transform:translate3d(0, 100%, 0)}to{opacity:1;-webkit-transform:none;transform:none}}@keyframes fadeInUp{from{opacity:0;-webkit-transform:translate3d(0, 100%, 0);transform:translate3d(0, 100%, 0)}to{opacity:1;-webkit-transform:none;transform:none}}.fadeInUp{-webkit-animation-name:fadeInUp;animation-name:fadeInUp}@-webkit-keyframes fadeInUpBig{from{opacity:0;-webkit-transform:translate3d(0, 2000px, 0);transform:translate3d(0, 2000px, 0)}to{opacity:1;-webkit-transform:none;transform:none}}@keyframes fadeInUpBig{from{opacity:0;-webkit-transform:translate3d(0, 2000px, 0);transform:translate3d(0, 2000px, 0)}to{opacity:1;-webkit-transform:none;transform:none}}.fadeInUpBig{-webkit-animation-name:fadeInUpBig;animation-name:fadeInUpBig}@-webkit-keyframes fadeOut{from{opacity:1}to{opacity:0}}@keyframes fadeOut{from{opacity:1}to{opacity:0}}.fadeOut{-webkit-animation-name:fadeOut;animation-name:fadeOut}@-webkit-keyframes fadeOutDown{from{opacity:1}to{opacity:0;-webkit-transform:translate3d(0, 100%, 0);transform:translate3d(0, 100%, 0)}}@keyframes fadeOutDown{from{opacity:1}to{opacity:0;-webkit-transform:translate3d(0, 100%, 0);transform:translate3d(0, 100%, 0)}}.fadeOutDown{-webkit-animation-name:fadeOutDown;animation-name:fadeOutDown}@-webkit-keyframes fadeOutDownBig{from{opacity:1}to{opacity:0;-webkit-transform:translate3d(0, 2000px, 0);transform:translate3d(0, 2000px, 0)}}@keyframes fadeOutDownBig{from{opacity:1}to{opacity:0;-webkit-transform:translate3d(0, 2000px, 0);transform:translate3d(0, 2000px, 0)}}.fadeOutDownBig{-webkit-animation-name:fadeOutDownBig;animation-name:fadeOutDownBig}@-webkit-keyframes fadeOutLeft{from{opacity:1}to{opacity:0;-webkit-transform:translate3d(-100%, 0, 0);transform:translate3d(-100%, 0, 0)}}@keyframes fadeOutLeft{from{opacity:1}to{opacity:0;-webkit-transform:translate3d(-100%, 0, 0);transform:translate3d(-100%, 0, 0)}}.fadeOutLeft{-webkit-animation-name:fadeOutLeft;animation-name:fadeOutLeft}@-webkit-keyframes fadeOutLeftBig{from{opacity:1}to{opacity:0;-webkit-transform:translate3d(-2000px, 0, 0);transform:translate3d(-2000px, 0, 0)}}@keyframes fadeOutLeftBig{from{opacity:1}to{opacity:0;-webkit-transform:translate3d(-2000px, 0, 0);transform:translate3d(-2000px, 0, 0)}}.fadeOutLeftBig{-webkit-animation-name:fadeOutLeftBig;animation-name:fadeOutLeftBig}@-webkit-keyframes fadeOutRight{from{opacity:1}to{opacity:0;-webkit-transform:translate3d(100%, 0, 0);transform:translate3d(100%, 0, 0)}}@keyframes fadeOutRight{from{opacity:1}to{opacity:0;-webkit-transform:translate3d(100%, 0, 0);transform:translate3d(100%, 0, 0)}}.fadeOutRight{-webkit-animation-name:fadeOutRight;animation-name:fadeOutRight}@-webkit-keyframes fadeOutRightBig{from{opacity:1}to{opacity:0;-webkit-transform:translate3d(2000px, 0, 0);transform:translate3d(2000px, 0, 0)}}@keyframes fadeOutRightBig{from{opacity:1}to{opacity:0;-webkit-transform:translate3d(2000px, 0, 0);transform:translate3d(2000px, 0, 0)}}.fadeOutRightBig{-webkit-animation-name:fadeOutRightBig;animation-name:fadeOutRightBig}@-webkit-keyframes fadeOutUp{from{opacity:1}to{opacity:0;-webkit-transform:translate3d(0, -100%, 0);transform:translate3d(0, -100%, 0)}}@keyframes fadeOutUp{from{opacity:1}to{opacity:0;-webkit-transform:translate3d(0, -100%, 0);transform:translate3d(0, -100%, 0)}}.fadeOutUp{-webkit-animation-name:fadeOutUp;animation-name:fadeOutUp}@-webkit-keyframes fadeOutUpBig{from{opacity:1}to{opacity:0;-webkit-transform:translate3d(0, -2000px, 0);transform:translate3d(0, -2000px, 0)}}@keyframes fadeOutUpBig{from{opacity:1}to{opacity:0;-webkit-transform:translate3d(0, -2000px, 0);transform:translate3d(0, -2000px, 0)}}.fadeOutUpBig{-webkit-animation-name:fadeOutUpBig;animation-name:fadeOutUpBig}@-webkit-keyframes flip{from{-webkit-transform:perspective(400px) rotate3d(0, 1, 0, -360deg);transform:perspective(400px) rotate3d(0, 1, 0, -360deg);-webkit-animation-timing-function:ease-out;animation-timing-function:ease-out}40%{-webkit-transform:perspective(400px) translate3d(0, 0, 150px) rotate3d(0, 1, 0, -190deg);transform:perspective(400px) translate3d(0, 0, 150px) rotate3d(0, 1, 0, -190deg);-webkit-animation-timing-function:ease-out;animation-timing-function:ease-out}50%{-webkit-transform:perspective(400px) translate3d(0, 0, 150px) rotate3d(0, 1, 0, -170deg);transform:perspective(400px) translate3d(0, 0, 150px) rotate3d(0, 1, 0, -170deg);-webkit-animation-timing-function:ease-in;animation-timing-function:ease-in}80%{-webkit-transform:perspective(400px) scale3d(0.95, 0.95, 0.95);transform:perspective(400px) scale3d(0.95, 0.95, 0.95);-webkit-animation-timing-function:ease-in;animation-timing-function:ease-in}to{-webkit-transform:perspective(400px);transform:perspective(400px);-webkit-animation-timing-function:ease-in;animation-timing-function:ease-in}}@keyframes flip{from{-webkit-transform:perspective(400px) rotate3d(0, 1, 0, -360deg);transform:perspective(400px) rotate3d(0, 1, 0, -360deg);-webkit-animation-timing-function:ease-out;animation-timing-function:ease-out}40%{-webkit-transform:perspective(400px) translate3d(0, 0, 150px) rotate3d(0, 1, 0, -190deg);transform:perspective(400px) translate3d(0, 0, 150px) rotate3d(0, 1, 0, -190deg);-webkit-animation-timing-function:ease-out;animation-timing-function:ease-out}50%{-webkit-transform:perspective(400px) translate3d(0, 0, 150px) rotate3d(0, 1, 0, -170deg);transform:perspective(400px) translate3d(0, 0, 150px) rotate3d(0, 1, 0, -170deg);-webkit-animation-timing-function:ease-in;animation-timing-function:ease-in}80%{-webkit-transform:perspective(400px) scale3d(0.95, 0.95, 0.95);transform:perspective(400px) scale3d(0.95, 0.95, 0.95);-webkit-animation-timing-function:ease-in;animation-timing-function:ease-in}to{-webkit-transform:perspective(400px);transform:perspective(400px);-webkit-animation-timing-function:ease-in;animation-timing-function:ease-in}}.animated.flip{-webkit-backface-visibility:visible;backface-visibility:visible;-webkit-animation-name:flip;animation-name:flip}@-webkit-keyframes flipInX{from{-webkit-transform:perspective(400px) rotate3d(1, 0, 0, 90deg);transform:perspective(400px) rotate3d(1, 0, 0, 90deg);-webkit-animation-timing-function:ease-in;animation-timing-function:ease-in;opacity:0}40%{-webkit-transform:perspective(400px) rotate3d(1, 0, 0, -20deg);transform:perspective(400px) rotate3d(1, 0, 0, -20deg);-webkit-animation-timing-function:ease-in;animation-timing-function:ease-in}60%{-webkit-transform:perspective(400px) rotate3d(1, 0, 0, 10deg);transform:perspective(400px) rotate3d(1, 0, 0, 10deg);opacity:1}80%{-webkit-transform:perspective(400px) rotate3d(1, 0, 0, -5deg);transform:perspective(400px) rotate3d(1, 0, 0, -5deg)}to{-webkit-transform:perspective(400px);transform:perspective(400px)}}@keyframes flipInX{from{-webkit-transform:perspective(400px) rotate3d(1, 0, 0, 90deg);transform:perspective(400px) rotate3d(1, 0, 0, 90deg);-webkit-animation-timing-function:ease-in;animation-timing-function:ease-in;opacity:0}40%{-webkit-transform:perspective(400px) rotate3d(1, 0, 0, -20deg);transform:perspective(400px) rotate3d(1, 0, 0, -20deg);-webkit-animation-timing-function:ease-in;animation-timing-function:ease-in}60%{-webkit-transform:perspective(400px) rotate3d(1, 0, 0, 10deg);transform:perspective(400px) rotate3d(1, 0, 0, 10deg);opacity:1}80%{-webkit-transform:perspective(400px) rotate3d(1, 0, 0, -5deg);transform:perspective(400px) rotate3d(1, 0, 0, -5deg)}to{-webkit-transform:perspective(400px);transform:perspective(400px)}}.flipInX{-webkit-backface-visibility:visible !important;backface-visibility:visible !important;-webkit-animation-name:flipInX;animation-name:flipInX}@-webkit-keyframes flipInY{from{-webkit-transform:perspective(400px) rotate3d(0, 1, 0, 90deg);transform:perspective(400px) rotate3d(0, 1, 0, 90deg);-webkit-animation-timing-function:ease-in;animation-timing-function:ease-in;opacity:0}40%{-webkit-transform:perspective(400px) rotate3d(0, 1, 0, -20deg);transform:perspective(400px) rotate3d(0, 1, 0, -20deg);-webkit-animation-timing-function:ease-in;animation-timing-function:ease-in}60%{-webkit-transform:perspective(400px) rotate3d(0, 1, 0, 10deg);transform:perspective(400px) rotate3d(0, 1, 0, 10deg);opacity:1}80%{-webkit-transform:perspective(400px) rotate3d(0, 1, 0, -5deg);transform:perspective(400px) rotate3d(0, 1, 0, -5deg)}to{-webkit-transform:perspective(400px);transform:perspective(400px)}}@keyframes flipInY{from{-webkit-transform:perspective(400px) rotate3d(0, 1, 0, 90deg);transform:perspective(400px) rotate3d(0, 1, 0, 90deg);-webkit-animation-timing-function:ease-in;animation-timing-function:ease-in;opacity:0}40%{-webkit-transform:perspective(400px) rotate3d(0, 1, 0, -20deg);transform:perspective(400px) rotate3d(0, 1, 0, -20deg);-webkit-animation-timing-function:ease-in;animation-timing-function:ease-in}60%{-webkit-transform:perspective(400px) rotate3d(0, 1, 0, 10deg);transform:perspective(400px) rotate3d(0, 1, 0, 10deg);opacity:1}80%{-webkit-transform:perspective(400px) rotate3d(0, 1, 0, -5deg);transform:perspective(400px) rotate3d(0, 1, 0, -5deg)}to{-webkit-transform:perspective(400px);transform:perspective(400px)}}.flipInY{-webkit-backface-visibility:visible !important;backface-visibility:visible !important;-webkit-animation-name:flipInY;animation-name:flipInY}@-webkit-keyframes flipOutX{from{-webkit-transform:perspective(400px);transform:perspective(400px)}30%{-webkit-transform:perspective(400px) rotate3d(1, 0, 0, -20deg);transform:perspective(400px) rotate3d(1, 0, 0, -20deg);opacity:1}to{-webkit-transform:perspective(400px) rotate3d(1, 0, 0, 90deg);transform:perspective(400px) rotate3d(1, 0, 0, 90deg);opacity:0}}@keyframes flipOutX{from{-webkit-transform:perspective(400px);transform:perspective(400px)}30%{-webkit-transform:perspective(400px) rotate3d(1, 0, 0, -20deg);transform:perspective(400px) rotate3d(1, 0, 0, -20deg);opacity:1}to{-webkit-transform:perspective(400px) rotate3d(1, 0, 0, 90deg);transform:perspective(400px) rotate3d(1, 0, 0, 90deg);opacity:0}}.flipOutX{-webkit-animation-name:flipOutX;animation-name:flipOutX;-webkit-backface-visibility:visible !important;backface-visibility:visible !important}@-webkit-keyframes flipOutY{from{-webkit-transform:perspective(400px);transform:perspective(400px)}30%{-webkit-transform:perspective(400px) rotate3d(0, 1, 0, -15deg);transform:perspective(400px) rotate3d(0, 1, 0, -15deg);opacity:1}to{-webkit-transform:perspective(400px) rotate3d(0, 1, 0, 90deg);transform:perspective(400px) rotate3d(0, 1, 0, 90deg);opacity:0}}@keyframes flipOutY{from{-webkit-transform:perspective(400px);transform:perspective(400px)}30%{-webkit-transform:perspective(400px) rotate3d(0, 1, 0, -15deg);transform:perspective(400px) rotate3d(0, 1, 0, -15deg);opacity:1}to{-webkit-transform:perspective(400px) rotate3d(0, 1, 0, 90deg);transform:perspective(400px) rotate3d(0, 1, 0, 90deg);opacity:0}}.flipOutY{-webkit-backface-visibility:visible !important;backface-visibility:visible !important;-webkit-animation-name:flipOutY;animation-name:flipOutY}@-webkit-keyframes lightSpeedIn{from{-webkit-transform:translate3d(100%, 0, 0) skewX(-30deg);transform:translate3d(100%, 0, 0) skewX(-30deg);opacity:0}60%{-webkit-transform:skewX(20deg);transform:skewX(20deg);opacity:1}80%{-webkit-transform:skewX(-5deg);transform:skewX(-5deg);opacity:1}to{-webkit-transform:none;transform:none;opacity:1}}@keyframes lightSpeedIn{from{-webkit-transform:translate3d(100%, 0, 0) skewX(-30deg);transform:translate3d(100%, 0, 0) skewX(-30deg);opacity:0}60%{-webkit-transform:skewX(20deg);transform:skewX(20deg);opacity:1}80%{-webkit-transform:skewX(-5deg);transform:skewX(-5deg);opacity:1}to{-webkit-transform:none;transform:none;opacity:1}}.lightSpeedIn{-webkit-animation-name:lightSpeedIn;animation-name:lightSpeedIn;-webkit-animation-timing-function:ease-out;animation-timing-function:ease-out}@-webkit-keyframes lightSpeedOut{from{opacity:1}to{-webkit-transform:translate3d(100%, 0, 0) skewX(30deg);transform:translate3d(100%, 0, 0) skewX(30deg);opacity:0}}@keyframes lightSpeedOut{from{opacity:1}to{-webkit-transform:translate3d(100%, 0, 0) skewX(30deg);transform:translate3d(100%, 0, 0) skewX(30deg);opacity:0}}.lightSpeedOut{-webkit-animation-name:lightSpeedOut;animation-name:lightSpeedOut;-webkit-animation-timing-function:ease-in;animation-timing-function:ease-in}@-webkit-keyframes rotateIn{from{-webkit-transform-origin:center;transform-origin:center;-webkit-transform:rotate3d(0, 0, 1, -200deg);transform:rotate3d(0, 0, 1, -200deg);opacity:0}to{-webkit-transform-origin:center;transform-origin:center;-webkit-transform:none;transform:none;opacity:1}}@keyframes rotateIn{from{-webkit-transform-origin:center;transform-origin:center;-webkit-transform:rotate3d(0, 0, 1, -200deg);transform:rotate3d(0, 0, 1, -200deg);opacity:0}to{-webkit-transform-origin:center;transform-origin:center;-webkit-transform:none;transform:none;opacity:1}}.rotateIn{-webkit-animation-name:rotateIn;animation-name:rotateIn}@-webkit-keyframes rotateInDownLeft{from{-webkit-transform-origin:left bottom;transform-origin:left bottom;-webkit-transform:rotate3d(0, 0, 1, -45deg);transform:rotate3d(0, 0, 1, -45deg);opacity:0}to{-webkit-transform-origin:left bottom;transform-origin:left bottom;-webkit-transform:none;transform:none;opacity:1}}@keyframes rotateInDownLeft{from{-webkit-transform-origin:left bottom;transform-origin:left bottom;-webkit-transform:rotate3d(0, 0, 1, -45deg);transform:rotate3d(0, 0, 1, -45deg);opacity:0}to{-webkit-transform-origin:left bottom;transform-origin:left bottom;-webkit-transform:none;transform:none;opacity:1}}.rotateInDownLeft{-webkit-animation-name:rotateInDownLeft;animation-name:rotateInDownLeft}@-webkit-keyframes rotateInDownRight{from{-webkit-transform-origin:right bottom;transform-origin:right bottom;-webkit-transform:rotate3d(0, 0, 1, 45deg);transform:rotate3d(0, 0, 1, 45deg);opacity:0}to{-webkit-transform-origin:right bottom;transform-origin:right bottom;-webkit-transform:none;transform:none;opacity:1}}@keyframes rotateInDownRight{from{-webkit-transform-origin:right bottom;transform-origin:right bottom;-webkit-transform:rotate3d(0, 0, 1, 45deg);transform:rotate3d(0, 0, 1, 45deg);opacity:0}to{-webkit-transform-origin:right bottom;transform-origin:right bottom;-webkit-transform:none;transform:none;opacity:1}}.rotateInDownRight{-webkit-animation-name:rotateInDownRight;animation-name:rotateInDownRight}@-webkit-keyframes rotateInUpLeft{from{-webkit-transform-origin:left bottom;transform-origin:left bottom;-webkit-transform:rotate3d(0, 0, 1, 45deg);transform:rotate3d(0, 0, 1, 45deg);opacity:0}to{-webkit-transform-origin:left bottom;transform-origin:left bottom;-webkit-transform:none;transform:none;opacity:1}}@keyframes rotateInUpLeft{from{-webkit-transform-origin:left bottom;transform-origin:left bottom;-webkit-transform:rotate3d(0, 0, 1, 45deg);transform:rotate3d(0, 0, 1, 45deg);opacity:0}to{-webkit-transform-origin:left bottom;transform-origin:left bottom;-webkit-transform:none;transform:none;opacity:1}}.rotateInUpLeft{-webkit-animation-name:rotateInUpLeft;animation-name:rotateInUpLeft}@-webkit-keyframes rotateInUpRight{from{-webkit-transform-origin:right bottom;transform-origin:right bottom;-webkit-transform:rotate3d(0, 0, 1, -90deg);transform:rotate3d(0, 0, 1, -90deg);opacity:0}to{-webkit-transform-origin:right bottom;transform-origin:right bottom;-webkit-transform:none;transform:none;opacity:1}}@keyframes rotateInUpRight{from{-webkit-transform-origin:right bottom;transform-origin:right bottom;-webkit-transform:rotate3d(0, 0, 1, -90deg);transform:rotate3d(0, 0, 1, -90deg);opacity:0}to{-webkit-transform-origin:right bottom;transform-origin:right bottom;-webkit-transform:none;transform:none;opacity:1}}.rotateInUpRight{-webkit-animation-name:rotateInUpRight;animation-name:rotateInUpRight}@-webkit-keyframes rotateOut{from{-webkit-transform-origin:center;transform-origin:center;opacity:1}to{-webkit-transform-origin:center;transform-origin:center;-webkit-transform:rotate3d(0, 0, 1, 200deg);transform:rotate3d(0, 0, 1, 200deg);opacity:0}}@keyframes rotateOut{from{-webkit-transform-origin:center;transform-origin:center;opacity:1}to{-webkit-transform-origin:center;transform-origin:center;-webkit-transform:rotate3d(0, 0, 1, 200deg);transform:rotate3d(0, 0, 1, 200deg);opacity:0}}.rotateOut{-webkit-animation-name:rotateOut;animation-name:rotateOut}@-webkit-keyframes rotateOutDownLeft{from{-webkit-transform-origin:left bottom;transform-origin:left bottom;opacity:1}to{-webkit-transform-origin:left bottom;transform-origin:left bottom;-webkit-transform:rotate3d(0, 0, 1, 45deg);transform:rotate3d(0, 0, 1, 45deg);opacity:0}}@keyframes rotateOutDownLeft{from{-webkit-transform-origin:left bottom;transform-origin:left bottom;opacity:1}to{-webkit-transform-origin:left bottom;transform-origin:left bottom;-webkit-transform:rotate3d(0, 0, 1, 45deg);transform:rotate3d(0, 0, 1, 45deg);opacity:0}}.rotateOutDownLeft{-webkit-animation-name:rotateOutDownLeft;animation-name:rotateOutDownLeft}@-webkit-keyframes rotateOutDownRight{from{-webkit-transform-origin:right bottom;transform-origin:right bottom;opacity:1}to{-webkit-transform-origin:right bottom;transform-origin:right bottom;-webkit-transform:rotate3d(0, 0, 1, -45deg);transform:rotate3d(0, 0, 1, -45deg);opacity:0}}@keyframes rotateOutDownRight{from{-webkit-transform-origin:right bottom;transform-origin:right bottom;opacity:1}to{-webkit-transform-origin:right bottom;transform-origin:right bottom;-webkit-transform:rotate3d(0, 0, 1, -45deg);transform:rotate3d(0, 0, 1, -45deg);opacity:0}}.rotateOutDownRight{-webkit-animation-name:rotateOutDownRight;animation-name:rotateOutDownRight}@-webkit-keyframes rotateOutUpLeft{from{-webkit-transform-origin:left bottom;transform-origin:left bottom;opacity:1}to{-webkit-transform-origin:left bottom;transform-origin:left bottom;-webkit-transform:rotate3d(0, 0, 1, -45deg);transform:rotate3d(0, 0, 1, -45deg);opacity:0}}@keyframes rotateOutUpLeft{from{-webkit-transform-origin:left bottom;transform-origin:left bottom;opacity:1}to{-webkit-transform-origin:left bottom;transform-origin:left bottom;-webkit-transform:rotate3d(0, 0, 1, -45deg);transform:rotate3d(0, 0, 1, -45deg);opacity:0}}.rotateOutUpLeft{-webkit-animation-name:rotateOutUpLeft;animation-name:rotateOutUpLeft}@-webkit-keyframes rotateOutUpRight{from{-webkit-transform-origin:right bottom;transform-origin:right bottom;opacity:1}to{-webkit-transform-origin:right bottom;transform-origin:right bottom;-webkit-transform:rotate3d(0, 0, 1, 90deg);transform:rotate3d(0, 0, 1, 90deg);opacity:0}}@keyframes rotateOutUpRight{from{-webkit-transform-origin:right bottom;transform-origin:right bottom;opacity:1}to{-webkit-transform-origin:right bottom;transform-origin:right bottom;-webkit-transform:rotate3d(0, 0, 1, 90deg);transform:rotate3d(0, 0, 1, 90deg);opacity:0}}.rotateOutUpRight{-webkit-animation-name:rotateOutUpRight;animation-name:rotateOutUpRight}@-webkit-keyframes hinge{0%{-webkit-transform-origin:top left;transform-origin:top left;-webkit-animation-timing-function:ease-in-out;animation-timing-function:ease-in-out}20%,60%{-webkit-transform:rotate3d(0, 0, 1, 80deg);transform:rotate3d(0, 0, 1, 80deg);-webkit-transform-origin:top left;transform-origin:top left;-webkit-animation-timing-function:ease-in-out;animation-timing-function:ease-in-out}40%,80%{-webkit-transform:rotate3d(0, 0, 1, 60deg);transform:rotate3d(0, 0, 1, 60deg);-webkit-transform-origin:top left;transform-origin:top left;-webkit-animation-timing-function:ease-in-out;animation-timing-function:ease-in-out;opacity:1}to{-webkit-transform:translate3d(0, 700px, 0);transform:translate3d(0, 700px, 0);opacity:0}}@keyframes hinge{0%{-webkit-transform-origin:top left;transform-origin:top left;-webkit-animation-timing-function:ease-in-out;animation-timing-function:ease-in-out}20%,60%{-webkit-transform:rotate3d(0, 0, 1, 80deg);transform:rotate3d(0, 0, 1, 80deg);-webkit-transform-origin:top left;transform-origin:top left;-webkit-animation-timing-function:ease-in-out;animation-timing-function:ease-in-out}40%,80%{-webkit-transform:rotate3d(0, 0, 1, 60deg);transform:rotate3d(0, 0, 1, 60deg);-webkit-transform-origin:top left;transform-origin:top left;-webkit-animation-timing-function:ease-in-out;animation-timing-function:ease-in-out;opacity:1}to{-webkit-transform:translate3d(0, 700px, 0);transform:translate3d(0, 700px, 0);opacity:0}}.hinge{-webkit-animation-name:hinge;animation-name:hinge}@-webkit-keyframes rollIn{from{opacity:0;-webkit-transform:translate3d(-100%, 0, 0) rotate3d(0, 0, 1, -120deg);transform:translate3d(-100%, 0, 0) rotate3d(0, 0, 1, -120deg)}to{opacity:1;-webkit-transform:none;transform:none}}@keyframes rollIn{from{opacity:0;-webkit-transform:translate3d(-100%, 0, 0) rotate3d(0, 0, 1, -120deg);transform:translate3d(-100%, 0, 0) rotate3d(0, 0, 1, -120deg)}to{opacity:1;-webkit-transform:none;transform:none}}.rollIn{-webkit-animation-name:rollIn;animation-name:rollIn}@-webkit-keyframes rollOut{from{opacity:1}to{opacity:0;-webkit-transform:translate3d(100%, 0, 0) rotate3d(0, 0, 1, 120deg);transform:translate3d(100%, 0, 0) rotate3d(0, 0, 1, 120deg)}}@keyframes rollOut{from{opacity:1}to{opacity:0;-webkit-transform:translate3d(100%, 0, 0) rotate3d(0, 0, 1, 120deg);transform:translate3d(100%, 0, 0) rotate3d(0, 0, 1, 120deg)}}.rollOut{-webkit-animation-name:rollOut;animation-name:rollOut}@-webkit-keyframes zoomIn{from{opacity:0;-webkit-transform:scale3d(0.3, 0.3, 0.3);transform:scale3d(0.3, 0.3, 0.3)}50%{opacity:1}}@keyframes zoomIn{from{opacity:0;-webkit-transform:scale3d(0.3, 0.3, 0.3);transform:scale3d(0.3, 0.3, 0.3)}50%{opacity:1}}.zoomIn{-webkit-animation-name:zoomIn;animation-name:zoomIn}@-webkit-keyframes zoomInDown{from{opacity:0;-webkit-transform:scale3d(0.1, 0.1, 0.1) translate3d(0, -1000px, 0);transform:scale3d(0.1, 0.1, 0.1) translate3d(0, -1000px, 0);-webkit-animation-timing-function:cubic-bezier(0.55, 0.055, 0.675, 0.19);animation-timing-function:cubic-bezier(0.55, 0.055, 0.675, 0.19)}60%{opacity:1;-webkit-transform:scale3d(0.475, 0.475, 0.475) translate3d(0, 60px, 0);transform:scale3d(0.475, 0.475, 0.475) translate3d(0, 60px, 0);-webkit-animation-timing-function:cubic-bezier(0.175, 0.885, 0.32, 1);animation-timing-function:cubic-bezier(0.175, 0.885, 0.32, 1)}}@keyframes zoomInDown{from{opacity:0;-webkit-transform:scale3d(0.1, 0.1, 0.1) translate3d(0, -1000px, 0);transform:scale3d(0.1, 0.1, 0.1) translate3d(0, -1000px, 0);-webkit-animation-timing-function:cubic-bezier(0.55, 0.055, 0.675, 0.19);animation-timing-function:cubic-bezier(0.55, 0.055, 0.675, 0.19)}60%{opacity:1;-webkit-transform:scale3d(0.475, 0.475, 0.475) translate3d(0, 60px, 0);transform:scale3d(0.475, 0.475, 0.475) translate3d(0, 60px, 0);-webkit-animation-timing-function:cubic-bezier(0.175, 0.885, 0.32, 1);animation-timing-function:cubic-bezier(0.175, 0.885, 0.32, 1)}}.zoomInDown{-webkit-animation-name:zoomInDown;animation-name:zoomInDown}@-webkit-keyframes zoomInLeft{from{opacity:0;-webkit-transform:scale3d(0.1, 0.1, 0.1) translate3d(-1000px, 0, 0);transform:scale3d(0.1, 0.1, 0.1) translate3d(-1000px, 0, 0);-webkit-animation-timing-function:cubic-bezier(0.55, 0.055, 0.675, 0.19);animation-timing-function:cubic-bezier(0.55, 0.055, 0.675, 0.19)}60%{opacity:1;-webkit-transform:scale3d(0.475, 0.475, 0.475) translate3d(10px, 0, 0);transform:scale3d(0.475, 0.475, 0.475) translate3d(10px, 0, 0);-webkit-animation-timing-function:cubic-bezier(0.175, 0.885, 0.32, 1);animation-timing-function:cubic-bezier(0.175, 0.885, 0.32, 1)}}@keyframes zoomInLeft{from{opacity:0;-webkit-transform:scale3d(0.1, 0.1, 0.1) translate3d(-1000px, 0, 0);transform:scale3d(0.1, 0.1, 0.1) translate3d(-1000px, 0, 0);-webkit-animation-timing-function:cubic-bezier(0.55, 0.055, 0.675, 0.19);animation-timing-function:cubic-bezier(0.55, 0.055, 0.675, 0.19)}60%{opacity:1;-webkit-transform:scale3d(0.475, 0.475, 0.475) translate3d(10px, 0, 0);transform:scale3d(0.475, 0.475, 0.475) translate3d(10px, 0, 0);-webkit-animation-timing-function:cubic-bezier(0.175, 0.885, 0.32, 1);animation-timing-function:cubic-bezier(0.175, 0.885, 0.32, 1)}}.zoomInLeft{-webkit-animation-name:zoomInLeft;animation-name:zoomInLeft}@-webkit-keyframes zoomInRight{from{opacity:0;-webkit-transform:scale3d(0.1, 0.1, 0.1) translate3d(1000px, 0, 0);transform:scale3d(0.1, 0.1, 0.1) translate3d(1000px, 0, 0);-webkit-animation-timing-function:cubic-bezier(0.55, 0.055, 0.675, 0.19);animation-timing-function:cubic-bezier(0.55, 0.055, 0.675, 0.19)}60%{opacity:1;-webkit-transform:scale3d(0.475, 0.475, 0.475) translate3d(-10px, 0, 0);transform:scale3d(0.475, 0.475, 0.475) translate3d(-10px, 0, 0);-webkit-animation-timing-function:cubic-bezier(0.175, 0.885, 0.32, 1);animation-timing-function:cubic-bezier(0.175, 0.885, 0.32, 1)}}@keyframes zoomInRight{from{opacity:0;-webkit-transform:scale3d(0.1, 0.1, 0.1) translate3d(1000px, 0, 0);transform:scale3d(0.1, 0.1, 0.1) translate3d(1000px, 0, 0);-webkit-animation-timing-function:cubic-bezier(0.55, 0.055, 0.675, 0.19);animation-timing-function:cubic-bezier(0.55, 0.055, 0.675, 0.19)}60%{opacity:1;-webkit-transform:scale3d(0.475, 0.475, 0.475) translate3d(-10px, 0, 0);transform:scale3d(0.475, 0.475, 0.475) translate3d(-10px, 0, 0);-webkit-animation-timing-function:cubic-bezier(0.175, 0.885, 0.32, 1);animation-timing-function:cubic-bezier(0.175, 0.885, 0.32, 1)}}.zoomInRight{-webkit-animation-name:zoomInRight;animation-name:zoomInRight}@-webkit-keyframes zoomInUp{from{opacity:0;-webkit-transform:scale3d(0.1, 0.1, 0.1) translate3d(0, 1000px, 0);transform:scale3d(0.1, 0.1, 0.1) translate3d(0, 1000px, 0);-webkit-animation-timing-function:cubic-bezier(0.55, 0.055, 0.675, 0.19);animation-timing-function:cubic-bezier(0.55, 0.055, 0.675, 0.19)}60%{opacity:1;-webkit-transform:scale3d(0.475, 0.475, 0.475) translate3d(0, -60px, 0);transform:scale3d(0.475, 0.475, 0.475) translate3d(0, -60px, 0);-webkit-animation-timing-function:cubic-bezier(0.175, 0.885, 0.32, 1);animation-timing-function:cubic-bezier(0.175, 0.885, 0.32, 1)}}@keyframes zoomInUp{from{opacity:0;-webkit-transform:scale3d(0.1, 0.1, 0.1) translate3d(0, 1000px, 0);transform:scale3d(0.1, 0.1, 0.1) translate3d(0, 1000px, 0);-webkit-animation-timing-function:cubic-bezier(0.55, 0.055, 0.675, 0.19);animation-timing-function:cubic-bezier(0.55, 0.055, 0.675, 0.19)}60%{opacity:1;-webkit-transform:scale3d(0.475, 0.475, 0.475) translate3d(0, -60px, 0);transform:scale3d(0.475, 0.475, 0.475) translate3d(0, -60px, 0);-webkit-animation-timing-function:cubic-bezier(0.175, 0.885, 0.32, 1);animation-timing-function:cubic-bezier(0.175, 0.885, 0.32, 1)}}.zoomInUp{-webkit-animation-name:zoomInUp;animation-name:zoomInUp}@-webkit-keyframes zoomOut{from{opacity:1}50%{opacity:0;-webkit-transform:scale3d(0.3, 0.3, 0.3);transform:scale3d(0.3, 0.3, 0.3)}to{opacity:0}}@keyframes zoomOut{from{opacity:1}50%{opacity:0;-webkit-transform:scale3d(0.3, 0.3, 0.3);transform:scale3d(0.3, 0.3, 0.3)}to{opacity:0}}.zoomOut{-webkit-animation-name:zoomOut;animation-name:zoomOut}@-webkit-keyframes zoomOutDown{40%{opacity:1;-webkit-transform:scale3d(0.475, 0.475, 0.475) translate3d(0, -60px, 0);transform:scale3d(0.475, 0.475, 0.475) translate3d(0, -60px, 0);-webkit-animation-timing-function:cubic-bezier(0.55, 0.055, 0.675, 0.19);animation-timing-function:cubic-bezier(0.55, 0.055, 0.675, 0.19)}to{opacity:0;-webkit-transform:scale3d(0.1, 0.1, 0.1) translate3d(0, 2000px, 0);transform:scale3d(0.1, 0.1, 0.1) translate3d(0, 2000px, 0);-webkit-transform-origin:center bottom;transform-origin:center bottom;-webkit-animation-timing-function:cubic-bezier(0.175, 0.885, 0.32, 1);animation-timing-function:cubic-bezier(0.175, 0.885, 0.32, 1)}}@keyframes zoomOutDown{40%{opacity:1;-webkit-transform:scale3d(0.475, 0.475, 0.475) translate3d(0, -60px, 0);transform:scale3d(0.475, 0.475, 0.475) translate3d(0, -60px, 0);-webkit-animation-timing-function:cubic-bezier(0.55, 0.055, 0.675, 0.19);animation-timing-function:cubic-bezier(0.55, 0.055, 0.675, 0.19)}to{opacity:0;-webkit-transform:scale3d(0.1, 0.1, 0.1) translate3d(0, 2000px, 0);transform:scale3d(0.1, 0.1, 0.1) translate3d(0, 2000px, 0);-webkit-transform-origin:center bottom;transform-origin:center bottom;-webkit-animation-timing-function:cubic-bezier(0.175, 0.885, 0.32, 1);animation-timing-function:cubic-bezier(0.175, 0.885, 0.32, 1)}}.zoomOutDown{-webkit-animation-name:zoomOutDown;animation-name:zoomOutDown}@-webkit-keyframes zoomOutLeft{40%{opacity:1;-webkit-transform:scale3d(0.475, 0.475, 0.475) translate3d(42px, 0, 0);transform:scale3d(0.475, 0.475, 0.475) translate3d(42px, 0, 0)}to{opacity:0;-webkit-transform:scale(0.1) translate3d(-2000px, 0, 0);transform:scale(0.1) translate3d(-2000px, 0, 0);-webkit-transform-origin:left center;transform-origin:left center}}@keyframes zoomOutLeft{40%{opacity:1;-webkit-transform:scale3d(0.475, 0.475, 0.475) translate3d(42px, 0, 0);transform:scale3d(0.475, 0.475, 0.475) translate3d(42px, 0, 0)}to{opacity:0;-webkit-transform:scale(0.1) translate3d(-2000px, 0, 0);transform:scale(0.1) translate3d(-2000px, 0, 0);-webkit-transform-origin:left center;transform-origin:left center}}.zoomOutLeft{-webkit-animation-name:zoomOutLeft;animation-name:zoomOutLeft}@-webkit-keyframes zoomOutRight{40%{opacity:1;-webkit-transform:scale3d(0.475, 0.475, 0.475) translate3d(-42px, 0, 0);transform:scale3d(0.475, 0.475, 0.475) translate3d(-42px, 0, 0)}to{opacity:0;-webkit-transform:scale(0.1) translate3d(2000px, 0, 0);transform:scale(0.1) translate3d(2000px, 0, 0);-webkit-transform-origin:right center;transform-origin:right center}}@keyframes zoomOutRight{40%{opacity:1;-webkit-transform:scale3d(0.475, 0.475, 0.475) translate3d(-42px, 0, 0);transform:scale3d(0.475, 0.475, 0.475) translate3d(-42px, 0, 0)}to{opacity:0;-webkit-transform:scale(0.1) translate3d(2000px, 0, 0);transform:scale(0.1) translate3d(2000px, 0, 0);-webkit-transform-origin:right center;transform-origin:right center}}.zoomOutRight{-webkit-animation-name:zoomOutRight;animation-name:zoomOutRight}@-webkit-keyframes zoomOutUp{40%{opacity:1;-webkit-transform:scale3d(0.475, 0.475, 0.475) translate3d(0, 60px, 0);transform:scale3d(0.475, 0.475, 0.475) translate3d(0, 60px, 0);-webkit-animation-timing-function:cubic-bezier(0.55, 0.055, 0.675, 0.19);animation-timing-function:cubic-bezier(0.55, 0.055, 0.675, 0.19)}to{opacity:0;-webkit-transform:scale3d(0.1, 0.1, 0.1) translate3d(0, -2000px, 0);transform:scale3d(0.1, 0.1, 0.1) translate3d(0, -2000px, 0);-webkit-transform-origin:center bottom;transform-origin:center bottom;-webkit-animation-timing-function:cubic-bezier(0.175, 0.885, 0.32, 1);animation-timing-function:cubic-bezier(0.175, 0.885, 0.32, 1)}}@keyframes zoomOutUp{40%{opacity:1;-webkit-transform:scale3d(0.475, 0.475, 0.475) translate3d(0, 60px, 0);transform:scale3d(0.475, 0.475, 0.475) translate3d(0, 60px, 0);-webkit-animation-timing-function:cubic-bezier(0.55, 0.055, 0.675, 0.19);animation-timing-function:cubic-bezier(0.55, 0.055, 0.675, 0.19)}to{opacity:0;-webkit-transform:scale3d(0.1, 0.1, 0.1) translate3d(0, -2000px, 0);transform:scale3d(0.1, 0.1, 0.1) translate3d(0, -2000px, 0);-webkit-transform-origin:center bottom;transform-origin:center bottom;-webkit-animation-timing-function:cubic-bezier(0.175, 0.885, 0.32, 1);animation-timing-function:cubic-bezier(0.175, 0.885, 0.32, 1)}}.zoomOutUp{-webkit-animation-name:zoomOutUp;animation-name:zoomOutUp}@-webkit-keyframes slideInDown{from{-webkit-transform:translate3d(0, -100%, 0);transform:translate3d(0, -100%, 0);visibility:visible}to{-webkit-transform:translate3d(0, 0, 0);transform:translate3d(0, 0, 0)}}@keyframes slideInDown{from{-webkit-transform:translate3d(0, -100%, 0);transform:translate3d(0, -100%, 0);visibility:visible}to{-webkit-transform:translate3d(0, 0, 0);transform:translate3d(0, 0, 0)}}.slideInDown{-webkit-animation-name:slideInDown;animation-name:slideInDown}@-webkit-keyframes slideInLeft{from{-webkit-transform:translate3d(-100%, 0, 0);transform:translate3d(-100%, 0, 0);visibility:visible}to{-webkit-transform:translate3d(0, 0, 0);transform:translate3d(0, 0, 0)}}@keyframes slideInLeft{from{-webkit-transform:translate3d(-100%, 0, 0);transform:translate3d(-100%, 0, 0);visibility:visible}to{-webkit-transform:translate3d(0, 0, 0);transform:translate3d(0, 0, 0)}}.slideInLeft{-webkit-animation-name:slideInLeft;animation-name:slideInLeft}@-webkit-keyframes slideInRight{from{-webkit-transform:translate3d(100%, 0, 0);transform:translate3d(100%, 0, 0);visibility:visible}to{-webkit-transform:translate3d(0, 0, 0);transform:translate3d(0, 0, 0)}}@keyframes slideInRight{from{-webkit-transform:translate3d(100%, 0, 0);transform:translate3d(100%, 0, 0);visibility:visible}to{-webkit-transform:translate3d(0, 0, 0);transform:translate3d(0, 0, 0)}}.slideInRight{-webkit-animation-name:slideInRight;animation-name:slideInRight}@-webkit-keyframes slideInUp{from{-webkit-transform:translate3d(0, 100%, 0);transform:translate3d(0, 100%, 0);visibility:visible}to{-webkit-transform:translate3d(0, 0, 0);transform:translate3d(0, 0, 0)}}@keyframes slideInUp{from{-webkit-transform:translate3d(0, 100%, 0);transform:translate3d(0, 100%, 0);visibility:visible}to{-webkit-transform:translate3d(0, 0, 0);transform:translate3d(0, 0, 0)}}.slideInUp{-webkit-animation-name:slideInUp;animation-name:slideInUp}@-webkit-keyframes slideOutDown{from{-webkit-transform:translate3d(0, 0, 0);transform:translate3d(0, 0, 0)}to{visibility:hidden;-webkit-transform:translate3d(0, 100%, 0);transform:translate3d(0, 100%, 0)}}@keyframes slideOutDown{from{-webkit-transform:translate3d(0, 0, 0);transform:translate3d(0, 0, 0)}to{visibility:hidden;-webkit-transform:translate3d(0, 100%, 0);transform:translate3d(0, 100%, 0)}}.slideOutDown{-webkit-animation-name:slideOutDown;animation-name:slideOutDown}@-webkit-keyframes slideOutLeft{from{-webkit-transform:translate3d(0, 0, 0);transform:translate3d(0, 0, 0)}to{visibility:hidden;-webkit-transform:translate3d(-100%, 0, 0);transform:translate3d(-100%, 0, 0)}}@keyframes slideOutLeft{from{-webkit-transform:translate3d(0, 0, 0);transform:translate3d(0, 0, 0)}to{visibility:hidden;-webkit-transform:translate3d(-100%, 0, 0);transform:translate3d(-100%, 0, 0)}}.slideOutLeft{-webkit-animation-name:slideOutLeft;animation-name:slideOutLeft}@-webkit-keyframes slideOutRight{from{-webkit-transform:translate3d(0, 0, 0);transform:translate3d(0, 0, 0)}to{visibility:hidden;-webkit-transform:translate3d(100%, 0, 0);transform:translate3d(100%, 0, 0)}}@keyframes slideOutRight{from{-webkit-transform:translate3d(0, 0, 0);transform:translate3d(0, 0, 0)}to{visibility:hidden;-webkit-transform:translate3d(100%, 0, 0);transform:translate3d(100%, 0, 0)}}.slideOutRight{-webkit-animation-name:slideOutRight;animation-name:slideOutRight}@-webkit-keyframes slideOutUp{from{-webkit-transform:translate3d(0, 0, 0);transform:translate3d(0, 0, 0)}to{visibility:hidden;-webkit-transform:translate3d(0, -100%, 0);transform:translate3d(0, -100%, 0)}}@keyframes slideOutUp{from{-webkit-transform:translate3d(0, 0, 0);transform:translate3d(0, 0, 0)}to{visibility:hidden;-webkit-transform:translate3d(0, -100%, 0);transform:translate3d(0, -100%, 0)}}.slideOutUp{-webkit-animation-name:slideOutUp;animation-name:slideOutUp}/*! jQuery UI - v1.11.2 - 2014-12-08\n* http://jqueryui.com\n* Includes: core.css, slider.css, theme.css\n* To view and modify this theme, visit http://jqueryui.com/themeroller/?ffDefault=Trebuchet%20MS%2CTahoma%2CVerdana%2CArial%2Csans-serif&fwDefault=bold&fsDefault=1.1em&cornerRadius=4px&bgColorHeader=f6a828&bgTextureHeader=gloss_wave&bgImgOpacityHeader=35&borderColorHeader=e78f08&fcHeader=ffffff&iconColorHeader=ffffff&bgColorContent=eeeeee&bgTextureContent=highlight_soft&bgImgOpacityContent=100&borderColorContent=dddddd&fcContent=333333&iconColorContent=222222&bgColorDefault=f6f6f6&bgTextureDefault=glass&bgImgOpacityDefault=100&borderColorDefault=cccccc&fcDefault=1c94c4&iconColorDefault=ef8c08&bgColorHover=fdf5ce&bgTextureHover=glass&bgImgOpacityHover=100&borderColorHover=fbcb09&fcHover=c77405&iconColorHover=ef8c08&bgColorActive=ffffff&bgTextureActive=glass&bgImgOpacityActive=65&borderColorActive=fbd850&fcActive=eb8f00&iconColorActive=ef8c08&bgColorHighlight=ffe45c&bgTextureHighlight=highlight_soft&bgImgOpacityHighlight=75&borderColorHighlight=fed22f&fcHighlight=363636&iconColorHighlight=228ef1&bgColorError=b81900&bgTextureError=diagonals_thick&bgImgOpacityError=18&borderColorError=cd0a0a&fcError=ffffff&iconColorError=ffd27a&bgColorOverlay=666666&bgTextureOverlay=diagonals_thick&bgImgOpacityOverlay=20&opacityOverlay=50&bgColorShadow=000000&bgTextureShadow=flat&bgImgOpacityShadow=10&opacityShadow=20&thicknessShadow=5px&offsetTopShadow=-5px&offsetLeftShadow=-5px&cornerRadiusShadow=5px\n* Copyright 2014 jQuery Foundation and other contributors; Licensed MIT */.ui-helper-zfix,.ui-widget-overlay{height:100%;width:100%;left:0;top:0}.ui-helper-hidden{display:none}.ui-helper-hidden-accessible{border:0;clip:rect(0 0 0 0);height:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;width:1px}.ui-helper-reset{margin:0;padding:0;border:0;outline:0;line-height:1.3;text-decoration:none;font-size:100%;list-style:none}.ui-helper-clearfix:after,.ui-helper-clearfix:before{content:\"\";display:table;border-collapse:collapse}.ui-helper-clearfix:after{clear:both}.ui-helper-clearfix{min-height:0}.ui-helper-zfix{position:absolute;opacity:0;filter:Alpha(Opacity=0)}.ui-front{z-index:100}.ui-state-disabled{cursor:default !important}.ui-icon{display:block;text-indent:-99999px;overflow:hidden;background-repeat:no-repeat}.ui-widget-overlay{position:fixed}.ui-slider{position:relative;text-align:left}.ui-slider .ui-slider-handle{position:absolute;z-index:2;width:1.2em;height:1.2em;cursor:default;-ms-touch-action:none;touch-action:none}.ui-slider .ui-slider-range{position:absolute;z-index:1;font-size:.7em;display:block;border:0;background-position:0 0}.ui-slider.ui-state-disabled .ui-slider-handle,.ui-slider.ui-state-disabled .ui-slider-range{filter:inherit}.ui-slider-horizontal{height:.8em}.ui-slider-horizontal .ui-slider-handle{top:-0.3em;margin-left:-0.6em}.ui-slider-horizontal .ui-slider-range{top:0;height:100%}.ui-slider-horizontal .ui-slider-range-min{left:0}.ui-slider-horizontal .ui-slider-range-max{right:0}.ui-slider-vertical{width:.8em;height:100px}.ui-slider-vertical .ui-slider-handle{left:-0.3em;margin-left:0;margin-bottom:-0.6em}.ui-slider-vertical .ui-slider-range{left:0;width:100%}.ui-slider-vertical .ui-slider-range-min{bottom:0}.ui-slider-vertical .ui-slider-range-max{top:0}.ui-widget{font-family:Trebuchet MS,Tahoma,Verdana,Arial,sans-serif;font-size:1.1em}.ui-widget .ui-widget{font-size:1em}.ui-widget button,.ui-widget input,.ui-widget select,.ui-widget textarea{font-family:Trebuchet MS,Tahoma,Verdana,Arial,sans-serif;font-size:1em}.ui-widget-content{border:1px solid #ddd;background:#eee;color:#333}.ui-widget-content a{color:#333}.ui-widget-header{border:1px solid #075c38;background:#0e7a4b;color:#fff;font-weight:700}.ui-widget-header a{color:#fff}.ui-state-default,.ui-widget-content .ui-state-default,.ui-widget-header .ui-state-default{border:1px solid #000;background:#fff;font-weight:700;color:#1c94c4;margin-top:-4px;cursor:e-resize}.ui-state-default a,.ui-state-default a:link,.ui-state-default a:visited{color:#1c94c4;text-decoration:none}.ui-state-focus,.ui-state-hover,.ui-widget-content .ui-state-focus,.ui-widget-content .ui-state-hover,.ui-widget-header .ui-state-focus,.ui-widget-header .ui-state-hover{border:1px solid #000;background:#fff;font-weight:700;color:#1c94c4;margin-top:-4px}.ui-state-focus a,.ui-state-focus a:hover,.ui-state-focus a:link,.ui-state-focus a:visited,.ui-state-hover a,.ui-state-hover a:hover,.ui-state-hover a:link,.ui-state-hover a:visited{color:#075c38;text-decoration:none}.ui-state-active,.ui-widget-content .ui-state-active,.ui-widget-header .ui-state-active{border:1px solid #000;background:#fff;font-weight:700;color:#1c94c4;margin-top:-4px}.ui-state-active a,.ui-state-active a:link,.ui-state-active a:visited{color:#0e7a4b;text-decoration:none}.ui-state-highlight,.ui-widget-content .ui-state-highlight,.ui-widget-header .ui-state-highlight{border:1px solid #fed22f;background:#ffe45c;color:#363636}.ui-state-highlight a,.ui-widget-content .ui-state-highlight a,.ui-widget-header .ui-state-highlight a{color:#363636}.ui-state-error,.ui-widget-content .ui-state-error,.ui-widget-header .ui-state-error{border:1px solid #cd0a0a;background:#b81900;color:#fff}.ui-state-error a,.ui-state-error-text,.ui-widget-content .ui-state-error a,.ui-widget-content .ui-state-error-text,.ui-widget-header .ui-state-error a,.ui-widget-header .ui-state-error-text{color:#fff}.ui-priority-primary,.ui-widget-content .ui-priority-primary,.ui-widget-header .ui-priority-primary{font-weight:700}.ui-priority-secondary,.ui-widget-content .ui-priority-secondary,.ui-widget-header .ui-priority-secondary{opacity:.7;filter:Alpha(Opacity=70);font-weight:400}.ui-state-disabled,.ui-widget-content .ui-state-disabled,.ui-widget-header .ui-state-disabled{opacity:.35;filter:Alpha(Opacity=35);background-image:none}.ui-state-disabled .ui-icon{filter:Alpha(Opacity=35)}.ui-icon{width:16px;height:16px}.ui-icon-blank{background-position:16px 16px}.ui-icon-carat-1-n{background-position:0 0}.ui-icon-carat-1-ne{background-position:-16px 0}.ui-icon-carat-1-e{background-position:-32px 0}.ui-icon-carat-1-se{background-position:-48px 0}.ui-icon-carat-1-s{background-position:-64px 0}.ui-icon-carat-1-sw{background-position:-80px 0}.ui-icon-carat-1-w{background-position:-96px 0}.ui-icon-carat-1-nw{background-position:-112px 0}.ui-icon-carat-2-n-s{background-position:-128px 0}.ui-icon-carat-2-e-w{background-position:-144px 0}.ui-icon-triangle-1-n{background-position:0 -16px}.ui-icon-triangle-1-ne{background-position:-16px -16px}.ui-icon-triangle-1-e{background-position:-32px -16px}.ui-icon-triangle-1-se{background-position:-48px -16px}.ui-icon-triangle-1-s{background-position:-64px -16px}.ui-icon-triangle-1-sw{background-position:-80px -16px}.ui-icon-triangle-1-w{background-position:-96px -16px}.ui-icon-triangle-1-nw{background-position:-112px -16px}.ui-icon-triangle-2-n-s{background-position:-128px -16px}.ui-icon-triangle-2-e-w{background-position:-144px -16px}.ui-icon-arrow-1-n{background-position:0 -32px}.ui-icon-arrow-1-ne{background-position:-16px -32px}.ui-icon-arrow-1-e{background-position:-32px -32px}.ui-icon-arrow-1-se{background-position:-48px -32px}.ui-icon-arrow-1-s{background-position:-64px -32px}.ui-icon-arrow-1-sw{background-position:-80px -32px}.ui-icon-arrow-1-w{background-position:-96px -32px}.ui-icon-arrow-1-nw{background-position:-112px -32px}.ui-icon-arrow-2-n-s{background-position:-128px -32px}.ui-icon-arrow-2-ne-sw{background-position:-144px -32px}.ui-icon-arrow-2-e-w{background-position:-160px -32px}.ui-icon-arrow-2-se-nw{background-position:-176px -32px}.ui-icon-arrowstop-1-n{background-position:-192px -32px}.ui-icon-arrowstop-1-e{background-position:-208px -32px}.ui-icon-arrowstop-1-s{background-position:-224px -32px}.ui-icon-arrowstop-1-w{background-position:-240px -32px}.ui-icon-arrowthick-1-n{background-position:0 -48px}.ui-icon-arrowthick-1-ne{background-position:-16px -48px}.ui-icon-arrowthick-1-e{background-position:-32px -48px}.ui-icon-arrowthick-1-se{background-position:-48px -48px}.ui-icon-arrowthick-1-s{background-position:-64px -48px}.ui-icon-arrowthick-1-sw{background-position:-80px -48px}.ui-icon-arrowthick-1-w{background-position:-96px -48px}.ui-icon-arrowthick-1-nw{background-position:-112px -48px}.ui-icon-arrowthick-2-n-s{background-position:-128px -48px}.ui-icon-arrowthick-2-ne-sw{background-position:-144px -48px}.ui-icon-arrowthick-2-e-w{background-position:-160px -48px}.ui-icon-arrowthick-2-se-nw{background-position:-176px -48px}.ui-icon-arrowthickstop-1-n{background-position:-192px -48px}.ui-icon-arrowthickstop-1-e{background-position:-208px -48px}.ui-icon-arrowthickstop-1-s{background-position:-224px -48px}.ui-icon-arrowthickstop-1-w{background-position:-240px -48px}.ui-icon-arrowreturnthick-1-w{background-position:0 -64px}.ui-icon-arrowreturnthick-1-n{background-position:-16px -64px}.ui-icon-arrowreturnthick-1-e{background-position:-32px -64px}.ui-icon-arrowreturnthick-1-s{background-position:-48px -64px}.ui-icon-arrowreturn-1-w{background-position:-64px -64px}.ui-icon-arrowreturn-1-n{background-position:-80px -64px}.ui-icon-arrowreturn-1-e{background-position:-96px -64px}.ui-icon-arrowreturn-1-s{background-position:-112px -64px}.ui-icon-arrowrefresh-1-w{background-position:-128px -64px}.ui-icon-arrowrefresh-1-n{background-position:-144px -64px}.ui-icon-arrowrefresh-1-e{background-position:-160px -64px}.ui-icon-arrowrefresh-1-s{background-position:-176px -64px}.ui-icon-arrow-4{background-position:0 -80px}.ui-icon-arrow-4-diag{background-position:-16px -80px}.ui-icon-extlink{background-position:-32px -80px}.ui-icon-newwin{background-position:-48px -80px}.ui-icon-refresh{background-position:-64px -80px}.ui-icon-shuffle{background-position:-80px -80px}.ui-icon-transfer-e-w{background-position:-96px -80px}.ui-icon-transferthick-e-w{background-position:-112px -80px}.ui-icon-folder-collapsed{background-position:0 -96px}.ui-icon-folder-open{background-position:-16px -96px}.ui-icon-document{background-position:-32px -96px}.ui-icon-document-b{background-position:-48px -96px}.ui-icon-note{background-position:-64px -96px}.ui-icon-mail-closed{background-position:-80px -96px}.ui-icon-mail-open{background-position:-96px -96px}.ui-icon-suitcase{background-position:-112px -96px}.ui-icon-comment{background-position:-128px -96px}.ui-icon-person{background-position:-144px -96px}.ui-icon-print{background-position:-160px -96px}.ui-icon-trash{background-position:-176px -96px}.ui-icon-locked{background-position:-192px -96px}.ui-icon-unlocked{background-position:-208px -96px}.ui-icon-bookmark{background-position:-224px -96px}.ui-icon-tag{background-position:-240px -96px}.ui-icon-home{background-position:0 -112px}.ui-icon-flag{background-position:-16px -112px}.ui-icon-calendar{background-position:-32px -112px}.ui-icon-cart{background-position:-48px -112px}.ui-icon-pencil{background-position:-64px -112px}.ui-icon-clock{background-position:-80px -112px}.ui-icon-disk{background-position:-96px -112px}.ui-icon-calculator{background-position:-112px -112px}.ui-icon-zoomin{background-position:-128px -112px}.ui-icon-zoomout{background-position:-144px -112px}.ui-icon-search{background-position:-160px -112px}.ui-icon-wrench{background-position:-176px -112px}.ui-icon-gear{background-position:-192px -112px}.ui-icon-heart{background-position:-208px -112px}.ui-icon-star{background-position:-224px -112px}.ui-icon-link{background-position:-240px -112px}.ui-icon-cancel{background-position:0 -128px}.ui-icon-plus{background-position:-16px -128px}.ui-icon-plusthick{background-position:-32px -128px}.ui-icon-minus{background-position:-48px -128px}.ui-icon-minusthick{background-position:-64px -128px}.ui-icon-close{background-position:-80px -128px}.ui-icon-closethick{background-position:-96px -128px}.ui-icon-key{background-position:-112px -128px}.ui-icon-lightbulb{background-position:-128px -128px}.ui-icon-scissors{background-position:-144px -128px}.ui-icon-clipboard{background-position:-160px -128px}.ui-icon-copy{background-position:-176px -128px}.ui-icon-contact{background-position:-192px -128px}.ui-icon-image{background-position:-208px -128px}.ui-icon-video{background-position:-224px -128px}.ui-icon-script{background-position:-240px -128px}.ui-icon-alert{background-position:0 -144px}.ui-icon-info{background-position:-16px -144px}.ui-icon-notice{background-position:-32px -144px}.ui-icon-help{background-position:-48px -144px}.ui-icon-check{background-position:-64px -144px}.ui-icon-bullet{background-position:-80px -144px}.ui-icon-radio-on{background-position:-96px -144px}.ui-icon-radio-off{background-position:-112px -144px}.ui-icon-pin-w{background-position:-128px -144px}.ui-icon-pin-s{background-position:-144px -144px}.ui-icon-play{background-position:0 -160px}.ui-icon-pause{background-position:-16px -160px}.ui-icon-seek-next{background-position:-32px -160px}.ui-icon-seek-prev{background-position:-48px -160px}.ui-icon-seek-end{background-position:-64px -160px}.ui-icon-seek-first,.ui-icon-seek-start{background-position:-80px -160px}.ui-icon-stop{background-position:-96px -160px}.ui-icon-eject{background-position:-112px -160px}.ui-icon-volume-off{background-position:-128px -160px}.ui-icon-volume-on{background-position:-144px -160px}.ui-icon-power{background-position:0 -176px}.ui-icon-signal-diag{background-position:-16px -176px}.ui-icon-signal{background-position:-32px -176px}.ui-icon-battery-0{background-position:-48px -176px}.ui-icon-battery-1{background-position:-64px -176px}.ui-icon-battery-2{background-position:-80px -176px}.ui-icon-battery-3{background-position:-96px -176px}.ui-icon-circle-plus{background-position:0 -192px}.ui-icon-circle-minus{background-position:-16px -192px}.ui-icon-circle-close{background-position:-32px -192px}.ui-icon-circle-triangle-e{background-position:-48px -192px}.ui-icon-circle-triangle-s{background-position:-64px -192px}.ui-icon-circle-triangle-w{background-position:-80px -192px}.ui-icon-circle-triangle-n{background-position:-96px -192px}.ui-icon-circle-arrow-e{background-position:-112px -192px}.ui-icon-circle-arrow-s{background-position:-128px -192px}.ui-icon-circle-arrow-w{background-position:-144px -192px}.ui-icon-circle-arrow-n{background-position:-160px -192px}.ui-icon-circle-zoomin{background-position:-176px -192px}.ui-icon-circle-zoomout{background-position:-192px -192px}.ui-icon-circle-check{background-position:-208px -192px}.ui-icon-circlesmall-plus{background-position:0 -208px}.ui-icon-circlesmall-minus{background-position:-16px -208px}.ui-icon-circlesmall-close{background-position:-32px -208px}.ui-icon-squaresmall-plus{background-position:-48px -208px}.ui-icon-squaresmall-minus{background-position:-64px -208px}.ui-icon-squaresmall-close{background-position:-80px -208px}.ui-icon-grip-dotted-vertical{background-position:0 -224px}.ui-icon-grip-dotted-horizontal{background-position:-16px -224px}.ui-icon-grip-solid-vertical{background-position:-32px -224px}.ui-icon-grip-solid-horizontal{background-position:-48px -224px}.ui-icon-gripsmall-diagonal-se{background-position:-64px -224px}.ui-icon-grip-diagonal-se{background-position:-80px -224px}.ui-corner-all,.ui-corner-left,.ui-corner-tl,.ui-corner-top{border-top-left-radius:9px}.ui-corner-all,.ui-corner-right,.ui-corner-top,.ui-corner-tr{border-top-right-radius:9px}.ui-corner-all,.ui-corner-bl,.ui-corner-bottom,.ui-corner-left{border-bottom-left-radius:9px}.ui-corner-all,.ui-corner-bottom,.ui-corner-br,.ui-corner-right{border-bottom-right-radius:9px}.ui-widget-overlay{background:#666;opacity:.5;filter:Alpha(Opacity=50)}.ui-widget-shadow{margin:-5px 0 0 -5px;padding:5px;background:#000;opacity:.2;filter:Alpha(Opacity=20);border-radius:5px}.mfp-bg,.mfp-wrap{left:0;top:0;position:fixed}.mfp-bg,.mfp-container,.mfp-wrap{width:100%;height:100%}.mfp-container,img.mfp-img{-moz-box-sizing:border-box;-webkit-box-sizing:border-box}.mfp-container:before,.mfp-figure:after{content:\"\"}.mfp-fade.mfp-bg,.mfp-fade.mfp-wrap .mfp-content{-webkit-transition:all .15s ease-out;-moz-transition:all .15s ease-out}.mfp-bg{z-index:1042;overflow:hidden;background:#0b0b0b;opacity:.8;filter:alpha(opacity=80)}.mfp-wrap{z-index:1043;outline:0 !important;-webkit-backface-visibility:hidden}.mfp-container{text-align:center;position:absolute;left:0;top:0;padding:0 8px;box-sizing:border-box}.mfp-container:before{display:inline-block;height:100%;vertical-align:middle}.mfp-align-top .mfp-container:before{display:none}.mfp-content{position:relative;display:inline-block;vertical-align:middle;margin:0 auto;text-align:left;z-index:1045}.mfp-ajax-holder .mfp-content,.mfp-inline-holder .mfp-content{width:100%;cursor:auto}.mfp-ajax-cur{cursor:progress}.mfp-zoom-out-cur,.mfp-zoom-out-cur .mfp-image-holder .mfp-close{cursor:-moz-zoom-out;cursor:-webkit-zoom-out;cursor:zoom-out}.mfp-zoom{cursor:pointer;cursor:-webkit-zoom-in;cursor:-moz-zoom-in;cursor:zoom-in}.mfp-auto-cursor .mfp-content{cursor:auto}.mfp-arrow,.mfp-close,.mfp-counter,.mfp-preloader{-webkit-user-select:none;-moz-user-select:none;user-select:none}.mfp-loading.mfp-figure{display:none}.mfp-hide{display:none !important}.mfp-preloader{color:#ccc;position:absolute;top:50%;width:auto;text-align:center;margin-top:-0.8em;left:8px;right:8px;z-index:1044}.mfp-preloader a{color:#ccc}.mfp-close,.mfp-preloader a:hover{color:#fff}.mfp-s-error .mfp-content,.mfp-s-ready .mfp-preloader{display:none}button.mfp-arrow,button.mfp-close{overflow:visible;cursor:pointer;background:0 0;border:0;-webkit-appearance:none;display:block;outline:0;padding:0;z-index:1046;-webkit-box-shadow:none;box-shadow:none}button::-moz-focus-inner{padding:0;border:0}.mfp-close{width:44px;height:44px;line-height:44px;position:absolute;right:0;top:0;text-decoration:none;text-align:center;opacity:.65;filter:alpha(opacity=65);padding:0 0 18px 10px;font-style:normal;font-size:28px;font-family:Arial,Baskerville,monospace}.mfp-close:focus,.mfp-close:hover{opacity:1;filter:alpha(opacity=100)}.mfp-close:active{top:1px}.mfp-close-btn-in .mfp-close{color:#333}.mfp-iframe-holder .mfp-close,.mfp-image-holder .mfp-close{color:#fff;right:-6px;text-align:right;padding-right:6px;width:100%}.mfp-counter{position:absolute;top:0;right:0;color:#ccc;font-size:12px;line-height:18px}.mfp-figure,img.mfp-img{line-height:0}.mfp-arrow{position:absolute;opacity:.65;filter:alpha(opacity=65);margin:-55px 0 0;top:50%;padding:0;width:90px;height:110px;-webkit-tap-highlight-color:transparent}.mfp-arrow:active{margin-top:-54px}.mfp-arrow:focus,.mfp-arrow:hover{opacity:1;filter:alpha(opacity=100)}.mfp-arrow .mfp-a,.mfp-arrow .mfp-b,.mfp-arrow:after,.mfp-arrow:before{content:\"\";display:block;width:0;height:0;position:absolute;left:0;top:0;margin-top:35px;margin-left:35px;border:inset transparent}.mfp-arrow .mfp-a,.mfp-arrow:after{border-top-width:13px;border-bottom-width:13px;top:8px}.mfp-arrow .mfp-b,.mfp-arrow:before{border-top-width:21px;border-bottom-width:21px;opacity:.7}.mfp-arrow-left{left:0}.mfp-arrow-left .mfp-a,.mfp-arrow-left:after{border-right:17px solid #fff;margin-left:31px}.mfp-arrow-left .mfp-b,.mfp-arrow-left:before{margin-left:25px;border-right:27px solid #3f3f3f}.mfp-arrow-right{right:0}.mfp-arrow-right .mfp-a,.mfp-arrow-right:after{border-left:17px solid #fff;margin-left:39px}.mfp-arrow-right .mfp-b,.mfp-arrow-right:before{border-left:27px solid #3f3f3f}.mfp-iframe-holder{padding-top:40px;padding-bottom:40px}.mfp-iframe-holder .mfp-content{line-height:0;width:100%;max-width:900px}.mfp-image-holder .mfp-content,img.mfp-img{max-width:100%}.mfp-iframe-holder .mfp-close{top:-40px}.mfp-iframe-scaler{width:100%;height:0;overflow:hidden;padding-top:56.25%}.mfp-iframe-scaler iframe{position:absolute;display:block;top:0;left:0;width:100%;height:100%;box-shadow:0 0 8px rgba(0, 0, 0, 0.6);background:#000}img.mfp-img{width:auto;height:auto;display:block;box-sizing:border-box;padding:40px 0;margin:0 auto}.mfp-figure:after{position:absolute;left:0;top:40px;bottom:40px;display:block;right:0;width:auto;height:auto;z-index:-1;box-shadow:0 0 8px rgba(0, 0, 0, 0.6);background:#444}.mfp-figure small{color:#bdbdbd;display:block;font-size:12px;line-height:14px}.mfp-figure figure{margin:0}.mfp-bottom-bar{margin-top:-36px;position:absolute;top:100%;left:0;width:100%;cursor:auto}.mfp-title{text-align:left;line-height:18px;color:#f3f3f3;word-wrap:break-word;padding-right:36px}.mfp-gallery .mfp-image-holder .mfp-figure{cursor:pointer}@media screen and (max-width: 800px)and (orientation: landscape),screen and (max-height: 300px){.mfp-img-mobile .mfp-image-holder{padding-left:0;padding-right:0}.mfp-img-mobile img.mfp-img{padding:0}.mfp-img-mobile .mfp-figure:after{top:0;bottom:0}.mfp-img-mobile .mfp-figure small{display:inline;margin-left:5px}.mfp-img-mobile .mfp-bottom-bar{background:rgba(0, 0, 0, 0.6);bottom:0;margin:0;top:auto;padding:3px 5px;position:fixed;-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box}.mfp-img-mobile .mfp-bottom-bar:empty{padding:0}.mfp-img-mobile .mfp-counter{right:5px;top:3px}.mfp-img-mobile .mfp-close{top:0;right:0;width:35px;height:35px;line-height:35px;background:rgba(0, 0, 0, 0.6);position:fixed;text-align:center;padding:0}}@media all and (max-width: 900px){.mfp-arrow{-webkit-transform:scale(0.75);transform:scale(0.75)}.mfp-arrow-left{-webkit-transform-origin:0;transform-origin:0}.mfp-arrow-right{-webkit-transform-origin:100%;transform-origin:100%}.mfp-container{padding-left:6px;padding-right:6px}}.mfp-ie7 .mfp-img{padding:0}.mfp-ie7 .mfp-bottom-bar{width:600px;left:50%;margin-left:-300px;margin-top:5px;padding-bottom:5px}.mfp-ie7 .mfp-container{padding:0}.mfp-ie7 .mfp-content{padding-top:44px}.mfp-ie7 .mfp-close{top:0;right:0;padding-top:0}.mfp-fade.mfp-bg{opacity:0;transition:all .15s ease-out}.mfp-fade.mfp-bg.mfp-ready{opacity:.8}.mfp-fade.mfp-bg.mfp-removing{opacity:0}.mfp-fade.mfp-wrap .mfp-content{opacity:0;transition:all .15s ease-out}.mfp-fade.mfp-wrap.mfp-ready .mfp-content{opacity:1}.mfp-fade.mfp-wrap.mfp-removing .mfp-content{opacity:0}div.checker input,div.radio input,div.selector select,div.uploader input{opacity:0;filter:alpha(opacity=0);-moz-opacity:0;border:none}div.selector select,div.selector span{font-family:\"Geist\",sans-serif}div.button,div.button span,div.checker span,div.radio span,div.selector,div.selector span,div.uploader,div.uploader span.action{background-image:url(" + __webpack_require__(138) + ");background-repeat:no-repeat;-webkit-font-smoothing:antialiased}div.button,div.checker,div.radio,div.selector,div.uploader{display:-moz-inline-box;display:inline-block;zoom:1;vertical-align:middle}div.button:focus,div.checker:focus,div.radio:focus,div.selector:focus,div.uploader:focus{outline:0}div.button,div.button *,div.checker,div.checker *,div.radio,div.radio *,div.selector,div.selector *,div.uploader,div.uploader *{margin:0;padding:0;cursor:pointer}div.checker input,input[type=search],input[type=search]:active{-moz-appearance:none;-webkit-appearance:none}div.selector{line-height:26px;width:100% !important;height:25px;padding:0 0 0 10px;position:relative;overflow:hidden}div.selector span{text-overflow:ellipsis;overflow:hidden;white-space:nowrap;background-position:right 0;height:26px;line-height:26px;padding-right:25px;cursor:pointer;width:98%;display:block;font-size:14px}div.selector.fixedWidth{width:190px}div.selector.fixedWidth span{width:155px}div.selector select{background:0 0;position:absolute;height:25px;top:0px;left:0;width:100%;font-size:13px}div.checker,div.radio,div.uploader{position:relative}div.checker,div.checker input,div.checker span{width:19px;height:19px}div.checker span{display:-moz-inline-box;display:inline-block;zoom:1;text-align:center;background-position:0 -260px}div.checker span.checked{background-position:-76px -260px}div.checker input{background:0 0;display:-moz-inline-box;display:inline-block;zoom:1}div.checker.active span{background-position:-19px -260px}div.checker.active span.checked{background-position:-95px -260px}div.checker.focus span,div.checker.hover span{background-position:-38px -260px}div.checker.focus span.checked,div.checker.hover span.checked{background-position:-114px -260px}div.checker.focus.active span,div.checker.hover.active span{background-position:-57px -260px}div.checker.focus.active span.checked,div.checker.hover.active span.checked{background-position:-133px -260px}div.checker.disabled,div.checker.disabled.active{background-position:-152px -260px}div.checker.disabled span.checked,div.checker.disabled.active span.checked{background-position:-171px -260px}div.radio,div.radio input,div.radio span{width:18px;height:18px}div.radio span{display:-moz-inline-box;display:inline-block;zoom:1;text-align:center;background-position:0 -279px}div.radio span.checked{background-position:-72px -279px}div.radio input{background:0 0;display:-moz-inline-box;display:inline-block;zoom:1;text-align:center}div.radio.active span{background-position:-18px -18px -279px}div.radio.active span.checked{background-position:-90px -279px}div.radio.focus span,div.radio.hover span{background-position:-36px -36px -279px}div.radio.focus span.checked,div.radio.hover span.checked{background-position:-108px -279px}div.radio.focus.active span,div.radio.hover.active span{background-position:-54px -279px}div.radio.focus.active span.checked,div.radio.hover.active span.checked{background-position:-126px -279px}div.radio.disabled span,div.radio.disabled.active span{background-position:-144px -279px}div.radio.disabled span.checked,div.radio.disabled.active span.checked{background-position:-162px -279px}div.uploader{background-position:0 -297px;height:28px;width:190px;cursor:pointer;overflow:hidden}div.uploader span.action{background-position:right -409px;height:28px;line-height:28px;width:85px;text-align:center;float:left;display:inline;overflow:hidden;cursor:pointer}div.uploader span.filename{text-overflow:ellipsis;display:block;overflow:hidden;white-space:nowrap;float:left;cursor:default;height:24px;margin:2px 0 2px 2px;line-height:24px;width:82px;padding:0 10px}div.uploader input{background:0 0;position:absolute;top:0;right:0;float:right;cursor:default;width:100%;height:100%}div.uploader.active span.action{background-position:right -465px}div.uploader.focus,div.uploader.hover{background-position:0 -353px}div.uploader.focus span.action,div.uploader.hover span.action{background-position:right -437px}div.uploader.focus.active span.action,div.uploader.hover.active span.action{background-position:right -493px}div.uploader.disabled,div.uploader.disabled.active{background-position:0 -325px}div.uploader.disabled span.action,div.uploader.disabled.active span.action{background-position:right -381px}div.button{background-position:0 -641px;height:30px;cursor:pointer;position:relative}div.button a,div.button button,div.button input{opacity:.01;filter:alpha(opacity=1);-moz-opacity:.01;display:block;top:0;left:0;right:0;bottom:0;position:absolute}div.button span{display:-moz-inline-box;display:inline-block;zoom:1;line-height:30px;text-align:center;background-position:right -521px;height:30px;margin-left:13px;padding:0}div.button.active{background-position:0 -671px}div.button.active span{background-position:right -551px;cursor:default}div.button.focus,div.button.hover{background-position:0 -701px}div.button.focus span,div.button.hover span{background-position:right -581px}div.button.disabled,div.button.disabled.active{background-position:0 -731px}div.button.disabled span,div.button.disabled.active span{background-position:right -611px;cursor:default}.lb-padrao-singup{width:430px;background-color:#fff;padding:30px;margin:0 auto;display:table;height:auto;position:relative}.lb-fechar{width:38px !important;height:38px !important;position:absolute !important;float:right;top:0;right:7px;color:#3a3a3a !important;font-size:19px;font-weight:600;padding:0}.lb-padrao h2{font-size:24px}.ld-descricao{margin-top:12px;padding-top:12px;border-top:1px solid #000;border-bottom:1px solid #000;padding-bottom:12px;margin-bottom:20px}.ld-descricao .lb-bt-facebook{background-position:0 -206px;width:245px;height:53px;display:block;margin:0 auto;margin-top:15px}.lb-input{width:100%;height:auto;display:table;margin-bottom:8px}.lb-input input{padding-left:15px;padding-right:15px;width:100%;height:38px;background-color:#fff;border-color:#b2b2b2 #e7e7e7 #d6d6d6;border-style:solid;border-width:1px;margin-top:5px}.lb-link{text-align:left;text-decoration:underline !important;display:block;color:#000}.lb-submit:hover{background-color:#075c38;transition:all .3s ease}.ld-password-descricao{padding-bottom:0px;border-bottom:0px}.lb-error{width:530px;height:170px;border:0px;background-color:#fff}.lb-error .ld-descricao{border:0px;width:390px;text-align:center;margin:0 auto}.lb-error .lb-fechar{background-position:-269px -313px;width:17px;height:17px}.lb-padrao img{margin:0 auto;display:block;margin-bottom:128px}@media only screen and (max-width: 500px){.lb-padrao{width:100%}}/*! normalize.css v3.0.1 | MIT License | git.io/normalize */html{font-family:sans-serif;-ms-text-size-adjust:100%;-webkit-text-size-adjust:100%}body{margin:0}article,aside,details,figcaption,figure,footer,header,hgroup,main,nav,section,summary{display:block}audio,canvas,progress,video{display:inline-block;vertical-align:baseline}audio:not([controls]){display:none;height:0}[hidden],template{display:none}a{background:0 0}a:active,a:hover{outline:0}abbr[title]{border-bottom:1px dotted}b,strong{font-weight:700}dfn{font-style:italic}h1{font-size:2em;margin:.67em 0}mark{background:#ff0;color:#000}small{font-size:80%}sub,sup{font-size:75%;line-height:0;position:relative;vertical-align:baseline}sup{top:-0.5em}sub{bottom:-0.25em}img{border:0}svg:not(:root){overflow:hidden}figure{margin:1em 40px}hr{-moz-box-sizing:content-box;box-sizing:content-box;height:0}pre{overflow:auto}code,kbd,pre,samp{font-family:monospace,monospace;font-size:1em}button,input,optgroup,select,textarea{color:inherit;font:inherit;margin:0}button{overflow:visible}button,select{text-transform:none}button,html input[type=button],input[type=reset],input[type=submit]{-webkit-appearance:button;cursor:pointer}button[disabled],html input[disabled]{cursor:default}button::-moz-focus-inner,input::-moz-focus-inner{border:0;padding:0}input{line-height:normal}input[type=checkbox],input[type=radio]{box-sizing:border-box;padding:0}input[type=number]::-webkit-inner-spin-button,input[type=number]::-webkit-outer-spin-button{height:auto}input[type=search]{-webkit-appearance:textfield;-moz-box-sizing:content-box;-webkit-box-sizing:content-box;box-sizing:content-box}input[type=search]::-webkit-search-cancel-button,input[type=search]::-webkit-search-decoration{-webkit-appearance:none}fieldset{border:1px solid var(--lt-color-border);margin:0 2px;padding:.35em .625em .75em}legend{border:0;padding:0}textarea{overflow:auto}optgroup{font-weight:700}table{border-collapse:collapse;border-spacing:0}td,th{padding:0}*{-webkit-tap-highlight-color:rgba(0, 0, 0, 0);-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box}body{background:#fff;position:relative}h1,h2,h3,h4,h5{font-weight:normal;margin:0;line-height:100%}input,textarea,select{outline:none}textarea{resize:none}button{padding:0}button:focus{outline:0}a,a:focus,a:hover{outline:none;text-decoration:none}body,p{font-size:14px}p{color:var(--lt-color-foreground);line-height:160%}ul,ol{list-style:none;margin:0;padding:0}label{cursor:pointer}b{font-weight:700}.clearfix:before{content:\" \";display:table}.clearfix:after{clear:both;content:\"\";display:table}.cb,.clear{clear:both !important}.hidden,.hide{display:none}.invisible{opacity:0;filter:alpha(opacity=0)}.bn{border:0 !important}.b1px{border-width:1px !important}.mn{margin:0 !important}.pn{padding:0 !important}.al{text-align:left !important}.ac,.tac{text-align:center !important}.ar,.tar{text-align:right !important}.al,.tal{text-align:left !important}.fl,.left{float:left}.fr,.right{float:right}.bgn{background:none !important}.relative{position:relative}.absolute{position:absolute}.sprite{background:url(" + __webpack_require__(138) + ") no-repeat;border:none;display:block;overflow:hidden;text-indent:-8000px}.sticky-wrapper{background-color:#fff;position:relative}.sticky-push{height:100px}.font-droid{margin:0;line-height:115%}.font-300{font-weight:300}.font-400{font-weight:400}.font-500{font-weight:500}.font-700{font-weight:700}.fullh{height:100%}.padding-0{padding:0 !important}.block{display:block}.inline{display:inline}.inline-block{display:inline-block}.flex{display:flex}.flex-center{display:flex;align-items:center}.cover{-webkit-background-size:cover !important;-moz-background-size:cover !important;-o-background-size:cover !important;background-size:cover !important}div.selector{height:38px !important;border:1px solid var(--lt-color-input) !important;padding:0 15px !important}div.selector span{background-image:url(" + __webpack_require__(138) + ") no-repeat;background-position:right 0;line-height:38px !important;font-family:\"Montserrat\",sans-serif;font-weight:200;height:38px !important;width:100% !important}div.selector select{height:38px !important}input{width:100%;height:38px;border:1px solid var(--lt-color-input);padding:0 15px;font-weight:200;color:var(--lt-color-foreground);margin-bottom:17px}textarea{width:100%;color:var(--lt-color-foreground);margin-bottom:17px}input.error{border-color:var(--lt-color-danger) !important}label.error{display:none !important}input[type=radio],input[type=checkbox]{display:block;width:17px;margin:0;height:20px;padding:0;position:relative;top:0;left:31px;z-index:1;opacity:0;cursor:pointer;margin-top:-1px;left:5%;bottom:4%}input[type=radio]+label,input[type=checkbox]+label{display:inline-block;cursor:pointer;position:relative;padding-left:18px}input[type=radio].error+label:before,input[type=checkbox].error+label:before{border-color:var(--lt-color-danger)}input[type=radio]+label:before,input[type=checkbox]+label:before{content:\"\";display:inline-block;width:12px;height:12px;border:1px solid white;margin-right:10px;position:absolute;left:0;background-color:none;top:2px;border-radius:50%;font-size:13px}input[type=radio]+label.error:before,input[type=checkbox]+label.error:before{border-color:var(--lt-color-danger)}input[type=radio]+label:after,input[type=checkbox]+label:after{content:\"\";opacity:0;display:block;background:var(--lt-color-primary);position:absolute;top:6px;left:4px;width:6px;height:6px;border-radius:50%;transition:all ease .5s}input[type=radio]:checked+label:after,input[type=checkbox]:checked+label:after{opacity:1}.singup input[type=radio],.singup input[type=checkbox]{display:block;width:17px;margin:0;height:20px;padding:0;position:relative;top:51px;left:3px;z-index:1;opacity:0;cursor:pointer;margin-top:-1px}.singup input[type=radio]+label,input[type=checkbox]+label{display:inline-block;cursor:pointer;position:relative;padding-left:25px}.singup input[type=radio].error+label:before,input[type=checkbox].error+label:before{border-color:var(--lt-color-danger)}.singup input[type=radio]+label:before,input[type=checkbox]+label:before{content:\"\";display:inline-block;width:19px;height:19px;border:1px solid var(--lt-color-input);margin-right:10px;position:absolute;left:0;background-color:none;top:0px;border-radius:24%;font-size:13px}.singup input[type=radio]+label.error:before,input[type=checkbox]+label.error:before{border-color:var(--lt-color-danger)}.singup input[type=radio]+label:after,input[type=checkbox]+label:after{content:\"\";opacity:0;display:block;position:absolute;background:url(" + __webpack_require__(971) + ");position:absolute;background-position:1px;top:5px;left:5px;width:12px;height:12px;border-radius:50%;-webkit-transition:all ease .3s;-o-transition:all ease .3s;transition:all ease .3}.singup input[type=radio]:checked+label:after,input[type=checkbox]:checked+label:after{opacity:1}select.bs-select-hidden,select.selectpicker{display:none !important}.bootstrap-select{width:220px\\9 }.bootstrap-select>.dropdown-toggle{width:100%;padding-right:25px;z-index:1}.bootstrap-select>.dropdown-toggle.bs-placeholder,.bootstrap-select>.dropdown-toggle.bs-placeholder:active,.bootstrap-select>.dropdown-toggle.bs-placeholder:focus,.bootstrap-select>.dropdown-toggle.bs-placeholder:hover{color:var(--lt-color-muted-foreground)}.bootstrap-select>select{position:absolute !important;bottom:0;left:50%;display:block !important;width:.5px !important;height:100% !important;padding:0 !important;opacity:0 !important;border:none}.bootstrap-select>select.mobile-device{top:0;left:0;display:block !important;width:100% !important;z-index:2}.error .bootstrap-select .dropdown-toggle,.has-error .bootstrap-select .dropdown-toggle{border-color:var(--lt-color-danger)}.bootstrap-select.fit-width{width:auto !important}.bootstrap-select:not([class*=col-]):not([class*=form-control]):not(.input-group-btn){width:220px}.bootstrap-select .dropdown-toggle:focus{outline:thin dotted var(--lt-color-focus) !important;outline:5px auto -webkit-focus-ring-color !important;outline-offset:-2px}.bootstrap-select.form-control{margin-bottom:0;padding:0;border:none}.bootstrap-select.form-control:not([class*=col-]){width:100%}.bootstrap-select.form-control.input-group-btn{z-index:auto}.bootstrap-select.form-control.input-group-btn:not(:first-child):not(:last-child)>.btn{border-radius:0}.bootstrap-select.btn-group:not(.input-group-btn),.bootstrap-select.btn-group[class*=col-]{float:none;display:inline-block;margin-left:0}.bootstrap-select.btn-group.dropdown-menu-right,.bootstrap-select.btn-group[class*=col-].dropdown-menu-right,.row .bootstrap-select.btn-group[class*=col-].dropdown-menu-right{float:right}.form-group .bootstrap-select.btn-group,.form-horizontal .bootstrap-select.btn-group,.form-inline .bootstrap-select.btn-group{margin-bottom:0}.form-group-lg .bootstrap-select.btn-group.form-control,.form-group-sm .bootstrap-select.btn-group.form-control{padding:0}.form-inline .bootstrap-select.btn-group .form-control{width:100%}.bootstrap-select.btn-group.disabled,.bootstrap-select.btn-group>.disabled{cursor:not-allowed}.bootstrap-select.btn-group.disabled:focus,.bootstrap-select.btn-group>.disabled:focus{outline:0 !important}.bootstrap-select.btn-group.bs-container{position:absolute;height:0 !important;padding:0 !important}.bootstrap-select.btn-group.bs-container .dropdown-menu{z-index:1060}.bootstrap-select.btn-group .dropdown-toggle .filter-option{display:inline-block;overflow:hidden;width:100%;text-align:left}.bootstrap-select.btn-group .dropdown-toggle .caret{position:absolute;top:50%;right:12px;margin-top:-2px;vertical-align:middle}.bootstrap-select.btn-group[class*=col-] .dropdown-toggle{width:100%}.bootstrap-select.btn-group .dropdown-menu{min-width:100%;-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box}.bootstrap-select.btn-group .dropdown-menu.inner{max-height:450px !important;position:static;float:none;border:0;padding:0;margin:0;border-radius:0;-webkit-box-shadow:none;box-shadow:none}.bootstrap-select.btn-group .dropdown-menu li{position:relative}.bootstrap-select.btn-group .dropdown-menu li.active small{color:#fff}.bootstrap-select.btn-group .dropdown-menu li.disabled a{cursor:not-allowed}.bootstrap-select.btn-group .dropdown-menu li a{cursor:pointer;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.bootstrap-select.btn-group .dropdown-menu li a.opt{position:relative;padding-left:2.25em}.bootstrap-select.btn-group .dropdown-menu li a span.check-mark{display:none}.bootstrap-select.btn-group .dropdown-menu li a span.text{display:inline-block}.bootstrap-select.btn-group .dropdown-menu li small{padding-left:.5em}.bootstrap-select.btn-group .dropdown-menu .notify{position:absolute;bottom:5px;width:96%;margin:0 2%;min-height:26px;padding:3px 5px;background:var(--lt-color-muted);border:1px solid var(--lt-color-border);-webkit-box-shadow:inset 0 1px 1px rgba(0, 0, 0, 0.05);box-shadow:inset 0 1px 1px rgba(0, 0, 0, 0.05);pointer-events:none;opacity:.9;-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box}.bootstrap-select.btn-group .no-results{padding:3px;background:var(--lt-color-muted);margin:0 5px;white-space:nowrap}.bootstrap-select.btn-group.fit-width .dropdown-toggle .filter-option{position:static}.bootstrap-select.btn-group.fit-width .dropdown-toggle .caret{position:static;top:auto;margin-top:-1px}.bootstrap-select.btn-group.show-tick .dropdown-menu li.selected a span.check-mark{position:absolute;display:inline-block;right:15px;margin-top:5px}.bootstrap-select.btn-group.show-tick .dropdown-menu li a span.text{margin-right:34px}.bootstrap-select.show-menu-arrow.open>.dropdown-toggle{z-index:1061}.bootstrap-select.show-menu-arrow .dropdown-toggle:before{content:\"\";border-left:7px solid transparent;border-right:7px solid transparent;border-bottom:7px solid rgba(204, 204, 204, 0.2);position:absolute;bottom:-4px;left:9px;display:none}.bootstrap-select.show-menu-arrow .dropdown-toggle:after{content:\"\";border-left:6px solid transparent;border-right:6px solid transparent;border-bottom:6px solid #fff;position:absolute;bottom:-4px;left:10px;display:none}.bootstrap-select.show-menu-arrow.dropup .dropdown-toggle:before{bottom:auto;top:-3px;border-top:7px solid rgba(204, 204, 204, 0.2);border-bottom:0}.bootstrap-select.show-menu-arrow.dropup .dropdown-toggle:after{bottom:auto;top:-3px;border-top:6px solid #fff;border-bottom:0}.bootstrap-select.show-menu-arrow.pull-right .dropdown-toggle:before{right:12px;left:auto}.bootstrap-select.show-menu-arrow.pull-right .dropdown-toggle:after{right:13px;left:auto}.bootstrap-select.show-menu-arrow.open>.dropdown-toggle:after,.bootstrap-select.show-menu-arrow.open>.dropdown-toggle:before{display:block}.bs-actionsbox,.bs-donebutton,.bs-searchbox{padding:4px 8px}.bs-actionsbox{width:100%;-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box}.bs-actionsbox .btn-group button{width:50%}.bs-donebutton{float:left;width:100%;-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box}.bs-donebutton .btn-group button{width:100%}.bs-searchbox+.bs-actionsbox{padding:0 8px 4px}.bs-searchbox .form-control{margin-bottom:0;width:100%;float:none}/*!\n *  Font Awesome 4.7.0 by @davegandy - http://fontawesome.io - @fontawesome\n *  License - http://fontawesome.io/license (Font: SIL OFL 1.1, CSS: MIT License)\n */@font-face{font-family:\"FontAwesome\";src:url(" + __webpack_require__(972) + ");src:url(" + __webpack_require__(973) + "?#iefix&v=4.7.0) format(\"embedded-opentype\"),url(" + __webpack_require__(974) + ") format(\"woff2\"),url(" + __webpack_require__(975) + ") format(\"woff\"),url(" + __webpack_require__(976) + ") format(\"truetype\"),url(" + __webpack_require__(977) + "#fontawesomeregular) format(\"svg\");font-weight:normal;font-style:normal}.fa{display:inline-block;font:normal normal normal 14px/1 FontAwesome;font-size:inherit;text-rendering:auto;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.fa-lg{font-size:1.33333333em;line-height:.75em;vertical-align:-15%}.fa-2x{font-size:2em}.fa-3x{font-size:3em}.fa-4x{font-size:4em}.fa-5x{font-size:5em}.fa-fw{width:1.28571429em;text-align:center}.fa-ul{padding-left:0;margin-left:2.14285714em;list-style-type:none}.fa-ul>li{position:relative}.fa-li{position:absolute;left:-2.14285714em;width:2.14285714em;top:.14285714em;text-align:center}.fa-li.fa-lg{left:-1.85714286em}.fa-border{padding:.2em .25em .15em;border:solid .08em #eee;border-radius:.1em}.fa-pull-left{float:left}.fa-pull-right{float:right}.fa.fa-pull-left{margin-right:.3em}.fa.fa-pull-right{margin-left:.3em}.pull-right{float:right}.pull-left{float:left}.fa.pull-left{margin-right:.3em}.fa.pull-right{margin-left:.3em}.fa-spin{-webkit-animation:fa-spin 2s infinite linear;animation:fa-spin 2s infinite linear}.fa-pulse{-webkit-animation:fa-spin 1s infinite steps(8);animation:fa-spin 1s infinite steps(8)}@-webkit-keyframes fa-spin{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}100%{-webkit-transform:rotate(359deg);transform:rotate(359deg)}}@keyframes fa-spin{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}100%{-webkit-transform:rotate(359deg);transform:rotate(359deg)}}.fa-rotate-90{-ms-filter:\"progid:DXImageTransform.Microsoft.BasicImage(rotation=1)\";-webkit-transform:rotate(90deg);-ms-transform:rotate(90deg);transform:rotate(90deg)}.fa-rotate-180{-ms-filter:\"progid:DXImageTransform.Microsoft.BasicImage(rotation=2)\";-webkit-transform:rotate(180deg);-ms-transform:rotate(180deg);transform:rotate(180deg)}.fa-rotate-270{-ms-filter:\"progid:DXImageTransform.Microsoft.BasicImage(rotation=3)\";-webkit-transform:rotate(270deg);-ms-transform:rotate(270deg);transform:rotate(270deg)}.fa-flip-horizontal{-ms-filter:\"progid:DXImageTransform.Microsoft.BasicImage(rotation=0, mirror=1)\";-webkit-transform:scale(-1, 1);-ms-transform:scale(-1, 1);transform:scale(-1, 1)}.fa-flip-vertical{-ms-filter:\"progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)\";-webkit-transform:scale(1, -1);-ms-transform:scale(1, -1);transform:scale(1, -1)}:root .fa-rotate-90,:root .fa-rotate-180,:root .fa-rotate-270,:root .fa-flip-horizontal,:root .fa-flip-vertical{filter:none}.fa-stack{position:relative;display:inline-block;width:2em;height:2em;line-height:2em;vertical-align:middle}.fa-stack-1x,.fa-stack-2x{position:absolute;left:0;width:100%;text-align:center}.fa-stack-1x{line-height:inherit}.fa-stack-2x{font-size:2em}.fa-inverse{color:#fff}.fa-glass:before{content:\"\\F000\"}.fa-music:before{content:\"\\F001\"}.fa-search:before{content:\"\\F002\"}.fa-envelope-o:before{content:\"\\F003\"}.fa-heart:before{content:\"\\F004\"}.fa-star:before{content:\"\\F005\"}.fa-star-o:before{content:\"\\F006\"}.fa-user:before{content:\"\\F007\"}.fa-film:before{content:\"\\F008\"}.fa-th-large:before{content:\"\\F009\"}.fa-th:before{content:\"\\F00A\"}.fa-th-list:before{content:\"\\F00B\"}.fa-check:before{content:\"\\F00C\"}.fa-remove:before,.fa-close:before,.fa-times:before{content:\"\\F00D\"}.fa-search-plus:before{content:\"\\F00E\"}.fa-search-minus:before{content:\"\\F010\"}.fa-power-off:before{content:\"\\F011\"}.fa-signal:before{content:\"\\F012\"}.fa-gear:before,.fa-cog:before{content:\"\\F013\"}.fa-trash-o:before{content:\"\\F014\"}.fa-home:before{content:\"\\F015\"}.fa-file-o:before{content:\"\\F016\"}.fa-clock-o:before{content:\"\\F017\"}.fa-road:before{content:\"\\F018\"}.fa-download:before{content:\"\\F019\"}.fa-arrow-circle-o-down:before{content:\"\\F01A\"}.fa-arrow-circle-o-up:before{content:\"\\F01B\"}.fa-inbox:before{content:\"\\F01C\"}.fa-play-circle-o:before{content:\"\\F01D\"}.fa-rotate-right:before,.fa-repeat:before{content:\"\\F01E\"}.fa-refresh:before{content:\"\\F021\"}.fa-list-alt:before{content:\"\\F022\"}.fa-lock:before{content:\"\\F023\"}.fa-flag:before{content:\"\\F024\"}.fa-headphones:before{content:\"\\F025\"}.fa-volume-off:before{content:\"\\F026\"}.fa-volume-down:before{content:\"\\F027\"}.fa-volume-up:before{content:\"\\F028\"}.fa-qrcode:before{content:\"\\F029\"}.fa-barcode:before{content:\"\\F02A\"}.fa-tag:before{content:\"\\F02B\"}.fa-tags:before{content:\"\\F02C\"}.fa-book:before{content:\"\\F02D\"}.fa-bookmark:before{content:\"\\F02E\"}.fa-print:before{content:\"\\F02F\"}.fa-camera:before{content:\"\\F030\"}.fa-font:before{content:\"\\F031\"}.fa-bold:before{content:\"\\F032\"}.fa-italic:before{content:\"\\F033\"}.fa-text-height:before{content:\"\\F034\"}.fa-text-width:before{content:\"\\F035\"}.fa-align-left:before{content:\"\\F036\"}.fa-align-center:before{content:\"\\F037\"}.fa-align-right:before{content:\"\\F038\"}.fa-align-justify:before{content:\"\\F039\"}.fa-list:before{content:\"\\F03A\"}.fa-dedent:before,.fa-outdent:before{content:\"\\F03B\"}.fa-indent:before{content:\"\\F03C\"}.fa-video-camera:before{content:\"\\F03D\"}.fa-photo:before,.fa-image:before,.fa-picture-o:before{content:\"\\F03E\"}.fa-pencil:before{content:\"\\F040\"}.fa-map-marker:before{content:\"\\F041\"}.fa-adjust:before{content:\"\\F042\"}.fa-tint:before{content:\"\\F043\"}.fa-edit:before,.fa-pencil-square-o:before{content:\"\\F044\"}.fa-share-square-o:before{content:\"\\F045\"}.fa-check-square-o:before{content:\"\\F046\"}.fa-arrows:before{content:\"\\F047\"}.fa-step-backward:before{content:\"\\F048\"}.fa-fast-backward:before{content:\"\\F049\"}.fa-backward:before{content:\"\\F04A\"}.fa-play:before{content:\"\\F04B\"}.fa-pause:before{content:\"\\F04C\"}.fa-stop:before{content:\"\\F04D\"}.fa-forward:before{content:\"\\F04E\"}.fa-fast-forward:before{content:\"\\F050\"}.fa-step-forward:before{content:\"\\F051\"}.fa-eject:before{content:\"\\F052\"}.fa-chevron-left:before{content:\"\\F053\"}.fa-chevron-right:before{content:\"\\F054\"}.fa-plus-circle:before{content:\"\\F055\"}.fa-minus-circle:before{content:\"\\F056\"}.fa-times-circle:before{content:\"\\F057\"}.fa-check-circle:before{content:\"\\F058\"}.fa-question-circle:before{content:\"\\F059\"}.fa-info-circle:before{content:\"\\F05A\"}.fa-crosshairs:before{content:\"\\F05B\"}.fa-times-circle-o:before{content:\"\\F05C\"}.fa-check-circle-o:before{content:\"\\F05D\"}.fa-ban:before{content:\"\\F05E\"}.fa-arrow-left:before{content:\"\\F060\"}.fa-arrow-right:before{content:\"\\F061\"}.fa-arrow-up:before{content:\"\\F062\"}.fa-arrow-down:before{content:\"\\F063\"}.fa-mail-forward:before,.fa-share:before{content:\"\\F064\"}.fa-expand:before{content:\"\\F065\"}.fa-compress:before{content:\"\\F066\"}.fa-plus:before{content:\"\\F067\"}.fa-minus:before{content:\"\\F068\"}.fa-asterisk:before{content:\"\\F069\"}.fa-exclamation-circle:before{content:\"\\F06A\"}.fa-gift:before{content:\"\\F06B\"}.fa-leaf:before{content:\"\\F06C\"}.fa-fire:before{content:\"\\F06D\"}.fa-eye:before{content:\"\\F06E\"}.fa-eye-slash:before{content:\"\\F070\"}.fa-warning:before,.fa-exclamation-triangle:before{content:\"\\F071\"}.fa-plane:before{content:\"\\F072\"}.fa-calendar:before{content:\"\\F073\"}.fa-random:before{content:\"\\F074\"}.fa-comment:before{content:\"\\F075\"}.fa-magnet:before{content:\"\\F076\"}.fa-chevron-up:before{content:\"\\F077\"}.fa-chevron-down:before{content:\"\\F078\"}.fa-retweet:before{content:\"\\F079\"}.fa-shopping-cart:before{content:\"\\F07A\"}.fa-folder:before{content:\"\\F07B\"}.fa-folder-open:before{content:\"\\F07C\"}.fa-arrows-v:before{content:\"\\F07D\"}.fa-arrows-h:before{content:\"\\F07E\"}.fa-bar-chart-o:before,.fa-bar-chart:before{content:\"\\F080\"}.fa-twitter-square:before{content:\"\\F081\"}.fa-facebook-square:before{content:\"\\F082\"}.fa-camera-retro:before{content:\"\\F083\"}.fa-key:before{content:\"\\F084\"}.fa-gears:before,.fa-cogs:before{content:\"\\F085\"}.fa-comments:before{content:\"\\F086\"}.fa-thumbs-o-up:before{content:\"\\F087\"}.fa-thumbs-o-down:before{content:\"\\F088\"}.fa-star-half:before{content:\"\\F089\"}.fa-heart-o:before{content:\"\\F08A\"}.fa-sign-out:before{content:\"\\F08B\"}.fa-linkedin-square:before{content:\"\\F08C\"}.fa-thumb-tack:before{content:\"\\F08D\"}.fa-external-link:before{content:\"\\F08E\"}.fa-sign-in:before{content:\"\\F090\"}.fa-trophy:before{content:\"\\F091\"}.fa-github-square:before{content:\"\\F092\"}.fa-upload:before{content:\"\\F093\"}.fa-lemon-o:before{content:\"\\F094\"}.fa-phone:before{content:\"\\F095\"}.fa-square-o:before{content:\"\\F096\"}.fa-bookmark-o:before{content:\"\\F097\"}.fa-phone-square:before{content:\"\\F098\"}.fa-twitter:before{content:\"\\F099\"}.fa-facebook-f:before,.fa-facebook:before{content:\"\\F09A\"}.fa-github:before{content:\"\\F09B\"}.fa-unlock:before{content:\"\\F09C\"}.fa-credit-card:before{content:\"\\F09D\"}.fa-feed:before,.fa-rss:before{content:\"\\F09E\"}.fa-hdd-o:before{content:\"\\F0A0\"}.fa-bullhorn:before{content:\"\\F0A1\"}.fa-bell:before{content:\"\\F0F3\"}.fa-certificate:before{content:\"\\F0A3\"}.fa-hand-o-right:before{content:\"\\F0A4\"}.fa-hand-o-left:before{content:\"\\F0A5\"}.fa-hand-o-up:before{content:\"\\F0A6\"}.fa-hand-o-down:before{content:\"\\F0A7\"}.fa-arrow-circle-left:before{content:\"\\F0A8\"}.fa-arrow-circle-right:before{content:\"\\F0A9\"}.fa-arrow-circle-up:before{content:\"\\F0AA\"}.fa-arrow-circle-down:before{content:\"\\F0AB\"}.fa-globe:before{content:\"\\F0AC\"}.fa-wrench:before{content:\"\\F0AD\"}.fa-tasks:before{content:\"\\F0AE\"}.fa-filter:before{content:\"\\F0B0\"}.fa-briefcase:before{content:\"\\F0B1\"}.fa-arrows-alt:before{content:\"\\F0B2\"}.fa-group:before,.fa-users:before{content:\"\\F0C0\"}.fa-chain:before,.fa-link:before{content:\"\\F0C1\"}.fa-cloud:before{content:\"\\F0C2\"}.fa-flask:before{content:\"\\F0C3\"}.fa-cut:before,.fa-scissors:before{content:\"\\F0C4\"}.fa-copy:before,.fa-files-o:before{content:\"\\F0C5\"}.fa-paperclip:before{content:\"\\F0C6\"}.fa-save:before,.fa-floppy-o:before{content:\"\\F0C7\"}.fa-square:before{content:\"\\F0C8\"}.fa-navicon:before,.fa-reorder:before,.fa-bars:before{content:\"\\F0C9\"}.fa-list-ul:before{content:\"\\F0CA\"}.fa-list-ol:before{content:\"\\F0CB\"}.fa-strikethrough:before{content:\"\\F0CC\"}.fa-underline:before{content:\"\\F0CD\"}.fa-table:before{content:\"\\F0CE\"}.fa-magic:before{content:\"\\F0D0\"}.fa-truck:before{content:\"\\F0D1\"}.fa-pinterest:before{content:\"\\F0D2\"}.fa-pinterest-square:before{content:\"\\F0D3\"}.fa-google-plus-square:before{content:\"\\F0D4\"}.fa-google-plus:before{content:\"\\F0D5\"}.fa-money:before{content:\"\\F0D6\"}.fa-caret-down:before{content:\"\\F0D7\"}.fa-caret-up:before{content:\"\\F0D8\"}.fa-caret-left:before{content:\"\\F0D9\"}.fa-caret-right:before{content:\"\\F0DA\"}.fa-columns:before{content:\"\\F0DB\"}.fa-unsorted:before,.fa-sort:before{content:\"\\F0DC\"}.fa-sort-down:before,.fa-sort-desc:before{content:\"\\F0DD\"}.fa-sort-up:before,.fa-sort-asc:before{content:\"\\F0DE\"}.fa-envelope:before{content:\"\\F0E0\"}.fa-linkedin:before{content:\"\\F0E1\"}.fa-rotate-left:before,.fa-undo:before{content:\"\\F0E2\"}.fa-legal:before,.fa-gavel:before{content:\"\\F0E3\"}.fa-dashboard:before,.fa-tachometer:before{content:\"\\F0E4\"}.fa-comment-o:before{content:\"\\F0E5\"}.fa-comments-o:before{content:\"\\F0E6\"}.fa-flash:before,.fa-bolt:before{content:\"\\F0E7\"}.fa-sitemap:before{content:\"\\F0E8\"}.fa-umbrella:before{content:\"\\F0E9\"}.fa-paste:before,.fa-clipboard:before{content:\"\\F0EA\"}.fa-lightbulb-o:before{content:\"\\F0EB\"}.fa-exchange:before{content:\"\\F0EC\"}.fa-cloud-download:before{content:\"\\F0ED\"}.fa-cloud-upload:before{content:\"\\F0EE\"}.fa-user-md:before{content:\"\\F0F0\"}.fa-stethoscope:before{content:\"\\F0F1\"}.fa-suitcase:before{content:\"\\F0F2\"}.fa-bell-o:before{content:\"\\F0A2\"}.fa-coffee:before{content:\"\\F0F4\"}.fa-cutlery:before{content:\"\\F0F5\"}.fa-file-text-o:before{content:\"\\F0F6\"}.fa-building-o:before{content:\"\\F0F7\"}.fa-hospital-o:before{content:\"\\F0F8\"}.fa-ambulance:before{content:\"\\F0F9\"}.fa-medkit:before{content:\"\\F0FA\"}.fa-fighter-jet:before{content:\"\\F0FB\"}.fa-beer:before{content:\"\\F0FC\"}.fa-h-square:before{content:\"\\F0FD\"}.fa-plus-square:before{content:\"\\F0FE\"}.fa-angle-double-left:before{content:\"\\F100\"}.fa-angle-double-right:before{content:\"\\F101\"}.fa-angle-double-up:before{content:\"\\F102\"}.fa-angle-double-down:before{content:\"\\F103\"}.fa-angle-left:before{content:\"\\F104\"}.fa-angle-right:before{content:\"\\F105\"}.fa-angle-up:before{content:\"\\F106\"}.fa-angle-down:before{content:\"\\F107\"}.fa-desktop:before{content:\"\\F108\"}.fa-laptop:before{content:\"\\F109\"}.fa-tablet:before{content:\"\\F10A\"}.fa-mobile-phone:before,.fa-mobile:before{content:\"\\F10B\"}.fa-circle-o:before{content:\"\\F10C\"}.fa-quote-left:before{content:\"\\F10D\"}.fa-quote-right:before{content:\"\\F10E\"}.fa-spinner:before{content:\"\\F110\"}.fa-circle:before{content:\"\\F111\"}.fa-mail-reply:before,.fa-reply:before{content:\"\\F112\"}.fa-github-alt:before{content:\"\\F113\"}.fa-folder-o:before{content:\"\\F114\"}.fa-folder-open-o:before{content:\"\\F115\"}.fa-smile-o:before{content:\"\\F118\"}.fa-frown-o:before{content:\"\\F119\"}.fa-meh-o:before{content:\"\\F11A\"}.fa-gamepad:before{content:\"\\F11B\"}.fa-keyboard-o:before{content:\"\\F11C\"}.fa-flag-o:before{content:\"\\F11D\"}.fa-flag-checkered:before{content:\"\\F11E\"}.fa-terminal:before{content:\"\\F120\"}.fa-code:before{content:\"\\F121\"}.fa-mail-reply-all:before,.fa-reply-all:before{content:\"\\F122\"}.fa-star-half-empty:before,.fa-star-half-full:before,.fa-star-half-o:before{content:\"\\F123\"}.fa-location-arrow:before{content:\"\\F124\"}.fa-crop:before{content:\"\\F125\"}.fa-code-fork:before{content:\"\\F126\"}.fa-unlink:before,.fa-chain-broken:before{content:\"\\F127\"}.fa-question:before{content:\"\\F128\"}.fa-info:before{content:\"\\F129\"}.fa-exclamation:before{content:\"\\F12A\"}.fa-superscript:before{content:\"\\F12B\"}.fa-subscript:before{content:\"\\F12C\"}.fa-eraser:before{content:\"\\F12D\"}.fa-puzzle-piece:before{content:\"\\F12E\"}.fa-microphone:before{content:\"\\F130\"}.fa-microphone-slash:before{content:\"\\F131\"}.fa-shield:before{content:\"\\F132\"}.fa-calendar-o:before{content:\"\\F133\"}.fa-fire-extinguisher:before{content:\"\\F134\"}.fa-rocket:before{content:\"\\F135\"}.fa-maxcdn:before{content:\"\\F136\"}.fa-chevron-circle-left:before{content:\"\\F137\"}.fa-chevron-circle-right:before{content:\"\\F138\"}.fa-chevron-circle-up:before{content:\"\\F139\"}.fa-chevron-circle-down:before{content:\"\\F13A\"}.fa-html5:before{content:\"\\F13B\"}.fa-css3:before{content:\"\\F13C\"}.fa-anchor:before{content:\"\\F13D\"}.fa-unlock-alt:before{content:\"\\F13E\"}.fa-bullseye:before{content:\"\\F140\"}.fa-ellipsis-h:before{content:\"\\F141\"}.fa-ellipsis-v:before{content:\"\\F142\"}.fa-rss-square:before{content:\"\\F143\"}.fa-play-circle:before{content:\"\\F144\"}.fa-ticket:before{content:\"\\F145\"}.fa-minus-square:before{content:\"\\F146\"}.fa-minus-square-o:before{content:\"\\F147\"}.fa-level-up:before{content:\"\\F148\"}.fa-level-down:before{content:\"\\F149\"}.fa-check-square:before{content:\"\\F14A\"}.fa-pencil-square:before{content:\"\\F14B\"}.fa-external-link-square:before{content:\"\\F14C\"}.fa-share-square:before{content:\"\\F14D\"}.fa-compass:before{content:\"\\F14E\"}.fa-toggle-down:before,.fa-caret-square-o-down:before{content:\"\\F150\"}.fa-toggle-up:before,.fa-caret-square-o-up:before{content:\"\\F151\"}.fa-toggle-right:before,.fa-caret-square-o-right:before{content:\"\\F152\"}.fa-euro:before,.fa-eur:before{content:\"\\F153\"}.fa-gbp:before{content:\"\\F154\"}.fa-dollar:before,.fa-usd:before{content:\"\\F155\"}.fa-rupee:before,.fa-inr:before{content:\"\\F156\"}.fa-cny:before,.fa-rmb:before,.fa-yen:before,.fa-jpy:before{content:\"\\F157\"}.fa-ruble:before,.fa-rouble:before,.fa-rub:before{content:\"\\F158\"}.fa-won:before,.fa-krw:before{content:\"\\F159\"}.fa-bitcoin:before,.fa-btc:before{content:\"\\F15A\"}.fa-file:before{content:\"\\F15B\"}.fa-file-text:before{content:\"\\F15C\"}.fa-sort-alpha-asc:before{content:\"\\F15D\"}.fa-sort-alpha-desc:before{content:\"\\F15E\"}.fa-sort-amount-asc:before{content:\"\\F160\"}.fa-sort-amount-desc:before{content:\"\\F161\"}.fa-sort-numeric-asc:before{content:\"\\F162\"}.fa-sort-numeric-desc:before{content:\"\\F163\"}.fa-thumbs-up:before{content:\"\\F164\"}.fa-thumbs-down:before{content:\"\\F165\"}.fa-youtube-square:before{content:\"\\F166\"}.fa-youtube:before{content:\"\\F167\"}.fa-xing:before{content:\"\\F168\"}.fa-xing-square:before{content:\"\\F169\"}.fa-youtube-play:before{content:\"\\F16A\"}.fa-dropbox:before{content:\"\\F16B\"}.fa-stack-overflow:before{content:\"\\F16C\"}.fa-instagram:before{content:\"\\F16D\"}.fa-flickr:before{content:\"\\F16E\"}.fa-adn:before{content:\"\\F170\"}.fa-bitbucket:before{content:\"\\F171\"}.fa-bitbucket-square:before{content:\"\\F172\"}.fa-tumblr:before{content:\"\\F173\"}.fa-tumblr-square:before{content:\"\\F174\"}.fa-long-arrow-down:before{content:\"\\F175\"}.fa-long-arrow-up:before{content:\"\\F176\"}.fa-long-arrow-left:before{content:\"\\F177\"}.fa-long-arrow-right:before{content:\"\\F178\"}.fa-apple:before{content:\"\\F179\"}.fa-windows:before{content:\"\\F17A\"}.fa-android:before{content:\"\\F17B\"}.fa-linux:before{content:\"\\F17C\"}.fa-dribbble:before{content:\"\\F17D\"}.fa-skype:before{content:\"\\F17E\"}.fa-foursquare:before{content:\"\\F180\"}.fa-trello:before{content:\"\\F181\"}.fa-female:before{content:\"\\F182\"}.fa-male:before{content:\"\\F183\"}.fa-gittip:before,.fa-gratipay:before{content:\"\\F184\"}.fa-sun-o:before{content:\"\\F185\"}.fa-moon-o:before{content:\"\\F186\"}.fa-archive:before{content:\"\\F187\"}.fa-bug:before{content:\"\\F188\"}.fa-vk:before{content:\"\\F189\"}.fa-weibo:before{content:\"\\F18A\"}.fa-renren:before{content:\"\\F18B\"}.fa-pagelines:before{content:\"\\F18C\"}.fa-stack-exchange:before{content:\"\\F18D\"}.fa-arrow-circle-o-right:before{content:\"\\F18E\"}.fa-arrow-circle-o-left:before{content:\"\\F190\"}.fa-toggle-left:before,.fa-caret-square-o-left:before{content:\"\\F191\"}.fa-dot-circle-o:before{content:\"\\F192\"}.fa-wheelchair:before{content:\"\\F193\"}.fa-vimeo-square:before{content:\"\\F194\"}.fa-turkish-lira:before,.fa-try:before{content:\"\\F195\"}.fa-plus-square-o:before{content:\"\\F196\"}.fa-space-shuttle:before{content:\"\\F197\"}.fa-slack:before{content:\"\\F198\"}.fa-envelope-square:before{content:\"\\F199\"}.fa-wordpress:before{content:\"\\F19A\"}.fa-openid:before{content:\"\\F19B\"}.fa-institution:before,.fa-bank:before,.fa-university:before{content:\"\\F19C\"}.fa-mortar-board:before,.fa-graduation-cap:before{content:\"\\F19D\"}.fa-yahoo:before{content:\"\\F19E\"}.fa-google:before{content:\"\\F1A0\"}.fa-reddit:before{content:\"\\F1A1\"}.fa-reddit-square:before{content:\"\\F1A2\"}.fa-stumbleupon-circle:before{content:\"\\F1A3\"}.fa-stumbleupon:before{content:\"\\F1A4\"}.fa-delicious:before{content:\"\\F1A5\"}.fa-digg:before{content:\"\\F1A6\"}.fa-pied-piper-pp:before{content:\"\\F1A7\"}.fa-pied-piper-alt:before{content:\"\\F1A8\"}.fa-drupal:before{content:\"\\F1A9\"}.fa-joomla:before{content:\"\\F1AA\"}.fa-language:before{content:\"\\F1AB\"}.fa-fax:before{content:\"\\F1AC\"}.fa-building:before{content:\"\\F1AD\"}.fa-child:before{content:\"\\F1AE\"}.fa-paw:before{content:\"\\F1B0\"}.fa-spoon:before{content:\"\\F1B1\"}.fa-cube:before{content:\"\\F1B2\"}.fa-cubes:before{content:\"\\F1B3\"}.fa-behance:before{content:\"\\F1B4\"}.fa-behance-square:before{content:\"\\F1B5\"}.fa-steam:before{content:\"\\F1B6\"}.fa-steam-square:before{content:\"\\F1B7\"}.fa-recycle:before{content:\"\\F1B8\"}.fa-automobile:before,.fa-car:before{content:\"\\F1B9\"}.fa-cab:before,.fa-taxi:before{content:\"\\F1BA\"}.fa-tree:before{content:\"\\F1BB\"}.fa-spotify:before{content:\"\\F1BC\"}.fa-deviantart:before{content:\"\\F1BD\"}.fa-soundcloud:before{content:\"\\F1BE\"}.fa-database:before{content:\"\\F1C0\"}.fa-file-pdf-o:before{content:\"\\F1C1\"}.fa-file-word-o:before{content:\"\\F1C2\"}.fa-file-excel-o:before{content:\"\\F1C3\"}.fa-file-powerpoint-o:before{content:\"\\F1C4\"}.fa-file-photo-o:before,.fa-file-picture-o:before,.fa-file-image-o:before{content:\"\\F1C5\"}.fa-file-zip-o:before,.fa-file-archive-o:before{content:\"\\F1C6\"}.fa-file-sound-o:before,.fa-file-audio-o:before{content:\"\\F1C7\"}.fa-file-movie-o:before,.fa-file-video-o:before{content:\"\\F1C8\"}.fa-file-code-o:before{content:\"\\F1C9\"}.fa-vine:before{content:\"\\F1CA\"}.fa-codepen:before{content:\"\\F1CB\"}.fa-jsfiddle:before{content:\"\\F1CC\"}.fa-life-bouy:before,.fa-life-buoy:before,.fa-life-saver:before,.fa-support:before,.fa-life-ring:before{content:\"\\F1CD\"}.fa-circle-o-notch:before{content:\"\\F1CE\"}.fa-ra:before,.fa-resistance:before,.fa-rebel:before{content:\"\\F1D0\"}.fa-ge:before,.fa-empire:before{content:\"\\F1D1\"}.fa-git-square:before{content:\"\\F1D2\"}.fa-git:before{content:\"\\F1D3\"}.fa-y-combinator-square:before,.fa-yc-square:before,.fa-hacker-news:before{content:\"\\F1D4\"}.fa-tencent-weibo:before{content:\"\\F1D5\"}.fa-qq:before{content:\"\\F1D6\"}.fa-wechat:before,.fa-weixin:before{content:\"\\F1D7\"}.fa-send:before,.fa-paper-plane:before{content:\"\\F1D8\"}.fa-send-o:before,.fa-paper-plane-o:before{content:\"\\F1D9\"}.fa-history:before{content:\"\\F1DA\"}.fa-circle-thin:before{content:\"\\F1DB\"}.fa-header:before{content:\"\\F1DC\"}.fa-paragraph:before{content:\"\\F1DD\"}.fa-sliders:before{content:\"\\F1DE\"}.fa-share-alt:before{content:\"\\F1E0\"}.fa-share-alt-square:before{content:\"\\F1E1\"}.fa-bomb:before{content:\"\\F1E2\"}.fa-soccer-ball-o:before,.fa-futbol-o:before{content:\"\\F1E3\"}.fa-tty:before{content:\"\\F1E4\"}.fa-binoculars:before{content:\"\\F1E5\"}.fa-plug:before{content:\"\\F1E6\"}.fa-slideshare:before{content:\"\\F1E7\"}.fa-twitch:before{content:\"\\F1E8\"}.fa-yelp:before{content:\"\\F1E9\"}.fa-newspaper-o:before{content:\"\\F1EA\"}.fa-wifi:before{content:\"\\F1EB\"}.fa-calculator:before{content:\"\\F1EC\"}.fa-paypal:before{content:\"\\F1ED\"}.fa-google-wallet:before{content:\"\\F1EE\"}.fa-cc-visa:before{content:\"\\F1F0\"}.fa-cc-mastercard:before{content:\"\\F1F1\"}.fa-cc-discover:before{content:\"\\F1F2\"}.fa-cc-amex:before{content:\"\\F1F3\"}.fa-cc-paypal:before{content:\"\\F1F4\"}.fa-cc-stripe:before{content:\"\\F1F5\"}.fa-bell-slash:before{content:\"\\F1F6\"}.fa-bell-slash-o:before{content:\"\\F1F7\"}.fa-trash:before{content:\"\\F1F8\"}.fa-copyright:before{content:\"\\F1F9\"}.fa-at:before{content:\"\\F1FA\"}.fa-eyedropper:before{content:\"\\F1FB\"}.fa-paint-brush:before{content:\"\\F1FC\"}.fa-birthday-cake:before{content:\"\\F1FD\"}.fa-area-chart:before{content:\"\\F1FE\"}.fa-pie-chart:before{content:\"\\F200\"}.fa-line-chart:before{content:\"\\F201\"}.fa-lastfm:before{content:\"\\F202\"}.fa-lastfm-square:before{content:\"\\F203\"}.fa-toggle-off:before{content:\"\\F204\"}.fa-toggle-on:before{content:\"\\F205\"}.fa-bicycle:before{content:\"\\F206\"}.fa-bus:before{content:\"\\F207\"}.fa-ioxhost:before{content:\"\\F208\"}.fa-angellist:before{content:\"\\F209\"}.fa-cc:before{content:\"\\F20A\"}.fa-shekel:before,.fa-sheqel:before,.fa-ils:before{content:\"\\F20B\"}.fa-meanpath:before{content:\"\\F20C\"}.fa-buysellads:before{content:\"\\F20D\"}.fa-connectdevelop:before{content:\"\\F20E\"}.fa-dashcube:before{content:\"\\F210\"}.fa-forumbee:before{content:\"\\F211\"}.fa-leanpub:before{content:\"\\F212\"}.fa-sellsy:before{content:\"\\F213\"}.fa-shirtsinbulk:before{content:\"\\F214\"}.fa-simplybuilt:before{content:\"\\F215\"}.fa-skyatlas:before{content:\"\\F216\"}.fa-cart-plus:before{content:\"\\F217\"}.fa-cart-arrow-down:before{content:\"\\F218\"}.fa-diamond:before{content:\"\\F219\"}.fa-ship:before{content:\"\\F21A\"}.fa-user-secret:before{content:\"\\F21B\"}.fa-motorcycle:before{content:\"\\F21C\"}.fa-street-view:before{content:\"\\F21D\"}.fa-heartbeat:before{content:\"\\F21E\"}.fa-venus:before{content:\"\\F221\"}.fa-mars:before{content:\"\\F222\"}.fa-mercury:before{content:\"\\F223\"}.fa-intersex:before,.fa-transgender:before{content:\"\\F224\"}.fa-transgender-alt:before{content:\"\\F225\"}.fa-venus-double:before{content:\"\\F226\"}.fa-mars-double:before{content:\"\\F227\"}.fa-venus-mars:before{content:\"\\F228\"}.fa-mars-stroke:before{content:\"\\F229\"}.fa-mars-stroke-v:before{content:\"\\F22A\"}.fa-mars-stroke-h:before{content:\"\\F22B\"}.fa-neuter:before{content:\"\\F22C\"}.fa-genderless:before{content:\"\\F22D\"}.fa-facebook-official:before{content:\"\\F230\"}.fa-pinterest-p:before{content:\"\\F231\"}.fa-whatsapp:before{content:\"\\F232\"}.fa-server:before{content:\"\\F233\"}.fa-user-plus:before{content:\"\\F234\"}.fa-user-times:before{content:\"\\F235\"}.fa-hotel:before,.fa-bed:before{content:\"\\F236\"}.fa-viacoin:before{content:\"\\F237\"}.fa-train:before{content:\"\\F238\"}.fa-subway:before{content:\"\\F239\"}.fa-medium:before{content:\"\\F23A\"}.fa-yc:before,.fa-y-combinator:before{content:\"\\F23B\"}.fa-optin-monster:before{content:\"\\F23C\"}.fa-opencart:before{content:\"\\F23D\"}.fa-expeditedssl:before{content:\"\\F23E\"}.fa-battery-4:before,.fa-battery:before,.fa-battery-full:before{content:\"\\F240\"}.fa-battery-3:before,.fa-battery-three-quarters:before{content:\"\\F241\"}.fa-battery-2:before,.fa-battery-half:before{content:\"\\F242\"}.fa-battery-1:before,.fa-battery-quarter:before{content:\"\\F243\"}.fa-battery-0:before,.fa-battery-empty:before{content:\"\\F244\"}.fa-mouse-pointer:before{content:\"\\F245\"}.fa-i-cursor:before{content:\"\\F246\"}.fa-object-group:before{content:\"\\F247\"}.fa-object-ungroup:before{content:\"\\F248\"}.fa-sticky-note:before{content:\"\\F249\"}.fa-sticky-note-o:before{content:\"\\F24A\"}.fa-cc-jcb:before{content:\"\\F24B\"}.fa-cc-diners-club:before{content:\"\\F24C\"}.fa-clone:before{content:\"\\F24D\"}.fa-balance-scale:before{content:\"\\F24E\"}.fa-hourglass-o:before{content:\"\\F250\"}.fa-hourglass-1:before,.fa-hourglass-start:before{content:\"\\F251\"}.fa-hourglass-2:before,.fa-hourglass-half:before{content:\"\\F252\"}.fa-hourglass-3:before,.fa-hourglass-end:before{content:\"\\F253\"}.fa-hourglass:before{content:\"\\F254\"}.fa-hand-grab-o:before,.fa-hand-rock-o:before{content:\"\\F255\"}.fa-hand-stop-o:before,.fa-hand-paper-o:before{content:\"\\F256\"}.fa-hand-scissors-o:before{content:\"\\F257\"}.fa-hand-lizard-o:before{content:\"\\F258\"}.fa-hand-spock-o:before{content:\"\\F259\"}.fa-hand-pointer-o:before{content:\"\\F25A\"}.fa-hand-peace-o:before{content:\"\\F25B\"}.fa-trademark:before{content:\"\\F25C\"}.fa-registered:before{content:\"\\F25D\"}.fa-creative-commons:before{content:\"\\F25E\"}.fa-gg:before{content:\"\\F260\"}.fa-gg-circle:before{content:\"\\F261\"}.fa-tripadvisor:before{content:\"\\F262\"}.fa-odnoklassniki:before{content:\"\\F263\"}.fa-odnoklassniki-square:before{content:\"\\F264\"}.fa-get-pocket:before{content:\"\\F265\"}.fa-wikipedia-w:before{content:\"\\F266\"}.fa-safari:before{content:\"\\F267\"}.fa-chrome:before{content:\"\\F268\"}.fa-firefox:before{content:\"\\F269\"}.fa-opera:before{content:\"\\F26A\"}.fa-internet-explorer:before{content:\"\\F26B\"}.fa-tv:before,.fa-television:before{content:\"\\F26C\"}.fa-contao:before{content:\"\\F26D\"}.fa-500px:before{content:\"\\F26E\"}.fa-amazon:before{content:\"\\F270\"}.fa-calendar-plus-o:before{content:\"\\F271\"}.fa-calendar-minus-o:before{content:\"\\F272\"}.fa-calendar-times-o:before{content:\"\\F273\"}.fa-calendar-check-o:before{content:\"\\F274\"}.fa-industry:before{content:\"\\F275\"}.fa-map-pin:before{content:\"\\F276\"}.fa-map-signs:before{content:\"\\F277\"}.fa-map-o:before{content:\"\\F278\"}.fa-map:before{content:\"\\F279\"}.fa-commenting:before{content:\"\\F27A\"}.fa-commenting-o:before{content:\"\\F27B\"}.fa-houzz:before{content:\"\\F27C\"}.fa-vimeo:before{content:\"\\F27D\"}.fa-black-tie:before{content:\"\\F27E\"}.fa-fonticons:before{content:\"\\F280\"}.fa-reddit-alien:before{content:\"\\F281\"}.fa-edge:before{content:\"\\F282\"}.fa-credit-card-alt:before{content:\"\\F283\"}.fa-codiepie:before{content:\"\\F284\"}.fa-modx:before{content:\"\\F285\"}.fa-fort-awesome:before{content:\"\\F286\"}.fa-usb:before{content:\"\\F287\"}.fa-product-hunt:before{content:\"\\F288\"}.fa-mixcloud:before{content:\"\\F289\"}.fa-scribd:before{content:\"\\F28A\"}.fa-pause-circle:before{content:\"\\F28B\"}.fa-pause-circle-o:before{content:\"\\F28C\"}.fa-stop-circle:before{content:\"\\F28D\"}.fa-stop-circle-o:before{content:\"\\F28E\"}.fa-shopping-bag:before{content:\"\\F290\"}.fa-shopping-basket:before{content:\"\\F291\"}.fa-hashtag:before{content:\"\\F292\"}.fa-bluetooth:before{content:\"\\F293\"}.fa-bluetooth-b:before{content:\"\\F294\"}.fa-percent:before{content:\"\\F295\"}.fa-gitlab:before{content:\"\\F296\"}.fa-wpbeginner:before{content:\"\\F297\"}.fa-wpforms:before{content:\"\\F298\"}.fa-envira:before{content:\"\\F299\"}.fa-universal-access:before{content:\"\\F29A\"}.fa-wheelchair-alt:before{content:\"\\F29B\"}.fa-question-circle-o:before{content:\"\\F29C\"}.fa-blind:before{content:\"\\F29D\"}.fa-audio-description:before{content:\"\\F29E\"}.fa-volume-control-phone:before{content:\"\\F2A0\"}.fa-braille:before{content:\"\\F2A1\"}.fa-assistive-listening-systems:before{content:\"\\F2A2\"}.fa-asl-interpreting:before,.fa-american-sign-language-interpreting:before{content:\"\\F2A3\"}.fa-deafness:before,.fa-hard-of-hearing:before,.fa-deaf:before{content:\"\\F2A4\"}.fa-glide:before{content:\"\\F2A5\"}.fa-glide-g:before{content:\"\\F2A6\"}.fa-signing:before,.fa-sign-language:before{content:\"\\F2A7\"}.fa-low-vision:before{content:\"\\F2A8\"}.fa-viadeo:before{content:\"\\F2A9\"}.fa-viadeo-square:before{content:\"\\F2AA\"}.fa-snapchat:before{content:\"\\F2AB\"}.fa-snapchat-ghost:before{content:\"\\F2AC\"}.fa-snapchat-square:before{content:\"\\F2AD\"}.fa-pied-piper:before{content:\"\\F2AE\"}.fa-first-order:before{content:\"\\F2B0\"}.fa-yoast:before{content:\"\\F2B1\"}.fa-themeisle:before{content:\"\\F2B2\"}.fa-google-plus-circle:before,.fa-google-plus-official:before{content:\"\\F2B3\"}.fa-fa:before,.fa-font-awesome:before{content:\"\\F2B4\"}.fa-handshake-o:before{content:\"\\F2B5\"}.fa-envelope-open:before{content:\"\\F2B6\"}.fa-envelope-open-o:before{content:\"\\F2B7\"}.fa-linode:before{content:\"\\F2B8\"}.fa-address-book:before{content:\"\\F2B9\"}.fa-address-book-o:before{content:\"\\F2BA\"}.fa-vcard:before,.fa-address-card:before{content:\"\\F2BB\"}.fa-vcard-o:before,.fa-address-card-o:before{content:\"\\F2BC\"}.fa-user-circle:before{content:\"\\F2BD\"}.fa-user-circle-o:before{content:\"\\F2BE\"}.fa-user-o:before{content:\"\\F2C0\"}.fa-id-badge:before{content:\"\\F2C1\"}.fa-drivers-license:before,.fa-id-card:before{content:\"\\F2C2\"}.fa-drivers-license-o:before,.fa-id-card-o:before{content:\"\\F2C3\"}.fa-quora:before{content:\"\\F2C4\"}.fa-free-code-camp:before{content:\"\\F2C5\"}.fa-telegram:before{content:\"\\F2C6\"}.fa-thermometer-4:before,.fa-thermometer:before,.fa-thermometer-full:before{content:\"\\F2C7\"}.fa-thermometer-3:before,.fa-thermometer-three-quarters:before{content:\"\\F2C8\"}.fa-thermometer-2:before,.fa-thermometer-half:before{content:\"\\F2C9\"}.fa-thermometer-1:before,.fa-thermometer-quarter:before{content:\"\\F2CA\"}.fa-thermometer-0:before,.fa-thermometer-empty:before{content:\"\\F2CB\"}.fa-shower:before{content:\"\\F2CC\"}.fa-bathtub:before,.fa-s15:before,.fa-bath:before{content:\"\\F2CD\"}.fa-podcast:before{content:\"\\F2CE\"}.fa-window-maximize:before{content:\"\\F2D0\"}.fa-window-minimize:before{content:\"\\F2D1\"}.fa-window-restore:before{content:\"\\F2D2\"}.fa-times-rectangle:before,.fa-window-close:before{content:\"\\F2D3\"}.fa-times-rectangle-o:before,.fa-window-close-o:before{content:\"\\F2D4\"}.fa-bandcamp:before{content:\"\\F2D5\"}.fa-grav:before{content:\"\\F2D6\"}.fa-etsy:before{content:\"\\F2D7\"}.fa-imdb:before{content:\"\\F2D8\"}.fa-ravelry:before{content:\"\\F2D9\"}.fa-eercast:before{content:\"\\F2DA\"}.fa-microchip:before{content:\"\\F2DB\"}.fa-snowflake-o:before{content:\"\\F2DC\"}.fa-superpowers:before{content:\"\\F2DD\"}.fa-wpexplorer:before{content:\"\\F2DE\"}.fa-meetup:before{content:\"\\F2E0\"}.sr-only{position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0, 0, 0, 0);border:0}.sr-only-focusable:active,.sr-only-focusable:focus{position:static;width:auto;height:auto;margin:0;overflow:visible;clip:auto}.mCustomScrollbar{-ms-touch-action:none;touch-action:none}.mCustomScrollbar.mCS_no_scrollbar,.mCustomScrollbar.mCS_touch_action{-ms-touch-action:auto;touch-action:auto}.mCustomScrollBox{position:relative;overflow:hidden;height:100%;max-width:100%;outline:none;direction:ltr}.mCSB_container{overflow:hidden;width:auto;height:auto}.mCSB_inside>.mCSB_container{margin-right:30px}.mCSB_container.mCS_no_scrollbar_y.mCS_y_hidden{margin-right:0}.mCS-dir-rtl>.mCSB_inside>.mCSB_container{margin-right:0;margin-left:30px}.mCS-dir-rtl>.mCSB_inside>.mCSB_container.mCS_no_scrollbar_y.mCS_y_hidden{margin-left:0}.mCSB_scrollTools{position:absolute;width:16px;height:auto;left:auto;top:0;right:0;bottom:0}.mCSB_outside+.mCSB_scrollTools{right:-26px}.mCS-dir-rtl>.mCSB_inside>.mCSB_scrollTools,.mCS-dir-rtl>.mCSB_outside+.mCSB_scrollTools{right:auto;left:0}.mCS-dir-rtl>.mCSB_outside+.mCSB_scrollTools{left:-26px}.mCSB_scrollTools .mCSB_draggerContainer{position:absolute;top:0;left:0;bottom:0;right:0;height:auto}.mCSB_scrollTools a+.mCSB_draggerContainer{margin:20px 0}.mCSB_scrollTools .mCSB_draggerRail{width:2px;height:100%;margin:0 auto;-webkit-border-radius:16px;-moz-border-radius:16px;border-radius:16px}.mCSB_scrollTools .mCSB_dragger{cursor:pointer;width:100%;height:30px;z-index:1}.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar{position:relative;width:4px;height:100%;margin:0 auto;-webkit-border-radius:16px;-moz-border-radius:16px;border-radius:16px;text-align:center}.mCSB_scrollTools_vertical.mCSB_scrollTools_onDrag_expand .mCSB_dragger.mCSB_dragger_onDrag_expanded .mCSB_dragger_bar,.mCSB_scrollTools_vertical.mCSB_scrollTools_onDrag_expand .mCSB_draggerContainer:hover .mCSB_dragger .mCSB_dragger_bar{width:12px}.mCSB_scrollTools_vertical.mCSB_scrollTools_onDrag_expand .mCSB_dragger.mCSB_dragger_onDrag_expanded+.mCSB_draggerRail,.mCSB_scrollTools_vertical.mCSB_scrollTools_onDrag_expand .mCSB_draggerContainer:hover .mCSB_draggerRail{width:8px}.mCSB_scrollTools .mCSB_buttonUp,.mCSB_scrollTools .mCSB_buttonDown{display:block;position:absolute;height:20px;width:100%;overflow:hidden;margin:0 auto;cursor:pointer}.mCSB_scrollTools .mCSB_buttonDown{bottom:0}.mCSB_horizontal.mCSB_inside>.mCSB_container{margin-right:0;margin-bottom:30px}.mCSB_horizontal.mCSB_outside>.mCSB_container{min-height:100%}.mCSB_horizontal>.mCSB_container.mCS_no_scrollbar_x.mCS_x_hidden{margin-bottom:0}.mCSB_scrollTools.mCSB_scrollTools_horizontal{width:auto;height:16px;top:auto;right:0;bottom:0;left:0}.mCustomScrollBox+.mCSB_scrollTools.mCSB_scrollTools_horizontal,.mCustomScrollBox+.mCSB_scrollTools+.mCSB_scrollTools.mCSB_scrollTools_horizontal{bottom:-26px}.mCSB_scrollTools.mCSB_scrollTools_horizontal a+.mCSB_draggerContainer{margin:0 20px}.mCSB_scrollTools.mCSB_scrollTools_horizontal .mCSB_draggerRail{width:100%;height:2px;margin:7px 0}.mCSB_scrollTools.mCSB_scrollTools_horizontal .mCSB_dragger{width:30px;height:100%;left:0}.mCSB_scrollTools.mCSB_scrollTools_horizontal .mCSB_dragger .mCSB_dragger_bar{width:100%;height:4px;margin:6px auto}.mCSB_scrollTools_horizontal.mCSB_scrollTools_onDrag_expand .mCSB_dragger.mCSB_dragger_onDrag_expanded .mCSB_dragger_bar,.mCSB_scrollTools_horizontal.mCSB_scrollTools_onDrag_expand .mCSB_draggerContainer:hover .mCSB_dragger .mCSB_dragger_bar{height:12px;margin:2px auto}.mCSB_scrollTools_horizontal.mCSB_scrollTools_onDrag_expand .mCSB_dragger.mCSB_dragger_onDrag_expanded+.mCSB_draggerRail,.mCSB_scrollTools_horizontal.mCSB_scrollTools_onDrag_expand .mCSB_draggerContainer:hover .mCSB_draggerRail{height:8px;margin:4px 0}.mCSB_scrollTools.mCSB_scrollTools_horizontal .mCSB_buttonLeft,.mCSB_scrollTools.mCSB_scrollTools_horizontal .mCSB_buttonRight{display:block;position:absolute;width:20px;height:100%;overflow:hidden;margin:0 auto;cursor:pointer}.mCSB_scrollTools.mCSB_scrollTools_horizontal .mCSB_buttonLeft{left:0}.mCSB_scrollTools.mCSB_scrollTools_horizontal .mCSB_buttonRight{right:0}.mCSB_container_wrapper{position:absolute;height:auto;width:auto;overflow:hidden;top:0;left:0;right:0;bottom:0;margin-right:30px;margin-bottom:30px}.mCSB_container_wrapper>.mCSB_container{padding-right:30px;padding-bottom:30px}.mCSB_vertical_horizontal>.mCSB_scrollTools.mCSB_scrollTools_vertical{bottom:20px}.mCSB_vertical_horizontal>.mCSB_scrollTools.mCSB_scrollTools_horizontal{right:20px}.mCSB_container_wrapper.mCS_no_scrollbar_x.mCS_x_hidden+.mCSB_scrollTools.mCSB_scrollTools_vertical{bottom:0}.mCSB_container_wrapper.mCS_no_scrollbar_y.mCS_y_hidden+.mCSB_scrollTools~.mCSB_scrollTools.mCSB_scrollTools_horizontal,.mCS-dir-rtl>.mCustomScrollBox.mCSB_vertical_horizontal.mCSB_inside>.mCSB_scrollTools.mCSB_scrollTools_horizontal{right:0}.mCS-dir-rtl>.mCustomScrollBox.mCSB_vertical_horizontal.mCSB_inside>.mCSB_scrollTools.mCSB_scrollTools_horizontal{left:20px}.mCS-dir-rtl>.mCustomScrollBox.mCSB_vertical_horizontal.mCSB_inside>.mCSB_container_wrapper.mCS_no_scrollbar_y.mCS_y_hidden+.mCSB_scrollTools~.mCSB_scrollTools.mCSB_scrollTools_horizontal{left:0}.mCS-dir-rtl>.mCSB_inside>.mCSB_container_wrapper{margin-right:0;margin-left:30px}.mCSB_container_wrapper.mCS_no_scrollbar_y.mCS_y_hidden>.mCSB_container{padding-right:0;-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box}.mCSB_container_wrapper.mCS_no_scrollbar_x.mCS_x_hidden>.mCSB_container{padding-bottom:0;-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box}.mCustomScrollBox.mCSB_vertical_horizontal.mCSB_inside>.mCSB_container_wrapper.mCS_no_scrollbar_y.mCS_y_hidden{margin-right:0;margin-left:0}.mCustomScrollBox.mCSB_vertical_horizontal.mCSB_inside>.mCSB_container_wrapper.mCS_no_scrollbar_x.mCS_x_hidden{margin-bottom:0}.mCSB_scrollTools,.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar,.mCSB_scrollTools .mCSB_buttonUp,.mCSB_scrollTools .mCSB_buttonDown,.mCSB_scrollTools .mCSB_buttonLeft,.mCSB_scrollTools .mCSB_buttonRight{-webkit-transition:opacity .2s ease-in-out,background-color .2s ease-in-out;-moz-transition:opacity .2s ease-in-out,background-color .2s ease-in-out;-o-transition:opacity .2s ease-in-out,background-color .2s ease-in-out;transition:opacity .2s ease-in-out,background-color .2s ease-in-out}.mCSB_scrollTools_vertical.mCSB_scrollTools_onDrag_expand .mCSB_dragger_bar,.mCSB_scrollTools_vertical.mCSB_scrollTools_onDrag_expand .mCSB_draggerRail,.mCSB_scrollTools_horizontal.mCSB_scrollTools_onDrag_expand .mCSB_dragger_bar,.mCSB_scrollTools_horizontal.mCSB_scrollTools_onDrag_expand .mCSB_draggerRail{-webkit-transition:width .2s ease-out .2s,height .2s ease-out .2s,margin-left .2s ease-out .2s,margin-right .2s ease-out .2s,margin-top .2s ease-out .2s,margin-bottom .2s ease-out .2s,opacity .2s ease-in-out,background-color .2s ease-in-out;-moz-transition:width .2s ease-out .2s,height .2s ease-out .2s,margin-left .2s ease-out .2s,margin-right .2s ease-out .2s,margin-top .2s ease-out .2s,margin-bottom .2s ease-out .2s,opacity .2s ease-in-out,background-color .2s ease-in-out;-o-transition:width .2s ease-out .2s,height .2s ease-out .2s,margin-left .2s ease-out .2s,margin-right .2s ease-out .2s,margin-top .2s ease-out .2s,margin-bottom .2s ease-out .2s,opacity .2s ease-in-out,background-color .2s ease-in-out;transition:width .2s ease-out .2s,height .2s ease-out .2s,margin-left .2s ease-out .2s,margin-right .2s ease-out .2s,margin-top .2s ease-out .2s,margin-bottom .2s ease-out .2s,opacity .2s ease-in-out,background-color .2s ease-in-out}.mCSB_scrollTools{opacity:.75;filter:\"alpha(opacity=75)\";-ms-filter:\"alpha(opacity=75)\"}.mCS-autoHide>.mCustomScrollBox>.mCSB_scrollTools,.mCS-autoHide>.mCustomScrollBox~.mCSB_scrollTools{opacity:0;filter:\"alpha(opacity=0)\";-ms-filter:\"alpha(opacity=0)\"}.mCustomScrollbar>.mCustomScrollBox>.mCSB_scrollTools.mCSB_scrollTools_onDrag,.mCustomScrollbar>.mCustomScrollBox~.mCSB_scrollTools.mCSB_scrollTools_onDrag,.mCustomScrollBox:hover>.mCSB_scrollTools,.mCustomScrollBox:hover~.mCSB_scrollTools,.mCS-autoHide:hover>.mCustomScrollBox>.mCSB_scrollTools,.mCS-autoHide:hover>.mCustomScrollBox~.mCSB_scrollTools{opacity:1;filter:\"alpha(opacity=100)\";-ms-filter:\"alpha(opacity=100)\"}.mCSB_scrollTools .mCSB_draggerRail{background-color:#000;background-color:rgba(0, 0, 0, 0.4);filter:\"alpha(opacity=40)\";-ms-filter:\"alpha(opacity=40)\"}.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar{background-color:#fff;background-color:rgba(255, 255, 255, 0.75);filter:\"alpha(opacity=75)\";-ms-filter:\"alpha(opacity=75)\"}.mCSB_scrollTools .mCSB_dragger:hover .mCSB_dragger_bar{background-color:#fff;background-color:rgba(255, 255, 255, 0.85);filter:\"alpha(opacity=85)\";-ms-filter:\"alpha(opacity=85)\"}.mCSB_scrollTools .mCSB_dragger:active .mCSB_dragger_bar,.mCSB_scrollTools .mCSB_dragger.mCSB_dragger_onDrag .mCSB_dragger_bar{background-color:#fff;background-color:rgba(255, 255, 255, 0.9);filter:\"alpha(opacity=90)\";-ms-filter:\"alpha(opacity=90)\"}.mCSB_scrollTools .mCSB_buttonUp,.mCSB_scrollTools .mCSB_buttonDown,.mCSB_scrollTools .mCSB_buttonLeft,.mCSB_scrollTools .mCSB_buttonRight{background-repeat:no-repeat;opacity:.4;filter:\"alpha(opacity=40)\";-ms-filter:\"alpha(opacity=40)\"}.mCSB_scrollTools .mCSB_buttonUp{background-position:0 0}.mCSB_scrollTools .mCSB_buttonDown{background-position:0 -20px}.mCSB_scrollTools .mCSB_buttonLeft{background-position:0 -40px}.mCSB_scrollTools .mCSB_buttonRight{background-position:0 -56px}.mCSB_scrollTools .mCSB_buttonUp:hover,.mCSB_scrollTools .mCSB_buttonDown:hover,.mCSB_scrollTools .mCSB_buttonLeft:hover,.mCSB_scrollTools .mCSB_buttonRight:hover{opacity:.75;filter:\"alpha(opacity=75)\";-ms-filter:\"alpha(opacity=75)\"}.mCSB_scrollTools .mCSB_buttonUp:active,.mCSB_scrollTools .mCSB_buttonDown:active,.mCSB_scrollTools .mCSB_buttonLeft:active,.mCSB_scrollTools .mCSB_buttonRight:active{opacity:.9;filter:\"alpha(opacity=90)\";-ms-filter:\"alpha(opacity=90)\"}.mCS-dark.mCSB_scrollTools .mCSB_draggerRail{background-color:#000;background-color:rgba(0, 0, 0, 0.15)}.mCS-dark.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar{background-color:#000;background-color:rgba(0, 0, 0, 0.75)}.mCS-dark.mCSB_scrollTools .mCSB_dragger:hover .mCSB_dragger_bar{background-color:rgba(0, 0, 0, 0.85)}.mCS-dark.mCSB_scrollTools .mCSB_dragger:active .mCSB_dragger_bar,.mCS-dark.mCSB_scrollTools .mCSB_dragger.mCSB_dragger_onDrag .mCSB_dragger_bar{background-color:rgba(0, 0, 0, 0.9)}.mCS-dark.mCSB_scrollTools .mCSB_buttonUp{background-position:-80px 0}.mCS-dark.mCSB_scrollTools .mCSB_buttonDown{background-position:-80px -20px}.mCS-dark.mCSB_scrollTools .mCSB_buttonLeft{background-position:-80px -40px}.mCS-dark.mCSB_scrollTools .mCSB_buttonRight{background-position:-80px -56px}.mCS-light-2.mCSB_scrollTools .mCSB_draggerRail,.mCS-dark-2.mCSB_scrollTools .mCSB_draggerRail{width:4px;background-color:#fff;background-color:rgba(255, 255, 255, 0.1);-webkit-border-radius:1px;-moz-border-radius:1px;border-radius:1px}.mCS-light-2.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar,.mCS-dark-2.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar{width:4px;background-color:#fff;background-color:rgba(255, 255, 255, 0.75);-webkit-border-radius:1px;-moz-border-radius:1px;border-radius:1px}.mCS-light-2.mCSB_scrollTools_horizontal .mCSB_draggerRail,.mCS-dark-2.mCSB_scrollTools_horizontal .mCSB_draggerRail,.mCS-light-2.mCSB_scrollTools_horizontal .mCSB_dragger .mCSB_dragger_bar,.mCS-dark-2.mCSB_scrollTools_horizontal .mCSB_dragger .mCSB_dragger_bar{width:100%;height:4px;margin:6px auto}.mCS-light-2.mCSB_scrollTools .mCSB_dragger:hover .mCSB_dragger_bar{background-color:#fff;background-color:rgba(255, 255, 255, 0.85)}.mCS-light-2.mCSB_scrollTools .mCSB_dragger:active .mCSB_dragger_bar,.mCS-light-2.mCSB_scrollTools .mCSB_dragger.mCSB_dragger_onDrag .mCSB_dragger_bar{background-color:#fff;background-color:rgba(255, 255, 255, 0.9)}.mCS-light-2.mCSB_scrollTools .mCSB_buttonUp{background-position:-32px 0}.mCS-light-2.mCSB_scrollTools .mCSB_buttonDown{background-position:-32px -20px}.mCS-light-2.mCSB_scrollTools .mCSB_buttonLeft{background-position:-40px -40px}.mCS-light-2.mCSB_scrollTools .mCSB_buttonRight{background-position:-40px -56px}.mCS-dark-2.mCSB_scrollTools .mCSB_draggerRail{background-color:#000;background-color:rgba(0, 0, 0, 0.1);-webkit-border-radius:1px;-moz-border-radius:1px;border-radius:1px}.mCS-dark-2.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar{background-color:#000;background-color:rgba(0, 0, 0, 0.75);-webkit-border-radius:1px;-moz-border-radius:1px;border-radius:1px}.mCS-dark-2.mCSB_scrollTools .mCSB_dragger:hover .mCSB_dragger_bar{background-color:#000;background-color:rgba(0, 0, 0, 0.85)}.mCS-dark-2.mCSB_scrollTools .mCSB_dragger:active .mCSB_dragger_bar,.mCS-dark-2.mCSB_scrollTools .mCSB_dragger.mCSB_dragger_onDrag .mCSB_dragger_bar{background-color:#000;background-color:rgba(0, 0, 0, 0.9)}.mCS-dark-2.mCSB_scrollTools .mCSB_buttonUp{background-position:-112px 0}.mCS-dark-2.mCSB_scrollTools .mCSB_buttonDown{background-position:-112px -20px}.mCS-dark-2.mCSB_scrollTools .mCSB_buttonLeft{background-position:-120px -40px}.mCS-dark-2.mCSB_scrollTools .mCSB_buttonRight{background-position:-120px -56px}.mCS-light-thick.mCSB_scrollTools .mCSB_draggerRail,.mCS-dark-thick.mCSB_scrollTools .mCSB_draggerRail{width:4px;background-color:#fff;background-color:rgba(255, 255, 255, 0.1);-webkit-border-radius:2px;-moz-border-radius:2px;border-radius:2px}.mCS-light-thick.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar,.mCS-dark-thick.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar{width:6px;background-color:#fff;background-color:rgba(255, 255, 255, 0.75);-webkit-border-radius:2px;-moz-border-radius:2px;border-radius:2px}.mCS-light-thick.mCSB_scrollTools_horizontal .mCSB_draggerRail,.mCS-dark-thick.mCSB_scrollTools_horizontal .mCSB_draggerRail{width:100%;height:4px;margin:6px 0}.mCS-light-thick.mCSB_scrollTools_horizontal .mCSB_dragger .mCSB_dragger_bar,.mCS-dark-thick.mCSB_scrollTools_horizontal .mCSB_dragger .mCSB_dragger_bar{width:100%;height:6px;margin:5px auto}.mCS-light-thick.mCSB_scrollTools .mCSB_dragger:hover .mCSB_dragger_bar{background-color:#fff;background-color:rgba(255, 255, 255, 0.85)}.mCS-light-thick.mCSB_scrollTools .mCSB_dragger:active .mCSB_dragger_bar,.mCS-light-thick.mCSB_scrollTools .mCSB_dragger.mCSB_dragger_onDrag .mCSB_dragger_bar{background-color:#fff;background-color:rgba(255, 255, 255, 0.9)}.mCS-light-thick.mCSB_scrollTools .mCSB_buttonUp{background-position:-16px 0}.mCS-light-thick.mCSB_scrollTools .mCSB_buttonDown{background-position:-16px -20px}.mCS-light-thick.mCSB_scrollTools .mCSB_buttonLeft{background-position:-20px -40px}.mCS-light-thick.mCSB_scrollTools .mCSB_buttonRight{background-position:-20px -56px}.mCS-dark-thick.mCSB_scrollTools .mCSB_draggerRail{background-color:#000;background-color:rgba(0, 0, 0, 0.1);-webkit-border-radius:2px;-moz-border-radius:2px;border-radius:2px}.mCS-dark-thick.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar{background-color:#000;background-color:rgba(0, 0, 0, 0.75);-webkit-border-radius:2px;-moz-border-radius:2px;border-radius:2px}.mCS-dark-thick.mCSB_scrollTools .mCSB_dragger:hover .mCSB_dragger_bar{background-color:#000;background-color:rgba(0, 0, 0, 0.85)}.mCS-dark-thick.mCSB_scrollTools .mCSB_dragger:active .mCSB_dragger_bar,.mCS-dark-thick.mCSB_scrollTools .mCSB_dragger.mCSB_dragger_onDrag .mCSB_dragger_bar{background-color:#000;background-color:rgba(0, 0, 0, 0.9)}.mCS-dark-thick.mCSB_scrollTools .mCSB_buttonUp{background-position:-96px 0}.mCS-dark-thick.mCSB_scrollTools .mCSB_buttonDown{background-position:-96px -20px}.mCS-dark-thick.mCSB_scrollTools .mCSB_buttonLeft{background-position:-100px -40px}.mCS-dark-thick.mCSB_scrollTools .mCSB_buttonRight{background-position:-100px -56px}.mCS-light-thin.mCSB_scrollTools .mCSB_draggerRail{background-color:#fff;background-color:rgba(255, 255, 255, 0.1)}.mCS-light-thin.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar,.mCS-dark-thin.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar{width:2px}.mCS-light-thin.mCSB_scrollTools_horizontal .mCSB_draggerRail,.mCS-dark-thin.mCSB_scrollTools_horizontal .mCSB_draggerRail{width:100%}.mCS-light-thin.mCSB_scrollTools_horizontal .mCSB_dragger .mCSB_dragger_bar,.mCS-dark-thin.mCSB_scrollTools_horizontal .mCSB_dragger .mCSB_dragger_bar{width:100%;height:2px;margin:7px auto}.mCS-dark-thin.mCSB_scrollTools .mCSB_draggerRail{background-color:#000;background-color:rgba(0, 0, 0, 0.15)}.mCS-dark-thin.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar{background-color:#000;background-color:rgba(0, 0, 0, 0.75)}.mCS-dark-thin.mCSB_scrollTools .mCSB_dragger:hover .mCSB_dragger_bar{background-color:#000;background-color:rgba(0, 0, 0, 0.85)}.mCS-dark-thin.mCSB_scrollTools .mCSB_dragger:active .mCSB_dragger_bar,.mCS-dark-thin.mCSB_scrollTools .mCSB_dragger.mCSB_dragger_onDrag .mCSB_dragger_bar{background-color:#000;background-color:rgba(0, 0, 0, 0.9)}.mCS-dark-thin.mCSB_scrollTools .mCSB_buttonUp{background-position:-80px 0}.mCS-dark-thin.mCSB_scrollTools .mCSB_buttonDown{background-position:-80px -20px}.mCS-dark-thin.mCSB_scrollTools .mCSB_buttonLeft{background-position:-80px -40px}.mCS-dark-thin.mCSB_scrollTools .mCSB_buttonRight{background-position:-80px -56px}.mCS-rounded.mCSB_scrollTools .mCSB_draggerRail{background-color:#fff;background-color:rgba(255, 255, 255, 0.15)}.mCS-rounded.mCSB_scrollTools .mCSB_dragger,.mCS-rounded-dark.mCSB_scrollTools .mCSB_dragger,.mCS-rounded-dots.mCSB_scrollTools .mCSB_dragger,.mCS-rounded-dots-dark.mCSB_scrollTools .mCSB_dragger{height:14px}.mCS-rounded.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar,.mCS-rounded-dark.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar,.mCS-rounded-dots.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar,.mCS-rounded-dots-dark.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar{width:14px;margin:0 1px}.mCS-rounded.mCSB_scrollTools_horizontal .mCSB_dragger,.mCS-rounded-dark.mCSB_scrollTools_horizontal .mCSB_dragger,.mCS-rounded-dots.mCSB_scrollTools_horizontal .mCSB_dragger,.mCS-rounded-dots-dark.mCSB_scrollTools_horizontal .mCSB_dragger{width:14px}.mCS-rounded.mCSB_scrollTools_horizontal .mCSB_dragger .mCSB_dragger_bar,.mCS-rounded-dark.mCSB_scrollTools_horizontal .mCSB_dragger .mCSB_dragger_bar,.mCS-rounded-dots.mCSB_scrollTools_horizontal .mCSB_dragger .mCSB_dragger_bar,.mCS-rounded-dots-dark.mCSB_scrollTools_horizontal .mCSB_dragger .mCSB_dragger_bar{height:14px;margin:1px 0}.mCS-rounded.mCSB_scrollTools_vertical.mCSB_scrollTools_onDrag_expand .mCSB_dragger.mCSB_dragger_onDrag_expanded .mCSB_dragger_bar,.mCS-rounded.mCSB_scrollTools_vertical.mCSB_scrollTools_onDrag_expand .mCSB_draggerContainer:hover .mCSB_dragger .mCSB_dragger_bar,.mCS-rounded-dark.mCSB_scrollTools_vertical.mCSB_scrollTools_onDrag_expand .mCSB_dragger.mCSB_dragger_onDrag_expanded .mCSB_dragger_bar,.mCS-rounded-dark.mCSB_scrollTools_vertical.mCSB_scrollTools_onDrag_expand .mCSB_draggerContainer:hover .mCSB_dragger .mCSB_dragger_bar{width:16px;height:16px;margin:-1px 0}.mCS-rounded.mCSB_scrollTools_vertical.mCSB_scrollTools_onDrag_expand .mCSB_dragger.mCSB_dragger_onDrag_expanded+.mCSB_draggerRail,.mCS-rounded.mCSB_scrollTools_vertical.mCSB_scrollTools_onDrag_expand .mCSB_draggerContainer:hover .mCSB_draggerRail,.mCS-rounded-dark.mCSB_scrollTools_vertical.mCSB_scrollTools_onDrag_expand .mCSB_dragger.mCSB_dragger_onDrag_expanded+.mCSB_draggerRail,.mCS-rounded-dark.mCSB_scrollTools_vertical.mCSB_scrollTools_onDrag_expand .mCSB_draggerContainer:hover .mCSB_draggerRail{width:4px}.mCS-rounded.mCSB_scrollTools_horizontal.mCSB_scrollTools_onDrag_expand .mCSB_dragger.mCSB_dragger_onDrag_expanded .mCSB_dragger_bar,.mCS-rounded.mCSB_scrollTools_horizontal.mCSB_scrollTools_onDrag_expand .mCSB_draggerContainer:hover .mCSB_dragger .mCSB_dragger_bar,.mCS-rounded-dark.mCSB_scrollTools_horizontal.mCSB_scrollTools_onDrag_expand .mCSB_dragger.mCSB_dragger_onDrag_expanded .mCSB_dragger_bar,.mCS-rounded-dark.mCSB_scrollTools_horizontal.mCSB_scrollTools_onDrag_expand .mCSB_draggerContainer:hover .mCSB_dragger .mCSB_dragger_bar{height:16px;width:16px;margin:0 -1px}.mCS-rounded.mCSB_scrollTools_horizontal.mCSB_scrollTools_onDrag_expand .mCSB_dragger.mCSB_dragger_onDrag_expanded+.mCSB_draggerRail,.mCS-rounded.mCSB_scrollTools_horizontal.mCSB_scrollTools_onDrag_expand .mCSB_draggerContainer:hover .mCSB_draggerRail,.mCS-rounded-dark.mCSB_scrollTools_horizontal.mCSB_scrollTools_onDrag_expand .mCSB_dragger.mCSB_dragger_onDrag_expanded+.mCSB_draggerRail,.mCS-rounded-dark.mCSB_scrollTools_horizontal.mCSB_scrollTools_onDrag_expand .mCSB_draggerContainer:hover .mCSB_draggerRail{height:4px;margin:6px 0}.mCS-rounded.mCSB_scrollTools .mCSB_buttonUp{background-position:0 -72px}.mCS-rounded.mCSB_scrollTools .mCSB_buttonDown{background-position:0 -92px}.mCS-rounded.mCSB_scrollTools .mCSB_buttonLeft{background-position:0 -112px}.mCS-rounded.mCSB_scrollTools .mCSB_buttonRight{background-position:0 -128px}.mCS-rounded-dark.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar,.mCS-rounded-dots-dark.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar{background-color:#000;background-color:rgba(0, 0, 0, 0.75)}.mCS-rounded-dark.mCSB_scrollTools .mCSB_draggerRail{background-color:#000;background-color:rgba(0, 0, 0, 0.15)}.mCS-rounded-dark.mCSB_scrollTools .mCSB_dragger:hover .mCSB_dragger_bar,.mCS-rounded-dots-dark.mCSB_scrollTools .mCSB_dragger:hover .mCSB_dragger_bar{background-color:#000;background-color:rgba(0, 0, 0, 0.85)}.mCS-rounded-dark.mCSB_scrollTools .mCSB_dragger:active .mCSB_dragger_bar,.mCS-rounded-dark.mCSB_scrollTools .mCSB_dragger.mCSB_dragger_onDrag .mCSB_dragger_bar,.mCS-rounded-dots-dark.mCSB_scrollTools .mCSB_dragger:active .mCSB_dragger_bar,.mCS-rounded-dots-dark.mCSB_scrollTools .mCSB_dragger.mCSB_dragger_onDrag .mCSB_dragger_bar{background-color:#000;background-color:rgba(0, 0, 0, 0.9)}.mCS-rounded-dark.mCSB_scrollTools .mCSB_buttonUp{background-position:-80px -72px}.mCS-rounded-dark.mCSB_scrollTools .mCSB_buttonDown{background-position:-80px -92px}.mCS-rounded-dark.mCSB_scrollTools .mCSB_buttonLeft{background-position:-80px -112px}.mCS-rounded-dark.mCSB_scrollTools .mCSB_buttonRight{background-position:-80px -128px}.mCS-rounded-dots.mCSB_scrollTools_vertical .mCSB_draggerRail,.mCS-rounded-dots-dark.mCSB_scrollTools_vertical .mCSB_draggerRail{width:4px}.mCS-rounded-dots.mCSB_scrollTools .mCSB_draggerRail,.mCS-rounded-dots-dark.mCSB_scrollTools .mCSB_draggerRail,.mCS-rounded-dots.mCSB_scrollTools_horizontal .mCSB_draggerRail,.mCS-rounded-dots-dark.mCSB_scrollTools_horizontal .mCSB_draggerRail{background-color:transparent;background-position:center}.mCS-rounded-dots.mCSB_scrollTools .mCSB_draggerRail,.mCS-rounded-dots-dark.mCSB_scrollTools .mCSB_draggerRail{background-image:url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAANElEQVQYV2NkIAAYiVbw//9/Y6DiM1ANJoyMjGdBbLgJQAX/kU0DKgDLkaQAvxW4HEvQFwCRcxIJK1XznAAAAABJRU5ErkJggg==\");background-repeat:repeat-y;opacity:.3;filter:\"alpha(opacity=30)\";-ms-filter:\"alpha(opacity=30)\"}.mCS-rounded-dots.mCSB_scrollTools_horizontal .mCSB_draggerRail,.mCS-rounded-dots-dark.mCSB_scrollTools_horizontal .mCSB_draggerRail{height:4px;margin:6px 0;background-repeat:repeat-x}.mCS-rounded-dots.mCSB_scrollTools .mCSB_buttonUp{background-position:-16px -72px}.mCS-rounded-dots.mCSB_scrollTools .mCSB_buttonDown{background-position:-16px -92px}.mCS-rounded-dots.mCSB_scrollTools .mCSB_buttonLeft{background-position:-20px -112px}.mCS-rounded-dots.mCSB_scrollTools .mCSB_buttonRight{background-position:-20px -128px}.mCS-rounded-dots-dark.mCSB_scrollTools .mCSB_draggerRail{background-image:url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAALElEQVQYV2NkIAAYSVFgDFR8BqrBBEifBbGRTfiPZhpYjiQFBK3A6l6CvgAAE9kGCd1mvgEAAAAASUVORK5CYII=\")}.mCS-rounded-dots-dark.mCSB_scrollTools .mCSB_buttonUp{background-position:-96px -72px}.mCS-rounded-dots-dark.mCSB_scrollTools .mCSB_buttonDown{background-position:-96px -92px}.mCS-rounded-dots-dark.mCSB_scrollTools .mCSB_buttonLeft{background-position:-100px -112px}.mCS-rounded-dots-dark.mCSB_scrollTools .mCSB_buttonRight{background-position:-100px -128px}.mCS-3d.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar,.mCS-3d-dark.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar,.mCS-3d-thick.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar,.mCS-3d-thick-dark.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar{background-repeat:repeat-y;background-image:-moz-linear-gradient(left, rgba(255, 255, 255, 0.5) 0%, rgba(255, 255, 255, 0) 100%);background-image:-webkit-gradient(linear, left top, right top, color-stop(0%, rgba(255, 255, 255, 0.5)), color-stop(100%, rgba(255, 255, 255, 0)));background-image:-webkit-linear-gradient(left, rgba(255, 255, 255, 0.5) 0%, rgba(255, 255, 255, 0) 100%);background-image:-o-linear-gradient(left, rgba(255, 255, 255, 0.5) 0%, rgba(255, 255, 255, 0) 100%);background-image:-ms-linear-gradient(left, rgba(255, 255, 255, 0.5) 0%, rgba(255, 255, 255, 0) 100%);background-image:linear-gradient(to right, rgba(255, 255, 255, 0.5) 0%, rgba(255, 255, 255, 0) 100%)}.mCS-3d.mCSB_scrollTools_horizontal .mCSB_dragger .mCSB_dragger_bar,.mCS-3d-dark.mCSB_scrollTools_horizontal .mCSB_dragger .mCSB_dragger_bar,.mCS-3d-thick.mCSB_scrollTools_horizontal .mCSB_dragger .mCSB_dragger_bar,.mCS-3d-thick-dark.mCSB_scrollTools_horizontal .mCSB_dragger .mCSB_dragger_bar{background-repeat:repeat-x;background-image:-moz-linear-gradient(top, rgba(255, 255, 255, 0.5) 0%, rgba(255, 255, 255, 0) 100%);background-image:-webkit-gradient(linear, left top, left bottom, color-stop(0%, rgba(255, 255, 255, 0.5)), color-stop(100%, rgba(255, 255, 255, 0)));background-image:-webkit-linear-gradient(top, rgba(255, 255, 255, 0.5) 0%, rgba(255, 255, 255, 0) 100%);background-image:-o-linear-gradient(top, rgba(255, 255, 255, 0.5) 0%, rgba(255, 255, 255, 0) 100%);background-image:-ms-linear-gradient(top, rgba(255, 255, 255, 0.5) 0%, rgba(255, 255, 255, 0) 100%);background-image:linear-gradient(to bottom, rgba(255, 255, 255, 0.5) 0%, rgba(255, 255, 255, 0) 100%)}.mCS-3d.mCSB_scrollTools_vertical .mCSB_dragger,.mCS-3d-dark.mCSB_scrollTools_vertical .mCSB_dragger{height:70px}.mCS-3d.mCSB_scrollTools_horizontal .mCSB_dragger,.mCS-3d-dark.mCSB_scrollTools_horizontal .mCSB_dragger{width:70px}.mCS-3d.mCSB_scrollTools,.mCS-3d-dark.mCSB_scrollTools{opacity:1;filter:\"alpha(opacity=30)\";-ms-filter:\"alpha(opacity=30)\"}.mCS-3d.mCSB_scrollTools .mCSB_draggerRail,.mCS-3d.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar,.mCS-3d-dark.mCSB_scrollTools .mCSB_draggerRail,.mCS-3d-dark.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar{-webkit-border-radius:16px;-moz-border-radius:16px;border-radius:16px}.mCS-3d.mCSB_scrollTools .mCSB_draggerRail,.mCS-3d-dark.mCSB_scrollTools .mCSB_draggerRail{width:8px;background-color:#000;background-color:rgba(0, 0, 0, 0.2);box-shadow:inset 1px 0 1px rgba(0, 0, 0, 0.5),inset -1px 0 1px rgba(255, 255, 255, 0.2)}.mCS-3d.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar,.mCS-3d.mCSB_scrollTools .mCSB_dragger:hover .mCSB_dragger_bar,.mCS-3d.mCSB_scrollTools .mCSB_dragger:active .mCSB_dragger_bar,.mCS-3d.mCSB_scrollTools .mCSB_dragger.mCSB_dragger_onDrag .mCSB_dragger_bar,.mCS-3d-dark.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar,.mCS-3d-dark.mCSB_scrollTools .mCSB_dragger:hover .mCSB_dragger_bar,.mCS-3d-dark.mCSB_scrollTools .mCSB_dragger:active .mCSB_dragger_bar,.mCS-3d-dark.mCSB_scrollTools .mCSB_dragger.mCSB_dragger_onDrag .mCSB_dragger_bar{background-color:#555}.mCS-3d.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar,.mCS-3d-dark.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar{width:8px}.mCS-3d.mCSB_scrollTools_horizontal .mCSB_draggerRail,.mCS-3d-dark.mCSB_scrollTools_horizontal .mCSB_draggerRail{width:100%;height:8px;margin:4px 0;box-shadow:inset 0 1px 1px rgba(0, 0, 0, 0.5),inset 0 -1px 1px rgba(255, 255, 255, 0.2)}.mCS-3d.mCSB_scrollTools_horizontal .mCSB_dragger .mCSB_dragger_bar,.mCS-3d-dark.mCSB_scrollTools_horizontal .mCSB_dragger .mCSB_dragger_bar{width:100%;height:8px;margin:4px auto}.mCS-3d.mCSB_scrollTools .mCSB_buttonUp{background-position:-32px -72px}.mCS-3d.mCSB_scrollTools .mCSB_buttonDown{background-position:-32px -92px}.mCS-3d.mCSB_scrollTools .mCSB_buttonLeft{background-position:-40px -112px}.mCS-3d.mCSB_scrollTools .mCSB_buttonRight{background-position:-40px -128px}.mCS-3d-dark.mCSB_scrollTools .mCSB_draggerRail{background-color:#000;background-color:rgba(0, 0, 0, 0.1);box-shadow:inset 1px 0 1px rgba(0, 0, 0, 0.1)}.mCS-3d-dark.mCSB_scrollTools_horizontal .mCSB_draggerRail{box-shadow:inset 0 1px 1px rgba(0, 0, 0, 0.1)}.mCS-3d-dark.mCSB_scrollTools .mCSB_buttonUp{background-position:-112px -72px}.mCS-3d-dark.mCSB_scrollTools .mCSB_buttonDown{background-position:-112px -92px}.mCS-3d-dark.mCSB_scrollTools .mCSB_buttonLeft{background-position:-120px -112px}.mCS-3d-dark.mCSB_scrollTools .mCSB_buttonRight{background-position:-120px -128px}.mCS-3d-thick.mCSB_scrollTools,.mCS-3d-thick-dark.mCSB_scrollTools{opacity:1;filter:\"alpha(opacity=30)\";-ms-filter:\"alpha(opacity=30)\"}.mCS-3d-thick.mCSB_scrollTools,.mCS-3d-thick-dark.mCSB_scrollTools,.mCS-3d-thick.mCSB_scrollTools .mCSB_draggerContainer,.mCS-3d-thick-dark.mCSB_scrollTools .mCSB_draggerContainer{-webkit-border-radius:7px;-moz-border-radius:7px;border-radius:7px}.mCS-3d-thick.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar,.mCS-3d-thick-dark.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar{-webkit-border-radius:5px;-moz-border-radius:5px;border-radius:5px}.mCSB_inside+.mCS-3d-thick.mCSB_scrollTools_vertical,.mCSB_inside+.mCS-3d-thick-dark.mCSB_scrollTools_vertical{right:1px}.mCS-3d-thick.mCSB_scrollTools_vertical,.mCS-3d-thick-dark.mCSB_scrollTools_vertical{box-shadow:inset 1px 0 1px rgba(0, 0, 0, 0.1),inset 0 0 14px rgba(0, 0, 0, 0.5)}.mCS-3d-thick.mCSB_scrollTools_horizontal,.mCS-3d-thick-dark.mCSB_scrollTools_horizontal{bottom:1px;box-shadow:inset 0 1px 1px rgba(0, 0, 0, 0.1),inset 0 0 14px rgba(0, 0, 0, 0.5)}.mCS-3d-thick.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar,.mCS-3d-thick-dark.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar{box-shadow:inset 1px 0 0 rgba(255, 255, 255, 0.4);width:12px;margin:2px;position:absolute;height:auto;top:0;bottom:0;left:0;right:0}.mCS-3d-thick.mCSB_scrollTools_horizontal .mCSB_dragger .mCSB_dragger_bar,.mCS-3d-thick-dark.mCSB_scrollTools_horizontal .mCSB_dragger .mCSB_dragger_bar{box-shadow:inset 0 1px 0 rgba(255, 255, 255, 0.4)}.mCS-3d-thick.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar,.mCS-3d-thick.mCSB_scrollTools .mCSB_dragger:hover .mCSB_dragger_bar,.mCS-3d-thick.mCSB_scrollTools .mCSB_dragger:active .mCSB_dragger_bar,.mCS-3d-thick.mCSB_scrollTools .mCSB_dragger.mCSB_dragger_onDrag .mCSB_dragger_bar{background-color:#555}.mCS-3d-thick.mCSB_scrollTools_horizontal .mCSB_dragger .mCSB_dragger_bar,.mCS-3d-thick-dark.mCSB_scrollTools_horizontal .mCSB_dragger .mCSB_dragger_bar{height:12px;width:auto}.mCS-3d-thick.mCSB_scrollTools .mCSB_draggerContainer{background-color:#000;background-color:rgba(0, 0, 0, 0.05);box-shadow:inset 1px 1px 16px rgba(0, 0, 0, 0.1)}.mCS-3d-thick.mCSB_scrollTools .mCSB_draggerRail{background-color:transparent}.mCS-3d-thick.mCSB_scrollTools .mCSB_buttonUp{background-position:-32px -72px}.mCS-3d-thick.mCSB_scrollTools .mCSB_buttonDown{background-position:-32px -92px}.mCS-3d-thick.mCSB_scrollTools .mCSB_buttonLeft{background-position:-40px -112px}.mCS-3d-thick.mCSB_scrollTools .mCSB_buttonRight{background-position:-40px -128px}.mCS-3d-thick-dark.mCSB_scrollTools{box-shadow:inset 0 0 14px rgba(0, 0, 0, 0.2)}.mCS-3d-thick-dark.mCSB_scrollTools_horizontal{box-shadow:inset 0 1px 1px rgba(0, 0, 0, 0.1),inset 0 0 14px rgba(0, 0, 0, 0.2)}.mCS-3d-thick-dark.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar{box-shadow:inset 1px 0 0 rgba(255, 255, 255, 0.4),inset -1px 0 0 rgba(0, 0, 0, 0.2)}.mCS-3d-thick-dark.mCSB_scrollTools_horizontal .mCSB_dragger .mCSB_dragger_bar{box-shadow:inset 0 1px 0 rgba(255, 255, 255, 0.4),inset 0 -1px 0 rgba(0, 0, 0, 0.2)}.mCS-3d-thick-dark.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar,.mCS-3d-thick-dark.mCSB_scrollTools .mCSB_dragger:hover .mCSB_dragger_bar,.mCS-3d-thick-dark.mCSB_scrollTools .mCSB_dragger:active .mCSB_dragger_bar,.mCS-3d-thick-dark.mCSB_scrollTools .mCSB_dragger.mCSB_dragger_onDrag .mCSB_dragger_bar{background-color:#777}.mCS-3d-thick-dark.mCSB_scrollTools .mCSB_draggerContainer{background-color:#fff;background-color:rgba(0, 0, 0, 0.05);box-shadow:inset 1px 1px 16px rgba(0, 0, 0, 0.1)}.mCS-3d-thick-dark.mCSB_scrollTools .mCSB_draggerRail{background-color:transparent}.mCS-3d-thick-dark.mCSB_scrollTools .mCSB_buttonUp{background-position:-112px -72px}.mCS-3d-thick-dark.mCSB_scrollTools .mCSB_buttonDown{background-position:-112px -92px}.mCS-3d-thick-dark.mCSB_scrollTools .mCSB_buttonLeft{background-position:-120px -112px}.mCS-3d-thick-dark.mCSB_scrollTools .mCSB_buttonRight{background-position:-120px -128px}.mCSB_outside+.mCS-minimal.mCSB_scrollTools_vertical,.mCSB_outside+.mCS-minimal-dark.mCSB_scrollTools_vertical{right:0;margin:12px 0}.mCustomScrollBox.mCS-minimal+.mCSB_scrollTools.mCSB_scrollTools_horizontal,.mCustomScrollBox.mCS-minimal+.mCSB_scrollTools+.mCSB_scrollTools.mCSB_scrollTools_horizontal,.mCustomScrollBox.mCS-minimal-dark+.mCSB_scrollTools.mCSB_scrollTools_horizontal,.mCustomScrollBox.mCS-minimal-dark+.mCSB_scrollTools+.mCSB_scrollTools.mCSB_scrollTools_horizontal{bottom:0;margin:0 12px}.mCS-dir-rtl>.mCSB_outside+.mCS-minimal.mCSB_scrollTools_vertical,.mCS-dir-rtl>.mCSB_outside+.mCS-minimal-dark.mCSB_scrollTools_vertical{left:0;right:auto}.mCS-minimal.mCSB_scrollTools .mCSB_draggerRail,.mCS-minimal-dark.mCSB_scrollTools .mCSB_draggerRail{background-color:transparent}.mCS-minimal.mCSB_scrollTools_vertical .mCSB_dragger,.mCS-minimal-dark.mCSB_scrollTools_vertical .mCSB_dragger{height:50px}.mCS-minimal.mCSB_scrollTools_horizontal .mCSB_dragger,.mCS-minimal-dark.mCSB_scrollTools_horizontal .mCSB_dragger{width:50px}.mCS-minimal.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar{background-color:#fff;background-color:rgba(255, 255, 255, 0.2);filter:\"alpha(opacity=20)\";-ms-filter:\"alpha(opacity=20)\"}.mCS-minimal.mCSB_scrollTools .mCSB_dragger:active .mCSB_dragger_bar,.mCS-minimal.mCSB_scrollTools .mCSB_dragger.mCSB_dragger_onDrag .mCSB_dragger_bar{background-color:#fff;background-color:rgba(255, 255, 255, 0.5);filter:\"alpha(opacity=50)\";-ms-filter:\"alpha(opacity=50)\"}.mCS-minimal-dark.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar{background-color:#000;background-color:rgba(0, 0, 0, 0.2);filter:\"alpha(opacity=20)\";-ms-filter:\"alpha(opacity=20)\"}.mCS-minimal-dark.mCSB_scrollTools .mCSB_dragger:active .mCSB_dragger_bar,.mCS-minimal-dark.mCSB_scrollTools .mCSB_dragger.mCSB_dragger_onDrag .mCSB_dragger_bar{background-color:#000;background-color:rgba(0, 0, 0, 0.5);filter:\"alpha(opacity=50)\";-ms-filter:\"alpha(opacity=50)\"}.mCS-light-3.mCSB_scrollTools .mCSB_draggerRail,.mCS-dark-3.mCSB_scrollTools .mCSB_draggerRail{width:6px;background-color:#000;background-color:rgba(0, 0, 0, 0.2)}.mCS-light-3.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar,.mCS-dark-3.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar{width:6px}.mCS-light-3.mCSB_scrollTools_horizontal .mCSB_dragger .mCSB_dragger_bar,.mCS-dark-3.mCSB_scrollTools_horizontal .mCSB_dragger .mCSB_dragger_bar,.mCS-light-3.mCSB_scrollTools_horizontal .mCSB_draggerRail,.mCS-dark-3.mCSB_scrollTools_horizontal .mCSB_draggerRail{width:100%;height:6px;margin:5px 0}.mCS-light-3.mCSB_scrollTools_vertical.mCSB_scrollTools_onDrag_expand .mCSB_dragger.mCSB_dragger_onDrag_expanded+.mCSB_draggerRail,.mCS-light-3.mCSB_scrollTools_vertical.mCSB_scrollTools_onDrag_expand .mCSB_draggerContainer:hover .mCSB_draggerRail,.mCS-dark-3.mCSB_scrollTools_vertical.mCSB_scrollTools_onDrag_expand .mCSB_dragger.mCSB_dragger_onDrag_expanded+.mCSB_draggerRail,.mCS-dark-3.mCSB_scrollTools_vertical.mCSB_scrollTools_onDrag_expand .mCSB_draggerContainer:hover .mCSB_draggerRail{width:12px}.mCS-light-3.mCSB_scrollTools_horizontal.mCSB_scrollTools_onDrag_expand .mCSB_dragger.mCSB_dragger_onDrag_expanded+.mCSB_draggerRail,.mCS-light-3.mCSB_scrollTools_horizontal.mCSB_scrollTools_onDrag_expand .mCSB_draggerContainer:hover .mCSB_draggerRail,.mCS-dark-3.mCSB_scrollTools_horizontal.mCSB_scrollTools_onDrag_expand .mCSB_dragger.mCSB_dragger_onDrag_expanded+.mCSB_draggerRail,.mCS-dark-3.mCSB_scrollTools_horizontal.mCSB_scrollTools_onDrag_expand .mCSB_draggerContainer:hover .mCSB_draggerRail{height:12px;margin:2px 0}.mCS-light-3.mCSB_scrollTools .mCSB_buttonUp{background-position:-32px -72px}.mCS-light-3.mCSB_scrollTools .mCSB_buttonDown{background-position:-32px -92px}.mCS-light-3.mCSB_scrollTools .mCSB_buttonLeft{background-position:-40px -112px}.mCS-light-3.mCSB_scrollTools .mCSB_buttonRight{background-position:-40px -128px}.mCS-dark-3.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar{background-color:#000;background-color:rgba(0, 0, 0, 0.75)}.mCS-dark-3.mCSB_scrollTools .mCSB_dragger:hover .mCSB_dragger_bar{background-color:#000;background-color:rgba(0, 0, 0, 0.85)}.mCS-dark-3.mCSB_scrollTools .mCSB_dragger:active .mCSB_dragger_bar,.mCS-dark-3.mCSB_scrollTools .mCSB_dragger.mCSB_dragger_onDrag .mCSB_dragger_bar{background-color:#000;background-color:rgba(0, 0, 0, 0.9)}.mCS-dark-3.mCSB_scrollTools .mCSB_draggerRail{background-color:#000;background-color:rgba(0, 0, 0, 0.1)}.mCS-dark-3.mCSB_scrollTools .mCSB_buttonUp{background-position:-112px -72px}.mCS-dark-3.mCSB_scrollTools .mCSB_buttonDown{background-position:-112px -92px}.mCS-dark-3.mCSB_scrollTools .mCSB_buttonLeft{background-position:-120px -112px}.mCS-dark-3.mCSB_scrollTools .mCSB_buttonRight{background-position:-120px -128px}.mCS-inset.mCSB_scrollTools .mCSB_draggerRail,.mCS-inset-dark.mCSB_scrollTools .mCSB_draggerRail,.mCS-inset-2.mCSB_scrollTools .mCSB_draggerRail,.mCS-inset-2-dark.mCSB_scrollTools .mCSB_draggerRail,.mCS-inset-3.mCSB_scrollTools .mCSB_draggerRail,.mCS-inset-3-dark.mCSB_scrollTools .mCSB_draggerRail{width:12px;background-color:#000;background-color:rgba(0, 0, 0, 0.2)}.mCS-inset.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar,.mCS-inset-dark.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar,.mCS-inset-2.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar,.mCS-inset-2-dark.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar,.mCS-inset-3.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar,.mCS-inset-3-dark.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar{width:6px;margin:3px 5px;position:absolute;height:auto;top:0;bottom:0;left:0;right:0}.mCS-inset.mCSB_scrollTools_horizontal .mCSB_dragger .mCSB_dragger_bar,.mCS-inset-dark.mCSB_scrollTools_horizontal .mCSB_dragger .mCSB_dragger_bar,.mCS-inset-2.mCSB_scrollTools_horizontal .mCSB_dragger .mCSB_dragger_bar,.mCS-inset-2-dark.mCSB_scrollTools_horizontal .mCSB_dragger .mCSB_dragger_bar,.mCS-inset-3.mCSB_scrollTools_horizontal .mCSB_dragger .mCSB_dragger_bar,.mCS-inset-3-dark.mCSB_scrollTools_horizontal .mCSB_dragger .mCSB_dragger_bar{height:6px;margin:5px 3px;position:absolute;width:auto;top:0;bottom:0;left:0;right:0}.mCS-inset.mCSB_scrollTools_horizontal .mCSB_draggerRail,.mCS-inset-dark.mCSB_scrollTools_horizontal .mCSB_draggerRail,.mCS-inset-2.mCSB_scrollTools_horizontal .mCSB_draggerRail,.mCS-inset-2-dark.mCSB_scrollTools_horizontal .mCSB_draggerRail,.mCS-inset-3.mCSB_scrollTools_horizontal .mCSB_draggerRail,.mCS-inset-3-dark.mCSB_scrollTools_horizontal .mCSB_draggerRail{width:100%;height:12px;margin:2px 0}.mCS-inset.mCSB_scrollTools .mCSB_buttonUp,.mCS-inset-2.mCSB_scrollTools .mCSB_buttonUp,.mCS-inset-3.mCSB_scrollTools .mCSB_buttonUp{background-position:-32px -72px}.mCS-inset.mCSB_scrollTools .mCSB_buttonDown,.mCS-inset-2.mCSB_scrollTools .mCSB_buttonDown,.mCS-inset-3.mCSB_scrollTools .mCSB_buttonDown{background-position:-32px -92px}.mCS-inset.mCSB_scrollTools .mCSB_buttonLeft,.mCS-inset-2.mCSB_scrollTools .mCSB_buttonLeft,.mCS-inset-3.mCSB_scrollTools .mCSB_buttonLeft{background-position:-40px -112px}.mCS-inset.mCSB_scrollTools .mCSB_buttonRight,.mCS-inset-2.mCSB_scrollTools .mCSB_buttonRight,.mCS-inset-3.mCSB_scrollTools .mCSB_buttonRight{background-position:-40px -128px}.mCS-inset-dark.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar,.mCS-inset-2-dark.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar,.mCS-inset-3-dark.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar{background-color:#000;background-color:rgba(0, 0, 0, 0.75)}.mCS-inset-dark.mCSB_scrollTools .mCSB_dragger:hover .mCSB_dragger_bar,.mCS-inset-2-dark.mCSB_scrollTools .mCSB_dragger:hover .mCSB_dragger_bar,.mCS-inset-3-dark.mCSB_scrollTools .mCSB_dragger:hover .mCSB_dragger_bar{background-color:#000;background-color:rgba(0, 0, 0, 0.85)}.mCS-inset-dark.mCSB_scrollTools .mCSB_dragger:active .mCSB_dragger_bar,.mCS-inset-dark.mCSB_scrollTools .mCSB_dragger.mCSB_dragger_onDrag .mCSB_dragger_bar,.mCS-inset-2-dark.mCSB_scrollTools .mCSB_dragger:active .mCSB_dragger_bar,.mCS-inset-2-dark.mCSB_scrollTools .mCSB_dragger.mCSB_dragger_onDrag .mCSB_dragger_bar,.mCS-inset-3-dark.mCSB_scrollTools .mCSB_dragger:active .mCSB_dragger_bar,.mCS-inset-3-dark.mCSB_scrollTools .mCSB_dragger.mCSB_dragger_onDrag .mCSB_dragger_bar{background-color:#000;background-color:rgba(0, 0, 0, 0.9)}.mCS-inset-dark.mCSB_scrollTools .mCSB_draggerRail,.mCS-inset-2-dark.mCSB_scrollTools .mCSB_draggerRail,.mCS-inset-3-dark.mCSB_scrollTools .mCSB_draggerRail{background-color:#000;background-color:rgba(0, 0, 0, 0.1)}.mCS-inset-dark.mCSB_scrollTools .mCSB_buttonUp,.mCS-inset-2-dark.mCSB_scrollTools .mCSB_buttonUp,.mCS-inset-3-dark.mCSB_scrollTools .mCSB_buttonUp{background-position:-112px -72px}.mCS-inset-dark.mCSB_scrollTools .mCSB_buttonDown,.mCS-inset-2-dark.mCSB_scrollTools .mCSB_buttonDown,.mCS-inset-3-dark.mCSB_scrollTools .mCSB_buttonDown{background-position:-112px -92px}.mCS-inset-dark.mCSB_scrollTools .mCSB_buttonLeft,.mCS-inset-2-dark.mCSB_scrollTools .mCSB_buttonLeft,.mCS-inset-3-dark.mCSB_scrollTools .mCSB_buttonLeft{background-position:-120px -112px}.mCS-inset-dark.mCSB_scrollTools .mCSB_buttonRight,.mCS-inset-2-dark.mCSB_scrollTools .mCSB_buttonRight,.mCS-inset-3-dark.mCSB_scrollTools .mCSB_buttonRight{background-position:-120px -128px}.mCS-inset-2.mCSB_scrollTools .mCSB_draggerRail,.mCS-inset-2-dark.mCSB_scrollTools .mCSB_draggerRail{background-color:transparent;border-width:1px;border-style:solid;border-color:#fff;border-color:rgba(255, 255, 255, 0.2);-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box}.mCS-inset-2-dark.mCSB_scrollTools .mCSB_draggerRail{border-color:#000;border-color:rgba(0, 0, 0, 0.2)}.mCS-inset-3.mCSB_scrollTools .mCSB_draggerRail{background-color:#fff;background-color:rgba(255, 255, 255, 0.6)}.mCS-inset-3-dark.mCSB_scrollTools .mCSB_draggerRail{background-color:#000;background-color:rgba(0, 0, 0, 0.6)}.mCS-inset-3.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar{background-color:#000;background-color:rgba(0, 0, 0, 0.75)}.mCS-inset-3.mCSB_scrollTools .mCSB_dragger:hover .mCSB_dragger_bar{background-color:#000;background-color:rgba(0, 0, 0, 0.85)}.mCS-inset-3.mCSB_scrollTools .mCSB_dragger:active .mCSB_dragger_bar,.mCS-inset-3.mCSB_scrollTools .mCSB_dragger.mCSB_dragger_onDrag .mCSB_dragger_bar{background-color:#000;background-color:rgba(0, 0, 0, 0.9)}.mCS-inset-3-dark.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar{background-color:#fff;background-color:rgba(255, 255, 255, 0.75)}.mCS-inset-3-dark.mCSB_scrollTools .mCSB_dragger:hover .mCSB_dragger_bar{background-color:#fff;background-color:rgba(255, 255, 255, 0.85)}.mCS-inset-3-dark.mCSB_scrollTools .mCSB_dragger:active .mCSB_dragger_bar,.mCS-inset-3-dark.mCSB_scrollTools .mCSB_dragger.mCSB_dragger_onDrag .mCSB_dragger_bar{background-color:#fff;background-color:rgba(255, 255, 255, 0.9)}.fast-reorder{width:100% !important;padding:15px 3em 5em !important}.fast-reorder a{margin-bottom:-15px}.fast-reorder .notice-reorder{display:block;margin-top:20px;font-size:12px}.fast-reorder table{width:100%}.fast-reorder table tbody tr.header{border-bottom:1px solid #dbe5df}.fast-reorder table tbody tr.header th{font-size:12px;font-family:\"Geist\";font-weight:600;color:#4a5f54;padding:5px 0;text-align:left;line-height:3.865;text-align:left}.fast-reorder table tbody tr.item{font-size:13px;font-family:\"Geist\";color:#0b2318;font-weight:bold;line-height:2.719;text-align:left;border-bottom:1px solid #dbe5df}.fast-reorder table tbody tr.item .date{padding-right:20px;font-size:13px;font-family:\"Geist\";color:#0b2318;font-weight:bold;line-height:2.719;text-align:left}.fast-reorder table tbody tr.item .restaurant-name{font-size:15px;font-family:\"Geist\";color:#0b2318;font-weight:bold;line-height:23px;text-align:left;width:20%}.fast-reorder table tbody tr.item .price{width:9%;font-size:15px}.fast-reorder table tbody tr.item .items-order a:last-child{padding-bottom:6px}.fast-reorder table tbody tr.item .items-order article{padding:0 !important;width:100% !important}.fast-reorder table tbody tr.item .items-order article header{justify-content:flex-start;border-bottom:0}.fast-reorder table tbody tr.item .items-order article header h3{font-size:15px;font-family:\"Geist\";color:#0b2318;font-weight:bold;line-height:2.356;text-align:left}.fast-reorder table tbody tr.item .items-order article header ul li{font-size:13px;font-family:\"Geist\";font-weight:500}.fast-reorder table tbody tr.item .items-order article header ul li:hover{color:#4a5f54 !important;background:unset !important}.fast-reorder table tbody tr.item .items-order article header ul li:first-child:before{content:\"\";display:inline-block;width:3px;height:3px;background:#0b2318;border-radius:30px;margin:0 .2em 0 0;margin-left:6px}.fast-reorder table tbody tr.item .items-order article header ul li span{font-size:13px}.fast-reorder table tbody tr.item .items-order article p{font-size:13px;font-family:\"Geist\";color:#0b2318;line-height:1.273;text-align:left;font-weight:500}.fast-reorder table tbody tr.item .repeat{padding-left:5px;border-bottom:1px solid rgba(0,0,0,0);height:100%}.fast-reorder table tbody tr.item .repeat a{font-size:13.615px;font-family:\"Geist\";color:#0e7a4b;font-weight:bold;line-height:1.505;text-align:left}.fast-reorder table tbody tr.item .repeat a:before{content:\"\";width:18px;height:20px;background:url(" + __webpack_require__(328) + ");background-size:contain;background-repeat:no-repeat;display:block;margin:0 auto}.fast-reorder a:hover article li{color:unset;background:unset}.fast-reorder a:hover article ul li:before{color:unset;background:unset}.list-items.fast-reorder.cart-open{width:72% !important;padding:15px 1em 5em !important}.fast-reorder-mobile{padding:1.5em 1.3em 0em !important}.fast-reorder-mobile li{width:100%;height:auto;display:table;padding-bottom:18px;margin-bottom:20px;font-size:13px;font-family:\"Geist\";color:#0b2318;text-align:left;border-bottom:1px solid #dbe5df}.fast-reorder-mobile li:last-child{border-bottom:0}.fast-reorder-mobile li .text-cinza{padding-right:20px;font-size:13px;font-family:\"Geist\";color:#4a5f54;font-weight:bold;line-height:1.719;display:block;float:left;width:100%}.fast-reorder-mobile li .text-destaque{font-size:15px;font-family:\"Geist\";color:#0b2318;font-weight:bold;display:block;float:left;width:100%;margin-top:-5px}.fast-reorder-mobile li .size-12{font-size:12px;float:left;display:block}.fast-reorder-mobile li .pedidos{width:100%;height:auto;display:table}.fast-reorder-mobile li .pedidos li{width:100%;height:auto;display:table;border:0;padding-bottom:15px;margin-bottom:0}.fast-reorder-mobile .repeat{font-size:13.615px;font-family:\"Geist\";color:#0e7a4b;font-weight:bold;text-align:left;display:table !important;float:left !important;width:auto !important;clear:both;padding-bottom:18px;padding-left:25px;position:relative}.fast-reorder-mobile .repeat:before{content:\"\";width:18px;height:20px;background:url(" + __webpack_require__(328) + ");background-size:contain;background-repeat:no-repeat;display:block;position:absolute;top:0;left:0}html,body{font-family:\"Geist\",sans-serif;color:#0b2318;font-size:14px;letter-spacing:-0.5px}a{color:#0b2318}[aria-invalid=true]{border-color:#c22525}h3{font-size:14px;color:#0b2318}h3.b{font-weight:bold}.sticky-wrapper.mCustomScrollbar #mCSB_1_container{margin:0}.mCSB_scrollTools{z-index:11}.mCSB_scrollTools:hover,.mCSB_scrollTools.mCSB_scrollTools_onDrag{visibility:visible}.mCSB_scrollTools:hover .mCSB_dragger .mCSB_dragger_bar,.mCSB_scrollTools.mCSB_scrollTools_onDrag .mCSB_dragger .mCSB_dragger_bar{opacity:.75}.mCSB_scrollTools:hover .mCSB_draggerRail,.mCSB_scrollTools.mCSB_scrollTools_onDrag .mCSB_draggerRail{opacity:1}.nav-up{top:-300px}.nav-down{top:0px}.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar{position:relative;width:8px !important;height:100%;margin:0 auto;-webkit-border-radius:16px;-moz-border-radius:16px;border-radius:16px;text-align:center}.mCS-dark.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar{background-color:#000;background-color:rgba(160,160,160,.75)}.mCSB_scrollTools .mCSB_draggerRail{width:8px;height:100%;margin:0 auto;-webkit-border-radius:16px;-moz-border-radius:16px;border-radius:18px}.smoother,.transform{transition:none}.animate-offset{opacity:0;transition:all ease 2s}.animate-offset.animate{opacity:1}.bootstrap-select.btn-group>.dropdown-toggle{background:rgba(0,0,0,0);border:1px solid rgba(0,0,0,0);padding:1px 15px;line-height:34px;outline:none;position:relative;direction:rtl}.bootstrap-select.btn-group>.dropdown-toggle .caret{width:8px;height:8px;border:1px solid rgba(0,0,0,.2);border-top-color:rgba(0,0,0,0);border-right-color:rgba(0,0,0,0);transform:rotate(-45deg);margin-top:-6px}select{direction:rtl;margin-right:10px}.bootstrap-select:not([class*=col-]):not([class*=form-control]):not(.input-group-btn){width:41px;height:25px;font-size:12px;position:relative;border-radius:8px;border:1px solid #769885;margin-right:5px;position:relative;direction:rtl}.bootstrap-select .dropdown-toggle:focus{outline:none !important}.bootstrap-select.btn-group .dropdown-toggle .filter-option{font-size:14px;color:#0b2318;background:none}select.bootstrap-select{font-weight:600}.bootstrap-select.btn-group .dropdown-menu{display:none;position:absolute;top:0;left:0;z-index:1;font-size:12px;border:1px solid #769885;background:#fff}.bootstrap-select.btn-group .dropdown-menu.open{display:block;z-index:99}.bootstrap-select.btn-group .dropdown-menu.inner{max-height:183px !important}.bootstrap-select.btn-group .dropdown-menu .dropdown-menu{display:block;padding:5px 0 6px}.bootstrap-select.btn-group .dropdown-menu .dropdown-menu a{padding:0 15px;line-height:25px;display:block;color:#0b2318}.bootstrap-select.btn-group .dropdown-menu .dropdown-menu a:hover,.bootstrap-select.btn-group .dropdown-menu .dropdown-menu a:focus{background:rgba(0,0,0,0);color:rgba(0,0,0,.5)}.bootstrap-select.btn-group .dropdown-menu .dropdown-menu .selected a{background:rgba(0,0,0,0);color:rgba(0,0,0,.5)}.bootstrap-select>.dropdown-toggle{border-color:rgba(0,0,0,.5)}.bootstrap-select.btn-group .dropdown-menu{background:#fff;border-color:rgba(0,0,0,.5)}.first-item{padding-left:8%}.total{margin-bottom:-5px}.subsidy{margin-bottom:-5px}.sub-total{margin-bottom:-5px}.wrap{margin:0 auto;width:1280px;display:table}.wrap .slick-dots{bottom:8px;position:absolute;text-align:center;width:100%}.wrap .slick-dots li{margin:0 2px;text-align:center;width:16px}.wrap .slick-dots li button{background:#dbe5df;border-radius:15px;height:11px;margin:4px 5px 0;padding:0;width:11px;transition:all .2s ease}.wrap .slick-dots li button:hover{background:#769885}.wrap .slick-dots .slick-active button{background:#0e7a4b !important}.principal-left{border-left:1px solid #dbe5df;float:left;width:18%;height:100%;display:table;position:relative}.principal-left:after{content:\"\";position:absolute;height:100%;width:14px;right:-15px;top:0;background:url(" + __webpack_require__(329) + ") repeat-y}.vr ul li:nth-child(1){margin-top:-1px}.vr .menu-nav li a{padding:0;font-weight:600}.vr aside nav .menu-nav{margin-left:8px}.vr aside nav .menu-nav>li ul{margin-top:20px}.vr aside nav .menu-nav .active:before{margin-left:-12px}.principal-right{float:right;width:82%;height:auto;display:table;position:relative}.principal-right:before{content:\"\";position:absolute;left:0;top:0;width:14px;height:100%;background:url(" + __webpack_require__(329) + ") repeat-y}.principal-right .list-items{float:left;width:81%;height:100%;padding:0 5em 5em;transition:.3s all ease-in-out;position:relative;background:#fff}.principal-right .list-items:before{content:\"\";position:absolute;left:0;top:0;width:1px;height:100%;background-color:#dbe5df}.principal-right .list-items.wallet:before,.principal-right .list-items.settings:before{position:static}.principal-right .list-items a{display:inline-block;width:100%}.principal-right .list-items a:hover article{color:#0e7a4b}.principal-right .list-items a:hover article p{color:#0e7a4b}.principal-right .list-items a:hover article li{color:#0e7a4b}.principal-right .list-items a:hover article ul li:before{background:#0e7a4b}.principal-right .list-items a:hover article .tooltip{border-bottom:.5px solid #0e7a4b}.principal-right .list-items a:hover article h3{color:#0e7a4b}.principal-right .list-items .menu-inactive:hover article{cursor:default !important}.principal-right .list-items .menu-inactive:hover article li{color:#4a5f54}.principal-right .list-items .menu-inactive:hover article h3{color:#4a5f54}.principal-right .list-items .menu-inactive:hover article p{color:#4a5f54}.principal-right .list-items .menu-inactive:hover article ul li:before{background:#4a5f54}.principal-right .list-items .menu-inactive:hover article .tooltip{color:#4a5f54;border-bottom:.5px solid #769885}.principal-right .list-items article{display:flex;flex-direction:column;float:left;padding:1.5em 3em 0em;width:100%}.principal-right .list-items article header{display:flex;justify-content:space-between;align-items:center;border-bottom:1px solid #dbe5df;transition:.2s}.principal-right .list-items article header h3,.principal-right .list-items article header p{font-weight:bold;transition:.2s}.principal-right .list-items article header p{font-size:15px;margin:0}.principal-right .list-items article p{margin:0 0 3px;font-size:13px;transition:.2s}.principal-right .list-items article ul{display:flex;margin-top:4px}.principal-right .list-items article ul li:nth-child(1)::before{display:none}.principal-right .list-items article ul li{margin:0 .5em 0 0;display:flex;align-items:center;transition:.2s}.principal-right .list-items article ul li a{text-decoration:underline}.principal-right .list-items article ul li::before{content:\"\";display:inline-block;width:3px;height:3px;background:#0b2318;border-radius:30px;margin:0 .2em 0 0}.principal-right .list-items article ul .tooltip{display:inline-block;border-bottom:.5px solid #0b2318}.principal-right .list-items .main-content .list-items{background:#fff}.principal-right .list-items .restaurant-name-home{text-transform:uppercase;font-size:12px;font-weight:600;margin-left:8px}.slick-list,.slick-track{height:100%}.featured-item{display:block;float:left;margin-bottom:10px;width:25%;text-align:center}.featured-item-figure{height:130px}.featured-item-figure img{margin:0 auto;max-height:130px;max-width:210px}.featured-item-sep{background:#dbe5df;height:1px;margin:18px auto 20px;width:210px}.featured-item-sep:before{background:url(" + __webpack_require__(138) + ");background-position:-358px 0;content:\"\";display:block;height:7px;position:relative;width:80px;top:-3px}.featured-item-ref{color:#0b2318;font-size:14px;margin-bottom:4px;height:41px;margin:0 auto;width:210px}.featured-item-oldprice{color:#4a5f54;font-size:12px;text-decoration:line-through;height:14px}.featured-item-price{color:#0b2318;font-size:14px}.featured-item-parcel{font-size:20px;color:#0b2318}.message-error{color:#c22525;line-height:140%}.lazy-container>*{opacity:0}.lazy-container>*.b-loaded{animation:fadeIn 1s forwards;opacity:1}.no-bg{background:rgba(11,11,11,.79) !important}.top-header.checkout:before{height:100px !important}.close-filter .header-restaurant a.cart-bar{z-index:2}.close-filter .header-restaurant .infos{z-index:unset}.close-filter .header-restaurant h1{z-index:20}.close-filter .infos .left{z-index:20}.close-filter .tooltip{z-index:1}.close-filter:before{content:\"\";position:fixed;top:0;display:table;width:77.9%;background:rgba(121,121,121,.33);z-index:9;height:100%}.top-header:before{background:rgba(0,0,0,.6);content:\"\";width:77.9%;height:150px;top:0;display:block;position:absolute;z-index:0}@media only screen and (max-width: 1281px){.close-filter:before{width:81.9% !important}}@media only screen and (max-width: 768px){.main-content{padding-top:6cm}}@media only screen and (min-width: 1426px){.close-filter:before{width:1049px}.top-header:before{background:rgba(0,0,0,.5);content:\"\";width:1049px;height:150px;top:0;display:block;position:absolute;z-index:0}.top-header:before{width:1049px}}@media only screen and (max-width: 1091px){.close-filter:before{width:73.2%}}@media only screen and (max-width: 768px){.close-filter:before{width:100%;top:0px}.top-header:before{width:100%;height:125px;top:57px}.top-header{width:100%}}@media only screen and (max-width: 510px){.top-header:before{width:100%;top:0}.top-header{width:100%}}@media only screen and (max-width: 1281px){#login6{padding:2.5em 4em 6em !important}}@media only screen and (min-width: 1280px)and (max-width: 1290px){.top-header:before{width:81.9%}.top-header{width:81.9% !important}}.my-mfp-zoom-in .zoom-anim-dialog{opacity:0;-webkit-transition:all .2s ease-in-out;-moz-transition:all .2s ease-in-out;-o-transition:all .2s ease-in-out;transition:all .2s ease-in-out;-webkit-transform:scale(0.8);-moz-transform:scale(0.8);-ms-transform:scale(0.8);-o-transform:scale(0.8);transform:scale(0.8)}.my-mfp-zoom-in.mfp-ready .zoom-anim-dialog{opacity:1 !important;-webkit-transform:scale(1) !important;-moz-transform:scale(1) !important;-ms-transform:scale(1) !important;-o-transform:scale(1) !important;transform:scale(1) !important}.my-mfp-zoom-in.mfp-removing .zoom-anim-dialog{-webkit-transform:scale(0.8) !important;-moz-transform:scale(0.8) !important;-ms-transform:scale(0.8) !important;-o-transform:scale(0.8) !important;transform:scale(0.8) !important;opacity:0 !important}.my-mfp-zoom-in.mfp-bg{opacity:0 !important;-webkit-transition:opacity .2s ease-out !important;-moz-transition:opacity .2s ease-out !important;-o-transition:opacity .2s ease-out !important;transition:opacity .2s ease-out !important}.my-mfp-zoom-in.mfp-ready.mfp-bg{opacity:.8 !important}.my-mfp-zoom-in.mfp-removing.mfp-bg{opacity:0 !important}.mfp-content{max-width:630px !important;border-radius:6px !important}.mfp-content .btn{margin:20px 0 0 !important}.mfp-bg{background:url(" + __webpack_require__(978) + ") !important;background-size:cover !important;background-repeat:no-repeat !important;background-position:center !important;height:100% !important}.my-mfp-zoom-in.mfp-ready.mfp-bg{opacity:1 !important}.modal{display:none;position:fixed;z-index:1;padding-top:1em;padding-bottom:1em;left:0;top:0;width:100%;height:100%;overflow:auto;background-color:rgba(0,0,0,.73)}.modal-content aside .menu-nav{padding:0}.modal-content aside .menu-nav li a{padding-left:1%}.modal-content aside{height:unset}.btn-close{background:url(/static/media/plus.84136092.svg) no-repeat center center;border:none;padding:20px;position:absolute;top:0;right:5px;transform:rotate(45deg)}.menu-left .btn-close{display:none}.cart-menu-category-overlay{position:fixed;top:0px;left:0px;right:0px;bottom:0px;background-color:rgba(0,0,0,.7);z-index:1100;width:100%;height:100%;display:none}.modal-content{position:relative;background-color:#fff;margin:auto;padding:0;overflow:hidden;width:100%;max-width:500px;padding:48px;border-radius:6px}.modal-content button.orange-bold{font-weight:bold}.modal-content .additional-content h4{font-size:16px;font-weight:bold;margin-top:20px;display:inline-block;margin-bottom:4px}.modal-content .additional-content textarea{height:40%;border-radius:6px;border:1px solid #0b2318;padding:1em;margin-top:15px;margin-bottom:11px}.modal-content article{display:flex;flex-direction:column;float:left;width:100%;transition:.3s}.modal-content article header{display:flex;align-items:center;border-bottom:1px solid #dbe5df}.modal-content article header h3{font-weight:bold;font-size:25px;display:block;margin-bottom:6px;letter-spacing:-1px}.modal-content article header span{font-size:14px;color:#4a5f54;font-weight:600;text-transform:uppercase;margin:3px 0 0 8px;letter-spacing:-1px}.modal-content article p{margin:0 0 20px;font-size:15px;line-height:19px;white-space:nowrap;text-overflow:ellipsis;overflow:hidden}.modal-content article ul{display:flex;margin-top:6px;margin-bottom:6px}.modal-content article ul li:nth-child(1)::before{display:none}.modal-content article ul li{margin:0 .5em 0 0;display:flex;align-items:center;font-size:15px}.modal-content article ul li a{text-decoration:underline}.modal-content article ul li::before{content:\"\";display:inline-block;width:3px;height:3px;background:#0b2318;border-radius:30px;margin:0 .2em 0 0}.modal-content article ul .tooltip{display:inline-block;border-bottom:.5px solid #0b2318}.modal-content .choice{margin-bottom:25px}.modal-content .choice .singup input[type=radio]+label:before{border-radius:0 !important}.modal-content .choice h4{font-size:16px;display:block;margin-bottom:-7px}.modal-content .choice label:before{border:1px solid #769885 !important;content:\"\"}.modal-content .choice label{margin-bottom:-0.8em;padding-left:35px !important;font-size:16px}.modal-content .choice label b{font-weight:600}.modal-content .choice input[type=checkbox],.modal-content .choice input[type=radio]{display:block;width:17px;margin:0;height:20px;padding:0;position:relative;top:20px;left:1px;z-index:1;opacity:0;cursor:pointer;margin-top:-1px}.close{color:#0b2318;position:absolute;z-index:90;top:80px;right:25px;font-size:35px;font-weight:bold}.close-button{position:absolute;right:20px !important;top:20px !important;line-height:50%}.close:hover,.close:focus{color:#4a5f54;text-decoration:none;cursor:pointer}.modal-page .btn{margin:20px 0 0px}.modal-page h3{text-align:center;font-size:18px;font-weight:bold;margin-bottom:15px;margin-top:15px}label.terms b{margin-left:10px;display:block}.lb-padrao-singup1 .btn{width:100% !important;max-width:240px}.lb-padrao-singup1 .cintas-terms-conditions-description{height:290px}.lb-padrao-singup1 .cintas-terms-conditions-description .content{padding-top:.2em}.lb-padrao-singup1 .cintas-terms-conditions-description .content p{font-size:15.23px}.lb-padrao-singup1 .cintas-terms-conditions-description::-webkit-scrollbar{width:5px}.lb-padrao-singup1 .cintas-terms-conditions-description::-webkit-scrollbar-thumb{background:#769885}.lb-padrao-singup1 .cintas-terms-conditions-description::-webkit-scrollbar-thumb:hover{background:#4a5f54}.lb-padrao-singup1 .cintas-terms-conditions-description::-webkit-scrollbar-thumb:active{background:#0b2318}.lb-padrao-singup1 img{display:block;margin:0 auto;padding-bottom:57px}.lb-padrao-singup1 h3{text-align:left;font-size:18px;font-weight:bold;margin-bottom:20px}.lb-padrao-singup1 label{margin-top:29px;margin-bottom:29px}#login2 label.singup{padding-left:38px;font-size:15px;font-weight:600}.lb-padrao-singup2 input[type=checkbox],.lb-padrao-singup2 input[type=radio]{display:block;width:17px;margin:0;height:20px;padding:0;position:relative;top:22px !important;left:3px !important;z-index:1;opacity:0;cursor:pointer;margin-top:-1px}.lb-padrao-singup2 .btn{margin-top:120px !important;width:100% !important;max-width:240px}.lb-padrao-singup2 img{display:block;margin:0 auto;padding-bottom:120px}.lb-padrao-singup2 h3{text-align:left;font-size:18px;font-weight:bold;margin-bottom:20px}.lb-padrao-singup3 img{display:block;margin:0 auto;padding-bottom:120px}.lb-padrao-singup3 h3{text-align:left;font-size:18px;font-weight:bold}.lb-padrao-singup3 .btn{font-size:14px;font-family:Source Sans Pro}.flex-row{width:calc(50% - 10px);float:left;margin:5px}#login4 p{text-align:center;font-weight:600;font-size:13px}.lb-padrao-singup4 img{display:block;margin:0 auto;padding-bottom:72px}.lb-padrao-singup4 h3{text-align:left;font-size:18px;font-weight:bold;margin-bottom:30px}.lb-padrao-singup4 input{border:1px solid #769885;border-radius:8px;margin-bottom:33px;-webkit-appearance:none}.lb-padrao-singup4 label{color:#769885;margin:0 0 10px 0;display:block}.lb-padrao-singup4 .btn{margin-top:70px !important;width:100% !important;max-width:240px}.fa-times:before{margin-left:15px !important;display:block !important;margin-top:15px !important;margin-bottom:0 !important}#login5{width:100%;margin:0 auto;padding:2.5em 4em 2.5em;border-radius:8px}.lb-padrao-singup5 img{display:block;margin:0 auto;padding-bottom:72px}.lb-padrao-singup5 h3{text-align:left;font-size:18px;font-weight:bold;margin-bottom:30px}.lb-padrao-singup5 input{border:1px solid #769885;border-radius:8px;margin-bottom:33px}.lb-padrao-singup5 label{color:#769885;margin:0 0 10px 0;display:block}.lb-padrao-singup5 .btn{margin-top:70px !important;width:100% !important;max-width:240px}.lb-padrao-singup6 img{display:block;margin:0 auto;padding-bottom:72px}.lb-padrao-singup6 h3{text-align:center;font-size:18px;font-weight:bold;margin-bottom:72px}.lb-padrao-singup6 .mail-icon{padding-top:39px;padding-bottom:29px}.lb-geral.lb-error_ .modal-content .bt-close:before{color:#c22525}.lb-geral.lb-receipt_ .modal-content .bt-close:before,.lb-geral.lb-placed_ .modal-content .bt-close:before{color:#075c38}.lb-geral.lb-receipt_ .modal-content{width:594px}.lb-geral.lb-receipt_ .modal-content .bt{background-color:#0e7a4b}.lb-geral.lb-receipt_ .modal-content .check-mark{background-color:#eaf5ee;color:#075c38}.lb-geral.lb-receipt_ .modal-content .check-mark .lt-success-tick{font-size:56px;line-height:67px}.lb-geral.lb-receipt_ .modal-content .lb-content .bt{display:inline-block;margin:40px 0 0 0;padding:10px 115px}.lb-geral.lb-placed_ .modal-content{width:303px}.lb-geral.lb-placed_ .modal-content .bt{background-color:#0e7a4b}.lb-geral.lb-placed_ .modal-content .check-mark{background-color:#eaf5ee;color:#075c38}.lb-geral.lb-placed_ .modal-content .check-mark .lt-success-tick{font-size:56px;line-height:67px}.lb-geral.lb-placed_ .modal-content .lb-content{padding:35px 15px}.lb-geral.lb-placed_ .modal-content .lb-content .order{margin:0 0 25px 0}.lb-geral.lb-error_ .modal-content{width:303px}.lb-geral.lb-error_ .modal-content .bt{background-color:#0e7a4b;text-transform:none}.lb-geral.lb-error_ .modal-content .check-mark{background-color:#fdecec;color:#c22525}.lb-geral.lb-error_ .modal-content .check-mark .lt-error-icon{font-size:56px;line-height:67px}.lb-geral.lb-error_ .modal-content .lb-content{padding:35px 15px}.lb-geral.lb-error_ .modal-content .lb-content .order{margin:0 0 50px 0}.lb-geral.lb-cart-message_ .modal-content{width:315px}.lb-geral.lb-cart-message_ .modal-content .check-mark{background-color:#0e7a4b}.lb-geral.lb-cart-message_ .modal-content .lb-content{padding:35px}.lb-geral.lb-cart-message_ .modal-content .lb-content .order strong{display:block;margin:0 0 25px 0}.lb-geral.lb-cart-message_ .modal-content .lb-content .no-yes{margin:40px 0 0 0}.lb-geral.lb-cart-message_ .modal-content .lb-content .bt.no,.lb-geral.lb-cart-message_ .modal-content .lb-content .bt.yes{float:left;margin:0;padding:4.8% 17.7%}.lb-geral.lb-cart-message_ .modal-content .lb-content .bt.no{background-color:#c22525;margin:0 15px 0 0}.lb-geral.lb-cart-message_ .modal-content .lb-content .bt.yes{background-color:#0e7a4b}.lb-geral .modal-content{padding:0;text-align:center}.lb-geral .modal-content .bt-close{opacity:1;right:0}.lb-geral .modal-content .bt-close:before{color:#fff;margin:0 !important}.lb-geral .modal-content .bt{border-radius:6px;color:#fff;display:block;font-weight:700;padding:10px;transition:.35s}.lb-geral .modal-content .bt:hover{opacity:.8}.lb-geral .modal-content img{padding:0}.lb-geral .modal-content .check-mark{border-top-left-radius:5px;border-top-right-radius:5px;padding:30px 0}.lb-geral .modal-content .lb-content{font-size:1.0714285714em;line-height:18px;padding:30px}.lb-geral .modal-content .lb-content .order{display:block;font-size:1.1em}.lb-geral .modal-content .lb-content .view{display:block;font-size:.8666666667em;margin:25px 0;text-decoration:underline}.lb-geral .modal-content .lb-content .purchase{text-align:left}.lb-geral .modal-content .lb-content .purchase h3{font-weight:700;font-size:1.6em;margin:0 0 20px 0;text-align:left}.lb-geral .modal-content .lb-content .purchase .thank-you{color:#0e7a4b;font-size:1.2em}.lb-geral .modal-content .lb-content .purchase .order-date{display:block;font-weight:600;font-size:.8em;margin:20px 0}.lb-geral .modal-content .lb-content .purchase .delivery .head{font-weight:600}.lb-geral .modal-content .lb-content .purchase .delivery .content:before,.lb-geral .modal-content .lb-content .purchase .delivery .content:after{background-color:#dbe5df;content:\"\";display:inline-block;height:1px;width:100%;margin:20px 0}.lb-geral .modal-content .lb-content .purchase .delivery .content .bloco{margin:0 0 30px 0}.lb-geral .modal-content .lb-content .purchase .delivery .content .bloco span{display:block;font-size:.8666666667em}.lb-geral .modal-content .lb-content .purchase .delivery .content .bloco:last-child{margin:0}.lb-geral .modal-content .lb-content .purchase .delivery .foot .total{font-weight:700}.wrapper:before,.wrapper:after{content:\"\";display:table}.wrapper:after{clear:both}select{border:1px solid #dbe5df !important;border-radius:8px;font-size:14px;font-weight:600;color:#0b2318;margin:0 6px 0 0;-moz-appearance:none}.styled-select{-webkit-box-sizing:border-box;box-sizing:border-box;border-radius:8px;position:relative;-moz-appearance:none}.fa.fa-angle-down{font-size:11px;padding-right:7px !important}.styled-select,.styled-select select{width:240px}select:focus{outline:none}.styled-select select{height:29px;padding:0px 0 0px 0px;background:rgba(0,0,0,0);border:none;-webkit-appearance:none}@-moz-document url-prefix(){.styled-select select{width:110%}}.fa-angle-down{position:absolute;top:9px;right:16px;font-size:11px !important}select::-ms-expand{display:none}_:-o-prefocus .styled-select,.selector .styled-select{background:none}@media only screen and (max-width: 1024px){.wrap{width:100% !important}.lb-padrao{width:100%}.mfp-wrap{z-index:9999 !important}.close-filter:before{width:78.2%}.mfp-content{width:97% !important;padding-top:1em !important}.cart-page{width:100% !important}#login1{padding:2em 3em 2em}.modal{padding-top:0px;z-index:99999}.modal .modal-content{width:100%}.principal-right .list-items{padding:0 15px 6em !important}.principal-right .list-items article{padding:1em 0}.principal-right .list-items.fast-reorder-mobile{padding-top:20px !important}.first-item{padding-left:0}.menu-open .cart-menu-category-overlay,.cart-open .cart-menu-category-overlay{display:block}.menu-left .btn-close{display:block}}@media only screen and (max-width: 500px){.principal-right .list-items .restaurant-name-home{width:100%;padding:6px 0}.lb-padrao-singup4 .btn{margin-top:20px !important;width:100% !important;max-width:240px}.mfp-bg{z-index:5000 !important}.modal-content{padding:22px}.mfp-wrap{top:0 !important}.wrap{width:100% !important}.lb-padrao{width:100%}.mfp-wrap{z-index:9999 !important}.mfp-content{width:97% !important;padding-top:1em}.principal-right{width:100%;padding-top:4em;padding-bottom:3em}.cart-page{width:100% !important}#login1{padding:1em 2em 1em}.modal{padding-top:0px;z-index:99999}.modal .modal-content{width:100%}}.m-center{width:100%;display:block;margin:0 auto;text-align:center}@media only screen and (max-width: 1279px){.wrap{width:100%}}@media only screen and (max-width: 1024px){.modal-content{width:100%}.modal{padding-top:20px}.home .wrap{width:95% !important}}@media only screen and (max-width: 768px){.home .wrap{width:95% !important}.lb-padrao{width:100%}.mfp-wrap{z-index:9999 !important}.mfp-content{width:97% !important}.principal-right{width:100%;padding-top:4em;padding-bottom:3em}.cart-page{width:100% !important}#login1,#login2,#login4,#login5,#login6{padding:1em 2em 1em;width:95%}#login3{padding:1em 2em 5em;max-width:95%}.lb-padrao-singup2 img{padding-bottom:69px}.lb-padrao-singup3 img{padding-bottom:83px}.lb-padrao-singup4 input{margin-bottom:6px}.lb-padrao-singup5 input{margin-bottom:13px}.modal-content article header span{margin:3px 0 6px 0}.modal-content article header{align-items:left;flex-direction:column}.modal{padding-top:0px;z-index:99999}.modal .modal-content{width:100%}}@media only screen and (max-width: 1024px){body,html{overflow-x:initial !important}.principal-right .main-content{padding-top:6em;width:100%}.principal-right .vr{z-index:9999;position:relative}html.lt-support-on .principal-right .vr{z-index:1000}aside{position:fixed !important;z-index:9999;bottom:0;height:auto !important;left:0;width:100% !important}aside .menu-nav{background:#fff;display:table;-webkit-box-shadow:0px 0px 40px 0px rgba(0,0,0,.4);-moz-box-shadow:0px 0px 40px 0px rgba(0,0,0,.4);box-shadow:0px 0px 40px 0px rgba(0,0,0,.4);z-index:1;margin:0 !important;padding:0;text-align:center}aside .menu-nav>li{margin:0 !important;width:33.334%;display:table-cell}aside .menu-nav>li>b{display:block;background:#fff;padding:18px 10px;position:relative;width:100%;z-index:1;bottom:0;margin:0}.menu-left .menu-nav ul[class^=submenu],aside .menu-nav>li ul{background:#fff;margin:0 15px !important;overflow-y:auto;display:block;position:fixed;bottom:-200%;transition:.5s all ease;-webkit-transition:.5s all ease;-moz-transition:.5s all ease;border-radius:8px;width:calc(100% - 30px);left:0;padding:0;padding-bottom:50px;height:auto;max-height:calc(100% - 60px);z-index:-1}.menu-left .menu-nav ul[class^=submenu] li,aside .menu-nav>li ul li{margin:1.5em 2em !important}.menu-left .menu-nav ul[class^=submenu] li a,aside .menu-nav>li ul li a{padding-left:0}.menu-left.menu-open .menu-nav ul.submenu,aside .menu-nav>li.menu-open ul{bottom:0}.cart-menu-category-overlay,.cart-menu-category-overlay{position:fixed;top:0px;left:0px;right:0px;bottom:0px;background-color:rgba(0,0,0,0);z-index:999;width:100%;height:100%;display:block;pointer-events:none;transition:.3s all ease-in-out}.menu-open~.cart-menu-category-overlay,.menu-open .cart-menu-category-overlay,.cart-open .cart-menu-category-overlay{z-index:1100;background-color:rgba(0,0,0,.7);position:fixed;pointer-events:all}.menu-nav ul>li .d-arrow{display:none}.menu-nav>ul>li a{padding-top:4px}}.desktop_hide{display:none}.top-header{position:relative;width:100% !important;z-index:1000;top:0;transition:0s top ease-in-out}.top-header.fixed{position:fixed;height:120px !important}.top-header.fixed:before{height:120px !important}.top-header.fixed .header-restaurant{height:120px !important}.top-header.fixed .header-restaurant .infos{margin-top:0}.top-header.fixed .header-restaurant h1{padding:.7em 0 0;width:100%;margin-bottom:5px}.close-filter .top-header:before{z-index:3}.header-restaurant{background-size:cover;background-repeat:no-repeat;background-position:center;height:150px;padding:0 3em 1em 3em;display:flex;flex-direction:column;justify-content:flex-end}.header-restaurant input[type=checkbox]+label,.header-restaurant input[type=radio]+label{padding-left:18px !important}.header-restaurant a.cart-bar{padding-top:5px;padding-left:8px}.header-restaurant h1{color:#fff;font-weight:bold;z-index:1;font-size:44px;letter-spacing:-2px}.header-restaurant .infos{width:100%;display:flex;align-items:center;justify-content:space-between;margin-top:2.5em;z-index:1}.header-restaurant .infos .left span{color:#fff;font-weight:600;white-space:nowrap}.header-restaurant .infos .right{display:flex;align-items:center}.header-restaurant .infos .right label{display:flex;align-items:center;margin:0 1em 0 -2px;color:#fff;font-size:13px;font-weight:600}.header-restaurant .infos .open::before{content:\"\";width:8px;display:inline-block;margin:0 4px 1px 0;height:8px;background:#0e7a4b;border-radius:30px}.header-restaurant .infos .closed::before{content:\"\";width:8px;display:inline-block;margin:0 4px 1px 0;height:8px;background:#c22525;border-radius:30px}.menu-mobile{display:none}.menu-mobile .menu-logo img{width:124px;margin-top:1px;height:26px}a#menu_toggle{cursor:pointer}@media only screen and (max-width: 768px){.header-restaurant h1{font-size:25px}.modal-content aside .menu-nav{padding:0 !important}.menu-mobile{display:block;position:fixed;width:100%;height:48px;background:#fff;z-index:4999}.menu-mobile .menu-logo{padding:11px 0 14px 0;border-bottom:0}.menu-mobile header{float:left;display:block;margin-right:2.35765%;width:100%}.menu-mobile header .cart-menu-m{position:absolute;right:42px;top:15px}.menu-mobile header .cart:after{padding:.7px;margin-top:-6px;margin-left:-4px}.menu-mobile header:last-child{margin-right:0}.menu-mobile header nav{text-align:center}.menu-mobile header nav ul{list-style-type:none;padding:0;margin-top:-10px}.menu-mobile header nav li{padding:9px 0}.menu-mobile header nav li a{text-transform:unset;font-weight:bold;cursor:pointer}.menu-mobile .menu{position:absolute;left:2em;top:15.5px}.menu-mobile #side-menu{box-shadow:0 12px 15px 0 rgba(0,0,0,.24);position:fixed;display:table;height:100%;width:76.7%;top:0;left:0;overflow:hidden;background:#fff;-webkit-transition:all .15s cubic-bezier(0.55, 0.085, 0.68, 0.53);-moz-transition:all .15s cubic-bezier(0.55, 0.085, 0.68, 0.53);transition:all .15s cubic-bezier(0.55, 0.085, 0.68, 0.53);-webkit-transform:translateX(-675px);-moz-transform:translateX(-675px);-ms-transform:translateX(-675px);-o-transform:translateX(-675px);transform:translateX(-675px);z-index:9999}.menu-mobile #side-menu .menu-nav{padding:11px 10.5% 0 40px}.menu-mobile .sideMenuToggle{-webkit-transform:translateX(0) !important;-moz-transform:translateX(0) !important;-ms-transform:translateX(0) !important;-o-transform:translateX(0) !important;transform:translateX(0) !important}.menu-mobile #close{float:right;margin:7px 18px;cursor:pointer}.header-restaurant{height:4cm;padding:0 3em 1em 1em;margin-bottom:-8px}.principal-left.menu-open{left:0;overflow:scroll;max-height:100%}.principal-right{width:100% !important}.principal-right .list-items{padding:0 0em 5em;width:100%;margin:0}.infos{flex-wrap:wrap;align-items:center;justify-content:flex-start;margin-top:3.3em}.infos .right{margin-top:1em}.infos .right a.cart-bar{display:none}}@media only screen and (max-width: 992px){.principal-left{width:23%}.principal-right{width:77%}.principal-right .list-items{padding:0 0em 5em}}@media only screen and (max-width: 1024px){.menu-mobile{display:block;position:fixed;width:100%;height:48px;background:#fff;z-index:4999}.menu-mobile .menu-logo{padding:11px 0 14px 0;border-bottom:0}.menu-mobile header{float:left;display:block;margin-right:2.35765%;width:100%}.menu-mobile header .cart-menu-m{position:absolute;right:42px;top:1.3em}.menu-mobile header .cart:after{padding:.7px;margin-top:-6px;margin-left:-4px}.menu-mobile header:last-child{margin-right:0}.menu-mobile header nav{text-align:center}.menu-mobile header nav ul{list-style-type:none;padding:0;margin-top:-10px}.menu-mobile header nav li{padding:9px 0}.menu-mobile header nav li a{text-transform:unset;font-weight:bold;cursor:pointer}.menu-mobile .menu{position:absolute;left:2em;top:15.5px}.menu-mobile #side-menu{box-shadow:0 12px 15px 0 rgba(0,0,0,.24);position:fixed;display:table;height:100%;width:30.7%;top:0;left:0;overflow:hidden;background:#fff;-webkit-transition:all .15s cubic-bezier(0.55, 0.085, 0.68, 0.53);-moz-transition:all .15s cubic-bezier(0.55, 0.085, 0.68, 0.53);transition:all .15s cubic-bezier(0.55, 0.085, 0.68, 0.53);-webkit-transform:translateX(-675px);-moz-transform:translateX(-675px);-ms-transform:translateX(-675px);-o-transform:translateX(-675px);transform:translateX(-675px);z-index:9999}.menu-mobile .sideMenuToggle{-webkit-transform:translateX(0) !important;-moz-transform:translateX(0) !important;-ms-transform:translateX(0) !important;-o-transform:translateX(0) !important;transform:translateX(0) !important}.menu-mobile #close{float:right;margin:7px 18px;cursor:pointer}.principal-right{width:100%;padding-top:0;padding-bottom:3em}.principal-right:before{position:static}.principal-right .top-header{height:4cm;top:48px}.principal-right .top-header:before{height:4cm}.principal-right .top-header .header-restaurant{height:4cm;padding:0 3em 1em 1em}.principal-right .main-content{padding-top:6em;position:absolute;width:100%}.principal-right .main-content .list-items:before{position:static}.principal-left .menu-left{top:0;border:0;float:left;max-width:280px;width:100%;height:100%;position:fixed;display:block;left:-300px;z-index:9999;background:#fff;-webkit-transition:all .5s ease;-moz-transition:all .5s ease;transition:all .5s ease}.principal-left .menu-left .menu-logo{display:none}.principal-left.menu-open .menu-left{top:0;left:0;overflow:scroll}.vr aside{bottom:0}.vr aside .menu-nav .menu-open .d-arrow{transform:rotate(180deg);transition:.3s transform ease-in-out}.vr aside .menu-nav .d-arrow{transition:.3s transform ease-in-out}.principal-right{width:100%}.principal-right .list-items{padding:0 0em 5em;width:100%;margin-top:0}.principal-right .list-items.team-voucher{width:95% !important;margin:0 auto}.infos{width:100%;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:justify;-webkit-justify-content:space-between;-ms-flex-pack:justify;justify-content:space-between}.infos .right{margin-top:1em}.infos .right a.cart-bar{display:none}}@media only screen and (max-width: 768px){.close-filter:before{width:100%;top:0}.menu-mobile{display:block;position:fixed;width:100%;height:48px;background:#fff;z-index:4999}.menu-mobile .menu-logo{padding:11px 0 14px 0;border-bottom:0}.menu-mobile header{float:left;display:block;margin-right:2.35765%;width:100%}.menu-mobile header .cart-menu-m{position:absolute;right:42px;top:1.3em}.menu-mobile header .cart:after{padding:.7px;margin-top:-6px;margin-left:-4px}.menu-mobile header:last-child{margin-right:0}.menu-mobile header nav{text-align:center}.menu-mobile header nav ul{list-style-type:none;padding:0;margin-top:-10px}.menu-mobile header nav li{padding:9px 0}.menu-mobile header nav li a{text-transform:unset;font-weight:bold;cursor:pointer}.menu-mobile .menu{position:absolute;left:2em;top:15.5px}.menu-mobile #side-menu{box-shadow:0 12px 15px 0 rgba(0,0,0,.24);position:fixed;display:table;height:100%;width:42.7%;top:0;left:0;overflow:hidden;background:#fff;-webkit-transition:all .15s cubic-bezier(0.55, 0.085, 0.68, 0.53);-moz-transition:all .15s cubic-bezier(0.55, 0.085, 0.68, 0.53);transition:all .15s cubic-bezier(0.55, 0.085, 0.68, 0.53);-webkit-transform:translateX(-675px);-moz-transform:translateX(-675px);-ms-transform:translateX(-675px);-o-transform:translateX(-675px);transform:translateX(-675px);z-index:9999}.menu-mobile .sideMenuToggle{-webkit-transform:translateX(0) !important;-moz-transform:translateX(0) !important;-ms-transform:translateX(0) !important;-o-transform:translateX(0) !important;transform:translateX(0) !important}.menu-mobile #close{float:right;margin:7px 18px;cursor:pointer}.header-restaurant{height:4cm;padding:0 3em 1em 1em;margin-top:-8px}.principal-right{width:100%}.principal-right .list-items{padding:0 0em 5em;width:100%;margin-top:0}.infos{flex-wrap:wrap;align-items:center;justify-content:flex-start}.infos .right{margin-top:1em}.infos .right a.cart-bar{display:none}}@media only screen and (max-width: 523px){.list-items{margin-top:0px}.lb-padrao-singup4 img{padding-bottom:20px}.lb-padrao-singup5 img{padding-bottom:20px}.lb-padrao-singup5 input{margin-bottom:6px}.lb-padrao-singup5 .btn{margin-top:20px !important}#login6{padding:1em 4em 1em}.lb-padrao-singup6 img{padding-bottom:0}.lb-padrao-singup6 h3{margin-bottom:20px}.lb-padrao-singup1 .cintas-terms-conditions-description{height:180px}.lb-padrao-singup1 .btn{margin:0 !important}.menu-mobile{display:block;position:fixed;width:100%;height:48px;background:#fff;z-index:4999}.menu-mobile .menu-logo{padding:11px 0 14px 0;border-bottom:0}.menu-mobile header{float:left;display:block;margin-right:2.35765%;width:100%}.menu-mobile header .cart-menu-m{position:absolute;right:42px;top:1.3em}.menu-mobile header .cart:after{padding:.7px;margin-top:-6px;margin-left:-4px}.menu-mobile header:last-child{margin-right:0}.menu-mobile header nav{text-align:center}.menu-mobile header nav ul{list-style-type:none;padding:0;margin-top:-10px}.menu-mobile header nav li{padding:9px 0}.menu-mobile header nav li a{text-transform:unset;font-weight:bold;cursor:pointer}.menu-mobile .menu{position:absolute;left:2em;top:15.5px}.menu-mobile #side-menu{box-shadow:0 12px 15px 0 rgba(0,0,0,.24);position:fixed;display:table;height:100%;width:76.7%;top:0;left:0;overflow:hidden;background:#fff;-webkit-transition:all .15s cubic-bezier(0.55, 0.085, 0.68, 0.53);-moz-transition:all .15s cubic-bezier(0.55, 0.085, 0.68, 0.53);transition:all .15s cubic-bezier(0.55, 0.085, 0.68, 0.53);-webkit-transform:translateX(-675px);-moz-transform:translateX(-675px);-ms-transform:translateX(-675px);-o-transform:translateX(-675px);transform:translateX(-675px);z-index:9999}.menu-mobile .sideMenuToggle{-webkit-transform:translateX(0) !important;-moz-transform:translateX(0) !important;-ms-transform:translateX(0) !important;-o-transform:translateX(0) !important;transform:translateX(0) !important}.menu-mobile #close{float:right;margin:7px 18px;cursor:pointer}.header-restaurant{height:4cm;padding:0 1em 1em 1em !important;background-position:left;margin-top:-8px}.principal-right{width:100%}.principal-right .list-items{padding:0 0em 5em;width:100%}.infos{flex-wrap:wrap;align-items:center;justify-content:flex-start;margin-top:4em}.infos .right{margin-left:-1.2em;margin-top:1em}.infos .right a.cart-bar{display:none}}@media only screen and (max-width: 568px)and (max-height: 320px)and (orientation: landscape){.menu-mobile #side-menu .menu-nav{padding:0px 10.5% 0 40px}.menu-mobile #side-menu{width:74.7%}.close-filter:before{width:100%;top:0}}#modal-cat aside nav .menu-nav li{margin-bottom:1em !important}@media only screen and (max-width: 768px){.top-header{width:100%;top:48px}.top-header:before{top:0}.header-restaurant{margin:0}}@media only screen and (max-width: 768px){.header-restaurant .infos{margin-top:3.3em}}@media only screen and (max-width: 1024px){.header-restaurant .infos{width:fit-content;margin-left:20px;z-index:initial}.header-restaurant .infos .left{z-index:1}.header-restaurant a.cart-bar{padding:13px;margin-right:20px;position:fixed;right:0;top:0;display:block !important;z-index:20}.menu-mobile{display:block;position:fixed;width:100%;height:48px;background:#fff;top:0;z-index:10}}@media only screen and (max-width: 768px){.header-restaurant .infos{width:fit-content;margin-left:0;z-index:initial}.header-restaurant .infos .left{display:block;width:100%;z-index:1}.header-restaurant a.cart-bar{padding:13px;margin-right:20px;position:fixed;right:0;top:0;display:block !important;z-index:20}.menu-mobile{display:block;position:fixed;width:100%;height:48px;background:#fff;top:0;z-index:10}}#sidebar-m{display:none;padding:6px 0}#modal-rest,#modal-cat,#modal-cart{visibility:hidden}.modal-content aside{display:block;width:100%;border:0}.modal-content aside .menu-nav{padding:0 10.5%}.modal-content .cart-sidebar{display:block !important;width:100%;margin-left:0}.modal-restaurants{visibility:hidden;position:fixed;z-index:4998;padding-top:65px;padding-bottom:3em;left:0;top:0;width:100%;height:100%;overflow:hidden;display:block;background-color:rgba(0,0,0,.73)}.modal-restaurants .modal-content{background-color:#fff;margin:auto;padding:0;overflow:overlay;width:100%;padding:35px 35px;height:100%;transform:translateY(120%);transition:all .5s ease}.modal-restaurants .modal-content ul.submenu li{margin:1em 0}.animate{transform:translateY(0) !important}@media only screen and (max-device-width: 768px)and (orientation: landscape){.modal-restaurants{padding-top:85px !important}.item .flex-center select{margin-right:1em}.tooltip{z-index:0}#sidebar-m{display:block;position:fixed;bottom:0;width:100%;background:#fff;z-index:4998;-webkit-box-shadow:0px -1px 19px 1px rgba(0,0,0,.47);-moz-box-shadow:0px -1px 19px 1px rgba(0,0,0,.47);box-shadow:0px -1px 19px 1px rgba(0,0,0,.47)}#sidebar-m ul{display:block;width:100%;padding:.7em}#sidebar-m ul li{float:left;width:33.3%;text-align:center}#sidebar-m ul li a{display:inline-block;color:#0e7a4b;font-weight:bold}#sidebar-m ul li a:after{content:\"\";width:13px;height:8px;display:flex;align-items:center;margin:5px -17px 0 0;float:right;background:url(" + __webpack_require__(139) + ")}}@media only screen and (max-width: 500px)and (max-device-width: 700px){.tooltip{z-index:0}#sidebar-m{display:block;position:fixed;bottom:0;width:100%;background:#fff;z-index:4998;-webkit-box-shadow:0px -1px 19px 1px rgba(0,0,0,.47);-moz-box-shadow:0px -1px 19px 1px rgba(0,0,0,.47);box-shadow:0px -1px 19px 1px rgba(0,0,0,.47)}#sidebar-m ul{display:block;width:100%}#sidebar-m ul li{float:left;width:33.3%;text-align:center}#sidebar-m ul li a{display:inline-block;color:#0e7a4b;font-weight:bold}#sidebar-m ul li a:after{content:\"\";width:13px;height:8px;display:flex;align-items:center;margin:5px -17px 0 0;float:right;background:url(" + __webpack_require__(139) + ")}}@media only screen and (max-width: 1024px){#sidebar-m{display:block;position:fixed;bottom:0;width:100%;background:#fff;z-index:4998;-webkit-box-shadow:0px -1px 19px 1px rgba(0,0,0,.47);-moz-box-shadow:0px -1px 19px 1px rgba(0,0,0,.47);box-shadow:0px -1px 19px 1px rgba(0,0,0,.47)}#sidebar-m ul{display:block;width:100%;margin:1em 1em 1em 0}#sidebar-m ul li{float:left;width:33.3%;text-align:center}#sidebar-m ul li a{display:inline-block;color:#0e7a4b;font-weight:bold}#sidebar-m ul li a:after{content:\"\";width:13px;height:8px;display:flex;align-items:center;margin:5px -17px 0 0;float:right;background:url(" + __webpack_require__(139) + ")}}@media only screen and (max-width: 768px){.tooltip{z-index:0}}@media only screen and (min-device-width: 768px)and (max-device-width: 1024px)and (orientation: portrait){.tooltip{z-index:0}#sidebar-m{display:block;position:fixed;bottom:0;width:100%;background:#fff;z-index:4998;-webkit-box-shadow:0px -1px 19px 1px rgba(0,0,0,.47);-moz-box-shadow:0px -1px 19px 1px rgba(0,0,0,.47);box-shadow:0px -1px 19px 1px rgba(0,0,0,.47)}#sidebar-m ul{display:block;width:100%;padding:.7em}#sidebar-m ul li{float:left;width:33.3%;text-align:center}#sidebar-m ul li a{display:inline-block;color:#0e7a4b;font-weight:bold}#sidebar-m ul li a:after{content:\"\";width:13px;height:8px;display:flex;align-items:center;margin:5px -17px 0 0;float:right;background:url(" + __webpack_require__(139) + ")}}@media only screen and (max-width: 500px){#sidebar-m ul li{margin:.5em 0}#sidebar-m ul li a{font-size:13px}.principal-right .list-items article header h3{float:left;width:70%;display:block}.principal-right .list-items article header p{float:right;width:30%;display:block;text-align:right}}@media only screen and (max-width: 500px){.principal-right .list-items article{padding:10px 0px 0em}}.erro-section{height:auto;padding:30px 0 50px 0}.erro-section .centralizar{margin:0 auto;display:table}.erro-section h2{font-size:45px;margin:0 auto;display:table}.erro-section h2 .sprite{background-position:-300px -262px;width:38px;height:31px;display:block;float:left;margin-top:6px;margin-right:12px}.erro-section h3{font-size:24px;text-align:center;margin-top:10px;margin-bottom:10px}.erro-section .featured{border-top:0;margin-top:0px}.erro-section .featured-title{display:none}.menu-logo{width:100%;height:auto;display:block;text-align:center;padding:36px 0 33px 0;border-bottom:1px solid #dbe5df}.fa-close:before,.fa-remove:before,.fa-times:before{margin-left:30px;display:block;margin-top:10px;margin-bottom:-20px}.menu-nav{width:100%;height:auto;display:table;padding:10.5%}.menu-nav li:hover>a{color:#0e7a4b !important;opacity:1}.menu-nav li{margin-bottom:1em}.menu-nav li a{color:#0b2318;padding-left:15px;transition:.3s;position:relative}.menu-nav li:hover>a{color:#0e7a4b}.menu-nav ul.submenu{padding-left:1px;margin:12px 0 0 0}.menu-nav ul.submenu li.active{font-weight:bold}.menu-nav ul.submenu li.active :before{content:\"\";width:5px;height:100%;background:#0e7a4b;display:inline-block;float:left;margin-left:-15px;position:absolute}.menu-nav ul.submenu li>a{padding-left:0}.menu-nav ul.submenu li:hover>a{color:#0e7a4b !important;opacity:1 !important}li.active a{color:#0e7a4b}aside ul.menu-nav li:hover>a{color:#0e7a4b !important;opacity:1}.cart:after{content:\"2\";background:#0e7a4b;width:17px;height:17px;display:inline-flex;align-items:center;justify-content:center;color:#fff;border-radius:100%;font-size:10.2px;text-align:center;position:absolute;margin-top:-6px;margin-left:-1px;padding:.5px}.menu-inactive li,.menu-inactive h3,.menu-inactive p,.menu-inactive span{color:#4a5f54;cursor:default}.orange-light{background:#fff;border:1px solid #0e7a4b;padding:9px;font-size:12px;color:#0e7a4b;border-radius:8px;width:100%;transition:all ease .3s}.orange-light:hover{background:#0e7a4b;color:#fff}.orange-bold{background:#0e7a4b;color:#fff;padding:9px;font-size:12px;border-radius:8px;width:100%;border:1px solid #fff;transition:all ease .3s}.orange-bold:hover{background:#fff;color:#0e7a4b;border:1px solid #0e7a4b}.btn{margin:20px 0 32px}i.restaurant{height:22px;width:19px;background:url(" + __webpack_require__(979) + ");display:inline-block;float:left;background-size:contain;background-repeat:no-repeat;background-position:center}i.reload{height:22px;width:19px;background:url(" + __webpack_require__(980) + ");display:inline-block;float:left;background-size:contain;background-repeat:no-repeat;background-position:center}i.voucher{height:22px;width:19px;background:url(" + __webpack_require__(981) + ");display:inline-block;float:left;background-size:contain;background-repeat:no-repeat;background-position:center}i.platters{height:22px;width:19px;background:url(" + __webpack_require__(982) + ");display:inline-block;float:left;background-size:contain;background-repeat:no-repeat;background-position:center}i.cart{height:22px;width:19px;background:url(" + __webpack_require__(983) + ");display:inline-block;float:left;background-size:contain;background-repeat:no-repeat;background-position:center}i.tracking{height:22px;width:19px;background:url(" + __webpack_require__(984) + ");display:inline-block;float:left;background-size:contain;background-repeat:no-repeat;background-position:center}i.sprite.wallet{padding:0 !important}i.wallet{height:22px;width:19px;background:url(" + __webpack_require__(985) + ");display:inline-block;float:left;background-size:contain;background-repeat:no-repeat;background-position:center}i.settings{height:22px;width:19px;background:url(" + __webpack_require__(986) + ");display:inline-block;float:left;background-size:contain;background-repeat:no-repeat;background-position:center;margin:unset !important}i.logout{height:22px;width:19px;background:url(" + __webpack_require__(987) + ");display:inline-block;float:left;background-size:contain;background-repeat:no-repeat;background-position:center}i.gdpr{height:22px;width:19px;background:url(" + __webpack_require__(988) + ");display:inline-block;float:left;background-size:contain;background-repeat:no-repeat;background-position:center}i.options{height:22px;width:19px;background:url(" + __webpack_require__(989) + ");display:inline-block;float:left;background-size:contain;background-repeat:no-repeat;background-position:center}.d-arrow{background:url(" + __webpack_require__(990) + ");background-repeat:no-repeat;width:18px;height:12px;display:inline-block}i.white-cart25{height:20px;width:25px;background-position:0px -44px;display:inline-block}aside{width:19%;float:left;transition:.3s all ease-in-out;height:100%;position:relative}aside:after{content:\"\";position:absolute;right:-1px;top:0;width:1px;height:100%;background-color:#dbe5df}aside nav{margin-top:5px}aside div ul{padding:1em}aside div ul li{font-weight:600;margin:1em 6px}.modal-content aside:after{position:static}@media only screen and (max-width: 1024px){#sidebar-m{display:block}}.cart-sidebar{width:calc(27% - 30px);display:inline-block;float:right;margin-right:15px;padding:15px 0}.cart-sidebar h2{font-weight:bold;margin-bottom:5px;font-size:15px}.cart-sidebar .payment-options{height:auto;display:table;width:100%;border-top:1px solid #dbe5df;padding-top:20px;margin-top:13px}.cart-sidebar .payment-options h4{margin-bottom:0;font-weight:bold;font-size:15px}.cart-sidebar .payment-options .radio-payment{padding-top:8px;clear:both;display:block}.cart-sidebar .payment-options .radio-payment input[type=radio]+label{margin-top:-8px;display:block}.cart-sidebar .payment-options .radio-payment input[type=radio]+label::before{border-color:#0b2318}.cart-sidebar .payment-options .add-card{font-size:14px;padding-top:15px;display:block}.cart-sidebar .payment-options .add-card span{font-size:14px;color:#0e7a4b}.cart-sidebar .payment-options .box-add-card{width:100%;height:auto;display:none}.cart-sidebar .payment-options .box-add-card.open{display:table}.cart-sidebar .items{border-bottom:1px solid #dbe5df;padding:1em 0;margin:0px 0 9px}.cart-sidebar .items .checked-cutlery input[type=checkbox]+label{padding-left:28px}.cart-sidebar .items .checked-cutlery input[type=checkbox]+label::before{background-color:#0e7a4b;border-color:#0e7a4b}.cart-sidebar .items .checked-cutlery input[type=checkbox]+label::after{background:url(" + __webpack_require__(991) + ") center center no-repeat !important}.cart-sidebar .items .item{font-size:14px;position:relative}.cart-sidebar .items .item a{float:right;color:#0b2318;font-family:\"Source Sans Pro\",sans-serif;font-size:17.82px}.cart-sidebar .items .item h3{font-weight:bold;font-size:14px;padding:0 2.3em}.cart-sidebar .items .item p{padding:0 2.3em}.cart-sidebar .total-items{display:flex;flex-direction:column}.cart-sidebar .total-items .left p{margin:0}.cart-sidebar .total-items .right p{margin:0}.cart-sidebar .total-items .total p{font-weight:bold}.cart-open{width:54% !important;float:left;padding:0 0em 3em !important;border-right:1px solid #dbe5df}@media only screen and (max-device-width: 768px)and (orientation: landscape){.cart-open{width:100% !important;border:0 !important}.cart-sidebar{display:none !important}}@media only screen and (max-width: 500px){.cart-open{width:100% !important;border:0 !important}.cart-sidebar{display:none !important}}@media only screen and (max-width: 768px){.cart-open{width:100% !important;border:0 !important}.cart-sidebar{display:none !important}}@media only screen and (max-width: 1024px){.cart-open{width:100% !important;border:0 !important}.cart-sidebar{display:none !important}}@media only screen and (min-device-width: 768px)and (max-device-width: 1024px)and (orientation: portrait){.cart-open{width:100% !important;border:0 !important}.cart-sidebar{display:none !important}}@media only screen and (min-width: 1024px){.cart-open+.cart-sidebar{opacity:1;transition:1s opacity;position:relative;top:0;padding:15px 0;transition:.4s all ease-out;overflow:initial;height:auto}.cart-sidebar{width:calc(27% - 30px);display:inline-block !important;float:right;margin-right:15px;padding:0;position:relative;top:100px;opacity:0;transition:.8s all ease-in;overflow:hidden;height:0}}@media only screen and (max-width: 1024px){.cart-sidebar{width:calc(100% - 60px);display:block !important;float:right;margin-left:30px;padding:15px 0;position:fixed;left:0;bottom:-100%;background:#fff;z-index:9999;padding:20px;-webkit-transition:all .5s ease;-moz-transition:all .5s ease;transition:all .5s ease;overflow:scroll;max-height:calc(100% - 70px);border-radius:8px}.cart-sidebar .payment-buttons a{display:block}.cart-open+.cart-sidebar{-webkit-transition:all .5s ease;-moz-transition:all .5s ease;transition:all .5s ease;bottom:30px}}@media only screen and (max-width: 768px){.cart-sidebar{width:calc(100% - 30px);display:block !important;float:right;margin-left:15px;padding:15px 0;position:fixed;left:0;bottom:-100%;background:#fff;z-index:9990;padding:20px;-webkit-transition:all .5s ease;-moz-transition:all .5s ease;transition:all .5s ease;overflow:scroll;max-height:calc(100% - 70px)}.cart-open+.cart-sidebar{-webkit-transition:all .5s ease;-moz-transition:all .5s ease;transition:all .5s ease;bottom:30px}}.checkout{height:100px !important;background-position:top;flex-direction:row;justify-content:left}.checkout h1{margin:0 8px 0 0}.checkout i{margin:6px 0 0 0;z-index:2}.styled-select,.styled-select select{width:35px;margin-right:8px}.cart-page{margin:0 auto;display:block;width:50%;padding:30px}.cart-page h2{font-size:23,82px;font-weight:bold}.cart-page h4{font-size:17px;font-weight:bold;color:#0e7a4b;margin-top:15px;display:block;float:left;padding-bottom:10px}.cart-page .items{border-bottom:1px solid #dbe5df;padding:1em 0 1em;border-top:1px solid #dbe5df;clear:both;display:block}.cart-page .items .item{font-size:14px}.cart-page .items .item a{float:right;color:#0b2318;font-family:\"Source Sans Pro\",sans-serif;font-size:17.82px}.cart-page .items .item h3{font-weight:bold;font-size:15.21px}.cart-page .items .item span{font-size:15.21;font-weight:600;padding-right:5px}.cart-page .items .item p{padding:0px 3.5em 0;margin:0px 0 5px 0px}.cart-page .items .item select{border:1px solid #dbe5df;border-radius:8px;font-size:14px;font-weight:600;color:#0b2318;margin:0 6px 0 0;-moz-appearance:none}.cart-page .total-items{display:flex;flex-direction:column;padding-top:8px}.cart-page .total-items .left p{margin:0}.cart-page .total-items .right p{margin:0}.cart-page .total-items .total p{font-weight:bold}.item-info{display:flex;align-items:center;width:100%;justify-content:space-between;padding:0 4px}.top-header:before{width:100% !important}.s1-on{background:url(" + __webpack_require__(992) + ");width:54px;height:54px;background-repeat:no-repeat}.s1-off{background:url(" + __webpack_require__(993) + ");width:54px;height:54px;background-repeat:no-repeat}.s2-on{background:url(" + __webpack_require__(994) + ");width:54px;height:54px;background-repeat:no-repeat}.s2-off{background:url(" + __webpack_require__(995) + ");width:54px;height:54px;background-repeat:no-repeat}.s3-on{background:url(" + __webpack_require__(996) + ");width:54px;height:54px;background-repeat:no-repeat}.s3-off{background:url(" + __webpack_require__(997) + ");width:54px;height:54px;background-repeat:no-repeat}.s4-on{background:url(" + __webpack_require__(998) + ");width:54px;height:54px;background-repeat:no-repeat}.s4-off{background:url(" + __webpack_require__(999) + ");width:54px;height:54px;background-repeat:no-repeat}.list-items.tracking{width:100%}.list-items.tracking span{color:#0b2318;font-size:12px;font-weight:bold;display:block;margin-top:10px}.list-items.tracking .arrival-time{color:#0b2318;font-size:15px;font-weight:bold;display:block;margin-top:15px;text-align:center}.list-items.tracking .steps{display:flex;align-items:center;justify-content:center;width:100%;border-top:1px solid #dbe5df;border-bottom:1px solid #dbe5df;margin-top:8px}.list-items.tracking .steps .step.four{justify-content:flex-end !important;width:62% !important}.list-items.tracking .steps .step.one{padding-right:3em}.list-items.tracking .steps .step{display:flex;align-items:center;justify-content:left;width:100%;margin:10px 0}.list-items.tracking .steps .step .step-info{margin:0 0 0 10px}.list-items.tracking .steps .step .step-info h4{font-size:9px;font-family:\"Geist\";margin-bottom:10px}.list-items.tracking .steps .step .step-info h3{font-size:14px;font-family:\"Geist\";font-weight:bold}.list-items.tracking .steps .step .step-info .step-now{background:#eaf5ee;border-radius:6px;color:#075c38;display:inline-block;font-size:12px;font-weight:600;line-height:16px;margin-left:4px;padding:2px 8px;vertical-align:middle}@media only screen and (max-width: 768px){.list-items.tracking{padding:0 3em 5em !important;display:flex;flex-wrap:wrap;flex-direction:column;align-items:center;justify-content:center}.list-items.tracking .steps .step.four{justify-content:left !important;width:100% !important}}@media only screen and (max-width: 320px){.list-items.tracking{padding:0 1em !important}}@media only screen and (max-width: 1100px){.s1-on{width:84px}.s1-off{width:84px}.s2-on{width:84px}.s2-off{width:84px}.s3-on{width:84px}.s3-off{width:84px}.s4-on{width:84px}.s4-off{width:84px}}.wallet{padding:1em;margin:0 auto}.wallet .balance{display:flex;align-items:center;margin-top:20px}.wallet .balance h3{font-size:23px;font-weight:bold}.wallet .balance span{font-size:23px;font-weight:bold;color:#075c38;margin-left:8px}.wallet .reload-balance h3{font-size:18px;font-weight:bold;border-bottom:1px solid #dbe5df;padding:30px 0 20px}.wallet .reload-balance .amount{padding:20px 0 20px;border-bottom:1px solid #dbe5df}.wallet .reload-balance .amount h4{font-size:18px;font-weight:bold;margin-bottom:10px}.wallet .reload-balance .amount .values{display:flex;align-items:center;justify-content:center}.wallet .reload-balance .amount .values input{max-width:289px !important;border-radius:8px;height:35px;margin-bottom:0 !important;margin-top:20px;margin-left:15px}.wallet .reload-balance .amount .values button{width:85px;height:35px;background:#fff;border:1px solid #0b2318;border-radius:8px;transition:.3s;font-weight:600;margin-right:15px}.wallet .reload-balance .amount .values button:hover{border:1px solid #0e7a4b;background:#0e7a4b;color:#fff}.wallet .reload-balance .amount .values .last-button{margin-right:0 !important}.wallet .reload-balance button{margin-top:20px}.wallet .orange-bold{margin-top:35px !important;width:243px;margin:0 auto;display:block}@media only screen and (max-width: 1024px){.principal-right .main-content .list-items.wallet{padding:0 2em 5em}.values{flex-wrap:wrap}}@media only screen and (max-width: 1279px){.wallet .reload-balance .amount .values input{max-width:220px !important}}@media only screen and (max-width: 960px)and (min-width: 950px){.top-header{width:74.9%}}@media only screen and (max-width: 768px){.list-items.wallet{padding:1em;padding-bottom:6em}.list-items.tracking .steps{flex-wrap:wrap}.list-items.tracking{padding:1em 3em}.wallet .reload-balance .amount .values .last-button{margin-right:15px !important}.wallet .reload-balance .amount .values input{max-width:100% !important;margin-left:0 !important}.wallet .reload-balance .amount .values button{margin:15px}}@media only screen and (max-width: 500px){.wallet .balance{display:block;height:auto;display:table;padding-bottom:15px}.wallet .balance h3{width:100%;display:block}.wallet .balance span{width:100%;display:block;margin:10px 0 0 0}}.list-items.tracking{padding:0 5em 5em}.settings{margin:0 auto}.settings .config-item.notifications{margin-bottom:2em}.settings .orange-bold{max-width:280px;margin:0 auto;display:block;margin-top:2em}.settings h2.margin-titles{display:block;margin-top:14em}.settings .config-item.w25{width:46% !important}.settings .config-item.notifications label{padding-top:2px}.settings h2{font-size:16px;color:#0b2318;font-weight:bold;font-family:\"Geist\";padding:3em 0 2em}.settings .margin-title{display:inline-block;margin-top:2em}.settings .flex-row{display:flex;align-items:center;width:100%}.settings .span{margin-bottom:4em}.settings .tool{float:right;position:relative;top:-42px;right:-136px}.settings .tool a{position:unset !important;font-size:12px;font-weight:bold;border-bottom:1px solid #0b2318}.settings .personal-info{margin-bottom:4em}.settings .personal-info .w55{width:100%}.settings .personal-info .w25{width:40%}.settings .password{margin-bottom:4em}.settings .password .config-item{width:29% !important}.settings .config-item{margin-right:2em;width:100%}.settings .config-item label{color:#4a5f54;font-size:12px;font-weight:bold;margin-bottom:1em;display:block}.settings .config-item input{border:1px solid #769885;border-radius:8px;height:50px}.settings .config-item input[disabled]{background:#eef4f0}.settings .notifications{display:flex;align-items:center}.lb-settings header{border:0 !important}.lb-settings .mfp-close{right:16px !important}.lb-settings .config-item{padding-top:35px;width:100%}.lb-settings .config-item label{color:#4a5f54;font-size:12px;font-weight:bold;margin-bottom:1em;display:block}.lb-settings .config-item textarea{border:1px solid #769885;border-radius:8px;height:90px}.lb-settings .config-item input{border:1px solid #769885;border-radius:8px;height:30px;margin-bottom:0}.lb-settings .config-item input[disabled]{background:#eef4f0;cursor:help}@media only screen and (max-width: 1024px){.principal-right .main-content .list-items.settings{padding:0 2em 6em}.principal-right .main-content .list-items.settings .tool{right:0;top:0}}@media only screen and (max-width: 768px){.list-items.settings{padding:0 2em 6em}.settings .flex-row{flex-wrap:wrap}.settings .tool{display:block;position:unset}.settings h2.margin-titles{margin-top:-1em}.settings .password .config-item{width:100% !important}}.gdpr-content{width:100% !important;padding:15px 3em 5em !important;padding-top:30px !important}.gdpr-content .title{font-size:30px;font-family:\"Geist\";color:#0b2318;font-weight:bold;margin-bottom:15px;display:block}@media only screen and (max-width: 1279px){.principal-right .list-items{padding:10px 15px 6em !important}}body,html{font-family:\"Geist\",sans-serif;color:#0b2318;font-size:14px;letter-spacing:-0.5px;overflow-x:hidden;height:100%}.App{margin:0 auto;width:1280px;display:table}", ""]);

// exports


/***/ }),
/* 970 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(14)(undefined);
// imports


// module
exports.push([module.i, "/* Slider */\n.slick-slider\n{\n    position: relative;\n\n    display: block;\n    box-sizing: border-box;\n\n    -webkit-user-select: none;\n       -moz-user-select: none;\n        -ms-user-select: none;\n            user-select: none;\n\n    -webkit-touch-callout: none;\n    -khtml-user-select: none;\n    -ms-touch-action: pan-y;\n        touch-action: pan-y;\n    -webkit-tap-highlight-color: transparent;\n}\n\n.slick-list\n{\n    position: relative;\n\n    display: block;\n    overflow: hidden;\n\n    margin: 0;\n    padding: 0;\n}\n.slick-list:focus\n{\n    outline: none;\n}\n.slick-list.dragging\n{\n    cursor: pointer;\n    cursor: hand;\n}\n\n.slick-slider .slick-track,\n.slick-slider .slick-list\n{\n    -webkit-transform: translate3d(0, 0, 0);\n       -moz-transform: translate3d(0, 0, 0);\n        -ms-transform: translate3d(0, 0, 0);\n         -o-transform: translate3d(0, 0, 0);\n            transform: translate3d(0, 0, 0);\n}\n\n.slick-track\n{\n    position: relative;\n    top: 0;\n    left: 0;\n\n    display: block;\n    margin-left: auto;\n    margin-right: auto;\n}\n.slick-track:before,\n.slick-track:after\n{\n    display: table;\n\n    content: '';\n}\n.slick-track:after\n{\n    clear: both;\n}\n.slick-loading .slick-track\n{\n    visibility: hidden;\n}\n\n.slick-slide\n{\n    display: none;\n    float: left;\n\n    height: 100%;\n    min-height: 1px;\n}\n[dir='rtl'] .slick-slide\n{\n    float: right;\n}\n.slick-slide img\n{\n    display: block;\n}\n.slick-slide.slick-loading img\n{\n    display: none;\n}\n.slick-slide.dragging img\n{\n    pointer-events: none;\n}\n.slick-initialized .slick-slide\n{\n    display: block;\n}\n.slick-loading .slick-slide\n{\n    visibility: hidden;\n}\n.slick-vertical .slick-slide\n{\n    display: block;\n\n    height: auto;\n\n    border: 1px solid transparent;\n}\n.slick-arrow.slick-hidden {\n    display: none;\n}\n", ""]);

// exports


/***/ }),
/* 971 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAMCAYAAAC0qUeeAAABI0lEQVR4AYSPsUoDQRCG/1nQiGAu2iq2PoFWKawEyQXS2VjYCJYiFuI2h5DoM+QFFG2CXhpJYZHCxkIfQRAsAmaTCHrRG2cuGk7QZNiPnfvv27k9gzE1F6wv5IJSTrWR8oz1i5+RuY2j/r0eGCkT8wUD8zpV+VfO2sKuCgoBjXZQa/8tB6tTxNgXMSO0XOt5R3Ykcvaw0PCsf6aB4kXTp9+f78lUi+pdX3Mza/28NHlmLnm2WPYO/DWAljGoD1epVwctYF7KYVMeukKGOd5kw5c6lYAnimlD8uFKrsFstvWlpIuC3hMgarqT8BqpSuTu8VVNpp1L/i5AD7qJ3pb2aRJZg06lvkegB+kfhSMEN2+y/1pDWVNXCVc6k69LLvVTmv/wBQAA//+tl85HAAAABklEQVQDAL61WeE0LlrPAAAAAElFTkSuQmCC"

/***/ }),
/* 972 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/fontawesome-webfont.674f50d2.eot";

/***/ }),
/* 973 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/fontawesome-webfont.674f50d2.eot";

/***/ }),
/* 974 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/fontawesome-webfont.af7ae505.woff2";

/***/ }),
/* 975 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/fontawesome-webfont.fee66e71.woff";

/***/ }),
/* 976 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/fontawesome-webfont.b06871f2.ttf";

/***/ }),
/* 977 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/fontawesome-webfont.912ec66d.svg";

/***/ }),
/* 978 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/login-bg.79fea343.jpg";

/***/ }),
/* 979 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/restaurant.481f02de.svg";

/***/ }),
/* 980 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/refresh.5234f37d.svg";

/***/ }),
/* 981 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/discount-voucher.82f89c2a.svg";

/***/ }),
/* 982 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/dinner.6b2aee08.svg";

/***/ }),
/* 983 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/shopping-cart.3091d9bc.svg";

/***/ }),
/* 984 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/delivery-truck.6bd535e6.svg";

/***/ }),
/* 985 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/wallet.75ac449a.svg";

/***/ }),
/* 986 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/settings-work-tool.2de4a89f.svg";

/***/ }),
/* 987 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/logout.495b5a8f.svg";

/***/ }),
/* 988 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/gdpr.1993961a.svg";

/***/ }),
/* 989 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/options.08e5601c.svg";

/***/ }),
/* 990 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAMCAMAAABYzB2OAAAAOVBMVEUAAAD//v6QkJHGxsbf39/x8fE6Ojw9PT1GRkZRUVFpaWlwcHCIiIiioqKxsbEEBAQeHh4NDg4pKSk48VfqAAAAD3RSTlMAA4tHJRD18ubZu7GVdGCDdXy6AAAAN0lEQVQI12MgCzCSpJqHn5OFgYGVm58NLsQswC/IxAciGOGmsXLxAwEHC4r5zOxCvKS4ihGLIAB/dAFKimHupQAAAABJRU5ErkJggg=="

/***/ }),
/* 991 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAMCAMAAACDd7esAAAAUVBMVEUAAAD///////////////////////////////////////////////////////////////////////////////////////////////////////8IN+deAAAAGnRSTlMA+dappZuObkEYCgf07enAuZSFXFdWTD0xElFg/dkAAABFSURBVAjXfU1HDgAhEHLsq9ubyv8faknmKhcIoYg5svIsF0VHZx9FsFjfJo38oiN6uq0hr53ciBYN4ObeuZnAI79N88MKjjkCDNaI9yYAAAAASUVORK5CYII="

/***/ }),
/* 992 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 993 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADYAAAA2CAMAAAC7m5rvAAAAulBMVEUAAADx8fH19fX19fXNzc319fX19fXNzc319fX19fX19fX19fXNzc319fX19fX19fX19fX19fX19fX19fXr6+v19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fXNzc319fX19fXNzc3Nzc319fXNzc319fX19fX19fX19fX19fX19fX19fX19fX19fX19fXNzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc319fX19fX19fXNzc1jMSjdAAAAPHRSTlMAA+YMwPHtcd5IMySQBvuaj4pqEQnhsqdyb1g3omHqxMBTo5/i1ciPQC0m2teql5N0Zf7v7rxsZSwh73MTFTtuAAACeElEQVRIx52W7XqiMBCFE2kRcREUVKyCWrVarV/97u7h/m9rJ8tuMQka3PNHGJ/X4DlDMqxEfDjwJ47datnOxB8MOasgvprZkGTPVibS6zgokdOJLq2U1CBU6w8azZDzsNkY9P+WkrMrNscg2XtXLrtBCtK4WU7d3YpfjS2myYrFkrd3ZVQbQKtdQDLYbgFo616MqPz0yM7K3QAYeYoZfSr2LHZBVg/AVjZmTyWfGxL1AewlNwTFjNoBOPFlTR72uBnjPfJz/X07ITcsVkHWEzD5d5OQ8y6rpEfKIckvo1qRiFGUbi3vzw5dWVUxi9boMBLvAnFFKF+kK9xrAKlVHYtSoEGf90BQ4nV9ns3rZaEEQJ++twHFRu/ziy0zoSX7+vTU5qTsOBuSIXL94yXLFs9/sOdFlr18KByZMmSxWPNU00zVVMboX/1iI2AgVRcatpCxATBiD7kxhTJdMkbWPzBKTd4kXjXqVcaalBy7BUKputSwpYyFZCUDIFscvSnUW6RESojA1KSn8xNoPlUz9wgRD6m11s0JdiMK+kMWlpixwpIiAAOmBFDEbcaKuPXmIr3/KPSuYdRcsWjllCma1guJhtRbWX1xzA/pAj+5+pqasQC4z42xrepYZOfWcwc4XLUFOfz/Nzzm0VVw1fZ69WbutoAjy8XHgBNWoULyYcy/m/Oag6opH4szM+ZLxyKpLbgqh3BQcuSHxiO/z5nMzajouBc8dIoBQxtngnPjTCCNM/rwdLBKoIM2POmj2k4ZPIeBLY1qupIuhNJt3FiHURSuG/E2hVA3ueSzd9ygRJujxwxa+TWZqfmritNHR4zYAI3Yu07p1Pcb+0iZpAawNjMAAAAASUVORK5CYII="

/***/ }),
/* 994 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 995 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADYAAAA2CAMAAAC7m5rvAAAAt1BMVEUAAADMzMz19fX19fX19fXx8fH19fX19fX19fX19fX19fX19fX19fXx8fH19fX19fX19fX19fX19fXMzMz19fX19fX19fX19fX19fX19fX19fXMzMz19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fXMzMz19fXMzMz19fX19fX19fX19fX19fXMzMzMzMz19fX19fX19fX19fXMzMzMzMzMzMz19fXMzMzH5U8BAAAAO3RSTlMA4AIK6QaaJPvvcA7dEeXgw2qj8OyfjzbxqJSAYj0qvdqMh1pWNDD0skm+t7Cvd2VPQffEeUoa1tGmetvN7W0AAAJISURBVEjHnVZpd+IwDDS5T0KgJECTQLkK3W0p3e0edf7/7+oYeDUxbpxkPpD3JM9DlkaSiQRa6lnzyHUcNxpYXqqRBtDy8R2t4G58VDHNQ0AlCGK9jpX1KUN/6B3t0DRD+xhPjbMp+/Yf7QEF3GRTNW+TU9QDW85aT+A0PEk4esyieFzJUvEAj5NwUpW4dOB+uGUN2c035FtsFzgwNAXrGMYfIamB/4wj02piljCNTUVFLRyaXVtWLACixAzHrvJiP1K60xooaEfphNdhTmkUkgbQ/6J+VyE6KWmELeqQXXQY8Zsqger2z7U9QBu+4A3/jU540sUwoZeYMKCOv4mA/+UFH6InRh5Y9nJkxxedP8vePTAq72+yAl3v8UURLXJLe2KfHmgiknOJ0U95G9oG/a6RAh1WrXQPeCvf2KcsR/j9VeXhf7bsis9VcymiV/VPKfWYzl7a0TyongnrtR1tzwSGSVW0o9moHLvgn3a0EEkk6Bm/Hc2E8jvQCGgdgvQRZMeUdCjAOwrQsdxdxcWlrKZxKYuNo6alp8bhbaqm8TblQ0FN40NBHEFqGvIYnHKRIdhQ6G4Oobt9NvC6jVfzsn2bD/MNG+atV4cfQFhfVbYnWKVm60VF1qq1yDf1WlzCQ+USvn0sWOqVv+MrX3hgpDU5DPirQIzTSXw5SU8cuJcy16sLj/HiS0heH67JuvapNhNCTRO37qkGrCLKYEy99yLU9dDee+qHIWBmCyrB4qAUQ24ZVY5h5aQRitgaBC6uGcytuCASfALpfKzeFiqbXQAAAABJRU5ErkJggg=="

/***/ }),
/* 996 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 997 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADYAAAA2CAMAAAC7m5rvAAAA9lBMVEUAAAD19fX19fX19fXMzMz19fX19fX19fXx8fH19fX19fX19fX19fX19fX19fX19fX19fX19fX19fXMzMzMzMz19fXMzMz19fX19fXt7e319fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fXMzMzMzMzMzMz19fX19fX19fX19fX19fXMzMz19fXMzMz19fXMzMzMzMz19fX19fX19fX19fX19fX19fXMzMz19fX19fXMzMz19fXMzMz19fXMzMzMzMzMzMzMzMzMzMzMzMzMzMz19fX19fX19fX19fX19fXMzMz19fXMzMxAlqd2AAAAUHRSTlMAAu7qmDX8DAXeD4/o4KOfmSPk+Xg9MScOCPHZsZRixMC9p3FvbFkw/PDYeHRpXUk6K/Tz4c22q5uLiodsZlVDQSL16tK2rp6IVU9KGRTHwLctV/UAAAKrSURBVEjHlZbXetpAEIVnhQQqVBOabTCmY+Peux33OE6G93+ZHMVlpZVgxX+jj9UeNJo5mlmKQVi9YjtnpNNGrl3sWYISICoFg0MYhVudsnHlcAzOVmPek1pL7LOU79+WXNt2S7f9TvZjqTXziaU1BoZnhZeHXorBWi1edb2Mm9luhiJkun4Uy9txAZ7jTtqTorDwPI3bZyKiymPZsWgmwxVsyNuKqoDFY5fmUF/Flk74eRdYKtiaip5iUzO4su0HILROKGLbIJD5A+ZVqLQ6xHkg67DOnHMpARnkpf31/wNk3qJEDFGHz/LZqKVHCTmDzz78ecWcqieVZWDRLQIC8W5SYrrIg8C1ArfVk8sy8PUOrihGUa7ubkzD/FB1HkqMGBFsRS5CpZFZSIWgPWYjUOmpViYQ5ZD6zCe0iIw6zD1qMk/myf6+vCjKHlzvG+uXKlO5DMl2mP+Qw1ybJzOr1edyNdRyUDnCC/7WvJt9tNEgSR1JpJ/MGV1K7sbPFADOny+TqDI1SL3MRZDzUyJRUhJbgHJQUFZlb+jQfrk3FdkrXQZr9qrIun65t9B9SGKa9xu47B+a/zkc48fhvWmS5ATmUqwMnsp3VJ1+7jOnVborP0WtTKEPB9yMxo/7X76olvcfx6PdyIcjP1OpexgdfW/cPRo93EQ+08+m4C7QFAw0hcVb0ITZEQRaCDbx4+pfDY/snBwkWjy/vS7czK00c2vh0eE6MJYIDqpjO9mgWg4Yf6Abi3JSD9QhnLcTqM6i83Xxka8/YFiOPBVEjzPuDEt5ady+iHv9a4Phl816jGiSZeTwmmIptRkYTUuED6WewWCtNDNX2zn2yXYmb7X3RuO9ttM9SekOhsBurXAMK1e29tBbzIY1qdOKoCTs9U/bjoHXdNab/b04zT+CvOHgVGKXvQAAAABJRU5ErkJggg=="

/***/ }),
/* 998 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 999 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADYAAAA2CAMAAAC7m5rvAAAAmVBMVEUAAAD19fX19fX19fXa2tr19fX19fXo6Oj19fXZ2dn19fX19fX19fX19fX19fX19fXMzMz19fX19fX19fX19fX19fX19fX19fX19fX19fX19fXMzMz19fX19fX19fX19fX19fX19fXMzMz19fX19fX19fX19fX19fXMzMzMzMz19fX19fXMzMz19fXMzMzMzMzMzMz19fXMzMzLsM/uAAAAMXRSTlMAAuydBQ7wCHQM6N4lEY/8xL+lmDVrPuSzVkq5iG7f2sMsq6o5Ylsira9jMrKsj4RFvKpGwQAAAiZJREFUSMedltlyozAQRVuAEGYdVju2MXHsxDPJzCTK/39croirHIwQy3ngATilru6WWqSBFXWeHqwksQ5pXheMJsAq25IdLLsaM0UZSA1BKUwrPa+lws/qbRg5ThRu68xvX62fB1cMH9uY4oI6FHEb9WOotx5ctZC3oh4rTy3pPugCjPEliTlp4fsEn+NeoE6G180bDfLW4Ifs3lPWhpMBvlEeddjjlc1GKmrjp30nG8qiUZT3Iy+hiwjZuMYQp3urQ4o+4DQBjh5K6coLMl/QJArU4YVaxBoVoYnE6DNBihK9wadqHP1SEmCI16PJeMgDgQrdy6drHFmvvouR0wzy7xJjV5znaGdER3RUzzkwrHOkWsoTGXDe7zfgScqabHMenT+f//u5tAkHwdZo/bpfbYsDgg5ShsPW775FoZQHQhmiWRZF2AYkpWSzLHKg6LSPv6L9/KQsvaYL8ulzJzqWJkhNSpwdvJulTUlbAI3XsXoF0JcbXsfql1vfXGI3aNE/bNS2lZnGWxlbef7Gwbb2l29T2O6CQ4GauUdQs/DAW3i8Lj3Mb6MjmmJFP0cHXeYMqkt3LGbjWqbGYm8IO2bJaYdwf75uIpMVbTSTmqkAgsKQw0B3wSC2N15n4kRFyIYvT1wjDV+ewCWVwMrPrBPGObckSC80xPViaJ08XAyFwMXQO1nXiyEZEK+N1NC8itHdm/tdx88rmsSxtNPAQrBBapdH0vAF1mVX0V+0VQgAAAAASUVORK5CYII="

/***/ }),
/* 1000 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = unregisterAll;
// Older builds registered a cache-first service worker (sw-precache). It served the cached
// index.html and bundle on every navigation, so returning visitors saw each deploy one visit
// late, and new routes (for example /MagicLogin/<token>) did not exist on the first click.
//
// The site no longer registers a worker. public/service-worker.js is now a kill switch that
// clears the old caches and unregisters itself; unregisterAll() does the same from the page
// once the new bundle is running.
function unregisterAll(){var nav=arguments.length>0&&arguments[0]!==undefined?arguments[0]:typeof navigator!=='undefined'?navigator:undefined;var cacheStorage=arguments.length>1&&arguments[1]!==undefined?arguments[1]:typeof caches!=='undefined'?caches:undefined;var tasks=[];if(nav&&nav.serviceWorker&&typeof nav.serviceWorker.getRegistrations==='function'){tasks.push(nav.serviceWorker.getRegistrations().then(function(registrations){return Promise.all(registrations.map(function(registration){return registration.unregister();}));}));}if(cacheStorage&&typeof cacheStorage.keys==='function'){tasks.push(cacheStorage.keys().then(function(keys){return Promise.all(keys.map(function(key){return cacheStorage.delete(key);}));}));}return Promise.all(tasks).then(function(){return undefined;},function(){return undefined;});}/* unused harmony default export */ var _unused_webpack_default_export = (unregisterAll);

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// static/js/main.84d6d214.js